/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(34);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouter = __webpack_require__(173);
	
	var _useScroll = __webpack_require__(252);
	
	var _useScroll2 = _interopRequireDefault(_useScroll);
	
	var _createRoutes = __webpack_require__(262);
	
	var _createRoutes2 = _interopRequireDefault(_createRoutes);
	
	var _gatsbyBrowser = __webpack_require__(958);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*  weak */
	var loadContext = __webpack_require__(960);
	
	function loadConfig(cb) {
	  var stuff = __webpack_require__(404);
	
	  if (false) {
	    module.hot.accept(stuff.id, function () {
	      return cb();
	    });
	  }
	  return cb();
	}
	
	var currentLocation = null;
	
	_reactRouter.browserHistory.listen(function (location) {
	  currentLocation = location;
	  if (_gatsbyBrowser.onRouteChange) {
	    console.warn('onRouteChange is now deprecated and will be removed in the next major Gatsby release (0.13). Please use onRouteUpdate instead. See the PR for more info (https://github.com/gatsbyjs/gatsby/pull/321).');
	    (0, _gatsbyBrowser.onRouteChange)(location);
	  }
	});
	
	function onUpdate() {
	  if (_gatsbyBrowser.onRouteUpdate) {
	    (0, _gatsbyBrowser.onRouteUpdate)(currentLocation);
	  }
	}
	
	function defaultShouldUpdateScroll(prevRouterProps, nextRouterProps) {
	  if (_gatsbyBrowser.shouldUpdateScroll) {
	    return (0, _gatsbyBrowser.shouldUpdateScroll)(prevRouterProps, nextRouterProps);
	  }
	  if (prevRouterProps) {
	    var oldPathname = prevRouterProps.location.pathname;
	    var pathname = nextRouterProps.location.pathname;
	
	    if (oldPathname === pathname) {
	      return false;
	    }
	  }
	  return true;
	}
	
	var routes = void 0;
	loadConfig(function () {
	  return loadContext(function (pagesReq) {
	    var _require = __webpack_require__(404),
	        pages = _require.pages;
	
	    if (!routes) {
	      routes = (0, _createRoutes2.default)(pages, pagesReq);
	    } else {
	      (0, _createRoutes2.default)(pages, pagesReq);
	    }
	
	    if (_gatsbyBrowser.modifyRoutes) {
	      routes = (0, _gatsbyBrowser.modifyRoutes)(routes);
	    }
	
	    var Root = function Root() {
	      return _react2.default.createElement(_reactRouter.Router, {
	        history: _reactRouter.browserHistory,
	        routes: routes,
	        render: (0, _reactRouter.applyRouterMiddleware)((0, _useScroll2.default)(defaultShouldUpdateScroll)),
	        onUpdate: onUpdate
	      });
	    };
	
	    if (_gatsbyBrowser.wrapRootComponent) {
	      Root = (0, _gatsbyBrowser.wrapRootComponent)(Root);
	    }
	
	    if (_gatsbyBrowser.replaceDOMRenderer) {
	      (0, _gatsbyBrowser.replaceDOMRenderer)({ routes: routes, defaultShouldUpdateScroll: defaultShouldUpdateScroll, onUpdate: onUpdate });
	    } else {
	      _reactDom2.default.render(_react2.default.createElement(Root, null), typeof window !== 'undefined' ? document.getElementById('react-mount') : undefined);
	    }
	  });
	});

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(3);


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var ReactBaseClasses = __webpack_require__(5);
	var ReactChildren = __webpack_require__(14);
	var ReactDOMFactories = __webpack_require__(22);
	var ReactElement = __webpack_require__(16);
	var ReactPropTypes = __webpack_require__(23);
	var ReactVersion = __webpack_require__(30);
	
	var createReactClass = __webpack_require__(31);
	var onlyChild = __webpack_require__(33);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';
	
	function ToObject(val) {
		if (val == null) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	module.exports = Object.assign || function (target, source) {
		var from;
		var keys;
		var to = ToObject(target);
	
		for (var s = 1; s < arguments.length; s++) {
			from = arguments[s];
			keys = Object.keys(Object(from));
	
			for (var i = 0; i < keys.length; i++) {
				to[keys[i]] = from[keys[i]];
			}
		}
	
		return to;
	};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(4);
	
	var ReactNoopUpdateQueue = __webpack_require__(7);
	
	var canDefineProperty = __webpack_require__(10);
	var emptyObject = __webpack_require__(11);
	var invariant = __webpack_require__(12);
	var lowPriorityWarning = __webpack_require__(13);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(8);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(9);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(15);
	var ReactElement = __webpack_require__(16);
	
	var emptyFunction = __webpack_require__(9);
	var traverseAllChildren = __webpack_require__(19);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ }),
/* 15 */
[1042, 6],
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var ReactCurrentOwner = __webpack_require__(17);
	
	var warning = __webpack_require__(8);
	var canDefineProperty = __webpack_require__(10);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(18);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactCurrentOwner = __webpack_require__(17);
	var REACT_ELEMENT_TYPE = __webpack_require__(18);
	
	var getIteratorFn = __webpack_require__(20);
	var invariant = __webpack_require__(12);
	var KeyEscapeUtils = __webpack_require__(21);
	var warning = __webpack_require__(8);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(16);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(16),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(24);
	
	module.exports = factory(isValidElement);

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(25);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactIs = __webpack_require__(26);
	var assign = __webpack_require__(4);
	
	var ReactPropTypesSecret = __webpack_require__(28);
	var checkPropTypes = __webpack_require__(29);
	
	var has = Function.call.bind(Object.prototype.hasOwnProperty);
	var printWarning = function() {};
	
	if (false) {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (false) {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(27);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ }),
/* 27 */
/***/ (function(module, exports) {

	/** @license React v16.13.0
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 28 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var printWarning = function() {};
	
	if (false) {
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	  var has = Function.call.bind(Object.prototype.hasOwnProperty);
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (false) {
	    loggedTypeFailures = {};
	  }
	}
	
	module.exports = checkPropTypes;


/***/ }),
/* 30 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(5),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(16),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(7);
	var factory = __webpack_require__(32);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var emptyObject = __webpack_require__(11);
	var _invariant = __webpack_require__(12);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactElement = __webpack_require__(16);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(35);


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactDefaultInjection = __webpack_require__(40);
	var ReactMount = __webpack_require__(164);
	var ReactReconciler = __webpack_require__(61);
	var ReactUpdates = __webpack_require__(58);
	var ReactVersion = __webpack_require__(169);
	
	var findDOMNode = __webpack_require__(170);
	var getHostComponentFromComposite = __webpack_require__(171);
	var renderSubtreeIntoContainer = __webpack_require__(172);
	var warning = __webpack_require__(8);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var DOMProperty = __webpack_require__(38);
	var ReactDOMComponentFlags = __webpack_require__(39);
	
	var invariant = __webpack_require__(12);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ }),
/* 37 */
6,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var invariant = __webpack_require__(12);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ }),
/* 39 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(41);
	var BeforeInputEventPlugin = __webpack_require__(42);
	var ChangeEventPlugin = __webpack_require__(57);
	var DefaultEventPluginOrder = __webpack_require__(70);
	var EnterLeaveEventPlugin = __webpack_require__(71);
	var HTMLDOMPropertyConfig = __webpack_require__(76);
	var ReactComponentBrowserEnvironment = __webpack_require__(77);
	var ReactDOMComponent = __webpack_require__(90);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactDOMEmptyComponent = __webpack_require__(135);
	var ReactDOMTreeTraversal = __webpack_require__(136);
	var ReactDOMTextComponent = __webpack_require__(137);
	var ReactDefaultBatchingStrategy = __webpack_require__(138);
	var ReactEventListener = __webpack_require__(139);
	var ReactInjection = __webpack_require__(142);
	var ReactReconcileTransaction = __webpack_require__(143);
	var SVGDOMPropertyConfig = __webpack_require__(151);
	var SelectEventPlugin = __webpack_require__(152);
	var SimpleEventPlugin = __webpack_require__(153);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(43);
	var ExecutionEnvironment = __webpack_require__(50);
	var FallbackCompositionState = __webpack_require__(51);
	var SyntheticCompositionEvent = __webpack_require__(54);
	var SyntheticInputEvent = __webpack_require__(56);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(44);
	var EventPluginUtils = __webpack_require__(46);
	
	var accumulateInto = __webpack_require__(48);
	var forEachAccumulated = __webpack_require__(49);
	var warning = __webpack_require__(8);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var EventPluginRegistry = __webpack_require__(45);
	var EventPluginUtils = __webpack_require__(46);
	var ReactErrorUtils = __webpack_require__(47);
	
	var accumulateInto = __webpack_require__(48);
	var forEachAccumulated = __webpack_require__(49);
	var invariant = __webpack_require__(12);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var ReactErrorUtils = __webpack_require__(47);
	
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(8);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function () {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var PooledClass = __webpack_require__(52);
	
	var getTextContentAccessor = __webpack_require__(53);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ }),
/* 52 */
[1042, 37],
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(50);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(55);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var PooledClass = __webpack_require__(52);
	
	var emptyFunction = __webpack_require__(9);
	var warning = __webpack_require__(8);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(55);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(44);
	var EventPropagators = __webpack_require__(43);
	var ExecutionEnvironment = __webpack_require__(50);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactUpdates = __webpack_require__(58);
	var SyntheticEvent = __webpack_require__(55);
	
	var inputValueTracking = __webpack_require__(66);
	var getEventTarget = __webpack_require__(67);
	var isEventSupported = __webpack_require__(68);
	var isTextInputElement = __webpack_require__(69);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37),
	    _assign = __webpack_require__(4);
	
	var CallbackQueue = __webpack_require__(59);
	var PooledClass = __webpack_require__(52);
	var ReactFeatureFlags = __webpack_require__(60);
	var ReactReconciler = __webpack_require__(61);
	var Transaction = __webpack_require__(65);
	
	var invariant = __webpack_require__(12);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(52);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 60 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(62);
	var ReactInstrumentation = __webpack_require__(64);
	
	var warning = __webpack_require__(8);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(63);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var invariant = __webpack_require__(12);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(36);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(50);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ }),
/* 69 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ }),
/* 70 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(43);
	var ReactDOMComponentTree = __webpack_require__(36);
	var SyntheticMouseEvent = __webpack_require__(72);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(73);
	var ViewportMetrics = __webpack_require__(74);
	
	var getEventModifierState = __webpack_require__(75);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(55);
	
	var getEventTarget = __webpack_require__(67);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ }),
/* 74 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ }),
/* 75 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(38);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(78);
	var ReactDOMIDOperations = __webpack_require__(89);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(79);
	var Danger = __webpack_require__(85);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactInstrumentation = __webpack_require__(64);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(82);
	var setInnerHTML = __webpack_require__(81);
	var setTextContent = __webpack_require__(83);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(80);
	var setInnerHTML = __webpack_require__(81);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(82);
	var setTextContent = __webpack_require__(83);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ }),
/* 80 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(50);
	var DOMNamespaces = __webpack_require__(80);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(82);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ }),
/* 82 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(50);
	var escapeTextContentForBrowser = __webpack_require__(84);
	var setInnerHTML = __webpack_require__(81);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ }),
/* 84 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var DOMLazyTree = __webpack_require__(79);
	var ExecutionEnvironment = __webpack_require__(50);
	
	var createNodesFromMarkup = __webpack_require__(86);
	var emptyFunction = __webpack_require__(9);
	var invariant = __webpack_require__(12);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(50);
	
	var createArrayFromMixed = __webpack_require__(87);
	var getMarkupWrap = __webpack_require__(88);
	var invariant = __webpack_require__(12);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(12);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(50);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(78);
	var ReactDOMComponentTree = __webpack_require__(36);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37),
	    _assign = __webpack_require__(4);
	
	var AutoFocusUtils = __webpack_require__(91);
	var CSSPropertyOperations = __webpack_require__(93);
	var DOMLazyTree = __webpack_require__(79);
	var DOMNamespaces = __webpack_require__(80);
	var DOMProperty = __webpack_require__(38);
	var DOMPropertyOperations = __webpack_require__(101);
	var EventPluginHub = __webpack_require__(44);
	var EventPluginRegistry = __webpack_require__(45);
	var ReactBrowserEventEmitter = __webpack_require__(103);
	var ReactDOMComponentFlags = __webpack_require__(39);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactDOMInput = __webpack_require__(106);
	var ReactDOMOption = __webpack_require__(109);
	var ReactDOMSelect = __webpack_require__(110);
	var ReactDOMTextarea = __webpack_require__(111);
	var ReactInstrumentation = __webpack_require__(64);
	var ReactMultiChild = __webpack_require__(112);
	var ReactServerRenderingTransaction = __webpack_require__(131);
	
	var emptyFunction = __webpack_require__(9);
	var escapeTextContentForBrowser = __webpack_require__(84);
	var invariant = __webpack_require__(12);
	var isEventSupported = __webpack_require__(68);
	var shallowEqual = __webpack_require__(120);
	var inputValueTracking = __webpack_require__(66);
	var validateDOMNesting = __webpack_require__(134);
	var warning = __webpack_require__(8);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(36);
	
	var focusNode = __webpack_require__(92);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ }),
/* 92 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(94);
	var ExecutionEnvironment = __webpack_require__(50);
	var ReactInstrumentation = __webpack_require__(64);
	
	var camelizeStyleName = __webpack_require__(95);
	var dangerousStyleValue = __webpack_require__(97);
	var hyphenateStyleName = __webpack_require__(98);
	var memoizeStringOnly = __webpack_require__(100);
	var warning = __webpack_require__(8);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ }),
/* 94 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(96);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ }),
/* 96 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(94);
	var warning = __webpack_require__(8);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(99);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ }),
/* 99 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ }),
/* 100 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(38);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactInstrumentation = __webpack_require__(64);
	
	var quoteAttributeValueForBrowser = __webpack_require__(102);
	var warning = __webpack_require__(8);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(84);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var EventPluginRegistry = __webpack_require__(45);
	var ReactEventEmitterMixin = __webpack_require__(104);
	var ViewportMetrics = __webpack_require__(74);
	
	var getVendorPrefixedEventName = __webpack_require__(105);
	var isEventSupported = __webpack_require__(68);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(44);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(50);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37),
	    _assign = __webpack_require__(4);
	
	var DOMPropertyOperations = __webpack_require__(101);
	var LinkedValueUtils = __webpack_require__(107);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactUpdates = __webpack_require__(58);
	
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(8);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var ReactPropTypesSecret = __webpack_require__(108);
	var propTypesFactory = __webpack_require__(24);
	
	var React = __webpack_require__(3);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(8);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var React = __webpack_require__(3);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactDOMSelect = __webpack_require__(110);
	
	var warning = __webpack_require__(8);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var LinkedValueUtils = __webpack_require__(107);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactUpdates = __webpack_require__(58);
	
	var warning = __webpack_require__(8);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37),
	    _assign = __webpack_require__(4);
	
	var LinkedValueUtils = __webpack_require__(107);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactUpdates = __webpack_require__(58);
	
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(8);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var ReactComponentEnvironment = __webpack_require__(113);
	var ReactInstanceMap = __webpack_require__(114);
	var ReactInstrumentation = __webpack_require__(64);
	
	var ReactCurrentOwner = __webpack_require__(17);
	var ReactReconciler = __webpack_require__(61);
	var ReactChildReconciler = __webpack_require__(115);
	
	var emptyFunction = __webpack_require__(9);
	var flattenChildren = __webpack_require__(130);
	var invariant = __webpack_require__(12);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var invariant = __webpack_require__(12);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ }),
/* 114 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(61);
	
	var instantiateReactComponent = __webpack_require__(117);
	var KeyEscapeUtils = __webpack_require__(125);
	var shouldUpdateReactComponent = __webpack_require__(121);
	var traverseAllChildren = __webpack_require__(126);
	var warning = __webpack_require__(8);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(129);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(116)))

/***/ }),
/* 116 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37),
	    _assign = __webpack_require__(4);
	
	var ReactCompositeComponent = __webpack_require__(118);
	var ReactEmptyComponent = __webpack_require__(122);
	var ReactHostComponent = __webpack_require__(123);
	
	var getNextDebugID = __webpack_require__(124);
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(8);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37),
	    _assign = __webpack_require__(4);
	
	var React = __webpack_require__(3);
	var ReactComponentEnvironment = __webpack_require__(113);
	var ReactCurrentOwner = __webpack_require__(17);
	var ReactErrorUtils = __webpack_require__(47);
	var ReactInstanceMap = __webpack_require__(114);
	var ReactInstrumentation = __webpack_require__(64);
	var ReactNodeTypes = __webpack_require__(119);
	var ReactReconciler = __webpack_require__(61);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(11);
	var invariant = __webpack_require__(12);
	var shallowEqual = __webpack_require__(120);
	var shouldUpdateReactComponent = __webpack_require__(121);
	var warning = __webpack_require__(8);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var React = __webpack_require__(3);
	
	var invariant = __webpack_require__(12);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ }),
/* 120 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 121 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ }),
/* 122 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var invariant = __webpack_require__(12);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ }),
/* 124 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ }),
/* 125 */
21,
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var ReactCurrentOwner = __webpack_require__(17);
	var REACT_ELEMENT_TYPE = __webpack_require__(127);
	
	var getIteratorFn = __webpack_require__(128);
	var invariant = __webpack_require__(12);
	var KeyEscapeUtils = __webpack_require__(125);
	var warning = __webpack_require__(8);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 127 */
18,
/* 128 */
20,
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactCurrentOwner = __webpack_require__(17);
	
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(8);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(125);
	var traverseAllChildren = __webpack_require__(126);
	var warning = __webpack_require__(8);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(129);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(116)))

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var PooledClass = __webpack_require__(52);
	var Transaction = __webpack_require__(65);
	var ReactInstrumentation = __webpack_require__(64);
	var ReactServerUpdateQueue = __webpack_require__(132);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(133);
	
	var warning = __webpack_require__(8);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var ReactCurrentOwner = __webpack_require__(17);
	var ReactInstanceMap = __webpack_require__(114);
	var ReactInstrumentation = __webpack_require__(64);
	var ReactUpdates = __webpack_require__(58);
	
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(8);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var emptyFunction = __webpack_require__(9);
	var warning = __webpack_require__(8);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var DOMLazyTree = __webpack_require__(79);
	var ReactDOMComponentTree = __webpack_require__(36);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37),
	    _assign = __webpack_require__(4);
	
	var DOMChildrenOperations = __webpack_require__(78);
	var DOMLazyTree = __webpack_require__(79);
	var ReactDOMComponentTree = __webpack_require__(36);
	
	var escapeTextContentForBrowser = __webpack_require__(84);
	var invariant = __webpack_require__(12);
	var validateDOMNesting = __webpack_require__(134);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var ReactUpdates = __webpack_require__(58);
	var Transaction = __webpack_require__(65);
	
	var emptyFunction = __webpack_require__(9);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var EventListener = __webpack_require__(140);
	var ExecutionEnvironment = __webpack_require__(50);
	var PooledClass = __webpack_require__(52);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactUpdates = __webpack_require__(58);
	
	var getEventTarget = __webpack_require__(67);
	var getUnboundedScrollPosition = __webpack_require__(141);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(9);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ }),
/* 141 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(38);
	var EventPluginHub = __webpack_require__(44);
	var EventPluginUtils = __webpack_require__(46);
	var ReactComponentEnvironment = __webpack_require__(113);
	var ReactEmptyComponent = __webpack_require__(122);
	var ReactBrowserEventEmitter = __webpack_require__(103);
	var ReactHostComponent = __webpack_require__(123);
	var ReactUpdates = __webpack_require__(58);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var CallbackQueue = __webpack_require__(59);
	var PooledClass = __webpack_require__(52);
	var ReactBrowserEventEmitter = __webpack_require__(103);
	var ReactInputSelection = __webpack_require__(144);
	var ReactInstrumentation = __webpack_require__(64);
	var Transaction = __webpack_require__(65);
	var ReactUpdateQueue = __webpack_require__(133);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(145);
	
	var containsNode = __webpack_require__(147);
	var focusNode = __webpack_require__(92);
	var getActiveElement = __webpack_require__(150);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(50);
	
	var getNodeForCharacterOffset = __webpack_require__(146);
	var getTextContentAccessor = __webpack_require__(53);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ }),
/* 146 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(148);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(149);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ }),
/* 149 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ }),
/* 150 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ }),
/* 151 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(43);
	var ExecutionEnvironment = __webpack_require__(50);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactInputSelection = __webpack_require__(144);
	var SyntheticEvent = __webpack_require__(55);
	
	var getActiveElement = __webpack_require__(150);
	var isTextInputElement = __webpack_require__(69);
	var shallowEqual = __webpack_require__(120);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var EventListener = __webpack_require__(140);
	var EventPropagators = __webpack_require__(43);
	var ReactDOMComponentTree = __webpack_require__(36);
	var SyntheticAnimationEvent = __webpack_require__(154);
	var SyntheticClipboardEvent = __webpack_require__(155);
	var SyntheticEvent = __webpack_require__(55);
	var SyntheticFocusEvent = __webpack_require__(156);
	var SyntheticKeyboardEvent = __webpack_require__(157);
	var SyntheticMouseEvent = __webpack_require__(72);
	var SyntheticDragEvent = __webpack_require__(160);
	var SyntheticTouchEvent = __webpack_require__(161);
	var SyntheticTransitionEvent = __webpack_require__(162);
	var SyntheticUIEvent = __webpack_require__(73);
	var SyntheticWheelEvent = __webpack_require__(163);
	
	var emptyFunction = __webpack_require__(9);
	var getEventCharCode = __webpack_require__(158);
	var invariant = __webpack_require__(12);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(55);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(55);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(73);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(73);
	
	var getEventCharCode = __webpack_require__(158);
	var getEventKey = __webpack_require__(159);
	var getEventModifierState = __webpack_require__(75);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 158 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(158);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(72);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(73);
	
	var getEventModifierState = __webpack_require__(75);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(55);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(72);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var DOMLazyTree = __webpack_require__(79);
	var DOMProperty = __webpack_require__(38);
	var React = __webpack_require__(3);
	var ReactBrowserEventEmitter = __webpack_require__(103);
	var ReactCurrentOwner = __webpack_require__(17);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactDOMContainerInfo = __webpack_require__(165);
	var ReactDOMFeatureFlags = __webpack_require__(166);
	var ReactFeatureFlags = __webpack_require__(60);
	var ReactInstanceMap = __webpack_require__(114);
	var ReactInstrumentation = __webpack_require__(64);
	var ReactMarkupChecksum = __webpack_require__(167);
	var ReactReconciler = __webpack_require__(61);
	var ReactUpdateQueue = __webpack_require__(133);
	var ReactUpdates = __webpack_require__(58);
	
	var emptyObject = __webpack_require__(11);
	var instantiateReactComponent = __webpack_require__(117);
	var invariant = __webpack_require__(12);
	var setInnerHTML = __webpack_require__(81);
	var shouldUpdateReactComponent = __webpack_require__(121);
	var warning = __webpack_require__(8);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(134);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ }),
/* 166 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(168);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ }),
/* 168 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ }),
/* 169 */
30,
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var ReactCurrentOwner = __webpack_require__(17);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactInstanceMap = __webpack_require__(114);
	
	var getHostComponentFromComposite = __webpack_require__(171);
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(8);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(119);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(164);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.PropTypes = exports.RoutingContext = exports.RouterContext = exports.createRoutes = exports.useRoutes = exports.RouteContext = exports.Lifecycle = exports.History = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(174);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes2 = __webpack_require__(175);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(180);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(182);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(229);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(230);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(231);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(233);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(235);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(234);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(236);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _History2 = __webpack_require__(237);
	
	var _History3 = _interopRequireDefault(_History2);
	
	var _Lifecycle2 = __webpack_require__(238);
	
	var _Lifecycle3 = _interopRequireDefault(_Lifecycle2);
	
	var _RouteContext2 = __webpack_require__(239);
	
	var _RouteContext3 = _interopRequireDefault(_RouteContext2);
	
	var _useRoutes2 = __webpack_require__(240);
	
	var _useRoutes3 = _interopRequireDefault(_useRoutes2);
	
	var _RouterContext2 = __webpack_require__(226);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _RoutingContext2 = __webpack_require__(241);
	
	var _RoutingContext3 = _interopRequireDefault(_RoutingContext2);
	
	var _PropTypes3 = _interopRequireDefault(_PropTypes2);
	
	var _match2 = __webpack_require__(242);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(246);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(247);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(248);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(251);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(243);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* mixins */
	
	exports.History = _History3.default;
	exports.Lifecycle = _Lifecycle3.default;
	exports.RouteContext = _RouteContext3.default;
	
	/* utils */
	
	exports.useRoutes = _useRoutes3.default;
	exports.RouterContext = _RouterContext3.default;
	exports.RoutingContext = _RoutingContext3.default;
	exports.PropTypes = _PropTypes3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.router = exports.routes = exports.route = exports.components = exports.component = exports.location = exports.history = exports.falsy = exports.locationShape = exports.routerShape = undefined;
	
	var _react = __webpack_require__(2);
	
	var _deprecateObjectProperties = __webpack_require__(176);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _InternalPropTypes = __webpack_require__(179);
	
	var InternalPropTypes = _interopRequireWildcard(_InternalPropTypes);
	
	var _routerWarning = __webpack_require__(177);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	var routerShape = exports.routerShape = shape({
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired,
	  setRouteLeaveHook: func.isRequired,
	  isActive: func.isRequired
	});
	
	var locationShape = exports.locationShape = shape({
	  pathname: string.isRequired,
	  search: string.isRequired,
	  state: object,
	  action: string.isRequired,
	  key: string
	});
	
	// Deprecated stuff below:
	
	var falsy = exports.falsy = InternalPropTypes.falsy;
	var history = exports.history = InternalPropTypes.history;
	var location = exports.location = locationShape;
	var component = exports.component = InternalPropTypes.component;
	var components = exports.components = InternalPropTypes.components;
	var route = exports.route = InternalPropTypes.route;
	var routes = exports.routes = InternalPropTypes.routes;
	var router = exports.router = routerShape;
	
	if (false) {
	  (function () {
	    var deprecatePropType = function deprecatePropType(propType, message) {
	      return function () {
	        process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	        return propType.apply(undefined, arguments);
	      };
	    };
	
	    var deprecateInternalPropType = function deprecateInternalPropType(propType) {
	      return deprecatePropType(propType, 'This prop type is not intended for external use, and was previously exported by mistake. These internal prop types are deprecated for external use, and will be removed in a later version.');
	    };
	
	    var deprecateRenamedPropType = function deprecateRenamedPropType(propType, name) {
	      return deprecatePropType(propType, 'The `' + name + '` prop type is now exported as `' + name + 'Shape` to avoid name conflicts. This export is deprecated and will be removed in a later version.');
	    };
	
	    exports.falsy = falsy = deprecateInternalPropType(falsy);
	    exports.history = history = deprecateInternalPropType(history);
	    exports.component = component = deprecateInternalPropType(component);
	    exports.components = components = deprecateInternalPropType(components);
	    exports.route = route = deprecateInternalPropType(route);
	    exports.routes = routes = deprecateInternalPropType(routes);
	
	    exports.location = location = deprecateRenamedPropType(location, 'location');
	    exports.router = router = deprecateRenamedPropType(router, 'router');
	  })();
	}
	
	var defaultExport = {
	  falsy: falsy,
	  history: history,
	  location: location,
	  component: component,
	  components: components,
	  route: route,
	  // For some reason, routes was never here.
	  router: router
	};
	
	if (false) {
	  defaultExport = (0, _deprecateObjectProperties2.default)(defaultExport, 'The default export from `react-router/lib/PropTypes` is deprecated. Please use the named exports instead.');
	}
	
	exports.default = defaultExport;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.canUseMembrane = undefined;
	
	var _routerWarning = __webpack_require__(177);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseMembrane = exports.canUseMembrane = false;
	
	// No-op by default.
	var deprecateObjectProperties = function deprecateObjectProperties(object) {
	  return object;
	};
	
	if (false) {
	  try {
	    if (Object.defineProperty({}, 'x', {
	      get: function get() {
	        return true;
	      }
	    }).x) {
	      exports.canUseMembrane = canUseMembrane = true;
	    }
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	  if (canUseMembrane) {
	    deprecateObjectProperties = function deprecateObjectProperties(object, message) {
	      // Wrap the deprecated object in a membrane to warn on property access.
	      var membrane = {};
	
	      var _loop = function _loop(prop) {
	        if (!Object.prototype.hasOwnProperty.call(object, prop)) {
	          return 'continue';
	        }
	
	        if (typeof object[prop] === 'function') {
	          // Can't use fat arrow here because of use of arguments below.
	          membrane[prop] = function () {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop].apply(object, arguments);
	          };
	          return 'continue';
	        }
	
	        // These properties are non-enumerable to prevent React dev tools from
	        // seeing them and causing spurious warnings when accessing them. In
	        // principle this could be done with a proxy, but support for the
	        // ownKeys trap on proxies is not universal, even among browsers that
	        // otherwise support proxies.
	        Object.defineProperty(membrane, prop, {
	          get: function get() {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop];
	          }
	        });
	      };
	
	      for (var prop in object) {
	        var _ret = _loop(prop);
	
	        if (_ret === 'continue') continue;
	      }
	
	      return membrane;
	    };
	  }
	}
	
	exports.default = deprecateObjectProperties;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(178);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _react = __webpack_require__(2);
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var arrayOf = _react.PropTypes.arrayOf;
	var oneOfType = _react.PropTypes.oneOfType;
	var element = _react.PropTypes.element;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = shape({
	  listen: func.isRequired,
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired
	});
	
	var component = exports.component = oneOfType([func, string]);
	var components = exports.components = oneOfType([component, object]);
	var route = exports.route = oneOfType([object, element]);
	var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(181);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern);
	
	  var regexpSource = _compilePattern2.regexpSource;
	  var paramNames = _compilePattern2.paramNames;
	  var tokens = _compilePattern2.tokens;
	
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames;
	  var paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern);
	
	  var tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0;
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenCount += 1;
	    } else if (token === ')') {
	      parenCount -= 1;
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURIComponent(paramValue);
	    } else {
	      pathname += token;
	    }
	  }
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createHashHistory = __webpack_require__(183);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _useQueries = __webpack_require__(215);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _invariant = __webpack_require__(181);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createTransitionManager = __webpack_require__(218);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _InternalPropTypes = __webpack_require__(179);
	
	var _RouterContext = __webpack_require__(226);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(174);
	
	var _RouterUtils = __webpack_require__(228);
	
	var _routerWarning = __webpack_require__(177);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isDeprecatedHistory(history) {
	  return !history || !history.__v2_compatible__;
	}
	
	/* istanbul ignore next: sanity check */
	function isUnsupportedHistory(history) {
	  // v3 histories expose getCurrentLocation, but aren't currently supported.
	  return history && history.getCurrentLocation;
	}
	
	var _React$PropTypes = _react2.default.PropTypes;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	
	var Router = _react2.default.createClass({
	  displayName: 'Router',
	
	
	  propTypes: {
	    history: object,
	    children: _InternalPropTypes.routes,
	    routes: _InternalPropTypes.routes, // alias for children
	    render: func,
	    createElement: func,
	    onError: func,
	    onUpdate: func,
	
	    // Deprecated:
	    parseQueryString: func,
	    stringifyQuery: func,
	
	    // PRIVATE: For client-side rehydration of server match.
	    matchContext: object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    var _props = this.props;
	    var parseQueryString = _props.parseQueryString;
	    var stringifyQuery = _props.stringifyQuery;
	
	     false ? (0, _routerWarning2.default)(!(parseQueryString || stringifyQuery), '`parseQueryString` and `stringifyQuery` are deprecated. Please create a custom history. http://tiny.cc/router-customquerystring') : void 0;
	
	    var _createRouterObjects = this.createRouterObjects();
	
	    var history = _createRouterObjects.history;
	    var transitionManager = _createRouterObjects.transitionManager;
	    var router = _createRouterObjects.router;
	
	
	    this._unlisten = transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	
	    this.history = history;
	    this.router = router;
	  },
	  createRouterObjects: function createRouterObjects() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext;
	    }
	
	    var history = this.props.history;
	    var _props2 = this.props;
	    var routes = _props2.routes;
	    var children = _props2.children;
	
	
	    !!isUnsupportedHistory(history) ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v3.x. ' + 'This version of React Router is not compatible with v3 history ' + 'objects. Please use history v2.x instead.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isDeprecatedHistory(history)) {
	      history = this.wrapDeprecatedHistory(history);
	    }
	
	    var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	    var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	    var routingHistory = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	    return { history: routingHistory, transitionManager: transitionManager, router: router };
	  },
	  wrapDeprecatedHistory: function wrapDeprecatedHistory(history) {
	    var _props3 = this.props;
	    var parseQueryString = _props3.parseQueryString;
	    var stringifyQuery = _props3.stringifyQuery;
	
	
	    var createHistory = void 0;
	    if (history) {
	       false ? (0, _routerWarning2.default)(false, 'It appears you have provided a deprecated history object to `<Router/>`, please use a history provided by ' + 'React Router with `import { browserHistory } from \'react-router\'` or `import { hashHistory } from \'react-router\'`. ' + 'If you are using a custom history please create it with `useRouterHistory`, see http://tiny.cc/router-usinghistory for details.') : void 0;
	      createHistory = function createHistory() {
	        return history;
	      };
	    } else {
	       false ? (0, _routerWarning2.default)(false, '`Router` no longer defaults the history prop to hash history. Please use the `hashHistory` singleton instead. http://tiny.cc/router-defaulthistory') : void 0;
	      createHistory = _createHashHistory2.default;
	    }
	
	    return (0, _useQueries2.default)(createHistory)({ parseQueryString: parseQueryString, stringifyQuery: stringifyQuery });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state;
	    var location = _state.location;
	    var routes = _state.routes;
	    var params = _state.params;
	    var components = _state.components;
	    var _props4 = this.props;
	    var createElement = _props4.createElement;
	    var render = _props4.render;
	
	    var props = _objectWithoutProperties(_props4, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(Router.propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      history: this.history,
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(178);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(181);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(184);
	
	var _PathUtils = __webpack_require__(185);
	
	var _ExecutionEnvironment = __webpack_require__(186);
	
	var _DOMUtils = __webpack_require__(187);
	
	var _DOMStateStorage = __webpack_require__(188);
	
	var _createDOMHistory = __webpack_require__(189);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	function isAbsolutePath(path) {
	  return typeof path === 'string' && path.charAt(0) === '/';
	}
	
	function ensureSlash() {
	  var path = _DOMUtils.getHashPath();
	
	  if (isAbsolutePath(path)) return true;
	
	  _DOMUtils.replaceHashPath('/' + path);
	
	  return false;
	}
	
	function addQueryStringValueToPath(path, key, value) {
	  return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
	}
	
	function stripQueryStringValueFromPath(path, key) {
	  return path.replace(new RegExp('[?&]?' + key + '=[a-zA-Z0-9]+'), '');
	}
	
	function getQueryStringValueFromPath(path, key) {
	  var match = path.match(new RegExp('\\?.*?\\b' + key + '=(.+?)\\b'));
	  return match && match[1];
	}
	
	var DefaultQueryKey = '_k';
	
	function createHashHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Hash history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var queryKey = options.queryKey;
	
	  if (queryKey === undefined || !!queryKey) queryKey = typeof queryKey === 'string' ? queryKey : DefaultQueryKey;
	
	  function getCurrentLocation() {
	    var path = _DOMUtils.getHashPath();
	
	    var key = undefined,
	        state = undefined;
	    if (queryKey) {
	      key = getQueryStringValueFromPath(path, queryKey);
	      path = stripQueryStringValueFromPath(path, queryKey);
	
	      if (key) {
	        state = _DOMStateStorage.readState(key);
	      } else {
	        state = null;
	        key = history.createKey();
	        _DOMUtils.replaceHashPath(addQueryStringValueToPath(path, queryKey, key));
	      }
	    } else {
	      key = state = null;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startHashChangeListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function hashChangeListener() {
	      if (!ensureSlash()) return; // Always make sure hashes are preceeded with a /.
	
	      transitionTo(getCurrentLocation());
	    }
	
	    ensureSlash();
	    _DOMUtils.addEventListener(window, 'hashchange', hashChangeListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'hashchange', hashChangeListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    var path = (basename || '') + pathname + search;
	
	    if (queryKey) {
	      path = addQueryStringValueToPath(path, queryKey, key);
	      _DOMStateStorage.saveState(key, state);
	    } else {
	      // Drop key and state.
	      location.key = location.state = null;
	    }
	
	    var currentHash = _DOMUtils.getHashPath();
	
	    if (action === _Actions.PUSH) {
	      if (currentHash !== path) {
	        window.location.hash = path;
	      } else {
	         false ? _warning2['default'](false, 'You cannot PUSH the same path using hash history') : undefined;
	      }
	    } else if (currentHash !== path) {
	      // REPLACE
	      _DOMUtils.replaceHashPath(path);
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopHashChangeListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function push(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.push(location);
	  }
	
	  function replace(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replace(location);
	  }
	
	  var goIsSupportedWithoutReload = _DOMUtils.supportsGoWithoutReloadUsingHash();
	
	  function go(n) {
	     false ? _warning2['default'](goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : undefined;
	
	    history.go(n);
	  }
	
	  function createHref(path) {
	    return '#' + history.createHref(path);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopHashChangeListener();
	  }
	
	  // deprecated
	  function pushState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.pushState(state, path);
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replaceState(state, path);
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    push: push,
	    replace: replace,
	    go: go,
	    createHref: createHref,
	
	    registerTransitionHook: registerTransitionHook, // deprecated - warning is in createHistory
	    unregisterTransitionHook: unregisterTransitionHook, // deprecated - warning is in createHistory
	    pushState: pushState, // deprecated - warning is in createHistory
	    replaceState: replaceState // deprecated - warning is in createHistory
	  });
	}
	
	exports['default'] = createHashHistory;
	module.exports = exports['default'];

/***/ }),
/* 184 */
/***/ (function(module, exports) {

	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	'use strict';
	
	exports.__esModule = true;
	var PUSH = 'PUSH';
	
	exports.PUSH = PUSH;
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = 'REPLACE';
	
	exports.REPLACE = REPLACE;
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = 'POP';
	
	exports.POP = POP;
	exports['default'] = {
	  PUSH: PUSH,
	  REPLACE: REPLACE,
	  POP: POP
	};

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.extractPath = extractPath;
	exports.parsePath = parsePath;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(178);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function extractPath(string) {
	  var match = string.match(/^https?:\/\/[^\/]*/);
	
	  if (match == null) return string;
	
	  return string.substring(match[0].length);
	}
	
	function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? _warning2['default'](path === pathname, 'A path must be pathname + search + hash only, not a fully qualified URL like "%s"', path) : undefined;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	}

/***/ }),
/* 186 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	exports.canUseDOM = canUseDOM;

/***/ }),
/* 187 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.getHashPath = getHashPath;
	exports.replaceHashPath = replaceHashPath;
	exports.getWindowPath = getWindowPath;
	exports.go = go;
	exports.getUserConfirmation = getUserConfirmation;
	exports.supportsHistory = supportsHistory;
	exports.supportsGoWithoutReloadUsingHash = supportsGoWithoutReloadUsingHash;
	
	function addEventListener(node, event, listener) {
	  if (node.addEventListener) {
	    node.addEventListener(event, listener, false);
	  } else {
	    node.attachEvent('on' + event, listener);
	  }
	}
	
	function removeEventListener(node, event, listener) {
	  if (node.removeEventListener) {
	    node.removeEventListener(event, listener, false);
	  } else {
	    node.detachEvent('on' + event, listener);
	  }
	}
	
	function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  return window.location.href.split('#')[1] || '';
	}
	
	function replaceHashPath(path) {
	  window.location.replace(window.location.pathname + window.location.search + '#' + path);
	}
	
	function getWindowPath() {
	  return window.location.pathname + window.location.search + window.location.hash;
	}
	
	function go(n) {
	  if (n) window.history.go(n);
	}
	
	function getUserConfirmation(message, callback) {
	  callback(window.confirm(message));
	}
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	 */
	
	function supportsHistory() {
	  var ua = navigator.userAgent;
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
	    return false;
	  }
	  return window.history && 'pushState' in window.history;
	}
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	
	function supportsGoWithoutReloadUsingHash() {
	  var ua = navigator.userAgent;
	  return ua.indexOf('Firefox') === -1;
	}

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	/*eslint-disable no-empty */
	'use strict';
	
	exports.__esModule = true;
	exports.saveState = saveState;
	exports.readState = readState;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(178);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var KeyPrefix = '@@History/';
	var QuotaExceededErrors = ['QuotaExceededError', 'QUOTA_EXCEEDED_ERR'];
	
	var SecurityError = 'SecurityError';
	
	function createKey(key) {
	  return KeyPrefix + key;
	}
	
	function saveState(key, state) {
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available due to security settings') : undefined;
	
	      return;
	    }
	
	    if (QuotaExceededErrors.indexOf(error.name) >= 0 && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : undefined;
	
	      return;
	    }
	
	    throw error;
	  }
	}
	
	function readState(key) {
	  var json = undefined;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to read state; sessionStorage is not available due to security settings') : undefined;
	
	      return null;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return null;
	}

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(181);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(186);
	
	var _DOMUtils = __webpack_require__(187);
	
	var _createHistory = __webpack_require__(190);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createDOMHistory(options) {
	  var history = _createHistory2['default'](_extends({
	    getUserConfirmation: _DOMUtils.getUserConfirmation
	  }, options, {
	    go: _DOMUtils.go
	  }));
	
	  function listen(listener) {
	    !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'DOM history needs a DOM') : _invariant2['default'](false) : undefined;
	
	    return history.listen(listener);
	  }
	
	  return _extends({}, history, {
	    listen: listen
	  });
	}
	
	exports['default'] = createDOMHistory;
	module.exports = exports['default'];

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(178);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _deepEqual = __webpack_require__(191);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _PathUtils = __webpack_require__(185);
	
	var _AsyncUtils = __webpack_require__(211);
	
	var _Actions = __webpack_require__(184);
	
	var _createLocation2 = __webpack_require__(212);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _runTransitionHook = __webpack_require__(213);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(214);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function createRandomKey(length) {
	  return Math.random().toString(36).substr(2, length);
	}
	
	function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search &&
	  //a.action === b.action && // Different action !== location change.
	  a.key === b.key && _deepEqual2['default'](a.state, b.state);
	}
	
	var DefaultKeyLength = 6;
	
	function createHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var getCurrentLocation = options.getCurrentLocation;
	  var finishTransition = options.finishTransition;
	  var saveState = options.saveState;
	  var go = options.go;
	  var getUserConfirmation = options.getUserConfirmation;
	  var keyLength = options.keyLength;
	
	  if (typeof keyLength !== 'number') keyLength = DefaultKeyLength;
	
	  var transitionHooks = [];
	
	  function listenBefore(hook) {
	    transitionHooks.push(hook);
	
	    return function () {
	      transitionHooks = transitionHooks.filter(function (item) {
	        return item !== hook;
	      });
	    };
	  }
	
	  var allKeys = [];
	  var changeListeners = [];
	  var location = undefined;
	
	  function getCurrent() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) {
	      return allKeys.indexOf(pendingLocation.key);
	    } else if (location) {
	      return allKeys.indexOf(location.key);
	    } else {
	      return -1;
	    }
	  }
	
	  function updateLocation(newLocation) {
	    var current = getCurrent();
	
	    location = newLocation;
	
	    if (location.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, current + 1), [location.key]);
	    } else if (location.action === _Actions.REPLACE) {
	      allKeys[current] = location.key;
	    }
	
	    changeListeners.forEach(function (listener) {
	      listener(location);
	    });
	  }
	
	  function listen(listener) {
	    changeListeners.push(listener);
	
	    if (location) {
	      listener(location);
	    } else {
	      var _location = getCurrentLocation();
	      allKeys = [_location.key];
	      updateLocation(_location);
	    }
	
	    return function () {
	      changeListeners = changeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }
	
	  function confirmTransitionTo(location, callback) {
	    _AsyncUtils.loopAsync(transitionHooks.length, function (index, next, done) {
	      _runTransitionHook2['default'](transitionHooks[index], location, function (result) {
	        if (result != null) {
	          done(result);
	        } else {
	          next();
	        }
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  }
	
	  var pendingLocation = undefined;
	
	  function transitionTo(nextLocation) {
	    if (location && locationsAreEqual(location, nextLocation)) return; // Nothing to do.
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted.
	
	      if (ok) {
	        // treat PUSH to current path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = createPath(location);
	          var nextPath = createPath(nextLocation);
	
	          if (nextPath === prevPath && _deepEqual2['default'](location.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (finishTransition(nextLocation) !== false) updateLocation(nextLocation);
	      } else if (location && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(location.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL.
	      }
	    });
	  }
	
	  function push(location) {
	    transitionTo(createLocation(location, _Actions.PUSH, createKey()));
	  }
	
	  function replace(location) {
	    transitionTo(createLocation(location, _Actions.REPLACE, createKey()));
	  }
	
	  function goBack() {
	    go(-1);
	  }
	
	  function goForward() {
	    go(1);
	  }
	
	  function createKey() {
	    return createRandomKey(keyLength);
	  }
	
	  function createPath(location) {
	    if (location == null || typeof location === 'string') return location;
	
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	
	    var result = pathname;
	
	    if (search) result += search;
	
	    if (hash) result += hash;
	
	    return result;
	  }
	
	  function createHref(location) {
	    return createPath(location);
	  }
	
	  function createLocation(location, action) {
	    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
	
	    if (typeof action === 'object') {
	       false ? _warning2['default'](false, 'The state (2nd) argument to history.createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      location = _extends({}, location, { state: action });
	
	      action = key;
	      key = arguments[3] || createKey();
	    }
	
	    return _createLocation3['default'](location, action, key);
	  }
	
	  // deprecated
	  function setState(state) {
	    if (location) {
	      updateLocationState(location, state);
	      updateLocation(location);
	    } else {
	      updateLocationState(getCurrentLocation(), state);
	    }
	  }
	
	  function updateLocationState(location, state) {
	    location.state = _extends({}, location.state, state);
	    saveState(location.key, location.state);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (transitionHooks.indexOf(hook) === -1) transitionHooks.push(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    transitionHooks = transitionHooks.filter(function (item) {
	      return item !== hook;
	    });
	  }
	
	  // deprecated
	  function pushState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    push(_extends({ state: state }, path));
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    replace(_extends({ state: state }, path));
	  }
	
	  return {
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: createPath,
	    createHref: createHref,
	    createLocation: createLocation,
	
	    setState: _deprecate2['default'](setState, 'setState is deprecated; use location.key to save state instead'),
	    registerTransitionHook: _deprecate2['default'](registerTransitionHook, 'registerTransitionHook is deprecated; use listenBefore instead'),
	    unregisterTransitionHook: _deprecate2['default'](unregisterTransitionHook, 'unregisterTransitionHook is deprecated; use the callback returned from listenBefore instead'),
	    pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	    replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	  };
	}
	
	exports['default'] = createHistory;
	module.exports = exports['default'];

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	var objectKeys = __webpack_require__(192);
	var isArguments = __webpack_require__(195);
	var is = __webpack_require__(196);
	var isRegex = __webpack_require__(197);
	var flags = __webpack_require__(201);
	var isDate = __webpack_require__(210);
	
	var getTime = Date.prototype.getTime;
	
	function deepEqual(actual, expected, options) {
	  var opts = options || {};
	
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (opts.strict ? is(actual, expected) : actual === expected) {
	    return true;
	  }
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
	  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
	    return opts.strict ? is(actual, expected) : actual == expected;
	  }
	
	  /*
	   * 7.4. For all other Object pairs, including Array objects, equivalence is
	   * determined by having the same number of owned properties (as verified
	   * with Object.prototype.hasOwnProperty.call), the same set of keys
	   * (although not necessarily the same order), equivalent values for every
	   * corresponding key, and an identical 'prototype' property. Note: this
	   * accounts for both named and indexed properties on Arrays.
	   */
	  // eslint-disable-next-line no-use-before-define
	  return objEquiv(actual, expected, opts);
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer(x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
	    return false;
	  }
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') {
	    return false;
	  }
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  /* eslint max-statements: [2, 50] */
	  var i, key;
	  if (typeof a !== typeof b) { return false; }
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }
	
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) { return false; }
	
	  if (isArguments(a) !== isArguments(b)) { return false; }
	
	  var aIsRegex = isRegex(a);
	  var bIsRegex = isRegex(b);
	  if (aIsRegex !== bIsRegex) { return false; }
	  if (aIsRegex || bIsRegex) {
	    return a.source === b.source && flags(a) === flags(b);
	  }
	
	  if (isDate(a) && isDate(b)) {
	    return getTime.call(a) === getTime.call(b);
	  }
	
	  var aIsBuffer = isBuffer(a);
	  var bIsBuffer = isBuffer(b);
	  if (aIsBuffer !== bIsBuffer) { return false; }
	  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
	    if (a.length !== b.length) { return false; }
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) { return false; }
	    }
	    return true;
	  }
	
	  if (typeof a !== typeof b) { return false; }
	
	  try {
	    var ka = objectKeys(a);
	    var kb = objectKeys(b);
	  } catch (e) { // happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates hasOwnProperty)
	  if (ka.length !== kb.length) { return false; }
	
	  // the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  // ~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i]) { return false; }
	  }
	  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) { return false; }
	  }
	
	  return true;
	}
	
	module.exports = deepEqual;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(193);
	
	var origKeys = Object.keys;
	var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(194);
	
	var originalKeys = Object.keys;
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				var args = Object.keys(arguments);
				return args && args.length === arguments.length;
			}(1, 2));
			if (!keysWorksWithArguments) {
				Object.keys = function keys(object) { // eslint-disable-line func-name-matching
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					}
					return originalKeys(object);
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ }),
/* 193 */
/***/ (function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var keysShim;
	if (!Object.keys) {
		// modified from https://github.com/es-shims/es5-shim
		var has = Object.prototype.hasOwnProperty;
		var toStr = Object.prototype.toString;
		var isArgs = __webpack_require__(193); // eslint-disable-line global-require
		var isEnumerable = Object.prototype.propertyIsEnumerable;
		var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
		var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
		var dontEnums = [
			'toString',
			'toLocaleString',
			'valueOf',
			'hasOwnProperty',
			'isPrototypeOf',
			'propertyIsEnumerable',
			'constructor'
		];
		var equalsConstructorPrototype = function (o) {
			var ctor = o.constructor;
			return ctor && ctor.prototype === o;
		};
		var excludedKeys = {
			$applicationCache: true,
			$console: true,
			$external: true,
			$frame: true,
			$frameElement: true,
			$frames: true,
			$innerHeight: true,
			$innerWidth: true,
			$onmozfullscreenchange: true,
			$onmozfullscreenerror: true,
			$outerHeight: true,
			$outerWidth: true,
			$pageXOffset: true,
			$pageYOffset: true,
			$parent: true,
			$scrollLeft: true,
			$scrollTop: true,
			$scrollX: true,
			$scrollY: true,
			$self: true,
			$webkitIndexedDB: true,
			$webkitStorageInfo: true,
			$window: true
		};
		var hasAutomationEqualityBug = (function () {
			/* global window */
			if (typeof window === 'undefined') { return false; }
			for (var k in window) {
				try {
					if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
						try {
							equalsConstructorPrototype(window[k]);
						} catch (e) {
							return true;
						}
					}
				} catch (e) {
					return true;
				}
			}
			return false;
		}());
		var equalsConstructorPrototypeIfNotBuggy = function (o) {
			/* global window */
			if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
				return equalsConstructorPrototype(o);
			}
			try {
				return equalsConstructorPrototype(o);
			} catch (e) {
				return false;
			}
		};
	
		keysShim = function keys(object) {
			var isObject = object !== null && typeof object === 'object';
			var isFunction = toStr.call(object) === '[object Function]';
			var isArguments = isArgs(object);
			var isString = isObject && toStr.call(object) === '[object String]';
			var theKeys = [];
	
			if (!isObject && !isFunction && !isArguments) {
				throw new TypeError('Object.keys called on a non-object');
			}
	
			var skipProto = hasProtoEnumBug && isFunction;
			if (isString && object.length > 0 && !has.call(object, 0)) {
				for (var i = 0; i < object.length; ++i) {
					theKeys.push(String(i));
				}
			}
	
			if (isArguments && object.length > 0) {
				for (var j = 0; j < object.length; ++j) {
					theKeys.push(String(j));
				}
			} else {
				for (var name in object) {
					if (!(skipProto && name === 'prototype') && has.call(object, name)) {
						theKeys.push(String(name));
					}
				}
			}
	
			if (hasDontEnumBug) {
				var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
				for (var k = 0; k < dontEnums.length; ++k) {
					if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
						theKeys.push(dontEnums[k]);
					}
				}
			}
			return theKeys;
		};
	}
	module.exports = keysShim;


/***/ }),
/* 195 */
/***/ (function(module, exports) {

	'use strict';
	
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	var toStr = Object.prototype.toString;
	
	var isStandardArguments = function isArguments(value) {
		if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
			return false;
		}
		return toStr.call(value) === '[object Arguments]';
	};
	
	var isLegacyArguments = function isArguments(value) {
		if (isStandardArguments(value)) {
			return true;
		}
		return value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value) !== '[object Array]' &&
			toStr.call(value.callee) === '[object Function]';
	};
	
	var supportsStandardArguments = (function () {
		return isStandardArguments(arguments);
	}());
	
	isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests
	
	module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ }),
/* 196 */
/***/ (function(module, exports) {

	'use strict';
	
	// http://www.ecma-international.org/ecma-262/6.0/#sec-object.is
	
	var numberIsNaN = function (value) {
		return value !== value;
	};
	
	module.exports = function is(a, b) {
		if (a === 0 && b === 0) {
			return 1 / a === 1 / b;
		}
		if (a === b) {
			return true;
		}
		if (numberIsNaN(a) && numberIsNaN(b)) {
			return true;
		}
		return false;
	};
	


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = __webpack_require__(198);
	var regexExec = RegExp.prototype.exec;
	var gOPD = Object.getOwnPropertyDescriptor;
	
	var tryRegexExecCall = function tryRegexExec(value) {
		try {
			var lastIndex = value.lastIndex;
			value.lastIndex = 0; // eslint-disable-line no-param-reassign
	
			regexExec.call(value);
			return true;
		} catch (e) {
			return false;
		} finally {
			value.lastIndex = lastIndex; // eslint-disable-line no-param-reassign
		}
	};
	var toStr = Object.prototype.toString;
	var regexClass = '[object RegExp]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}
		if (!hasToStringTag) {
			return toStr.call(value) === regexClass;
		}
	
		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}
	
		return tryRegexExecCall(value);
	};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(199);
	
	module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(200);
	
	module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 200 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var slice = Array.prototype.slice;
	var toStr = Object.prototype.toString;
	var funcType = '[object Function]';
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slice.call(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                args.concat(slice.call(arguments))
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        } else {
	            return target.apply(
	                that,
	                args.concat(slice.call(arguments))
	            );
	        }
	    };
	
	    var boundLength = Math.max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs.push('$' + i);
	    }
	
	    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(202);
	var callBind = __webpack_require__(203);
	
	var implementation = __webpack_require__(207);
	var getPolyfill = __webpack_require__(208);
	var shim = __webpack_require__(209);
	
	var flagsBound = callBind(implementation);
	
	define(flagsBound, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = flagsBound;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys = __webpack_require__(192);
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
	
	var toStr = Object.prototype.toString;
	var concat = Array.prototype.concat;
	var origDefineProperty = Object.defineProperty;
	
	var isFunction = function (fn) {
		return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
	};
	
	var arePropertyDescriptorsSupported = function () {
		var obj = {};
		try {
			origDefineProperty(obj, 'x', { enumerable: false, value: obj });
			// eslint-disable-next-line no-unused-vars, no-restricted-syntax
			for (var _ in obj) { // jscs:ignore disallowUnusedVariables
				return false;
			}
			return obj.x === obj;
		} catch (e) { /* this is IE 8. */
			return false;
		}
	};
	var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();
	
	var defineProperty = function (object, name, value, predicate) {
		if (name in object && (!isFunction(predicate) || !predicate())) {
			return;
		}
		if (supportsDescriptors) {
			origDefineProperty(object, name, {
				configurable: true,
				enumerable: false,
				value: value,
				writable: true
			});
		} else {
			object[name] = value;
		}
	};
	
	var defineProperties = function (object, map) {
		var predicates = arguments.length > 2 ? arguments[2] : {};
		var props = keys(map);
		if (hasSymbols) {
			props = concat.call(props, Object.getOwnPropertySymbols(map));
		}
		for (var i = 0; i < props.length; i += 1) {
			defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
		}
	};
	
	defineProperties.supportsDescriptors = !!supportsDescriptors;
	
	module.exports = defineProperties;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(199);
	
	var GetIntrinsic = __webpack_require__(204);
	
	var $Function = GetIntrinsic('%Function%');
	var $apply = $Function.apply;
	var $call = $Function.call;
	
	module.exports = function callBind() {
		return bind.apply($call, arguments);
	};
	
	module.exports.apply = function applyBind() {
		return bind.apply($apply, arguments);
	};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/* globals
		Atomics,
		SharedArrayBuffer,
	*/
	
	var undefined;
	
	var $TypeError = TypeError;
	
	var $gOPD = Object.getOwnPropertyDescriptor;
	if ($gOPD) {
		try {
			$gOPD({}, '');
		} catch (e) {
			$gOPD = null; // this is IE 8, which has a broken gOPD
		}
	}
	
	var throwTypeError = function () { throw new $TypeError(); };
	var ThrowTypeError = $gOPD
		? (function () {
			try {
				// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
				arguments.callee; // IE 8 does not throw here
				return throwTypeError;
			} catch (calleeThrows) {
				try {
					// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
					return $gOPD(arguments, 'callee').get;
				} catch (gOPDthrows) {
					return throwTypeError;
				}
			}
		}())
		: throwTypeError;
	
	var hasSymbols = __webpack_require__(205)();
	
	var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto
	
	var generator; // = function * () {};
	var generatorFunction = generator ? getProto(generator) : undefined;
	var asyncFn; // async function() {};
	var asyncFunction = asyncFn ? asyncFn.constructor : undefined;
	var asyncGen; // async function * () {};
	var asyncGenFunction = asyncGen ? getProto(asyncGen) : undefined;
	var asyncGenIterator = asyncGen ? asyncGen() : undefined;
	
	var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);
	
	var INTRINSICS = {
		'%Array%': Array,
		'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
		'%ArrayBufferPrototype%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer.prototype,
		'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
		'%ArrayPrototype%': Array.prototype,
		'%ArrayProto_entries%': Array.prototype.entries,
		'%ArrayProto_forEach%': Array.prototype.forEach,
		'%ArrayProto_keys%': Array.prototype.keys,
		'%ArrayProto_values%': Array.prototype.values,
		'%AsyncFromSyncIteratorPrototype%': undefined,
		'%AsyncFunction%': asyncFunction,
		'%AsyncFunctionPrototype%': asyncFunction ? asyncFunction.prototype : undefined,
		'%AsyncGenerator%': asyncGen ? getProto(asyncGenIterator) : undefined,
		'%AsyncGeneratorFunction%': asyncGenFunction,
		'%AsyncGeneratorPrototype%': asyncGenFunction ? asyncGenFunction.prototype : undefined,
		'%AsyncIteratorPrototype%': asyncGenIterator && hasSymbols && Symbol.asyncIterator ? asyncGenIterator[Symbol.asyncIterator]() : undefined,
		'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
		'%Boolean%': Boolean,
		'%BooleanPrototype%': Boolean.prototype,
		'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
		'%DataViewPrototype%': typeof DataView === 'undefined' ? undefined : DataView.prototype,
		'%Date%': Date,
		'%DatePrototype%': Date.prototype,
		'%decodeURI%': decodeURI,
		'%decodeURIComponent%': decodeURIComponent,
		'%encodeURI%': encodeURI,
		'%encodeURIComponent%': encodeURIComponent,
		'%Error%': Error,
		'%ErrorPrototype%': Error.prototype,
		'%eval%': eval, // eslint-disable-line no-eval
		'%EvalError%': EvalError,
		'%EvalErrorPrototype%': EvalError.prototype,
		'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
		'%Float32ArrayPrototype%': typeof Float32Array === 'undefined' ? undefined : Float32Array.prototype,
		'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
		'%Float64ArrayPrototype%': typeof Float64Array === 'undefined' ? undefined : Float64Array.prototype,
		'%Function%': Function,
		'%FunctionPrototype%': Function.prototype,
		'%Generator%': generator ? getProto(generator()) : undefined,
		'%GeneratorFunction%': generatorFunction,
		'%GeneratorPrototype%': generatorFunction ? generatorFunction.prototype : undefined,
		'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
		'%Int8ArrayPrototype%': typeof Int8Array === 'undefined' ? undefined : Int8Array.prototype,
		'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
		'%Int16ArrayPrototype%': typeof Int16Array === 'undefined' ? undefined : Int8Array.prototype,
		'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
		'%Int32ArrayPrototype%': typeof Int32Array === 'undefined' ? undefined : Int32Array.prototype,
		'%isFinite%': isFinite,
		'%isNaN%': isNaN,
		'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
		'%JSON%': typeof JSON === 'object' ? JSON : undefined,
		'%JSONParse%': typeof JSON === 'object' ? JSON.parse : undefined,
		'%Map%': typeof Map === 'undefined' ? undefined : Map,
		'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
		'%MapPrototype%': typeof Map === 'undefined' ? undefined : Map.prototype,
		'%Math%': Math,
		'%Number%': Number,
		'%NumberPrototype%': Number.prototype,
		'%Object%': Object,
		'%ObjectPrototype%': Object.prototype,
		'%ObjProto_toString%': Object.prototype.toString,
		'%ObjProto_valueOf%': Object.prototype.valueOf,
		'%parseFloat%': parseFloat,
		'%parseInt%': parseInt,
		'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
		'%PromisePrototype%': typeof Promise === 'undefined' ? undefined : Promise.prototype,
		'%PromiseProto_then%': typeof Promise === 'undefined' ? undefined : Promise.prototype.then,
		'%Promise_all%': typeof Promise === 'undefined' ? undefined : Promise.all,
		'%Promise_reject%': typeof Promise === 'undefined' ? undefined : Promise.reject,
		'%Promise_resolve%': typeof Promise === 'undefined' ? undefined : Promise.resolve,
		'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
		'%RangeError%': RangeError,
		'%RangeErrorPrototype%': RangeError.prototype,
		'%ReferenceError%': ReferenceError,
		'%ReferenceErrorPrototype%': ReferenceError.prototype,
		'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
		'%RegExp%': RegExp,
		'%RegExpPrototype%': RegExp.prototype,
		'%Set%': typeof Set === 'undefined' ? undefined : Set,
		'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
		'%SetPrototype%': typeof Set === 'undefined' ? undefined : Set.prototype,
		'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
		'%SharedArrayBufferPrototype%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer.prototype,
		'%String%': String,
		'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
		'%StringPrototype%': String.prototype,
		'%Symbol%': hasSymbols ? Symbol : undefined,
		'%SymbolPrototype%': hasSymbols ? Symbol.prototype : undefined,
		'%SyntaxError%': SyntaxError,
		'%SyntaxErrorPrototype%': SyntaxError.prototype,
		'%ThrowTypeError%': ThrowTypeError,
		'%TypedArray%': TypedArray,
		'%TypedArrayPrototype%': TypedArray ? TypedArray.prototype : undefined,
		'%TypeError%': $TypeError,
		'%TypeErrorPrototype%': $TypeError.prototype,
		'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
		'%Uint8ArrayPrototype%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array.prototype,
		'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
		'%Uint8ClampedArrayPrototype%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray.prototype,
		'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
		'%Uint16ArrayPrototype%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array.prototype,
		'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
		'%Uint32ArrayPrototype%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array.prototype,
		'%URIError%': URIError,
		'%URIErrorPrototype%': URIError.prototype,
		'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
		'%WeakMapPrototype%': typeof WeakMap === 'undefined' ? undefined : WeakMap.prototype,
		'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
		'%WeakSetPrototype%': typeof WeakSet === 'undefined' ? undefined : WeakSet.prototype
	};
	
	var bind = __webpack_require__(199);
	var $replace = bind.call(Function.call, String.prototype.replace);
	
	/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
	var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
	var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
	var stringToPath = function stringToPath(string) {
		var result = [];
		$replace(string, rePropName, function (match, number, quote, subString) {
			result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : (number || match);
		});
		return result;
	};
	/* end adaptation */
	
	var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
		if (!(name in INTRINSICS)) {
			throw new SyntaxError('intrinsic ' + name + ' does not exist!');
		}
	
		// istanbul ignore if // hopefully this is impossible to test :-)
		if (typeof INTRINSICS[name] === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}
	
		return INTRINSICS[name];
	};
	
	module.exports = function GetIntrinsic(name, allowMissing) {
		if (typeof name !== 'string' || name.length === 0) {
			throw new TypeError('intrinsic name must be a non-empty string');
		}
		if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
			throw new TypeError('"allowMissing" argument must be a boolean');
		}
	
		var parts = stringToPath(name);
	
		var value = getBaseIntrinsic('%' + (parts.length > 0 ? parts[0] : '') + '%', allowMissing);
		for (var i = 1; i < parts.length; i += 1) {
			if (value != null) {
				if ($gOPD && (i + 1) >= parts.length) {
					var desc = $gOPD(value, parts[i]);
					if (!allowMissing && !(parts[i] in value)) {
						throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
					}
					value = desc ? (desc.get || desc.value) : value[parts[i]];
				} else {
					value = value[parts[i]];
				}
			}
		}
		return value;
	};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var origSymbol = global.Symbol;
	var hasSymbolSham = __webpack_require__(206);
	
	module.exports = function hasNativeSymbols() {
		if (typeof origSymbol !== 'function') { return false; }
		if (typeof Symbol !== 'function') { return false; }
		if (typeof origSymbol('foo') !== 'symbol') { return false; }
		if (typeof Symbol('bar') !== 'symbol') { return false; }
	
		return hasSymbolSham();
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 206 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint complexity: [2, 18], max-statements: [2, 33] */
	module.exports = function hasSymbols() {
		if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
		if (typeof Symbol.iterator === 'symbol') { return true; }
	
		var obj = {};
		var sym = Symbol('test');
		var symObj = Object(sym);
		if (typeof sym === 'string') { return false; }
	
		if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
		if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }
	
		// temp disabled per https://github.com/ljharb/object.assign/issues/17
		// if (sym instanceof Symbol) { return false; }
		// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
		// if (!(symObj instanceof Symbol)) { return false; }
	
		// if (typeof Symbol.prototype.toString !== 'function') { return false; }
		// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
	
		var symVal = 42;
		obj[sym] = symVal;
		for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax
		if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }
	
		if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }
	
		var syms = Object.getOwnPropertySymbols(obj);
		if (syms.length !== 1 || syms[0] !== sym) { return false; }
	
		if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }
	
		if (typeof Object.getOwnPropertyDescriptor === 'function') {
			var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
			if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
		}
	
		return true;
	};


/***/ }),
/* 207 */
/***/ (function(module, exports) {

	'use strict';
	
	var $Object = Object;
	var $TypeError = TypeError;
	
	module.exports = function flags() {
		if (this != null && this !== $Object(this)) {
			throw new $TypeError('RegExp.prototype.flags getter called on non-object');
		}
		var result = '';
		if (this.global) {
			result += 'g';
		}
		if (this.ignoreCase) {
			result += 'i';
		}
		if (this.multiline) {
			result += 'm';
		}
		if (this.dotAll) {
			result += 's';
		}
		if (this.unicode) {
			result += 'u';
		}
		if (this.sticky) {
			result += 'y';
		}
		return result;
	};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(207);
	
	var supportsDescriptors = __webpack_require__(202).supportsDescriptors;
	var $gOPD = Object.getOwnPropertyDescriptor;
	var $TypeError = TypeError;
	
	module.exports = function getPolyfill() {
		if (!supportsDescriptors) {
			throw new $TypeError('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
		}
		if ((/a/mig).flags === 'gim') {
			var descriptor = $gOPD(RegExp.prototype, 'flags');
			if (descriptor && typeof descriptor.get === 'function' && typeof (/a/).dotAll === 'boolean') {
				return descriptor.get;
			}
		}
		return implementation;
	};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var supportsDescriptors = __webpack_require__(202).supportsDescriptors;
	var getPolyfill = __webpack_require__(208);
	var gOPD = Object.getOwnPropertyDescriptor;
	var defineProperty = Object.defineProperty;
	var TypeErr = TypeError;
	var getProto = Object.getPrototypeOf;
	var regex = /a/;
	
	module.exports = function shimFlags() {
		if (!supportsDescriptors || !getProto) {
			throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
		}
		var polyfill = getPolyfill();
		var proto = getProto(regex);
		var descriptor = gOPD(proto, 'flags');
		if (!descriptor || descriptor.get !== polyfill) {
			defineProperty(proto, 'flags', {
				configurable: true,
				enumerable: false,
				get: polyfill
			});
		}
		return polyfill;
	};


/***/ }),
/* 210 */
/***/ (function(module, exports) {

	'use strict';
	
	var getDay = Date.prototype.getDay;
	var tryDateObject = function tryDateGetDayCall(value) {
		try {
			getDay.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	
	var toStr = Object.prototype.toString;
	var dateClass = '[object Date]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isDateObject(value) {
		if (typeof value !== 'object' || value === null) {
			return false;
		}
		return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
	};


/***/ }),
/* 211 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var _slice = Array.prototype.slice;
	exports.loopAsync = loopAsync;
	
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = undefined;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(_slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(178);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Actions = __webpack_require__(184);
	
	var _PathUtils = __webpack_require__(185);
	
	function createLocation() {
	  var location = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
	  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	  var _fourthArg = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	
	  if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	  if (typeof action === 'object') {
	     false ? _warning2['default'](false, 'The state (2nd) argument to createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	    location = _extends({}, location, { state: action });
	
	    action = key || _Actions.POP;
	    key = _fourthArg;
	  }
	
	  var pathname = location.pathname || '/';
	  var search = location.search || '';
	  var hash = location.hash || '';
	  var state = location.state || null;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	}
	
	exports['default'] = createLocation;
	module.exports = exports['default'];

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(178);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? _warning2['default'](result === undefined, 'You should not "return" in a transition hook with a callback argument; call the callback instead') : undefined;
	  }
	}
	
	exports['default'] = runTransitionHook;
	module.exports = exports['default'];

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(178);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function deprecate(fn, message) {
	  return function () {
	     false ? _warning2['default'](false, '[history] ' + message) : undefined;
	    return fn.apply(this, arguments);
	  };
	}
	
	exports['default'] = deprecate;
	module.exports = exports['default'];

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(178);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _queryString = __webpack_require__(216);
	
	var _runTransitionHook = __webpack_require__(213);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(185);
	
	var _deprecate = __webpack_require__(214);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var SEARCH_BASE_KEY = '$searchBase';
	
	function defaultStringifyQuery(query) {
	  return _queryString.stringify(query).replace(/%20/g, '+');
	}
	
	var defaultParseQueryString = _queryString.parse;
	
	function isNestedObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p) && typeof object[p] === 'object' && !Array.isArray(object[p]) && object[p] !== null) return true;
	  }return false;
	}
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var stringifyQuery = options.stringifyQuery;
	    var parseQueryString = options.parseQueryString;
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    function addQuery(location) {
	      if (location.query == null) {
	        var search = location.search;
	
	        location.query = parseQueryString(search.substring(1));
	        location[SEARCH_BASE_KEY] = { search: search, searchBase: '' };
	      }
	
	      // TODO: Instead of all the book-keeping here, this should just strip the
	      // stringified query from the search.
	
	      return location;
	    }
	
	    function appendQuery(location, query) {
	      var _extends2;
	
	      var searchBaseSpec = location[SEARCH_BASE_KEY];
	      var queryString = query ? stringifyQuery(query) : '';
	      if (!searchBaseSpec && !queryString) {
	        return location;
	      }
	
	       false ? _warning2['default'](stringifyQuery !== defaultStringifyQuery || !isNestedObject(query), 'useQueries does not stringify nested query objects by default; ' + 'use a custom stringifyQuery function') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var searchBase = undefined;
	      if (searchBaseSpec && location.search === searchBaseSpec.search) {
	        searchBase = searchBaseSpec.searchBase;
	      } else {
	        searchBase = location.search || '';
	      }
	
	      var search = searchBase;
	      if (queryString) {
	        search += (search ? '&' : '?') + queryString;
	      }
	
	      return _extends({}, location, (_extends2 = {
	        search: search
	      }, _extends2[SEARCH_BASE_KEY] = { search: search, searchBase: searchBase }, _extends2));
	    }
	
	    // Override all read methods with query-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addQuery(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addQuery(location));
	      });
	    }
	
	    // Override all write methods with query-aware versions.
	    function push(location) {
	      history.push(appendQuery(location, location.query));
	    }
	
	    function replace(location) {
	      history.replace(appendQuery(location, location.query));
	    }
	
	    function createPath(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createPath is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createPath(appendQuery(location, query || location.query));
	    }
	
	    function createHref(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createHref is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createHref(appendQuery(location, query || location.query));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var fullLocation = history.createLocation.apply(history, [appendQuery(location, location.query)].concat(args));
	      if (location.query) {
	        fullLocation.query = location.query;
	      }
	      return addQuery(fullLocation);
	    }
	
	    // deprecated
	    function pushState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path, { query: query }));
	    }
	
	    // deprecated
	    function replaceState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path, { query: query }));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useQueries;
	module.exports = exports['default'];

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(217);
	var objectAssign = __webpack_require__(4);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ }),
/* 217 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(177);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(219);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(220);
	
	var _isActive2 = __webpack_require__(222);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(223);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(225);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	  function isActive(location) {
	    var indexOnlyOrDeprecatedQuery = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	    var deprecatedIndexOnly = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	    var indexOnly = void 0;
	    if (indexOnlyOrDeprecatedQuery && indexOnlyOrDeprecatedQuery !== true || deprecatedIndexOnly !== null) {
	       false ? (0, _routerWarning2.default)(false, '`isActive(pathname, query, indexOnly) is deprecated; use `isActive(location, indexOnly)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      location = { pathname: location, query: indexOnlyOrDeprecatedQuery };
	      indexOnly = deprecatedIndexOnly || false;
	    } else {
	      location = history.createLocation(location);
	      indexOnly = indexOnlyOrDeprecatedQuery;
	    }
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState);
	
	    var leaveRoutes = _computeChangedRoutes.leaveRoutes;
	    var changeRoutes = _computeChangedRoutes.changeRoutes;
	    var enterRoutes = _computeChangedRoutes.enterRoutes;
	
	
	    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.reduce(function (hooks, route) {
	      hooks.push.apply(hooks, RouteHooks[getRouteID(route)]);
	      return hooks;
	    }, []);
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route, false);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    // TODO: Warn if they register for a route that isn't currently
	    // active. They're probably doing something wrong, like re-creating
	    // route objects on every location change.
	    var routeID = getRouteID(route);
	    var hooks = RouteHooks[routeID];
	
	    if (!hooks) {
	      var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	
	      RouteHooks[routeID] = [hook];
	
	      if (thereWereNoRouteHooks) {
	        // setup transition & beforeunload hooks
	        unlistenBefore = history.listenBefore(transitionHook);
	
	        if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	      }
	    } else {
	      if (hooks.indexOf(hook) === -1) {
	         false ? (0, _routerWarning2.default)(false, 'adding multiple leave hooks for the same route is deprecated; manage multiple confirmations in your own code instead') : void 0;
	
	        hooks.push(hook);
	      }
	    }
	
	    return function () {
	      var hooks = RouteHooks[routeID];
	
	      if (hooks) {
	        var newHooks = hooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (newHooks.length === 0) {
	          removeListenBeforeHooksForRoute(route);
	        } else {
	          RouteHooks[routeID] = newHooks;
	        }
	      }
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    // TODO: Only use a single history listener. Otherwise we'll
	    // end up with multiple concurrent calls to match.
	    return history.listen(function (location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    });
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	
	//export default useRoutes
	
	module.exports = exports['default'];

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(180);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    (function () {
	      var parentIsLeaving = false;
	      leaveRoutes = prevRoutes.filter(function (route) {
	        if (parentIsLeaving) {
	          return true;
	        } else {
	          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	          if (isLeaving) parentIsLeaving = true;
	          return isLeaving;
	        }
	      });
	
	      // onLeave hooks start at the leaf route.
	      leaveRoutes.reverse();
	
	      enterRoutes = [];
	      changeRoutes = [];
	
	      nextRoutes.forEach(function (route) {
	        var isNew = prevRoutes.indexOf(route) === -1;
	        var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	      });
	    })();
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runEnterHooks = runEnterHooks;
	exports.runChangeHooks = runChangeHooks;
	exports.runLeaveHooks = runLeaveHooks;
	
	var _AsyncUtils = __webpack_require__(221);
	
	var _routerWarning = __webpack_require__(177);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createTransitionHook(hook, route, asyncArity) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    hook.apply(route, args);
	
	    if (hook.length < asyncArity) {
	      var callback = args[args.length - 1];
	      // Assume hook executes synchronously and
	      // automatically call the callback.
	      callback();
	    }
	  };
	}
	
	function getEnterHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3));
	
	    return hooks;
	  }, []);
	}
	
	function getChangeHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4));
	    return hooks;
	  }, []);
	}
	
	function runTransitionHooks(length, iter, callback) {
	  if (!length) {
	    callback();
	    return;
	  }
	
	  var redirectInfo = void 0;
	  function replace(location, deprecatedPathname, deprecatedQuery) {
	    if (deprecatedPathname) {
	       false ? (0, _routerWarning2.default)(false, '`replaceState(state, pathname, query) is deprecated; use `replace(location)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      redirectInfo = {
	        pathname: deprecatedPathname,
	        query: deprecatedQuery,
	        state: location
	      };
	
	      return;
	    }
	
	    redirectInfo = location;
	  }
	
	  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	    iter(index, replace, function (error) {
	      if (error || redirectInfo) {
	        done(error, redirectInfo); // No need to continue.
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	
	/**
	 * Runs all onEnter hooks in the given array of routes in order
	 * with onEnter(nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runEnterHooks(routes, nextState, callback) {
	  var hooks = getEnterHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onChange hooks in the given array of routes in order
	 * with onChange(prevState, nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runChangeHooks(routes, state, nextState, callback) {
	  var hooks = getChangeHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](state, nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onLeave hooks in the given array of routes in order.
	 */
	function runLeaveHooks(routes, prevState) {
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	  }
	}

/***/ }),
/* 221 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(180);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname;
	  var query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(221);
	
	var _makeStateWithLocation = __webpack_require__(224);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (!getComponent) {
	    callback();
	    return;
	  }
	
	  var location = nextState.location;
	
	  var nextStateWithLocation = (0, _makeStateWithLocation2.default)(nextState, location);
	
	  getComponent.call(route, nextStateWithLocation, callback);
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = makeStateWithLocation;
	
	var _deprecateObjectProperties = __webpack_require__(176);
	
	var _routerWarning = __webpack_require__(177);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeStateWithLocation(state, location) {
	  if (false) {
	    var stateWithLocation = _extends({}, state);
	
	    // I don't use deprecateObjectProperties here because I want to keep the
	    // same code path between development and production, in that we just
	    // assign extra properties to the copy of the state object in both cases.
	
	    var _loop = function _loop(prop) {
	      if (!Object.prototype.hasOwnProperty.call(location, prop)) {
	        return 'continue';
	      }
	
	      Object.defineProperty(stateWithLocation, prop, {
	        get: function get() {
	          process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, 'Accessing location properties directly from the first argument to `getComponent`, `getComponents`, `getChildRoutes`, and `getIndexRoute` is deprecated. That argument is now the router state (`nextState` or `partialNextState`) rather than the location. To access the location, use `nextState.location` or `partialNextState.location`.') : void 0;
	          return location[prop];
	        }
	      });
	    };
	
	    for (var prop in location) {
	      var _ret = _loop(prop);
	
	      if (_ret === 'continue') continue;
	    }
	
	    return stateWithLocation;
	  }
	
	  return _extends({}, state, location);
	}
	module.exports = exports['default'];

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(221);
	
	var _makeStateWithLocation = __webpack_require__(224);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	var _PatternUtils = __webpack_require__(180);
	
	var _routerWarning = __webpack_require__(177);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(174);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	  route.getChildRoutes(partialNextStateWithLocation, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	    route.getIndexRoute(partialNextStateWithLocation, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	  } else if (route.childRoutes) {
	    (function () {
	      var pathless = route.childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    })();
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var _ret2 = function () {
	        var match = {
	          routes: [route],
	          params: createParams(paramNames, paramValues)
	        };
	
	        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	          if (error) {
	            callback(error);
	          } else {
	            if (Array.isArray(indexRoute)) {
	              var _match$routes;
	
	               false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	                return !route.path;
	              }), 'Index routes should not have paths') : void 0;
	              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	            } else if (indexRoute) {
	               false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	              match.routes.push(indexRoute);
	            }
	
	            callback(null, match);
	          }
	        });
	
	        return {
	          v: void 0
	        };
	      }();
	
	      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];
	  var paramValues = arguments.length <= 5 || arguments[5] === undefined ? [] : arguments[5];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(181);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _deprecateObjectProperties = __webpack_require__(176);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _getRouteParams = __webpack_require__(227);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _RouteUtils = __webpack_require__(174);
	
	var _routerWarning = __webpack_require__(177);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var array = _React$PropTypes.array;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	
	var RouterContext = _react2.default.createClass({
	  displayName: 'RouterContext',
	
	
	  propTypes: {
	    history: object,
	    router: object.isRequired,
	    location: object.isRequired,
	    routes: array.isRequired,
	    params: object.isRequired,
	    components: array.isRequired,
	    createElement: func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    history: object,
	    location: object.isRequired,
	    router: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    var _props = this.props;
	    var router = _props.router;
	    var history = _props.history;
	    var location = _props.location;
	
	    if (!router) {
	       false ? (0, _routerWarning2.default)(false, '`<RouterContext>` expects a `router` rather than a `history`') : void 0;
	
	      router = _extends({}, history, {
	        setRouteLeaveHook: history.listenBeforeLeavingRoute
	      });
	      delete router.listenBeforeLeavingRoute;
	    }
	
	    if (false) {
	      location = (0, _deprecateObjectProperties2.default)(location, '`context.location` is deprecated, please use a route component\'s `props.location` instead. http://tiny.cc/router-accessinglocation');
	    }
	
	    return { history: history, location: location, router: router };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props2 = this.props;
	    var history = _props2.history;
	    var location = _props2.location;
	    var routes = _props2.routes;
	    var params = _props2.params;
	    var components = _props2.components;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          history: history,
	          location: location,
	          params: params,
	          route: route,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(180);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.createRoutingHistory = createRoutingHistory;
	
	var _deprecateObjectProperties = __webpack_require__(176);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createRouterObject(history, transitionManager) {
	  return _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	}
	
	// deprecated
	function createRoutingHistory(history, transitionManager) {
	  history = _extends({}, history, transitionManager);
	
	  if (false) {
	    history = (0, _deprecateObjectProperties2.default)(history, '`props.history` and `context.history` are deprecated. Please use `context.router`. http://tiny.cc/router-contextchanges');
	  }
	
	  return history;
	}

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(177);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(181);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(175);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var bool = _React$PropTypes.bool;
	var object = _React$PropTypes.object;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	var oneOfType = _React$PropTypes.oneOfType;
	
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function createLocationDescriptor(to, _ref) {
	  var query = _ref.query;
	  var hash = _ref.hash;
	  var state = _ref.state;
	
	  if (query || hash || state) {
	    return { pathname: to, query: query, hash: hash, state: state };
	  }
	
	  return to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 *
	 * Links may pass along location state and/or query string parameters
	 * in the state/query props, respectively.
	 *
	 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
	 */
	var Link = _react2.default.createClass({
	  displayName: 'Link',
	
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: oneOfType([string, object]),
	    query: object,
	    hash: string,
	    state: object,
	    activeStyle: object,
	    activeClassName: string,
	    onlyActiveOnIndex: bool.isRequired,
	    onClick: func,
	    target: string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    !this.context.router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    var _props = this.props;
	    var to = _props.to;
	    var query = _props.query;
	    var hash = _props.hash;
	    var state = _props.state;
	
	    var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	
	    this.context.router.push(location);
	  },
	  render: function render() {
	    var _props2 = this.props;
	    var to = _props2.to;
	    var query = _props2.query;
	    var hash = _props2.hash;
	    var state = _props2.state;
	    var activeClassName = _props2.activeClassName;
	    var activeStyle = _props2.activeStyle;
	    var onlyActiveOnIndex = _props2.onlyActiveOnIndex;
	
	    var props = _objectWithoutProperties(_props2, ['to', 'query', 'hash', 'state', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	     false ? (0, _routerWarning2.default)(!(query || hash || state), 'the `query`, `hash`, and `state` props on `<Link>` are deprecated, use `<Link to={{ pathname, query, hash, state }}/>. http://tiny.cc/router-isActivedeprecated') : void 0;
	
	    // Ignore if rendered outside the context of router, simplifies unit testing.
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (to == null) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	      props.href = router.createHref(location);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(location, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(229);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = _react2.default.createClass({
	  displayName: 'IndexLink',
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(181);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(232);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _PropTypes = __webpack_require__(175);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = _react2.default.createClass({
	    displayName: 'WithRouter',
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      var props = _extends({}, this.props, { router: router });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ }),
/* 232 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(177);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(181);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(234);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	
	var IndexRedirect = _react2.default.createClass({
	  displayName: 'IndexRedirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(181);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(174);
	
	var _PatternUtils = __webpack_require__(180);
	
	var _InternalPropTypes = __webpack_require__(179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	
	var Redirect = _react2.default.createClass({
	  displayName: 'Redirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location;
	        var params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: string,
	    from: string, // Alias for path
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(177);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(181);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(174);
	
	var _InternalPropTypes = __webpack_require__(179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react2.default.PropTypes.func;
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	
	var IndexRoute = _react2.default.createClass({
	  displayName: 'IndexRoute',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(181);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(174);
	
	var _InternalPropTypes = __webpack_require__(179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	
	var Route = _react2.default.createClass({
	  displayName: 'Route',
	
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(177);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _InternalPropTypes = __webpack_require__(179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A mixin that adds the "history" instance variable to components.
	 */
	var History = {
	
	  contextTypes: {
	    history: _InternalPropTypes.history
	  },
	
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `History` mixin is deprecated, please access `context.router` with your own `contextTypes`. http://tiny.cc/router-historymixin') : void 0;
	    this.history = this.context.history;
	  }
	};
	
	exports.default = History;
	module.exports = exports['default'];

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(177);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(181);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The Lifecycle mixin adds the routerWillLeave lifecycle method to a
	 * component that may be used to cancel a transition or prompt the user
	 * for confirmation.
	 *
	 * On standard transitions, routerWillLeave receives a single argument: the
	 * location we're transitioning to. To cancel the transition, return false.
	 * To prompt the user for confirmation, return a prompt message (string).
	 *
	 * During the beforeunload event (assuming you're using the useBeforeUnload
	 * history enhancer), routerWillLeave does not receive a location object
	 * because it isn't possible for us to know the location we're transitioning
	 * to. In this case routerWillLeave must return a prompt message to prevent
	 * the user from closing the window/tab.
	 */
	
	var Lifecycle = {
	
	  contextTypes: {
	    history: object.isRequired,
	    // Nested children receive the route as context, either
	    // set by the route component using the RouteContext mixin
	    // or by some other ancestor.
	    route: object
	  },
	
	  propTypes: {
	    // Route components receive the route object as a prop.
	    route: object
	  },
	
	  componentDidMount: function componentDidMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `Lifecycle` mixin is deprecated, please use `context.router.setRouteLeaveHook(route, hook)`. http://tiny.cc/router-lifecyclemixin') : void 0;
	    !this.routerWillLeave ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin requires you to define a routerWillLeave method') : (0, _invariant2.default)(false) : void 0;
	
	    var route = this.props.route || this.context.route;
	
	    !route ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin must be used on either a) a <Route component> or ' + 'b) a descendant of a <Route component> that uses the RouteContext mixin') : (0, _invariant2.default)(false) : void 0;
	
	    this._unlistenBeforeLeavingRoute = this.context.history.listenBeforeLeavingRoute(route, this.routerWillLeave);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlistenBeforeLeavingRoute) this._unlistenBeforeLeavingRoute();
	  }
	};
	
	exports.default = Lifecycle;
	module.exports = exports['default'];

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(177);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The RouteContext mixin provides a convenient way for route
	 * components to set the route in context. This is needed for
	 * routes that render elements that want to use the Lifecycle
	 * mixin to prevent transitions.
	 */
	
	var RouteContext = {
	
	  propTypes: {
	    route: object.isRequired
	  },
	
	  childContextTypes: {
	    route: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      route: this.props.route
	    };
	  },
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'The `RouteContext` mixin is deprecated. You can provide `this.props.route` on context with your own `contextTypes`. http://tiny.cc/router-routecontextmixin') : void 0;
	  }
	};
	
	exports.default = RouteContext;
	module.exports = exports['default'];

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _useQueries = __webpack_require__(215);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _createTransitionManager = __webpack_require__(218);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _routerWarning = __webpack_require__(177);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know about routing.
	 *
	 * Enhances history objects with the following methods:
	 *
	 * - listen((error, nextState) => {})
	 * - listenBeforeLeavingRoute(route, (nextLocation) => {})
	 * - match(location, (error, redirectLocation, nextState) => {})
	 * - isActive(pathname, query, indexOnly=false)
	 */
	function useRoutes(createHistory) {
	   false ? (0, _routerWarning2.default)(false, '`useRoutes` is deprecated. Please use `createTransitionManager` instead.') : void 0;
	
	  return function () {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var routes = _ref.routes;
	
	    var options = _objectWithoutProperties(_ref, ['routes']);
	
	    var history = (0, _useQueries2.default)(createHistory)(options);
	    var transitionManager = (0, _createTransitionManager2.default)(history, routes);
	    return _extends({}, history, transitionManager);
	  };
	}
	
	exports.default = useRoutes;
	module.exports = exports['default'];

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(226);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(177);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RoutingContext = _react2.default.createClass({
	  displayName: 'RoutingContext',
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, '`RoutingContext` has been renamed to `RouterContext`. Please use `import { RouterContext } from \'react-router\'`. http://tiny.cc/router-routercontext') : void 0;
	  },
	  render: function render() {
	    return _react2.default.createElement(_RouterContext2.default, this.props);
	  }
	});
	
	exports.default = RoutingContext;
	module.exports = exports['default'];

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(184);
	
	var _invariant = __webpack_require__(181);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(243);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(218);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(174);
	
	var _RouterUtils = __webpack_require__(228);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history;
	  var routes = _ref.routes;
	  var location = _ref.location;
	
	  var options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  var unlisten = void 0;
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    // Pick up the location from the history via synchronous history.listen
	    // call if needed.
	    unlisten = history.listen(function (historyLocation) {
	      location = historyLocation;
	    });
	  }
	
	  var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	  history = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    callback(error, redirectLocation && router.createLocation(redirectLocation, _Actions.REPLACE), nextState && _extends({}, nextState, {
	      history: history,
	      router: router,
	      matchContext: { history: history, transitionManager: transitionManager, router: router }
	    }));
	
	    // Defer removing the listener to here to prevent DOM histories from having
	    // to unwind DOM event listeners unnecessarily, in case callback renders a
	    // <Router> and attaches another history listener.
	    if (unlisten) {
	      unlisten();
	    }
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(215);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(244);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(245);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useRoutes` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  history.__v2_compatible__ = true;
	  return history;
	}
	module.exports = exports['default'];

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(178);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ExecutionEnvironment = __webpack_require__(186);
	
	var _PathUtils = __webpack_require__(185);
	
	var _runTransitionHook = __webpack_require__(213);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(214);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var basename = options.basename;
	
	    var checkedBaseHref = false;
	
	    function checkBaseHref() {
	      if (checkedBaseHref) {
	        return;
	      }
	
	      // Automatically use the value of <base href> in HTML
	      // documents as basename if it's not explicitly given.
	      if (basename == null && _ExecutionEnvironment.canUseDOM) {
	        var base = document.getElementsByTagName('base')[0];
	        var baseHref = base && base.getAttribute('href');
	
	        if (baseHref != null) {
	          basename = baseHref;
	
	           false ? _warning2['default'](false, 'Automatically setting basename using <base href> is deprecated and will ' + 'be removed in the next major release. The semantics of <base href> are ' + 'subtly different from basename. Please pass the basename explicitly in ' + 'the options to createHistory') : undefined;
	        }
	      }
	
	      checkedBaseHref = true;
	    }
	
	    function addBasename(location) {
	      checkBaseHref();
	
	      if (basename && location.basename == null) {
	        if (location.pathname.indexOf(basename) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    }
	
	    function prependBasename(location) {
	      checkBaseHref();
	
	      if (!basename) return location;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var pname = location.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, location, {
	        pathname: pathname
	      });
	    }
	
	    // Override all read methods with basename-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addBasename(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addBasename(location));
	      });
	    }
	
	    // Override all write methods with basename-aware versions.
	    function push(location) {
	      history.push(prependBasename(location));
	    }
	
	    function replace(location) {
	      history.replace(prependBasename(location));
	    }
	
	    function createPath(location) {
	      return history.createPath(prependBasename(location));
	    }
	
	    function createHref(location) {
	      return history.createHref(prependBasename(location));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    }
	
	    // deprecated
	    function pushState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path));
	    }
	
	    // deprecated
	    function replaceState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useBasename;
	module.exports = exports['default'];

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(178);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(181);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PathUtils = __webpack_require__(185);
	
	var _Actions = __webpack_require__(184);
	
	var _createHistory = __webpack_require__(190);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	}
	
	function createMemoryHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var history = _createHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: saveState,
	    go: go
	  }));
	
	  var _options = options;
	  var entries = _options.entries;
	  var current = _options.current;
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    var key = history.createKey();
	
	    if (typeof entry === 'string') return { pathname: entry, key: key };
	
	    if (typeof entry === 'object' && entry) return _extends({}, entry, { key: key });
	
	     true ?  false ? _invariant2['default'](false, 'Unable to create history entry from %s', entry) : _invariant2['default'](false) : undefined;
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? _invariant2['default'](false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : _invariant2['default'](false) : undefined;
	  }
	
	  var storage = createStateStorage(entries);
	
	  function saveState(key, state) {
	    storage[key] = state;
	  }
	
	  function readState(key) {
	    return storage[key];
	  }
	
	  function getCurrentLocation() {
	    var entry = entries[current];
	    var basename = entry.basename;
	    var pathname = entry.pathname;
	    var search = entry.search;
	
	    var path = (basename || '') + pathname + (search || '');
	
	    var key = undefined,
	        state = undefined;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    } else {
	      key = history.createKey();
	      state = null;
	      entry.key = key;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  }
	
	  function go(n) {
	    if (n) {
	      if (!canGo(n)) {
	         false ? _warning2['default'](false, 'Cannot go(%s) there is not enough history', n) : undefined;
	        return;
	      }
	
	      current += n;
	
	      var currentLocation = getCurrentLocation();
	
	      // change action to POP
	      history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	    }
	  }
	
	  function finishTransition(location) {
	    switch (location.action) {
	      case _Actions.PUSH:
	        current += 1;
	
	        // if we are not on the top of stack
	        // remove rest and push new
	        if (current < entries.length) entries.splice(current);
	
	        entries.push(location);
	        saveState(location.key, location.state);
	        break;
	      case _Actions.REPLACE:
	        entries[current] = location;
	        saveState(location.key, location.state);
	        break;
	    }
	  }
	
	  return history;
	}
	
	exports['default'] = createMemoryHistory;
	module.exports = exports['default'];

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(215);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(244);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    history.__v2_compatible__ = true;
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(226);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(177);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length <= 0 || arguments[0] === undefined ? _react.createElement : arguments[0];
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(249);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(250);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(181);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(184);
	
	var _PathUtils = __webpack_require__(185);
	
	var _ExecutionEnvironment = __webpack_require__(186);
	
	var _DOMUtils = __webpack_require__(187);
	
	var _DOMStateStorage = __webpack_require__(188);
	
	var _createDOMHistory = __webpack_require__(189);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve URLs.
	 */
	function createBrowserHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Browser history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var forceRefresh = options.forceRefresh;
	
	  var isSupported = _DOMUtils.supportsHistory();
	  var useRefresh = !isSupported || forceRefresh;
	
	  function getCurrentLocation(historyState) {
	    try {
	      historyState = historyState || window.history.state || {};
	    } catch (e) {
	      historyState = {};
	    }
	
	    var path = _DOMUtils.getWindowPath();
	    var _historyState = historyState;
	    var key = _historyState.key;
	
	    var state = undefined;
	    if (key) {
	      state = _DOMStateStorage.readState(key);
	    } else {
	      state = null;
	      key = history.createKey();
	
	      if (isSupported) window.history.replaceState(_extends({}, historyState, { key: key }), null);
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startPopStateListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function popStateListener(event) {
	      if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.
	
	      transitionTo(getCurrentLocation(event.state));
	    }
	
	    _DOMUtils.addEventListener(window, 'popstate', popStateListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'popstate', popStateListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    _DOMStateStorage.saveState(key, state);
	
	    var path = (basename || '') + pathname + search + hash;
	    var historyState = {
	      key: key
	    };
	
	    if (action === _Actions.PUSH) {
	      if (useRefresh) {
	        window.location.href = path;
	        return false; // Prevent location update.
	      } else {
	          window.history.pushState(historyState, null, path);
	        }
	    } else {
	      // REPLACE
	      if (useRefresh) {
	        window.location.replace(path);
	        return false; // Prevent location update.
	      } else {
	          window.history.replaceState(historyState, null, path);
	        }
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopPopStateListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopPopStateListener();
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    registerTransitionHook: registerTransitionHook,
	    unregisterTransitionHook: unregisterTransitionHook
	  });
	}
	
	exports['default'] = createBrowserHistory;
	module.exports = exports['default'];

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	};
	
	var _useRouterHistory = __webpack_require__(246);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	module.exports = exports['default'];

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(183);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(250);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useScroll;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ScrollBehaviorContext = __webpack_require__(253);
	
	var _ScrollBehaviorContext2 = _interopRequireDefault(_ScrollBehaviorContext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useScroll(shouldUpdateScroll) {
	  return {
	    renderRouterContext: function renderRouterContext(child, props) {
	      return _react2.default.createElement(
	        _ScrollBehaviorContext2.default,
	        {
	          shouldUpdateScroll: shouldUpdateScroll,
	          routerProps: props
	        },
	        child
	      );
	    }
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ScrollBehavior = __webpack_require__(254);
	
	var _ScrollBehavior2 = _interopRequireDefault(_ScrollBehavior);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  shouldUpdateScroll: _react2.default.PropTypes.func,
	  routerProps: _react2.default.PropTypes.object.isRequired,
	  children: _react2.default.PropTypes.element.isRequired
	};
	
	var childContextTypes = {
	  scrollBehavior: _react2.default.PropTypes.object.isRequired
	};
	
	var ScrollBehaviorContext = function (_React$Component) {
	  _inherits(ScrollBehaviorContext, _React$Component);
	
	  function ScrollBehaviorContext(props, context) {
	    _classCallCheck(this, ScrollBehaviorContext);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _initialiseProps.call(_this);
	
	    var routerProps = props.routerProps;
	
	
	    _this.scrollBehavior = new _ScrollBehavior2.default(routerProps.router, function () {
	      return _this.props.routerProps.location;
	    }, _this.shouldUpdateScroll);
	
	    _this.scrollBehavior.updateScroll(null, routerProps);
	    return _this;
	  }
	
	  ScrollBehaviorContext.prototype.getChildContext = function getChildContext() {
	    return {
	      scrollBehavior: this
	    };
	  };
	
	  ScrollBehaviorContext.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var routerProps = this.props.routerProps;
	
	    var prevRouterProps = prevProps.routerProps;
	
	    if (routerProps.location === prevRouterProps.location) {
	      return;
	    }
	
	    this.scrollBehavior.updateScroll(prevRouterProps, routerProps);
	  };
	
	  ScrollBehaviorContext.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.scrollBehavior.stop();
	  };
	
	  ScrollBehaviorContext.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return ScrollBehaviorContext;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.shouldUpdateScroll = function (prevRouterProps, routerProps) {
	    var shouldUpdateScroll = _this2.props.shouldUpdateScroll;
	
	    if (!shouldUpdateScroll) {
	      return true;
	    }
	
	    // Hack to allow accessing scrollBehavior.readPosition().
	    return shouldUpdateScroll.call(_this2.scrollBehavior, prevRouterProps, routerProps);
	  };
	
	  this.registerElement = function (key, element, shouldUpdateScroll) {
	    _this2.scrollBehavior.registerElement(key, element, shouldUpdateScroll, _this2.props.routerProps);
	  };
	
	  this.unregisterElement = function (key) {
	    _this2.scrollBehavior.unregisterElement(key);
	  };
	};
	
	ScrollBehaviorContext.propTypes = propTypes;
	ScrollBehaviorContext.childContextTypes = childContextTypes;
	
	exports.default = ScrollBehaviorContext;
	module.exports = exports['default'];

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _off = __webpack_require__(255);
	
	var _off2 = _interopRequireDefault(_off);
	
	var _on = __webpack_require__(257);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _scrollLeft = __webpack_require__(258);
	
	var _scrollLeft2 = _interopRequireDefault(_scrollLeft);
	
	var _scrollTop = __webpack_require__(260);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _requestAnimationFrame = __webpack_require__(261);
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _Actions = __webpack_require__(184);
	
	var _DOMStateStorage = __webpack_require__(188);
	
	var _invariant = __webpack_require__(181);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* eslint-disable no-underscore-dangle */
	
	// FIXME: Stop using this gross hack. This won't collide with any actual
	// history location keys, but it's dirty to sneakily use the same storage here.
	var KEY_PREFIX = 's/';
	
	// Try at most this many times to scroll, to avoid getting stuck.
	var MAX_SCROLL_ATTEMPTS = 2;
	
	var ScrollBehavior = function () {
	  function ScrollBehavior(history, getCurrentLocation, shouldUpdateScroll) {
	    var _this = this;
	
	    _classCallCheck(this, ScrollBehavior);
	
	    this._onWindowScroll = function () {
	      // It's possible that this scroll operation was triggered by what will be a
	      // `POP` transition. Instead of updating the saved location immediately, we
	      // have to enqueue the update, then potentially cancel it if we observe a
	      // location update.
	      if (_this._saveWindowPositionHandle === null) {
	        _this._saveWindowPositionHandle = (0, _requestAnimationFrame2.default)(_this._saveWindowPosition);
	      }
	
	      if (_this._windowScrollTarget) {
	        var _windowScrollTarget = _this._windowScrollTarget;
	        var xTarget = _windowScrollTarget[0];
	        var yTarget = _windowScrollTarget[1];
	
	        var x = (0, _scrollLeft2.default)(window);
	        var y = (0, _scrollTop2.default)(window);
	
	        if (x === xTarget && y === yTarget) {
	          _this._windowScrollTarget = null;
	          _this._cancelCheckWindowScroll();
	        }
	      }
	    };
	
	    this._saveWindowPosition = function () {
	      _this._saveWindowPositionHandle = null;
	
	      _this._savePosition(null, window);
	    };
	
	    this._checkWindowScrollPosition = function () {
	      _this._checkWindowScrollHandle = null;
	
	      // We can only get here if scrollTarget is set. Every code path that unsets
	      // scroll target also cancels the handle to avoid calling this handler.
	      // Still, check anyway just in case.
	      /* istanbul ignore if: paranoid guard */
	      if (!_this._windowScrollTarget) {
	        return;
	      }
	
	      var _windowScrollTarget2 = _this._windowScrollTarget;
	      var x = _windowScrollTarget2[0];
	      var y = _windowScrollTarget2[1];
	
	      window.scrollTo(x, y);
	
	      ++_this._numWindowScrollAttempts;
	
	      /* istanbul ignore if: paranoid guard */
	      if (_this._numWindowScrollAttempts >= MAX_SCROLL_ATTEMPTS) {
	        _this._windowScrollTarget = null;
	        return;
	      }
	
	      _this._checkWindowScrollHandle = (0, _requestAnimationFrame2.default)(_this._checkWindowScrollPosition);
	    };
	
	    this._history = history;
	    this._getCurrentLocation = getCurrentLocation;
	    this._shouldUpdateScroll = shouldUpdateScroll;
	
	    // This helps avoid some jankiness in fighting against the browser's
	    // default scroll behavior on `POP` transitions.
	    /* istanbul ignore if: not supported by any browsers on Travis */
	    if ('scrollRestoration' in window.history) {
	      this._oldScrollRestoration = window.history.scrollRestoration;
	      window.history.scrollRestoration = 'manual';
	    } else {
	      this._oldScrollRestoration = null;
	    }
	
	    this._saveWindowPositionHandle = null;
	    this._checkWindowScrollHandle = null;
	    this._windowScrollTarget = null;
	    this._numWindowScrollAttempts = 0;
	
	    this._scrollElements = {};
	
	    // We have to listen to each window scroll update rather than to just
	    // location updates, because some browsers will update scroll position
	    // before emitting the location change.
	    (0, _on2.default)(window, 'scroll', this._onWindowScroll);
	
	    this._unlistenBefore = history.listenBefore(function () {
	      if (_this._saveWindowPositionHandle !== null) {
	        _requestAnimationFrame2.default.cancel(_this._saveWindowPositionHandle);
	        _this._saveWindowPositionHandle = null;
	      }
	
	      // It's fine to save element scroll positions here, though; the browser
	      // won't modify them.
	      Object.keys(_this._scrollElements).forEach(function (key) {
	        _this._saveElementPosition(key);
	      });
	    });
	  }
	
	  ScrollBehavior.prototype.stop = function stop() {
	    /* istanbul ignore if: not supported by any browsers on Travis */
	    if (this._oldScrollRestoration) {
	      window.history.scrollRestoration = this._oldScrollRestoration;
	    }
	
	    (0, _off2.default)(window, 'scroll', this._onWindowScroll);
	    this._cancelCheckWindowScroll();
	
	    this._unlistenBefore();
	  };
	
	  ScrollBehavior.prototype.registerElement = function registerElement(key, element, shouldUpdateScroll, context) {
	    !!this._scrollElements[key] ?  false ? (0, _invariant2.default)(false, 'ScrollBehavior: There is already an element registered for `%s`.', key) : (0, _invariant2.default)(false) : void 0;
	
	    this._scrollElements[key] = { element: element, shouldUpdateScroll: shouldUpdateScroll };
	    this._updateElementScroll(key, null, context);
	  };
	
	  ScrollBehavior.prototype.unregisterElement = function unregisterElement(key) {
	    !this._scrollElements[key] ?  false ? (0, _invariant2.default)(false, 'ScrollBehavior: There is no element registered for `%s`.', key) : (0, _invariant2.default)(false) : void 0;
	
	    delete this._scrollElements[key];
	  };
	
	  ScrollBehavior.prototype.updateScroll = function updateScroll(prevContext, context) {
	    var _this2 = this;
	
	    this._updateWindowScroll(prevContext, context);
	
	    Object.keys(this._scrollElements).forEach(function (key) {
	      _this2._updateElementScroll(key, prevContext, context);
	    });
	  };
	
	  ScrollBehavior.prototype.readPosition = function readPosition(location, key) {
	    return (0, _DOMStateStorage.readState)(this._getKey(location, key));
	  };
	
	  ScrollBehavior.prototype._cancelCheckWindowScroll = function _cancelCheckWindowScroll() {
	    if (this._checkWindowScrollHandle !== null) {
	      _requestAnimationFrame2.default.cancel(this._checkWindowScrollHandle);
	      this._checkWindowScrollHandle = null;
	    }
	  };
	
	  ScrollBehavior.prototype._saveElementPosition = function _saveElementPosition(key) {
	    var element = this._scrollElements[key].element;
	
	
	    this._savePosition(key, element);
	  };
	
	  ScrollBehavior.prototype._savePosition = function _savePosition(key, element) {
	    // We have to directly update `DOMStateStorage`, because actually updating
	    // the location could cause e.g. React Router to re-render the entire page,
	    // which would lead to observably bad scroll performance.
	    (0, _DOMStateStorage.saveState)(this._getKey(this._getCurrentLocation(), key), [(0, _scrollLeft2.default)(element), (0, _scrollTop2.default)(element)]);
	  };
	
	  ScrollBehavior.prototype._getKey = function _getKey(location, key) {
	    // Use fallback location key when actual location key is unavailable.
	    var locationKey = location.key || this._history.createHref(location);
	
	    return key == null ? '' + KEY_PREFIX + locationKey : '' + KEY_PREFIX + key + '/' + locationKey;
	  };
	
	  ScrollBehavior.prototype._updateWindowScroll = function _updateWindowScroll(prevContext, context) {
	    // Whatever we were doing before isn't relevant any more.
	    this._cancelCheckWindowScroll();
	
	    this._windowScrollTarget = this._getScrollTarget(null, this._shouldUpdateScroll, prevContext, context);
	
	    // Check the scroll position to see if we even need to scroll. This call
	    // will unset _windowScrollTarget if the current scroll position matches
	    // the target.
	    this._onWindowScroll();
	
	    if (!this._windowScrollTarget) {
	      return;
	    }
	
	    // Updating the window scroll position is really flaky. Just trying to
	    // scroll it isn't enough. Instead, try to scroll a few times until it
	    // works.
	    this._numWindowScrollAttempts = 0;
	    this._checkWindowScrollPosition();
	  };
	
	  ScrollBehavior.prototype._updateElementScroll = function _updateElementScroll(key, prevContext, context) {
	    var _scrollElements$key = this._scrollElements[key];
	    var element = _scrollElements$key.element;
	    var shouldUpdateScroll = _scrollElements$key.shouldUpdateScroll;
	
	
	    var scrollTarget = this._getScrollTarget(key, shouldUpdateScroll, prevContext, context);
	    if (!scrollTarget) {
	      return;
	    }
	
	    // Unlike with the window, there shouldn't be any flakiness to deal with
	    // here.
	    var x = scrollTarget[0];
	    var y = scrollTarget[1];
	
	    (0, _scrollLeft2.default)(element, x);
	    (0, _scrollTop2.default)(element, y);
	  };
	
	  ScrollBehavior.prototype._getScrollTarget = function _getScrollTarget(key, shouldUpdateScroll, prevContext, context) {
	    var scrollTarget = shouldUpdateScroll ? shouldUpdateScroll.call(this, prevContext, context) : true;
	
	    if (!scrollTarget || Array.isArray(scrollTarget)) {
	      return scrollTarget;
	    }
	
	    var location = this._getCurrentLocation();
	    if (location.action === _Actions.PUSH) {
	      return [0, 0];
	    }
	
	    return this.readPosition(location, key) || [0, 0];
	  };
	
	  return ScrollBehavior;
	}();
	
	exports.default = ScrollBehavior;
	module.exports = exports['default'];

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__(256);
	var off = function off() {};
	
	if (canUseDOM) {
	
	  off = (function () {
	
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  })();
	}
	
	module.exports = off;

/***/ }),
/* 256 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__(256);
	var on = function on() {};
	
	if (canUseDOM) {
	  on = (function () {
	
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, handler);
	    };
	  })();
	}
	
	module.exports = on;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var getWindow = __webpack_require__(259);
	
	module.exports = function scrollTop(node, val) {
	  var win = getWindow(node);
	
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	};

/***/ }),
/* 259 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	};

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var getWindow = __webpack_require__(259);
	
	module.exports = function scrollTop(node, val) {
	  var win = getWindow(node);
	
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	};

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var canUseDOM = __webpack_require__(256);
	
	var vendors = ['', 'webkit', 'moz', 'o', 'ms'],
	    cancel = 'clearTimeout',
	    raf = fallback,
	    compatRaf;
	
	var getKey = function getKey(vendor, k) {
	  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
	};
	
	if (canUseDOM) {
	  vendors.some(function (vendor) {
	    var rafKey = getKey(vendor, 'request');
	
	    if (rafKey in window) {
	      cancel = getKey(vendor, 'cancel');
	      return raf = function (cb) {
	        return window[rafKey](cb);
	      };
	    }
	  });
	}
	
	/* https://github.com/component/raf */
	var prev = new Date().getTime();
	
	function fallback(fn) {
	  var curr = new Date().getTime(),
	      ms = Math.max(0, 16 - (curr - prev)),
	      req = setTimeout(fn, ms);
	
	  prev = curr;
	  return req;
	}
	
	compatRaf = function (cb) {
	  return raf(cb);
	};
	compatRaf.cancel = function (id) {
	  return window[cancel](id);
	};
	
	module.exports = compatRaf;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _filter = __webpack_require__(263);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _last = __webpack_require__(385);
	
	var _last2 = _interopRequireDefault(_last);
	
	var _sortBy = __webpack_require__(386);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	var _gatsbyHelpers = __webpack_require__(403);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*  weak */
	function requireComponent(moduleReq) {
	  // Minor differences in `require` behavior across languages
	  // are handled by this wrapper.
	  //
	  // If `moduleReq` is a typescript module (versus javascript/coffeescript)
	  // an object with a `default` property is returned rather than the
	  // default export.
	  var module = moduleReq;
	  if (module.default) {
	    module = module.default;
	  }
	  return module;
	}
	
	module.exports = function (files, pagesReq) {
	  // Remove files that start with an underscore as this indicates
	  // the file shouldn't be turned into a page.
	  var pages = (0, _filter2.default)(files, function (file) {
	    return file.file.name.slice(0, 1) !== '_';
	  });
	  var templates = (0, _filter2.default)(files, function (file) {
	    return (
	      // eslint-disable-next-line comma-dangle
	      file.file.name === '_template'
	    );
	  });
	
	  var routes = {
	    path: (0, _gatsbyHelpers.prefixLink)('/'),
	    component: requireComponent(__webpack_require__(406)),
	    childRoutes: [],
	    indexRoute: {},
	    pages: pages,
	    templates: templates
	  };
	  var notFound = null;
	  var templatesHash = {};
	  templatesHash.root = routes;
	  templatesHash['/'] = routes;
	
	  // Arrange pages in data structure according to their position
	  // on the file system. Then use this to create routes.
	  //
	  // Algorithm
	  // 1. Find all templates.
	  // 2. Create routes for each template russian-doll style.
	  // 3. For each index file paired with a template, create a default route
	  // 4. Create normal routes for each remaining file under the appropriate
	  // template
	  var templatesWithoutRoot = (0, _filter2.default)(files, function (file) {
	    return (
	      // eslint-disable-next-line comma-dangle
	      file.file.name === '_template' && file.file.dirname !== ''
	    );
	  }
	
	  // Find the parent template for each template file and create a route
	  // with it.
	  );templatesWithoutRoot.forEach(function (templateFile) {
	    var parentTemplates = (0, _filter2.default)(templatesWithoutRoot, function (template) {
	      return (
	        // eslint-disable-next-line comma-dangle
	        templateFile.requirePath.indexOf(template.file.dirname) === 0 && templateFile !== template
	      );
	    }
	    // Sort parent templates by directory length. In cases
	    // where a template has multiple parents
	    // e.g. /_template.js/blog/_template.js/archive/_template.js
	    // we want to nest this template under its most immediate parent.
	    );parentTemplates = (0, _sortBy2.default)(parentTemplates, function (template) {
	      if (template) {
	        return template.file.dirname.length;
	      } else {
	        return 0;
	      }
	    });
	    var parentTemplateFile = (0, _last2.default)(parentTemplates);
	    var parentRoute = void 0;
	    if (parentTemplateFile) {
	      parentRoute = templatesHash[parentTemplateFile.file.dirname];
	    }
	    if (!parentRoute) {
	      parentRoute = templatesHash.root;
	    }
	
	    // Create new route for the template.
	    var route = {
	      path: (0, _gatsbyHelpers.prefixLink)(templateFile.templatePath),
	      component: requireComponent(pagesReq('./' + templateFile.requirePath)),
	      childRoutes: [],
	      indexRoute: {},
	      pages: pages,
	      templates: templates,
	      parentTemplateFile: parentTemplateFile
	
	      // Add route to the templates object for easy access.
	    };templatesHash[templateFile.file.dirname] = route;
	
	    // Push new route onto its parent.
	    parentRoute.childRoutes.push(route);
	  });
	
	  var staticFileTypes = ['ipynb', 'md', 'rmd', 'mkd', 'mkdn', 'mdwn', 'mdown', 'markdown', 'litcoffee', 'html', 'json', 'yaml', 'toml'];
	  var reactComponentFileTypes = ['js', 'ts', 'jsx', 'tsx', 'cjsx'];
	  var wrappers = {};
	  staticFileTypes.forEach(function (type) {
	    try {
	      // $FlowIssue - https://github.com/facebook/flow/issues/1975
	      wrappers[type] = __webpack_require__(950)("./" + type);
	    } catch (e) {
	      // Ignore module not found errors; show others on console
	      if (e.code !== 'MODULE_NOT_FOUND' && e.message && !e.message.match(/^Cannot find module/) && typeof console !== 'undefined') {
	        console.error('Error requiring wrapper', type, ':', e);
	      }
	    }
	  });
	
	  pages.forEach(function (p) {
	    var page = p;
	    var handler = void 0;
	    if (staticFileTypes.indexOf(page.file.ext) !== -1) {
	      handler = wrappers[page.file.ext];
	      page.data = pagesReq('./' + page.requirePath);
	    } else if (reactComponentFileTypes.indexOf(page.file.ext) !== -1) {
	      handler = requireComponent(pagesReq('./' + page.requirePath));
	      page.data = page.data === undefined ? {} : page.data;
	    }
	
	    // Determine parent template for page.
	    var parentTemplates = (0, _filter2.default)(templatesWithoutRoot, function (templateFile) {
	      return (
	        // eslint-disable-next-line comma-dangle
	        page.requirePath.indexOf(templateFile.file.dirname) === 0
	      );
	    });
	
	    var sortedParentTemplates = (0, _sortBy2.default)(parentTemplates, function (route) {
	      return route.file.dirname.length;
	    });
	
	    var parentTemplateFile = (0, _last2.default)(sortedParentTemplates);
	    var parentRoute = void 0;
	    if (parentTemplateFile) {
	      parentRoute = templatesHash[parentTemplateFile.file.dirname];
	    }
	
	    if (!parentRoute) {
	      parentRoute = templatesHash.root;
	    }
	
	    // If page is an index page *and* has the same path as its parentRoute,
	    // it is the index route (for that template).
	    if (page.file.name === 'index' && (0, _gatsbyHelpers.prefixLink)(page.path) === parentRoute.path) {
	      parentRoute.indexRoute = {
	        component: handler,
	        page: page,
	        pages: pages,
	        templates: templates,
	        parentTemplateFile: parentTemplateFile
	      };
	    } else {
	      parentRoute.childRoutes.push({
	        path: (0, _gatsbyHelpers.prefixLink)(page.path),
	        component: handler,
	        page: page,
	        pages: pages,
	        templates: templates,
	        parentTemplateFile: parentTemplateFile
	      });
	    }
	
	    if (page.path.indexOf('/404') !== -1) {
	      notFound = {
	        path: '*',
	        component: handler,
	        page: page,
	        pages: pages,
	        templates: templates,
	        parentTemplateFile: parentTemplateFile
	      };
	    }
	  });
	
	  if (notFound) {
	    routes.childRoutes.push(notFound);
	  }
	
	  return routes;
	};

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(264),
	    baseFilter = __webpack_require__(265),
	    baseIteratee = __webpack_require__(300),
	    isArray = __webpack_require__(282);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * **Note:** Unlike `_.remove`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.reject
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = filter;


/***/ }),
/* 264 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(266);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(267),
	    createBaseEach = __webpack_require__(299);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(268),
	    keys = __webpack_require__(270);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(269);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),
/* 269 */
/***/ (function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(271),
	    baseKeys = __webpack_require__(292),
	    isArrayLike = __webpack_require__(296);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(272),
	    isArguments = __webpack_require__(273),
	    isArray = __webpack_require__(282),
	    isBuffer = __webpack_require__(283),
	    isIndex = __webpack_require__(286),
	    isTypedArray = __webpack_require__(287);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 272 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(274),
	    isObjectLike = __webpack_require__(281);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(275),
	    isObjectLike = __webpack_require__(281);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(276),
	    getRawTag = __webpack_require__(279),
	    objectToString = __webpack_require__(280);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(277);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(278);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 278 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(276);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 280 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 281 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 282 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(277),
	    stubFalse = __webpack_require__(285);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(284)(module)))

/***/ }),
/* 284 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 285 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 286 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(288),
	    baseUnary = __webpack_require__(290),
	    nodeUtil = __webpack_require__(291);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(275),
	    isLength = __webpack_require__(289),
	    isObjectLike = __webpack_require__(281);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 289 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 290 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(278);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(284)(module)))

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(293),
	    nativeKeys = __webpack_require__(294);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 293 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(295);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 295 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(297),
	    isLength = __webpack_require__(289);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(275),
	    isObject = __webpack_require__(298);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 298 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(296);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(301),
	    baseMatchesProperty = __webpack_require__(365),
	    identity = __webpack_require__(381),
	    isArray = __webpack_require__(282),
	    property = __webpack_require__(382);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(302),
	    getMatchData = __webpack_require__(362),
	    matchesStrictComparable = __webpack_require__(364);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(303),
	    baseIsEqual = __webpack_require__(339);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(304),
	    stackClear = __webpack_require__(312),
	    stackDelete = __webpack_require__(313),
	    stackGet = __webpack_require__(314),
	    stackHas = __webpack_require__(315),
	    stackSet = __webpack_require__(316);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(305),
	    listCacheDelete = __webpack_require__(306),
	    listCacheGet = __webpack_require__(309),
	    listCacheHas = __webpack_require__(310),
	    listCacheSet = __webpack_require__(311);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 305 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(307);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(308);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 308 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(307);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(307);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(307);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(304);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 313 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 314 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 315 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(304),
	    Map = __webpack_require__(317),
	    MapCache = __webpack_require__(324);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(318),
	    root = __webpack_require__(277);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(319),
	    getValue = __webpack_require__(323);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(297),
	    isMasked = __webpack_require__(320),
	    isObject = __webpack_require__(298),
	    toSource = __webpack_require__(322);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(321);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(277);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 322 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 323 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(325),
	    mapCacheDelete = __webpack_require__(333),
	    mapCacheGet = __webpack_require__(336),
	    mapCacheHas = __webpack_require__(337),
	    mapCacheSet = __webpack_require__(338);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(326),
	    ListCache = __webpack_require__(304),
	    Map = __webpack_require__(317);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(327),
	    hashDelete = __webpack_require__(329),
	    hashGet = __webpack_require__(330),
	    hashHas = __webpack_require__(331),
	    hashSet = __webpack_require__(332);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(328);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(318);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 329 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(328);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(328);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(328);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(334);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(335);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 335 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(334);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(334);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(334);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(340),
	    isObjectLike = __webpack_require__(281);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(303),
	    equalArrays = __webpack_require__(341),
	    equalByTag = __webpack_require__(347),
	    equalObjects = __webpack_require__(351),
	    getTag = __webpack_require__(357),
	    isArray = __webpack_require__(282),
	    isBuffer = __webpack_require__(283),
	    isTypedArray = __webpack_require__(287);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(342),
	    arraySome = __webpack_require__(345),
	    cacheHas = __webpack_require__(346);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(324),
	    setCacheAdd = __webpack_require__(343),
	    setCacheHas = __webpack_require__(344);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),
/* 343 */
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),
/* 344 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),
/* 345 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),
/* 346 */
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(276),
	    Uint8Array = __webpack_require__(348),
	    eq = __webpack_require__(308),
	    equalArrays = __webpack_require__(341),
	    mapToArray = __webpack_require__(349),
	    setToArray = __webpack_require__(350);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(277);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 349 */
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),
/* 350 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(352);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(353),
	    getSymbols = __webpack_require__(355),
	    keys = __webpack_require__(270);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(354),
	    isArray = __webpack_require__(282);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 354 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(264),
	    stubArray = __webpack_require__(356);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 356 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(358),
	    Map = __webpack_require__(317),
	    Promise = __webpack_require__(359),
	    Set = __webpack_require__(360),
	    WeakMap = __webpack_require__(361),
	    baseGetTag = __webpack_require__(275),
	    toSource = __webpack_require__(322);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(318),
	    root = __webpack_require__(277);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(318),
	    root = __webpack_require__(277);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(318),
	    root = __webpack_require__(277);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(318),
	    root = __webpack_require__(277);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(363),
	    keys = __webpack_require__(270);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(298);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),
/* 364 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(339),
	    get = __webpack_require__(366),
	    hasIn = __webpack_require__(378),
	    isKey = __webpack_require__(369),
	    isStrictComparable = __webpack_require__(363),
	    matchesStrictComparable = __webpack_require__(364),
	    toKey = __webpack_require__(377);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(367);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(368),
	    toKey = __webpack_require__(377);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(282),
	    isKey = __webpack_require__(369),
	    stringToPath = __webpack_require__(371),
	    toString = __webpack_require__(374);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(282),
	    isSymbol = __webpack_require__(370);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(275),
	    isObjectLike = __webpack_require__(281);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(372);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(373);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(324);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(375);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(276),
	    arrayMap = __webpack_require__(376),
	    isArray = __webpack_require__(282),
	    isSymbol = __webpack_require__(370);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 376 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(370);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(379),
	    hasPath = __webpack_require__(380);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ }),
/* 379 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(368),
	    isArguments = __webpack_require__(273),
	    isArray = __webpack_require__(282),
	    isIndex = __webpack_require__(286),
	    isLength = __webpack_require__(289),
	    toKey = __webpack_require__(377);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ }),
/* 381 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(383),
	    basePropertyDeep = __webpack_require__(384),
	    isKey = __webpack_require__(369),
	    toKey = __webpack_require__(377);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),
/* 383 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(367);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),
/* 385 */
/***/ (function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(387),
	    baseOrderBy = __webpack_require__(389),
	    baseRest = __webpack_require__(394),
	    isIterateeCall = __webpack_require__(402);
	
	/**
	 * Creates an array of elements, sorted in ascending order by the results of
	 * running each element in a collection thru each iteratee. This method
	 * performs a stable sort, that is, it preserves the original sort order of
	 * equal elements. The iteratees are invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {...(Function|Function[])} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 40 },
	 *   { 'user': 'barney', 'age': 34 }
	 * ];
	 *
	 * _.sortBy(users, [function(o) { return o.user; }]);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	 *
	 * _.sortBy(users, ['user', 'age']);
	 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	 */
	var sortBy = baseRest(function(collection, iteratees) {
	  if (collection == null) {
	    return [];
	  }
	  var length = iteratees.length;
	  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	    iteratees = [];
	  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	    iteratees = [iteratees[0]];
	  }
	  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	});
	
	module.exports = sortBy;


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(354),
	    isFlattenable = __webpack_require__(388);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(276),
	    isArguments = __webpack_require__(273),
	    isArray = __webpack_require__(282);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(376),
	    baseIteratee = __webpack_require__(300),
	    baseMap = __webpack_require__(390),
	    baseSortBy = __webpack_require__(391),
	    baseUnary = __webpack_require__(290),
	    compareMultiple = __webpack_require__(392),
	    identity = __webpack_require__(381);
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  var index = -1;
	  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseOrderBy;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(266),
	    isArrayLike = __webpack_require__(296);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ }),
/* 391 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	var compareAscending = __webpack_require__(393);
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(370);
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(381),
	    overRest = __webpack_require__(395),
	    setToString = __webpack_require__(397);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(396);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),
/* 396 */
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(398),
	    shortOut = __webpack_require__(401);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(399),
	    defineProperty = __webpack_require__(400),
	    identity = __webpack_require__(381);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),
/* 399 */
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(318);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 401 */
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(308),
	    isArrayLike = __webpack_require__(296),
	    isIndex = __webpack_require__(286),
	    isObject = __webpack_require__(298);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _config = __webpack_require__(404);
	
	var _invariant = __webpack_require__(181);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isString = __webpack_require__(405);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isDataURL(s) {
	  // Regex from https://gist.github.com/bgrins/6194623#gistcomment-1671744
	  // eslint-disable-next-line
	  var regex = /^\s*data:([a-z]+\/[a-z0-9\-\+]+(;[a-z\-]+=[a-z0-9\-]+)?)?(;base64)?,[a-z0-9!\$&',\(\)\*\+,;=\-\._~:@\/\?%\s]*\s*$/i;
	  return !!s.match(regex);
	}
	
	// Function to add prefix to links.
	/*  weak */
	var prefixLink = function prefixLink(_link) {
	  if (typeof __PREFIX_LINKS__ !== 'undefined' && __PREFIX_LINKS__ !== null && __PREFIX_LINKS__ && _config.config.linkPrefix !== null) {
	    var invariantMessage = '\n    You\'re trying to build your site with links prefixed\n    but you haven\'t set \'linkPrefix\' in your config.toml.\n    ';
	    (0, _invariant2.default)((0, _isString2.default)(_config.config.linkPrefix), invariantMessage
	
	    // When url-loader is used with the limit option, some of images are encoded to
	    // base64 data url, this check prevent such links from being prefixed.
	    );if (isDataURL(_link)) {
	      return _link;
	    } else {
	      if (_link.slice(0, 1) !== '/') {
	        return _config.config.linkPrefix + '/' + _link;
	      }
	      return '' + _config.config.linkPrefix + _link;
	    }
	  } else {
	    return _link;
	  }
	};
	
	module.exports = {
	  prefixLink: prefixLink
	};

/***/ }),
/* 404 */
/***/ (function(module, exports) {

	module.exports = {
		"config": {
			"siteTitle": "Men(S)tis",
			"baseColor": "#f26d80",
			"linkPrefix": "/menstis-test"
		},
		"relativePath": "",
		"pages": [
			{
				"file": {
					"root": "",
					"dir": "",
					"base": "_template.jsx",
					"ext": "jsx",
					"name": "_template",
					"extname": ".jsx",
					"basename": "_template.jsx",
					"dirname": "",
					"stem": "_template",
					"path": "_template.jsx"
				},
				"requirePath": "_template.jsx",
				"templatePath": "//",
				"data": {}
			},
			{
				"file": {
					"root": "",
					"dir": "",
					"base": "404.md",
					"ext": "md",
					"name": "404",
					"extname": ".md",
					"basename": "404.md",
					"dirname": "",
					"stem": "404",
					"path": "404.md"
				},
				"requirePath": "404.md",
				"path": "/404.html",
				"data": {
					"path": "/404.html"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "blog",
					"base": "_template.jsx",
					"ext": "jsx",
					"name": "_template",
					"extname": ".jsx",
					"basename": "_template.jsx",
					"dirname": "blog",
					"stem": "_template",
					"path": "blog\\_template.jsx"
				},
				"requirePath": "blog/_template.jsx",
				"templatePath": "/blog/",
				"data": {}
			},
			{
				"file": {
					"root": "",
					"dir": "blog\\2015-01-01-TelevisieUitzendingHetVermoeden",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "blog/2015-01-01-TelevisieUitzendingHetVermoeden",
					"stem": "index",
					"path": "blog\\2015-01-01-TelevisieUitzendingHetVermoeden\\index.md"
				},
				"requirePath": "blog/2015-01-01-TelevisieUitzendingHetVermoeden/index.md",
				"path": "/blog/2015-01-01-TelevisieUitzendingHetVermoeden/",
				"data": {
					"title": "Televisie uitzending Het Vermoeden",
					"date": "2013-04-01T00:00:00Z",
					"layout": "post",
					"attachment": null,
					"linktext": null
				}
			},
			{
				"file": {
					"root": "",
					"dir": "blog\\2015-01-02-Filmdossiers",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "blog/2015-01-02-Filmdossiers",
					"stem": "index",
					"path": "blog\\2015-01-02-Filmdossiers\\index.md"
				},
				"requirePath": "blog/2015-01-02-Filmdossiers/index.md",
				"path": "/blog/2015-01-02-Filmdossiers/",
				"data": {
					"title": "Filmdossiers",
					"date": "2013-04-01T00:00:00Z",
					"layout": "post"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "blog\\2015-01-04-Archief20Jaar",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "blog/2015-01-04-Archief20Jaar",
					"stem": "index",
					"path": "blog\\2015-01-04-Archief20Jaar\\index.md"
				},
				"requirePath": "blog/2015-01-04-Archief20Jaar/index.md",
				"path": "/blog/2015-01-04-Archief20Jaar/",
				"data": {
					"title": "Kortfilm Men(S)tis Gedachtenis",
					"date": "2013-04-01T00:00:00Z",
					"layout": "post",
					"attachment": "movie/",
					"linktext": "Bekijk het fragment"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "blog\\2015-01-04-Archief20Jaar",
					"base": "movie.md",
					"ext": "md",
					"name": "movie",
					"extname": ".md",
					"basename": "movie.md",
					"dirname": "blog/2015-01-04-Archief20Jaar",
					"stem": "movie",
					"path": "blog\\2015-01-04-Archief20Jaar\\movie.md"
				},
				"requirePath": "blog/2015-01-04-Archief20Jaar/movie.md",
				"path": "/blog/2015-01-04-Archief20Jaar/movie/",
				"data": {}
			},
			{
				"file": {
					"root": "",
					"dir": "blog\\2015-01-05-BoekGedachtenis",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "blog/2015-01-05-BoekGedachtenis",
					"stem": "index",
					"path": "blog\\2015-01-05-BoekGedachtenis\\index.md"
				},
				"requirePath": "blog/2015-01-05-BoekGedachtenis/index.md",
				"path": "/blog/2015-01-05-BoekGedachtenis/",
				"data": {
					"title": "Voorstelling boek Gedachtenis",
					"date": "2013-04-01T00:00:00Z",
					"layout": "post",
					"attachment": "Gedachtenis.pdf",
					"linktext": "Lees Kennismaking"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "blog\\2015-01-06-TrapCinematografie",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "blog/2015-01-06-TrapCinematografie",
					"stem": "index",
					"path": "blog\\2015-01-06-TrapCinematografie\\index.md"
				},
				"requirePath": "blog/2015-01-06-TrapCinematografie/index.md",
				"path": "/blog/2015-01-06-TrapCinematografie/",
				"data": {
					"title": "De trap van de cinematografie",
					"date": "2013-04-01T00:00:00Z",
					"layout": "post",
					"attachment": "Filmanalyse schema.pdf",
					"linktext": "Lees het schema voor filmanalyse en filmgesprek"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "blog\\2015-01-07-BoekAardsParadijs",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "blog/2015-01-07-BoekAardsParadijs",
					"stem": "index",
					"path": "blog\\2015-01-07-BoekAardsParadijs\\index.md"
				},
				"requirePath": "blog/2015-01-07-BoekAardsParadijs/index.md",
				"path": "/blog/2015-01-07-BoekAardsParadijs/",
				"data": {
					"title": "Voorstelling boek Het aards paradijs",
					"date": "2013-04-01T00:00:00Z",
					"layout": "post",
					"attachment": "StudieAardsParadijs.pdf",
					"linktext": "Lees kennismaking"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "blog\\2015-01-08-BergredeXIII",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "blog/2015-01-08-BergredeXIII",
					"stem": "index",
					"path": "blog\\2015-01-08-BergredeXIII\\index.md"
				},
				"requirePath": "blog/2015-01-08-BergredeXIII/index.md",
				"path": "/blog/2015-01-08-BergredeXIII/",
				"data": {
					"title": "Bergrede XIII",
					"date": "2013-04-01T00:00:00Z",
					"layout": "post",
					"attachment": "Bergrede_XIII_Blog.pdf",
					"linktext": "Lees bergrede"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "blog\\2015-01-09-InterviewBraambos",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "blog/2015-01-09-InterviewBraambos",
					"stem": "index",
					"path": "blog\\2015-01-09-InterviewBraambos\\index.md"
				},
				"requirePath": "blog/2015-01-09-InterviewBraambos/index.md",
				"path": "/blog/2015-01-09-InterviewBraambos/",
				"data": {
					"title": "Interview Braambos",
					"date": "2015-02-10T00:00:00Z",
					"layout": "post",
					"attachment": "ibr.mp3",
					"linktext": "Beluister interview"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "blog\\2015-01-10-Bibliografie",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "blog/2015-01-10-Bibliografie",
					"stem": "index",
					"path": "blog\\2015-01-10-Bibliografie\\index.md"
				},
				"requirePath": "blog/2015-01-10-Bibliografie/index.md",
				"path": "/blog/2015-01-10-Bibliografie/",
				"data": {
					"title": "Bibliografie Sylvain De Bleeckere",
					"date": "2015-05-01T22:12:03.284Z",
					"layout": "post",
					"attachment": "sdbbiblio20.pdf",
					"linktext": "Lees bibliografie"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "blog\\2017-12-27 Programakaart De Dag",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "blog/2017-12-27 Programakaart De Dag",
					"stem": "index",
					"path": "blog\\2017-12-27 Programakaart De Dag\\index.md"
				},
				"requirePath": "blog/2017-12-27 Programakaart De Dag/index.md",
				"path": "/blog/2017-12-27 Programakaart De Dag/",
				"data": {
					"title": "Programmakaart De Dag 2020",
					"date": "2017-12-27T00:00:00Z",
					"layout": "post",
					"attachment": "kaart29.pdf",
					"linktext": "Lees kaart"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "blog",
					"base": "index.js",
					"ext": "js",
					"name": "index",
					"extname": ".js",
					"basename": "index.js",
					"dirname": "blog",
					"stem": "index",
					"path": "blog\\index.js"
				},
				"requirePath": "blog/index.js",
				"path": "/blog/",
				"data": {}
			},
			{
				"file": {
					"root": "",
					"dir": "dedag",
					"base": "_template.jsx",
					"ext": "jsx",
					"name": "_template",
					"extname": ".jsx",
					"basename": "_template.jsx",
					"dirname": "dedag",
					"stem": "_template",
					"path": "dedag\\_template.jsx"
				},
				"requirePath": "dedag/_template.jsx",
				"templatePath": "/dedag/",
				"data": {}
			},
			{
				"file": {
					"root": "",
					"dir": "dedag",
					"base": "geschiedenis.md",
					"ext": "md",
					"name": "geschiedenis",
					"extname": ".md",
					"basename": "geschiedenis.md",
					"dirname": "dedag",
					"stem": "geschiedenis",
					"path": "dedag\\geschiedenis.md"
				},
				"requirePath": "dedag/geschiedenis.md",
				"path": "/dedag/geschiedenis/",
				"data": {
					"title": "Geschiedenis"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "dedag",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "dedag",
					"stem": "index",
					"path": "dedag\\index.md"
				},
				"requirePath": "dedag/index.md",
				"path": "/dedag/",
				"data": {
					"title": "Concept"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "dedag",
					"base": "inschrijving.md",
					"ext": "md",
					"name": "inschrijving",
					"extname": ".md",
					"basename": "inschrijving.md",
					"dirname": "dedag",
					"stem": "inschrijving",
					"path": "dedag\\inschrijving.md"
				},
				"requirePath": "dedag/inschrijving.md",
				"path": "/dedag/inschrijving/",
				"data": {
					"title": "Inschrijving"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "dedag",
					"base": "locatie-contact.md",
					"ext": "md",
					"name": "locatie-contact",
					"extname": ".md",
					"basename": "locatie-contact.md",
					"dirname": "dedag",
					"stem": "locatie-contact",
					"path": "dedag\\locatie-contact.md"
				},
				"requirePath": "dedag/locatie-contact.md",
				"path": "/dedag/locatie-contact/",
				"data": {
					"title": "Locatie & Contact"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "dedag\\programma",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "dedag/programma",
					"stem": "index",
					"path": "dedag\\programma\\index.md"
				},
				"requirePath": "dedag/programma/index.md",
				"path": "/dedag/programma/",
				"data": {
					"title": "Programma 2020"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "dedag",
					"base": "toeschouwers.md",
					"ext": "md",
					"name": "toeschouwers",
					"extname": ".md",
					"basename": "toeschouwers.md",
					"dirname": "dedag",
					"stem": "toeschouwers",
					"path": "dedag\\toeschouwers.md"
				},
				"requirePath": "dedag/toeschouwers.md",
				"path": "/dedag/toeschouwers/",
				"data": {
					"title": "Toeschouwers"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "film-focus",
					"base": "_template.jsx",
					"ext": "jsx",
					"name": "_template",
					"extname": ".jsx",
					"basename": "_template.jsx",
					"dirname": "film-focus",
					"stem": "_template",
					"path": "film-focus\\_template.jsx"
				},
				"requirePath": "film-focus/_template.jsx",
				"templatePath": "/film-focus/",
				"data": {}
			},
			{
				"file": {
					"root": "",
					"dir": "film-focus\\agora",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "film-focus/agora",
					"stem": "index",
					"path": "film-focus\\agora\\index.md"
				},
				"requirePath": "film-focus/agora/index.md",
				"path": "/film-focus/agora/",
				"data": {
					"title": "Agora"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "film-focus\\andreiroublev",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "film-focus/andreiroublev",
					"stem": "index",
					"path": "film-focus\\andreiroublev\\index.md"
				},
				"requirePath": "film-focus/andreiroublev/index.md",
				"path": "/film-focus/andreiroublev/",
				"data": {
					"title": "Andrei Roublev"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "film-focus\\benx",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "film-focus/benx",
					"stem": "index",
					"path": "film-focus\\benx\\index.md"
				},
				"requirePath": "film-focus/benx/index.md",
				"path": "/film-focus/benx/",
				"data": {
					"title": "BenX"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "film-focus\\birthofanation",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "film-focus/birthofanation",
					"stem": "index",
					"path": "film-focus\\birthofanation\\index.md"
				},
				"requirePath": "film-focus/birthofanation/index.md",
				"path": "/film-focus/birthofanation/",
				"data": {
					"title": "The Birth of a Nation"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "film-focus\\comeandsee",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "film-focus/comeandsee",
					"stem": "index",
					"path": "film-focus\\comeandsee\\index.md"
				},
				"requirePath": "film-focus/comeandsee/index.md",
				"path": "/film-focus/comeandsee/",
				"data": {
					"title": "Come and See"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "film-focus\\damien",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "film-focus/damien",
					"stem": "index",
					"path": "film-focus\\damien\\index.md"
				},
				"requirePath": "film-focus/damien/index.md",
				"path": "/film-focus/damien/",
				"data": {
					"title": "Father Damien"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "film-focus\\darkesthour",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "film-focus/darkesthour",
					"stem": "index",
					"path": "film-focus\\darkesthour\\index.md"
				},
				"requirePath": "film-focus/darkesthour/index.md",
				"path": "/film-focus/darkesthour/",
				"data": {
					"title": "Darkest Hour"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "film-focus\\Dekalog",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "film-focus/Dekalog",
					"stem": "index",
					"path": "film-focus\\Dekalog\\index.md"
				},
				"requirePath": "film-focus/Dekalog/index.md",
				"path": "/film-focus/Dekalog/",
				"data": {
					"title": "Dekalog"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "film-focus\\desterre",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "film-focus/desterre",
					"stem": "index",
					"path": "film-focus\\desterre\\index.md"
				},
				"requirePath": "film-focus/desterre/index.md",
				"path": "/film-focus/desterre/",
				"data": {
					"title": "En waar de sterre bleef stille staan"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "film-focus\\dolls",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "film-focus/dolls",
					"stem": "index",
					"path": "film-focus\\dolls\\index.md"
				},
				"requirePath": "film-focus/dolls/index.md",
				"path": "/film-focus/dolls/",
				"data": {
					"title": "Dolls"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "film-focus\\elsoldelmembrillo",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "film-focus/elsoldelmembrillo",
					"stem": "index",
					"path": "film-focus\\elsoldelmembrillo\\index.md"
				},
				"requirePath": "film-focus/elsoldelmembrillo/index.md",
				"path": "/film-focus/elsoldelmembrillo/",
				"data": {
					"title": "El sol del membrillo"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "film-focus\\goddess",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "film-focus/goddess",
					"stem": "index",
					"path": "film-focus\\goddess\\index.md"
				},
				"requirePath": "film-focus/goddess/index.md",
				"path": "/film-focus/goddess/",
				"data": {
					"title": "Goddess of 1967"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "film-focus\\hommes",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "film-focus/hommes",
					"stem": "index",
					"path": "film-focus\\hommes\\index.md"
				},
				"requirePath": "film-focus/hommes/index.md",
				"path": "/film-focus/hommes/",
				"data": {
					"title": "Des hommes et des dieux"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "film-focus\\ida",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "film-focus/ida",
					"stem": "index",
					"path": "film-focus\\ida\\index.md"
				},
				"requirePath": "film-focus/ida/index.md",
				"path": "/film-focus/ida/",
				"data": {
					"title": "Ida"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "film-focus",
					"base": "index.jsx",
					"ext": "jsx",
					"name": "index",
					"extname": ".jsx",
					"basename": "index.jsx",
					"dirname": "film-focus",
					"stem": "index",
					"path": "film-focus\\index.jsx"
				},
				"requirePath": "film-focus/index.jsx",
				"path": "/film-focus/",
				"data": {}
			},
			{
				"file": {
					"root": "",
					"dir": "film-focus\\innocentes",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "film-focus/innocentes",
					"stem": "index",
					"path": "film-focus\\innocentes\\index.md"
				},
				"requirePath": "film-focus/innocentes/index.md",
				"path": "/film-focus/innocentes/",
				"data": {
					"title": "Les Innocentes"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "film-focus\\intothewild",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "film-focus/intothewild",
					"stem": "index",
					"path": "film-focus\\intothewild\\index.md"
				},
				"requirePath": "film-focus/intothewild/index.md",
				"path": "/film-focus/intothewild/",
				"data": {
					"title": "Into the Wild"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "film-focus\\iris",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "film-focus/iris",
					"stem": "index",
					"path": "film-focus\\iris\\index.md"
				},
				"requirePath": "film-focus/iris/index.md",
				"path": "/film-focus/iris/",
				"data": {
					"title": "Iris"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "film-focus\\italiensk",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "film-focus/italiensk",
					"stem": "index",
					"path": "film-focus\\italiensk\\index.md"
				},
				"requirePath": "film-focus/italiensk/index.md",
				"path": "/film-focus/italiensk/",
				"data": {
					"title": "Italiensk for Begyndere"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "film-focus\\kain",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "film-focus/kain",
					"stem": "index",
					"path": "film-focus\\kain\\index.md"
				},
				"requirePath": "film-focus/kain/index.md",
				"path": "/film-focus/kain/",
				"data": {
					"title": "Kaïn"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "film-focus\\marieheurtin",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "film-focus/marieheurtin",
					"stem": "index",
					"path": "film-focus\\marieheurtin\\index.md"
				},
				"requirePath": "film-focus/marieheurtin/index.md",
				"path": "/film-focus/marieheurtin/",
				"data": {
					"title": "Marie Heurtin"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "film-focus\\millcross",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "film-focus/millcross",
					"stem": "index",
					"path": "film-focus\\millcross\\index.md"
				},
				"requirePath": "film-focus/millcross/index.md",
				"path": "/film-focus/millcross/",
				"data": {
					"title": "The Mill & the Cross"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "film-focus\\mrturner",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "film-focus/mrturner",
					"stem": "index",
					"path": "film-focus\\mrturner\\index.md"
				},
				"requirePath": "film-focus/mrturner/index.md",
				"path": "/film-focus/mrturner/",
				"data": {
					"title": "Mr. Turner"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "film-focus\\nativity",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "film-focus/nativity",
					"stem": "index",
					"path": "film-focus\\nativity\\index.md"
				},
				"requirePath": "film-focus/nativity/index.md",
				"path": "/film-focus/nativity/",
				"data": {
					"title": "The Nativity Story"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "film-focus\\newworld",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "film-focus/newworld",
					"stem": "index",
					"path": "film-focus\\newworld\\index.md"
				},
				"requirePath": "film-focus/newworld/index.md",
				"path": "/film-focus/newworld/",
				"data": {
					"title": "The New World"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "film-focus\\pilgrimage",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "film-focus/pilgrimage",
					"stem": "index",
					"path": "film-focus\\pilgrimage\\index.md"
				},
				"requirePath": "film-focus/pilgrimage/index.md",
				"path": "/film-focus/pilgrimage/",
				"data": {
					"title": "PilgrImage"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "film-focus\\priere",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "film-focus/priere",
					"stem": "index",
					"path": "film-focus\\priere\\index.md"
				},
				"requirePath": "film-focus/priere/index.md",
				"path": "/film-focus/priere/",
				"data": {
					"title": "La prière"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "film-focus\\resurrection",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "film-focus/resurrection",
					"stem": "index",
					"path": "film-focus\\resurrection\\index.md"
				},
				"requirePath": "film-focus/resurrection/index.md",
				"path": "/film-focus/resurrection/",
				"data": {
					"title": "Resurrection"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "film-focus\\samara",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "film-focus/samara",
					"stem": "index",
					"path": "film-focus\\samara\\index.md"
				},
				"requirePath": "film-focus/samara/index.md",
				"path": "/film-focus/samara/",
				"data": {
					"title": "Samsara"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "film-focus\\silence",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "film-focus/silence",
					"stem": "index",
					"path": "film-focus\\silence\\index.md"
				},
				"requirePath": "film-focus/silence/index.md",
				"path": "/film-focus/silence/",
				"data": {
					"title": "Into Great Silence"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "film-focus\\sonofsaul",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "film-focus/sonofsaul",
					"stem": "index",
					"path": "film-focus\\sonofsaul\\index.md"
				},
				"requirePath": "film-focus/sonofsaul/index.md",
				"path": "/film-focus/sonofsaul/",
				"data": {
					"title": "Son of Saul"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "film-focus\\spirited",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "film-focus/spirited",
					"stem": "index",
					"path": "film-focus\\spirited\\index.md"
				},
				"requirePath": "film-focus/spirited/index.md",
				"path": "/film-focus/spirited/",
				"data": {
					"title": "Spirited Away"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "",
					"base": "index.jsx",
					"ext": "jsx",
					"name": "index",
					"extname": ".jsx",
					"basename": "index.jsx",
					"dirname": "",
					"stem": "index",
					"path": "index.jsx"
				},
				"requirePath": "index.jsx",
				"path": "/",
				"data": {}
			},
			{
				"file": {
					"root": "",
					"dir": "missie",
					"base": "_template.jsx",
					"ext": "jsx",
					"name": "_template",
					"extname": ".jsx",
					"basename": "_template.jsx",
					"dirname": "missie",
					"stem": "_template",
					"path": "missie\\_template.jsx"
				},
				"requirePath": "missie/_template.jsx",
				"templatePath": "/missie/",
				"data": {}
			},
			{
				"file": {
					"root": "",
					"dir": "missie",
					"base": "index_old.html",
					"ext": "html",
					"name": "index_old",
					"extname": ".html",
					"basename": "index_old.html",
					"dirname": "missie",
					"stem": "index_old",
					"path": "missie\\index_old.html"
				},
				"requirePath": "missie/index_old.html",
				"path": "/missie/index_old/",
				"data": {
					"body": "<!DOCTYPE HTML PUBLIC \"-//W3C//DTD HTML 4.0 Transitional//EN\">\r\n<html><!-- InstanceBegin template=\"/Templates/missie.dwt\" codeOutsideHTMLIsLocked=\"false\" -->\r\n<head>\r\n<meta http-equiv=\"Content-Type\" content=\"text/html; charset=iso-8859-1\">\r\n<meta http-equiv=\"imagetoolbar\" content=\"no\">\r\n<!-- InstanceBeginEditable name=\"titel\" -->\r\n<title>Missie statement Men(s)tis vzw</title>\r\n<!-- InstanceEndEditable -->\r\n<link href=\"/style/basic.css\" rel=\"stylesheet\" type=\"text/css\" media=\"all\">\r\n<link rel=\"icon\" type=\"image/gif\" href=\"/favicon.gif\">\r\n</head>\r\n<body bgcolor=\"#FFFFF4\" text=\"#7F7D82\" link=\"#7366EE\" vlink=\"#8388FF\" alink=\"#F78A6A\">\r\n<div align=\"center\">\r\n<center>\r\n\r\n<table border=\"0\" cellpadding=\"10\" cellspacing=\"0\" width=\"80%\">\r\n<tr>\r\n\t<td><a href=\"index.html\"><img border=\"0\" src=\"../statement.jpg\" width=\"60\" height=\"30\" alt=\"Missie\"></a></td>\r\n\t<td><a href=\"../blog/index.html\"><img border=\"0\" src=\"../etalage.jpg\" width=\"60\" height=\"30\" alt=\"Blog\"></a></td>\r\n\t<td><a href=\"../dedag/index.html\"><img border=\"0\" src=\"../De%20Dag.jpg\" width=\"30\" height=\"45\" alt=\"De Dag van de Religieuze Film\"></a></td>\r\n\t<td><a href=\"../film/index.html\"><img border=\"0\" src=\"../FilmFocus.jpg\" width=\"30\" height=\"45\" alt=\"FilmFocus\"></a></td>\r\n\t<td><a href=\"../producties/index.html\"><img border=\"0\" src=\"../producties.jpg\" width=\"60\" height=\"30\" alt=\"Producties\"></a></td>\r\n    <td><a href=\"../uitgeverij/index.html\"><img border=\"0\" src=\"../uitgeverij.jpg\" width=\"60\" height=\"30\" alt=\"Uitgeverij\"></a></td>\r\n</tr>\r\n\r\n</table>\r\n<table border=\"0\" cellpadding=\"4\" cellspacing=\"0\" width=\"90%\">\r\n    <tr>\r\n        <td width=\"160\" valign=\"top\" rowspan=\"2\" bgcolor=\"#FCF9FF\">\r\n\t\t\t\t       \r\n\t\t<!-- InstanceBeginEditable name=\"menueinde\" -->\r\n\t\t\t<h2>Men(S)tis vzw</h2>\r\n\t        <p><a href=\"#HOM\"><b>Mens</b></a><br></p>\r\n\t        <p><a href=\"#GEE\"><b>Geest</b></a><br></p>\r\n\t        <p><a href=\"#HET\"><b>Leven</b></a><br></p>\r\n\t        \r\n\t        <p><a href=\"#STI\"><b>Stichtende leden</b></a><br></p><!-- InstanceEndEditable -->\r\n\t\t</td>\r\n        <td rowspan=\"2\">&nbsp;</td>\r\n        <td valign=\"bottom\" nowrap bgcolor=\"#400030\"><font color=\"#FFFFF4\"><h2>\r\n\t\t<!-- InstanceBeginEditable name=\"subtitel\" -->Missie\r\n\t\t<!-- InstanceEndEditable -->\r\n\t\t</h2>\r\n\t\t<h2>\r\n\t\t  <!-- InstanceBeginEditable name=\"subtitel2\" --><!-- InstanceEndEditable -->\r\n\t\t</h2></font>\r\n        </td>\r\n    </tr>\r\n \t<tr>\r\n\t\t<td valign=\"top\" bgcolor=\"#FCF9FF\">\r\n             <!-- InstanceBeginEditable name=\"Inhoud\" -->\r\n\t\t\t<p>De missie van de vereniging zonder winstgevend doel, <strong class=\"menstis\">Men(S)tis, </strong>rust op </strong><span class=\"opvallend\"><strong>de waarden 'mens, geest en leven'</strong></span>. </p>\r\n\t\t\t<p><strong>Het eerste element, </strong><span class=\"opvallend\"><strong>de mens, </strong></span>is aanwezig in de naam die leest als 'mens, menstis'.<strong class=\"menstis\">  Men(S)tis vzw</strong> <strong>wil het mysterie van de menswording</strong> blijven huldigen en  exploreren.</p>\r\n\t\t\t<p><strong>Het tweede element </strong> van  'mens, menstis', is  <strong>het Latijnse woord mens voor </strong><span class=\"opvallend\"><strong>geest</strong></span>.  Die betekenis blijft immers goed leesbaar in de woorden 'mentaal, mentaliteit'   en het Engelse 'mind'.   <strong class=\"menstis\">Men(S)tis   </strong><strong>werkt vanuit  de mentale rijkdom van de mens.</strong> In en door de mens stroomt er  een innerlijk kapitaal aan gedachten, gevoelens en beelden. Het hoort bij de Homo  sapiens als de bladeren aan de boom, maar... ze zijn diens eigendom niet. De  Latijnse genitief &mdash; <em>menstis</em> &mdash; signaleert dat de mens verbonden  is met <strong>de wonderlijke en complexe wereld van de geest</strong>, een wereld waarin  het fenomeen mens zijn nest heeft, een wereld waarin hij thuis is en woont,  maar die hij niet als zijn volle eigendom bezit of beheerst.             </p><p><center><a name=\"GIB\"></a><img src=\"GIB.jpg\" width=200 height=200> </center></p>\r\n<p><strong>Het derde element</strong> van de missie, is <strong>het fenomeen van </strong><span class=\"opvallend\"><strong>het leven</strong></span>.</strong> Daarvan is het beeldlogo het zichtbare teken. Het beeld, een creatie van Nelly Claeys in opdracht van de vereniging, toont in close-up een ginkgoblad op een alizarine rode achtergrond. Het blad vertegenwoordigt  de oudste  boom, de <strong>ginkgo biloba</strong>. Hij is de  echte levensboom van de planeet aarde. <strong class=\"menstis\">Men(S)tis  vzw</strong> participeert hiermee aan een kunsttraditie die het ginkgoblad als  <strong>het levende beeld ziet van de heilige waarde van het leven</strong>. De Duitse dichter Goethe bezong het ginkgoblad;  het hedendaagse Britse kunstenaarsduo Gilbert &amp; George nam het blad als leidmotief voor een reeks van werken.</p>\r\n<p><strong class=\"menstis\">Men(S)tis  vzw</strong> schept met ieder initiatief  een re&euml;le en mentale ruimte die verschijnt als een <strong>bescheiden, tijdelijke en  vruchtbare zone van zin</strong>, een oord van levensbeschouwing. <strong class=\"menstis\">Men(S)tis vzw</strong> wil hiermee bijdragen tot de ontwikkeling van  <strong>het  beeldend denken</strong> en tot <strong>het onderzoek naar de  religiositeit, eigen aan de zich ontwikkelende audiovisuele cultuur</strong>. </p>\r\n<p>De vereniging heeft ook een <strong>eigen website </strong>en<strong> een Facebook-profiel</strong>.</p>\r\n<p><a name=\"STI\"></a>De</strong><span class=\"opvallend\"> <strong>stichtende leden</strong></span> </strong>zijn: Sylvain De Bleeckere  (1950), Felix Rijcken (1929), Nicole De Bleeckere-Van de Kerckhove (1951-1996),  Gie Dandois (1955-1997). De <strong>huidige </strong>bestuursleden  zijn: Sylvain De Bleeckere (voorzitter), Felix Rijcken (ondervoorzitter), Samuel   De Bleeckere (secretaris-boekhouder).</p>\r\n             <!-- InstanceEndEditable -->\r\n\t\t</td>\r\n     </tr>\r\n</table>\r\n</center>\r\n</div>\r\n</body>\r\n<!-- InstanceEnd --></html>\r\n"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "missie",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "missie",
					"stem": "index",
					"path": "missie\\index.md"
				},
				"requirePath": "missie/index.md",
				"path": "/missie/",
				"data": {}
			},
			{
				"file": {
					"root": "",
					"dir": "producties",
					"base": "_template.jsx",
					"ext": "jsx",
					"name": "_template",
					"extname": ".jsx",
					"basename": "_template.jsx",
					"dirname": "producties",
					"stem": "_template",
					"path": "producties\\_template.jsx"
				},
				"requirePath": "producties/_template.jsx",
				"templatePath": "/producties/",
				"data": {}
			},
			{
				"file": {
					"root": "",
					"dir": "producties\\Agora",
					"base": "AgoraMovies.jsx",
					"ext": "jsx",
					"name": "AgoraMovies",
					"extname": ".jsx",
					"basename": "AgoraMovies.jsx",
					"dirname": "producties/Agora",
					"stem": "AgoraMovies",
					"path": "producties\\Agora\\AgoraMovies.jsx"
				},
				"requirePath": "producties/Agora/AgoraMovies.jsx",
				"path": "/producties/Agora/AgoraMovies/",
				"data": {}
			},
			{
				"file": {
					"root": "",
					"dir": "producties\\Agora",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "producties/Agora",
					"stem": "index",
					"path": "producties\\Agora\\index.md"
				},
				"requirePath": "producties/Agora/index.md",
				"path": "/producties/Agora/",
				"data": {
					"title": "AGORA: KERKGEBOUW - WEEFSEL VAN ZINGEVING",
					"order": 1
				}
			},
			{
				"file": {
					"root": "",
					"dir": "producties\\ClairObscur",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "producties/ClairObscur",
					"stem": "index",
					"path": "producties\\ClairObscur\\index.md"
				},
				"requirePath": "producties/ClairObscur/index.md",
				"path": "/producties/ClairObscur/",
				"data": {
					"title": "Clair - Obscur",
					"order": 3
				}
			},
			{
				"file": {
					"root": "",
					"dir": "producties\\DeGeleMadonna",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "producties/DeGeleMadonna",
					"stem": "index",
					"path": "producties\\DeGeleMadonna\\index.md"
				},
				"requirePath": "producties/DeGeleMadonna/index.md",
				"path": "/producties/DeGeleMadonna/",
				"data": {
					"title": "De Madonna van de Tederheid",
					"order": 4
				}
			},
			{
				"file": {
					"root": "",
					"dir": "producties",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "producties",
					"stem": "index",
					"path": "producties\\index.md"
				},
				"requirePath": "producties/index.md",
				"path": "/producties/",
				"data": {
					"title": "Producties"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "producties\\Jute",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "producties/Jute",
					"stem": "index",
					"path": "producties\\Jute\\index.md"
				},
				"requirePath": "producties/Jute/index.md",
				"path": "/producties/Jute/",
				"data": {
					"title": "Jute",
					"order": 2
				}
			},
			{
				"file": {
					"root": "",
					"dir": "webshop",
					"base": "_template.jsx",
					"ext": "jsx",
					"name": "_template",
					"extname": ".jsx",
					"basename": "_template.jsx",
					"dirname": "webshop",
					"stem": "_template",
					"path": "webshop\\_template.jsx"
				},
				"requirePath": "webshop/_template.jsx",
				"templatePath": "/webshop/",
				"data": {}
			},
			{
				"file": {
					"root": "",
					"dir": "webshop\\AanDeTafel",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "webshop/AanDeTafel",
					"stem": "index",
					"path": "webshop\\AanDeTafel\\index.md"
				},
				"requirePath": "webshop/AanDeTafel/index.md",
				"path": "/webshop/AanDeTafel/",
				"data": {
					"title": "Aan de tafel van het verborgen atelier"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "webshop\\AardsParadijs",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "webshop/AardsParadijs",
					"stem": "index",
					"path": "webshop\\AardsParadijs\\index.md"
				},
				"requirePath": "webshop/AardsParadijs/index.md",
				"path": "/webshop/AardsParadijs/",
				"data": {
					"title": "Het aards paradijs als zinnebeeld"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "webshop\\Beeldgebed",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "webshop/Beeldgebed",
					"stem": "index",
					"path": "webshop\\Beeldgebed\\index.md"
				},
				"requirePath": "webshop/Beeldgebed/index.md",
				"path": "/webshop/Beeldgebed/",
				"data": {
					"title": "Beeldgebed"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "webshop",
					"base": "index.js",
					"ext": "js",
					"name": "index",
					"extname": ".js",
					"basename": "index.js",
					"dirname": "webshop",
					"stem": "index",
					"path": "webshop\\index.js"
				},
				"requirePath": "webshop/index.js",
				"path": "/webshop/",
				"data": {}
			},
			{
				"file": {
					"root": "",
					"dir": "webshop\\Kerkgebouw",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "webshop/Kerkgebouw",
					"stem": "index",
					"path": "webshop\\Kerkgebouw\\index.md"
				},
				"requirePath": "webshop/Kerkgebouw/index.md",
				"path": "/webshop/Kerkgebouw/",
				"data": {
					"title": "Meerstemmig kerkgebouw"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "webshop\\Land",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "webshop/Land",
					"stem": "index",
					"path": "webshop\\Land\\index.md"
				},
				"requirePath": "webshop/Land/index.md",
				"path": "/webshop/Land/",
				"data": {
					"title": "Het Beloofde Land"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "webshop\\LerenLevenMetBeelden",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "webshop/LerenLevenMetBeelden",
					"stem": "index",
					"path": "webshop\\LerenLevenMetBeelden\\index.md"
				},
				"requirePath": "webshop/LerenLevenMetBeelden/index.md",
				"path": "/webshop/LerenLevenMetBeelden/",
				"data": {
					"title": "Leren Leven Met Beelden"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "webshop\\Levensbeschouwing",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "webshop/Levensbeschouwing",
					"stem": "index",
					"path": "webshop\\Levensbeschouwing\\index.md"
				},
				"requirePath": "webshop/Levensbeschouwing/index.md",
				"path": "/webshop/Levensbeschouwing/",
				"data": {
					"title": "Levensbeschouwing democratisch belicht"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "webshop\\MethodeBoek",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "webshop/MethodeBoek",
					"stem": "index",
					"path": "webshop\\MethodeBoek\\index.md"
				},
				"requirePath": "webshop/MethodeBoek/index.md",
				"path": "/webshop/MethodeBoek/",
				"data": {
					"title": "Methode Boek"
				}
			},
			{
				"file": {
					"root": "",
					"dir": "webshop\\MethodeCD",
					"base": "index.md",
					"ext": "md",
					"name": "index",
					"extname": ".md",
					"basename": "index.md",
					"dirname": "webshop/MethodeCD",
					"stem": "index",
					"path": "webshop\\MethodeCD\\index.md"
				},
				"requirePath": "webshop/MethodeCD/index.md",
				"path": "/webshop/MethodeCD/",
				"data": {
					"title": "Methode CD"
				}
			}
		]
	}

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(275),
	    isArray = __webpack_require__(282),
	    isObjectLike = __webpack_require__(281);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(173);
	
	var _reactResponsiveGrid = __webpack_require__(407);
	
	var _gatsbyHelpers = __webpack_require__(403);
	
	var _Header = __webpack_require__(419);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _typography = __webpack_require__(427);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _config = __webpack_require__(404);
	
	__webpack_require__(949);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rhythm = _typography2.default.rhythm,
	    adjustFontSizeTo = _typography2.default.adjustFontSizeTo;
	
	// Import styles.
	
	module.exports = _react2.default.createClass({
	  displayName: 'exports',
	  propTypes: function propTypes() {
	    return {
	      children: _react2.default.PropTypes.object
	    };
	  },
	  render: function render() {
	    if (this.props.location.pathname == (0, _gatsbyHelpers.prefixLink)('/')) return _react2.default.createElement(
	      'div',
	      null,
	      this.props.children
	    );else return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_Header2.default, { location: this.props.location }),
	      _react2.default.createElement(
	        'div',
	        null,
	        this.props.children
	      )
	    );
	  }
	});

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.10.0
	exports.Container = __webpack_require__(408);
	
	exports.Grid = __webpack_require__(409);
	
	exports.Breakpoint = __webpack_require__(410);
	
	exports.Span = __webpack_require__(417);


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.10.0
	var React, objectAssign;
	
	React = __webpack_require__(2);
	
	objectAssign = __webpack_require__(4);
	
	module.exports = React.createClass({
	  displayName: "Container",
	  render: function() {
	    var children, defaultStyles, props, styles;
	    defaultStyles = {
	      maxWidth: '960px',
	      marginLeft: 'auto',
	      marginRight: 'auto'
	    };
	    styles = objectAssign(defaultStyles, this.props.style);
	    children = this.props.children;
	    props = objectAssign({}, this.props);
	    delete props.children;
	    delete props.style;
	    return React.createElement("div", Object.assign({}, props, {
	      "style": styles
	    }), children, React.createElement("span", {
	      "style": {
	        display: 'block',
	        clear: 'both'
	      }
	    }, ' '));
	  }
	});


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.10.0
	var React, objectAssign;
	
	React = __webpack_require__(2);
	
	objectAssign = __webpack_require__(4);
	
	module.exports = React.createClass({
	  displayName: "Grid",
	  propTypes: {
	    columns: React.PropTypes.number,
	    gutterRatio: React.PropTypes.number
	  },
	  getDefaultProps: function() {
	    return {
	      columns: 12,
	      gutterRatio: 1 / 4
	    };
	  },
	  renderChildren: function() {
	    return React.Children.map(this.props.children, (function(_this) {
	      return function(child) {
	        var ref, ref1;
	        if ((ref = (ref1 = child.type) != null ? ref1.displayName : void 0) === "Breakpoint" || ref === "Span") {
	          return React.cloneElement(child, {
	            context: {
	              columns: _this.props.columns,
	              gutterRatio: _this.props.gutterRatio
	            }
	          });
	        } else {
	          return child;
	        }
	      };
	    })(this));
	  },
	  render: function() {
	    var props;
	    props = objectAssign({}, this.props);
	    delete props.gutterRatio;
	    delete props.columns;
	    return React.createElement("div", Object.assign({}, props), this.renderChildren(), React.createElement("span", {
	      "style": {
	        display: 'block',
	        clear: 'both'
	      }
	    }, ' '));
	  }
	});


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.10.0
	var ComponentWidthComponent, PageWidthComponent, PageWidthMixin, React, componentWidthMixin, objectAssign;
	
	React = __webpack_require__(2);
	
	componentWidthMixin = __webpack_require__(411);
	
	PageWidthMixin = __webpack_require__(413);
	
	objectAssign = __webpack_require__(4);
	
	ComponentWidthComponent = React.createClass({
	  displayName: "Breakpoint",
	  mixins: [componentWidthMixin],
	  propTypes: {
	    minWidth: React.PropTypes.number,
	    maxWidth: React.PropTypes.number
	  },
	  getDefaultProps: function() {
	    return {
	      minWidth: 0,
	      maxWidth: 1000000000000000000000
	    };
	  },
	  renderChildren: function() {
	    return React.Children.map(this.props.children, (function(_this) {
	      return function(child) {
	        var ref;
	        if ((child != null ? (ref = child.type) != null ? ref.displayName : void 0 : void 0) === "Span") {
	          return React.cloneElement(child, {
	            context: _this.props.context
	          });
	        } else {
	          return child;
	        }
	      };
	    })(this));
	  },
	  render: function() {
	    var props, ref;
	    props = objectAssign({}, this.props);
	    delete props.maxWidth;
	    delete props.minWidth;
	    delete props.widthMethod;
	    if (this.state.componentWidth) {
	      if ((this.props.minWidth <= (ref = this.state.componentWidth) && ref < this.props.maxWidth)) {
	        return React.createElement("div", Object.assign({}, props), this.renderChildren());
	      } else {
	        return React.createElement("div", null);
	      }
	    } else {
	      return React.createElement("div", null);
	    }
	  }
	});
	
	PageWidthComponent = React.createClass({
	  displayName: "Breakpoint",
	  mixins: [PageWidthMixin],
	  propTypes: {
	    minWidth: React.PropTypes.number,
	    maxWidth: React.PropTypes.number
	  },
	  getDefaultProps: function() {
	    return {
	      minWidth: 0,
	      maxWidth: 1000000000000000000000
	    };
	  },
	  renderChildren: function() {
	    return React.Children.map(this.props.children, (function(_this) {
	      return function(child) {
	        var ref;
	        if (((ref = child.type) != null ? ref.displayName : void 0) === "Span") {
	          return React.cloneElement(child, {
	            context: _this.props.context
	          });
	        } else {
	          return child;
	        }
	      };
	    })(this));
	  },
	  render: function() {
	    var props, ref;
	    props = objectAssign({}, this.props);
	    delete props.maxWidth;
	    delete props.minWidth;
	    delete props.widthMethod;
	    if (this.state.pageWidth) {
	      if ((this.props.minWidth <= (ref = this.state.pageWidth) && ref < this.props.maxWidth)) {
	        return React.createElement("div", Object.assign({}, props), this.renderChildren());
	      } else {
	        return React.createElement("div", null);
	      }
	    } else {
	      return React.createElement("div", null);
	    }
	  }
	});
	
	module.exports = React.createClass({
	  displayName: 'Breakpoint',
	  propTypes: {
	    widthMethod: React.PropTypes.string.isRequired,
	    minWidth: React.PropTypes.number,
	    maxWidth: React.PropTypes.number
	  },
	  getDefaultProps: function() {
	    return {
	      widthMethod: 'pageWidth'
	    };
	  },
	  render: function() {
	    if (this.props.widthMethod === "pageWidth") {
	      return React.createElement(PageWidthComponent, Object.assign({}, this.props));
	    } else if (this.props.widthMethod === "componentWidth") {
	      return React.createElement(ComponentWidthComponent, Object.assign({}, this.props));
	    }
	  }
	});


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	var ReactDOM = __webpack_require__(34);
	var elementResizeEvent = __webpack_require__(412);
	
	module.exports = {
	  getInitialState: function() {
	    if (this.props.initialComponentWidth !== undefined && this.props.initialComponentWidth !== null) {
	      return {
	        componentWidth: this.props.initialComponentWidth
	      };
	    } else {
	      return {};
	    }
	  },
	  // Add our resize sensor.
	  componentDidMount: function() {
	    this.setState({
	      componentWidth: ReactDOM.findDOMNode(this).getBoundingClientRect().width
	    });
	    elementResizeEvent(ReactDOM.findDOMNode(this), this.onResize);
	  },
	  // When the DOM updates, check that our resize sensor is still there.
	  componentDidUpdate: function() {
	    if (0 === ReactDOM.findDOMNode(this).getElementsByClassName('resize-sensor').length) {
	      elementResizeEvent(ReactDOM.findDOMNode(this), this.onResize);
	    }
	  },
	  onResize: function() {
	    this.setState({
	      componentWidth: ReactDOM.findDOMNode(this).getBoundingClientRect().width
	    });
	  }
	};


/***/ }),
/* 412 */
/***/ (function(module, exports) {

	var requestFrame = (function () {
	  var window = this
	  var raf = window.requestAnimationFrame ||
	    window.mozRequestAnimationFrame ||
	    window.webkitRequestAnimationFrame ||
	    function fallbackRAF(func) {
	      return window.setTimeout(func, 20)
	    }
	  return function requestFrameFunction(func) {
	    return raf(func)
	  }
	})()
	
	var cancelFrame = (function () {
	  var window = this
	  var cancel = window.cancelAnimationFrame ||
	    window.mozCancelAnimationFrame ||
	    window.webkitCancelAnimationFrame ||
	    window.clearTimeout
	  return function cancelFrameFunction(id) {
	    return cancel(id)
	  }
	})()
	
	function resizeListener(e) {
	  var win = e.target || e.srcElement
	  if (win.__resizeRAF__) {
	    cancelFrame(win.__resizeRAF__)
	  }
	  win.__resizeRAF__ = requestFrame(function () {
	    var trigger = win.__resizeTrigger__
	    trigger.__resizeListeners__.forEach(function (fn) {
	      fn.call(trigger, e)
	    })
	  })
	}
	
	var exports = function exports(element, fn) {
	  var window = this
	  var document = window.document
	  var isIE
	
	  var attachEvent = document.attachEvent
	  if (typeof navigator !== 'undefined') {
	    isIE = navigator.userAgent.match(/Trident/) ||
	      navigator.userAgent.match(/Edge/)
	  }
	
	  function objectLoad() {
	    this.contentDocument.defaultView.__resizeTrigger__ = this.__resizeElement__
	    this.contentDocument.defaultView.addEventListener('resize', resizeListener)
	  }
	
	  if (!element.__resizeListeners__) {
	    element.__resizeListeners__ = []
	    if (attachEvent) {
	      element.__resizeTrigger__ = element
	      element.attachEvent('onresize', resizeListener)
	    } else {
	      if (getComputedStyle(element).position === 'static') {
	        element.style.position = 'relative'
	      }
	      var obj = (element.__resizeTrigger__ = document.createElement('object'))
	      obj.setAttribute(
	        'style',
	        'display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; pointer-events: none; z-index: -1; opacity: 0;'
	      )
	      obj.setAttribute('class', 'resize-sensor')
	      obj.__resizeElement__ = element
	      obj.onload = objectLoad
	      obj.type = 'text/html'
	      if (isIE) {
	        element.appendChild(obj)
	      }
	      obj.data = 'about:blank'
	      if (!isIE) {
	        element.appendChild(obj)
	      }
	    }
	  }
	  element.__resizeListeners__.push(fn)
	}
	
	module.exports = typeof window === 'undefined' ? exports : exports.bind(window)
	
	module.exports.unbind = function (element, fn) {
	  var attachEvent = document.attachEvent
	  if (fn) {
	    element.__resizeListeners__.splice(
	      element.__resizeListeners__.indexOf(fn),
	      1
	    )
	  } else {
	    element.__resizeListeners__ = []
	  }
	  if (!element.__resizeListeners__.length) {
	    if (attachEvent) {
	      element.detachEvent('onresize', resizeListener)
	    } else {
	      element.__resizeTrigger__.contentDocument.defaultView.removeEventListener(
	        'resize',
	        resizeListener
	      )
	      delete element.__resizeTrigger__.contentDocument.defaultView.__resizeTrigger__
	      element.__resizeTrigger__ = !element.removeChild(
	        element.__resizeTrigger__
	      )
	    }
	    delete element.__resizeListeners__
	  }
	}


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.2
	var resizeListener;
	
	resizeListener = __webpack_require__(414);
	
	module.exports = {
	  getInitialState: function() {
	    if (this.props.initialPageWidth) {
	      return {
	        pageWidth: this.props.initialPageWidth
	      };
	    } else {
	      return {};
	    }
	  },
	  componentDidMount: function() {
	    return resizeListener.on(this.onResize);
	  },
	  componentWillUnmount: function() {
	    return resizeListener.off(this.onResize);
	  },
	  onResize: function(pageWidth) {
	    return this.setState({
	      pageWidth: pageWidth
	    });
	  }
	};


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.2
	var currentWidth, onResize, raf, subscribers, ticking, update;
	
	raf = __webpack_require__(415);
	
	currentWidth = void 0;
	
	subscribers = [];
	
	ticking = false;
	
	if (typeof window !== "undefined" && window !== null) {
	  currentWidth = window.innerWidth;
	}
	
	onResize = function() {
	  if (!ticking) {
	    ticking = true;
	    return raf(update);
	  }
	};
	
	update = function() {
	  var i, len, subscriber;
	  currentWidth = window.innerWidth;
	  for (i = 0, len = subscribers.length; i < len; i++) {
	    subscriber = subscribers[i];
	    subscriber(currentWidth);
	  }
	  return ticking = false;
	};
	
	if (typeof window !== "undefined" && window !== null) {
	  window.addEventListener("resize", onResize);
	}
	
	module.exports = {
	  on: function(subscribeFn) {
	    subscribeFn(currentWidth);
	    return subscribers.push(subscribeFn);
	  },
	  off: function(subscribeFn) {
	    return subscribers.splice(subscribers.indexOf(subscribeFn), 1);
	  }
	};


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	var now = __webpack_require__(416)
	  , global = typeof window === 'undefined' ? {} : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = global['request' + suffix]
	  , caf = global['cancel' + suffix] || global['cancelRequest' + suffix]
	  , isNative = true
	
	for(var i = 0; i < vendors.length && !raf; i++) {
	  raf = global[vendors[i] + 'Request' + suffix]
	  caf = global[vendors[i] + 'Cancel' + suffix]
	      || global[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  isNative = false
	
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  if(!isNative) {
	    return raf.call(global, fn)
	  }
	  return raf.call(global, function() {
	    try{
	      fn.apply(this, arguments)
	    } catch(e) {
	      setTimeout(function() { throw e }, 0)
	    }
	  })
	}
	module.exports.cancel = function() {
	  caf.apply(global, arguments)
	}


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
	(function() {
	  var getNanoSeconds, hrtime, loadTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - loadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    loadTime = getNanoSeconds();
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(116)))

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.10.0
	var React, objectAssign, spanCalculate;
	
	React = __webpack_require__(2);
	
	objectAssign = __webpack_require__(4);
	
	spanCalculate = __webpack_require__(418);
	
	module.exports = React.createClass({
	  displayName: "Span",
	  propTypes: {
	    context: React.PropTypes.object,
	    columns: React.PropTypes.number,
	    at: React.PropTypes.number,
	    pre: React.PropTypes.number,
	    post: React.PropTypes.number,
	    squish: React.PropTypes.number,
	    last: React.PropTypes.bool,
	    "break": React.PropTypes.bool
	  },
	  getDefaultProps: function() {
	    return {
	      at: 0,
	      pre: 0,
	      post: 0,
	      squish: 0,
	      last: false,
	      first: false,
	      "break": false
	    };
	  },
	  renderChildren: function() {
	    return React.Children.map(this.props.children, (function(_this) {
	      return function(child) {
	        var ref;
	        if ((child != null ? (ref = child.type) != null ? ref.displayName : void 0 : void 0) === "Span") {
	          return React.cloneElement(child, {
	            context: {
	              columns: _this.props.columns,
	              gutterRatio: _this.props.context.gutterRatio
	            }
	          });
	        } else {
	          return child;
	        }
	      };
	    })(this));
	  },
	  render: function() {
	    var props, style;
	    style = spanCalculate({
	      contextColumns: this.props.context.columns,
	      gutterRatio: this.props.context.gutterRatio,
	      columns: this.props.columns,
	      at: this.props.at,
	      pre: this.props.pre,
	      post: this.props.post,
	      squish: this.props.squish,
	      last: this.props.last,
	      "break": this.props["break"]
	    });
	    style = objectAssign(style, this.props.style);
	    props = objectAssign({}, this.props, {
	      "style": style
	    });
	    delete props.at;
	    delete props["break"];
	    delete props.columns;
	    delete props.context;
	    delete props.first;
	    delete props.last;
	    delete props.post;
	    delete props.pre;
	    delete props.squish;
	    delete props.style;
	    return React.createElement("div", Object.assign({}, props, {
	      "style": style
	    }), this.renderChildren(), React.createElement("span", {
	      "style": {
	        display: 'block',
	        clear: 'both'
	      }
	    }, ' '));
	  }
	});


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.10.0
	var objectAssign;
	
	objectAssign = __webpack_require__(4);
	
	module.exports = function(options) {
	  var calcSpacing, calcSpanWidth, defaults, float, gutterWidth, marginLeft, marginRight, n, ops, width;
	  defaults = {
	    columns: 3,
	    at: 0,
	    pre: 0,
	    post: 0,
	    squish: 0,
	    contextColumns: 12,
	    gutterRatio: 1 / 4,
	    first: false,
	    last: false
	  };
	  ops = objectAssign(defaults, options);
	  n = 100 / (ops.contextColumns + ((ops.contextColumns - 1) * ops.gutterRatio));
	  gutterWidth = ops.gutterRatio * n;
	  calcSpanWidth = function(numColumns) {
	    return n * numColumns + gutterWidth * (numColumns - 1);
	  };
	  calcSpacing = function(numColumns) {
	    if (numColumns === 0) {
	      return 0;
	    } else {
	      return calcSpanWidth(numColumns) + gutterWidth;
	    }
	  };
	  width = calcSpanWidth(ops.columns);
	  if (ops.at === 0 && ops.pre === 0 && ops.squish === 0) {
	    marginLeft = 0;
	  } else {
	    marginLeft = calcSpacing(ops.at) + calcSpacing(ops.pre) + calcSpacing(ops.squish);
	  }
	  if (ops.last && ops.post === 0 && ops.squish === 0) {
	    marginRight = 0;
	  } else if (ops.post !== 0 || ops.squish !== 0) {
	    marginRight = calcSpacing(ops.post) + calcSpacing(ops.squish);
	    if (!ops.last) {
	      marginRight = marginRight + gutterWidth;
	    }
	  } else {
	    marginRight = gutterWidth;
	  }
	  if (ops.last) {
	    float = "right";
	  } else {
	    float = "left";
	  }
	  width = width + "%";
	  marginLeft = marginLeft + "%";
	  marginRight = marginRight + "%";
	  return {
	    float: float,
	    marginLeft: marginLeft,
	    marginRight: marginRight,
	    width: width,
	    clear: ops["break"] ? 'both' : 'none'
	  };
	};


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _include = __webpack_require__(420);
	
	var _include2 = _interopRequireDefault(_include);
	
	var _colors = __webpack_require__(422);
	
	var _typography = __webpack_require__(427);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _reactRouter = __webpack_require__(173);
	
	var _gatsbyHelpers = __webpack_require__(403);
	
	var _config = __webpack_require__(404);
	
	var _semanticUiReact = __webpack_require__(471);
	
	var _breakpoint = __webpack_require__(947);
	
	var _breakpoint2 = _interopRequireDefault(_breakpoint);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rhythm = _typography2.default.rhythm,
	    adjustFontSizeTo = _typography2.default.adjustFontSizeTo;
	
	
	var Header = _react2.default.createClass({
	  displayName: 'Header',
	  propTypes: function propTypes() {
	    return {
	      route: _react2.default.PropTypes.object
	    };
	  },
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	  handleDropDown: function handleDropDown(e, data) {
	    return this.context.router.push(data.value);
	  },
	  render: function render() {
	    var uitgeverijAct = (0, _include2.default)(this.props.location.pathname, '/webshop/');
	    var productiesAct = (0, _include2.default)(this.props.location.pathname, '/producties/');
	    var blogAct = (0, _include2.default)(this.props.location.pathname, '/blog/');
	    var missieAct = (0, _include2.default)(this.props.location.pathname, '/missie/');
	    var dedagAct = (0, _include2.default)(this.props.location.pathname, '/dedag/');
	    var filmfocusAct = (0, _include2.default)(this.props.location.pathname, '/film-focus/');
	    var drop_list = [];
	    drop_list.push({ key: '/dedag/', value: '/dedag/', text: 'De Dag' });
	    drop_list.push({ key: '/blog/', value: '/blog/', text: 'Blog' });
	    drop_list.push({ key: '/missie/', value: '/missie/', text: 'Missie' });
	    drop_list.push({ key: '/film-focus/', value: '/film-focus/', text: 'FilmFocus' });
	    drop_list.push({ key: '/producties/', value: '/producties/', text: 'Producties' });
	    drop_list.push({ key: '/webshop/', value: '/webshop/', text: 'Webshop' });
	    var act_item = '';
	    if (dedagAct) act_item = '/dedag/';
	    if (blogAct) act_item = '/blog/';
	    if (missieAct) act_item = '/missie/';
	    if (filmfocusAct) act_item = '/film-focus/';
	    if (productiesAct) act_item = '/producties/';
	    if (uitgeverijAct) act_item = '/webshop/';
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'ui fluid container ' },
	        _react2.default.createElement(
	          _breakpoint2.default,
	          { mobile: true },
	          _react2.default.createElement(
	            'div',
	            { className: 'ui massive menu pointing secondary' },
	            _react2.default.createElement(
	              'div',
	              { className: 'ui container ' },
	              _react2.default.createElement(
	                'div',
	                { className: 'item', style: { padding: '0px', "marginRight": "20px" } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'parent-menu blog-image ' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'child-menu' },
	                    _react2.default.createElement(
	                      'span',
	                      { style: { fontWeight: 'bold' } },
	                      'men(',
	                      _react2.default.createElement(
	                        'span',
	                        { style: { color: '#f26d80' } },
	                        'S'
	                      ),
	                      ')tis'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  to: (0, _gatsbyHelpers.prefixLink)('/dedag/'),
	                  className: dedagAct ? 'active item' : 'item'
	                },
	                'De Dag'
	              ),
	              _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  to: (0, _gatsbyHelpers.prefixLink)('/blog/'),
	                  className: blogAct ? 'active item' : 'item'
	                },
	                'Blog'
	              ),
	              _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  to: (0, _gatsbyHelpers.prefixLink)('/missie/'),
	                  className: missieAct ? 'active item' : 'item'
	                },
	                'Missie'
	              ),
	              _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  to: (0, _gatsbyHelpers.prefixLink)('/film-focus/'),
	                  className: filmfocusAct ? 'active item' : 'item'
	                },
	                'FilmFocus'
	              ),
	              _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  to: (0, _gatsbyHelpers.prefixLink)('/producties/'),
	                  className: productiesAct ? 'active item' : 'item'
	                },
	                'Producties'
	              ),
	              _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  to: (0, _gatsbyHelpers.prefixLink)('/webshop/'),
	                  className: uitgeverijAct ? 'active item' : 'item'
	                },
	                'Webshop'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _breakpoint2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'parent-blog blog-image ', style: { textAlign: "center" } },
	            _react2.default.createElement(
	              'div',
	              { className: 'child-blog' },
	              _react2.default.createElement(
	                'span',
	                { style: { fontWeight: 'bold' } },
	                'men(',
	                _react2.default.createElement(
	                  'span',
	                  { style: { color: '#f26d80' } },
	                  'S'
	                ),
	                ')tis'
	              )
	            )
	          ),
	          _react2.default.createElement('div', { style: { height: '10px' } }),
	          _react2.default.createElement(_semanticUiReact.Dropdown, { defaultValue: act_item, fluid: true, search: true, selection: true,
	            options: drop_list, onChange: this.handleDropDown
	
	          })
	        )
	      ),
	      _react2.default.createElement('div', { style: { height: "10px" } })
	    );
	  }
	});
	
	Header.propTypes = {
	  location: _react2.default.PropTypes.object.isRequired
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(421);
	
	module.exports = function include(str, needle) {
	  if (needle === '') return true;
	  return makeString(str).indexOf(needle) !== -1;
	};


/***/ }),
/* 421 */
/***/ (function(module, exports) {

	/**
	 * Ensure some object is a coerced to a string
	 **/
	module.exports = function makeString(object) {
	  if (object == null) return '';
	  return '' + object;
	};


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.activeColors = exports.colors = undefined;
	
	var _colorPairsPicker = __webpack_require__(423);
	
	var _colorPairsPicker2 = _interopRequireDefault(_colorPairsPicker);
	
	var _chromaJs = __webpack_require__(424);
	
	var _chromaJs2 = _interopRequireDefault(_chromaJs);
	
	var _config = __webpack_require__(404);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var colors = exports.colors = (0, _colorPairsPicker2.default)(_config.config.baseColor, {
	  contrast: 5.5
	});
	
	var darker = (0, _chromaJs2.default)(_config.config.baseColor).darken(10).hex();
	var activeColors = exports.activeColors = (0, _colorPairsPicker2.default)(darker, {
	  contrast: 7
	});

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.3
	var chroma, colorPicker, contrastSearch, isObject, objectAssign;
	
	chroma = __webpack_require__(424);
	
	objectAssign = __webpack_require__(4);
	
	contrastSearch = __webpack_require__(425);
	
	isObject = __webpack_require__(426);
	
	module.exports = colorPicker = function(color, targetColor, options) {
	  var bg, contrastToEnd, contrastToStart, end, endColor, fg, highestPossibleContrast, newEnd, newStart, secondColor, start, startColor;
	  if (options == null) {
	    options = {};
	  }
	  if (targetColor == null) {
	    targetColor = color;
	  }
	  if (isObject(targetColor)) {
	    options = targetColor;
	    targetColor = color;
	  }
	  options = objectAssign({
	    colorIsBackground: true,
	    contrast: 5,
	    foregroundMax: 0.98,
	    foregroundMin: 0.02,
	    backgroundMax: 0.85,
	    backgroundMin: 0.15,
	    direction: void 0
	  }, options);
	  if (options.colorIsBackground) {
	    start = options.foregroundMin;
	    end = options.foregroundMax;
	  } else {
	    start = options.backgroundMin;
	    end = options.backgroundMax;
	  }
	  if (options.direction != null) {
	    secondColor = contrastSearch(targetColor, color, start, end, options.direction, options.contrast);
	  } else {
	    endColor = chroma(targetColor, 'lab').luminance(end);
	    startColor = chroma(targetColor, 'lab').luminance(start);
	    contrastToStart = chroma.contrast(color, startColor.css());
	    contrastToEnd = chroma.contrast(color, endColor.css());
	    if (contrastToEnd > options.contrast) {
	      secondColor = contrastSearch(targetColor, color, start, end, 'end', options.contrast);
	    } else if (contrastToStart > options.contrast) {
	      secondColor = contrastSearch(targetColor, color, start, end, 'start', options.contrast);
	    } else {
	      if (options.colorIsBackground) {
	        newStart = options.backgroundMin;
	        newEnd = options.backgroundMax;
	      } else {
	        newStart = options.foregroundMin;
	        newEnd = options.foregroundMax;
	      }
	      if (contrastToEnd > contrastToStart) {
	        secondColor = chroma(targetColor, 'lab').luminance(end);
	        highestPossibleContrast = chroma.contrast(secondColor.css(), chroma(color, 'lab').luminance(newStart));
	        if (highestPossibleContrast > options.contrast) {
	          color = contrastSearch(color, secondColor.css(), newStart, newEnd, 'start', options.contrast);
	        } else {
	          color = chroma(color, 'lab').luminance(newStart).lab();
	        }
	        secondColor = secondColor.lab();
	      } else {
	        secondColor = chroma(color, 'lab').luminance(start);
	        highestPossibleContrast = chroma.contrast(secondColor.css(), chroma(color, 'lab').luminance(newEnd));
	        if (highestPossibleContrast > options.contrast) {
	          color = contrastSearch(color, secondColor.css(), newStart, newEnd, 'end', options.contrast);
	        } else {
	          color = chroma(color, 'lab').luminance(newEnd).lab();
	        }
	        secondColor = secondColor.lab();
	      }
	    }
	  }
	  if (options.colorIsBackground) {
	    bg = color;
	    fg = secondColor;
	  } else {
	    bg = secondColor;
	    fg = color;
	  }
	  return {
	    bg: chroma.lab(bg).css(),
	    fg: chroma.lab(fg).css()
	  };
	};


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {
	/**
	 * @license
	 *
	 * chroma.js - JavaScript library for color conversions
	 * 
	 * Copyright (c) 2011-2015, Gregor Aisch
	 * All rights reserved.
	 * 
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are met:
	 * 
	 * 1. Redistributions of source code must retain the above copyright notice, this
	 *    list of conditions and the following disclaimer.
	 * 
	 * 2. Redistributions in binary form must reproduce the above copyright notice,
	 *    this list of conditions and the following disclaimer in the documentation
	 *    and/or other materials provided with the distribution.
	 * 
	 * 3. The name Gregor Aisch may not be used to endorse or promote products
	 *    derived from this software without specific prior written permission.
	 * 
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
	 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
	 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
	 * DISCLAIMED. IN NO EVENT SHALL GREGOR AISCH OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 * INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
	 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
	 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
	 * OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
	 * EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 *
	 */
	
	(function() {
	  var Color, K, PITHIRD, TWOPI, X, Y, Z, bezier, blend, blend_f, brewer, burn, chroma, clip_rgb, colors, cos, css2rgb, darken, dodge, each, floor, hex2rgb, hsi2rgb, hsl2rgb, hsv2rgb, lab2lch, lab2rgb, lab_xyz, lch2lab, lch2rgb, lighten, limit, log, luminance, luminance_x, multiply, normal, num2rgb, overlay, pow, rgb2hex, rgb2hsi, rgb2hsl, rgb2hsv, rgb2lab, rgb2lch, rgb2num, rgb2temp, rgb2xyz, rgb_xyz, root, round, screen, sin, temp2rgb, type, unpack, xyz_lab, xyz_rgb;
	
	  chroma = function(x, y, z, m) {
	    return new Color(x, y, z, m);
	  };
	
	  if ((typeof module !== "undefined" && module !== null) && (module.exports != null)) {
	    module.exports = chroma;
	  }
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return chroma;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else {
	    root = typeof exports !== "undefined" && exports !== null ? exports : this;
	    root.chroma = chroma;
	  }
	
	  chroma.color = function(x, y, z, m) {
	    return new Color(x, y, z, m);
	  };
	
	  chroma.hsl = function(h, s, l, a) {
	    return new Color(h, s, l, a, 'hsl');
	  };
	
	  chroma.hsv = function(h, s, v, a) {
	    return new Color(h, s, v, a, 'hsv');
	  };
	
	  chroma.rgb = function(r, g, b, a) {
	    return new Color(r, g, b, a, 'rgb');
	  };
	
	  chroma.hex = function(x) {
	    return new Color(x);
	  };
	
	  chroma.css = function(x) {
	    return new Color(x);
	  };
	
	  chroma.lab = function(l, a, b) {
	    return new Color(l, a, b, 'lab');
	  };
	
	  chroma.lch = function(l, c, h) {
	    return new Color(l, c, h, 'lch');
	  };
	
	  chroma.hsi = function(h, s, i) {
	    return new Color(h, s, i, 'hsi');
	  };
	
	  chroma.gl = function(r, g, b, a) {
	    return new Color(r, g, b, a, 'gl');
	  };
	
	  chroma.num = function(n) {
	    return new Color(n, 'num');
	  };
	
	  chroma.random = function() {
	    var code, digits, i, o;
	    digits = '0123456789abcdef';
	    code = '#';
	    for (i = o = 0; o < 6; i = ++o) {
	      code += digits.charAt(floor(Math.random() * 16));
	    }
	    return new Color(code);
	  };
	
	  chroma.interpolate = function(a, b, f, m) {
	    var ref, ref1;
	    if ((a == null) || (b == null)) {
	      return '#000';
	    }
	    if ((ref = type(a)) === 'string' || ref === 'number') {
	      a = new Color(a);
	    }
	    if ((ref1 = type(b)) === 'string' || ref1 === 'number') {
	      b = new Color(b);
	    }
	    return a.interpolate(f, b, m);
	  };
	
	  chroma.mix = chroma.interpolate;
	
	  chroma.contrast = function(a, b) {
	    var l1, l2, ref, ref1;
	    if ((ref = type(a)) === 'string' || ref === 'number') {
	      a = new Color(a);
	    }
	    if ((ref1 = type(b)) === 'string' || ref1 === 'number') {
	      b = new Color(b);
	    }
	    l1 = a.luminance();
	    l2 = b.luminance();
	    if (l1 > l2) {
	      return (l1 + 0.05) / (l2 + 0.05);
	    } else {
	      return (l2 + 0.05) / (l1 + 0.05);
	    }
	  };
	
	  chroma.luminance = function(color) {
	    return chroma(color).luminance();
	  };
	
	  chroma.kelvin = function(k) {
	    return chroma(temp2rgb(k), 'rgb');
	  };
	
	  chroma.version = '0.7.8';
	
	  chroma._Color = Color;
	
	
	  /**
	      chroma.js
	  
	      Copyright (c) 2011-2013, Gregor Aisch
	      All rights reserved.
	  
	      Redistribution and use in source and binary forms, with or without
	      modification, are permitted provided that the following conditions are met:
	  
	      * Redistributions of source code must retain the above copyright notice, this
	        list of conditions and the following disclaimer.
	  
	      * Redistributions in binary form must reproduce the above copyright notice,
	        this list of conditions and the following disclaimer in the documentation
	        and/or other materials provided with the distribution.
	  
	      * The name Gregor Aisch may not be used to endorse or promote products
	        derived from this software without specific prior written permission.
	  
	      THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
	      AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
	      IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
	      DISCLAIMED. IN NO EVENT SHALL GREGOR AISCH OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	      INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
	      BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
	      DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
	      OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	      NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
	      EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	  
	      @source: https://github.com/gka/chroma.js
	   */
	
	  Color = (function() {
	    function Color() {
	      var a, arg, args, len, m, me, me_rgb, o, ref, ref1, ref2, ref3, ref4, x, y, z;
	      me = this;
	      args = [];
	      for (o = 0, len = arguments.length; o < len; o++) {
	        arg = arguments[o];
	        if (arg != null) {
	          args.push(arg);
	        }
	      }
	      if (args.length === 0) {
	        ref = [255, 0, 255, 1, 'rgb'], x = ref[0], y = ref[1], z = ref[2], a = ref[3], m = ref[4];
	      } else if (type(args[0]) === "array") {
	        if (args[0].length === 3) {
	          ref1 = args[0], x = ref1[0], y = ref1[1], z = ref1[2];
	          a = 1;
	        } else if (args[0].length === 4) {
	          ref2 = args[0], x = ref2[0], y = ref2[1], z = ref2[2], a = ref2[3];
	        } else {
	          throw 'unknown input argument';
	        }
	        m = (ref3 = args[1]) != null ? ref3 : 'rgb';
	      } else if (type(args[0]) === "string") {
	        x = args[0];
	        m = 'hex';
	      } else if (type(args[0]) === "object") {
	        ref4 = args[0]._rgb, x = ref4[0], y = ref4[1], z = ref4[2], a = ref4[3];
	        m = 'rgb';
	      } else if (args.length <= 2 && type(args[0]) === "number") {
	        x = args[0];
	        m = 'num';
	      } else if (args.length >= 3) {
	        x = args[0];
	        y = args[1];
	        z = args[2];
	      }
	      if (args.length === 3) {
	        m = 'rgb';
	        a = 1;
	      } else if (args.length === 4) {
	        if (type(args[3]) === "string") {
	          m = args[3];
	          a = 1;
	        } else if (type(args[3]) === "number") {
	          m = 'rgb';
	          a = args[3];
	        }
	      } else if (args.length === 5) {
	        a = args[3];
	        m = args[4];
	      }
	      if (a == null) {
	        a = 1;
	      }
	      if (m === 'rgb') {
	        me._rgb = [x, y, z, a];
	      } else if (m === 'gl') {
	        me._rgb = [x * 255, y * 255, z * 255, a];
	      } else if (m === 'hsl') {
	        me._rgb = hsl2rgb(x, y, z);
	        me._rgb[3] = a;
	      } else if (m === 'hsv') {
	        me._rgb = hsv2rgb(x, y, z);
	        me._rgb[3] = a;
	      } else if (m === 'hex') {
	        me._rgb = hex2rgb(x);
	      } else if (m === 'lab') {
	        me._rgb = lab2rgb(x, y, z);
	        me._rgb[3] = a;
	      } else if (m === 'lch') {
	        me._rgb = lch2rgb(x, y, z);
	        me._rgb[3] = a;
	      } else if (m === 'hsi') {
	        me._rgb = hsi2rgb(x, y, z);
	        me._rgb[3] = a;
	      } else if (m === 'num') {
	        me._rgb = num2rgb(x);
	      }
	      me_rgb = clip_rgb(me._rgb);
	    }
	
	    Color.prototype.rgb = function() {
	      return this._rgb.slice(0, 3);
	    };
	
	    Color.prototype.rgba = function() {
	      return this._rgb;
	    };
	
	    Color.prototype.hex = function(mode) {
	      if (mode == null) {
	        mode = 'rgb';
	      }
	      return rgb2hex(this._rgb, mode);
	    };
	
	    Color.prototype.toString = function() {
	      return this.name();
	    };
	
	    Color.prototype.hsl = function() {
	      return rgb2hsl(this._rgb);
	    };
	
	    Color.prototype.hsv = function() {
	      return rgb2hsv(this._rgb);
	    };
	
	    Color.prototype.lab = function() {
	      return rgb2lab(this._rgb);
	    };
	
	    Color.prototype.lch = function() {
	      return rgb2lch(this._rgb);
	    };
	
	    Color.prototype.hsi = function() {
	      return rgb2hsi(this._rgb);
	    };
	
	    Color.prototype.gl = function() {
	      return [this._rgb[0] / 255, this._rgb[1] / 255, this._rgb[2] / 255, this._rgb[3]];
	    };
	
	    Color.prototype.num = function() {
	      return rgb2num(this._rgb);
	    };
	
	    Color.prototype.luminance = function(lum, mode) {
	      var cur_lum, eps, max_iter, test;
	      if (mode == null) {
	        mode = 'rgb';
	      }
	      if (!arguments.length) {
	        return luminance(this._rgb);
	      }
	      if (lum === 0) {
	        this._rgb = [0, 0, 0, this._rgb[3]];
	      }
	      if (lum === 1) {
	        this._rgb = [255, 255, 255, this._rgb[3]];
	      }
	      cur_lum = luminance(this._rgb);
	      eps = 1e-7;
	      max_iter = 20;
	      test = function(l, h) {
	        var lm, m;
	        m = l.interpolate(0.5, h, mode);
	        lm = m.luminance();
	        if (Math.abs(lum - lm) < eps || !max_iter--) {
	          return m;
	        }
	        if (lm > lum) {
	          return test(l, m);
	        }
	        return test(m, h);
	      };
	      this._rgb = (cur_lum > lum ? test(new Color('black'), this) : test(this, new Color('white'))).rgba();
	      return this;
	    };
	
	    Color.prototype.name = function() {
	      var h, k;
	      h = this.hex();
	      for (k in chroma.colors) {
	        if (h === chroma.colors[k]) {
	          return k;
	        }
	      }
	      return h;
	    };
	
	    Color.prototype.alpha = function(alpha) {
	      if (arguments.length) {
	        this._rgb[3] = alpha;
	        return this;
	      }
	      return this._rgb[3];
	    };
	
	    Color.prototype.css = function(mode) {
	      var hsl, me, rgb, rnd;
	      if (mode == null) {
	        mode = 'rgb';
	      }
	      me = this;
	      rgb = me._rgb;
	      if (mode.length === 3 && rgb[3] < 1) {
	        mode += 'a';
	      }
	      if (mode === 'rgb') {
	        return mode + '(' + rgb.slice(0, 3).map(round).join(',') + ')';
	      } else if (mode === 'rgba') {
	        return mode + '(' + rgb.slice(0, 3).map(round).join(',') + ',' + rgb[3] + ')';
	      } else if (mode === 'hsl' || mode === 'hsla') {
	        hsl = me.hsl();
	        rnd = function(a) {
	          return round(a * 100) / 100;
	        };
	        hsl[0] = rnd(hsl[0] || 0);
	        hsl[1] = rnd(hsl[1] * 100) + '%';
	        hsl[2] = rnd(hsl[2] * 100) + '%';
	        if (mode.length === 4) {
	          hsl[3] = rgb[3];
	        }
	        return mode + '(' + hsl.join(',') + ')';
	      }
	    };
	
	    Color.prototype.interpolate = function(f, col, m) {
	
	      /*
	      interpolates between colors
	      f = 0 --> me
	      f = 1 --> col
	       */
	      var dh, hue, hue0, hue1, lbv, lbv0, lbv1, me, res, sat, sat0, sat1, xyz0, xyz1;
	      me = this;
	      if (m == null) {
	        m = 'rgb';
	      }
	      if (type(col) === "string") {
	        col = new Color(col);
	      }
	      if (m === 'hsl' || m === 'hsv' || m === 'lch' || m === 'hsi') {
	        if (m === 'hsl') {
	          xyz0 = me.hsl();
	          xyz1 = col.hsl();
	        } else if (m === 'hsv') {
	          xyz0 = me.hsv();
	          xyz1 = col.hsv();
	        } else if (m === 'hsi') {
	          xyz0 = me.hsi();
	          xyz1 = col.hsi();
	        } else if (m === 'lch') {
	          xyz0 = me.lch();
	          xyz1 = col.lch();
	        }
	        if (m.substr(0, 1) === 'h') {
	          hue0 = xyz0[0], sat0 = xyz0[1], lbv0 = xyz0[2];
	          hue1 = xyz1[0], sat1 = xyz1[1], lbv1 = xyz1[2];
	        } else {
	          lbv0 = xyz0[0], sat0 = xyz0[1], hue0 = xyz0[2];
	          lbv1 = xyz1[0], sat1 = xyz1[1], hue1 = xyz1[2];
	        }
	        if (!isNaN(hue0) && !isNaN(hue1)) {
	          if (hue1 > hue0 && hue1 - hue0 > 180) {
	            dh = hue1 - (hue0 + 360);
	          } else if (hue1 < hue0 && hue0 - hue1 > 180) {
	            dh = hue1 + 360 - hue0;
	          } else {
	            dh = hue1 - hue0;
	          }
	          hue = hue0 + f * dh;
	        } else if (!isNaN(hue0)) {
	          hue = hue0;
	          if ((lbv1 === 1 || lbv1 === 0) && m !== 'hsv') {
	            sat = sat0;
	          }
	        } else if (!isNaN(hue1)) {
	          hue = hue1;
	          if ((lbv0 === 1 || lbv0 === 0) && m !== 'hsv') {
	            sat = sat1;
	          }
	        } else {
	          hue = Number.NaN;
	        }
	        if (sat == null) {
	          sat = sat0 + f * (sat1 - sat0);
	        }
	        lbv = lbv0 + f * (lbv1 - lbv0);
	        if (m.substr(0, 1) === 'h') {
	          res = new Color(hue, sat, lbv, m);
	        } else {
	          res = new Color(lbv, sat, hue, m);
	        }
	      } else if (m === 'rgb') {
	        xyz0 = me._rgb;
	        xyz1 = col._rgb;
	        res = new Color(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), m);
	      } else if (m === 'num') {
	        if (!(col instanceof Color)) {
	          col = new Color(col, m);
	        }
	        xyz0 = me._rgb;
	        xyz1 = col._rgb;
	        res = new Color(((xyz0[0] + f * (xyz1[0] - xyz0[0])) << 16) + ((xyz0[1] + f * (xyz1[1] - xyz0[1])) << 8) + ((xyz0[2] + f * (xyz1[2] - xyz0[2])) & 0xff), m);
	      } else if (m === 'lab') {
	        xyz0 = me.lab();
	        xyz1 = col.lab();
	        res = new Color(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), m);
	      } else {
	        throw "color mode " + m + " is not supported";
	      }
	      res.alpha(me.alpha() + f * (col.alpha() - me.alpha()));
	      return res;
	    };
	
	    Color.prototype.mix = function(f, col, m) {
	      return this.interpolate(f, col, m);
	    };
	
	    Color.prototype.premultiply = function() {
	      var a, rgb;
	      rgb = this.rgb();
	      a = this.alpha();
	      return chroma(rgb[0] * a, rgb[1] * a, rgb[2] * a, a);
	    };
	
	    Color.prototype.darken = function(amount) {
	      var lch, me;
	      if (amount == null) {
	        amount = 20;
	      }
	      me = this;
	      lch = me.lch();
	      lch[0] -= amount;
	      return chroma.lch(lch).alpha(me.alpha());
	    };
	
	    Color.prototype.darker = function(amount) {
	      return this.darken(amount);
	    };
	
	    Color.prototype.brighten = function(amount) {
	      if (amount == null) {
	        amount = 20;
	      }
	      return this.darken(-amount);
	    };
	
	    Color.prototype.brighter = function(amount) {
	      return this.brighten(amount);
	    };
	
	    Color.prototype.saturate = function(amount) {
	      var lch, me;
	      if (amount == null) {
	        amount = 20;
	      }
	      me = this;
	      lch = me.lch();
	      lch[1] += amount;
	      return chroma.lch(lch).alpha(me.alpha());
	    };
	
	    Color.prototype.desaturate = function(amount) {
	      if (amount == null) {
	        amount = 20;
	      }
	      return this.saturate(-amount);
	    };
	
	    Color.prototype.blend = function(col, mode) {
	      return chroma.blend(this, col, mode);
	    };
	
	    Color.prototype.kelvin = function() {
	      return rgb2temp(this.rgb());
	    };
	
	    return Color;
	
	  })();
	
	  clip_rgb = function(rgb) {
	    var i;
	    for (i in rgb) {
	      if (i < 3) {
	        if (rgb[i] < 0) {
	          rgb[i] = 0;
	        }
	        if (rgb[i] > 255) {
	          rgb[i] = 255;
	        }
	      } else if (i === 3) {
	        if (rgb[i] < 0) {
	          rgb[i] = 0;
	        }
	        if (rgb[i] > 1) {
	          rgb[i] = 1;
	        }
	      }
	    }
	    return rgb;
	  };
	
	  css2rgb = function(css) {
	    var aa, ab, hsl, i, m, o, rgb, w;
	    css = css.toLowerCase();
	    if ((chroma.colors != null) && chroma.colors[css]) {
	      return hex2rgb(chroma.colors[css]);
	    }
	    if (m = css.match(/rgb\(\s*(\-?\d+),\s*(\-?\d+)\s*,\s*(\-?\d+)\s*\)/)) {
	      rgb = m.slice(1, 4);
	      for (i = o = 0; o <= 2; i = ++o) {
	        rgb[i] = +rgb[i];
	      }
	      rgb[3] = 1;
	    } else if (m = css.match(/rgba\(\s*(\-?\d+),\s*(\-?\d+)\s*,\s*(\-?\d+)\s*,\s*([01]|[01]?\.\d+)\)/)) {
	      rgb = m.slice(1, 5);
	      for (i = w = 0; w <= 3; i = ++w) {
	        rgb[i] = +rgb[i];
	      }
	    } else if (m = css.match(/rgb\(\s*(\-?\d+(?:\.\d+)?)%,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*\)/)) {
	      rgb = m.slice(1, 4);
	      for (i = aa = 0; aa <= 2; i = ++aa) {
	        rgb[i] = round(rgb[i] * 2.55);
	      }
	      rgb[3] = 1;
	    } else if (m = css.match(/rgba\(\s*(\-?\d+(?:\.\d+)?)%,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)/)) {
	      rgb = m.slice(1, 5);
	      for (i = ab = 0; ab <= 2; i = ++ab) {
	        rgb[i] = round(rgb[i] * 2.55);
	      }
	      rgb[3] = +rgb[3];
	    } else if (m = css.match(/hsl\(\s*(\-?\d+(?:\.\d+)?),\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*\)/)) {
	      hsl = m.slice(1, 4);
	      hsl[1] *= 0.01;
	      hsl[2] *= 0.01;
	      rgb = hsl2rgb(hsl);
	      rgb[3] = 1;
	    } else if (m = css.match(/hsla\(\s*(\-?\d+(?:\.\d+)?),\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)/)) {
	      hsl = m.slice(1, 4);
	      hsl[1] *= 0.01;
	      hsl[2] *= 0.01;
	      rgb = hsl2rgb(hsl);
	      rgb[3] = +m[4];
	    }
	    return rgb;
	  };
	
	  hex2rgb = function(hex) {
	    var a, b, g, r, rgb, u;
	    if (hex.match(/^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)) {
	      if (hex.length === 4 || hex.length === 7) {
	        hex = hex.substr(1);
	      }
	      if (hex.length === 3) {
	        hex = hex.split("");
	        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
	      }
	      u = parseInt(hex, 16);
	      r = u >> 16;
	      g = u >> 8 & 0xFF;
	      b = u & 0xFF;
	      return [r, g, b, 1];
	    }
	    if (hex.match(/^#?([A-Fa-f0-9]{8})$/)) {
	      if (hex.length === 9) {
	        hex = hex.substr(1);
	      }
	      u = parseInt(hex, 16);
	      r = u >> 24 & 0xFF;
	      g = u >> 16 & 0xFF;
	      b = u >> 8 & 0xFF;
	      a = round((u & 0xFF) / 0xFF * 100) / 100;
	      return [r, g, b, a];
	    }
	    if (rgb = css2rgb(hex)) {
	      return rgb;
	    }
	    throw "unknown color: " + hex;
	  };
	
	  hsi2rgb = function(h, s, i) {
	
	    /*
	    borrowed from here:
	    http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/hsi2rgb.cpp
	     */
	    var b, g, r, ref;
	    ref = unpack(arguments), h = ref[0], s = ref[1], i = ref[2];
	    h /= 360;
	    if (h < 1 / 3) {
	      b = (1 - s) / 3;
	      r = (1 + s * cos(TWOPI * h) / cos(PITHIRD - TWOPI * h)) / 3;
	      g = 1 - (b + r);
	    } else if (h < 2 / 3) {
	      h -= 1 / 3;
	      r = (1 - s) / 3;
	      g = (1 + s * cos(TWOPI * h) / cos(PITHIRD - TWOPI * h)) / 3;
	      b = 1 - (r + g);
	    } else {
	      h -= 2 / 3;
	      g = (1 - s) / 3;
	      b = (1 + s * cos(TWOPI * h) / cos(PITHIRD - TWOPI * h)) / 3;
	      r = 1 - (g + b);
	    }
	    r = limit(i * r * 3);
	    g = limit(i * g * 3);
	    b = limit(i * b * 3);
	    return [r * 255, g * 255, b * 255];
	  };
	
	  hsl2rgb = function() {
	    var b, c, g, h, i, l, o, r, ref, ref1, s, t1, t2, t3;
	    ref = unpack(arguments), h = ref[0], s = ref[1], l = ref[2];
	    if (s === 0) {
	      r = g = b = l * 255;
	    } else {
	      t3 = [0, 0, 0];
	      c = [0, 0, 0];
	      t2 = l < 0.5 ? l * (1 + s) : l + s - l * s;
	      t1 = 2 * l - t2;
	      h /= 360;
	      t3[0] = h + 1 / 3;
	      t3[1] = h;
	      t3[2] = h - 1 / 3;
	      for (i = o = 0; o <= 2; i = ++o) {
	        if (t3[i] < 0) {
	          t3[i] += 1;
	        }
	        if (t3[i] > 1) {
	          t3[i] -= 1;
	        }
	        if (6 * t3[i] < 1) {
	          c[i] = t1 + (t2 - t1) * 6 * t3[i];
	        } else if (2 * t3[i] < 1) {
	          c[i] = t2;
	        } else if (3 * t3[i] < 2) {
	          c[i] = t1 + (t2 - t1) * ((2 / 3) - t3[i]) * 6;
	        } else {
	          c[i] = t1;
	        }
	      }
	      ref1 = [round(c[0] * 255), round(c[1] * 255), round(c[2] * 255)], r = ref1[0], g = ref1[1], b = ref1[2];
	    }
	    return [r, g, b];
	  };
	
	  hsv2rgb = function() {
	    var b, f, g, h, i, p, q, r, ref, ref1, ref2, ref3, ref4, ref5, ref6, s, t, v;
	    ref = unpack(arguments), h = ref[0], s = ref[1], v = ref[2];
	    v *= 255;
	    if (s === 0) {
	      r = g = b = v;
	    } else {
	      if (h === 360) {
	        h = 0;
	      }
	      if (h > 360) {
	        h -= 360;
	      }
	      if (h < 0) {
	        h += 360;
	      }
	      h /= 60;
	      i = floor(h);
	      f = h - i;
	      p = v * (1 - s);
	      q = v * (1 - s * f);
	      t = v * (1 - s * (1 - f));
	      switch (i) {
	        case 0:
	          ref1 = [v, t, p], r = ref1[0], g = ref1[1], b = ref1[2];
	          break;
	        case 1:
	          ref2 = [q, v, p], r = ref2[0], g = ref2[1], b = ref2[2];
	          break;
	        case 2:
	          ref3 = [p, v, t], r = ref3[0], g = ref3[1], b = ref3[2];
	          break;
	        case 3:
	          ref4 = [p, q, v], r = ref4[0], g = ref4[1], b = ref4[2];
	          break;
	        case 4:
	          ref5 = [t, p, v], r = ref5[0], g = ref5[1], b = ref5[2];
	          break;
	        case 5:
	          ref6 = [v, p, q], r = ref6[0], g = ref6[1], b = ref6[2];
	      }
	    }
	    r = round(r);
	    g = round(g);
	    b = round(b);
	    return [r, g, b];
	  };
	
	  K = 18;
	
	  X = 0.950470;
	
	  Y = 1;
	
	  Z = 1.088830;
	
	  lab2lch = function() {
	    var a, b, c, h, l, ref;
	    ref = unpack(arguments), l = ref[0], a = ref[1], b = ref[2];
	    c = Math.sqrt(a * a + b * b);
	    h = (Math.atan2(b, a) / Math.PI * 180 + 360) % 360;
	    return [l, c, h];
	  };
	
	  lab2rgb = function(l, a, b) {
	
	    /*
	    adapted to match d3 implementation
	     */
	    var g, r, ref, ref1, x, y, z;
	    if (l !== void 0 && l.length === 3) {
	      ref = l, l = ref[0], a = ref[1], b = ref[2];
	    }
	    if (l !== void 0 && l.length === 3) {
	      ref1 = l, l = ref1[0], a = ref1[1], b = ref1[2];
	    }
	    y = (l + 16) / 116;
	    x = y + a / 500;
	    z = y - b / 200;
	    x = lab_xyz(x) * X;
	    y = lab_xyz(y) * Y;
	    z = lab_xyz(z) * Z;
	    r = xyz_rgb(3.2404542 * x - 1.5371385 * y - 0.4985314 * z);
	    g = xyz_rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z);
	    b = xyz_rgb(0.0556434 * x - 0.2040259 * y + 1.0572252 * z);
	    return [limit(r, 0, 255), limit(g, 0, 255), limit(b, 0, 255), 1];
	  };
	
	  lab_xyz = function(x) {
	    if (x > 0.206893034) {
	      return x * x * x;
	    } else {
	      return (x - 4 / 29) / 7.787037;
	    }
	  };
	
	  xyz_rgb = function(r) {
	    return round(255 * (r <= 0.00304 ? 12.92 * r : 1.055 * pow(r, 1 / 2.4) - 0.055));
	  };
	
	  lch2lab = function() {
	
	    /*
	    Convert from a qualitative parameter h and a quantitative parameter l to a 24-bit pixel. These formulas were invented by David Dalrymple to obtain maximum contrast without going out of gamut if the parameters are in the range 0-1.
	    A saturation multiplier was added by Gregor Aisch
	     */
	    var c, h, l, ref;
	    ref = unpack(arguments), l = ref[0], c = ref[1], h = ref[2];
	    h = h * Math.PI / 180;
	    return [l, Math.cos(h) * c, Math.sin(h) * c];
	  };
	
	  lch2rgb = function(l, c, h) {
	    var L, a, b, g, r, ref, ref1;
	    ref = lch2lab(l, c, h), L = ref[0], a = ref[1], b = ref[2];
	    ref1 = lab2rgb(L, a, b), r = ref1[0], g = ref1[1], b = ref1[2];
	    return [limit(r, 0, 255), limit(g, 0, 255), limit(b, 0, 255)];
	  };
	
	  luminance = function(r, g, b) {
	    var ref;
	    ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
	    r = luminance_x(r);
	    g = luminance_x(g);
	    b = luminance_x(b);
	    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
	  };
	
	  luminance_x = function(x) {
	    x /= 255;
	    if (x <= 0.03928) {
	      return x / 12.92;
	    } else {
	      return Math.pow((x + 0.055) / 1.055, 2.4);
	    }
	  };
	
	  num2rgb = function(num) {
	    var b, g, r;
	    if (type(num) === "number" && num >= 0 && num <= 0xFFFFFF) {
	      r = num >> 16;
	      g = (num >> 8) & 0xFF;
	      b = num & 0xFF;
	      return [r, g, b, 1];
	    }
	    throw "unknown num color: " + num;
	  };
	
	  rgb2hex = function(channels, mode) {
	    var a, b, g, hxa, r, str, u;
	    if (mode == null) {
	      mode = 'rgb';
	    }
	    r = channels[0], g = channels[1], b = channels[2], a = channels[3];
	    u = r << 16 | g << 8 | b;
	    str = "000000" + u.toString(16);
	    str = str.substr(str.length - 6);
	    hxa = '0' + round(a * 255).toString(16);
	    hxa = hxa.substr(hxa.length - 2);
	    return "#" + (function() {
	      switch (mode.toLowerCase()) {
	        case 'rgba':
	          return str + hxa;
	        case 'argb':
	          return hxa + str;
	        default:
	          return str;
	      }
	    })();
	  };
	
	  rgb2hsi = function() {
	
	    /*
	    borrowed from here:
	    http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/rgb2hsi.cpp
	     */
	    var TWOPI, b, g, h, i, min, r, ref, s;
	    ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
	    TWOPI = Math.PI * 2;
	    r /= 255;
	    g /= 255;
	    b /= 255;
	    min = Math.min(r, g, b);
	    i = (r + g + b) / 3;
	    s = 1 - min / i;
	    if (s === 0) {
	      h = 0;
	    } else {
	      h = ((r - g) + (r - b)) / 2;
	      h /= Math.sqrt((r - g) * (r - g) + (r - b) * (g - b));
	      h = Math.acos(h);
	      if (b > g) {
	        h = TWOPI - h;
	      }
	      h /= TWOPI;
	    }
	    return [h * 360, s, i];
	  };
	
	  rgb2hsl = function(r, g, b) {
	    var h, l, max, min, ref, s;
	    if (r !== void 0 && r.length >= 3) {
	      ref = r, r = ref[0], g = ref[1], b = ref[2];
	    }
	    r /= 255;
	    g /= 255;
	    b /= 255;
	    min = Math.min(r, g, b);
	    max = Math.max(r, g, b);
	    l = (max + min) / 2;
	    if (max === min) {
	      s = 0;
	      h = Number.NaN;
	    } else {
	      s = l < 0.5 ? (max - min) / (max + min) : (max - min) / (2 - max - min);
	    }
	    if (r === max) {
	      h = (g - b) / (max - min);
	    } else if (g === max) {
	      h = 2 + (b - r) / (max - min);
	    } else if (b === max) {
	      h = 4 + (r - g) / (max - min);
	    }
	    h *= 60;
	    if (h < 0) {
	      h += 360;
	    }
	    return [h, s, l];
	  };
	
	  rgb2hsv = function() {
	    var b, delta, g, h, max, min, r, ref, s, v;
	    ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
	    min = Math.min(r, g, b);
	    max = Math.max(r, g, b);
	    delta = max - min;
	    v = max / 255.0;
	    if (max === 0) {
	      h = Number.NaN;
	      s = 0;
	    } else {
	      s = delta / max;
	      if (r === max) {
	        h = (g - b) / delta;
	      }
	      if (g === max) {
	        h = 2 + (b - r) / delta;
	      }
	      if (b === max) {
	        h = 4 + (r - g) / delta;
	      }
	      h *= 60;
	      if (h < 0) {
	        h += 360;
	      }
	    }
	    return [h, s, v];
	  };
	
	  rgb2lab = function() {
	    var b, g, r, ref, ref1, x, y, z;
	    ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
	    ref1 = rgb2xyz(r, g, b), x = ref1[0], y = ref1[1], z = ref1[2];
	    return [116 * y - 16, 500 * (x - y), 200 * (y - z)];
	  };
	
	  rgb_xyz = function(r) {
	    if ((r /= 255) <= 0.04045) {
	      return r / 12.92;
	    } else {
	      return Math.pow((r + 0.055) / 1.055, 2.4);
	    }
	  };
	
	  xyz_lab = function(x) {
	    if (x > 0.008856) {
	      return Math.pow(x, 1 / 3);
	    } else {
	      return 7.787037 * x + 4 / 29;
	    }
	  };
	
	  rgb2xyz = function() {
	    var b, g, r, ref, x, y, z;
	    ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
	    r = rgb_xyz(r);
	    g = rgb_xyz(g);
	    b = rgb_xyz(b);
	    x = xyz_lab((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / X);
	    y = xyz_lab((0.2126729 * r + 0.7151522 * g + 0.0721750 * b) / Y);
	    z = xyz_lab((0.0193339 * r + 0.1191920 * g + 0.9503041 * b) / Z);
	    return [x, y, z];
	  };
	
	  rgb2lch = function() {
	    var a, b, g, l, r, ref, ref1;
	    ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
	    ref1 = rgb2lab(r, g, b), l = ref1[0], a = ref1[1], b = ref1[2];
	    return lab2lch(l, a, b);
	  };
	
	  rgb2num = function() {
	    var b, g, r, ref;
	    ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
	    return (r << 16) + (g << 8) + b;
	  };
	
	  temp2rgb = function(kelvin) {
	    var b, g, r, temp;
	    temp = kelvin / 100;
	    if (temp < 66) {
	      r = 255;
	      g = -155.25485562709179 - 0.44596950469579133 * (g = temp - 2) + 104.49216199393888 * log(g);
	      b = temp < 20 ? 0 : -254.76935184120902 + 0.8274096064007395 * (b = temp - 10) + 115.67994401066147 * log(b);
	    } else {
	      r = 351.97690566805693 + 0.114206453784165 * (r = temp - 55) - 40.25366309332127 * log(r);
	      g = 325.4494125711974 + 0.07943456536662342 * (g = temp - 50) - 28.0852963507957 * log(g);
	      b = 255;
	    }
	    return clip_rgb([r, g, b]);
	  };
	
	  rgb2temp = function() {
	    var b, eps, g, maxTemp, minTemp, r, ref, rgb, temp;
	    ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
	    minTemp = 1000;
	    maxTemp = 40000;
	    eps = 0.4;
	    while (maxTemp - minTemp > eps) {
	      temp = (maxTemp + minTemp) * 0.5;
	      rgb = temp2rgb(temp);
	      if ((rgb[2] / rgb[0]) >= (b / r)) {
	        maxTemp = temp;
	      } else {
	        minTemp = temp;
	      }
	    }
	    return round(temp);
	  };
	
	
	  /*
	      chroma.js
	  
	      Copyright (c) 2011-2013, Gregor Aisch
	      All rights reserved.
	  
	      Redistribution and use in source and binary forms, with or without
	      modification, are permitted provided that the following conditions are met:
	  
	      * Redistributions of source code must retain the above copyright notice, this
	        list of conditions and the following disclaimer.
	  
	      * Redistributions in binary form must reproduce the above copyright notice,
	        this list of conditions and the following disclaimer in the documentation
	        and/or other materials provided with the distribution.
	  
	      * The name Gregor Aisch may not be used to endorse or promote products
	        derived from this software without specific prior written permission.
	  
	      THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
	      AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
	      IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
	      DISCLAIMED. IN NO EVENT SHALL GREGOR AISCH OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	      INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
	      BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
	      DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
	      OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	      NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
	      EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	  
	      @source: https://github.com/gka/chroma.js
	   */
	
	  chroma.scale = function(colors, positions) {
	    var _colorCache, _colors, _correctLightness, _domain, _fixed, _max, _min, _mode, _nacol, _numClasses, _out, _pos, _spread, classifyValue, f, getClass, getColor, resetCache, setColors, setDomain, tmap;
	    _mode = 'rgb';
	    _nacol = chroma('#ccc');
	    _spread = 0;
	    _fixed = false;
	    _domain = [0, 1];
	    _colors = [];
	    _out = false;
	    _pos = [];
	    _min = 0;
	    _max = 1;
	    _correctLightness = false;
	    _numClasses = 0;
	    _colorCache = {};
	    setColors = function(colors, positions) {
	      var c, col, o, ref, ref1, ref2, w;
	      if (colors == null) {
	        colors = ['#ddd', '#222'];
	      }
	      if ((colors != null) && type(colors) === 'string' && (((ref = chroma.brewer) != null ? ref[colors] : void 0) != null)) {
	        colors = chroma.brewer[colors];
	      }
	      if (type(colors) === 'array') {
	        colors = colors.slice(0);
	        for (c = o = 0, ref1 = colors.length - 1; 0 <= ref1 ? o <= ref1 : o >= ref1; c = 0 <= ref1 ? ++o : --o) {
	          col = colors[c];
	          if (type(col) === "string") {
	            colors[c] = chroma(col);
	          }
	        }
	        if (positions != null) {
	          _pos = positions;
	        } else {
	          _pos = [];
	          for (c = w = 0, ref2 = colors.length - 1; 0 <= ref2 ? w <= ref2 : w >= ref2; c = 0 <= ref2 ? ++w : --w) {
	            _pos.push(c / (colors.length - 1));
	          }
	        }
	      }
	      resetCache();
	      return _colors = colors;
	    };
	    setDomain = function(domain) {
	      if (domain == null) {
	        domain = [];
	      }
	
	      /*
	       * use this if you want to display a limited number of data classes
	       * possible methods are "equalinterval", "quantiles", "custom"
	       */
	      _domain = domain;
	      _min = domain[0];
	      _max = domain[domain.length - 1];
	      resetCache();
	      if (domain.length === 2) {
	        return _numClasses = 0;
	      } else {
	        return _numClasses = domain.length - 1;
	      }
	    };
	    getClass = function(value) {
	      var i, n;
	      if (_domain != null) {
	        n = _domain.length - 1;
	        i = 0;
	        while (i < n && value >= _domain[i]) {
	          i++;
	        }
	        return i - 1;
	      }
	      return 0;
	    };
	    tmap = function(t) {
	      return t;
	    };
	    classifyValue = function(value) {
	      var i, maxc, minc, n, val;
	      val = value;
	      if (_domain.length > 2) {
	        n = _domain.length - 1;
	        i = getClass(value);
	        minc = _domain[0] + (_domain[1] - _domain[0]) * (0 + _spread * 0.5);
	        maxc = _domain[n - 1] + (_domain[n] - _domain[n - 1]) * (1 - _spread * 0.5);
	        val = _min + ((_domain[i] + (_domain[i + 1] - _domain[i]) * 0.5 - minc) / (maxc - minc)) * (_max - _min);
	      }
	      return val;
	    };
	    getColor = function(val, bypassMap) {
	      var c, col, f0, i, k, o, p, ref, t;
	      if (bypassMap == null) {
	        bypassMap = false;
	      }
	      if (isNaN(val)) {
	        return _nacol;
	      }
	      if (!bypassMap) {
	        if (_domain.length > 2) {
	          c = getClass(val);
	          t = c / (_numClasses - 1);
	        } else {
	          t = f0 = _min !== _max ? (val - _min) / (_max - _min) : 0;
	          t = f0 = (val - _min) / (_max - _min);
	          t = Math.min(1, Math.max(0, t));
	        }
	      } else {
	        t = val;
	      }
	      if (!bypassMap) {
	        t = tmap(t);
	      }
	      k = Math.floor(t * 10000);
	      if (_colorCache[k]) {
	        col = _colorCache[k];
	      } else {
	        if (type(_colors) === 'array') {
	          for (i = o = 0, ref = _pos.length - 1; 0 <= ref ? o <= ref : o >= ref; i = 0 <= ref ? ++o : --o) {
	            p = _pos[i];
	            if (t <= p) {
	              col = _colors[i];
	              break;
	            }
	            if (t >= p && i === _pos.length - 1) {
	              col = _colors[i];
	              break;
	            }
	            if (t > p && t < _pos[i + 1]) {
	              t = (t - p) / (_pos[i + 1] - p);
	              col = chroma.interpolate(_colors[i], _colors[i + 1], t, _mode);
	              break;
	            }
	          }
	        } else if (type(_colors) === 'function') {
	          col = _colors(t);
	        }
	        _colorCache[k] = col;
	      }
	      return col;
	    };
	    resetCache = function() {
	      return _colorCache = {};
	    };
	    setColors(colors, positions);
	    f = function(v) {
	      var c;
	      c = getColor(v);
	      if (_out && c[_out]) {
	        return c[_out]();
	      } else {
	        return c;
	      }
	    };
	    f.domain = function(domain, classes, mode, key) {
	      var d;
	      if (mode == null) {
	        mode = 'e';
	      }
	      if (!arguments.length) {
	        return _domain;
	      }
	      if (classes != null) {
	        d = chroma.analyze(domain, key);
	        if (classes === 0) {
	          domain = [d.min, d.max];
	        } else {
	          domain = chroma.limits(d, mode, classes);
	        }
	      }
	      setDomain(domain);
	      return f;
	    };
	    f.mode = function(_m) {
	      if (!arguments.length) {
	        return _mode;
	      }
	      _mode = _m;
	      resetCache();
	      return f;
	    };
	    f.range = function(colors, _pos) {
	      setColors(colors, _pos);
	      return f;
	    };
	    f.out = function(_o) {
	      _out = _o;
	      return f;
	    };
	    f.spread = function(val) {
	      if (!arguments.length) {
	        return _spread;
	      }
	      _spread = val;
	      return f;
	    };
	    f.correctLightness = function(v) {
	      if (!arguments.length) {
	        return _correctLightness;
	      }
	      _correctLightness = v;
	      resetCache();
	      if (_correctLightness) {
	        tmap = function(t) {
	          var L0, L1, L_actual, L_diff, L_ideal, max_iter, pol, t0, t1;
	          L0 = getColor(0, true).lab()[0];
	          L1 = getColor(1, true).lab()[0];
	          pol = L0 > L1;
	          L_actual = getColor(t, true).lab()[0];
	          L_ideal = L0 + (L1 - L0) * t;
	          L_diff = L_actual - L_ideal;
	          t0 = 0;
	          t1 = 1;
	          max_iter = 20;
	          while (Math.abs(L_diff) > 1e-2 && max_iter-- > 0) {
	            (function() {
	              if (pol) {
	                L_diff *= -1;
	              }
	              if (L_diff < 0) {
	                t0 = t;
	                t += (t1 - t) * 0.5;
	              } else {
	                t1 = t;
	                t += (t0 - t) * 0.5;
	              }
	              L_actual = getColor(t, true).lab()[0];
	              return L_diff = L_actual - L_ideal;
	            })();
	          }
	          return t;
	        };
	      } else {
	        tmap = function(t) {
	          return t;
	        };
	      }
	      return f;
	    };
	    f.colors = function(out) {
	      var i, len, o, ref, samples, w;
	      if (out == null) {
	        out = 'hex';
	      }
	      colors = [];
	      samples = [];
	      if (_domain.length > 2) {
	        for (i = o = 1, ref = _domain.length; 1 <= ref ? o < ref : o > ref; i = 1 <= ref ? ++o : --o) {
	          samples.push((_domain[i - 1] + _domain[i]) * 0.5);
	        }
	      } else {
	        samples = _domain;
	      }
	      for (w = 0, len = samples.length; w < len; w++) {
	        i = samples[w];
	        colors.push(f(i)[out]());
	      }
	      return colors;
	    };
	    return f;
	  };
	
	  if (chroma.scales == null) {
	    chroma.scales = {};
	  }
	
	  chroma.scales.cool = function() {
	    return chroma.scale([chroma.hsl(180, 1, .9), chroma.hsl(250, .7, .4)]);
	  };
	
	  chroma.scales.hot = function() {
	    return chroma.scale(['#000', '#f00', '#ff0', '#fff'], [0, .25, .75, 1]).mode('rgb');
	  };
	
	
	  /*
	      chroma.js
	  
	      Copyright (c) 2011-2013, Gregor Aisch
	      All rights reserved.
	  
	      Redistribution and use in source and binary forms, with or without
	      modification, are permitted provided that the following conditions are met:
	  
	      * Redistributions of source code must retain the above copyright notice, this
	        list of conditions and the following disclaimer.
	  
	      * Redistributions in binary form must reproduce the above copyright notice,
	        this list of conditions and the following disclaimer in the documentation
	        and/or other materials provided with the distribution.
	  
	      * The name Gregor Aisch may not be used to endorse or promote products
	        derived from this software without specific prior written permission.
	  
	      THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
	      AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
	      IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
	      DISCLAIMED. IN NO EVENT SHALL GREGOR AISCH OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	      INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
	      BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
	      DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
	      OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	      NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
	      EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	  
	      @source: https://github.com/gka/chroma.js
	   */
	
	  chroma.analyze = function(data, key, filter) {
	    var add, k, len, o, r, val, visit;
	    r = {
	      min: Number.MAX_VALUE,
	      max: Number.MAX_VALUE * -1,
	      sum: 0,
	      values: [],
	      count: 0
	    };
	    if (filter == null) {
	      filter = function() {
	        return true;
	      };
	    }
	    add = function(val) {
	      if ((val != null) && !isNaN(val)) {
	        r.values.push(val);
	        r.sum += val;
	        if (val < r.min) {
	          r.min = val;
	        }
	        if (val > r.max) {
	          r.max = val;
	        }
	        r.count += 1;
	      }
	    };
	    visit = function(val, k) {
	      if (filter(val, k)) {
	        if ((key != null) && type(key) === 'function') {
	          return add(key(val));
	        } else if ((key != null) && type(key) === 'string' || type(key) === 'number') {
	          return add(val[key]);
	        } else {
	          return add(val);
	        }
	      }
	    };
	    if (type(data) === 'array') {
	      for (o = 0, len = data.length; o < len; o++) {
	        val = data[o];
	        visit(val);
	      }
	    } else {
	      for (k in data) {
	        val = data[k];
	        visit(val, k);
	      }
	    }
	    r.domain = [r.min, r.max];
	    r.limits = function(mode, num) {
	      return chroma.limits(r, mode, num);
	    };
	    return r;
	  };
	
	  chroma.limits = function(data, mode, num) {
	    var aa, ab, ac, ad, ae, af, ag, ah, ai, aj, ak, al, am, assignments, best, centroids, cluster, clusterSizes, dist, i, j, kClusters, limits, max, max_log, min, min_log, mindist, n, nb_iters, newCentroids, o, p, pb, pr, ref, ref1, ref10, ref11, ref12, ref13, ref14, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, repeat, sum, tmpKMeansBreaks, value, values, w;
	    if (mode == null) {
	      mode = 'equal';
	    }
	    if (num == null) {
	      num = 7;
	    }
	    if (type(data) === 'array') {
	      data = chroma.analyze(data);
	    }
	    min = data.min;
	    max = data.max;
	    sum = data.sum;
	    values = data.values.sort(function(a, b) {
	      return a - b;
	    });
	    limits = [];
	    if (mode.substr(0, 1) === 'c') {
	      limits.push(min);
	      limits.push(max);
	    }
	    if (mode.substr(0, 1) === 'e') {
	      limits.push(min);
	      for (i = o = 1, ref = num - 1; 1 <= ref ? o <= ref : o >= ref; i = 1 <= ref ? ++o : --o) {
	        limits.push(min + (i / num) * (max - min));
	      }
	      limits.push(max);
	    } else if (mode.substr(0, 1) === 'l') {
	      if (min <= 0) {
	        throw 'Logarithmic scales are only possible for values > 0';
	      }
	      min_log = Math.LOG10E * log(min);
	      max_log = Math.LOG10E * log(max);
	      limits.push(min);
	      for (i = w = 1, ref1 = num - 1; 1 <= ref1 ? w <= ref1 : w >= ref1; i = 1 <= ref1 ? ++w : --w) {
	        limits.push(pow(10, min_log + (i / num) * (max_log - min_log)));
	      }
	      limits.push(max);
	    } else if (mode.substr(0, 1) === 'q') {
	      limits.push(min);
	      for (i = aa = 1, ref2 = num - 1; 1 <= ref2 ? aa <= ref2 : aa >= ref2; i = 1 <= ref2 ? ++aa : --aa) {
	        p = values.length * i / num;
	        pb = floor(p);
	        if (pb === p) {
	          limits.push(values[pb]);
	        } else {
	          pr = p - pb;
	          limits.push(values[pb] * pr + values[pb + 1] * (1 - pr));
	        }
	      }
	      limits.push(max);
	    } else if (mode.substr(0, 1) === 'k') {
	
	      /*
	      implementation based on
	      http://code.google.com/p/figue/source/browse/trunk/figue.js#336
	      simplified for 1-d input values
	       */
	      n = values.length;
	      assignments = new Array(n);
	      clusterSizes = new Array(num);
	      repeat = true;
	      nb_iters = 0;
	      centroids = null;
	      centroids = [];
	      centroids.push(min);
	      for (i = ab = 1, ref3 = num - 1; 1 <= ref3 ? ab <= ref3 : ab >= ref3; i = 1 <= ref3 ? ++ab : --ab) {
	        centroids.push(min + (i / num) * (max - min));
	      }
	      centroids.push(max);
	      while (repeat) {
	        for (j = ac = 0, ref4 = num - 1; 0 <= ref4 ? ac <= ref4 : ac >= ref4; j = 0 <= ref4 ? ++ac : --ac) {
	          clusterSizes[j] = 0;
	        }
	        for (i = ad = 0, ref5 = n - 1; 0 <= ref5 ? ad <= ref5 : ad >= ref5; i = 0 <= ref5 ? ++ad : --ad) {
	          value = values[i];
	          mindist = Number.MAX_VALUE;
	          for (j = ae = 0, ref6 = num - 1; 0 <= ref6 ? ae <= ref6 : ae >= ref6; j = 0 <= ref6 ? ++ae : --ae) {
	            dist = abs(centroids[j] - value);
	            if (dist < mindist) {
	              mindist = dist;
	              best = j;
	            }
	          }
	          clusterSizes[best]++;
	          assignments[i] = best;
	        }
	        newCentroids = new Array(num);
	        for (j = af = 0, ref7 = num - 1; 0 <= ref7 ? af <= ref7 : af >= ref7; j = 0 <= ref7 ? ++af : --af) {
	          newCentroids[j] = null;
	        }
	        for (i = ag = 0, ref8 = n - 1; 0 <= ref8 ? ag <= ref8 : ag >= ref8; i = 0 <= ref8 ? ++ag : --ag) {
	          cluster = assignments[i];
	          if (newCentroids[cluster] === null) {
	            newCentroids[cluster] = values[i];
	          } else {
	            newCentroids[cluster] += values[i];
	          }
	        }
	        for (j = ah = 0, ref9 = num - 1; 0 <= ref9 ? ah <= ref9 : ah >= ref9; j = 0 <= ref9 ? ++ah : --ah) {
	          newCentroids[j] *= 1 / clusterSizes[j];
	        }
	        repeat = false;
	        for (j = ai = 0, ref10 = num - 1; 0 <= ref10 ? ai <= ref10 : ai >= ref10; j = 0 <= ref10 ? ++ai : --ai) {
	          if (newCentroids[j] !== centroids[i]) {
	            repeat = true;
	            break;
	          }
	        }
	        centroids = newCentroids;
	        nb_iters++;
	        if (nb_iters > 200) {
	          repeat = false;
	        }
	      }
	      kClusters = {};
	      for (j = aj = 0, ref11 = num - 1; 0 <= ref11 ? aj <= ref11 : aj >= ref11; j = 0 <= ref11 ? ++aj : --aj) {
	        kClusters[j] = [];
	      }
	      for (i = ak = 0, ref12 = n - 1; 0 <= ref12 ? ak <= ref12 : ak >= ref12; i = 0 <= ref12 ? ++ak : --ak) {
	        cluster = assignments[i];
	        kClusters[cluster].push(values[i]);
	      }
	      tmpKMeansBreaks = [];
	      for (j = al = 0, ref13 = num - 1; 0 <= ref13 ? al <= ref13 : al >= ref13; j = 0 <= ref13 ? ++al : --al) {
	        tmpKMeansBreaks.push(kClusters[j][0]);
	        tmpKMeansBreaks.push(kClusters[j][kClusters[j].length - 1]);
	      }
	      tmpKMeansBreaks = tmpKMeansBreaks.sort(function(a, b) {
	        return a - b;
	      });
	      limits.push(tmpKMeansBreaks[0]);
	      for (i = am = 1, ref14 = tmpKMeansBreaks.length - 1; am <= ref14; i = am += 2) {
	        if (!isNaN(tmpKMeansBreaks[i])) {
	          limits.push(tmpKMeansBreaks[i]);
	        }
	      }
	    }
	    return limits;
	  };
	
	
	  /**
	  	ColorBrewer colors for chroma.js
	  
	  	Copyright (c) 2002 Cynthia Brewer, Mark Harrower, and The 
	  	Pennsylvania State University.
	  
	  	Licensed under the Apache License, Version 2.0 (the "License"); 
	  	you may not use this file except in compliance with the License.
	  	You may obtain a copy of the License at	
	  	http://www.apache.org/licenses/LICENSE-2.0
	  
	  	Unless required by applicable law or agreed to in writing, software distributed
	  	under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	  	CONDITIONS OF ANY KIND, either express or implied. See the License for the
	  	specific language governing permissions and limitations under the License.
	  
	      @preserve
	   */
	
	  chroma.brewer = brewer = {
	    OrRd: ['#fff7ec', '#fee8c8', '#fdd49e', '#fdbb84', '#fc8d59', '#ef6548', '#d7301f', '#b30000', '#7f0000'],
	    PuBu: ['#fff7fb', '#ece7f2', '#d0d1e6', '#a6bddb', '#74a9cf', '#3690c0', '#0570b0', '#045a8d', '#023858'],
	    BuPu: ['#f7fcfd', '#e0ecf4', '#bfd3e6', '#9ebcda', '#8c96c6', '#8c6bb1', '#88419d', '#810f7c', '#4d004b'],
	    Oranges: ['#fff5eb', '#fee6ce', '#fdd0a2', '#fdae6b', '#fd8d3c', '#f16913', '#d94801', '#a63603', '#7f2704'],
	    BuGn: ['#f7fcfd', '#e5f5f9', '#ccece6', '#99d8c9', '#66c2a4', '#41ae76', '#238b45', '#006d2c', '#00441b'],
	    YlOrBr: ['#ffffe5', '#fff7bc', '#fee391', '#fec44f', '#fe9929', '#ec7014', '#cc4c02', '#993404', '#662506'],
	    YlGn: ['#ffffe5', '#f7fcb9', '#d9f0a3', '#addd8e', '#78c679', '#41ab5d', '#238443', '#006837', '#004529'],
	    Reds: ['#fff5f0', '#fee0d2', '#fcbba1', '#fc9272', '#fb6a4a', '#ef3b2c', '#cb181d', '#a50f15', '#67000d'],
	    RdPu: ['#fff7f3', '#fde0dd', '#fcc5c0', '#fa9fb5', '#f768a1', '#dd3497', '#ae017e', '#7a0177', '#49006a'],
	    Greens: ['#f7fcf5', '#e5f5e0', '#c7e9c0', '#a1d99b', '#74c476', '#41ab5d', '#238b45', '#006d2c', '#00441b'],
	    YlGnBu: ['#ffffd9', '#edf8b1', '#c7e9b4', '#7fcdbb', '#41b6c4', '#1d91c0', '#225ea8', '#253494', '#081d58'],
	    Purples: ['#fcfbfd', '#efedf5', '#dadaeb', '#bcbddc', '#9e9ac8', '#807dba', '#6a51a3', '#54278f', '#3f007d'],
	    GnBu: ['#f7fcf0', '#e0f3db', '#ccebc5', '#a8ddb5', '#7bccc4', '#4eb3d3', '#2b8cbe', '#0868ac', '#084081'],
	    Greys: ['#ffffff', '#f0f0f0', '#d9d9d9', '#bdbdbd', '#969696', '#737373', '#525252', '#252525', '#000000'],
	    YlOrRd: ['#ffffcc', '#ffeda0', '#fed976', '#feb24c', '#fd8d3c', '#fc4e2a', '#e31a1c', '#bd0026', '#800026'],
	    PuRd: ['#f7f4f9', '#e7e1ef', '#d4b9da', '#c994c7', '#df65b0', '#e7298a', '#ce1256', '#980043', '#67001f'],
	    Blues: ['#f7fbff', '#deebf7', '#c6dbef', '#9ecae1', '#6baed6', '#4292c6', '#2171b5', '#08519c', '#08306b'],
	    PuBuGn: ['#fff7fb', '#ece2f0', '#d0d1e6', '#a6bddb', '#67a9cf', '#3690c0', '#02818a', '#016c59', '#014636'],
	    Spectral: ['#9e0142', '#d53e4f', '#f46d43', '#fdae61', '#fee08b', '#ffffbf', '#e6f598', '#abdda4', '#66c2a5', '#3288bd', '#5e4fa2'],
	    RdYlGn: ['#a50026', '#d73027', '#f46d43', '#fdae61', '#fee08b', '#ffffbf', '#d9ef8b', '#a6d96a', '#66bd63', '#1a9850', '#006837'],
	    RdBu: ['#67001f', '#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#f7f7f7', '#d1e5f0', '#92c5de', '#4393c3', '#2166ac', '#053061'],
	    PiYG: ['#8e0152', '#c51b7d', '#de77ae', '#f1b6da', '#fde0ef', '#f7f7f7', '#e6f5d0', '#b8e186', '#7fbc41', '#4d9221', '#276419'],
	    PRGn: ['#40004b', '#762a83', '#9970ab', '#c2a5cf', '#e7d4e8', '#f7f7f7', '#d9f0d3', '#a6dba0', '#5aae61', '#1b7837', '#00441b'],
	    RdYlBu: ['#a50026', '#d73027', '#f46d43', '#fdae61', '#fee090', '#ffffbf', '#e0f3f8', '#abd9e9', '#74add1', '#4575b4', '#313695'],
	    BrBG: ['#543005', '#8c510a', '#bf812d', '#dfc27d', '#f6e8c3', '#f5f5f5', '#c7eae5', '#80cdc1', '#35978f', '#01665e', '#003c30'],
	    RdGy: ['#67001f', '#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#ffffff', '#e0e0e0', '#bababa', '#878787', '#4d4d4d', '#1a1a1a'],
	    PuOr: ['#7f3b08', '#b35806', '#e08214', '#fdb863', '#fee0b6', '#f7f7f7', '#d8daeb', '#b2abd2', '#8073ac', '#542788', '#2d004b'],
	    Set2: ['#66c2a5', '#fc8d62', '#8da0cb', '#e78ac3', '#a6d854', '#ffd92f', '#e5c494', '#b3b3b3'],
	    Accent: ['#7fc97f', '#beaed4', '#fdc086', '#ffff99', '#386cb0', '#f0027f', '#bf5b17', '#666666'],
	    Set1: ['#e41a1c', '#377eb8', '#4daf4a', '#984ea3', '#ff7f00', '#ffff33', '#a65628', '#f781bf', '#999999'],
	    Set3: ['#8dd3c7', '#ffffb3', '#bebada', '#fb8072', '#80b1d3', '#fdb462', '#b3de69', '#fccde5', '#d9d9d9', '#bc80bd', '#ccebc5', '#ffed6f'],
	    Dark2: ['#1b9e77', '#d95f02', '#7570b3', '#e7298a', '#66a61e', '#e6ab02', '#a6761d', '#666666'],
	    Paired: ['#a6cee3', '#1f78b4', '#b2df8a', '#33a02c', '#fb9a99', '#e31a1c', '#fdbf6f', '#ff7f00', '#cab2d6', '#6a3d9a', '#ffff99', '#b15928'],
	    Pastel2: ['#b3e2cd', '#fdcdac', '#cbd5e8', '#f4cae4', '#e6f5c9', '#fff2ae', '#f1e2cc', '#cccccc'],
	    Pastel1: ['#fbb4ae', '#b3cde3', '#ccebc5', '#decbe4', '#fed9a6', '#ffffcc', '#e5d8bd', '#fddaec', '#f2f2f2']
	  };
	
	
	  /**
	  	X11 color names
	  
	  	http://www.w3.org/TR/css3-color/#svg-color
	   */
	
	  chroma.colors = colors = {
	    indigo: "#4b0082",
	    gold: "#ffd700",
	    hotpink: "#ff69b4",
	    firebrick: "#b22222",
	    indianred: "#cd5c5c",
	    yellow: "#ffff00",
	    mistyrose: "#ffe4e1",
	    darkolivegreen: "#556b2f",
	    olive: "#808000",
	    darkseagreen: "#8fbc8f",
	    pink: "#ffc0cb",
	    tomato: "#ff6347",
	    lightcoral: "#f08080",
	    orangered: "#ff4500",
	    navajowhite: "#ffdead",
	    lime: "#00ff00",
	    palegreen: "#98fb98",
	    darkslategrey: "#2f4f4f",
	    greenyellow: "#adff2f",
	    burlywood: "#deb887",
	    seashell: "#fff5ee",
	    mediumspringgreen: "#00fa9a",
	    fuchsia: "#ff00ff",
	    papayawhip: "#ffefd5",
	    blanchedalmond: "#ffebcd",
	    chartreuse: "#7fff00",
	    dimgray: "#696969",
	    black: "#000000",
	    peachpuff: "#ffdab9",
	    springgreen: "#00ff7f",
	    aquamarine: "#7fffd4",
	    white: "#ffffff",
	    orange: "#ffa500",
	    lightsalmon: "#ffa07a",
	    darkslategray: "#2f4f4f",
	    brown: "#a52a2a",
	    ivory: "#fffff0",
	    dodgerblue: "#1e90ff",
	    peru: "#cd853f",
	    lawngreen: "#7cfc00",
	    chocolate: "#d2691e",
	    crimson: "#dc143c",
	    forestgreen: "#228b22",
	    darkgrey: "#a9a9a9",
	    lightseagreen: "#20b2aa",
	    cyan: "#00ffff",
	    mintcream: "#f5fffa",
	    silver: "#c0c0c0",
	    antiquewhite: "#faebd7",
	    mediumorchid: "#ba55d3",
	    skyblue: "#87ceeb",
	    gray: "#808080",
	    darkturquoise: "#00ced1",
	    goldenrod: "#daa520",
	    darkgreen: "#006400",
	    floralwhite: "#fffaf0",
	    darkviolet: "#9400d3",
	    darkgray: "#a9a9a9",
	    moccasin: "#ffe4b5",
	    saddlebrown: "#8b4513",
	    grey: "#808080",
	    darkslateblue: "#483d8b",
	    lightskyblue: "#87cefa",
	    lightpink: "#ffb6c1",
	    mediumvioletred: "#c71585",
	    slategrey: "#708090",
	    red: "#ff0000",
	    deeppink: "#ff1493",
	    limegreen: "#32cd32",
	    darkmagenta: "#8b008b",
	    palegoldenrod: "#eee8aa",
	    plum: "#dda0dd",
	    turquoise: "#40e0d0",
	    lightgrey: "#d3d3d3",
	    lightgoldenrodyellow: "#fafad2",
	    darkgoldenrod: "#b8860b",
	    lavender: "#e6e6fa",
	    maroon: "#800000",
	    yellowgreen: "#9acd32",
	    sandybrown: "#f4a460",
	    thistle: "#d8bfd8",
	    violet: "#ee82ee",
	    navy: "#000080",
	    magenta: "#ff00ff",
	    dimgrey: "#696969",
	    tan: "#d2b48c",
	    rosybrown: "#bc8f8f",
	    olivedrab: "#6b8e23",
	    blue: "#0000ff",
	    lightblue: "#add8e6",
	    ghostwhite: "#f8f8ff",
	    honeydew: "#f0fff0",
	    cornflowerblue: "#6495ed",
	    slateblue: "#6a5acd",
	    linen: "#faf0e6",
	    darkblue: "#00008b",
	    powderblue: "#b0e0e6",
	    seagreen: "#2e8b57",
	    darkkhaki: "#bdb76b",
	    snow: "#fffafa",
	    sienna: "#a0522d",
	    mediumblue: "#0000cd",
	    royalblue: "#4169e1",
	    lightcyan: "#e0ffff",
	    green: "#008000",
	    mediumpurple: "#9370db",
	    midnightblue: "#191970",
	    cornsilk: "#fff8dc",
	    paleturquoise: "#afeeee",
	    bisque: "#ffe4c4",
	    slategray: "#708090",
	    darkcyan: "#008b8b",
	    khaki: "#f0e68c",
	    wheat: "#f5deb3",
	    teal: "#008080",
	    darkorchid: "#9932cc",
	    deepskyblue: "#00bfff",
	    salmon: "#fa8072",
	    darkred: "#8b0000",
	    steelblue: "#4682b4",
	    palevioletred: "#db7093",
	    lightslategray: "#778899",
	    aliceblue: "#f0f8ff",
	    lightslategrey: "#778899",
	    lightgreen: "#90ee90",
	    orchid: "#da70d6",
	    gainsboro: "#dcdcdc",
	    mediumseagreen: "#3cb371",
	    lightgray: "#d3d3d3",
	    mediumturquoise: "#48d1cc",
	    lemonchiffon: "#fffacd",
	    cadetblue: "#5f9ea0",
	    lightyellow: "#ffffe0",
	    lavenderblush: "#fff0f5",
	    coral: "#ff7f50",
	    purple: "#800080",
	    aqua: "#00ffff",
	    whitesmoke: "#f5f5f5",
	    mediumslateblue: "#7b68ee",
	    darkorange: "#ff8c00",
	    mediumaquamarine: "#66cdaa",
	    darksalmon: "#e9967a",
	    beige: "#f5f5dc",
	    blueviolet: "#8a2be2",
	    azure: "#f0ffff",
	    lightsteelblue: "#b0c4de",
	    oldlace: "#fdf5e6",
	    rebeccapurple: "#663399"
	  };
	
	
	  /*
	      chroma.js
	  
	      Copyright (c) 2011-2013, Gregor Aisch
	      All rights reserved.
	  
	      Redistribution and use in source and binary forms, with or without
	      modification, are permitted provided that the following conditions are met:
	  
	      * Redistributions of source code must retain the above copyright notice, this
	        list of conditions and the following disclaimer.
	  
	      * Redistributions in binary form must reproduce the above copyright notice,
	        this list of conditions and the following disclaimer in the documentation
	        and/or other materials provided with the distribution.
	  
	      * The name Gregor Aisch may not be used to endorse or promote products
	        derived from this software without specific prior written permission.
	  
	      THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
	      AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
	      IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
	      DISCLAIMED. IN NO EVENT SHALL GREGOR AISCH OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	      INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
	      BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
	      DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
	      OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	      NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
	      EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	  
	      @source: https://github.com/gka/chroma.js
	   */
	
	  type = (function() {
	
	    /*
	    for browser-safe type checking+
	    ported from jQuery's $.type
	     */
	    var classToType, len, name, o, ref;
	    classToType = {};
	    ref = "Boolean Number String Function Array Date RegExp Undefined Null".split(" ");
	    for (o = 0, len = ref.length; o < len; o++) {
	      name = ref[o];
	      classToType["[object " + name + "]"] = name.toLowerCase();
	    }
	    return function(obj) {
	      var strType;
	      strType = Object.prototype.toString.call(obj);
	      return classToType[strType] || "object";
	    };
	  })();
	
	  limit = function(x, min, max) {
	    if (min == null) {
	      min = 0;
	    }
	    if (max == null) {
	      max = 1;
	    }
	    if (x < min) {
	      x = min;
	    }
	    if (x > max) {
	      x = max;
	    }
	    return x;
	  };
	
	  unpack = function(args) {
	    if (args.length >= 3) {
	      return args;
	    } else {
	      return args[0];
	    }
	  };
	
	  TWOPI = Math.PI * 2;
	
	  PITHIRD = Math.PI / 3;
	
	  round = Math.round, cos = Math.cos, floor = Math.floor, pow = Math.pow, log = Math.log, sin = Math.sin;
	
	
	  /*
	  interpolates between a set of colors uzing a bezier spline
	   */
	
	  bezier = function(colors) {
	    var I, I0, I1, c, lab0, lab1, lab2, lab3, ref, ref1, ref2;
	    colors = (function() {
	      var len, o, results;
	      results = [];
	      for (o = 0, len = colors.length; o < len; o++) {
	        c = colors[o];
	        results.push(chroma(c));
	      }
	      return results;
	    })();
	    if (colors.length === 2) {
	      ref = (function() {
	        var len, o, results;
	        results = [];
	        for (o = 0, len = colors.length; o < len; o++) {
	          c = colors[o];
	          results.push(c.lab());
	        }
	        return results;
	      })(), lab0 = ref[0], lab1 = ref[1];
	      I = function(t) {
	        var i, lab;
	        lab = (function() {
	          var o, results;
	          results = [];
	          for (i = o = 0; o <= 2; i = ++o) {
	            results.push(lab0[i] + t * (lab1[i] - lab0[i]));
	          }
	          return results;
	        })();
	        return chroma.lab.apply(chroma, lab);
	      };
	    } else if (colors.length === 3) {
	      ref1 = (function() {
	        var len, o, results;
	        results = [];
	        for (o = 0, len = colors.length; o < len; o++) {
	          c = colors[o];
	          results.push(c.lab());
	        }
	        return results;
	      })(), lab0 = ref1[0], lab1 = ref1[1], lab2 = ref1[2];
	      I = function(t) {
	        var i, lab;
	        lab = (function() {
	          var o, results;
	          results = [];
	          for (i = o = 0; o <= 2; i = ++o) {
	            results.push((1 - t) * (1 - t) * lab0[i] + 2 * (1 - t) * t * lab1[i] + t * t * lab2[i]);
	          }
	          return results;
	        })();
	        return chroma.lab.apply(chroma, lab);
	      };
	    } else if (colors.length === 4) {
	      ref2 = (function() {
	        var len, o, results;
	        results = [];
	        for (o = 0, len = colors.length; o < len; o++) {
	          c = colors[o];
	          results.push(c.lab());
	        }
	        return results;
	      })(), lab0 = ref2[0], lab1 = ref2[1], lab2 = ref2[2], lab3 = ref2[3];
	      I = function(t) {
	        var i, lab;
	        lab = (function() {
	          var o, results;
	          results = [];
	          for (i = o = 0; o <= 2; i = ++o) {
	            results.push((1 - t) * (1 - t) * (1 - t) * lab0[i] + 3 * (1 - t) * (1 - t) * t * lab1[i] + 3 * (1 - t) * t * t * lab2[i] + t * t * t * lab3[i]);
	          }
	          return results;
	        })();
	        return chroma.lab.apply(chroma, lab);
	      };
	    } else if (colors.length === 5) {
	      I0 = bezier(colors.slice(0, 3));
	      I1 = bezier(colors.slice(2, 5));
	      I = function(t) {
	        if (t < 0.5) {
	          return I0(t * 2);
	        } else {
	          return I1((t - 0.5) * 2);
	        }
	      };
	    }
	    return I;
	  };
	
	  chroma.interpolate.bezier = bezier;
	
	
	  /*
	  interpolates between a set of colors uzing a bezier spline
	  
	  blend mode formulas taken from:
	  http://www.venture-ware.com/kevin/coding/lets-learn-math-photoshop-blend-modes/
	   */
	
	  blend = function(bottom, top, mode) {
	    if (!blend[mode]) {
	      throw 'unknown blend mode ' + mode;
	    }
	    return blend[mode](bottom, top);
	  };
	
	  blend_f = function(f) {
	    return function(bottom, top) {
	      var c0, c1;
	      c0 = chroma(top).rgb();
	      c1 = chroma(bottom).rgb();
	      return chroma(f(c0, c1), 'rgb');
	    };
	  };
	
	  each = function(f) {
	    return function(c0, c1) {
	      var i, o, out;
	      out = [];
	      for (i = o = 0; o <= 3; i = ++o) {
	        out[i] = f(c0[i], c1[i]);
	      }
	      return out;
	    };
	  };
	
	  normal = function(a, b) {
	    return a;
	  };
	
	  multiply = function(a, b) {
	    return a * b / 255;
	  };
	
	  darken = function(a, b) {
	    if (a > b) {
	      return b;
	    } else {
	      return a;
	    }
	  };
	
	  lighten = function(a, b) {
	    if (a > b) {
	      return a;
	    } else {
	      return b;
	    }
	  };
	
	  screen = function(a, b) {
	    return 255 * (1 - (1 - a / 255) * (1 - b / 255));
	  };
	
	  overlay = function(a, b) {
	    if (b < 128) {
	      return 2 * a * b / 255;
	    } else {
	      return 255 * (1 - 2 * (1 - a / 255) * (1 - b / 255));
	    }
	  };
	
	  burn = function(a, b) {
	    return 255 * (1 - (1 - b / 255) / (a / 255));
	  };
	
	  dodge = function(a, b) {
	    if (a === 255) {
	      return 255;
	    }
	    a = 255 * (b / 255) / (1 - a / 255);
	    if (a > 255) {
	      return 255;
	    } else {
	      return a;
	    }
	  };
	
	  blend.normal = blend_f(each(normal));
	
	  blend.multiply = blend_f(each(multiply));
	
	  blend.screen = blend_f(each(screen));
	
	  blend.overlay = blend_f(each(overlay));
	
	  blend.darken = blend_f(each(darken));
	
	  blend.lighten = blend_f(each(lighten));
	
	  blend.dodge = blend_f(each(dodge));
	
	  blend.burn = blend_f(each(burn));
	
	  chroma.blend = blend;
	
	
	  /*
	      chroma.js
	  
	      Copyright (c) 2011-2013, Gregor Aisch
	      All rights reserved.
	  
	      Redistribution and use in source and binary forms, with or without
	      modification, are permitted provided that the following conditions are met:
	  
	      * Redistributions of source code must retain the above copyright notice, this
	        list of conditions and the following disclaimer.
	  
	      * Redistributions in binary form must reproduce the above copyright notice,
	        this list of conditions and the following disclaimer in the documentation
	        and/or other materials provided with the distribution.
	  
	      * The name Gregor Aisch may not be used to endorse or promote products
	        derived from this software without specific prior written permission.
	  
	      THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
	      AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
	      IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
	      DISCLAIMED. IN NO EVENT SHALL GREGOR AISCH OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	      INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
	      BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
	      DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
	      OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	      NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
	      EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	  
	      @source: https://github.com/gka/chroma.js
	   */
	
	  chroma.cubehelix = function(start, rotations, hue, gamma, lightness) {
	    var dh, dl;
	    if (start == null) {
	      start = 300;
	    }
	    if (rotations == null) {
	      rotations = -1.5;
	    }
	    if (hue == null) {
	      hue = 1;
	    }
	    if (gamma == null) {
	      gamma = 1;
	    }
	    if (lightness == null) {
	      lightness = [0, 1];
	    }
	    dl = lightness[1] - lightness[0];
	    if (type(hue) === 'array') {
	      dh = hue[1] - hue[0];
	      if (dh === 0) {
	        hue = hue[1];
	      }
	    } else {
	      dh = 0;
	    }
	    return function(fract) {
	      var a, amp, b, cos_a, g, h, l, r, sin_a;
	      a = TWOPI * ((start + 120) / 360 + rotations * fract);
	      l = pow(lightness[0] + dl * fract, gamma);
	      h = dh !== 0 ? hue[0] + fract * dh : hue;
	      amp = h * l * (1 - l) / 2;
	      cos_a = cos(a);
	      sin_a = sin(a);
	      r = l + amp * (-0.14861 * cos_a + 1.78277 * sin_a);
	      g = l + amp * (-0.29227 * cos_a - 0.90649 * sin_a);
	      b = l + amp * (+1.97294 * cos_a);
	      return chroma(clip_rgb([r * 255, g * 255, b * 255]));
	    };
	  };
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(284)(module)))

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.3
	var chroma, color, contrastSearch, counter, targetColor;
	
	chroma = __webpack_require__(424);
	
	counter = 0;
	
	module.exports = contrastSearch = function(targetColor, compareColor, start, end, direction, contrast) {
	  var b, color, curContrast, middle;
	  if (compareColor == null) {
	    compareColor = targetColor;
	  }
	  if (start == null) {
	    start = 0;
	  }
	  if (end == null) {
	    end = 1;
	  }
	  if (direction == null) {
	    direction = "end";
	  }
	  if (contrast == null) {
	    contrast = 5;
	  }
	  counter += 1;
	  middle = (start + end) / 2;
	  b = chroma(targetColor, 'lab');
	  color = b.luminance(middle).lab();
	  curContrast = chroma.contrast(chroma(compareColor).css(), b.css());
	  if (counter > 15) {
	    counter = 0;
	    return color;
	  }
	  if ((contrast - 0.1) < curContrast && curContrast < (contrast + 0.1)) {
	    counter = 0;
	    return color;
	  }
	  if (curContrast > contrast) {
	    if (direction === "end") {
	      return contrastSearch(targetColor, compareColor, start, middle - 0.001, direction, contrast);
	    } else {
	      return contrastSearch(targetColor, compareColor, middle + 0.001, end, direction, contrast);
	    }
	  } else if (curContrast < contrast) {
	    if (direction === "start") {
	      return contrastSearch(targetColor, compareColor, start, middle - 0.001, direction, contrast);
	    } else {
	      return contrastSearch(targetColor, compareColor, middle + 0.001, end, direction, contrast);
	    }
	  }
	};
	
	color = 'rgb(8, 27, 44)';
	
	targetColor = 'rgb(124, 171, 217)';
	
	color = 'red';
	
	targetColor = 'red';


/***/ }),
/* 426 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function isObject(x) {
		return typeof x === "object" && x !== null;
	};


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typography = __webpack_require__(428);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _typographyPluginCode = __webpack_require__(470);
	
	var _typographyPluginCode2 = _interopRequireDefault(_typographyPluginCode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var options = {
	  //baseFontSize: '16px',
	  //baseLineHeight: 1.5,
	  bodyFontFamily: ['Lucida Sans Unicode', 'Lucida Bright', 'Lucida Grande', 'sans-serif', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue'],
	  //bodyWeight: 400,
	  //headerWeight: 700,
	  //boldWeight: 700,
	  //scale: 1.618,
	  plugins: [new _typographyPluginCode2.default()]
	};
	
	var typography = new _typography2.default(options);
	
	// Hot reload typography in development.
	if (false) {}
	
	exports.default = typography;
	module.exports = exports['default'];

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _objectAssign = __webpack_require__(4);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _compassVerticalRhythm = __webpack_require__(429);
	
	var _compassVerticalRhythm2 = _interopRequireDefault(_compassVerticalRhythm);
	
	var _modularscale = __webpack_require__(432);
	
	var _modularscale2 = _interopRequireDefault(_modularscale);
	
	var _createStyles = __webpack_require__(434);
	
	var _createStyles2 = _interopRequireDefault(_createStyles);
	
	var _compileStyles = __webpack_require__(467);
	
	var _compileStyles2 = _interopRequireDefault(_compileStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var typography = function typography(opts) {
	  var defaults = {
	    baseFontSize: '16px',
	    baseLineHeight: 1.5,
	    scaleRatio: 2,
	    googleFonts: [],
	    headerFontFamily: ['-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', 'sans-serif'],
	    bodyFontFamily: ['georgia', 'serif'],
	    headerGray: 20,
	    headerGrayHue: 0,
	    bodyGray: 20,
	    bodyGrayHue: 0,
	    headerWeight: 'bold',
	    bodyWeight: 'normal',
	    boldWeight: 'bold',
	    includeNormalize: true,
	    blockMarginBottom: 1
	  };
	
	  var options = (0, _objectAssign2.default)({}, defaults, opts);
	
	  var vr = (0, _compassVerticalRhythm2.default)(options);
	
	  // Add this function to the vertical rhythm object so it'll be passed around
	  // as well and be available. Not related really but this is the easiest
	  // way to pass around extra utility functions atm... :-\
	  vr.scale = function (value) {
	    // This doesn't pick the right scale ratio if a theme has more than one ratio.
	    // Perhaps add optional parameter for a width and it'll get the ratio
	    // for this width. Tricky part is maxWidth could be set in non-pixels.
	    var baseFont = options.baseFontSize.slice(0, -2);
	    var newFontSize = (0, _modularscale2.default)(value, options.scaleRatio) * baseFont + 'px';
	    return vr.adjustFontSizeTo(newFontSize);
	  };
	
	  return _extends({
	    options: options
	  }, vr, {
	    createStyles: function createStyles() {
	      return this.toString();
	    },
	    // TODO remove in next breaking release.
	    toJSON: function toJSON() {
	      return (0, _createStyles2.default)(vr, options);
	    },
	    toString: function toString() {
	      return (0, _compileStyles2.default)(vr, options, this.toJSON());
	    },
	    injectStyles: function injectStyles() {
	      if (typeof document !== 'undefined') {
	        // Replace existing
	        if (document.getElementById('typography.js')) {
	          var styleNode = document.getElementById('typography.js');
	          styleNode.innerHTML = this.toString();
	        } else {
	          var node = document.createElement('style');
	          node.id = 'typography.js';
	          node.innerHTML = this.toString();
	          document.head.appendChild(node);
	        }
	      }
	    }
	  });
	};
	
	module.exports = typography;
	
	/*
	const test = typography({
	  baseFontSize: '16px',
	  includeNormalize: false,
	})
	
	console.log(test.toJSON())
	console.log(test.toString())
	*/

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	var e=__webpack_require__(430),n=__webpack_require__(431),t=function(e){return n(e)[1]},i=function(e){return n(e)[0]},r={baseFontSize:"16px",baseLineHeight:1.5,rhythmUnit:"rem",defaultRhythmBorderWidth:"1px",defaultRhythmBorderStyle:"solid",roundToNearestHalfLine:!0,minLinePadding:"2px"},a=function(n,t){var r,a=e(t.baseFontSize),o=i(a(n,"px")),s=i(t.baseLineHeightInPx),u=i(a(t.minLinePadding,"px"));return(r=t.roundToNearestHalfLine?Math.ceil(2*o/s)/2:Math.ceil(o/s))*s-o<2*u&&(r+=t.roundToNearestHalfLine?.5:1),r},o=function(n){var r=e(n.baseFontSize);return function(e,a,o){null==e&&(e=1),null==a&&(a=n.baseFontSize),null==o&&(o=0);var s=e*i(n.baseLineHeightInPx)-o+"px",u=r(s,n.rhythmUnit,a);return"px"===t(u)&&(u=Math.floor(i(u))+t(u)),parseFloat(i(u).toFixed(5))+t(u)}};module.exports=function(n){var s=JSON.parse(JSON.stringify(r)),u=Object.assign({},s,n),h=e(u.baseFontSize);if(t(u.baseLineHeight)){i(h(u.baseFontSize,"px"));u.baseLineHeightInPx=h(u.baseLineHeight,"px")}else u.baseLineHeightInPx=i(u.baseFontSize)*u.baseLineHeight+"px";return{rhythm:o(u),establishBaseline:function(){return function(n){e(n.baseFontSize);return{fontSize:i(n.baseFontSize)/16*100+"%",lineHeight:n.baseLineHeight.toString()}}(u)},linesForFontSize:function(e){return a(e,u)},adjustFontSizeTo:function(n,r,s){return null==r&&(r="auto"),function(n,r,s,u){null==s&&(s=u.baseFontSize),"%"===t(n)&&(n=i(u.baseFontSize)*(i(n)/100)+"px");var h=e(u.baseFontSize);n=h(n,"px",s=h(s,"px"));var l=o(u);return"auto"===r&&(r=a(n,u)),{fontSize:h(n,u.rhythmUnit,s),lineHeight:l(r,s)}}(n,r,s,u)}}};
	//# sourceMappingURL=index.js.map


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	var e=__webpack_require__(431),r=function(r){return e(r)[0]};module.exports=function(n){return null==n&&(n=n),function(u,i,t,f){null==t&&(t=n),null==f&&(f=t);var l=function(r){return e(r)[1]}(u);if(l===i)return u;var o=r(u);if("px"!==l)if("em"===l)o=r(u)*r(t);else if("rem"===l)o=r(u)*r(n);else{if("ex"!==l)return u;o=r(u)*r(t)*2}var a=o;if("px"!==i)if("em"===i)a=o/r(f);else if("rem"===i)a=o/r(n);else{if("ex"!==i)return u;a=o/r(f)/2}return parseFloat(a.toFixed(5))+i}};
	//# sourceMappingURL=index.js.map


/***/ }),
/* 431 */
/***/ (function(module, exports) {

	module.exports = function parseUnit(str, out) {
	    if (!out)
	        out = [ 0, '' ]
	
	    str = String(str)
	    var num = parseFloat(str, 10)
	    out[0] = num
	    out[1] = str.match(/[\d.\-\+]*\s*(.*)/)[1] || ''
	    return out
	}

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.1
	var isNumber, ratios;
	
	isNumber = __webpack_require__(433);
	
	ratios = {
	  "minor second": 16 / 15,
	  "major second": 9 / 8,
	  "minor third": 6 / 5,
	  "major third": 4 / 3,
	  "diminished fourth": Math.sqrt(2),
	  "perfect fifth": 3 / 2,
	  "minor sixth": 8 / 5,
	  "golden": 1.61803398875,
	  "phi": 1.61803398875,
	  "major sixth": 5 / 3,
	  "minor seventh": 16 / 9,
	  "major seventh": 15 / 8,
	  "octave": 2,
	  "major tenth": 5 / 2,
	  "major eleventh": 8 / 3,
	  "major twelfth": 3,
	  "double octave": 4
	};
	
	module.exports = function(value, ratio) {
	  var r;
	  if (value == null) {
	    value = 0;
	  }
	  if (ratio == null) {
	    ratio = "golden";
	  }
	  if (isNumber(ratio)) {
	    r = ratio;
	  } else if (ratios[ratio] != null) {
	    r = ratios[ratio];
	  } else {
	    r = ratios['golden'];
	  }
	  return Math.pow(r, value);
	};


/***/ }),
/* 433 */
/***/ (function(module, exports) {

	/**
	 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var numberTag = '[object Number]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Number` primitive or object.
	 *
	 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
	 * as numbers, use the `_.isFinite` method.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isNumber(3);
	 * // => true
	 *
	 * _.isNumber(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isNumber(Infinity);
	 * // => true
	 *
	 * _.isNumber('3');
	 * // => false
	 */
	function isNumber(value) {
	  return typeof value == 'number' ||
	    (isObjectLike(value) && objectToString.call(value) == numberTag);
	}
	
	module.exports = isNumber;


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _grayPercentage = __webpack_require__(435);
	
	var _grayPercentage2 = _interopRequireDefault(_grayPercentage);
	
	var _set = __webpack_require__(436);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _forEach = __webpack_require__(440);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _isNumber = __webpack_require__(443);
	
	var _isNumber2 = _interopRequireDefault(_isNumber);
	
	var _isString = __webpack_require__(405);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _isFunction = __webpack_require__(297);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isArray = __webpack_require__(282);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _merge = __webpack_require__(444);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _reduce = __webpack_require__(464);
	
	var _reduce2 = _interopRequireDefault(_reduce);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var setStyles = function setStyles() {
	  var styles = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var els = arguments[1];
	  var rules = arguments[2];
	
	  var elements = void 0;
	  if (!(0, _isArray2.default)(els)) {
	    elements = [els];
	  } else {
	    elements = els;
	  }
	  (0, _forEach2.default)(elements, function (element) {
	    (0, _forEach2.default)(rules, function (value, prop) {
	      (0, _set2.default)(styles, element + '.' + prop, value);
	    });
	  });
	  return styles;
	};
	
	module.exports = function (vr, options) {
	  var styles = {};
	
	  // Base HTML styles.
	  styles = setStyles(styles, 'html', _extends({}, vr.establishBaseline(), {
	    boxSizing: 'border-box',
	    overflowY: 'scroll'
	  }));
	
	  // box-sizing reset.
	  styles = setStyles(styles, ['*', '*:before', '*:after'], {
	    boxSizing: 'inherit'
	  });
	
	  // Base body styles.
	  styles = setStyles(styles, 'body', {
	    color: (0, _grayPercentage2.default)(options.bodyGray, options.bodyGrayHue),
	    fontFamily: options.bodyFontFamily.join(','),
	    fontWeight: options.bodyWeight,
	    wordWrap: 'break-word'
	  });
	
	  // Make images responsive.
	  styles = setStyles(styles, 'img', {
	    maxWidth: '100%'
	  });
	
	  // All block elements get one rhythm of bottom margin by default
	  // or whatever is passed in as option.
	  var blockMarginBottom = void 0;
	  if ((0, _isNumber2.default)(options.blockMarginBottom)) {
	    blockMarginBottom = vr.rhythm(options.blockMarginBottom);
	  } else if ((0, _isString2.default)(options.blockMarginBottom)) {
	    blockMarginBottom = options.blockMarginBottom;
	  } else {
	    blockMarginBottom = vr.rhythm(1);
	  }
	  styles = setStyles(styles, ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hgroup', 'ul', 'ol', 'dl', 'dd', 'p', 'figure', 'pre', 'table', 'fieldset', 'blockquote', 'form', 'noscript', 'iframe', 'img', 'hr', 'address'], {
	
	    // Reset margin/padding to 0.
	    marginLeft: 0,
	    marginRight: 0,
	    marginTop: 0,
	    paddingBottom: 0,
	    paddingLeft: 0,
	    paddingRight: 0,
	    paddingTop: 0,
	    marginBottom: blockMarginBottom
	  });
	
	  // Basic blockquote styles.
	  styles = setStyles(styles, 'blockquote', {
	    marginRight: vr.rhythm(1),
	    marginBottom: blockMarginBottom,
	    marginLeft: vr.rhythm(1)
	  });
	
	  // b, strong.
	  styles = setStyles(styles, ['b', 'strong', 'dt', 'th'], {
	    fontWeight: options.boldWeight
	  });
	
	  // hr.
	  styles = setStyles(styles, 'hr', {
	    background: (0, _grayPercentage2.default)(80, options.bodyGrayHue),
	    border: 'none',
	    height: '1px',
	    marginBottom: 'calc(' + blockMarginBottom + ' - 1px)'
	  });
	
	  // ol, ul.
	  styles = setStyles(styles, ['ol', 'ul'], {
	    listStylePosition: 'outside',
	    listStyleImage: 'none',
	    marginLeft: vr.rhythm(1)
	  });
	
	  // li.
	  styles = setStyles(styles, 'li', {
	    marginBottom: 'calc(' + blockMarginBottom + ' / 2)'
	  });
	
	  // Remove default padding on list items.
	  styles = setStyles(styles, ['ol li', 'ul li'], {
	    paddingLeft: 0
	  });
	
	  // children ol, ul.
	  styles = setStyles(styles, ['li > ol', 'li > ul'], {
	    marginLeft: vr.rhythm(1),
	    marginBottom: 'calc(' + blockMarginBottom + ' / 2)',
	    marginTop: 'calc(' + blockMarginBottom + ' / 2)'
	  });
	
	  // Make generally smaller elements, smaller.
	  styles = setStyles(styles, ['code', 'kbd', 'pre', 'samp'], _extends({}, vr.adjustFontSizeTo('85%')));
	
	  // Abbr, Acronym.
	  styles = setStyles(styles, ['abbr', 'acronym'], {
	    borderBottom: '1px dotted ' + (0, _grayPercentage2.default)(50),
	    cursor: 'help'
	  });
	  styles['abbr[title]'] = {
	    borderBottom: '1px dotted ' + (0, _grayPercentage2.default)(50),
	    cursor: 'help',
	    textDecoration: 'none'
	  };
	
	  // Table styles.
	  styles = setStyles(styles, ['table'], _extends({}, vr.adjustFontSizeTo(options.baseFontSize), {
	    borderCollapse: 'collapse',
	    width: '100%'
	  }));
	  styles = setStyles(styles, ['thead'], {
	    textAlign: 'left'
	  });
	  styles = setStyles(styles, ['td,th'], {
	    textAlign: 'left',
	    borderBottom: '1px solid ' + (0, _grayPercentage2.default)(88),
	    fontFeatureSettings: 'tnum',
	    paddingLeft: vr.rhythm(2 / 3),
	    paddingRight: vr.rhythm(2 / 3),
	    paddingTop: vr.rhythm(1 / 2),
	    paddingBottom: 'calc(' + vr.rhythm(1 / 2) + ' - 1px)'
	  });
	  styles = setStyles(styles, 'th:first-child,td:first-child', {
	    paddingLeft: 0
	  });
	  styles = setStyles(styles, 'th:last-child,td:last-child', {
	    paddingRight: 0
	  });
	
	  // Create styles for headers.
	  styles = setStyles(styles, ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'], {
	    color: (0, _grayPercentage2.default)(options.headerGray, options.headerGrayHue),
	    fontFamily: options.headerFontFamily.join(','),
	    fontWeight: options.headerWeight,
	    textRendering: 'optimizeLegibility'
	  });
	
	  // Set header sizes.
	  var h1 = vr.scale(5 / 5);
	  var h2 = vr.scale(3 / 5);
	  var h3 = vr.scale(2 / 5);
	  var h4 = vr.scale(0 / 5);
	  var h5 = vr.scale(-1 / 5);
	  var h6 = vr.scale(-1.5 / 5);
	
	  (0, _forEach2.default)([h1, h2, h3, h4, h5, h6], function (header, i) {
	    styles = (0, _set2.default)(styles, 'h' + (i + 1) + '.fontSize', header.fontSize);
	    styles = (0, _set2.default)(styles, 'h' + (i + 1) + '.lineHeight', header.lineHeight);
	  });
	
	  // TODO add support for Breakpoints here.
	
	  // Call plugins if any.
	  if ((0, _isArray2.default)(options.plugins)) {
	    styles = (0, _reduce2.default)(options.plugins, function (stylesObj, plugin) {
	      return (0, _merge2.default)(stylesObj, plugin(vr, options, stylesObj));
	    }, styles);
	  }
	
	  // Call overrideStyles function on options (if set).
	  if ((0, _isFunction2.default)(options.overrideStyles)) {
	    styles = (0, _merge2.default)(styles, options.overrideStyles(vr, options, styles));
	  }
	
	  // Call overrideThemeStyles function on options (if set).
	  if ((0, _isFunction2.default)(options.overrideThemeStyles)) {
	    styles = (0, _merge2.default)(styles, options.overrideThemeStyles(vr, options, styles));
	  }
	
	  return styles;
	};

/***/ }),
/* 435 */
/***/ (function(module, exports) {

	function isNumeric(n) {
	  return !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	
	module.exports = function(lightness, hue, darkBackground) {
	  if (typeof hue === "undefined") {
	    hue = 0;
	  }
	  if (typeof darkBackground === "undefined") {
	    darkBackground = false;
	  }
	
	  // Convert named hues into numeric lightness value.
	  if (hue === "cool") {
	    hue = 237;
	  }
	  else if (hue === "slate") {
	    hue = 122;
	  }
	  else if (hue === "warm") {
	    hue = 69;
	  }
	
	  if (!isNumeric(hue)) {
	    throw new Error("Hue is not a number");
	  }
	
	  if (!isNumeric(lightness)) {
	    throw new Error("Lightness is not a number");
	  }
	
	  if (lightness > 100) {
	    lightness = 100;
	  }
	  if (lightness < 0) {
	    lightness = 0;
	  }
	
	  var saturation = 0;
	  if (hue !== 0) {
	    var a = 19.92978;
	    var b = -0.3651759;
	    var c = 0.001737214;
	    saturation = a + b * lightness + c * Math.pow(lightness, 2);
	  }
	
	  var opacity = 0
	  if (darkBackground) {
	    opacity = lightness / 100
	    lightness = '100%,'
	  } else {
	    opacity = (100 - lightness) / 100
	    lightness = '0%,'
	  }
	
	  return "hsla(" + hue + "," + saturation + "%," + lightness + opacity + ")";
	};


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSet = __webpack_require__(437);
	
	/**
	 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	 * it's created. Arrays are created for missing index properties while objects
	 * are created for all other missing properties. Use `_.setWith` to customize
	 * `path` creation.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.set(object, 'a[0].b.c', 4);
	 * console.log(object.a[0].b.c);
	 * // => 4
	 *
	 * _.set(object, ['x', '0', 'y', 'z'], 5);
	 * console.log(object.x[0].y.z);
	 * // => 5
	 */
	function set(object, path, value) {
	  return object == null ? object : baseSet(object, path, value);
	}
	
	module.exports = set;


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(438),
	    castPath = __webpack_require__(368),
	    isIndex = __webpack_require__(286),
	    isObject = __webpack_require__(298),
	    toKey = __webpack_require__(377);
	
	/**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */
	function baseSet(object, path, value, customizer) {
	  if (!isObject(object)) {
	    return object;
	  }
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      lastIndex = length - 1,
	      nested = object;
	
	  while (nested != null && ++index < length) {
	    var key = toKey(path[index]),
	        newValue = value;
	
	    if (index != lastIndex) {
	      var objValue = nested[key];
	      newValue = customizer ? customizer(objValue, key, nested) : undefined;
	      if (newValue === undefined) {
	        newValue = isObject(objValue)
	          ? objValue
	          : (isIndex(path[index + 1]) ? [] : {});
	      }
	    }
	    assignValue(nested, key, newValue);
	    nested = nested[key];
	  }
	  return object;
	}
	
	module.exports = baseSet;


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(439),
	    eq = __webpack_require__(308);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(400);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(441),
	    baseEach = __webpack_require__(266),
	    castFunction = __webpack_require__(442),
	    isArray = __webpack_require__(282);
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _.forEach([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, castFunction(iteratee));
	}
	
	module.exports = forEach;


/***/ }),
/* 441 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(381);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(275),
	    isObjectLike = __webpack_require__(281);
	
	/** `Object#toString` result references. */
	var numberTag = '[object Number]';
	
	/**
	 * Checks if `value` is classified as a `Number` primitive or object.
	 *
	 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	 * classified as numbers, use the `_.isFinite` method.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	 * @example
	 *
	 * _.isNumber(3);
	 * // => true
	 *
	 * _.isNumber(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isNumber(Infinity);
	 * // => true
	 *
	 * _.isNumber('3');
	 * // => false
	 */
	function isNumber(value) {
	  return typeof value == 'number' ||
	    (isObjectLike(value) && baseGetTag(value) == numberTag);
	}
	
	module.exports = isNumber;


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(445),
	    createAssigner = __webpack_require__(463);
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(303),
	    assignMergeValue = __webpack_require__(446),
	    baseFor = __webpack_require__(268),
	    baseMergeDeep = __webpack_require__(447),
	    isObject = __webpack_require__(298),
	    keysIn = __webpack_require__(460),
	    safeGet = __webpack_require__(457);
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    stack || (stack = new Stack);
	    if (isObject(srcValue)) {
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	module.exports = baseMerge;


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(439),
	    eq = __webpack_require__(308);
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignMergeValue;


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	var assignMergeValue = __webpack_require__(446),
	    cloneBuffer = __webpack_require__(448),
	    cloneTypedArray = __webpack_require__(449),
	    copyArray = __webpack_require__(451),
	    initCloneObject = __webpack_require__(452),
	    isArguments = __webpack_require__(273),
	    isArray = __webpack_require__(282),
	    isArrayLikeObject = __webpack_require__(455),
	    isBuffer = __webpack_require__(283),
	    isFunction = __webpack_require__(297),
	    isObject = __webpack_require__(298),
	    isPlainObject = __webpack_require__(456),
	    isTypedArray = __webpack_require__(287),
	    safeGet = __webpack_require__(457),
	    toPlainObject = __webpack_require__(458);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = safeGet(object, key),
	      srcValue = safeGet(source, key),
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || isFunction(objValue)) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	module.exports = baseMergeDeep;


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(277);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(284)(module)))

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(450);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(348);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ }),
/* 451 */
/***/ (function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(453),
	    getPrototype = __webpack_require__(454),
	    isPrototype = __webpack_require__(293);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(298);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(295);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(296),
	    isObjectLike = __webpack_require__(281);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(275),
	    getPrototype = __webpack_require__(454),
	    isObjectLike = __webpack_require__(281);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 457 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function safeGet(object, key) {
	  if (key === 'constructor' && typeof object[key] === 'function') {
	    return;
	  }
	
	  if (key == '__proto__') {
	    return;
	  }
	
	  return object[key];
	}
	
	module.exports = safeGet;


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(459),
	    keysIn = __webpack_require__(460);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(438),
	    baseAssignValue = __webpack_require__(439);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(271),
	    baseKeysIn = __webpack_require__(461),
	    isArrayLike = __webpack_require__(296);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(298),
	    isPrototype = __webpack_require__(293),
	    nativeKeysIn = __webpack_require__(462);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ }),
/* 462 */
/***/ (function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(394),
	    isIterateeCall = __webpack_require__(402);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(465),
	    baseEach = __webpack_require__(266),
	    baseIteratee = __webpack_require__(300),
	    baseReduce = __webpack_require__(466),
	    isArray = __webpack_require__(282);
	
	/**
	 * Reduces `collection` to a value which is the accumulated result of running
	 * each element in `collection` thru `iteratee`, where each successive
	 * invocation is supplied the return value of the previous. If `accumulator`
	 * is not given, the first element of `collection` is used as the initial
	 * value. The iteratee is invoked with four arguments:
	 * (accumulator, value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.reduce`, `_.reduceRight`, and `_.transform`.
	 *
	 * The guarded methods are:
	 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	 * and `sortBy`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @returns {*} Returns the accumulated value.
	 * @see _.reduceRight
	 * @example
	 *
	 * _.reduce([1, 2], function(sum, n) {
	 *   return sum + n;
	 * }, 0);
	 * // => 3
	 *
	 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	 *   (result[value] || (result[value] = [])).push(key);
	 *   return result;
	 * }, {});
	 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	 */
	function reduce(collection, iteratee, accumulator) {
	  var func = isArray(collection) ? arrayReduce : baseReduce,
	      initAccum = arguments.length < 3;
	
	  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	}
	
	module.exports = reduce;


/***/ }),
/* 465 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ }),
/* 466 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.reduce` and `_.reduceRight`, without support
	 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} accumulator The initial value.
	 * @param {boolean} initAccum Specify using the first or last element of
	 *  `collection` as the initial value.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @returns {*} Returns the accumulated value.
	 */
	function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	  eachFunc(collection, function(value, index, collection) {
	    accumulator = initAccum
	      ? (initAccum = false, value)
	      : iteratee(accumulator, value, index, collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseReduce;


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typographyNormalize = __webpack_require__(468);
	
	var _typographyNormalize2 = _interopRequireDefault(_typographyNormalize);
	
	var _decamelize = __webpack_require__(469);
	
	var _decamelize2 = _interopRequireDefault(_decamelize);
	
	var _forEach = __webpack_require__(440);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _reduce = __webpack_require__(464);
	
	var _reduce2 = _interopRequireDefault(_reduce);
	
	var _isObject = __webpack_require__(298);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var compileStyles = function compileStyles(styles) {
	  return (0, _reduce2.default)(styles, function (stylesStr, ruleSet, selector) {
	    stylesStr += selector + '{'; // eslint-disable-line
	    (0, _forEach2.default)(ruleSet, function (value, property) {
	      if ((0, _isObject2.default)(value)) {
	        var newObject = {};
	        newObject[property] = value;
	        stylesStr += compileStyles(newObject); // eslint-disable-line
	      } else {
	        stylesStr += (0, _decamelize2.default)(property, '-') + ':' + value + ';'; // eslint-disable-line
	      }
	    });
	    stylesStr += '}'; // eslint-disable-line
	    return stylesStr;
	  }, '');
	};
	
	
	module.exports = function (vr, options, styles) {
	  // Compile styles to string.
	  var stylesStr = compileStyles(styles);
	
	  if (options.includeNormalize) {
	    stylesStr = '' + _typographyNormalize2.default + stylesStr;
	  }
	
	  return stylesStr;
	};

/***/ }),
/* 468 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint-disable */
	/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css */
	exports.default = 'html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block}audio:not([controls]){display:none;height:0}progress{vertical-align:baseline}[hidden],template{display:none}a{background-color:transparent;-webkit-text-decoration-skip:objects}a:active,a:hover{outline-width:0}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:inherit;font-weight:bolder}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background-color:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}svg:not(:root){overflow:hidden}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}figure{margin:1em 40px}hr{box-sizing:content-box;height:0;overflow:visible}button,input,optgroup,select,textarea{font:inherit;margin:0}optgroup{font-weight:700}button,input{overflow:visible}button,select{text-transform:none}[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-input-placeholder{color:inherit;opacity:.54}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}';

/***/ }),
/* 469 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (str, sep) {
		if (typeof str !== 'string') {
			throw new TypeError('Expected a string');
		}
	
		sep = typeof sep === 'undefined' ? '_' : sep;
	
		return str
			.replace(/([a-z\d])([A-Z])/g, '$1' + sep + '$2')
			.replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1' + sep + '$2')
			.toLowerCase();
	};


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _grayPercentage = __webpack_require__(435);
	
	var _grayPercentage2 = _interopRequireDefault(_grayPercentage);
	
	var _isNumber = __webpack_require__(443);
	
	var _isNumber2 = _interopRequireDefault(_isNumber);
	
	var _isString = __webpack_require__(405);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CodePlugin = function CodePlugin() {
	  return function (_ref, options) {
	    var adjustFontSizeTo = _ref.adjustFontSizeTo;
	    var rhythm = _ref.rhythm;
	
	    var blockMarginBottom = void 0;
	    if ((0, _isNumber2.default)(options.blockMarginBottom)) {
	      blockMarginBottom = rhythm(options.blockMarginBottom);
	    } else if ((0, _isString2.default)(options.blockMarginBottom)) {
	      blockMarginBottom = options.blockMarginBottom;
	    } else {
	      blockMarginBottom = rhythm(1);
	    }
	    return {
	      'tt,code': {
	        backgroundColor: (0, _grayPercentage2.default)(96),
	        borderRadius: '3px',
	        fontFamily: 'Consolas,"Roboto Mono","Liberation Mono",Menlo,Courier,monospace',
	        padding: 0,
	        paddingTop: '0.2em',
	        paddingBottom: '0.2em'
	      },
	      pre: {
	        background: (0, _grayPercentage2.default)(96),
	        borderRadius: '3px',
	        lineHeight: 1.42,
	        overflow: 'auto',
	        padding: blockMarginBottom
	      },
	      'pre code': {
	        background: 'none',
	        lineHeight: 1.42
	      },
	      // Add space before and after code/tt elements.
	      'code:before,code:after,tt:before,tt:after': {
	        letterSpacing: '-0.2em',
	        content: '" "'
	      },
	      // But don't add spaces if the code is inside a pre.
	      'pre code:before,pre code:after,pre tt:before,pre tt:after': {
	        content: '""'
	      }
	    };
	  };
	};
	
	exports.default = CodePlugin;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Confirm = __webpack_require__(472);
	
	Object.defineProperty(exports, 'Confirm', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Confirm).default;
	  }
	});
	
	var _Portal = __webpack_require__(729);
	
	Object.defineProperty(exports, 'Portal', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Portal).default;
	  }
	});
	
	var _Radio = __webpack_require__(751);
	
	Object.defineProperty(exports, 'Radio', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Radio).default;
	  }
	});
	
	var _Select = __webpack_require__(755);
	
	Object.defineProperty(exports, 'Select', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Select).default;
	  }
	});
	
	var _TextArea = __webpack_require__(783);
	
	Object.defineProperty(exports, 'TextArea', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TextArea).default;
	  }
	});
	
	var _Breadcrumb = __webpack_require__(785);
	
	Object.defineProperty(exports, 'Breadcrumb', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Breadcrumb).default;
	  }
	});
	
	var _BreadcrumbDivider = __webpack_require__(787);
	
	Object.defineProperty(exports, 'BreadcrumbDivider', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BreadcrumbDivider).default;
	  }
	});
	
	var _BreadcrumbSection = __webpack_require__(788);
	
	Object.defineProperty(exports, 'BreadcrumbSection', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BreadcrumbSection).default;
	  }
	});
	
	var _Form = __webpack_require__(789);
	
	Object.defineProperty(exports, 'Form', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Form).default;
	  }
	});
	
	var _FormButton = __webpack_require__(792);
	
	Object.defineProperty(exports, 'FormButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormButton).default;
	  }
	});
	
	var _FormCheckbox = __webpack_require__(794);
	
	Object.defineProperty(exports, 'FormCheckbox', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormCheckbox).default;
	  }
	});
	
	var _FormDropdown = __webpack_require__(795);
	
	Object.defineProperty(exports, 'FormDropdown', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormDropdown).default;
	  }
	});
	
	var _FormField = __webpack_require__(793);
	
	Object.defineProperty(exports, 'FormField', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormField).default;
	  }
	});
	
	var _FormGroup = __webpack_require__(796);
	
	Object.defineProperty(exports, 'FormGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormGroup).default;
	  }
	});
	
	var _FormInput = __webpack_require__(797);
	
	Object.defineProperty(exports, 'FormInput', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormInput).default;
	  }
	});
	
	var _FormRadio = __webpack_require__(800);
	
	Object.defineProperty(exports, 'FormRadio', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormRadio).default;
	  }
	});
	
	var _FormSelect = __webpack_require__(801);
	
	Object.defineProperty(exports, 'FormSelect', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormSelect).default;
	  }
	});
	
	var _FormTextArea = __webpack_require__(802);
	
	Object.defineProperty(exports, 'FormTextArea', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormTextArea).default;
	  }
	});
	
	var _Grid = __webpack_require__(803);
	
	Object.defineProperty(exports, 'Grid', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Grid).default;
	  }
	});
	
	var _GridColumn = __webpack_require__(805);
	
	Object.defineProperty(exports, 'GridColumn', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GridColumn).default;
	  }
	});
	
	var _GridRow = __webpack_require__(806);
	
	Object.defineProperty(exports, 'GridRow', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GridRow).default;
	  }
	});
	
	var _Menu = __webpack_require__(807);
	
	Object.defineProperty(exports, 'Menu', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Menu).default;
	  }
	});
	
	var _MenuHeader = __webpack_require__(809);
	
	Object.defineProperty(exports, 'MenuHeader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MenuHeader).default;
	  }
	});
	
	var _MenuItem = __webpack_require__(810);
	
	Object.defineProperty(exports, 'MenuItem', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MenuItem).default;
	  }
	});
	
	var _MenuMenu = __webpack_require__(827);
	
	Object.defineProperty(exports, 'MenuMenu', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MenuMenu).default;
	  }
	});
	
	var _Message = __webpack_require__(828);
	
	Object.defineProperty(exports, 'Message', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Message).default;
	  }
	});
	
	var _MessageContent = __webpack_require__(830);
	
	Object.defineProperty(exports, 'MessageContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MessageContent).default;
	  }
	});
	
	var _MessageHeader = __webpack_require__(831);
	
	Object.defineProperty(exports, 'MessageHeader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MessageHeader).default;
	  }
	});
	
	var _MessageItem = __webpack_require__(833);
	
	Object.defineProperty(exports, 'MessageItem', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MessageItem).default;
	  }
	});
	
	var _MessageList = __webpack_require__(832);
	
	Object.defineProperty(exports, 'MessageList', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MessageList).default;
	  }
	});
	
	var _Table = __webpack_require__(834);
	
	Object.defineProperty(exports, 'Table', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Table).default;
	  }
	});
	
	var _TableBody = __webpack_require__(836);
	
	Object.defineProperty(exports, 'TableBody', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TableBody).default;
	  }
	});
	
	var _TableCell = __webpack_require__(837);
	
	Object.defineProperty(exports, 'TableCell', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TableCell).default;
	  }
	});
	
	var _TableFooter = __webpack_require__(838);
	
	Object.defineProperty(exports, 'TableFooter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TableFooter).default;
	  }
	});
	
	var _TableHeader = __webpack_require__(839);
	
	Object.defineProperty(exports, 'TableHeader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TableHeader).default;
	  }
	});
	
	var _TableHeaderCell = __webpack_require__(840);
	
	Object.defineProperty(exports, 'TableHeaderCell', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TableHeaderCell).default;
	  }
	});
	
	var _TableRow = __webpack_require__(841);
	
	Object.defineProperty(exports, 'TableRow', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TableRow).default;
	  }
	});
	
	var _Button = __webpack_require__(721);
	
	Object.defineProperty(exports, 'Button', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Button).default;
	  }
	});
	
	var _ButtonContent = __webpack_require__(738);
	
	Object.defineProperty(exports, 'ButtonContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ButtonContent).default;
	  }
	});
	
	var _ButtonGroup = __webpack_require__(739);
	
	Object.defineProperty(exports, 'ButtonGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ButtonGroup).default;
	  }
	});
	
	var _ButtonOr = __webpack_require__(740);
	
	Object.defineProperty(exports, 'ButtonOr', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ButtonOr).default;
	  }
	});
	
	var _Container = __webpack_require__(842);
	
	Object.defineProperty(exports, 'Container', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Container).default;
	  }
	});
	
	var _Divider = __webpack_require__(844);
	
	Object.defineProperty(exports, 'Divider', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Divider).default;
	  }
	});
	
	var _Flag = __webpack_require__(778);
	
	Object.defineProperty(exports, 'Flag', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Flag).default;
	  }
	});
	
	var _Header = __webpack_require__(846);
	
	Object.defineProperty(exports, 'Header', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Header).default;
	  }
	});
	
	var _HeaderContent = __webpack_require__(849);
	
	Object.defineProperty(exports, 'HeaderContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HeaderContent).default;
	  }
	});
	
	var _HeaderSubheader = __webpack_require__(848);
	
	Object.defineProperty(exports, 'HeaderSubheader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HeaderSubheader).default;
	  }
	});
	
	var _Icon = __webpack_require__(750);
	
	Object.defineProperty(exports, 'Icon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Icon).default;
	  }
	});
	
	var _IconGroup = __webpack_require__(724);
	
	Object.defineProperty(exports, 'IconGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_IconGroup).default;
	  }
	});
	
	var _Image = __webpack_require__(780);
	
	Object.defineProperty(exports, 'Image', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Image).default;
	  }
	});
	
	var _ImageGroup = __webpack_require__(735);
	
	Object.defineProperty(exports, 'ImageGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ImageGroup).default;
	  }
	});
	
	var _Input = __webpack_require__(798);
	
	Object.defineProperty(exports, 'Input', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Input).default;
	  }
	});
	
	var _Label = __webpack_require__(775);
	
	Object.defineProperty(exports, 'Label', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Label).default;
	  }
	});
	
	var _LabelDetail = __webpack_require__(736);
	
	Object.defineProperty(exports, 'LabelDetail', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LabelDetail).default;
	  }
	});
	
	var _LabelGroup = __webpack_require__(737);
	
	Object.defineProperty(exports, 'LabelGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LabelGroup).default;
	  }
	});
	
	var _List = __webpack_require__(850);
	
	Object.defineProperty(exports, 'List', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_List).default;
	  }
	});
	
	var _ListContent = __webpack_require__(852);
	
	Object.defineProperty(exports, 'ListContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListContent).default;
	  }
	});
	
	var _ListDescription = __webpack_require__(853);
	
	Object.defineProperty(exports, 'ListDescription', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListDescription).default;
	  }
	});
	
	var _ListHeader = __webpack_require__(854);
	
	Object.defineProperty(exports, 'ListHeader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListHeader).default;
	  }
	});
	
	var _ListIcon = __webpack_require__(855);
	
	Object.defineProperty(exports, 'ListIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListIcon).default;
	  }
	});
	
	var _ListItem = __webpack_require__(856);
	
	Object.defineProperty(exports, 'ListItem', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListItem).default;
	  }
	});
	
	var _ListList = __webpack_require__(857);
	
	Object.defineProperty(exports, 'ListList', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListList).default;
	  }
	});
	
	var _Loader = __webpack_require__(858);
	
	Object.defineProperty(exports, 'Loader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Loader).default;
	  }
	});
	
	var _Rail = __webpack_require__(860);
	
	Object.defineProperty(exports, 'Rail', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Rail).default;
	  }
	});
	
	var _Reveal = __webpack_require__(862);
	
	Object.defineProperty(exports, 'Reveal', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Reveal).default;
	  }
	});
	
	var _RevealContent = __webpack_require__(864);
	
	Object.defineProperty(exports, 'RevealContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RevealContent).default;
	  }
	});
	
	var _Segment = __webpack_require__(865);
	
	Object.defineProperty(exports, 'Segment', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Segment).default;
	  }
	});
	
	var _SegmentGroup = __webpack_require__(867);
	
	Object.defineProperty(exports, 'SegmentGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SegmentGroup).default;
	  }
	});
	
	var _Step = __webpack_require__(868);
	
	Object.defineProperty(exports, 'Step', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Step).default;
	  }
	});
	
	var _StepContent = __webpack_require__(870);
	
	Object.defineProperty(exports, 'StepContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StepContent).default;
	  }
	});
	
	var _StepDescription = __webpack_require__(871);
	
	Object.defineProperty(exports, 'StepDescription', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StepDescription).default;
	  }
	});
	
	var _StepGroup = __webpack_require__(873);
	
	Object.defineProperty(exports, 'StepGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StepGroup).default;
	  }
	});
	
	var _StepTitle = __webpack_require__(872);
	
	Object.defineProperty(exports, 'StepTitle', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StepTitle).default;
	  }
	});
	
	var _Accordion = __webpack_require__(874);
	
	Object.defineProperty(exports, 'Accordion', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Accordion).default;
	  }
	});
	
	var _AccordionContent = __webpack_require__(875);
	
	Object.defineProperty(exports, 'AccordionContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AccordionContent).default;
	  }
	});
	
	var _AccordionTitle = __webpack_require__(876);
	
	Object.defineProperty(exports, 'AccordionTitle', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AccordionTitle).default;
	  }
	});
	
	var _Checkbox = __webpack_require__(753);
	
	Object.defineProperty(exports, 'Checkbox', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Checkbox).default;
	  }
	});
	
	var _Dimmer = __webpack_require__(727);
	
	Object.defineProperty(exports, 'Dimmer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Dimmer).default;
	  }
	});
	
	var _DimmerDimmable = __webpack_require__(734);
	
	Object.defineProperty(exports, 'DimmerDimmable', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DimmerDimmable).default;
	  }
	});
	
	var _Dropdown = __webpack_require__(757);
	
	Object.defineProperty(exports, 'Dropdown', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Dropdown).default;
	  }
	});
	
	var _DropdownDivider = __webpack_require__(776);
	
	Object.defineProperty(exports, 'DropdownDivider', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DropdownDivider).default;
	  }
	});
	
	var _DropdownHeader = __webpack_require__(781);
	
	Object.defineProperty(exports, 'DropdownHeader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DropdownHeader).default;
	  }
	});
	
	var _DropdownItem = __webpack_require__(777);
	
	Object.defineProperty(exports, 'DropdownItem', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DropdownItem).default;
	  }
	});
	
	var _DropdownMenu = __webpack_require__(782);
	
	Object.defineProperty(exports, 'DropdownMenu', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DropdownMenu).default;
	  }
	});
	
	var _Embed = __webpack_require__(877);
	
	Object.defineProperty(exports, 'Embed', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Embed).default;
	  }
	});
	
	var _Modal = __webpack_require__(741);
	
	Object.defineProperty(exports, 'Modal', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Modal).default;
	  }
	});
	
	var _ModalActions = __webpack_require__(748);
	
	Object.defineProperty(exports, 'ModalActions', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ModalActions).default;
	  }
	});
	
	var _ModalContent = __webpack_require__(747);
	
	Object.defineProperty(exports, 'ModalContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ModalContent).default;
	  }
	});
	
	var _ModalDescription = __webpack_require__(749);
	
	Object.defineProperty(exports, 'ModalDescription', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ModalDescription).default;
	  }
	});
	
	var _ModalHeader = __webpack_require__(746);
	
	Object.defineProperty(exports, 'ModalHeader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ModalHeader).default;
	  }
	});
	
	var _Popup = __webpack_require__(879);
	
	Object.defineProperty(exports, 'Popup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Popup).default;
	  }
	});
	
	var _PopupContent = __webpack_require__(883);
	
	Object.defineProperty(exports, 'PopupContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PopupContent).default;
	  }
	});
	
	var _PopupHeader = __webpack_require__(884);
	
	Object.defineProperty(exports, 'PopupHeader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PopupHeader).default;
	  }
	});
	
	var _Progress = __webpack_require__(885);
	
	Object.defineProperty(exports, 'Progress', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Progress).default;
	  }
	});
	
	var _Rating = __webpack_require__(890);
	
	Object.defineProperty(exports, 'Rating', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Rating).default;
	  }
	});
	
	var _RatingIcon = __webpack_require__(892);
	
	Object.defineProperty(exports, 'RatingIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RatingIcon).default;
	  }
	});
	
	var _Search = __webpack_require__(893);
	
	Object.defineProperty(exports, 'Search', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Search).default;
	  }
	});
	
	var _SearchCategory = __webpack_require__(899);
	
	Object.defineProperty(exports, 'SearchCategory', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SearchCategory).default;
	  }
	});
	
	var _SearchResult = __webpack_require__(900);
	
	Object.defineProperty(exports, 'SearchResult', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SearchResult).default;
	  }
	});
	
	var _SearchResults = __webpack_require__(901);
	
	Object.defineProperty(exports, 'SearchResults', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SearchResults).default;
	  }
	});
	
	var _Sidebar = __webpack_require__(902);
	
	Object.defineProperty(exports, 'Sidebar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Sidebar).default;
	  }
	});
	
	var _SidebarPushable = __webpack_require__(904);
	
	Object.defineProperty(exports, 'SidebarPushable', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SidebarPushable).default;
	  }
	});
	
	var _SidebarPusher = __webpack_require__(905);
	
	Object.defineProperty(exports, 'SidebarPusher', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SidebarPusher).default;
	  }
	});
	
	var _Card = __webpack_require__(906);
	
	Object.defineProperty(exports, 'Card', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Card).default;
	  }
	});
	
	var _CardContent = __webpack_require__(907);
	
	Object.defineProperty(exports, 'CardContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CardContent).default;
	  }
	});
	
	var _CardDescription = __webpack_require__(908);
	
	Object.defineProperty(exports, 'CardDescription', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CardDescription).default;
	  }
	});
	
	var _CardGroup = __webpack_require__(911);
	
	Object.defineProperty(exports, 'CardGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CardGroup).default;
	  }
	});
	
	var _CardHeader = __webpack_require__(909);
	
	Object.defineProperty(exports, 'CardHeader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CardHeader).default;
	  }
	});
	
	var _CardMeta = __webpack_require__(910);
	
	Object.defineProperty(exports, 'CardMeta', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CardMeta).default;
	  }
	});
	
	var _Comment = __webpack_require__(912);
	
	Object.defineProperty(exports, 'Comment', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Comment).default;
	  }
	});
	
	var _CommentAction = __webpack_require__(914);
	
	Object.defineProperty(exports, 'CommentAction', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CommentAction).default;
	  }
	});
	
	var _CommentActions = __webpack_require__(915);
	
	Object.defineProperty(exports, 'CommentActions', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CommentActions).default;
	  }
	});
	
	var _CommentAuthor = __webpack_require__(916);
	
	Object.defineProperty(exports, 'CommentAuthor', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CommentAuthor).default;
	  }
	});
	
	var _CommentAvatar = __webpack_require__(917);
	
	Object.defineProperty(exports, 'CommentAvatar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CommentAvatar).default;
	  }
	});
	
	var _CommentContent = __webpack_require__(918);
	
	Object.defineProperty(exports, 'CommentContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CommentContent).default;
	  }
	});
	
	var _CommentGroup = __webpack_require__(919);
	
	Object.defineProperty(exports, 'CommentGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CommentGroup).default;
	  }
	});
	
	var _CommentMetadata = __webpack_require__(920);
	
	Object.defineProperty(exports, 'CommentMetadata', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CommentMetadata).default;
	  }
	});
	
	var _CommentText = __webpack_require__(921);
	
	Object.defineProperty(exports, 'CommentText', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CommentText).default;
	  }
	});
	
	var _Feed = __webpack_require__(922);
	
	Object.defineProperty(exports, 'Feed', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Feed).default;
	  }
	});
	
	var _FeedContent = __webpack_require__(924);
	
	Object.defineProperty(exports, 'FeedContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FeedContent).default;
	  }
	});
	
	var _FeedDate = __webpack_require__(925);
	
	Object.defineProperty(exports, 'FeedDate', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FeedDate).default;
	  }
	});
	
	var _FeedEvent = __webpack_require__(931);
	
	Object.defineProperty(exports, 'FeedEvent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FeedEvent).default;
	  }
	});
	
	var _FeedExtra = __webpack_require__(926);
	
	Object.defineProperty(exports, 'FeedExtra', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FeedExtra).default;
	  }
	});
	
	var _FeedLabel = __webpack_require__(932);
	
	Object.defineProperty(exports, 'FeedLabel', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FeedLabel).default;
	  }
	});
	
	var _FeedLike = __webpack_require__(928);
	
	Object.defineProperty(exports, 'FeedLike', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FeedLike).default;
	  }
	});
	
	var _FeedMeta = __webpack_require__(927);
	
	Object.defineProperty(exports, 'FeedMeta', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FeedMeta).default;
	  }
	});
	
	var _FeedSummary = __webpack_require__(929);
	
	Object.defineProperty(exports, 'FeedSummary', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FeedSummary).default;
	  }
	});
	
	var _FeedUser = __webpack_require__(930);
	
	Object.defineProperty(exports, 'FeedUser', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FeedUser).default;
	  }
	});
	
	var _Item = __webpack_require__(933);
	
	Object.defineProperty(exports, 'Item', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Item).default;
	  }
	});
	
	var _ItemContent = __webpack_require__(935);
	
	Object.defineProperty(exports, 'ItemContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ItemContent).default;
	  }
	});
	
	var _ItemDescription = __webpack_require__(937);
	
	Object.defineProperty(exports, 'ItemDescription', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ItemDescription).default;
	  }
	});
	
	var _ItemExtra = __webpack_require__(938);
	
	Object.defineProperty(exports, 'ItemExtra', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ItemExtra).default;
	  }
	});
	
	var _ItemGroup = __webpack_require__(940);
	
	Object.defineProperty(exports, 'ItemGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ItemGroup).default;
	  }
	});
	
	var _ItemHeader = __webpack_require__(936);
	
	Object.defineProperty(exports, 'ItemHeader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ItemHeader).default;
	  }
	});
	
	var _ItemImage = __webpack_require__(941);
	
	Object.defineProperty(exports, 'ItemImage', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ItemImage).default;
	  }
	});
	
	var _ItemMeta = __webpack_require__(939);
	
	Object.defineProperty(exports, 'ItemMeta', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ItemMeta).default;
	  }
	});
	
	var _Statistic = __webpack_require__(942);
	
	Object.defineProperty(exports, 'Statistic', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Statistic).default;
	  }
	});
	
	var _StatisticGroup = __webpack_require__(944);
	
	Object.defineProperty(exports, 'StatisticGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StatisticGroup).default;
	  }
	});
	
	var _StatisticLabel = __webpack_require__(945);
	
	Object.defineProperty(exports, 'StatisticLabel', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StatisticLabel).default;
	  }
	});
	
	var _StatisticValue = __webpack_require__(946);
	
	Object.defineProperty(exports, 'StatisticValue', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StatisticValue).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Confirm = __webpack_require__(473);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Confirm2.default;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(513);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(514);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(518);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(552);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _has2 = __webpack_require__(560);
	
	var _has3 = _interopRequireDefault(_has2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _Button = __webpack_require__(720);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Modal = __webpack_require__(741);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A Confirm modal gives the user a choice to confirm or cancel an action/
	 * @see Modal
	 */
	var Confirm = function (_Component) {
	  (0, _inherits3.default)(Confirm, _Component);
	
	  function Confirm() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Confirm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Confirm.__proto__ || Object.getPrototypeOf(Confirm)).call.apply(_ref, [this].concat(args))), _this), _this.handleCancel = function (e) {
	      var onCancel = _this.props.onCancel;
	
	
	      if (onCancel) onCancel(e, _this.props);
	    }, _this.handleConfirm = function (e) {
	      var onConfirm = _this.props.onConfirm;
	
	
	      if (onConfirm) onConfirm(e, _this.props);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Confirm, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cancelButton = _props.cancelButton,
	          confirmButton = _props.confirmButton,
	          content = _props.content,
	          header = _props.header,
	          open = _props.open;
	
	      var rest = (0, _lib.getUnhandledProps)(Confirm, this.props);
	
	      // `open` is auto controlled by the Modal
	      // It cannot be present (even undefined) with `defaultOpen`
	      // only apply it if the user provided an open prop
	      var openProp = {};
	      if ((0, _has3.default)(this.props, 'open')) openProp.open = open;
	
	      return _react2.default.createElement(
	        _Modal2.default,
	        (0, _extends3.default)({}, rest, openProp, { size: 'small', onClose: this.handleCancel }),
	        _Modal2.default.Header.create(header),
	        _Modal2.default.Content.create(content),
	        _react2.default.createElement(
	          _Modal2.default.Actions,
	          null,
	          _Button2.default.create(cancelButton, { onClick: this.handleCancel }),
	          _Button2.default.create(confirmButton, {
	            onClick: this.handleConfirm,
	            primary: true
	          })
	        )
	      );
	    }
	  }]);
	  return Confirm;
	}(_react.Component);
	
	Confirm.defaultProps = {
	  cancelButton: 'Cancel',
	  confirmButton: 'OK',
	  content: 'Are you sure?'
	};
	Confirm._meta = {
	  name: 'Confirm',
	  type: _lib.META.TYPES.ADDON
	};
	 false ? Confirm.propTypes = {
	  /** The cancel button text. */
	  cancelButton: _lib.customPropTypes.itemShorthand,
	
	  /** The OK button text. */
	  confirmButton: _lib.customPropTypes.itemShorthand,
	
	  /** The ModalContent text. */
	  content: _lib.customPropTypes.itemShorthand,
	
	  /** The ModalHeader text. */
	  header: _lib.customPropTypes.itemShorthand,
	
	  /**
	   * Called when the Modal is closed without clicking confirm.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onCancel: _react.PropTypes.func,
	
	  /**
	   * Called when the OK button is clicked.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onConfirm: _react.PropTypes.func,
	
	  /** Whether or not the modal is visible. */
	  open: _react.PropTypes.bool
	} : void 0;
	Confirm.handledProps = ['cancelButton', 'confirmButton', 'content', 'header', 'onCancel', 'onConfirm', 'open'];
	exports.default = Confirm;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(475);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(476), __esModule: true };

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(477);
	module.exports = __webpack_require__(480).Object.assign;


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(478);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(494) });


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(479);
	var core = __webpack_require__(480);
	var ctx = __webpack_require__(481);
	var hide = __webpack_require__(483);
	var has = __webpack_require__(493);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 479 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 480 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.11' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(482);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 482 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(484);
	var createDesc = __webpack_require__(492);
	module.exports = __webpack_require__(488) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(485);
	var IE8_DOM_DEFINE = __webpack_require__(487);
	var toPrimitive = __webpack_require__(491);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(488) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(486);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 486 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(488) && !__webpack_require__(489)(function () {
	  return Object.defineProperty(__webpack_require__(490)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(489)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 489 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(486);
	var document = __webpack_require__(479).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(486);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 492 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 493 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(488);
	var getKeys = __webpack_require__(495);
	var gOPS = __webpack_require__(510);
	var pIE = __webpack_require__(511);
	var toObject = __webpack_require__(512);
	var IObject = __webpack_require__(498);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(489)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(496);
	var enumBugKeys = __webpack_require__(509);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(493);
	var toIObject = __webpack_require__(497);
	var arrayIndexOf = __webpack_require__(501)(false);
	var IE_PROTO = __webpack_require__(505)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(498);
	var defined = __webpack_require__(500);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(499);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 499 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 500 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(497);
	var toLength = __webpack_require__(502);
	var toAbsoluteIndex = __webpack_require__(504);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(503);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 503 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(503);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(506)('keys');
	var uid = __webpack_require__(508);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(480);
	var global = __webpack_require__(479);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(507) ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 507 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 508 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 509 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 510 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 511 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(500);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 513 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(515);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(516), __esModule: true };

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(517);
	var $Object = __webpack_require__(480).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(478);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(488), 'Object', { defineProperty: __webpack_require__(484).f });


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(519);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(520);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(539);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(521), __esModule: true };

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(522);
	__webpack_require__(534);
	module.exports = __webpack_require__(538).f('iterator');


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(523)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(524)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(503);
	var defined = __webpack_require__(500);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(507);
	var $export = __webpack_require__(478);
	var redefine = __webpack_require__(525);
	var hide = __webpack_require__(483);
	var Iterators = __webpack_require__(526);
	var $iterCreate = __webpack_require__(527);
	var setToStringTag = __webpack_require__(531);
	var getPrototypeOf = __webpack_require__(533);
	var ITERATOR = __webpack_require__(532)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(483);


/***/ }),
/* 526 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(528);
	var descriptor = __webpack_require__(492);
	var setToStringTag = __webpack_require__(531);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(483)(IteratorPrototype, __webpack_require__(532)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(485);
	var dPs = __webpack_require__(529);
	var enumBugKeys = __webpack_require__(509);
	var IE_PROTO = __webpack_require__(505)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(490)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(530).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(484);
	var anObject = __webpack_require__(485);
	var getKeys = __webpack_require__(495);
	
	module.exports = __webpack_require__(488) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(479).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(484).f;
	var has = __webpack_require__(493);
	var TAG = __webpack_require__(532)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(506)('wks');
	var uid = __webpack_require__(508);
	var Symbol = __webpack_require__(479).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(493);
	var toObject = __webpack_require__(512);
	var IE_PROTO = __webpack_require__(505)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(535);
	var global = __webpack_require__(479);
	var hide = __webpack_require__(483);
	var Iterators = __webpack_require__(526);
	var TO_STRING_TAG = __webpack_require__(532)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(536);
	var step = __webpack_require__(537);
	var Iterators = __webpack_require__(526);
	var toIObject = __webpack_require__(497);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(524)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 536 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 537 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(532);


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(540), __esModule: true };

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(541);
	__webpack_require__(549);
	__webpack_require__(550);
	__webpack_require__(551);
	module.exports = __webpack_require__(480).Symbol;


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(479);
	var has = __webpack_require__(493);
	var DESCRIPTORS = __webpack_require__(488);
	var $export = __webpack_require__(478);
	var redefine = __webpack_require__(525);
	var META = __webpack_require__(542).KEY;
	var $fails = __webpack_require__(489);
	var shared = __webpack_require__(506);
	var setToStringTag = __webpack_require__(531);
	var uid = __webpack_require__(508);
	var wks = __webpack_require__(532);
	var wksExt = __webpack_require__(538);
	var wksDefine = __webpack_require__(543);
	var enumKeys = __webpack_require__(544);
	var isArray = __webpack_require__(545);
	var anObject = __webpack_require__(485);
	var isObject = __webpack_require__(486);
	var toObject = __webpack_require__(512);
	var toIObject = __webpack_require__(497);
	var toPrimitive = __webpack_require__(491);
	var createDesc = __webpack_require__(492);
	var _create = __webpack_require__(528);
	var gOPNExt = __webpack_require__(546);
	var $GOPD = __webpack_require__(548);
	var $GOPS = __webpack_require__(510);
	var $DP = __webpack_require__(484);
	var $keys = __webpack_require__(495);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(547).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(511).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(507)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(483)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(508)('meta');
	var isObject = __webpack_require__(486);
	var has = __webpack_require__(493);
	var setDesc = __webpack_require__(484).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(489)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(479);
	var core = __webpack_require__(480);
	var LIBRARY = __webpack_require__(507);
	var wksExt = __webpack_require__(538);
	var defineProperty = __webpack_require__(484).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(495);
	var gOPS = __webpack_require__(510);
	var pIE = __webpack_require__(511);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(499);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(497);
	var gOPN = __webpack_require__(547).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(496);
	var hiddenKeys = __webpack_require__(509).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(511);
	var createDesc = __webpack_require__(492);
	var toIObject = __webpack_require__(497);
	var toPrimitive = __webpack_require__(491);
	var has = __webpack_require__(493);
	var IE8_DOM_DEFINE = __webpack_require__(487);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(488) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 549 */
/***/ (function(module, exports) {



/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(543)('asyncIterator');


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(543)('observable');


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(553);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(557);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(519);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(554), __esModule: true };

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(555);
	module.exports = __webpack_require__(480).Object.setPrototypeOf;


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(478);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(556).set });


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(486);
	var anObject = __webpack_require__(485);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(481)(Function.call, __webpack_require__(548).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(558), __esModule: true };

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(559);
	var $Object = __webpack_require__(480).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(478);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(528) });


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHas = __webpack_require__(561),
	    hasPath = __webpack_require__(380);
	
	/**
	 * Checks if `path` is a direct property of `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = { 'a': { 'b': 2 } };
	 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.has(object, 'a');
	 * // => true
	 *
	 * _.has(object, 'a.b');
	 * // => true
	 *
	 * _.has(object, ['a', 'b']);
	 * // => true
	 *
	 * _.has(other, 'a');
	 * // => false
	 */
	function has(object, path) {
	  return object != null && hasPath(object, path, baseHas);
	}
	
	module.exports = has;


/***/ }),
/* 561 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.has` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHas(object, key) {
	  return object != null && hasOwnProperty.call(object, key);
	}
	
	module.exports = baseHas;


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.objectDiff = exports.numberToWord = exports.numberToWordMap = exports.keyboardKey = exports.SUI = exports.META = exports.leven = exports.isBrowser = exports.getElementType = exports.getUnhandledProps = exports.makeDebugger = exports.debug = exports.customPropTypes = exports.useVerticalAlignProp = exports.useTextAlignProp = exports.useWidthProp = exports.useKeyOrValueAndKey = exports.useValueAndKey = exports.useKeyOnly = exports.childrenUtils = exports.AutoControlledComponent = undefined;
	
	var _AutoControlledComponent = __webpack_require__(563);
	
	Object.defineProperty(exports, 'AutoControlledComponent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AutoControlledComponent).default;
	  }
	});
	
	var _classNameBuilders = __webpack_require__(583);
	
	Object.defineProperty(exports, 'useKeyOnly', {
	  enumerable: true,
	  get: function get() {
	    return _classNameBuilders.useKeyOnly;
	  }
	});
	Object.defineProperty(exports, 'useValueAndKey', {
	  enumerable: true,
	  get: function get() {
	    return _classNameBuilders.useValueAndKey;
	  }
	});
	Object.defineProperty(exports, 'useKeyOrValueAndKey', {
	  enumerable: true,
	  get: function get() {
	    return _classNameBuilders.useKeyOrValueAndKey;
	  }
	});
	Object.defineProperty(exports, 'useWidthProp', {
	  enumerable: true,
	  get: function get() {
	    return _classNameBuilders.useWidthProp;
	  }
	});
	Object.defineProperty(exports, 'useTextAlignProp', {
	  enumerable: true,
	  get: function get() {
	    return _classNameBuilders.useTextAlignProp;
	  }
	});
	Object.defineProperty(exports, 'useVerticalAlignProp', {
	  enumerable: true,
	  get: function get() {
	    return _classNameBuilders.useVerticalAlignProp;
	  }
	});
	
	var _debug = __webpack_require__(585);
	
	Object.defineProperty(exports, 'debug', {
	  enumerable: true,
	  get: function get() {
	    return _debug.debug;
	  }
	});
	Object.defineProperty(exports, 'makeDebugger', {
	  enumerable: true,
	  get: function get() {
	    return _debug.makeDebugger;
	  }
	});
	
	var _factories = __webpack_require__(590);
	
	Object.keys(_factories).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _factories[key];
	    }
	  });
	});
	
	var _getUnhandledProps = __webpack_require__(592);
	
	Object.defineProperty(exports, 'getUnhandledProps', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getUnhandledProps).default;
	  }
	});
	
	var _getElementType = __webpack_require__(593);
	
	Object.defineProperty(exports, 'getElementType', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getElementType).default;
	  }
	});
	
	var _isBrowser = __webpack_require__(586);
	
	Object.defineProperty(exports, 'isBrowser', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_isBrowser).default;
	  }
	});
	
	var _leven = __webpack_require__(594);
	
	Object.defineProperty(exports, 'leven', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_leven).default;
	  }
	});
	
	var _keyboardKey = __webpack_require__(595);
	
	Object.defineProperty(exports, 'keyboardKey', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_keyboardKey).default;
	  }
	});
	
	var _numberToWord = __webpack_require__(584);
	
	Object.defineProperty(exports, 'numberToWordMap', {
	  enumerable: true,
	  get: function get() {
	    return _numberToWord.numberToWordMap;
	  }
	});
	Object.defineProperty(exports, 'numberToWord', {
	  enumerable: true,
	  get: function get() {
	    return _numberToWord.numberToWord;
	  }
	});
	
	var _objectDiff = __webpack_require__(597);
	
	Object.defineProperty(exports, 'objectDiff', {
	  enumerable: true,
	  get: function get() {
	    return _objectDiff.objectDiff;
	  }
	});
	
	var _childrenUtils2 = __webpack_require__(600);
	
	var _childrenUtils = _interopRequireWildcard(_childrenUtils2);
	
	var _customPropTypes2 = __webpack_require__(606);
	
	var _customPropTypes = _interopRequireWildcard(_customPropTypes2);
	
	var _META2 = __webpack_require__(712);
	
	var _META = _interopRequireWildcard(_META2);
	
	var _SUI2 = __webpack_require__(719);
	
	var _SUI = _interopRequireWildcard(_SUI2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.childrenUtils = _childrenUtils;
	exports.customPropTypes = _customPropTypes;
	exports.META = _META;
	exports.SUI = _SUI;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAutoControlledStateValue = undefined;
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(513);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(514);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(518);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(552);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _difference2 = __webpack_require__(564);
	
	var _difference3 = _interopRequireDefault(_difference2);
	
	var _isUndefined2 = __webpack_require__(572);
	
	var _isUndefined3 = _interopRequireDefault(_isUndefined2);
	
	var _startsWith2 = __webpack_require__(573);
	
	var _startsWith3 = _interopRequireDefault(_startsWith2);
	
	var _filter2 = __webpack_require__(263);
	
	var _filter3 = _interopRequireDefault(_filter2);
	
	var _isEmpty2 = __webpack_require__(578);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _keys2 = __webpack_require__(270);
	
	var _keys3 = _interopRequireDefault(_keys2);
	
	var _intersection2 = __webpack_require__(579);
	
	var _intersection3 = _interopRequireDefault(_intersection2);
	
	var _has2 = __webpack_require__(560);
	
	var _has3 = _interopRequireDefault(_has2);
	
	var _each2 = __webpack_require__(582);
	
	var _each3 = _interopRequireDefault(_each2);
	
	var _react = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getDefaultPropName = function getDefaultPropName(prop) {
	  return 'default' + (prop[0].toUpperCase() + prop.slice(1));
	};
	
	/**
	 * Return the auto controlled state value for a give prop. The initial value is chosen in this order:
	 *  - regular props
	 *  - then, default props
	 *  - then, initial state
	 *  - then, `checked` defaults to false
	 *  - then, `value` defaults to '' or [] if props.multiple
	 *  - else, undefined
	 *
	 *  @param {string} propName A prop name
	 *  @param {object} [props] A props object
	 *  @param {object} [state] A state object
	 *  @param {boolean} [includeDefaults=false] Whether or not to heed the default props or initial state
	 */
	/* eslint-disable no-console */
	/**
	 * Why choose inheritance over a HOC?  Multiple advantages for this particular use case.
	 * In short, we need identical functionality to setState(), unless there is a prop defined
	 * for the state key.  Also:
	 *
	 * 1. Single Renders
	 *    Calling trySetState() in constructor(), componentWillMount(), or componentWillReceiveProps()
	 *    does not cause two renders. Consumers and tests do not have to wait two renders to get state.
	 *    See www.react.run/4kJFdKoxb/27 for an example of this issue.
	 *
	 * 2. Simple Testing
	 *    Using a HOC means you must either test the undecorated component or test through the decorator.
	 *    Testing the undecorated component means you must mock the decorator functionality.
	 *    Testing through the HOC means you can not simply shallow render your component.
	 *
	 * 3. Statics
	 *    HOC wrap instances, so statics are no longer accessible.  They can be hoisted, but this is more
	 *    looping over properties and storing references.  We rely heavily on statics for testing and sub
	 *    components.
	 *
	 * 4. Instance Methods
	 *    Some instance methods may be exposed to users via refs.  Again, these are lost with HOC unless
	 *    hoisted and exposed by the HOC.
	 */
	var getAutoControlledStateValue = exports.getAutoControlledStateValue = function getAutoControlledStateValue(propName, props, state) {
	  var includeDefaults = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  // regular props
	  var propValue = props[propName];
	  if (propValue !== undefined) return propValue;
	
	  if (includeDefaults) {
	    // defaultProps
	    var defaultProp = props[getDefaultPropName(propName)];
	    if (defaultProp !== undefined) return defaultProp;
	
	    // initial state - state may be null or undefined
	    if (state) {
	      var initialState = state[propName];
	      if (initialState !== undefined) return initialState;
	    }
	  }
	
	  // React doesn't allow changing from uncontrolled to controlled components,
	  // default checked/value if they were not present.
	  if (propName === 'checked') return false;
	  if (propName === 'value') return props.multiple ? [] : '';
	
	  // otherwise, undefined
	};
	
	var AutoControlledComponent = function (_Component) {
	  (0, _inherits3.default)(AutoControlledComponent, _Component);
	
	  function AutoControlledComponent() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, AutoControlledComponent);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AutoControlledComponent.__proto__ || Object.getPrototypeOf(AutoControlledComponent)).call.apply(_ref, [this].concat(args))), _this), _this.trySetState = function (maybeState, state) {
	      var autoControlledProps = _this.constructor.autoControlledProps;
	
	      if (false) {
	        var name = _this.constructor.name;
	        // warn about failed attempts to setState for keys not listed in autoControlledProps
	
	        var illegalKeys = (0, _difference3.default)((0, _keys3.default)(maybeState), autoControlledProps);
	        if (!(0, _isEmpty3.default)(illegalKeys)) {
	          console.error([name + ' called trySetState() with controlled props: "' + illegalKeys + '".', 'State will not be set.', 'Only props in static autoControlledProps will be set on state.'].join(' '));
	        }
	      }
	
	      var newState = Object.keys(maybeState).reduce(function (acc, prop) {
	        // ignore props defined by the parent
	        if (_this.props[prop] !== undefined) return acc;
	
	        // ignore props not listed in auto controlled props
	        if (autoControlledProps.indexOf(prop) === -1) return acc;
	
	        acc[prop] = maybeState[prop];
	        return acc;
	      }, {});
	
	      if (state) newState = (0, _extends3.default)({}, newState, state);
	
	      if (Object.keys(newState).length > 0) _this.setState(newState);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(AutoControlledComponent, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var autoControlledProps = this.constructor.autoControlledProps;
	
	
	      if (false) {
	        (function () {
	          var _constructor = _this2.constructor,
	              defaultProps = _constructor.defaultProps,
	              name = _constructor.name,
	              propTypes = _constructor.propTypes;
	          // require static autoControlledProps
	
	          if (!autoControlledProps) {
	            console.error('Auto controlled ' + name + ' must specify a static autoControlledProps array.');
	          }
	
	          // require propTypes
	          (0, _each3.default)(autoControlledProps, function (prop) {
	            var defaultProp = getDefaultPropName(prop);
	            // regular prop
	            if (!(0, _has3.default)(propTypes, defaultProp)) {
	              console.error(name + ' is missing "' + defaultProp + '" propTypes validation for auto controlled prop "' + prop + '".');
	            }
	            // its default prop
	            if (!(0, _has3.default)(propTypes, prop)) {
	              console.error(name + ' is missing propTypes validation for auto controlled prop "' + prop + '".');
	            }
	          });
	
	          // prevent autoControlledProps in defaultProps
	          //
	          // When setting state, auto controlled props values always win (so the parent can manage them).
	          // It is not reasonable to decipher the difference between props from the parent and defaultProps.
	          // Allowing defaultProps results in trySetState always deferring to the defaultProp value.
	          // Auto controlled props also listed in defaultProps can never be updated.
	          //
	          // To set defaults for an AutoControlled prop, you can set the initial state in the
	          // constructor or by using an ES7 property initializer:
	          // https://babeljs.io/blog/2015/06/07/react-on-es6-plus#property-initializers
	          var illegalDefaults = (0, _intersection3.default)(autoControlledProps, (0, _keys3.default)(defaultProps));
	          if (!(0, _isEmpty3.default)(illegalDefaults)) {
	            console.error(['Do not set defaultProps for autoControlledProps. You can set defaults by', 'setting state in the constructor or using an ES7 property initializer', '(https://babeljs.io/blog/2015/06/07/react-on-es6-plus#property-initializers)', 'See ' + name + ' props: "' + illegalDefaults + '".'].join(' '));
	          }
	
	          // prevent listing defaultProps in autoControlledProps
	          //
	          // Default props are automatically handled.
	          // Listing defaults in autoControlledProps would result in allowing defaultDefaultValue props.
	          var illegalAutoControlled = (0, _filter3.default)(autoControlledProps, function (prop) {
	            return (0, _startsWith3.default)(prop, 'default');
	          });
	          if (!(0, _isEmpty3.default)(illegalAutoControlled)) {
	            console.error(['Do not add default props to autoControlledProps.', 'Default props are automatically handled.', 'See ' + name + ' autoControlledProps: "' + illegalAutoControlled + '".'].join(' '));
	          }
	        })();
	      }
	
	      // Auto controlled props are copied to state.
	      // Set initial state by copying auto controlled props to state.
	      // Also look for the default prop for any auto controlled props (foo => defaultFoo)
	      // so we can set initial values from defaults.
	      var initialAutoControlledState = autoControlledProps.reduce(function (acc, prop) {
	        acc[prop] = getAutoControlledStateValue(prop, _this2.props, _this2.state, true);
	
	        if (false) {
	          var defaultPropName = getDefaultPropName(prop);
	          var _name = _this2.constructor.name;
	          // prevent defaultFoo={} along side foo={}
	
	          if (defaultPropName in _this2.props && prop in _this2.props) {
	            console.error(_name + ' prop "' + prop + '" is auto controlled. Specify either ' + defaultPropName + ' or ' + prop + ', but not both.');
	          }
	        }
	
	        return acc;
	      }, {});
	
	      this.state = (0, _extends3.default)({}, this.state, initialAutoControlledState);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      var autoControlledProps = this.constructor.autoControlledProps;
	
	      // Solve the next state for autoControlledProps
	
	      var newState = autoControlledProps.reduce(function (acc, prop) {
	        var isNextUndefined = (0, _isUndefined3.default)(nextProps[prop]);
	        var propWasRemoved = !(0, _isUndefined3.default)(_this3.props[prop]) && isNextUndefined;
	
	        // if next is defined then use its value
	        if (!isNextUndefined) acc[prop] = nextProps[prop];
	
	        // reinitialize state for props just removed / set undefined
	        else if (propWasRemoved) acc[prop] = getAutoControlledStateValue(prop, nextProps);
	
	        return acc;
	      }, {});
	
	      if (Object.keys(newState).length > 0) this.setState(newState);
	    }
	
	    /**
	     * Safely attempt to set state for props that might be controlled by the user.
	     * Second argument is a state object that is always passed to setState.
	     * @param {object} maybeState State that corresponds to controlled props.
	     * @param {object} [state] Actual state, useful when you also need to setState.
	     */
	
	  }]);
	  return AutoControlledComponent;
	}(_react.Component);
	
	exports.default = AutoControlledComponent;

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(565),
	    baseFlatten = __webpack_require__(387),
	    baseRest = __webpack_require__(394),
	    isArrayLikeObject = __webpack_require__(455);
	
	/**
	 * Creates an array of `array` values not included in the other given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order and references of result values are
	 * determined by the first array.
	 *
	 * **Note:** Unlike `_.pullAll`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...Array} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.without, _.xor
	 * @example
	 *
	 * _.difference([2, 1], [2, 3]);
	 * // => [1]
	 */
	var difference = baseRest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	    : [];
	});
	
	module.exports = difference;


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(342),
	    arrayIncludes = __webpack_require__(566),
	    arrayIncludesWith = __webpack_require__(571),
	    arrayMap = __webpack_require__(376),
	    baseUnary = __webpack_require__(290),
	    cacheHas = __webpack_require__(346);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee == null ? value : iteratee(value);
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(567);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(568),
	    baseIsNaN = __webpack_require__(569),
	    strictIndexOf = __webpack_require__(570);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ }),
/* 568 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ }),
/* 569 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ }),
/* 570 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ }),
/* 571 */
/***/ (function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ }),
/* 572 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is `undefined`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	 * @example
	 *
	 * _.isUndefined(void 0);
	 * // => true
	 *
	 * _.isUndefined(null);
	 * // => false
	 */
	function isUndefined(value) {
	  return value === undefined;
	}
	
	module.exports = isUndefined;


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClamp = __webpack_require__(574),
	    baseToString = __webpack_require__(375),
	    toInteger = __webpack_require__(575),
	    toString = __webpack_require__(374);
	
	/**
	 * Checks if `string` starts with the given target string.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to inspect.
	 * @param {string} [target] The string to search for.
	 * @param {number} [position=0] The position to search from.
	 * @returns {boolean} Returns `true` if `string` starts with `target`,
	 *  else `false`.
	 * @example
	 *
	 * _.startsWith('abc', 'a');
	 * // => true
	 *
	 * _.startsWith('abc', 'b');
	 * // => false
	 *
	 * _.startsWith('abc', 'b', 1);
	 * // => true
	 */
	function startsWith(string, target, position) {
	  string = toString(string);
	  position = position == null
	    ? 0
	    : baseClamp(toInteger(position), 0, string.length);
	
	  target = baseToString(target);
	  return string.slice(position, position + target.length) == target;
	}
	
	module.exports = startsWith;


/***/ }),
/* 574 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.clamp` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {number} number The number to clamp.
	 * @param {number} [lower] The lower bound.
	 * @param {number} upper The upper bound.
	 * @returns {number} Returns the clamped number.
	 */
	function baseClamp(number, lower, upper) {
	  if (number === number) {
	    if (upper !== undefined) {
	      number = number <= upper ? number : upper;
	    }
	    if (lower !== undefined) {
	      number = number >= lower ? number : lower;
	    }
	  }
	  return number;
	}
	
	module.exports = baseClamp;


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(576);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(577);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(298),
	    isSymbol = __webpack_require__(370);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	var baseKeys = __webpack_require__(292),
	    getTag = __webpack_require__(357),
	    isArguments = __webpack_require__(273),
	    isArray = __webpack_require__(282),
	    isArrayLike = __webpack_require__(296),
	    isBuffer = __webpack_require__(283),
	    isPrototype = __webpack_require__(293),
	    isTypedArray = __webpack_require__(287);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if `value` is an empty object, collection, map, or set.
	 *
	 * Objects are considered empty if they have no own enumerable string keyed
	 * properties.
	 *
	 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	 * jQuery-like collections are considered empty if they have a `length` of `0`.
	 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (value == null) {
	    return true;
	  }
	  if (isArrayLike(value) &&
	      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	    return !value.length;
	  }
	  var tag = getTag(value);
	  if (tag == mapTag || tag == setTag) {
	    return !value.size;
	  }
	  if (isPrototype(value)) {
	    return !baseKeys(value).length;
	  }
	  for (var key in value) {
	    if (hasOwnProperty.call(value, key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = isEmpty;


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(376),
	    baseIntersection = __webpack_require__(580),
	    baseRest = __webpack_require__(394),
	    castArrayLikeObject = __webpack_require__(581);
	
	/**
	 * Creates an array of unique values that are included in all given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order and references of result values are
	 * determined by the first array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of intersecting values.
	 * @example
	 *
	 * _.intersection([2, 1], [2, 3]);
	 * // => [2]
	 */
	var intersection = baseRest(function(arrays) {
	  var mapped = arrayMap(arrays, castArrayLikeObject);
	  return (mapped.length && mapped[0] === arrays[0])
	    ? baseIntersection(mapped)
	    : [];
	});
	
	module.exports = intersection;


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(342),
	    arrayIncludes = __webpack_require__(566),
	    arrayIncludesWith = __webpack_require__(571),
	    arrayMap = __webpack_require__(376),
	    baseUnary = __webpack_require__(290),
	    cacheHas = __webpack_require__(346);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * The base implementation of methods like `_.intersection`, without support
	 * for iteratee shorthands, that accepts an array of arrays to inspect.
	 *
	 * @private
	 * @param {Array} arrays The arrays to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of shared values.
	 */
	function baseIntersection(arrays, iteratee, comparator) {
	  var includes = comparator ? arrayIncludesWith : arrayIncludes,
	      length = arrays[0].length,
	      othLength = arrays.length,
	      othIndex = othLength,
	      caches = Array(othLength),
	      maxLength = Infinity,
	      result = [];
	
	  while (othIndex--) {
	    var array = arrays[othIndex];
	    if (othIndex && iteratee) {
	      array = arrayMap(array, baseUnary(iteratee));
	    }
	    maxLength = nativeMin(array.length, maxLength);
	    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	      ? new SetCache(othIndex && array)
	      : undefined;
	  }
	  array = arrays[0];
	
	  var index = -1,
	      seen = caches[0];
	
	  outer:
	  while (++index < length && result.length < maxLength) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (!(seen
	          ? cacheHas(seen, computed)
	          : includes(result, computed, comparator)
	        )) {
	      othIndex = othLength;
	      while (--othIndex) {
	        var cache = caches[othIndex];
	        if (!(cache
	              ? cacheHas(cache, computed)
	              : includes(arrays[othIndex], computed, comparator))
	            ) {
	          continue outer;
	        }
	      }
	      if (seen) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseIntersection;


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLikeObject = __webpack_require__(455);
	
	/**
	 * Casts `value` to an empty array if it's not an array like object.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array|Object} Returns the cast array-like object.
	 */
	function castArrayLikeObject(value) {
	  return isArrayLikeObject(value) ? value : [];
	}
	
	module.exports = castArrayLikeObject;


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(440);


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useVerticalAlignProp = exports.useTextAlignProp = exports.useWidthProp = exports.useKeyOrValueAndKey = exports.useValueAndKey = exports.useKeyOnly = undefined;
	
	var _typeof2 = __webpack_require__(519);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _numberToWord = __webpack_require__(584);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Props where only the prop key is used in the className.
	 * @param {*} val A props value
	 * @param {string} key A props key
	 *
	 * @example
	 * <Label tag />
	 * <div class="ui tag label"></div>
	 */
	var useKeyOnly = exports.useKeyOnly = function useKeyOnly(val, key) {
	  return val && key;
	};
	
	/**
	 * Props that require both a key and value to create a className.
	 * @param {*} val A props value
	 * @param {string} key A props key
	 *
	 * @example
	 * <Label corner='left' />
	 * <div class="ui left corner label"></div>
	 */
	/*
	 * There are 4 prop patterns used to build up the className for a component.
	 * Each utility here is meant for use in a classnames() argument.
	 *
	 * There is no util for valueOnly() because it would simply return val.
	 * Use the prop value inline instead.
	 *   <Label size='big' />
	 *   <div class="ui big label"></div>
	 */
	var useValueAndKey = exports.useValueAndKey = function useValueAndKey(val, key) {
	  return val && val !== true && val + ' ' + key;
	};
	
	/**
	 * Props whose key will be used in className, or value and key.
	 * @param {*} val A props value
	 * @param {string} key A props key
	 *
	 * @example Key Only
	 * <Label pointing />
	 * <div class="ui pointing label"></div>
	 *
	 * @example Key and Value
	 * <Label pointing='left' />
	 * <div class="ui left pointing label"></div>
	 */
	var useKeyOrValueAndKey = exports.useKeyOrValueAndKey = function useKeyOrValueAndKey(val, key) {
	  return val && (val === true ? key : val + ' ' + key);
	};
	
	//
	// Prop to className exceptions
	//
	
	/**
	 * Create "X", "X wide" and "equal width" classNames.
	 * "X" is a numberToWord value and "wide" is configurable.
	 * @param {*} val The prop value
	 * @param {string} [widthClass=''] The class
	 * @param {boolean} [canEqual=false] Flag that indicates possibility of "equal" value
	 *
	 * @example
	 * <Grid columns='equal' />
	 * <div class="ui equal width grid"></div>
	 *
	 * <Form widths='equal' />
	 * <div class="ui equal width form"></div>
	 *
	 * <FieldGroup widths='equal' />
	 * <div class="equal width fields"></div>
	 *
	 * @example
	 * <Grid columns={4} />
	 * <div class="ui four column grid"></div>
	 */
	var useWidthProp = exports.useWidthProp = function useWidthProp(val) {
	  var widthClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var canEqual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if (canEqual && val === 'equal') {
	    return 'equal width';
	  }
	  var valType = typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val);
	  if ((valType === 'string' || valType === 'number') && widthClass) {
	    return (0, _numberToWord.numberToWord)(val) + ' ' + widthClass;
	  }
	  return (0, _numberToWord.numberToWord)(val);
	};
	/**
	 * The "textAlign" prop follows the useValueAndKey except when the value is "justified'.
	 * In this case, only the class "justified" is used, ignoring the "aligned" class.
	 * @param {*} val The value of the "textAlign" prop
	 *
	 * @example
	 * <Container textAlign='justified' />
	 * <div class="ui justified container"></div>
	 *
	 * @example
	 * <Container textAlign='left' />
	 * <div class="ui left aligned container"></div>
	 */
	var useTextAlignProp = exports.useTextAlignProp = function useTextAlignProp(val) {
	  return val === 'justified' ? 'justified' : useValueAndKey(val, 'aligned');
	};
	
	/**
	 * The "verticalAlign" prop follows the useValueAndKey.
	 *
	 * @param {*} val The value of the "verticalAlign" prop
	 *
	 * @example
	 * <Grid verticalAlign='middle' />
	 * <div class="ui middle aligned grid"></div>
	 */
	var useVerticalAlignProp = exports.useVerticalAlignProp = function useVerticalAlignProp(val) {
	  return useValueAndKey(val, 'aligned');
	};

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.numberToWordMap = undefined;
	
	var _typeof2 = __webpack_require__(519);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.numberToWord = numberToWord;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var numberToWordMap = exports.numberToWordMap = {
	  1: 'one',
	  2: 'two',
	  3: 'three',
	  4: 'four',
	  5: 'five',
	  6: 'six',
	  7: 'seven',
	  8: 'eight',
	  9: 'nine',
	  10: 'ten',
	  11: 'eleven',
	  12: 'twelve',
	  13: 'thirteen',
	  14: 'fourteen',
	  15: 'fifteen',
	  16: 'sixteen'
	};
	
	/**
	 * Return the number word for numbers 1-16.
	 * Returns strings or numbers as is if there is no corresponding word.
	 * Returns an empty string if value is not a string or number.
	 * @param {string|number} value The value to convert to a word.
	 * @returns {string}
	 */
	function numberToWord(value) {
	  var type = typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value);
	  if (type === 'string' || type === 'number') {
	    return numberToWordMap[value] || value;
	  }
	
	  return '';
	}

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.debug = exports.makeDebugger = undefined;
	
	var _isBrowser = __webpack_require__(586);
	
	var _isBrowser2 = _interopRequireDefault(_isBrowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _debug = void 0;
	var noop = function noop() {
	  return undefined;
	};
	
	if (_isBrowser2.default && ("production") !== 'production' && ("production") !== 'test') {
	  // Heads Up!
	  // https://github.com/visionmedia/debug/pull/331
	  //
	  // debug now clears storage on load, grab the debug settings before require('debug').
	  // We try/catch here as Safari throws on localStorage access in private mode or with cookies disabled.
	  var DEBUG = void 0;
	  try {
	    DEBUG = window.localStorage.debug;
	  } catch (e) {
	    /* eslint-disable no-console */
	    console.error('Semantic-UI-React could not enable debug.');
	    console.error(e);
	    /* eslint-enable no-console */
	  }
	
	  _debug = __webpack_require__(587);
	
	  // enable what ever settings we got from storage
	  _debug.enable(DEBUG);
	} else {
	  _debug = function _debug() {
	    return noop;
	  };
	}
	
	/**
	 * Create a namespaced debug function.
	 * @param {String} namespace Usually a component name.
	 * @example
	 * import { makeDebugger } from 'src/lib'
	 * const debug = makeDebugger('namespace')
	 *
	 * debug('Some message')
	 * @returns {Function}
	 */
	var makeDebugger = exports.makeDebugger = function makeDebugger(namespace) {
	  return _debug('semanticUIReact:' + namespace);
	};
	
	/**
	 * Default debugger, simple log.
	 * @example
	 * import { debug } from 'src/lib'
	 * debug('Some message')
	 */
	var debug = exports.debug = makeDebugger('log');

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(519);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasDocument = (typeof document === 'undefined' ? 'undefined' : (0, _typeof3.default)(document)) === 'object' && document !== null;
	var hasWindow = (typeof window === 'undefined' ? 'undefined' : (0, _typeof3.default)(window)) === 'object' && window !== null && window.self === window;
	
	exports.default = hasDocument && hasWindow;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(588);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
	    return true;
	  }
	
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
	    // double check webkit in userAgent just in case we are in a worker
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs(args) {
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return;
	
	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit')
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = ({"NODE_ENV":"production"}).DEBUG;
	  }
	
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(116)))

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(589);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor(namespace) {
	  var hash = 0, i;
	
	  for (i in namespace) {
	    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }
	
	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function createDebug(namespace) {
	
	  function debug() {
	    // disabled?
	    if (!debug.enabled) return;
	
	    var self = debug;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);
	
	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	
	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	
	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }
	
	  return debug;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  exports.names = [];
	  exports.skips = [];
	
	  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ }),
/* 589 */
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return;
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name;
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createHTMLLabel = exports.createHTMLInput = exports.createHTMLImage = undefined;
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isFunction2 = __webpack_require__(297);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isArray2 = __webpack_require__(282);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _isPlainObject2 = __webpack_require__(456);
	
	var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
	
	var _isNumber2 = __webpack_require__(443);
	
	var _isNumber3 = _interopRequireDefault(_isNumber2);
	
	var _isString2 = __webpack_require__(405);
	
	var _isString3 = _interopRequireDefault(_isString2);
	
	exports.createShorthand = createShorthand;
	exports.createShorthandFactory = createShorthandFactory;
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// ============================================================
	// Factories
	// ============================================================
	
	/**
	 * A more robust React.createElement. It can create elements from primitive values.
	 *
	 * @param {function|string} Component A ReactClass or string
	 * @param {function} mapValueToProps A function that maps a primitive value to the Component props
	 * @param {string|object|function} val The value to create a ReactElement from
	 * @param {object|function} [defaultProps={}] Default props object or function (called with regular props).
	 * @param {boolean} [generateKey=false] Whether or not to generate a child key, useful for collections.
	 * @returns {object|null}
	 */
	function createShorthand(Component, mapValueToProps, val) {
	  var defaultProps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var generateKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  if (typeof Component !== 'function' && typeof Component !== 'string') {
	    throw new Error('createShorthandFactory() Component must be a string or function.');
	  }
	  // short circuit for disabling shorthand
	  if (val === null) return null;
	  var valIsString = (0, _isString3.default)(val);
	  var valIsNumber = (0, _isNumber3.default)(val);
	
	  var isReactElement = (0, _react.isValidElement)(val);
	  var isPropsObject = (0, _isPlainObject3.default)(val);
	  var isPrimitiveValue = valIsString || valIsNumber || (0, _isArray3.default)(val);
	
	  // ----------------------------------------
	  // Build up props
	  // ----------------------------------------
	
	  // User's props
	  var usersProps = isReactElement && val.props || isPropsObject && val || isPrimitiveValue && mapValueToProps(val);
	
	  // Default props
	  defaultProps = (0, _isFunction3.default)(defaultProps) ? defaultProps(usersProps) : defaultProps;
	
	  // Merge props
	  /* eslint-disable react/prop-types */
	  var props = (0, _extends3.default)({}, defaultProps, usersProps);
	
	  // Merge className
	  if (usersProps.className && defaultProps.className) {
	    props.className = (0, _classnames2.default)(defaultProps.className, usersProps.className);
	  }
	
	  // Merge style
	  if (usersProps.style && defaultProps.style) {
	    props.style = (0, _extends3.default)({}, defaultProps.style, usersProps.style);
	  }
	
	  // ----------------------------------------
	  // Get key
	  // ----------------------------------------
	
	  // Use key, childKey, or generate key
	  if (!props.key) {
	    var childKey = props.childKey;
	
	
	    if (childKey) {
	      // apply and consume the childKey
	      props.key = typeof childKey === 'function' ? childKey(props) : childKey;
	      delete props.childKey;
	    } else if (generateKey && (valIsString || valIsNumber)) {
	      // use string/number shorthand values as the key
	      props.key = val;
	    }
	  }
	  /* eslint-enable react/prop-types */
	
	  // ----------------------------------------
	  // Create Element
	  // ----------------------------------------
	
	  // Clone ReactElements
	  if (isReactElement) return (0, _react.cloneElement)(val, props);
	
	  // Create ReactElements from built up props
	  if (isPrimitiveValue || isPropsObject) return _react2.default.createElement(Component, props);
	
	  // Otherwise null
	  return null;
	}
	
	// ============================================================
	// Factory Creators
	// ============================================================
	
	/**
	 * Creates a `createShorthand` function that is waiting for a value and defaultProps.
	 *
	 * @param {function|string} Component A ReactClass or string
	 * @param {function} mapValueToProps A function that maps a primitive value to the Component props
	 * @param {boolean} [generateKey] Whether or not to generate a child key, useful for collections.
	 * @return {function} A shorthand factory function waiting for `val` and `defaultProps`.
	 */
	createShorthand.handledProps = [];
	function createShorthandFactory(Component, mapValueToProps, generateKey) {
	  if (typeof Component !== 'function' && typeof Component !== 'string') {
	    throw new Error('createShorthandFactory() Component must be a string or function.');
	  }
	
	  return function (val, defaultProps) {
	    return createShorthand(Component, mapValueToProps, val, defaultProps, generateKey);
	  };
	}
	
	// ============================================================
	// HTML Factories
	// ============================================================
	var createHTMLImage = exports.createHTMLImage = createShorthandFactory('img', function (value) {
	  return { src: value };
	});
	var createHTMLInput = exports.createHTMLInput = createShorthandFactory('input', function (value) {
	  return { type: value };
	});
	var createHTMLLabel = exports.createHTMLLabel = createShorthandFactory('label', function (value) {
	  return { children: value };
	});

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 592 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Returns an object consisting of props beyond the scope of the Component.
	 * Useful for getting and spreading unknown props from the user.
	 * @param {function} Component A function or ReactClass.
	 * @param {object} props A ReactElement props object
	 * @returns {{}} A shallow copy of the prop object
	 */
	var getUnhandledProps = function getUnhandledProps(Component, props) {
	  // Note that `handledProps` are generated automatically during build with `babel-plugin-transform-react-handled-props`
	  var _Component$handledPro = Component.handledProps,
	      handledProps = _Component$handledPro === undefined ? [] : _Component$handledPro;
	
	
	  return Object.keys(props).reduce(function (acc, prop) {
	    if (prop === 'childKey') return acc;
	    if (handledProps.indexOf(prop) === -1) acc[prop] = props[prop];
	    return acc;
	  }, {});
	};
	
	exports.default = getUnhandledProps;

/***/ }),
/* 593 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Returns a createElement() type based on the props of the Component.
	 * Useful for calculating what type a component should render as.
	 *
	 * @param {function} Component A function or ReactClass.
	 * @param {object} props A ReactElement props object
	 * @param {function} [getDefault] A function that returns a default element type.
	 * @returns {string|function} A ReactElement type
	 */
	function getElementType(Component, props, getDefault) {
	  var _Component$defaultPro = Component.defaultProps,
	      defaultProps = _Component$defaultPro === undefined ? {} : _Component$defaultPro;
	
	  // ----------------------------------------
	  // user defined "as" element type
	
	  if (props.as && props.as !== defaultProps.as) return props.as;
	
	  // ----------------------------------------
	  // computed default element type
	
	  if (getDefault) {
	    var computedDefault = getDefault();
	    if (computedDefault) return computedDefault;
	  }
	
	  // ----------------------------------------
	  // infer anchor links
	
	  if (props.href) return 'a';
	
	  // ----------------------------------------
	  // use defaultProp or 'div'
	
	  return defaultProps.as || 'div';
	}
	
	exports.default = getElementType;

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copy of sindre's leven, wrapped in dead code elimination for production
	// https://github.com/sindresorhus/leven/blob/master/index.js
	
	var leven = function leven() {
	  return 0;
	};
	
	if (false) {
	  (function () {
	    /* eslint-disable complexity, no-nested-ternary */
	    var arr = [];
	    var charCodeCache = [];
	
	    leven = function leven(a, b) {
	      if (a === b) return 0;
	
	      var aLen = a.length;
	      var bLen = b.length;
	
	      if (aLen === 0) return bLen;
	      if (bLen === 0) return aLen;
	
	      var bCharCode = void 0;
	      var ret = void 0;
	      var tmp = void 0;
	      var tmp2 = void 0;
	      var i = 0;
	      var j = 0;
	
	      while (i < aLen) {
	        charCodeCache[i] = a.charCodeAt(i);
	        arr[i] = ++i;
	      }
	
	      while (j < bLen) {
	        bCharCode = b.charCodeAt(j);
	        tmp = j++;
	        ret = j;
	
	        for (i = 0; i < aLen; i++) {
	          tmp2 = bCharCode === charCodeCache[i] ? tmp : tmp + 1;
	          tmp = arr[i];
	          ret = arr[i] = tmp > ret ? tmp2 > ret ? ret + 1 : tmp2 : tmp2 > tmp ? tmp + 1 : tmp2;
	        }
	      }
	
	      return ret;
	    };
	  })();
	}
	
	exports.default = leven;

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isObject2 = __webpack_require__(298);
	
	var _isObject3 = _interopRequireDefault(_isObject2);
	
	var _times2 = __webpack_require__(596);
	
	var _times3 = _interopRequireDefault(_times2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * All previous KeyboardEvent key identifying properties are deprecated in favor of `key`.
	 * Unfortunately, `key` is not yet fully supported.
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key
	 */
	var codes = {
	  // ----------------------------------------
	  // By Code
	  // ----------------------------------------
	  3: 'Cancel',
	  6: 'Help',
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  28: 'Convert',
	  29: 'NonConvert',
	  30: 'Accept',
	  31: 'ModeChange',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  41: 'Select',
	  42: 'Print',
	  43: 'Execute',
	  44: 'PrintScreen',
	  45: 'Insert',
	  46: 'Delete',
	  48: ['0', ')'],
	  49: ['1', '!'],
	  50: ['2', '@'],
	  51: ['3', '#'],
	  52: ['4', '$'],
	  53: ['5', '%'],
	  54: ['6', '^'],
	  55: ['7', '&'],
	  56: ['8', '*'],
	  57: ['9', '('],
	  91: 'OS',
	  93: 'ContextMenu',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  181: 'VolumeMute',
	  182: 'VolumeDown',
	  183: 'VolumeUp',
	  186: [';', ':'],
	  187: ['=', '+'],
	  188: [',', '<'],
	  189: ['-', '_'],
	  190: ['.', '>'],
	  191: ['/', '?'],
	  192: ['`', '~'],
	  219: ['[', '{'],
	  220: ['\\', '|'],
	  221: [']', '}'],
	  222: ["'", '"'],
	  224: 'Meta',
	  225: 'AltGraph',
	  246: 'Attn',
	  247: 'CrSel',
	  248: 'ExSel',
	  249: 'EraseEof',
	  250: 'Play',
	  251: 'ZoomOut'
	};
	
	// Function Keys (F1-24)
	(0, _times3.default)(24, function (i) {
	  return codes[112 + i] = 'F' + (i + 1);
	});
	
	// Alphabet (a-Z)
	(0, _times3.default)(26, function (i) {
	  var n = i + 65;
	  codes[n] = [String.fromCharCode(n + 32), String.fromCharCode(n)];
	});
	
	var keyboardKey = {
	  codes: codes,
	
	  /**
	   * Get the `keyCode` or `which` value from a keyboard event or `key` name.
	   * @param {string|object} name A keyboard event like object or `key` name.
	   * @param {string} [name.key] If object, it must have one of these keys.
	   * @param {string} [name.keyCode] If object, it must have one of these keys.
	   * @param {string} [name.which] If object, it must have one of these keys.
	   * @returns {*}
	   */
	  getCode: function getCode(name) {
	    if ((0, _isObject3.default)(name)) {
	      return name.keyCode || name.which || this[name.key];
	    }
	    return this[name];
	  },
	
	
	  /**
	   * Get the key name from a keyboard event, `keyCode`, or `which` value.
	   * @param {number|object} code A keyboard event like object or key name.
	   * @param {number} [code.keyCode] If object, it must have one of these keys.
	   * @param {number} [code.which] If object, it must have one of these keys.
	   * @param {number} [code.shiftKey] If object, it must have one of these keys.
	   * @returns {*}
	   */
	  getName: function getName(code) {
	    var isEvent = (0, _isObject3.default)(code);
	    var name = codes[isEvent ? code.keyCode || code.which : code];
	
	    if (Array.isArray(name)) {
	      if (isEvent) {
	        name = name[code.shiftKey ? 1 : 0];
	      } else {
	        name = name[0];
	      }
	    }
	
	    return name;
	  },
	
	
	  // ----------------------------------------
	  // By Name
	  // ----------------------------------------
	  // declare these manually for static analysis
	  Cancel: 3,
	  Help: 6,
	  Backspace: 8,
	  Tab: 9,
	  Clear: 12,
	  Enter: 13,
	  Shift: 16,
	  Control: 17,
	  Alt: 18,
	  Pause: 19,
	  CapsLock: 20,
	  Escape: 27,
	  Convert: 28,
	  NonConvert: 29,
	  Accept: 30,
	  ModeChange: 31,
	  ' ': 32,
	  PageUp: 33,
	  PageDown: 34,
	  End: 35,
	  Home: 36,
	  ArrowLeft: 37,
	  ArrowUp: 38,
	  ArrowRight: 39,
	  ArrowDown: 40,
	  Select: 41,
	  Print: 42,
	  Execute: 43,
	  PrintScreen: 44,
	  Insert: 45,
	  Delete: 46,
	  0: 48, ')': 48,
	  1: 49, '!': 49,
	  2: 50, '@': 50,
	  3: 51, '#': 51,
	  4: 52, $: 52,
	  5: 53, '%': 53,
	  6: 54, '^': 54,
	  7: 55, '&': 55,
	  8: 56, '*': 56,
	  9: 57, '(': 57,
	  a: 65, A: 65,
	  b: 66, B: 66,
	  c: 67, C: 67,
	  d: 68, D: 68,
	  e: 69, E: 69,
	  f: 70, F: 70,
	  g: 71, G: 71,
	  h: 72, H: 72,
	  i: 73, I: 73,
	  j: 74, J: 74,
	  k: 75, K: 75,
	  l: 76, L: 76,
	  m: 77, M: 77,
	  n: 78, N: 78,
	  o: 79, O: 79,
	  p: 80, P: 80,
	  q: 81, Q: 81,
	  r: 82, R: 82,
	  s: 83, S: 83,
	  t: 84, T: 84,
	  u: 85, U: 85,
	  v: 86, V: 86,
	  w: 87, W: 87,
	  x: 88, X: 88,
	  y: 89, Y: 89,
	  z: 90, Z: 90,
	  OS: 91,
	  ContextMenu: 93,
	  F1: 112,
	  F2: 113,
	  F3: 114,
	  F4: 115,
	  F5: 116,
	  F6: 117,
	  F7: 118,
	  F8: 119,
	  F9: 120,
	  F10: 121,
	  F11: 122,
	  F12: 123,
	  F13: 124,
	  F14: 125,
	  F15: 126,
	  F16: 127,
	  F17: 128,
	  F18: 129,
	  F19: 130,
	  F20: 131,
	  F21: 132,
	  F22: 133,
	  F23: 134,
	  F24: 135,
	  NumLock: 144,
	  ScrollLock: 145,
	  VolumeMute: 181,
	  VolumeDown: 182,
	  VolumeUp: 183,
	  ';': 186, ':': 186,
	  '=': 187, '+': 187,
	  ',': 188, '<': 188,
	  '-': 189, _: 189,
	  '.': 190, '>': 190,
	  '/': 191, '?': 191,
	  '`': 192, '~': 192,
	  '[': 219, '{': 219,
	  '\\': 220, '\|': 220,
	  ']': 221, '}': 221,
	  "'": 222, '"': 222,
	  Meta: 224,
	  AltGraph: 225,
	  Attn: 246,
	  CrSel: 247,
	  ExSel: 248,
	  EraseEof: 249,
	  Play: 250,
	  ZoomOut: 251
	};
	
	// ----------------------------------------
	// By Alias
	// ----------------------------------------
	// provide dot-notation accessible keys for all key names
	keyboardKey.Spacebar = keyboardKey[' '];
	keyboardKey.Digit0 = keyboardKey['0'];
	keyboardKey.Digit1 = keyboardKey['1'];
	keyboardKey.Digit2 = keyboardKey['2'];
	keyboardKey.Digit3 = keyboardKey['3'];
	keyboardKey.Digit4 = keyboardKey['4'];
	keyboardKey.Digit5 = keyboardKey['5'];
	keyboardKey.Digit6 = keyboardKey['6'];
	keyboardKey.Digit7 = keyboardKey['7'];
	keyboardKey.Digit8 = keyboardKey['8'];
	keyboardKey.Digit9 = keyboardKey['9'];
	keyboardKey.Tilde = keyboardKey['~'];
	keyboardKey.GraveAccent = keyboardKey['`'];
	keyboardKey.ExclamationPoint = keyboardKey['!'];
	keyboardKey.AtSign = keyboardKey['@'];
	keyboardKey.PoundSign = keyboardKey['#'];
	keyboardKey.PercentSign = keyboardKey['%'];
	keyboardKey.Caret = keyboardKey['^'];
	keyboardKey.Ampersand = keyboardKey['&'];
	keyboardKey.PlusSign = keyboardKey['+'];
	keyboardKey.MinusSign = keyboardKey['-'];
	keyboardKey.EqualsSign = keyboardKey['='];
	keyboardKey.DivisionSign = keyboardKey['/'];
	keyboardKey.MultiplicationSign = keyboardKey['*'];
	keyboardKey.Comma = keyboardKey[','];
	keyboardKey.Decimal = keyboardKey['.'];
	keyboardKey.Colon = keyboardKey[':'];
	keyboardKey.Semicolon = keyboardKey[';'];
	keyboardKey.Pipe = keyboardKey['|'];
	keyboardKey.BackSlash = keyboardKey['\\'];
	keyboardKey.QuestionMark = keyboardKey['?'];
	keyboardKey.SingleQuote = keyboardKey['"'];
	keyboardKey.DoubleQuote = keyboardKey['"'];
	keyboardKey.LeftCurlyBrace = keyboardKey['{'];
	keyboardKey.RightCurlyBrace = keyboardKey['}'];
	keyboardKey.LeftParenthesis = keyboardKey['('];
	keyboardKey.RightParenthesis = keyboardKey[')'];
	keyboardKey.LeftAngleBracket = keyboardKey['<'];
	keyboardKey.RightAngleBracket = keyboardKey['>'];
	keyboardKey.LeftSquareBracket = keyboardKey['['];
	keyboardKey.RightSquareBracket = keyboardKey[']'];
	
	exports.default = keyboardKey;

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(272),
	    castFunction = __webpack_require__(442),
	    toInteger = __webpack_require__(575);
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Invokes the iteratee `n` times, returning an array of the results of
	 * each invocation. The iteratee is invoked with one argument; (index).
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 * @example
	 *
	 * _.times(3, String);
	 * // => ['0', '1', '2']
	 *
	 *  _.times(4, _.constant(0));
	 * // => [0, 0, 0, 0]
	 */
	function times(n, iteratee) {
	  n = toInteger(n);
	  if (n < 1 || n > MAX_SAFE_INTEGER) {
	    return [];
	  }
	  var index = MAX_ARRAY_LENGTH,
	      length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	  iteratee = castFunction(iteratee);
	  n -= MAX_ARRAY_LENGTH;
	
	  var result = baseTimes(length, iteratee);
	  while (++index < n) {
	    iteratee(index);
	  }
	  return result;
	}
	
	module.exports = times;


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.objectDiff = undefined;
	
	var _isEqual2 = __webpack_require__(598);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _has2 = __webpack_require__(560);
	
	var _has3 = _interopRequireDefault(_has2);
	
	var _transform2 = __webpack_require__(599);
	
	var _transform3 = _interopRequireDefault(_transform2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Naive and inefficient object difference, intended for development / debugging use only.
	 * Deleted keys are shown as [DELETED].
	 * @param {{}} source The source object
	 * @param {{}} target The target object.
	 * @returns {{}} A new object containing new/modified/deleted keys.
	 * @example
	 * import { objectDiff } from 'src/lib'
	 *
	 * const a = { key: 'val', foo: 'bar' }
	 * const b = { key: 'val', foo: 'baz' }
	 *
	 * objectDiff(a, b)
	 * //=> { foo: 'baz' }
	 */
	var objectDiff = exports.objectDiff = function objectDiff(source, target) {
	  return (0, _transform3.default)(source, function (res, val, key) {
	    // deleted keys
	    if (!(0, _has3.default)(target, key)) res[key] = '[DELETED]';
	    // new keys / changed values
	    else if (!(0, _isEqual3.default)(val, target[key])) res[key] = target[key];
	  }, {});
	};

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(339);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(441),
	    baseCreate = __webpack_require__(453),
	    baseForOwn = __webpack_require__(267),
	    baseIteratee = __webpack_require__(300),
	    getPrototype = __webpack_require__(454),
	    isArray = __webpack_require__(282),
	    isBuffer = __webpack_require__(283),
	    isFunction = __webpack_require__(297),
	    isObject = __webpack_require__(298),
	    isTypedArray = __webpack_require__(287);
	
	/**
	 * An alternative to `_.reduce`; this method transforms `object` to a new
	 * `accumulator` object which is the result of running each of its own
	 * enumerable string keyed properties thru `iteratee`, with each invocation
	 * potentially mutating the `accumulator` object. If `accumulator` is not
	 * provided, a new object with the same `[[Prototype]]` will be used. The
	 * iteratee is invoked with four arguments: (accumulator, value, key, object).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.3.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The custom accumulator value.
	 * @returns {*} Returns the accumulated value.
	 * @example
	 *
	 * _.transform([2, 3, 4], function(result, n) {
	 *   result.push(n *= n);
	 *   return n % 2 == 0;
	 * }, []);
	 * // => [4, 9]
	 *
	 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	 *   (result[value] || (result[value] = [])).push(key);
	 * }, {});
	 * // => { '1': ['a', 'c'], '2': ['b'] }
	 */
	function transform(object, iteratee, accumulator) {
	  var isArr = isArray(object),
	      isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	  iteratee = baseIteratee(iteratee, 4);
	  if (accumulator == null) {
	    var Ctor = object && object.constructor;
	    if (isArrLike) {
	      accumulator = isArr ? new Ctor : [];
	    }
	    else if (isObject(object)) {
	      accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	    }
	    else {
	      accumulator = {};
	    }
	  }
	  (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	    return iteratee(accumulator, value, index, object);
	  });
	  return accumulator;
	}
	
	module.exports = transform;


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.findByType = exports.someByType = undefined;
	
	var _find2 = __webpack_require__(601);
	
	var _find3 = _interopRequireDefault(_find2);
	
	var _some2 = __webpack_require__(604);
	
	var _some3 = _interopRequireDefault(_some2);
	
	var _react = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Determine if child by type exists in children.
	 * @param {Object} children The children prop of a component.
	 * @param {string|Function} type An html tag name string or React component.
	 * @returns {Boolean}
	 */
	var someByType = exports.someByType = function someByType(children, type) {
	  return (0, _some3.default)(_react.Children.toArray(children), { type: type });
	};
	
	/**
	 * Find child by type.
	 * @param {Object} children The children prop of a component.
	 * @param {string|Function} type An html tag name string or React component.
	 * @returns {undefined|Object}
	 */
	var findByType = exports.findByType = function findByType(children, type) {
	  return (0, _find3.default)(_react.Children.toArray(children), { type: type });
	};

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(602),
	    findIndex = __webpack_require__(603);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(300),
	    isArrayLike = __webpack_require__(296),
	    keys = __webpack_require__(270);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate, 3);
	      collection = keys(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(568),
	    baseIteratee = __webpack_require__(300),
	    toInteger = __webpack_require__(575);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(345),
	    baseIteratee = __webpack_require__(300),
	    baseSome = __webpack_require__(605),
	    isArray = __webpack_require__(282),
	    isIterateeCall = __webpack_require__(402);
	
	/**
	 * Checks if `predicate` returns truthy for **any** element of `collection`.
	 * Iteration is stopped once `predicate` returns truthy. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.some([null, 0, 'yes', false], Boolean);
	 * // => true
	 *
	 * var users = [
	 *   { 'user': 'barney', 'active': true },
	 *   { 'user': 'fred',   'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.some(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.some(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.some(users, 'active');
	 * // => true
	 */
	function some(collection, predicate, guard) {
	  var func = isArray(collection) ? arraySome : baseSome;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = some;


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(266);
	
	/**
	 * The base implementation of `_.some` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function baseSome(collection, predicate) {
	  var result;
	
	  baseEach(collection, function(value, index, collection) {
	    result = predicate(value, index, collection);
	    return !result;
	  });
	  return !!result;
	}
	
	module.exports = baseSome;


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.deprecate = exports.collectionShorthand = exports.itemShorthand = exports.contentShorthand = exports.demand = exports.givenProps = exports.some = exports.every = exports.disallow = exports.suggest = exports.as = undefined;
	
	var _toConsumableArray2 = __webpack_require__(607);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _isObject2 = __webpack_require__(617);
	
	var _isObject3 = _interopRequireDefault(_isObject2);
	
	var _pick2 = __webpack_require__(681);
	
	var _pick3 = _interopRequireDefault(_pick2);
	
	var _keys2 = __webpack_require__(685);
	
	var _keys3 = _interopRequireDefault(_keys2);
	
	var _isPlainObject2 = __webpack_require__(686);
	
	var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
	
	var _isFunction2 = __webpack_require__(687);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _compact2 = __webpack_require__(688);
	
	var _compact3 = _interopRequireDefault(_compact2);
	
	var _take2 = __webpack_require__(690);
	
	var _take3 = _interopRequireDefault(_take2);
	
	var _sortBy2 = __webpack_require__(693);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	var _sum2 = __webpack_require__(694);
	
	var _sum3 = _interopRequireDefault(_sum2);
	
	var _min2 = __webpack_require__(697);
	
	var _min3 = _interopRequireDefault(_min2);
	
	var _map2 = __webpack_require__(701);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _flow2 = __webpack_require__(703);
	
	var _flow3 = _interopRequireDefault(_flow2);
	
	var _includes2 = __webpack_require__(706);
	
	var _includes3 = _interopRequireDefault(_includes2);
	
	var _isNil2 = __webpack_require__(710);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _react = __webpack_require__(2);
	
	var _leven = __webpack_require__(594);
	
	var _leven2 = _interopRequireDefault(_leven);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var typeOf = function typeOf() {
	  var _Object$prototype$toS;
	
	  return (_Object$prototype$toS = Object.prototype.toString).call.apply(_Object$prototype$toS, arguments);
	};
	
	/**
	 * Ensure a component can render as a give prop value.
	 */
	var as = exports.as = function as() {
	  return _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]).apply(undefined, arguments);
	};
	
	/**
	 * Similar to PropTypes.oneOf but shows closest matches.
	 * Word order is ignored allowing `left chevron` to match `chevron left`.
	 * Useful for very large lists of options (e.g. Icon name, Flag name, etc.)
	 * @param {string[]} suggestions An array of allowed values.
	 */
	var suggest = exports.suggest = function suggest(suggestions) {
	  return function (props, propName, componentName) {
	    if (!Array.isArray(suggestions)) {
	      throw new Error(['Invalid argument supplied to suggest, expected an instance of array.', ' See `' + propName + '` prop in `' + componentName + '`.'].join(''));
	    }
	    var propValue = props[propName];
	
	    // skip if prop is undefined or is included in the suggestions
	    if ((0, _isNil3.default)(propValue) || propValue === false || (0, _includes3.default)(propValue, suggestions)) return;
	
	    // find best suggestions
	    var propValueWords = propValue.split(' ');
	
	    /* eslint-disable max-nested-callbacks */
	    var bestMatches = (0, _flow3.default)((0, _map3.default)(function (suggestion) {
	      var suggestionWords = suggestion.split(' ');
	
	      var propValueScore = (0, _flow3.default)((0, _map3.default)(function (x) {
	        return (0, _map3.default)(function (y) {
	          return (0, _leven2.default)(x, y);
	        }, suggestionWords);
	      }), (0, _map3.default)(_min3.default), _sum3.default)(propValueWords);
	
	      var suggestionScore = (0, _flow3.default)((0, _map3.default)(function (x) {
	        return (0, _map3.default)(function (y) {
	          return (0, _leven2.default)(x, y);
	        }, propValueWords);
	      }), (0, _map3.default)(_min3.default), _sum3.default)(suggestionWords);
	
	      return { suggestion: suggestion, score: propValueScore + suggestionScore };
	    }), (0, _sortBy3.default)(['score', 'suggestion']), (0, _take3.default)(3))(suggestions);
	    /* eslint-enable max-nested-callbacks */
	
	    // skip if a match scored 0
	    // since we're matching on words (classNames) this allows any word order to pass validation
	    // e.g. `left chevron` vs `chevron left`
	    if (bestMatches.some(function (x) {
	      return x.score === 0;
	    })) return;
	
	    return new Error(['Invalid prop `' + propName + '` of value `' + propValue + '` supplied to `' + componentName + '`.', '\n\nInstead of `' + propValue + '`, did you mean:', bestMatches.map(function (x) {
	      return '\n  - ' + x.suggestion;
	    }).join(''), '\n'].join(''));
	  };
	};
	
	/**
	 * Disallow other props form being defined with this prop.
	 * @param {string[]} disallowedProps An array of props that cannot be used with this prop.
	 */
	var disallow = exports.disallow = function disallow(disallowedProps) {
	  return function (props, propName, componentName) {
	    if (!Array.isArray(disallowedProps)) {
	      throw new Error(['Invalid argument supplied to disallow, expected an instance of array.', ' See `' + propName + '` prop in `' + componentName + '`.'].join(''));
	    }
	
	    // skip if prop is undefined
	    if ((0, _isNil3.default)(props[propName]) || props[propName] === false) return;
	
	    // find disallowed props with values
	    var disallowed = disallowedProps.reduce(function (acc, disallowedProp) {
	      if (!(0, _isNil3.default)(props[disallowedProp]) && props[disallowedProp] !== false) {
	        return [].concat((0, _toConsumableArray3.default)(acc), [disallowedProp]);
	      }
	      return acc;
	    }, []);
	
	    if (disallowed.length > 0) {
	      return new Error(['Prop `' + propName + '` in `' + componentName + '` conflicts with props: `' + disallowed.join('`, `') + '`.', 'They cannot be defined together, choose one or the other.'].join(' '));
	    }
	  };
	};
	
	/**
	 * Ensure a prop adherers to multiple prop type validators.
	 * @param {function[]} validators An array of propType functions.
	 */
	var every = exports.every = function every(validators) {
	  return function (props, propName, componentName) {
	    for (var _len = arguments.length, rest = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      rest[_key - 3] = arguments[_key];
	    }
	
	    if (!Array.isArray(validators)) {
	      throw new Error(['Invalid argument supplied to every, expected an instance of array.', 'See `' + propName + '` prop in `' + componentName + '`.'].join(' '));
	    }
	
	    var errors = (0, _flow3.default)((0, _map3.default)(function (validator) {
	      if (typeof validator !== 'function') {
	        throw new Error('every() argument "validators" should contain functions, found: ' + typeOf(validator) + '.');
	      }
	      return validator.apply(undefined, [props, propName, componentName].concat(rest));
	    }), _compact3.default)(validators);
	
	    // we can only return one error at a time
	    return errors[0];
	  };
	};
	
	/**
	 * Ensure a prop adherers to at least one of the given prop type validators.
	 * @param {function[]} validators An array of propType functions.
	 */
	var some = exports.some = function some(validators) {
	  return function (props, propName, componentName) {
	    for (var _len2 = arguments.length, rest = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
	      rest[_key2 - 3] = arguments[_key2];
	    }
	
	    if (!Array.isArray(validators)) {
	      throw new Error(['Invalid argument supplied to some, expected an instance of array.', 'See `' + propName + '` prop in `' + componentName + '`.'].join(' '));
	    }
	
	    var errors = (0, _compact3.default)((0, _map3.default)(validators, function (validator) {
	      if (!(0, _isFunction3.default)(validator)) {
	        throw new Error('some() argument "validators" should contain functions, found: ' + typeOf(validator) + '.');
	      }
	      return validator.apply(undefined, [props, propName, componentName].concat(rest));
	    }));
	
	    // fail only if all validators failed
	    if (errors.length === validators.length) {
	      var error = new Error('One of these validators must pass:');
	      error.message += '\n' + (0, _map3.default)(errors, function (err, i) {
	        return '[' + (i + 1) + ']: ' + err.message;
	      }).join('\n');
	      return error;
	    }
	  };
	};
	
	/**
	 * Ensure a validator passes only when a component has a given propsShape.
	 * @param {object} propsShape An object describing the prop shape.
	 * @param {function} validator A propType function.
	 */
	var givenProps = exports.givenProps = function givenProps(propsShape, validator) {
	  return function (props, propName, componentName) {
	    for (var _len3 = arguments.length, rest = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
	      rest[_key3 - 3] = arguments[_key3];
	    }
	
	    if (!(0, _isPlainObject3.default)(propsShape)) {
	      throw new Error(['Invalid argument supplied to givenProps, expected an object.', 'See `' + propName + '` prop in `' + componentName + '`.'].join(' '));
	    }
	
	    if (typeof validator !== 'function') {
	      throw new Error(['Invalid argument supplied to givenProps, expected a function.', 'See `' + propName + '` prop in `' + componentName + '`.'].join(' '));
	    }
	
	    var shouldValidate = (0, _keys3.default)(propsShape).every(function (key) {
	      var val = propsShape[key];
	      // require propShape validators to pass or prop values to match
	      return typeof val === 'function' ? !val.apply(undefined, [props, key, componentName].concat(rest)) : val === props[propName];
	    });
	
	    if (!shouldValidate) return;
	
	    var error = validator.apply(undefined, [props, propName, componentName].concat(rest));
	
	    if (error) {
	      // poor mans shallow pretty print, prevents JSON circular reference errors
	      var prettyProps = '{ ' + (0, _keys3.default)((0, _pick3.default)((0, _keys3.default)(propsShape), props)).map(function (key) {
	        var val = props[key];
	        var renderedValue = val;
	        if (typeof val === 'string') renderedValue = '"' + val + '"';else if (Array.isArray(val)) renderedValue = '[' + val.join(', ') + ']';else if ((0, _isObject3.default)(val)) renderedValue = '{...}';
	
	        return key + ': ' + renderedValue;
	      }).join(', ') + ' }';
	
	      error.message = 'Given props ' + prettyProps + ': ' + error.message;
	      return error;
	    }
	  };
	};
	
	/**
	 * Define prop dependencies by requiring other props.
	 * @param {string[]} requiredProps An array of required prop names.
	 */
	var demand = exports.demand = function demand(requiredProps) {
	  return function (props, propName, componentName) {
	    if (!Array.isArray(requiredProps)) {
	      throw new Error(['Invalid `requiredProps` argument supplied to require, expected an instance of array.', ' See `' + propName + '` prop in `' + componentName + '`.'].join(''));
	    }
	
	    // skip if prop is undefined
	    if (props[propName] === undefined) return;
	
	    var missingRequired = requiredProps.filter(function (requiredProp) {
	      return props[requiredProp] === undefined;
	    });
	    if (missingRequired.length > 0) {
	      return new Error('`' + propName + '` prop in `' + componentName + '` requires props: `' + missingRequired.join('`, `') + '`.');
	    }
	  };
	};
	
	/**
	 * Ensure a component can render as a node passed as a prop value in place of children.
	 */
	var contentShorthand = exports.contentShorthand = function contentShorthand() {
	  return every([disallow(['children']), _react.PropTypes.node]).apply(undefined, arguments);
	};
	
	/**
	 * Item shorthand is a description of a component that can be a literal,
	 * a props object, or an element.
	 */
	var itemShorthand = exports.itemShorthand = function itemShorthand() {
	  return every([disallow(['children']), _react.PropTypes.oneOfType([_react.PropTypes.array, _react.PropTypes.node, _react.PropTypes.object])]).apply(undefined, arguments);
	};
	
	/**
	 * Collection shorthand ensures a prop is an array of item shorthand.
	 */
	var collectionShorthand = exports.collectionShorthand = function collectionShorthand() {
	  return every([disallow(['children']), _react.PropTypes.arrayOf(itemShorthand)]).apply(undefined, arguments);
	};
	
	/**
	 * Show a deprecated warning for component props with a help message and optional validator.
	 * @param {string} help A help message to display with the deprecation warning.
	 * @param {function} [validator] A propType function.
	 */
	var deprecate = exports.deprecate = function deprecate(help, validator) {
	  return function (props, propName, componentName) {
	    for (var _len4 = arguments.length, args = Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++) {
	      args[_key4 - 3] = arguments[_key4];
	    }
	
	    if (typeof help !== 'string') {
	      throw new Error(['Invalid `help` argument supplied to deprecate, expected a string.', 'See `' + propName + '` prop in `' + componentName + '`.'].join(' '));
	    }
	
	    // skip if prop is undefined
	    if (props[propName] === undefined) return;
	
	    // deprecation error and help
	    var error = new Error('The `' + propName + '` prop in `' + componentName + '` is deprecated.');
	    if (help) error.message += ' ' + help;
	
	    // add optional validation error message
	    if (validator) {
	      if (typeof validator === 'function') {
	        var validationError = validator.apply(undefined, [props, propName, componentName].concat(args));
	        if (validationError) {
	          error.message = error.message + ' ' + validationError.message;
	        }
	      } else {
	        throw new Error(['Invalid argument supplied to deprecate, expected a function.', 'See `' + propName + '` prop in `' + componentName + '`.'].join(' '));
	      }
	    }
	
	    return error;
	  };
	};

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(608);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(609), __esModule: true };

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(522);
	__webpack_require__(610);
	module.exports = __webpack_require__(480).Array.from;


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(481);
	var $export = __webpack_require__(478);
	var toObject = __webpack_require__(512);
	var call = __webpack_require__(611);
	var isArrayIter = __webpack_require__(612);
	var toLength = __webpack_require__(502);
	var createProperty = __webpack_require__(613);
	var getIterFn = __webpack_require__(614);
	
	$export($export.S + $export.F * !__webpack_require__(616)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(485);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(526);
	var ITERATOR = __webpack_require__(532)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(484);
	var createDesc = __webpack_require__(492);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(615);
	var ITERATOR = __webpack_require__(532)('iterator');
	var Iterators = __webpack_require__(526);
	module.exports = __webpack_require__(480).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(499);
	var TAG = __webpack_require__(532)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(532)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(618),
	    func = convert('isObject', __webpack_require__(298), __webpack_require__(680));
	
	func.placeholder = __webpack_require__(621);
	module.exports = func;


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	var baseConvert = __webpack_require__(619),
	    util = __webpack_require__(622);
	
	/**
	 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
	 * version with conversion `options` applied. If `name` is an object its methods
	 * will be converted.
	 *
	 * @param {string} name The name of the function to wrap.
	 * @param {Function} [func] The function to wrap.
	 * @param {Object} [options] The options object. See `baseConvert` for more details.
	 * @returns {Function|Object} Returns the converted function or object.
	 */
	function convert(name, func, options) {
	  return baseConvert(util, name, func, options);
	}
	
	module.exports = convert;


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	var mapping = __webpack_require__(620),
	    fallbackHolder = __webpack_require__(621);
	
	/** Built-in value reference. */
	var push = Array.prototype.push;
	
	/**
	 * Creates a function, with an arity of `n`, that invokes `func` with the
	 * arguments it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} n The arity of the new function.
	 * @returns {Function} Returns the new function.
	 */
	function baseArity(func, n) {
	  return n == 2
	    ? function(a, b) { return func.apply(undefined, arguments); }
	    : function(a) { return func.apply(undefined, arguments); };
	}
	
	/**
	 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
	 * any additional arguments.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @param {number} n The arity cap.
	 * @returns {Function} Returns the new function.
	 */
	function baseAry(func, n) {
	  return n == 2
	    ? function(a, b) { return func(a, b); }
	    : function(a) { return func(a); };
	}
	
	/**
	 * Creates a clone of `array`.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the cloned array.
	 */
	function cloneArray(array) {
	  var length = array ? array.length : 0,
	      result = Array(length);
	
	  while (length--) {
	    result[length] = array[length];
	  }
	  return result;
	}
	
	/**
	 * Creates a function that clones a given object using the assignment `func`.
	 *
	 * @private
	 * @param {Function} func The assignment function.
	 * @returns {Function} Returns the new cloner function.
	 */
	function createCloner(func) {
	  return function(object) {
	    return func({}, object);
	  };
	}
	
	/**
	 * A specialized version of `_.spread` which flattens the spread array into
	 * the arguments of the invoked `func`.
	 *
	 * @private
	 * @param {Function} func The function to spread arguments over.
	 * @param {number} start The start position of the spread.
	 * @returns {Function} Returns the new function.
	 */
	function flatSpread(func, start) {
	  return function() {
	    var length = arguments.length,
	        lastIndex = length - 1,
	        args = Array(length);
	
	    while (length--) {
	      args[length] = arguments[length];
	    }
	    var array = args[start],
	        otherArgs = args.slice(0, start);
	
	    if (array) {
	      push.apply(otherArgs, array);
	    }
	    if (start != lastIndex) {
	      push.apply(otherArgs, args.slice(start + 1));
	    }
	    return func.apply(this, otherArgs);
	  };
	}
	
	/**
	 * Creates a function that wraps `func` and uses `cloner` to clone the first
	 * argument it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} cloner The function to clone arguments.
	 * @returns {Function} Returns the new immutable function.
	 */
	function wrapImmutable(func, cloner) {
	  return function() {
	    var length = arguments.length;
	    if (!length) {
	      return;
	    }
	    var args = Array(length);
	    while (length--) {
	      args[length] = arguments[length];
	    }
	    var result = args[0] = cloner.apply(undefined, args);
	    func.apply(undefined, args);
	    return result;
	  };
	}
	
	/**
	 * The base implementation of `convert` which accepts a `util` object of methods
	 * required to perform conversions.
	 *
	 * @param {Object} util The util object.
	 * @param {string} name The name of the function to convert.
	 * @param {Function} func The function to convert.
	 * @param {Object} [options] The options object.
	 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
	 * @param {boolean} [options.curry=true] Specify currying.
	 * @param {boolean} [options.fixed=true] Specify fixed arity.
	 * @param {boolean} [options.immutable=true] Specify immutable operations.
	 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
	 * @returns {Function|Object} Returns the converted function or object.
	 */
	function baseConvert(util, name, func, options) {
	  var isLib = typeof name == 'function',
	      isObj = name === Object(name);
	
	  if (isObj) {
	    options = func;
	    func = name;
	    name = undefined;
	  }
	  if (func == null) {
	    throw new TypeError;
	  }
	  options || (options = {});
	
	  var config = {
	    'cap': 'cap' in options ? options.cap : true,
	    'curry': 'curry' in options ? options.curry : true,
	    'fixed': 'fixed' in options ? options.fixed : true,
	    'immutable': 'immutable' in options ? options.immutable : true,
	    'rearg': 'rearg' in options ? options.rearg : true
	  };
	
	  var defaultHolder = isLib ? func : fallbackHolder,
	      forceCurry = ('curry' in options) && options.curry,
	      forceFixed = ('fixed' in options) && options.fixed,
	      forceRearg = ('rearg' in options) && options.rearg,
	      pristine = isLib ? func.runInContext() : undefined;
	
	  var helpers = isLib ? func : {
	    'ary': util.ary,
	    'assign': util.assign,
	    'clone': util.clone,
	    'curry': util.curry,
	    'forEach': util.forEach,
	    'isArray': util.isArray,
	    'isError': util.isError,
	    'isFunction': util.isFunction,
	    'isWeakMap': util.isWeakMap,
	    'iteratee': util.iteratee,
	    'keys': util.keys,
	    'rearg': util.rearg,
	    'toInteger': util.toInteger,
	    'toPath': util.toPath
	  };
	
	  var ary = helpers.ary,
	      assign = helpers.assign,
	      clone = helpers.clone,
	      curry = helpers.curry,
	      each = helpers.forEach,
	      isArray = helpers.isArray,
	      isError = helpers.isError,
	      isFunction = helpers.isFunction,
	      isWeakMap = helpers.isWeakMap,
	      keys = helpers.keys,
	      rearg = helpers.rearg,
	      toInteger = helpers.toInteger,
	      toPath = helpers.toPath;
	
	  var aryMethodKeys = keys(mapping.aryMethod);
	
	  var wrappers = {
	    'castArray': function(castArray) {
	      return function() {
	        var value = arguments[0];
	        return isArray(value)
	          ? castArray(cloneArray(value))
	          : castArray.apply(undefined, arguments);
	      };
	    },
	    'iteratee': function(iteratee) {
	      return function() {
	        var func = arguments[0],
	            arity = arguments[1],
	            result = iteratee(func, arity),
	            length = result.length;
	
	        if (config.cap && typeof arity == 'number') {
	          arity = arity > 2 ? (arity - 2) : 1;
	          return (length && length <= arity) ? result : baseAry(result, arity);
	        }
	        return result;
	      };
	    },
	    'mixin': function(mixin) {
	      return function(source) {
	        var func = this;
	        if (!isFunction(func)) {
	          return mixin(func, Object(source));
	        }
	        var pairs = [];
	        each(keys(source), function(key) {
	          if (isFunction(source[key])) {
	            pairs.push([key, func.prototype[key]]);
	          }
	        });
	
	        mixin(func, Object(source));
	
	        each(pairs, function(pair) {
	          var value = pair[1];
	          if (isFunction(value)) {
	            func.prototype[pair[0]] = value;
	          } else {
	            delete func.prototype[pair[0]];
	          }
	        });
	        return func;
	      };
	    },
	    'nthArg': function(nthArg) {
	      return function(n) {
	        var arity = n < 0 ? 1 : (toInteger(n) + 1);
	        return curry(nthArg(n), arity);
	      };
	    },
	    'rearg': function(rearg) {
	      return function(func, indexes) {
	        var arity = indexes ? indexes.length : 0;
	        return curry(rearg(func, indexes), arity);
	      };
	    },
	    'runInContext': function(runInContext) {
	      return function(context) {
	        return baseConvert(util, runInContext(context), options);
	      };
	    }
	  };
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Casts `func` to a function with an arity capped iteratee if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @returns {Function} Returns the cast function.
	   */
	  function castCap(name, func) {
	    if (config.cap) {
	      var indexes = mapping.iterateeRearg[name];
	      if (indexes) {
	        return iterateeRearg(func, indexes);
	      }
	      var n = !isLib && mapping.iterateeAry[name];
	      if (n) {
	        return iterateeAry(func, n);
	      }
	    }
	    return func;
	  }
	
	  /**
	   * Casts `func` to a curried function if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @param {number} n The arity of `func`.
	   * @returns {Function} Returns the cast function.
	   */
	  function castCurry(name, func, n) {
	    return (forceCurry || (config.curry && n > 1))
	      ? curry(func, n)
	      : func;
	  }
	
	  /**
	   * Casts `func` to a fixed arity function if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @param {number} n The arity cap.
	   * @returns {Function} Returns the cast function.
	   */
	  function castFixed(name, func, n) {
	    if (config.fixed && (forceFixed || !mapping.skipFixed[name])) {
	      var data = mapping.methodSpread[name],
	          start = data && data.start;
	
	      return start  === undefined ? ary(func, n) : flatSpread(func, start);
	    }
	    return func;
	  }
	
	  /**
	   * Casts `func` to an rearged function if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @param {number} n The arity of `func`.
	   * @returns {Function} Returns the cast function.
	   */
	  function castRearg(name, func, n) {
	    return (config.rearg && n > 1 && (forceRearg || !mapping.skipRearg[name]))
	      ? rearg(func, mapping.methodRearg[name] || mapping.aryRearg[n])
	      : func;
	  }
	
	  /**
	   * Creates a clone of `object` by `path`.
	   *
	   * @private
	   * @param {Object} object The object to clone.
	   * @param {Array|string} path The path to clone by.
	   * @returns {Object} Returns the cloned object.
	   */
	  function cloneByPath(object, path) {
	    path = toPath(path);
	
	    var index = -1,
	        length = path.length,
	        lastIndex = length - 1,
	        result = clone(Object(object)),
	        nested = result;
	
	    while (nested != null && ++index < length) {
	      var key = path[index],
	          value = nested[key];
	
	      if (value != null &&
	          !(isFunction(value) || isError(value) || isWeakMap(value))) {
	        nested[key] = clone(index == lastIndex ? value : Object(value));
	      }
	      nested = nested[key];
	    }
	    return result;
	  }
	
	  /**
	   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
	   * version with conversion `options` applied.
	   *
	   * @param {Object} [options] The options object. See `baseConvert` for more details.
	   * @returns {Function} Returns the converted `lodash`.
	   */
	  function convertLib(options) {
	    return _.runInContext.convert(options)(undefined);
	  }
	
	  /**
	   * Create a converter function for `func` of `name`.
	   *
	   * @param {string} name The name of the function to convert.
	   * @param {Function} func The function to convert.
	   * @returns {Function} Returns the new converter function.
	   */
	  function createConverter(name, func) {
	    var realName = mapping.aliasToReal[name] || name,
	        methodName = mapping.remap[realName] || realName,
	        oldOptions = options;
	
	    return function(options) {
	      var newUtil = isLib ? pristine : helpers,
	          newFunc = isLib ? pristine[methodName] : func,
	          newOptions = assign(assign({}, oldOptions), options);
	
	      return baseConvert(newUtil, realName, newFunc, newOptions);
	    };
	  }
	
	  /**
	   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
	   * arguments, ignoring any additional arguments.
	   *
	   * @private
	   * @param {Function} func The function to cap iteratee arguments for.
	   * @param {number} n The arity cap.
	   * @returns {Function} Returns the new function.
	   */
	  function iterateeAry(func, n) {
	    return overArg(func, function(func) {
	      return typeof func == 'function' ? baseAry(func, n) : func;
	    });
	  }
	
	  /**
	   * Creates a function that wraps `func` to invoke its iteratee with arguments
	   * arranged according to the specified `indexes` where the argument value at
	   * the first index is provided as the first argument, the argument value at
	   * the second index is provided as the second argument, and so on.
	   *
	   * @private
	   * @param {Function} func The function to rearrange iteratee arguments for.
	   * @param {number[]} indexes The arranged argument indexes.
	   * @returns {Function} Returns the new function.
	   */
	  function iterateeRearg(func, indexes) {
	    return overArg(func, function(func) {
	      var n = indexes.length;
	      return baseArity(rearg(baseAry(func, n), indexes), n);
	    });
	  }
	
	  /**
	   * Creates a function that invokes `func` with its first argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function() {
	      var length = arguments.length;
	      if (!length) {
	        return func();
	      }
	      var args = Array(length);
	      while (length--) {
	        args[length] = arguments[length];
	      }
	      var index = config.rearg ? 0 : (length - 1);
	      args[index] = transform(args[index]);
	      return func.apply(undefined, args);
	    };
	  }
	
	  /**
	   * Creates a function that wraps `func` and applys the conversions
	   * rules by `name`.
	   *
	   * @private
	   * @param {string} name The name of the function to wrap.
	   * @param {Function} func The function to wrap.
	   * @returns {Function} Returns the converted function.
	   */
	  function wrap(name, func, placeholder) {
	    var result,
	        realName = mapping.aliasToReal[name] || name,
	        wrapped = func,
	        wrapper = wrappers[realName];
	
	    if (wrapper) {
	      wrapped = wrapper(func);
	    }
	    else if (config.immutable) {
	      if (mapping.mutate.array[realName]) {
	        wrapped = wrapImmutable(func, cloneArray);
	      }
	      else if (mapping.mutate.object[realName]) {
	        wrapped = wrapImmutable(func, createCloner(func));
	      }
	      else if (mapping.mutate.set[realName]) {
	        wrapped = wrapImmutable(func, cloneByPath);
	      }
	    }
	    each(aryMethodKeys, function(aryKey) {
	      each(mapping.aryMethod[aryKey], function(otherName) {
	        if (realName == otherName) {
	          var data = mapping.methodSpread[realName],
	              afterRearg = data && data.afterRearg;
	
	          result = afterRearg
	            ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey)
	            : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);
	
	          result = castCap(realName, result);
	          result = castCurry(realName, result, aryKey);
	          return false;
	        }
	      });
	      return !result;
	    });
	
	    result || (result = wrapped);
	    if (result == func) {
	      result = forceCurry ? curry(result, 1) : function() {
	        return func.apply(this, arguments);
	      };
	    }
	    result.convert = createConverter(realName, func);
	    result.placeholder = func.placeholder = placeholder;
	
	    return result;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  if (!isObj) {
	    return wrap(name, func, defaultHolder);
	  }
	  var _ = func;
	
	  // Convert methods by ary cap.
	  var pairs = [];
	  each(aryMethodKeys, function(aryKey) {
	    each(mapping.aryMethod[aryKey], function(key) {
	      var func = _[mapping.remap[key] || key];
	      if (func) {
	        pairs.push([key, wrap(key, func, _)]);
	      }
	    });
	  });
	
	  // Convert remaining methods.
	  each(keys(_), function(key) {
	    var func = _[key];
	    if (typeof func == 'function') {
	      var length = pairs.length;
	      while (length--) {
	        if (pairs[length][0] == key) {
	          return;
	        }
	      }
	      func.convert = createConverter(key, func);
	      pairs.push([key, func]);
	    }
	  });
	
	  // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
	  each(pairs, function(pair) {
	    _[pair[0]] = pair[1];
	  });
	
	  _.convert = convertLib;
	  _.placeholder = _;
	
	  // Assign aliases.
	  each(keys(_), function(key) {
	    each(mapping.realToAlias[key] || [], function(alias) {
	      _[alias] = _[key];
	    });
	  });
	
	  return _;
	}
	
	module.exports = baseConvert;


/***/ }),
/* 620 */
/***/ (function(module, exports) {

	/** Used to map aliases to their real names. */
	exports.aliasToReal = {
	
	  // Lodash aliases.
	  'each': 'forEach',
	  'eachRight': 'forEachRight',
	  'entries': 'toPairs',
	  'entriesIn': 'toPairsIn',
	  'extend': 'assignIn',
	  'extendAll': 'assignInAll',
	  'extendAllWith': 'assignInAllWith',
	  'extendWith': 'assignInWith',
	  'first': 'head',
	
	  // Methods that are curried variants of others.
	  'conforms': 'conformsTo',
	  'matches': 'isMatch',
	  'property': 'get',
	
	  // Ramda aliases.
	  '__': 'placeholder',
	  'F': 'stubFalse',
	  'T': 'stubTrue',
	  'all': 'every',
	  'allPass': 'overEvery',
	  'always': 'constant',
	  'any': 'some',
	  'anyPass': 'overSome',
	  'apply': 'spread',
	  'assoc': 'set',
	  'assocPath': 'set',
	  'complement': 'negate',
	  'compose': 'flowRight',
	  'contains': 'includes',
	  'dissoc': 'unset',
	  'dissocPath': 'unset',
	  'dropLast': 'dropRight',
	  'dropLastWhile': 'dropRightWhile',
	  'equals': 'isEqual',
	  'identical': 'eq',
	  'indexBy': 'keyBy',
	  'init': 'initial',
	  'invertObj': 'invert',
	  'juxt': 'over',
	  'omitAll': 'omit',
	  'nAry': 'ary',
	  'path': 'get',
	  'pathEq': 'matchesProperty',
	  'pathOr': 'getOr',
	  'paths': 'at',
	  'pickAll': 'pick',
	  'pipe': 'flow',
	  'pluck': 'map',
	  'prop': 'get',
	  'propEq': 'matchesProperty',
	  'propOr': 'getOr',
	  'props': 'at',
	  'symmetricDifference': 'xor',
	  'symmetricDifferenceBy': 'xorBy',
	  'symmetricDifferenceWith': 'xorWith',
	  'takeLast': 'takeRight',
	  'takeLastWhile': 'takeRightWhile',
	  'unapply': 'rest',
	  'unnest': 'flatten',
	  'useWith': 'overArgs',
	  'where': 'conformsTo',
	  'whereEq': 'isMatch',
	  'zipObj': 'zipObject'
	};
	
	/** Used to map ary to method names. */
	exports.aryMethod = {
	  '1': [
	    'assignAll', 'assignInAll', 'attempt', 'castArray', 'ceil', 'create',
	    'curry', 'curryRight', 'defaultsAll', 'defaultsDeepAll', 'floor', 'flow',
	    'flowRight', 'fromPairs', 'invert', 'iteratee', 'memoize', 'method', 'mergeAll',
	    'methodOf', 'mixin', 'nthArg', 'over', 'overEvery', 'overSome','rest', 'reverse',
	    'round', 'runInContext', 'spread', 'template', 'trim', 'trimEnd', 'trimStart',
	    'uniqueId', 'words', 'zipAll'
	  ],
	  '2': [
	    'add', 'after', 'ary', 'assign', 'assignAllWith', 'assignIn', 'assignInAllWith',
	    'at', 'before', 'bind', 'bindAll', 'bindKey', 'chunk', 'cloneDeepWith',
	    'cloneWith', 'concat', 'conformsTo', 'countBy', 'curryN', 'curryRightN',
	    'debounce', 'defaults', 'defaultsDeep', 'defaultTo', 'delay', 'difference',
	    'divide', 'drop', 'dropRight', 'dropRightWhile', 'dropWhile', 'endsWith', 'eq',
	    'every', 'filter', 'find', 'findIndex', 'findKey', 'findLast', 'findLastIndex',
	    'findLastKey', 'flatMap', 'flatMapDeep', 'flattenDepth', 'forEach',
	    'forEachRight', 'forIn', 'forInRight', 'forOwn', 'forOwnRight', 'get',
	    'groupBy', 'gt', 'gte', 'has', 'hasIn', 'includes', 'indexOf', 'intersection',
	    'invertBy', 'invoke', 'invokeMap', 'isEqual', 'isMatch', 'join', 'keyBy',
	    'lastIndexOf', 'lt', 'lte', 'map', 'mapKeys', 'mapValues', 'matchesProperty',
	    'maxBy', 'meanBy', 'merge', 'mergeAllWith', 'minBy', 'multiply', 'nth', 'omit',
	    'omitBy', 'overArgs', 'pad', 'padEnd', 'padStart', 'parseInt', 'partial',
	    'partialRight', 'partition', 'pick', 'pickBy', 'propertyOf', 'pull', 'pullAll',
	    'pullAt', 'random', 'range', 'rangeRight', 'rearg', 'reject', 'remove',
	    'repeat', 'restFrom', 'result', 'sampleSize', 'some', 'sortBy', 'sortedIndex',
	    'sortedIndexOf', 'sortedLastIndex', 'sortedLastIndexOf', 'sortedUniqBy',
	    'split', 'spreadFrom', 'startsWith', 'subtract', 'sumBy', 'take', 'takeRight',
	    'takeRightWhile', 'takeWhile', 'tap', 'throttle', 'thru', 'times', 'trimChars',
	    'trimCharsEnd', 'trimCharsStart', 'truncate', 'union', 'uniqBy', 'uniqWith',
	    'unset', 'unzipWith', 'without', 'wrap', 'xor', 'zip', 'zipObject',
	    'zipObjectDeep'
	  ],
	  '3': [
	    'assignInWith', 'assignWith', 'clamp', 'differenceBy', 'differenceWith',
	    'findFrom', 'findIndexFrom', 'findLastFrom', 'findLastIndexFrom', 'getOr',
	    'includesFrom', 'indexOfFrom', 'inRange', 'intersectionBy', 'intersectionWith',
	    'invokeArgs', 'invokeArgsMap', 'isEqualWith', 'isMatchWith', 'flatMapDepth',
	    'lastIndexOfFrom', 'mergeWith', 'orderBy', 'padChars', 'padCharsEnd',
	    'padCharsStart', 'pullAllBy', 'pullAllWith', 'rangeStep', 'rangeStepRight',
	    'reduce', 'reduceRight', 'replace', 'set', 'slice', 'sortedIndexBy',
	    'sortedLastIndexBy', 'transform', 'unionBy', 'unionWith', 'update', 'xorBy',
	    'xorWith', 'zipWith'
	  ],
	  '4': [
	    'fill', 'setWith', 'updateWith'
	  ]
	};
	
	/** Used to map ary to rearg configs. */
	exports.aryRearg = {
	  '2': [1, 0],
	  '3': [2, 0, 1],
	  '4': [3, 2, 0, 1]
	};
	
	/** Used to map method names to their iteratee ary. */
	exports.iterateeAry = {
	  'dropRightWhile': 1,
	  'dropWhile': 1,
	  'every': 1,
	  'filter': 1,
	  'find': 1,
	  'findFrom': 1,
	  'findIndex': 1,
	  'findIndexFrom': 1,
	  'findKey': 1,
	  'findLast': 1,
	  'findLastFrom': 1,
	  'findLastIndex': 1,
	  'findLastIndexFrom': 1,
	  'findLastKey': 1,
	  'flatMap': 1,
	  'flatMapDeep': 1,
	  'flatMapDepth': 1,
	  'forEach': 1,
	  'forEachRight': 1,
	  'forIn': 1,
	  'forInRight': 1,
	  'forOwn': 1,
	  'forOwnRight': 1,
	  'map': 1,
	  'mapKeys': 1,
	  'mapValues': 1,
	  'partition': 1,
	  'reduce': 2,
	  'reduceRight': 2,
	  'reject': 1,
	  'remove': 1,
	  'some': 1,
	  'takeRightWhile': 1,
	  'takeWhile': 1,
	  'times': 1,
	  'transform': 2
	};
	
	/** Used to map method names to iteratee rearg configs. */
	exports.iterateeRearg = {
	  'mapKeys': [1],
	  'reduceRight': [1, 0]
	};
	
	/** Used to map method names to rearg configs. */
	exports.methodRearg = {
	  'assignInAllWith': [1, 0],
	  'assignInWith': [1, 2, 0],
	  'assignAllWith': [1, 0],
	  'assignWith': [1, 2, 0],
	  'differenceBy': [1, 2, 0],
	  'differenceWith': [1, 2, 0],
	  'getOr': [2, 1, 0],
	  'intersectionBy': [1, 2, 0],
	  'intersectionWith': [1, 2, 0],
	  'isEqualWith': [1, 2, 0],
	  'isMatchWith': [2, 1, 0],
	  'mergeAllWith': [1, 0],
	  'mergeWith': [1, 2, 0],
	  'padChars': [2, 1, 0],
	  'padCharsEnd': [2, 1, 0],
	  'padCharsStart': [2, 1, 0],
	  'pullAllBy': [2, 1, 0],
	  'pullAllWith': [2, 1, 0],
	  'rangeStep': [1, 2, 0],
	  'rangeStepRight': [1, 2, 0],
	  'setWith': [3, 1, 2, 0],
	  'sortedIndexBy': [2, 1, 0],
	  'sortedLastIndexBy': [2, 1, 0],
	  'unionBy': [1, 2, 0],
	  'unionWith': [1, 2, 0],
	  'updateWith': [3, 1, 2, 0],
	  'xorBy': [1, 2, 0],
	  'xorWith': [1, 2, 0],
	  'zipWith': [1, 2, 0]
	};
	
	/** Used to map method names to spread configs. */
	exports.methodSpread = {
	  'assignAll': { 'start': 0 },
	  'assignAllWith': { 'start': 0 },
	  'assignInAll': { 'start': 0 },
	  'assignInAllWith': { 'start': 0 },
	  'defaultsAll': { 'start': 0 },
	  'defaultsDeepAll': { 'start': 0 },
	  'invokeArgs': { 'start': 2 },
	  'invokeArgsMap': { 'start': 2 },
	  'mergeAll': { 'start': 0 },
	  'mergeAllWith': { 'start': 0 },
	  'partial': { 'start': 1 },
	  'partialRight': { 'start': 1 },
	  'without': { 'start': 1 },
	  'zipAll': { 'start': 0 }
	};
	
	/** Used to identify methods which mutate arrays or objects. */
	exports.mutate = {
	  'array': {
	    'fill': true,
	    'pull': true,
	    'pullAll': true,
	    'pullAllBy': true,
	    'pullAllWith': true,
	    'pullAt': true,
	    'remove': true,
	    'reverse': true
	  },
	  'object': {
	    'assign': true,
	    'assignAll': true,
	    'assignAllWith': true,
	    'assignIn': true,
	    'assignInAll': true,
	    'assignInAllWith': true,
	    'assignInWith': true,
	    'assignWith': true,
	    'defaults': true,
	    'defaultsAll': true,
	    'defaultsDeep': true,
	    'defaultsDeepAll': true,
	    'merge': true,
	    'mergeAll': true,
	    'mergeAllWith': true,
	    'mergeWith': true,
	  },
	  'set': {
	    'set': true,
	    'setWith': true,
	    'unset': true,
	    'update': true,
	    'updateWith': true
	  }
	};
	
	/** Used to map real names to their aliases. */
	exports.realToAlias = (function() {
	  var hasOwnProperty = Object.prototype.hasOwnProperty,
	      object = exports.aliasToReal,
	      result = {};
	
	  for (var key in object) {
	    var value = object[key];
	    if (hasOwnProperty.call(result, value)) {
	      result[value].push(key);
	    } else {
	      result[value] = [key];
	    }
	  }
	  return result;
	}());
	
	/** Used to map method names to other names. */
	exports.remap = {
	  'assignAll': 'assign',
	  'assignAllWith': 'assignWith',
	  'assignInAll': 'assignIn',
	  'assignInAllWith': 'assignInWith',
	  'curryN': 'curry',
	  'curryRightN': 'curryRight',
	  'defaultsAll': 'defaults',
	  'defaultsDeepAll': 'defaultsDeep',
	  'findFrom': 'find',
	  'findIndexFrom': 'findIndex',
	  'findLastFrom': 'findLast',
	  'findLastIndexFrom': 'findLastIndex',
	  'getOr': 'get',
	  'includesFrom': 'includes',
	  'indexOfFrom': 'indexOf',
	  'invokeArgs': 'invoke',
	  'invokeArgsMap': 'invokeMap',
	  'lastIndexOfFrom': 'lastIndexOf',
	  'mergeAll': 'merge',
	  'mergeAllWith': 'mergeWith',
	  'padChars': 'pad',
	  'padCharsEnd': 'padEnd',
	  'padCharsStart': 'padStart',
	  'propertyOf': 'get',
	  'rangeStep': 'range',
	  'rangeStepRight': 'rangeRight',
	  'restFrom': 'rest',
	  'spreadFrom': 'spread',
	  'trimChars': 'trim',
	  'trimCharsEnd': 'trimEnd',
	  'trimCharsStart': 'trimStart',
	  'zipAll': 'zip'
	};
	
	/** Used to track methods that skip fixing their arity. */
	exports.skipFixed = {
	  'castArray': true,
	  'flow': true,
	  'flowRight': true,
	  'iteratee': true,
	  'mixin': true,
	  'rearg': true,
	  'runInContext': true
	};
	
	/** Used to track methods that skip rearranging arguments. */
	exports.skipRearg = {
	  'add': true,
	  'assign': true,
	  'assignIn': true,
	  'bind': true,
	  'bindKey': true,
	  'concat': true,
	  'difference': true,
	  'divide': true,
	  'eq': true,
	  'gt': true,
	  'gte': true,
	  'isEqual': true,
	  'lt': true,
	  'lte': true,
	  'matchesProperty': true,
	  'merge': true,
	  'multiply': true,
	  'overArgs': true,
	  'partial': true,
	  'partialRight': true,
	  'propertyOf': true,
	  'random': true,
	  'range': true,
	  'rangeRight': true,
	  'subtract': true,
	  'zip': true,
	  'zipObject': true,
	  'zipObjectDeep': true
	};


/***/ }),
/* 621 */
/***/ (function(module, exports) {

	/**
	 * The default argument placeholder value for methods.
	 *
	 * @type {Object}
	 */
	module.exports = {};


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = {
	  'ary': __webpack_require__(623),
	  'assign': __webpack_require__(655),
	  'clone': __webpack_require__(656),
	  'curry': __webpack_require__(672),
	  'forEach': __webpack_require__(441),
	  'isArray': __webpack_require__(282),
	  'isError': __webpack_require__(673),
	  'isFunction': __webpack_require__(297),
	  'isWeakMap': __webpack_require__(674),
	  'iteratee': __webpack_require__(675),
	  'keys': __webpack_require__(292),
	  'rearg': __webpack_require__(676),
	  'toInteger': __webpack_require__(575),
	  'toPath': __webpack_require__(679)
	};


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	var createWrap = __webpack_require__(624);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_ARY_FLAG = 128;
	
	/**
	 * Creates a function that invokes `func`, with up to `n` arguments,
	 * ignoring any additional arguments.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {Function} func The function to cap arguments for.
	 * @param {number} [n=func.length] The arity cap.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Function} Returns the new capped function.
	 * @example
	 *
	 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	 * // => [6, 8, 10]
	 */
	function ary(func, n, guard) {
	  n = guard ? undefined : n;
	  n = (func && n == null) ? func.length : n;
	  return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	}
	
	module.exports = ary;


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(625),
	    createBind = __webpack_require__(627),
	    createCurry = __webpack_require__(629),
	    createHybrid = __webpack_require__(630),
	    createPartial = __webpack_require__(653),
	    getData = __webpack_require__(638),
	    mergeData = __webpack_require__(654),
	    setData = __webpack_require__(645),
	    setWrapToString = __webpack_require__(646),
	    toInteger = __webpack_require__(575);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that either curries or invokes `func` with optional
	 * `this` binding and partially applied arguments.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags.
	 *    1 - `_.bind`
	 *    2 - `_.bindKey`
	 *    4 - `_.curry` or `_.curryRight` of a bound function
	 *    8 - `_.curry`
	 *   16 - `_.curryRight`
	 *   32 - `_.partial`
	 *   64 - `_.partialRight`
	 *  128 - `_.rearg`
	 *  256 - `_.ary`
	 *  512 - `_.flip`
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to be partially applied.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	  if (!isBindKey && typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var length = partials ? partials.length : 0;
	  if (!length) {
	    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	    partials = holders = undefined;
	  }
	  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	  arity = arity === undefined ? arity : toInteger(arity);
	  length -= holders ? holders.length : 0;
	
	  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	    var partialsRight = partials,
	        holdersRight = holders;
	
	    partials = holders = undefined;
	  }
	  var data = isBindKey ? undefined : getData(func);
	
	  var newData = [
	    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	    argPos, ary, arity
	  ];
	
	  if (data) {
	    mergeData(newData, data);
	  }
	  func = newData[0];
	  bitmask = newData[1];
	  thisArg = newData[2];
	  partials = newData[3];
	  holders = newData[4];
	  arity = newData[9] = newData[9] === undefined
	    ? (isBindKey ? 0 : func.length)
	    : nativeMax(newData[9] - length, 0);
	
	  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	  }
	  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	    var result = createBind(func, bitmask, thisArg);
	  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	    result = createCurry(func, bitmask, arity);
	  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	    result = createPartial(func, bitmask, thisArg, partials);
	  } else {
	    result = createHybrid.apply(undefined, newData);
	  }
	  var setter = data ? baseSetData : setData;
	  return setWrapToString(setter(result, newData), func, bitmask);
	}
	
	module.exports = createWrap;


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(381),
	    metaMap = __webpack_require__(626);
	
	/**
	 * The base implementation of `setData` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetData = !metaMap ? identity : function(func, data) {
	  metaMap.set(func, data);
	  return func;
	};
	
	module.exports = baseSetData;


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	var WeakMap = __webpack_require__(361);
	
	/** Used to store function metadata. */
	var metaMap = WeakMap && new WeakMap;
	
	module.exports = metaMap;


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	var createCtor = __webpack_require__(628),
	    root = __webpack_require__(277);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the optional `this`
	 * binding of `thisArg`.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createBind(func, bitmask, thisArg) {
	  var isBind = bitmask & WRAP_BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return fn.apply(isBind ? thisArg : this, arguments);
	  }
	  return wrapper;
	}
	
	module.exports = createBind;


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(453),
	    isObject = __webpack_require__(298);
	
	/**
	 * Creates a function that produces an instance of `Ctor` regardless of
	 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	 *
	 * @private
	 * @param {Function} Ctor The constructor to wrap.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCtor(Ctor) {
	  return function() {
	    // Use a `switch` statement to work with class constructors. See
	    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	    // for more details.
	    var args = arguments;
	    switch (args.length) {
	      case 0: return new Ctor;
	      case 1: return new Ctor(args[0]);
	      case 2: return new Ctor(args[0], args[1]);
	      case 3: return new Ctor(args[0], args[1], args[2]);
	      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	    }
	    var thisBinding = baseCreate(Ctor.prototype),
	        result = Ctor.apply(thisBinding, args);
	
	    // Mimic the constructor's `return` behavior.
	    // See https://es5.github.io/#x13.2.2 for more details.
	    return isObject(result) ? result : thisBinding;
	  };
	}
	
	module.exports = createCtor;


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(396),
	    createCtor = __webpack_require__(628),
	    createHybrid = __webpack_require__(630),
	    createRecurry = __webpack_require__(634),
	    getHolder = __webpack_require__(650),
	    replaceHolders = __webpack_require__(652),
	    root = __webpack_require__(277);
	
	/**
	 * Creates a function that wraps `func` to enable currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {number} arity The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCurry(func, bitmask, arity) {
	  var Ctor = createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length,
	        placeholder = getHolder(wrapper);
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	      ? []
	      : replaceHolders(args, placeholder);
	
	    length -= holders.length;
	    if (length < arity) {
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, undefined,
	        args, holders, undefined, undefined, arity - length);
	    }
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return apply(fn, this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createCurry;


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(631),
	    composeArgsRight = __webpack_require__(632),
	    countHolders = __webpack_require__(633),
	    createCtor = __webpack_require__(628),
	    createRecurry = __webpack_require__(634),
	    getHolder = __webpack_require__(650),
	    reorder = __webpack_require__(651),
	    replaceHolders = __webpack_require__(652),
	    root = __webpack_require__(277);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_ARY_FLAG = 128,
	    WRAP_FLIP_FLAG = 512;
	
	/**
	 * Creates a function that wraps `func` to invoke it with optional `this`
	 * binding of `thisArg`, partial application, and currying.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [partialsRight] The arguments to append to those provided
	 *  to the new function.
	 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	  var isAry = bitmask & WRAP_ARY_FLAG,
	      isBind = bitmask & WRAP_BIND_FLAG,
	      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	      isFlip = bitmask & WRAP_FLIP_FLAG,
	      Ctor = isBindKey ? undefined : createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length;
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    if (isCurried) {
	      var placeholder = getHolder(wrapper),
	          holdersCount = countHolders(args, placeholder);
	    }
	    if (partials) {
	      args = composeArgs(args, partials, holders, isCurried);
	    }
	    if (partialsRight) {
	      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	    }
	    length -= holdersCount;
	    if (isCurried && length < arity) {
	      var newHolders = replaceHolders(args, placeholder);
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	        args, newHolders, argPos, ary, arity - length
	      );
	    }
	    var thisBinding = isBind ? thisArg : this,
	        fn = isBindKey ? thisBinding[func] : func;
	
	    length = args.length;
	    if (argPos) {
	      args = reorder(args, argPos);
	    } else if (isFlip && length > 1) {
	      args.reverse();
	    }
	    if (isAry && ary < length) {
	      args.length = ary;
	    }
	    if (this && this !== root && this instanceof wrapper) {
	      fn = Ctor || createCtor(fn);
	    }
	    return fn.apply(thisBinding, args);
	  }
	  return wrapper;
	}
	
	module.exports = createHybrid;


/***/ }),
/* 631 */
/***/ (function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates an array that is the composition of partially applied arguments,
	 * placeholders, and provided arguments into a single array of arguments.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to prepend to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgs(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersLength = holders.length,
	      leftIndex = -1,
	      leftLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(leftLength + rangeLength),
	      isUncurried = !isCurried;
	
	  while (++leftIndex < leftLength) {
	    result[leftIndex] = partials[leftIndex];
	  }
	  while (++argsIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[holders[argsIndex]] = args[argsIndex];
	    }
	  }
	  while (rangeLength--) {
	    result[leftIndex++] = args[argsIndex++];
	  }
	  return result;
	}
	
	module.exports = composeArgs;


/***/ }),
/* 632 */
/***/ (function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This function is like `composeArgs` except that the arguments composition
	 * is tailored for `_.partialRight`.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to append to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgsRight(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersIndex = -1,
	      holdersLength = holders.length,
	      rightIndex = -1,
	      rightLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(rangeLength + rightLength),
	      isUncurried = !isCurried;
	
	  while (++argsIndex < rangeLength) {
	    result[argsIndex] = args[argsIndex];
	  }
	  var offset = argsIndex;
	  while (++rightIndex < rightLength) {
	    result[offset + rightIndex] = partials[rightIndex];
	  }
	  while (++holdersIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[offset + holders[holdersIndex]] = args[argsIndex++];
	    }
	  }
	  return result;
	}
	
	module.exports = composeArgsRight;


/***/ }),
/* 633 */
/***/ (function(module, exports) {

	/**
	 * Gets the number of `placeholder` occurrences in `array`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} placeholder The placeholder to search for.
	 * @returns {number} Returns the placeholder count.
	 */
	function countHolders(array, placeholder) {
	  var length = array.length,
	      result = 0;
	
	  while (length--) {
	    if (array[length] === placeholder) {
	      ++result;
	    }
	  }
	  return result;
	}
	
	module.exports = countHolders;


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	var isLaziable = __webpack_require__(635),
	    setData = __webpack_require__(645),
	    setWrapToString = __webpack_require__(646);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_BOUND_FLAG = 4,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64;
	
	/**
	 * Creates a function that wraps `func` to continue currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {Function} wrapFunc The function to create the `func` wrapper.
	 * @param {*} placeholder The placeholder value.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	  var isCurry = bitmask & WRAP_CURRY_FLAG,
	      newHolders = isCurry ? holders : undefined,
	      newHoldersRight = isCurry ? undefined : holders,
	      newPartials = isCurry ? partials : undefined,
	      newPartialsRight = isCurry ? undefined : partials;
	
	  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	  }
	  var newData = [
	    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	    newHoldersRight, argPos, ary, arity
	  ];
	
	  var result = wrapFunc.apply(undefined, newData);
	  if (isLaziable(func)) {
	    setData(result, newData);
	  }
	  result.placeholder = placeholder;
	  return setWrapToString(result, func, bitmask);
	}
	
	module.exports = createRecurry;


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(636),
	    getData = __webpack_require__(638),
	    getFuncName = __webpack_require__(640),
	    lodash = __webpack_require__(642);
	
	/**
	 * Checks if `func` has a lazy counterpart.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	 *  else `false`.
	 */
	function isLaziable(func) {
	  var funcName = getFuncName(func),
	      other = lodash[funcName];
	
	  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	    return false;
	  }
	  if (func === other) {
	    return true;
	  }
	  var data = getData(other);
	  return !!data && func === data[0];
	}
	
	module.exports = isLaziable;


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(453),
	    baseLodash = __webpack_require__(637);
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;
	
	/**
	 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	 *
	 * @private
	 * @constructor
	 * @param {*} value The value to wrap.
	 */
	function LazyWrapper(value) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__dir__ = 1;
	  this.__filtered__ = false;
	  this.__iteratees__ = [];
	  this.__takeCount__ = MAX_ARRAY_LENGTH;
	  this.__views__ = [];
	}
	
	// Ensure `LazyWrapper` is an instance of `baseLodash`.
	LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	LazyWrapper.prototype.constructor = LazyWrapper;
	
	module.exports = LazyWrapper;


/***/ }),
/* 637 */
/***/ (function(module, exports) {

	/**
	 * The function whose prototype chain sequence wrappers inherit from.
	 *
	 * @private
	 */
	function baseLodash() {
	  // No operation performed.
	}
	
	module.exports = baseLodash;


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	var metaMap = __webpack_require__(626),
	    noop = __webpack_require__(639);
	
	/**
	 * Gets metadata for `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {*} Returns the metadata for `func`.
	 */
	var getData = !metaMap ? noop : function(func) {
	  return metaMap.get(func);
	};
	
	module.exports = getData;


/***/ }),
/* 639 */
/***/ (function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	var realNames = __webpack_require__(641);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the name of `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {string} Returns the function name.
	 */
	function getFuncName(func) {
	  var result = (func.name + ''),
	      array = realNames[result],
	      length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	  while (length--) {
	    var data = array[length],
	        otherFunc = data.func;
	    if (otherFunc == null || otherFunc == func) {
	      return data.name;
	    }
	  }
	  return result;
	}
	
	module.exports = getFuncName;


/***/ }),
/* 641 */
/***/ (function(module, exports) {

	/** Used to lookup unminified function names. */
	var realNames = {};
	
	module.exports = realNames;


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(636),
	    LodashWrapper = __webpack_require__(643),
	    baseLodash = __webpack_require__(637),
	    isArray = __webpack_require__(282),
	    isObjectLike = __webpack_require__(281),
	    wrapperClone = __webpack_require__(644);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates a `lodash` object which wraps `value` to enable implicit method
	 * chain sequences. Methods that operate on and return arrays, collections,
	 * and functions can be chained together. Methods that retrieve a single value
	 * or may return a primitive value will automatically end the chain sequence
	 * and return the unwrapped value. Otherwise, the value must be unwrapped
	 * with `_#value`.
	 *
	 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	 * enabled using `_.chain`.
	 *
	 * The execution of chained methods is lazy, that is, it's deferred until
	 * `_#value` is implicitly or explicitly called.
	 *
	 * Lazy evaluation allows several methods to support shortcut fusion.
	 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	 * the creation of intermediate arrays and can greatly reduce the number of
	 * iteratee executions. Sections of a chain sequence qualify for shortcut
	 * fusion if the section is applied to an array and iteratees accept only
	 * one argument. The heuristic for whether a section qualifies for shortcut
	 * fusion is subject to change.
	 *
	 * Chaining is supported in custom builds as long as the `_#value` method is
	 * directly or indirectly included in the build.
	 *
	 * In addition to lodash methods, wrappers have `Array` and `String` methods.
	 *
	 * The wrapper `Array` methods are:
	 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	 *
	 * The wrapper `String` methods are:
	 * `replace` and `split`
	 *
	 * The wrapper methods that support shortcut fusion are:
	 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	 *
	 * The chainable wrapper methods are:
	 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	 * `zipObject`, `zipObjectDeep`, and `zipWith`
	 *
	 * The wrapper methods that are **not** chainable by default are:
	 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	 * `upperFirst`, `value`, and `words`
	 *
	 * @name _
	 * @constructor
	 * @category Seq
	 * @param {*} value The value to wrap in a `lodash` instance.
	 * @returns {Object} Returns the new `lodash` wrapper instance.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var wrapped = _([1, 2, 3]);
	 *
	 * // Returns an unwrapped value.
	 * wrapped.reduce(_.add);
	 * // => 6
	 *
	 * // Returns a wrapped value.
	 * var squares = wrapped.map(square);
	 *
	 * _.isArray(squares);
	 * // => false
	 *
	 * _.isArray(squares.value());
	 * // => true
	 */
	function lodash(value) {
	  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	    if (value instanceof LodashWrapper) {
	      return value;
	    }
	    if (hasOwnProperty.call(value, '__wrapped__')) {
	      return wrapperClone(value);
	    }
	  }
	  return new LodashWrapper(value);
	}
	
	// Ensure wrappers are instances of `baseLodash`.
	lodash.prototype = baseLodash.prototype;
	lodash.prototype.constructor = lodash;
	
	module.exports = lodash;


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(453),
	    baseLodash = __webpack_require__(637);
	
	/**
	 * The base constructor for creating `lodash` wrapper objects.
	 *
	 * @private
	 * @param {*} value The value to wrap.
	 * @param {boolean} [chainAll] Enable explicit method chain sequences.
	 */
	function LodashWrapper(value, chainAll) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__chain__ = !!chainAll;
	  this.__index__ = 0;
	  this.__values__ = undefined;
	}
	
	LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	LodashWrapper.prototype.constructor = LodashWrapper;
	
	module.exports = LodashWrapper;


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(636),
	    LodashWrapper = __webpack_require__(643),
	    copyArray = __webpack_require__(451);
	
	/**
	 * Creates a clone of `wrapper`.
	 *
	 * @private
	 * @param {Object} wrapper The wrapper to clone.
	 * @returns {Object} Returns the cloned wrapper.
	 */
	function wrapperClone(wrapper) {
	  if (wrapper instanceof LazyWrapper) {
	    return wrapper.clone();
	  }
	  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	  result.__actions__ = copyArray(wrapper.__actions__);
	  result.__index__  = wrapper.__index__;
	  result.__values__ = wrapper.__values__;
	  return result;
	}
	
	module.exports = wrapperClone;


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(625),
	    shortOut = __webpack_require__(401);
	
	/**
	 * Sets metadata for `func`.
	 *
	 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	 * period of time, it will trip its breaker and transition to an identity
	 * function to avoid garbage collection pauses in V8. See
	 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	 * for more details.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var setData = shortOut(baseSetData);
	
	module.exports = setData;


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	var getWrapDetails = __webpack_require__(647),
	    insertWrapDetails = __webpack_require__(648),
	    setToString = __webpack_require__(397),
	    updateWrapDetails = __webpack_require__(649);
	
	/**
	 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	 * with wrapper details in a comment at the top of the source body.
	 *
	 * @private
	 * @param {Function} wrapper The function to modify.
	 * @param {Function} reference The reference function.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Function} Returns `wrapper`.
	 */
	function setWrapToString(wrapper, reference, bitmask) {
	  var source = (reference + '');
	  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	}
	
	module.exports = setWrapToString;


/***/ }),
/* 647 */
/***/ (function(module, exports) {

	/** Used to match wrap detail comments. */
	var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	    reSplitDetails = /,? & /;
	
	/**
	 * Extracts wrapper details from the `source` body comment.
	 *
	 * @private
	 * @param {string} source The source to inspect.
	 * @returns {Array} Returns the wrapper details.
	 */
	function getWrapDetails(source) {
	  var match = source.match(reWrapDetails);
	  return match ? match[1].split(reSplitDetails) : [];
	}
	
	module.exports = getWrapDetails;


/***/ }),
/* 648 */
/***/ (function(module, exports) {

	/** Used to match wrap detail comments. */
	var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
	
	/**
	 * Inserts wrapper `details` in a comment at the top of the `source` body.
	 *
	 * @private
	 * @param {string} source The source to modify.
	 * @returns {Array} details The details to insert.
	 * @returns {string} Returns the modified source.
	 */
	function insertWrapDetails(source, details) {
	  var length = details.length;
	  if (!length) {
	    return source;
	  }
	  var lastIndex = length - 1;
	  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	  details = details.join(length > 2 ? ', ' : ' ');
	  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	}
	
	module.exports = insertWrapDetails;


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(441),
	    arrayIncludes = __webpack_require__(566);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256,
	    WRAP_FLIP_FLAG = 512;
	
	/** Used to associate wrap methods with their bit flags. */
	var wrapFlags = [
	  ['ary', WRAP_ARY_FLAG],
	  ['bind', WRAP_BIND_FLAG],
	  ['bindKey', WRAP_BIND_KEY_FLAG],
	  ['curry', WRAP_CURRY_FLAG],
	  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	  ['flip', WRAP_FLIP_FLAG],
	  ['partial', WRAP_PARTIAL_FLAG],
	  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	  ['rearg', WRAP_REARG_FLAG]
	];
	
	/**
	 * Updates wrapper `details` based on `bitmask` flags.
	 *
	 * @private
	 * @returns {Array} details The details to modify.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Array} Returns `details`.
	 */
	function updateWrapDetails(details, bitmask) {
	  arrayEach(wrapFlags, function(pair) {
	    var value = '_.' + pair[0];
	    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	      details.push(value);
	    }
	  });
	  return details.sort();
	}
	
	module.exports = updateWrapDetails;


/***/ }),
/* 650 */
/***/ (function(module, exports) {

	/**
	 * Gets the argument placeholder value for `func`.
	 *
	 * @private
	 * @param {Function} func The function to inspect.
	 * @returns {*} Returns the placeholder value.
	 */
	function getHolder(func) {
	  var object = func;
	  return object.placeholder;
	}
	
	module.exports = getHolder;


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	var copyArray = __webpack_require__(451),
	    isIndex = __webpack_require__(286);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Reorder `array` according to the specified indexes where the element at
	 * the first index is assigned as the first element, the element at
	 * the second index is assigned as the second element, and so on.
	 *
	 * @private
	 * @param {Array} array The array to reorder.
	 * @param {Array} indexes The arranged array indexes.
	 * @returns {Array} Returns `array`.
	 */
	function reorder(array, indexes) {
	  var arrLength = array.length,
	      length = nativeMin(indexes.length, arrLength),
	      oldArray = copyArray(array);
	
	  while (length--) {
	    var index = indexes[length];
	    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	  }
	  return array;
	}
	
	module.exports = reorder;


/***/ }),
/* 652 */
/***/ (function(module, exports) {

	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/**
	 * Replaces all `placeholder` elements in `array` with an internal placeholder
	 * and returns an array of their indexes.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {*} placeholder The placeholder to replace.
	 * @returns {Array} Returns the new array of placeholder indexes.
	 */
	function replaceHolders(array, placeholder) {
	  var index = -1,
	      length = array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value === placeholder || value === PLACEHOLDER) {
	      array[index] = PLACEHOLDER;
	      result[resIndex++] = index;
	    }
	  }
	  return result;
	}
	
	module.exports = replaceHolders;


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(396),
	    createCtor = __webpack_require__(628),
	    root = __webpack_require__(277);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the `this` binding
	 * of `thisArg` and `partials` prepended to the arguments it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} partials The arguments to prepend to those provided to
	 *  the new function.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createPartial(func, bitmask, thisArg, partials) {
	  var isBind = bitmask & WRAP_BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var argsIndex = -1,
	        argsLength = arguments.length,
	        leftIndex = -1,
	        leftLength = partials.length,
	        args = Array(leftLength + argsLength),
	        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	    while (++leftIndex < leftLength) {
	      args[leftIndex] = partials[leftIndex];
	    }
	    while (argsLength--) {
	      args[leftIndex++] = arguments[++argsIndex];
	    }
	    return apply(fn, isBind ? thisArg : this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createPartial;


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(631),
	    composeArgsRight = __webpack_require__(632),
	    replaceHolders = __webpack_require__(652);
	
	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_BOUND_FLAG = 4,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Merges the function metadata of `source` into `data`.
	 *
	 * Merging metadata reduces the number of wrappers used to invoke a function.
	 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	 * may be applied regardless of execution order. Methods like `_.ary` and
	 * `_.rearg` modify function arguments, making the order in which they are
	 * executed important, preventing the merging of metadata. However, we make
	 * an exception for a safe combined case where curried functions have `_.ary`
	 * and or `_.rearg` applied.
	 *
	 * @private
	 * @param {Array} data The destination metadata.
	 * @param {Array} source The source metadata.
	 * @returns {Array} Returns `data`.
	 */
	function mergeData(data, source) {
	  var bitmask = data[1],
	      srcBitmask = source[1],
	      newBitmask = bitmask | srcBitmask,
	      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	  var isCombo =
	    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	  // Exit early if metadata can't be merged.
	  if (!(isCommon || isCombo)) {
	    return data;
	  }
	  // Use source `thisArg` if available.
	  if (srcBitmask & WRAP_BIND_FLAG) {
	    data[2] = source[2];
	    // Set when currying a bound function.
	    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	  }
	  // Compose partial arguments.
	  var value = source[3];
	  if (value) {
	    var partials = data[3];
	    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	  }
	  // Compose partial right arguments.
	  value = source[5];
	  if (value) {
	    partials = data[5];
	    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	  }
	  // Use source `argPos` if available.
	  value = source[7];
	  if (value) {
	    data[7] = value;
	  }
	  // Use source `ary` if it's smaller.
	  if (srcBitmask & WRAP_ARY_FLAG) {
	    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	  }
	  // Use source `arity` if one is not provided.
	  if (data[9] == null) {
	    data[9] = source[9];
	  }
	  // Use source `func` and merge bitmasks.
	  data[0] = source[0];
	  data[1] = newBitmask;
	
	  return data;
	}
	
	module.exports = mergeData;


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(459),
	    keys = __webpack_require__(270);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(657);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * Creates a shallow clone of `value`.
	 *
	 * **Note:** This method is loosely based on the
	 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	 * and supports cloning arrays, array buffers, booleans, date objects, maps,
	 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	 * arrays. The own enumerable properties of `arguments` objects are cloned
	 * as plain objects. An empty object is returned for uncloneable values such
	 * as error objects, functions, DOM nodes, and WeakMaps.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to clone.
	 * @returns {*} Returns the cloned value.
	 * @see _.cloneDeep
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var shallow = _.clone(objects);
	 * console.log(shallow[0] === objects[0]);
	 * // => true
	 */
	function clone(value) {
	  return baseClone(value, CLONE_SYMBOLS_FLAG);
	}
	
	module.exports = clone;


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(303),
	    arrayEach = __webpack_require__(441),
	    assignValue = __webpack_require__(438),
	    baseAssign = __webpack_require__(655),
	    baseAssignIn = __webpack_require__(658),
	    cloneBuffer = __webpack_require__(448),
	    copyArray = __webpack_require__(451),
	    copySymbols = __webpack_require__(659),
	    copySymbolsIn = __webpack_require__(660),
	    getAllKeys = __webpack_require__(352),
	    getAllKeysIn = __webpack_require__(662),
	    getTag = __webpack_require__(357),
	    initCloneArray = __webpack_require__(663),
	    initCloneByTag = __webpack_require__(664),
	    initCloneObject = __webpack_require__(452),
	    isArray = __webpack_require__(282),
	    isBuffer = __webpack_require__(283),
	    isMap = __webpack_require__(668),
	    isObject = __webpack_require__(298),
	    isSet = __webpack_require__(670),
	    keys = __webpack_require__(270);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (isSet(value)) {
	    value.forEach(function(subValue) {
	      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	    });
	  } else if (isMap(value)) {
	    value.forEach(function(subValue, key) {
	      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	    });
	  }
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(459),
	    keysIn = __webpack_require__(460);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(459),
	    getSymbols = __webpack_require__(355);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(459),
	    getSymbolsIn = __webpack_require__(661);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(354),
	    getPrototype = __webpack_require__(454),
	    getSymbols = __webpack_require__(355),
	    stubArray = __webpack_require__(356);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(353),
	    getSymbolsIn = __webpack_require__(661),
	    keysIn = __webpack_require__(460);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ }),
/* 663 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(450),
	    cloneDataView = __webpack_require__(665),
	    cloneRegExp = __webpack_require__(666),
	    cloneSymbol = __webpack_require__(667),
	    cloneTypedArray = __webpack_require__(449);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return new Ctor;
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return new Ctor;
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(450);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ }),
/* 666 */
/***/ (function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(276);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMap = __webpack_require__(669),
	    baseUnary = __webpack_require__(290),
	    nodeUtil = __webpack_require__(291);
	
	/* Node.js helper references. */
	var nodeIsMap = nodeUtil && nodeUtil.isMap;
	
	/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */
	var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	module.exports = isMap;


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(357),
	    isObjectLike = __webpack_require__(281);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]';
	
	/**
	 * The base implementation of `_.isMap` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 */
	function baseIsMap(value) {
	  return isObjectLike(value) && getTag(value) == mapTag;
	}
	
	module.exports = baseIsMap;


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsSet = __webpack_require__(671),
	    baseUnary = __webpack_require__(290),
	    nodeUtil = __webpack_require__(291);
	
	/* Node.js helper references. */
	var nodeIsSet = nodeUtil && nodeUtil.isSet;
	
	/**
	 * Checks if `value` is classified as a `Set` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 * @example
	 *
	 * _.isSet(new Set);
	 * // => true
	 *
	 * _.isSet(new WeakSet);
	 * // => false
	 */
	var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	module.exports = isSet;


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(357),
	    isObjectLike = __webpack_require__(281);
	
	/** `Object#toString` result references. */
	var setTag = '[object Set]';
	
	/**
	 * The base implementation of `_.isSet` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 */
	function baseIsSet(value) {
	  return isObjectLike(value) && getTag(value) == setTag;
	}
	
	module.exports = baseIsSet;


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	var createWrap = __webpack_require__(624);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_CURRY_FLAG = 8;
	
	/**
	 * Creates a function that accepts arguments of `func` and either invokes
	 * `func` returning its result, if at least `arity` number of arguments have
	 * been provided, or returns a function that accepts the remaining `func`
	 * arguments, and so on. The arity of `func` may be specified if `func.length`
	 * is not sufficient.
	 *
	 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	 * may be used as a placeholder for provided arguments.
	 *
	 * **Note:** This method doesn't set the "length" property of curried functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Function
	 * @param {Function} func The function to curry.
	 * @param {number} [arity=func.length] The arity of `func`.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Function} Returns the new curried function.
	 * @example
	 *
	 * var abc = function(a, b, c) {
	 *   return [a, b, c];
	 * };
	 *
	 * var curried = _.curry(abc);
	 *
	 * curried(1)(2)(3);
	 * // => [1, 2, 3]
	 *
	 * curried(1, 2)(3);
	 * // => [1, 2, 3]
	 *
	 * curried(1, 2, 3);
	 * // => [1, 2, 3]
	 *
	 * // Curried with placeholders.
	 * curried(1)(_, 3)(2);
	 * // => [1, 2, 3]
	 */
	function curry(func, arity, guard) {
	  arity = guard ? undefined : arity;
	  var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	  result.placeholder = curry.placeholder;
	  return result;
	}
	
	// Assign default placeholders.
	curry.placeholder = {};
	
	module.exports = curry;


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(275),
	    isObjectLike = __webpack_require__(281),
	    isPlainObject = __webpack_require__(456);
	
	/** `Object#toString` result references. */
	var domExcTag = '[object DOMException]',
	    errorTag = '[object Error]';
	
	/**
	 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	 * `SyntaxError`, `TypeError`, or `URIError` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	 * @example
	 *
	 * _.isError(new Error);
	 * // => true
	 *
	 * _.isError(Error);
	 * // => false
	 */
	function isError(value) {
	  if (!isObjectLike(value)) {
	    return false;
	  }
	  var tag = baseGetTag(value);
	  return tag == errorTag || tag == domExcTag ||
	    (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	}
	
	module.exports = isError;


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(357),
	    isObjectLike = __webpack_require__(281);
	
	/** `Object#toString` result references. */
	var weakMapTag = '[object WeakMap]';
	
	/**
	 * Checks if `value` is classified as a `WeakMap` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	 * @example
	 *
	 * _.isWeakMap(new WeakMap);
	 * // => true
	 *
	 * _.isWeakMap(new Map);
	 * // => false
	 */
	function isWeakMap(value) {
	  return isObjectLike(value) && getTag(value) == weakMapTag;
	}
	
	module.exports = isWeakMap;


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(657),
	    baseIteratee = __webpack_require__(300);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a function that invokes `func` with the arguments of the created
	 * function. If `func` is a property name, the created function returns the
	 * property value for a given element. If `func` is an array or object, the
	 * created function returns `true` for elements that contain the equivalent
	 * source properties, otherwise it returns `false`.
	 *
	 * @static
	 * @since 4.0.0
	 * @memberOf _
	 * @category Util
	 * @param {*} [func=_.identity] The value to convert to a callback.
	 * @returns {Function} Returns the callback.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, _.iteratee(['user', 'fred']));
	 * // => [{ 'user': 'fred', 'age': 40 }]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, _.iteratee('user'));
	 * // => ['barney', 'fred']
	 *
	 * // Create custom iteratee shorthands.
	 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	 *     return func.test(string);
	 *   };
	 * });
	 *
	 * _.filter(['abc', 'def'], /ef/);
	 * // => ['def']
	 */
	function iteratee(func) {
	  return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	}
	
	module.exports = iteratee;


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	var createWrap = __webpack_require__(624),
	    flatRest = __webpack_require__(677);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_REARG_FLAG = 256;
	
	/**
	 * Creates a function that invokes `func` with arguments arranged according
	 * to the specified `indexes` where the argument value at the first index is
	 * provided as the first argument, the argument value at the second index is
	 * provided as the second argument, and so on.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {Function} func The function to rearrange arguments for.
	 * @param {...(number|number[])} indexes The arranged argument indexes.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var rearged = _.rearg(function(a, b, c) {
	 *   return [a, b, c];
	 * }, [2, 0, 1]);
	 *
	 * rearged('b', 'c', 'a')
	 * // => ['a', 'b', 'c']
	 */
	var rearg = flatRest(function(func, indexes) {
	  return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	});
	
	module.exports = rearg;


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	var flatten = __webpack_require__(678),
	    overRest = __webpack_require__(395),
	    setToString = __webpack_require__(397);
	
	/**
	 * A specialized version of `baseRest` which flattens the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	function flatRest(func) {
	  return setToString(overRest(func, undefined, flatten), func + '');
	}
	
	module.exports = flatRest;


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(387);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(376),
	    copyArray = __webpack_require__(451),
	    isArray = __webpack_require__(282),
	    isSymbol = __webpack_require__(370),
	    stringToPath = __webpack_require__(371),
	    toKey = __webpack_require__(377),
	    toString = __webpack_require__(374);
	
	/**
	 * Converts `value` to a property path array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Util
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the new property path array.
	 * @example
	 *
	 * _.toPath('a.b.c');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toPath('a[0].b.c');
	 * // => ['a', '0', 'b', 'c']
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return arrayMap(value, toKey);
	  }
	  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	}
	
	module.exports = toPath;


/***/ }),
/* 680 */
/***/ (function(module, exports) {

	module.exports = {
	  'cap': false,
	  'curry': false,
	  'fixed': false,
	  'immutable': false,
	  'rearg': false
	};


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(618),
	    func = convert('pick', __webpack_require__(682));
	
	func.placeholder = __webpack_require__(621);
	module.exports = func;


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	var basePick = __webpack_require__(683),
	    flatRest = __webpack_require__(677);
	
	/**
	 * Creates an object composed of the picked `object` properties.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to pick.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pick(object, ['a', 'c']);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var pick = flatRest(function(object, paths) {
	  return object == null ? {} : basePick(object, paths);
	});
	
	module.exports = pick;


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	var basePickBy = __webpack_require__(684),
	    hasIn = __webpack_require__(378);
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property identifiers.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, paths) {
	  return basePickBy(object, paths, function(value, path) {
	    return hasIn(object, path);
	  });
	}
	
	module.exports = basePick;


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(367),
	    baseSet = __webpack_require__(437),
	    castPath = __webpack_require__(368);
	
	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, paths, predicate) {
	  var index = -1,
	      length = paths.length,
	      result = {};
	
	  while (++index < length) {
	    var path = paths[index],
	        value = baseGet(object, path);
	
	    if (predicate(value, path)) {
	      baseSet(result, castPath(path, object), value);
	    }
	  }
	  return result;
	}
	
	module.exports = basePickBy;


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(618),
	    func = convert('keys', __webpack_require__(270), __webpack_require__(680));
	
	func.placeholder = __webpack_require__(621);
	module.exports = func;


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(618),
	    func = convert('isPlainObject', __webpack_require__(456), __webpack_require__(680));
	
	func.placeholder = __webpack_require__(621);
	module.exports = func;


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(618),
	    func = convert('isFunction', __webpack_require__(297), __webpack_require__(680));
	
	func.placeholder = __webpack_require__(621);
	module.exports = func;


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(618),
	    func = convert('compact', __webpack_require__(689), __webpack_require__(680));
	
	func.placeholder = __webpack_require__(621);
	module.exports = func;


/***/ }),
/* 689 */
/***/ (function(module, exports) {

	/**
	 * Creates an array with all falsey values removed. The values `false`, `null`,
	 * `0`, `""`, `undefined`, and `NaN` are falsey.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to compact.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * _.compact([0, 1, false, 2, '', 3]);
	 * // => [1, 2, 3]
	 */
	function compact(array) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = compact;


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(618),
	    func = convert('take', __webpack_require__(691));
	
	func.placeholder = __webpack_require__(621);
	module.exports = func;


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(692),
	    toInteger = __webpack_require__(575);
	
	/**
	 * Creates a slice of `array` with `n` elements taken from the beginning.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @param {number} [n=1] The number of elements to take.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * _.take([1, 2, 3]);
	 * // => [1]
	 *
	 * _.take([1, 2, 3], 2);
	 * // => [1, 2]
	 *
	 * _.take([1, 2, 3], 5);
	 * // => [1, 2, 3]
	 *
	 * _.take([1, 2, 3], 0);
	 * // => []
	 */
	function take(array, n, guard) {
	  if (!(array && array.length)) {
	    return [];
	  }
	  n = (guard || n === undefined) ? 1 : toInteger(n);
	  return baseSlice(array, 0, n < 0 ? 0 : n);
	}
	
	module.exports = take;


/***/ }),
/* 692 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(618),
	    func = convert('sortBy', __webpack_require__(386));
	
	func.placeholder = __webpack_require__(621);
	module.exports = func;


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(618),
	    func = convert('sum', __webpack_require__(695), __webpack_require__(680));
	
	func.placeholder = __webpack_require__(621);
	module.exports = func;


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSum = __webpack_require__(696),
	    identity = __webpack_require__(381);
	
	/**
	 * Computes the sum of the values in `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.4.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {number} Returns the sum.
	 * @example
	 *
	 * _.sum([4, 2, 8, 6]);
	 * // => 20
	 */
	function sum(array) {
	  return (array && array.length)
	    ? baseSum(array, identity)
	    : 0;
	}
	
	module.exports = sum;


/***/ }),
/* 696 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.sum` and `_.sumBy` without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {number} Returns the sum.
	 */
	function baseSum(array, iteratee) {
	  var result,
	      index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var current = iteratee(array[index]);
	    if (current !== undefined) {
	      result = result === undefined ? current : (result + current);
	    }
	  }
	  return result;
	}
	
	module.exports = baseSum;


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(618),
	    func = convert('min', __webpack_require__(698), __webpack_require__(680));
	
	func.placeholder = __webpack_require__(621);
	module.exports = func;


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(699),
	    baseLt = __webpack_require__(700),
	    identity = __webpack_require__(381);
	
	/**
	 * Computes the minimum value of `array`. If `array` is empty or falsey,
	 * `undefined` is returned.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {*} Returns the minimum value.
	 * @example
	 *
	 * _.min([4, 2, 8, 6]);
	 * // => 2
	 *
	 * _.min([]);
	 * // => undefined
	 */
	function min(array) {
	  return (array && array.length)
	    ? baseExtremum(array, identity, baseLt)
	    : undefined;
	}
	
	module.exports = min;


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(370);
	
	/**
	 * The base implementation of methods like `_.max` and `_.min` which accepts a
	 * `comparator` to determine the extremum value.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The iteratee invoked per iteration.
	 * @param {Function} comparator The comparator used to compare values.
	 * @returns {*} Returns the extremum value.
	 */
	function baseExtremum(array, iteratee, comparator) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var value = array[index],
	        current = iteratee(value);
	
	    if (current != null && (computed === undefined
	          ? (current === current && !isSymbol(current))
	          : comparator(current, computed)
	        )) {
	      var computed = current,
	          result = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseExtremum;


/***/ }),
/* 700 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.lt` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is less than `other`,
	 *  else `false`.
	 */
	function baseLt(value, other) {
	  return value < other;
	}
	
	module.exports = baseLt;


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(618),
	    func = convert('map', __webpack_require__(702));
	
	func.placeholder = __webpack_require__(621);
	module.exports = func;


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(376),
	    baseIteratee = __webpack_require__(300),
	    baseMap = __webpack_require__(390),
	    isArray = __webpack_require__(282);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(618),
	    func = convert('flow', __webpack_require__(704));
	
	func.placeholder = __webpack_require__(621);
	module.exports = func;


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	var createFlow = __webpack_require__(705);
	
	/**
	 * Creates a function that returns the result of invoking the given functions
	 * with the `this` binding of the created function, where each successive
	 * invocation is supplied the return value of the previous.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Util
	 * @param {...(Function|Function[])} [funcs] The functions to invoke.
	 * @returns {Function} Returns the new composite function.
	 * @see _.flowRight
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var addSquare = _.flow([_.add, square]);
	 * addSquare(1, 2);
	 * // => 9
	 */
	var flow = createFlow();
	
	module.exports = flow;


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	var LodashWrapper = __webpack_require__(643),
	    flatRest = __webpack_require__(677),
	    getData = __webpack_require__(638),
	    getFuncName = __webpack_require__(640),
	    isArray = __webpack_require__(282),
	    isLaziable = __webpack_require__(635);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_CURRY_FLAG = 8,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256;
	
	/**
	 * Creates a `_.flow` or `_.flowRight` function.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new flow function.
	 */
	function createFlow(fromRight) {
	  return flatRest(function(funcs) {
	    var length = funcs.length,
	        index = length,
	        prereq = LodashWrapper.prototype.thru;
	
	    if (fromRight) {
	      funcs.reverse();
	    }
	    while (index--) {
	      var func = funcs[index];
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	        var wrapper = new LodashWrapper([], true);
	      }
	    }
	    index = wrapper ? index : length;
	    while (++index < length) {
	      func = funcs[index];
	
	      var funcName = getFuncName(func),
	          data = funcName == 'wrapper' ? getData(func) : undefined;
	
	      if (data && isLaziable(data[0]) &&
	            data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	            !data[4].length && data[9] == 1
	          ) {
	        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	      } else {
	        wrapper = (func.length == 1 && isLaziable(func))
	          ? wrapper[funcName]()
	          : wrapper.thru(func);
	      }
	    }
	    return function() {
	      var args = arguments,
	          value = args[0];
	
	      if (wrapper && args.length == 1 && isArray(value)) {
	        return wrapper.plant(value).value();
	      }
	      var index = 0,
	          result = length ? funcs[index].apply(this, args) : value;
	
	      while (++index < length) {
	        result = funcs[index].call(this, result);
	      }
	      return result;
	    };
	  });
	}
	
	module.exports = createFlow;


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(618),
	    func = convert('includes', __webpack_require__(707));
	
	func.placeholder = __webpack_require__(621);
	module.exports = func;


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(567),
	    isArrayLike = __webpack_require__(296),
	    isString = __webpack_require__(405),
	    toInteger = __webpack_require__(575),
	    values = __webpack_require__(708);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Checks if `value` is in `collection`. If `collection` is a string, it's
	 * checked for a substring of `value`, otherwise
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * is used for equality comparisons. If `fromIndex` is negative, it's used as
	 * the offset from the end of `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {boolean} Returns `true` if `value` is found, else `false`.
	 * @example
	 *
	 * _.includes([1, 2, 3], 1);
	 * // => true
	 *
	 * _.includes([1, 2, 3], 1, 2);
	 * // => false
	 *
	 * _.includes({ 'a': 1, 'b': 2 }, 1);
	 * // => true
	 *
	 * _.includes('abcd', 'bc');
	 * // => true
	 */
	function includes(collection, value, fromIndex, guard) {
	  collection = isArrayLike(collection) ? collection : values(collection);
	  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	  var length = collection.length;
	  if (fromIndex < 0) {
	    fromIndex = nativeMax(length + fromIndex, 0);
	  }
	  return isString(collection)
	    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	}
	
	module.exports = includes;


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(709),
	    keys = __webpack_require__(270);
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object == null ? [] : baseValues(object, keys(object));
	}
	
	module.exports = values;


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(376);
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	module.exports = baseValues;


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(618),
	    func = convert('isNil', __webpack_require__(711), __webpack_require__(680));
	
	func.placeholder = __webpack_require__(621);
	module.exports = func;


/***/ }),
/* 711 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is `null` or `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	 * @example
	 *
	 * _.isNil(null);
	 * // => true
	 *
	 * _.isNil(void 0);
	 * // => true
	 *
	 * _.isNil(NaN);
	 * // => false
	 */
	function isNil(value) {
	  return value == null;
	}
	
	module.exports = isNil;


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isPrivate = exports.isChild = exports.isParent = exports.isModule = exports.isView = exports.isElement = exports.isCollection = exports.isAddon = exports.isType = exports.isMeta = exports.TYPES = undefined;
	
	var _startsWith2 = __webpack_require__(713);
	
	var _startsWith3 = _interopRequireDefault(_startsWith2);
	
	var _has2 = __webpack_require__(714);
	
	var _has3 = _interopRequireDefault(_has2);
	
	var _eq2 = __webpack_require__(715);
	
	var _eq3 = _interopRequireDefault(_eq2);
	
	var _flow2 = __webpack_require__(703);
	
	var _flow3 = _interopRequireDefault(_flow2);
	
	var _curry2 = __webpack_require__(716);
	
	var _curry3 = _interopRequireDefault(_curry2);
	
	var _get2 = __webpack_require__(717);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _includes2 = __webpack_require__(706);
	
	var _includes3 = _interopRequireDefault(_includes2);
	
	var _values2 = __webpack_require__(718);
	
	var _values3 = _interopRequireDefault(_values2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TYPES = exports.TYPES = {
	  ADDON: 'addon',
	  COLLECTION: 'collection',
	  ELEMENT: 'element',
	  VIEW: 'view',
	  MODULE: 'module'
	};
	
	var TYPE_VALUES = (0, _values3.default)(TYPES);
	
	/**
	 * Determine if an object qualifies as a META object.
	 * It must have the required keys and valid values.
	 * @private
	 * @param {Object} _meta A proposed component _meta object.
	 * @returns {Boolean}
	 */
	var isMeta = exports.isMeta = function isMeta(_meta) {
	  return (0, _includes3.default)((0, _get3.default)('type', _meta), TYPE_VALUES);
	};
	
	/**
	 * Extract a component's _meta object and optional key.
	 * Handles literal _meta objects, classes with _meta, objects with _meta
	 * @private
	 * @param {function|object} metaArg A class, a component instance, or meta object..
	 * @returns {object|string|undefined}
	 */
	var getMeta = function getMeta(metaArg) {
	  // literal
	  if (isMeta(metaArg)) return metaArg;
	
	  // from prop
	  else if (isMeta((0, _get3.default)('_meta', metaArg))) return metaArg._meta;
	
	    // from class
	    else if (isMeta((0, _get3.default)('constructor._meta', metaArg))) return metaArg.constructor._meta;
	};
	
	var metaHasKeyValue = (0, _curry3.default)(function (key, val, metaArg) {
	  return (0, _flow3.default)(getMeta, (0, _get3.default)(key), (0, _eq3.default)(val))(metaArg);
	});
	var isType = exports.isType = metaHasKeyValue('type');
	
	// ----------------------------------------
	// Export
	// ----------------------------------------
	
	// type
	var isAddon = exports.isAddon = isType(TYPES.ADDON);
	var isCollection = exports.isCollection = isType(TYPES.COLLECTION);
	var isElement = exports.isElement = isType(TYPES.ELEMENT);
	var isView = exports.isView = isType(TYPES.VIEW);
	var isModule = exports.isModule = isType(TYPES.MODULE);
	
	// parent
	var isParent = exports.isParent = (0, _flow3.default)(getMeta, (0, _has3.default)('parent'), (0, _eq3.default)(false));
	var isChild = exports.isChild = (0, _flow3.default)(getMeta, (0, _has3.default)('parent'));
	
	// other
	var isPrivate = exports.isPrivate = (0, _flow3.default)(getMeta, (0, _get3.default)('name'), (0, _startsWith3.default)('_'));

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(618),
	    func = convert('startsWith', __webpack_require__(573));
	
	func.placeholder = __webpack_require__(621);
	module.exports = func;


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(618),
	    func = convert('has', __webpack_require__(560));
	
	func.placeholder = __webpack_require__(621);
	module.exports = func;


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(618),
	    func = convert('eq', __webpack_require__(308));
	
	func.placeholder = __webpack_require__(621);
	module.exports = func;


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(618),
	    func = convert('curry', __webpack_require__(672));
	
	func.placeholder = __webpack_require__(621);
	module.exports = func;


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(618),
	    func = convert('get', __webpack_require__(366));
	
	func.placeholder = __webpack_require__(621);
	module.exports = func;


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(618),
	    func = convert('values', __webpack_require__(708), __webpack_require__(680));
	
	func.placeholder = __webpack_require__(621);
	module.exports = func;


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ICONS_AND_ALIASES = exports.ICON_ALIASES = exports.ICONS = exports.NETWORKS_AND_WEBSITE_ICONS = exports.PAYMENT_OPTIONS_ICONS = exports.CURRENCY_ICONS = exports.TEXT_EDITOR_ICONS = exports.TABLES_ICONS = exports.MAP_LOCATIONS_TRANSPORTATION_ICONS = exports.AUDIO_ICONS = exports.RATING_ICONS = exports.TECHNOLOGIES_ICONS = exports.FILE_SYSTEM_ICONS = exports.COMPUTER_ICONS = exports.MOBILE_ICONS = exports.POINTERS_ICONS = exports.MEDIA_ICONS = exports.ITEM_SELECTION_ICONS = exports.SHAPES_ICONS = exports.LITERAL_OBJECTS_ICONS = exports.VIEW_ADJUSTMENT_ICONS = exports.ACCESSIBILITY_ICONS = exports.GENDER_SEXUALITY_ICONS = exports.USERS_ICONS = exports.MESSAGES_ICONS = exports.USER_ACTIONS_ICONS = exports.WEB_CONTENT_ICONS = exports.WIDTHS = exports.VERTICAL_ALIGNMENTS = exports.TEXT_ALIGNMENTS = exports.SIZES = exports.FLOATS = exports.COLORS = undefined;
	
	var _toConsumableArray2 = __webpack_require__(607);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _values2 = __webpack_require__(708);
	
	var _values3 = _interopRequireDefault(_values2);
	
	var _keys2 = __webpack_require__(270);
	
	var _keys3 = _interopRequireDefault(_keys2);
	
	var _numberToWord = __webpack_require__(584);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var COLORS = exports.COLORS = ['red', 'orange', 'yellow', 'olive', 'green', 'teal', 'blue', 'violet', 'purple', 'pink', 'brown', 'grey', 'black'];
	var FLOATS = exports.FLOATS = ['left', 'right'];
	var SIZES = exports.SIZES = ['mini', 'tiny', 'small', 'medium', 'large', 'big', 'huge', 'massive'];
	var TEXT_ALIGNMENTS = exports.TEXT_ALIGNMENTS = ['left', 'center', 'right', 'justified'];
	var VERTICAL_ALIGNMENTS = exports.VERTICAL_ALIGNMENTS = ['bottom', 'middle', 'top'];
	
	var WIDTHS = exports.WIDTHS = [].concat((0, _toConsumableArray3.default)((0, _keys3.default)(_numberToWord.numberToWordMap)), (0, _toConsumableArray3.default)((0, _keys3.default)(_numberToWord.numberToWordMap).map(Number)), (0, _toConsumableArray3.default)((0, _values3.default)(_numberToWord.numberToWordMap)));
	
	// Generated from:
	// https://github.com/Semantic-Org/Semantic-UI/blob/master/dist/components/icon.css
	var WEB_CONTENT_ICONS = exports.WEB_CONTENT_ICONS = ['search', 'mail outline', 'signal', 'setting', 'home', 'inbox', 'browser', 'tag', 'tags', 'image', 'calendar', 'comment', 'shop', 'comments', 'external', 'privacy', 'settings', 'comments', 'external', 'trophy', 'payment', 'feed', 'alarm outline', 'tasks', 'cloud', 'lab', 'mail', 'dashboard', 'comment outline', 'comments outline', 'sitemap', 'idea', 'alarm', 'terminal', 'code', 'protect', 'calendar outline', 'ticket', 'external square', 'bug', 'mail square', 'history', 'options', 'text telephone', 'find', 'wifi', 'alarm mute', 'alarm mute outline', 'copyright', 'at', 'eyedropper', 'paint brush', 'heartbeat', 'mouse pointer', 'hourglass empty', 'hourglass start', 'hourglass half', 'hourglass end', 'hourglass full', 'hand pointer', 'trademark', 'registered', 'creative commons', 'add to calendar', 'remove from calendar', 'delete calendar', 'checked calendar', 'industry', 'shopping bag', 'shopping basket', 'hashtag', 'percent'];
	var USER_ACTIONS_ICONS = exports.USER_ACTIONS_ICONS = ['wait', 'download', 'repeat', 'refresh', 'lock', 'bookmark', 'print', 'write', 'adjust', 'theme', 'edit', 'external share', 'ban', 'mail forward', 'share', 'expand', 'compress', 'unhide', 'hide', 'random', 'retweet', 'sign out', 'pin', 'sign in', 'upload', 'call', 'remove bookmark', 'call square', 'unlock', 'configure', 'filter', 'wizard', 'undo', 'exchange', 'cloud download', 'cloud upload', 'reply', 'reply all', 'erase', 'unlock alternate', 'write square', 'share square', 'archive', 'translate', 'recycle', 'send', 'send outline', 'share alternate', 'share alternate square', 'add to cart', 'in cart', 'add user', 'remove user', 'object group', 'object ungroup', 'clone', 'talk', 'talk outline'];
	var MESSAGES_ICONS = exports.MESSAGES_ICONS = ['help circle', 'info circle', 'warning circle', 'warning sign', 'announcement', 'help', 'info', 'warning', 'birthday', 'help circle outline'];
	var USERS_ICONS = exports.USERS_ICONS = ['user', 'users', 'doctor', 'handicap', 'student', 'child', 'spy'];
	var GENDER_SEXUALITY_ICONS = exports.GENDER_SEXUALITY_ICONS = ['female', 'male', 'woman', 'man', 'non binary transgender', 'intergender', 'transgender', 'lesbian', 'gay', 'heterosexual', 'other gender', 'other gender vertical', 'other gender horizontal', 'neuter', 'genderless'];
	var ACCESSIBILITY_ICONS = exports.ACCESSIBILITY_ICONS = ['universal access', 'wheelchair', 'blind', 'audio description', 'volume control phone', 'braille', 'asl', 'assistive listening systems', 'deafness', 'sign language', 'low vision'];
	var VIEW_ADJUSTMENT_ICONS = exports.VIEW_ADJUSTMENT_ICONS = ['block layout', 'grid layout', 'list layout', 'zoom', 'zoom out', 'resize vertical', 'resize horizontal', 'maximize', 'crop'];
	var LITERAL_OBJECTS_ICONS = exports.LITERAL_OBJECTS_ICONS = ['cocktail', 'road', 'flag', 'book', 'gift', 'leaf', 'fire', 'plane', 'magnet', 'lemon', 'world', 'travel', 'shipping', 'money', 'legal', 'lightning', 'umbrella', 'treatment', 'suitcase', 'bar', 'flag outline', 'flag checkered', 'puzzle', 'fire extinguisher', 'rocket', 'anchor', 'bullseye', 'sun', 'moon', 'fax', 'life ring', 'bomb', 'soccer', 'calculator', 'diamond', 'sticky note', 'sticky note outline', 'law', 'hand peace', 'hand rock', 'hand paper', 'hand scissors', 'hand lizard', 'hand spock', 'tv'];
	var SHAPES_ICONS = exports.SHAPES_ICONS = ['crosshairs', 'asterisk', 'square outline', 'certificate', 'square', 'quote left', 'quote right', 'spinner', 'circle', 'ellipsis horizontal', 'ellipsis vertical', 'cube', 'cubes', 'circle notched', 'circle thin'];
	var ITEM_SELECTION_ICONS = exports.ITEM_SELECTION_ICONS = ['checkmark', 'remove', 'checkmark box', 'move', 'add circle', 'minus circle', 'remove circle', 'check circle', 'remove circle outline', 'check circle outline', 'plus', 'minus', 'add square', 'radio', 'minus square', 'minus square outline', 'check square', 'selected radio', 'plus square outline', 'toggle off', 'toggle on'];
	var MEDIA_ICONS = exports.MEDIA_ICONS = ['film', 'sound', 'photo', 'bar chart', 'camera retro', 'newspaper', 'area chart', 'pie chart', 'line chart'];
	var POINTERS_ICONS = exports.POINTERS_ICONS = ['arrow circle outline down', 'arrow circle outline up', 'chevron left', 'chevron right', 'arrow left', 'arrow right', 'arrow up', 'arrow down', 'chevron up', 'chevron down', 'pointing right', 'pointing left', 'pointing up', 'pointing down', 'arrow circle left', 'arrow circle right', 'arrow circle up', 'arrow circle down', 'caret down', 'caret up', 'caret left', 'caret right', 'angle double left', 'angle double right', 'angle double up', 'angle double down', 'angle left', 'angle right', 'angle up', 'angle down', 'chevron circle left', 'chevron circle right', 'chevron circle up', 'chevron circle down', 'toggle down', 'toggle up', 'toggle right', 'long arrow down', 'long arrow up', 'long arrow left', 'long arrow right', 'arrow circle outline right', 'arrow circle outline left', 'toggle left'];
	var MOBILE_ICONS = exports.MOBILE_ICONS = ['tablet', 'mobile', 'battery full', 'battery high', 'battery medium', 'battery low', 'battery empty'];
	var COMPUTER_ICONS = exports.COMPUTER_ICONS = ['power', 'trash outline', 'disk outline', 'desktop', 'laptop', 'game', 'keyboard', 'plug'];
	var FILE_SYSTEM_ICONS = exports.FILE_SYSTEM_ICONS = ['trash', 'file outline', 'folder', 'folder open', 'file text outline', 'folder outline', 'folder open outline', 'level up', 'level down', 'file', 'file text', 'file pdf outline', 'file word outline', 'file excel outline', 'file powerpoint outline', 'file image outline', 'file archive outline', 'file audio outline', 'file video outline', 'file code outline'];
	var TECHNOLOGIES_ICONS = exports.TECHNOLOGIES_ICONS = ['qrcode', 'barcode', 'rss', 'fork', 'html5', 'css3', 'rss square', 'openid', 'database', 'server', 'usb', 'bluetooth', 'bluetooth alternative'];
	var RATING_ICONS = exports.RATING_ICONS = ['heart', 'star', 'empty star', 'thumbs outline up', 'thumbs outline down', 'star half', 'empty heart', 'smile', 'frown', 'meh', 'star half empty', 'thumbs up', 'thumbs down'];
	var AUDIO_ICONS = exports.AUDIO_ICONS = ['music', 'video play outline', 'volume off', 'volume down', 'volume up', 'record', 'step backward', 'fast backward', 'backward', 'play', 'pause', 'stop', 'forward', 'fast forward', 'step forward', 'eject', 'unmute', 'mute', 'video play', 'closed captioning', 'pause circle', 'pause circle outline', 'stop circle', 'stop circle outline'];
	var MAP_LOCATIONS_TRANSPORTATION_ICONS = exports.MAP_LOCATIONS_TRANSPORTATION_ICONS = ['marker', 'coffee', 'food', 'building outline', 'hospital', 'emergency', 'first aid', 'military', 'h', 'location arrow', 'compass', 'space shuttle', 'university', 'building', 'paw', 'spoon', 'car', 'taxi', 'tree', 'bicycle', 'bus', 'ship', 'motorcycle', 'street view', 'hotel', 'train', 'subway', 'map pin', 'map signs', 'map outline', 'map'];
	var TABLES_ICONS = exports.TABLES_ICONS = ['table', 'columns', 'sort', 'sort descending', 'sort ascending', 'sort alphabet ascending', 'sort alphabet descending', 'sort content ascending', 'sort content descending', 'sort numeric ascending', 'sort numeric descending'];
	var TEXT_EDITOR_ICONS = exports.TEXT_EDITOR_ICONS = ['font', 'bold', 'italic', 'text height', 'text width', 'align left', 'align center', 'align right', 'align justify', 'list', 'outdent', 'indent', 'linkify', 'cut', 'copy', 'attach', 'save', 'content', 'unordered list', 'ordered list', 'strikethrough', 'underline', 'paste', 'unlinkify', 'superscript', 'subscript', 'header', 'paragraph', 'text cursor'];
	var CURRENCY_ICONS = exports.CURRENCY_ICONS = ['euro', 'pound', 'dollar', 'rupee', 'yen', 'ruble', 'won', 'bitcoin', 'lira', 'shekel'];
	var PAYMENT_OPTIONS_ICONS = exports.PAYMENT_OPTIONS_ICONS = ['paypal', 'google wallet', 'visa', 'mastercard', 'discover', 'american express', 'paypal card', 'stripe', 'japan credit bureau', 'diners club', 'credit card alternative'];
	var NETWORKS_AND_WEBSITE_ICONS = exports.NETWORKS_AND_WEBSITE_ICONS = ['twitter square', 'facebook square', 'linkedin square', 'github square', 'twitter', 'facebook f', 'github', 'pinterest', 'pinterest square', 'google plus square', 'google plus', 'linkedin', 'github alternate', 'maxcdn', 'youtube square', 'youtube', 'xing', 'xing square', 'youtube play', 'dropbox', 'stack overflow', 'instagram', 'flickr', 'adn', 'bitbucket', 'bitbucket square', 'tumblr', 'tumblr square', 'apple', 'windows', 'android', 'linux', 'dribble', 'skype', 'foursquare', 'trello', 'gittip', 'vk', 'weibo', 'renren', 'pagelines', 'stack exchange', 'vimeo square', 'slack', 'wordpress', 'yahoo', 'google', 'reddit', 'reddit square', 'stumbleupon circle', 'stumbleupon', 'delicious', 'digg', 'pied piper', 'pied piper alternate', 'drupal', 'joomla', 'behance', 'behance square', 'steam', 'steam square', 'spotify', 'deviantart', 'soundcloud', 'vine', 'codepen', 'jsfiddle', 'rebel', 'empire', 'git square', 'git', 'hacker news', 'tencent weibo', 'qq', 'wechat', 'slideshare', 'twitch', 'yelp', 'lastfm', 'lastfm square', 'ioxhost', 'angellist', 'meanpath', 'buysellads', 'connectdevelop', 'dashcube', 'forumbee', 'leanpub', 'sellsy', 'shirtsinbulk', 'simplybuilt', 'skyatlas', 'facebook', 'pinterest', 'whatsapp', 'viacoin', 'medium', 'y combinator', 'optinmonster', 'opencart', 'expeditedssl', 'gg', 'gg circle', 'tripadvisor', 'odnoklassniki', 'odnoklassniki square', 'pocket', 'wikipedia', 'safari', 'chrome', 'firefox', 'opera', 'internet explorer', 'contao', '500px', 'amazon', 'houzz', 'vimeo', 'black tie', 'fonticons', 'reddit alien', 'microsoft edge', 'codiepie', 'modx', 'fort awesome', 'product hunt', 'mixcloud', 'scribd', 'gitlab', 'wpbeginner', 'wpforms', 'envira gallery', 'glide', 'glide g', 'viadeo', 'viadeo square', 'snapchat', 'snapchat ghost', 'snapchat square', 'pied piper hat', 'first order', 'yoast', 'themeisle', 'google plus circle', 'font awesome'];
	var ICONS = exports.ICONS = [].concat(WEB_CONTENT_ICONS, USER_ACTIONS_ICONS, MESSAGES_ICONS, USERS_ICONS, GENDER_SEXUALITY_ICONS, ACCESSIBILITY_ICONS, VIEW_ADJUSTMENT_ICONS, LITERAL_OBJECTS_ICONS, SHAPES_ICONS, ITEM_SELECTION_ICONS, MEDIA_ICONS, POINTERS_ICONS, MOBILE_ICONS, COMPUTER_ICONS, FILE_SYSTEM_ICONS, TECHNOLOGIES_ICONS, RATING_ICONS, AUDIO_ICONS, MAP_LOCATIONS_TRANSPORTATION_ICONS, TABLES_ICONS, TEXT_EDITOR_ICONS, CURRENCY_ICONS, PAYMENT_OPTIONS_ICONS, NETWORKS_AND_WEBSITE_ICONS);
	var ICON_ALIASES = exports.ICON_ALIASES = ['like', 'favorite', 'video', 'check', 'close', 'cancel', 'delete', 'x', 'zoom in', 'magnify', 'shutdown', 'clock', 'time', 'play circle outline', 'headphone', 'camera', 'video camera', 'picture', 'pencil', 'compose', 'point', 'tint', 'signup', 'plus circle', 'question circle', 'dont', 'minimize', 'add', 'exclamation circle', 'attention', 'eye', 'exclamation triangle', 'shuffle', 'chat', 'cart', 'shopping cart', 'bar graph', 'key', 'cogs', 'discussions', 'like outline', 'dislike outline', 'heart outline', 'log out', 'thumb tack', 'winner', 'phone', 'bookmark outline', 'phone square', 'credit card', 'hdd outline', 'bullhorn', 'bell outline', 'hand outline right', 'hand outline left', 'hand outline up', 'hand outline down', 'globe', 'wrench', 'briefcase', 'group', 'linkify', 'chain', 'flask', 'sidebar', 'bars', 'list ul', 'list ol', 'numbered list', 'magic', 'truck', 'currency', 'triangle down', 'dropdown', 'triangle up', 'triangle left', 'triangle right', 'envelope', 'conversation', 'rain', 'clipboard', 'lightbulb', 'bell', 'ambulance', 'medkit', 'fighter jet', 'beer', 'plus square', 'computer', 'circle outline', 'gamepad', 'star half full', 'broken chain', 'question', 'exclamation', 'eraser', 'microphone', 'microphone slash', 'shield', 'target', 'play circle', 'pencil square', 'eur', 'gbp', 'usd', 'inr', 'cny', 'rmb', 'jpy', 'rouble', 'rub', 'krw', 'btc', 'gratipay', 'zip', 'dot circle outline', 'try', 'graduation', 'circle outline', 'sliders', 'weixin', 'tty', 'teletype', 'binoculars', 'power cord', 'wifi', 'visa card', 'mastercard card', 'discover card', 'amex', 'american express card', 'stripe card', 'bell slash', 'bell slash outline', 'area graph', 'pie graph', 'line graph', 'cc', 'sheqel', 'ils', 'plus cart', 'arrow down cart', 'detective', 'venus', 'mars', 'mercury', 'intersex', 'venus double', 'female homosexual', 'mars double', 'male homosexual', 'venus mars', 'mars stroke', 'mars alternate', 'mars vertical', 'mars stroke vertical', 'mars horizontal', 'mars stroke horizontal', 'asexual', 'facebook official', 'user plus', 'user times', 'user close', 'user cancel', 'user delete', 'user x', 'bed', 'yc', 'ycombinator', 'battery four', 'battery three', 'battery three quarters', 'battery two', 'battery half', 'battery one', 'battery quarter', 'battery zero', 'i cursor', 'jcb', 'japan credit bureau card', 'diners club card', 'balance', 'hourglass outline', 'hourglass zero', 'hourglass one', 'hourglass two', 'hourglass three', 'hourglass four', 'grab', 'hand victory', 'tm', 'r circle', 'television', 'five hundred pixels', 'calendar plus', 'calendar minus', 'calendar times', 'calendar check', 'factory', 'commenting', 'commenting outline', 'edge', 'ms edge', 'wordpress beginner', 'wordpress forms', 'envira', 'question circle outline', 'assistive listening devices', 'als', 'ald', 'asl interpreting', 'deaf', 'american sign language interpreting', 'hard of hearing', 'signing', 'new pied piper', 'theme isle', 'google plus official', 'fa'];
	var ICONS_AND_ALIASES = exports.ICONS_AND_ALIASES = [].concat((0, _toConsumableArray3.default)(ICONS), ICON_ALIASES);

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Button = __webpack_require__(721);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Button2.default;

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(607);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(513);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(514);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(518);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(552);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _Icon = __webpack_require__(722);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Label = __webpack_require__(725);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _ButtonContent = __webpack_require__(738);
	
	var _ButtonContent2 = _interopRequireDefault(_ButtonContent);
	
	var _ButtonGroup = __webpack_require__(739);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _ButtonOr = __webpack_require__(740);
	
	var _ButtonOr2 = _interopRequireDefault(_ButtonOr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var debug = (0, _lib.makeDebugger)('button');
	
	/**
	 * A Button indicates a possible user action.
	 * @see Form
	 * @see Icon
	 * @see Label
	 */
	
	var Button = function (_Component) {
	  (0, _inherits3.default)(Button, _Component);
	
	  function Button() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Button);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Button.__proto__ || Object.getPrototypeOf(Button)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
	      var _this$props = _this.props,
	          disabled = _this$props.disabled,
	          onClick = _this$props.onClick;
	
	
	      if (disabled) {
	        e.preventDefault();
	        return;
	      }
	
	      if (onClick) onClick(e, _this.props);
	    }, _this.computeTabIndex = function (ElementType) {
	      var _this$props2 = _this.props,
	          disabled = _this$props2.disabled,
	          tabIndex = _this$props2.tabIndex;
	
	
	      if (!(0, _isNil3.default)(tabIndex)) return tabIndex;
	      if (disabled) return -1;
	      if (ElementType === 'div') return 0;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Button, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          animated = _props.animated,
	          attached = _props.attached,
	          basic = _props.basic,
	          children = _props.children,
	          circular = _props.circular,
	          className = _props.className,
	          color = _props.color,
	          compact = _props.compact,
	          content = _props.content,
	          disabled = _props.disabled,
	          floated = _props.floated,
	          fluid = _props.fluid,
	          icon = _props.icon,
	          inverted = _props.inverted,
	          label = _props.label,
	          labelPosition = _props.labelPosition,
	          loading = _props.loading,
	          negative = _props.negative,
	          positive = _props.positive,
	          primary = _props.primary,
	          secondary = _props.secondary,
	          size = _props.size,
	          toggle = _props.toggle;
	
	
	      var labeledClasses = (0, _classnames2.default)((0, _lib.useKeyOrValueAndKey)(labelPosition || !!label, 'labeled'));
	
	      var baseClasses = (0, _classnames2.default)(color, size, (0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(basic, 'basic'), (0, _lib.useKeyOnly)(circular, 'circular'), (0, _lib.useKeyOnly)(compact, 'compact'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(icon === true || icon && (labelPosition || !children && !content), 'icon'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(loading, 'loading'), (0, _lib.useKeyOnly)(negative, 'negative'), (0, _lib.useKeyOnly)(positive, 'positive'), (0, _lib.useKeyOnly)(primary, 'primary'), (0, _lib.useKeyOnly)(secondary, 'secondary'), (0, _lib.useKeyOnly)(toggle, 'toggle'), (0, _lib.useKeyOrValueAndKey)(animated, 'animated'), (0, _lib.useKeyOrValueAndKey)(attached, 'attached'), (0, _lib.useValueAndKey)(floated, 'floated'));
	      var rest = (0, _lib.getUnhandledProps)(Button, this.props);
	      var ElementType = (0, _lib.getElementType)(Button, this.props, function () {
	        if (!(0, _isNil3.default)(label) || !(0, _isNil3.default)(attached)) return 'div';
	      });
	      var tabIndex = this.computeTabIndex(ElementType);
	
	      if (!(0, _isNil3.default)(children)) {
	        var _classes = (0, _classnames2.default)('ui', baseClasses, labeledClasses, 'button', className);
	        debug('render children:', { classes: _classes });
	        return _react2.default.createElement(
	          ElementType,
	          (0, _extends3.default)({}, rest, { className: _classes, tabIndex: tabIndex, onClick: this.handleClick }),
	          children
	        );
	      }
	
	      var labelElement = _Label2.default.create(label, {
	        basic: true,
	        pointing: labelPosition === 'left' ? 'right' : 'left'
	      });
	      if (labelElement) {
	        var _classes2 = (0, _classnames2.default)('ui', baseClasses, 'button', className);
	        var containerClasses = (0, _classnames2.default)('ui', labeledClasses, 'button', className);
	        debug('render label:', { classes: _classes2, containerClasses: containerClasses }, this.props);
	
	        return _react2.default.createElement(
	          ElementType,
	          (0, _extends3.default)({}, rest, { className: containerClasses, onClick: this.handleClick }),
	          labelPosition === 'left' && labelElement,
	          _react2.default.createElement(
	            'button',
	            { className: _classes2 },
	            _Icon2.default.create(icon),
	            ' ',
	            content
	          ),
	          (labelPosition === 'right' || !labelPosition) && labelElement
	        );
	      }
	
	      if (!(0, _isNil3.default)(icon) && (0, _isNil3.default)(label)) {
	        var _classes3 = (0, _classnames2.default)('ui', labeledClasses, baseClasses, 'button', className);
	        debug('render icon && !label:', { classes: _classes3 });
	        return _react2.default.createElement(
	          ElementType,
	          (0, _extends3.default)({}, rest, { className: _classes3, tabIndex: tabIndex, onClick: this.handleClick }),
	          _Icon2.default.create(icon),
	          ' ',
	          content
	        );
	      }
	
	      var classes = (0, _classnames2.default)('ui', labeledClasses, baseClasses, 'button', className);
	      debug('render default:', { classes: classes });
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes, tabIndex: tabIndex, onClick: this.handleClick }),
	        content
	      );
	    }
	  }]);
	  return Button;
	}(_react.Component);
	
	Button.defaultProps = {
	  as: 'button'
	};
	Button._meta = {
	  name: 'Button',
	  type: _lib.META.TYPES.ELEMENT
	};
	Button.Content = _ButtonContent2.default;
	Button.Group = _ButtonGroup2.default;
	Button.Or = _ButtonOr2.default;
	 false ? Button.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A button can show it is currently the active user selection. */
	  active: _react.PropTypes.bool,
	
	  /** A button can animate to show hidden content. */
	  animated: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.oneOf(['fade', 'vertical'])]),
	
	  /** A button can be attached to the top or bottom of other content. */
	  attached: _react.PropTypes.oneOf(['left', 'right', 'top', 'bottom']),
	
	  /** A basic button is less pronounced. */
	  basic: _react.PropTypes.bool,
	
	  /** Primary content. */
	  children: _lib.customPropTypes.every([_react.PropTypes.node, _lib.customPropTypes.disallow(['label']), _lib.customPropTypes.givenProps({
	    icon: _react.PropTypes.oneOfType([_react.PropTypes.string.isRequired, _react.PropTypes.object.isRequired, _react.PropTypes.element.isRequired])
	  }, _lib.customPropTypes.disallow(['icon']))]),
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** A button can be circular. */
	  circular: _react.PropTypes.bool,
	
	  /** A button can have different colors */
	  color: _react.PropTypes.oneOf([].concat((0, _toConsumableArray3.default)(_lib.SUI.COLORS), ['facebook', 'google plus', 'instagram', 'linkedin', 'twitter', 'vk', 'youtube'])),
	
	  /** A button can reduce its padding to fit into tighter spaces. */
	  compact: _react.PropTypes.bool,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A button can show it is currently unable to be interacted with. */
	  disabled: _react.PropTypes.bool,
	
	  /** A button can be aligned to the left or right of its container. */
	  floated: _react.PropTypes.oneOf(_lib.SUI.FLOATS),
	
	  /** A button can take the width of its container. */
	  fluid: _react.PropTypes.bool,
	
	  /** Add an Icon by name, props object, or pass an <Icon />. */
	  icon: _lib.customPropTypes.some([_react.PropTypes.bool, _react.PropTypes.string, _react.PropTypes.object, _react.PropTypes.element]),
	
	  /** A button can be formatted to appear on dark backgrounds. */
	  inverted: _react.PropTypes.bool,
	
	  /** Add a Label by text, props object, or pass a <Label />. */
	  label: _lib.customPropTypes.some([_react.PropTypes.string, _react.PropTypes.object, _react.PropTypes.element]),
	
	  /** A labeled button can format a Label or Icon to appear on the left or right. */
	  labelPosition: _react.PropTypes.oneOf(['right', 'left']),
	
	  /** A button can show a loading indicator. */
	  loading: _react.PropTypes.bool,
	
	  /** A button can hint towards a negative consequence. */
	  negative: _react.PropTypes.bool,
	
	  /**
	   * Called after user's click.
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _react.PropTypes.func,
	
	  /** A button can hint towards a positive consequence. */
	  positive: _react.PropTypes.bool,
	
	  /** A button can be formatted to show different levels of emphasis. */
	  primary: _react.PropTypes.bool,
	
	  /** A button can be formatted to show different levels of emphasis. */
	  secondary: _react.PropTypes.bool,
	
	  /** A button can have different sizes. */
	  size: _react.PropTypes.oneOf(_lib.SUI.SIZES),
	
	  /** A button can receive focus. */
	  tabIndex: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	
	  /** A button can be formatted to toggle on and off. */
	  toggle: _react.PropTypes.bool
	} : void 0;
	Button.handledProps = ['active', 'animated', 'as', 'attached', 'basic', 'children', 'circular', 'className', 'color', 'compact', 'content', 'disabled', 'floated', 'fluid', 'icon', 'inverted', 'label', 'labelPosition', 'loading', 'negative', 'onClick', 'positive', 'primary', 'secondary', 'size', 'tabIndex', 'toggle'];
	
	
	Button.create = (0, _lib.createShorthandFactory)(Button, function (value) {
	  return { content: value };
	});
	
	exports.default = Button;

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(723);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _IconGroup = __webpack_require__(724);
	
	var _IconGroup2 = _interopRequireDefault(_IconGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An icon is a glyph used to represent something else.
	 * @see Image
	 */
	function Icon(props) {
	  var bordered = props.bordered,
	      circular = props.circular,
	      className = props.className,
	      color = props.color,
	      corner = props.corner,
	      disabled = props.disabled,
	      fitted = props.fitted,
	      flipped = props.flipped,
	      inverted = props.inverted,
	      link = props.link,
	      loading = props.loading,
	      name = props.name,
	      rotated = props.rotated,
	      size = props.size;
	
	
	  var classes = (0, _classnames2.default)(color, name, size, (0, _lib.useKeyOnly)(bordered, 'bordered'), (0, _lib.useKeyOnly)(circular, 'circular'), (0, _lib.useKeyOnly)(corner, 'corner'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(fitted, 'fitted'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(link, 'link'), (0, _lib.useKeyOnly)(loading, 'loading'), (0, _lib.useValueAndKey)(flipped, 'flipped'), (0, _lib.useValueAndKey)(rotated, 'rotated'), 'icon', className);
	  var rest = (0, _lib.getUnhandledProps)(Icon, props);
	  var ElementType = (0, _lib.getElementType)(Icon, props);
	
	  return _react2.default.createElement(ElementType, (0, _extends3.default)({}, rest, { 'aria-hidden': 'true', className: classes }));
	}
	
	Icon.handledProps = ['as', 'bordered', 'circular', 'className', 'color', 'corner', 'disabled', 'fitted', 'flipped', 'inverted', 'link', 'loading', 'name', 'rotated', 'size'];
	Icon.Group = _IconGroup2.default;
	
	Icon._meta = {
	  name: 'Icon',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	 false ? Icon.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Formatted to appear bordered. */
	  bordered: _react.PropTypes.bool,
	
	  /** Icon can formatted to appear circular. */
	  circular: _react.PropTypes.bool,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Color of the icon. */
	  color: _react.PropTypes.oneOf(_lib.SUI.COLORS),
	
	  /** Icons can display a smaller corner icon. */
	  corner: _react.PropTypes.bool,
	
	  /** Show that the icon is inactive. */
	  disabled: _react.PropTypes.bool,
	
	  /** Fitted, without space to left or right of Icon. */
	  fitted: _react.PropTypes.bool,
	
	  /** Icon can flipped. */
	  flipped: _react.PropTypes.oneOf(['horizontally', 'vertically']),
	
	  /** Formatted to have its colors inverted for contrast. */
	  inverted: _react.PropTypes.bool,
	
	  /** Icon can be formatted as a link. */
	  link: _react.PropTypes.bool,
	
	  /** Icon can be used as a simple loader. */
	  loading: _react.PropTypes.bool,
	
	  /** Name of the icon. */
	  name: _lib.customPropTypes.suggest(_lib.SUI.ICONS_AND_ALIASES),
	
	  /** Icon can rotated. */
	  rotated: _react.PropTypes.oneOf(['clockwise', 'counterclockwise']),
	
	  /** Size of the icon. */
	  size: _react.PropTypes.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'medium'))
	} : void 0;
	
	Icon.defaultProps = {
	  as: 'i'
	};
	
	Icon.create = (0, _lib.createShorthandFactory)(Icon, function (value) {
	  return { name: value };
	});
	
	exports.default = Icon;

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(565),
	    baseRest = __webpack_require__(394),
	    isArrayLikeObject = __webpack_require__(455);
	
	/**
	 * Creates an array excluding all given values using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * **Note:** Unlike `_.pull`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...*} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.difference, _.xor
	 * @example
	 *
	 * _.without([2, 1, 2, 3], 1, 2);
	 * // => [3]
	 */
	var without = baseRest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, values)
	    : [];
	});
	
	module.exports = without;


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(723);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Several icons can be used together as a group.
	 */
	function IconGroup(props) {
	  var children = props.children,
	      className = props.className,
	      size = props.size;
	
	  var classes = (0, _classnames2.default)(size, 'icons', className);
	  var rest = (0, _lib.getUnhandledProps)(IconGroup, props);
	  var ElementType = (0, _lib.getElementType)(IconGroup, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	IconGroup.handledProps = ['as', 'children', 'className', 'size'];
	IconGroup._meta = {
	  name: 'IconGroup',
	  parent: 'Icon',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	 false ? IconGroup.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Size of the icon group. */
	  size: _react.PropTypes.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'medium'))
	} : void 0;
	
	IconGroup.defaultProps = {
	  as: 'i'
	};
	
	exports.default = IconGroup;

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(513);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(514);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(518);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(552);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _isUndefined2 = __webpack_require__(572);
	
	var _isUndefined3 = _interopRequireDefault(_isUndefined2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _Icon = __webpack_require__(722);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Image = __webpack_require__(726);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _LabelDetail = __webpack_require__(736);
	
	var _LabelDetail2 = _interopRequireDefault(_LabelDetail);
	
	var _LabelGroup = __webpack_require__(737);
	
	var _LabelGroup2 = _interopRequireDefault(_LabelGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A label displays content classification.
	 */
	var Label = function (_Component) {
	  (0, _inherits3.default)(Label, _Component);
	
	  function Label() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Label);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Label.__proto__ || Object.getPrototypeOf(Label)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
	      var onClick = _this.props.onClick;
	
	
	      if (onClick) onClick(e, _this.props);
	    }, _this.handleRemove = function (e) {
	      var onRemove = _this.props.onRemove;
	
	
	      if (onRemove) onRemove(e, _this.props);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Label, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          attached = _props.attached,
	          basic = _props.basic,
	          children = _props.children,
	          circular = _props.circular,
	          className = _props.className,
	          color = _props.color,
	          content = _props.content,
	          corner = _props.corner,
	          detail = _props.detail,
	          empty = _props.empty,
	          floating = _props.floating,
	          horizontal = _props.horizontal,
	          icon = _props.icon,
	          image = _props.image,
	          onRemove = _props.onRemove,
	          pointing = _props.pointing,
	          removeIcon = _props.removeIcon,
	          ribbon = _props.ribbon,
	          size = _props.size,
	          tag = _props.tag;
	
	
	      var pointingClass = pointing === true && 'pointing' || (pointing === 'left' || pointing === 'right') && pointing + ' pointing' || (pointing === 'above' || pointing === 'below') && 'pointing ' + pointing;
	
	      var classes = (0, _classnames2.default)('ui', color, pointingClass, size, (0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(basic, 'basic'), (0, _lib.useKeyOnly)(circular, 'circular'), (0, _lib.useKeyOnly)(empty, 'empty'), (0, _lib.useKeyOnly)(floating, 'floating'), (0, _lib.useKeyOnly)(horizontal, 'horizontal'), (0, _lib.useKeyOnly)(image === true, 'image'), (0, _lib.useKeyOnly)(tag, 'tag'), (0, _lib.useKeyOrValueAndKey)(corner, 'corner'), (0, _lib.useKeyOrValueAndKey)(ribbon, 'ribbon'), (0, _lib.useValueAndKey)(attached, 'attached'), 'label', className);
	      var rest = (0, _lib.getUnhandledProps)(Label, this.props);
	      var ElementType = (0, _lib.getElementType)(Label, this.props);
	
	      if (!(0, _isNil3.default)(children)) {
	        return _react2.default.createElement(
	          ElementType,
	          (0, _extends3.default)({}, rest, { className: classes, onClick: this.handleClick }),
	          children
	        );
	      }
	
	      var removeIconShorthand = (0, _isUndefined3.default)(removeIcon) ? 'delete' : removeIcon;
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({ className: classes, onClick: this.handleClick }, rest),
	        _Icon2.default.create(icon),
	        typeof image !== 'boolean' && _Image2.default.create(image),
	        content,
	        (0, _lib.createShorthand)(_LabelDetail2.default, function (val) {
	          return { content: val };
	        }, detail),
	        onRemove && _Icon2.default.create(removeIconShorthand, { onClick: this.handleRemove })
	      );
	    }
	  }]);
	  return Label;
	}(_react.Component);
	
	Label._meta = {
	  name: 'Label',
	  type: _lib.META.TYPES.ELEMENT
	};
	Label.Detail = _LabelDetail2.default;
	Label.Group = _LabelGroup2.default;
	exports.default = Label;
	 false ? Label.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A label can be active. */
	  active: _react.PropTypes.bool,
	
	  /** A label can attach to a content segment. */
	  attached: _react.PropTypes.oneOf(['top', 'bottom', 'top right', 'top left', 'bottom left', 'bottom right']),
	
	  /** A label can reduce its complexity. */
	  basic: _react.PropTypes.bool,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** A label can be circular. */
	  circular: _react.PropTypes.bool,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Color of the label. */
	  color: _react.PropTypes.oneOf(_lib.SUI.COLORS),
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A label can position itself in the corner of an element. */
	  corner: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.oneOf(['left', 'right'])]),
	
	  /** Shorthand for LabelDetail. */
	  detail: _lib.customPropTypes.itemShorthand,
	
	  /** Formats the label as a dot. */
	  empty: _lib.customPropTypes.every([_react.PropTypes.bool, _lib.customPropTypes.demand(['circular'])]),
	
	  /** Float above another element in the upper right corner. */
	  floating: _react.PropTypes.bool,
	
	  /** A horizontal label is formatted to label content along-side it horizontally. */
	  horizontal: _react.PropTypes.bool,
	
	  /** Shorthand for Icon. */
	  icon: _lib.customPropTypes.itemShorthand,
	
	  /** A label can be formatted to emphasize an image or prop can be used as shorthand for Image. */
	  image: _react.PropTypes.oneOfType([_react.PropTypes.bool, _lib.customPropTypes.itemShorthand]),
	
	  /**
	   * Called on click.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _react.PropTypes.func,
	
	  /**
	   * Adds an "x" icon, called when "x" is clicked.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onRemove: _react.PropTypes.func,
	
	  /** A label can point to content next to it. */
	  pointing: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.oneOf(['above', 'below', 'left', 'right'])]),
	
	  /** Shorthand for Icon to appear as the last child and trigger onRemove. */
	  removeIcon: _lib.customPropTypes.itemShorthand,
	
	  /** A label can appear as a ribbon attaching itself to an element. */
	  ribbon: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.oneOf(['right'])]),
	
	  /** A label can have different sizes. */
	  size: _react.PropTypes.oneOf(_lib.SUI.SIZES),
	
	  /** A label can appear as a tag. */
	  tag: _react.PropTypes.bool
	} : void 0;
	Label.handledProps = ['active', 'as', 'attached', 'basic', 'children', 'circular', 'className', 'color', 'content', 'corner', 'detail', 'empty', 'floating', 'horizontal', 'icon', 'image', 'onClick', 'onRemove', 'pointing', 'removeIcon', 'ribbon', 'size', 'tag'];
	
	
	Label.create = (0, _lib.createShorthandFactory)(Label, function (value) {
	  return { content: value };
	});

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _Dimmer = __webpack_require__(727);
	
	var _Dimmer2 = _interopRequireDefault(_Dimmer);
	
	var _Label = __webpack_require__(725);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _ImageGroup = __webpack_require__(735);
	
	var _ImageGroup2 = _interopRequireDefault(_ImageGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An image is a graphic representation of something.
	 * @see Icon
	 */
	function Image(props) {
	  var alt = props.alt,
	      avatar = props.avatar,
	      bordered = props.bordered,
	      centered = props.centered,
	      children = props.children,
	      className = props.className,
	      dimmer = props.dimmer,
	      disabled = props.disabled,
	      floated = props.floated,
	      fluid = props.fluid,
	      height = props.height,
	      hidden = props.hidden,
	      href = props.href,
	      inline = props.inline,
	      label = props.label,
	      shape = props.shape,
	      size = props.size,
	      spaced = props.spaced,
	      src = props.src,
	      verticalAlign = props.verticalAlign,
	      width = props.width,
	      wrapped = props.wrapped,
	      ui = props.ui;
	
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(ui, 'ui'), size, shape, (0, _lib.useKeyOnly)(avatar, 'avatar'), (0, _lib.useKeyOnly)(bordered, 'bordered'), (0, _lib.useKeyOnly)(centered, 'centered'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(hidden, 'hidden'), (0, _lib.useKeyOnly)(inline, 'inline'), (0, _lib.useKeyOrValueAndKey)(spaced, 'spaced'), (0, _lib.useValueAndKey)(floated, 'floated'), (0, _lib.useVerticalAlignProp)(verticalAlign, 'aligned'), 'image', className);
	  var rest = (0, _lib.getUnhandledProps)(Image, props);
	  var ElementType = (0, _lib.getElementType)(Image, props, function () {
	    if (!(0, _isNil3.default)(dimmer) || !(0, _isNil3.default)(label) || !(0, _isNil3.default)(wrapped) || !(0, _isNil3.default)(children)) return 'div';
	  });
	
	  if (!(0, _isNil3.default)(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  var rootProps = (0, _extends3.default)({}, rest, { className: classes });
	  var imgTagProps = { alt: alt, src: src, height: height, width: width };
	
	  if (ElementType === 'img') return _react2.default.createElement(ElementType, (0, _extends3.default)({}, rootProps, imgTagProps));
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rootProps, { href: href }),
	    _Dimmer2.default.create(dimmer),
	    _Label2.default.create(label),
	    _react2.default.createElement('img', imgTagProps)
	  );
	}
	
	Image.handledProps = ['alt', 'as', 'avatar', 'bordered', 'centered', 'children', 'className', 'dimmer', 'disabled', 'floated', 'fluid', 'height', 'hidden', 'href', 'inline', 'label', 'shape', 'size', 'spaced', 'src', 'ui', 'verticalAlign', 'width', 'wrapped'];
	Image.Group = _ImageGroup2.default;
	
	Image._meta = {
	  name: 'Image',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	 false ? Image.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Alternate text for the image specified. */
	  alt: _react.PropTypes.string,
	
	  /** An image may be formatted to appear inline with text as an avatar. */
	  avatar: _react.PropTypes.bool,
	
	  /** An image may include a border to emphasize the edges of white or transparent content. */
	  bordered: _react.PropTypes.bool,
	
	  /** An image can appear centered in a content block. */
	  centered: _react.PropTypes.bool,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** An image can show that it is disabled and cannot be selected. */
	  disabled: _react.PropTypes.bool,
	
	  /** Shorthand for Dimmer. */
	  dimmer: _lib.customPropTypes.itemShorthand,
	
	  /** An image can sit to the left or right of other content. */
	  floated: _react.PropTypes.oneOf(_lib.SUI.FLOATS),
	
	  /** An image can take up the width of its container. */
	  fluid: _lib.customPropTypes.every([_react.PropTypes.bool, _lib.customPropTypes.disallow(['size'])]),
	
	  /** The img element height attribute. */
	  height: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	
	  /** An image can be hidden. */
	  hidden: _react.PropTypes.bool,
	
	  /** Renders the Image as an <a> tag with this href. */
	  href: _react.PropTypes.string,
	
	  /** An image may appear inline. */
	  inline: _react.PropTypes.bool,
	
	  /** Shorthand for Label. */
	  label: _lib.customPropTypes.itemShorthand,
	
	  /** An image may appear rounded or circular. */
	  shape: _react.PropTypes.oneOf(['rounded', 'circular']),
	
	  /** An image may appear at different sizes. */
	  size: _react.PropTypes.oneOf(_lib.SUI.SIZES),
	
	  /** An image can specify that it needs an additional spacing to separate it from nearby content. */
	  spaced: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.oneOf(['left', 'right'])]),
	
	  /** Specifies the URL of the image. */
	  src: _react.PropTypes.string,
	
	  /** Whether or not to add the ui className. */
	  ui: _react.PropTypes.bool,
	
	  /** An image can specify its vertical alignment. */
	  verticalAlign: _react.PropTypes.oneOf(_lib.SUI.VERTICAL_ALIGNMENTS),
	
	  /** The img element width attribute. */
	  width: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	
	  /** An image can render wrapped in a `div.ui.image` as alternative HTML markup. */
	  wrapped: _lib.customPropTypes.every([_react.PropTypes.bool,
	  // these props wrap the image in an a tag already
	  _lib.customPropTypes.disallow(['href'])])
	} : void 0;
	
	Image.defaultProps = {
	  as: 'img',
	  ui: true
	};
	
	Image.create = (0, _lib.createShorthandFactory)(Image, function (value) {
	  return { src: value };
	});
	
	exports.default = Image;

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Dimmer = __webpack_require__(728);
	
	var _Dimmer2 = _interopRequireDefault(_Dimmer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Dimmer2.default;

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(513);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(514);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(518);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(552);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _Portal = __webpack_require__(729);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _DimmerDimmable = __webpack_require__(734);
	
	var _DimmerDimmable2 = _interopRequireDefault(_DimmerDimmable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A dimmer hides distractions to focus attention on particular content.
	 */
	var Dimmer = function (_Component) {
	  (0, _inherits3.default)(Dimmer, _Component);
	
	  function Dimmer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Dimmer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Dimmer.__proto__ || Object.getPrototypeOf(Dimmer)).call.apply(_ref, [this].concat(args))), _this), _this.handlePortalMount = function () {
	      if (_lib.isBrowser) document.body.classList.add('dimmed', 'dimmable');
	    }, _this.handlePortalUnmount = function () {
	      if (_lib.isBrowser) document.body.classList.remove('dimmed', 'dimmable');
	    }, _this.handleClick = function (e) {
	      var _this$props = _this.props,
	          onClick = _this$props.onClick,
	          onClickOutside = _this$props.onClickOutside;
	
	
	      if (onClick) onClick(e, _this.props);
	      if (_this.center && _this.center !== e.target && _this.center.contains(e.target)) return;
	      if (onClickOutside) onClickOutside(e, _this.props);
	    }, _this.handleCenterRef = function (c) {
	      return _this.center = c;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Dimmer, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          className = _props.className,
	          content = _props.content,
	          disabled = _props.disabled,
	          inverted = _props.inverted,
	          page = _props.page,
	          simple = _props.simple;
	
	
	      var classes = (0, _classnames2.default)('ui', (0, _lib.useKeyOnly)(active, 'active transition visible'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(page, 'page'), (0, _lib.useKeyOnly)(simple, 'simple'), 'dimmer', className);
	      var rest = (0, _lib.getUnhandledProps)(Dimmer, this.props);
	      var ElementType = (0, _lib.getElementType)(Dimmer, this.props);
	
	      var childrenContent = (0, _isNil3.default)(children) ? content : children;
	
	      var dimmerElement = _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes, onClick: this.handleClick }),
	        childrenContent && _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'center', ref: this.handleCenterRef },
	            childrenContent
	          )
	        )
	      );
	
	      if (page) {
	        return _react2.default.createElement(
	          _Portal2.default,
	          {
	            closeOnEscape: false,
	            closeOnDocumentClick: false,
	            onMount: this.handlePortalMount,
	            onUnmount: this.handlePortalUnmount,
	            open: active,
	            openOnTriggerClick: false
	          },
	          dimmerElement
	        );
	      }
	
	      return dimmerElement;
	    }
	  }]);
	  return Dimmer;
	}(_react.Component);
	
	Dimmer._meta = {
	  name: 'Dimmer',
	  type: _lib.META.TYPES.MODULE
	};
	Dimmer.Dimmable = _DimmerDimmable2.default;
	exports.default = Dimmer;
	 false ? Dimmer.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** An active dimmer will dim its parent container. */
	  active: _react.PropTypes.bool,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A disabled dimmer cannot be activated */
	  disabled: _react.PropTypes.bool,
	
	  /**
	   * Called on click.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _react.PropTypes.func,
	
	  /**
	   * Handles click outside Dimmer's content, but inside Dimmer area.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClickOutside: _react.PropTypes.func,
	
	  /** A dimmer can be formatted to have its colors inverted. */
	  inverted: _react.PropTypes.bool,
	
	  /** A dimmer can be formatted to be fixed to the page. */
	  page: _react.PropTypes.bool,
	
	  /** A dimmer can be controlled with simple prop. */
	  simple: _react.PropTypes.bool
	} : void 0;
	Dimmer.handledProps = ['active', 'as', 'children', 'className', 'content', 'disabled', 'inverted', 'onClick', 'onClickOutside', 'page', 'simple'];
	
	
	Dimmer.create = (0, _lib.createShorthandFactory)(Dimmer, function (value) {
	  return { content: value };
	});

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Portal = __webpack_require__(730);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Portal2.default;

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(513);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(514);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(518);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(552);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _invoke2 = __webpack_require__(731);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _react = __webpack_require__(2);
	
	var _reactDom = __webpack_require__(34);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var debug = (0, _lib.makeDebugger)('portal');
	
	/**
	 * A component that allows you to render children outside their parent.
	 * @see Modal
	 */
	
	var Portal = function (_Component) {
	  (0, _inherits3.default)(Portal, _Component);
	
	  function Portal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Portal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Portal.__proto__ || Object.getPrototypeOf(Portal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.handleDocumentClick = function (e) {
	      var _this$props = _this.props,
	          closeOnDocumentClick = _this$props.closeOnDocumentClick,
	          closeOnRootNodeClick = _this$props.closeOnRootNodeClick;
	
	
	      if (!_this.rootNode // not mounted
	      || !_this.portalNode // no portal
	      || (0, _invoke3.default)(_this, 'triggerNode.contains', e.target) // event happened in trigger (delegate to trigger handlers)
	      || (0, _invoke3.default)(_this, 'portalNode.contains', e.target) // event happened in the portal
	      ) return; // ignore the click
	
	      var didClickInRootNode = _this.rootNode.contains(e.target);
	
	      if (closeOnDocumentClick && !didClickInRootNode || closeOnRootNodeClick && didClickInRootNode) {
	        debug('handleDocumentClick()');
	
	        _this.close(e);
	      }
	    }, _this.handleEscape = function (e) {
	      if (!_this.props.closeOnEscape) return;
	      if (_lib.keyboardKey.getCode(e) !== _lib.keyboardKey.Escape) return;
	
	      debug('handleEscape()');
	
	      _this.close(e);
	    }, _this.handlePortalMouseLeave = function (e) {
	      var _this$props2 = _this.props,
	          closeOnPortalMouseLeave = _this$props2.closeOnPortalMouseLeave,
	          mouseLeaveDelay = _this$props2.mouseLeaveDelay;
	
	
	      if (!closeOnPortalMouseLeave) return;
	
	      debug('handlePortalMouseLeave()');
	      _this.mouseLeaveTimer = _this.closeWithTimeout(e, mouseLeaveDelay);
	    }, _this.handlePortalMouseEnter = function (e) {
	      // In order to enable mousing from the trigger to the portal, we need to
	      // clear the mouseleave timer that was set when leaving the trigger.
	      var closeOnPortalMouseLeave = _this.props.closeOnPortalMouseLeave;
	
	
	      if (!closeOnPortalMouseLeave) return;
	
	      debug('handlePortalMouseEnter()');
	      clearTimeout(_this.mouseLeaveTimer);
	    }, _this.handleTriggerBlur = function (e) {
	      var _this$props3 = _this.props,
	          trigger = _this$props3.trigger,
	          closeOnTriggerBlur = _this$props3.closeOnTriggerBlur;
	
	      // Call original event handler
	
	      (0, _invoke3.default)(trigger, 'props.onBlur', e);
	
	      // do not close if focus is given to the portal
	      var didFocusPortal = (0, _invoke3.default)(_this, 'rootNode.contains', e.relatedTarget);
	
	      if (!closeOnTriggerBlur || didFocusPortal) return;
	
	      debug('handleTriggerBlur()');
	      _this.close(e);
	    }, _this.handleTriggerClick = function (e) {
	      var _this$props4 = _this.props,
	          trigger = _this$props4.trigger,
	          closeOnTriggerClick = _this$props4.closeOnTriggerClick,
	          openOnTriggerClick = _this$props4.openOnTriggerClick;
	      var open = _this.state.open;
	
	      // Call original event handler
	
	      (0, _invoke3.default)(trigger, 'props.onClick', e);
	
	      if (open && closeOnTriggerClick) {
	        debug('handleTriggerClick() - close');
	
	        _this.close(e);
	      } else if (!open && openOnTriggerClick) {
	        debug('handleTriggerClick() - open');
	
	        _this.open(e);
	      }
	    }, _this.handleTriggerFocus = function (e) {
	      var _this$props5 = _this.props,
	          trigger = _this$props5.trigger,
	          openOnTriggerFocus = _this$props5.openOnTriggerFocus;
	
	      // Call original event handler
	
	      (0, _invoke3.default)(trigger, 'props.onFocus', e);
	
	      if (!openOnTriggerFocus) return;
	
	      debug('handleTriggerFocus()');
	      _this.open(e);
	    }, _this.handleTriggerMouseLeave = function (e) {
	      clearTimeout(_this.mouseEnterTimer);
	
	      var _this$props6 = _this.props,
	          trigger = _this$props6.trigger,
	          closeOnTriggerMouseLeave = _this$props6.closeOnTriggerMouseLeave,
	          mouseLeaveDelay = _this$props6.mouseLeaveDelay;
	
	      // Call original event handler
	
	      (0, _invoke3.default)(trigger, 'props.onMouseLeave', e);
	
	      if (!closeOnTriggerMouseLeave) return;
	
	      debug('handleTriggerMouseLeave()');
	      _this.mouseLeaveTimer = _this.closeWithTimeout(e, mouseLeaveDelay);
	    }, _this.handleTriggerMouseEnter = function (e) {
	      clearTimeout(_this.mouseLeaveTimer);
	
	      var _this$props7 = _this.props,
	          trigger = _this$props7.trigger,
	          mouseEnterDelay = _this$props7.mouseEnterDelay,
	          openOnTriggerMouseEnter = _this$props7.openOnTriggerMouseEnter;
	
	      // Call original event handler
	
	      (0, _invoke3.default)(trigger, 'props.onMouseEnter', _this.handleTriggerMouseEnter);
	
	      if (!openOnTriggerMouseEnter) return;
	
	      debug('handleTriggerMouseEnter()');
	      _this.mouseEnterTimer = _this.openWithTimeout(e, mouseEnterDelay);
	    }, _this.open = function (e) {
	      debug('open()');
	
	      var onOpen = _this.props.onOpen;
	
	      if (onOpen) onOpen(e, _this.props);
	
	      _this.trySetState({ open: true });
	    }, _this.openWithTimeout = function (e, delay) {
	      debug('openWithTimeout()', delay);
	      // React wipes the entire event object and suggests using e.persist() if
	      // you need the event for async access. However, even with e.persist
	      // certain required props (e.g. currentTarget) are null so we're forced to clone.
	      var eventClone = (0, _extends3.default)({}, e);
	      return setTimeout(function () {
	        return _this.open(eventClone);
	      }, delay || 0);
	    }, _this.close = function (e) {
	      debug('close()');
	
	      var onClose = _this.props.onClose;
	
	      if (onClose) onClose(e, _this.props);
	
	      _this.trySetState({ open: false });
	    }, _this.closeWithTimeout = function (e, delay) {
	      debug('closeWithTimeout()', delay);
	      // React wipes the entire event object and suggests using e.persist() if
	      // you need the event for async access. However, even with e.persist
	      // certain required props (e.g. currentTarget) are null so we're forced to clone.
	      var eventClone = (0, _extends3.default)({}, e);
	      return setTimeout(function () {
	        return _this.close(eventClone);
	      }, delay || 0);
	    }, _this.mountPortal = function () {
	      if (!_lib.isBrowser || _this.rootNode) return;
	
	      debug('mountPortal()');
	
	      var _this$props8 = _this.props,
	          _this$props8$mountNod = _this$props8.mountNode,
	          mountNode = _this$props8$mountNod === undefined ? _lib.isBrowser ? document.body : null : _this$props8$mountNod,
	          prepend = _this$props8.prepend;
	
	
	      _this.rootNode = document.createElement('div');
	
	      if (prepend) {
	        mountNode.insertBefore(_this.rootNode, mountNode.firstElementChild);
	      } else {
	        mountNode.appendChild(_this.rootNode);
	      }
	
	      document.addEventListener('click', _this.handleDocumentClick);
	      document.addEventListener('keydown', _this.handleEscape);
	
	      var onMount = _this.props.onMount;
	
	      if (onMount) onMount(null, _this.props);
	    }, _this.unmountPortal = function () {
	      if (!_lib.isBrowser || !_this.rootNode) return;
	      _this.didInitialRender = false;
	
	      debug('unmountPortal()');
	
	      _reactDom2.default.unmountComponentAtNode(_this.rootNode);
	      _this.rootNode.parentNode.removeChild(_this.rootNode);
	
	      _this.portalNode.removeEventListener('mouseleave', _this.handlePortalMouseLeave);
	      _this.portalNode.removeEventListener('mouseenter', _this.handlePortalMouseEnter);
	
	      _this.rootNode = null;
	      _this.portalNode = null;
	
	      document.removeEventListener('click', _this.handleDocumentClick);
	      document.removeEventListener('keydown', _this.handleEscape);
	
	      var onUnmount = _this.props.onUnmount;
	
	      if (onUnmount) onUnmount(null, _this.props);
	    }, _this.handleRef = function (c) {
	      _this.triggerNode = _reactDom2.default.findDOMNode(c);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Portal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      debug('componentDidMount()');
	      this.renderPortal();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      debug('componentDidUpdate()');
	      // NOTE: Ideally the portal rendering would happen in the render() function
	      // but React gives a warning about not being pure and suggests doing it
	      // within this method.
	
	      // If the portal is open, render (or re-render) the portal and child.
	      this.renderPortal();
	
	      if (prevState.open && !this.state.open) {
	        debug('portal closed');
	        this.unmountPortal();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unmountPortal();
	
	      // Clean up timers
	      clearTimeout(this.mouseEnterTimer);
	      clearTimeout(this.mouseLeaveTimer);
	    }
	
	    // ----------------------------------------
	    // Document Event Handlers
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Component Event Handlers
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Behavior
	    // ----------------------------------------
	
	  }, {
	    key: 'renderPortal',
	    value: function renderPortal() {
	      var _this2 = this;
	
	      if (!this.state.open) return;
	      debug('renderPortal()');
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          closeOnTriggerBlur = _props.closeOnTriggerBlur,
	          openOnTriggerFocus = _props.openOnTriggerFocus;
	
	
	      this.mountPortal();
	
	      // Server side rendering
	      if (!_lib.isBrowser) return null;
	
	      this.rootNode.className = className || '';
	
	      // when re-rendering, first remove listeners before re-adding them to the new node
	      if (this.portalNode) {
	        this.portalNode.removeEventListener('mouseleave', this.handlePortalMouseLeave);
	        this.portalNode.removeEventListener('mouseenter', this.handlePortalMouseEnter);
	      }
	
	      _reactDom2.default.unstable_renderSubtreeIntoContainer(this, _react.Children.only(children), this.rootNode);
	
	      this.portalNode = this.rootNode.firstElementChild;
	
	      // don't take focus away from for focus based portal triggers
	      if (!this.didInitialRender && !(openOnTriggerFocus || closeOnTriggerBlur)) {
	        this.didInitialRender = true;
	
	        // add a tabIndex so we can focus it, remove outline
	        this.portalNode.tabIndex = -1;
	        this.portalNode.style.outline = 'none';
	
	        // Wait a tick for things like popups which need to calculate where the popup shows up.
	        // Otherwise, the element is focused at its initial position, scrolling the browser, then
	        // it is immediately repositioned at the proper location.
	        setTimeout(function () {
	          if (_this2.portalNode) _this2.portalNode.focus();
	        });
	      }
	
	      this.portalNode.addEventListener('mouseleave', this.handlePortalMouseLeave);
	      this.portalNode.addEventListener('mouseenter', this.handlePortalMouseEnter);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var trigger = this.props.trigger;
	
	
	      if (!trigger) return null;
	
	      return (0, _react.cloneElement)(trigger, {
	        ref: this.handleRef,
	        onBlur: this.handleTriggerBlur,
	        onClick: this.handleTriggerClick,
	        onFocus: this.handleTriggerFocus,
	        onMouseLeave: this.handleTriggerMouseLeave,
	        onMouseEnter: this.handleTriggerMouseEnter
	      });
	    }
	  }]);
	  return Portal;
	}(_lib.AutoControlledComponent);
	
	Portal.defaultProps = {
	  closeOnDocumentClick: true,
	  closeOnEscape: true,
	  openOnTriggerClick: true
	};
	Portal.autoControlledProps = ['open'];
	Portal._meta = {
	  name: 'Portal',
	  type: _lib.META.TYPES.ADDON
	};
	 false ? Portal.propTypes = {
	  /** Primary content. */
	  children: _react.PropTypes.node.isRequired,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Controls whether or not the portal should close when the document is clicked. */
	  closeOnDocumentClick: _react.PropTypes.bool,
	
	  /** Controls whether or not the portal should close when escape is pressed is displayed. */
	  closeOnEscape: _react.PropTypes.bool,
	
	  /**
	   * Controls whether or not the portal should close when mousing out of the portal.
	   * NOTE: This will prevent `closeOnTriggerMouseLeave` when mousing over the
	   * gap from the trigger to the portal.
	   */
	  closeOnPortalMouseLeave: _react.PropTypes.bool,
	
	  /**
	   * Controls whether or not the portal should close on a click on the portal background.
	   * NOTE: This differs from closeOnDocumentClick:
	   * - DocumentClick - any click not within the portal
	   * - RootNodeClick - a click not within the portal but within the portal's wrapper
	   */
	  closeOnRootNodeClick: _react.PropTypes.bool,
	
	  /** Controls whether or not the portal should close on blur of the trigger. */
	  closeOnTriggerBlur: _react.PropTypes.bool,
	
	  /** Controls whether or not the portal should close on click of the trigger. */
	  closeOnTriggerClick: _react.PropTypes.bool,
	
	  /** Controls whether or not the portal should close when mousing out of the trigger. */
	  closeOnTriggerMouseLeave: _react.PropTypes.bool,
	
	  /** Initial value of open. */
	  defaultOpen: _react.PropTypes.bool,
	
	  /** The node where the portal should mount. */
	  mountNode: _react.PropTypes.any,
	
	  /** Milliseconds to wait before closing on mouse leave */
	  mouseLeaveDelay: _react.PropTypes.number,
	
	  /** Milliseconds to wait before opening on mouse over */
	  mouseEnterDelay: _react.PropTypes.number,
	
	  /**
	   * Called when a close event happens
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClose: _react.PropTypes.func,
	
	  /**
	   * Called when the portal is mounted on the DOM
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onMount: _react.PropTypes.func,
	
	  /**
	   * Called when an open event happens
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onOpen: _react.PropTypes.func,
	
	  /**
	   * Called when the portal is unmounted from the DOM
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onUnmount: _react.PropTypes.func,
	
	  /** Controls whether or not the portal is displayed. */
	  open: _react.PropTypes.bool,
	
	  /** Controls whether or not the portal should open when the trigger is clicked. */
	  openOnTriggerClick: _react.PropTypes.bool,
	
	  /** Controls whether or not the portal should open on focus of the trigger. */
	  openOnTriggerFocus: _react.PropTypes.bool,
	
	  /** Controls whether or not the portal should open when mousing over the trigger. */
	  openOnTriggerMouseEnter: _react.PropTypes.bool,
	
	  /** Controls whether the portal should be prepended to the mountNode instead of appended. */
	  prepend: _react.PropTypes.bool,
	
	  /** Element to be rendered in-place where the portal is defined. */
	  trigger: _react.PropTypes.node
	} : void 0;
	Portal.handledProps = ['children', 'className', 'closeOnDocumentClick', 'closeOnEscape', 'closeOnPortalMouseLeave', 'closeOnRootNodeClick', 'closeOnTriggerBlur', 'closeOnTriggerClick', 'closeOnTriggerMouseLeave', 'defaultOpen', 'mountNode', 'mouseEnterDelay', 'mouseLeaveDelay', 'onClose', 'onMount', 'onOpen', 'onUnmount', 'open', 'openOnTriggerClick', 'openOnTriggerFocus', 'openOnTriggerMouseEnter', 'prepend', 'trigger'];
	exports.default = Portal;

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	var baseInvoke = __webpack_require__(732),
	    baseRest = __webpack_require__(394);
	
	/**
	 * Invokes the method at `path` of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the method to invoke.
	 * @param {...*} [args] The arguments to invoke the method with.
	 * @returns {*} Returns the result of the invoked method.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	 *
	 * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	 * // => [2, 3]
	 */
	var invoke = baseRest(baseInvoke);
	
	module.exports = invoke;


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(396),
	    castPath = __webpack_require__(368),
	    last = __webpack_require__(385),
	    parent = __webpack_require__(733),
	    toKey = __webpack_require__(377);
	
	/**
	 * The base implementation of `_.invoke` without support for individual
	 * method arguments.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the method to invoke.
	 * @param {Array} args The arguments to invoke the method with.
	 * @returns {*} Returns the result of the invoked method.
	 */
	function baseInvoke(object, path, args) {
	  path = castPath(path, object);
	  object = parent(object, path);
	  var func = object == null ? object : object[toKey(last(path))];
	  return func == null ? undefined : apply(func, object, args);
	}
	
	module.exports = baseInvoke;


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(367),
	    baseSlice = __webpack_require__(692);
	
	/**
	 * Gets the parent value at `path` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path to get the parent value of.
	 * @returns {*} Returns the parent value.
	 */
	function parent(object, path) {
	  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	}
	
	module.exports = parent;


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A dimmable sub-component for Dimmer.
	 */
	function DimmerDimmable(props) {
	  var blurring = props.blurring,
	      className = props.className,
	      children = props.children,
	      dimmed = props.dimmed;
	
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(blurring, 'blurring'), (0, _lib.useKeyOnly)(dimmed, 'dimmed'), 'dimmable', className);
	  var rest = (0, _lib.getUnhandledProps)(DimmerDimmable, props);
	  var ElementType = (0, _lib.getElementType)(DimmerDimmable, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	DimmerDimmable.handledProps = ['as', 'blurring', 'children', 'className', 'dimmed'];
	DimmerDimmable._meta = {
	  name: 'DimmerDimmable',
	  type: _lib.META.TYPES.MODULE,
	  parent: 'Dimmer'
	};
	
	 false ? DimmerDimmable.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A dimmable element can blur its contents. */
	  blurring: _react.PropTypes.bool,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Controls whether or not the dim is displayed. */
	  dimmed: _react.PropTypes.bool
	} : void 0;
	
	exports.default = DimmerDimmable;

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A group of images.
	 */
	function ImageGroup(props) {
	  var children = props.children,
	      className = props.className,
	      size = props.size;
	
	  var classes = (0, _classnames2.default)('ui', size, className, 'images');
	  var rest = (0, _lib.getUnhandledProps)(ImageGroup, props);
	  var ElementType = (0, _lib.getElementType)(ImageGroup, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	ImageGroup.handledProps = ['as', 'children', 'className', 'size'];
	ImageGroup._meta = {
	  name: 'ImageGroup',
	  parent: 'Image',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	 false ? ImageGroup.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** A group of images can be formatted to have the same size. */
	  size: _react.PropTypes.oneOf(_lib.SUI.SIZES)
	} : void 0;
	
	exports.default = ImageGroup;

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LabelDetail(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('detail', className);
	  var rest = (0, _lib.getUnhandledProps)(LabelDetail, props);
	  var ElementType = (0, _lib.getElementType)(LabelDetail, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _isNil3.default)(children) ? content : children
	  );
	}
	
	LabelDetail.handledProps = ['as', 'children', 'className', 'content'];
	LabelDetail._meta = {
	  name: 'LabelDetail',
	  parent: 'Label',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	 false ? LabelDetail.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : void 0;
	
	exports.default = LabelDetail;

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A label can be grouped.
	 */
	function LabelGroup(props) {
	  var children = props.children,
	      circular = props.circular,
	      className = props.className,
	      color = props.color,
	      size = props.size,
	      tag = props.tag;
	
	
	  var classes = (0, _classnames2.default)('ui', color, size, (0, _lib.useKeyOnly)(circular, 'circular'), (0, _lib.useKeyOnly)(tag, 'tag'), 'labels', className);
	  var rest = (0, _lib.getUnhandledProps)(LabelGroup, props);
	  var ElementType = (0, _lib.getElementType)(LabelGroup, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	LabelGroup.handledProps = ['as', 'children', 'circular', 'className', 'color', 'size', 'tag'];
	LabelGroup._meta = {
	  name: 'LabelGroup',
	  parent: 'Label',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	 false ? LabelGroup.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Labels can share shapes. */
	  circular: _react.PropTypes.bool,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Label group can share colors together. */
	  color: _react.PropTypes.oneOf(_lib.SUI.COLORS),
	
	  /** Label group can share sizes together. */
	  size: _react.PropTypes.oneOf(_lib.SUI.SIZES),
	
	  /** Label group can share tag formatting. */
	  tag: _react.PropTypes.bool
	} : void 0;
	
	exports.default = LabelGroup;

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Used in some Button types, such as `animated`.
	 */
	function ButtonContent(props) {
	  var children = props.children,
	      className = props.className,
	      hidden = props.hidden,
	      visible = props.visible;
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(visible, 'visible'), (0, _lib.useKeyOnly)(hidden, 'hidden'), 'content', className);
	  var rest = (0, _lib.getUnhandledProps)(ButtonContent, props);
	  var ElementType = (0, _lib.getElementType)(ButtonContent, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	ButtonContent.handledProps = ['as', 'children', 'className', 'hidden', 'visible'];
	ButtonContent._meta = {
	  name: 'ButtonContent',
	  parent: 'Button',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	 false ? ButtonContent.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Initially hidden, visible on hover. */
	  hidden: _react.PropTypes.bool,
	
	  /** Initially visible, hidden on hover. */
	  visible: _react.PropTypes.bool
	} : void 0;
	
	exports.default = ButtonContent;

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Buttons can be grouped.
	 */
	function ButtonGroup(props) {
	  var attached = props.attached,
	      basic = props.basic,
	      children = props.children,
	      className = props.className,
	      color = props.color,
	      compact = props.compact,
	      floated = props.floated,
	      fluid = props.fluid,
	      icon = props.icon,
	      inverted = props.inverted,
	      labeled = props.labeled,
	      negative = props.negative,
	      positive = props.positive,
	      primary = props.primary,
	      secondary = props.secondary,
	      size = props.size,
	      toggle = props.toggle,
	      vertical = props.vertical,
	      widths = props.widths;
	
	
	  var classes = (0, _classnames2.default)('ui', color, size, (0, _lib.useKeyOnly)(basic, 'basic'), (0, _lib.useKeyOnly)(compact, 'compact'), (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(icon, 'icon'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(labeled, 'labeled'), (0, _lib.useKeyOnly)(negative, 'negative'), (0, _lib.useKeyOnly)(positive, 'positive'), (0, _lib.useKeyOnly)(primary, 'primary'), (0, _lib.useKeyOnly)(secondary, 'secondary'), (0, _lib.useKeyOnly)(toggle, 'toggle'), (0, _lib.useKeyOnly)(vertical, 'vertical'), (0, _lib.useValueAndKey)(attached, 'attached'), (0, _lib.useValueAndKey)(floated, 'floated'), (0, _lib.useWidthProp)(widths), 'buttons', className);
	  var rest = (0, _lib.getUnhandledProps)(ButtonGroup, props);
	  var ElementType = (0, _lib.getElementType)(ButtonGroup, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	ButtonGroup.handledProps = ['as', 'attached', 'basic', 'children', 'className', 'color', 'compact', 'floated', 'fluid', 'icon', 'inverted', 'labeled', 'negative', 'positive', 'primary', 'secondary', 'size', 'toggle', 'vertical', 'widths'];
	ButtonGroup._meta = {
	  name: 'ButtonGroup',
	  parent: 'Button',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	 false ? ButtonGroup.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A button can be attached to the top or bottom of other content. */
	  attached: _react.PropTypes.oneOf(['left', 'right', 'top', 'bottom']),
	
	  /** Groups can be less pronounced. */
	  basic: _react.PropTypes.bool,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Groups can have a shared color. */
	  color: _react.PropTypes.oneOf(_lib.SUI.COLORS),
	
	  /** Groups can reduce their padding to fit into tighter spaces. */
	  compact: _react.PropTypes.bool,
	
	  /** Groups can be aligned to the left or right of its container. */
	  floated: _react.PropTypes.oneOf(_lib.SUI.FLOATS),
	
	  /** Groups can take the width of their container. */
	  fluid: _react.PropTypes.bool,
	
	  /** Groups can be formatted as icons. */
	  icon: _react.PropTypes.bool,
	
	  /** Groups can be formatted to appear on dark backgrounds. */
	  inverted: _react.PropTypes.bool,
	
	  /** Groups can be formatted as labeled icon buttons. */
	  labeled: _react.PropTypes.bool,
	
	  /** Groups can hint towards a negative consequence. */
	  negative: _react.PropTypes.bool,
	
	  /** Groups can hint towards a positive consequence. */
	  positive: _react.PropTypes.bool,
	
	  /** Groups can be formatted to show different levels of emphasis. */
	  primary: _react.PropTypes.bool,
	
	  /** Groups can be formatted to show different levels of emphasis. */
	  secondary: _react.PropTypes.bool,
	
	  /** Groups can have different sizes. */
	  size: _react.PropTypes.oneOf(_lib.SUI.SIZES),
	
	  /** Groups can be formatted to toggle on and off. */
	  toggle: _react.PropTypes.bool,
	
	  /** Groups can be formatted to appear vertically. */
	  vertical: _react.PropTypes.bool,
	
	  /** Groups can have their widths divided evenly. */
	  widths: _react.PropTypes.oneOf(_lib.SUI.WIDTHS)
	} : void 0;
	
	exports.default = ButtonGroup;

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Used in some Button types, such as `animated`.
	 */
	function ButtonOr(props) {
	  var className = props.className;
	
	  var classes = (0, _classnames2.default)('or', className);
	  var rest = (0, _lib.getUnhandledProps)(ButtonOr, props);
	  var ElementType = (0, _lib.getElementType)(ButtonOr, props);
	
	  return _react2.default.createElement(ElementType, (0, _extends3.default)({}, rest, { className: classes }));
	}
	
	ButtonOr.handledProps = ['as', 'className'];
	ButtonOr._meta = {
	  name: 'ButtonOr',
	  parent: 'Button',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	 false ? ButtonOr.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string
	} : void 0;
	
	exports.default = ButtonOr;

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Modal = __webpack_require__(742);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Modal2.default;

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(513);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(514);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(518);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(552);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _pick2 = __webpack_require__(682);
	
	var _pick3 = _interopRequireDefault(_pick2);
	
	var _omit2 = __webpack_require__(743);
	
	var _omit3 = _interopRequireDefault(_omit2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ModalHeader = __webpack_require__(746);
	
	var _ModalHeader2 = _interopRequireDefault(_ModalHeader);
	
	var _ModalContent = __webpack_require__(747);
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _ModalActions = __webpack_require__(748);
	
	var _ModalActions2 = _interopRequireDefault(_ModalActions);
	
	var _ModalDescription = __webpack_require__(749);
	
	var _ModalDescription2 = _interopRequireDefault(_ModalDescription);
	
	var _Icon = __webpack_require__(750);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Portal = __webpack_require__(729);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var debug = (0, _lib.makeDebugger)('modal');
	
	var _meta = {
	  name: 'Modal',
	  type: _lib.META.TYPES.MODULE,
	  props: {
	    size: ['fullscreen', 'large', 'small'],
	    dimmer: ['inverted', 'blurring']
	  }
	};
	
	/**
	 * A modal displays content that temporarily blocks interactions with the main view of a site
	 * @see Confirm
	 * @see Portal
	 */
	
	var Modal = function (_Component) {
	  (0, _inherits3.default)(Modal, _Component);
	
	  function Modal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.getMountNode = function () {
	      return _lib.isBrowser ? _this.props.mountNode || document.body : null;
	    }, _this.handleClose = function (e) {
	      debug('close()');
	
	      var onClose = _this.props.onClose;
	
	      if (onClose) onClose(e, _this.props);
	
	      _this.trySetState({ open: false });
	    }, _this.handleOpen = function (e) {
	      debug('open()');
	
	      var onOpen = _this.props.onOpen;
	
	      if (onOpen) onOpen(e, _this.props);
	
	      _this.trySetState({ open: true });
	    }, _this.handlePortalMount = function (e) {
	      debug('handlePortalMount()');
	      var dimmer = _this.props.dimmer;
	
	      var mountNode = _this.getMountNode();
	
	      if (dimmer) {
	        debug('adding dimmer');
	        mountNode.classList.add('dimmable', 'dimmed');
	
	        if (dimmer === 'blurring') {
	          debug('adding blurred dimmer');
	          mountNode.classList.add('blurring');
	        }
	      }
	
	      _this.setPosition();
	
	      var onMount = _this.props.onMount;
	
	      if (onMount) onMount(e, _this.props);
	    }, _this.handlePortalUnmount = function (e) {
	      debug('handlePortalUnmount()');
	
	      // Always remove all dimmer classes.
	      // If the dimmer value changes while the modal is open, then removing its
	      // current value could leave cruft classes previously added.
	      var mountNode = _this.getMountNode();
	      mountNode.classList.remove('blurring', 'dimmable', 'dimmed', 'scrollable');
	
	      cancelAnimationFrame(_this.animationRequestId);
	
	      var onUnmount = _this.props.onUnmount;
	
	      if (onUnmount) onUnmount(e, _this.props);
	    }, _this.setPosition = function () {
	      if (_this._modalNode) {
	        var mountNode = _this.getMountNode();
	
	        var _this$_modalNode$getB = _this._modalNode.getBoundingClientRect(),
	            height = _this$_modalNode$getB.height;
	
	        var marginTop = -Math.round(height / 2);
	        var scrolling = height >= window.innerHeight;
	
	        var newState = {};
	
	        if (_this.state.marginTop !== marginTop) {
	          newState.marginTop = marginTop;
	        }
	
	        if (_this.state.scrolling !== scrolling) {
	          newState.scrolling = scrolling;
	
	          if (scrolling) {
	            mountNode.classList.add('scrolling');
	          } else {
	            mountNode.classList.remove('scrolling');
	          }
	        }
	
	        if (Object.keys(newState).length > 0) _this.setState(newState);
	      }
	
	      _this.animationRequestId = requestAnimationFrame(_this.setPosition);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Modal, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      debug('componentWillUnmount()');
	      this.handlePortalUnmount();
	    }
	
	    // Do not access document when server side rendering
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var open = this.state.open;
	      var _props = this.props,
	          basic = _props.basic,
	          children = _props.children,
	          className = _props.className,
	          closeIcon = _props.closeIcon,
	          closeOnDimmerClick = _props.closeOnDimmerClick,
	          closeOnDocumentClick = _props.closeOnDocumentClick,
	          dimmer = _props.dimmer,
	          size = _props.size;
	
	
	      var mountNode = this.getMountNode();
	
	      // Short circuit when server side rendering
	      if (!_lib.isBrowser) return null;
	
	      var _state = this.state,
	          marginTop = _state.marginTop,
	          scrolling = _state.scrolling;
	
	      var classes = (0, _classnames2.default)('ui', size, (0, _lib.useKeyOnly)(basic, 'basic'), (0, _lib.useKeyOnly)(scrolling, 'scrolling'), 'modal transition visible active', className);
	      var unhandled = (0, _lib.getUnhandledProps)(Modal, this.props);
	      var portalPropNames = _Portal2.default.handledProps;
	
	      var rest = (0, _omit3.default)(unhandled, portalPropNames);
	      var portalProps = (0, _pick3.default)(unhandled, portalPropNames);
	      var ElementType = (0, _lib.getElementType)(Modal, this.props);
	
	      var closeIconName = closeIcon === true ? 'close' : closeIcon;
	
	      var modalJSX = _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes, style: { marginTop: marginTop }, ref: function ref(c) {
	            return _this2._modalNode = c;
	          } }),
	        _Icon2.default.create(closeIconName, { onClick: this.handleClose }),
	        children
	      );
	
	      // wrap dimmer modals
	      var dimmerClasses = !dimmer ? null : (0, _classnames2.default)('ui', dimmer === 'inverted' && 'inverted', 'page modals dimmer transition visible active');
	
	      // Heads up!
	      //
	      // The SUI CSS selector to prevent the modal itself from blurring requires an immediate .dimmer child:
	      // .blurring.dimmed.dimmable>:not(.dimmer) { ... }
	      //
	      // The .blurring.dimmed.dimmable is the body, so that all body content inside is blurred.
	      // We need the immediate child to be the dimmer to :not() blur the modal itself!
	      // Otherwise, the portal div is also blurred, blurring the modal.
	      //
	      // We cannot them wrap the modalJSX in an actual <Dimmer /> instead, we apply the dimmer classes to the <Portal />.
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        (0, _extends3.default)({
	          closeOnRootNodeClick: closeOnDimmerClick,
	          closeOnDocumentClick: closeOnDocumentClick
	        }, portalProps, {
	          className: dimmerClasses,
	          mountNode: mountNode,
	          onClose: this.handleClose,
	          onMount: this.handlePortalMount,
	          onOpen: this.handleOpen,
	          onUnmount: this.handlePortalUnmount,
	          open: open
	        }),
	        modalJSX
	      );
	    }
	  }]);
	  return Modal;
	}(_lib.AutoControlledComponent);
	
	Modal.defaultProps = {
	  dimmer: true,
	  closeOnDimmerClick: true,
	  closeOnDocumentClick: false
	};
	Modal.autoControlledProps = ['open'];
	Modal._meta = _meta;
	Modal.Header = _ModalHeader2.default;
	Modal.Content = _ModalContent2.default;
	Modal.Description = _ModalDescription2.default;
	Modal.Actions = _ModalActions2.default;
	 false ? Modal.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A modal can reduce its complexity */
	  basic: _react.PropTypes.bool,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Icon */
	  closeIcon: _react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.object, _react.PropTypes.bool]),
	
	  /**
	   * Whether or not the Modal should close when the dimmer is clicked.
	   */
	  closeOnDimmerClick: _react.PropTypes.bool,
	
	  /** Whether or not the Modal should close when the document is clicked. */
	  closeOnDocumentClick: _react.PropTypes.bool,
	
	  /** Initial value of open. */
	  defaultOpen: _react.PropTypes.bool,
	
	  /** A modal can appear in a dimmer */
	  dimmer: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.oneOf(_meta.props.dimmer)]),
	
	  /** The node where the modal should mount.  Defaults to document.body. */
	  mountNode: _react.PropTypes.any,
	
	  /**
	   * Called when a close event happens
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClose: _react.PropTypes.func,
	
	  /**
	   * Called when the portal is mounted on the DOM
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onMount: _react.PropTypes.func,
	
	  /**
	   * Called when an open event happens
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onOpen: _react.PropTypes.func,
	
	  /**
	   * Called when the portal is unmounted from the DOM
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onUnmount: _react.PropTypes.func,
	
	  /** Controls whether or not the Modal is displayed. */
	  open: _react.PropTypes.bool,
	
	  /** A modal can vary in size */
	  size: _react.PropTypes.oneOf(_meta.props.size)
	
	} : void 0;
	Modal.handledProps = ['as', 'basic', 'children', 'className', 'closeIcon', 'closeOnDimmerClick', 'closeOnDocumentClick', 'defaultOpen', 'dimmer', 'mountNode', 'onClose', 'onMount', 'onOpen', 'onUnmount', 'open', 'size'];
	exports.default = Modal;

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(376),
	    baseClone = __webpack_require__(657),
	    baseUnset = __webpack_require__(744),
	    castPath = __webpack_require__(368),
	    copyObject = __webpack_require__(459),
	    customOmitClone = __webpack_require__(745),
	    flatRest = __webpack_require__(677),
	    getAllKeysIn = __webpack_require__(662);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable property paths of `object` that are not omitted.
	 *
	 * **Note:** This method is considerably slower than `_.pick`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to omit.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omit(object, ['a', 'c']);
	 * // => { 'b': '2' }
	 */
	var omit = flatRest(function(object, paths) {
	  var result = {};
	  if (object == null) {
	    return result;
	  }
	  var isDeep = false;
	  paths = arrayMap(paths, function(path) {
	    path = castPath(path, object);
	    isDeep || (isDeep = path.length > 1);
	    return path;
	  });
	  copyObject(object, getAllKeysIn(object), result);
	  if (isDeep) {
	    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	  }
	  var length = paths.length;
	  while (length--) {
	    baseUnset(result, paths[length]);
	  }
	  return result;
	});
	
	module.exports = omit;


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(368),
	    last = __webpack_require__(385),
	    parent = __webpack_require__(733),
	    toKey = __webpack_require__(377);
	
	/**
	 * The base implementation of `_.unset`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The property path to unset.
	 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	 */
	function baseUnset(object, path) {
	  path = castPath(path, object);
	  object = parent(object, path);
	  return object == null || delete object[toKey(last(path))];
	}
	
	module.exports = baseUnset;


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	var isPlainObject = __webpack_require__(456);
	
	/**
	 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	 * objects.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {string} key The key of the property to inspect.
	 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	 */
	function customOmitClone(value) {
	  return isPlainObject(value) ? undefined : value;
	}
	
	module.exports = customOmitClone;


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ModalHeader(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)(className, 'header');
	  var rest = (0, _lib.getUnhandledProps)(ModalHeader, props);
	  var ElementType = (0, _lib.getElementType)(ModalHeader, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _isNil3.default)(children) ? content : children
	  );
	}
	
	ModalHeader.handledProps = ['as', 'children', 'className', 'content'];
	ModalHeader._meta = {
	  name: 'ModalHeader',
	  type: _lib.META.TYPES.MODULE,
	  parent: 'Modal'
	};
	
	 false ? ModalHeader.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : void 0;
	
	ModalHeader.create = (0, _lib.createShorthandFactory)(ModalHeader, function (content) {
	  return { content: content };
	});
	
	exports.default = ModalHeader;

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ModalContent(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      image = props.image;
	
	
	  var classes = (0, _classnames2.default)(className, (0, _lib.useKeyOnly)(image, 'image'), 'content');
	  var rest = (0, _lib.getUnhandledProps)(ModalContent, props);
	  var ElementType = (0, _lib.getElementType)(ModalContent, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _isNil3.default)(children) ? content : children
	  );
	}
	
	ModalContent.handledProps = ['as', 'children', 'className', 'content', 'image'];
	ModalContent._meta = {
	  name: 'ModalContent',
	  type: _lib.META.TYPES.MODULE,
	  parent: 'Modal'
	};
	
	 false ? ModalContent.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A modal can contain image content */
	  image: _react.PropTypes.bool
	} : void 0;
	
	ModalContent.create = (0, _lib.createShorthandFactory)(ModalContent, function (content) {
	  return { content: content };
	});
	
	exports.default = ModalContent;

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ModalActions(props) {
	  var children = props.children,
	      className = props.className;
	
	  var classes = (0, _classnames2.default)(className, 'actions');
	  var rest = (0, _lib.getUnhandledProps)(ModalActions, props);
	  var ElementType = (0, _lib.getElementType)(ModalActions, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	ModalActions.handledProps = ['as', 'children', 'className'];
	ModalActions._meta = {
	  name: 'ModalActions',
	  type: _lib.META.TYPES.MODULE,
	  parent: 'Modal'
	};
	
	 false ? ModalActions.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string
	} : void 0;
	
	exports.default = ModalActions;

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ModalDescription(props) {
	  var children = props.children,
	      className = props.className;
	
	  var classes = (0, _classnames2.default)(className, 'description');
	  var rest = (0, _lib.getUnhandledProps)(ModalDescription, props);
	  var ElementType = (0, _lib.getElementType)(ModalDescription, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	ModalDescription.handledProps = ['as', 'children', 'className'];
	ModalDescription._meta = {
	  name: 'ModalDescription',
	  type: _lib.META.TYPES.MODULE,
	  parent: 'Modal'
	};
	
	 false ? ModalDescription.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string
	} : void 0;
	
	exports.default = ModalDescription;

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Icon = __webpack_require__(722);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Icon2.default;

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Radio = __webpack_require__(752);
	
	var _Radio2 = _interopRequireDefault(_Radio);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Radio2.default;

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _Checkbox = __webpack_require__(753);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A Radio is sugar for <Checkbox radio />.
	 * Useful for exclusive groups of sliders or toggles.
	 * @see Checkbox
	 * @see Form
	 */
	function Radio(props) {
	  var slider = props.slider,
	      toggle = props.toggle,
	      type = props.type;
	
	  var rest = (0, _lib.getUnhandledProps)(Radio, props);
	  // const ElementType = getElementType(Radio, props)
	  // radio, slider, toggle are exclusive
	  // use an undefined radio if slider or toggle are present
	  var radio = !(slider || toggle) || undefined;
	
	  return _react2.default.createElement(_Checkbox2.default, (0, _extends3.default)({}, rest, { type: type, radio: radio, slider: slider, toggle: toggle }));
	}
	
	Radio.handledProps = ['slider', 'toggle', 'type'];
	Radio._meta = {
	  name: 'Radio',
	  type: _lib.META.TYPES.ADDON
	};
	
	 false ? Radio.propTypes = {
	  /** Format to emphasize the current selection state. */
	  slider: _Checkbox2.default.propTypes.slider,
	
	  /** Format to show an on or off choice. */
	  toggle: _Checkbox2.default.propTypes.toggle,
	
	  /** HTML input type, either checkbox or radio. */
	  type: _Checkbox2.default.propTypes.type
	} : void 0;
	
	Radio.defaultProps = {
	  type: 'radio'
	};
	
	exports.default = Radio;

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Checkbox = __webpack_require__(754);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Checkbox2.default;

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(513);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(514);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(518);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(552);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _isNil2 = __webpack_require__(710);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var debug = (0, _lib.makeDebugger)('checkbox');
	
	/**
	 * A checkbox allows a user to select a value from a small set of options, often binary.
	 * @see Form
	 * @see Radio
	 */
	
	var Checkbox = function (_Component) {
	  (0, _inherits3.default)(Checkbox, _Component);
	
	  function Checkbox() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Checkbox);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.canToggle = function () {
	      var _this$props = _this.props,
	          disabled = _this$props.disabled,
	          radio = _this$props.radio,
	          readOnly = _this$props.readOnly;
	      var checked = _this.state.checked;
	
	
	      return !disabled && !readOnly && !(radio && checked);
	    }, _this.handleRef = function (c) {
	      _this.checkboxRef = c;
	    }, _this.handleClick = function (e) {
	      debug('handleClick()');
	      var _this$props2 = _this.props,
	          onChange = _this$props2.onChange,
	          onClick = _this$props2.onClick;
	      var _this$state = _this.state,
	          checked = _this$state.checked,
	          indeterminate = _this$state.indeterminate;
	
	
	      if (_this.canToggle()) {
	        if (onClick) onClick(e, (0, _extends3.default)({}, _this.props, { checked: !!checked, indeterminate: !!indeterminate }));
	        if (onChange) onChange(e, (0, _extends3.default)({}, _this.props, { checked: !checked, indeterminate: false }));
	
	        _this.trySetState({ checked: !checked, indeterminate: false });
	      }
	    }, _this.setIndeterminate = function () {
	      var indeterminate = _this.state.indeterminate;
	
	      if (_this.checkboxRef) _this.checkboxRef.indeterminate = !!indeterminate;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Checkbox, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setIndeterminate();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.setIndeterminate();
	    }
	
	    // Note: You can't directly set the indeterminate prop on the input, so we
	    // need to maintain a ref to the input and set it manually whenever the
	    // component updates.
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          disabled = _props.disabled,
	          label = _props.label,
	          name = _props.name,
	          radio = _props.radio,
	          readOnly = _props.readOnly,
	          slider = _props.slider,
	          tabIndex = _props.tabIndex,
	          toggle = _props.toggle,
	          type = _props.type,
	          value = _props.value;
	      var _state = this.state,
	          checked = _state.checked,
	          indeterminate = _state.indeterminate;
	
	
	      var classes = (0, _classnames2.default)('ui', (0, _lib.useKeyOnly)(checked, 'checked'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(indeterminate, 'indeterminate'),
	      // auto apply fitted class to compact white space when there is no label
	      // http://semantic-ui.com/modules/checkbox.html#fitted
	      (0, _lib.useKeyOnly)(!label, 'fitted'), (0, _lib.useKeyOnly)(radio, 'radio'), (0, _lib.useKeyOnly)(readOnly, 'read-only'), (0, _lib.useKeyOnly)(slider, 'slider'), (0, _lib.useKeyOnly)(toggle, 'toggle'), 'checkbox', className);
	      var rest = (0, _lib.getUnhandledProps)(Checkbox, this.props);
	      var ElementType = (0, _lib.getElementType)(Checkbox, this.props);
	
	      var computedTabIndex = void 0;
	      if (!(0, _isNil3.default)(tabIndex)) computedTabIndex = tabIndex;else computedTabIndex = disabled ? -1 : 0;
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes, onClick: this.handleClick, onChange: this.handleClick }),
	        _react2.default.createElement('input', {
	          checked: checked,
	          className: 'hidden',
	          name: name,
	          readOnly: true,
	          ref: this.handleRef,
	          tabIndex: computedTabIndex,
	          type: type,
	          value: value
	        }),
	        (0, _lib.createHTMLLabel)(label) || _react2.default.createElement('label', null)
	      );
	    }
	  }]);
	  return Checkbox;
	}(_lib.AutoControlledComponent);
	
	Checkbox.defaultProps = {
	  type: 'checkbox'
	};
	Checkbox.autoControlledProps = ['checked', 'indeterminate'];
	Checkbox._meta = {
	  name: 'Checkbox',
	  type: _lib.META.TYPES.MODULE
	};
	exports.default = Checkbox;
	 false ? Checkbox.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Whether or not checkbox is checked. */
	  checked: _react.PropTypes.bool,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** The initial value of checked. */
	  defaultChecked: _react.PropTypes.bool,
	
	  /** Whether or not checkbox is indeterminate. */
	  defaultIndeterminate: _react.PropTypes.bool,
	
	  /** A checkbox can appear disabled and be unable to change states */
	  disabled: _react.PropTypes.bool,
	
	  /** Removes padding for a label. Auto applied when there is no label. */
	  fitted: _react.PropTypes.bool,
	
	  /** Whether or not checkbox is indeterminate. */
	  indeterminate: _react.PropTypes.bool,
	
	  /** The text of the associated label element. */
	  label: _lib.customPropTypes.itemShorthand,
	
	  /** The HTML input name. */
	  name: _react.PropTypes.string,
	
	  /**
	   * Called when the user attempts to change the checked state.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props and proposed checked/indeterminate state.
	   */
	  onChange: _react.PropTypes.func,
	
	  /**
	   * Called when the checkbox or label is clicked.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props and current checked/indeterminate state.
	   */
	  onClick: _react.PropTypes.func,
	
	  /** Format as a radio element. This means it is an exclusive option. */
	  radio: _lib.customPropTypes.every([_react.PropTypes.bool, _lib.customPropTypes.disallow(['slider', 'toggle'])]),
	
	  /** A checkbox can be read-only and unable to change states. */
	  readOnly: _react.PropTypes.bool,
	
	  /** Format to emphasize the current selection state. */
	  slider: _lib.customPropTypes.every([_react.PropTypes.bool, _lib.customPropTypes.disallow(['radio', 'toggle'])]),
	
	  /** Format to show an on or off choice. */
	  toggle: _lib.customPropTypes.every([_react.PropTypes.bool, _lib.customPropTypes.disallow(['radio', 'slider'])]),
	
	  /** HTML input type, either checkbox or radio. */
	  type: _react.PropTypes.oneOf(['checkbox', 'radio']),
	
	  /** The HTML input value. */
	  value: _react.PropTypes.string,
	
	  /** A checkbox can receive focus. */
	  tabIndex: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])
	} : void 0;
	Checkbox.handledProps = ['as', 'checked', 'className', 'defaultChecked', 'defaultIndeterminate', 'disabled', 'fitted', 'indeterminate', 'label', 'name', 'onChange', 'onClick', 'radio', 'readOnly', 'slider', 'tabIndex', 'toggle', 'type', 'value'];

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Select = __webpack_require__(756);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Select2.default;

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _Dropdown = __webpack_require__(757);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A Select is sugar for <Dropdown selection />.
	 * @see Dropdown
	 * @see Form
	 */
	function Select(props) {
	  return _react2.default.createElement(_Dropdown2.default, (0, _extends3.default)({}, props, { selection: true }));
	}
	
	Select.handledProps = [];
	Select._meta = {
	  name: 'Select',
	  type: _lib.META.TYPES.ADDON
	};
	
	Select.Divider = _Dropdown2.default.Divider;
	Select.Header = _Dropdown2.default.Header;
	Select.Item = _Dropdown2.default.Item;
	Select.Menu = _Dropdown2.default.Menu;
	
	exports.default = Select;

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Dropdown = __webpack_require__(758);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Dropdown2.default;

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(513);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(514);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(518);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get3 = __webpack_require__(759);
	
	var _get4 = _interopRequireDefault(_get3);
	
	var _inherits2 = __webpack_require__(552);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _compact2 = __webpack_require__(689);
	
	var _compact3 = _interopRequireDefault(_compact2);
	
	var _map2 = __webpack_require__(702);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _every2 = __webpack_require__(767);
	
	var _every3 = _interopRequireDefault(_every2);
	
	var _without2 = __webpack_require__(723);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _findIndex2 = __webpack_require__(603);
	
	var _findIndex3 = _interopRequireDefault(_findIndex2);
	
	var _find2 = __webpack_require__(601);
	
	var _find3 = _interopRequireDefault(_find2);
	
	var _reduce2 = __webpack_require__(464);
	
	var _reduce3 = _interopRequireDefault(_reduce2);
	
	var _some2 = __webpack_require__(604);
	
	var _some3 = _interopRequireDefault(_some2);
	
	var _escapeRegExp2 = __webpack_require__(770);
	
	var _escapeRegExp3 = _interopRequireDefault(_escapeRegExp2);
	
	var _filter2 = __webpack_require__(263);
	
	var _filter3 = _interopRequireDefault(_filter2);
	
	var _isFunction2 = __webpack_require__(297);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _dropRight2 = __webpack_require__(771);
	
	var _dropRight3 = _interopRequireDefault(_dropRight2);
	
	var _isEmpty2 = __webpack_require__(578);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _union2 = __webpack_require__(772);
	
	var _union3 = _interopRequireDefault(_union2);
	
	var _get5 = __webpack_require__(366);
	
	var _get6 = _interopRequireDefault(_get5);
	
	var _includes2 = __webpack_require__(707);
	
	var _includes3 = _interopRequireDefault(_includes2);
	
	var _isUndefined2 = __webpack_require__(572);
	
	var _isUndefined3 = _interopRequireDefault(_isUndefined2);
	
	var _has2 = __webpack_require__(560);
	
	var _has3 = _interopRequireDefault(_has2);
	
	var _isEqual2 = __webpack_require__(598);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _Icon = __webpack_require__(750);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Label = __webpack_require__(775);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _DropdownDivider = __webpack_require__(776);
	
	var _DropdownDivider2 = _interopRequireDefault(_DropdownDivider);
	
	var _DropdownItem = __webpack_require__(777);
	
	var _DropdownItem2 = _interopRequireDefault(_DropdownItem);
	
	var _DropdownHeader = __webpack_require__(781);
	
	var _DropdownHeader2 = _interopRequireDefault(_DropdownHeader);
	
	var _DropdownMenu = __webpack_require__(782);
	
	var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var debug = (0, _lib.makeDebugger)('dropdown');
	
	var _meta = {
	  name: 'Dropdown',
	  type: _lib.META.TYPES.MODULE,
	  props: {
	    pointing: ['left', 'right', 'top', 'top left', 'top right', 'bottom', 'bottom left', 'bottom right'],
	    additionPosition: ['top', 'bottom']
	  }
	};
	
	/**
	 * A dropdown allows a user to select a value from a series of options.
	 * @see Form
	 * @see Select
	 * @see Menu
	 */
	
	var Dropdown = function (_Component) {
	  (0, _inherits3.default)(Dropdown, _Component);
	
	  function Dropdown() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Dropdown);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (e, value) {
	      debug('handleChange()');
	      debug(value);
	      var onChange = _this.props.onChange;
	
	      if (onChange) onChange(e, (0, _extends3.default)({}, _this.props, { value: value }));
	    }, _this.closeOnChange = function (e) {
	      var _this$props = _this.props,
	          closeOnChange = _this$props.closeOnChange,
	          multiple = _this$props.multiple;
	
	      var shouldClose = (0, _isUndefined3.default)(closeOnChange) ? !multiple : closeOnChange;
	
	      if (shouldClose) _this.close(e);
	    }, _this.closeOnEscape = function (e) {
	      if (_lib.keyboardKey.getCode(e) !== _lib.keyboardKey.Escape) return;
	      e.preventDefault();
	      _this.close();
	    }, _this.moveSelectionOnKeyDown = function (e) {
	      debug('moveSelectionOnKeyDown()');
	      debug(_lib.keyboardKey.getName(e));
	      switch (_lib.keyboardKey.getCode(e)) {
	        case _lib.keyboardKey.ArrowDown:
	          e.preventDefault();
	          _this.moveSelectionBy(1);
	          break;
	        case _lib.keyboardKey.ArrowUp:
	          e.preventDefault();
	          _this.moveSelectionBy(-1);
	          break;
	        default:
	          break;
	      }
	    }, _this.openOnSpace = function (e) {
	      debug('openOnSpace()');
	
	      if (_lib.keyboardKey.getCode(e) !== _lib.keyboardKey.Spacebar) return;
	      if (_this.state.open) return;
	
	      e.preventDefault();
	
	      _this.open(e);
	    }, _this.openOnArrow = function (e) {
	      debug('openOnArrow()');
	
	      var code = _lib.keyboardKey.getCode(e);
	      if (!(0, _includes3.default)([_lib.keyboardKey.ArrowDown, _lib.keyboardKey.ArrowUp], code)) return;
	      if (_this.state.open) return;
	
	      e.preventDefault();
	
	      _this.open(e);
	    }, _this.makeSelectedItemActive = function (e) {
	      var open = _this.state.open;
	      var _this$props2 = _this.props,
	          multiple = _this$props2.multiple,
	          onAddItem = _this$props2.onAddItem;
	
	      var item = _this.getSelectedItem();
	      var value = (0, _get6.default)(item, 'value');
	
	      // prevent selecting null if there was no selected item value
	      // prevent selecting duplicate items when the dropdown is closed
	      if (!value || !open) return;
	
	      // notify the onAddItem prop if this is a new value
	      if (onAddItem && item['data-additional']) {
	        onAddItem(e, (0, _extends3.default)({}, _this.props, { value: value }));
	      }
	      // notify the onChange prop that the user is trying to change value
	      if (multiple) {
	        // state value may be undefined
	        var newValue = (0, _union3.default)(_this.state.value, [value]);
	        _this.setValue(newValue);
	        _this.handleChange(e, newValue);
	      } else {
	        _this.setValue(value);
	        _this.handleChange(e, value);
	      }
	    }, _this.selectItemOnEnter = function (e) {
	      debug('selectItemOnEnter()');
	      debug(_lib.keyboardKey.getName(e));
	      if (_lib.keyboardKey.getCode(e) !== _lib.keyboardKey.Enter) return;
	      e.preventDefault();
	
	      _this.makeSelectedItemActive(e);
	      _this.closeOnChange(e);
	    }, _this.removeItemOnBackspace = function (e) {
	      debug('removeItemOnBackspace()');
	      debug(_lib.keyboardKey.getName(e));
	      if (_lib.keyboardKey.getCode(e) !== _lib.keyboardKey.Backspace) return;
	
	      var _this$props3 = _this.props,
	          multiple = _this$props3.multiple,
	          search = _this$props3.search;
	      var _this$state = _this.state,
	          searchQuery = _this$state.searchQuery,
	          value = _this$state.value;
	
	
	      if (searchQuery || !search || !multiple || (0, _isEmpty3.default)(value)) return;
	
	      e.preventDefault();
	
	      // remove most recent value
	      var newValue = (0, _dropRight3.default)(value);
	
	      _this.setValue(newValue);
	      _this.handleChange(e, newValue);
	    }, _this.closeOnDocumentClick = function (e) {
	      debug('closeOnDocumentClick()');
	      debug(e);
	
	      // If event happened in the dropdown, ignore it
	      if (_this._dropdown && (0, _isFunction3.default)(_this._dropdown.contains) && _this._dropdown.contains(e.target)) return;
	
	      _this.close();
	    }, _this.handleMouseDown = function (e) {
	      debug('handleMouseDown()');
	      var onMouseDown = _this.props.onMouseDown;
	
	      if (onMouseDown) onMouseDown(e, _this.props);
	      _this.isMouseDown = true;
	      // Do not access document when server side rendering
	      if (!_lib.isBrowser) return;
	      document.addEventListener('mouseup', _this.handleDocumentMouseUp);
	    }, _this.handleDocumentMouseUp = function () {
	      debug('handleDocumentMouseUp()');
	      _this.isMouseDown = false;
	      // Do not access document when server side rendering
	      if (!_lib.isBrowser) return;
	      document.removeEventListener('mouseup', _this.handleDocumentMouseUp);
	    }, _this.handleClick = function (e) {
	      debug('handleClick()', e);
	      var onClick = _this.props.onClick;
	
	      if (onClick) onClick(e, _this.props);
	      // prevent closeOnDocumentClick()
	      e.stopPropagation();
	      _this.toggle(e);
	    }, _this.handleItemClick = function (e, item) {
	      debug('handleItemClick()');
	      debug(item);
	      var _this$props4 = _this.props,
	          multiple = _this$props4.multiple,
	          onAddItem = _this$props4.onAddItem;
	      var value = item.value;
	
	      // prevent toggle() in handleClick()
	
	      e.stopPropagation();
	      // prevent closeOnDocumentClick() if multiple or item is disabled
	      if (multiple || item.disabled) {
	        e.nativeEvent.stopImmediatePropagation();
	      }
	
	      if (item.disabled) return;
	
	      // notify the onAddItem prop if this is a new value
	      if (onAddItem && item['data-additional']) {
	        onAddItem(e, (0, _extends3.default)({}, _this.props, { value: value }));
	      }
	
	      // notify the onChange prop that the user is trying to change value
	      if (multiple) {
	        var newValue = (0, _union3.default)(_this.state.value, [value]);
	        _this.setValue(newValue);
	        _this.handleChange(e, newValue);
	      } else {
	        _this.setValue(value);
	        _this.handleChange(e, value);
	      }
	      _this.closeOnChange(e);
	    }, _this.handleFocus = function (e) {
	      debug('handleFocus()');
	      var onFocus = _this.props.onFocus;
	      var focus = _this.state.focus;
	
	      if (focus) return;
	      if (onFocus) onFocus(e, _this.props);
	      _this.setState({ focus: true });
	    }, _this.handleBlur = function (e) {
	      debug('handleBlur()');
	      var _this$props5 = _this.props,
	          closeOnBlur = _this$props5.closeOnBlur,
	          multiple = _this$props5.multiple,
	          onBlur = _this$props5.onBlur,
	          selectOnBlur = _this$props5.selectOnBlur;
	      // do not "blur" when the mouse is down inside of the Dropdown
	
	      if (_this.isMouseDown) return;
	      if (onBlur) onBlur(e, _this.props);
	      if (selectOnBlur && !multiple) {
	        _this.makeSelectedItemActive(e);
	        if (closeOnBlur) _this.close();
	      }
	      _this.setState({ focus: false, searchQuery: '' });
	    }, _this.handleSearchChange = function (e) {
	      debug('handleSearchChange()');
	      debug(e.target.value);
	      // prevent propagating to this.props.onChange()
	      e.stopPropagation();
	      var _this$props6 = _this.props,
	          search = _this$props6.search,
	          onSearchChange = _this$props6.onSearchChange;
	      var open = _this.state.open;
	
	      var newQuery = e.target.value;
	
	      if (onSearchChange) onSearchChange(e, newQuery);
	
	      // open search dropdown on search query
	      if (search && newQuery && !open) _this.open();
	
	      _this.setState({
	        selectedIndex: 0,
	        searchQuery: newQuery
	      });
	    }, _this.getMenuOptions = function () {
	      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.value;
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props.options;
	      var _this$props7 = _this.props,
	          multiple = _this$props7.multiple,
	          search = _this$props7.search,
	          allowAdditions = _this$props7.allowAdditions,
	          additionPosition = _this$props7.additionPosition,
	          additionLabel = _this$props7.additionLabel;
	      var searchQuery = _this.state.searchQuery;
	
	
	      var filteredOptions = options;
	
	      // filter out active options
	      if (multiple) {
	        filteredOptions = (0, _filter3.default)(filteredOptions, function (opt) {
	          return !(0, _includes3.default)(value, opt.value);
	        });
	      }
	
	      // filter by search query
	      if (search && searchQuery) {
	        if ((0, _isFunction3.default)(search)) {
	          filteredOptions = search(filteredOptions, searchQuery);
	        } else {
	          (function () {
	            var re = new RegExp((0, _escapeRegExp3.default)(searchQuery), 'i');
	            filteredOptions = (0, _filter3.default)(filteredOptions, function (opt) {
	              return re.test(opt.text);
	            });
	          })();
	        }
	      }
	
	      // insert the "add" item
	      if (allowAdditions && search && searchQuery && !(0, _some3.default)(filteredOptions, { text: searchQuery })) {
	        var additionLabelElement = _react2.default.isValidElement(additionLabel) ? _react2.default.cloneElement(additionLabel, { key: 'label' }) : additionLabel || '';
	
	        var addItem = {
	          // by using an array, we can pass multiple elements, but when doing so
	          // we must specify a `key` for React to know which one is which
	          text: [additionLabelElement, _react2.default.createElement(
	            'b',
	            { key: 'addition' },
	            searchQuery
	          )],
	          value: searchQuery,
	          className: 'addition',
	          'data-additional': true
	        };
	        if (additionPosition === 'top') filteredOptions.unshift(addItem);else filteredOptions.push(addItem);
	      }
	
	      return filteredOptions;
	    }, _this.getSelectedItem = function () {
	      var selectedIndex = _this.state.selectedIndex;
	
	      var options = _this.getMenuOptions();
	
	      return (0, _get6.default)(options, '[' + selectedIndex + ']');
	    }, _this.getEnabledIndices = function (givenOptions) {
	      var options = givenOptions || _this.getMenuOptions();
	
	      return (0, _reduce3.default)(options, function (memo, item, index) {
	        if (!item.disabled) memo.push(index);
	        return memo;
	      }, []);
	    }, _this.getItemByValue = function (value) {
	      var options = _this.props.options;
	
	
	      return (0, _find3.default)(options, { value: value });
	    }, _this.getMenuItemIndexByValue = function (value, givenOptions) {
	      var options = givenOptions || _this.getMenuOptions();
	
	      return (0, _findIndex3.default)(options, ['value', value]);
	    }, _this.getDropdownAriaOptions = function (ElementType) {
	      var _this$props8 = _this.props,
	          loading = _this$props8.loading,
	          disabled = _this$props8.disabled,
	          search = _this$props8.search,
	          multiple = _this$props8.multiple;
	      var open = _this.state.open;
	
	      var ariaOptions = {
	        role: search ? 'combobox' : 'listbox',
	        'aria-busy': loading,
	        'aria-disabled': disabled,
	        'aria-expanded': !!open
	      };
	      if (ariaOptions.role === 'listbox') {
	        ariaOptions['aria-multiselectable'] = multiple;
	      }
	      return ariaOptions;
	    }, _this.setValue = function (value) {
	      debug('setValue()');
	      debug('value', value);
	      var newState = {
	        searchQuery: ''
	      };
	
	      var _this$props9 = _this.props,
	          multiple = _this$props9.multiple,
	          search = _this$props9.search;
	
	      if (multiple && search && _this._search) _this._search.focus();
	
	      _this.trySetState({ value: value }, newState);
	      _this.setSelectedIndex(value);
	    }, _this.setSelectedIndex = function () {
	      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.value;
	      var optionsProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props.options;
	      var multiple = _this.props.multiple;
	      var selectedIndex = _this.state.selectedIndex;
	
	      var options = _this.getMenuOptions(value, optionsProps);
	      var enabledIndicies = _this.getEnabledIndices(options);
	
	      var newSelectedIndex = void 0;
	
	      // update the selected index
	      if (!selectedIndex || selectedIndex < 0) {
	        var firstIndex = enabledIndicies[0];
	
	        // Select the currently active item, if none, use the first item.
	        // Multiple selects remove active items from the list,
	        // their initial selected index should be 0.
	        newSelectedIndex = multiple ? firstIndex : _this.getMenuItemIndexByValue(value, options) || enabledIndicies[0];
	      } else if (multiple) {
	        // multiple selects remove options from the menu as they are made active
	        // keep the selected index within range of the remaining items
	        if (selectedIndex >= options.length - 1) {
	          newSelectedIndex = enabledIndicies[enabledIndicies.length - 1];
	        }
	      } else {
	        var activeIndex = _this.getMenuItemIndexByValue(value, options);
	
	        // regular selects can only have one active item
	        // set the selected index to the currently active item
	        newSelectedIndex = (0, _includes3.default)(enabledIndicies, activeIndex) ? activeIndex : undefined;
	      }
	
	      if (!newSelectedIndex || newSelectedIndex < 0) {
	        newSelectedIndex = enabledIndicies[0];
	      }
	
	      _this.setState({ selectedIndex: newSelectedIndex });
	    }, _this.handleLabelClick = function (e, labelProps) {
	      debug('handleLabelClick()');
	      // prevent focusing search input on click
	      e.stopPropagation();
	
	      _this.setState({ selectedLabel: labelProps.value });
	
	      var onLabelClick = _this.props.onLabelClick;
	
	      if (onLabelClick) onLabelClick(e, labelProps);
	    }, _this.handleLabelRemove = function (e, labelProps) {
	      debug('handleLabelRemove()');
	      // prevent focusing search input on click
	      e.stopPropagation();
	      var value = _this.state.value;
	
	      var newValue = (0, _without3.default)(value, labelProps.value);
	      debug('label props:', labelProps);
	      debug('current value:', value);
	      debug('remove value:', labelProps.value);
	      debug('new value:', newValue);
	
	      _this.setValue(newValue);
	      _this.handleChange(e, newValue);
	    }, _this.moveSelectionBy = function (offset) {
	      var startIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.selectedIndex;
	
	      debug('moveSelectionBy()');
	      debug('offset: ' + offset);
	
	      var options = _this.getMenuOptions();
	      var lastIndex = options.length - 1;
	
	      // Prevent infinite loop
	      if ((0, _every3.default)(options, 'disabled')) return;
	
	      // next is after last, wrap to beginning
	      // next is before first, wrap to end
	      var nextIndex = startIndex + offset;
	      if (nextIndex > lastIndex) nextIndex = 0;else if (nextIndex < 0) nextIndex = lastIndex;
	
	      if (options[nextIndex].disabled) return _this.moveSelectionBy(offset, nextIndex);
	
	      _this.setState({ selectedIndex: nextIndex });
	      _this.scrollSelectedItemIntoView();
	    }, _this.scrollSelectedItemIntoView = function () {
	      debug('scrollSelectedItemIntoView()');
	      var menu = _this._dropdown.querySelector('.menu.visible');
	      var item = menu.querySelector('.item.selected');
	      debug('menu: ' + menu);
	      debug('item: ' + item);
	      var isOutOfUpperView = item.offsetTop < menu.scrollTop;
	      var isOutOfLowerView = item.offsetTop + item.clientHeight > menu.scrollTop + menu.clientHeight;
	
	      if (isOutOfUpperView) {
	        menu.scrollTop = item.offsetTop;
	      } else if (isOutOfLowerView) {
	        menu.scrollTop = item.offsetTop + item.clientHeight - menu.clientHeight;
	      }
	    }, _this.open = function (e) {
	      debug('open()');
	
	      var _this$props10 = _this.props,
	          disabled = _this$props10.disabled,
	          onOpen = _this$props10.onOpen,
	          search = _this$props10.search;
	
	      if (disabled) return;
	      if (search && _this._search) _this._search.focus();
	      if (onOpen) onOpen(e, _this.props);
	
	      _this.trySetState({ open: true });
	    }, _this.close = function (e) {
	      debug('close()');
	
	      var onClose = _this.props.onClose;
	
	      if (onClose) onClose(e, _this.props);
	
	      _this.trySetState({ open: false });
	    }, _this.handleClose = function () {
	      debug('handleClose()');
	      var hasSearchFocus = document.activeElement === _this._search;
	      var hasDropdownFocus = document.activeElement === _this._dropdown;
	      var hasFocus = hasSearchFocus || hasDropdownFocus;
	      // https://github.com/Semantic-Org/Semantic-UI-React/issues/627
	      // Blur the Dropdown on close so it is blurred after selecting an item.
	      // This is to prevent it from re-opening when switching tabs after selecting an item.
	      if (!hasSearchFocus) {
	        _this._dropdown.blur();
	      }
	
	      // We need to keep the virtual model in sync with the browser focus change
	      // https://github.com/Semantic-Org/Semantic-UI-React/issues/692
	      _this.setState({ focus: hasFocus });
	    }, _this.toggle = function (e) {
	      return _this.state.open ? _this.close(e) : _this.open(e);
	    }, _this.renderText = function () {
	      var _this$props11 = _this.props,
	          multiple = _this$props11.multiple,
	          placeholder = _this$props11.placeholder,
	          search = _this$props11.search,
	          text = _this$props11.text;
	      var _this$state2 = _this.state,
	          searchQuery = _this$state2.searchQuery,
	          value = _this$state2.value,
	          open = _this$state2.open;
	
	      var hasValue = multiple ? !(0, _isEmpty3.default)(value) : !(0, _isNil3.default)(value) && value !== '';
	
	      var classes = (0, _classnames2.default)(placeholder && !hasValue && 'default', 'text', search && searchQuery && 'filtered');
	      var _text = placeholder;
	      if (searchQuery) {
	        _text = null;
	      } else if (text) {
	        _text = text;
	      } else if (open && !multiple) {
	        _text = (0, _get6.default)(_this.getSelectedItem(), 'text');
	      } else if (hasValue) {
	        _text = (0, _get6.default)(_this.getItemByValue(value), 'text');
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: classes },
	        _text
	      );
	    }, _this.renderHiddenInput = function () {
	      debug('renderHiddenInput()');
	      var value = _this.state.value;
	      var _this$props12 = _this.props,
	          multiple = _this$props12.multiple,
	          name = _this$props12.name,
	          options = _this$props12.options,
	          selection = _this$props12.selection;
	
	      debug('name:      ' + name);
	      debug('selection: ' + selection);
	      debug('value:     ' + value);
	      if (!selection) return null;
	
	      // a dropdown without an active item will have an empty string value
	      return _react2.default.createElement(
	        'select',
	        { type: 'hidden', 'aria-hidden': 'true', name: name, value: value, multiple: multiple },
	        _react2.default.createElement('option', { value: '' }),
	        (0, _map3.default)(options, function (option) {
	          return _react2.default.createElement(
	            'option',
	            { key: option.value, value: option.value },
	            option.text
	          );
	        })
	      );
	    }, _this.renderSearchInput = function () {
	      var _this$props13 = _this.props,
	          disabled = _this$props13.disabled,
	          search = _this$props13.search,
	          name = _this$props13.name,
	          tabIndex = _this$props13.tabIndex;
	      var searchQuery = _this.state.searchQuery;
	
	
	      if (!search) return null;
	
	      // tabIndex
	      var computedTabIndex = void 0;
	      if (!(0, _isNil3.default)(tabIndex)) computedTabIndex = tabIndex;else computedTabIndex = disabled ? -1 : 0;
	
	      // resize the search input, temporarily show the sizer so we can measure it
	      var searchWidth = void 0;
	      if (_this._sizer && searchQuery) {
	        _this._sizer.style.display = 'inline';
	        _this._sizer.textContent = searchQuery;
	        searchWidth = Math.ceil(_this._sizer.getBoundingClientRect().width);
	        _this._sizer.style.removeProperty('display');
	      }
	
	      return _react2.default.createElement('input', {
	        value: searchQuery,
	        type: 'text',
	        'aria-autocomplete': 'list',
	        onChange: _this.handleSearchChange,
	        className: 'search',
	        name: [name, 'search'].join('-'),
	        autoComplete: 'off',
	        tabIndex: computedTabIndex,
	        style: { width: searchWidth },
	        ref: function ref(c) {
	          return _this._search = c;
	        }
	      });
	    }, _this.renderSearchSizer = function () {
	      var _this$props14 = _this.props,
	          search = _this$props14.search,
	          multiple = _this$props14.multiple;
	
	
	      if (!(search && multiple)) return null;
	
	      return _react2.default.createElement('span', { className: 'sizer', ref: function ref(c) {
	          return _this._sizer = c;
	        } });
	    }, _this.renderLabels = function () {
	      debug('renderLabels()');
	      var _this$props15 = _this.props,
	          multiple = _this$props15.multiple,
	          renderLabel = _this$props15.renderLabel;
	      var _this$state3 = _this.state,
	          selectedLabel = _this$state3.selectedLabel,
	          value = _this$state3.value;
	
	      if (!multiple || (0, _isEmpty3.default)(value)) {
	        return;
	      }
	      var selectedItems = (0, _map3.default)(value, _this.getItemByValue);
	      debug('selectedItems', selectedItems);
	
	      // if no item could be found for a given state value the selected item will be undefined
	      // compact the selectedItems so we only have actual objects left
	      return (0, _map3.default)((0, _compact3.default)(selectedItems), function (item, index) {
	        var defaultLabelProps = {
	          active: item.value === selectedLabel,
	          as: 'a',
	          key: item.value,
	          onClick: _this.handleLabelClick,
	          onRemove: _this.handleLabelRemove,
	          value: item.value
	        };
	
	        return _Label2.default.create(renderLabel(item, index, defaultLabelProps), defaultLabelProps);
	      });
	    }, _this.renderOptions = function () {
	      var _this$props16 = _this.props,
	          multiple = _this$props16.multiple,
	          search = _this$props16.search,
	          noResultsMessage = _this$props16.noResultsMessage;
	      var _this$state4 = _this.state,
	          selectedIndex = _this$state4.selectedIndex,
	          value = _this$state4.value;
	
	      var options = _this.getMenuOptions();
	
	      if (noResultsMessage !== null && search && (0, _isEmpty3.default)(options)) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'message' },
	          noResultsMessage
	        );
	      }
	
	      var isActive = multiple ? function (optValue) {
	        return (0, _includes3.default)(value, optValue);
	      } : function (optValue) {
	        return optValue === value;
	      };
	
	      return (0, _map3.default)(options, function (opt, i) {
	        return _react2.default.createElement(_DropdownItem2.default, (0, _extends3.default)({
	          key: opt.value + '-' + i,
	          active: isActive(opt.value),
	          onClick: _this.handleItemClick,
	          selected: selectedIndex === i
	        }, opt, {
	          // Needed for handling click events on disabled items
	          style: (0, _extends3.default)({}, opt.style, { pointerEvents: 'all' })
	        }));
	      });
	    }, _this.renderMenu = function () {
	      var _this$props17 = _this.props,
	          children = _this$props17.children,
	          header = _this$props17.header;
	      var open = _this.state.open;
	
	      var menuClasses = open ? 'visible' : '';
	      var ariaOptions = _this.getDropdownMenuAriaOptions();
	
	      // single menu child
	      if (!(0, _isNil3.default)(children)) {
	        var menuChild = _react.Children.only(children);
	        var className = (0, _classnames2.default)(menuClasses, menuChild.props.className);
	
	        return (0, _react.cloneElement)(menuChild, (0, _extends3.default)({ className: className }, ariaOptions));
	      }
	
	      return _react2.default.createElement(
	        _DropdownMenu2.default,
	        (0, _extends3.default)({}, ariaOptions, { className: menuClasses }),
	        (0, _lib.createShorthand)(_DropdownHeader2.default, function (val) {
	          return { content: val };
	        }, header),
	        _this.renderOptions()
	      );
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Dropdown, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if ((0, _get4.default)(Dropdown.prototype.__proto__ || Object.getPrototypeOf(Dropdown.prototype), 'componentWillMount', this)) (0, _get4.default)(Dropdown.prototype.__proto__ || Object.getPrototypeOf(Dropdown.prototype), 'componentWillMount', this).call(this);
	      debug('componentWillMount()');
	      var _state = this.state,
	          open = _state.open,
	          value = _state.value;
	
	
	      this.setValue(value);
	      if (open) this.open();
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _isEqual3.default)(nextProps, this.props) || !(0, _isEqual3.default)(nextState, this.state);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      (0, _get4.default)(Dropdown.prototype.__proto__ || Object.getPrototypeOf(Dropdown.prototype), 'componentWillReceiveProps', this).call(this, nextProps);
	      debug('componentWillReceiveProps()');
	      // TODO objectDiff still runs in prod, stop it
	      debug('to props:', (0, _lib.objectDiff)(this.props, nextProps));
	
	      /* eslint-disable no-console */
	      if (false) {
	        // in development, validate value type matches dropdown type
	        var isNextValueArray = Array.isArray(nextProps.value);
	        var hasValue = (0, _has3.default)(nextProps, 'value');
	
	        if (hasValue && nextProps.multiple && !isNextValueArray) {
	          console.error('Dropdown `value` must be an array when `multiple` is set.' + (' Received type: `' + Object.prototype.toString.call(nextProps.value) + '`.'));
	        } else if (hasValue && !nextProps.multiple && isNextValueArray) {
	          console.error('Dropdown `value` must not be an array when `multiple` is not set.' + ' Either set `multiple={true}` or use a string or number value.');
	        }
	      }
	      /* eslint-enable no-console */
	
	      if (!(0, _isEqual3.default)(nextProps.value, this.props.value)) {
	        debug('value changed, setting', nextProps.value);
	        this.setValue(nextProps.value);
	      }
	
	      if (!(0, _isEqual3.default)(nextProps.options, this.props.options)) {
	        this.setSelectedIndex(undefined, nextProps.options);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      // eslint-disable-line complexity
	      debug('componentDidUpdate()');
	      // TODO objectDiff still runs in prod, stop it
	      debug('to state:', (0, _lib.objectDiff)(prevState, this.state));
	
	      // Do not access document when server side rendering
	      if (!_lib.isBrowser) return;
	
	      // focused / blurred
	      if (!prevState.focus && this.state.focus) {
	        debug('dropdown focused');
	        if (!this.isMouseDown) {
	          var openOnFocus = this.props.openOnFocus;
	
	          debug('mouse is not down, opening');
	          if (openOnFocus) this.open();
	        }
	        if (!this.state.open) {
	          document.addEventListener('keydown', this.openOnArrow);
	          document.addEventListener('keydown', this.openOnSpace);
	        } else {
	          document.addEventListener('keydown', this.moveSelectionOnKeyDown);
	          document.addEventListener('keydown', this.selectItemOnEnter);
	        }
	        document.addEventListener('keydown', this.removeItemOnBackspace);
	      } else if (prevState.focus && !this.state.focus) {
	        debug('dropdown blurred');
	        var closeOnBlur = this.props.closeOnBlur;
	
	        if (!this.isMouseDown && closeOnBlur) {
	          debug('mouse is not down and closeOnBlur=true, closing');
	          this.close();
	        }
	        document.removeEventListener('keydown', this.openOnArrow);
	        document.removeEventListener('keydown', this.openOnSpace);
	        document.removeEventListener('keydown', this.moveSelectionOnKeyDown);
	        document.removeEventListener('keydown', this.selectItemOnEnter);
	        document.removeEventListener('keydown', this.removeItemOnBackspace);
	      }
	
	      // opened / closed
	      if (!prevState.open && this.state.open) {
	        debug('dropdown opened');
	        document.addEventListener('keydown', this.closeOnEscape);
	        document.addEventListener('keydown', this.moveSelectionOnKeyDown);
	        document.addEventListener('keydown', this.selectItemOnEnter);
	        document.addEventListener('keydown', this.removeItemOnBackspace);
	        document.addEventListener('click', this.closeOnDocumentClick);
	        document.removeEventListener('keydown', this.openOnArrow);
	        document.removeEventListener('keydown', this.openOnSpace);
	      } else if (prevState.open && !this.state.open) {
	        debug('dropdown closed');
	        this.handleClose();
	        document.removeEventListener('keydown', this.closeOnEscape);
	        document.removeEventListener('keydown', this.moveSelectionOnKeyDown);
	        document.removeEventListener('keydown', this.selectItemOnEnter);
	        document.removeEventListener('click', this.closeOnDocumentClick);
	        if (!this.state.focus) {
	          document.removeEventListener('keydown', this.removeItemOnBackspace);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      debug('componentWillUnmount()');
	
	      // Do not access document when server side rendering
	      if (!_lib.isBrowser) return;
	
	      document.removeEventListener('keydown', this.openOnArrow);
	      document.removeEventListener('keydown', this.openOnSpace);
	      document.removeEventListener('keydown', this.moveSelectionOnKeyDown);
	      document.removeEventListener('keydown', this.selectItemOnEnter);
	      document.removeEventListener('keydown', this.removeItemOnBackspace);
	      document.removeEventListener('keydown', this.closeOnEscape);
	      document.removeEventListener('click', this.closeOnDocumentClick);
	    }
	
	    // ----------------------------------------
	    // Document Event Handlers
	    // ----------------------------------------
	
	    // onChange needs to receive a value
	    // can't rely on props.value if we are controlled
	
	
	    // ----------------------------------------
	    // Component Event Handlers
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Getters
	    // ----------------------------------------
	
	    // There are times when we need to calculate the options based on a value
	    // that hasn't yet been persisted to state.
	
	  }, {
	    key: 'getDropdownMenuAriaOptions',
	    value: function getDropdownMenuAriaOptions() {
	      var _props = this.props,
	          search = _props.search,
	          multiple = _props.multiple;
	
	      var ariaOptions = {};
	
	      if (search) {
	        ariaOptions['aria-multiselectable'] = multiple;
	        ariaOptions.role = 'listbox';
	      }
	      return ariaOptions;
	    }
	
	    // ----------------------------------------
	    // Setters
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Behavior
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Render
	    // ----------------------------------------
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      debug('render()');
	      debug('props', this.props);
	      debug('state', this.state);
	      var open = this.state.open;
	      var _props2 = this.props,
	          basic = _props2.basic,
	          button = _props2.button,
	          className = _props2.className,
	          compact = _props2.compact,
	          fluid = _props2.fluid,
	          floating = _props2.floating,
	          icon = _props2.icon,
	          inline = _props2.inline,
	          item = _props2.item,
	          labeled = _props2.labeled,
	          multiple = _props2.multiple,
	          pointing = _props2.pointing,
	          search = _props2.search,
	          selection = _props2.selection,
	          simple = _props2.simple,
	          loading = _props2.loading,
	          error = _props2.error,
	          disabled = _props2.disabled,
	          scrolling = _props2.scrolling,
	          tabIndex = _props2.tabIndex,
	          trigger = _props2.trigger;
	
	      // Classes
	
	      var classes = (0, _classnames2.default)('ui', (0, _lib.useKeyOnly)(open, 'active visible'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(error, 'error'), (0, _lib.useKeyOnly)(loading, 'loading'), (0, _lib.useKeyOnly)(basic, 'basic'), (0, _lib.useKeyOnly)(button, 'button'), (0, _lib.useKeyOnly)(compact, 'compact'), (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(floating, 'floating'), (0, _lib.useKeyOnly)(inline, 'inline'),
	      // TODO: consider augmentation to render Dropdowns as Button/Menu, solves icon/link item issues
	      // https://github.com/Semantic-Org/Semantic-UI-React/issues/401#issuecomment-240487229
	      // TODO: the icon class is only required when a dropdown is a button
	      // useKeyOnly(icon, 'icon'),
	      (0, _lib.useKeyOnly)(labeled, 'labeled'), (0, _lib.useKeyOnly)(item, 'item'), (0, _lib.useKeyOnly)(multiple, 'multiple'), (0, _lib.useKeyOnly)(search, 'search'), (0, _lib.useKeyOnly)(selection, 'selection'), (0, _lib.useKeyOnly)(simple, 'simple'), (0, _lib.useKeyOnly)(scrolling, 'scrolling'), (0, _lib.useKeyOrValueAndKey)(pointing, 'pointing'), className, 'dropdown');
	      var rest = (0, _lib.getUnhandledProps)(Dropdown, this.props);
	      var ElementType = (0, _lib.getElementType)(Dropdown, this.props);
	      var ariaOptions = this.getDropdownAriaOptions(ElementType, this.props);
	
	      var computedTabIndex = void 0;
	      if (!(0, _isNil3.default)(tabIndex)) {
	        computedTabIndex = tabIndex;
	      } else if (!search) {
	        // don't set a root node tabIndex as the search input has its own tabIndex
	        computedTabIndex = disabled ? -1 : 0;
	      }
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, ariaOptions, {
	          className: classes,
	          onBlur: this.handleBlur,
	          onClick: this.handleClick,
	          onMouseDown: this.handleMouseDown,
	          onFocus: this.handleFocus,
	          onChange: this.handleChange,
	          tabIndex: computedTabIndex,
	          ref: function ref(c) {
	            return _this2._dropdown = c;
	          }
	        }),
	        this.renderHiddenInput(),
	        this.renderLabels(),
	        this.renderSearchInput(),
	        this.renderSearchSizer(),
	        trigger || this.renderText(),
	        _Icon2.default.create(icon),
	        this.renderMenu()
	      );
	    }
	  }]);
	  return Dropdown;
	}(_lib.AutoControlledComponent);
	
	Dropdown.defaultProps = {
	  additionLabel: 'Add ',
	  additionPosition: 'top',
	  icon: 'dropdown',
	  noResultsMessage: 'No results found.',
	  renderLabel: function renderLabel(_ref2) {
	    var text = _ref2.text;
	    return text;
	  },
	  selectOnBlur: true,
	  openOnFocus: true,
	  closeOnBlur: true
	};
	Dropdown.autoControlledProps = ['open', 'value', 'selectedLabel'];
	Dropdown._meta = _meta;
	Dropdown.Divider = _DropdownDivider2.default;
	Dropdown.Header = _DropdownHeader2.default;
	Dropdown.Item = _DropdownItem2.default;
	Dropdown.Menu = _DropdownMenu2.default;
	exports.default = Dropdown;
	 false ? Dropdown.propTypes = {
	  /**
	   * Allow user additions to the list of options (boolean).
	   * Requires the use of `selection`, `options` and `search`.
	   */
	  allowAdditions: _lib.customPropTypes.every([_lib.customPropTypes.demand(['options', 'selection', 'search']), _react.PropTypes.bool]),
	
	  /** Position of the `Add: ...` option in the dropdown list ('top' or 'bottom'). */
	  additionPosition: _react.PropTypes.oneOf(_meta.props.additionPosition),
	
	  /** Label prefixed to an option added by a user. */
	  additionLabel: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.string]),
	
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A Dropdown can reduce its complexity */
	  basic: _react.PropTypes.bool,
	
	  /** Format the Dropdown to appear as a button. */
	  button: _react.PropTypes.bool,
	
	  /** Primary content. */
	  children: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['options', 'selection']), _lib.customPropTypes.givenProps({ children: _react.PropTypes.any.isRequired }, _react2.default.PropTypes.element.isRequired)]),
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Whether or not the menu should close when the dropdown is blurred. */
	  closeOnBlur: _react.PropTypes.bool,
	
	  /**
	   * Whether or not the menu should close when a value is selected from the dropdown.
	   * By default, multiple selection dropdowns will remain open on change, while single
	   * selection dropdowns will close on change.
	   */
	  closeOnChange: _react.PropTypes.bool,
	
	  /** A compact dropdown has no minimum width. */
	  compact: _react.PropTypes.bool,
	
	  /** Initial value of open. */
	  defaultOpen: _react.PropTypes.bool,
	
	  /** Currently selected label in multi-select. */
	  defaultSelectedLabel: _lib.customPropTypes.every([_lib.customPropTypes.demand(['multiple']), _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number])]),
	
	  /** Initial value or value array if multiple. */
	  defaultValue: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number, _react.PropTypes.arrayOf(_react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]))]),
	
	  /** A disabled dropdown menu or item does not allow user interaction. */
	  disabled: _react.PropTypes.bool,
	
	  /** An errored dropdown can alert a user to a problem. */
	  error: _react.PropTypes.bool,
	
	  /** A dropdown menu can contain floated content. */
	  floating: _react.PropTypes.bool,
	
	  /** A dropdown can take the full width of its parent */
	  fluid: _react.PropTypes.bool,
	
	  /** A dropdown menu can contain a header. */
	  header: _react.PropTypes.node,
	
	  /** Shorthand for Icon. */
	  icon: _react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.object]),
	
	  /** A dropdown can be formatted to appear inline in other content. */
	  inline: _react.PropTypes.bool,
	
	  /** A dropdown can be labeled. */
	  labeled: _react.PropTypes.bool,
	
	  /** A dropdown can be formatted as a Menu item. */
	  item: _react.PropTypes.bool,
	
	  /** A dropdown can show that it is currently loading data. */
	  loading: _react.PropTypes.bool,
	
	  /** A selection dropdown can allow multiple selections. */
	  multiple: _react.PropTypes.bool,
	
	  /** Name of the hidden input which holds the value. */
	  name: _react.PropTypes.string,
	
	  /** Message to display when there are no results. */
	  noResultsMessage: _react.PropTypes.string,
	
	  /**
	   * Called when a user adds a new item. Use this to update the options list.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props and the new item's value.
	   */
	  onAddItem: _react.PropTypes.func,
	
	  /**
	   * Called on blur.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onBlur: _react.PropTypes.func,
	
	  /**
	   * Called when the user attempts to change the value.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props and proposed value.
	   */
	  onChange: _react.PropTypes.func,
	
	  /**
	   * Called when a close event happens.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClose: _react.PropTypes.func,
	
	  /**
	   * Called when a multi-select label is clicked.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All label props.
	   */
	  onLabelClick: _react.PropTypes.func,
	
	  /**
	   * Called when an open event happens.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onOpen: _react.PropTypes.func,
	
	  /**
	   * Called on search input change.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {string} value - Current value of search input.
	   */
	  onSearchChange: _react.PropTypes.func,
	
	  /**
	   * Called on click.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _react.PropTypes.func,
	
	  /**
	   * Called on focus.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onFocus: _react.PropTypes.func,
	
	  /**
	   * Called on mousedown.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onMouseDown: _react.PropTypes.func,
	
	  /** Controls whether or not the dropdown menu is displayed. */
	  open: _react.PropTypes.bool,
	
	  /** Whether or not the menu should open when the dropdown is focused. */
	  openOnFocus: _react.PropTypes.bool,
	
	  /** Array of Dropdown.Item props e.g. `{ text: '', value: '' }` */
	  options: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['children']), _react.PropTypes.arrayOf(_react.PropTypes.shape(_DropdownItem2.default.propTypes))]),
	
	  /** Placeholder text. */
	  placeholder: _react.PropTypes.string,
	
	  /** A dropdown can be formatted so that its menu is pointing. */
	  pointing: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.oneOf(_meta.props.pointing)]),
	
	  /**
	   * A function that takes (data, index, defaultLabelProps) and returns
	   * shorthand for Label .
	   */
	  renderLabel: _react.PropTypes.func,
	
	  /** A dropdown can have its menu scroll. */
	  scrolling: _react.PropTypes.bool,
	
	  /**
	   * A selection dropdown can allow a user to search through a large list of choices.
	   * Pass a function here to replace the default search.
	   */
	  search: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.func]),
	
	  // TODO 'searchInMenu' or 'search='in menu' or ???  How to handle this markup and functionality?
	
	  /** Currently selected label in multi-select. */
	  selectedLabel: _lib.customPropTypes.every([_lib.customPropTypes.demand(['multiple']), _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number])]),
	
	  /** A dropdown can be used to select between choices in a form. */
	  selection: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['children']), _lib.customPropTypes.demand(['options']), _react.PropTypes.bool]),
	
	  /** Define whether the highlighted item should be selected on blur. */
	  selectOnBlur: _react.PropTypes.bool,
	
	  /** A simple dropdown can open without Javascript. */
	  simple: _react.PropTypes.bool,
	
	  /** A dropdown can receive focus. */
	  tabIndex: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	
	  /** The text displayed in the dropdown, usually for the active item. */
	  text: _react.PropTypes.string,
	
	  /** Custom element to trigger the menu to become visible. Takes place of 'text'. */
	  trigger: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['selection', 'text']), _react.PropTypes.node]),
	
	  /** Current value or value array if multiple. Creates a controlled component. */
	  value: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number, _react.PropTypes.arrayOf(_react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]))])
	} : void 0;
	Dropdown.handledProps = ['additionLabel', 'additionPosition', 'allowAdditions', 'as', 'basic', 'button', 'children', 'className', 'closeOnBlur', 'closeOnChange', 'compact', 'defaultOpen', 'defaultSelectedLabel', 'defaultValue', 'disabled', 'error', 'floating', 'fluid', 'header', 'icon', 'inline', 'item', 'labeled', 'loading', 'multiple', 'name', 'noResultsMessage', 'onAddItem', 'onBlur', 'onChange', 'onClick', 'onClose', 'onFocus', 'onLabelClick', 'onMouseDown', 'onOpen', 'onSearchChange', 'open', 'openOnFocus', 'options', 'placeholder', 'pointing', 'renderLabel', 'scrolling', 'search', 'selectOnBlur', 'selectedLabel', 'selection', 'simple', 'tabIndex', 'text', 'trigger', 'value'];

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getPrototypeOf = __webpack_require__(760);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _getOwnPropertyDescriptor = __webpack_require__(764);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function get(object, property, receiver) {
	  if (object === null) object = Function.prototype;
	  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);
	
	  if (desc === undefined) {
	    var parent = (0, _getPrototypeOf2.default)(object);
	
	    if (parent === null) {
	      return undefined;
	    } else {
	      return get(parent, property, receiver);
	    }
	  } else if ("value" in desc) {
	    return desc.value;
	  } else {
	    var getter = desc.get;
	
	    if (getter === undefined) {
	      return undefined;
	    }
	
	    return getter.call(receiver);
	  }
	};

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(761), __esModule: true };

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(762);
	module.exports = __webpack_require__(480).Object.getPrototypeOf;


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(512);
	var $getPrototypeOf = __webpack_require__(533);
	
	__webpack_require__(763)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(478);
	var core = __webpack_require__(480);
	var fails = __webpack_require__(489);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(765), __esModule: true };

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(766);
	var $Object = __webpack_require__(480).Object;
	module.exports = function getOwnPropertyDescriptor(it, key) {
	  return $Object.getOwnPropertyDescriptor(it, key);
	};


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(497);
	var $getOwnPropertyDescriptor = __webpack_require__(548).f;
	
	__webpack_require__(763)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEvery = __webpack_require__(768),
	    baseEvery = __webpack_require__(769),
	    baseIteratee = __webpack_require__(300),
	    isArray = __webpack_require__(282),
	    isIterateeCall = __webpack_require__(402);
	
	/**
	 * Checks if `predicate` returns truthy for **all** elements of `collection`.
	 * Iteration is stopped once `predicate` returns falsey. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * **Note:** This method returns `true` for
	 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	 * elements of empty collections.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.every([true, 1, null, 'yes'], Boolean);
	 * // => false
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': false },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.every(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.every(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.every(users, 'active');
	 * // => false
	 */
	function every(collection, predicate, guard) {
	  var func = isArray(collection) ? arrayEvery : baseEvery;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = every;


/***/ }),
/* 768 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.every` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 */
	function arrayEvery(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (!predicate(array[index], index, array)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = arrayEvery;


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(266);
	
	/**
	 * The base implementation of `_.every` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`
	 */
	function baseEvery(collection, predicate) {
	  var result = true;
	  baseEach(collection, function(value, index, collection) {
	    result = !!predicate(value, index, collection);
	    return result;
	  });
	  return result;
	}
	
	module.exports = baseEvery;


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(374);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	    reHasRegExpChar = RegExp(reRegExpChar.source);
	
	/**
	 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to escape.
	 * @returns {string} Returns the escaped string.
	 * @example
	 *
	 * _.escapeRegExp('[lodash](https://lodash.com/)');
	 * // => '\[lodash\]\(https://lodash\.com/\)'
	 */
	function escapeRegExp(string) {
	  string = toString(string);
	  return (string && reHasRegExpChar.test(string))
	    ? string.replace(reRegExpChar, '\\$&')
	    : string;
	}
	
	module.exports = escapeRegExp;


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(692),
	    toInteger = __webpack_require__(575);
	
	/**
	 * Creates a slice of `array` with `n` elements dropped from the end.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @param {number} [n=1] The number of elements to drop.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * _.dropRight([1, 2, 3]);
	 * // => [1, 2]
	 *
	 * _.dropRight([1, 2, 3], 2);
	 * // => [1]
	 *
	 * _.dropRight([1, 2, 3], 5);
	 * // => []
	 *
	 * _.dropRight([1, 2, 3], 0);
	 * // => [1, 2, 3]
	 */
	function dropRight(array, n, guard) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return [];
	  }
	  n = (guard || n === undefined) ? 1 : toInteger(n);
	  n = length - n;
	  return baseSlice(array, 0, n < 0 ? 0 : n);
	}
	
	module.exports = dropRight;


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(387),
	    baseRest = __webpack_require__(394),
	    baseUniq = __webpack_require__(773),
	    isArrayLikeObject = __webpack_require__(455);
	
	/**
	 * Creates an array of unique values, in order, from all given arrays using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of combined values.
	 * @example
	 *
	 * _.union([2], [1, 2]);
	 * // => [2, 1]
	 */
	var union = baseRest(function(arrays) {
	  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	});
	
	module.exports = union;


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(342),
	    arrayIncludes = __webpack_require__(566),
	    arrayIncludesWith = __webpack_require__(571),
	    cacheHas = __webpack_require__(346),
	    createSet = __webpack_require__(774),
	    setToArray = __webpack_require__(350);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      length = array.length,
	      isCommon = true,
	      result = [],
	      seen = result;
	
	  if (comparator) {
	    isCommon = false;
	    includes = arrayIncludesWith;
	  }
	  else if (length >= LARGE_ARRAY_SIZE) {
	    var set = iteratee ? null : createSet(array);
	    if (set) {
	      return setToArray(set);
	    }
	    isCommon = false;
	    includes = cacheHas;
	    seen = new SetCache;
	  }
	  else {
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (!includes(seen, computed, comparator)) {
	      if (seen !== result) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(360),
	    noop = __webpack_require__(639),
	    setToArray = __webpack_require__(350);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Creates a set object of `values`.
	 *
	 * @private
	 * @param {Array} values The values to add to the set.
	 * @returns {Object} Returns the new set.
	 */
	var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	  return new Set(values);
	};
	
	module.exports = createSet;


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Label = __webpack_require__(725);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Label2.default;

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DropdownDivider(props) {
	  var className = props.className;
	
	  var classes = (0, _classnames2.default)('divider', className);
	  var rest = (0, _lib.getUnhandledProps)(DropdownDivider, props);
	  var ElementType = (0, _lib.getElementType)(DropdownDivider, props);
	
	  return _react2.default.createElement(ElementType, (0, _extends3.default)({}, rest, { className: classes }));
	}
	
	DropdownDivider.handledProps = ['as', 'className'];
	DropdownDivider._meta = {
	  name: 'DropdownDivider',
	  parent: 'Dropdown',
	  type: _lib.META.TYPES.MODULE
	};
	
	 false ? DropdownDivider.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string
	} : void 0;
	
	exports.default = DropdownDivider;

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(513);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(514);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(518);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(552);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _Flag = __webpack_require__(778);
	
	var _Flag2 = _interopRequireDefault(_Flag);
	
	var _Icon = __webpack_require__(750);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Image = __webpack_require__(780);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Label = __webpack_require__(775);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An item sub-component for Dropdown component
	 */
	var DropdownItem = function (_Component) {
	  (0, _inherits3.default)(DropdownItem, _Component);
	
	  function DropdownItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DropdownItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DropdownItem.__proto__ || Object.getPrototypeOf(DropdownItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
	      var onClick = _this.props.onClick;
	
	
	      if (onClick) onClick(e, _this.props);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DropdownItem, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          className = _props.className,
	          content = _props.content,
	          disabled = _props.disabled,
	          description = _props.description,
	          flag = _props.flag,
	          icon = _props.icon,
	          image = _props.image,
	          label = _props.label,
	          selected = _props.selected,
	          text = _props.text;
	
	
	      var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(selected, 'selected'), 'item', className);
	      // add default dropdown icon if item contains another menu
	      var iconName = (0, _isNil3.default)(icon) ? _lib.childrenUtils.someByType(children, 'DropdownMenu') && 'dropdown' : icon;
	      var rest = (0, _lib.getUnhandledProps)(DropdownItem, this.props);
	      var ElementType = (0, _lib.getElementType)(DropdownItem, this.props);
	      var ariaOptions = {
	        role: 'option',
	        'aria-disabled': disabled,
	        'aria-checked': active,
	        'aria-selected': selected
	      };
	
	      if (!(0, _isNil3.default)(children)) {
	        return _react2.default.createElement(
	          ElementType,
	          (0, _extends3.default)({}, rest, ariaOptions, { className: classes, onClick: this.handleClick }),
	          children
	        );
	      }
	
	      var flagElement = _Flag2.default.create(flag);
	      var iconElement = _Icon2.default.create(iconName);
	      var imageElement = _Image2.default.create(image);
	      var labelElement = _Label2.default.create(label);
	      var descriptionElement = (0, _lib.createShorthand)('span', function (val) {
	        return { className: 'description', children: val };
	      }, description);
	
	      if (descriptionElement) {
	        return _react2.default.createElement(
	          ElementType,
	          (0, _extends3.default)({}, rest, ariaOptions, { className: classes, onClick: this.handleClick }),
	          imageElement,
	          iconElement,
	          flagElement,
	          labelElement,
	          descriptionElement,
	          (0, _lib.createShorthand)('span', function (val) {
	            return { className: 'text', children: val };
	          }, content || text)
	        );
	      }
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, ariaOptions, { className: classes, onClick: this.handleClick }),
	        imageElement,
	        iconElement,
	        flagElement,
	        labelElement,
	        content || text
	      );
	    }
	  }]);
	  return DropdownItem;
	}(_react.Component);
	
	DropdownItem._meta = {
	  name: 'DropdownItem',
	  parent: 'Dropdown',
	  type: _lib.META.TYPES.MODULE
	};
	exports.default = DropdownItem;
	 false ? DropdownItem.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Style as the currently chosen item. */
	  active: _react.PropTypes.bool,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Additional text with less emphasis. */
	  description: _lib.customPropTypes.itemShorthand,
	
	  /** A dropdown item can be disabled. */
	  disabled: _react.PropTypes.bool,
	
	  /** Shorthand for Flag. */
	  flag: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for Icon. */
	  icon: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for Image. */
	  image: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for Label. */
	  label: _lib.customPropTypes.itemShorthand,
	
	  /**
	   * The item currently selected by keyboard shortcut.
	   * This is not the active item.
	   */
	  selected: _react.PropTypes.bool,
	
	  /** Display text. */
	  text: _lib.customPropTypes.contentShorthand,
	
	  /** Stored value */
	  value: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	
	  /**
	   * Called on click.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _react.PropTypes.func
	} : void 0;
	DropdownItem.handledProps = ['active', 'as', 'children', 'className', 'content', 'description', 'disabled', 'flag', 'icon', 'image', 'label', 'onClick', 'selected', 'text', 'value'];

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Flag = __webpack_require__(779);
	
	var _Flag2 = _interopRequireDefault(_Flag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Flag2.default;

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var names = ['ad', 'andorra', 'ae', 'united arab emirates', 'uae', 'af', 'afghanistan', 'ag', 'antigua', 'ai', 'anguilla', 'al', 'albania', 'am', 'armenia', 'an', 'netherlands antilles', 'ao', 'angola', 'ar', 'argentina', 'as', 'american samoa', 'at', 'austria', 'au', 'australia', 'aw', 'aruba', 'ax', 'aland islands', 'az', 'azerbaijan', 'ba', 'bosnia', 'bb', 'barbados', 'bd', 'bangladesh', 'be', 'belgium', 'bf', 'burkina faso', 'bg', 'bulgaria', 'bh', 'bahrain', 'bi', 'burundi', 'bj', 'benin', 'bm', 'bermuda', 'bn', 'brunei', 'bo', 'bolivia', 'br', 'brazil', 'bs', 'bahamas', 'bt', 'bhutan', 'bv', 'bouvet island', 'bw', 'botswana', 'by', 'belarus', 'bz', 'belize', 'ca', 'canada', 'cc', 'cocos islands', 'cd', 'congo', 'cf', 'central african republic', 'cg', 'congo brazzaville', 'ch', 'switzerland', 'ci', 'cote divoire', 'ck', 'cook islands', 'cl', 'chile', 'cm', 'cameroon', 'cn', 'china', 'co', 'colombia', 'cr', 'costa rica', 'cs', 'cu', 'cuba', 'cv', 'cape verde', 'cx', 'christmas island', 'cy', 'cyprus', 'cz', 'czech republic', 'de', 'germany', 'dj', 'djibouti', 'dk', 'denmark', 'dm', 'dominica', 'do', 'dominican republic', 'dz', 'algeria', 'ec', 'ecuador', 'ee', 'estonia', 'eg', 'egypt', 'eh', 'western sahara', 'er', 'eritrea', 'es', 'spain', 'et', 'ethiopia', 'eu', 'european union', 'fi', 'finland', 'fj', 'fiji', 'fk', 'falkland islands', 'fm', 'micronesia', 'fo', 'faroe islands', 'fr', 'france', 'ga', 'gabon', 'gb', 'united kingdom', 'gd', 'grenada', 'ge', 'georgia', 'gf', 'french guiana', 'gh', 'ghana', 'gi', 'gibraltar', 'gl', 'greenland', 'gm', 'gambia', 'gn', 'guinea', 'gp', 'guadeloupe', 'gq', 'equatorial guinea', 'gr', 'greece', 'gs', 'sandwich islands', 'gt', 'guatemala', 'gu', 'guam', 'gw', 'guinea-bissau', 'gy', 'guyana', 'hk', 'hong kong', 'hm', 'heard island', 'hn', 'honduras', 'hr', 'croatia', 'ht', 'haiti', 'hu', 'hungary', 'id', 'indonesia', 'ie', 'ireland', 'il', 'israel', 'in', 'india', 'io', 'indian ocean territory', 'iq', 'iraq', 'ir', 'iran', 'is', 'iceland', 'it', 'italy', 'jm', 'jamaica', 'jo', 'jordan', 'jp', 'japan', 'ke', 'kenya', 'kg', 'kyrgyzstan', 'kh', 'cambodia', 'ki', 'kiribati', 'km', 'comoros', 'kn', 'saint kitts and nevis', 'kp', 'north korea', 'kr', 'south korea', 'kw', 'kuwait', 'ky', 'cayman islands', 'kz', 'kazakhstan', 'la', 'laos', 'lb', 'lebanon', 'lc', 'saint lucia', 'li', 'liechtenstein', 'lk', 'sri lanka', 'lr', 'liberia', 'ls', 'lesotho', 'lt', 'lithuania', 'lu', 'luxembourg', 'lv', 'latvia', 'ly', 'libya', 'ma', 'morocco', 'mc', 'monaco', 'md', 'moldova', 'me', 'montenegro', 'mg', 'madagascar', 'mh', 'marshall islands', 'mk', 'macedonia', 'ml', 'mali', 'mm', 'myanmar', 'burma', 'mn', 'mongolia', 'mo', 'macau', 'mp', 'northern mariana islands', 'mq', 'martinique', 'mr', 'mauritania', 'ms', 'montserrat', 'mt', 'malta', 'mu', 'mauritius', 'mv', 'maldives', 'mw', 'malawi', 'mx', 'mexico', 'my', 'malaysia', 'mz', 'mozambique', 'na', 'namibia', 'nc', 'new caledonia', 'ne', 'niger', 'nf', 'norfolk island', 'ng', 'nigeria', 'ni', 'nicaragua', 'nl', 'netherlands', 'no', 'norway', 'np', 'nepal', 'nr', 'nauru', 'nu', 'niue', 'nz', 'new zealand', 'om', 'oman', 'pa', 'panama', 'pe', 'peru', 'pf', 'french polynesia', 'pg', 'new guinea', 'ph', 'philippines', 'pk', 'pakistan', 'pl', 'poland', 'pm', 'saint pierre', 'pn', 'pitcairn islands', 'pr', 'puerto rico', 'ps', 'palestine', 'pt', 'portugal', 'pw', 'palau', 'py', 'paraguay', 'qa', 'qatar', 're', 'reunion', 'ro', 'romania', 'rs', 'serbia', 'ru', 'russia', 'rw', 'rwanda', 'sa', 'saudi arabia', 'sb', 'solomon islands', 'sc', 'seychelles', 'gb sct', 'scotland', 'sd', 'sudan', 'se', 'sweden', 'sg', 'singapore', 'sh', 'saint helena', 'si', 'slovenia', 'sj', 'svalbard', 'jan mayen', 'sk', 'slovakia', 'sl', 'sierra leone', 'sm', 'san marino', 'sn', 'senegal', 'so', 'somalia', 'sr', 'suriname', 'st', 'sao tome', 'sv', 'el salvador', 'sy', 'syria', 'sz', 'swaziland', 'tc', 'caicos islands', 'td', 'chad', 'tf', 'french territories', 'tg', 'togo', 'th', 'thailand', 'tj', 'tajikistan', 'tk', 'tokelau', 'tl', 'timorleste', 'tm', 'turkmenistan', 'tn', 'tunisia', 'to', 'tonga', 'tr', 'turkey', 'tt', 'trinidad', 'tv', 'tuvalu', 'tw', 'taiwan', 'tz', 'tanzania', 'ua', 'ukraine', 'ug', 'uganda', 'um', 'us minor islands', 'us', 'america', 'united states', 'uy', 'uruguay', 'uz', 'uzbekistan', 'va', 'vatican city', 'vc', 'saint vincent', 've', 'venezuela', 'vg', 'british virgin islands', 'vi', 'us virgin islands', 'vn', 'vietnam', 'vu', 'vanuatu', 'gb wls', 'wales', 'wf', 'wallis and futuna', 'ws', 'samoa', 'ye', 'yemen', 'yt', 'mayotte', 'za', 'south africa', 'zm', 'zambia', 'zw', 'zimbabwe'];
	
	/**
	 * A flag is is used to represent a political state.
	 */
	function Flag(props) {
	  var className = props.className,
	      name = props.name;
	
	  var classes = (0, _classnames2.default)(name, 'flag', className);
	  var rest = (0, _lib.getUnhandledProps)(Flag, props);
	  var ElementType = (0, _lib.getElementType)(Flag, props);
	
	  return _react2.default.createElement(ElementType, (0, _extends3.default)({}, rest, { className: classes }));
	}
	
	Flag.handledProps = ['as', 'className', 'name'];
	Flag._meta = {
	  name: 'Flag',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	 false ? Flag.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Flag name, can use the two digit country code, the full name, or a common alias. */
	  name: _lib.customPropTypes.suggest(names)
	} : void 0;
	
	Flag.defaultProps = {
	  as: 'i'
	};
	
	Flag.create = (0, _lib.createShorthandFactory)(Flag, function (value) {
	  return { name: value };
	});
	
	exports.default = Flag;

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Image = __webpack_require__(726);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Image2.default;

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _Icon = __webpack_require__(750);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DropdownHeader(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      icon = props.icon;
	
	  var classes = (0, _classnames2.default)('header', className);
	  var rest = (0, _lib.getUnhandledProps)(DropdownHeader, props);
	  var ElementType = (0, _lib.getElementType)(DropdownHeader, props);
	
	  if (!(0, _isNil3.default)(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _Icon2.default.create(icon),
	    content
	  );
	}
	
	DropdownHeader.handledProps = ['as', 'children', 'className', 'content', 'icon'];
	DropdownHeader._meta = {
	  name: 'DropdownHeader',
	  parent: 'Dropdown',
	  type: _lib.META.TYPES.MODULE
	};
	
	 false ? DropdownHeader.propTypes = {
	  /** An element type to render as (string or function) */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Shorthand for Icon. */
	  icon: _lib.customPropTypes.itemShorthand
	} : void 0;
	
	exports.default = DropdownHeader;

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DropdownMenu(props) {
	  var children = props.children,
	      className = props.className,
	      scrolling = props.scrolling;
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(scrolling, 'scrolling'), 'menu transition', className);
	  var rest = (0, _lib.getUnhandledProps)(DropdownMenu, props);
	  var ElementType = (0, _lib.getElementType)(DropdownMenu, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	DropdownMenu.handledProps = ['as', 'children', 'className', 'scrolling'];
	DropdownMenu._meta = {
	  name: 'DropdownMenu',
	  parent: 'Dropdown',
	  type: _lib.META.TYPES.MODULE
	};
	
	 false ? DropdownMenu.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** A dropdown menu can scroll. */
	  scrolling: _react.PropTypes.bool
	} : void 0;
	
	exports.default = DropdownMenu;

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _TextArea = __webpack_require__(784);
	
	var _TextArea2 = _interopRequireDefault(_TextArea);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TextArea2.default;

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(513);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(514);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(518);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(552);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A TextArea can be used to allow for extended user input.
	 * @see Form
	 */
	var TextArea = function (_Component) {
	  (0, _inherits3.default)(TextArea, _Component);
	
	  function TextArea() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TextArea);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TextArea.__proto__ || Object.getPrototypeOf(TextArea)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (e) {
	      var onChange = _this.props.onChange;
	
	      if (onChange) onChange(e, (0, _extends3.default)({}, _this.props, { value: e.target && e.target.value }));
	
	      _this.updateHeight(e.target);
	    }, _this.removeAutoHeightStyles = function () {
	      _this.rootNode.removeAttribute('rows');
	      _this.rootNode.style.height = null;
	      _this.rootNode.style.minHeight = null;
	      _this.rootNode.style.resize = null;
	    }, _this.updateHeight = function () {
	      if (!_this.rootNode) return;
	
	      var autoHeight = _this.props.autoHeight;
	
	      if (!autoHeight) return;
	
	      var _window$getComputedSt = window.getComputedStyle(_this.rootNode),
	          borderTopWidth = _window$getComputedSt.borderTopWidth,
	          borderBottomWidth = _window$getComputedSt.borderBottomWidth;
	
	      borderTopWidth = parseInt(borderTopWidth, 10);
	      borderBottomWidth = parseInt(borderBottomWidth, 10);
	
	      _this.rootNode.rows = '1';
	      _this.rootNode.style.minHeight = '0';
	      _this.rootNode.style.resize = 'none';
	      _this.rootNode.style.height = 'auto';
	      _this.rootNode.style.height = _this.rootNode.scrollHeight + borderTopWidth + borderBottomWidth + 'px';
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TextArea, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateHeight();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      // removed autoHeight
	      if (!this.props.autoHeight && prevProps.autoHeight) {
	        this.removeAutoHeightStyles();
	      }
	      // added autoHeight or value changed
	      if (this.props.autoHeight && !prevProps.autoHeight || prevProps.value !== this.props.value) {
	        this.updateHeight();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var value = this.props.value;
	
	      var rest = (0, _lib.getUnhandledProps)(TextArea, this.props);
	      var ElementType = (0, _lib.getElementType)(TextArea, this.props);
	
	      return _react2.default.createElement(ElementType, (0, _extends3.default)({}, rest, {
	        value: value,
	        onChange: this.handleChange,
	        ref: function ref(c) {
	          return _this2.rootNode = c;
	        }
	      }));
	    }
	  }]);
	  return TextArea;
	}(_react.Component);
	
	TextArea._meta = {
	  name: 'TextArea',
	  type: _lib.META.TYPES.ADDON
	};
	TextArea.defaultProps = {
	  as: 'textarea'
	};
	 false ? TextArea.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Indicates whether height of the textarea fits the content or not. */
	  autoHeight: _react.PropTypes.bool,
	
	  /**
	   * Called on change.
	   * @param {SyntheticEvent} event - The React SyntheticEvent object
	   * @param {object} data - All props and the event value.
	   */
	  onChange: _react.PropTypes.func,
	
	  /** The value of the textarea. */
	  value: _react.PropTypes.string
	} : void 0;
	TextArea.handledProps = ['as', 'autoHeight', 'onChange', 'value'];
	exports.default = TextArea;

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Breadcrumb = __webpack_require__(786);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Breadcrumb2.default;

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(723);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _map2 = __webpack_require__(702);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _each2 = __webpack_require__(582);
	
	var _each3 = _interopRequireDefault(_each2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _BreadcrumbDivider = __webpack_require__(787);
	
	var _BreadcrumbDivider2 = _interopRequireDefault(_BreadcrumbDivider);
	
	var _BreadcrumbSection = __webpack_require__(788);
	
	var _BreadcrumbSection2 = _interopRequireDefault(_BreadcrumbSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A breadcrumb is used to show hierarchy between content.
	 */
	function Breadcrumb(props) {
	  var children = props.children,
	      className = props.className,
	      divider = props.divider,
	      icon = props.icon,
	      sections = props.sections,
	      size = props.size;
	
	
	  var classes = (0, _classnames2.default)('ui', size, 'breadcrumb', className);
	  var rest = (0, _lib.getUnhandledProps)(Breadcrumb, props);
	  var ElementType = (0, _lib.getElementType)(Breadcrumb, props);
	
	  if (!(0, _isNil3.default)(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  var childElements = [];
	
	  (0, _each3.default)(sections, function (section, index) {
	    // section
	    var breadcrumbSection = _BreadcrumbSection2.default.create(section);
	    childElements.push(breadcrumbSection);
	
	    // divider
	    if (index !== sections.length - 1) {
	      // TODO generate a key from breadcrumbSection.props once this is merged:
	      // https://github.com/Semantic-Org/Semantic-UI-React/pull/645
	      //
	      // Stringify the props of the section as the divider key.
	      //
	      // Section:     { content: 'Home', link: true, onClick: handleClick }
	      // Divider key: content=Home|link=true|onClick=handleClick
	      var key = void 0;
	      if (section.key) {
	        key = section.key + '_divider';
	      } else {
	        key = (0, _map3.default)(breadcrumbSection.props, function (v, k) {
	          return k + '=' + (typeof v === 'function' ? v.name || 'func' : v);
	        }).join('|');
	      }
	      childElements.push(_BreadcrumbDivider2.default.create({ content: divider, icon: icon, key: key }));
	    }
	  });
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    childElements
	  );
	}
	
	Breadcrumb.handledProps = ['as', 'children', 'className', 'divider', 'icon', 'sections', 'size'];
	Breadcrumb._meta = {
	  name: 'Breadcrumb',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	 false ? Breadcrumb.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for primary content of the Breadcrumb.Divider. */
	  divider: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['icon']), _lib.customPropTypes.contentShorthand]),
	
	  /** For use with the sections prop. Render as an `Icon` component with `divider` class instead of a `div` in
	   *  Breadcrumb.Divider. */
	  icon: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['divider']), _lib.customPropTypes.itemShorthand]),
	
	  /** Shorthand array of props for Breadcrumb.Section. */
	  sections: _lib.customPropTypes.collectionShorthand,
	
	  /** Size of Breadcrumb. */
	  size: _react.PropTypes.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'medium'))
	} : void 0;
	
	Breadcrumb.Divider = _BreadcrumbDivider2.default;
	Breadcrumb.Section = _BreadcrumbSection2.default;
	
	exports.default = Breadcrumb;

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _Icon = __webpack_require__(750);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A divider sub-component for Breadcrumb component.
	 */
	function BreadcrumbDivider(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      icon = props.icon;
	
	
	  var classes = (0, _classnames2.default)('divider', className);
	  var rest = (0, _lib.getUnhandledProps)(BreadcrumbDivider, props);
	  var ElementType = (0, _lib.getElementType)(BreadcrumbDivider, props);
	
	  var iconElement = _Icon2.default.create(icon, (0, _extends3.default)({}, rest, { className: classes }));
	  if (iconElement) return iconElement;
	
	  var breadcrumbContent = content;
	  if ((0, _isNil3.default)(content)) breadcrumbContent = (0, _isNil3.default)(children) ? '/' : children;
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    breadcrumbContent
	  );
	}
	
	BreadcrumbDivider.handledProps = ['as', 'children', 'className', 'content', 'icon'];
	BreadcrumbDivider._meta = {
	  name: 'BreadcrumbDivider',
	  type: _lib.META.TYPES.COLLECTION,
	  parent: 'Breadcrumb'
	};
	
	 false ? BreadcrumbDivider.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Render as an `Icon` component with `divider` class instead of a `div`. */
	  icon: _lib.customPropTypes.itemShorthand
	} : void 0;
	
	BreadcrumbDivider.create = (0, _lib.createShorthandFactory)(BreadcrumbDivider, function (icon) {
	  return { icon: icon };
	});
	
	exports.default = BreadcrumbDivider;

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(513);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(514);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(518);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(552);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A section sub-component for Breadcrumb component.
	 */
	var BreadcrumbSection = function (_Component) {
	  (0, _inherits3.default)(BreadcrumbSection, _Component);
	
	  function BreadcrumbSection() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, BreadcrumbSection);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BreadcrumbSection.__proto__ || Object.getPrototypeOf(BreadcrumbSection)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
	      var onClick = _this.props.onClick;
	
	
	      if (onClick) onClick(e, _this.props);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(BreadcrumbSection, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          className = _props.className,
	          content = _props.content,
	          href = _props.href,
	          link = _props.link,
	          onClick = _props.onClick;
	
	
	      var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(active, 'active'), 'section', className);
	      var rest = (0, _lib.getUnhandledProps)(BreadcrumbSection, this.props);
	      var ElementType = (0, _lib.getElementType)(BreadcrumbSection, this.props, function () {
	        if (link || onClick) return 'a';
	      });
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes, href: href, onClick: this.handleClick }),
	        (0, _isNil3.default)(children) ? content : children
	      );
	    }
	  }]);
	  return BreadcrumbSection;
	}(_react.Component);
	
	BreadcrumbSection._meta = {
	  name: 'BreadcrumbSection',
	  type: _lib.META.TYPES.COLLECTION,
	  parent: 'Breadcrumb'
	};
	exports.default = BreadcrumbSection;
	 false ? BreadcrumbSection.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Style as the currently active section. */
	  active: _react.PropTypes.bool,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Render as an `a` tag instead of a `div` and adds the href attribute. */
	  href: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['link']), _react.PropTypes.string]),
	
	  /** Render as an `a` tag instead of a `div`. */
	  link: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['href']), _react.PropTypes.bool]),
	
	  /**
	   * Called on click. When passed, the component will render as an `a`
	   * tag by default instead of a `div`.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _react.PropTypes.func
	} : void 0;
	BreadcrumbSection.handledProps = ['active', 'as', 'children', 'className', 'content', 'href', 'link', 'onClick'];
	
	
	BreadcrumbSection.create = (0, _lib.createShorthandFactory)(BreadcrumbSection, function (content) {
	  return { content: content, link: true };
	}, true);

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Form = __webpack_require__(790);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Form2.default;

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(513);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(514);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(518);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(552);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _defineProperty2 = __webpack_require__(791);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _without2 = __webpack_require__(723);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _map2 = __webpack_require__(702);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _find2 = __webpack_require__(601);
	
	var _find3 = _interopRequireDefault(_find2);
	
	var _filter2 = __webpack_require__(263);
	
	var _filter3 = _interopRequireDefault(_filter2);
	
	var _each2 = __webpack_require__(582);
	
	var _each3 = _interopRequireDefault(_each2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _FormButton = __webpack_require__(792);
	
	var _FormButton2 = _interopRequireDefault(_FormButton);
	
	var _FormCheckbox = __webpack_require__(794);
	
	var _FormCheckbox2 = _interopRequireDefault(_FormCheckbox);
	
	var _FormDropdown = __webpack_require__(795);
	
	var _FormDropdown2 = _interopRequireDefault(_FormDropdown);
	
	var _FormField = __webpack_require__(793);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _FormGroup = __webpack_require__(796);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _FormInput = __webpack_require__(797);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _FormRadio = __webpack_require__(800);
	
	var _FormRadio2 = _interopRequireDefault(_FormRadio);
	
	var _FormSelect = __webpack_require__(801);
	
	var _FormSelect2 = _interopRequireDefault(_FormSelect);
	
	var _FormTextArea = __webpack_require__(802);
	
	var _FormTextArea2 = _interopRequireDefault(_FormTextArea);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var debug = (0, _lib.makeDebugger)('form');
	
	var getNodeName = function getNodeName(_ref) {
	  var name = _ref.name;
	  return name;
	};
	var debugSerializedResult = function debugSerializedResult() {
	  return undefined;
	};
	
	if (process.NODE_ENV !== 'production') {
	  // debug serialized values
	  debugSerializedResult = function debugSerializedResult(json, name, node) {
	    debug('serialized ' + JSON.stringify((0, _defineProperty3.default)({}, name, json[name])) + ' from:', node);
	  };
	
	  // warn about form nodes missing a "name"
	  getNodeName = function getNodeName(node) {
	    var name = node.name;
	
	    if (!name) {
	      var errorMessage = ['Encountered a form control node without a name attribute.', 'Each node in a group should have a name.', 'Otherwise, the node will serialize as { "undefined": <value> }.'].join(' ');
	      console.error(errorMessage, node); // eslint-disable-line no-console
	    }
	
	    return name;
	  };
	}
	
	function formSerializer(formNode) {
	  debug('formSerializer()');
	  var json = {};
	  // handle empty formNode ref
	  if (!formNode) return json;
	
	  // ----------------------------------------
	  // Checkboxes
	  // Single: { name: value|bool        }
	  // Group:  { name: [value|bool, ...] }
	
	  (0, _each3.default)(formNode.querySelectorAll('input[type="checkbox"]'), function (node, index, arr) {
	    var name = getNodeName(node);
	    var checkboxesByName = (0, _filter3.default)(arr, { name: name });
	
	    // single: (value|checked)
	    if (checkboxesByName.length === 1) {
	      json[name] = node.checked && node.value !== 'on' ? node.value : node.checked;
	      debugSerializedResult(json, name, node);
	      return;
	    }
	
	    // groups (checked): [value, ...]
	    if (!Array.isArray(json[name])) json[name] = [];
	    if (node.checked) json[name].push(node.value);
	    debugSerializedResult(json, name, node);
	
	    // in dev, warn about multiple checkboxes with a default browser value of "on"
	    if (process.NODE_ENV !== 'production' && node.value === 'on') {
	      var errorMessage = ["Encountered a checkbox in a group with the default browser value 'on'.", 'Each checkbox in a group should have a unique value.', "Otherwise, the checkbox value will serialize as ['on', ...]."].join(' ');
	      console.error(errorMessage, node, formNode); // eslint-disable-line no-console
	    }
	  });
	
	  // ----------------------------------------
	  // Radios
	  // checked: { name: checked value }
	  // none:    { name: null }
	
	  (0, _each3.default)(formNode.querySelectorAll('input[type="radio"]'), function (node, index, arr) {
	    var name = getNodeName(node);
	    var checkedRadio = (0, _find3.default)(arr, { name: name, checked: true });
	
	    if (checkedRadio) {
	      json[name] = checkedRadio.value;
	    } else {
	      json[name] = null;
	    }
	
	    debugSerializedResult(json, name, node);
	
	    // in dev, warn about radios with a default browser value of "on"
	    if (process.NODE_ENV !== 'production' && node.value === 'on') {
	      var errorMessage = ["Encountered a radio with the default browser value 'on'.", 'Each radio should have a unique value.', "Otherwise, the radio value will serialize as { [name]: 'on' }."].join(' ');
	      console.error(errorMessage, node, formNode); // eslint-disable-line no-console
	    }
	  });
	
	  // ----------------------------------------
	  // Other inputs
	  // { name: value }
	
	  (0, _each3.default)(formNode.querySelectorAll('input:not([type="radio"]):not([type="checkbox"])'), function (node) {
	    var name = getNodeName(node);
	    json[name] = node.value;
	    debugSerializedResult(json, name, node);
	  });
	
	  // ----------------------------------------
	  // Other inputs and text areas
	  // { name: value }
	
	  (0, _each3.default)(formNode.querySelectorAll('textarea'), function (node) {
	    var name = getNodeName(node);
	    json[name] = node.value;
	    debugSerializedResult(json, name, node);
	  });
	
	  // ----------------------------------------
	  // Selects
	  // single:   { name: value }
	  // multiple: { name: [value, ...] }
	
	  (0, _each3.default)(formNode.querySelectorAll('select'), function (node) {
	    var name = getNodeName(node);
	
	    if (node.multiple) {
	      json[name] = (0, _map3.default)((0, _filter3.default)(node.querySelectorAll('option'), 'selected'), 'value');
	    } else {
	      json[name] = node.value;
	    }
	
	    debugSerializedResult(json, name, node);
	  });
	
	  return json;
	}
	
	var _meta = {
	  name: 'Form',
	  type: _lib.META.TYPES.COLLECTION,
	  props: {
	    widths: ['equal'],
	    size: (0, _without3.default)(_lib.SUI.SIZES, 'medium')
	  }
	};
	
	/**
	 * A Form displays a set of related user input fields in a structured way.
	 * @see Button
	 * @see Checkbox
	 * @see Dropdown
	 * @see Input
	 * @see Message
	 * @see Radio
	 * @see Select
	 * @see TextArea
	 */
	
	var Form = function (_Component) {
	  (0, _inherits3.default)(Form, _Component);
	
	  function Form() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Form);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref2, [this].concat(args))), _this), _this._form = null, _this.handleRef = function (c) {
	      return _this._form = _this._form || c;
	    }, _this.handleSubmit = function (e) {
	      var _this$props = _this.props,
	          onSubmit = _this$props.onSubmit,
	          serializer = _this$props.serializer;
	
	
	      if (onSubmit) onSubmit(e, (0, _extends3.default)({}, _this.props, { formData: serializer(_this._form) }));
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Form, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          error = _props.error,
	          inverted = _props.inverted,
	          loading = _props.loading,
	          reply = _props.reply,
	          size = _props.size,
	          success = _props.success,
	          warning = _props.warning,
	          widths = _props.widths;
	
	
	      var classes = (0, _classnames2.default)('ui', size, (0, _lib.useKeyOnly)(error, 'error'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(loading, 'loading'), (0, _lib.useKeyOnly)(reply, 'reply'), (0, _lib.useKeyOnly)(success, 'success'), (0, _lib.useKeyOnly)(warning, 'warning'), (0, _lib.useWidthProp)(widths, null, true), 'form', className);
	      var rest = (0, _lib.getUnhandledProps)(Form, this.props);
	      var ElementType = (0, _lib.getElementType)(Form, this.props);
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes, ref: this.handleRef, onSubmit: this.handleSubmit }),
	        children
	      );
	    }
	  }]);
	  return Form;
	}(_react.Component);
	
	Form.defaultProps = {
	  as: 'form',
	  serializer: formSerializer
	};
	Form._meta = _meta;
	Form.Field = _FormField2.default;
	Form.Button = _FormButton2.default;
	Form.Checkbox = _FormCheckbox2.default;
	Form.Dropdown = _FormDropdown2.default;
	Form.Group = _FormGroup2.default;
	Form.Input = _FormInput2.default;
	Form.Radio = _FormRadio2.default;
	Form.Select = _FormSelect2.default;
	Form.TextArea = _FormTextArea2.default;
	exports.default = Form;
	 false ? Form.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Automatically show any error Message children */
	  error: _react.PropTypes.bool,
	
	  /** A form can have its color inverted for contrast */
	  inverted: _react.PropTypes.bool,
	
	  /** Automatically show a loading indicator */
	  loading: _react.PropTypes.bool,
	
	  /**
	   * Called on submit
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props and the form's serialized values.
	   */
	  onSubmit: _react.PropTypes.func,
	
	  /** A comment can contain a form to reply to a comment. This may have arbitrary content. */
	  reply: _react.PropTypes.bool,
	
	  /** Called onSubmit with the form node that returns the serialized form object */
	  serializer: _react.PropTypes.func,
	
	  /** A form can vary in size */
	  size: _react.PropTypes.oneOf(_meta.props.size),
	
	  /** Automatically show any success Message children */
	  success: _react.PropTypes.bool,
	
	  /** Automatically show any warning Message children */
	  warning: _react.PropTypes.bool,
	
	  /** Forms can automatically divide fields to be equal width */
	  widths: _react.PropTypes.oneOf(_meta.props.widths)
	} : void 0;
	Form.handledProps = ['as', 'children', 'className', 'error', 'inverted', 'loading', 'onSubmit', 'reply', 'serializer', 'size', 'success', 'warning', 'widths'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(116)))

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(515);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _Button = __webpack_require__(720);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _FormField = __webpack_require__(793);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sugar for <Form.Field control={Button} />
	 * @see Button
	 * @see Form
	 */
	function FormButton(props) {
	  var control = props.control;
	
	  var rest = (0, _lib.getUnhandledProps)(FormButton, props);
	  var ElementType = (0, _lib.getElementType)(FormButton, props);
	
	  return _react2.default.createElement(ElementType, (0, _extends3.default)({}, rest, { control: control }));
	}
	
	FormButton.handledProps = ['as', 'control'];
	FormButton._meta = {
	  name: 'FormButton',
	  parent: 'Form',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	 false ? FormButton.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A FormField control prop */
	  control: _FormField2.default.propTypes.control
	} : void 0;
	
	FormButton.defaultProps = {
	  as: _FormField2.default,
	  control: _Button2.default
	};
	
	exports.default = FormButton;

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _Checkbox = __webpack_require__(753);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _Radio = __webpack_require__(751);
	
	var _Radio2 = _interopRequireDefault(_Radio);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A field is a form element containing a label and an input
	 * @see Form
	 * @see Button
	 * @see Checkbox
	 * @see Dropdown
	 * @see Input
	 * @see Radio
	 * @see Select
	 * @see TextArea
	 */
	function FormField(props) {
	  var children = props.children,
	      className = props.className,
	      control = props.control,
	      disabled = props.disabled,
	      error = props.error,
	      inline = props.inline,
	      label = props.label,
	      required = props.required,
	      type = props.type,
	      width = props.width;
	
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(error, 'error'), (0, _lib.useKeyOnly)(inline, 'inline'), (0, _lib.useKeyOnly)(required, 'required'), (0, _lib.useWidthProp)(width, 'wide'), 'field', className);
	  var rest = (0, _lib.getUnhandledProps)(FormField, props);
	  var ElementType = (0, _lib.getElementType)(FormField, props);
	
	  // ----------------------------------------
	  // No Control
	  // ----------------------------------------
	
	  if ((0, _isNil3.default)(control)) {
	    if ((0, _isNil3.default)(label)) return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      (0, _lib.createHTMLLabel)(label)
	    );
	  }
	
	  // ----------------------------------------
	  // Checkbox/Radio Control
	  // ----------------------------------------
	  var controlProps = (0, _extends3.default)({}, rest, { children: children, required: required, type: type });
	
	  // wrap HTML checkboxes/radios in the label
	  if (control === 'input' && (type === 'checkbox' || type === 'radio')) {
	    return _react2.default.createElement(
	      ElementType,
	      { className: classes },
	      _react2.default.createElement(
	        'label',
	        null,
	        (0, _react.createElement)(control, controlProps),
	        ' ',
	        label
	      )
	    );
	  }
	
	  // pass label prop to controls that support it
	  if (control === _Checkbox2.default || control === _Radio2.default) {
	    return _react2.default.createElement(
	      ElementType,
	      { className: classes },
	      (0, _react.createElement)(control, (0, _extends3.default)({}, controlProps, { label: label }))
	    );
	  }
	
	  // ----------------------------------------
	  // Other Control
	  // ----------------------------------------
	
	  return _react2.default.createElement(
	    ElementType,
	    { className: classes },
	    (0, _lib.createHTMLLabel)(label),
	    (0, _react.createElement)(control, controlProps)
	  );
	}
	
	FormField.handledProps = ['as', 'children', 'className', 'control', 'disabled', 'error', 'inline', 'label', 'required', 'type', 'width'];
	FormField._meta = {
	  name: 'FormField',
	  parent: 'Form',
	  type: _lib.META.TYPES.COLLECTION,
	  props: {
	    width: _lib.SUI.WIDTHS,
	    control: ['button', 'input', 'select', 'textarea']
	  }
	};
	
	 false ? FormField.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /**
	   * A form control component (i.e. Dropdown) or HTML tagName (i.e. 'input').
	   * Extra FormField props are passed to the control component.
	   * Mutually exclusive with children.
	   */
	  control: _lib.customPropTypes.some([_react.PropTypes.func, _react.PropTypes.oneOf(FormField._meta.props.control)]),
	
	  /** Individual fields may be disabled */
	  disabled: _react.PropTypes.bool,
	
	  /** Individual fields may display an error state */
	  error: _react.PropTypes.bool,
	
	  /** A field can have its label next to instead of above it */
	  inline: _react.PropTypes.bool,
	
	  // Heads Up!
	  // Do not disallow children with `label` shorthand
	  // The `control` might accept a `label` prop and `children`
	  /** Mutually exclusive with children. */
	  label: _react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.object]),
	
	  /** A field can show that input is mandatory.  Requires a label. */
	  required: _lib.customPropTypes.every([_lib.customPropTypes.demand(['label']), _react.PropTypes.bool]),
	
	  /** Passed to the control component (i.e. <input type='password' />) */
	  type: _lib.customPropTypes.every([_lib.customPropTypes.demand(['control'])]),
	
	  /** A field can specify its width in grid columns */
	  width: _react.PropTypes.oneOf(FormField._meta.props.width)
	} : void 0;
	
	exports.default = FormField;

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _Checkbox = __webpack_require__(753);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _FormField = __webpack_require__(793);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sugar for <Form.Field control={Checkbox} />
	 * @see Checkbox
	 * @see Form
	 */
	function FormCheckbox(props) {
	  var control = props.control;
	
	  var rest = (0, _lib.getUnhandledProps)(FormCheckbox, props);
	  var ElementType = (0, _lib.getElementType)(FormCheckbox, props);
	
	  return _react2.default.createElement(ElementType, (0, _extends3.default)({}, rest, { control: control }));
	}
	
	FormCheckbox.handledProps = ['as', 'control'];
	FormCheckbox._meta = {
	  name: 'FormCheckbox',
	  parent: 'Form',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	 false ? FormCheckbox.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A FormField control prop */
	  control: _FormField2.default.propTypes.control
	} : void 0;
	
	FormCheckbox.defaultProps = {
	  as: _FormField2.default,
	  control: _Checkbox2.default
	};
	
	exports.default = FormCheckbox;

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _Dropdown = __webpack_require__(757);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _FormField = __webpack_require__(793);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sugar for <Form.Field control={Dropdown} />
	 * @see Dropdown
	 * @see Form
	 */
	function FormDropdown(props) {
	  var control = props.control;
	
	  var rest = (0, _lib.getUnhandledProps)(FormDropdown, props);
	  var ElementType = (0, _lib.getElementType)(FormDropdown, props);
	
	  return _react2.default.createElement(ElementType, (0, _extends3.default)({}, rest, { control: control }));
	}
	
	FormDropdown.handledProps = ['as', 'control'];
	FormDropdown._meta = {
	  name: 'FormDropdown',
	  parent: 'Form',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	 false ? FormDropdown.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A FormField control prop */
	  control: _FormField2.default.propTypes.control
	} : void 0;
	
	FormDropdown.defaultProps = {
	  as: _FormField2.default,
	  control: _Dropdown2.default
	};
	
	exports.default = FormDropdown;

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(607);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A set of fields can appear grouped together
	 * @see Form
	 */
	function FormGroup(props) {
	  var children = props.children,
	      className = props.className,
	      grouped = props.grouped,
	      inline = props.inline,
	      widths = props.widths;
	
	  var classes = (0, _classnames2.default)((0, _lib.useWidthProp)(widths, null, true), (0, _lib.useKeyOnly)(inline, 'inline'), (0, _lib.useKeyOnly)(grouped, 'grouped'), 'fields', className);
	  var rest = (0, _lib.getUnhandledProps)(FormGroup, props);
	  var ElementType = (0, _lib.getElementType)(FormGroup, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	FormGroup.handledProps = ['as', 'children', 'className', 'grouped', 'inline', 'widths'];
	FormGroup._meta = {
	  name: 'FormGroup',
	  parent: 'Form',
	  type: _lib.META.TYPES.COLLECTION,
	  props: {
	    widths: [].concat((0, _toConsumableArray3.default)(_lib.SUI.WIDTHS), ['equal'])
	  }
	};
	
	 false ? FormGroup.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Fields can show related choices */
	  grouped: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['inline']), _react.PropTypes.bool]),
	
	  /** Multiple fields may be inline in a row */
	  inline: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['grouped']), _react.PropTypes.bool]),
	
	  /** Fields Groups can specify their width in grid columns or automatically divide fields to be equal width */
	  widths: _react.PropTypes.oneOf(FormGroup._meta.props.widths)
	} : void 0;
	
	FormGroup.defaultProps = {
	  as: 'div'
	};
	
	exports.default = FormGroup;

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _Input = __webpack_require__(798);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _FormField = __webpack_require__(793);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sugar for <Form.Field control={Input} />
	 * @see Form
	 * @see Input
	 */
	function FormInput(props) {
	  var control = props.control;
	
	  var rest = (0, _lib.getUnhandledProps)(FormInput, props);
	  var ElementType = (0, _lib.getElementType)(FormInput, props);
	
	  return _react2.default.createElement(ElementType, (0, _extends3.default)({}, rest, { control: control }));
	}
	
	FormInput.handledProps = ['as', 'control'];
	FormInput._meta = {
	  name: 'FormInput',
	  parent: 'Form',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	 false ? FormInput.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A FormField control prop */
	  control: _FormField2.default.propTypes.control
	} : void 0;
	
	FormInput.defaultProps = {
	  as: _FormField2.default,
	  control: _Input2.default
	};
	
	exports.default = FormInput;

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Input = __webpack_require__(799);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Input2.default;

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.htmlInputPropNames = undefined;
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(513);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(514);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(518);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(552);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _includes2 = __webpack_require__(707);
	
	var _includes3 = _interopRequireDefault(_includes2);
	
	var _map2 = __webpack_require__(702);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _pick2 = __webpack_require__(682);
	
	var _pick3 = _interopRequireDefault(_pick2);
	
	var _omit2 = __webpack_require__(743);
	
	var _omit3 = _interopRequireDefault(_omit2);
	
	var _get2 = __webpack_require__(366);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lib = __webpack_require__(562);
	
	var _Button = __webpack_require__(720);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(750);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Label = __webpack_require__(775);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var htmlInputPropNames = exports.htmlInputPropNames = [
	// REACT
	'selected', 'defaultValue', 'defaultChecked',
	
	// LIMITED HTML PROPS
	'autoComplete', 'autoFocus', 'checked', 'form', 'max', 'maxLength', 'min', 'name', 'pattern', 'placeholder', 'readOnly', 'required', 'step', 'type', 'value',
	
	// Heads Up!
	// Do not pass disabled, it duplicates the SUI CSS opacity rule.
	// 'disabled',
	
	// EVENTS
	// keyboard
	'onKeyDown', 'onKeyPress', 'onKeyUp',
	
	// focus
	'onFocus', 'onBlur',
	
	// form
	'onChange', 'onInput',
	
	// mouse
	'onClick', 'onContextMenu', 'onDrag', 'onDragEnd', 'onDragEnter', 'onDragExit', 'onDragLeave', 'onDragOver', 'onDragStart', 'onDrop', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onMouseUp',
	
	// selection
	'onSelect',
	
	// touch
	'onTouchCancel', 'onTouchEnd', 'onTouchMove', 'onTouchStart'];
	
	/**
	 * An Input is a field used to elicit a response from a user.
	 * @see Button
	 * @see Form
	 * @see Icon
	 * @see Label
	 */
	
	var Input = function (_Component) {
	  (0, _inherits3.default)(Input, _Component);
	
	  function Input() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Input);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Input.__proto__ || Object.getPrototypeOf(Input)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (e) {
	      var value = (0, _get3.default)(e, 'target.value');
	
	      var onChange = _this.props.onChange;
	
	      if (onChange) onChange(e, (0, _extends3.default)({}, _this.props, { value: value }));
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Input, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          action = _props.action,
	          actionPosition = _props.actionPosition,
	          children = _props.children,
	          className = _props.className,
	          disabled = _props.disabled,
	          error = _props.error,
	          fluid = _props.fluid,
	          focus = _props.focus,
	          icon = _props.icon,
	          iconPosition = _props.iconPosition,
	          input = _props.input,
	          inverted = _props.inverted,
	          label = _props.label,
	          labelPosition = _props.labelPosition,
	          loading = _props.loading,
	          onChange = _props.onChange,
	          size = _props.size,
	          tabIndex = _props.tabIndex,
	          transparent = _props.transparent,
	          type = _props.type;
	
	
	      var classes = (0, _classnames2.default)('ui', size, (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(error, 'error'), (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(focus, 'focus'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(loading, 'loading'), (0, _lib.useKeyOnly)(transparent, 'transparent'), (0, _lib.useValueAndKey)(actionPosition, 'action') || (0, _lib.useKeyOnly)(action, 'action'), (0, _lib.useValueAndKey)(iconPosition, 'icon') || (0, _lib.useKeyOnly)(icon, 'icon'), (0, _lib.useValueAndKey)(labelPosition, 'labeled') || (0, _lib.useKeyOnly)(label, 'labeled'), 'input', className);
	      var unhandled = (0, _lib.getUnhandledProps)(Input, this.props);
	
	      var rest = (0, _omit3.default)(unhandled, htmlInputPropNames);
	
	      var htmlInputProps = (0, _pick3.default)(this.props, htmlInputPropNames);
	      if (onChange) htmlInputProps.onChange = this.handleChange;
	
	      var ElementType = (0, _lib.getElementType)(Input, this.props);
	
	      // tabIndex
	      if (!(0, _isNil3.default)(tabIndex)) htmlInputProps.tabIndex = tabIndex;else if (disabled) htmlInputProps.tabIndex = -1;
	
	      // Render with children
	      // ----------------------------------------
	      if (!(0, _isNil3.default)(children)) {
	        // add htmlInputProps to the `<input />` child
	        var childElements = (0, _map3.default)(_react.Children.toArray(children), function (child) {
	          if (child.type !== 'input') return child;
	
	          return (0, _react.cloneElement)(child, (0, _extends3.default)({}, htmlInputProps, child.props));
	        });
	
	        return _react2.default.createElement(
	          ElementType,
	          (0, _extends3.default)({}, rest, { className: classes }),
	          childElements
	        );
	      }
	
	      // Render Shorthand
	      // ----------------------------------------
	      var actionElement = _Button2.default.create(action, function (elProps) {
	        return {
	          className: (0, _classnames2.default)(
	          // all action components should have the button className
	          !(0, _includes3.default)(elProps.className, 'button') && 'button')
	        };
	      });
	      var iconElement = _Icon2.default.create(icon);
	      var labelElement = _Label2.default.create(label, function (elProps) {
	        return {
	          className: (0, _classnames2.default)(
	          // all label components should have the label className
	          !(0, _includes3.default)(elProps.className, 'label') && 'label',
	          // add 'left|right corner'
	          (0, _includes3.default)(labelPosition, 'corner') && labelPosition)
	        };
	      });
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes }),
	        actionPosition === 'left' && actionElement,
	        iconPosition === 'left' && iconElement,
	        labelPosition !== 'right' && labelElement,
	        (0, _lib.createHTMLInput)(input || type, htmlInputProps),
	        actionPosition !== 'left' && actionElement,
	        iconPosition !== 'left' && iconElement,
	        labelPosition === 'right' && labelElement
	      );
	    }
	  }]);
	  return Input;
	}(_react.Component);
	
	Input.defaultProps = {
	  type: 'text'
	};
	Input._meta = {
	  name: 'Input',
	  type: _lib.META.TYPES.ELEMENT
	};
	 false ? Input.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** An Input can be formatted to alert the user to an action they may perform. */
	  action: _react.PropTypes.oneOfType([_react.PropTypes.bool, _lib.customPropTypes.itemShorthand]),
	
	  /** An action can appear along side an Input on the left or right. */
	  actionPosition: _react.PropTypes.oneOf(['left']),
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** An Input field can show that it is disabled. */
	  disabled: _react.PropTypes.bool,
	
	  /** An Input field can show the data contains errors. */
	  error: _react.PropTypes.bool,
	
	  /** Take on the size of it's container. */
	  fluid: _react.PropTypes.bool,
	
	  /** An Input field can show a user is currently interacting with it. */
	  focus: _react.PropTypes.bool,
	
	  /** Optional Icon to display inside the Input. */
	  icon: _react.PropTypes.oneOfType([_react.PropTypes.bool, _lib.customPropTypes.itemShorthand]),
	
	  /** An Icon can appear inside an Input on the left or right. */
	  iconPosition: _react.PropTypes.oneOf(['left']),
	
	  /** Shorthand for creating the HTML Input. */
	  input: _lib.customPropTypes.itemShorthand,
	
	  /** Format to appear on dark backgrounds. */
	  inverted: _react.PropTypes.bool,
	
	  /** Optional Label to display along side the Input. */
	  label: _lib.customPropTypes.itemShorthand,
	
	  /** A Label can appear outside an Input on the left or right. */
	  labelPosition: _react.PropTypes.oneOf(['left', 'right', 'left corner', 'right corner']),
	
	  /** An Icon Input field can show that it is currently loading data. */
	  loading: _react.PropTypes.bool,
	
	  /**
	   * Called on change.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props and proposed value.
	   */
	  onChange: _react.PropTypes.func,
	
	  /** An Input can vary in size. */
	  size: _react.PropTypes.oneOf(_lib.SUI.SIZES),
	
	  /** An Input can receive focus. */
	  tabIndex: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	
	  /** Transparent Input has no background. */
	  transparent: _react.PropTypes.bool,
	
	  /** The HTML input type. */
	  type: _react.PropTypes.string
	} : void 0;
	Input.handledProps = ['action', 'actionPosition', 'as', 'children', 'className', 'disabled', 'error', 'fluid', 'focus', 'icon', 'iconPosition', 'input', 'inverted', 'label', 'labelPosition', 'loading', 'onChange', 'size', 'tabIndex', 'transparent', 'type'];
	
	
	Input.create = (0, _lib.createShorthandFactory)(Input, function (type) {
	  return { type: type };
	});
	
	exports.default = Input;

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _Radio = __webpack_require__(751);
	
	var _Radio2 = _interopRequireDefault(_Radio);
	
	var _FormField = __webpack_require__(793);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sugar for <Form.Field control={Radio} />
	 * @see Form
	 * @see Radio
	 */
	function FormRadio(props) {
	  var control = props.control;
	
	  var rest = (0, _lib.getUnhandledProps)(FormRadio, props);
	  var ElementType = (0, _lib.getElementType)(FormRadio, props);
	
	  return _react2.default.createElement(ElementType, (0, _extends3.default)({}, rest, { control: control }));
	}
	
	FormRadio.handledProps = ['as', 'control'];
	FormRadio._meta = {
	  name: 'FormRadio',
	  parent: 'Form',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	 false ? FormRadio.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A FormField control prop */
	  control: _FormField2.default.propTypes.control
	} : void 0;
	
	FormRadio.defaultProps = {
	  as: _FormField2.default,
	  control: _Radio2.default
	};
	
	exports.default = FormRadio;

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _Select = __webpack_require__(755);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _FormField = __webpack_require__(793);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sugar for <Form.Field control={Select} />
	 * @see Form
	 * @see Select
	 */
	function FormSelect(props) {
	  var control = props.control;
	
	  var rest = (0, _lib.getUnhandledProps)(FormSelect, props);
	  var ElementType = (0, _lib.getElementType)(FormSelect, props);
	
	  return _react2.default.createElement(ElementType, (0, _extends3.default)({}, rest, { control: control }));
	}
	
	FormSelect.handledProps = ['as', 'control'];
	FormSelect._meta = {
	  name: 'FormSelect',
	  parent: 'Form',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	 false ? FormSelect.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A FormField control prop */
	  control: _FormField2.default.propTypes.control
	} : void 0;
	
	FormSelect.defaultProps = {
	  as: _FormField2.default,
	  control: _Select2.default
	};
	
	exports.default = FormSelect;

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _TextArea = __webpack_require__(783);
	
	var _TextArea2 = _interopRequireDefault(_TextArea);
	
	var _FormField = __webpack_require__(793);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sugar for <Form.Field control={TextArea} />
	 * @see Form
	 * @see TextArea
	 */
	function FormTextArea(props) {
	  var control = props.control;
	
	  var rest = (0, _lib.getUnhandledProps)(FormTextArea, props);
	  var ElementType = (0, _lib.getElementType)(FormTextArea, props);
	
	  return _react2.default.createElement(ElementType, (0, _extends3.default)({}, rest, { control: control }));
	}
	
	FormTextArea.handledProps = ['as', 'control'];
	FormTextArea._meta = {
	  name: 'FormTextArea',
	  parent: 'Form',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	 false ? FormTextArea.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A FormField control prop */
	  control: _FormField2.default.propTypes.control
	} : void 0;
	
	FormTextArea.defaultProps = {
	  as: _FormField2.default,
	  control: _TextArea2.default
	};
	
	exports.default = FormTextArea;

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Grid = __webpack_require__(804);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Grid2.default;

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(607);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _GridColumn = __webpack_require__(805);
	
	var _GridColumn2 = _interopRequireDefault(_GridColumn);
	
	var _GridRow = __webpack_require__(806);
	
	var _GridRow2 = _interopRequireDefault(_GridRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A grid is used to harmonize negative space in a layout.
	 */
	function Grid(props) {
	  var celled = props.celled,
	      centered = props.centered,
	      children = props.children,
	      className = props.className,
	      columns = props.columns,
	      container = props.container,
	      divided = props.divided,
	      doubling = props.doubling,
	      padded = props.padded,
	      relaxed = props.relaxed,
	      reversed = props.reversed,
	      stackable = props.stackable,
	      stretched = props.stretched,
	      textAlign = props.textAlign,
	      verticalAlign = props.verticalAlign;
	
	
	  var classes = (0, _classnames2.default)('ui', (0, _lib.useKeyOnly)(centered, 'centered'), (0, _lib.useKeyOnly)(container, 'container'), (0, _lib.useKeyOnly)(doubling, 'doubling'), (0, _lib.useKeyOnly)(stackable, 'stackable'), (0, _lib.useKeyOnly)(stretched, 'stretched'), (0, _lib.useKeyOrValueAndKey)(celled, 'celled'), (0, _lib.useKeyOrValueAndKey)(divided, 'divided'), (0, _lib.useKeyOrValueAndKey)(padded, 'padded'), (0, _lib.useKeyOrValueAndKey)(relaxed, 'relaxed'), (0, _lib.useTextAlignProp)(textAlign), (0, _lib.useValueAndKey)(reversed, 'reversed'), (0, _lib.useVerticalAlignProp)(verticalAlign), (0, _lib.useWidthProp)(columns, 'column', true), 'grid', className);
	  var rest = (0, _lib.getUnhandledProps)(Grid, props);
	  var ElementType = (0, _lib.getElementType)(Grid, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	Grid.handledProps = ['as', 'celled', 'centered', 'children', 'className', 'columns', 'container', 'divided', 'doubling', 'padded', 'relaxed', 'reversed', 'stackable', 'stretched', 'textAlign', 'verticalAlign'];
	Grid.Column = _GridColumn2.default;
	Grid.Row = _GridRow2.default;
	
	Grid._meta = {
	  name: 'Grid',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	 false ? Grid.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A grid can have rows divided into cells. */
	  celled: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.oneOf(['internally'])]),
	
	  /** A grid can have its columns centered. */
	  centered: _react.PropTypes.bool,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Represents column count per row in Grid. */
	  columns: _react.PropTypes.oneOf([].concat((0, _toConsumableArray3.default)(_lib.SUI.WIDTHS), ['equal'])),
	
	  /** A grid can be combined with a container to use avaiable layout and alignment. */
	  container: _react.PropTypes.bool,
	
	  /** A grid can have dividers between its columns. */
	  divided: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.oneOf(['vertically'])]),
	
	  /** A grid can double its column width on tablet and mobile sizes. */
	  doubling: _react.PropTypes.bool,
	
	  /** A grid can preserve its vertical and horizontal gutters on first and last columns. */
	  padded: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.oneOf(['horizontally', 'vertically'])]),
	
	  /** A grid can increase its gutters to allow for more negative space. */
	  relaxed: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.oneOf(['very'])]),
	
	  /** A grid can specify that its columns should reverse order at different device sizes. */
	  reversed: _react.PropTypes.oneOf(['computer', 'computer vertically', 'mobile', 'mobile vertically', 'tablet', 'tablet vertically']),
	
	  /** A grid can have its columns stack on-top of each other after reaching mobile breakpoints. */
	  stackable: _react.PropTypes.bool,
	
	  /** An can stretch its contents to take up the entire grid height. */
	  stretched: _react.PropTypes.bool,
	
	  /** A grid can specify its text alignment. */
	  textAlign: _react.PropTypes.oneOf(_lib.SUI.TEXT_ALIGNMENTS),
	
	  /** A grid can specify its vertical alignment to have all its columns vertically centered. */
	  verticalAlign: _react.PropTypes.oneOf(_lib.SUI.VERTICAL_ALIGNMENTS)
	} : void 0;
	
	exports.default = Grid;

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A column sub-component for Grid.
	 */
	function GridColumn(props) {
	  var children = props.children,
	      className = props.className,
	      computer = props.computer,
	      color = props.color,
	      floated = props.floated,
	      largeScreen = props.largeScreen,
	      mobile = props.mobile,
	      only = props.only,
	      stretched = props.stretched,
	      tablet = props.tablet,
	      textAlign = props.textAlign,
	      verticalAlign = props.verticalAlign,
	      widescreen = props.widescreen,
	      width = props.width;
	
	
	  var classes = (0, _classnames2.default)(color, (0, _lib.useKeyOnly)(stretched, 'stretched'), (0, _lib.useTextAlignProp)(textAlign), (0, _lib.useValueAndKey)(floated, 'floated'), (0, _lib.useValueAndKey)(only, 'only'), (0, _lib.useVerticalAlignProp)(verticalAlign), (0, _lib.useWidthProp)(computer, 'wide computer'), (0, _lib.useWidthProp)(largeScreen, 'wide large screen'), (0, _lib.useWidthProp)(mobile, 'wide mobile'), (0, _lib.useWidthProp)(tablet, 'wide tablet'), (0, _lib.useWidthProp)(widescreen, 'wide widescreen'), (0, _lib.useWidthProp)(width, 'wide'), 'column', className);
	  var rest = (0, _lib.getUnhandledProps)(GridColumn, props);
	  var ElementType = (0, _lib.getElementType)(GridColumn, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	GridColumn.handledProps = ['as', 'children', 'className', 'color', 'computer', 'floated', 'largeScreen', 'mobile', 'only', 'stretched', 'tablet', 'textAlign', 'verticalAlign', 'widescreen', 'width'];
	GridColumn._meta = {
	  name: 'GridColumn',
	  parent: 'Grid',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	 false ? GridColumn.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** A grid column can be colored. */
	  color: _react.PropTypes.oneOf(_lib.SUI.COLORS),
	
	  /** A column can specify a width for a computer. */
	  computer: _react.PropTypes.oneOf(_lib.SUI.WIDTHS),
	
	  /** A column can sit flush against the left or right edge of a row. */
	  floated: _react.PropTypes.oneOf(_lib.SUI.FLOATS),
	
	  /** A column can specify a width for a large screen device. */
	  largeScreen: _react.PropTypes.oneOf(_lib.SUI.WIDTHS),
	
	  /** A column can specify a width for a mobile device. */
	  mobile: _react.PropTypes.oneOf(_lib.SUI.WIDTHS),
	
	  /** A column can appear only for a specific device, or screen sizes. */
	  only: _react.PropTypes.oneOf(['computer', 'large screen', 'mobile', 'tablet mobile', 'tablet', 'widescreen']),
	
	  /** An can stretch its contents to take up the entire grid or row height. */
	  stretched: _react.PropTypes.bool,
	
	  /** A column can specify a width for a tablet device. */
	  tablet: _react.PropTypes.oneOf(_lib.SUI.WIDTHS),
	
	  /** A row can specify its text alignment. */
	  textAlign: _react.PropTypes.oneOf(_lib.SUI.TEXT_ALIGNMENTS),
	
	  /** A column can specify its vertical alignment to have all its columns vertically centered. */
	  verticalAlign: _react.PropTypes.oneOf(_lib.SUI.VERTICAL_ALIGNMENTS),
	
	  /** A column can specify a width for a wide screen device. */
	  widescreen: _react.PropTypes.oneOf(_lib.SUI.WIDTHS),
	
	  /** Represents width of column. */
	  width: _react.PropTypes.oneOf(_lib.SUI.WIDTHS)
	} : void 0;
	
	exports.default = GridColumn;

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(607);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A row sub-component for Grid.
	 */
	function GridRow(props) {
	  var centered = props.centered,
	      children = props.children,
	      className = props.className,
	      color = props.color,
	      columns = props.columns,
	      divided = props.divided,
	      only = props.only,
	      reversed = props.reversed,
	      stretched = props.stretched,
	      textAlign = props.textAlign,
	      verticalAlign = props.verticalAlign;
	
	
	  var classes = (0, _classnames2.default)(color, (0, _lib.useKeyOnly)(centered, 'centered'), (0, _lib.useKeyOnly)(divided, 'divided'), (0, _lib.useKeyOnly)(stretched, 'stretched'), (0, _lib.useTextAlignProp)(textAlign), (0, _lib.useValueAndKey)(only, 'only'), (0, _lib.useValueAndKey)(reversed, 'reversed'), (0, _lib.useVerticalAlignProp)(verticalAlign), (0, _lib.useWidthProp)(columns, 'column', true), 'row', className);
	  var rest = (0, _lib.getUnhandledProps)(GridRow, props);
	  var ElementType = (0, _lib.getElementType)(GridRow, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	GridRow.handledProps = ['as', 'centered', 'children', 'className', 'color', 'columns', 'divided', 'only', 'reversed', 'stretched', 'textAlign', 'verticalAlign'];
	GridRow._meta = {
	  name: 'GridRow',
	  parent: 'Grid',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	 false ? GridRow.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A row can have its columns centered. */
	  centered: _react.PropTypes.bool,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** A grid row can be colored. */
	  color: _react.PropTypes.oneOf(_lib.SUI.COLORS),
	
	  /** Represents column count per line in Row. */
	  columns: _react.PropTypes.oneOf([].concat((0, _toConsumableArray3.default)(_lib.SUI.WIDTHS), ['equal'])),
	
	  /** A row can have dividers between its columns. */
	  divided: _react.PropTypes.bool,
	
	  /** A row can appear only for a specific device, or screen sizes. */
	  only: _react.PropTypes.oneOf(['computer', 'large screen', 'mobile', 'tablet mobile', 'tablet', 'widescreen']),
	
	  /** A  row can specify that its columns should reverse order at different device sizes. */
	  reversed: _react.PropTypes.oneOf(['computer', 'computer vertically', 'mobile', 'mobile vertically', 'tablet', 'tablet vertically']),
	
	  /** An can stretch its contents to take up the entire column height. */
	  stretched: _react.PropTypes.bool,
	
	  /** A row can specify its text alignment. */
	  textAlign: _react.PropTypes.oneOf(_lib.SUI.TEXT_ALIGNMENTS),
	
	  /** A row can specify its vertical alignment to have all its columns vertically centered. */
	  verticalAlign: _react.PropTypes.oneOf(_lib.SUI.VERTICAL_ALIGNMENTS)
	} : void 0;
	
	exports.default = GridRow;

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Menu = __webpack_require__(808);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Menu2.default;

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(513);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(514);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(518);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(552);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _map2 = __webpack_require__(702);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _get2 = __webpack_require__(366);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _without2 = __webpack_require__(723);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _MenuHeader = __webpack_require__(809);
	
	var _MenuHeader2 = _interopRequireDefault(_MenuHeader);
	
	var _MenuItem = __webpack_require__(810);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _MenuMenu = __webpack_require__(827);
	
	var _MenuMenu2 = _interopRequireDefault(_MenuMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A menu displays grouped navigation actions.
	 * @see Dropdown
	 */
	var Menu = function (_Component) {
	  (0, _inherits3.default)(Menu, _Component);
	
	  function Menu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Menu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Menu.__proto__ || Object.getPrototypeOf(Menu)).call.apply(_ref, [this].concat(args))), _this), _this.handleItemClick = function (e, itemProps) {
	      var index = itemProps.index;
	      var _this$props = _this.props,
	          items = _this$props.items,
	          onItemClick = _this$props.onItemClick;
	
	
	      _this.trySetState({ activeIndex: index });
	
	      if ((0, _get3.default)(items[index], 'onClick')) items[index].onClick(e, itemProps);
	      if (onItemClick) onItemClick(e, itemProps);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Menu, [{
	    key: 'renderItems',
	    value: function renderItems() {
	      var _this2 = this;
	
	      var items = this.props.items;
	      var activeIndex = this.state.activeIndex;
	
	
	      return (0, _map3.default)(items, function (item, index) {
	        return _MenuItem2.default.create(item, {
	          active: activeIndex === index,
	          index: index,
	          onClick: _this2.handleItemClick
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          attached = _props.attached,
	          borderless = _props.borderless,
	          children = _props.children,
	          className = _props.className,
	          color = _props.color,
	          compact = _props.compact,
	          fixed = _props.fixed,
	          floated = _props.floated,
	          fluid = _props.fluid,
	          icon = _props.icon,
	          inverted = _props.inverted,
	          pagination = _props.pagination,
	          pointing = _props.pointing,
	          secondary = _props.secondary,
	          size = _props.size,
	          stackable = _props.stackable,
	          tabular = _props.tabular,
	          text = _props.text,
	          vertical = _props.vertical,
	          widths = _props.widths;
	
	      var classes = (0, _classnames2.default)('ui', color, size, (0, _lib.useKeyOnly)(borderless, 'borderless'), (0, _lib.useKeyOnly)(compact, 'compact'), (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(pagination, 'pagination'), (0, _lib.useKeyOnly)(pointing, 'pointing'), (0, _lib.useKeyOnly)(secondary, 'secondary'), (0, _lib.useKeyOnly)(stackable, 'stackable'), (0, _lib.useKeyOnly)(text, 'text'), (0, _lib.useKeyOnly)(vertical, 'vertical'), (0, _lib.useKeyOrValueAndKey)(attached, 'attached'), (0, _lib.useKeyOrValueAndKey)(floated, 'floated'), (0, _lib.useKeyOrValueAndKey)(icon, 'icon'), (0, _lib.useKeyOrValueAndKey)(tabular, 'tabular'), (0, _lib.useValueAndKey)(fixed, 'fixed'), (0, _lib.useWidthProp)(widths, 'item'), className, 'menu');
	      var rest = (0, _lib.getUnhandledProps)(Menu, this.props);
	      var ElementType = (0, _lib.getElementType)(Menu, this.props);
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes }),
	        (0, _isNil3.default)(children) ? this.renderItems() : children
	      );
	    }
	  }]);
	  return Menu;
	}(_lib.AutoControlledComponent);
	
	Menu._meta = {
	  name: 'Menu',
	  type: _lib.META.TYPES.COLLECTION
	};
	Menu.autoControlledProps = ['activeIndex'];
	Menu.Header = _MenuHeader2.default;
	Menu.Item = _MenuItem2.default;
	Menu.Menu = _MenuMenu2.default;
	 false ? Menu.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Index of the currently active item. */
	  activeIndex: _react.PropTypes.number,
	
	  /** A menu may be attached to other content segments. */
	  attached: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.oneOf(['top', 'bottom'])]),
	
	  /** A menu item or menu can have no borders. */
	  borderless: _react.PropTypes.bool,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Additional colors can be specified. */
	  color: _react.PropTypes.oneOf(_lib.SUI.COLORS),
	
	  /** A menu can take up only the space necessary to fit its content. */
	  compact: _react.PropTypes.bool,
	
	  /** Initial activeIndex value. */
	  defaultActiveIndex: _react.PropTypes.number,
	
	  /** A menu can be fixed to a side of its context. */
	  fixed: _react.PropTypes.oneOf(['left', 'right', 'bottom', 'top']),
	
	  /** A menu can be floated. */
	  floated: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.oneOf(['right'])]),
	
	  /** A vertical menu may take the size of its container. */
	  fluid: _react.PropTypes.bool,
	
	  /** A menu may have labeled icons. */
	  icon: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.oneOf(['labeled'])]),
	
	  /** A menu may have its colors inverted to show greater contrast. */
	  inverted: _react.PropTypes.bool,
	
	  /** Shorthand array of props for Menu. */
	  items: _lib.customPropTypes.collectionShorthand,
	
	  /**
	   * onClick handler for MenuItem. Mutually exclusive with children.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All item props.
	   */
	  onItemClick: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['children']), _react.PropTypes.func]),
	
	  /** A pagination menu is specially formatted to present links to pages of content. */
	  pagination: _react.PropTypes.bool,
	
	  /** A menu can point to show its relationship to nearby content. */
	  pointing: _react.PropTypes.bool,
	
	  /** A menu can adjust its appearance to de-emphasize its contents. */
	  secondary: _react.PropTypes.bool,
	
	  /** A menu can vary in size. */
	  size: _react.PropTypes.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'medium', 'big')),
	
	  /** A menu can stack at mobile resolutions. */
	  stackable: _react.PropTypes.bool,
	
	  /** A menu can be formatted to show tabs of information. */
	  tabular: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.oneOf(['right'])]),
	
	  /** A menu can be formatted for text content. */
	  text: _react.PropTypes.bool,
	
	  /** A vertical menu displays elements vertically. */
	  vertical: _react.PropTypes.bool,
	
	  /** A menu can have its items divided evenly. */
	  widths: _react.PropTypes.oneOf(_lib.SUI.WIDTHS)
	} : void 0;
	Menu.handledProps = ['activeIndex', 'as', 'attached', 'borderless', 'children', 'className', 'color', 'compact', 'defaultActiveIndex', 'fixed', 'floated', 'fluid', 'icon', 'inverted', 'items', 'onItemClick', 'pagination', 'pointing', 'secondary', 'size', 'stackable', 'tabular', 'text', 'vertical', 'widths'];
	exports.default = Menu;

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A menu item may include a header or may itself be a header.
	 */
	function MenuHeader(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('header', className);
	  var rest = (0, _lib.getUnhandledProps)(MenuHeader, props);
	  var ElementType = (0, _lib.getElementType)(MenuHeader, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _isNil3.default)(children) ? content : children
	  );
	}
	
	MenuHeader.handledProps = ['as', 'children', 'className', 'content'];
	MenuHeader._meta = {
	  name: 'MenuHeader',
	  type: _lib.META.TYPES.COLLECTION,
	  parent: 'Menu'
	};
	
	 false ? MenuHeader.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : void 0;
	
	exports.default = MenuHeader;

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(513);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(514);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(518);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(552);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _startCase2 = __webpack_require__(811);
	
	var _startCase3 = _interopRequireDefault(_startCase2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _Icon = __webpack_require__(750);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A menu can contain an item.
	 */
	var MenuItem = function (_Component) {
	  (0, _inherits3.default)(MenuItem, _Component);
	
	  function MenuItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, MenuItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
	      var onClick = _this.props.onClick;
	
	
	      if (onClick) onClick(e, _this.props);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(MenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          className = _props.className,
	          color = _props.color,
	          content = _props.content,
	          fitted = _props.fitted,
	          header = _props.header,
	          icon = _props.icon,
	          link = _props.link,
	          name = _props.name,
	          onClick = _props.onClick,
	          position = _props.position;
	
	
	      var classes = (0, _classnames2.default)(color, position, (0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(icon === true || icon && !(name || content), 'icon'), (0, _lib.useKeyOnly)(header, 'header'), (0, _lib.useKeyOnly)(link, 'link'), (0, _lib.useKeyOrValueAndKey)(fitted, 'fitted'), 'item', className);
	      var ElementType = (0, _lib.getElementType)(MenuItem, this.props, function () {
	        if (onClick) return 'a';
	      });
	      var rest = (0, _lib.getUnhandledProps)(MenuItem, this.props);
	
	      if (!(0, _isNil3.default)(children)) {
	        return _react2.default.createElement(
	          ElementType,
	          (0, _extends3.default)({}, rest, { className: classes, onClick: this.handleClick }),
	          children
	        );
	      }
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes, onClick: this.handleClick }),
	        _Icon2.default.create(icon),
	        content || (0, _startCase3.default)(name)
	      );
	    }
	  }]);
	  return MenuItem;
	}(_react.Component);
	
	MenuItem._meta = {
	  name: 'MenuItem',
	  type: _lib.META.TYPES.COLLECTION,
	  parent: 'Menu'
	};
	exports.default = MenuItem;
	 false ? MenuItem.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A menu item can be active. */
	  active: _react.PropTypes.bool,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Additional colors can be specified. */
	  color: _react.PropTypes.oneOf(_lib.SUI.COLORS),
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A menu item or menu can remove element padding, vertically or horizontally. */
	  fitted: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.oneOf(['horizontally', 'vertically'])]),
	
	  /** A menu item may include a header or may itself be a header. */
	  header: _react.PropTypes.bool,
	
	  /** MenuItem can be only icon. */
	  icon: _react.PropTypes.oneOfType([_react.PropTypes.bool, _lib.customPropTypes.itemShorthand]),
	
	  /** MenuItem index inside Menu. */
	  index: _react.PropTypes.number,
	
	  /** A menu item can be link. */
	  link: _react.PropTypes.bool,
	
	  /** Internal name of the MenuItem. */
	  name: _react.PropTypes.string,
	
	  /**
	   * Called on click. When passed, the component will render as an `a`
	   * tag by default instead of a `div`.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _react.PropTypes.func,
	
	  /** A menu item can take right position. */
	  position: _react.PropTypes.oneOf(['right'])
	} : void 0;
	MenuItem.handledProps = ['active', 'as', 'children', 'className', 'color', 'content', 'fitted', 'header', 'icon', 'index', 'link', 'name', 'onClick', 'position'];
	
	
	MenuItem.create = (0, _lib.createShorthandFactory)(MenuItem, function (val) {
	  return { content: val, name: val };
	}, true);

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	var createCompounder = __webpack_require__(812),
	    upperFirst = __webpack_require__(820);
	
	/**
	 * Converts `string` to
	 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.1.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the start cased string.
	 * @example
	 *
	 * _.startCase('--foo-bar--');
	 * // => 'Foo Bar'
	 *
	 * _.startCase('fooBar');
	 * // => 'Foo Bar'
	 *
	 * _.startCase('__FOO_BAR__');
	 * // => 'FOO BAR'
	 */
	var startCase = createCompounder(function(result, word, index) {
	  return result + (index ? ' ' : '') + upperFirst(word);
	});
	
	module.exports = startCase;


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(465),
	    deburr = __webpack_require__(813),
	    words = __webpack_require__(816);
	
	/** Used to compose unicode capture groups. */
	var rsApos = "['\u2019]";
	
	/** Used to match apostrophes. */
	var reApos = RegExp(rsApos, 'g');
	
	/**
	 * Creates a function like `_.camelCase`.
	 *
	 * @private
	 * @param {Function} callback The function to combine each word.
	 * @returns {Function} Returns the new compounder function.
	 */
	function createCompounder(callback) {
	  return function(string) {
	    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	  };
	}
	
	module.exports = createCompounder;


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	var deburrLetter = __webpack_require__(814),
	    toString = __webpack_require__(374);
	
	/** Used to match Latin Unicode letters (excluding mathematical operators). */
	var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	/** Used to compose unicode character classes. */
	var rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
	
	/** Used to compose unicode capture groups. */
	var rsCombo = '[' + rsComboRange + ']';
	
	/**
	 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	 */
	var reComboMark = RegExp(rsCombo, 'g');
	
	/**
	 * Deburrs `string` by converting
	 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	 * letters to basic Latin letters and removing
	 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to deburr.
	 * @returns {string} Returns the deburred string.
	 * @example
	 *
	 * _.deburr('déjà vu');
	 * // => 'deja vu'
	 */
	function deburr(string) {
	  string = toString(string);
	  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	}
	
	module.exports = deburr;


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	var basePropertyOf = __webpack_require__(815);
	
	/** Used to map Latin Unicode letters to basic Latin letters. */
	var deburredLetters = {
	  // Latin-1 Supplement block.
	  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	  '\xc7': 'C',  '\xe7': 'c',
	  '\xd0': 'D',  '\xf0': 'd',
	  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	  '\xd1': 'N',  '\xf1': 'n',
	  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	  '\xc6': 'Ae', '\xe6': 'ae',
	  '\xde': 'Th', '\xfe': 'th',
	  '\xdf': 'ss',
	  // Latin Extended-A block.
	  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	  '\u0134': 'J',  '\u0135': 'j',
	  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	  '\u0174': 'W',  '\u0175': 'w',
	  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	  '\u0132': 'IJ', '\u0133': 'ij',
	  '\u0152': 'Oe', '\u0153': 'oe',
	  '\u0149': "'n", '\u017f': 's'
	};
	
	/**
	 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	 * letters to basic Latin letters.
	 *
	 * @private
	 * @param {string} letter The matched letter to deburr.
	 * @returns {string} Returns the deburred letter.
	 */
	var deburrLetter = basePropertyOf(deburredLetters);
	
	module.exports = deburrLetter;


/***/ }),
/* 815 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.propertyOf` without support for deep paths.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyOf(object) {
	  return function(key) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = basePropertyOf;


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	var asciiWords = __webpack_require__(817),
	    hasUnicodeWord = __webpack_require__(818),
	    toString = __webpack_require__(374),
	    unicodeWords = __webpack_require__(819);
	
	/**
	 * Splits `string` into an array of its words.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to inspect.
	 * @param {RegExp|string} [pattern] The pattern to match words.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the words of `string`.
	 * @example
	 *
	 * _.words('fred, barney, & pebbles');
	 * // => ['fred', 'barney', 'pebbles']
	 *
	 * _.words('fred, barney, & pebbles', /[^, ]+/g);
	 * // => ['fred', 'barney', '&', 'pebbles']
	 */
	function words(string, pattern, guard) {
	  string = toString(string);
	  pattern = guard ? undefined : pattern;
	
	  if (pattern === undefined) {
	    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	  }
	  return string.match(pattern) || [];
	}
	
	module.exports = words;


/***/ }),
/* 817 */
/***/ (function(module, exports) {

	/** Used to match words composed of alphanumeric characters. */
	var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	/**
	 * Splits an ASCII `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function asciiWords(string) {
	  return string.match(reAsciiWord) || [];
	}
	
	module.exports = asciiWords;


/***/ }),
/* 818 */
/***/ (function(module, exports) {

	/** Used to detect strings that need a more robust regexp to match words. */
	var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	/**
	 * Checks if `string` contains a word composed of Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a word is found, else `false`.
	 */
	function hasUnicodeWord(string) {
	  return reHasUnicodeWord.test(string);
	}
	
	module.exports = hasUnicodeWord;


/***/ }),
/* 819 */
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsDingbatRange = '\\u2700-\\u27bf',
	    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	    rsPunctuationRange = '\\u2000-\\u206f',
	    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	    rsVarRange = '\\ufe0e\\ufe0f',
	    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	/** Used to compose unicode capture groups. */
	var rsApos = "['\u2019]",
	    rsBreak = '[' + rsBreakRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsDigits = '\\d+',
	    rsDingbat = '[' + rsDingbatRange + ']',
	    rsLower = '[' + rsLowerRange + ']',
	    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsUpper = '[' + rsUpperRange + ']',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	    reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;
	
	/** Used to match complex or compound words. */
	var reUnicodeWord = RegExp([
	  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	  rsUpper + '+' + rsOptContrUpper,
	  rsOrdUpper,
	  rsOrdLower,
	  rsDigits,
	  rsEmoji
	].join('|'), 'g');
	
	/**
	 * Splits a Unicode `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function unicodeWords(string) {
	  return string.match(reUnicodeWord) || [];
	}
	
	module.exports = unicodeWords;


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	var createCaseFirst = __webpack_require__(821);
	
	/**
	 * Converts the first character of `string` to upper case.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.upperFirst('fred');
	 * // => 'Fred'
	 *
	 * _.upperFirst('FRED');
	 * // => 'FRED'
	 */
	var upperFirst = createCaseFirst('toUpperCase');
	
	module.exports = upperFirst;


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	var castSlice = __webpack_require__(822),
	    hasUnicode = __webpack_require__(823),
	    stringToArray = __webpack_require__(824),
	    toString = __webpack_require__(374);
	
	/**
	 * Creates a function like `_.lowerFirst`.
	 *
	 * @private
	 * @param {string} methodName The name of the `String` case method to use.
	 * @returns {Function} Returns the new case function.
	 */
	function createCaseFirst(methodName) {
	  return function(string) {
	    string = toString(string);
	
	    var strSymbols = hasUnicode(string)
	      ? stringToArray(string)
	      : undefined;
	
	    var chr = strSymbols
	      ? strSymbols[0]
	      : string.charAt(0);
	
	    var trailing = strSymbols
	      ? castSlice(strSymbols, 1).join('')
	      : string.slice(1);
	
	    return chr[methodName]() + trailing;
	  };
	}
	
	module.exports = createCaseFirst;


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(692);
	
	/**
	 * Casts `array` to a slice if it's needed.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {number} start The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the cast slice.
	 */
	function castSlice(array, start, end) {
	  var length = array.length;
	  end = end === undefined ? length : end;
	  return (!start && end >= length) ? array : baseSlice(array, start, end);
	}
	
	module.exports = castSlice;


/***/ }),
/* 823 */
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsZWJ = '\\u200d';
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	/**
	 * Checks if `string` contains Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	 */
	function hasUnicode(string) {
	  return reHasUnicode.test(string);
	}
	
	module.exports = hasUnicode;


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	var asciiToArray = __webpack_require__(825),
	    hasUnicode = __webpack_require__(823),
	    unicodeToArray = __webpack_require__(826);
	
	/**
	 * Converts `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function stringToArray(string) {
	  return hasUnicode(string)
	    ? unicodeToArray(string)
	    : asciiToArray(string);
	}
	
	module.exports = stringToArray;


/***/ }),
/* 825 */
/***/ (function(module, exports) {

	/**
	 * Converts an ASCII `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function asciiToArray(string) {
	  return string.split('');
	}
	
	module.exports = asciiToArray;


/***/ }),
/* 826 */
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Converts a Unicode `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function unicodeToArray(string) {
	  return string.match(reUnicode) || [];
	}
	
	module.exports = unicodeToArray;


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A menu can contain a sub menu.
	 */
	function MenuMenu(props) {
	  var children = props.children,
	      className = props.className,
	      position = props.position;
	
	
	  var classes = (0, _classnames2.default)(position, 'menu', className);
	  var rest = (0, _lib.getUnhandledProps)(MenuMenu, props);
	  var ElementType = (0, _lib.getElementType)(MenuMenu, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	MenuMenu.handledProps = ['as', 'children', 'className', 'position'];
	MenuMenu._meta = {
	  name: 'MenuMenu',
	  type: _lib.META.TYPES.COLLECTION,
	  parent: 'Menu'
	};
	
	 false ? MenuMenu.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** A sub menu can take right position. */
	  position: _react.PropTypes.oneOf(['right'])
	} : void 0;
	
	exports.default = MenuMenu;

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Message = __webpack_require__(829);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Message2.default;

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(513);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(514);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(518);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(552);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _without2 = __webpack_require__(723);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _Icon = __webpack_require__(750);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _MessageContent = __webpack_require__(830);
	
	var _MessageContent2 = _interopRequireDefault(_MessageContent);
	
	var _MessageHeader = __webpack_require__(831);
	
	var _MessageHeader2 = _interopRequireDefault(_MessageHeader);
	
	var _MessageList = __webpack_require__(832);
	
	var _MessageList2 = _interopRequireDefault(_MessageList);
	
	var _MessageItem = __webpack_require__(833);
	
	var _MessageItem2 = _interopRequireDefault(_MessageItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A message displays information that explains nearby content.
	 * @see Form
	 */
	var Message = function (_Component) {
	  (0, _inherits3.default)(Message, _Component);
	
	  function Message() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Message);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Message.__proto__ || Object.getPrototypeOf(Message)).call.apply(_ref, [this].concat(args))), _this), _this.handleDismiss = function (e) {
	      var onDismiss = _this.props.onDismiss;
	
	
	      if (onDismiss) onDismiss(e, _this.props);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Message, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          attached = _props.attached,
	          children = _props.children,
	          className = _props.className,
	          color = _props.color,
	          compact = _props.compact,
	          content = _props.content,
	          error = _props.error,
	          floating = _props.floating,
	          header = _props.header,
	          hidden = _props.hidden,
	          icon = _props.icon,
	          info = _props.info,
	          list = _props.list,
	          negative = _props.negative,
	          onDismiss = _props.onDismiss,
	          positive = _props.positive,
	          size = _props.size,
	          success = _props.success,
	          visible = _props.visible,
	          warning = _props.warning;
	
	
	      var classes = (0, _classnames2.default)('ui', color, size, (0, _lib.useKeyOnly)(compact, 'compact'), (0, _lib.useKeyOnly)(error, 'error'), (0, _lib.useKeyOnly)(floating, 'floating'), (0, _lib.useKeyOnly)(hidden, 'hidden'), (0, _lib.useKeyOnly)(icon, 'icon'), (0, _lib.useKeyOnly)(info, 'info'), (0, _lib.useKeyOnly)(negative, 'negative'), (0, _lib.useKeyOnly)(positive, 'positive'), (0, _lib.useKeyOnly)(success, 'success'), (0, _lib.useKeyOnly)(visible, 'visible'), (0, _lib.useKeyOnly)(warning, 'warning'), (0, _lib.useKeyOrValueAndKey)(attached, 'attached'), 'message', className);
	
	      var dismissIcon = onDismiss && _react2.default.createElement(_Icon2.default, { name: 'close', onClick: this.handleDismiss });
	      var rest = (0, _lib.getUnhandledProps)(Message, this.props);
	      var ElementType = (0, _lib.getElementType)(Message, this.props);
	
	      if (!(0, _isNil3.default)(children)) {
	        return _react2.default.createElement(
	          ElementType,
	          (0, _extends3.default)({}, rest, { className: classes }),
	          dismissIcon,
	          children
	        );
	      }
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes }),
	        dismissIcon,
	        _Icon2.default.create(icon),
	        (!(0, _isNil3.default)(header) || !(0, _isNil3.default)(content) || !(0, _isNil3.default)(list)) && _react2.default.createElement(
	          _MessageContent2.default,
	          null,
	          _MessageHeader2.default.create(header),
	          _MessageList2.default.create(list),
	          (0, _lib.createShorthand)('p', function (val) {
	            return { children: val };
	          }, content)
	        )
	      );
	    }
	  }]);
	  return Message;
	}(_react.Component);
	
	Message._meta = {
	  name: 'Message',
	  type: _lib.META.TYPES.COLLECTION
	};
	Message.Content = _MessageContent2.default;
	Message.Header = _MessageHeader2.default;
	Message.List = _MessageList2.default;
	Message.Item = _MessageItem2.default;
	exports.default = Message;
	 false ? Message.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A message can be formatted to attach itself to other content. */
	  attached: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.oneOf(['bottom'])]),
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** A message can be formatted to be different colors. */
	  color: _react.PropTypes.oneOf(_lib.SUI.COLORS),
	
	  /** A message can only take up the width of its content. */
	  compact: _react.PropTypes.bool,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A message may be formatted to display a negative message. Same as `negative`. */
	  error: _react.PropTypes.bool,
	
	  /** A message can float above content that it is related to. */
	  floating: _react.PropTypes.bool,
	
	  /** Shorthand for MessageHeader. */
	  header: _lib.customPropTypes.itemShorthand,
	
	  /** A message can be hidden. */
	  hidden: _react.PropTypes.bool,
	
	  /** A message can contain an icon. */
	  icon: _react.PropTypes.oneOfType([_lib.customPropTypes.itemShorthand, _react.PropTypes.bool]),
	
	  /** A message may be formatted to display information. */
	  info: _react.PropTypes.bool,
	
	  /** Array shorthand items for the MessageList. Mutually exclusive with children. */
	  list: _lib.customPropTypes.collectionShorthand,
	
	  /** A message may be formatted to display a negative message. Same as `error`. */
	  negative: _react.PropTypes.bool,
	
	  /**
	   * A message that the user can choose to hide.
	   * Called when the user clicks the "x" icon. This also adds the "x" icon.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onDismiss: _react.PropTypes.func,
	
	  /** A message may be formatted to display a positive message.  Same as `success`. */
	  positive: _react.PropTypes.bool,
	
	  /** A message may be formatted to display a positive message.  Same as `positive`. */
	  success: _react.PropTypes.bool,
	
	  /** A message can have different sizes. */
	  size: _react.PropTypes.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'medium')),
	
	  /** A message can be set to visible to force itself to be shown. */
	  visible: _react.PropTypes.bool,
	
	  /** A message may be formatted to display warning messages. */
	  warning: _react.PropTypes.bool
	} : void 0;
	Message.handledProps = ['as', 'attached', 'children', 'className', 'color', 'compact', 'content', 'error', 'floating', 'header', 'hidden', 'icon', 'info', 'list', 'negative', 'onDismiss', 'positive', 'size', 'success', 'visible', 'warning'];

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A message can contain a content.
	 */
	function MessageContent(props) {
	  var children = props.children,
	      className = props.className;
	
	  var classes = (0, _classnames2.default)('content', className);
	  var rest = (0, _lib.getUnhandledProps)(MessageContent, props);
	  var ElementType = (0, _lib.getElementType)(MessageContent, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	MessageContent.handledProps = ['as', 'children', 'className'];
	MessageContent._meta = {
	  name: 'MessageContent',
	  parent: 'Message',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	 false ? MessageContent.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string
	} : void 0;
	
	exports.default = MessageContent;

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A message can contain a header.
	 */
	function MessageHeader(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('header', className);
	  var rest = (0, _lib.getUnhandledProps)(MessageHeader, props);
	  var ElementType = (0, _lib.getElementType)(MessageHeader, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _isNil3.default)(children) ? content : children
	  );
	}
	
	MessageHeader.handledProps = ['as', 'children', 'className', 'content'];
	MessageHeader._meta = {
	  name: 'MessageHeader',
	  parent: 'Message',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	 false ? MessageHeader.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.itemShorthand
	} : void 0;
	
	MessageHeader.create = (0, _lib.createShorthandFactory)(MessageHeader, function (val) {
	  return { content: val };
	});
	
	exports.default = MessageHeader;

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _map2 = __webpack_require__(702);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _MessageItem = __webpack_require__(833);
	
	var _MessageItem2 = _interopRequireDefault(_MessageItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A message can contain a list of items.
	 */
	function MessageList(props) {
	  var children = props.children,
	      className = props.className,
	      items = props.items;
	
	  var classes = (0, _classnames2.default)('list', className);
	  var rest = (0, _lib.getUnhandledProps)(MessageList, props);
	  var ElementType = (0, _lib.getElementType)(MessageList, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _isNil3.default)(children) ? (0, _map3.default)(items, _MessageItem2.default.create) : children
	  );
	}
	
	MessageList.handledProps = ['as', 'children', 'className', 'items'];
	MessageList._meta = {
	  name: 'MessageList',
	  parent: 'Message',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	 false ? MessageList.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand Message.Items. */
	  items: _lib.customPropTypes.collectionShorthand
	} : void 0;
	
	MessageList.defaultProps = {
	  as: 'ul'
	};
	
	MessageList.create = (0, _lib.createShorthandFactory)(MessageList, function (val) {
	  return { items: val };
	});
	
	exports.default = MessageList;

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A message list can contain an item.
	 */
	function MessageItem(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('content', className);
	  var rest = (0, _lib.getUnhandledProps)(MessageItem, props);
	  var ElementType = (0, _lib.getElementType)(MessageItem, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _isNil3.default)(children) ? content : children
	  );
	}
	
	MessageItem.handledProps = ['as', 'children', 'className', 'content'];
	MessageItem._meta = {
	  name: 'MessageItem',
	  parent: 'Message',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	 false ? MessageItem.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.itemShorthand
	} : void 0;
	
	MessageItem.defaultProps = {
	  as: 'li'
	};
	
	MessageItem.create = (0, _lib.createShorthandFactory)(MessageItem, function (content) {
	  return { content: content };
	}, true);
	
	exports.default = MessageItem;

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Table = __webpack_require__(835);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Table2.default;

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(723);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _map2 = __webpack_require__(702);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _TableBody = __webpack_require__(836);
	
	var _TableBody2 = _interopRequireDefault(_TableBody);
	
	var _TableCell = __webpack_require__(837);
	
	var _TableCell2 = _interopRequireDefault(_TableCell);
	
	var _TableFooter = __webpack_require__(838);
	
	var _TableFooter2 = _interopRequireDefault(_TableFooter);
	
	var _TableHeader = __webpack_require__(839);
	
	var _TableHeader2 = _interopRequireDefault(_TableHeader);
	
	var _TableHeaderCell = __webpack_require__(840);
	
	var _TableHeaderCell2 = _interopRequireDefault(_TableHeaderCell);
	
	var _TableRow = __webpack_require__(841);
	
	var _TableRow2 = _interopRequireDefault(_TableRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A table displays a collections of data grouped into rows.
	 */
	function Table(props) {
	  var attached = props.attached,
	      basic = props.basic,
	      celled = props.celled,
	      children = props.children,
	      className = props.className,
	      collapsing = props.collapsing,
	      color = props.color,
	      columns = props.columns,
	      compact = props.compact,
	      definition = props.definition,
	      fixed = props.fixed,
	      footerRow = props.footerRow,
	      headerRow = props.headerRow,
	      inverted = props.inverted,
	      padded = props.padded,
	      renderBodyRow = props.renderBodyRow,
	      selectable = props.selectable,
	      singleLine = props.singleLine,
	      size = props.size,
	      sortable = props.sortable,
	      stackable = props.stackable,
	      striped = props.striped,
	      structured = props.structured,
	      tableData = props.tableData,
	      unstackable = props.unstackable;
	
	
	  var classes = (0, _classnames2.default)('ui', color, size, (0, _lib.useKeyOnly)(celled, 'celled'), (0, _lib.useKeyOnly)(collapsing, 'collapsing'), (0, _lib.useKeyOnly)(definition, 'definition'), (0, _lib.useKeyOnly)(fixed, 'fixed'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(selectable, 'selectable'), (0, _lib.useKeyOnly)(singleLine, 'single line'), (0, _lib.useKeyOnly)(sortable, 'sortable'), (0, _lib.useKeyOnly)(stackable, 'stackable'), (0, _lib.useKeyOnly)(striped, 'striped'), (0, _lib.useKeyOnly)(structured, 'structured'), (0, _lib.useKeyOnly)(unstackable, 'unstackable'), (0, _lib.useKeyOrValueAndKey)(attached, 'attached'), (0, _lib.useKeyOrValueAndKey)(basic, 'basic'), (0, _lib.useKeyOrValueAndKey)(compact, 'compact'), (0, _lib.useKeyOrValueAndKey)(padded, 'padded'), (0, _lib.useWidthProp)(columns, 'column'), 'table', className);
	  var rest = (0, _lib.getUnhandledProps)(Table, props);
	  var ElementType = (0, _lib.getElementType)(Table, props);
	
	  if (!(0, _isNil3.default)(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    headerRow && _react2.default.createElement(
	      _TableHeader2.default,
	      null,
	      _TableRow2.default.create(headerRow, { cellAs: 'th' })
	    ),
	    _react2.default.createElement(
	      _TableBody2.default,
	      null,
	      renderBodyRow && (0, _map3.default)(tableData, function (data, index) {
	        return _TableRow2.default.create(renderBodyRow(data, index));
	      })
	    ),
	    footerRow && _react2.default.createElement(
	      _TableFooter2.default,
	      null,
	      _TableRow2.default.create(footerRow)
	    )
	  );
	}
	
	Table.handledProps = ['as', 'attached', 'basic', 'celled', 'children', 'className', 'collapsing', 'color', 'columns', 'compact', 'definition', 'fixed', 'footerRow', 'headerRow', 'inverted', 'padded', 'renderBodyRow', 'selectable', 'singleLine', 'size', 'sortable', 'stackable', 'striped', 'structured', 'tableData', 'unstackable'];
	Table._meta = {
	  name: 'Table',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	Table.defaultProps = {
	  as: 'table'
	};
	
	 false ? Table.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Attach table to other content */
	  attached: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.oneOf(['top', 'bottom'])]),
	
	  /** A table can reduce its complexity to increase readability. */
	  basic: _react.PropTypes.oneOfType([_react.PropTypes.oneOf(['very']), _react.PropTypes.bool]),
	
	  /** A table may be divided each row into separate cells. */
	  celled: _react.PropTypes.bool,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** A table can be collapsing, taking up only as much space as its rows. */
	  collapsing: _react.PropTypes.bool,
	
	  /** A table can be given a color to distinguish it from other tables. */
	  color: _react.PropTypes.oneOf(_lib.SUI.COLORS),
	
	  /** A table can specify its column count to divide its content evenly. */
	  columns: _react.PropTypes.oneOf(_lib.SUI.WIDTHS),
	
	  /** A table may sometimes need to be more compact to make more rows visible at a time. */
	  compact: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.oneOf(['very'])]),
	
	  /** A table may be formatted to emphasize a first column that defines a rows content. */
	  definition: _react.PropTypes.bool,
	
	  /**
	   * A table can use fixed a special faster form of table rendering that does not resize table cells based on content
	   */
	  fixed: _react.PropTypes.bool,
	
	  /** Shorthand for a TableRow to be placed within Table.Footer. */
	  footerRow: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for a TableRow to be placed within Table.Header. */
	  headerRow: _lib.customPropTypes.itemShorthand,
	
	  /** A table's colors can be inverted. */
	  inverted: _react.PropTypes.bool,
	
	  /** A table may sometimes need to be more padded for legibility. */
	  padded: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.oneOf(['very'])]),
	
	  /**
	   * A function that takes (data, index) and returns shorthand for a TableRow
	   * to be placed within Table.Body.
	   */
	  renderBodyRow: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['children']), _lib.customPropTypes.demand(['tableData']), _react.PropTypes.func]),
	
	  /** A table can have its rows appear selectable. */
	  selectable: _react.PropTypes.bool,
	
	  /** A table can specify that its cell contents should remain on a single line and not wrap. */
	  singleLine: _react.PropTypes.bool,
	
	  /** A table can also be small or large. */
	  size: _react.PropTypes.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'mini', 'tiny', 'medium', 'big', 'huge', 'massive')),
	
	  /** A table may allow a user to sort contents by clicking on a table header. */
	  sortable: _react.PropTypes.bool,
	
	  /** A table can specify how it stacks table content responsively. */
	  stackable: _react.PropTypes.bool,
	
	  /** A table can stripe alternate rows of content with a darker color to increase contrast. */
	  striped: _react.PropTypes.bool,
	
	  /** A table can be formatted to display complex structured data. */
	  structured: _react.PropTypes.bool,
	
	  /** Data to be passed to the renderBodyRow function. */
	  tableData: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['children']), _lib.customPropTypes.demand(['renderBodyRow']), _react.PropTypes.array]),
	
	  /** A table can specify how it stacks table content responsively. */
	  unstackable: _react.PropTypes.bool
	} : void 0;
	
	Table.Body = _TableBody2.default;
	Table.Cell = _TableCell2.default;
	Table.Footer = _TableFooter2.default;
	Table.Header = _TableHeader2.default;
	Table.HeaderCell = _TableHeaderCell2.default;
	Table.Row = _TableRow2.default;
	
	exports.default = Table;

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TableBody(props) {
	  var children = props.children,
	      className = props.className;
	
	  var classes = (0, _classnames2.default)(className);
	  var rest = (0, _lib.getUnhandledProps)(TableBody, props);
	  var ElementType = (0, _lib.getElementType)(TableBody, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	TableBody.handledProps = ['as', 'children', 'className'];
	TableBody._meta = {
	  name: 'TableBody',
	  type: _lib.META.TYPES.COLLECTION,
	  parent: 'Table'
	};
	
	TableBody.defaultProps = {
	  as: 'tbody'
	};
	
	 false ? TableBody.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string
	} : void 0;
	
	exports.default = TableBody;

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(723);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _Icon = __webpack_require__(750);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A table row can have cells.
	 */
	function TableCell(props) {
	  var active = props.active,
	      children = props.children,
	      className = props.className,
	      collapsing = props.collapsing,
	      content = props.content,
	      disabled = props.disabled,
	      error = props.error,
	      icon = props.icon,
	      negative = props.negative,
	      positive = props.positive,
	      selectable = props.selectable,
	      singleLine = props.singleLine,
	      textAlign = props.textAlign,
	      verticalAlign = props.verticalAlign,
	      warning = props.warning,
	      width = props.width;
	
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(collapsing, 'collapsing'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(error, 'error'), (0, _lib.useKeyOnly)(negative, 'negative'), (0, _lib.useKeyOnly)(positive, 'positive'), (0, _lib.useKeyOnly)(selectable, 'selectable'), (0, _lib.useKeyOnly)(singleLine, 'single line'), (0, _lib.useKeyOnly)(warning, 'warning'), (0, _lib.useTextAlignProp)(textAlign), (0, _lib.useVerticalAlignProp)(verticalAlign), (0, _lib.useWidthProp)(width, 'wide'), className);
	  var rest = (0, _lib.getUnhandledProps)(TableCell, props);
	  var ElementType = (0, _lib.getElementType)(TableCell, props);
	
	  if (!(0, _isNil3.default)(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _Icon2.default.create(icon),
	    content
	  );
	}
	
	TableCell.handledProps = ['active', 'as', 'children', 'className', 'collapsing', 'content', 'disabled', 'error', 'icon', 'negative', 'positive', 'selectable', 'singleLine', 'textAlign', 'verticalAlign', 'warning', 'width'];
	TableCell._meta = {
	  name: 'TableCell',
	  type: _lib.META.TYPES.COLLECTION,
	  parent: 'Table'
	};
	
	TableCell.defaultProps = {
	  as: 'td'
	};
	
	 false ? TableCell.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A cell can be active or selected by a user. */
	  active: _react.PropTypes.bool,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** A cell can be collapsing so that it only uses as much space as required. */
	  collapsing: _react.PropTypes.bool,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A cell can be disabled. */
	  disabled: _react.PropTypes.bool,
	
	  /** A cell may call attention to an error or a negative value. */
	  error: _react.PropTypes.bool,
	
	  /** Add an Icon by name, props object, or pass an <Icon /> */
	  icon: _lib.customPropTypes.itemShorthand,
	
	  /** A cell may let a user know whether a value is bad. */
	  negative: _react.PropTypes.bool,
	
	  /** A cell may let a user know whether a value is good. */
	  positive: _react.PropTypes.bool,
	
	  /** A cell can be selectable. */
	  selectable: _react.PropTypes.bool,
	
	  /** A cell can specify that its contents should remain on a single line and not wrap. */
	  singleLine: _react.PropTypes.bool,
	
	  /** A table cell can adjust its text alignment. */
	  textAlign: _react.PropTypes.oneOf((0, _without3.default)(_lib.SUI.TEXT_ALIGNMENTS, 'justified')),
	
	  /** A table cell can adjust its text alignment. */
	  verticalAlign: _react.PropTypes.oneOf(_lib.SUI.VERTICAL_ALIGNMENTS),
	
	  /** A cell may warn a user. */
	  warning: _react.PropTypes.bool,
	
	  /** A table can specify the width of individual columns independently. */
	  width: _react.PropTypes.oneOf(_lib.SUI.WIDTHS)
	} : void 0;
	
	TableCell.create = (0, _lib.createShorthandFactory)(TableCell, function (content) {
	  return { content: content };
	}, true);
	
	exports.default = TableCell;

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _TableHeader = __webpack_require__(839);
	
	var _TableHeader2 = _interopRequireDefault(_TableHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A table can have a footer.
	 */
	function TableFooter(props) {
	  return _react2.default.createElement(_TableHeader2.default, props);
	}
	
	TableFooter.handledProps = ['as'];
	TableFooter._meta = {
	  name: 'TableFooter',
	  type: _lib.META.TYPES.COLLECTION,
	  parent: 'Table'
	};
	
	TableFooter.defaultProps = {
	  as: 'tfoot'
	};
	
	exports.default = TableFooter;

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A table can have a header.
	 */
	function TableHeader(props) {
	  var children = props.children,
	      className = props.className,
	      fullWidth = props.fullWidth;
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(fullWidth, 'full-width'), className);
	  var rest = (0, _lib.getUnhandledProps)(TableHeader, props);
	  var ElementType = (0, _lib.getElementType)(TableHeader, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	TableHeader.handledProps = ['as', 'children', 'className', 'fullWidth'];
	TableHeader._meta = {
	  name: 'TableHeader',
	  type: _lib.META.TYPES.COLLECTION,
	  parent: 'Table'
	};
	
	TableHeader.defaultProps = {
	  as: 'thead'
	};
	
	 false ? TableHeader.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** A definition table can have a full width header or footer, filling in the gap left by the first column. */
	  fullWidth: _react.PropTypes.bool
	} : void 0;
	
	exports.default = TableHeader;

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _TableCell = __webpack_require__(837);
	
	var _TableCell2 = _interopRequireDefault(_TableCell);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A table can have a header cell.
	 */
	function TableHeaderCell(props) {
	  var as = props.as,
	      className = props.className,
	      sorted = props.sorted;
	
	  var classes = (0, _classnames2.default)((0, _lib.useValueAndKey)(sorted, 'sorted'), className);
	  var rest = (0, _lib.getUnhandledProps)(TableHeaderCell, props);
	
	  return _react2.default.createElement(_TableCell2.default, (0, _extends3.default)({}, rest, { as: as, className: classes }));
	}
	
	TableHeaderCell.handledProps = ['as', 'className', 'sorted'];
	TableHeaderCell._meta = {
	  name: 'TableHeaderCell',
	  type: _lib.META.TYPES.COLLECTION,
	  parent: 'Table'
	};
	
	 false ? TableHeaderCell.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** A header cell can be sorted in ascending or descending order. */
	  sorted: _react.PropTypes.oneOf(['ascending', 'descending'])
	} : void 0;
	
	TableHeaderCell.defaultProps = {
	  as: 'th'
	};
	
	exports.default = TableHeaderCell;

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(723);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _map2 = __webpack_require__(702);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _TableCell = __webpack_require__(837);
	
	var _TableCell2 = _interopRequireDefault(_TableCell);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A table can have rows.
	 */
	function TableRow(props) {
	  var active = props.active,
	      cellAs = props.cellAs,
	      cells = props.cells,
	      children = props.children,
	      className = props.className,
	      disabled = props.disabled,
	      error = props.error,
	      negative = props.negative,
	      positive = props.positive,
	      textAlign = props.textAlign,
	      verticalAlign = props.verticalAlign,
	      warning = props.warning;
	
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(error, 'error'), (0, _lib.useKeyOnly)(negative, 'negative'), (0, _lib.useKeyOnly)(positive, 'positive'), (0, _lib.useKeyOnly)(warning, 'warning'), (0, _lib.useTextAlignProp)(textAlign), (0, _lib.useVerticalAlignProp)(verticalAlign), className);
	  var rest = (0, _lib.getUnhandledProps)(TableRow, props);
	  var ElementType = (0, _lib.getElementType)(TableRow, props);
	
	  if (!(0, _isNil3.default)(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _map3.default)(cells, function (cell) {
	      return _TableCell2.default.create(cell, { as: cellAs });
	    })
	  );
	}
	
	TableRow.handledProps = ['active', 'as', 'cellAs', 'cells', 'children', 'className', 'disabled', 'error', 'negative', 'positive', 'textAlign', 'verticalAlign', 'warning'];
	TableRow._meta = {
	  name: 'TableRow',
	  type: _lib.META.TYPES.COLLECTION,
	  parent: 'Table'
	};
	
	TableRow.defaultProps = {
	  as: 'tr',
	  cellAs: 'td'
	};
	
	 false ? TableRow.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A row can be active or selected by a user. */
	  active: _react.PropTypes.bool,
	
	  /** An element type to render as (string or function). */
	  cellAs: _lib.customPropTypes.as,
	
	  /** Shorthand array of props for TableCell. */
	  cells: _lib.customPropTypes.collectionShorthand,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** A row can be disabled. */
	  disabled: _react.PropTypes.bool,
	
	  /** A row may call attention to an error or a negative value. */
	  error: _react.PropTypes.bool,
	
	  /** A row may let a user know whether a value is bad. */
	  negative: _react.PropTypes.bool,
	
	  /** A row may let a user know whether a value is good. */
	  positive: _react.PropTypes.bool,
	
	  /** A table row can adjust its text alignment. */
	  textAlign: _react.PropTypes.oneOf((0, _without3.default)(_lib.SUI.TEXT_ALIGNMENTS, 'justified')),
	
	  /** A table row can adjust its vertical alignment. */
	  verticalAlign: _react.PropTypes.oneOf(_lib.SUI.VERTICAL_ALIGNMENTS),
	
	  /** A row may warn a user. */
	  warning: _react.PropTypes.bool
	} : void 0;
	
	TableRow.create = (0, _lib.createShorthandFactory)(TableRow, function (cells) {
	  return { cells: cells };
	}, true);
	
	exports.default = TableRow;

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Container = __webpack_require__(843);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Container2.default;

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A container limits content to a maximum width.
	 */
	function Container(props) {
	  var children = props.children,
	      className = props.className,
	      fluid = props.fluid,
	      text = props.text,
	      textAlign = props.textAlign;
	
	  var classes = (0, _classnames2.default)('ui', (0, _lib.useKeyOnly)(text, 'text'), (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useTextAlignProp)(textAlign), 'container', className);
	  var rest = (0, _lib.getUnhandledProps)(Container, props);
	  var ElementType = (0, _lib.getElementType)(Container, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	Container.handledProps = ['as', 'children', 'className', 'fluid', 'text', 'textAlign'];
	Container._meta = {
	  name: 'Container',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	 false ? Container.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Container has no maximum with. */
	  fluid: _react.PropTypes.bool,
	
	  /** Reduce maximum width to more naturally accommodate text. */
	  text: _react.PropTypes.bool,
	
	  /** Align container text. */
	  textAlign: _react.PropTypes.oneOf(_lib.SUI.TEXT_ALIGNMENTS)
	} : void 0;
	
	exports.default = Container;

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Divider = __webpack_require__(845);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Divider2.default;

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A divider visually segments content into groups.
	 */
	function Divider(props) {
	  var children = props.children,
	      className = props.className,
	      clearing = props.clearing,
	      fitted = props.fitted,
	      hidden = props.hidden,
	      horizontal = props.horizontal,
	      inverted = props.inverted,
	      section = props.section,
	      vertical = props.vertical;
	
	
	  var classes = (0, _classnames2.default)('ui', (0, _lib.useKeyOnly)(clearing, 'clearing'), (0, _lib.useKeyOnly)(fitted, 'fitted'), (0, _lib.useKeyOnly)(hidden, 'hidden'), (0, _lib.useKeyOnly)(horizontal, 'horizontal'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(section, 'section'), (0, _lib.useKeyOnly)(vertical, 'vertical'), 'divider', className);
	  var rest = (0, _lib.getUnhandledProps)(Divider, props);
	  var ElementType = (0, _lib.getElementType)(Divider, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	Divider.handledProps = ['as', 'children', 'className', 'clearing', 'fitted', 'hidden', 'horizontal', 'inverted', 'section', 'vertical'];
	Divider._meta = {
	  name: 'Divider',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	 false ? Divider.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Divider can clear the content above it. */
	  clearing: _react.PropTypes.bool,
	
	  /** Divider can be fitted without any space above or below it. */
	  fitted: _react.PropTypes.bool,
	
	  /** Divider can divide content without creating a dividing line. */
	  hidden: _react.PropTypes.bool,
	
	  /** Divider can segment content horizontally. */
	  horizontal: _react.PropTypes.bool,
	
	  /** Divider can have it's colours inverted. */
	  inverted: _react.PropTypes.bool,
	
	  /** Divider can provide greater margins to divide sections of content. */
	  section: _react.PropTypes.bool,
	
	  /** Divider can segment content vertically. */
	  vertical: _react.PropTypes.bool
	} : void 0;
	
	exports.default = Divider;

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Header = __webpack_require__(847);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Header2.default;

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(723);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _Icon = __webpack_require__(750);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Image = __webpack_require__(780);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _HeaderSubheader = __webpack_require__(848);
	
	var _HeaderSubheader2 = _interopRequireDefault(_HeaderSubheader);
	
	var _HeaderContent = __webpack_require__(849);
	
	var _HeaderContent2 = _interopRequireDefault(_HeaderContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A header provides a short summary of content
	 */
	function Header(props) {
	  var attached = props.attached,
	      block = props.block,
	      children = props.children,
	      className = props.className,
	      color = props.color,
	      content = props.content,
	      disabled = props.disabled,
	      dividing = props.dividing,
	      floated = props.floated,
	      icon = props.icon,
	      image = props.image,
	      inverted = props.inverted,
	      size = props.size,
	      sub = props.sub,
	      subheader = props.subheader,
	      textAlign = props.textAlign;
	
	
	  var classes = (0, _classnames2.default)('ui', color, size, (0, _lib.useKeyOnly)(block, 'block'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(dividing, 'dividing'), (0, _lib.useValueAndKey)(floated, 'floated'), (0, _lib.useKeyOnly)(icon === true, 'icon'), (0, _lib.useKeyOnly)(image === true, 'image'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(sub, 'sub'), (0, _lib.useKeyOrValueAndKey)(attached, 'attached'), (0, _lib.useTextAlignProp)(textAlign), 'header', className);
	  var rest = (0, _lib.getUnhandledProps)(Header, props);
	  var ElementType = (0, _lib.getElementType)(Header, props);
	
	  if (!(0, _isNil3.default)(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  var iconElement = _Icon2.default.create(icon);
	  var imageElement = _Image2.default.create(image);
	  var subheaderElement = _HeaderSubheader2.default.create(subheader);
	
	  if (iconElement || imageElement) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      iconElement || imageElement,
	      (content || subheaderElement) && _react2.default.createElement(
	        _HeaderContent2.default,
	        null,
	        content,
	        subheaderElement
	      )
	    );
	  }
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    content,
	    subheaderElement
	  );
	}
	
	Header.handledProps = ['as', 'attached', 'block', 'children', 'className', 'color', 'content', 'disabled', 'dividing', 'floated', 'icon', 'image', 'inverted', 'size', 'sub', 'subheader', 'textAlign'];
	Header._meta = {
	  name: 'Header',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	 false ? Header.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Attach header  to other content, like a segment. */
	  attached: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.oneOf(['top', 'bottom'])]),
	
	  /** Format header to appear inside a content block. */
	  block: _react.PropTypes.bool,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Color of the header. */
	  color: _react.PropTypes.oneOf(_lib.SUI.COLORS),
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Show that the header is inactive. */
	  disabled: _react.PropTypes.bool,
	
	  /** Divide header from the content below it. */
	  dividing: _react.PropTypes.bool,
	
	  /** Header can sit to the left or right of other content. */
	  floated: _react.PropTypes.oneOf(_lib.SUI.FLOATS),
	
	  /** Add an icon by icon name or pass an Icon. */
	  icon: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['image']), _react.PropTypes.oneOfType([_react.PropTypes.bool, _lib.customPropTypes.itemShorthand])]),
	
	  /** Add an image by img src or pass an Image. */
	  image: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['icon']), _react.PropTypes.oneOfType([_react.PropTypes.bool, _lib.customPropTypes.itemShorthand])]),
	
	  /** Inverts the color of the header for dark backgrounds. */
	  inverted: _react.PropTypes.bool,
	
	  /** Content headings are sized with em and are based on the font-size of their container. */
	  size: _react.PropTypes.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'big', 'massive')),
	
	  /** Headers may be formatted to label smaller or de-emphasized content. */
	  sub: _react.PropTypes.bool,
	
	  /** Shorthand for Header.Subheader. */
	  subheader: _lib.customPropTypes.itemShorthand,
	
	  /** Align header content. */
	  textAlign: _react.PropTypes.oneOf(_lib.SUI.TEXT_ALIGNMENTS)
	} : void 0;
	
	Header.Content = _HeaderContent2.default;
	Header.Subheader = _HeaderSubheader2.default;
	
	exports.default = Header;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Headers may contain subheaders.
	 */
	function HeaderSubheader(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('sub header', className);
	  var rest = (0, _lib.getUnhandledProps)(HeaderSubheader, props);
	  var ElementType = (0, _lib.getElementType)(HeaderSubheader, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _isNil3.default)(children) ? content : children
	  );
	}
	
	HeaderSubheader.handledProps = ['as', 'children', 'className', 'content'];
	HeaderSubheader._meta = {
	  name: 'HeaderSubheader',
	  parent: 'Header',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	 false ? HeaderSubheader.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : void 0;
	
	HeaderSubheader.create = (0, _lib.createShorthandFactory)(HeaderSubheader, function (content) {
	  return { content: content };
	});
	
	exports.default = HeaderSubheader;

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Header content wraps the main content when there is an adjacent Icon or Image.
	 */
	function HeaderContent(props) {
	  var children = props.children,
	      className = props.className;
	
	  var classes = (0, _classnames2.default)('content', className);
	  var rest = (0, _lib.getUnhandledProps)(HeaderContent, props);
	  var ElementType = (0, _lib.getElementType)(HeaderContent, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	HeaderContent.handledProps = ['as', 'children', 'className'];
	HeaderContent._meta = {
	  name: 'HeaderContent',
	  parent: 'Header',
	  type: _lib.META.TYPES.VIEW
	};
	
	 false ? HeaderContent.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string
	} : void 0;
	
	exports.default = HeaderContent;

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _List = __webpack_require__(851);
	
	var _List2 = _interopRequireDefault(_List);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _List2.default;

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _map2 = __webpack_require__(702);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _ListContent = __webpack_require__(852);
	
	var _ListContent2 = _interopRequireDefault(_ListContent);
	
	var _ListDescription = __webpack_require__(853);
	
	var _ListDescription2 = _interopRequireDefault(_ListDescription);
	
	var _ListHeader = __webpack_require__(854);
	
	var _ListHeader2 = _interopRequireDefault(_ListHeader);
	
	var _ListIcon = __webpack_require__(855);
	
	var _ListIcon2 = _interopRequireDefault(_ListIcon);
	
	var _ListItem = __webpack_require__(856);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _ListList = __webpack_require__(857);
	
	var _ListList2 = _interopRequireDefault(_ListList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A list groups related content.
	 */
	function List(props) {
	  var animated = props.animated,
	      bulleted = props.bulleted,
	      celled = props.celled,
	      children = props.children,
	      className = props.className,
	      divided = props.divided,
	      floated = props.floated,
	      horizontal = props.horizontal,
	      inverted = props.inverted,
	      items = props.items,
	      link = props.link,
	      ordered = props.ordered,
	      relaxed = props.relaxed,
	      selection = props.selection,
	      size = props.size,
	      verticalAlign = props.verticalAlign;
	
	
	  var classes = (0, _classnames2.default)('ui', size, (0, _lib.useKeyOnly)(animated, 'animated'), (0, _lib.useKeyOnly)(bulleted, 'bulleted'), (0, _lib.useKeyOnly)(celled, 'celled'), (0, _lib.useKeyOnly)(divided, 'divided'), (0, _lib.useKeyOnly)(horizontal, 'horizontal'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(link, 'link'), (0, _lib.useKeyOnly)(ordered, 'ordered'), (0, _lib.useKeyOnly)(selection, 'selection'), (0, _lib.useKeyOrValueAndKey)(relaxed, 'relaxed'), (0, _lib.useValueAndKey)(floated, 'floated'), (0, _lib.useVerticalAlignProp)(verticalAlign), 'list', className);
	  var rest = (0, _lib.getUnhandledProps)(List, props);
	  var ElementType = (0, _lib.getElementType)(List, props);
	
	  if (!(0, _isNil3.default)(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { role: 'list', className: classes }),
	      children
	    );
	  }
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { role: 'list', className: classes }),
	    (0, _map3.default)(items, function (item) {
	      return _ListItem2.default.create(item);
	    })
	  );
	}
	
	List.handledProps = ['animated', 'as', 'bulleted', 'celled', 'children', 'className', 'divided', 'floated', 'horizontal', 'inverted', 'items', 'link', 'ordered', 'relaxed', 'selection', 'size', 'verticalAlign'];
	List._meta = {
	  name: 'List',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	 false ? List.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A list can animate to set the current item apart from the list. */
	  animated: _react.PropTypes.bool,
	
	  /** A list can mark items with a bullet. */
	  bulleted: _react.PropTypes.bool,
	
	  /** A list can divide its items into cells. */
	  celled: _react.PropTypes.bool,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** A list can show divisions between content. */
	  divided: _react.PropTypes.bool,
	
	  /** An list can be floated left or right. */
	  floated: _react.PropTypes.oneOf(_lib.SUI.FLOATS),
	
	  /** A list can be formatted to have items appear horizontally. */
	  horizontal: _react.PropTypes.bool,
	
	  /** A list can be inverted to appear on a dark background. */
	  inverted: _react.PropTypes.bool,
	
	  /** Shorthand array of props for ListItem. */
	  items: _lib.customPropTypes.collectionShorthand,
	
	  /** A list can be specially formatted for navigation links. */
	  link: _react.PropTypes.bool,
	
	  /** A list can be ordered numerically. */
	  ordered: _react.PropTypes.bool,
	
	  /** A list can relax its padding to provide more negative space. */
	  relaxed: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.oneOf(['very'])]),
	
	  /** A selection list formats list items as possible choices. */
	  selection: _react.PropTypes.bool,
	
	  /** A list can vary in size. */
	  size: _react.PropTypes.oneOf(_lib.SUI.SIZES),
	
	  /** An element inside a list can be vertically aligned. */
	  verticalAlign: _react.PropTypes.oneOf(_lib.SUI.VERTICAL_ALIGNMENTS)
	} : void 0;
	
	List.Content = _ListContent2.default;
	List.Description = _ListDescription2.default;
	List.Header = _ListHeader2.default;
	List.Icon = _ListIcon2.default;
	List.Item = _ListItem2.default;
	List.List = _ListList2.default;
	
	exports.default = List;

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _ListDescription = __webpack_require__(853);
	
	var _ListDescription2 = _interopRequireDefault(_ListDescription);
	
	var _ListHeader = __webpack_require__(854);
	
	var _ListHeader2 = _interopRequireDefault(_ListHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A list item can contain a content.
	 */
	function ListContent(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      description = props.description,
	      floated = props.floated,
	      header = props.header,
	      verticalAlign = props.verticalAlign;
	
	
	  var classes = (0, _classnames2.default)((0, _lib.useValueAndKey)(floated, 'floated'), (0, _lib.useVerticalAlignProp)(verticalAlign), 'content', className);
	  var rest = (0, _lib.getUnhandledProps)(ListContent, props);
	  var ElementType = (0, _lib.getElementType)(ListContent, props);
	
	  if (!(0, _isNil3.default)(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _ListHeader2.default.create(header),
	    _ListDescription2.default.create(description),
	    content
	  );
	}
	
	ListContent.handledProps = ['as', 'children', 'className', 'content', 'description', 'floated', 'header', 'verticalAlign'];
	ListContent._meta = {
	  name: 'ListContent',
	  parent: 'List',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	 false ? ListContent.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Shorthand for ListDescription. */
	  description: _lib.customPropTypes.itemShorthand,
	
	  /** An list content can be floated left or right. */
	  floated: _react.PropTypes.oneOf(_lib.SUI.FLOATS),
	
	  /** Shorthand for ListHeader. */
	  header: _lib.customPropTypes.itemShorthand,
	
	  /** An element inside a list can be vertically aligned. */
	  verticalAlign: _react.PropTypes.oneOf(_lib.SUI.VERTICAL_ALIGNMENTS)
	} : void 0;
	
	ListContent.create = (0, _lib.createShorthandFactory)(ListContent, function (content) {
	  return { content: content };
	});
	
	exports.default = ListContent;

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A list item can contain a description.
	 */
	function ListDescription(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)(className, 'description');
	  var rest = (0, _lib.getUnhandledProps)(ListDescription, props);
	  var ElementType = (0, _lib.getElementType)(ListDescription, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _isNil3.default)(children) ? content : children
	  );
	}
	
	ListDescription.handledProps = ['as', 'children', 'className', 'content'];
	ListDescription._meta = {
	  name: 'ListDescription',
	  parent: 'List',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	 false ? ListDescription.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : void 0;
	
	ListDescription.create = (0, _lib.createShorthandFactory)(ListDescription, function (content) {
	  return { content: content };
	});
	
	exports.default = ListDescription;

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A list item can contain a header.
	 */
	function ListHeader(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('header', className);
	  var rest = (0, _lib.getUnhandledProps)(ListHeader, props);
	  var ElementType = (0, _lib.getElementType)(ListHeader, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _isNil3.default)(children) ? content : children
	  );
	}
	
	ListHeader.handledProps = ['as', 'children', 'className', 'content'];
	ListHeader._meta = {
	  name: 'ListHeader',
	  parent: 'List',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	 false ? ListHeader.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : void 0;
	
	ListHeader.create = (0, _lib.createShorthandFactory)(ListHeader, function (content) {
	  return { content: content };
	});
	
	exports.default = ListHeader;

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _Icon = __webpack_require__(722);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A list item can contain an icon.
	 */
	function ListIcon(props) {
	  var className = props.className,
	      verticalAlign = props.verticalAlign;
	
	  var classes = (0, _classnames2.default)((0, _lib.useVerticalAlignProp)(verticalAlign), className);
	  var rest = (0, _lib.getUnhandledProps)(ListIcon, props);
	
	  return _react2.default.createElement(_Icon2.default, (0, _extends3.default)({}, rest, { className: classes }));
	}
	
	ListIcon.handledProps = ['className', 'verticalAlign'];
	ListIcon._meta = {
	  name: 'ListIcon',
	  parent: 'List',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	 false ? ListIcon.propTypes = {
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** An element inside a list can be vertically aligned. */
	  verticalAlign: _react.PropTypes.oneOf(_lib.SUI.VERTICAL_ALIGNMENTS)
	} : void 0;
	
	ListIcon.create = (0, _lib.createShorthandFactory)(ListIcon, function (name) {
	  return { name: name };
	});
	
	exports.default = ListIcon;

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isPlainObject2 = __webpack_require__(456);
	
	var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _Image = __webpack_require__(780);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _ListContent = __webpack_require__(852);
	
	var _ListContent2 = _interopRequireDefault(_ListContent);
	
	var _ListDescription = __webpack_require__(853);
	
	var _ListDescription2 = _interopRequireDefault(_ListDescription);
	
	var _ListHeader = __webpack_require__(854);
	
	var _ListHeader2 = _interopRequireDefault(_ListHeader);
	
	var _ListIcon = __webpack_require__(855);
	
	var _ListIcon2 = _interopRequireDefault(_ListIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A list item can contain a set of items.
	 */
	function ListItem(props) {
	  var active = props.active,
	      children = props.children,
	      className = props.className,
	      content = props.content,
	      description = props.description,
	      disabled = props.disabled,
	      header = props.header,
	      icon = props.icon,
	      image = props.image,
	      value = props.value;
	
	
	  var ElementType = (0, _lib.getElementType)(ListItem, props);
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(ElementType !== 'li', 'item'), className);
	  var rest = (0, _lib.getUnhandledProps)(ListItem, props);
	  var valueProp = ElementType === 'li' ? { value: value } : { 'data-value': value };
	
	  if (!(0, _isNil3.default)(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, valueProp, { role: 'listitem', className: classes }),
	      children
	    );
	  }
	
	  var iconElement = _ListIcon2.default.create(icon);
	  var imageElement = _Image2.default.create(image);
	
	  // See description of `content` prop for explanation about why this is necessary.
	  if (!(0, _react.isValidElement)(content) && (0, _isPlainObject3.default)(content)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, valueProp, { role: 'listitem', className: classes }),
	      iconElement || imageElement,
	      _ListContent2.default.create(content, { header: header, description: description })
	    );
	  }
	
	  var headerElement = _ListHeader2.default.create(header);
	  var descriptionElement = _ListDescription2.default.create(description);
	
	  if (iconElement || imageElement) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, valueProp, { role: 'listitem', className: classes }),
	      iconElement || imageElement,
	      (content || headerElement || descriptionElement) && _react2.default.createElement(
	        _ListContent2.default,
	        null,
	        headerElement,
	        descriptionElement,
	        content
	      )
	    );
	  }
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, valueProp, { role: 'listitem', className: classes }),
	    headerElement,
	    descriptionElement,
	    content
	  );
	}
	
	ListItem.handledProps = ['active', 'as', 'children', 'className', 'content', 'description', 'disabled', 'header', 'icon', 'image', 'value'];
	ListItem._meta = {
	  name: 'ListItem',
	  parent: 'List',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	 false ? ListItem.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A list item can active. */
	  active: _react.PropTypes.bool,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /**
	   * Shorthand for primary content.
	   *
	   * Heads up!
	   *
	   * This is handled slightly differently than the typical `content` prop since
	   * the wrapping ListContent is not used when there's no icon or image.
	   *
	   * If you pass content as:
	   * - an element/literal, it's treated as the sibling node to
	   * header/description (whether wrapped in Item.Content or not).
	   * - a props object, it forces the presence of Item.Content and passes those
	   * props to it. If you pass a content prop within that props object, it
	   * will be treated as the sibling node to header/description.
	   */
	  content: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for ListDescription. */
	  description: _lib.customPropTypes.itemShorthand,
	
	  /** A list item can disabled. */
	  disabled: _react.PropTypes.bool,
	
	  /** Shorthand for ListHeader. */
	  header: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for ListIcon. */
	  icon: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['image']), _lib.customPropTypes.itemShorthand]),
	
	  /** Shorthand for Image. */
	  image: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['icon']), _lib.customPropTypes.itemShorthand]),
	
	  /** A value for an ordered list. */
	  value: _react.PropTypes.string
	} : void 0;
	
	ListItem.create = (0, _lib.createShorthandFactory)(ListItem, function (content) {
	  return { content: content };
	}, true);
	
	exports.default = ListItem;

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A list can contain a sub list.
	 */
	function ListList(props) {
	  var children = props.children,
	      className = props.className;
	
	
	  var rest = (0, _lib.getUnhandledProps)(ListList, props);
	  var ElementType = (0, _lib.getElementType)(ListList, props);
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(ElementType !== 'ul' && ElementType !== 'ol', 'list'), className);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	ListList.handledProps = ['as', 'children', 'className'];
	ListList._meta = {
	  name: 'ListList',
	  parent: 'List',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	 false ? ListList.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string
	} : void 0;
	
	exports.default = ListList;

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Loader = __webpack_require__(859);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Loader2.default;

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A loader alerts a user to wait for an activity to complete.
	 * @see Dimmer
	 */
	function Loader(props) {
	  var active = props.active,
	      children = props.children,
	      className = props.className,
	      content = props.content,
	      disabled = props.disabled,
	      indeterminate = props.indeterminate,
	      inline = props.inline,
	      inverted = props.inverted,
	      size = props.size;
	
	
	  var classes = (0, _classnames2.default)('ui', size, (0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(indeterminate, 'indeterminate'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(children || content, 'text'), (0, _lib.useKeyOrValueAndKey)(inline, 'inline'), 'loader', className);
	  var rest = (0, _lib.getUnhandledProps)(Loader, props);
	  var ElementType = (0, _lib.getElementType)(Loader, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _isNil3.default)(children) ? content : children
	  );
	}
	
	Loader.handledProps = ['active', 'as', 'children', 'className', 'content', 'disabled', 'indeterminate', 'inline', 'inverted', 'size'];
	Loader._meta = {
	  name: 'Loader',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	 false ? Loader.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A loader can be active or visible. */
	  active: _react.PropTypes.bool,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A loader can be disabled or hidden. */
	  disabled: _react.PropTypes.bool,
	
	  /** A loader can show it's unsure of how long a task will take. */
	  indeterminate: _react.PropTypes.bool,
	
	  /** Loaders can appear inline with content. */
	  inline: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.oneOf(['centered'])]),
	
	  /** Loaders can have their colors inverted. */
	  inverted: _react.PropTypes.bool,
	
	  /** Loaders can have different sizes. */
	  size: _react.PropTypes.oneOf(_lib.SUI.SIZES)
	} : void 0;
	
	exports.default = Loader;

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Rail = __webpack_require__(861);
	
	var _Rail2 = _interopRequireDefault(_Rail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Rail2.default;

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(723);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A rail is used to show accompanying content outside the boundaries of the main view of a site.
	 */
	function Rail(props) {
	  var attached = props.attached,
	      children = props.children,
	      className = props.className,
	      close = props.close,
	      dividing = props.dividing,
	      internal = props.internal,
	      position = props.position,
	      size = props.size;
	
	
	  var classes = (0, _classnames2.default)('ui', position, size, (0, _lib.useKeyOnly)(attached, 'attached'), (0, _lib.useKeyOnly)(dividing, 'dividing'), (0, _lib.useKeyOnly)(internal, 'internal'), (0, _lib.useKeyOrValueAndKey)(close, 'close'), 'rail', className);
	  var rest = (0, _lib.getUnhandledProps)(Rail, props);
	  var ElementType = (0, _lib.getElementType)(Rail, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	Rail.handledProps = ['as', 'attached', 'children', 'className', 'close', 'dividing', 'internal', 'position', 'size'];
	Rail._meta = {
	  name: 'Rail',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	 false ? Rail.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A rail can appear attached to the main viewport. */
	  attached: _react.PropTypes.bool,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** A rail can appear closer to the main viewport. */
	  close: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.oneOf(['very'])]),
	
	  /** A rail can create a division between itself and a container. */
	  dividing: _react.PropTypes.bool,
	
	  /** A rail can attach itself to the inside of a container. */
	  internal: _react.PropTypes.bool,
	
	  /** A rail can be presented on the left or right side of a container. */
	  position: _react.PropTypes.oneOf(_lib.SUI.FLOATS).isRequired,
	
	  /** A rail can have different sizes. */
	  size: _react.PropTypes.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'medium'))
	} : void 0;
	
	exports.default = Rail;

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Reveal = __webpack_require__(863);
	
	var _Reveal2 = _interopRequireDefault(_Reveal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Reveal2.default;

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _RevealContent = __webpack_require__(864);
	
	var _RevealContent2 = _interopRequireDefault(_RevealContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A reveal displays additional content in place of previous content when activated.
	 */
	function Reveal(props) {
	  var active = props.active,
	      animated = props.animated,
	      children = props.children,
	      className = props.className,
	      disabled = props.disabled,
	      instant = props.instant;
	
	
	  var classes = (0, _classnames2.default)('ui', animated, (0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(instant, 'instant'), 'reveal', className);
	  var rest = (0, _lib.getUnhandledProps)(Reveal, props);
	  var ElementType = (0, _lib.getElementType)(Reveal, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	Reveal.handledProps = ['active', 'animated', 'as', 'children', 'className', 'disabled', 'instant'];
	Reveal._meta = {
	  name: 'Reveal',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	 false ? Reveal.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** An active reveal displays its hidden content. */
	  active: _react.PropTypes.bool,
	
	  /** An animation name that will be applied to Reveal. */
	  animated: _react.PropTypes.oneOf(['fade', 'small fade', 'move', 'move right', 'move up', 'move down', 'rotate', 'rotate left']),
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** A disabled reveal will not animate when hovered. */
	  disabled: _react.PropTypes.bool,
	
	  /** An element can show its content without delay. */
	  instant: _react.PropTypes.bool
	} : void 0;
	
	Reveal.Content = _RevealContent2.default;
	
	exports.default = Reveal;

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A content sub-component for the Reveal.
	 */
	function RevealContent(props) {
	  var children = props.children,
	      className = props.className,
	      hidden = props.hidden,
	      visible = props.visible;
	
	
	  var classes = (0, _classnames2.default)('ui', (0, _lib.useKeyOnly)(hidden, 'hidden'), (0, _lib.useKeyOnly)(visible, 'visible'), 'content', className);
	  var rest = (0, _lib.getUnhandledProps)(RevealContent, props);
	  var ElementType = (0, _lib.getElementType)(RevealContent, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	RevealContent.handledProps = ['as', 'children', 'className', 'hidden', 'visible'];
	RevealContent._meta = {
	  name: 'RevealContent',
	  parent: 'Reveal',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	 false ? RevealContent.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** A reveal may contain content that is visible before interaction. */
	  hidden: _react.PropTypes.bool,
	
	  /** A reveal may contain content that is hidden before user interaction. */
	  visible: _react.PropTypes.bool
	} : void 0;
	
	exports.default = RevealContent;

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Segment = __webpack_require__(866);
	
	var _Segment2 = _interopRequireDefault(_Segment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Segment2.default;

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(723);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _SegmentGroup = __webpack_require__(867);
	
	var _SegmentGroup2 = _interopRequireDefault(_SegmentGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A segment is used to create a grouping of related content.
	 */
	function Segment(props) {
	  var attached = props.attached,
	      basic = props.basic,
	      children = props.children,
	      circular = props.circular,
	      className = props.className,
	      clearing = props.clearing,
	      color = props.color,
	      compact = props.compact,
	      disabled = props.disabled,
	      floated = props.floated,
	      inverted = props.inverted,
	      loading = props.loading,
	      padded = props.padded,
	      piled = props.piled,
	      raised = props.raised,
	      secondary = props.secondary,
	      size = props.size,
	      stacked = props.stacked,
	      tertiary = props.tertiary,
	      textAlign = props.textAlign,
	      vertical = props.vertical;
	
	
	  var classes = (0, _classnames2.default)('ui', color, size, (0, _lib.useKeyOnly)(basic, 'basic'), (0, _lib.useKeyOnly)(circular, 'circular'), (0, _lib.useKeyOnly)(clearing, 'clearing'), (0, _lib.useKeyOnly)(compact, 'compact'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(loading, 'loading'), (0, _lib.useKeyOnly)(piled, 'piled'), (0, _lib.useKeyOnly)(raised, 'raised'), (0, _lib.useKeyOnly)(secondary, 'secondary'), (0, _lib.useKeyOnly)(stacked, 'stacked'), (0, _lib.useKeyOnly)(tertiary, 'tertiary'), (0, _lib.useKeyOnly)(vertical, 'vertical'), (0, _lib.useKeyOrValueAndKey)(attached, 'attached'), (0, _lib.useKeyOrValueAndKey)(padded, 'padded'), (0, _lib.useTextAlignProp)(textAlign), (0, _lib.useValueAndKey)(floated, 'floated'), 'segment', className);
	  var rest = (0, _lib.getUnhandledProps)(Segment, props);
	  var ElementType = (0, _lib.getElementType)(Segment, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	Segment.handledProps = ['as', 'attached', 'basic', 'children', 'circular', 'className', 'clearing', 'color', 'compact', 'disabled', 'floated', 'inverted', 'loading', 'padded', 'piled', 'raised', 'secondary', 'size', 'stacked', 'tertiary', 'textAlign', 'vertical'];
	Segment.Group = _SegmentGroup2.default;
	
	Segment._meta = {
	  name: 'Segment',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	 false ? Segment.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Attach segment to other content, like a header. */
	  attached: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.oneOf(['top', 'bottom'])]),
	
	  /** A basic segment has no special formatting. */
	  basic: _react.PropTypes.bool,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** A segment can be circular. */
	  circular: _react.PropTypes.bool,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** A segment can clear floated content. */
	  clearing: _react.PropTypes.bool,
	
	  /** Segment can be colored. */
	  color: _react.PropTypes.oneOf(_lib.SUI.COLORS),
	
	  /** A segment may take up only as much space as is necessary. */
	  compact: _react.PropTypes.bool,
	
	  /** A segment may show its content is disabled. */
	  disabled: _react.PropTypes.bool,
	
	  /** Segment content can be floated to the left or right. */
	  floated: _react.PropTypes.oneOf(_lib.SUI.FLOATS),
	
	  /** A segment can have its colors inverted for contrast. */
	  inverted: _react.PropTypes.bool,
	
	  /** A segment may show its content is being loaded. */
	  loading: _react.PropTypes.bool,
	
	  /** A segment can increase its padding. */
	  padded: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.oneOf(['very'])]),
	
	  /** Formatted to look like a pile of pages. */
	  piled: _react.PropTypes.bool,
	
	  /** A segment may be formatted to raise above the page. */
	  raised: _react.PropTypes.bool,
	
	  /** A segment can be formatted to appear less noticeable. */
	  secondary: _react.PropTypes.bool,
	
	  /** A segment can have different sizes. */
	  size: _react.PropTypes.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'medium')),
	
	  /** Formatted to show it contains multiple pages. */
	  stacked: _react.PropTypes.bool,
	
	  /** A segment can be formatted to appear even less noticeable. */
	  tertiary: _react.PropTypes.bool,
	
	  /** Formats content to be aligned as part of a vertical group. */
	  textAlign: _react.PropTypes.oneOf((0, _without3.default)(_lib.SUI.TEXT_ALIGNMENTS, 'justified')),
	
	  /** Formats content to be aligned vertically. */
	  vertical: _react.PropTypes.bool
	} : void 0;
	
	exports.default = Segment;

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(723);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A group of segments can be formatted to appear together.
	 */
	function SegmentGroup(props) {
	  var children = props.children,
	      className = props.className,
	      compact = props.compact,
	      horizontal = props.horizontal,
	      piled = props.piled,
	      raised = props.raised,
	      size = props.size,
	      stacked = props.stacked;
	
	
	  var classes = (0, _classnames2.default)('ui', size, (0, _lib.useKeyOnly)(compact, 'compact'), (0, _lib.useKeyOnly)(horizontal, 'horizontal'), (0, _lib.useKeyOnly)(piled, 'piled'), (0, _lib.useKeyOnly)(raised, 'raised'), (0, _lib.useKeyOnly)(stacked, 'stacked'), 'segments', className);
	  var rest = (0, _lib.getUnhandledProps)(SegmentGroup, props);
	  var ElementType = (0, _lib.getElementType)(SegmentGroup, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	SegmentGroup.handledProps = ['as', 'children', 'className', 'compact', 'horizontal', 'piled', 'raised', 'size', 'stacked'];
	SegmentGroup._meta = {
	  name: 'SegmentGroup',
	  parent: 'Segment',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	 false ? SegmentGroup.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** A segment may take up only as much space as is necessary. */
	  compact: _react.PropTypes.bool,
	
	  /** Formats content to be aligned horizontally. */
	  horizontal: _react.PropTypes.bool,
	
	  /** Formatted to look like a pile of pages. */
	  piled: _react.PropTypes.bool,
	
	  /** A segment group may be formatted to raise above the page. */
	  raised: _react.PropTypes.bool,
	
	  /** A segment group can have different sizes. */
	  size: _react.PropTypes.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'medium')),
	
	  /** Formatted to show it contains multiple pages. */
	  stacked: _react.PropTypes.bool
	} : void 0;
	
	exports.default = SegmentGroup;

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Step = __webpack_require__(869);
	
	var _Step2 = _interopRequireDefault(_Step);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Step2.default;

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(513);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(514);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(518);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(552);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _Icon = __webpack_require__(750);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _StepContent = __webpack_require__(870);
	
	var _StepContent2 = _interopRequireDefault(_StepContent);
	
	var _StepDescription = __webpack_require__(871);
	
	var _StepDescription2 = _interopRequireDefault(_StepDescription);
	
	var _StepGroup = __webpack_require__(873);
	
	var _StepGroup2 = _interopRequireDefault(_StepGroup);
	
	var _StepTitle = __webpack_require__(872);
	
	var _StepTitle2 = _interopRequireDefault(_StepTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A step shows the completion status of an activity in a series of activities.
	 */
	var Step = function (_Component) {
	  (0, _inherits3.default)(Step, _Component);
	
	  function Step() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Step);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Step.__proto__ || Object.getPrototypeOf(Step)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
	      var onClick = _this.props.onClick;
	
	
	      if (onClick) onClick(e, _this.props);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Step, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          className = _props.className,
	          completed = _props.completed,
	          description = _props.description,
	          disabled = _props.disabled,
	          href = _props.href,
	          icon = _props.icon,
	          link = _props.link,
	          onClick = _props.onClick,
	          title = _props.title;
	
	
	      var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(completed, 'completed'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(link, 'link'), 'step', className);
	      var rest = (0, _lib.getUnhandledProps)(Step, this.props);
	      var ElementType = (0, _lib.getElementType)(Step, this.props, function () {
	        if (onClick) return 'a';
	      });
	
	      if (!(0, _isNil3.default)(children)) {
	        return _react2.default.createElement(
	          ElementType,
	          (0, _extends3.default)({}, rest, { className: classes, href: href, onClick: this.handleClick }),
	          children
	        );
	      }
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes, href: href, onClick: this.handleClick }),
	        _Icon2.default.create(icon),
	        _react2.default.createElement(_StepContent2.default, { description: description, title: title })
	      );
	    }
	  }]);
	  return Step;
	}(_react.Component);
	
	Step._meta = {
	  name: 'Step',
	  type: _lib.META.TYPES.ELEMENT
	};
	Step.Content = _StepContent2.default;
	Step.Description = _StepDescription2.default;
	Step.Group = _StepGroup2.default;
	Step.Title = _StepTitle2.default;
	exports.default = Step;
	 false ? Step.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A step can be highlighted as active. */
	  active: _react.PropTypes.bool,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** A step can show that a user has completed it. */
	  completed: _react.PropTypes.bool,
	
	  /** Shorthand for StepDescription. */
	  description: _lib.customPropTypes.itemShorthand,
	
	  /** Show that the Loader is inactive. */
	  disabled: _react.PropTypes.bool,
	
	  /** Render as an `a` tag instead of a `div` and adds the href attribute. */
	  href: _react.PropTypes.string,
	
	  /** Shorthand for Icon. */
	  icon: _lib.customPropTypes.itemShorthand,
	
	  /** A step can be link. */
	  link: _react.PropTypes.bool,
	
	  /**
	   * Called on click. When passed, the component will render as an `a`
	   * tag by default instead of a `div`.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _react.PropTypes.func,
	
	  /** A step can show a ordered sequence of steps. Passed from StepGroup. */
	  ordered: _react.PropTypes.bool,
	
	  /** Shorthand for StepTitle. */
	  title: _lib.customPropTypes.itemShorthand
	} : void 0;
	Step.handledProps = ['active', 'as', 'children', 'className', 'completed', 'description', 'disabled', 'href', 'icon', 'link', 'onClick', 'ordered', 'title'];

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _StepDescription = __webpack_require__(871);
	
	var _StepDescription2 = _interopRequireDefault(_StepDescription);
	
	var _StepTitle = __webpack_require__(872);
	
	var _StepTitle2 = _interopRequireDefault(_StepTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A step can contain a content.
	 */
	function StepContent(props) {
	  var children = props.children,
	      className = props.className,
	      description = props.description,
	      title = props.title;
	
	  var classes = (0, _classnames2.default)('content', className);
	  var rest = (0, _lib.getUnhandledProps)(StepContent, props);
	  var ElementType = (0, _lib.getElementType)(StepContent, props);
	
	  if (!(0, _isNil3.default)(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _lib.createShorthand)(_StepTitle2.default, function (val) {
	      return { title: val };
	    }, title),
	    (0, _lib.createShorthand)(_StepDescription2.default, function (val) {
	      return { description: val };
	    }, description)
	  );
	}
	
	StepContent.handledProps = ['as', 'children', 'className', 'description', 'title'];
	StepContent._meta = {
	  name: 'StepContent',
	  parent: 'Step',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	 false ? StepContent.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Shorthand for StepDescription. */
	  description: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for StepTitle. */
	  title: _lib.customPropTypes.itemShorthand
	} : void 0;
	
	exports.default = StepContent;

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function StepDescription(props) {
	  var children = props.children,
	      className = props.className,
	      description = props.description;
	
	  var classes = (0, _classnames2.default)('description', className);
	  var rest = (0, _lib.getUnhandledProps)(StepDescription, props);
	  var ElementType = (0, _lib.getElementType)(StepDescription, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _isNil3.default)(children) ? description : children
	  );
	}
	
	StepDescription.handledProps = ['as', 'children', 'className', 'description'];
	StepDescription._meta = {
	  name: 'StepDescription',
	  parent: 'Step',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	 false ? StepDescription.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Shorthand for primary content. */
	  description: _lib.customPropTypes.contentShorthand
	} : void 0;
	
	exports.default = StepDescription;

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A step can contain a title.
	 */
	function StepTitle(props) {
	  var children = props.children,
	      className = props.className,
	      title = props.title;
	
	  var classes = (0, _classnames2.default)('title', className);
	  var rest = (0, _lib.getUnhandledProps)(StepTitle, props);
	  var ElementType = (0, _lib.getElementType)(StepTitle, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _isNil3.default)(children) ? title : children
	  );
	}
	
	StepTitle.handledProps = ['as', 'children', 'className', 'title'];
	StepTitle._meta = {
	  name: 'StepTitle',
	  parent: 'Step',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	 false ? StepTitle.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Shorthand for primary content. */
	  title: _lib.customPropTypes.contentShorthand
	} : void 0;
	
	exports.default = StepTitle;

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(723);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _map2 = __webpack_require__(702);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _Step = __webpack_require__(869);
	
	var _Step2 = _interopRequireDefault(_Step);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A set of steps.
	 */
	function StepGroup(props) {
	  var children = props.children,
	      className = props.className,
	      fluid = props.fluid,
	      items = props.items,
	      ordered = props.ordered,
	      size = props.size,
	      stackable = props.stackable,
	      vertical = props.vertical;
	
	  var classes = (0, _classnames2.default)('ui', size, (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(ordered, 'ordered'), (0, _lib.useKeyOnly)(vertical, 'vertical'), (0, _lib.useValueAndKey)(stackable, 'stackable'), 'steps', className);
	  var rest = (0, _lib.getUnhandledProps)(StepGroup, props);
	  var ElementType = (0, _lib.getElementType)(StepGroup, props);
	
	  if (!(0, _isNil3.default)(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  var content = (0, _map3.default)(items, function (item) {
	    var key = item.key || [item.title, item.description].join('-');
	    return _react2.default.createElement(_Step2.default, (0, _extends3.default)({ key: key }, item));
	  });
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    content
	  );
	}
	
	StepGroup.handledProps = ['as', 'children', 'className', 'fluid', 'items', 'ordered', 'size', 'stackable', 'vertical'];
	StepGroup._meta = {
	  name: 'StepGroup',
	  parent: 'Step',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	 false ? StepGroup.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** A fluid step takes up the width of its container. */
	  fluid: _react.PropTypes.bool,
	
	  /** Shorthand array of props for Step. */
	  items: _lib.customPropTypes.collectionShorthand,
	
	  /** A step can show a ordered sequence of steps. */
	  ordered: _react.PropTypes.bool,
	
	  /** Steps can have different sizes. */
	  size: _react.PropTypes.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'medium')),
	
	  /** A step can stack vertically only on smaller screens. */
	  stackable: _react.PropTypes.oneOf(['tablet']),
	
	  /** A step can be displayed stacked vertically. */
	  vertical: _react.PropTypes.bool
	} : void 0;
	
	exports.default = StepGroup;

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(519);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(607);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(513);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(514);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(518);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(552);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _keys2 = __webpack_require__(270);
	
	var _keys3 = _interopRequireDefault(_keys2);
	
	var _omit2 = __webpack_require__(743);
	
	var _omit3 = _interopRequireDefault(_omit2);
	
	var _each2 = __webpack_require__(582);
	
	var _each3 = _interopRequireDefault(_each2);
	
	var _has2 = __webpack_require__(560);
	
	var _has3 = _interopRequireDefault(_has2);
	
	var _without2 = __webpack_require__(723);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _includes2 = __webpack_require__(707);
	
	var _includes3 = _interopRequireDefault(_includes2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _Icon = __webpack_require__(750);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _AccordionContent = __webpack_require__(875);
	
	var _AccordionContent2 = _interopRequireDefault(_AccordionContent);
	
	var _AccordionTitle = __webpack_require__(876);
	
	var _AccordionTitle2 = _interopRequireDefault(_AccordionTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An accordion allows users to toggle the display of sections of content
	 */
	var Accordion = function (_Component) {
	  (0, _inherits3.default)(Accordion, _Component);
	
	  function Accordion() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, Accordion);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = Accordion.__proto__ || Object.getPrototypeOf(Accordion)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = {};
	
	    _this.handleTitleClick = function (e, index) {
	      var _this$props = _this.props,
	          onTitleClick = _this$props.onTitleClick,
	          exclusive = _this$props.exclusive;
	      var activeIndex = _this.state.activeIndex;
	
	
	      var newIndex = void 0;
	      if (exclusive) {
	        newIndex = index === activeIndex ? -1 : index;
	      } else {
	        // check to see if index is in array, and remove it, if not then add it
	        newIndex = (0, _includes3.default)(activeIndex, index) ? (0, _without3.default)(activeIndex, index) : [].concat((0, _toConsumableArray3.default)(activeIndex), [index]);
	      }
	      _this.trySetState({ activeIndex: newIndex });
	      if (onTitleClick) onTitleClick(e, index);
	    };
	
	    _this.isIndexActive = function (index) {
	      var exclusive = _this.props.exclusive;
	      var activeIndex = _this.state.activeIndex;
	
	      return exclusive ? activeIndex === index : (0, _includes3.default)(activeIndex, index);
	    };
	
	    _this.renderChildren = function () {
	      var children = _this.props.children;
	
	      var titleIndex = 0;
	      var contentIndex = 0;
	
	      return _react.Children.map(children, function (child) {
	        var isTitle = child.type === _AccordionTitle2.default;
	        var isContent = child.type === _AccordionContent2.default;
	
	        if (isTitle) {
	          var _ret = function () {
	            var currentIndex = titleIndex;
	            var isActive = (0, _has3.default)(child, 'props.active') ? child.props.active : _this.isIndexActive(titleIndex);
	            var onClick = function onClick(e) {
	              _this.handleTitleClick(e, currentIndex);
	              if (child.props.onClick) child.props.onClick(e, currentIndex);
	            };
	            titleIndex++;
	            return {
	              v: (0, _react.cloneElement)(child, (0, _extends3.default)({}, child.props, { active: isActive, onClick: onClick }))
	            };
	          }();
	
	          if ((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object") return _ret.v;
	        }
	
	        if (isContent) {
	          var _isActive = (0, _has3.default)(child, 'props.active') ? child.props.active : _this.isIndexActive(contentIndex);
	          contentIndex++;
	          return (0, _react.cloneElement)(child, (0, _extends3.default)({}, child.props, { active: _isActive }));
	        }
	
	        return child;
	      });
	    };
	
	    _this.renderPanels = function () {
	      var panels = _this.props.panels;
	
	      var children = [];
	
	      (0, _each3.default)(panels, function (panel, i) {
	        var isActive = (0, _has3.default)(panel, 'active') ? panel.active : _this.isIndexActive(i);
	        var onClick = function onClick(e) {
	          _this.handleTitleClick(e, i);
	          if (panel.onClick) panel.onClick(e, i);
	        };
	
	        children.push(_react2.default.createElement(
	          _AccordionTitle2.default,
	          { key: panel.title + '-title', active: isActive, onClick: onClick },
	          _react2.default.createElement(_Icon2.default, { name: 'dropdown' }),
	          panel.title
	        ));
	        children.push(_react2.default.createElement(
	          _AccordionContent2.default,
	          { key: panel.title + '-content', active: isActive },
	          panel.content
	        ));
	      });
	
	      return children;
	    };
	
	    _this.state = {
	      activeIndex: _this.props.exclusive ? -1 : [-1]
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Accordion, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          fluid = _props.fluid,
	          inverted = _props.inverted,
	          panels = _props.panels,
	          styled = _props.styled;
	
	
	      var classes = (0, _classnames2.default)('ui', (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(styled, 'styled'), 'accordion', className);
	      var rest = (0, _omit3.default)(this.props, (0, _keys3.default)(Accordion.propTypes));
	      var ElementType = (0, _lib.getElementType)(Accordion, this.props);
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes }),
	        panels ? this.renderPanels() : this.renderChildren()
	      );
	    }
	  }]);
	  return Accordion;
	}(_lib.AutoControlledComponent);
	
	Accordion.defaultProps = {
	  exclusive: true
	};
	Accordion.autoControlledProps = ['activeIndex'];
	Accordion._meta = {
	  name: 'Accordion',
	  type: _lib.META.TYPES.MODULE
	};
	Accordion.Content = _AccordionContent2.default;
	Accordion.Title = _AccordionTitle2.default;
	exports.default = Accordion;
	 false ? Accordion.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Index of the currently active panel. */
	  activeIndex: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.arrayOf(_react.PropTypes.number)]),
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Initial activeIndex value. */
	  defaultActiveIndex: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.arrayOf(_react.PropTypes.number)]),
	
	  /** Only allow one panel open at a time */
	  exclusive: _react.PropTypes.bool,
	
	  /** Format to take up the width of it's container. */
	  fluid: _react.PropTypes.bool,
	
	  /** Format for dark backgrounds. */
	  inverted: _react.PropTypes.bool,
	
	  /** Called with (event, index) when a panel title is clicked. */
	  onTitleClick: _react.PropTypes.func,
	
	  /**
	   * Create simple accordion panels from an array of { text: <string>, content: <custom> } objects.
	   * Object can optionally define an `active` key to open/close the panel.
	   * Mutually exclusive with children.
	   * TODO: AccordionPanel should be a sub-component
	   */
	  panels: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['children']), _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    active: _react.PropTypes.bool,
	    title: _react.PropTypes.string,
	    content: _lib.customPropTypes.contentShorthand,
	    onClick: _react.PropTypes.func
	  }))]),
	
	  /** Adds some basic styling to accordion panels. */
	  styled: _react.PropTypes.bool
	} : void 0;
	Accordion.handledProps = ['activeIndex', 'as', 'children', 'className', 'defaultActiveIndex', 'exclusive', 'fluid', 'inverted', 'onTitleClick', 'panels', 'styled'];

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AccordionContent(props) {
	  var active = props.active,
	      children = props.children,
	      className = props.className;
	
	  var classes = (0, _classnames2.default)('content', (0, _lib.useKeyOnly)(active, 'active'), className);
	  var rest = (0, _lib.getUnhandledProps)(AccordionContent, props);
	  var ElementType = (0, _lib.getElementType)(AccordionContent, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	AccordionContent.handledProps = ['active', 'as', 'children', 'className'];
	AccordionContent.displayName = 'AccordionContent';
	
	 false ? AccordionContent.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Whether or not the content is visible. */
	  active: _react.PropTypes.bool,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string
	} : void 0;
	
	AccordionContent._meta = {
	  name: 'AccordionContent',
	  type: _lib.META.TYPES.MODULE,
	  parent: 'Accordion'
	};
	
	exports.default = AccordionContent;

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(513);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(514);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(518);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(552);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A title sub-component for Accordion component
	 */
	var AccordionTitle = function (_Component) {
	  (0, _inherits3.default)(AccordionTitle, _Component);
	
	  function AccordionTitle() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, AccordionTitle);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AccordionTitle.__proto__ || Object.getPrototypeOf(AccordionTitle)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
	      var onClick = _this.props.onClick;
	
	
	      if (onClick) onClick(e, _this.props);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(AccordionTitle, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          className = _props.className;
	
	
	      var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(active, 'active'), 'title', className);
	      var rest = (0, _lib.getUnhandledProps)(AccordionTitle, this.props);
	      var ElementType = (0, _lib.getElementType)(AccordionTitle, this.props);
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes, onClick: this.handleClick }),
	        children
	      );
	    }
	  }]);
	  return AccordionTitle;
	}(_react.Component);
	
	AccordionTitle.displayName = 'AccordionTitle';
	AccordionTitle._meta = {
	  name: 'AccordionTitle',
	  type: _lib.META.TYPES.MODULE,
	  parent: 'Accordion'
	};
	exports.default = AccordionTitle;
	 false ? AccordionTitle.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Whether or not the title is in the open state. */
	  active: _react.PropTypes.bool,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /**
	   * Called on blur.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _react.PropTypes.func
	} : void 0;
	AccordionTitle.handledProps = ['active', 'as', 'children', 'className', 'onClick'];

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Embed = __webpack_require__(878);
	
	var _Embed2 = _interopRequireDefault(_Embed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Embed2.default;

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(513);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(514);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(518);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(552);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _Icon = __webpack_require__(750);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An embed displays content from other websites like YouTube videos or Google Maps.
	 */
	var Embed = function (_Component) {
	  (0, _inherits3.default)(Embed, _Component);
	
	  function Embed() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Embed);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Embed.__proto__ || Object.getPrototypeOf(Embed)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.handleClick = function (e) {
	      var onClick = _this.props.onClick;
	      var active = _this.state.active;
	
	
	      if (onClick) onClick(e, (0, _extends3.default)({}, _this.props, { active: true }));
	      if (!active) _this.trySetState({ active: true });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Embed, [{
	    key: 'getSrc',
	    value: function getSrc() {
	      var _props = this.props,
	          _props$autoplay = _props.autoplay,
	          autoplay = _props$autoplay === undefined ? true : _props$autoplay,
	          _props$brandedUI = _props.brandedUI,
	          brandedUI = _props$brandedUI === undefined ? false : _props$brandedUI,
	          _props$color = _props.color,
	          color = _props$color === undefined ? '#444444' : _props$color,
	          _props$hd = _props.hd,
	          hd = _props$hd === undefined ? true : _props$hd,
	          id = _props.id,
	          source = _props.source,
	          url = _props.url;
	
	
	      if (source === 'youtube') {
	        return ['//www.youtube.com/embed/' + id, '?autohide=true', '&amp;autoplay=' + autoplay, '&amp;color=' + encodeURIComponent(color), '&amp;hq=' + hd, '&amp;jsapi=false', '&amp;modestbranding=' + brandedUI].join('');
	      }
	
	      if (source === 'vimeo') {
	        return ['//player.vimeo.com/video/' + id, '?api=false', '&amp;autoplay=' + autoplay, '&amp;byline=false', '&amp;color=' + encodeURIComponent(color), '&amp;portrait=false', '&amp;title=false'].join('');
	      }
	
	      return url;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          aspectRatio = _props2.aspectRatio,
	          className = _props2.className,
	          icon = _props2.icon,
	          placeholder = _props2.placeholder;
	      var active = this.state.active;
	
	
	      var classes = (0, _classnames2.default)('ui', aspectRatio, (0, _lib.useKeyOnly)(active, 'active'), 'embed', className);
	      var rest = (0, _lib.getUnhandledProps)(Embed, this.props);
	      var ElementType = (0, _lib.getElementType)(Embed, this.props);
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes, onClick: this.handleClick }),
	        _Icon2.default.create(icon),
	        placeholder && _react2.default.createElement('img', { className: 'placeholder', src: placeholder }),
	        this.renderEmbed()
	      );
	    }
	  }, {
	    key: 'renderEmbed',
	    value: function renderEmbed() {
	      var children = this.props.children;
	      var active = this.state.active;
	
	
	      if (!active) return null;
	      if (!(0, _isNil3.default)(children)) return _react2.default.createElement(
	        'div',
	        { className: 'embed' },
	        children
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'embed' },
	        _react2.default.createElement('iframe', {
	          allowFullScreen: '',
	          frameBorder: '0',
	          height: '100%',
	          scrolling: 'no',
	          src: this.getSrc(),
	          width: '100%'
	        })
	      );
	    }
	  }]);
	  return Embed;
	}(_lib.AutoControlledComponent);
	
	Embed.autoControlledProps = ['active'];
	Embed.defaultProps = {
	  icon: 'video play'
	};
	Embed._meta = {
	  name: 'Embed',
	  type: _lib.META.TYPES.MODULE
	};
	exports.default = Embed;
	 false ? Embed.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** An embed can be active. */
	  active: _react.PropTypes.bool,
	
	  /** An embed can specify an alternative aspect ratio. */
	  aspectRatio: _react.PropTypes.oneOf(['4:3', '16:9', '21:9']),
	
	  /** Setting to true or false will force autoplay. */
	  autoplay: _lib.customPropTypes.every([_lib.customPropTypes.demand(['source']), _react.PropTypes.bool]),
	
	  /** Whether to show networks branded UI like title cards, or after video calls to action. */
	  brandedUI: _lib.customPropTypes.every([_lib.customPropTypes.demand(['source']), _react.PropTypes.bool]),
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Specifies a default chrome color with Vimeo or YouTube. */
	  color: _lib.customPropTypes.every([_lib.customPropTypes.demand(['source']), _react.PropTypes.string]),
	
	  /** Initial value of active. */
	  defaultActive: _react.PropTypes.bool,
	
	  /** Whether to show networks branded UI like title cards, or after video calls to action. */
	  hd: _lib.customPropTypes.every([_lib.customPropTypes.demand(['source']), _react.PropTypes.bool]),
	
	  /** Specifies an icon to use with placeholder content. */
	  icon: _lib.customPropTypes.itemShorthand,
	
	  /** Specifies an id for source. */
	  id: _lib.customPropTypes.every([_lib.customPropTypes.demand(['source']), _react.PropTypes.string]),
	
	  /**
	   * Сalled on click.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props and proposed value.
	   */
	  onClick: _react.PropTypes.func,
	
	  /** A placeholder image for embed. */
	  placeholder: _react.PropTypes.string,
	
	  /** Specifies a source to use. */
	  source: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['sourceUrl']), _react.PropTypes.oneOf(['youtube', 'vimeo'])]),
	
	  /** Specifies a url to use for embed. */
	  url: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['source']), _react.PropTypes.string])
	} : void 0;
	Embed.handledProps = ['active', 'as', 'aspectRatio', 'autoplay', 'brandedUI', 'children', 'className', 'color', 'defaultActive', 'hd', 'icon', 'id', 'onClick', 'placeholder', 'source', 'url'];

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Popup = __webpack_require__(880);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Popup2.default;

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(513);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(514);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(518);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(552);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _pick2 = __webpack_require__(682);
	
	var _pick3 = _interopRequireDefault(_pick2);
	
	var _omit2 = __webpack_require__(743);
	
	var _omit3 = _interopRequireDefault(_omit2);
	
	var _assign2 = __webpack_require__(881);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _mapValues2 = __webpack_require__(882);
	
	var _mapValues3 = _interopRequireDefault(_mapValues2);
	
	var _isNumber2 = __webpack_require__(443);
	
	var _isNumber3 = _interopRequireDefault(_isNumber2);
	
	var _includes2 = __webpack_require__(707);
	
	var _includes3 = _interopRequireDefault(_includes2);
	
	var _without2 = __webpack_require__(723);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lib = __webpack_require__(562);
	
	var _Portal = __webpack_require__(729);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _PopupContent = __webpack_require__(883);
	
	var _PopupContent2 = _interopRequireDefault(_PopupContent);
	
	var _PopupHeader = __webpack_require__(884);
	
	var _PopupHeader2 = _interopRequireDefault(_PopupHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var debug = (0, _lib.makeDebugger)('popup');
	
	var _meta = {
	  name: 'Popup',
	  type: _lib.META.TYPES.MODULE,
	  props: {
	    on: ['hover', 'click', 'focus'],
	    positioning: ['top left', 'top right', 'bottom right', 'bottom left', 'right center', 'left center', 'top center', 'bottom center'],
	    size: (0, _without3.default)(_lib.SUI.SIZES, 'medium', 'big', 'massive'),
	    wide: [true, false, 'very']
	  }
	};
	
	/**
	 * A Popup displays additional information on top of a page.
	 */
	
	var Popup = function (_Component) {
	  (0, _inherits3.default)(Popup, _Component);
	
	  function Popup() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Popup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Popup.__proto__ || Object.getPrototypeOf(Popup)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.hideOnScroll = function (e) {
	      _this.setState({ closed: true });
	      window.removeEventListener('scroll', _this.hideOnScroll);
	      setTimeout(function () {
	        return _this.setState({ closed: false });
	      }, 50);
	    }, _this.handleClose = function (e) {
	      debug('handleClose()');
	      var onClose = _this.props.onClose;
	
	      if (onClose) onClose(e, _this.props);
	    }, _this.handleOpen = function (e) {
	      debug('handleOpen()');
	      _this.coords = e.currentTarget.getBoundingClientRect();
	
	      var onOpen = _this.props.onOpen;
	
	      if (onOpen) onOpen(e, _this.props);
	    }, _this.handlePortalMount = function (e) {
	      debug('handlePortalMount()');
	      if (_this.props.hideOnScroll) {
	        window.addEventListener('scroll', _this.hideOnScroll);
	      }
	
	      var onMount = _this.props.onMount;
	
	      if (onMount) onMount(e, _this.props);
	    }, _this.handlePortalUnmount = function (e) {
	      debug('handlePortalUnmount()');
	      var onUnmount = _this.props.onUnmount;
	
	      if (onUnmount) onUnmount(e, _this.props);
	    }, _this.popupMounted = function (ref) {
	      debug('popupMounted()');
	      _this.popupCoords = ref ? ref.getBoundingClientRect() : null;
	      _this.setPopupStyle();
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Popup, [{
	    key: 'computePopupStyle',
	    value: function computePopupStyle(positions) {
	      var style = { position: 'absolute' };
	
	      // Do not access window/document when server side rendering
	      if (!_lib.isBrowser) return style;
	
	      var offset = this.props.offset;
	      var _window = window,
	          pageYOffset = _window.pageYOffset,
	          pageXOffset = _window.pageXOffset;
	      var _document$documentEle = document.documentElement,
	          clientWidth = _document$documentEle.clientWidth,
	          clientHeight = _document$documentEle.clientHeight;
	
	
	      if ((0, _includes3.default)(positions, 'right')) {
	        style.right = Math.round(clientWidth - (this.coords.right + pageXOffset));
	        style.left = 'auto';
	      } else if ((0, _includes3.default)(positions, 'left')) {
	        style.left = Math.round(this.coords.left + pageXOffset);
	        style.right = 'auto';
	      } else {
	        // if not left nor right, we are horizontally centering the element
	        var xOffset = (this.coords.width - this.popupCoords.width) / 2;
	        style.left = Math.round(this.coords.left + xOffset + pageXOffset);
	        style.right = 'auto';
	      }
	
	      if ((0, _includes3.default)(positions, 'top')) {
	        style.bottom = Math.round(clientHeight - (this.coords.top + pageYOffset));
	        style.top = 'auto';
	      } else if ((0, _includes3.default)(positions, 'bottom')) {
	        style.top = Math.round(this.coords.bottom + pageYOffset);
	        style.bottom = 'auto';
	      } else {
	        // if not top nor bottom, we are vertically centering the element
	        var yOffset = (this.coords.height + this.popupCoords.height) / 2;
	        style.top = Math.round(this.coords.bottom + pageYOffset - yOffset);
	        style.bottom = 'auto';
	
	        var _xOffset = this.popupCoords.width + 8;
	        if ((0, _includes3.default)(positions, 'right')) {
	          style.right -= _xOffset;
	        } else {
	          style.left -= _xOffset;
	        }
	      }
	
	      if (offset) {
	        if ((0, _isNumber3.default)(style.right)) {
	          style.right -= offset;
	        } else {
	          style.left -= offset;
	        }
	      }
	
	      return style;
	    }
	
	    // check if the style would display
	    // the popup outside of the view port
	
	  }, {
	    key: 'isStyleInViewport',
	    value: function isStyleInViewport(style) {
	      var _window2 = window,
	          pageYOffset = _window2.pageYOffset,
	          pageXOffset = _window2.pageXOffset;
	      var _document$documentEle2 = document.documentElement,
	          clientWidth = _document$documentEle2.clientWidth,
	          clientHeight = _document$documentEle2.clientHeight;
	
	
	      var element = {
	        top: style.top,
	        left: style.left,
	        width: this.popupCoords.width,
	        height: this.popupCoords.height
	      };
	      if ((0, _isNumber3.default)(style.right)) {
	        element.left = clientWidth - style.right - element.width;
	      }
	      if ((0, _isNumber3.default)(style.bottom)) {
	        element.top = clientHeight - style.bottom - element.height;
	      }
	
	      // hidden on top
	      if (element.top < pageYOffset) return false;
	      // hidden on the bottom
	      if (element.top + element.height > pageYOffset + clientHeight) return false;
	      // hidden the left
	      if (element.left < pageXOffset) return false;
	      // hidden on the right
	      if (element.left + element.width > pageXOffset + clientWidth) return false;
	
	      return true;
	    }
	  }, {
	    key: 'setPopupStyle',
	    value: function setPopupStyle() {
	      if (!this.coords || !this.popupCoords) return;
	      var positioning = this.props.positioning;
	      var style = this.computePopupStyle(positioning);
	
	      // Lets detect if the popup is out of the viewport and adjust
	      // the position accordingly
	      var positions = (0, _without3.default)(_meta.props.positioning, positioning);
	      for (var i = 0; !this.isStyleInViewport(style) && i < positions.length; i++) {
	        style = this.computePopupStyle(positions[i]);
	        positioning = positions[i];
	      }
	
	      // Append 'px' to every numerical values in the style
	      style = (0, _mapValues3.default)(style, function (value) {
	        return (0, _isNumber3.default)(value) ? value + 'px' : value;
	      });
	      this.setState({ style: style, positioning: positioning });
	    }
	  }, {
	    key: 'getPortalProps',
	    value: function getPortalProps() {
	      var portalProps = {};
	
	      var _props = this.props,
	          on = _props.on,
	          hoverable = _props.hoverable;
	
	
	      if (hoverable) {
	        portalProps.closeOnPortalMouseLeave = true;
	        portalProps.mouseLeaveDelay = 300;
	      }
	
	      if (on === 'click') {
	        portalProps.openOnTriggerClick = true;
	        portalProps.closeOnTriggerClick = true;
	        portalProps.closeOnDocumentClick = true;
	      } else if (on === 'focus') {
	        portalProps.openOnTriggerFocus = true;
	        portalProps.closeOnTriggerBlur = true;
	      } else if (on === 'hover') {
	        portalProps.openOnTriggerMouseEnter = true;
	        portalProps.closeOnTriggerMouseLeave = true;
	        // Taken from SUI: https://git.io/vPmCm
	        portalProps.mouseLeaveDelay = 70;
	        portalProps.mouseEnterDelay = 50;
	      }
	
	      return portalProps;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          basic = _props2.basic,
	          children = _props2.children,
	          className = _props2.className,
	          content = _props2.content,
	          flowing = _props2.flowing,
	          header = _props2.header,
	          inverted = _props2.inverted,
	          size = _props2.size,
	          trigger = _props2.trigger,
	          wide = _props2.wide;
	      var _state = this.state,
	          positioning = _state.positioning,
	          closed = _state.closed;
	
	      var style = (0, _assign3.default)({}, this.state.style, this.props.style);
	      var classes = (0, _classnames2.default)('ui', positioning, size, (0, _lib.useKeyOrValueAndKey)(wide, 'wide'), (0, _lib.useKeyOnly)(basic, 'basic'), (0, _lib.useKeyOnly)(flowing, 'flowing'), (0, _lib.useKeyOnly)(inverted, 'inverted'), 'popup transition visible', className);
	
	      if (closed) return trigger;
	
	      var unhandled = (0, _lib.getUnhandledProps)(Popup, this.props);
	      var portalPropNames = _Portal2.default.handledProps;
	
	      var rest = (0, _omit3.default)(unhandled, portalPropNames);
	      var portalProps = (0, _pick3.default)(unhandled, portalPropNames);
	      var ElementType = (0, _lib.getElementType)(Popup, this.props);
	
	      var popupJSX = _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes, style: style, ref: this.popupMounted }),
	        children,
	        !children && _PopupHeader2.default.create(header),
	        !children && _PopupContent2.default.create(content)
	      );
	
	      var mergedPortalProps = (0, _extends3.default)({}, this.getPortalProps(), portalProps);
	      debug('portal props:', mergedPortalProps);
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        (0, _extends3.default)({}, mergedPortalProps, {
	          trigger: trigger,
	          onClose: this.handleClose,
	          onMount: this.handlePortalMount,
	          onOpen: this.handleOpen,
	          onUnmount: this.handlePortalUnmount
	        }),
	        popupJSX
	      );
	    }
	  }]);
	  return Popup;
	}(_react.Component);
	
	Popup.defaultProps = {
	  positioning: 'top left',
	  on: 'hover'
	};
	Popup._meta = _meta;
	Popup.Content = _PopupContent2.default;
	Popup.Header = _PopupHeader2.default;
	exports.default = Popup;
	 false ? Popup.propTypes = {
	  /** Display the popup without the pointing arrow. */
	  basic: _react.PropTypes.bool,
	
	  /** You may pass a content as children of the Popup. */
	  children: _react.PropTypes.node,
	
	  /** Classes to add to the Popup className. */
	  className: _react.PropTypes.string,
	
	  /** Simple text content for the popover */
	  content: _react.PropTypes.node,
	
	  /** A flowing Popup has no maximum width and continues to flow to fit its content. */
	  flowing: _react.PropTypes.bool,
	
	  /** Takes up the entire width of its offset container. */
	  // TODO: implement the Popup fluid layout
	  // fluid: PropTypes.bool,
	
	  /** Header displayed above the content in bold. */
	  header: _react.PropTypes.string,
	
	  /** Whether the popup should not close on hover. */
	  hoverable: _react.PropTypes.bool,
	
	  /** Invert the colors of the Popup. */
	  inverted: _react.PropTypes.bool,
	
	  /** Hide the Popup when scrolling the window. */
	  hideOnScroll: _react.PropTypes.bool,
	
	  /** Horizontal offset in pixels to be applied to the Popup. */
	  offset: _react.PropTypes.number,
	
	  /** Event triggering the popup */
	  on: _react.PropTypes.oneOf(_meta.props.on),
	
	  /**
	   * Called when a close event happens.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClose: _react.PropTypes.func,
	
	  /**
	   * Called when the portal is mounted on the DOM.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onMount: _react.PropTypes.func,
	
	  /**
	   * Called when an open event happens.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onOpen: _react.PropTypes.func,
	
	  /**
	   * Called when the portal is unmounted from the DOM.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onUnmount: _react.PropTypes.func,
	
	  /** Positioning for the popover */
	  positioning: _react.PropTypes.oneOf(_meta.props.positioning),
	
	  /** Popup size. */
	  size: _react.PropTypes.oneOf(_meta.props.size),
	
	  /** Custom Popup style. */
	  style: _react.PropTypes.object,
	
	  /** Element to be rendered in-place where the popup is defined. */
	  trigger: _react.PropTypes.node,
	
	  /** Popup width. */
	  wide: _react.PropTypes.oneOf(_meta.props.wide)
	} : void 0;
	Popup.handledProps = ['basic', 'children', 'className', 'content', 'flowing', 'header', 'hideOnScroll', 'hoverable', 'inverted', 'offset', 'on', 'onClose', 'onMount', 'onOpen', 'onUnmount', 'positioning', 'size', 'style', 'trigger', 'wide'];

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(438),
	    copyObject = __webpack_require__(459),
	    createAssigner = __webpack_require__(463),
	    isArrayLike = __webpack_require__(296),
	    isPrototype = __webpack_require__(293),
	    keys = __webpack_require__(270);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns own enumerable string keyed properties of source objects to the
	 * destination object. Source objects are applied from left to right.
	 * Subsequent sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object` and is loosely based on
	 * [`Object.assign`](https://mdn.io/Object/assign).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assignIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assign({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var assign = createAssigner(function(object, source) {
	  if (isPrototype(source) || isArrayLike(source)) {
	    copyObject(source, keys(source), object);
	    return;
	  }
	  for (var key in source) {
	    if (hasOwnProperty.call(source, key)) {
	      assignValue(object, key, source[key]);
	    }
	  }
	});
	
	module.exports = assign;


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(439),
	    baseForOwn = __webpack_require__(267),
	    baseIteratee = __webpack_require__(300);
	
	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, key, iteratee(value, key, object));
	  });
	  return result;
	}
	
	module.exports = mapValues;


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = PopupContent;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A PopupContent displays the content body of a Popover.
	 */
	function PopupContent(props) {
	  var children = props.children,
	      className = props.className;
	
	  var classes = (0, _classnames2.default)('content', className);
	  var rest = (0, _lib.getUnhandledProps)(PopupContent, props);
	  var ElementType = (0, _lib.getElementType)(PopupContent, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	PopupContent.handledProps = ['children', 'className'];
	PopupContent.create = (0, _lib.createShorthandFactory)(PopupContent, function (value) {
	  return { children: value };
	});
	
	 false ? PopupContent.propTypes = {
	  /** The content of the Popup */
	  children: _react.PropTypes.node,
	
	  /** Classes to add to the Popup content className. */
	  className: _react.PropTypes.string
	} : void 0;
	
	PopupContent._meta = {
	  name: 'PopupContent',
	  type: _lib.META.TYPES.MODULE,
	  parent: 'Popup'
	};

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = PopupHeader;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A PopupHeader displays a header in a Popover.
	 */
	function PopupHeader(props) {
	  var children = props.children,
	      className = props.className;
	
	  var classes = (0, _classnames2.default)('header', className);
	  var rest = (0, _lib.getUnhandledProps)(PopupHeader, props);
	  var ElementType = (0, _lib.getElementType)(PopupHeader, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	PopupHeader.handledProps = ['children', 'className'];
	PopupHeader.create = (0, _lib.createShorthandFactory)(PopupHeader, function (value) {
	  return { children: value };
	});
	
	 false ? PopupHeader.propTypes = {
	  /** The header of the Popup */
	  children: _react.PropTypes.node,
	
	  /** Classes to add to the Popup header className. */
	  className: _react.PropTypes.string
	} : void 0;
	
	PopupHeader._meta = {
	  name: 'PopupHeader',
	  type: _lib.META.TYPES.MODULE,
	  parent: 'Popup'
	};

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Progress = __webpack_require__(886);
	
	var _Progress2 = _interopRequireDefault(_Progress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Progress2.default;

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(513);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(514);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(518);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(552);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _every2 = __webpack_require__(767);
	
	var _every3 = _interopRequireDefault(_every2);
	
	var _round2 = __webpack_require__(887);
	
	var _round3 = _interopRequireDefault(_round2);
	
	var _clamp2 = __webpack_require__(889);
	
	var _clamp3 = _interopRequireDefault(_clamp2);
	
	var _isUndefined2 = __webpack_require__(572);
	
	var _isUndefined3 = _interopRequireDefault(_isUndefined2);
	
	var _without2 = __webpack_require__(723);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A progress bar shows the progression of a task.
	 */
	var Progress = function (_Component) {
	  (0, _inherits3.default)(Progress, _Component);
	
	  function Progress() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Progress);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Progress.__proto__ || Object.getPrototypeOf(Progress)).call.apply(_ref, [this].concat(args))), _this), _this.calculatePercent = function () {
	      var _this$props = _this.props,
	          percent = _this$props.percent,
	          total = _this$props.total,
	          value = _this$props.value;
	
	
	      if (!(0, _isUndefined3.default)(percent)) return percent;
	      if (!(0, _isUndefined3.default)(total) && !(0, _isUndefined3.default)(value)) return value / total * 100;
	    }, _this.getPercent = function () {
	      var precision = _this.props.precision;
	
	      var percent = (0, _clamp3.default)(_this.calculatePercent(), 0, 100);
	
	      if ((0, _isUndefined3.default)(precision)) return percent;
	      return (0, _round3.default)(percent, precision);
	    }, _this.isAutoSuccess = function () {
	      var _this$props2 = _this.props,
	          autoSuccess = _this$props2.autoSuccess,
	          percent = _this$props2.percent,
	          total = _this$props2.total,
	          value = _this$props2.value;
	
	
	      return autoSuccess && (percent >= 100 || value >= total);
	    }, _this.showProgress = function () {
	      var _this$props3 = _this.props,
	          label = _this$props3.label,
	          precision = _this$props3.precision,
	          progress = _this$props3.progress,
	          total = _this$props3.total,
	          value = _this$props3.value;
	
	
	      if (label || progress || !(0, _isUndefined3.default)(precision)) return true;
	      return !(0, _every3.default)([total, value], _isUndefined3.default);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Progress, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          attached = _props.attached,
	          children = _props.children,
	          className = _props.className,
	          color = _props.color,
	          disabled = _props.disabled,
	          error = _props.error,
	          indicating = _props.indicating,
	          inverted = _props.inverted,
	          label = _props.label,
	          size = _props.size,
	          success = _props.success,
	          total = _props.total,
	          value = _props.value,
	          warning = _props.warning;
	
	
	      var classes = (0, _classnames2.default)('ui', color, size, (0, _lib.useKeyOnly)(active || indicating, 'active'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(error, 'error'), (0, _lib.useKeyOnly)(indicating, 'indicating'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(success || this.isAutoSuccess(), 'success'), (0, _lib.useKeyOnly)(warning, 'warning'), (0, _lib.useValueAndKey)(attached, 'attached'), 'progress', className);
	      var rest = (0, _lib.getUnhandledProps)(Progress, this.props);
	      var ElementType = (0, _lib.getElementType)(Progress, this.props);
	
	      var percent = this.getPercent();
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes }),
	        _react2.default.createElement(
	          'div',
	          { className: 'bar', style: { width: percent + '%' } },
	          this.showProgress() && _react2.default.createElement(
	            'div',
	            { className: 'progress' },
	            label !== 'ratio' ? percent + '%' : value + '/' + total
	          )
	        ),
	        children && _react2.default.createElement(
	          'div',
	          { className: 'label' },
	          children
	        )
	      );
	    }
	  }]);
	  return Progress;
	}(_react.Component);
	
	Progress._meta = {
	  name: 'Progress',
	  type: _lib.META.TYPES.MODULE
	};
	 false ? Progress.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A progress bar can show activity. */
	  active: _react.PropTypes.bool,
	
	  /** A progress bar can attach to and show the progress of an element (i.e. Card or Segment). */
	  attached: _react.PropTypes.oneOf(['top', 'bottom']),
	
	  /** Whether success state should automatically trigger when progress completes. */
	  autoSuccess: _react.PropTypes.bool,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** A progress bar can have different colors. */
	  color: _react.PropTypes.oneOf(_lib.SUI.COLORS),
	
	  /** A progress bar be disabled. */
	  disabled: _react.PropTypes.bool,
	
	  /** A progress bar can show a error state. */
	  error: _react.PropTypes.bool,
	
	  /** An indicating progress bar visually indicates the current level of progress of a task. */
	  indicating: _react.PropTypes.bool,
	
	  /** A progress bar can have its colors inverted. */
	  inverted: _react.PropTypes.bool,
	
	  /** Can be set to either to display progress as percent or ratio. */
	  label: _lib.customPropTypes.every([_lib.customPropTypes.some([_lib.customPropTypes.demand(['percent']), _lib.customPropTypes.demand(['total', 'value'])]), _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.oneOf(['ratio', 'percent'])])]),
	
	  /** Current percent complete. */
	  percent: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['total', 'value']), _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])]),
	
	  /** Decimal point precision for calculated progress. */
	  precision: _react.PropTypes.number,
	
	  /** A progress bar can contain a text value indicating current progress. */
	  progress: _react.PropTypes.bool,
	
	  /** A progress bar can vary in size. */
	  size: _react.PropTypes.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'mini', 'huge', 'massive')),
	
	  /** A progress bar can show a success state. */
	  success: _react.PropTypes.bool,
	
	  /**
	   * For use with value.
	   * Together, these will calculate the percent.
	   * Mutually excludes percent.
	   */
	  total: _lib.customPropTypes.every([_lib.customPropTypes.demand(['value']), _lib.customPropTypes.disallow(['percent']), _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])]),
	
	  /**
	   * For use with total. Together, these will calculate the percent. Mutually excludes percent.
	   */
	  value: _lib.customPropTypes.every([_lib.customPropTypes.demand(['total']), _lib.customPropTypes.disallow(['percent']), _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])]),
	
	  /** A progress bar can show a warning state. */
	  warning: _react.PropTypes.bool
	} : void 0;
	Progress.handledProps = ['active', 'as', 'attached', 'autoSuccess', 'children', 'className', 'color', 'disabled', 'error', 'indicating', 'inverted', 'label', 'percent', 'precision', 'progress', 'size', 'success', 'total', 'value', 'warning'];
	exports.default = Progress;

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	var createRound = __webpack_require__(888);
	
	/**
	 * Computes `number` rounded to `precision`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.10.0
	 * @category Math
	 * @param {number} number The number to round.
	 * @param {number} [precision=0] The precision to round to.
	 * @returns {number} Returns the rounded number.
	 * @example
	 *
	 * _.round(4.006);
	 * // => 4
	 *
	 * _.round(4.006, 2);
	 * // => 4.01
	 *
	 * _.round(4060, -2);
	 * // => 4100
	 */
	var round = createRound('round');
	
	module.exports = round;


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(277),
	    toInteger = __webpack_require__(575),
	    toNumber = __webpack_require__(577),
	    toString = __webpack_require__(374);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsFinite = root.isFinite,
	    nativeMin = Math.min;
	
	/**
	 * Creates a function like `_.round`.
	 *
	 * @private
	 * @param {string} methodName The name of the `Math` method to use when rounding.
	 * @returns {Function} Returns the new round function.
	 */
	function createRound(methodName) {
	  var func = Math[methodName];
	  return function(number, precision) {
	    number = toNumber(number);
	    precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	    if (precision && nativeIsFinite(number)) {
	      // Shift with exponential notation to avoid floating-point issues.
	      // See [MDN](https://mdn.io/round#Examples) for more details.
	      var pair = (toString(number) + 'e').split('e'),
	          value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	      pair = (toString(value) + 'e').split('e');
	      return +(pair[0] + 'e' + (+pair[1] - precision));
	    }
	    return func(number);
	  };
	}
	
	module.exports = createRound;


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClamp = __webpack_require__(574),
	    toNumber = __webpack_require__(577);
	
	/**
	 * Clamps `number` within the inclusive `lower` and `upper` bounds.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Number
	 * @param {number} number The number to clamp.
	 * @param {number} [lower] The lower bound.
	 * @param {number} upper The upper bound.
	 * @returns {number} Returns the clamped number.
	 * @example
	 *
	 * _.clamp(-10, -5, 5);
	 * // => -5
	 *
	 * _.clamp(10, -5, 5);
	 * // => 5
	 */
	function clamp(number, lower, upper) {
	  if (upper === undefined) {
	    upper = lower;
	    lower = undefined;
	  }
	  if (upper !== undefined) {
	    upper = toNumber(upper);
	    upper = upper === upper ? upper : 0;
	  }
	  if (lower !== undefined) {
	    lower = toNumber(lower);
	    lower = lower === lower ? lower : 0;
	  }
	  return baseClamp(toNumber(number), lower, upper);
	}
	
	module.exports = clamp;


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Rating = __webpack_require__(891);
	
	var _Rating2 = _interopRequireDefault(_Rating);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Rating2.default;

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(513);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(514);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(518);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(552);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _times2 = __webpack_require__(596);
	
	var _times3 = _interopRequireDefault(_times2);
	
	var _invoke2 = __webpack_require__(731);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _without2 = __webpack_require__(723);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _RatingIcon = __webpack_require__(892);
	
	var _RatingIcon2 = _interopRequireDefault(_RatingIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A rating indicates user interest in content.
	 */
	var Rating = function (_Component) {
	  (0, _inherits3.default)(Rating, _Component);
	
	  function Rating() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Rating);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Rating.__proto__ || Object.getPrototypeOf(Rating)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Rating, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          className = _props.className,
	          disabled = _props.disabled,
	          icon = _props.icon,
	          maxRating = _props.maxRating,
	          size = _props.size;
	      var _state = this.state,
	          rating = _state.rating,
	          selectedIndex = _state.selectedIndex,
	          isSelecting = _state.isSelecting;
	
	
	      var classes = (0, _classnames2.default)('ui', icon, size, (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(isSelecting && !disabled && selectedIndex >= 0, 'selected'), 'rating', className);
	      var rest = (0, _lib.getUnhandledProps)(Rating, this.props);
	      var ElementType = (0, _lib.getElementType)(Rating, this.props);
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes, role: 'radiogroup', onMouseLeave: this.handleMouseLeave }),
	        (0, _times3.default)(maxRating, function (i) {
	          return _react2.default.createElement(_RatingIcon2.default, {
	            active: rating >= i + 1,
	            'aria-checked': rating === i + 1,
	            'aria-posinset': i + 1,
	            'aria-setsize': maxRating,
	            index: i,
	            key: i,
	            onClick: _this2.handleIconClick,
	            onMouseEnter: _this2.handleIconMouseEnter,
	            selected: selectedIndex >= i && isSelecting
	          });
	        })
	      );
	    }
	  }]);
	  return Rating;
	}(_lib.AutoControlledComponent);
	
	Rating.autoControlledProps = ['rating'];
	Rating.defaultProps = {
	  clearable: 'auto',
	  maxRating: 1
	};
	Rating._meta = {
	  name: 'Rating',
	  type: _lib.META.TYPES.MODULE
	};
	Rating.Icon = _RatingIcon2.default;
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.handleIconClick = function (e, _ref2) {
	    var index = _ref2.index;
	    var _props2 = _this3.props,
	        clearable = _props2.clearable,
	        disabled = _props2.disabled,
	        maxRating = _props2.maxRating,
	        onRate = _props2.onRate;
	    var rating = _this3.state.rating;
	
	    if (disabled) return;
	
	    // default newRating is the clicked icon
	    // allow toggling a binary rating
	    // allow clearing ratings
	    var newRating = index + 1;
	    if (clearable === 'auto' && maxRating === 1) {
	      newRating = +!rating;
	    } else if (clearable === true && newRating === rating) {
	      newRating = 0;
	    }
	
	    // set rating
	    _this3.trySetState({ rating: newRating }, { isSelecting: false });
	    if (onRate) onRate(e, (0, _extends3.default)({}, _this3.props, { rating: newRating }));
	  };
	
	  this.handleIconMouseEnter = function (e, _ref3) {
	    var index = _ref3.index;
	
	    if (_this3.props.disabled) return;
	
	    _this3.setState({ selectedIndex: index, isSelecting: true });
	  };
	
	  this.handleMouseLeave = function () {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    _invoke3.default.apply(undefined, [_this3.props, 'onMouseLeave'].concat(args));
	
	    if (_this3.props.disabled) return;
	
	    _this3.setState({ selectedIndex: -1, isSelecting: false });
	  };
	};
	
	exports.default = Rating;
	 false ? Rating.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /**
	   * You can clear the rating by clicking on the current start rating.
	   * By default a rating will be only clearable if there is 1 icon.
	   * Setting to `true`/`false` will allow or disallow a user to clear their rating.
	   */
	  clearable: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.oneOf(['auto'])]),
	
	  /** The initial rating value. */
	  defaultRating: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	
	  /** You can disable or enable interactive rating.  Makes a read-only rating. */
	  disabled: _react.PropTypes.bool,
	
	  /** A rating can use a set of star or heart icons. */
	  icon: _react.PropTypes.oneOf(['star', 'heart']),
	
	  /** The total number of icons. */
	  maxRating: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	
	  /**
	   * Called after user selects a new rating.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props and proposed rating.
	   */
	  onRate: _react.PropTypes.func,
	
	  /** The current number of active icons. */
	  rating: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	
	  /** A progress bar can vary in size. */
	  size: _react.PropTypes.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'medium', 'big'))
	} : void 0;
	Rating.handledProps = ['as', 'className', 'clearable', 'defaultRating', 'disabled', 'icon', 'maxRating', 'onRate', 'rating', 'size'];

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(513);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(514);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(518);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(552);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An internal icon sub-component for Rating component
	 */
	var RatingIcon = function (_Component) {
	  (0, _inherits3.default)(RatingIcon, _Component);
	
	  function RatingIcon() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RatingIcon);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RatingIcon.__proto__ || Object.getPrototypeOf(RatingIcon)).call.apply(_ref, [this].concat(args))), _this), _this.defaultProps = {
	      as: 'i'
	    }, _this.handleClick = function (e) {
	      var onClick = _this.props.onClick;
	
	
	      if (onClick) onClick(e, _this.props);
	    }, _this.handleKeyUp = function (e) {
	      var _this$props = _this.props,
	          onClick = _this$props.onClick,
	          onKeyUp = _this$props.onKeyUp;
	
	
	      if (onKeyUp) onKeyUp(e, _this.props);
	
	      if (onClick) {
	        switch (_lib.keyboardKey.getCode(e)) {
	          case _lib.keyboardKey.Enter:
	          case _lib.keyboardKey.Spacebar:
	            e.preventDefault();
	            onClick(e, _this.props);
	            break;
	          default:
	            return;
	        }
	      }
	    }, _this.handleMouseEnter = function (e) {
	      var onMouseEnter = _this.props.onMouseEnter;
	
	
	      if (onMouseEnter) onMouseEnter(e, _this.props);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(RatingIcon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          className = _props.className,
	          selected = _props.selected;
	
	      var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(selected, 'selected'), 'icon', className);
	      var rest = (0, _lib.getUnhandledProps)(RatingIcon, this.props);
	      var ElementType = (0, _lib.getElementType)(RatingIcon, this.props);
	
	      return _react2.default.createElement(ElementType, (0, _extends3.default)({}, rest, {
	        className: classes,
	        onClick: this.handleClick,
	        onKeyUp: this.handleKeyUp,
	        onMouseEnter: this.handleMouseEnter,
	        tabIndex: 0,
	        role: 'radio'
	      }));
	    }
	  }]);
	  return RatingIcon;
	}(_react.Component);
	
	RatingIcon._meta = {
	  name: 'RatingIcon',
	  parent: 'Rating',
	  type: _lib.META.TYPES.MODULE
	};
	exports.default = RatingIcon;
	 false ? RatingIcon.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Indicates activity of an icon. */
	  active: _react.PropTypes.bool,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** An index of icon inside Rating. */
	  index: _react.PropTypes.number,
	
	  /**
	   * Called on click.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _react.PropTypes.func,
	
	  /**
	   * Called on keyup.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onKeyUp: _react.PropTypes.func,
	
	  /**
	   * Called on mouseenter.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onMouseEnter: _react.PropTypes.func,
	
	  /** Indicates selection of an icon. */
	  selected: _react.PropTypes.bool
	} : void 0;
	RatingIcon.handledProps = ['active', 'as', 'className', 'index', 'onClick', 'onKeyUp', 'onMouseEnter', 'selected'];

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Search = __webpack_require__(894);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Search2.default;

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(895);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(513);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(514);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(518);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get3 = __webpack_require__(759);
	
	var _get4 = _interopRequireDefault(_get3);
	
	var _inherits2 = __webpack_require__(552);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _isEmpty2 = __webpack_require__(578);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _partialRight2 = __webpack_require__(896);
	
	var _partialRight3 = _interopRequireDefault(_partialRight2);
	
	var _inRange2 = __webpack_require__(897);
	
	var _inRange3 = _interopRequireDefault(_inRange2);
	
	var _map2 = __webpack_require__(702);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _get5 = __webpack_require__(366);
	
	var _get6 = _interopRequireDefault(_get5);
	
	var _reduce2 = __webpack_require__(464);
	
	var _reduce3 = _interopRequireDefault(_reduce2);
	
	var _isEqual2 = __webpack_require__(598);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _without2 = __webpack_require__(723);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _Input = __webpack_require__(798);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _SearchCategory = __webpack_require__(899);
	
	var _SearchCategory2 = _interopRequireDefault(_SearchCategory);
	
	var _SearchResult = __webpack_require__(900);
	
	var _SearchResult2 = _interopRequireDefault(_SearchResult);
	
	var _SearchResults = __webpack_require__(901);
	
	var _SearchResults2 = _interopRequireDefault(_SearchResults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var debug = (0, _lib.makeDebugger)('search');
	
	/**
	 * A search module allows a user to query for results from a selection of data
	 */
	
	var Search = function (_Component) {
	  (0, _inherits3.default)(Search, _Component);
	
	  function Search() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Search);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Search.__proto__ || Object.getPrototypeOf(Search)).call.apply(_ref, [this].concat(args))), _this), _this.handleResultSelect = function (e, result) {
	      debug('handleResultSelect()');
	      debug(result);
	      var onResultSelect = _this.props.onResultSelect;
	
	      if (onResultSelect) onResultSelect(e, result);
	    }, _this.closeOnEscape = function (e) {
	      if (_lib.keyboardKey.getCode(e) !== _lib.keyboardKey.Escape) return;
	      e.preventDefault();
	      _this.close();
	    }, _this.moveSelectionOnKeyDown = function (e) {
	      debug('moveSelectionOnKeyDown()');
	      debug(_lib.keyboardKey.getName(e));
	      switch (_lib.keyboardKey.getCode(e)) {
	        case _lib.keyboardKey.ArrowDown:
	          e.preventDefault();
	          _this.moveSelectionBy(1);
	          break;
	        case _lib.keyboardKey.ArrowUp:
	          e.preventDefault();
	          _this.moveSelectionBy(-1);
	          break;
	        default:
	          break;
	      }
	    }, _this.selectItemOnEnter = function (e) {
	      debug('selectItemOnEnter()');
	      debug(_lib.keyboardKey.getName(e));
	      if (_lib.keyboardKey.getCode(e) !== _lib.keyboardKey.Enter) return;
	      e.preventDefault();
	
	      var result = _this.getSelectedResult();
	
	      // prevent selecting null if there was no selected item value
	      if (!result) return;
	
	      // notify the onResultSelect prop that the user is trying to change value
	      _this.setValue(result.title);
	      _this.handleResultSelect(e, result);
	      _this.close();
	    }, _this.closeOnDocumentClick = function (e) {
	      debug('closeOnDocumentClick()');
	      debug(e);
	      _this.close();
	    }, _this.handleMouseDown = function (e) {
	      debug('handleMouseDown()');
	      var onMouseDown = _this.props.onMouseDown;
	
	      if (onMouseDown) onMouseDown(e, _this.props);
	      _this.isMouseDown = true;
	      // Do not access document when server side rendering
	      if (!_lib.isBrowser) return;
	      document.addEventListener('mouseup', _this.handleDocumentMouseUp);
	    }, _this.handleDocumentMouseUp = function () {
	      debug('handleDocumentMouseUp()');
	      _this.isMouseDown = false;
	      // Do not access document when server side rendering
	      if (!_lib.isBrowser) return;
	      document.removeEventListener('mouseup', _this.handleDocumentMouseUp);
	    }, _this.handleInputClick = function (e) {
	      debug('handleInputClick()', e);
	
	      // prevent closeOnDocumentClick()
	      e.nativeEvent.stopImmediatePropagation();
	
	      _this.tryOpen();
	    }, _this.handleItemClick = function (e, _ref2) {
	      var id = _ref2.id;
	
	      debug('handleItemClick()');
	      debug(id);
	      var result = _this.getSelectedResult(id);
	
	      // prevent closeOnDocumentClick()
	      e.nativeEvent.stopImmediatePropagation();
	
	      // notify the onResultSelect prop that the user is trying to change value
	      _this.setValue(result.title);
	      _this.handleResultSelect(e, result);
	      _this.close();
	    }, _this.handleFocus = function (e) {
	      debug('handleFocus()');
	      var onFocus = _this.props.onFocus;
	
	      if (onFocus) onFocus(e, _this.props);
	      _this.setState({ focus: true });
	    }, _this.handleBlur = function (e) {
	      debug('handleBlur()');
	      var onBlur = _this.props.onBlur;
	
	      if (onBlur) onBlur(e, _this.props);
	      _this.setState({ focus: false });
	    }, _this.handleSearchChange = function (e) {
	      debug('handleSearchChange()');
	      debug(e.target.value);
	      // prevent propagating to this.props.onChange()
	      e.stopPropagation();
	      var _this$props = _this.props,
	          onSearchChange = _this$props.onSearchChange,
	          minCharacters = _this$props.minCharacters;
	      var open = _this.state.open;
	
	      var newQuery = e.target.value;
	
	      if (onSearchChange) onSearchChange(e, newQuery);
	
	      // open search dropdown on search query
	      if (newQuery.length < minCharacters) {
	        _this.close();
	      } else if (!open) {
	        _this.tryOpen(newQuery);
	      }
	
	      _this.setValue(newQuery);
	    }, _this.getFlattenedResults = function () {
	      var _this$props2 = _this.props,
	          category = _this$props2.category,
	          results = _this$props2.results;
	
	
	      return !category ? results : (0, _reduce3.default)(results, function (memo, categoryData) {
	        return memo.concat(categoryData.results);
	      }, []);
	    }, _this.getSelectedResult = function () {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.selectedIndex;
	
	      var results = _this.getFlattenedResults();
	      return (0, _get6.default)(results, index);
	    }, _this.setValue = function (value) {
	      debug('setValue()');
	      debug('value', value);
	
	      var selectFirstResult = _this.props.selectFirstResult;
	
	
	      _this.trySetState({ value: value }, { selectedIndex: selectFirstResult ? 0 : -1 });
	    }, _this.moveSelectionBy = function (offset) {
	      debug('moveSelectionBy()');
	      debug('offset: ' + offset);
	      var selectedIndex = _this.state.selectedIndex;
	
	
	      var results = _this.getFlattenedResults();
	      var lastIndex = results.length - 1;
	
	      // next is after last, wrap to beginning
	      // next is before first, wrap to end
	      var nextIndex = selectedIndex + offset;
	      if (nextIndex > lastIndex) nextIndex = 0;else if (nextIndex < 0) nextIndex = lastIndex;
	
	      _this.setState({ selectedIndex: nextIndex });
	      _this.scrollSelectedItemIntoView();
	    }, _this.scrollSelectedItemIntoView = function () {
	      debug('scrollSelectedItemIntoView()');
	      // Do not access document when server side rendering
	      if (!_lib.isBrowser) return;
	      var menu = document.querySelector('.ui.search.active.visible .results.visible');
	      var item = menu.querySelector('.result.active');
	      debug('menu (results): ' + menu);
	      debug('item (result): ' + item);
	      var isOutOfUpperView = item.offsetTop < menu.scrollTop;
	      var isOutOfLowerView = item.offsetTop + item.clientHeight > menu.scrollTop + menu.clientHeight;
	
	      if (isOutOfUpperView) {
	        menu.scrollTop = item.offsetTop;
	      } else if (isOutOfLowerView) {
	        menu.scrollTop = item.offsetTop + item.clientHeight - menu.clientHeight;
	      }
	    }, _this.tryOpen = function () {
	      var currentValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.value;
	
	      debug('open()');
	
	      var minCharacters = _this.props.minCharacters;
	
	      if (currentValue.length < minCharacters) return;
	
	      _this.open();
	    }, _this.open = function () {
	      debug('open()');
	      _this.trySetState({ open: true });
	    }, _this.close = function () {
	      debug('close()');
	      _this.trySetState({ open: false });
	    }, _this.renderSearchInput = function () {
	      var _this$props3 = _this.props,
	          icon = _this$props3.icon,
	          input = _this$props3.input,
	          placeholder = _this$props3.placeholder;
	      var value = _this.state.value;
	
	
	      return _Input2.default.create(input, {
	        value: value,
	        placeholder: placeholder,
	        onBlur: _this.handleBlur,
	        onChange: _this.handleSearchChange,
	        onFocus: _this.handleFocus,
	        onClick: _this.handleInputClick,
	        input: { className: 'prompt', tabIndex: '0', autoComplete: 'off' },
	        icon: icon
	      });
	    }, _this.renderNoResults = function () {
	      var _this$props4 = _this.props,
	          noResultsDescription = _this$props4.noResultsDescription,
	          noResultsMessage = _this$props4.noResultsMessage;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'message empty' },
	        _react2.default.createElement(
	          'div',
	          { className: 'header' },
	          noResultsMessage
	        ),
	        noResultsDescription && _react2.default.createElement(
	          'div',
	          { className: 'description' },
	          noResultsDescription
	        )
	      );
	    }, _this.renderResult = function (_ref3, index, _array) {
	      var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	      var childKey = _ref3.childKey,
	          result = (0, _objectWithoutProperties3.default)(_ref3, ['childKey']);
	      var resultRenderer = _this.props.resultRenderer;
	      var selectedIndex = _this.state.selectedIndex;
	
	      var offsetIndex = index + offset;
	
	      return _react2.default.createElement(_SearchResult2.default, (0, _extends3.default)({
	        key: childKey || result.title,
	        active: selectedIndex === offsetIndex,
	        onClick: _this.handleItemClick,
	        renderer: resultRenderer
	      }, result, {
	        id: offsetIndex // Used to lookup the result on item click
	      }));
	    }, _this.renderResults = function () {
	      var results = _this.props.results;
	
	
	      return (0, _map3.default)(results, _this.renderResult);
	    }, _this.renderCategories = function () {
	      var _this$props5 = _this.props,
	          categoryRenderer = _this$props5.categoryRenderer,
	          categories = _this$props5.results;
	      var selectedIndex = _this.state.selectedIndex;
	
	
	      var count = 0;
	
	      return (0, _map3.default)(categories, function (_ref4, name, index) {
	        var childKey = _ref4.childKey,
	            category = (0, _objectWithoutProperties3.default)(_ref4, ['childKey']);
	
	        var categoryProps = (0, _extends3.default)({
	          key: childKey || category.name,
	          active: (0, _inRange3.default)(selectedIndex, count, count + category.results.length),
	          renderer: categoryRenderer
	        }, category);
	        var renderFn = (0, _partialRight3.default)(_this.renderResult, count);
	
	        count = count + category.results.length;
	
	        return _react2.default.createElement(
	          _SearchCategory2.default,
	          categoryProps,
	          category.results.map(renderFn)
	        );
	      });
	    }, _this.renderMenuContent = function () {
	      var _this$props6 = _this.props,
	          category = _this$props6.category,
	          showNoResults = _this$props6.showNoResults,
	          results = _this$props6.results;
	
	
	      if ((0, _isEmpty3.default)(results)) {
	        return showNoResults ? _this.renderNoResults() : null;
	      }
	
	      return category ? _this.renderCategories() : _this.renderResults();
	    }, _this.renderResultsMenu = function () {
	      var open = _this.state.open;
	
	      var resultsClasses = open ? 'visible' : '';
	      var menuContent = _this.renderMenuContent();
	
	      if (!menuContent) return;
	
	      return _react2.default.createElement(
	        _SearchResults2.default,
	        { className: resultsClasses },
	        menuContent
	      );
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Search, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if ((0, _get4.default)(Search.prototype.__proto__ || Object.getPrototypeOf(Search.prototype), 'componentWillMount', this)) (0, _get4.default)(Search.prototype.__proto__ || Object.getPrototypeOf(Search.prototype), 'componentWillMount', this).call(this);
	      debug('componentWillMount()');
	      var _state = this.state,
	          open = _state.open,
	          value = _state.value;
	
	
	      this.setValue(value);
	      if (open) this.open();
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _isEqual3.default)(nextProps, this.props) || !(0, _isEqual3.default)(nextState, this.state);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      (0, _get4.default)(Search.prototype.__proto__ || Object.getPrototypeOf(Search.prototype), 'componentWillReceiveProps', this).call(this, nextProps);
	      debug('componentWillReceiveProps()');
	      // TODO objectDiff still runs in prod, stop it
	      debug('changed props:', (0, _lib.objectDiff)(nextProps, this.props));
	
	      if (!(0, _isEqual3.default)(nextProps.value, this.props.value)) {
	        debug('value changed, setting', nextProps.value);
	        this.setValue(nextProps.value);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      // eslint-disable-line complexity
	      debug('componentDidUpdate()');
	      // TODO objectDiff still runs in prod, stop it
	      debug('to state:', (0, _lib.objectDiff)(prevState, this.state));
	
	      // Do not access document when server side rendering
	      if (!_lib.isBrowser) return;
	
	      // focused / blurred
	      if (!prevState.focus && this.state.focus) {
	        debug('search focused');
	        if (!this.isMouseDown) {
	          debug('mouse is not down, opening');
	          this.tryOpen();
	        }
	        if (this.state.open) {
	          document.addEventListener('keydown', this.moveSelectionOnKeyDown);
	          document.addEventListener('keydown', this.selectItemOnEnter);
	        }
	      } else if (prevState.focus && !this.state.focus) {
	        debug('search blurred');
	        if (!this.isMouseDown) {
	          debug('mouse is not down, closing');
	          this.close();
	        }
	        document.removeEventListener('keydown', this.moveSelectionOnKeyDown);
	        document.removeEventListener('keydown', this.selectItemOnEnter);
	      }
	
	      // opened / closed
	      if (!prevState.open && this.state.open) {
	        debug('search opened');
	        this.open();
	        document.addEventListener('keydown', this.closeOnEscape);
	        document.addEventListener('keydown', this.moveSelectionOnKeyDown);
	        document.addEventListener('keydown', this.selectItemOnEnter);
	        document.addEventListener('click', this.closeOnDocumentClick);
	      } else if (prevState.open && !this.state.open) {
	        debug('search closed');
	        this.close();
	        document.removeEventListener('keydown', this.closeOnEscape);
	        document.removeEventListener('keydown', this.moveSelectionOnKeyDown);
	        document.removeEventListener('keydown', this.selectItemOnEnter);
	        document.removeEventListener('click', this.closeOnDocumentClick);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      debug('componentWillUnmount()');
	
	      // Do not access document when server side rendering
	      if (!_lib.isBrowser) return;
	
	      document.removeEventListener('keydown', this.moveSelectionOnKeyDown);
	      document.removeEventListener('keydown', this.selectItemOnEnter);
	      document.removeEventListener('keydown', this.closeOnEscape);
	      document.removeEventListener('click', this.closeOnDocumentClick);
	    }
	
	    // ----------------------------------------
	    // Document Event Handlers
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Component Event Handlers
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Getters
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Setters
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Behavior
	    // ----------------------------------------
	
	    // Open if the current value is greater than the minCharacters prop
	
	
	    // ----------------------------------------
	    // Render
	    // ----------------------------------------
	
	    /**
	     * Offset is needed for determining the active item for results within a
	     * category. Since the index is reset to 0 for each new category, an offset
	     * must be passed in.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      debug('render()');
	      debug('props', this.props);
	      debug('state', this.state);
	      var _state2 = this.state,
	          searchClasses = _state2.searchClasses,
	          focus = _state2.focus,
	          open = _state2.open;
	      var _props = this.props,
	          aligned = _props.aligned,
	          category = _props.category,
	          className = _props.className,
	          fluid = _props.fluid,
	          loading = _props.loading,
	          size = _props.size;
	
	      // Classes
	
	      var classes = (0, _classnames2.default)('ui', open && 'active visible', size, searchClasses, (0, _lib.useKeyOnly)(category, 'category'), (0, _lib.useKeyOnly)(focus, 'focus'), (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(loading, 'loading'), (0, _lib.useValueAndKey)(aligned, 'aligned'), 'search', className);
	      var rest = (0, _lib.getUnhandledProps)(Search, this.props);
	      var ElementType = (0, _lib.getElementType)(Search, this.props);
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, {
	          className: classes,
	          onBlur: this.handleBlur,
	          onFocus: this.handleFocus,
	          onMouseDown: this.handleMouseDown
	        }),
	        this.renderSearchInput(),
	        this.renderResultsMenu()
	      );
	    }
	  }]);
	  return Search;
	}(_lib.AutoControlledComponent);
	
	Search.defaultProps = {
	  icon: 'search',
	  input: 'text',
	  minCharacters: 1,
	  noResultsMessage: 'No results found.',
	  showNoResults: true
	};
	Search.autoControlledProps = ['open', 'value'];
	Search._meta = {
	  name: 'Search',
	  type: _lib.META.TYPES.MODULE
	};
	Search.Category = _SearchCategory2.default;
	Search.Result = _SearchResult2.default;
	Search.Results = _SearchResults2.default;
	exports.default = Search;
	 false ? Search.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  // ------------------------------------
	  // Behavior
	  // ------------------------------------
	
	  /** Initial value of open. */
	  defaultOpen: _react.PropTypes.bool,
	
	  /** Initial value. */
	  defaultValue: _react.PropTypes.string,
	
	  /** Shorthand for Icon. */
	  icon: _react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.object]),
	
	  /** Controls whether or not the results menu is displayed. */
	  open: _react.PropTypes.bool,
	
	  /** Placeholder of the search input. */
	  placeholder: _react.PropTypes.string,
	
	  /**
	   * One of:
	   * - array of Search.Result props e.g. `{ title: '', description: '' }` or
	   * - object of categories e.g. `{ name: '', results: [{ title: '', description: '' }]`
	   */
	  results: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.shape(_SearchResult2.default.propTypes)), _react.PropTypes.object]),
	
	  /** Minimum characters to query for results */
	  minCharacters: _react.PropTypes.number,
	
	  /** Additional text for "No Results" message with less emphasis. */
	  noResultsDescription: _react.PropTypes.string,
	
	  /** Message to display when there are no results. */
	  noResultsMessage: _react.PropTypes.string,
	
	  /** Whether the search should automatically select the first result after searching */
	  selectFirstResult: _react.PropTypes.bool,
	
	  /** Whether a "no results" message should be shown if no results are found. */
	  showNoResults: _react.PropTypes.bool,
	
	  /** Current value of the search input. Creates a controlled component. */
	  value: _react.PropTypes.string,
	
	  // ------------------------------------
	  // Rendering
	  // ------------------------------------
	
	  /**
	   * A function that returns the category contents.
	   * Receives all SearchCategory props.
	   */
	  categoryRenderer: _react.PropTypes.func,
	
	  /**
	   * A function that returns the result contents.
	   * Receives all SearchResult props.
	   */
	  resultRenderer: _react.PropTypes.func,
	
	  // ------------------------------------
	  // Callbacks
	  // ------------------------------------
	
	  /**
	   * Called on blur.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onBlur: _react.PropTypes.func,
	
	  /**
	   * Called on focus.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onFocus: _react.PropTypes.func,
	
	  /**
	   * Called on mousedown.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onMouseDown: _react.PropTypes.func,
	
	  /**
	   * Called when a result is selected.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onResultSelect: _react.PropTypes.func,
	
	  /**
	   * Called on search input change.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {string} value - Current value of search input.
	   */
	  onSearchChange: _react.PropTypes.func,
	
	  // ------------------------------------
	  // Style
	  // ------------------------------------
	
	  /** A search can have its results aligned to its left or right container edge. */
	  aligned: _react.PropTypes.string,
	
	  /** A search can display results from remote content ordered by categories. */
	  category: _react.PropTypes.bool,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** A search can have its results take up the width of its container. */
	  fluid: _react.PropTypes.bool,
	
	  /** A search input can take up the width of its container. */
	  input: _lib.customPropTypes.itemShorthand,
	
	  /** A search can show a loading indicator. */
	  loading: _react.PropTypes.bool,
	
	  /** A search can have different sizes. */
	  size: _react.PropTypes.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'medium'))
	} : void 0;
	Search.handledProps = ['aligned', 'as', 'category', 'categoryRenderer', 'className', 'defaultOpen', 'defaultValue', 'fluid', 'icon', 'input', 'loading', 'minCharacters', 'noResultsDescription', 'noResultsMessage', 'onBlur', 'onFocus', 'onMouseDown', 'onResultSelect', 'onSearchChange', 'open', 'placeholder', 'resultRenderer', 'results', 'selectFirstResult', 'showNoResults', 'size', 'value'];

/***/ }),
/* 895 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(394),
	    createWrap = __webpack_require__(624),
	    getHolder = __webpack_require__(650),
	    replaceHolders = __webpack_require__(652);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_PARTIAL_RIGHT_FLAG = 64;
	
	/**
	 * This method is like `_.partial` except that partially applied arguments
	 * are appended to the arguments it receives.
	 *
	 * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	 * builds, may be used as a placeholder for partially applied arguments.
	 *
	 * **Note:** This method doesn't set the "length" property of partially
	 * applied functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Function
	 * @param {Function} func The function to partially apply arguments to.
	 * @param {...*} [partials] The arguments to be partially applied.
	 * @returns {Function} Returns the new partially applied function.
	 * @example
	 *
	 * function greet(greeting, name) {
	 *   return greeting + ' ' + name;
	 * }
	 *
	 * var greetFred = _.partialRight(greet, 'fred');
	 * greetFred('hi');
	 * // => 'hi fred'
	 *
	 * // Partially applied with placeholders.
	 * var sayHelloTo = _.partialRight(greet, 'hello', _);
	 * sayHelloTo('fred');
	 * // => 'hello fred'
	 */
	var partialRight = baseRest(function(func, partials) {
	  var holders = replaceHolders(partials, getHolder(partialRight));
	  return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	});
	
	// Assign default placeholders.
	partialRight.placeholder = {};
	
	module.exports = partialRight;


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

	var baseInRange = __webpack_require__(898),
	    toFinite = __webpack_require__(576),
	    toNumber = __webpack_require__(577);
	
	/**
	 * Checks if `n` is between `start` and up to, but not including, `end`. If
	 * `end` is not specified, it's set to `start` with `start` then set to `0`.
	 * If `start` is greater than `end` the params are swapped to support
	 * negative ranges.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.3.0
	 * @category Number
	 * @param {number} number The number to check.
	 * @param {number} [start=0] The start of the range.
	 * @param {number} end The end of the range.
	 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	 * @see _.range, _.rangeRight
	 * @example
	 *
	 * _.inRange(3, 2, 4);
	 * // => true
	 *
	 * _.inRange(4, 8);
	 * // => true
	 *
	 * _.inRange(4, 2);
	 * // => false
	 *
	 * _.inRange(2, 2);
	 * // => false
	 *
	 * _.inRange(1.2, 2);
	 * // => true
	 *
	 * _.inRange(5.2, 4);
	 * // => false
	 *
	 * _.inRange(-3, -2, -6);
	 * // => true
	 */
	function inRange(number, start, end) {
	  start = toFinite(start);
	  if (end === undefined) {
	    end = start;
	    start = 0;
	  } else {
	    end = toFinite(end);
	  }
	  number = toNumber(number);
	  return baseInRange(number, start, end);
	}
	
	module.exports = inRange;


/***/ }),
/* 898 */
/***/ (function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * The base implementation of `_.inRange` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {number} number The number to check.
	 * @param {number} start The start of the range.
	 * @param {number} end The end of the range.
	 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	 */
	function baseInRange(number, start, end) {
	  return number >= nativeMin(start, end) && number < nativeMax(start, end);
	}
	
	module.exports = baseInRange;


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultRenderer = function defaultRenderer(_ref) {
	  var name = _ref.name;
	  return name;
	};
	
	function SearchCategory(props) {
	  var active = props.active,
	      children = props.children,
	      className = props.className,
	      renderer = props.renderer;
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(active, 'active'), 'category', className);
	  var rest = (0, _lib.getUnhandledProps)(SearchCategory, props);
	  var ElementType = (0, _lib.getElementType)(SearchCategory, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _react2.default.createElement(
	      'div',
	      { className: 'name' },
	      renderer ? renderer(props) : defaultRenderer(props)
	    ),
	    children
	  );
	}
	
	SearchCategory.handledProps = ['active', 'as', 'children', 'className', 'name', 'renderer', 'results'];
	SearchCategory._meta = {
	  name: 'SearchCategory',
	  parent: 'Search',
	  type: _lib.META.TYPES.MODULE
	};
	
	 false ? SearchCategory.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** The item currently selected by keyboard shortcut. */
	  active: _react.PropTypes.bool,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Display name. */
	  name: _react.PropTypes.string,
	
	  /**
	   * A function that returns the category contents.
	   * Receives all SearchCategory props.
	   */
	  renderer: _react.PropTypes.func,
	
	  /** Array of Search.Result props */
	  results: _react.PropTypes.array
	} : void 0;
	
	exports.default = SearchCategory;

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(513);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(514);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(518);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(552);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Note: You technically only need the 'content' wrapper when there's an
	// image. However, optionally wrapping it makes this function a lot more
	// complicated and harder to read. Since always wrapping it doesn't affect
	// the style in any way let's just do that.
	//
	// Note: To avoid requiring a wrapping div, we return an array here so to
	// prevent rendering issues each node needs a unique key.
	var defaultRenderer = function defaultRenderer(_ref) {
	  var image = _ref.image,
	      price = _ref.price,
	      title = _ref.title,
	      description = _ref.description;
	  return [image && _react2.default.createElement(
	    'div',
	    { key: 'image', className: 'image' },
	    (0, _lib.createHTMLImage)(image)
	  ), _react2.default.createElement(
	    'div',
	    { key: 'content', className: 'content' },
	    price && _react2.default.createElement(
	      'div',
	      { className: 'price' },
	      price
	    ),
	    title && _react2.default.createElement(
	      'div',
	      { className: 'title' },
	      title
	    ),
	    description && _react2.default.createElement(
	      'div',
	      { className: 'description' },
	      description
	    )
	  )];
	};
	
	defaultRenderer.handledProps = [];
	
	var SearchResult = function (_Component) {
	  (0, _inherits3.default)(SearchResult, _Component);
	
	  function SearchResult() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SearchResult);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = SearchResult.__proto__ || Object.getPrototypeOf(SearchResult)).call.apply(_ref2, [this].concat(args))), _this), _this.handleClick = function (e) {
	      var onClick = _this.props.onClick;
	
	
	      if (onClick) onClick(e, _this.props);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SearchResult, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          className = _props.className,
	          renderer = _props.renderer;
	
	
	      var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(active, 'active'), 'result', className);
	      var rest = (0, _lib.getUnhandledProps)(SearchResult, this.props);
	      var ElementType = (0, _lib.getElementType)(SearchResult, this.props);
	
	      // Note: You technically only need the 'content' wrapper when there's an
	      // image. However, optionally wrapping it makes this function a lot more
	      // complicated and harder to read. Since always wrapping it doesn't affect
	      // the style in any way let's just do that.
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes, onClick: this.handleClick }),
	        renderer ? renderer(this.props) : defaultRenderer(this.props)
	      );
	    }
	  }]);
	  return SearchResult;
	}(_react.Component);
	
	SearchResult._meta = {
	  name: 'SearchResult',
	  parent: 'Search',
	  type: _lib.META.TYPES.MODULE
	};
	exports.default = SearchResult;
	 false ? SearchResult.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** The item currently selected by keyboard shortcut. */
	  active: _react.PropTypes.bool,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Additional text with less emphasis. */
	  description: _react.PropTypes.string,
	
	  /** A unique identifier. */
	  id: _react.PropTypes.number,
	
	  /** Add an image to the item. */
	  image: _react.PropTypes.string,
	
	  /**
	   * Called on click.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _react.PropTypes.func,
	
	  /** Customized text for price. */
	  price: _react.PropTypes.string,
	
	  /**
	   * A function that returns the result contents.
	   * Receives all SearchResult props.
	   */
	  renderer: _react.PropTypes.func,
	
	  /** Display title. */
	  title: _react.PropTypes.string
	} : void 0;
	SearchResult.handledProps = ['active', 'as', 'className', 'description', 'id', 'image', 'onClick', 'price', 'renderer', 'title'];

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SearchResults(props) {
	  var children = props.children,
	      className = props.className;
	
	  var classes = (0, _classnames2.default)('results transition', className);
	  var rest = (0, _lib.getUnhandledProps)(SearchResults, props);
	  var ElementType = (0, _lib.getElementType)(SearchResults, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	SearchResults.handledProps = ['as', 'children', 'className'];
	SearchResults._meta = {
	  name: 'SearchResults',
	  parent: 'Search',
	  type: _lib.META.TYPES.MODULE
	};
	
	 false ? SearchResults.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string
	} : void 0;
	
	exports.default = SearchResults;

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Sidebar = __webpack_require__(903);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Sidebar2.default;

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(513);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(514);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(518);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(552);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _SidebarPushable = __webpack_require__(904);
	
	var _SidebarPushable2 = _interopRequireDefault(_SidebarPushable);
	
	var _SidebarPusher = __webpack_require__(905);
	
	var _SidebarPusher2 = _interopRequireDefault(_SidebarPusher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A sidebar hides additional content beside a page.
	 */
	var Sidebar = function (_Component) {
	  (0, _inherits3.default)(Sidebar, _Component);
	
	  function Sidebar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Sidebar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.startAnimating = function () {
	      var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 500;
	
	      clearTimeout(_this.stopAnimatingTimer);
	
	      _this.setState({ animating: true });
	
	      _this.stopAnimatingTimer = setTimeout(function () {
	        return _this.setState({ animating: false });
	      }, duration);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Sidebar, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.visible !== this.props.visible) {
	        this.startAnimating();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          animation = _props.animation,
	          className = _props.className,
	          children = _props.children,
	          direction = _props.direction,
	          visible = _props.visible,
	          width = _props.width;
	      var animating = this.state.animating;
	
	
	      var classes = (0, _classnames2.default)('ui', animation, direction, width, (0, _lib.useKeyOnly)(animating, 'animating'), (0, _lib.useKeyOnly)(visible, 'visible'), 'sidebar', className);
	
	      var rest = (0, _lib.getUnhandledProps)(Sidebar, this.props);
	      var ElementType = (0, _lib.getElementType)(Sidebar, this.props);
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes }),
	        children
	      );
	    }
	  }]);
	  return Sidebar;
	}(_lib.AutoControlledComponent);
	
	Sidebar.defaultProps = {
	  direction: 'left'
	};
	Sidebar.autoControlledProps = ['visible'];
	Sidebar._meta = {
	  name: 'Sidebar',
	  type: _lib.META.TYPES.MODULE
	};
	Sidebar.Pushable = _SidebarPushable2.default;
	Sidebar.Pusher = _SidebarPusher2.default;
	 false ? Sidebar.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Animation style. */
	  animation: _react.PropTypes.oneOf(['overlay', 'push', 'scale down', 'uncover', 'slide out', 'slide along']),
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Initial value of visible. */
	  defaultVisible: _react.PropTypes.bool,
	
	  /** Direction the sidebar should appear on. */
	  direction: _react.PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /** Controls whether or not the sidebar is visible on the page. */
	  visible: _react.PropTypes.bool,
	
	  /** Sidebar width. */
	  width: _react.PropTypes.oneOf(['very thin', 'thin', 'wide', 'very wide'])
	} : void 0;
	Sidebar.handledProps = ['animation', 'as', 'children', 'className', 'defaultVisible', 'direction', 'visible', 'width'];
	exports.default = Sidebar;

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A pushable sub-component for Sidebar.
	 */
	function SidebarPushable(props) {
	  var className = props.className,
	      children = props.children;
	
	  var classes = (0, _classnames2.default)('pushable', className);
	  var rest = (0, _lib.getUnhandledProps)(SidebarPushable, props);
	  var ElementType = (0, _lib.getElementType)(SidebarPushable, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	SidebarPushable.handledProps = ['as', 'children', 'className'];
	SidebarPushable._meta = {
	  name: 'SidebarPushable',
	  type: _lib.META.TYPES.MODULE,
	  parent: 'Sidebar'
	};
	
	 false ? SidebarPushable.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string
	} : void 0;
	
	exports.default = SidebarPushable;

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A pushable sub-component for Sidebar.
	 */
	function SidebarPusher(props) {
	  var className = props.className,
	      dimmed = props.dimmed,
	      children = props.children;
	
	
	  var classes = (0, _classnames2.default)('pusher', (0, _lib.useKeyOnly)(dimmed, 'dimmed'), className);
	  var rest = (0, _lib.getUnhandledProps)(SidebarPusher, props);
	  var ElementType = (0, _lib.getElementType)(SidebarPusher, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	SidebarPusher.handledProps = ['as', 'children', 'className', 'dimmed'];
	SidebarPusher._meta = {
	  name: 'SidebarPusher',
	  type: _lib.META.TYPES.MODULE,
	  parent: 'Sidebar'
	};
	
	 false ? SidebarPusher.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Controls whether or not the dim is displayed. */
	  dimmed: _react.PropTypes.bool
	} : void 0;
	
	exports.default = SidebarPusher;

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(513);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(514);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(518);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(552);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _Image = __webpack_require__(780);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _CardContent = __webpack_require__(907);
	
	var _CardContent2 = _interopRequireDefault(_CardContent);
	
	var _CardDescription = __webpack_require__(908);
	
	var _CardDescription2 = _interopRequireDefault(_CardDescription);
	
	var _CardGroup = __webpack_require__(911);
	
	var _CardGroup2 = _interopRequireDefault(_CardGroup);
	
	var _CardHeader = __webpack_require__(909);
	
	var _CardHeader2 = _interopRequireDefault(_CardHeader);
	
	var _CardMeta = __webpack_require__(910);
	
	var _CardMeta2 = _interopRequireDefault(_CardMeta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A card displays site content in a manner similar to a playing card.
	 */
	var Card = function (_Component) {
	  (0, _inherits3.default)(Card, _Component);
	
	  function Card() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Card);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Card.__proto__ || Object.getPrototypeOf(Card)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
	      var onClick = _this.props.onClick;
	
	
	      if (onClick) onClick(e, _this.props);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Card, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          centered = _props.centered,
	          children = _props.children,
	          className = _props.className,
	          color = _props.color,
	          description = _props.description,
	          extra = _props.extra,
	          fluid = _props.fluid,
	          header = _props.header,
	          href = _props.href,
	          image = _props.image,
	          meta = _props.meta,
	          onClick = _props.onClick,
	          raised = _props.raised;
	
	
	      var classes = (0, _classnames2.default)('ui', color, (0, _lib.useKeyOnly)(centered, 'centered'), (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(raised, 'raised'), 'card', className);
	      var rest = (0, _lib.getUnhandledProps)(Card, this.props);
	      var ElementType = (0, _lib.getElementType)(Card, this.props, function () {
	        if (onClick) return 'a';
	      });
	
	      if (!(0, _isNil3.default)(children)) {
	        return _react2.default.createElement(
	          ElementType,
	          (0, _extends3.default)({}, rest, { className: classes, href: href, onClick: this.handleClick }),
	          children
	        );
	      }
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes, href: href, onClick: this.handleClick }),
	        _Image2.default.create(image),
	        (description || header || meta) && _react2.default.createElement(_CardContent2.default, { description: description, header: header, meta: meta }),
	        extra && _react2.default.createElement(
	          _CardContent2.default,
	          { extra: true },
	          extra
	        )
	      );
	    }
	  }]);
	  return Card;
	}(_react.Component);
	
	Card._meta = {
	  name: 'Card',
	  type: _lib.META.TYPES.VIEW
	};
	Card.Content = _CardContent2.default;
	Card.Description = _CardDescription2.default;
	Card.Group = _CardGroup2.default;
	Card.Header = _CardHeader2.default;
	Card.Meta = _CardMeta2.default;
	exports.default = Card;
	 false ? Card.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A Card can center itself inside its container. */
	  centered: _react.PropTypes.bool,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** A Card can be formatted to display different colors. */
	  color: _react.PropTypes.oneOf(_lib.SUI.COLORS),
	
	  /** Shorthand for CardDescription. */
	  description: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for primary content of CardContent. */
	  extra: _lib.customPropTypes.contentShorthand,
	
	  /** A Card can be formatted to take up the width of its container. */
	  fluid: _react.PropTypes.bool,
	
	  /** Shorthand for CardHeader. */
	  header: _lib.customPropTypes.itemShorthand,
	
	  /** Render as an `a` tag instead of a `div` and adds the href attribute. */
	  href: _react.PropTypes.string,
	
	  /** A card can contain an Image component. */
	  image: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for CardMeta. */
	  meta: _lib.customPropTypes.itemShorthand,
	
	  /**
	   * Called on click. When passed, the component renders as an `a`
	   * tag by default instead of a `div`.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _react.PropTypes.func,
	
	  /** A Card can be formatted to raise above the page. */
	  raised: _react.PropTypes.bool
	} : void 0;
	Card.handledProps = ['as', 'centered', 'children', 'className', 'color', 'description', 'extra', 'fluid', 'header', 'href', 'image', 'meta', 'onClick', 'raised'];

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _CardDescription = __webpack_require__(908);
	
	var _CardDescription2 = _interopRequireDefault(_CardDescription);
	
	var _CardHeader = __webpack_require__(909);
	
	var _CardHeader2 = _interopRequireDefault(_CardHeader);
	
	var _CardMeta = __webpack_require__(910);
	
	var _CardMeta2 = _interopRequireDefault(_CardMeta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A card can contain blocks of content or extra content meant to be formatted separately from the main content.
	 */
	function CardContent(props) {
	  var children = props.children,
	      className = props.className,
	      description = props.description,
	      extra = props.extra,
	      header = props.header,
	      meta = props.meta;
	
	
	  var classes = (0, _classnames2.default)(className, (0, _lib.useKeyOnly)(extra, 'extra'), 'content');
	  var rest = (0, _lib.getUnhandledProps)(CardContent, props);
	  var ElementType = (0, _lib.getElementType)(CardContent, props);
	
	  if (!(0, _isNil3.default)(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _lib.createShorthand)(_CardHeader2.default, function (val) {
	      return { content: val };
	    }, header),
	    (0, _lib.createShorthand)(_CardMeta2.default, function (val) {
	      return { content: val };
	    }, meta),
	    (0, _lib.createShorthand)(_CardDescription2.default, function (val) {
	      return { content: val };
	    }, description)
	  );
	}
	
	CardContent.handledProps = ['as', 'children', 'className', 'description', 'extra', 'header', 'meta'];
	CardContent._meta = {
	  name: 'CardContent',
	  parent: 'Card',
	  type: _lib.META.TYPES.VIEW
	};
	
	 false ? CardContent.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for CardDescription. */
	  description: _lib.customPropTypes.itemShorthand,
	
	  /** A card can contain extra content meant to be formatted separately from the main content. */
	  extra: _react.PropTypes.bool,
	
	  /** Shorthand for CardHeader. */
	  header: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for CardMeta. */
	  meta: _lib.customPropTypes.itemShorthand
	} : void 0;
	
	exports.default = CardContent;

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A card can contain a description with one or more paragraphs.
	 */
	function CardDescription(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)(className, 'description');
	  var rest = (0, _lib.getUnhandledProps)(CardDescription, props);
	  var ElementType = (0, _lib.getElementType)(CardDescription, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _isNil3.default)(children) ? content : children
	  );
	}
	
	CardDescription.handledProps = ['as', 'children', 'className', 'content'];
	CardDescription._meta = {
	  name: 'CardDescription',
	  parent: 'Card',
	  type: _lib.META.TYPES.VIEW
	};
	
	 false ? CardDescription.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : void 0;
	
	exports.default = CardDescription;

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A card can contain a header.
	 */
	function CardHeader(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)(className, 'header');
	  var rest = (0, _lib.getUnhandledProps)(CardHeader, props);
	  var ElementType = (0, _lib.getElementType)(CardHeader, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _isNil3.default)(children) ? content : children
	  );
	}
	
	CardHeader.handledProps = ['as', 'children', 'className', 'content'];
	CardHeader._meta = {
	  name: 'CardHeader',
	  parent: 'Card',
	  type: _lib.META.TYPES.VIEW
	};
	
	 false ? CardHeader.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : void 0;
	
	exports.default = CardHeader;

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A card can contain content metadata.
	 */
	function CardMeta(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)(className, 'meta');
	  var rest = (0, _lib.getUnhandledProps)(CardMeta, props);
	  var ElementType = (0, _lib.getElementType)(CardMeta, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _isNil3.default)(children) ? content : children
	  );
	}
	
	CardMeta.handledProps = ['as', 'children', 'className', 'content'];
	CardMeta._meta = {
	  name: 'CardMeta',
	  parent: 'Card',
	  type: _lib.META.TYPES.VIEW
	};
	
	 false ? CardMeta.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : void 0;
	
	exports.default = CardMeta;

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _map2 = __webpack_require__(702);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _Card = __webpack_require__(906);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A group of cards.
	 */
	function CardGroup(props) {
	  var children = props.children,
	      className = props.className,
	      doubling = props.doubling,
	      items = props.items,
	      itemsPerRow = props.itemsPerRow,
	      stackable = props.stackable;
	
	
	  var classes = (0, _classnames2.default)('ui', (0, _lib.useKeyOnly)(doubling, 'doubling'), (0, _lib.useKeyOnly)(stackable, 'stackable'), (0, _lib.useWidthProp)(itemsPerRow), className, 'cards');
	  var rest = (0, _lib.getUnhandledProps)(CardGroup, props);
	  var ElementType = (0, _lib.getElementType)(CardGroup, props);
	
	  if (!(0, _isNil3.default)(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  var content = (0, _map3.default)(items, function (item) {
	    var key = item.key || [item.header, item.description].join('-');
	    return _react2.default.createElement(_Card2.default, (0, _extends3.default)({ key: key }, item));
	  });
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    content
	  );
	}
	
	CardGroup.handledProps = ['as', 'children', 'className', 'doubling', 'items', 'itemsPerRow', 'stackable'];
	CardGroup._meta = {
	  name: 'CardGroup',
	  parent: 'Card',
	  type: _lib.META.TYPES.VIEW
	};
	
	 false ? CardGroup.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** A group of cards can double its column width for mobile. */
	  doubling: _react.PropTypes.bool,
	
	  /** Shorthand array of props for Card. */
	  items: _lib.customPropTypes.collectionShorthand,
	
	  /** A group of cards can set how many cards should exist in a row. */
	  itemsPerRow: _react.PropTypes.oneOf(_lib.SUI.WIDTHS),
	
	  /** A group of cards can automatically stack rows to a single columns on mobile devices. */
	  stackable: _react.PropTypes.bool
	} : void 0;
	
	exports.default = CardGroup;

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Comment = __webpack_require__(913);
	
	var _Comment2 = _interopRequireDefault(_Comment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Comment2.default;

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _CommentAction = __webpack_require__(914);
	
	var _CommentAction2 = _interopRequireDefault(_CommentAction);
	
	var _CommentActions = __webpack_require__(915);
	
	var _CommentActions2 = _interopRequireDefault(_CommentActions);
	
	var _CommentAuthor = __webpack_require__(916);
	
	var _CommentAuthor2 = _interopRequireDefault(_CommentAuthor);
	
	var _CommentAvatar = __webpack_require__(917);
	
	var _CommentAvatar2 = _interopRequireDefault(_CommentAvatar);
	
	var _CommentContent = __webpack_require__(918);
	
	var _CommentContent2 = _interopRequireDefault(_CommentContent);
	
	var _CommentGroup = __webpack_require__(919);
	
	var _CommentGroup2 = _interopRequireDefault(_CommentGroup);
	
	var _CommentMetadata = __webpack_require__(920);
	
	var _CommentMetadata2 = _interopRequireDefault(_CommentMetadata);
	
	var _CommentText = __webpack_require__(921);
	
	var _CommentText2 = _interopRequireDefault(_CommentText);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A comment displays user feedback to site content.
	 * */
	function Comment(props) {
	  var className = props.className,
	      children = props.children,
	      collapsed = props.collapsed;
	
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(collapsed, 'collapsed'), 'comment', className);
	  var rest = (0, _lib.getUnhandledProps)(Comment, props);
	  var ElementType = (0, _lib.getElementType)(Comment, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	Comment.handledProps = ['as', 'children', 'className', 'collapsed'];
	Comment._meta = {
	  name: 'Comment',
	  type: _lib.META.TYPES.VIEW
	};
	
	 false ? Comment.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Comment can be collapsed, or hidden from view. */
	  collapsed: _react.PropTypes.bool
	} : void 0;
	
	Comment.Author = _CommentAuthor2.default;
	Comment.Action = _CommentAction2.default;
	Comment.Actions = _CommentActions2.default;
	Comment.Avatar = _CommentAvatar2.default;
	Comment.Content = _CommentContent2.default;
	Comment.Group = _CommentGroup2.default;
	Comment.Metadata = _CommentMetadata2.default;
	Comment.Text = _CommentText2.default;
	
	exports.default = Comment;

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A comment can contain an action.
	 */
	function CommentAction(props) {
	  var active = props.active,
	      className = props.className,
	      children = props.children;
	
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(active, 'active'), className);
	  var rest = (0, _lib.getUnhandledProps)(CommentAction, props);
	  var ElementType = (0, _lib.getElementType)(CommentAction, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	CommentAction.handledProps = ['active', 'as', 'children', 'className'];
	CommentAction._meta = {
	  name: 'CommentAction',
	  parent: 'Comment',
	  type: _lib.META.TYPES.VIEW
	};
	
	CommentAction.defaultProps = {
	  as: 'a'
	};
	
	 false ? CommentAction.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Style as the currently active action. */
	  active: _react.PropTypes.bool,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string
	} : void 0;
	
	exports.default = CommentAction;

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A comment can contain an list of actions a user may perform related to this comment.
	 */
	function CommentActions(props) {
	  var className = props.className,
	      children = props.children;
	
	  var classes = (0, _classnames2.default)('actions', className);
	  var rest = (0, _lib.getUnhandledProps)(CommentActions, props);
	  var ElementType = (0, _lib.getElementType)(CommentActions, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	CommentActions.handledProps = ['as', 'children', 'className'];
	CommentActions._meta = {
	  name: 'CommentActions',
	  parent: 'Comment',
	  type: _lib.META.TYPES.VIEW
	};
	
	 false ? CommentActions.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string
	} : void 0;
	
	exports.default = CommentActions;

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A comment can contain an author.
	 */
	function CommentAuthor(props) {
	  var className = props.className,
	      children = props.children;
	
	  var classes = (0, _classnames2.default)('author', className);
	  var rest = (0, _lib.getUnhandledProps)(CommentAuthor, props);
	  var ElementType = (0, _lib.getElementType)(CommentAuthor, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	CommentAuthor.handledProps = ['as', 'children', 'className'];
	CommentAuthor._meta = {
	  name: 'CommentAuthor',
	  parent: 'Comment',
	  type: _lib.META.TYPES.VIEW
	};
	
	 false ? CommentAuthor.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string
	} : void 0;
	
	exports.default = CommentAuthor;

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A comment can contain an image or avatar.
	 */
	function CommentAvatar(props) {
	  var className = props.className,
	      src = props.src;
	
	  var classes = (0, _classnames2.default)('avatar', className);
	  var rest = (0, _lib.getUnhandledProps)(CommentAvatar, props);
	  var ElementType = (0, _lib.getElementType)(CommentAvatar, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _lib.createHTMLImage)(src)
	  );
	}
	
	CommentAvatar.handledProps = ['as', 'className', 'src'];
	CommentAvatar._meta = {
	  name: 'CommentAvatar',
	  parent: 'Comment',
	  type: _lib.META.TYPES.VIEW
	};
	
	 false ? CommentAvatar.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Specifies the URL of the image. */
	  src: _react.PropTypes.string
	} : void 0;
	
	exports.default = CommentAvatar;

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A comment can contain content.
	 */
	function CommentContent(props) {
	  var className = props.className,
	      children = props.children;
	
	  var classes = (0, _classnames2.default)(className, 'content');
	  var rest = (0, _lib.getUnhandledProps)(CommentContent, props);
	  var ElementType = (0, _lib.getElementType)(CommentContent, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	CommentContent.handledProps = ['as', 'children', 'className'];
	CommentContent._meta = {
	  name: 'CommentContent',
	  parent: 'Comment',
	  type: _lib.META.TYPES.VIEW
	};
	
	 false ? CommentContent.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string
	} : void 0;
	
	exports.default = CommentContent;

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Comments can be grouped.
	 */
	function CommentGroup(props) {
	  var className = props.className,
	      children = props.children,
	      collapsed = props.collapsed,
	      minimal = props.minimal,
	      threaded = props.threaded;
	
	
	  var classes = (0, _classnames2.default)('ui', (0, _lib.useKeyOnly)(collapsed, 'collapsed'), (0, _lib.useKeyOnly)(minimal, 'minimal'), (0, _lib.useKeyOnly)(threaded, 'threaded'), 'comments', className);
	  var rest = (0, _lib.getUnhandledProps)(CommentGroup, props);
	  var ElementType = (0, _lib.getElementType)(CommentGroup, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	CommentGroup.handledProps = ['as', 'children', 'className', 'collapsed', 'minimal', 'threaded'];
	CommentGroup._meta = {
	  name: 'CommentGroup',
	  parent: 'Comment',
	  type: _lib.META.TYPES.VIEW
	};
	
	 false ? CommentGroup.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Comments can be collapsed, or hidden from view. */
	  collapsed: _react.PropTypes.bool,
	
	  /** Comments can hide extra information unless a user shows intent to interact with a comment. */
	  minimal: _react.PropTypes.bool,
	
	  /** A comment list can be threaded to showing the relationship between conversations. */
	  threaded: _react.PropTypes.bool
	} : void 0;
	
	exports.default = CommentGroup;

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A comment can contain metadata about the comment, an arbitrary amount of metadata may be defined.
	 */
	function CommentMetadata(props) {
	  var className = props.className,
	      children = props.children;
	
	  var classes = (0, _classnames2.default)('metadata', className);
	  var rest = (0, _lib.getUnhandledProps)(CommentMetadata, props);
	  var ElementType = (0, _lib.getElementType)(CommentMetadata, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	CommentMetadata.handledProps = ['as', 'children', 'className'];
	CommentMetadata._meta = {
	  name: 'CommentMetadata',
	  parent: 'Comment',
	  type: _lib.META.TYPES.VIEW
	};
	
	 false ? CommentMetadata.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string
	} : void 0;
	
	exports.default = CommentMetadata;

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A comment can contain text.
	 */
	function CommentText(props) {
	  var className = props.className,
	      children = props.children;
	
	  var classes = (0, _classnames2.default)(className, 'text');
	  var rest = (0, _lib.getUnhandledProps)(CommentText, props);
	  var ElementType = (0, _lib.getElementType)(CommentText, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	CommentText.handledProps = ['as', 'children', 'className'];
	CommentText._meta = {
	  name: 'CommentText',
	  parent: 'Comment',
	  type: _lib.META.TYPES.VIEW
	};
	
	 false ? CommentText.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string
	} : void 0;
	
	exports.default = CommentText;

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Feed = __webpack_require__(923);
	
	var _Feed2 = _interopRequireDefault(_Feed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Feed2.default;

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(895);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(723);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _map2 = __webpack_require__(702);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _FeedContent = __webpack_require__(924);
	
	var _FeedContent2 = _interopRequireDefault(_FeedContent);
	
	var _FeedDate = __webpack_require__(925);
	
	var _FeedDate2 = _interopRequireDefault(_FeedDate);
	
	var _FeedEvent = __webpack_require__(931);
	
	var _FeedEvent2 = _interopRequireDefault(_FeedEvent);
	
	var _FeedExtra = __webpack_require__(926);
	
	var _FeedExtra2 = _interopRequireDefault(_FeedExtra);
	
	var _FeedLabel = __webpack_require__(932);
	
	var _FeedLabel2 = _interopRequireDefault(_FeedLabel);
	
	var _FeedLike = __webpack_require__(928);
	
	var _FeedLike2 = _interopRequireDefault(_FeedLike);
	
	var _FeedMeta = __webpack_require__(927);
	
	var _FeedMeta2 = _interopRequireDefault(_FeedMeta);
	
	var _FeedSummary = __webpack_require__(929);
	
	var _FeedSummary2 = _interopRequireDefault(_FeedSummary);
	
	var _FeedUser = __webpack_require__(930);
	
	var _FeedUser2 = _interopRequireDefault(_FeedUser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Feed(props) {
	  var children = props.children,
	      className = props.className,
	      events = props.events,
	      size = props.size;
	
	
	  var classes = (0, _classnames2.default)('ui', size, 'feed', className);
	  var rest = (0, _lib.getUnhandledProps)(Feed, props);
	  var ElementType = (0, _lib.getElementType)(Feed, props);
	
	  if (!(0, _isNil3.default)(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  var eventElements = (0, _map3.default)(events, function (eventProps) {
	    var childKey = eventProps.childKey,
	        date = eventProps.date,
	        meta = eventProps.meta,
	        summary = eventProps.summary,
	        eventData = (0, _objectWithoutProperties3.default)(eventProps, ['childKey', 'date', 'meta', 'summary']);
	
	    var finalKey = childKey || [date, meta, summary].join('-');
	
	    return _react2.default.createElement(_FeedEvent2.default, (0, _extends3.default)({
	      date: date,
	      key: finalKey,
	      meta: meta,
	      summary: summary
	    }, eventData));
	  });
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    eventElements
	  );
	}
	
	Feed.handledProps = ['as', 'children', 'className', 'events', 'size'];
	Feed._meta = {
	  name: 'Feed',
	  type: _lib.META.TYPES.VIEW
	};
	
	 false ? Feed.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand array of props for FeedEvent. */
	  events: _lib.customPropTypes.collectionShorthand,
	
	  /** A feed can have different sizes. */
	  size: _react.PropTypes.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'mini', 'tiny', 'medium', 'big', 'huge', 'massive'))
	} : void 0;
	
	Feed.Content = _FeedContent2.default;
	Feed.Date = _FeedDate2.default;
	Feed.Event = _FeedEvent2.default;
	Feed.Extra = _FeedExtra2.default;
	Feed.Label = _FeedLabel2.default;
	Feed.Like = _FeedLike2.default;
	Feed.Meta = _FeedMeta2.default;
	Feed.Summary = _FeedSummary2.default;
	Feed.User = _FeedUser2.default;
	
	exports.default = Feed;

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _FeedDate = __webpack_require__(925);
	
	var _FeedDate2 = _interopRequireDefault(_FeedDate);
	
	var _FeedExtra = __webpack_require__(926);
	
	var _FeedExtra2 = _interopRequireDefault(_FeedExtra);
	
	var _FeedMeta = __webpack_require__(927);
	
	var _FeedMeta2 = _interopRequireDefault(_FeedMeta);
	
	var _FeedSummary = __webpack_require__(929);
	
	var _FeedSummary2 = _interopRequireDefault(_FeedSummary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FeedContent(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      extraImages = props.extraImages,
	      extraText = props.extraText,
	      date = props.date,
	      meta = props.meta,
	      summary = props.summary;
	
	
	  var classes = (0, _classnames2.default)('content', className);
	  var rest = (0, _lib.getUnhandledProps)(FeedContent, props);
	  var ElementType = (0, _lib.getElementType)(FeedContent, props);
	
	  if (!(0, _isNil3.default)(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _lib.createShorthand)(_FeedDate2.default, function (val) {
	      return { content: val };
	    }, date),
	    (0, _lib.createShorthand)(_FeedSummary2.default, function (val) {
	      return { content: val };
	    }, summary),
	    content,
	    (0, _lib.createShorthand)(_FeedExtra2.default, function (val) {
	      return { text: true, content: val };
	    }, extraText),
	    (0, _lib.createShorthand)(_FeedExtra2.default, function (val) {
	      return { images: val };
	    }, extraImages),
	    (0, _lib.createShorthand)(_FeedMeta2.default, function (val) {
	      return { content: val };
	    }, meta)
	  );
	}
	
	FeedContent.handledProps = ['as', 'children', 'className', 'content', 'date', 'extraImages', 'extraText', 'meta', 'summary'];
	FeedContent._meta = {
	  name: 'FeedContent',
	  parent: 'Feed',
	  type: _lib.META.TYPES.VIEW
	};
	
	 false ? FeedContent.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** An event can contain a date. */
	  date: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for FeedExtra with images. */
	  extraImages: _FeedExtra2.default.propTypes.images,
	
	  /** Shorthand for FeedExtra with text. */
	  extraText: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for FeedMeta. */
	  meta: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for FeedSummary. */
	  summary: _lib.customPropTypes.itemShorthand
	} : void 0;
	
	exports.default = FeedContent;

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An event or an event summary can contain a date.
	 */
	function FeedDate(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('date', className);
	  var rest = (0, _lib.getUnhandledProps)(FeedDate, props);
	  var ElementType = (0, _lib.getElementType)(FeedDate, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _isNil3.default)(children) ? content : children
	  );
	}
	
	FeedDate.handledProps = ['as', 'children', 'className', 'content'];
	FeedDate._meta = {
	  name: 'FeedDate',
	  parent: 'Feed',
	  type: _lib.META.TYPES.VIEW
	};
	
	 false ? FeedDate.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : void 0;
	
	exports.default = FeedDate;

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _map2 = __webpack_require__(702);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A feed can contain an extra content.
	 */
	function FeedExtra(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      images = props.images,
	      text = props.text;
	
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(images, 'images'), (0, _lib.useKeyOnly)(content || text, 'text'), 'extra', className);
	  var rest = (0, _lib.getUnhandledProps)(FeedExtra, props);
	  var ElementType = (0, _lib.getElementType)(FeedExtra, props);
	
	  if (!(0, _isNil3.default)(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  // TODO need a "collection factory" to handle creating multiple image elements and their keys
	  var imageElements = (0, _map3.default)(images, function (image, index) {
	    var key = [index, image].join('-');
	    return (0, _lib.createHTMLImage)(image, { key: key });
	  });
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    content,
	    imageElements
	  );
	}
	
	FeedExtra.handledProps = ['as', 'children', 'className', 'content', 'images', 'text'];
	FeedExtra._meta = {
	  name: 'FeedExtra',
	  parent: 'Feed',
	  type: _lib.META.TYPES.VIEW
	};
	
	 false ? FeedExtra.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** An event can contain additional information like a set of images. */
	  images: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['text']), _react.PropTypes.oneOfType([_react.PropTypes.bool, _lib.customPropTypes.collectionShorthand])]),
	
	  /** An event can contain additional text information. */
	  text: _react.PropTypes.bool
	} : void 0;
	
	exports.default = FeedExtra;

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _FeedLike = __webpack_require__(928);
	
	var _FeedLike2 = _interopRequireDefault(_FeedLike);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A feed can contain a meta.
	 */
	function FeedMeta(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      like = props.like;
	
	
	  var classes = (0, _classnames2.default)('meta', className);
	  var rest = (0, _lib.getUnhandledProps)(FeedMeta, props);
	  var ElementType = (0, _lib.getElementType)(FeedMeta, props);
	
	  if (!(0, _isNil3.default)(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _lib.createShorthand)(_FeedLike2.default, function (val) {
	      return { content: val };
	    }, like),
	    content
	  );
	}
	
	FeedMeta.handledProps = ['as', 'children', 'className', 'content', 'like'];
	FeedMeta._meta = {
	  name: 'FeedMeta',
	  parent: 'Feed',
	  type: _lib.META.TYPES.VIEW
	};
	
	 false ? FeedMeta.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Shorthand for FeedLike. */
	  like: _lib.customPropTypes.itemShorthand
	} : void 0;
	
	exports.default = FeedMeta;

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _Icon = __webpack_require__(750);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A feed can contain a like element.
	 */
	function FeedLike(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      icon = props.icon;
	
	
	  var classes = (0, _classnames2.default)('like', className);
	  var rest = (0, _lib.getUnhandledProps)(FeedLike, props);
	  var ElementType = (0, _lib.getElementType)(FeedLike, props);
	
	  if (!(0, _isNil3.default)(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _Icon2.default.create(icon),
	    content
	  );
	}
	
	FeedLike.handledProps = ['as', 'children', 'className', 'content', 'icon'];
	FeedLike._meta = {
	  name: 'FeedLike',
	  parent: 'Feed',
	  type: _lib.META.TYPES.VIEW
	};
	
	FeedLike.defaultProps = {
	  as: 'a'
	};
	
	 false ? FeedLike.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Shorthand for icon. Mutually exclusive with children. */
	  icon: _lib.customPropTypes.itemShorthand
	} : void 0;
	
	exports.default = FeedLike;

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _FeedDate = __webpack_require__(925);
	
	var _FeedDate2 = _interopRequireDefault(_FeedDate);
	
	var _FeedUser = __webpack_require__(930);
	
	var _FeedUser2 = _interopRequireDefault(_FeedUser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A feed can contain a summary.
	 */
	function FeedSummary(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      date = props.date,
	      user = props.user;
	
	
	  var classes = (0, _classnames2.default)('summary', className);
	  var rest = (0, _lib.getUnhandledProps)(FeedSummary, props);
	  var ElementType = (0, _lib.getElementType)(FeedSummary, props);
	
	  if (!(0, _isNil3.default)(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _lib.createShorthand)(_FeedUser2.default, function (val) {
	      return { content: val };
	    }, user),
	    content,
	    (0, _lib.createShorthand)(_FeedDate2.default, function (val) {
	      return { content: val };
	    }, date)
	  );
	}
	
	FeedSummary.handledProps = ['as', 'children', 'className', 'content', 'date', 'user'];
	FeedSummary._meta = {
	  name: 'FeedSummary',
	  parent: 'Feed',
	  type: _lib.META.TYPES.VIEW
	};
	
	 false ? FeedSummary.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Shorthand for FeedDate. */
	  date: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for FeedUser. */
	  user: _lib.customPropTypes.itemShorthand
	} : void 0;
	
	exports.default = FeedSummary;

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A feed can contain a user element.
	 */
	function FeedUser(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('user', className);
	  var rest = (0, _lib.getUnhandledProps)(FeedUser, props);
	  var ElementType = (0, _lib.getElementType)(FeedUser, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _isNil3.default)(children) ? content : children
	  );
	}
	
	FeedUser.handledProps = ['as', 'children', 'className', 'content'];
	FeedUser._meta = {
	  name: 'FeedUser',
	  parent: 'Feed',
	  type: _lib.META.TYPES.VIEW
	};
	
	 false ? FeedUser.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : void 0;
	
	FeedUser.defaultProps = {
	  as: 'a'
	};
	
	exports.default = FeedUser;

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _FeedContent = __webpack_require__(924);
	
	var _FeedContent2 = _interopRequireDefault(_FeedContent);
	
	var _FeedLabel = __webpack_require__(932);
	
	var _FeedLabel2 = _interopRequireDefault(_FeedLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A feed contains an event.
	 */
	function FeedEvent(props) {
	  var content = props.content,
	      children = props.children,
	      className = props.className,
	      date = props.date,
	      extraImages = props.extraImages,
	      extraText = props.extraText,
	      image = props.image,
	      icon = props.icon,
	      meta = props.meta,
	      summary = props.summary;
	
	
	  var classes = (0, _classnames2.default)('event', className);
	  var rest = (0, _lib.getUnhandledProps)(FeedEvent, props);
	  var ElementType = (0, _lib.getElementType)(FeedEvent, props);
	
	  var hasContentProp = content || date || extraImages || extraText || meta || summary;
	  var contentProps = { content: content, date: date, extraImages: extraImages, extraText: extraText, meta: meta, summary: summary };
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _lib.createShorthand)(_FeedLabel2.default, function (val) {
	      return { icon: val };
	    }, icon),
	    (0, _lib.createShorthand)(_FeedLabel2.default, function (val) {
	      return { image: val };
	    }, image),
	    hasContentProp && _react2.default.createElement(_FeedContent2.default, contentProps),
	    children
	  );
	}
	
	FeedEvent.handledProps = ['as', 'children', 'className', 'content', 'date', 'extraImages', 'extraText', 'icon', 'image', 'meta', 'summary'];
	FeedEvent._meta = {
	  name: 'FeedEvent',
	  parent: 'Feed',
	  type: _lib.META.TYPES.VIEW
	};
	
	 false ? FeedEvent.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for FeedContent. */
	  content: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for FeedDate. */
	  date: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for FeedExtra with images. */
	  extraImages: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for FeedExtra with content. */
	  extraText: _lib.customPropTypes.itemShorthand,
	
	  /** An event can contain icon label. */
	  icon: _lib.customPropTypes.itemShorthand,
	
	  /** An event can contain image label. */
	  image: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for FeedMeta. */
	  meta: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for FeedSummary. */
	  summary: _lib.customPropTypes.itemShorthand
	} : void 0;
	
	exports.default = FeedEvent;

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _Icon = __webpack_require__(750);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An event can contain an image or icon label.
	 */
	function FeedLabel(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      icon = props.icon,
	      image = props.image;
	
	
	  var classes = (0, _classnames2.default)('label', className);
	  var rest = (0, _lib.getUnhandledProps)(FeedLabel, props);
	  var ElementType = (0, _lib.getElementType)(FeedLabel, props);
	
	  if (!(0, _isNil3.default)(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    content,
	    _Icon2.default.create(icon),
	    (0, _lib.createHTMLImage)(image)
	  );
	}
	
	FeedLabel.handledProps = ['as', 'children', 'className', 'content', 'icon', 'image'];
	FeedLabel._meta = {
	  name: 'FeedLabel',
	  parent: 'Feed',
	  type: _lib.META.TYPES.VIEW
	};
	
	 false ? FeedLabel.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** An event can contain icon label. */
	  icon: _lib.customPropTypes.itemShorthand,
	
	  /** An event can contain image label. */
	  image: _lib.customPropTypes.itemShorthand
	} : void 0;
	
	exports.default = FeedLabel;

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Item = __webpack_require__(934);
	
	var _Item2 = _interopRequireDefault(_Item);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Item2.default;

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _ItemContent = __webpack_require__(935);
	
	var _ItemContent2 = _interopRequireDefault(_ItemContent);
	
	var _ItemDescription = __webpack_require__(937);
	
	var _ItemDescription2 = _interopRequireDefault(_ItemDescription);
	
	var _ItemExtra = __webpack_require__(938);
	
	var _ItemExtra2 = _interopRequireDefault(_ItemExtra);
	
	var _ItemGroup = __webpack_require__(940);
	
	var _ItemGroup2 = _interopRequireDefault(_ItemGroup);
	
	var _ItemHeader = __webpack_require__(936);
	
	var _ItemHeader2 = _interopRequireDefault(_ItemHeader);
	
	var _ItemImage = __webpack_require__(941);
	
	var _ItemImage2 = _interopRequireDefault(_ItemImage);
	
	var _ItemMeta = __webpack_require__(939);
	
	var _ItemMeta2 = _interopRequireDefault(_ItemMeta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An item view presents large collections of site content for display.
	 */
	function Item(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      description = props.description,
	      extra = props.extra,
	      header = props.header,
	      image = props.image,
	      meta = props.meta;
	
	
	  var classes = (0, _classnames2.default)('item', className);
	  var rest = (0, _lib.getUnhandledProps)(Item, props);
	  var ElementType = (0, _lib.getElementType)(Item, props);
	
	  if (!(0, _isNil3.default)(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _ItemImage2.default.create(image),
	    _react2.default.createElement(_ItemContent2.default, {
	      content: content,
	      description: description,
	      extra: extra,
	      header: header,
	      meta: meta
	    })
	  );
	}
	
	Item.handledProps = ['as', 'children', 'className', 'content', 'description', 'extra', 'header', 'image', 'meta'];
	Item._meta = {
	  name: 'Item',
	  type: _lib.META.TYPES.VIEW
	};
	
	Item.Content = _ItemContent2.default;
	Item.Description = _ItemDescription2.default;
	Item.Extra = _ItemExtra2.default;
	Item.Group = _ItemGroup2.default;
	Item.Header = _ItemHeader2.default;
	Item.Image = _ItemImage2.default;
	Item.Meta = _ItemMeta2.default;
	
	 false ? Item.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for ItemContent component. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Shorthand for ItemDescription component. */
	  description: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for ItemExtra component. */
	  extra: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for ItemImage component. */
	  image: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for ItemHeader component. */
	  header: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for ItemMeta component. */
	  meta: _lib.customPropTypes.itemShorthand
	} : void 0;
	
	exports.default = Item;

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _ItemHeader = __webpack_require__(936);
	
	var _ItemHeader2 = _interopRequireDefault(_ItemHeader);
	
	var _ItemDescription = __webpack_require__(937);
	
	var _ItemDescription2 = _interopRequireDefault(_ItemDescription);
	
	var _ItemExtra = __webpack_require__(938);
	
	var _ItemExtra2 = _interopRequireDefault(_ItemExtra);
	
	var _ItemMeta = __webpack_require__(939);
	
	var _ItemMeta2 = _interopRequireDefault(_ItemMeta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An item can contain content.
	 */
	function ItemContent(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      description = props.description,
	      extra = props.extra,
	      header = props.header,
	      meta = props.meta,
	      verticalAlign = props.verticalAlign;
	
	
	  var classes = (0, _classnames2.default)((0, _lib.useVerticalAlignProp)(verticalAlign), 'content', className);
	  var rest = (0, _lib.getUnhandledProps)(ItemContent, props);
	  var ElementType = (0, _lib.getElementType)(ItemContent, props);
	
	  if (!(0, _isNil3.default)(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _ItemHeader2.default.create(header),
	    _ItemMeta2.default.create(meta),
	    _ItemDescription2.default.create(description),
	    _ItemExtra2.default.create(extra),
	    content
	  );
	}
	
	ItemContent.handledProps = ['as', 'children', 'className', 'content', 'description', 'extra', 'header', 'meta', 'verticalAlign'];
	ItemContent._meta = {
	  name: 'ItemContent',
	  parent: 'Item',
	  type: _lib.META.TYPES.VIEW
	};
	
	 false ? ItemContent.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Shorthand for ItemDescription component. */
	  description: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for ItemExtra component. */
	  extra: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for ItemHeader component. */
	  header: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for ItemMeta component. */
	  meta: _lib.customPropTypes.itemShorthand,
	
	  /** Content can specify its vertical alignment. */
	  verticalAlign: _react.PropTypes.oneOf(_lib.SUI.VERTICAL_ALIGNMENTS)
	} : void 0;
	
	exports.default = ItemContent;

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An item can contain a header.
	 */
	function ItemHeader(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('header', className);
	  var rest = (0, _lib.getUnhandledProps)(ItemHeader, props);
	  var ElementType = (0, _lib.getElementType)(ItemHeader, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _isNil3.default)(children) ? content : children
	  );
	}
	
	ItemHeader.handledProps = ['as', 'children', 'className', 'content'];
	ItemHeader._meta = {
	  name: 'ItemHeader',
	  parent: 'Item',
	  type: _lib.META.TYPES.VIEW
	};
	
	 false ? ItemHeader.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : void 0;
	
	ItemHeader.create = (0, _lib.createShorthandFactory)(ItemHeader, function (content) {
	  return { content: content };
	});
	
	exports.default = ItemHeader;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An item can contain a description with a single or multiple paragraphs.
	 */
	function ItemDescription(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('description', className);
	  var rest = (0, _lib.getUnhandledProps)(ItemDescription, props);
	  var ElementType = (0, _lib.getElementType)(ItemDescription, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _isNil3.default)(children) ? content : children
	  );
	}
	
	ItemDescription.handledProps = ['as', 'children', 'className', 'content'];
	ItemDescription._meta = {
	  name: 'ItemDescription',
	  parent: 'Item',
	  type: _lib.META.TYPES.VIEW
	};
	
	 false ? ItemDescription.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : void 0;
	
	ItemDescription.create = (0, _lib.createShorthandFactory)(ItemDescription, function (content) {
	  return { content: content };
	});
	
	exports.default = ItemDescription;

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An item can contain extra content meant to be formatted separately from the main content.
	 */
	function ItemExtra(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('extra', className);
	  var rest = (0, _lib.getUnhandledProps)(ItemExtra, props);
	  var ElementType = (0, _lib.getElementType)(ItemExtra, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _isNil3.default)(children) ? content : children
	  );
	}
	
	ItemExtra.handledProps = ['as', 'children', 'className', 'content'];
	ItemExtra._meta = {
	  name: 'ItemExtra',
	  parent: 'Item',
	  type: _lib.META.TYPES.VIEW
	};
	
	 false ? ItemExtra.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : void 0;
	
	ItemExtra.create = (0, _lib.createShorthandFactory)(ItemExtra, function (content) {
	  return { content: content };
	});
	
	exports.default = ItemExtra;

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An item can contain content metadata.
	 */
	function ItemMeta(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('meta', className);
	  var rest = (0, _lib.getUnhandledProps)(ItemMeta, props);
	  var ElementType = (0, _lib.getElementType)(ItemMeta, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _isNil3.default)(children) ? content : children
	  );
	}
	
	ItemMeta.handledProps = ['as', 'children', 'className', 'content'];
	ItemMeta._meta = {
	  name: 'ItemMeta',
	  parent: 'Item',
	  type: _lib.META.TYPES.VIEW
	};
	
	 false ? ItemMeta.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : void 0;
	
	ItemMeta.create = (0, _lib.createShorthandFactory)(ItemMeta, function (content) {
	  return { content: content };
	});
	
	exports.default = ItemMeta;

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(895);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _map2 = __webpack_require__(702);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _Item = __webpack_require__(934);
	
	var _Item2 = _interopRequireDefault(_Item);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A group of items.
	 */
	function ItemGroup(props) {
	  var children = props.children,
	      className = props.className,
	      divided = props.divided,
	      items = props.items,
	      link = props.link,
	      relaxed = props.relaxed;
	
	
	  var classes = (0, _classnames2.default)('ui', (0, _lib.useKeyOnly)(divided, 'divided'), (0, _lib.useKeyOnly)(link, 'link'), (0, _lib.useKeyOrValueAndKey)(relaxed, 'relaxed'), 'items', className);
	  var rest = (0, _lib.getUnhandledProps)(ItemGroup, props);
	  var ElementType = (0, _lib.getElementType)(ItemGroup, props);
	
	  if (!(0, _isNil3.default)(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  var itemsJSX = (0, _map3.default)(items, function (item) {
	    var childKey = item.childKey,
	        itemProps = (0, _objectWithoutProperties3.default)(item, ['childKey']);
	
	    var finalKey = childKey || [itemProps.content, itemProps.description, itemProps.header, itemProps.meta].join('-');
	
	    return _react2.default.createElement(_Item2.default, (0, _extends3.default)({}, itemProps, { key: finalKey }));
	  });
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    itemsJSX
	  );
	}
	
	ItemGroup.handledProps = ['as', 'children', 'className', 'divided', 'items', 'link', 'relaxed'];
	ItemGroup._meta = {
	  name: 'ItemGroup',
	  type: _lib.META.TYPES.VIEW,
	  parent: 'Item'
	};
	
	 false ? ItemGroup.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Items can be divided to better distinguish between grouped content. */
	  divided: _react.PropTypes.bool,
	
	  /** Shorthand array of props for Item. */
	  items: _lib.customPropTypes.collectionShorthand,
	
	  /** An item can be formatted so that the entire contents link to another page. */
	  link: _react.PropTypes.bool,
	
	  /** A group of items can relax its padding to provide more negative space. */
	  relaxed: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.oneOf(['very'])])
	} : void 0;
	
	exports.default = ItemGroup;

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _Image = __webpack_require__(780);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An item can contain an image.
	 */
	function ItemImage(props) {
	  var size = props.size;
	
	  var rest = (0, _lib.getUnhandledProps)(ItemImage, props);
	
	  return _react2.default.createElement(_Image2.default, (0, _extends3.default)({}, rest, { size: size, ui: !!size, wrapped: true }));
	}
	
	ItemImage.handledProps = ['size'];
	ItemImage._meta = {
	  name: 'ItemImage',
	  parent: 'Item',
	  type: _lib.META.TYPES.VIEW
	};
	
	 false ? ItemImage.propTypes = {
	  /** An image may appear at different sizes. */
	  size: _Image2.default.propTypes.size
	} : void 0;
	
	ItemImage.create = (0, _lib.createShorthandFactory)(ItemImage, function (src) {
	  return { src: src };
	});
	
	exports.default = ItemImage;

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Statistic = __webpack_require__(943);
	
	var _Statistic2 = _interopRequireDefault(_Statistic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Statistic2.default;

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(723);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _StatisticGroup = __webpack_require__(944);
	
	var _StatisticGroup2 = _interopRequireDefault(_StatisticGroup);
	
	var _StatisticLabel = __webpack_require__(945);
	
	var _StatisticLabel2 = _interopRequireDefault(_StatisticLabel);
	
	var _StatisticValue = __webpack_require__(946);
	
	var _StatisticValue2 = _interopRequireDefault(_StatisticValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A statistic emphasizes the current value of an attribute.
	 */
	function Statistic(props) {
	  var children = props.children,
	      className = props.className,
	      color = props.color,
	      floated = props.floated,
	      horizontal = props.horizontal,
	      inverted = props.inverted,
	      label = props.label,
	      size = props.size,
	      text = props.text,
	      value = props.value;
	
	
	  var classes = (0, _classnames2.default)('ui', color, size, (0, _lib.useValueAndKey)(floated, 'floated'), (0, _lib.useKeyOnly)(horizontal, 'horizontal'), (0, _lib.useKeyOnly)(inverted, 'inverted'), 'statistic', className);
	  var rest = (0, _lib.getUnhandledProps)(Statistic, props);
	  var ElementType = (0, _lib.getElementType)(Statistic, props);
	
	  if (!(0, _isNil3.default)(children)) return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _react2.default.createElement(_StatisticValue2.default, { text: text, value: value }),
	    _react2.default.createElement(_StatisticLabel2.default, { label: label })
	  );
	}
	
	Statistic.handledProps = ['as', 'children', 'className', 'color', 'floated', 'horizontal', 'inverted', 'label', 'size', 'text', 'value'];
	Statistic._meta = {
	  name: 'Statistic',
	  type: _lib.META.TYPES.VIEW
	};
	
	 false ? Statistic.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** A statistic can be formatted to be different colors. */
	  color: _react.PropTypes.oneOf(_lib.SUI.COLORS),
	
	  /** A statistic can sit to the left or right of other content. */
	  floated: _react.PropTypes.oneOf(_lib.SUI.FLOATS),
	
	  /** A statistic can present its measurement horizontally. */
	  horizontal: _react.PropTypes.bool,
	
	  /** A statistic can be formatted to fit on a dark background. */
	  inverted: _react.PropTypes.bool,
	
	  /** Label content of the Statistic. */
	  label: _lib.customPropTypes.contentShorthand,
	
	  /** A statistic can vary in size. */
	  size: _react.PropTypes.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'big', 'massive', 'medium')),
	
	  /** Format the StatisticValue with smaller font size to fit nicely beside number values. */
	  text: _react.PropTypes.bool,
	
	  /** Value content of the Statistic. */
	  value: _lib.customPropTypes.contentShorthand
	} : void 0;
	
	Statistic.Group = _StatisticGroup2.default;
	Statistic.Label = _StatisticLabel2.default;
	Statistic.Value = _StatisticValue2.default;
	
	exports.default = Statistic;

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(723);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _map2 = __webpack_require__(702);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	var _Statistic = __webpack_require__(943);
	
	var _Statistic2 = _interopRequireDefault(_Statistic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A group of statistics.
	 */
	function StatisticGroup(props) {
	  var children = props.children,
	      className = props.className,
	      color = props.color,
	      horizontal = props.horizontal,
	      inverted = props.inverted,
	      items = props.items,
	      size = props.size,
	      widths = props.widths;
	
	
	  var classes = (0, _classnames2.default)('ui', color, size, (0, _lib.useKeyOnly)(horizontal, 'horizontal'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useWidthProp)(widths), 'statistics', className);
	  var rest = (0, _lib.getUnhandledProps)(StatisticGroup, props);
	  var ElementType = (0, _lib.getElementType)(StatisticGroup, props);
	
	  if (!(0, _isNil3.default)(children)) return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	
	  var itemsJSX = (0, _map3.default)(items, function (item) {
	    return _react2.default.createElement(_Statistic2.default, (0, _extends3.default)({ key: item.childKey || [item.label, item.title].join('-') }, item));
	  });
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    itemsJSX
	  );
	}
	
	StatisticGroup.handledProps = ['as', 'children', 'className', 'color', 'horizontal', 'inverted', 'items', 'size', 'widths'];
	StatisticGroup._meta = {
	  name: 'StatisticGroup',
	  type: _lib.META.TYPES.VIEW,
	  parent: 'Statistic'
	};
	
	 false ? StatisticGroup.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** A statistic group can be formatted to be different colors. */
	  color: _react.PropTypes.oneOf(_lib.SUI.COLORS),
	
	  /** A statistic group can present its measurement horizontally. */
	  horizontal: _react.PropTypes.bool,
	
	  /** A statistic group can be formatted to fit on a dark background. */
	  inverted: _react.PropTypes.bool,
	
	  /** Array of props for Statistic. */
	  items: _lib.customPropTypes.collectionShorthand,
	
	  /** A statistic group can vary in size. */
	  size: _react.PropTypes.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'big', 'massive', 'medium')),
	
	  /** A statistic group can have its items divided evenly. */
	  widths: _react.PropTypes.oneOf(_lib.SUI.WIDTHS)
	} : void 0;
	
	exports.default = StatisticGroup;

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A statistic can contain a label to help provide context for the presented value.
	 */
	function StatisticLabel(props) {
	  var children = props.children,
	      className = props.className,
	      label = props.label;
	
	  var classes = (0, _classnames2.default)('label', className);
	  var rest = (0, _lib.getUnhandledProps)(StatisticLabel, props);
	  var ElementType = (0, _lib.getElementType)(StatisticLabel, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _isNil3.default)(children) ? label : children
	  );
	}
	
	StatisticLabel.handledProps = ['as', 'children', 'className', 'label'];
	StatisticLabel._meta = {
	  name: 'StatisticLabel',
	  parent: 'Statistic',
	  type: _lib.META.TYPES.VIEW
	};
	
	 false ? StatisticLabel.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Shorthand for primary content. */
	  label: _lib.customPropTypes.contentShorthand
	} : void 0;
	
	exports.default = StatisticLabel;

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(474);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(711);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(591);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A statistic can contain a numeric, icon, image, or text value.
	 */
	function StatisticValue(props) {
	  var children = props.children,
	      className = props.className,
	      text = props.text,
	      value = props.value;
	
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(text, 'text'), 'value', className);
	  var rest = (0, _lib.getUnhandledProps)(StatisticValue, props);
	  var ElementType = (0, _lib.getElementType)(StatisticValue, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _isNil3.default)(children) ? value : children
	  );
	}
	
	StatisticValue.handledProps = ['as', 'children', 'className', 'text', 'value'];
	StatisticValue._meta = {
	  name: 'StatisticValue',
	  parent: 'Statistic',
	  type: _lib.META.TYPES.VIEW
	};
	
	 false ? StatisticValue.propTypes = {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _react.PropTypes.node,
	
	  /** Additional classes. */
	  className: _react.PropTypes.string,
	
	  /** Format the value with smaller font size to fit nicely beside number values. */
	  text: _react.PropTypes.bool,
	
	  /** Primary content of the StatisticValue. Mutually exclusive with the children prop. */
	  value: _lib.customPropTypes.contentShorthand
	} : void 0;
	
	exports.default = StatisticValue;

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(948);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Breakpoint = function (_Component) {
	  _inherits(Breakpoint, _Component);
	
	  function Breakpoint() {
	    _classCallCheck(this, Breakpoint);
	
	    return _possibleConstructorReturn(this, (Breakpoint.__proto__ || Object.getPrototypeOf(Breakpoint)).apply(this, arguments));
	  }
	
	  _createClass(Breakpoint, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          mobile = _props.mobile,
	          children = _props.children;
	
	
	      if (mobile) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'breakpoint-min-width-700' },
	          children
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'breakpoint-max-width-700' },
	        children
	      );
	    }
	  }]);
	
	  return Breakpoint;
	}(_react.Component);
	
	Breakpoint.propTypes = {
	  children: _react2.default.PropTypes.array,
	  mobile: _react2.default.PropTypes.bool
	};
	
	exports.default = Breakpoint;
	module.exports = exports['default'];

/***/ }),
/* 948 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 949 */
948,
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./html": 951,
		"./html.jsx": 951,
		"./md": 957,
		"./md.jsx": 957
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 950;


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDocumentTitle = __webpack_require__(952);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _config = __webpack_require__(404);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _react2.default.createClass({
	  displayName: 'exports',
	  propTypes: function propTypes() {
	    return {
	      route: _react2.default.PropTypes.object
	    };
	  },
	  render: function render() {
	    var post = this.props.route.page.data;
	
	    return _react2.default.createElement(
	      _reactDocumentTitle2.default,
	      { title: post.title + ' | ' + _config.config.siteTitle },
	      _react2.default.createElement(
	        'div',
	        { className: 'html' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          post.title
	        ),
	        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: post.body } })
	      )
	    );
	  }
	});

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(2),
	    PropTypes = __webpack_require__(953),
	    withSideEffect = __webpack_require__(955);
	
	function reducePropsToState(propsList) {
	  var innermostProps = propsList[propsList.length - 1];
	  if (innermostProps) {
	    return innermostProps.title;
	  }
	}
	
	function handleStateChangeOnClient(title) {
	  var nextTitle = title || '';
	  if (nextTitle !== document.title) {
	    document.title = nextTitle;
	  }
	}
	
	function DocumentTitle() {}
	DocumentTitle.prototype = Object.create(React.Component.prototype);
	
	DocumentTitle.displayName = 'DocumentTitle';
	DocumentTitle.propTypes = {
	  title: PropTypes.string.isRequired
	};
	
	DocumentTitle.prototype.render = function() {
	  if (this.props.children) {
	    return React.Children.only(this.props.children);
	  } else {
	    return null;
	  }
	};
	
	module.exports = withSideEffect(
	  reducePropsToState,
	  handleStateChangeOnClient
	)(DocumentTitle);


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(954)();
	}


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(28);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(2);
	var React__default = _interopDefault(React);
	var shallowEqual = _interopDefault(__webpack_require__(956));
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(SideEffect, _Component);
	
	      function SideEffect() {
	        return _Component.apply(this, arguments) || this;
	      }
	
	      // Try to use displayName of wrapped component
	      // Expose canUseDOM so tests can monkeypatch it
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      var _proto = SideEffect.prototype;
	
	      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      _proto.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      _proto.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      _proto.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      _proto.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
	
	    _defineProperty(SideEffect, "canUseDOM", canUseDOM);
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),
/* 956 */
/***/ (function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDocumentTitle = __webpack_require__(952);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _config = __webpack_require__(404);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _react2.default.createClass({
	  displayName: 'exports',
	  propTypes: function propTypes() {
	    return {
	      route: _react2.default.PropTypes.object
	    };
	  },
	  render: function render() {
	    var post = this.props.route.page.data;
	
	    return _react2.default.createElement(
	      _reactDocumentTitle2.default,
	      { title: post.title + ' | ' + _config.config.siteTitle },
	      _react2.default.createElement(
	        'div',
	        { className: 'markdown' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          post.title
	        ),
	        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: post.body } })
	      )
	    );
	  }
	});

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var ReactGA = __webpack_require__(959);
	ReactGA.initialize('UA-92709510-1');
	
	var onRouteUpdate = exports.onRouteUpdate = function onRouteUpdate(state) {
	
	  ReactGA.set({ page: state.pathname });
	  ReactGA.pageview(state.pathname);
	};

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(2), __webpack_require__(953));
		else if(typeof define === 'function' && define.amd)
			define(["react", "prop-types"], factory);
		else {
			var a = typeof exports === 'object' ? factory(require("react"), require("prop-types")) : factory(root["react"], root["prop-types"]);
			for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
		}
	})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE__12__, __WEBPACK_EXTERNAL_MODULE__13__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 10);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = warn;
	
	function warn(s) {
	  console.warn('[react-ga]', s);
	}
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = trim;
	
	// GA strings need to have leading/trailing whitespace trimmed, and not all
	// browsers have String.prototoype.trim().
	function trim(s) {
	  return s.replace(/^\s+|\s+$/g, '');
	}
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialize = initialize;
	exports.ga = ga;
	exports.set = set;
	exports.send = send;
	exports.pageview = pageview;
	exports.modalview = modalview;
	exports.timing = timing;
	exports.event = event;
	exports.exception = exception;
	exports.outboundLink = outboundLink;
	exports["default"] = exports.testModeAPI = exports.plugin = void 0;
	
	var _format2 = _interopRequireDefault(__webpack_require__(3));
	
	var _removeLeadingSlash = _interopRequireDefault(__webpack_require__(6));
	
	var _trim = _interopRequireDefault(__webpack_require__(1));
	
	var _loadGA = _interopRequireDefault(__webpack_require__(7));
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	var _log = _interopRequireDefault(__webpack_require__(8));
	
	var _testModeAPI = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var _isNotBrowser = typeof window === 'undefined' || typeof document === 'undefined';
	
	var _debug = false;
	var _titleCase = true;
	var _testMode = false;
	var _alwaysSendToDefaultTracker = true;
	
	var internalGa = function internalGa() {
	  var _window;
	
	  if (_testMode) return _testModeAPI["default"].ga.apply(_testModeAPI["default"], arguments);
	  if (_isNotBrowser) return false;
	  if (!window.ga) return (0, _warn["default"])('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
	  return (_window = window).ga.apply(_window, arguments);
	};
	
	function _format(s) {
	  return (0, _format2["default"])(s, _titleCase);
	}
	
	function _gaCommand(trackerNames) {
	  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  var command = args[0];
	
	  if (typeof internalGa === 'function') {
	    if (typeof command !== 'string') {
	      (0, _warn["default"])('ga command must be a string');
	      return;
	    }
	
	    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(void 0, args);
	
	    if (Array.isArray(trackerNames)) {
	      trackerNames.forEach(function (name) {
	        internalGa.apply(void 0, _toConsumableArray(["".concat(name, ".").concat(command)].concat(args.slice(1))));
	      });
	    }
	  }
	}
	
	function _initialize(gaTrackingID, options) {
	  if (!gaTrackingID) {
	    (0, _warn["default"])('gaTrackingID is required in initialize()');
	    return;
	  }
	
	  if (options) {
	    if (options.debug && options.debug === true) {
	      _debug = true;
	    }
	
	    if (options.titleCase === false) {
	      _titleCase = false;
	    }
	
	    if (options.useExistingGa) {
	      return;
	    }
	  }
	
	  if (options && options.gaOptions) {
	    internalGa('create', gaTrackingID, options.gaOptions);
	  } else {
	    internalGa('create', gaTrackingID, 'auto');
	  }
	}
	
	function initialize(configsOrTrackingId, options) {
	  if (options && options.testMode === true) {
	    _testMode = true;
	  } else {
	    if (_isNotBrowser) {
	      return false;
	    }
	
	    if (!options || options.standardImplementation !== true) (0, _loadGA["default"])(options);
	  }
	
	  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;
	
	  if (Array.isArray(configsOrTrackingId)) {
	    configsOrTrackingId.forEach(function (config) {
	      if (_typeof(config) !== 'object') {
	        (0, _warn["default"])('All configs must be an object');
	        return;
	      }
	
	      _initialize(config.trackingId, config);
	    });
	  } else {
	    _initialize(configsOrTrackingId, options);
	  }
	
	  return true;
	}
	/**
	 * ga:
	 * Returns the original GA object.
	 */
	
	
	function ga() {
	  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  if (args.length > 0) {
	    internalGa.apply(void 0, args);
	
	    if (_debug) {
	      (0, _log["default"])('called ga(\'arguments\');');
	      (0, _log["default"])("with arguments: ".concat(JSON.stringify(args)));
	    }
	  }
	
	  return window.ga;
	}
	/**
	 * set:
	 * GA tracker set method
	 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function set(fieldsObject, trackerNames) {
	  if (!fieldsObject) {
	    (0, _warn["default"])('`fieldsObject` is required in .set()');
	    return;
	  }
	
	  if (_typeof(fieldsObject) !== 'object') {
	    (0, _warn["default"])('Expected `fieldsObject` arg to be an Object');
	    return;
	  }
	
	  if (Object.keys(fieldsObject).length === 0) {
	    (0, _warn["default"])('empty `fieldsObject` given to .set()');
	  }
	
	  _gaCommand(trackerNames, 'set', fieldsObject);
	
	  if (_debug) {
	    (0, _log["default"])('called ga(\'set\', fieldsObject);');
	    (0, _log["default"])("with fieldsObject: ".concat(JSON.stringify(fieldsObject)));
	  }
	}
	/**
	 * send:
	 * Clone of the low level `ga.send` method
	 * WARNING: No validations will be applied to this
	 * @param  {Object} fieldObject - field object for tracking different analytics
	 * @param  {Array} trackerNames - trackers to send the command to
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function send(fieldObject, trackerNames) {
	  _gaCommand(trackerNames, 'send', fieldObject);
	
	  if (_debug) {
	    (0, _log["default"])('called ga(\'send\', fieldObject);');
	    (0, _log["default"])("with fieldObject: ".concat(JSON.stringify(fieldObject)));
	    (0, _log["default"])("with trackers: ".concat(JSON.stringify(trackerNames)));
	  }
	}
	/**
	 * pageview:
	 * Basic GA pageview tracking
	 * @param  {String} path - the current page page e.g. '/about'
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 * @param {String} title - (optional) the page title e. g. 'My Website'
	 */
	
	
	function pageview(rawPath, trackerNames, title) {
	  if (!rawPath) {
	    (0, _warn["default"])('path is required in .pageview()');
	    return;
	  }
	
	  var path = (0, _trim["default"])(rawPath);
	
	  if (path === '') {
	    (0, _warn["default"])('path cannot be an empty string in .pageview()');
	    return;
	  }
	
	  var extraFields = {};
	
	  if (title) {
	    extraFields.title = title;
	  }
	
	  if (typeof ga === 'function') {
	    _gaCommand(trackerNames, 'send', _objectSpread({
	      hitType: 'pageview',
	      page: path
	    }, extraFields));
	
	    if (_debug) {
	      (0, _log["default"])('called ga(\'send\', \'pageview\', path);');
	      var extraLog = '';
	
	      if (title) {
	        extraLog = " and title: ".concat(title);
	      }
	
	      (0, _log["default"])("with path: ".concat(path).concat(extraLog));
	    }
	  }
	}
	/**
	 * modalview:
	 * a proxy to basic GA pageview tracking to consistently track
	 * modal views that are an equivalent UX to a traditional pageview
	 * @param  {String} modalName e.g. 'add-or-edit-club'
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function modalview(rawModalName, trackerNames) {
	  if (!rawModalName) {
	    (0, _warn["default"])('modalName is required in .modalview(modalName)');
	    return;
	  }
	
	  var modalName = (0, _removeLeadingSlash["default"])((0, _trim["default"])(rawModalName));
	
	  if (modalName === '') {
	    (0, _warn["default"])('modalName cannot be an empty string or a single / in .modalview()');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    var path = "/modal/".concat(modalName);
	
	    _gaCommand(trackerNames, 'send', 'pageview', path);
	
	    if (_debug) {
	      (0, _log["default"])('called ga(\'send\', \'pageview\', path);');
	      (0, _log["default"])("with path: ".concat(path));
	    }
	  }
	}
	/**
	 * timing:
	 * GA timing
	 * @param args.category {String} required
	 * @param args.variable {String} required
	 * @param args.value  {Int}  required
	 * @param args.label  {String} required
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function timing() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      category = _ref.category,
	      variable = _ref.variable,
	      value = _ref.value,
	      label = _ref.label;
	
	  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;
	
	  if (typeof ga === 'function') {
	    if (!category || !variable || !value || typeof value !== 'number') {
	      (0, _warn["default"])('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'timing',
	      timingCategory: _format(category),
	      timingVar: _format(variable),
	      timingValue: value
	    };
	
	    if (label) {
	      fieldObject.timingLabel = _format(label);
	    }
	
	    send(fieldObject, trackerNames);
	  }
	}
	/**
	 * event:
	 * GA event tracking
	 * @param args.category {String} required
	 * @param args.action {String} required
	 * @param args.label {String} optional
	 * @param args.value {Int} optional
	 * @param args.nonInteraction {boolean} optional
	 * @param args.transport {string} optional
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function event() {
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      category = _ref2.category,
	      action = _ref2.action,
	      label = _ref2.label,
	      value = _ref2.value,
	      nonInteraction = _ref2.nonInteraction,
	      transport = _ref2.transport,
	      args = _objectWithoutProperties(_ref2, ["category", "action", "label", "value", "nonInteraction", "transport"]);
	
	  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;
	
	  if (typeof ga === 'function') {
	    // Simple Validation
	    if (!category || !action) {
	      (0, _warn["default"])('args.category AND args.action are required in event()');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'event',
	      eventCategory: _format(category),
	      eventAction: _format(action)
	    }; // Optional Fields
	
	    if (label) {
	      fieldObject.eventLabel = _format(label);
	    }
	
	    if (typeof value !== 'undefined') {
	      if (typeof value !== 'number') {
	        (0, _warn["default"])('Expected `args.value` arg to be a Number.');
	      } else {
	        fieldObject.eventValue = value;
	      }
	    }
	
	    if (typeof nonInteraction !== 'undefined') {
	      if (typeof nonInteraction !== 'boolean') {
	        (0, _warn["default"])('`args.nonInteraction` must be a boolean.');
	      } else {
	        fieldObject.nonInteraction = nonInteraction;
	      }
	    }
	
	    if (typeof transport !== 'undefined') {
	      if (typeof transport !== 'string') {
	        (0, _warn["default"])('`args.transport` must be a string.');
	      } else {
	        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
	          (0, _warn["default"])('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
	        }
	
	        fieldObject.transport = transport;
	      }
	    }
	
	    Object.keys(args).filter(function (key) {
	      return key.substr(0, 'dimension'.length) === 'dimension';
	    }).forEach(function (key) {
	      fieldObject[key] = args[key];
	    });
	    Object.keys(args).filter(function (key) {
	      return key.substr(0, 'metric'.length) === 'metric';
	    }).forEach(function (key) {
	      fieldObject[key] = args[key];
	    }); // Send to GA
	
	    send(fieldObject, trackerNames);
	  }
	}
	/**
	 * exception:
	 * GA exception tracking
	 * @param args.description {String} optional
	 * @param args.fatal {boolean} optional
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function exception(_ref3, trackerNames) {
	  var description = _ref3.description,
	      fatal = _ref3.fatal;
	
	  if (typeof ga === 'function') {
	    // Required Fields
	    var fieldObject = {
	      hitType: 'exception'
	    }; // Optional Fields
	
	    if (description) {
	      fieldObject.exDescription = _format(description);
	    }
	
	    if (typeof fatal !== 'undefined') {
	      if (typeof fatal !== 'boolean') {
	        (0, _warn["default"])('`args.fatal` must be a boolean.');
	      } else {
	        fieldObject.exFatal = fatal;
	      }
	    } // Send to GA
	
	
	    send(fieldObject, trackerNames);
	  }
	}
	
	var plugin = {
	  /**
	   * require:
	   * GA requires a plugin
	   * @param name {String} e.g. 'ecommerce' or 'myplugin'
	   * @param options {Object} optional e.g {path: '/log', debug: true}
	   * @param trackerName {String} optional e.g 'trackerName'
	   */
	  require: function require(rawName, options, trackerName) {
	    if (typeof ga === 'function') {
	      // Required Fields
	      if (!rawName) {
	        (0, _warn["default"])('`name` is required in .require()');
	        return;
	      }
	
	      var name = (0, _trim["default"])(rawName);
	
	      if (name === '') {
	        (0, _warn["default"])('`name` cannot be an empty string in .require()');
	        return;
	      }
	
	      var requireString = trackerName ? "".concat(trackerName, ".require") : 'require'; // Optional Fields
	
	      if (options) {
	        if (_typeof(options) !== 'object') {
	          (0, _warn["default"])('Expected `options` arg to be an Object');
	          return;
	        }
	
	        if (Object.keys(options).length === 0) {
	          (0, _warn["default"])('Empty `options` given to .require()');
	        }
	
	        ga(requireString, name, options);
	
	        if (_debug) {
	          (0, _log["default"])("called ga('require', '".concat(name, "', ").concat(JSON.stringify(options)));
	        }
	      } else {
	        ga(requireString, name);
	
	        if (_debug) {
	          (0, _log["default"])("called ga('require', '".concat(name, "');"));
	        }
	      }
	    }
	  },
	
	  /**
	   * execute:
	   * GA execute action for plugin
	   * Takes variable number of arguments
	   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
	   * @param action {String} e.g. 'addItem' or 'myCustomAction'
	   * @param actionType {String} optional e.g. 'detail'
	   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
	   */
	  execute: function execute(pluginName, action) {
	    var payload;
	    var actionType;
	
	    if ((arguments.length <= 2 ? 0 : arguments.length - 2) === 1) {
	      payload = arguments.length <= 2 ? undefined : arguments[2];
	    } else {
	      actionType = arguments.length <= 2 ? undefined : arguments[2];
	      payload = arguments.length <= 3 ? undefined : arguments[3];
	    }
	
	    if (typeof ga === 'function') {
	      if (typeof pluginName !== 'string') {
	        (0, _warn["default"])('Expected `pluginName` arg to be a String.');
	      } else if (typeof action !== 'string') {
	        (0, _warn["default"])('Expected `action` arg to be a String.');
	      } else {
	        var command = "".concat(pluginName, ":").concat(action);
	        payload = payload || null;
	
	        if (actionType && payload) {
	          ga(command, actionType, payload);
	
	          if (_debug) {
	            (0, _log["default"])("called ga('".concat(command, "');"));
	            (0, _log["default"])("actionType: \"".concat(actionType, "\" with payload: ").concat(JSON.stringify(payload)));
	          }
	        } else if (payload) {
	          ga(command, payload);
	
	          if (_debug) {
	            (0, _log["default"])("called ga('".concat(command, "');"));
	            (0, _log["default"])("with payload: ".concat(JSON.stringify(payload)));
	          }
	        } else {
	          ga(command);
	
	          if (_debug) {
	            (0, _log["default"])("called ga('".concat(command, "');"));
	          }
	        }
	      }
	    }
	  }
	};
	/**
	 * outboundLink:
	 * GA outboundLink tracking
	 * @param args.label {String} e.g. url, or 'Create an Account'
	 * @param {function} hitCallback - Called after processing a hit.
	 */
	
	exports.plugin = plugin;
	
	function outboundLink(args, hitCallback, trackerNames) {
	  if (typeof hitCallback !== 'function') {
	    (0, _warn["default"])('hitCallback function is required');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    // Simple Validation
	    if (!args || !args.label) {
	      (0, _warn["default"])('args.label is required in outboundLink()');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'event',
	      eventCategory: 'Outbound',
	      eventAction: 'Click',
	      eventLabel: _format(args.label)
	    };
	    var safetyCallbackCalled = false;
	
	    var safetyCallback = function safetyCallback() {
	      // This prevents a delayed response from GA
	      // causing hitCallback from being fired twice
	      safetyCallbackCalled = true;
	      hitCallback();
	    }; // Using a timeout to ensure the execution of critical application code
	    // in the case when the GA server might be down
	    // or an ad blocker prevents sending the data
	    // register safety net timeout:
	
	
	    var t = setTimeout(safetyCallback, 250);
	
	    var clearableCallbackForGA = function clearableCallbackForGA() {
	      clearTimeout(t);
	
	      if (!safetyCallbackCalled) {
	        hitCallback();
	      }
	    };
	
	    fieldObject.hitCallback = clearableCallbackForGA; // Send to GA
	
	    send(fieldObject, trackerNames);
	  } else {
	    // if ga is not defined, return the callback so the application
	    // continues to work as expected
	    setTimeout(hitCallback, 0);
	  }
	}
	
	var testModeAPI = _testModeAPI["default"];
	exports.testModeAPI = testModeAPI;
	var _default = {
	  initialize: initialize,
	  ga: ga,
	  set: set,
	  send: send,
	  pageview: pageview,
	  modalview: modalview,
	  timing: timing,
	  event: event,
	  exception: exception,
	  plugin: plugin,
	  outboundLink: outboundLink,
	  testModeAPI: _testModeAPI["default"]
	};
	exports["default"] = _default;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = format;
	
	var _mightBeEmail = _interopRequireDefault(__webpack_require__(4));
	
	var _toTitleCase = _interopRequireDefault(__webpack_require__(5));
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var redacted = 'REDACTED (Potential Email Address)';
	
	function format(s, titleCase) {
	  if ((0, _mightBeEmail["default"])(s)) {
	    (0, _warn["default"])('This arg looks like an email address, redacting.');
	    return redacted;
	  }
	
	  if (titleCase) {
	    return (0, _toTitleCase["default"])(s);
	  }
	
	  return s;
	}
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = mightBeEmail;
	
	// See if s could be an email address. We don't want to send personal data like email.
	// https://support.google.com/analytics/answer/2795983?hl=en
	function mightBeEmail(s) {
	  // There's no point trying to validate rfc822 fully, just look for ...@...
	  return typeof s === 'string' && s.indexOf('@') !== -1;
	}
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = toTitleCase;
	
	var _trim = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * To Title Case 2.1 - http://individed.com/code/to-title-case/
	 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
	 * https://github.com/gouch/to-title-case
	 */
	var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
	
	function toTitleCase(string) {
	  return (0, _trim["default"])(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
	    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
	      return match.toLowerCase();
	    }
	
	    if (match.substr(1).search(/[A-Z]|\../) > -1) {
	      return match;
	    }
	
	    return match.charAt(0).toUpperCase() + match.substr(1);
	  });
	}
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = removeLeadingSlash;
	
	function removeLeadingSlash(string) {
	  if (string.substring(0, 1) === '/') {
	    return string.substring(1);
	  }
	
	  return string;
	}
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = _default;
	
	function _default(options) {
	  var gaAddress = 'https://www.google-analytics.com/analytics.js';
	
	  if (options && options.gaAddress) {
	    gaAddress = options.gaAddress;
	  } else if (options && options.debug) {
	    gaAddress = 'https://www.google-analytics.com/analytics_debug.js';
	  } // https://developers.google.com/analytics/devguides/collection/analyticsjs/
	
	  /* eslint-disable */
	
	
	  (function (i, s, o, g, r, a, m) {
	    i['GoogleAnalyticsObject'] = r;
	    i[r] = i[r] || function () {
	      (i[r].q = i[r].q || []).push(arguments);
	    }, i[r].l = 1 * new Date();
	    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
	    a.async = 1;
	    a.src = g;
	    m.parentNode.insertBefore(a, m);
	  })(window, document, 'script', gaAddress, 'ga');
	  /* eslint-enable */
	
	}
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = log;
	
	function log(s) {
	  console.info('[react-ga]', s);
	}
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.gaCalls = void 0;
	var gaCalls = [];
	exports.gaCalls = gaCalls;
	var _default = {
	  calls: gaCalls,
	  ga: function ga() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    gaCalls.push([].concat(args));
	  },
	  resetCalls: function resetCalls() {
	    gaCalls.length = 0;
	  }
	};
	exports["default"] = _default;
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.OutboundLink = exports.testModeAPI = exports.outboundLink = exports.plugin = exports.exception = exports.event = exports.timing = exports.modalview = exports.pageview = exports.send = exports.set = exports.ga = exports.initialize = void 0;
	
	var _OutboundLink = _interopRequireDefault(__webpack_require__(11));
	
	var Defaults = _interopRequireWildcard(__webpack_require__(2));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialize = Defaults.initialize;
	exports.initialize = initialize;
	var ga = Defaults.ga;
	exports.ga = ga;
	var set = Defaults.set;
	exports.set = set;
	var send = Defaults.send;
	exports.send = send;
	var pageview = Defaults.pageview;
	exports.pageview = pageview;
	var modalview = Defaults.modalview;
	exports.modalview = modalview;
	var timing = Defaults.timing;
	exports.timing = timing;
	var event = Defaults.event;
	exports.event = event;
	var exception = Defaults.exception;
	exports.exception = exception;
	var plugin = Defaults.plugin;
	exports.plugin = plugin;
	var outboundLink = Defaults.outboundLink;
	exports.outboundLink = outboundLink;
	var testModeAPI = Defaults.testModeAPI;
	exports.testModeAPI = testModeAPI;
	_OutboundLink["default"].origTrackLink = _OutboundLink["default"].trackLink;
	_OutboundLink["default"].trackLink = Defaults.outboundLink;
	var OutboundLink = _OutboundLink["default"];
	exports.OutboundLink = OutboundLink;
	
	var _default = _objectSpread({}, Defaults, {
	  OutboundLink: OutboundLink
	});
	
	exports["default"] = _default;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(12));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var NEWTAB = '_blank';
	var MIDDLECLICK = 1;
	
	var OutboundLink =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(OutboundLink, _Component);
	
	  function OutboundLink() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, OutboundLink);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(OutboundLink)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
	      var _this$props = _this.props,
	          target = _this$props.target,
	          eventLabel = _this$props.eventLabel,
	          to = _this$props.to,
	          onClick = _this$props.onClick,
	          trackerNames = _this$props.trackerNames;
	      var eventMeta = {
	        label: eventLabel
	      };
	      var sameTarget = target !== NEWTAB;
	      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);
	
	      if (sameTarget && normalClick) {
	        event.preventDefault();
	        OutboundLink.trackLink(eventMeta, function () {
	          window.location.href = to;
	        }, trackerNames);
	      } else {
	        OutboundLink.trackLink(eventMeta, function () {}, trackerNames);
	      }
	
	      if (onClick) {
	        onClick(event);
	      }
	    });
	
	    return _this;
	  }
	
	  _createClass(OutboundLink, [{
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          href = _this$props2.to,
	          oldProps = _objectWithoutProperties(_this$props2, ["to"]);
	
	      var props = _objectSpread({}, oldProps, {
	        href: href,
	        onClick: this.handleClick
	      });
	
	      if (this.props.target === NEWTAB) {
	        props.rel = 'noopener noreferrer';
	      }
	
	      delete props.eventLabel;
	      delete props.trackerNames;
	      return _react["default"].createElement('a', props);
	    }
	  }]);
	
	  return OutboundLink;
	}(_react.Component);
	
	exports["default"] = OutboundLink;
	
	_defineProperty(OutboundLink, "trackLink", function () {
	  (0, _warn["default"])('ga tracking not enabled');
	});
	
	_defineProperty(OutboundLink, "propTypes", {
	  eventLabel: _propTypes["default"].string.isRequired,
	  target: _propTypes["default"].string,
	  to: _propTypes["default"].string,
	  onClick: _propTypes["default"].func,
	  trackerNames: _propTypes["default"].arrayOf(_propTypes["default"].string)
	});
	
	_defineProperty(OutboundLink, "defaultProps", {
	  target: null,
	  to: null,
	  onClick: null,
	  trackerNames: null
	});
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE__12__;
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE__13__;
	
	/***/ })
	/******/ ]);
	});

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*  weak */
	// This file is auto-written and used by Gatsby to require
	// files from your pages directory.
	
	module.exports = function (callback) {
	  var context = __webpack_require__(961);if (false) {
	    module.hot.accept(context.id, function () {
	      context = require.context('./pages', true, /(coffee|cjsx|ts|tsx|jsx|js|md|rmd|mkdn?|mdwn|mdown|markdown|litcoffee|ipynb|html|json|yaml|toml)$/ // eslint-disable-line
	      );return callback(context);
	    });
	  }
	  return callback(context);
	};

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./404.md": 962,
		"./_template.jsx": 406,
		"./blog/2015-01-01-TelevisieUitzendingHetVermoeden/index.md": 963,
		"./blog/2015-01-02-Filmdossiers/index.md": 964,
		"./blog/2015-01-04-Archief20Jaar/index.md": 965,
		"./blog/2015-01-04-Archief20Jaar/movie.md": 966,
		"./blog/2015-01-05-BoekGedachtenis/index.md": 967,
		"./blog/2015-01-06-TrapCinematografie/index.md": 968,
		"./blog/2015-01-07-BoekAardsParadijs/index.md": 969,
		"./blog/2015-01-08-BergredeXIII/index.md": 970,
		"./blog/2015-01-09-InterviewBraambos/index.md": 971,
		"./blog/2015-01-10-Bibliografie/index.md": 972,
		"./blog/2017-12-27 Programakaart De Dag/index.md": 973,
		"./blog/_template.jsx": 974,
		"./blog/index.js": 977,
		"./dedag/_template.jsx": 979,
		"./dedag/geschiedenis.md": 980,
		"./dedag/index.md": 981,
		"./dedag/inschrijving.md": 982,
		"./dedag/locatie-contact.md": 983,
		"./dedag/programma/index.md": 984,
		"./dedag/toeschouwers.md": 985,
		"./film-focus/Dekalog/index.md": 986,
		"./film-focus/_template.jsx": 987,
		"./film-focus/agora/index.md": 988,
		"./film-focus/andreiroublev/index.md": 989,
		"./film-focus/benx/index.md": 990,
		"./film-focus/birthofanation/index.md": 991,
		"./film-focus/comeandsee/index.md": 992,
		"./film-focus/damien/index.md": 993,
		"./film-focus/darkesthour/index.md": 994,
		"./film-focus/desterre/index.md": 995,
		"./film-focus/dolls/index.md": 996,
		"./film-focus/elsoldelmembrillo/index.md": 997,
		"./film-focus/goddess/index.md": 998,
		"./film-focus/hommes/index.md": 999,
		"./film-focus/ida/index.md": 1000,
		"./film-focus/index.jsx": 1001,
		"./film-focus/innocentes/index.md": 1003,
		"./film-focus/intothewild/index.md": 1004,
		"./film-focus/iris/index.md": 1005,
		"./film-focus/italiensk/index.md": 1006,
		"./film-focus/kain/index.md": 1007,
		"./film-focus/marieheurtin/index.md": 1008,
		"./film-focus/millcross/index.md": 1009,
		"./film-focus/mrturner/index.md": 1010,
		"./film-focus/nativity/index.md": 1011,
		"./film-focus/newworld/index.md": 1012,
		"./film-focus/pilgrimage/index.md": 1013,
		"./film-focus/priere/index.md": 1014,
		"./film-focus/resurrection/index.md": 1015,
		"./film-focus/samara/index.md": 1016,
		"./film-focus/silence/index.md": 1017,
		"./film-focus/sonofsaul/index.md": 1018,
		"./film-focus/spirited/index.md": 1019,
		"./index.jsx": 1020,
		"./missie/_template.jsx": 1021,
		"./missie/index.md": 1022,
		"./missie/index_old.html": 1023,
		"./producties/Agora/AgoraMovies.jsx": 1024,
		"./producties/Agora/index.md": 1025,
		"./producties/ClairObscur/index.md": 1026,
		"./producties/DeGeleMadonna/index.md": 1027,
		"./producties/Jute/index.md": 1028,
		"./producties/_template.jsx": 1029,
		"./producties/index.md": 1030,
		"./webshop/AanDeTafel/index.md": 1031,
		"./webshop/AardsParadijs/index.md": 1032,
		"./webshop/Beeldgebed/index.md": 1033,
		"./webshop/Kerkgebouw/index.md": 1034,
		"./webshop/Land/index.md": 1035,
		"./webshop/LerenLevenMetBeelden/index.md": 1036,
		"./webshop/Levensbeschouwing/index.md": 1037,
		"./webshop/MethodeBoek/index.md": 1038,
		"./webshop/MethodeCD/index.md": 1039,
		"./webshop/_template.jsx": 1040,
		"./webshop/index.js": 1041
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 961;


/***/ }),
/* 962 */
/***/ (function(module, exports) {

	module.exports = {"path":"/404.html","body":"<h1>NOT AVAILABLE OR DOES NOT EXISTS</h1>\n<p>Try refreshing the page…</p>\n"}

/***/ }),
/* 963 */
/***/ (function(module, exports) {

	module.exports = {"title":"Televisie uitzending Het Vermoeden","date":"2013-04-01T00:00:00Z","layout":"post","attachment":null,"linktext":null,"body":"<p>Op <strong>24</strong> en <strong>26 april</strong> (herhaling) <strong>2009</strong> was Sylvain De Bleeckere de gast van het televisieprogramma <strong>Het Vermoeden op Ned. 2 (Ikon)</strong>.\nDe uitzending is online te bekijken op <a href=\"http://www.npo.nl/het-vermoeden/12-09-2009/POW_00245630\">Het vermoeden</a>.</p>\n"}

/***/ }),
/* 964 */
/***/ (function(module, exports) {

	module.exports = {"title":"Filmdossiers","date":"2013-04-01T00:00:00Z","layout":"post","body":"<p>Sylvain De Bleeckere schreef in 2005 een uitgebreid dossier over de film <strong>Hotel Rwanda</strong> van <strong>Terry George</strong>. De titel luidt: <strong>Hotel Rwanda. Over menselijkheid en genocide</strong>. Het dossier bevat een deel van de leerkracht en een deel van de leerling.</p>\n<p><a href=\"2015-01-02-Filmdossiers/hr.pdf\">Dossier Hotel Rwanda</a></p>\n<p>Naar aanleiding van de heiligverklaring van <strong>pater Damiaan op 11 oktober 2009</strong>  biedt Men(s)tis een uitgebreid <strong>dossier</strong> aan over de film  <strong>Father Damien van Paul Cox</strong>. De film, een Vlaamse productie,  schildert een <strong>authentiek, religieus portret</strong> van de moderne heilige van Molokai.</p>\n<p><a href=\"2015-01-02-Filmdossiers/fd.pdf\">Dossier Father Damien</a></p>\n<p>De gekende jeugdroman <strong>The Book Thief</strong> (2005) van Markus Zusak kreeg een goede verfilming in 2013 onder de regie van <strong>Brian Perceval</strong>. De film volgt het boek in een geslaagde combinatie van <strong>historische roman</strong> over Duitsland in de Tweede Wereldoorlog en <strong>een coming-of-age verhaal</strong>. De confrontatie met de dood speelt een hoofdrol waardoor het filmverhaal zich beweegt binnen het register van <strong>de zingeving</strong>.</p>\n<p><a href=\"2015-01-02-Filmdossiers/tbt.pdf\">Dossier The Book Thief</a></p>\n<p>De Europese animatiefilm <strong>Brendan and the Secret of Kells</strong> (2008) van Tomm Moore stelt het historische evangelieboek <strong>The Book of Kells</strong>, bewaard in het Trinity College in Dublin, centraal. Sylvain De Bleeckere besteedt zowel aandacht aan het maken van de film als aan de historische achtergrond ervan en de esthetische benadering die steunt op het historische evangelieboek.</p>\n<p><a href=\"2015-01-02-Filmdossiers/br.pdf\">Dossier Brendan and The Secret of Kells</a></p>\n<p>De Vlaamse film <strong>BenX</strong> van Nic Balthazar handelt over  autisme in relatie tot de thuissituatie en het onderwijs. De film ondersteunt het pedagogisch werk van scholen rond het fenomeen ‘pesten op school’. Tegelijkertijd is de film zeer geschikt voor beeldopvoeding en lessen of projecten met een levensbeschouwelijke insteek. Sylvain De Bleeckere schreef een uitgebreid dossier voor de leerkracht en een dossier voor de leerlingen. Dit laatste is opgevat als werkmateriaal in de klas. Dit kan gratis worden opgevraagd via <a href=\"mailto:info@menstis.be\">info@menstis.be</a>.</p>\n<p><a href=\"2015-01-02-Filmdossiers/bx.pdf\">Dossier BenX voor leerkrachten</a></p>\n"}

/***/ }),
/* 965 */
/***/ (function(module, exports) {

	module.exports = {"title":"Kortfilm Men(S)tis Gedachtenis","date":"2013-04-01T00:00:00Z","layout":"post","attachment":"movie/","linktext":"Bekijk het fragment","body":"<p>Korte <strong>archieffilm</strong> gemaakt naar aanleiding van de <strong>20ste</strong> editie van <em>De Dag van de Religieuze Film</em> (2011). De titel is <strong>Gedachtenis</strong>. Het filmpje bewaart in het bijzonder de herinnering aan <strong>Nicole De Bleeckere-Van de Kerckhove</strong> (1951-1996). Ze was een van de vier stichters van Men(S)tis. Ze zorgde al die tijd, tot in 1996, voor het secretariaat en het onthaal. Ook <strong>Henk Hoekstra</strong>, o.carm., (1932-2000) verschijnt in beeld. Hij was de toenmalige president van de <em>Organisation Catholique Internationale du Cinéma et d’Audiovisuel</em> (OCIC, heden <em>Signis</em> genoemd) en tevens voorzitter van de <em>Katholieke Filmactie Nederland</em> (KFN).</p>\n"}

/***/ }),
/* 966 */
/***/ (function(module, exports) {

	module.exports = {"body":"<center>\n<video width=\"320px\" height=\"240px\" autobuffer=\"autobuffer\" autoplay=\"autoplay\" controls=\"controls\">\n    <source src=\"menstis.m4v\" type=\"video/mp4\">\n</video>\n</center>"}

/***/ }),
/* 967 */
/***/ (function(module, exports) {

	module.exports = {"title":"Voorstelling boek Gedachtenis","date":"2013-04-01T00:00:00Z","layout":"post","attachment":"Gedachtenis.pdf","linktext":"Lees Kennismaking","body":"<p>Presentatie van <strong>het boek</strong> over <strong>het thema gedachtenis</strong>, belicht vanuit de films: <strong>En waar de sterre bleef stille staan</strong>, <strong>Agora</strong> en <strong>Des hommes et des dieux</strong>.\nU kan het boek bestellen in onze rubriek <a href=\"/webshop/\">Webshop</a></p>\n"}

/***/ }),
/* 968 */
/***/ (function(module, exports) {

	module.exports = {"title":"De trap van de cinematografie","date":"2013-04-01T00:00:00Z","layout":"post","attachment":"Filmanalyse schema.pdf","linktext":"Lees het schema voor filmanalyse en filmgesprek","body":"<p>Dit document bevat <strong>het schema voor filmanalyse en filmgesprek</strong>, dat Sylvain De Bleeckere ontwikkelde. Het betreft een bewerking van een schema waarvan de eerse aanzet is gepubliceerd in <strong>Leren Leven Met Beelden</strong> nr. 2 (1996).</p>\n"}

/***/ }),
/* 969 */
/***/ (function(module, exports) {

	module.exports = {"title":"Voorstelling boek Het aards paradijs","date":"2013-04-01T00:00:00Z","layout":"post","attachment":"StudieAardsParadijs.pdf","linktext":"Lees kennismaking","body":"<p>Presentatie van het <strong>boek</strong> over <strong>het thema het aards paradijs</strong>, belicht vanuit het werk van <strong>Terrence Malick</strong> (<strong>The New World</strong> en <strong>The Tree of Life</strong>).</p>\n"}

/***/ }),
/* 970 */
/***/ (function(module, exports) {

	module.exports = {"title":"Bergrede XIII","date":"2013-04-01T00:00:00Z","layout":"post","attachment":"Bergrede_XIII_Blog.pdf","linktext":"Lees bergrede","body":"<p>De tekst die Sylvain De Bleeckere heeft uitgesproken bij de <strong>22ste editie van De Dag van de Religieuze Film</strong> met als thema: <strong>Bergrede XIII</strong>.</p>\n"}

/***/ }),
/* 971 */
/***/ (function(module, exports) {

	module.exports = {"title":"Interview Braambos","date":"2015-02-10T00:00:00Z","layout":"post","attachment":"ibr.mp3","linktext":"Beluister interview","body":"<p><strong>Interview met Sylvain De Bleeckere</strong> over het boek <strong>Levensbeschouwing democratisch belicht</strong>. uitgezonden door <strong>Braambos</strong> op 10.02.2015, naar aanleiding van de <em>24ste editie van De Dag van de Religieuze Film</em>.</p>\n"}

/***/ }),
/* 972 */
/***/ (function(module, exports) {

	module.exports = {"title":"Bibliografie Sylvain De Bleeckere","date":"2015-05-01T22:12:03.284Z","layout":"post","attachment":"sdbbiblio20.pdf","linktext":"Lees bibliografie","body":"<p>Het betreft de bibliografie van het gepubliceerde werk van prof.dr.em. Sylvain De Bleeckere. De bibliografie kwam tot stand naar aanleiding van zijn keynote-lezing <strong>Les Écritures cinématographiques</strong> tijdens het <strong>VIIIième Colloque International van Le Reseau de Recherche en Narrotologie et Bible</strong> met als thema: <em>Le Récit: thèmes bibliques et variations. Lectures et récritures littéraires et arstistiques</em>, aan de Université de Lorraine, Metz, van 26 tot 29 mei 2016.</p>\n<p>Laatste update bibliografie: 01.2020</p>\n"}

/***/ }),
/* 973 */
/***/ (function(module, exports) {

	module.exports = {"title":"Programmakaart De Dag 2020","date":"2017-12-27T00:00:00Z","layout":"post","attachment":"kaart29.pdf","linktext":"Lees kaart","body":"<p>Hier kunt u de programmakaart van De Dag van de Religieuze Film editie 29 (2020) downloaden.</p>\n"}

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(173);
	
	var _reactResponsiveGrid = __webpack_require__(407);
	
	var _gatsbyHelpers = __webpack_require__(403);
	
	var _typography = __webpack_require__(427);
	
	var _config = __webpack_require__(404);
	
	var _lodash = __webpack_require__(975);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _safeAccess = __webpack_require__(976);
	
	var _safeAccess2 = _interopRequireDefault(_safeAccess);
	
	var _Header = __webpack_require__(419);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var style = {
	  header: {
	    marginBottom: (0, _typography.rhythm)(1.5)
	  },
	  h1: {
	    marginBottom: 0,
	    fontSize: (0, _typography.scale)(1.5).fontSize,
	    lineHeight: (0, _typography.scale)(1.5).lineHeight,
	    marginTop: 0
	  },
	  h2: {
	    marginTop: 0,
	    textAlign: 'center'
	  },
	  h3: {
	    fontFamily: 'Montserrat, sans-serif',
	    marginTop: 0
	  },
	  img: {
	    margin: 0,
	    border: 0,
	    width: '1em',
	    height: '1em',
	    verticalAlign: 'middle'
	  },
	  Link: {
	    boxShadow: 'none',
	    textDecoration: 'none',
	    color: 'inherit'
	  },
	  Container: {
	    maxWidth: (0, _typography.rhythm)(24),
	    padding: (0, _typography.rhythm)(1.5) + ' ' + (0, _typography.rhythm)(3 / 4)
	  }
	};
	
	var Template = function (_React$Component) {
	  _inherits(Template, _React$Component);
	
	  function Template() {
	    _classCallCheck(this, Template);
	
	    return _possibleConstructorReturn(this, (Template.__proto__ || Object.getPrototypeOf(Template)).apply(this, arguments));
	  }
	
	  _createClass(Template, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          location = _props.location,
	          children = _props.children;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ui text container' },
	        children
	      );
	    }
	  }]);
	
	  return Template;
	}(_react2.default.Component);
	
	Template.propTypes = {
	  children: _react2.default.PropTypes.any,
	  location: _react2.default.PropTypes.object,
	  route: _react2.default.PropTypes.object
	};
	
	exports.default = Template;
	module.exports = exports['default'];

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.15';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	      } else if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        stack || (stack = new Stack);
	        if (isObject(srcValue)) {
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision && nativeIsFinite(number)) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key === 'constructor' && typeof object[key] === 'function') {
	        return;
	      }
	
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      // The sourceURL gets injected into the source that's eval-ed, so be careful
	      // with lookup (in case of e.g. prototype pollution), and strip newlines if any.
	      // A newline wouldn't be a valid sourceURL anyway, and it'd enable code injection.
	      var sourceURL = '//# sourceURL=' +
	        (hasOwnProperty.call(options, 'sourceURL')
	          ? (options.sourceURL + '').replace(/[\r\n]/g, ' ')
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      // Like with sourceURL, we take care to not check the option's prototype,
	      // as this configuration is a code injection vector.
	      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name + '';
	        if (!hasOwnProperty.call(realNames, key)) {
	          realNames[key] = [];
	        }
	        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(284)(module)))

/***/ }),
/* 976 */
/***/ (function(module, exports) {

	module.exports = function access(obj, accessStr) {
	  // auto-curry here
	  if (isUndefined(accessStr)) {
	    return access.bind(null, obj);
	  }
	
	  var funcArgs = Array.prototype.slice.call(arguments, 2);
	  return helper(obj, tokenize(accessStr), null, funcArgs);
	};
	
	function helper(obj, tokens, ctx, fnArgs) {
	  if (tokens.length === 0) {
	    return obj;
	  }
	
	  var currentToken = tokens[0];
	
	  if (isUndefined(obj) || isNull(obj) ||
	    (isTokenFunctionCall(currentToken) && !isFunction(obj))) {
	    return undefined;
	  }
	
	  if (isTokenFunctionCall(currentToken)) {
	
	    return helper(obj[isArray(fnArgs[0]) ? 'apply' : 'call'](ctx, fnArgs[0]),
	      tokens.slice(1),
	      // clear context because consecutive fn calls execute in global context
	      // e.g. `a.b()()`
	      null,
	      fnArgs.slice(1));
	
	  } else if (isTokenArrayAccess(currentToken)) {
	
	    return helper(obj[parseInt(currentToken.substr(1), 10)],
	      tokens.slice(1),
	      // lookahead two tokens for function calls
	      isTokenFunctionCall(tokens[1]) ? obj : ctx,
	      fnArgs);
	
	  } else {
	
	    return helper(obj[currentToken],
	      tokens.slice(1),
	      // lookahead two tokens for function calls
	      isTokenFunctionCall(tokens[1]) ? obj : ctx,
	      fnArgs);
	
	  }
	}
	
	function isUndefined(a) {
	  return a === void 0;
	}
	
	function isNull(a) {
	  return a === null;
	}
	
	function isArray(a) {
	  return Array.isArray(a);
	}
	
	function isFunction(a) {
	  return typeof a === 'function';
	}
	
	function isTokenFunctionCall(token) {
	  return token === '()';
	}
	
	function isTokenArrayAccess(token) {
	  return /^\[\d+\]$/.test(token);
	}
	
	function tokenize(str) {
	  return str.split(/\.|(\(\))|(\[\d+?])/).filter(function(t) { return t; });
	}


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(173);
	
	var _sortBy = __webpack_require__(386);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	var _reactDocumentTitle = __webpack_require__(952);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _gatsbyHelpers = __webpack_require__(403);
	
	var _typography = __webpack_require__(427);
	
	var _safeAccess = __webpack_require__(976);
	
	var _safeAccess2 = _interopRequireDefault(_safeAccess);
	
	var _config = __webpack_require__(404);
	
	var _include = __webpack_require__(420);
	
	var _include2 = _interopRequireDefault(_include);
	
	var _moment = __webpack_require__(978);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _startsWith = __webpack_require__(573);
	
	var _startsWith2 = _interopRequireDefault(_startsWith);
	
	var _semanticUiReact = __webpack_require__(471);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var style = {
	  post: {
	    marginBottom: (0, _typography.rhythm)(1),
	    listStyle: 'none'
	  },
	  Link: {},
	  date: {
	    fontSize: (0, _typography.rhythm)(1 / 2),
	    color: 'gray'
	  }
	};
	
	var BlogIndex = function (_React$Component) {
	  _inherits(BlogIndex, _React$Component);
	
	  function BlogIndex() {
	    _classCallCheck(this, BlogIndex);
	
	    return _possibleConstructorReturn(this, (BlogIndex.__proto__ || Object.getPrototypeOf(BlogIndex)).apply(this, arguments));
	  }
	
	  _createClass(BlogIndex, [{
	    key: 'render',
	    value: function render() {
	
	      var pageLinks = [];
	      // Sort pages.
	      //<Link style={style.Link} to={prefixLink(page.path)}>
	      var sortedPages = (0, _sortBy2.default)(this.props.route.pages, function (page) {
	        return (0, _safeAccess2.default)(page, 'data.date');
	      }).reverse();
	      sortedPages.forEach(function (page) {
	        if ((0, _safeAccess2.default)(page, 'file.ext') === 'md' && !(0, _include2.default)(page.path, '/404') && (0, _startsWith2.default)(page.path, "/blog/")) {
	          var title = (0, _safeAccess2.default)(page, 'data.title') || page.path;
	          var link = null;
	          if (!(0, _safeAccess2.default)(page, 'data.linktext')) {
	            link = _react2.default.createElement('span', null);
	          } else {
	            link = _react2.default.createElement(
	              _reactRouter.Link,
	              { target: '_blank', style: style.Link, to: (0, _gatsbyHelpers.prefixLink)(function (path, linkFile) {
	                  var index = path.lastIndexOf("/");
	                  return path.substr(0, index + 1) + linkFile;
	                })(page.path, page.data.attachment) },
	              (0, _safeAccess2.default)(page, 'data.linktext') || page.path
	            );
	          }
	          if ((0, _safeAccess2.default)(page, 'data.layout') == "post") {
	            pageLinks.push(_react2.default.createElement(
	              'li',
	              { key: page.path, style: style.post },
	              _react2.default.createElement(
	                'div',
	                { className: 'parent-blog blog-image ' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'child-blog' },
	                  page.data.title
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: style.date },
	                (0, _moment2.default)(page.data.date).calendar()
	              ),
	              _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: page.data.body } }),
	              link,
	              _react2.default.createElement('h1', null)
	            ));
	          }
	        }
	      });
	      return _react2.default.createElement(
	        _reactDocumentTitle2.default,
	        { title: _config.config.blogTitle },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('h1', null),
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Blog'
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            pageLinks
	          )
	        )
	      );
	    }
	  }]);
	
	  return BlogIndex;
	}(_react2.default.Component);
	
	BlogIndex.propTypes = {
	  route: _react2.default.PropTypes.object
	};
	
	exports.default = BlogIndex;
	module.exports = exports['default'];

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return (Object.getOwnPropertyNames(obj).length === 0);
	        } else {
	            var k;
	            for (k in obj) {
	                if (obj.hasOwnProperty(k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null,
	            rfc2822         : false,
	            weekdayMismatch : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid = isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            }
	            else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid (flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        ss : '%d seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function set$1 (mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	            }
	            else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        if (!m) {
	            return isArray(this._months) ? this._months :
	                this._months['standalone'];
	        }
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        if (!m) {
	            return isArray(this._monthsShort) ? this._monthsShort :
	                this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            var args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays (ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        var weekdays = isArray(this._weekdays) ? this._weekdays :
	            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
	        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
	            : (m) ? weekdays[m.day()] : weekdays;
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('k',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour they want. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var localeFamilies = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                var aliasedRequire = require;
	                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {}
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	            else {
	                if ((typeof console !==  'undefined') && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var locale, parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, tmpLocale, parentConfig = baseConfig;
	            // MERGE
	            tmpLocale = loadLocale(name);
	            if (tmpLocale != null) {
	                parentConfig = tmpLocale._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            var curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10)
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    var obsOffsets = {
	        UT: 0,
	        GMT: 0,
	        EDT: -4 * 60,
	        EST: -5 * 60,
	        CDT: -5 * 60,
	        CST: -6 * 60,
	        MDT: -6 * 60,
	        MST: -7 * 60,
	        PDT: -7 * 60,
	        PST: -8 * 60
	    };
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10);
	            var m = hm % 100, h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i));
	        if (match) {
	            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        // Final attempt, use Input Fallback
	        hooks.createFromInputFallback(config);
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	        'discouraged and will be removed in an upcoming major release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	    function isDurationValid(m) {
	        for (var key in m) {
	            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	                return false;
	            }
	        }
	
	        var unitHasDecimal = false;
	        for (var i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher);
	
	        if (matches === null) {
	            return null;
	        }
	
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ?
	          0 :
	          parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            }
	            else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (isNumber(input)) {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])                         * sign,
	                h  : toInt(match[HOUR])                         * sign,
	                m  : toInt(match[MINUTE])                       * sign,
	                s  : toInt(match[SECOND])                       * sign,
	                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add      = createAdder(1, 'add');
	    var subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function calendar$1 (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year': output = monthDiff(this, that) / 12; break;
	            case 'month': output = monthDiff(this, that); break;
	            case 'quarter': output = monthDiff(this, that) / 3; break;
	            case 'second': output = (this - that) / 1e3; break; // 1000
	            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default: output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true;
	        var m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect () {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment';
	        var zone = '';
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        var prefix = '[' + func + '("]';
	        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        var suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000;
	    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
	    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
	    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return (dividend % divisor + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2 () {
	        return isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict ?
	          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	          locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add               = add;
	    proto.calendar          = calendar$1;
	    proto.clone             = clone;
	    proto.diff              = diff;
	    proto.endOf             = endOf;
	    proto.format            = format;
	    proto.from              = from;
	    proto.fromNow           = fromNow;
	    proto.to                = to;
	    proto.toNow             = toNow;
	    proto.get               = stringGet;
	    proto.invalidAt         = invalidAt;
	    proto.isAfter           = isAfter;
	    proto.isBefore          = isBefore;
	    proto.isBetween         = isBetween;
	    proto.isSame            = isSame;
	    proto.isSameOrAfter     = isSameOrAfter;
	    proto.isSameOrBefore    = isSameOrBefore;
	    proto.isValid           = isValid$2;
	    proto.lang              = lang;
	    proto.locale            = locale;
	    proto.localeData        = localeData;
	    proto.max               = prototypeMax;
	    proto.min               = prototypeMin;
	    proto.parsingFlags      = parsingFlags;
	    proto.set               = stringSet;
	    proto.startOf           = startOf;
	    proto.subtract          = subtract;
	    proto.toArray           = toArray;
	    proto.toObject          = toObject;
	    proto.toDate            = toDate;
	    proto.toISOString       = toISOString;
	    proto.inspect           = inspect;
	    proto.toJSON            = toJSON;
	    proto.toString          = toString;
	    proto.unix              = unix;
	    proto.valueOf           = valueOf;
	    proto.creationData      = creationData;
	    proto.year       = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear    = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month       = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week           = proto.weeks        = getSetWeek;
	    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	    proto.weeksInYear    = getWeeksInYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.date       = getSetDayOfMonth;
	    proto.day        = proto.days             = getSetDayOfWeek;
	    proto.weekday    = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear  = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset            = getSetOffset;
	    proto.utc                  = setOffsetToUTC;
	    proto.local                = setOffsetToLocal;
	    proto.parseZone            = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST                = isDaylightSavingTime;
	    proto.isLocal              = isLocal;
	    proto.isUtcOffset          = isUtcOffset;
	    proto.isUtc                = isUtc;
	    proto.isUTC                = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    function createUnix (input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone () {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar        = calendar;
	    proto$1.longDateFormat  = longDateFormat;
	    proto$1.invalidDate     = invalidDate;
	    proto$1.ordinal         = ordinal;
	    proto$1.preparse        = preParsePostFormat;
	    proto$1.postformat      = preParsePostFormat;
	    proto$1.relativeTime    = relativeTime;
	    proto$1.pastFuture      = pastFuture;
	    proto$1.set             = set;
	
	    proto$1.months            =        localeMonths;
	    proto$1.monthsShort       =        localeMonthsShort;
	    proto$1.monthsParse       =        localeMonthsParse;
	    proto$1.monthsRegex       = monthsRegex;
	    proto$1.monthsShortRegex  = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays       =        localeWeekdays;
	    proto$1.weekdaysMin    =        localeWeekdaysMin;
	    proto$1.weekdaysShort  =        localeWeekdaysShort;
	    proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	    proto$1.weekdaysRegex       =        weekdaysRegex;
	    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1 (format, index, field, setter) {
	        var locale = getLocale();
	        var utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	    var mathAbs = Math.abs;
	
	    function abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1 (duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1 (input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1 (input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':   return months;
	                case 'quarter': return months / 3;
	                case 'year':    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1 () {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asQuarters     = makeAs('Q');
	    var asYears        = makeAs('y');
	
	    function clone$1 () {
	        return createDuration(this);
	    }
	
	    function get$2 (units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        ss: 44,         // a few seconds to seconds
	        s : 45,         // seconds to minute
	        m : 45,         // minutes to hour
	        h : 22,         // hours to day
	        d : 26,         // days to month
	        M : 11          // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	        var duration = createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds <= thresholds.ss && ['s', seconds]  ||
	                seconds < thresholds.s   && ['ss', seconds] ||
	                minutes <= 1             && ['m']           ||
	                minutes < thresholds.m   && ['mm', minutes] ||
	                hours   <= 1             && ['h']           ||
	                hours   < thresholds.h   && ['hh', hours]   ||
	                days    <= 1             && ['d']           ||
	                days    < thresholds.d   && ['dd', days]    ||
	                months  <= 1             && ['M']           ||
	                months  < thresholds.M   && ['MM', months]  ||
	                years   <= 1             && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var locale = this.localeData();
	        var output = relativeTime$1(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return ((x > 0) - (x < 0)) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000;
	        var days         = abs$1(this._days);
	        var months       = abs$1(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        var totalSign = total < 0 ? '-' : '';
	        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return totalSign + 'P' +
	            (Y ? ymSign + Y + 'Y' : '') +
	            (M ? ymSign + M + 'M' : '') +
	            (D ? daysSign + D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? hmsSign + h + 'H' : '') +
	            (m ? hmsSign + m + 'M' : '') +
	            (s ? hmsSign + s + 'S' : '');
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid        = isValid$1;
	    proto$2.abs            = abs;
	    proto$2.add            = add$1;
	    proto$2.subtract       = subtract$1;
	    proto$2.as             = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds      = asSeconds;
	    proto$2.asMinutes      = asMinutes;
	    proto$2.asHours        = asHours;
	    proto$2.asDays         = asDays;
	    proto$2.asWeeks        = asWeeks;
	    proto$2.asMonths       = asMonths;
	    proto$2.asQuarters     = asQuarters;
	    proto$2.asYears        = asYears;
	    proto$2.valueOf        = valueOf$1;
	    proto$2._bubble        = bubble;
	    proto$2.clone          = clone$1;
	    proto$2.get            = get$2;
	    proto$2.milliseconds   = milliseconds;
	    proto$2.seconds        = seconds;
	    proto$2.minutes        = minutes;
	    proto$2.hours          = hours;
	    proto$2.days           = days;
	    proto$2.weeks          = weeks;
	    proto$2.months         = months;
	    proto$2.years          = years;
	    proto$2.humanize       = humanize;
	    proto$2.toISOString    = toISOString$1;
	    proto$2.toString       = toISOString$1;
	    proto$2.toJSON         = toISOString$1;
	    proto$2.locale         = locale;
	    proto$2.localeData     = localeData;
	
	    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	    proto$2.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    hooks.version = '2.24.0';
	
	    setHookCallback(createLocal);
	
	    hooks.fn                    = proto;
	    hooks.min                   = min;
	    hooks.max                   = max;
	    hooks.now                   = now;
	    hooks.utc                   = createUTC;
	    hooks.unix                  = createUnix;
	    hooks.months                = listMonths;
	    hooks.isDate                = isDate;
	    hooks.locale                = getSetGlobalLocale;
	    hooks.invalid               = createInvalid;
	    hooks.duration              = createDuration;
	    hooks.isMoment              = isMoment;
	    hooks.weekdays              = listWeekdays;
	    hooks.parseZone             = createInZone;
	    hooks.localeData            = getLocale;
	    hooks.isDuration            = isDuration;
	    hooks.monthsShort           = listMonthsShort;
	    hooks.weekdaysMin           = listWeekdaysMin;
	    hooks.defineLocale          = defineLocale;
	    hooks.updateLocale          = updateLocale;
	    hooks.locales               = listLocales;
	    hooks.weekdaysShort         = listWeekdaysShort;
	    hooks.normalizeUnits        = normalizeUnits;
	    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat        = getCalendarFormat;
	    hooks.prototype             = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD',                             // <input type="date" />
	        TIME: 'HH:mm',                                  // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
	        MONTH: 'YYYY-MM'                                // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(284)(module)))

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(173);
	
	var _Header = __webpack_require__(419);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _find = __webpack_require__(601);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _gatsbyHelpers = __webpack_require__(403);
	
	var _config = __webpack_require__(404);
	
	var _safeAccess = __webpack_require__(976);
	
	var _safeAccess2 = _interopRequireDefault(_safeAccess);
	
	var _typography = __webpack_require__(427);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _include = __webpack_require__(420);
	
	var _include2 = _interopRequireDefault(_include);
	
	var _startsWith = __webpack_require__(573);
	
	var _startsWith2 = _interopRequireDefault(_startsWith);
	
	var _breakpoint = __webpack_require__(947);
	
	var _breakpoint2 = _interopRequireDefault(_breakpoint);
	
	var _semanticUiReact = __webpack_require__(471);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rhythm = _typography2.default.rhythm;
	
	
	module.exports = _react2.default.createClass({
	  displayName: 'exports',
	  propTypes: function propTypes() {
	    return {
	      route: _react2.default.PropTypes.object
	    };
	  },
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	  handleTopicChange: function handleTopicChange(e) {
	    return this.context.router.push(e.target.value);
	  },
	  handleDropDown: function handleDropDown(e, data) {
	    return this.context.router.push(data.value);
	  },
	  render: function render() {
	    var _this = this;
	
	    var pageLinks = [];
	    // Sort pages.
	    var pages = this.props.route.pages;
	    var childPages = [];
	    var dropDown = [];
	    pages.forEach(function (page) {
	      if ((0, _safeAccess2.default)(page, 'file.ext') === 'md' && !(0, _include2.default)(page.path, '/404') && (0, _startsWith2.default)(page.path, "/dedag/")) {
	        var title = (0, _safeAccess2.default)(page, 'data.title') || page.path;
	        var isActive = page.path === _this.props.location.pathname;
	        pageLinks.push(_react2.default.createElement(
	          'li',
	          {
	            key: page.path,
	            style: {
	              marginBottom: rhythm(1 / 4)
	            }
	          },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { style: { boxShadow: 'none' }, to: (0, _gatsbyHelpers.prefixLink)(page.path) },
	            isActive ? _react2.default.createElement(
	              'strong',
	              null,
	              title
	            ) : title
	          )
	        ));
	        dropDown.push({ key: page.path, value: page.path, text: title });
	        childPages.push(page);
	      }
	    });
	    var docOptions = childPages.map(function (child) {
	      return _react2.default.createElement(
	        'option',
	        {
	          key: (0, _gatsbyHelpers.prefixLink)(child.path),
	          value: (0, _gatsbyHelpers.prefixLink)(child.path)
	        },
	        child.data.title
	      );
	    });
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'ui container' },
	        _react2.default.createElement(
	          _breakpoint2.default,
	          {
	            mobile: true
	          },
	          _react2.default.createElement(
	            'div',
	            {
	              style: {
	                overflowY: 'auto',
	                paddingRight: 'calc(' + rhythm(1 / 2) + ' - 2px)',
	                position: 'absolute',
	                width: 'calc(' + rhythm(10) + ' - 2px)',
	                borderRight: '1px solid lightgrey'
	              }
	            },
	            _react2.default.createElement(
	              'ul',
	              {
	                style: {
	                  listStyle: 'none',
	                  marginLeft: 0,
	                  marginTop: rhythm(1 / 2)
	                }
	              },
	              pageLinks
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              style: {
	                padding: '0 ' + rhythm(1),
	                paddingLeft: 'calc(' + rhythm(10) + ' + ' + rhythm(1) + ')'
	              }
	            },
	            this.props.children
	          )
	        ),
	        _react2.default.createElement(
	          _breakpoint2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { style: { paddingLeft: '15px' } },
	            _react2.default.createElement(_semanticUiReact.Dropdown, { defaultValue: this.props.location.pathname, fluid: true, search: true, selection: true,
	              options: dropDown, onChange: this.handleDropDown
	
	            })
	          ),
	          _react2.default.createElement('br', null),
	          this.props.children
	        )
	      )
	    );
	  }
	});

/***/ }),
/* 980 */
/***/ (function(module, exports) {

	module.exports = {"title":"Geschiedenis","body":"<p></font></td></p>\n</tr>\n<tr>\n<td bgcolor=\"#FCF9FF\" valign=\"top\">\n<p>In <strong>1983</strong> organiseerde de toenmalige Diocesane Werkgroep Filmopvoeding op School onder\nde leiding van <strong>Sylvain De Bleeckere</strong> haar eerste studiedag met als onderwerp ‘Filmopvoeding en filmanimatie’.</p>\n<p>In het kader van de viering van <strong>de tiende studiedag op 2 maart 1992</strong>,\norganiseerde de Werkgroep voor de eerste maal <strong>De Dag van de Religieuze Film</strong>\nonder het moto: “Een feest voor oog en geest”. Als inhoudelijke ondersteuning\npubliceerde Sylvain De Bleeckere het boek\n<strong>Het licht van de Schepping. De religiositeit van de beeldcultuur</strong>.\nAltiora, Averbode, 1992. Toen werden er acht films vertoond in twee zalen\nvan de toenmalige Trioscoop Hasselt. Er was tevens een inhoudelijk programma\nin het nabijgelegen Sint-Jozelfscollege.\nOver de <em>eerste</em> en de <em>tweede</em> editie van <em>De Dag van de Religieuze Film</em>\nis er <strong>een korte archieffilm</strong> te zien in de rubriek <a href=\"../blog/index.html\" title=\"archieffilm \">Blog</a>.</p>\n<p>Nadien ging ieder jaar op krokusmaandag <strong>De Dag</strong> door; er werden telkens\ndrie recente films vertoond in het kader van een thema.</p>\n<p>Vanaf <strong>de derde editie</strong> (1994) van <em>De Dag van de Religieuze Film</em>\npubliceerde Men(S)tis jaarijks <strong>Leren Leven Met Beelden</strong>\nter ondersteuning van leerkrachten en hun leerlingen bij filmopvoeding op school.\nDe brochure bevat een selectie van recente films die voor scholen relevant zijn.</p>\n<p><strong>Vanaf 1996, bij het eerste lustrum,</strong> vormde de werkgroep zich om tot\nde nieuwe vereniging zonder winstgevend doel die luistert naar de naam &quot;<strong>Mens, mentis’</strong>,\ngeschreven als “<strong>Men(S)tis</strong>” v.z.w. De vereniging werkt zonder subsidies, sponsoring of reclame-inkomsten.</p>\n<p>Bij de <strong>tiende</strong> editie van <em>De Dag</em> in <strong>2001</strong> verscheen\nhet boek <strong>Tragiek, Transcendentie en Triade. Beeldend denken nabij het oeuvre van Andrei Tarkovski</strong>.\nHierin introduceert Sylvain De Bleeckere <strong>het concept ‘beeldend denken’</strong>.</p>\n<p>Bij de <strong>twintigste</strong> editie van <em>De Dag</em> in 2011 verscheen het eerste nummer\nin de nieuwe reeks <strong>Men(S)tis’ Studies</strong> over het thema van <em>De Dag</em>: <strong>Gedachtenis</strong>.\nDeze nieuwe reeks vervangt de reeks Leren Leven Met Beelden waarvan er <em>zestien edities</em> verschenen.</p>\n<p>Bij de <strong>vierentwingste</strong> editie (2015) verscheen het boek <strong>Levensbeschouwing, democratisch belicht</strong>,\nvan Sylvain De Bleeckere, een uitgave van Pelckmans. Het synthetiseert en verdiept het denken waaruit\nDe Dag van de Religieuze Film is ontstaan. Naar aanleiding daarvan,\nstonden <strong>de vier- en vijfentwintigste edities van De Dag in het teken van het thema Levensbeschouwing</strong>.</p>\n<p>Hier volgt het overzicht van de vertoonde films per jaargang. Sommige film zijn opgenomen in de rubriek\nFilmFocus van deze website. De eerste zes jaargangen stonden in het teken\nvan het thema <strong>Het Licht van de Schepping</strong>, tevens de titel van het boek\nvan Sylvain De Bleeckere, verschenen naar aanleiding van <strong>de\neerste editie van De Dag van de Religieuze Film in 1992</strong>.</p>\n<blockquote>\n<p>Jaargang 29 (2020) <strong>Het Onzevader. Deel III: Breng ons niet in beproeving</strong>: Darkest Hour, Cold War, La prière.<br>\nJaargang 28 (2019) <strong>Het Onzevader. Deel II: Uw Rijk Kome</strong>: The Birth of a Nation, Lincoln, Selma.<br>\nJaargang 27 (2018) <strong>Het Onzevader. Deel I: Verlos ons van het kwade</strong>: Resurrection, Hacksaw Ridge, Hidden Figures.<br>\nJaargang 26 (2017) <strong>Magnificat in Em</strong>: Ida, Les Innocentes, The Help.<br>\nJaargang 25 (2016) <strong>Levensbeschouwing deel 2</strong>: Marie Heurtin, Son of Saul, Mr. Turner.<br>\nJaargang 24 (2015) <strong>Levensbeschouwing deel 1</strong>: The Mill and the Cross, Vision, The Book Thief.<br>\nJaargang 23 (2014) <strong>Het Beloofde Land</strong>:  Hannah Arendt, Inch’Allah, The Attack.<br>\nJaargang 22 (2013) <strong>Bergrede XIII</strong>: Le gamin au vélo, Detachement, Le Havre.<br>\nJaargang 21 (2012) <strong>Aards@Paradijs</strong>: Hadewijch, The Tree of Life, Les Neiges de Kilimandjaro.<br>\nJaargang 20 (2011) <strong>Gedachtenis</strong>: En waar de sterre bleef stille staan, Agora, Des Hommes et des Dieux.<br>\nJaargang 19 (2010) <strong>Blijvende Bijbelbeelden</strong>: Kain, I’m Not There, Brendan and the Secret of Kells,\nThe Nativity Story.<br>\nJaargang 18 (2009) <strong>God@the USA</strong>: W., There Will Be Blood, Into the Wild.<br>\nJaargang 17 (2008) <strong>Corpus Christi</strong>: Corpus Christi, BenX, Das Leben der Anderen, The Freedom Writers.<br>\nJaargang 16 (2007) <strong>Methode</strong>: Into Great Silence, The New World. <br>\nJaargang 15 (2006) <strong>Geloof in menselijkheid</strong>: Sophie Scholl, Hotel Rwanda, The Interpreter. <br>\nJaargang 14 (2005) <strong>Contemplatievermogen</strong>: Osama, Russian Ark, In America. <br>\nJaargang 13 (2004) <strong>Verzoening</strong>: Bloody Sunday, Far From Heaven, All or Nothing. <br>\nJaargang 12 (2003) <strong>Tao en de weg</strong>: The Road Home, Samsara, The Crouching Tiger, Hidden Dragon.<br>\nJaargang 11 (2002) <strong>Tabula Rasa</strong>: The Last Days, Wilde Blue –Notes à quelques vois, Chocolat. <br>\nJaargang 10 (2001) <strong>Tabula Sacra</strong>: L’Humanité,  Secrets and Lies, Babbettes Gaestebud.<br>\nJaargang 9 (2000)  <strong>1 en 1 = 1</strong>: Offret, The Book of Life, C’est quoi la vie? <br>\nJaargang 8 (1999)  <strong>Nostalgie</strong>: Mat’i sin, Amistad, Al Massir. <br>\nJaargang 7 (1998)  <strong>Vriendschap</strong>: Sancta Mortale, Breaking The Waves, Smoke, Il Postino. <br>\nJaargang 6 (1997)  <strong>Het Licht van de Schepping</strong>: Une histoire de vent, City of Joy, The Englishman Who Went Up A Hill But Came Down A Mountain.<br>\nJaargang 5 (1996)  <strong>Het Licht van de Schepping</strong>: The Secret Garden, My Life, Manneken Pis. <br>\nJaargang 4 (1995)  <strong>Het Licht van de Schepping</strong>: Ladybird, Ladybirth, Raining Stones, Shadowlands. <br>\nJaargang 3 (1994)  <strong>Het Licht van de Schepping</strong>: El Sol del Membrillo, L’Annonce faite à Marie, Marcellino, Pane e Vino, Decaloog 2 en 8. <br>\nJaargang 2 (1993)  <strong>Het Licht van de Schepping</strong>: La Double Vie de Véronique, Céline, Bagdad Café,  The Solovkis - the Promised Land, the Scorned Land. <br>\nJaargang 1 (1992)  <strong>Het Licht van de Schepping</strong>: Yeelen, Romero, Ei, De legende van de heilige drinker, Jesus de Montréal, Andrei Roublev, Dekalog 1.<br></p>\n</blockquote>\n"}

/***/ }),
/* 981 */
/***/ (function(module, exports) {

	module.exports = {"title":"Concept","body":"<p><em>De Dag van de Religieuze Film</em> onderzoekt en beleeft <strong>het antropologisch fenomeen van de levensbeschouwing in de postmoderne, democratische samenleving</strong>. Daarbij schenkt <em>De Dag</em> aandacht aan <strong>de hedendaagse waarde van het authentieke beeld, de esthetische</strong> en <strong>spirituele rijkdom van de cinematografie</strong> en <strong>de veelzijdige praxis van zingeving en religie</strong>. <em>De Dag</em> kadert in <strong>de ontwikkeling van het beeldend denken</strong>. Het <strong>motto</strong> van <em>De Dag</em> luidt: ‘<strong>Een feest voor oog en geest</strong>’.</p>\n<p><em>De Dag</em> ziet er uit als <strong>een bescheiden en niet-gesponsord event</strong> dat enkele recente films op <em>een andere manier</em> in de kijker plaatst dan de louter journalistieke en/of commerciële presentatie. Er is <strong>een beeldprogramma</strong> met films, alsook <strong>een woordprogramma</strong> dat het jaarthema en de verschillende films belicht.</p>\n<p>Iedere editie van <em>De Dag</em> heeft <strong>een andere thematische invalshoek</strong>. Sylvain De Bleeckere belicht het thema en de films tijdens zijn inleidingen en via publicaties. Van de 20ste editie (2011) en de 21ste editie (2012) verschenen zijn studies als <a href=\"../uitgeverij/index.html\" title=\"uitgeverij\">Men(S)tis’ Studies</a>. Naar aanleiding van de 23ste editie (2013) verscheen zijn boek <strong>Het Beloofde Land</strong> (Averbode Altiora) en bij de 24ste editie (2015) zijn boek <strong>Levensbeschouwing, democratisch belicht</strong> (Uitgeverij Pelckmans).</p>\n<p>De Dag vindt plaats in <strong>het bioscoopcomplex Kinepolis te Hasselt</strong>, telkens op krokusmaandag.</p>\n<p>Het Men(S)tis’ <strong>team</strong> dat het event organiseert: <strong>Sylvain De Bleeckere</strong> (concept en inhoud),\n<strong>Felix Rijcken</strong> (ondersteuning en verwelkoming),\n<strong>Samuel De Bleeckere</strong> (databeheer), <strong>Siegfried De Bleeckere</strong> (website),\n<strong>Gerda Bracke, Dorothea De Bleeckere, Thirza Vandenabeele</strong> (balie en onthaal).</p>\n<p>Voor meer informatie in verband met de <em>Dag van de Religieuze Film</em> kan je mailen naar dit adres: <a href=\"mailto:info@menstis.be\"><strong>info@menstis.be</strong></a>.</p>\n<img src=\"./zaal.jpg\" >\n<img src=\"./zaal2.jpg\" >\n"}

/***/ }),
/* 982 */
/***/ (function(module, exports) {

	module.exports = {"title":"Inschrijving","body":"<p><strong>Inschrijving vooraf</strong></p>\n<p>€ 45 per persoon op rek. nr. BE59 1430 7126 8126 [GEBA BE BB] van Men(S)tis vzw, Hasselt, met vermelding: <em>De Dag 29</em> en <em>de namen van de personen die zullen deelnemen</em>. Inschrijven vooraf via een bankoverschrijving is mogelijk tot en met vrijdag 20 februari 2020.</p>\n<p><strong>Op De Dag zelf</strong></p>\n<p>€ 50 per persoon.</p>\n<p><strong>Verzenden toegangskaarten</strong></p>\n<p>We bevelen aan om jouw/jullie overschrijving ook te melden via <a href=\"mailto:info@menstis.be\">info@menstis.be</a> met opgave van de volledige naam van de persoon of personen die inschrijven, samen met het postadres waarnaar de toegangskaarten kunnen worden verzonden. De naam van de betaler kan immers verschillen van die van de deelnemer/s aan <strong>De Dag</strong>. De toegangskaarten van hen die zijn ingeschreven tot en met zondag 16 februari 20120, worden verzonden op maandag 17 februari 2020.  Wie daarna nog inschrijft, kan de toegangskaart op <strong>De Dag</strong> zelf aan de balie komen afhalen.</p>\n<p><strong>Inschrijven via school/organisatie</strong></p>\n<p>Wie inschrijft via school of organisatie, mailt ons zijn/haar naam en adres, en vermeldt de officiële naam van de instantie die het bedrag van de deelname overschrijft. Zo kunnen we misverstanden bij het verzenden van de toegangskaart vermijden. Vraag aan de boekhouding die overschrijft, de persoon of personen te vermelden voor wie wordt overgeschreven.</p>\n<p><strong>Bewijs bankoverschrijving</strong></p>\n<p>Wie nog per bankoverschrijving op de laatste donderdag of vrijdag overschrijft,  dient een kopie van zijn of haar betalingsbewijs mee te brengen naar de balie. Hetzelfde geldt voor wie laat inschrijft via het rekeningnummer van een organisatie of school. Hierdoor vermijden we misverstanden of nalatigheden.</p>\n<p><strong>Ondeelbaar</strong></p>\n<p>Het is niet mogelijk om voor een deel van het programma in te schrijven.</p>\n<p><strong>Vragen of info</strong></p>\n<p><a href=\"mailto:info@menstis.be\">info@menstis.be</a></p>\n<p><strong>Inbegrepen</strong></p>\n<blockquote>\n<blockquote>\n<ol>\n<li>Het volledige programma.</li>\n<li>Koffie of thee (tijdens het onthaal tussen 9u00 en 9u55 geserveerd in de Brasserie 5th Avenue, rechts van de Kinepolistrap.</li>\n<li>Het recente boekje <strong>Beeldgebed</strong>, de nieuwe publicatie van Men(S)tis, naar een concept en met tekst van <em>Sylvain De Bleeckere</em>, en met originele beelden van de kunstenaars <em>Jan De Wachter, Marleen Mertens, Vincent Spaas en Jef Van Eynde</em>.</li>\n</ol>\n</blockquote>\n</blockquote>\n"}

/***/ }),
/* 983 */
/***/ (function(module, exports) {

	module.exports = {"title":"Locatie & Contact","body":"<h2>Locatie: Kinepolis Hasselt</h2>\n<p>De 29ste editie van <strong>De Dag van de Religieuze Film</strong> op 24 februari 2020 gaat door te <a href=\"https://business.kinepolis.be/evenementenlocatie/hasselt\">Kinepolis Hasselt, Via Media 1, 3500 Hasselt</a>. De bioscoop is gelegen op 200m van de grote ring van Hasselt (langs de Universiteitslaan, richting universitaire campus en Genk).</p>\n<p>Wie met de auto komt, kan gratis gebruik maken van de ruime parking.</p>\n<p>Met het openbaar vervoer kan je de bus H3 nemen tot de halte <em>Hasselt P&amp;R Grenslandhallen</em> (200 meter van Kinepolis Complex) of de bussen 11, 20a, 36 en 45 tot de halte <em>Hasselt Provinciehuis</em> (op 50 meter van Kinepolis Complex).</p>\n<p>Er zijn vier eetgelegenheden in het Kinepolis Complex: <em>5th Avenue</em> (Belgische keuken), <em>Guiliano</em> (Italiaans), <em>L’Avenda</em> (Eten aan lopende band), <em>Quick</em> (Fastfood).</p>\n<h2>Contact</h2>\n<p>Voor meer informatie in verband met de Dag van de Religieuze Film kan u mailen naar dit adres: <a href=\"mailto:info@menstis.be\">info@menstis.be</a>.\nTelefonische info: 011/25 27 43.</p>\n"}

/***/ }),
/* 984 */
/***/ (function(module, exports) {

	module.exports = {"title":"Programma 2020","body":"<p>Het nieuwe progamma van de <strong>29ste editie</strong> van <strong>De Dag</strong> op krokusmaandag <strong>24 februari 2020</strong> staat in het teken van het derde en laatste deel van de thematische triptiek over <strong>Het Onzevader</strong>. Het thema is <strong>Beproeving</strong>.</p>\n<p><strong>Darkest Hour</strong> (2017)</p>\n<img src= \"dh.jpg\">\n<p>De historische, Britse Oscarfilm van Joe Wright zoomt in op een weinig gekend historisch moment in het verhaal van de Tweede Wereldoorlog. Het betreft een verhaal waarvan de uitkomst het landschap van de huidige Europese Unie blijft tekenen. Centraal staat de uitzonderlijke politieke moed van de Britse premier <em>Sir Winston Churchill</em>. Hiermee thematiseert de film het fenomeen ‘<em>beproeving</em>’. De film houdt ermee de vinger aan de pols van wat vandaag dagelijks in de nieuwsmedia zicht- en hoorbaar is omdat het zo zeldzaam is: <em>politieke moed tonen tegenover de zorg voor een humane, democratische machtsuitoefening</em>. In de recente geschiedenis van de mensheid was dat nooit zo pregnant aan de orde in de maand mei van 1940. Aan de donkere kant van het spectrum bevond zich toen Hitler en zijn oorlogsregime, met wie de leiding gevende Engelse politici een deal wilden sluiten, aan de lichtzijde ervan stond Winston Churchill helemaal alleen. Hij vond de kracht om ‘de beproeving’ te doorstaan door zowel de warme menselijke kracht van zijn huwelijk en gezin als door zijn trouw aan de christelijke inspiratie van de humane, democratische Europese waarden waarin hij rotsvast en consequent geloofde. Het beklijvende en immer actuele filmportret is sterk gebaseerd op nauwkeurig historisch onderzoek, ook van het bestaande beeldmateriaal. Direct na <strong>De Dag</strong> verschijnt er op deze site - <strong>FilmFocus</strong> - een uitgebreide filmstudie over <strong>Darkest Hour</strong>. De film ontving zes Oscarnominaties en won er drie van, waaronder die van beste film van het jaar en beste acteur in hoofdrol.</p>\n<p><strong>Cold War</strong> (2018)</p>\n<img src=cws.jpg>\n<p><strong>Cold War</strong> sluit naadloos aan bij <strong>Darkest Hour</strong>. Churchill introduceerde na de Tweede Wereldoorlog het begrip ‘Iron Curtain’ (IJzeren Gordijn), zichtbaar teken van de Koude Oorlog. Het verdeelde Europa bestond uit twee verschillende ideologische werelden: de communistische in het Oosten en de liberale-democratische in het Westen. De film Zimna wojna (‘<strong>Cold War</strong>’) van de Pools-Amerikaanse regisseur Pawel Pawlikowski is, zoals zijn vorige film <strong>Ida</strong> - zie de filmstudie op de pagina FilmFocus - een echte Europese auteursfilm in zwart-wit. Via de twee personages Wiktor Warski en Zuzanne Zula Lichon schildert de regisseur <em>de twee tegengestelde ideologische werelden</em> op het niveau van het dagelijkse leven. Daarbij verkent Pawlikowski de verschillende ‘beproevingen’ die elk van de regimes typeert. Met die ‘beproevingen’ moeten individuen omgaan, wat niet altijd lukt. De film oogt esthetisch als een cinematografisch juweel dat vooral, in goede Europese filmtraditie, is opgebouwd naar een heel bijzondere slotsequentie die zich situeert in een kleine, vervallen dorpskerk.</p>\n<p><strong>La prière</strong> (2018)</p>\n<img src=\"lp.jpg\">\n<p>De Franse film van regisseur Cédric Kahn die ook samen met Fanny Burdino en Samuel Doux het scenario schreef, brengt ons naar een hedendaagse vorm van ‘<em>beproeving</em>’, die van <em>de verslaving</em>, in casu de verslaving aan harddrugs. De film volgt de tweeëntwintigjarige Thomas die een weg zoekt om van zijn zware heroïneverslaving af te raken. Die zoektocht brengt hem naar een gebedsgemeenschap in de Zwitserse bergen. Daar proberen verslaafden en ex-verslaafden via een gemeenschapsleven, gebaseerd op een uitgesproken gebedsleven, hun menselijke waardigheid en identiteit terug te vinden. De film brengt een fictief verhaal dat echter is geïnspireerd op bestaande experimenten om drugsverslaafden te helpen via <em>de contemplatieve methode van het bidden</em>. De film opent een <em>levensbeschouwelijke horizon</em> die alle vormen van verslaving, inherent aan onze brutale consumptiesamenleving, belicht vanuit een ongewoon, religieus bewogen zorgperspectief.</p>\n<p><strong>Het verloop van De Dag ziet er als volgt uit</strong>.</p>\n<table cellpadding=\"3\" cellspacing=\"2\">\n               <tr>\n                 <td valign=\"top\">09.00 &ndash; 10.00</td>\n                 <td><strong id=\"onthaal\">Onthaal</strong></td>\n               </tr>\n               <tr>\n                 <td valign=\"top\">10.00 &ndash; 10.05 </td>\n                 <td><strong id=\"welkom\">Welkom</strong><br>\n                   <span id=\"felixrijcken\">Felix Rijcken</span></td>\n               </tr>\n                 <td valign=\"top\">10.05 &ndash; 10.30 </td>\n                 <td><strong id=\"ovrhetthema\">Thema en films</strong><br>\n                   <span id=\"SylvainDeBleeckere\">Sylvain De Bleeckere</span></td>\n               </tr>\n                 </td> \n               <tr>\n                 <td valign=\"top\">10.30 &ndash; 12.35</td>\n                 <td><strong class=\"style1\" id=\"legaminauv&eacute;lo\">Darkest Hour</strong> (2017) <br>\n                   <strong>Joe Wright</strong><br>\n                   <span class=\"Prijs\">3 Oscars, 6 Oscarnominaties</span></td>\n               </tr>\n               <tr>\n                 <td>12.35  &ndash; 13.45</td>\n                 <td id=\"middagpauze2\"><strong>Middagpauze</strong></td>\n               </tr>\n               </td>\n               </tr>\n                 <td valign=\"top\">13.45 &ndash; 14.00 </td>\n                 <td><strong id=\"ovrhetthema\">Inleiding Cold War</strong><br>\n                   <span id=\"SylvainDeBleeckere\">Sylvain De Bleeckere</span></td>\n               </tr>\n                 </td> \n                 <td valign=\"top\n               <tr>\n                 <td valign=\"top\">14.00  &ndash; 15.30</td>\n                 <td><strong class=\"style1\">Cold War</strong>(2012) <br>\n                   <strong id=\"tonykaye\">Pawel Pawlikowski</strong><br>\n                 <span class=\"Prijs\">Cannes 2018: Beste regisseur</span></td>\n               </tr>\n               <tr>\n                 <td valign=\"top\">15.30 &ndash; 15.45</td>\n                 <td><strong id=\"pauze\">Pauze</strong></td>\n               </tr>\n                 <td valign=\"top\">15.45&ndash; 16.00 </td>\n                 <td><strong id=\"inleiding\">Inleiding La pière <span class=\"gamin\"></span></strong><br>\n                   <span id=\"SylvainDeBleeckere\">Sylvain De Bleeckere</span></td>\n               <tr>\n                 <td valign=\"top\">16.00 &ndash; 18.00</td>\n                 <td><strong class=\"style1\" id=\"hiddenfigures\">La prière</strong> (2018) <br>\n                   <span id=\"alikaurismaki\"><strong>Cédric Kahn</strong> <br>\n                   <span class=\"Prijs\">Berlijn: Beste acteur </span></span></td>\n               </tr>\n            </td>\n    </table>"}

/***/ }),
/* 985 */
/***/ (function(module, exports) {

	module.exports = {"title":"Toeschouwers","body":"<p><strong>Naar aanleiding van de 25ste editie van De Dag van de Religieuze Film (2016) krijgen de toeschouwers hier het woord. Verschillende toeschouwers die hier aan het woord komen, hebben alle of bijna alle edities meegemaakt. Voelt u zich ook als toeschouwer aangesproken, zend dan uw bijdrage naar <a href=\"mailto:info@menstis.be\">info@menstis.be</a>.</strong></p>\n<hr>\n<div class=\"menstis-title\"><h1>  Felix Rijcken </h1></div>\n<p>Maandag (16.02.2015) was een uitzonderlijke dag in de geschiedenis van De Dag. De inleidingen  waren subliem. Vele toeschouwers hebben stil  ‘genoten’ en dragen inspirerende beelden mee voor hunleven. Een ‘film’ kan een openbaring zijn, wat elke mens en elke tijd zo spontaan naar verlangt en ons uitnodigt naar de Goede, de Schone, de Ware Liefde. Proficiat!</p>\n<div class=\"menstis-title\"><h1>  Pierrot Onkelinx </h1></div>\n<p>Mag ik Sylvain en Men(S)tis proficiat wensen, maar vooral bedanken met de organisatie van ‘De Dag’. Ik had (heb) het nodig om weer eens ondergedompeld te worden in een filmblad. Film: mijn inspiratie en troost. Nog andere aanwezigen bevestigden dit. Bij het ouder worden neemt dat alleen maar toe. Met het programma in de hand zat ik op een roetsjbaan van beelden, muziek en emoties. Heel sterk was de timing en de vlotheid. ‘De Dag’ vloog voorbij! Met drie kanjers van films, in een mooie volgorde vertoond: zalig! Op je nuchtere maag <em>Resurrection</em> (editie 2018) zien, was recht in de roos. Tot op heden laat deze film mij niet los. Een parel! In deze woelige tijden, zijn er dus nog zekerheden. Sylvain en Felix trouw op post. Na zovele jaren nog even enthousiast! Want dat heeft me het meest geraakt. Het enthousiasme in Sylvain zijn spreken. Een vrolijkheid die inspireert! Daar hou ik van. ‘De Dag’ is duidelijk iets wat Sylvain echt koestert. Ik ben heel fier dat ik in de beginjaren daar als vrijwilliger heb mogen aan meewerken, dat ik daar bij mocht zijn. In ieder geval, bij leven en welzijn tot volgende editie!</p>\n<div class=\"menstis-title\"><h1>  Erik Aerts </h1></div>\n<p>Het was indrukwekkend, de drie films van de 24ste editie (<em>The Mill and the Cross, Vision, The Book Thief</em>). Ik kan alleen maar verwijzen naar <em>Levensbeschouwing democratisch belicht</em>: ‘de praxis van het contemplatievermogen’; dat inzien is het buitengewone zien (p. 83-84). Beklijvende indrukken die blijven nawerken en die niet in woorden uit te drukken zijn. De inleiding heeft mij zeker geholpen om er ‘in te komen’ en om het laten ‘in te werken’.</p>\n<hr>\n<div class=\"menstis-title\"><h1>  Zuster Kristien Vanderfeesten  </h1></div>\n<p>Mooie films boeien mij. Op De Dag van de Religieuze Film krijgen we de kans die te zien; daarom ben ik er graag bij. Elk jaar opnieuw doet Sylvain met Men(s)tis de moeite mooie films te kiezen, deze zeer goed in te leiden en te bespreken en dat wil ik niet missen. Voor mij is deze dag  echt een hoogdag, waar ik echt kan genieten van iets heel moois in de filmwereld zowel in beelden als qua uitleg. Niet te missen !!! De eerste film van editie 27 (2018), <em>Resurrection</em>, kon voor mij niet duidelijker het Onze Vader weergeven met de verwijzing naar het mooie schilderij van Rembrandt, <em>De Terugkeer van de Verloren Zoon</em>. De tweede film <em>Hacksaw Ridge</em> gaf duidelijk weer dat goedheid geen geweld is, en dat zij mensen echt inzet en daadkracht geeft.</p>\n<hr>\n<div class=\"menstis-title\"><h1>  Piet Martens </h1></div>\n<p>Leidt film vaak naar een magische Upperworld, dan is De Dag van de Religieuze Film voor mij zo dikwijls de toegangspoort geweest naar de moeilijk toegankelijke innerlijke wereld van de ziel. Verrassend en inspirerend.</p>\n<hr>\n<div class=\"menstis-title\"><h1>  Willy Schaeken </h1></div>\n<p>In menig opzicht heeft De Dag een uiterst positieve invloed. In het licht van Godards en Bressons waardevolle uitspraken over de levenskunst van de cinematografie, toont De Dag ieder jaar op krokusmaandag opnieuw het pure leven, ontdaan van elk waarheidsdenken en/of ideologie.</p>\n<hr>\n<div class=\"menstis-title\"><h1>  Jan De Wachter </h1></div>\n<p>25 jaar de Dag: Stille getuigenissen tussen de grote storm van de (kunst)mediawereld van een diep gefundeerde levensbeschouwelijk en artistiek leren kijken; liefde en leed gedeeld in de ruimte van de Lichtaard; film leren ervaren als een der belangrijkste menselijke, artistieke uitingen; een onmisbare bron /gids om als leerkracht uit te putten en mee aan de slag te gaan. Zie website <a href=\"http://www.jandewachter.be/\">Jan De Wachter</a>.</p>\n<hr>\n<div class=\"menstis-title\"><h1>  Marleen Mertens </h1></div>\n<p>Ik getuig met mijn eigen beelden en metaforen…25 jaar lang heeft De Dag mij meegenomen naar het hart van de film en de ziel van het beeld. Meermaals was ik geraakt en geïnspireerd als vrouw, moeder, leerkracht, kunstenaar…als mens. Ik heb er het oeuvre van Andrej Tarkovski ontdekt, het werd mijn inspiratiebron voor eigen werk: Gewaden van licht, een gewichtloos weefsel in witte vlasdraden en Chinees rijstpapier in de kleuren van het licht; Pillars of light, transparante zuilen in witte vlasdraden geweven met een kapiteel in gouddraden en metaforen voor de kracht van het licht. Het werk van Gust Van den Berghe En waar de sterre bleef stille staan, inspireerde me voor de creatie van Window of the soul, metafoor voor een venster op het leven. Zie website <a href=\"http://www.marleen-mertens.be/\">Marleen Mertens</a>.</p>\n<hr>\n<div class=\"menstis-title\"><h1>  Mieke Van Poucke </h1></div>\n<p>Na twintig keren aanwezig te zijn geweest, kan ik zeggen dat De Dag voor mij altijd een aparte beleving is. Het geeft je een beter inzicht in: Hoe bekijk ik een film? Na de altijd boeiende inleiding, word je meegenomen in de film, en de personages volg je op een andere manier. Ik geniet er altijd van de films een tweede maal te bekijken, het is even stilstaan bij jezelf en tot het besluit komen: ‘Wat doe ik er mee om mijn steentje bij te dragen in deze al moeilijke wereld?’ Ik ga altijd gelukkig naar huis, weliswaar met het hoofd vol van de vele impressies die nog verwerkt moeten worden. In ieder geval de moeite waard, ik wil De Dag zeker niet missen, en ook de vele mensen die je jaarlijks terug ziet.</p>\n<hr>\n<div class=\"menstis-title\"><h1>  Jan Hens </h1></div>\n<p>Een eenvoudige wijze om uit de drukte van het ’ laten leven ’ te stappen. Onbevangen de beeldende verbeelding van de werkelijkheid samen aanschouwen en toch zelf deze verbeelding beschouwen vanuit je eigen inspiratie als mens: soms een herkenning, soms een aanvulling, maar steeds een verdieping, een terugkeren naar de bron van je leven, van het evangelie. En daarnaast - ook al is dit soms vluchtig - een ont-moeten van mensen en van de bezieler van deze dag en dit vanuit een zeer groot respect voor het werk ,maar zeker voor deze mens als vleesgeworden Woord. Deze kleine bronnen van verbeelding zijn dikwijls de zaden van ons leven, waarmee we verder kunnen, in ons professioneel leven, maar ook in ons persoonlijk leven, omdat ze in ons ook groeien als een levenshouding…</p>\n<hr>\n<div class=\"menstis-title\"><h1>  Walter Kleuthgen </h1></div>\n<p>Als de scholen een week Krokusvakantie plannen, schreeuwt die maandag vet, onderlijnd en in een fluorkleurtje om aandacht in mijn kalender. Ik zou niet meer durven om dan iets anders te plannen, want ik word in Kinepolis verwacht voor … De Dag! Ik ga helemaal bovenaan zitten. Zo ben ik ten volle deel van de verwachtingsvolle groep die door het welkomswoord binnenduikt in de perfecte sfeer. De inleiding door prof dr. De Bleeckere is een klaterende waterval van energie, die mijn volle aandacht opeist. Horizonten worden breder, kaders worden helder belicht en verwachtingen worden aangescherpt. En alweer is de organisator er in geslaagd om drie films bij elkaar te brengen, die als gepolijste puzzelstukken in elkaar passen. Vanuit een afgebakend, maar ruim bemeten thema zit ik een marathon uit van beelden die me naar een hoger niveau tillen. Ik knoop nieuwe touwen aan elkaar, verbind feiten met interpretaties. Het is een voorrecht om me aan deze bron te mogen laven.</p>\n<hr>\n<div class=\"menstis-title\"><h1>  Sylvester Lamberigts </h1></div>\n<p>De Dag van de Religieuze Film, die ik tot hiertoe nog maar tweemaal heb gemist, is voor mij telkens weer een dag van bezinning, een dag om door te dringen in de zo vaak vergeten diepte van het Mysterie (met hoofdletter) in mezelf en in de wereld om mij heen. Zoals het Scheppingsverhaal in <em>Genesis 1-2,4a</em> begint ook deze dag altijd met het bezielende woord van Sylvain De Bleeckere, gevolgd door het licht van drie prachtige films die dit jaar [2016], ieder op zijn eigen wijze, het thema ‘Levensbeschouwing’ zullen belichten. Heel graag en van harte beveel ik ook het pas verschenen boek <em>Levensbeschouwing democratisch belicht</em> van Sylvain De Bleeckere aan, waarin de visie wordt verduidelijkt die aan de basis ligt van 25 jaar De Dag van de Religieuze Film. Iedereen zou dit moeten lezen en herlezen, voor of na deze religieuze filmdag. Ik zelf heb er intens van genoten, van de eerste tot de laatste bladzijde, met steeds groeiende belangstelling. Dit boek heeft me deugd gedaan, ook als exegeet. De uitleg van het scheppings-oerverhaal uit <em>Genesis 1-2,4a</em> die in dit boek wordt voorgesteld is zonder meer magistraal. Het laatste woord en eigenlijk een synthese van heel dit boek is ‘Lichtaard’, een andere naam voor ‘God’, die de duisternis doorbreekt en aan de aarde het licht schenkt.</p>\n<hr>\n<div class=\"menstis-title\"><h1>  Piet en Chris Ardui-Geerts </h1></div>\n<p>‘Il faut des rites’, zei de vos aan de Kleine Prins. Dat klopt voor ons want sinds jaar en dag is er op maandag van de Krokusvakantie de Dag van de Religieuze Film. Alle ingrediënten van een goed ritueel zijn aanwezig: je kijkt uit naar de nieuwheid binnen een vertrouwd kader; je wordt hartelijk ontvangen door Sylvain en zijn familie; je ziet bekende gezichten terug; je luistert naar boeiende inleidingen die je ogen alleen maar scherper en gerichter doen kijken; je doet met een paar honderd mensen aan ‘bioscoop’: beschouwen van het leven in al zijn rijke en diepe dimensies, je reflecteert over onze wereld, er is plaats voor kritiek en voor vertrouwen in de toekomst, je volhardt tot de laatste film, je neemt hartelijk afscheid van Sylvain\n’tot volgend jaar’. Zeker weten. De Dag… dat is goede liturgie.</p>\n<hr>\n<div class=\"menstis-title\"><h1>  Ann Brasseur </h1></div>\n<p>Als vormingswerker én begeleider van enkele groepen, werk ik ook graag met films als didactische werkvorm. Ik volg nu reeds achttien jaar De Dag van de Religieuze Film. Wat ik daar vooral leer is: leren kijken naar een film doorheen het beeld en achter het beeld. Door de inleiding en begeleiding van Sylvain De Bleeckere, verwerf je een dieptezicht in de film. Dat dit thematisch gebeurt, is buitengewoon interessant. De studies van Sylvain ? o.a. <em>Gedachtenis, Het aards paradijs, Het Beloofde Land, Levensbeschouwing thematisch belicht</em>, en vooral de zestien edities van <em>Leren leven met beelden</em> zijn een meerwaarde voor leerkrachten, vormingswerkers, en allen die zich enigszins willen vertrouwd maken met de dieper lichtende boodschap van het cultuurfenomeen FILM. Een film kan confronterend zijn, maar door dit telkens begeleid te volgen tijdens De Dag van de Religieuze Film, heb ik leren ontdekken dat deze benadering bijzonder goed werkt bij groepen. Je hebt geen woorden nodig om mensen bewust te maken van eigen gedrag. Met een gefundeerde inleiding krijgt men een goede entree tot bewustmaking zonder mensen te viseren, zonder gedrag te definiëren, wat in plaats van blokkerend, veeleer verruimend, bevrijdend en langzaam incorporerend werkt. Dat heb ik doorheen die achttien jaren tijdens ‘De Dag’ geleerd, mogen meemaken en leren waarderen. Een bijzondere dank aan al die mensen die dit mede mogelijk maken. Sylvain, je bent doorheen die jaren een enorme leraar geweest voor mij en voor de mensen die met mij meewerkten.</p>\n<hr>\n<div class=\"menstis-title\"><h1>  Liliane Hermans </h1></div>\n<p>De dag leert mij om op een diepere manier naar beelden en mijzelf te kijken. Steeds weer, dank zij de degelijke inleidingen, ligt daar een warme oproep tot meer mens-worden. De verhelderende en vaak confronterende en beklijvende beelden  vormen een aanzet tot een andere wereldbenadering en tot verdiept geloof…</p>\n<hr>\n<div class=\"menstis-title\"><h1>  Jos de Backere </h1></div>\n<p>Via vergelijkend beeldmateriaal kreeg ik een ruim inzicht in wat mensen motiveert om zich al dan niet in te zetten voor een ideaal. Het werden ook soms drama’s met echte menselijkheid. De Dag was me steeds een stimulans om, door mensen gestuwd, mijn levensqueeste te verdiepen en verder te zetten…</p>\n<hr>\n<div class=\"menstis-title\"><h1>  Peter Van Goethem </h1></div>\n<p>Mijn ervaring van De Dag in 2014 (thema <em>Shalom/Sjalam</em>) heeft een waaier van emoties losgemaakt die doordrongen tot mijn grondgemoed. Dit maakt dat ik niet onbewogen naar huis gereden ben. Ik ben aan De Dag zonder verwachtingen begonnen, ik liet me graag meevoeren op de reis die de organisatie voor ogen had. Naarmate deze reis vorderde, werd ik steeds meer geraakt, kwamen vragen aan bod die me niet meteen toelieten te praten. Ik moet toegeven dat ik in de namiddag verward ben geraak, deze toestand zie ik of voelt aan als een appel dat tot op vandaag een gebaar verwacht. De films lieten met andere woorden hun impact na, wellicht omdat ik het belangrijk vond om er aan blootgesteld te worden. Misschien vind ik daarin de essentie van De Dag: de mogelijkheid die geboden wordt om blootgesteld en daardoor geraakt te kunnen worden. Toen ik buiten het cinemacomplex kwam, scheen de ondergaande zon achter de wolken, de stralen braken door en verlichtten de omgeving. Ik begreep toen dat De Dag geen woorden behoeft.</p>\n<hr>\n<div class=\"menstis-title\"><h1>  Mark De Vroede </h1></div>\n<p>Het jaarlijkse ritueel dat Noord- en Zuid-Limburg verenigt, klinkt ongeveer als volgt: “Hallo Ignace?” “Ah, het moet weer bijna krokusvakantie zijn. Natuurlijk zal ik er zijn! Ga jij onze plaatsen voorbehouden zodat we goed kunnen volgen? We treffen elkaar bij de koffie, O.K.?” “Tot maandag.” Wat doet zo’n Dag van de Religieuze Film met een mens? Elk jaar opnieuw ervaar ik de dag als een triniteit waarin een religieuze geest werkzaam is. Het is mooi om vast te stellen dat het zoeken naar de zin van de filmbeelden leiden tot een bezinning op het leven van elk van ons. Een rijkdom aan beelden, soms hard, soms ontroerend beschrijft het leven nu en dan eens impliciet, maar regelmatig ook expliciet, vanuit een levensbeschouwing met een religieuze, meestal christelijke inspiratie. Na het zien van de beelden is er steevast een koffietijdige of maaltijdige reflectie en spreken we in onze, intussen vaste ‘Dagvandereligieuzefilm-groep’ over de pas geziene films. Vaak zeggen we tegen elkaar: ‘Het is toch straf dat er zoveel in een film zit, maar alleen zou ik het niet gezien of begrepen hebben!’ Gaandeweg hebben we begrepen dat film een universele taal is en zoals er in elke gesproken taal ook moeilijke, mooie, gevoelige,… woorden zijn, zo is er ook een zeer rijk palet van sprekende beelden die worden aangeboden tijdens deze steeds weer verrassende Dag van de Religieuze Film. Ten slotte, wil ik deze dag definiëren als een mooie triptiek: een dag van ‘het bekijken en beschouwen van beelden’, die ‘betekenisvol beklijven’ en ‘uitnodigen tot bewust beleven’.</p>\n<hr>\n<div class=\"menstis-title\"><h1>  Bart Coenegrachts </h1></div>\n<p>Enkele jaren geleden heb ik opnieuw de weg gevonden naar De Dag van de Religieuze Film. Sindsdien heeft de dag een vaste plek in mijn jaarprogramma, en in dat van enkele vrienden. Graag laten we onze horizon verruimen door het licht dat cineasten hebben gezien en verbeeld. Hun creativiteit verrast me, verbaast me of blaast me omver. Mijn hart en mijn denken vinden voedsel in de waarheid van het leven dat getoond wordt en in de openheid voor de schenkende bron van die levende waarheid. Vele films die me intens blij hebben gemaakt, zou ik nooit gezien hebben zonder deze Dag. Films die ons in contact hebben gebracht met grote persoonlijkheden uit de geschiedenis: <em>Vision. Aus dem Leben der Hildegard von Bingen, Hannah Arendt</em>. Beelden die in mijn hart blijven geprent, zoals de film opgebouwd rond een schilderij van Breugel: <em>The Mill and the Cross</em>; verhalen die hoop geven zoals <em>The Book Thief</em>. Een vrucht van deze dag is dat we in mijn werkveld, een groep van zeven parochies, de gewoonte hebben regelmatig een waardevolle film te tonen. In het voorjaar werd The Book Thief getoond. Mensen zijn er dankbaar om. Dankbaar ben ook ik.</p>\n<hr>\n<div class=\"menstis-title\"><h1>  Ivo Cleiren </h1></div>\n<p>‘D-Day’, zo klinkt in mijn oren De Dag (van de Religieuze Film). Voor mij een belangrijke dag waarop ik mezelf telkenjare trakteer, en waar ik ook ècht naar uitkijk. Belangrijk om verschillende redenen, die doorheen de jaren uiteraard wat veranderd zijn. In het prille begin was mijn beweegreden die van een jonge jeugdpastor, die toch wat op de hoogte wilde zijn van wat er in de (religieuze) filmwereld bewoog. Vermits ik buiten De Dag (bijna) nooit naar de cinema ga, wil ik die dag niet missen. Wat ik vooral wil zeggen over De Dag is dat ik de zorg zo waardeer, waardoor die dag een dag met een hoofdletter wordt. Goed op voorhand aangekondigd. Ter plekke hartelijk, warm en verzorgd onthaal door enthousiaste mensen  wààr vindt men die nog?. Prima verzorgd welkomstwoord, én dan telkens die deskundige uitleg van Sylvain. Met zorg uitgekozen filmen. Elk jaar weer zo beklijvend voor mij. Echt een feestdag. Zie webstite <a href=\"http://www.tongerlo.org/\">Ivo Cleiren</a>.</p>\n<hr>\n<div class=\"menstis-title\"><h1>  Paul Jacobs </h1></div>\n<p>Bijna alle 25 edities heb ik meegemaakt. Telkens weer kijk ik er begin januari al naar uit om De Dag met telkens een aanbod van drie films mee te maken. Al 25 jaar geeft prof. Sylvain De Bleeckere daarbij tekst en uitleg en vervolgens kun je je ‘beeldend’ laten verwennen gedurende een hele dag gekaderd in een bepaald thema. Zo’n beleving zet je aan het denken. Je smaakt de spirituele rijkdom van de filmbeelden. ‘Beeldend denken dankzij het contemplatievermogen van de mens’, noemt Sylvain dat. In al die jaren van het toeschouwerschap wordt je eigen denken gevormd en dat is de bedoeling van het immer wordende menszijn dat nooit af is. De Dag van de Religieuze Film is ook belangrijk in het kader van de huidige maatschappij die geseculariseerd is en waarin afscheid wordt genomen van een (Grieks metafysisch) platonisch christendom. De samenleving neemt dus zichtbaar afstand van een bepaalde godservaring, maar is de godservaring in het westen daarom geheel aan het verdwijnen? Hoegenaamd niet! Je merkt dat vele cineasten in hun filmisch kunstwerk een heel religieuze, spirituele dimensie leggen en daardoor een zingevende betekenis openstellen. Een dimensie tevens die oog heeft voor het niet te ontkennen aardse leven dat zich afspeelt in de Lichtaard waarbij de hemel de aarde nooit los laat. Religieus denken dat zo begrepen wordt is oecumenisch en de beste remedie tegen foute godsbeelden, ideologisering en radicalisering in welke vorm dan ook. En dat precies hebben deze 25 edities bereikt.</p>\n<hr>\n<div class=\"menstis-title\"><h1>  Frans Schoofs </h1></div>\n<p>Tijdens De Dag heb ik de eigen kracht van de filmwereld ervaren. Met zijn grote openheid en realiteitszin hebben de films mijn geest open gemaakt die op veel vlakken wereldvreemd was door de bekrompenheid van het allesbeheersende ‘woord’; er ontstond opmerkelijk meer ademruimte en horizon voor een zinvol leven. Met een zekere verwijzing naar het Damascusvisioen van Paulus, kan ik zeggen dat bepaalde films die ik heb leren kennen tijdens de vele edities van De Dag, mijn ogen hebben geopend voor realiteitszin en verantwoordelijkheidszin. Hoe troostend in nood de aanraking van een beeld of een gedenksteen kan zijn, zo genadevol waren de filmbeelden van allerlei aard die mijn ziel hebben geraakt vijfentwintig jaren lang. Mijn leven was als een grote bronzen klok zonder klepel, maar werd een klok met een boodschap van inzicht en vrede. De goedgunstigheid van God werd zichtbaar in de zorgende liefde van mensen voor elkaar, die niet een leven beleven met een goed verborgen agenda, maar een leven als open gebeuren met zijn tragiek en zijn overgave, beseffend dat angst, met of zonder god, nooit zal verdwijnen. De expressieve kracht van heel wat sterke filmbeelden brachten bij mij een meervoudig denken op gang, ze openbaarden me samen, met de boodschap van Jezus, de ultieme zin van het leven.</p>\n<hr>\n<div class=\"menstis-title\"><h1>  Thirza V. (zus van ‘Ben Hur’) </h1></div>\n<p>Toen ik als tiener (16) voor de tweede keer deel nam aan De Dag, was ik betoverd door de keuze van de films. Ze verwonderden me keer op keer. De toelichting bij de films vind ik zeer handig omdat ik merk dat er veel dingen aan mij voorbij gaan, dingen die ik anders niet zou opmerken. Hierdoor zijn de toelichtingen zeer interessant.</p>\n<hr>\n<div class=\"menstis-title\"><h1>  Katrien Ruytjens </h1></div>\n<p>Ik beleef De Dag als een intiem moment van persoonlijke, geestelijke oefening en vorming. Het geeft me een bijzonder moment van onthaasting en concentratie – te koesteren als jonge mama van vier. Toch is het geen escapisme, de Dag opgesloten in de cinema. Het is in tegendeel een dieper kijken in de werkelijkheid – ook mijn persoonlijke werkelijkheid. Uitzonderlijk was de emotie bij het zien van <em>Inch’Allah</em> (2014) met die krachtige boodschap rond vrijwilligerswerk, nuance, ideologie…dingen die me dierbaar zijn. Ik hoop de volgende 25 jaar te kunnen blijven komen. Met dank en waardering.</p>\n<hr>\n<div class=\"menstis-title\"><h1>  Marcella Wallraf </h1></div>\n<p>Ik ben ongeveer 15 keer naar De Dag gekomen, eerst in opdracht van de school, nu uit overtuiging dat ik hier goede films zie met een prachtige inleiding. De films blijven ‘hangen’. Goed georganiseerd.</p>\n<hr>\n<div class=\"menstis-title\"><h1>  Hilde Poelmans </h1></div>\n<p>Een dag stilstaan: luisteren, kijken, nadenken, genieten. Licht! Traditie in ons gezin: mama naar de filmdag , (drukke) papa neemt vrij voor de kindjes. Vandaag is de volwassen dochter een hevige, kritische filmfan.</p>\n<hr>\n<div class=\"menstis-title\"><h1>  P.S. </h1></div>\n<p>Ik weet niet meer hoeveel jaar, meer dan 20 in elk geval, ik deel genomen heb aan De Dag. Eerst in naam van de school, dan in eigen naam. Ik heb er elk jaar van genoten en houd elk jaar die maandag vrij. Niet te missen… voor mij in ieder geval niet!</p>\n<hr>\n<div class=\"menstis-title\"><h1>  Marc Michiels en Tine Blommaert </h1></div>\n<p>De Bleeckere brengt films samen waar wij vooraf geen verband zien. Wij hebben doorheen de jaren, en steeds opnieuw, films ontdekt en thema’s ontmoet die wij anders niet gezien zouden hebben. Het zijn films die blijven naspelen. Onze ogen werden door de inleidingen geopend zodat we ‘anders’ naar film kijken. De traagheid en de stilte die in de programmatie dikwijls terugkeren, zijn enerzijds bevreemdend en stemmen anderzijds tot reflectie. Enkele films die ons bijzonder zijn bijgebleven: <em>Chocolat</em> – <em>Kaïn en Abel</em> – <em>Les Neiges de Kilimandjaro</em> – <em>Hadewijck</em> – <em>Tree of Life</em> – <em>Hannah Arendt</em>  en de twee films over <em>Het Beloofde Land</em>.</p>\n<hr>\n<div class=\"menstis-title\"><h1>  Ignace De Wit </h1></div>\n<p>Elk jaar schoonheid, en telkens weer op de weg van de verwondering terug gezet…, leven is wonder en geschenk. Op een ‘verloren maandag’, de eerste dag van de krokusvakantie, ga ik sinds zijn ontstaan naar de ‘Dag van de religieuze film’ in Hasselt, die dit jaar (2017) aan zijn 26ste editie toe was. Ik miste de eerste uitgave in het Sint-Jozefscollege, en de edities van 2007 (toen ik in Brazilië en Chili verbleef) en van  2015 en 2017 (wegens ziekte). Trouwe bezoekers noemen hem ‘Dé Dag’, en ondertussen worden we ontvangen in Kinepolis Hasselt. Van één ding zijn de liefhebbers overtuigd: dat is geen verloren maandag! Want wij leerden er gaandeweg naar film kijken. Je zou kunnen opperen: “Dat gaat toch niet anders, naar film moet je nu eenmaal kijken!” Maar de bezieler en organisator, prof. dr. Sylvain De Bleeckere, leerde ons verder dan oppervlakkig of consumerend kijken, hij oefende ons in het dieper zien. Het ‘onder’ of ‘achter’ kijken. Interpreteren. De op het eerste zicht verborgen inhouden en rijkdommen zien. Verbindingen maken. Schoonheid zien. Ver-beeld-en. Beschouwen. Een Mens-beeld vormen. Menswording zien. Dankzij die jarenlange krokuscursus ‘zien’ durfde ik mijn eerste poging  ondernemen om zelf een film te bespreken. Nog wel een film waarvan ik de regisseur en een acteur ken. Het is de film <em>LIMBURGIA</em> van Noël Loozen die het scenario schreef en de film regisseerde.  Op het filmfestival van Utrecht in september 2017 sleepte deze film vier sterren in de wacht. Hij werd in 2017 uitgezonden op de Nederlandse televisie.</p>\n<hr>\n<div class=\"menstis-title\"><h1>  Zuster Marjolein Bruinen</h1></div>\n<p><em>Magnificat in Em</em> (2017) was het eerste evenement dat ik meegemaakt heb (ik stiet toevallig op een mededeling over de “Dag van de religieuze Film”, die - weer toevallig - op een vakantiedag voor mij viel, die ik genoot na ons algemeen kapittel). Daar ik als <em>Dominicanes van Bethanië</em> meerdere keren heb deelgenomen aan retraites met filmen, dacht ik: dat is iets voor mij. Ik heb me aangemeld en was heel benieuwd naar de gang van zaken. Nou, ik ben niet teleurgesteld - integendeel! Het was een fantastische, inspirerende, meditatieve, onrustig makende, bijzondere dag! De inleidingen bij de films door Sylvain waren subliem: ze openden je ogen en oren - en hart! - voor wat je te zien kreeg. De keuze van de films vond ik ook heel bijzonder. Als algemeen secretaris van de <em>UCESM</em> ― Unie van religieuze congregatie van hogere oversten in Europa, d.w.z. degene, die alle hogere oversten van religieuze congregaties in Europa bij elkaar moet houden/brengen en tevens algemeen secretaresse van onze congregatie van dominicanessen van Bethanië ― wil ik de film <em>Ida</em> tonen aan elke kandidate novice, die denkt, roeping voor het kloosterleven te hebben. Je komt er diep door in contact met jezelf…En de film <em>The Help</em> tenslotte, eveneens buitengewoon actueel, maar gelukkig ook met humor - hoe zou je anders weer naar huis hebben gekund? Ik wil allen die aan De Dag hebben meegewerkt  heel hartelijk danken voor dit geweldige geschenk en heb de datum voor de volgende editie al gereserveerd!</p>\n"}

/***/ }),
/* 986 */
/***/ (function(module, exports) {

	module.exports = {"title":"Dekalog","body":"<center>\n<img src=\"deka.jpg\" >\n</center>\n<a name=\"KLA\"></a>\n<h2><strong>Klapbord</strong></h2>\n<p>De tiendelige filmcyclus <span style=\"color:blue\"><strong>Dekalog</strong></span>, in het Nederlands <span style=\"color:blue\"><strong>Decaloog</strong></span>, is een Poolse productie, gerealiseerd door het duo Krzysztof Kieslowski en Krzysztof Piesiewicz.</p>\n<blockquote>\n<p>De eerste is een Poolse regisseur, geboren in 1941 en overleden in 1996. De tweede is een Poolse advocaat en scenarioschrijver, geboren in 1946. Beiden werkten intens samen aan tien scenario’s voor tien filmverhalen van circa 55 minuten, bestemd voor de Poolse televisie.</p>\n</blockquote>\n<blockquote>\n<p>Het uitgangspunt van hun project was de tekst van <em>de Bijbelse Tien Geboden</em>. Ze namen die bekende tekst als referentiekader, dus niet als uitgangspunt voor een vrij letterlijke toepassing of illustratie. Ze kozen voor _tien verschillende verhalen_met telkens andere personages. Ze verbonden die met elkaar verbonden via <em>de gemeenschappelijke locatie</em>.</p>\n</blockquote>\n<blockquote>\n<p>De personages wonen allemaal in een en zelfde moderne wijk van woonblokken. De opnames gebeurden inderdaad in <em>de Stawki-wijk</em> in Warschau.</p>\n</blockquote>\n<blockquote>\n<p>De opnames zelf vonden plaats van 8 maart 1987 tot juli 1988. Kieslowksi monteerde de opnames <span style=\"color:blue\"><strong>Dekalog</strong></span><strong>Dekalog</strong> in wereldpremière op de Poolse televisie. De respons was zo massaal positief dat de reeks ook als aparte films buiten Polen werden uitgebracht, eerst op internationale filmfestivals, daarna via het art house circuit over de hele wereld.</p>\n</blockquote>\n<blockquote>\n<p>Kieslowski maakte van <span style=\"color:blue\"><strong>Dekalog 5</strong></span> en <span style=\"color:blue\"><strong>Dekalog 6</strong></span> een aparte langere bioscoopversie onder de titels <em>A Short Film About Killing</em> en <em>A Short Film About Love</em>. De filmmuziek van <span style=\"color:blue\"><strong>Dekalog</strong></span> is van de Poolse componist Zbigniew Preisner.</p>\n</blockquote>\n<p><a name=\"SYN\"></a></p>\n<h2><strong>Synopsis</strong></h2>\n<p><span style=\"color:blue\"><strong>Dekalog 1</strong></span> verwijst naar de eerste van de Tien Geboden. In de Nederlandse versie die via het godsdienstonderwijs (de Mechelse Catechismus) werd verspreid, luidt het eerste Gebod: ‘<em>Bovenal bemin één God</em>’. Via de personages van de vader Krzysztof en zijn zoontje Pawel thematiseert Kieslowski- Piesiewicz de relatie mens - God. Vader Krzysztof is als professor linguïstiek een woordvoerder van de moderne mens. Hij doceert het geloof dat de moderne mens via de computertalen de metafysische positie die voorheen God bekleedde, kan uitschakelen en overnemen. Irena, de zuster van de professor en de tante van Pawel, is catechiste. Zij ontfermt zich gedeeltelijk over Pawel en opent voor de jongen de poort van het religieuze leven. De hardnekkigheid waarmee Krzysztof het gelijk van zijn geloof in de moderne vooruitgang wil bewijzen, kost het leven van zijn zoontje. Tegenover de dood wordt hij machteloos.</p>\n<p><span style=\"color:blue\"><strong>Dekalog 2.</strong></span> Het tweede van de Tien Geboden (‘<em>Zweer niet ijdel, vloek noch spot</em>’) handelt over het verbod om de naam van God ijdel te gebruiken. In het tweede verhaal van Kieslowski- Piesiewicz staat Dorota Geller centraal. Ze is violiste in het Filharmonisch Orkest. Haar man, Andrei, lijdt aan een kwaadaardige kanker en verblijft op de afdeling in het ziekenhuis waarvan de oudere geneesheer, buurman van Dorota en Andrei, het hoofd is. Dorota en Andrei konden tot nu toe geen kinderen krijgen. Nu is ze zwanger van Witek, een collega van het orkest, met wie ze een kortstondige verhouding heeft gehad, mede vanuit haar kinderwens. Dorota wil echter Andrei niet verliezen. Ze overweegt abortus wanneer ze de zekerheid had dat Andrei kan genezen. Die zekerheid vraagt ze aan haar buurman, de geneesheer.</p>\n<p><span style=\"color:blue\"><strong>Dekalog 3.</strong></span> In de christelijke traditie is het derde gebod van de Joodse decaloog omgevormd tot: ‘<em>Heilig steeds de Dag des Heren</em>’. Kieslowski- Piesiewicz situeren het derde verhaal op kerstavond; het verhaal eindigt bij de komst van het daglicht op kerstdag wanneer de klok het zevende uur aanwijst. Via het getal zeven plaatsen Kieslowski- Piesiewicz het verhaal in het teken van de Bijbelse betekenis van de zevende dag, de zondag, ‘de Dag des Heren’. Centraal staan de taxichauffeur Janusz en de alleenstaande vrouw Ewa. Beiden hebben drie jaar geleden een kortstondige, buitenechtelijke relatie gehad. Janusz heeft een gezin met zijn vrouw en hun twee kinderen. Ze wonen samen de middernachtmis bij. Ewa ziet Janusz en zijn gezin in de kerk. Na de mis belt ze aan bij haar vroegere minnaar. Ze lokt Janusz naar buiten met de leugen dat ze hopeloos op zoek is naar haar man die niet is thuisgekomen. Zo probeert aldus de eenzaamheid die op kerstavond en –nacht zwaarder doorweegt dan anders, te verdrijven. Janusz probeert haar te helpen. Wanneer Ewa om zeven uur ’s morgens de waarheid opbiecht, keert Janusz ongeschonden terug naar zijn gezin.</p>\n<p><span style=\"color:blue\"><strong>Dekalog 4.</strong></span>  Het Bijbelse vierde gebod handelt over de kinderen en de ouders: ‘<em>Vader, moeder zult gij eren</em>.’ Kieslowski- Piesiewicz stellen hun vierde verhaal in het teken van het vaderschap. De personages heten Anka, een studente aan de kunstschool, Jarek, haar vriend-medestudent, en Michal, weduwnaar en de vader van Anka. De ethische spankracht van het verhaal handelt over de betekenis van het vaderschap in een relatie vader-dochter waarbij de vader niet de biologische vader is.</p>\n<p><span style=\"color:blue\"><strong>Dekalog 5.</strong></span> Het vijfde van de Tien Geboden is wel het bekendste: ‘<em>Gij zult niet doden</em>’, in de catechetische stijl: ‘<em>Dood niet, geef geen ergernis</em>.’ Kieslowski- Piesiewicz plaatsen hun vijfde verhaal in het teken van de doodstraf. De personages zijn Piotr Balicki, Waldemar Rykowki, Jacek Lazar. Piotr is een pas gediplomeerde advocaat, Waldemar is een taxichauffeur, de jonge twintiger Jacek stapt in de taxi van Waldemar en, zonder enig aanleiding, vermoordt hij de man. Piotr wordt de advocaat van Jacek, zijn eerste klant.</p>\n<p><span style=\"color:blue\"><strong>Dekalog 6.</strong></span> Het zesde Gebod handelt over seksuele relaties. ‘Doe nooit wat onkuisheid is.’ Dit is een katholieke vertaling van de Joodse formulering: ‘<em>Gij zult geen echtbreuk plegen</em>.’ Over dat laatste handelt het zesde verhaal van Kieslowski- Piesiewicz. De hoofdpersonages zijn jonge postbediende Tomek en de ongehuwde kunstenares Magda. Tussen beiden ontstaat er een relatie via de verrekijker waarmee Tomek Magda begluurt. Wanneer hij met Magda contact zoekt, vernedert ze hem seksueel vanuit haar cynische kijk op seksualiteit. Ze heeft echter de gevolgen van haar gedrag tegenover Tomek niet ingeschat.</p>\n<p><span style=\"color:blue\"><strong>Dekalog 7.</strong></span> Het zevende gebod verbiedt <em>het stelen</em>. Het zevende verhaal van Kieslowski- Piesiewicz handelt niet expliciet over dieven. Het verhaal vertrekt van de vraag van de tweeëntwintigjarige ongehuwde moeder Majka: ‘Kan je stelen wat van jou is?’ In het verhaal zit een ethische bezinning over het stelen van gevoelens, verbonden met het zesjarige Anka, het dochtertje van Majka die bij haar moeder Ewa inwoont. Naar de buitenwereld toe, gedraagt de veertigjarige Ewa zich als de moeder van Anka.</p>\n<p><span style=\"color:blue\"><strong>Dekalog 8.</strong></span> In het achtste Gebod staat <em>het liegen</em> centraal. God verbiedt de leugen, een wijd verspreid gebruik onder mensen. Het Bijbelse Gebod gaat letterlijk over de morele afwijzing van het afleggen van een valse verklaring of getuigenis. In hun achtste verhaal verplaatsen Kieslowski- Piesiewicz de rechtszaal naar de collegezaal aan de universiteit van Warschau. Elzbieta Lorenz is een Poolse Jodin die in de Verenigde Staten woont. Ze is naar de universiteit in haar geboortestad gekomen om er het college te volgen van vrouwelijke professor in ethiek, Zofia. Elzbieta heeft Zofia’s boeken van het Pools naar het Engels vertaald. Tijdens het college komt er een ethische confrontatie tussen Zofia en Elzbieta. Die confrontatie brengt de pijnlijke herinnering aan de Jodenvervolging in Polen naar boven.</p>\n<p><span style=\"color:blue\"><strong>Dekalog 9.</strong></span> Het negende verhaal van Kieslowski- Piesiewicz gaat opnieuw vrij om met de katholieke formulering van het negende Gebod: ‘Ge zult geen onkuisheid begeren’ of ‘Doe nooit wat onkuisheid is’ (Mechelse Catechismus). Concreet zoomt het verhaal in op het echtpaar Hanka en Romek. Hij is een hartchirurg. Door een ziekte is hij impotent. Hij ontdekt dat zijn vrouw Hanka regelmatig contact heeft met een zekere Mariusz. Hanka en Romek zoeken elk afzonderlijk een weg om toch hun wederzijdse liefde en hun huwelijk te beschermen. De regie van toevalligheden en het spel van argwaan en onmacht maken dat hun weg erg hobbelig verloopt.</p>\n<p><span style=\"color:blue\"><strong>Dekalog 10.</strong></span> Het niet-begeren van andermans goed ― het Tiende Gebod ― staat centraal in het laatste verhaal van Kieslowski- Piesiewicz. Twee broers, Jerzy en Artur Korzen, beslissen na het overlijden van hun vader, een bekende Poolse filatelist, de kostbare collectie van hun vader te bewaren en nog beter te beveiligen. Ze offeren alles op voor het behoud van het kostbare goed waarvan ze de waarde nog willen vergroten tot ze vaststellen dat ze zijn bestolen.</p>\n<p><a name=\"CIN\"></a></p>\n<h2><strong>Cinematografie</strong></h2>\n<p><span style=\"color:darkkhaki\"><strong>SPIEGELING.</strong></span> Cinematografisch werkt Kieslowski met het fenomeen spiegeling. Dat is in de eerste plaats letterlijk te verstaan.</p>\n<blockquote>\n<p>In <span style=\"color:blue\"><strong>Dekalog 6</strong></span> bijvoorbeeld spiegelen zich de begin- en eindsequenties in elkaar via een letterlijk spiegelbeeld. In het begin en op het einde komt Magda naar het postkantoor waar Tomek werkt. Kieslowski maakt gebruikt van het reflecterende glas van het postloket om het gereflecteerde gelaat van Magda samen te brengen met dat van Tomek.</p>\n</blockquote>\n<blockquote>\n<p>In de andere delen van de <span style=\"color:blue\"><strong>Dekalog</strong></span> komen verschillende sequenties voor waarin de personages in de spiegel kijken. <span style=\"color:blue\"><strong>Dekalog 5</strong></span> opent zelfs met een spiegelbeeld, namelijk dat van de student rechten Piotr. Hij staat op het punt zijn laatste examen af te leggen. Gedurende het hele verhaal bewaart Piotr die reflexieve, beschouwende houding waarmee Kieslowski-Piesiewicz zich identificeren.</p>\n</blockquote>\n<blockquote>\n<p>Maar de spiegeling als cinematografisch principe reikt verder dan de <em>letterlijke</em> spiegeling. Kieslowski gebruikt ook de <em>narratieve</em> spiegeling. Dat gebeurt bijvoorbeeld door <span style=\"color:blue\"><strong>Dekalog 1</strong></span> en <span style=\"color:blue\"><strong>Dekalog 2</strong></span> in elkaar narratief te spiegelen. Niettegenstaande de personages van <span style=\"color:blue\"><strong>Dekalog 1</strong></span> en <span style=\"color:blue\"><strong>Dekalog 2</strong></span> niets met elkaar gemeen hebben, behalve dat ze in dezelfde buurt wonen, spiegelen beide delen zich toch in elkaar. <span style=\"color:blue\"><strong>Dekalog 1</strong></span> staat narratief in de modus van de dood, terwijl <span style=\"color:blue\"><strong>Dekalog 2</strong></span> zich ontwikkelt in de modus van het leven. De dood van de kleine Pawel (<span style=\"color:blue\"><strong>Dekalog 1</strong></span>) spiegelt zich in de nakende geboorte van het eerste kind van Dorota en Andrei (<span style=\"color:blue\"><strong>Dekalog 2</strong></span>).</p>\n</blockquote>\n<blockquote>\n<p>Behalve de letterlijke spiegeling en de narratieve spiegeling, werkt Kieslowski ook nog met de <em>structurele</em> spiegeling. Die duidt op de opbouw van de vertelling die verloopt volgens de stijlfiguur van het chiasme. Verwijzend naar de Griekse letter X betreft het een herhaling via omkering. Dat kenmerkt bijvoorbeeld zeer sterk de opbouw van <span style=\"color:blue\"><strong>Dekalog 5</strong></span> en <span style=\"color:blue\"><strong>Dekalog 6</strong></span>. In <span style=\"color:blue\"><strong>Dekalog 5</strong></span> is er eerst het verhaal van de moordenaar Jacek, daarna volgt het verhaal van advocaat Piotr die wordt geconfronteerd op de moord op Jacek via de doodstraf. In <span style=\"color:blue\"><strong>Dekalog 6</strong></span> bekijkt eerst Tomek Magda via de verrekijker, nadien zoekt Magda contact met Tomek via haar verrekijker en haar raam.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>EENHEID IN VERSCHEIDENHEID.</strong></span>  De tien verhalen staan ieder op zich. Ze kennen telkens andere hoofd- en nevenpersonages. Tegelijkertijd zijn ze in menig opzicht met elkaar verbonden.</p>\n<blockquote>\n<p>Dat gebeurt natuurlijk door de eenheid van locatie, de wijk met de woonblokken. Daarnaast worden hoofdpersonages soms figuranten. In <span style=\"color:blue\"><strong>Dekalog 3</strong></span> bijvoorbeeld komt taxichauffeur Janusz thuis. Wanneer hij de deur van het appartementsgebouw wil openen, is Krzysztof, de vader van Pawel in <span style=\"color:blue\"><strong>Dekalog 1</strong></span>, hem voor.</p>\n</blockquote>\n<blockquote>\n<p>De onderliggende eenheid blijkt ook uit de betiteling. Alle verhalen hebben dezelfde titel: <span style=\"color:blue\"><strong>Dekalog</strong></span>; alleen hun nummer van hun plaats in het geheel verschilt. De onderliggende eenheid, aanwezig in de hoofdtitel, duidt op <em>de eigentijdse interpretatie van de Bijbelse Decaloog</em>, beter gekend als <em>De Tien Geboden</em>.</p>\n</blockquote>\n<blockquote>\n<p>Die ethische eenheid krijgt nog een gemeenschappelijke verschijning in de existentiële scène waarop de tien verhalen met hun personages zich bewegen. Alle verhalen zijn <em>levensverhalen</em>. De personages denken daarbij niet aan een aanwezig gebod of verbod. Hun gedrag ontwikkelt zich vanuit hun eigen existentiële ervaringen in de regie van het toeval. Die ervaringen primeren.</p>\n</blockquote>\n<blockquote>\n<p>De narratieve onderlegger verdwijnt niet achter een dogmatische wand van geboden en verboden. In de optiek van <span style=\"color:blue\"><strong>Dekalog</strong></span> vormen die geboden en verboden geen statische uitspraken die het menselijk gedrag vanboven af willen dirigeren. Ze staan niet boven het leven van de personages. De eeuwenoude set van geboden en verboden zitten verweven in de existentie van de concrete personages. Hun existentie beweegt zich op het dramatisch ritme van lijden en geluk, verdriet en vreugde, donker en licht.</p>\n</blockquote>\n<blockquote>\n<p>Een bijzonder aspect van die onderliggende eenheid is de verschijning van een vreemd personage in negen van de tien verhalen, namelijk van <span style=\"color:blue\"><strong>Dekalog 1</strong></span> tot en met <span style=\"color:blue\"><strong>Dekalog 9</strong></span>. Het betreft <em>het anonieme personage</em> dat op het eerste gezicht een figurantenrol speelt. Maar omdat hij in negen van de tien verhalen telkens optreedt in verschillende rollen, is hij een dominante beeldmetafoor. De eerste keer verschijnt hij in <span style=\"color:blue\"><strong>Dekalog 1</strong></span>. In enkele scènes zien we hem zitten bij het meer waar zich aan houtvuur warmt. Hij blijkt een zwijgende getuige te zijn van het gebeuren. Hij komt echter nooit tussen om het verloop van het gebeuren te beïnvloeden. Zijn verschijning is tevens zuiver beeldend. In <span style=\"color:blue\"><strong>Dekalog 9</strong></span>, zijn laatste verschijning, komt de anonieme man in beeld als fietser. Blijkbaar reist hij al fietsend door het land, want aan zijn fiets heeft hij een kleine bagagedrager waarop hij enkele reistassen heeft vastgemaakt. Opnieuw is hij de bevoorrechte getuige van een dramatisch moment. Romek worstelt met zijn gevoelens van onmacht, verdriet en vertwijfeling, en rijdt bewust met zijn fiets van een brug de afgrond in.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>BEELDEND DENKEN.</strong></span>\nDe cinematografie van Kieslowski beoefent het beeldend denken op het hoogste niveau. Dat blijkt al uit de spanning tussen de titel <span style=\"color:blue\"><strong>Dekalog</strong></span> en de tien verhalen.</p>\n<blockquote>\n<p>De titel verwijst direct naar het Bijbels thema van <em>de Tien Geboden</em>. In een meer hedendaagse versie noemt men ze nu ook soms <em>De Tien Woorden</em>. Het Griekse ‘decaloog’ bestaat immers uit het getal tien (‘deca/δέκα’); logos (‘λόγος’) betekent letterlijk ‘woord’ en bij uitbreiding ‘zinnen’ die samen een samenhangende geheel, een tekst, vormen. In de traditie is <em>logos</em> synoniem geworden van logica, wetenschap.</p>\n</blockquote>\n<blockquote>\n<p>In het woord ‘decaloog’ staat ‘logos’ duidelijk voor de tien goddelijke woorden die samen een tekst van de tien geboden en verboden vormen. Die tekst handelt over morele voorschriften met een goddelijke status.</p>\n</blockquote>\n<blockquote>\n<p>Het gaat inderdaad om tien voorschriften die volgens <em>Exodus 20</em> door God zelf zijn geschreven in twee stenen tafelen met de pen van de bliksem. De nadruk ligt duidelijk op het spreken. Aldus God: ‘<em>Jullie zijn er getuige van geweest dat ik vanuit de hemel tot jullie heb gesproken</em>’. (Ex 20:22). God en Taal staan bovenaan. Het beeld onderaan. Het joodse iconoclasme is vermaard. Het stipuleert dat God en bij uitbreiding het religieuze enkel bereikbaar en ervaarbaar is via het medium van de Taal.</p>\n</blockquote>\n<blockquote>\n<p>Indien dat zo is - wat inderdaad eeuwenlang het geval is geweest - dan kunnen de tien verhalen van de <span style=\"color:blue\"><strong>Dekalog</strong></span> enkel illustraties zijn van de goddelijke Logos. De verhalen kunnen niet meer zijn dan beeldende illustraties van die Tien Woorden.</p>\n</blockquote>\n<blockquote>\n<p>Als de <span style=\"color:blue\"><strong>Dekalog</strong></span> echter iets niet is, dan wel een illustratie van een goddelijke Tekst. In de <span style=\"color:blue\"><strong>Dekalog</strong></span> herinterpreteert Kieslowski de Bijbelse <em>Tien Geboden</em> vanuit een beeldend perspectief. Het uitgangspunt zijn de verhalen, cinematografisch verteld. Ze beoefenen het beeldend denken.</p>\n</blockquote>\n<blockquote>\n<p>Dat verklaart de vele <em>beeldmetaforen</em> in <span style=\"color:blue\"><strong>Dekalog</strong></span>. Een van de belangrijkste is wel het anonieme personage in <span style=\"color:blue\"><strong>Dekalog1</strong></span> tot en met <span style=\"color:blue\"><strong>Dekalog9</strong></span>. Zijn verschijning is zuiver beeldend. Hij heeft geen achtergrond, geen karakter, geen eigen verhaal.</p>\n</blockquote>\n<blockquote>\n<p>Maar ook in ieder van de <span style=\"color:blue\"><strong>Dekalog</strong></span>-verhalen komen er talrijke beeldmetaforen voor. We blijven exemplarisch stilstaan bij de beeldmetafoor van het <em>theater</em> in <span style=\"color:blue\"><strong>Dekalog7</strong></span>.</p>\n</blockquote>\n<blockquote>\n<p>In de sequentiereeks die zich situeert in het kindertheater werkt Kieslowski de metafoor van het theater beeldend uit en integreert die in de betekenisruimte van het drama met Majka, haar moeder Ewa en haar dochtertje Anka. Samen bezoeken ze het kindertheater. Dat bevindt zich in het grote gebouw van het <em>Paleis van Cultuur</em> te Warschau. Kieslowski brengt het gebouw duidelijk in beeld. Hij laat de neoklassieke, statige allure van het gebouw oplichten.</p>\n</blockquote>\n<blockquote>\n<p>De uitstraling van het cultuurgebouw contrasteert met de woonblokken van de Stawki-wijk. <span style=\"color:blue\"><strong>Dekalog7</strong></span> opent trouwens met beelden van die appartementsblokken, op de klankband begeleid met een harde schreeuw van een angstig kind. Later leren we dat het kind Anka heet. Van die angst bij Anka is in het kindertheater niets meer te merken. Het meisje voelt er zich thuis. Ze volgt gespannen het opgevoerde stuk over de gevangen genomen prinses en danst nadien mee met de kinderen en de levende poppen op de scène. In de grote ruimte krijgen de kinderen ademruimte. Uitgerekend daar ‘ontvoert’ Majka haar eigen dochtertje Anka.</p>\n</blockquote>\n<blockquote>\n<p>Kieslowski betrekt het spel op de scène direct op wat er zich afspeelt tussen de personages. De bevrijding van de prinses in het toneelstuk zinspeelt direct op de ‘bevrijding’ van Anka door haar moeder Majka.</p>\n</blockquote>\n<blockquote>\n<p><em>De uitdieping van de beeldmetafoor van het theater</em> krijgt nog meer betekenislagen via de scènes van Majka en Anka die weglopen uit het theatergebouw. Kieslowski situeert die dramatische ontsnapping als een vlucht uit de schijn van hun Stawki-bestaan.</p>\n</blockquote>\n<blockquote>\n<p>De cineast ent <em>de traditionele en negatieve betekenis van het theater</em> als schijnwereld niet op die theaterwereld zelf, maar uitgerekend op de echte wereld waarin Ewa, Majka en Anka dagelijks leven. Die situeert zich in het Stawki-appartement en dat verschijnt nu als ‘het theater’ in de negatieve zin, de plaats waar de schijn regeert.</p>\n</blockquote>\n<blockquote>\n<p>Ewa dwingt immers haar eigen ongehuwde dochter Majka naar de buitenwereld haar eigen moederschap te verloochenen en Anka niet als haar eigen dochtertje maar als haar zusje te erkennen. Moeder Ewa is immers ook schooldirectrice. Ze wil geen roddels over zich heen krijgen wegens haar ongehuwde dochter-moeder.</p>\n</blockquote>\n<blockquote>\n<p><em>Kieslowski draait dus de traditionele, negatieve betekenis van het theater om</em>. Hij werkt die betekenis beeldend en in een positieve zin uit. <em>Door de eigen narratieve context maakt hij van het echte theater een plaats van waarheid</em>. We zien dat in de sequentiereeks in het <em>Paleis van Cultuur</em> waar Ewa voor het eerst haar zelfzekerheid verliest. Zij komt nu angstig en onzeker over. Ze raakt zelfs in paniek en valt uit haar rol van directrice die het spel van de schijn beheerst en regisseert. Op de trappen van het gebouw verliest ze letterlijk haar evenwicht en struikelt ze over haar eigen voeten. De draagwijdte daarvan blijkt uit de verdere ontwikkeling van het verhaal waarvan de cineast de betekenis <em>creatief</em> uitwerkt vanuit <em>de beeldmetafoor van het theater met zijn vermeende tegenstelling schijn-zijn</em>.</p>\n</blockquote>\n<p><a name=\"BET\"></a></p>\n<h2><strong>Betekenisruimte</strong></h2>\n<p><span style=\"color:darkkhaki\"><strong>VOORBIJ HET MORALISME.</strong></span> Kieslowski-Piesiewicz illustreren de <em>Bijbelse Tien Geboden</em> niet. Dat impliceert dat ze <em>afstand nemen</em> van de traditionele, moralistische interpretatie ervan zoals die eeuwenlang is beoefend door <em>de zowel Joodse als christelijke theologieën en hun respectieve godsdienstige gezagsdragers</em>.</p>\n<blockquote>\n<p>Het moralisme bouwde op de <em>Tien Geboden</em> een net van voorgeschriften, geboden en verboden. Die werden over het reële leven van mensen uitgespreid. Dat moralisme met <em>zijn zwart-wit denken</em> reduceerde het levensverhaal van mensen tot een toepassingsveld van die geboden en verboden. Daarbij beheersten <em>zonde, straf en boete</em> het bestaan van de mensen. Hun levensverhalen hadden enkel waarde en betekenis als <em>casuïstiek</em>. Hun levensverhalen waren ‘gevallen’, casussen, die interessant waren als toelichting en illustratie van de moralistische beginselen en regels.</p>\n</blockquote>\n<blockquote>\n<p>Kieslowski-Piesiewicz stellen zich bewust buiten de oude moraaltheologische traditie op. Ze laten haar <em>legalistische lectuur van de Tien Geboden</em> achter zich. Dergelijke moralistische benadering duwde via de naam van God het concrete leven van jongeren en ouderen, mannen en vrouwen, in het keurslijf van een rigoureus moreel systeem van wetten en gedragsregels.</p>\n</blockquote>\n<blockquote>\n<p><em>Het levensperspectief</em> van Kieslowski-Piesiewicz in <span style=\"color:blue\"><strong>Dekalog</strong></span> blijkt uit de weigering om schuldigen van onschuldigen te scheiden. Ze delen geen straffen uit en stellen zich niet op als de Morele Rechter die over mensen moreel oordeelt. Dat uit zich in de zuiver beeldende aanwezigheid van <em>het anonieme personage</em> in <span style=\"color:blue\"><strong>Dekalog 1</strong></span> tot en met <span style=\"color:blue\"><strong>Dekalog 9</strong></span>. Hij is de bevoorrechte getuige van het existentieel drama waarin mensen zich bevinden. Hij registreert hoe mensen op hun eigen levensritme en met hun eigen levensbagage een zin zoeken in hun bestaan door samen te leven met anderen in een netwerk van relaties. Hij registreert, maar oordeelt niet.</p>\n</blockquote>\n<blockquote>\n<p>Het wonderlijke feit dat het anonieme personage niet voorkomt in het slot van de <span style=\"color:blue\"><strong>Dekalog</strong></span>, namelijk in <span style=\"color:blue\"><strong>Dekalog 10</strong></span>, heeft een eigen betekenis. In dat laatste verhaal neemt de camera van Kieslowski de positie van het anonieme personage in en geeft zo aan de toeschouwers de sleutel in handen om de verschijning van het anonieme personage in de voorgaande delen als de menselijke belichaming te zien van de aanwezigheid van de filmcamera zelf. Het personage is het menselijke verlengde van de filmcamera. Dat maakt van <span style=\"color:blue\"><strong>Dekalog</strong></span> in plaats van een morele les een levensbeschouwelijk getuigenis. Hieruit blijkt tevens de consequente keuze voor het beeldend denken, eigen aan de cinematografie van Kieslowski.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>LEVENSBESCHOUWING.</strong></span>\nEén van de implicaties van de weigering om in het traditionele moralisme te gaan staan, is de uitwerking van <em>het levensperspectief</em>. Die uitwerking toont zich in <em>de praxis van de levensbeschouwing</em>, beoefend door Kieslowski-Piesiewicz in hun <span style=\"color:blue\"><strong>Dekalog</strong></span>.</p>\n<blockquote>\n<p>Zij verheffen <em>de cinematografie</em> tot <em>de kunst van de levensbeschouwing</em>. Zij identificeren zich met het personage van het <em>anonieme personage</em>, de bevoorrechte maar tevens zwijgende, stille getuige van de vele levensverhalen.</p>\n</blockquote>\n<blockquote>\n<p>In dergelijk levensbeschouwelijk perspectief, resultaat van beeldend denken, is de moraal van goed versus kwaad niet meer primair. Eerst komt het bestaan, de existentie. Het betreft <em>het in-het-leven-staan</em>, het tijdelijk deel uitmaken van de complexe realiteit van het leven. En de plaats bij uitstek van die complexiteit is uitgerekend <em>het menszijn, het domein van de humaniteit</em>, daar waar menszijn alleen voorkomt in <em>de modus van de menswording</em>.</p>\n</blockquote>\n<blockquote>\n<p>In dat existentiële levensdomein dat <em>menselijkheid (humaniteit)</em> heet, tekenen zich de levensverhalen van de personages en hun concrete levenslijn af. Van <span style=\"color:blue\"><strong>Dekalog 1</strong></span> en <span style=\"color:blue\"><strong>Dekalog 2</strong></span> af zetten Kieslowski-Piesiewicz die existentiële levenslijn uit.</p>\n</blockquote>\n<blockquote>\n<p>Ze tekenen er de beweging van dood naar leven uit. In <span style=\"color:blue\"><strong>Dekalog 3</strong></span> versterken ze die levenslijn via de dagelijkse lijn van de geboorte van het licht. Die vertrekt van het middernachtelijke uur, het nulpunt van het licht, en mondt uit in de dageraad, de geboorte van het licht. De auteurs versterken die levenslijn nog door het verhaal zelf te situeren in de kerstnacht. Het verhaal beweegt van de middernachtmis en eindigt om zeven uur ’s morgens op Kerstmis.</p>\n</blockquote>\n<blockquote>\n<p>Bij sommige personages kent die levenslijn een ethisch verloop. De twee broers, Jerzy en Artur, gaan in <span style=\"color:blue\"><strong>Dekalog 10</strong></span> door de ethische nacht van hun bezitsdrang naar een ethische verlichting, het ultieme inzicht in de kostbare waarde van hun familieband die met geen geld te koop of verkoopbaar is. Zelfs in <span style=\"color:blue\"><strong>Dekalog 1</strong></span> breekt die ethische verlichting bij de vader van Pawel, Krzysztof, door. Dat gebeurt in het avonddonker bij kaarslicht in het nieuwe kerkgebouw dat in de steigers staat. De rouwende vader vindt troost bij <em>de icoon van Madonna met Kind</em>. De ethische verlichting krijgt hier een religieuze onderbouw.</p>\n</blockquote>\n<blockquote>\n<p>In <em>het levensperspectief</em> dat Kieslowski-Piesiewicz innemen staan dood en leven niet als antipoden tegenover elkaar. Het moralisme daarentegen denkt in termen van antipoden. Zoals blijkt uit de levensverhalen die Kieslowski-Piesiewicz <em>decascopisch</em> ontvouwen, maakt de dood deel uit van het leven.</p>\n</blockquote>\n<blockquote>\n<p>Opvallend daarbij is dat de kracht van het leven zelf die personages die zich gedragen alsof ze heer en meester willen zijn van niet alleen hun leven, maar ook dat van anderen, terug met hun twee voeten op de grond van hun menszijn plaatst. Dat is bijvoorbeeld het geval voor vader Krzysztof in <span style=\"color:blue\"><strong>Dekalog 1</strong></span>, Magda in <span style=\"color:blue\"><strong>Dekalog 6</strong></span>, Ewa in <span style=\"color:blue\"><strong>Dekalog 7</strong></span>, de broers Jerzy en Artur in <span style=\"color:blue\"><strong>Dekalog 10</strong></span>.</p>\n</blockquote>\n<blockquote>\n<p>Zij allen ervaren hoe goed en kwaad, de fundamenten van het moralisme, secundair en relatief zijn ten aanzien van de levenswaarden. Die ontwikkelen zich immers op <em>het levensritme van de menswording</em>. In dat proces van menswording zijn al de personages betrokken partij. Immers, ieder mens afzonderlijk bewandelt de weg van zijn eigen menszijn; iedere mens bouwt zijn eigen levensverhaal uit, gedeeltelijk in eigen regie, gedeeltelijk in een regie bepaald door anderen. Niemand kan menszijn in de plaats van een ander mens.</p>\n</blockquote>\n<blockquote>\n<p><em>Iedere mens belichaamt daarom alleen al een eigen levenswaarde</em> die door geen ander mens kan worden geschaad, laat staan vernietigd. Hiermee werpen Kieslowski-Piesiewicz <em>een nieuw licht op de oude Tien Geboden</em> die, bevrijd van hun moralistisch keurslijf, een ander gezicht krijgen. Een van de meest opvallende consequenties van de levensbeschouwelijke praxis, eigen aan <span style=\"color:blue\"><strong>Dekalog</strong></span>, is de aandacht voor <em>de levenswaarde van het dagelijks leven</em></p>\n</blockquote>\n<blockquote>\n<p>Die aandacht steekt al in de Bijbelse <em>Tien Geboden</em>. In <span style=\"color:blue\"><strong>Dekalog</strong></span> van Kieslowski-Piesiewicz bevrijdt dat dagelijkse leven zich van het oude moralistische kleed dat het opgelegd kreeg. Voor Kieslowski enten <em>de levenswaarden</em> zich op <em>het dagelijkse leven van mensen dat zich altijd situeert in een bepaalde tijd en ruimte</em>. Die levenswaarden omvatten: omgaan met <em>het gegeven van de geboorte</em> (huiselijkheid, gezinsleven, ouderschap, liefde- familierelaties) en <em>dat van de dood</em> (lijden, ziekte, sterfelijkheid).</p>\n</blockquote>\n<blockquote>\n<p>Op die levenslijn bevinden zich de levenswaarden van <em>generatieverbondenheid, buurtschap, opvoeding en onderwijs, bezit en eigendom, wonen en bouwen, het collectieve geheugen, samenleving en rechtspraak, traditie en moderniteit</em>. Die levensbeschouwelijke aandachtspunten vormen het weefsel van de <span style=\"color:blue\"><strong>Dekalog</strong></span> zoals die ook, zij het in een andere constellatie, voorkomen in de Bijbelse <em>Tien Geboden</em>.</p>\n</blockquote>\n<p><a name=\"CON\"></a></p>\n<h2><strong>Context</strong></h2>\n<p>De tiendelige filmcyclus <span style=\"color:blue\"><strong>Dekalog</strong></span> van Krzysztof Kieslowski loopt parallel met de laatste jaren en maanden van <em>het IJzeren Gordijn met de Muur van Berlijn</em>, de meest tot de verbeelding sprekende exponent van <em>de Koude Oorlog</em> (1945-1991).</p>\n<blockquote>\n<p>Met de val van die Muur op 9 november 1989 hield de hegemonie van de Sovjet-Unie over Oost-Europa, Polen inbegrepen, op te bestaan. De geschiedenis van de Sovjet-Unie zelf eindigde op 26 december 1991.</p>\n</blockquote>\n<blockquote>\n<p>Een maand na de Val van de Muur van Berlijn, in december 1989, kende de <span style=\"color:blue\"><strong>Dekalog</strong></span> zijn wereldpremière op de Poolse televisie. In dit historisch licht beschouwd, is de <span style=\"color:blue\"><strong>Dekalog</strong></span> profetisch te noemen en tevens een bevoorrechte getuige van de belangrijkste historische gebeurtenis in Europa sinds het einde van de Tweede Wereldoorlog.</p>\n</blockquote>\n<blockquote>\n<p>Nog opgenomen tijdens de communistische dictatuur in Polen, kijken Kieslowski-Piesiewicz in de Dekalog al naar de toekomst. Die bestaat uit <em>het einde van het communistische bewind en het begin van een vrij, democratisch Polen binnen de grote gemeenschap van de Europese Unie</em>.</p>\n</blockquote>\n<blockquote>\n<p>Het resultaat van dit laatste gegeven is anno 2017 goed te zien. In het jaar dat de EU zijn zestigste verjaardag (1957-2017) viert, is de president ervan een Pool, Donald Tusk.</p>\n</blockquote>\n<blockquote>\n<p>De verwijzingen naar de dramatische geschiedenis van Polen in de 20ste eeuw zijn in <span style=\"color:blue\"><strong>Dekalog</strong></span> duidelijk herkenbaar. De Tweede Wereldoorlog ― begonnen met de invasie van Polen door Hitlers troepen op 1 september 1939 ― komt ter sprake in <span style=\"color:blue\"><strong>Dekalog 2</strong></span> (de oude geneesheer) en <span style=\"color:blue\"><strong>Dekalog 8</strong></span>** (de Jodenvervolging).</p>\n</blockquote>\n<blockquote>\n<p>De periode van de Koude Oorlog is overal aanwezig via de locatie, de Stawki-wijk in Warschau. De woonblokken zijn een typische realisatie van het communistische bewind in het Oostblok. Het promootte het collectieve wonen als vehikel voor een ideale, communistische samenleving.</p>\n</blockquote>\n<blockquote>\n<p>Kieslowski-Piesiewicz plaatsen tegenover dat <em>collectieve en anonieme wonen</em> de concrete mens, het individu met zijn eigen unieke levensverhaal centraal. Wat verborgen blijft achter de anonieme façade, brengen zij via de kunst van de cinematografie aan het licht.</p>\n</blockquote>\n<blockquote>\n<p>Bovendien verwijzen ze direct naar <em>de christelijk-katholieke traditie van Polen</em> die stand hield tegenover het atheïsme van het communistische bewind. Dat blijkt al in <span style=\"color:blue\"><strong>Dekalog 1</strong></span> dat is gefilmd vanuit het perspectief van tante Irena, de catechiste. Via haar komt er een foto voor van <em>de Poolse paus, Johannes-Paulus II</em>. Historisch heeft hij en de katholieke Kerk van Polen een hoofdrol gespeeld in de steun van de maatschappelijke oppositie in Polen, de beweging van <em>Solidarnosc</em>. Zij was de hefboom die het Oostblok met het IJzeren Gordijn uit evenwicht tilde.</p>\n</blockquote>\n<blockquote>\n<p>Ook <span style=\"color:blue\"><strong>Dekalog 3</strong></span> staat expliciet in het teken van het vieren van Kerstmis tijdens de middernachtmis. En uiteindelijk maakt vooral de expliciete verwijzing naar <em>de Bijbelse Decaloog</em> deel uit van de actualisering van de christelijk-katholieke traditie.</p>\n</blockquote>\n<blockquote>\n<p>Kieslowski-Piesiewicz tonen aan dat de wederopbouw van het nieuwe, vrije en democratische Polen een hoeksteen van menselijke waarden nodig heeft. De communistische waarden van gelijkheid, gefundeerd in een rationalistisch atheïsme, hebben iedere geloofwaardigheid verloren.</p>\n</blockquote>\n<blockquote>\n<p>Kieslowski-Piesiewicz vinden <em>die noodzakelijke hoeksteen van waarden</em> via <em>hun lezing</em> van de Bijbelse <em>Tien Geboden</em>. Ze tonen dat die hun betekenis kunnen behouden wanneer ze worden gezien als <em>levenswaarden</em>. Zo kunnen ze hun blijvende betekenis prijsgeven in een modern, democratisch Europa.</p>\n</blockquote>\n<blockquote>\n<p>In die optiek blijft de Poolse <span style=\"color:blue\"><strong>Dekalog</strong></span> een basiswerk van de naoorlogse filmkunst voor de hele Europese Unie. De kunst van de cinematografie bewijst ermee <em>haar onmisbare levensbeschouwelijke praxis</em> in de verdere uitbouw van <em>een democratische EU</em>, een thuis voor blijvende menswording met onder andere een actuele, decascopische lezing van de Bijbelse Tien Geboden als blijvende inspiratiebron.</p>\n</blockquote>\n<p><a name=\"FIL\"></a></p>\n<h2><font color=\"#808000\"><strong>Links</strong></font></h2>\n<p>Over <span style=\"color:blue\"><strong>Dekalog</strong></span> schreef Sylvain De Bleeckere een uitgebreide en unieke studie. Hij bespreekt ieder deel afzonderlijk en belicht het geheel vooral in de inleiding en het besluit. Iedere analyse van elk van de <span style=\"color:blue\"><strong>Dekalog</strong></span>-verhalen bestaat uit tien onderdelen. Titel: <em>Levenswaarden en levensverhalen. Een studie van de Decaloog van Kieslowski</em>. Leuven, Acco, 1994. Het boek is enkel nog tweedehands verkrijgbaar.</p>\n<p>De internationale website gewijd aan het oeuvre van Kieslowski is <a href=\"http://www.petey.com/kk/\">Kino Kieslowski</a>.</p>\n<p><font size=\"-2\">© Sylvain De Bleeckere, Men(S)tis, 2017</font></p>\n"}

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(173);
	
	var _breakpoint = __webpack_require__(947);
	
	var _breakpoint2 = _interopRequireDefault(_breakpoint);
	
	var _find = __webpack_require__(601);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _gatsbyHelpers = __webpack_require__(403);
	
	var _config = __webpack_require__(404);
	
	var _safeAccess = __webpack_require__(976);
	
	var _safeAccess2 = _interopRequireDefault(_safeAccess);
	
	var _typography = __webpack_require__(427);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _include = __webpack_require__(420);
	
	var _include2 = _interopRequireDefault(_include);
	
	var _startsWith = __webpack_require__(573);
	
	var _startsWith2 = _interopRequireDefault(_startsWith);
	
	var _Header = __webpack_require__(419);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rhythm = _typography2.default.rhythm;
	
	
	module.exports = _react2.default.createClass({
	  displayName: 'exports',
	  propTypes: function propTypes() {
	    return {
	      route: _react2.default.PropTypes.object
	    };
	  },
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	  render: function render() {
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'ui container' },
	      this.props.children
	    );
	  }
	});

/***/ }),
/* 988 */
/***/ (function(module, exports) {

	module.exports = {"title":"Agora","body":"<center>\n<img src=\"agora.jpg\" >\n</center>\n<a name=\"KLA\"></a>\n<h2><strong>Klapbord</strong></h2>\n<p><span style=\"color:blue\"><strong>Agora</strong></span>\nis de titel van <em>het historische filmepos</em> van de Spaans-Chileense regisseur Alejandro Amenábar. Hij filmde zich eerder in de kijker met het euthanasiedrama <em>Mar Adentro</em>, maar eveneens met <em>The Others</em> en <em>Abre los ojos</em>. <span style=\"color:blue\"><strong>Agora</strong></span> is zijn eerste kostuumfilm. Hij reconstrueert de weinig gekende geschiedenis van <em>de vrouwelijke Alexandrijnse filosoof Hypatia</em> (ca. 370-415). De historische film is met zijn 50 miljoen euro tot op heden de duurste Spaanse film ooit. Hij evoceert de teloorgang van <em>de hellenistische cultuurstad Alexandrië</em> en weerkaatst de betekenis ervan naar het begin van de 21ste eeuw, onze tijd. De film ontving de 7 Goya’s (de Oscars van de Spaanse film) en 6 Goya-nominaties. Het personage <em>Hypatia</em> wordt vertolkt door Rachel Weisz. De locatie was Malta.</p>\n<p><a name=\"SYN\"></a></p>\n<h2><strong>Synopsis</strong></h2>\n<p>In het Romeins-Egyptische Alexandrië leeft en werkt rond 400 <em>Hypatia</em>. Zij is de enige vrouwelijke filosoof die onderwijst en onderzoek verricht in de <em>grote bibliotheek</em>, de schatkamer aan kennis van de mediterrane mensheid, een internationale school en een ontmoetingsplaats van geleerden van diverse culturele origine. <em>Hypatia</em> brengt haar verwondering over de orde in het heelal over op haar leerlingen die ze als ‘broeders’ ziet en bij wie ze een geest van verdraagzaamheid en een kritische instelling overbrengt. Haar vader, <em>Theon</em>, leidt de bibliotheek. De stad komt onder toenemende spanning te staan door het succes van <em>de christenen</em> die nu niet meer worden vervolgd en op <em>de agora</em> in discussie gaan met de bestaande ‘heidense’ verering van diverse goden.</p>\n<blockquote>\n<p>In de stad is de belangrijkste tempel die van <em>Serapis</em>, een versmelting van de Egyptische en Griekse religies. Het hoofdgebouw van de bibliotheek bevindt zich in de tempel van Serapis. <em>Patriarch Theophilus</em> moedigt de christenen aan om met de heidense godenbeelden de spot te drijven. De missionair ingestelde monnik <em>Ammonius</em>, leider van de gewapende Christussoldaten, <em>de Parabolanen</em>, neemt daarbij het voortouw. De christenen krijgen zeer veel aanhang bij het gewone volk en de slaven, onder wie <em>Davus</em>, de slaaf en assistent van <em>Hypatia</em>.</p>\n</blockquote>\n<blockquote>\n<p>De spanningen lopen uit de hand en ontaarden in bloedige conflicten. De Romeinse prefect heeft een te zwakke politieke en militaire macht om de situatie onder controle te houden. De christenen bestormen uit weerwraak de tempel van Serapis na een bloedige aanval op hen door de aanhangers van de tempel. De bibliotheek wordt verwoest. De christenen nemen het gebouw over en gebruiken een deel ervan als kerk.</p>\n</blockquote>\n<blockquote>\n<p>Wanneer de jonge en ambitieuze <em>Cyrillus</em> de overleden Theophilus opvolgt, streeft hij naar een volledige controle over de politieke en religieuze macht. Hij schakelt de joden uit en valt nadien nog de laatste aanhangers van de ‘heidense’ goden aan. Wanneer daarbij de nieuwe prefect, <em>Orestes</em>, een oud-leerling van <em>Hypatia</em>, hem in de weg staat, speelt hij een politiek schaakspel met als inzet niemand minder dan <em>Hypatia</em>. Zij wordt als <em>heks</em> gestenigd vὀὀr het altaar van Christus. Dat gebeurt nadat ze door haar kosmologische studies en experimenten een vermoeden kreeg van de hypothese van het <em>heliocentrisme</em>.</p>\n</blockquote>\n<p><a name=\"CIN\"></a></p>\n<h2><strong>Cinematografie</strong></h2>\n<p><span style=\"color:darkkhaki\"><strong>HISTORISCHE EVOCATIE</strong></span>. Het filmproject steunt op grondig onderzoek over het historische Alexandrië rond het jaar 400 toen de waardevolle bibliotheek ten onder is gegaan. <em>De stad met zijn unieke bibliotheek</em> vormt het hoofdpersonage in het eerste deel van de film. De decors werden zo authentiek mogelijk gebouwd. Voor het eerst krijgt de vermaarde bibliotheek een concreet, architecturaal gezicht. De verwoesting van het gebouw vormt het dramatische hoogtepunt van het eerste deel van de film.</p>\n<blockquote>\n<p>De regisseur verwerkt in het scenario de overgeleverde feiten over de stad Alexandrië bij de overgang van de Romeinse naar de christelijk periode onder de leiding van patriarch <em>Cyrillus van Alexandrië</em> die in oktober 412 de overleden Theophilus opvolgde.</p>\n</blockquote>\n<blockquote>\n<p>Eén van schaarse historische bronnen over <em>Hypatia</em> is het werk van <em>Synesius van Cyrene</em>, de Griekse bisschop van Ptolemais (Lybische Pentapolis). Hij was een leerling van <em>Hypatia</em> in Alexandrië en er is een brief van hem aan <em>Hypatia</em> bewaard. Aan die historische context ontleent de regisseur het personage <em>Synesius</em> dat in het tweede deel van de film een voorname bijrol speelt.</p>\n</blockquote>\n<blockquote>\n<p>Over <em>Hypatia</em> zelf zijn slechts enkele feiten bekend. Die zijn in de film verwerkt. De regisseur heeft zelf de vele leemtes moeten inkleuren. Daarbij heeft hij rekening gehouden met de geest van de tijd. De personages van <em>Hypatia</em>’s assistenten, <em>Davus</em> en <em>Aspasius</em>, zijn fictief. Vooral de eerste speelt een grote rol in de film en helpt de regisseur om het verhaal te vertellen over het succes van de christelijke leer onder de Romeinse slaven. Davus is immers de slaaf van <em>Hypatia</em> en hij is in het geheim christen.</p>\n</blockquote>\n<blockquote>\n<p>Via het personage van <em>Hypatia</em> brengt de regisseur de succesrijke Helleense filosofie van <em>het neoplatonisme</em> in beeld. Dat concretiseert zich in haar intellectuele passie voor de studie van de kosmos. Zij onderwijst het toen algemeen aanvaarde <em>geocentrische wereldbeeld van Ptolemaius</em>, een sleutelvisie van het neoplatonisme. In het eerste deel van de film komen enkele scènes voor waarin <em>Hypatia</em> de sinds Plato als goddelijk beschouwde figuur van <em>de cirkel</em> bestudeerd in relatie tot de komische bewegingen van de zon en de planeten.</p>\n</blockquote>\n<blockquote>\n<p>In het tweede deel verdicht Amenábar de latere overgang van het <em>geocentrisme</em> naar het <em>heliocentrisme</em> in <em>Hypatia</em>’s intellectuele honger om de kosmos te doorgronden. Daar is historisch geen enkel bewijs voor aangezien het geschreven werk van de ‘heks’ <em>Hypatia</em> volledig verloren is gegaan. De (moderne) ontdekking van de elliptische omwentelingsbaan van de planeten door Kepler in 1609, zou ook door <em>Hypatia</em> als hypothese zijn kunnen onderwezen. Zo verwijst de film naar Aristarchus die circa 700 jaar voor Hypatia al het heliocentrisme kende. De intellectuelen uit de Griekse oudheid kenden de theorie, ook al nam niemand ze ernstig, zeker niet toen de jonge christelijke theologie het wereldbeeld van Ptolemaius adopteerde. Het neoplatonisme vond weerklank bij alle intellectuelen van die tijd, ook bij de christenen zoals Synesius.</p>\n</blockquote>\n<blockquote>\n<p>Alleen radicale figuren als Cyrillus I verzetten zich krachtig tegen de mogelijke invloed van de <em>neoplatoonse</em> filosofie op de christenen. Dat was zijn motief om in het bijzonder <em>Hypatia</em> te viseren. Er zijn geen historische bronnen over een directe confrontatie tussen Cyrillus en <em>Hypatia</em>. Amenábar laat wel zien hoe Cyrillus zowel zijn eigen aanhang als de beleidslieden van Alexandrië onder wie de prefect Orestes, oud-leerling en vriend van <em>Hypatia</em>, manipuleert om <em>Hypatia</em>’s (neoplatoonse) invloed in de stad te neutraliseren en uit te schakelen. De gruwelijke moord op <em>Hypatia</em> door de radicale christenen, de Parabolanen, is in de film verzacht. Uit overgeleverde bronnen blijkt dat zij de eerste vrouw is die in naam van Christus als ‘heks’ op een wrede wijze is terechtgesteld.</p>\n</blockquote>\n<p><span Style=\"color:darkkhaki\"><strong>WERELDBEELDPERSPECTIEF</strong></span>. Een van de opvallendste visuele eigenschapen van <span style=\"color:blue\"><strong>Agora</strong></span> is het wereldbeeldperspectief. De camera bevindt zich als het ware in het heelal, is zelf een planeet die de aarde observeert en vervolgens inzoomt op de Egyptische stad Alexandrië.</p>\n<blockquote>\n<p>Het openingsbeeld toont de sterrenhemel met de introductie van de planeet aarde; als een gigantisch lichtschip beweegt deze in een cirkelbaan door het heelal. Bij die beelden weerklinkt dan in voice-over de stem van <em>Hypatia</em> over de betekenis van de cirkel voor de planeten in de kosmos. Dan verplaatst zich de camera van de hemel naar de aarde in de collegezaal waar <em>Hypatia</em> aanschouwelijk via de astronomie  het klassieke of Oud-Griekse wereldbeeld doceert.</p>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><em>Maar de aarde? Wat gebeurt er hier op aarde? Hier vallen de voorwerpen wel naar beneden terwijl de sterren en de hemellichamen niet naar beneden vallen, maar in cirkels bewegen.</em></p>\n</blockquote>\n</blockquote>\n<blockquote>\n<p>Het tweede deel opent eveneens met het wereldbeeldperspectief om uiteindelijk in het slotbeweging terug te keren naar de plaats van de camera in het heelal.</p>\n</blockquote>\n<blockquote>\n<p>Nog in het eerste deel met name in het tafereel dat zich in het <em>theater</em> afspeelt, komt ook een betekenisvol hemelperspectief voor. In de pauze van het theaterstuk spreekt Orestes van op de scène zijn liefde uit voor <em>Hypatia</em> en speelt hij voor haar op de Griekse dubbelfluit. Tijdens het muziekopvoering last Amenábar een beeld in genomen vanuit het heelal met zicht op de aarde. Hiermee verwijst Amenábar naar de componenten van het klassieke of Oud-Griekse wereldbeeld: de astronomie en de  kosmologie, de muziek(leer) en de metafysica. <em>Hypatia</em> had immers Orestes’ verliefdheid afgewimpeld met het advies zich op de muziek toe te leggen. Sinds de leer van Pythagoras over <em>de muziek van de sferen</em> waarmee hij bedoelde de muziek die in de kosmos ontstaat door de bewegingen van de planeten, beschouwden de neoplatonisten de studie van de muziek als een onderdeel van de studie van het <em>wereldbeeld</em>, gevoed door de toenmalige verwondering en bewondering over de perfecte schoonheid van de kosmos met zijn harmonieuze verhoudingen en bewegingen.</p>\n</blockquote>\n<blockquote>\n<p>Met dat wereldbeeldperspectief onderlijnt Amenábar het blikveld van <em>Hypatia</em>. Zij kijkt consequent naar de kosmos boven de planeet aarde als een onophoudelijke bron van verwondering en kennis over de hogere werkelijkheid die in harmonie leeft met zichzelf. De beelden van de sterrenhemel vinden hun oorsprong in de schouwende blik van <em>Hypatia</em>.</p>\n</blockquote>\n<blockquote>\n<p>Dat typische wereldbeeldperspectief kan ook het <em>goddelijk perspectief</em> worden genoemd. In het licht van de neoplatoonse metafysica bevindt de werkelijkheid van God zich boven de aarde (het <em>meta-fysische</em> of het <em>boven-natuurlijke</em>) en is de schoonheid van de kosmos het meest zichtbare beeld van God dat mensen met de ogen kunnen aanschouwen.</p>\n</blockquote>\n<blockquote>\n<p>In de populaire voorstelling van dat <em>metafysische wereldbeeld</em> woont God in de hemel en kijkt hij naar de aarde. In de optiek van het <em>neoplatonisme</em> was de studie van de kosmos met onder andere de astronomie in feite een deel van <em>de natuurlijke theologie</em>. In de traditie van Plato en Aristoteles onderzoekt <em>Hypatia</em> met de kracht van het menselijk denken dat hellenistische wereldbeeld met centraal de studie van de <em>kosmos</em> is. De scènes met <em>Hypatia</em> en haar studie van de kosmos vormen telkens een rustpunt midden de actiescènes.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>STIJL VAN JOURNALISTIEKE VERSLAGGEVING</strong></span>. Voor de taferelen die zich in de stad afspelen en die tevens in het teken staan van de toenemende spanningen tussen de drie groepen, de ‘heidenen’ of de polytheïsten, de christenen en de joden, kiest Amenábar voor een <em>zeer levendige, journalistieke</em> stijl. Hij wil met de montage van verschillende camerabewegingen van hetzelfde gebeuren de toeschouwer meenemen in een tijdscabine en als een CNN-kijker de actie zelf als een bevoorrechte getuige laten meemaken. Die werkwijze ondersteunt de inleving bij de toeschouwer.</p>\n<blockquote>\n<p>In diezelfde geest filmt hij belangrijke momenten vanuit de <em>blik van een getuige</em>. Een mooi voorbeeld hiervan is de aanhouding van <em>Hypatia</em> door de troepen van Cyrillus, de Parabolanen. Dat gebeuren zelf komt niet in beeld, maar de gevolgen ervan wel; de toeschouwer kan die direct meemaken vanuit het standpunt van Davus. Dat betekent dat Amenábar in tegenstelling met andere historische epische drama’s niet werkt met een alziend standpunt: de camera ziet niet alles en is niet overal bij.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>FLASHBACKS</strong></span>. De film <span style=\"color:blue\"><strong>Agora</strong></span> is lineair opgebouwd. Alleen tijdens de dramatische ontknoping last Amenábar flashbackbeelden in. Dat gebeurt concreet tijdens de sterfscène. Davus verstikt de naakte <em>Hypatia</em> die op het punt staat te worden gestenigd door de fanatieke Parabolanen. Hij wil voorkomen dat ze nog meer wordt vernederd en gefolterd.</p>\n<blockquote>\n<p><em>De flashbacks</em> zijn de herinneringen van Davus, de slaaf en tevens beste leerling-assistent van <em>Hypatia</em>. Hij hield oprecht van haar, maar besefte dat die liefde onmogelijk was. Het is uit zijn liefde voor haar dat hij haar helpt sterven. Door de dood van <em>Hypatia</em> zo in beeld te brengen, brengt Amenábar poëzie in een moment dat alleen maar van gruwel spreekt. De uitbeelding van de historisch overgeleverde moord op <em>Hypatia</em> is immers onmogelijk en ondraaglijk om te zien: het levend villen met scherven van schelpen.</p>\n</blockquote>\n<p><a name=\"BET\"></a></p>\n<h2><strong>Betekenisruimte</strong></h2>\n<p><span style=\"color:darkkhaki\"><strong>DE AGORISCHE SAMENLEVING</strong></span>. Omdat Amenábar de naam <em>Hypatia</em> geen mooie naam en evenmin een goede titel vond, hebben hij en de producent uiteindelijk gekozen voor de titel <em>Agora</em>. Het woord komt ook in het script voor. Het is een uniek Grieks woord voor de <em>open publieke ruimte</em>, begrepen als de plaats waar mensen zich in vrijheid kunnen verzamelen om met elkaar over alles te spreken, handel te drijven, ambachten en kunsten te beoefenen, enzovoort.</p>\n<blockquote>\n<p><em>De agora</em> is de slagader van de <em>democratische</em> samenleving zoals die in het oude Athene voor het eerst heeft gefunctioneerd. Ook het laatantieke Alexandrië had een agora en weerspiegelde het open karakter van de samenleving waar diverse groepen met elk hun religie op een positieve manier samenleefden.</p>\n</blockquote>\n<blockquote>\n<p>Op de agora van Alexandrië staat immers een beeld van de Griekse godin <em>Athena</em> aan wie de stad Athene haar naam ontleent. De bibliotheek van Alexandrië voedde die <em>open democratische</em> geest. <em>Hypatia</em> onderwees immers de fundamentele <em>broederschap</em> onder de mensen.</p>\n</blockquote>\n<blockquote>\n<p>De film beschrijft de ondergang van <em>de agora</em> via een crescendo van destructie: in het eerste deel de vernieling van de bibliotheek als gebouw met zijn boekrollen en onderwijsruimtes, en in het tweede deel de geest van de bibliotheek in de gestalte van de moord op de laatste meester van de bibliotheek, <em>Hypatia</em>.</p>\n</blockquote>\n<blockquote>\n<p>Voor Amenábar is <em>de agora</em> uiteindelijk de metafoor voor de plaats van het <em>samen</em>-leven. Hij laat zien dat de destructie daarvan meteeen de destructie van het menszijn zelf inhoudt.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>HISTORISCHE SPIEGELING</strong></span>. De regisseur heeft met <span style=\"color:blue\"><strong>Agora</strong></span> geen vrijblijvende film gemaakt. In verschillende interviews en in zijn dvd-commentaar bij de film, onderstreept Amenábar dat hij “<em>alles wat hij denkt over de menselijke natuur</em>” in dat ene verhaal heeft verwerkt. Het <em>vrijwel ongekende</em> historische verhaal is voor de cineast nog steeds relevant. Hij stelt in één van zijn interviews:</p>\n<blockquote>\n<blockquote>\n<p><em>De vernietiging van de Alexandrijnse bibliotheek luidde het begin van de donkere middeleeuwen in. Nu zitten we, vrees ik, opnieuw op zo’n scharniermoment. Het religieuze fanatisme neemt opnieuw toe; er dreigen weer bloedige godsdienstoorlogen.</em></p>\n</blockquote>\n</blockquote>\n<blockquote>\n<p>In zowel het eerste als het tweede deel wijst de cineast erop dat in alle religies het <em>fanatisme</em> de kop opsteekt. Er zijn in alle groepen goeden en slechten. Zo laat Amenábar in het eerste deel zien dat de priesters van de Serapistempel met het zwaard de christenen die de spot drijven met de hellenistische godenbeelden aanvallen. Die moordpartij lokt dan weer de furieuze aanval van de christenen uit die leidt tot de verwoesting van de bibliotheek. In het tweede deel nemen de joden wraak op de Parabolanen, waarna het bloedige antwoord volgt van de christenen.</p>\n</blockquote>\n<blockquote>\n<p>Amenábar verwijst in die beelden direct naar de <em>Holocaust</em> van de 20ste eeuw en hij laat zien hoe het fanatieke <em>antisemitisme</em> waaruit de Holocaust is voortgekomen, diepe historische wortels heeft in het fanatieke laatantieke christlijke <em>wereldbeeld</em>. In de hevige toespraak van de jonge patriarch Cyrillus over de joden en over de noodzaak om de stad te zuiveren, verwerkt Amenábar woorden van kerkvader <em>Augustinus van Hippo</em>, een tijdgenoot van <em>Hypatia</em> en Cyrillus. Amenábar verwijst expliciet naar de verbranding van de joden en naar de uitdrijving van de joden uit onder andere Poolse steden zoals Spielberg die in beeld brengt in <em>Schindler’s List</em>.</p>\n</blockquote>\n<blockquote>\n<p>De spiraal van geweld die het <em>godsdienstfanatisme</em> voortbrengt, vloeit voort uit, zo toont Amenábar, de afwezigheid van respect voor de verschillende uitdrukkingen van godsgeloof. De negatieve spiraal begint eigenlijk bij het bespotten van de hellenistische godsbeelden op de agora. Daaruit spreekt het oudtestamentische  <em>iconoclasme</em> (o.a. <em>Exodus</em> 20, 3-4) dat zich nog versterkt in de slogan van de christenen die tijdens de aanval op de bibliotheek roepen: “<em>God is één</em>.”</p>\n</blockquote>\n<blockquote>\n<p>De spiraal versterkt zich via wraakgevoelens waarna die zich kristalliseert in een <em>niets ontziende politieke machtstrijd</em>. In het tweede deel, vooral in de episode van de wegvoering van <em>Hypatia</em> door de Parabolanen, roept de regisseur hedendaagse beelden op van de <em>Taliban</em> en <em>IS</em> en hun uitgesproken minachting voor vrouwen. In het jaar 2010, het jaar waarin de film in de westerse landen in de bioscoop is te zien geweest, laaide in Manhattan, New York, een hevige politieke discussie op over de geplande bouw van een moskee en islamitisch centrum op twee blokken verwijderd van de toenmalige <em>Ground Zero</em>. Dat leidde tot beelden van fanatieke christenen en moslims die zo uit het laatantieke Alexandrië hadden kunnen komen.</p>\n</blockquote>\n<blockquote>\n<p>Amenábar neemt letterlijk afstand van dergelijke conflicten die een belangrijke deel van de wereldpolitiek op aarde nog steeds blijven beheersen. Dat blijkt uit de filmische afstand van het geweld. Hij filmt met opzet de eerste gewapende aanval van op grote afstand. En hij vergroot die afstand nog via de metafoor van de <em>mieren</em>. De hele episode van de verwoesting van de bibliotheek opent met een close-up van mieren en eindigt met een panoramisch hoogteshot van de verwoeste bibliotheek en de mensen die als mieren door en achter elkaar al vechtend en plunderend lopen.</p>\n</blockquote>\n<blockquote>\n<p>Hier werkt het <em>wereldbeeldperspectief</em> door en het verwijst naar de filosofische distantie die eigen is aan <em>Hypatia</em> en de studie van de astronomische studie van de kosmos. Het blikveld van <em>harmonie en symmetrie</em> versus het gewriemel van elkaar vermoordende mensen die vanuit de hemel slechts op mieren lijken.</p>\n</blockquote>\n<blockquote>\n<p>Een laatste aspect van de historische spiegeling, betreft het <em>genderaspect</em>. Amenábar laat duidelijk zien hoe de positie van de vrouw in zowel het hellenistische als christelijke <em>wereldbeeld</em> die van een <em>tweederangsburger</em> of zelfs van een <em>slaaf</em> was. Dat werkt hij uit in het verhaal over het <em>ongehuwd</em> blijven van <em>Hypatia</em>. Hij toont dat hoe dan ook de historische figuur van <em>Hypatia</em> een grote uitzondering is gebleven en dat die uitzondering uiteindelijk ook teniet gedaan is. Daarbij heeft de christelijk-theologische <em>wereldbeeld</em> een gigantische, historische rol gespeeld.</p>\n</blockquote>\n<blockquote>\n<p>Het is geen toeval dat hij in het tweede deel de fanatieke Cyrillus in de kerk de Bijbeltekst laat lezen, met name het <em>tweede hoofdstuk van de eerste brief van Paulus aan Timoteüs</em> over het verplichte statuut en de vaste tweederangsplaats van de vrouw in de christelijke kerkgemeenschap. Cyrillus gebruikt die tekst op zo’n manier dat hij ermee de politieke leider van de stad, Orestes, zelf een christen en leerling van <em>Hypatia</em>, met zijn rug tegen de muur zet. Hij verplicht Orestes afstand te nemen van <em>Hypatia</em>.</p>\n</blockquote>\n<blockquote>\n<p>Door toedoen van Cyrillus draaien de rollen om. In het begin onderwijst <em>Hypatia</em> de (mannelijke) leerlingen Orestes en Synesius, terwijl in de laatste sequentie met de drie personages <em>Hypatia</em> op de plaats van de leerlingen zit, terwijl Orestes en Synesius als de (politieke en religieuze) meesters haar duidelijk maken dat ze zich dient te onderwerpen. Ze weigert. Die weigering maakte haar tot de eerste <em>heks</em> uit de pijnlijke geschiedenis van de Kerk in relatie tot de waarde en de waardigheid van de vrouw.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>EEN JEZUS-CHRISTENDOM</strong></span>. Amenábar heeft met <span style=\"color:blue\"><strong>Agora</strong></span> geen <em>antichristelijke</em> film gemaakt. Ook al is hij naar eigen zeggen zelf van een christen geëvolueerd naar een atheïst. Uit zijn grote interesse voor de astronomie en de werkelijkheid van het heelal richt hij zich wel op een <em>mensoverstijgende</em> werkelijkheid waarin ook de religies hun oorsprong vinden. In de film laat hij <em>Hypatia</em> zeggen: “<em>Ik geloof in filosofie</em>.”</p>\n<blockquote>\n<p>In de <em>hellenistische oudheid</em> was het beoefenen van de filosofie een religieuze activiteit want zoals Aristoteles stelde is de metafysica de eerste filosofie die haar hoogtepunt bereikt in het hoofdstuk van de <em>natuurlijke theologie</em>.</p>\n</blockquote>\n<blockquote>\n<p>Daarnaast toont Amenábar veel sympathie voor de <em>evangelische Jezus</em> en diens humaniserende levensvisie met de elementen van <em>het broederschap van de mensen</em> en <em>de zorg voor de minsten</em> in de samenleving. Hij stelt de kennismaking van Davus met de leer van de christenen helemaal in het teken van de <em>Bergrede</em> die hij letterlijk citeert en met beelden van het uitdelen en breken van broden met de armen verduidelijkt.</p>\n</blockquote>\n<blockquote>\n<p>Amenábar portretteert <em>Hypatia</em> met trekken die de evangelies aan Jezus toeschrijven. Zij leert haar studenten wat <em>broederschap</em> betekent door applaus te vragen voor haar assistent, de slaaf Davus. Zij weigert iedere vorm van geweld. Ze legt het zwaard neer dat Davus haar geeft om hem als straf te doden en ze weigert militaire protectie net zoals Jezus deed in de Hof van Olijven bij zijn gevangenneming. Later schenkt Hypatia Davus zijn vrijheid. In de film laat Amenábar Davus het begin van het <em>Onze Vader</em> bidden. Hij filmt de gevangenneming en de terechtstelling van <em>Hypatia</em> als een passieverhaal: de onschuldige leraar wordt door de fanatieke godsdienstleiders gevangen genomen, wordt voor de politieke en kerkelijke macht (Orestes en Synesius) gebracht, door de soldaten bespot en vernederd, op de berg meegevoerd, van zijn kleding beroofd en terechtgesteld. Amenábar filmt de aangrijpende sterfscène als een kruisafneming die tevens oogt als een staande <em>piëta</em>.</p>\n</blockquote>\n<p><a name=\"CON\"></a></p>\n<h2><strong>Context</strong></h2>\n<p>De film <span style=\"color:blue\"><strong>Agora</strong></span> van Amenábar kadert in een <em>postmoderne</em> benadering van het fenomeen religie, kerk en geschiedenis. Het is een kritische benadering die vooral afstand neemt van het <em>monotheïstische</em> denken dat vandaag de voedingsbodem blijft van de wereldreligies christendom, jodendom en islam. Het zijn die religies die in hun politieke verschijning tegenover elkaar komen te staan, na al die eeuwen.</p>\n<blockquote>\n<p>De film draagt bij tot de onmisbare reflectie over de <em>cultuurwaarde van de religies</em> vandaag. Daarbij kan een kritische studie van de voorbije geschiedenis niet ontbreken. Amenábar brengt via het medium film een belangrijk, <em>vergeten</em> hoofdstuk van die geschiedenis aan het licht.</p>\n</blockquote>\n<blockquote>\n<p>Hij roept tegelijkertijd in het beeld van de <em>Oud-Griekse agora</em> de metafoor op van de wereldwijde democratische ruimte waarin mensen vanuit een planetair bewustzijn tot de ontdekking komen dat ze meer met elkaar gemeen hebben dan de verschillen die ze ervaren. Het oorspronkelijke, <em>Alexandrijnse polytheïsme</em> dat ruimte liet voor diverse religieuze expressies krijgt in een hedendaagse wereldcontext de betekenis van een wereldforum waar de verschillende monotheïstische religies elkaar niet meer als vijanden benaderen maar als kleurschakeringen van eenzelfde, transcendente werkelijkheid.</p>\n</blockquote>\n<blockquote>\n<p>Een interessant detail van de film krijgt hier een bijzondere betekenis. Naar het einde toe monteert Amenábar een shot in kikvorsperspectief van Cyrillus die een <em>bijbelboek</em> als object liturgisch boven zijn hoofd houdt. Hij eist van iedereen, ook van de politieke leiders, onderwerping en gehoorzaamheid aan het <em>Boek</em>. Cyrillus staat hier duidelijk voor de verschuiving van de beelden die elkaar op de agora relativeren en in balans houden, eigen aan het hellenistische polytheïsme, naar het ene beeld van <em>hét Boek</em>.</p>\n</blockquote>\n<blockquote>\n<p>In onze <em>postmoderne</em> beschaving die er één is van de opstand van de beelden, geïnspireerd en gevoed door het medium van de <em>cinematografie</em>, verliest het <em>Boek</em> zijn bevoorrecht statuut en komt het terecht in de maalstroom van de planetaire <em>beeldenagora</em>. Beschouwd vanuit de overgeleverde religies ontstaat daar de boeiende vraag naar hun waarde en betekenis voor de verdere ontwikkeling van de mensheid op de planeet aarde. Die fundamentele vraag verdicht Amenábar ten aanzien van het christendom in het fictieve personage van Davus. In zijn verhaal en dat van Hypatia verdicht zich een belangrijk hoofdstuk van de kerkgeschiedenis.</p>\n</blockquote>\n<p><a name=\"FIL\"></a></p>\n<h2><font color=\"#808000\"><strong>Links</strong></font></h2>\n<p>Zie <a href=\"http://www.menstis.be/producties/Agora\">hier</a> voor de link met het <strong>Project Agora</strong> van Men(S)tis.</p>\n<p>Zie voor een uitgebreide verheldering over de achtergrond van het fenomeen <em>wereldbeeld</em> en over de invloed van het <em>neoplatonisme</em> op het christelijk-theologische wereldbeeld, én voor een constructieve visie op de bijdrage van de cinematografie in de opbouw van een democratische samenleving: <a href=\"http://www.menstis.be/uitgeverij/Levensbeschouwing\">Sylvain De Bleeckere, Levensbeschouwing democratisch belicht</a>.</p>\n<p>In het essay, verschenen als het tweede, uitgebreide deel van <a href=\"http://www.menstis.be/uitgeverij/Gedachtenis\">Men(S)tis’ Studies # 1</a> publiceerde Sylvain De Bleeckere een uitgebreide studie over <span style=\"color:blue\"><strong>Agora</strong></span>.</p>\n<p><font size=\"-2\">© Sylvain De Bleeckere, Men(S)tis, 2011/2017</font></p>\n"}

/***/ }),
/* 989 */
/***/ (function(module, exports) {

	module.exports = {"title":"Andrei Roublev","body":"<center>\n<img src=\"ar.jpg\" >\n</center>\n<a name=\"KLA\"></a>\n<h2><font color=\"#808000\"><strong>Klapbord</strong></font></h2>\n<p><span style=\"color:blue\"><strong>Andrei Roublev</strong></span> is de tweede langspeelfilm van de Russische cineast Andrei Tarkovsky. Hij leefde van 4 april 1932 (Zavraje bij Moskou) tot 29 december 1986 (Parijs). Zijn laatste vier levensjaren bracht hij door in vrijwillige ballingschap in Italië. Hij stierf aan longkanker in een ziekenhuis in Parijs. Zijn graf bevindt zich op het Russische kerkhof aldaar. Wegens voortdurende tegenwerkingen door het regime van de Sovjet-Unie wilde hij niet meer werken in zijn moederland, Rusland.</p>\n<blockquote>\n<p>Door die tegenwerkingen kon hij slechts vijf langspeelfilms realiseren onder het communistische regime van de Sovjet-Unie: <strong>Ivanovo Destvo</strong> (Ivans Jeugd) (1962), <strong>Andrei Roublev</strong> (1966), <strong>Solaris</strong> (1972), <strong>Zerkalo</strong> (De Spiegel) (1975) en <strong>Stalker</strong> (1979). Daarna filmde hij in Italië en Zweden zijn laatste twee films, respectievelijk <strong>Nostalghia</strong> en <strong>Offret</strong> (Het Offer).</p>\n</blockquote>\n<blockquote>\n<p>Op zijn graf te Parijs beitelde de Russische beeldhouwer Ernst Neizvestny de woorden: ‘<em>Voor de man die de Engel zag.</em>’ Dit verwijst naar het <em>diepreligieuze karakter en de uitzonderlijke spirituele uitstraling van Tarkovsky’s films</em>.</p>\n</blockquote>\n<blockquote>\n<p>Dit geldt bij uitstek voor <span style=\"color:blue\"><strong>Andrei Roublev</strong></span>, zijn subliem meesterwerk en een hoogtepunt in de kunst van de cinematografie en de religieuze kunst van de twintigste eeuw. De film heeft zowel esthetisch als religieus een uitstraling die niet taant.</p>\n</blockquote>\n<p><a name=\"SYN\"></a></p>\n<h2><font color=\"#808000\"><strong>Synopsis</strong></font></h2>\n<p>Andrei Roublev is de drieëntwintig jaar jonge monnik-schilder. Hij heeft een uitzonderlijk talent voor het schilderen van iconen. Op zekere dag verlaat hij het <em>Triniteitsklooster</em> waar hij heeft gewerkt, begeleid door zijn oudere medebroeder, de monnik-schilder Kyrill en zijn geestelijke mentor, de monnik Daniël.</p>\n<blockquote>\n<p>Ze gaan een schilderopdracht uitvoeren in de nieuwe <em>Annuniciatiekerk</em> te Moskou. Hij wordt tevens persoonlijk gevraagd om mee te werken met de zeer gerespecteerde, buitenlandse iconenschilder <em>Theofaan De Griek</em>. Die uitnodiging, teken van grote waardering van de grootmeester, wekt de jaloezie op van zijn oudere medebroeder-schilder <em>Kyrill</em>. Die verlaat daarvoor zelfs het klooster.</p>\n</blockquote>\n<blockquote>\n<p>In de loop van de jaren komt Andrei ook in conflict met zijn mentor, de monnik <em>Daniël</em>. Hij blijkt bobendien een heel andere visie te hebben over de betekenis van iconen in de kerken dan Theofaan De Griek. Het conflict tussen Andrei en Daniël escaleert. In die breuk staat de schildering van <em>Het Laatste Oordeel</em> centraal, een tafereel dat Andrei weigert te schilderen. Het tafereel moet volgens de kerkelijke en theologische voorschriften, aldus Daniël, de gelovigen angst voor de hel inboezemen en hen aldus tot een vroom leven aansporen. Andrei weigert echter te schilderen.</p>\n</blockquote>\n<blockquote>\n<p>Tijdens zijn voettochten naar de diverse kerken heeft hij immers het gewone volk leren kennen. Hij heeft gezien hoe het wordt vernederd en lijdt. Het gaat immers al vele decennia lang gebukt onder het juk van de Mongoolse Tartaren die met de regelmaat van een klok het opgeslagen voedsel komen roven. Andrei maakt aan de lijve <em>de belegering en plundering van de stad Vladimir</em> mee. De Tartaren terroriseren de bewoners en plunderen de kerk, de schuilplaats voor het angstige volk.</p>\n</blockquote>\n<blockquote>\n<p>Tijdens die belegering beschermt Andrei een jonge vrouw over wie hij zich al een tijdje ontfermt. Ze is doofstom, heeft geen naam en geen bezittingen. Ze bezit een heilige onschuld. De bescherming van <em>de onschuldige</em> vormt nu Andrei’s prioriteit.</p>\n</blockquote>\n<blockquote>\n<p>Door getuige te zijn van het lot van het gelovige volk, van de plundering van de kerk en de verbranding van de iconen, beslist Andrei net zoals de anonieme onschuldige niet meer te spreken en ook niet meer te schilderen. Ondertussen zorgt hij in het <em>Andronikovklooster</em> voor de onschuldige. Dat is niet vanzelfsprekend. Door de terreur van de Tartaren kampt ook het klooster met een nijpend tekort aan voedsel. Wanneer de Tartaren ook de kloosterlingen zelf komen vernederen, weten ze de onschuldige te verleiden met kleding en vlees. Ze rijdt uit eigen wil weg uit het klooster op de rug van het paard van de leider van de Tartaren. Ondertussen is Kyrill uitgehongerd teruggekeerd naar het klooster. Vol berouw smeekt hij de ouder geworden Andrei zijn zwijgen te doorbreken en opnieuw te gaan iconen schilderen.</p>\n</blockquote>\n<blockquote>\n<p>Wanneer Andrei op zekere dag met een kar volgeladen met verse groenten in de buurt van de nieuwe hoofdstad Moskou komt, ziet hij de jonge <em>Boriska</em>, de zoon van een overleden klokkengieter, aan het werk. Andrei beslist om zijn stilte te doorbreken en samen met de jongen mee te werken aan de wederopbouw van het centrum van het zich herstelde christelijke Rusland, het <em>Triniteitsklooster</em> nabij Moskou. De jongen zal klokken gieten, Andrei iconen schilderen.</p>\n</blockquote>\n<p><a name=\"CIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Cinematografie</strong></font></h2>\n<p><span style=\"color:darkkhaki\"><strong>HISTORISCH EN EPISCH FRESCO</strong></span>. De film is niet in de volle zin van het woord een historische film. Het is zeker geen biografische film want iedere verwijzing naar de geboorte en kindertijd, en de ouderdom en het overlijden ontbreken. Bovendien zijn er over de <em>historische monnik-schilder Andrei Roublev</em>  bijzonder weinig historische gegevens bekend. Op basis van de weinige data kunnen we met enige zekerheid zeggen dat Andrei Roublev leefde van <em>circa 1370 tot circa 1430</em>.</p>\n<blockquote>\n<p>Een anonieme kroniekschrijver, een tijdgenoot van Roublev, vermeldt Roublev en Daniël als spirituele broeders die zich met passie hebben gewijd aan de prachtige iconen van de nieuwe hoofdkerk van het <em>Triniteitsklooster in Sergei Posad</em>, nabij Moskou (vandaag de <em>Troitse-Sergieva Lavra</em> of ‘<em>het Klooster van de heilige Triniteit en de heilige Sergei</em>’ genoemd, het centrum van de Russische Orthodoxie; het klooster werd door de regering van de Sovjet-Unie gesloten in 1918 en heropend in 1946.</p>\n</blockquote>\n<blockquote>\n<p>De film <span style=\"color:blue\"><strong>Andrei Roublev</strong></span> van Tarkovsky opent met Andrei die het Triniteitsklooster verlaat om in de stad Moskou iconen te gaan schilderen en de film eindigt op het ogenblik dat Andrei beslist iconen te zullen schilderen voor de nieuwe hoofdkerk van het Triniteitsklooster. Daar realiseerde hij immers zijn sublieme <em>Triniteitsicoon</em>. Dat staat centraal in de <em>epiloog</em> van de film. Tussen het midden van de zestiende eeuw en het begin van de twintigste eeuw was het werk van Roublev echter helemaal vergeten. Rond de eeuwwisseling begon men werk te maken van de restauratie van oude, Russische iconen. Zo werd de <em>Triniteitsicoon</em> van Andrei Roublev herontdekt, de enige icoon die met zekerheid aan hem wordt toegeschreven. Het meesterwerk van de oud-Russische schilderkunst wordt heden bewaard in de <a href=\"https://www.tretyakovgallery.ru/en/\">State Tretyakov Gallery</a> in Moskou.</p>\n</blockquote>\n<blockquote>\n<p>Pas in 1988 werd de historische Andrei Roublev <em>heilig</em> verklaard door de Russische Orthodoxe Kerk naar aanleiding van het eerste millennium van het christendom in Rusland (988-1988). Hij is hiermee de <em>enige heilge kunstenaar van alle christelijke kerken</em>.</p>\n</blockquote>\n<blockquote>\n<p>Via het portret van de historische Roublev schildert Tarkovsky ook <em>een portret van het Russische volk</em> in het begin van de vijftiende eeuw. In die periode is nadien voorgesteld als de tijd van de <em>Russische renaissance</em>. Het betreft een kantelmoment waarin Rusland van zijn middeleeuwen overgaat in een nieuwe tijd met Moskou als nieuw centrum.</p>\n</blockquote>\n<blockquote>\n<p>Roublev bevond zich inderdaad in <em>een erg chaotische overgangstijd</em> waarin niemand kon voorzien hoe de toekomst er verder zou gaan uitzien. Het was een tragische scharnierperiode in de grote geschiedenis van Rusland. Die periode begon wanneer het eerste, grote historische tijdperk van Ruslands geschiedenis, die met <em>Kiev</em> als centrum, gedurende de dertiende eeuw helemaal ten onder ging. Dat gebeurde door <em>de bijzonder wrede en ongenadige strooptochten van de nomadische Mongoolse Tartaren</em> van Dzenghis Kahn en zijn opvolgers. Zo een tweehonderd jaar lang moesten de Russen zien te overleven in de wouden van het noorden en het oosten. Eén van de voornaamste oorzaken van deze apocalyptische tijden waren de <em>onderlinge vetes en broedertwisten</em> die de Russische Kievnatie verlamden. De onderlinge verbondenheid ontbrak. De talrijke oproepen van de kerkelijke overheid, de metropolieten van Kiev, om <em>de interne broederstrijd</em> op te geven, haalden niets uit. Tarkovsky heeft die historische basisgegevens verwerkt in zijn film over <em>het einde van de veertiende en het begin van de vijftiende eeuw</em>, de periode waarin zich in alle opzichten de wedergeboorte van het christelijke Rusland aankondigde.</p>\n</blockquote>\n<blockquote>\n<p>De historische held die Tarkovsky in <span style=\"color:blue\"><strong>Andrei Roublev</strong></span> op het voorplan plaatst, is echter geen militair, geen prins, maar <em>een monnik-kunstenaar</em>. De regisseur wil geenszins zelf de witte vlekken van de biografie van Roublev invullen. Hij beperkt zich tot de weinig bekende gegevens en concentreert zich op de historische omstandigheden vanuit de optiek van de historische Roublev en de religieuze en spirituele traditie van waaruit hij heeft geleefd en gewerkt. Die traditie gaat terug op de <em>heilige monnik Sergei van Radonezh</em> die eind veertiende eeuw stierf. Zijn religieuze en spirituele beweging stond in het teken van <em>het geloof in de Triniteit</em> (de mystieke gemeenschap van Vader, Zoon en Geest). Ofschoon de heilige Sergei als een kluizenaar leefde in de ondoordringbare wouden van Rusland, trok hij door zijn charismatische persoonlijkheid toch veel monniken aan. Hij stichtte daarom <em>het historische Triniteitsklooster</em> in de nabijheid van Moskou. Zijn leerlingen stichtten daarna diverse kloosters, een ervan is <em>het Andronikovklooster</em> in Moskou. De eerste abt ervan was de heilige <em>Andronik</em>, een leerling van de heilige Sergei van Radonezh.</p>\n</blockquote>\n<blockquote>\n<p>Vandaag is het voormalige klooster het <em>Andrei Roublev Museum</em> van de oud-Russische kunst. Andrie Roublev is de meest beroemde monnik van het klooster geweest. Het was zijn fysieke en geestelijke thuisbasis, ook al zal hij veel tijd hebben doorgebracht in het centrale Triniteitsklooster. Tarkovsky schetst in <em>zijn historisch fresco</em> van iets meer dan drie uren vooral hoe Roublev, gevormd in de geest van de Triniteit volgens de heilige Sergei, de situatie van het lijdende volk in zich opneemt en verwerkt in zijn unieke iconen, in het bijzonder in die van zijn meesterwerk, <em>de Triniteit</em>.</p>\n</blockquote>\n<blockquote>\n<p>Tarkovksy brengt Roublevs iconen tot leven in de <em>epiloog</em> van de film. Hij maakt er een drieluik van, bestaande uit iconen die aan Roublev en zijn Moskouse school worden toegeschreven met in het middenluik de <em>Triniteitsicoon</em>.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>TOESCHOUWERSCHAP IN TWEEVOUD</strong></span>. Wie <span style=\"color:blue\"><strong>Andrei Roublev</strong></span> bekijkt vanuit de verwachtingen die het genre van de historische film schept, raakt gefrustreerd en zelfs geërgerd. Dat was bijvoorbeeld het geval bij de Russische schrijver Alexander Solzhenitsyn, Nobelprijswinnaar voor literatuur in 1970 en internationaal bekende dissident van de Sovjet-Unie. Hij wees de film van Tarkovsky af met de woorden ‘<em>een onmogelijke lange film met extra episodes die het hoofdverhaal niet ondersteunen</em>’, zoals geciteerd door Robert Bird in zijn Engelse studie voor het British Film Institute, <em>Andrei Rublev</em> (London, 2004, 37).</p>\n<blockquote>\n<p>In zekere zin frustreert de film bewust de verwachting van de toeschouwer. Bij het zien van een film over de belangrijkste schilder van Rusland, verwacht die toeschouwer allerlei scènes en sequenties met het hoofdpersonage die aan het schilderen is. Dat gebeurt dus niet. Tarkovsky heeft dat bewust zo gewild. Zijn <span style=\"color:blue\"><strong>Andrei Roublev</strong></span> is inderdaad <em>een episch fresco over een schilder die niet schildert</em>. Er is slechts één korte scène waaruit blijkt dat Roublev een schilder is. Hij bereidt duidelijk de schildering van een icoon voor.</p>\n</blockquote>\n<blockquote>\n<p>Het motief van Tarkovsky om het historische kunstenaarsportret atypisch uit te werken, betreft <em>het toeschouwerschap</em>. Dat bepaalt op <em>twee niveaus</em> het meesterwerk. Op <em>het narratieve niveau</em> portretteert Tarkovsky zijn historisch hoofdpersonage als een toeschouwer. Andrei Roublev treedt het verhaal binnen op het ogenblik dat hij, in het gezelschap van Kyrill en Daniël, op weg gaat naar een nieuwe opdracht. De jonge monnik verlaat voor het eerst de veilige wereld van het klooster en treedt binnen in de voor hem ongekende wereld buiten het klooster. Als volleerd iconenschilder beschikt hij over een sterke blik. Die begeleidt hem nu, niet zozeer om de muren van nieuwe kerken te beschilderen, maar om de nieuwe wereld die hem verschijnt, in zich te absorberen.</p>\n</blockquote>\n<blockquote>\n<p>Reeds in de eerste episode ― <em>De nar. Zomer 1400</em> ― ziet Andrei Roublev de wereld rondom hem met nieuwe ogen. Voor een onweer gaan de drie monniken schuilen bij de boeren. Een nar vermaakt hen in ruil voor wat eten. Andrei neemt alles aandachtig in zich op en ontdekt dat de monniken bij monde van Kyrill zich distantiëren van het gewone volk en de nar, een volkskunstenaar die al zingend en dansend zijn publiek vermaakt. Andrei ziet ook hoe Kyrill de nar verraadt bij de gewapende ruiters, zij die in opdracht van de regerende Groot-Hertog de orde handhaven. De jonge monnik stelt vast dat hij, als monnik, tegenover het volk en zijn kunstenaar staat en zich dus aan de kant van de heersers bevindt. Dit zet hem aan het denken. Vanaf die eerste episode treedt hij binnen in <em>de nieuwe wereld van het beeldend denken</em>. Dat denken is een nieuwe wijze van kijken naar het leven waarvan hij deel uitmaakt maar waarvan hij de betekenis en de draagwijdte in het klooster nooit heeft leren zien. Het beeldend denken leidt hem binnen in <em>de nieuwe leerschool, die van het reële leven</em>. Op het ritme van zijn verdere tocht waarbij hij regelmatig terugkeert naar zijn thuis, <em>het Andronikovklooster</em>, leert hij in de school van het leven <em>het lijden van het volk</em> door en door kennen tot hij er zich mee gaat identificeren. Dat gebeurt door de komst van <em>de onschuldige, jonge vrouw</em> die het lijden van het volk belichaamt: stom en doof gemaakt, weerloos zonder enig bezit.</p>\n</blockquote>\n<blockquote>\n<p>In de laatste episode ― <em>De klok-Zomer-herfst-winter-lente 1423-1424</em> ― ziet de oudere Andrei Roublev de nar, de volkskunstenaar terug. Hij is gemarteld tijdens zijn gevangenschap. Tegelijkertijd ontdekt Andrei een nieuwe gestalte van de volkskunst: <em>de jonge klokkengieter Boriska</em>. Hij is een wees wiens vader een gekende klokkengieter was. Om te ontsnappen aan de dood van honger, slaagt hij erin om zich te laten aanwerven door de gezanten van de Groot-Hertog als de nieuwe klokkengieter, de opvolger van zijn vader. Daartoe liegt hij wanneer hij de gezanten vertelt dat zijn vader hem op diens sterfbed het geheim van het klokkengieten heeft verklapt. Andrei volgt zwijgend maar met een scherpe blik hoe de jonge Boriska vanuit zijn wil om te overleven en vanuit zijn intuïtie, gevoed door de herinneringen aan zijn vader, erin slaagt een klok te gieten. Vanuit die schouwing van het leven zelf beslist Andrei Roublev zijn zwijgen te verbreken en opnieuw iconen te gaan schilderen. Die iconen zijn <em>de historische iconen die Tarkovsky tijdens de epiloog in kleur</em> toont.</p>\n</blockquote>\n<blockquote>\n<p>Met andere woorden, de regisseur schildert zelf het portret van zijn hoofdpersonage in zwart-wit als een <em>leerproces</em>. Hij toont welke fasen Andrei Roublev moet hebben doorlopen in zijn eigen tijd om tot de creatie te kunnen komen van de iconen, waaronder <em>de Triniteitsicoon</em>, waarvan slechts een deel de lotgevallen van de geschiedenis hebben overleefd. Tarkovsky focust dus niet op de evocatie van historische feiten op zich, maar op de in de eigen tijd gewortelde levenshouding van de historische Roublev. Het inzicht in die levenshouding helpt inzien <em>vanuit welk artistiek vermogen en visie de reële, overgeleverde iconen zijn voortgekomen</em>.</p>\n</blockquote>\n<blockquote>\n<p>Meteen vormt dit <em>het tweede niveau van het toeschouwerschap</em> dat het meesterwerk van Tarkovsky typeert. Op dat niveau staat <em>de toeschouwer die de film ziet</em>, op de voorgrond. De regisseur heeft de film inderdaad gemaakt met het oog op de toeschouwer. De verschillende episodes van het verhaal, samen met de proloog en de epiloog, zijn bedoeld om de toeschouwer in <em>een bepaalde denk- en kijkhouding</em> te brengen. Die houding, eigen aan het toeschouwerschap, is vereist om op het einde de iconen van Roublev vanuit de juiste blik te kunnen bekijken. Het hoofdpersonage Roublev die zijn leerschool van het leven doorloopt, vormt de leidraad voor de toeschouwer van de film. Het blikveld van het hoofdpersonage bouwt het blikveld van de toeschouwer op. De verschillende episodes brengen die laatste in <em>de juiste contemplatieve houding</em>, die van <em>het beeldend denken</em>, om aldus de betekenis en de draagwijdte van Roublevs bewaarde en gerestaureerde iconen op gepaste wijze te kunnen aanschouwen.</p>\n</blockquote>\n<blockquote>\n<p>Dat toeschouwerschap is geënt op de iconenkunst van Roublev zelf. De iconen, met <em>de Triniteitsicoon</em> als de standaard, beoefenen zelf het toeschouwerschap. De volledige icoon werkt als een oog, nog versterkt door de unieke blik van de geschilderde personages. Het zijn ogen gericht naar de toeschouwer. Hun blik dringt door tot in zijn gemoed. Sinds het begin van vorige eeuw duiden kunsttheoretici die unieke werking van de iconen met de term ‘<em>het omgekeerde perspectief</em>’. Dat houdt in dat het snijpunt van het blikveld niet in het beeld zelf ligt, maar in de toeschouwer die het bekijkt. Het blikveld van de icoon betrekt de levende toeschouwer in zijn eigen beeldruimte. Hiermee wordt het schouwen van een icoon, geschilderd in de lijn van Andrei Roublev, een spirituele ontmoeting. De toeschouwer overstijgt zijn voyeurisme en ontdekt in die ontmoeting de sleutel tot zijn eigen vermogen van het toeschouwerschap.</p>\n</blockquote>\n<blockquote>\n<p>Kijken verandert in schouwen. De Russische priester-filosoof-kunsttheoreticus en moderne wetenschapper, <em>Pavel Florensky</em> (1882-1937), vermoord door Stalins Sovjetregime, leende de term ‘<em>het omgekeerde perspectief’ (die umgekehrte Perspektive/the reverse perspective)</em> van de Duitse kunsttheoreticus <em>Oskar Wulff</em>. Die ontwikkelde in 1907 het concept in zijn studie over de vormgeving van de ruimte in de Oud-Byzantijnse kunst. Wulff zelf leende de term  de Russische kunstgeleerde <em>Dimitry Ainalov</em>. Die introduceerde circa 1900 de term ‘<em>het omgekeerde perspectief</em>’ vanuit zijn eerder negatieve visie op de eigenheid van de Byzantijnse iconenkunst. Die zou volgens Ainalov voort zijn gekomen uit een gebrek aan artistieke vaardigheden bij de iconenschilders. Wulff daarentegen herijkte de term in een <em>positieve</em> zin. Hij bakende de unieke eigenheid van de Byzantijnse iconenkunst af tegenover die van <em>de westerse renaissancekunst</em>. Kenmerkend voor die kunst is <em>het geometrische perspectief</em>, in Oud-Griekenland en het Romeinse Rijk vooral werd beoefend in de decorbouw en de architectuur. De architecten en de kunstenaars van de Renaissance werkten dat perspectief verder uit. In dat westerse en geometrische perspectief ligt het snijpunt altijd in het beeld zelf. Het kenmerkt <em>de westerse voyeuristische houding</em> tegenover de werkelijkheid van de ruimte en de dingen.</p>\n</blockquote>\n<blockquote>\n<p>Maar het is Florensky die de <em>positieve</em> betekenis van het omgekeerde perspectief van Wulff verder uitwerkte. Hij liet zien dat vooral de schilders van de Russische iconen, voortgekomen uit <em>de Moskouse school van Andrei Roublev</em>, de kunst van het omgekeerde perspectief zeer bewust en op een geniale manier hebben ontwikkeld en uitgewerkt.</p>\n</blockquote>\n<blockquote>\n<p>Op die constructieve visie van Florensky ent Andrei Tarkovsky zijn <span style=\"color:blue\"><strong>Andrei Roublev</strong></span> en zijn cinematografische beschouwing van Roublevs Triniteitsicoon. In zekere zin toont Tarkovsky in de <em>modus van het beeldend denken</em> nog meer dan Florensky in de modus van het theoretische denken aan dat de Russische iconenkunst van Roublev zich op een unieke manier onderscheidt van de Byzantijnse. Dat verklaart waarom de regisseur in de film een belangrijke episode inlast, <em>De passie van Andrei</em>, waarin Andrei Roublev theologisch en spiritueel afstand neemt van de visie van <em>Theofaan De Griek</em>. Roublev introduceert de eigen Russische iconenkunst door zich te distantiëren van die van Theofaan De Griek, de vertegenwoordiger van de Byzantijnse traditie. Tarkovsky zelf transponeert op zijn manier die originele visie van de historische Roublev naar de nieuwe kunst van de cinematografie, een kunst die volgens de Orthodoxe Kerk zelf helemaal niet geschikt is als religieuze kunst.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>TRINAIRE COMPOSITIE.</strong></span> Eén van de belangrijkste esthetische sleutels van <span style=\"color:blue\"><strong>Andrei Roublev</strong></span>, is de <em>trinaire</em> compositie. Trinair staat hier tegenover binair.</p>\n<blockquote>\n<p>Tarkovsky ontleent zijn drieledige benadering aan de historische, religieuze beweging van en rond <em>de heilige Sergei</em>, vereeuwigd in onder andere <em>de Triniteitsicoon</em> van de historische Roublev. Deze unieke icoon vormt de muze én de hoeksteen van de film. Dat blijkt uit <em>de drieledige beweging van de film</em> in zijn geheel alsook in het iconendeel van de epiloog. Wat de hele film betreft blijkt de drieledigheid uit de momenten van de aarde in zwart-wit, de iconen en het slotbeeld met de aarde in kleur. In het iconendeel komen drie iconen volledig in beeld: <em>de Pantocrator, de Triniteit en de Verlosser</em>. Zij worden met elkaar verbonden via fragmenten van andere iconen. <em>De Triniteit</em> vormt het middenstuk waarop de camera inzoomt.</p>\n</blockquote>\n<blockquote>\n<p>In het iconendeel monteert Tarkovsky op de klankband <em>driemaal</em> de donder, het hanengekraai en het klokkengelui. In het zwart-wit gedeelte, het grootste deel van de film, is <em>het trinaire principe</em> ook werkzaam. Het portret van het hoofdpersonage kent immers <em>een drieluik</em>: de monnik van het Andronikovklooster, en zijn alter-ego’s, de anonieme onschuldige en Boriska.</p>\n</blockquote>\n<blockquote>\n<p><em>Het trinaire portret van Roublev</em> krijgt nog <em>een tweede drieluik</em> via de drie monniken Andrei, Kyrill en Daniël. Met hun drie openen ze de eerste episode van het verhaal. Ze vertegenwoordigen de wereld van het orthodoxe klooster. Het beeld van de machthebbers is eveneens <em>trinair</em> opgebouwd: de Groot-Hertog, diens broer en het hoofd van de Tartaren. Vanuit de optiek van de volkskunstenaar vormen de nar, Andrei en Boriska ook een betekenisvol <em>drieluik</em>. Tot slot, ook de wereld van de iconenschilders verschijnt <em>in drievoud</em>: Andrei Roublev, Theofaan De Griek en Kyrill.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>VAN ZWART-WIT NAAR KLEUR.</strong></span> Het grootste deel van <span style=\"color:blue\"><strong>Andrei Roublev</strong></span> is in zwart-wit. Dat geldt voor proloog met de ballonvaarder en de verschillende episodes.</p>\n<blockquote>\n<p>Alleen het iconendeel met het slotbeeld, samen de epiloog van de film, zijn in kleur. Het zwart-wit deel vertegenwoordigt <em>de wereld van het reële leven</em>. Daar maken de monniken met hun klooster deel van uit. Dat geldt uiteraard voor de boeren en hun families, de Russische machthebbers en de buitenlandse indringers. De iconen vertegenwoordigen <em>de wereld van de kunst met hun hemelse kleuren en figuren</em>. Dat laatste impliceert niet dat ze zich boven de gewone wereld van de stervelingen bevinden. Tarkovsky laat daarover geen twijfel bestaan.</p>\n</blockquote>\n<blockquote>\n<p>Vanuit de kleurrijke wereld van de iconen keert hij in het slotbeeld terug naar de aardse wereld, de grote scène waar zich het reële leven afspeelt. <em>De kleurrijke iconen vormen de zon wiens licht en warme op het aardse leven schijnen</em>. Zij geven aan dat aardse leven een nieuwe, kleurrijke dimensie.</p>\n</blockquote>\n<blockquote>\n<p><em>De overgang</em> van het zwart-wit gedeelte naar de epiloog met iconen in kleur gebeurt bijna ongemerkt en dus vanzelfsprekend in de scène waarin Andrei zijn zwijgen verbreekt en beslist om met Boriska samen te gaan werken in dienst van het herop gestane volk. Na het moment waarop Andrei zijn scheppingsverbond met Boriska heeft gesloten, zoomt de camera in op de bevuilde kleren van Boriska die, na het gieten van de klok en de inzegening ervan, neerzit in de modder, de vruchtbare aarde in de schoot waarvan hij zopas de klok heeft gegoten. Dan gaat het beeld over naar het brandhout dan nog nasmeult. Dat beeld krijgt geleidelijk een lichtrode kleur die herinnert aan het vuur dat Boriska heeft ontstoken om het edel metaal te kunnen doen smelten. Tegelijkertijd valt dat beeld via een overvloeier samen met het eerste beeld van het iconendeel. Het betreft namelijk nog een onherkenbaar detail uit een van de iconen die geleidelijk aan in beeld komen.</p>\n</blockquote>\n<blockquote>\n<p>Tarkovsky beschrijft dus een drieledige beweging. Ze begint bij de aarde op de plaats van het nasmeulende hout, gaat vervolgens over naar de iconen en keert van daaruit terug naar de vruchtbare aarde waar op een eiland in een stroom paarden staan te grazen in de lenteregen.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>BEELDMOTIEVEN.</strong></span> Dat Tarkovsky het beeldend denken uitmuntend beoefent in zijn <span style=\"color:blue\"><strong>Andrei Roublev</strong></span>, blijkt uit zijn creatie van <em>diverse visuele beeldmotieven</em>. Die krijgen <em>een menselijke gestalte</em> in de figuren van Andrei, de monniken, de ballonvaarder, de nar, de onschuldige, Boriska, de machthebbers. De beeldmotieven kunnen ook <em>dingen</em> zijn: de rivier, de boom, de modder, de regen, de appels, het vlees, het ijs, het kerkgebouw, de klok, enzovoort.</p>\n<blockquote>\n<p>Een van de meest eigene beeldmotieven van de film zijn <em>de dieren</em>: de zwaan en vooral het paard, in casu <em>het beeld van het zwarte paard</em>. Het is mogelijk om <span style=\"color:blue\"><strong>Andrei Roublev</strong></span> alleen al te bekijken vanuit zijn <em>eigenzinnige en tevens complexe iconografie van het zwarte paard</em>.</p>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><span style=\"color:teal\"><strong>INTRODUCTIE VAN HET ZWARTE PAARD.</strong></span> In <em>het openingstafereel met de ballonvaarder</em> last Tarkovsky het beeld in van de kudde paarden die vrij draaft over het onbegrensde land. Wanneer de ballonvaarder echter is neergestort en het tafereel zijn eindpunt bereikt, ensceneert Tarkovsky die slotsequentie met een beeld in slow motion van een vrij zwart paard. Het dier ligt op de grond, op zijn rug. Het tracht moeizaam recht te komen. Uiteindelijk slaagt het daarin. Dan loopt het rustig weg van de onfortuinlijke ballonvaarder.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><span style=\"color:teal\"><strong>INSTRUMENT VAN MACHT.</strong></span> Het beeldmotief van het <em>vrije, zwarte paard</em> contrasteert met het beeld van de andere paarden in de film. Binnen de verhaalstructuur verschijnen die paarden als de levende instrumenten van de niets ontziende machtigen. In het tafereel met de zingende en dansende volkskunstenaar, een rondtrekkende nar, die voor wat eten de ongeletterde boeren vermaakt met een zowel obscene als rebelse opvoering, verraadt monnik Kyrill de kunstenaar. De manschappen van de Groot-Hertog houden hem aan, slaan hem bewusteloos tegen een boom en voeren hem in gevangenschap weg op hun paarden.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><span style=\"color:teal\"><strong>OBJECT VAN WREEDHEID.</strong></span> <em>In de epische episode van de belegering van de stad Vladimir</em> komt de Tartaarse leider nooit van zijn paard. Met de hulp van de troepen van de Russische verrader, de broer van de Groot-Hertog en tevens diens rivaal, plunderen, verkrachten, verwoesten, moorden, verbranden de Tartaren zonder genade. Tijdens de belegering verschijnt plots <em>het vrije, zwarte paard</em>. Geen ruiter bereidt het. Vanwaar het komt, bij welk kamp het hoort, dat speelt geen rol. Het dier is helemaal alleen en duidelijk op de vlucht voor het geweld dat mens noch dier spaart. Het verkeert in paniek, want het wil weg uit de brandende stal waar het zich bevindt. Het zoekt een uitweg via een kleine, steile trap. Dat lukt niet, het dier struikelt en valt naar beneden. Het bezeert daarbij zijn achterste poten. De camera zwenkt even naar rechts: Tartaarse soldaten hebben daar een Russische vrouw verkracht. Dan beweegt de camera terug naar het gekwetste paard. Ondertussen heeft het geprobeerd recht te staan en enkele stappen vooruit te zetten, maar het zakt door zijn gebroken achterpoten, maakt een rugwaartse tuimeling en valt weerloos neer. Op dat ogenblik komt er een soldaat met een lans voorbij en maakt het dier af.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><span style=\"color:teal\"><strong>HET KERKGEBOUW.</strong></span> Daarna monteert Tarkovsky het eerste beeld binnen in <em>het kerkgebouw</em>. Bij de laatste buitenbeelden met het zwarte paard bereidt Tarkovsky de overgang naar beelden binnen de kerk voor via de klankband. Daar weerklinkt de koorzang van het angstige, maar biddende, gelovige volk. Met een klagende, bijna wenende stem wachten ze bang het moment af waarop de Tartaren de kerkdeur zullen openen. Die audiovisuele collage vormt samen een krachtig reflectief beeld. De schreeuw van het weerloze paard voegt zich bij het klaaglied van het belaagde Russische kerkvolk en omgekeerd.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><span style=\"color:teal\"><strong>HET GELUID VAN DE TRAGIEK.</strong></span> De beeldovergang van het zwarte paard naar het kerkvolk sticht een betekeniswereld die de toeschouwer alleen via het beeldend denken kan betreden. Tarkovsky verdicht ermee het <em>tragische lot van de stad</em> in de laatste sequentie met het zwarte paard en maakt ervan de sleutel waarmee hij de sequentiereeks opent van de kerk met de plundering van het gebouw, het uitmoorden van de gelovigen, het folteren van de koster, het bespotten en verbranden van de iconostase. Die beeldspraak van de tragiek vervolgt in de slotsequentie binnen in de kerk. Het sneeuwt binnen in de kerk, alleen Roublev, de onschuldige vrouw en een zwart paard komen in beeld. Zij vertegenwoordigen de achtergebleven overlevenden. Met het beeld van het figurentrio krijgt de stem van de tragiek het geluid van de stilte.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><span style=\"color:teal\"><strong>DE SCHULDIGE REDDING VAN DE ONSCHULDIGE.</strong></span> Roublev heeft tijdens de plundering van de kerk een jonge vrouw gered uit de handen van een Russische soldaat. Hij heeft de man met een bijl gedood. De onschuldige was weerloos. Roublev ontfermt zich over haar waardoor hij zondigt. Een medemens vermoorden, dat ervaart Roublev als een grote schuld ook al heeft hij dit gedaan om de onschuldige te redden. Op het einde van de sequentie in de kerkruïne met sneeuw belooft hij niet meer te zullen schilderen en geen woord meer te zeggen. Uit boetedoening zwijgen, als kunstenaar én als mens.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><span style=\"color:teal\"><strong>DE TERUGKEER.</strong></span> En dan komt opnieuw een ander zwart paard de kerk binnengestapt. Niemand leidt het. Een van de Tartaren heeft het voordien uit de kerk gejaagd nadat de folteraars van de koster de man eerst met zijn voeten aan het paard hadden vastgeknoopt. Voordien hadden ze de koster de mond gesnoerd door vloeibaar, kokend metaal in zijn keel te gieten. Het zwarte paard keert terug naar de kerk en brengt de herinnering mee aan de wrede terechtstelling van de trouwe koster die weigerde de plaats van de kerkschatten te verraden.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><span style=\"color:teal\"><strong>BEELDEN WAARVOOR GEEN WOORDEN ZIJN.</strong></span> Het figurentrio in de vernielde kerk ― <em>Andrei, de onschuldige, het zwarte paard</em> ― vertolkt <em>de diepe tragiek van het grote lijden</em> van al die anonieme mensen die het volk vormen. Vooral <em>de vrouwen</em> ondergaan die tragiek. Terwijl Andrei in de verwoeste kerk mediteert over het gebeuren, kijkt hij naar de onschuldige die bezig is het haar te vlechten van een vermoorde vrouw. Deze lijkt wel de zuster van de onschuldige te zijn, want ze hebben dezelfde gevlochten haren. Met dit beeld voor ogen vraagt Roublev: ’<em>Rusland verdraagt altijd het lijden en zal dat blijven doen. Maar hoelang nog?</em>’ De monnik-kunstenaar Andrei doorleeft <em>de tragiek van de geschiedenis</em>. Hij engageert zich vanuit dit besef van het tragische en identificeert zich met het stom gemaakte volk, object van wreedheid, subject van onmeetbaar lijden.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><span style=\"color:teal\"><strong>EPILOOG VAN VRIJHEID.</strong></span> In het slotbeeld verschijnen vier paarden die vrij grazen zonder enig spoor van hun ruiters.</p>\n</blockquote>\n</blockquote>\n<p><a name=\"BET\"></a></p>\n<h2><font color=\"#808000\"><strong>Betekenisruimte</strong></font></h2>\n<p><span style=\"color:darkkhaki\"><strong>KUNST AAN DE OVERZIJDE VAN DE IDEOLOGIE.</strong></span> Met <span style=\"color:blue\"><strong>Andrei Roublev</strong></span> doet Tarkovsky meer dan een collectieve herinnering in beeld brengen. Hij beoefent op de scène van de collectieve herinnering aan Andrei Roublev <em>het beeldend denken</em> op een hoogst persoonlijke en intensieve manier. Daarbij mediteert hij over de betekenis en de draagwijdte van kunst in de menselijke beschaving. Die meditatie houdt hij in de context van de Sovjet-Unie waar de kunst werd opgeëist in dienst van de verspreiding van <em>de communistische staatsideologie</em>.</p>\n<blockquote>\n<p>Tegelijkertijd steunt Tarkovsky op <em>de herinterpretatie van het Russisch-Orthodoxe christendom</em>, verdicht in de iconen van Andrei Roublev, zelf een exponent van  <em>de Triniteitsbeweging rond de heilige Sergei van Radonezh</em>. Tarkovsky put voor zijn beeldrijke  herinterpretatie uit de traditie van Russische auteurs als <em>Leon Tolstoi, Fjodor Dostojevski, Pavel Florensky en Nicolai Berdyaev</em>. Allen droegen ze bij tot <em>een herlezing van het Russisch-Orthodoxe christendom in dialoog met de moderne, democratische ontwikkelingen in de Europese filosofie en wetenschap</em>.</p>\n</blockquote>\n<blockquote>\n<p>Met zijn <span style=\"color:blue\"><strong>Andrei Roublev</strong></span> bracht Tarkovsky die traditie van de tweede helft van de negentiende en de eerste helft van de twintigste eeuw terug aan de oppervlakte. Hij deed dit op het ogenblik dat ze was ondergesneeuwd door de agressieve, atheïstische staatsideologie van de Sovjet-Unie. In <span style=\"color:blue\"><strong>Andrei Roublev</strong></span> stelt hij zijn personage van de kunstenaar, de monnik-schilder Roublev, tegenover twee vertegenwoordigers van een <em>ideologisch blikveld</em> op de werkelijkheid van het leven.</p>\n</blockquote>\n<blockquote>\n<p>Het zijn <em>Theofaan De Griek en de monnik Daniël</em>. Bij de eerste, de buitenlandse iconenschilder die de kunst van de iconen uit Byzantium naar Rusland brengt, primeert <em>de ideologische visie op kunst</em> in het algemeen en die van de iconen in het bijzonder. Voor Theofaan De Griek is de kunst hemels en transcendent. Zij keert zich af van de verwerpelijke wereld van de mensen. Dat zijn toch maar zondaars die het hemelse en het verhevene van de religie in en door hun gedrag verloochenen. De mannen en de vrouwen die het volk uitmaken, verdienen eigenlijk niet dat God in de gestalte van Jezus Christus voor hen aan het kruis is gestorven. De Griek formuleert zijn afwijzende visie op het lijdende volk tegenover Andrei.</p>\n</blockquote>\n<blockquote>\n<p>De jonge monnik distantieert zich echter radicaal van dergelijke visie. Dat gebeurt in de episode <em>De passie van Andrei</em>. Het woord ‘passie’ verwijst hier naar het evangelische passieverhaal. De monnik Daniël spreekt en handelt ook ideologisch. Hij belichaamt <em>de geestelijke macht van de Orthodoxe Kerk</em>. Hij wijst Andrei terecht wanneer die niet wil schilderen wat hem vanuit de kerkelijke overheid wordt opgedragen. Dat betreft vooral het tafereel van <em>het Laatste Oordeel</em>.</p>\n</blockquote>\n<blockquote>\n<p>Daniël handelt als een kerkelijke ambtenaar. Hij denkt en treedt op in dienst van de machthebbers zonder nog daarover vragen te stellen. Hij is uitvoerder en een bewaker van <em>de geldende Ideologie</em>. Zowel Theofaan De Griek als Daniël zorgen voor <em>de impact van de heersende Ideologie in het dagelijkse leven</em>. Ze leggen als het ware een zwaar kleed over het bestaande leven van mensen en dingen. Ze denken binair. Ze delen alle fenomenen en gebeurtenissen op volgens <em>het strakke dualistische schema van goed versus kwaad, toegelaten versus verboden, wit versus zwart,  hoog versus laag, man versus vrouw, clerus versus leek</em>.</p>\n</blockquote>\n<blockquote>\n<p>Andrei Roublev aanvaardt dat hardnekkige, traditionele dualisme niet. Hij zoekt een weg om het te overstijgen. Hij volgt zijn <em>levensbeschouwelijke weg in de school van het reële leven</em>. Hij gaat in de tragiek ervan staan, de tragiek waarvoor <em>het binaire dualisme</em> blind is. Zo herontdekt hij via de ontmoetingen met de volkskunstenaar, de onschuldige, en Boriska <em>de trinaire bron van zijn religieuze beleving</em> en van <em>het Russisch-Orthodoxe christendom van de heilige Sergei van Radonezh</em>.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>DE CHRISTELIJKE IDENTITEIT.</strong></span> Tarkovsky vond in een meditatief en biddend bezoek aan de <em>Triniteitsicoon in het State Tretyakov Gallery</em> in Moskou de inspiratiebron voor zijn film <span style=\"color:blue\"><strong>Andrei Roublev</strong></span>.</p>\n<blockquote>\n<p>De Russische cineast benadert de icoon niet als een kostbaar museumstuk. Hij beschouwt het als een religieus kunstwerk dat voortgekomen is uit de levende beweging van het Russische volk en zijn Kerk. <em>De Triniteitsicoon</em> maakte oorspronkelijk deel uit van de iconostase van de kerk van het Triniteitsklooster in Sergei Posad, de bakermat van de Russische Orthodoxie en bijhorende spirituele beweging. Van belang is dat Tarkovsky niet vertrokken is vanuit een theologische Idee of Dogma of Leer.</p>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><span style=\"color:teal\"><strong>BELICHAMING.</strong></span> Het unieke van de <em>Triniteitsicoon</em> kan nooit worden gereduceerd tot een of andere Theorie van welke aard dan ook. Geschreven of gesproken woorden bezitten de kracht niet om de plaats van het Beeld in te nemen. Door de scheppende act waaruit ze is ontstaan, belichaamt de <em>Triniteitsicoon</em> de levende religieuze spirituele beweging rond het christelijke geloof in de Triniteit, zoals het teruggaat op de heilige Sergei van Radonezh.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><span style=\"color:teal\"><strong>LEVENSBESCHOUWING.</strong></span> In die beweging speelt <em>de levensbeschouwelijke beleving en interpretatie van het christelijke credo van de Menswording</em> een hoofdrol. Opvallend daarbij is dat die levensbeschouwelijk stroming uitgaat van drie beeldende ankerpunten: <em>een oudtestamentisch verhaal, een nieuwtestamentisch verhaal en een levende mensheid</em>.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><span style=\"color:teal\"><strong>GENESIS.</strong></span> Het <em>Genesisverhaal 18, 1-16</em> beschrijft Gods aanwezigheid beeldend in de gestalte van drie engelen die op de aarde wandelen en aankomen bij de tent van Abraham en Sarah om te rusten. Het oudere en kinderloze koppel ontvangt hen zo gastvrij dat ze na het bezoek van de drie engelen de gave van de zwangerschap ontvangen. Andrei Roublev vertrekt van dat verhaal, een oorspronkelijk werk van het contemplatievermogen van een van de vele, anonieme auteurs van Genesis. Dat verhaal is een echte beeldende creatie. Het is geen Idee of Wet. Het verhaal ent zich op de werkelijkheid van het leven zelf: <em>de vruchtbaarheid</em> van het koppel man-vrouw, hun liefde, hun huwelijk. En Gods aanwezigheid neemt de gedaante aan van <em>de hemelse Beschouwer</em> die het leven op aarde, in het bijzonder de heiligheid van het menselijke leven, komt schouwen, waarderen en zegenen.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><span style=\"color:teal\"><strong>FEMINIENE HOUDING.</strong></span> Andrei Roublev schildert de drie engelen terwijl ze uitrusten aan de tafel. De figuren van Abraham en Sarah zijn <em>afwezig</em>. Hun aanwezigheid in het verhaal wordt via <em>het omgekeerde perspectief</em> ingenomen door <em>de levende toeschouwer</em> die zo meezit aan de tafel. Het omgekeerde perspectief krijgt hierdoor <em>een feminiene, moederlijke open-barende houding</em> wat verwijst naar de vruchtbaarheid, het zegel van de komst van de drie engelen. Andrei Roublev versterkt nog de feminiene dimensie via de personages van de drie engelen.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><span style=\"color:teal\"><strong>MENSWORDING.</strong></span> Die schildert hij vanuit <em>het nieuwtestamentisch verhaal, aanwezig in de vier Evangelies, van de Menswording</em>. Tarkovsky verwijst naar het evangelische verhaal van de Menswording via <em>de figuur van de onschuldige vrouw</em>. Net zoals Maria in de Evangelies is zij iemand van de onderdrukte volk. Ze bekleedt geen maatschappelijke positie, integendeel. Ze heeft geen dak boven haar hoofd. Het lijden heeft haar sprakeloos en doof gemaakt.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><span style=\"color:teal\"><strong>HET PASSIEVERHAAL VAN JEZUS.</strong></span> Tegelijkertijd schenkt Tarkovsky in de episode <em>De passie van Andrei</em> aandacht aan <em>het Passieverhaal</em>, de hoeksteen van het nieuwtestamentische narratief. In die episode verdedigt het personage van Andrei Roublev dat verhaal van de Menswording tegenover de theoreticus Theofaan De Griek. Hij reduceert het verhaal tot een argument van een bewijsvoering. <em>Het Passieverhaal</em> ‘bewijst’ volgens hem de schuld van het zondige volk dat alleen maar minachting en afwijzing verdient.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><span style=\"color:teal\"><strong>HET PASSIEVERHAAL VAN HET LIJDENDE VOLK.</strong></span> Daartegenover plaatst Andrei <em>de beeldende betekenis van het Passieverhaal</em>. Er is de lijdensweg in regie van de machthebbers, terwijl het lijdensweg van Jezus ook die is van het gewone, onderdrukte volk zelf. In <em>de verbeeldende hervertelling van het Passieverhaal</em> door het personage Roublev en regisseur Tarkovsky heeft de verschijning van Jezus de gedaante van een Russische boer. De lijdensweg zelf voltrekt zich in een Russisch sneeuwlandschap.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><span style=\"color:teal\"><strong>GEZIN.</strong></span> Andrei Roublev plaatst in zijn <em>Triniteitsicoon</em> de nieuwtestamentische Jezusfiguur in het midden aan de tafel. Dat betekent dat hij op één lijn zit met de levende toeschouwer. Tegelijkertijd vormt hij een gemeenschap met de twee andere personages van de Icoon: de Vader en de Geest. Alle drie vormen ze via <em>hun naar elkaar buigende houding een intense gemeenschap</em>, een Gezin. Hun verschijning kent <em>feminiene vormen</em>. Ze lijken niet op stoere, machtige en mannelijke heersers die op het punt staan <em>het Laatste Oordeel</em> over mensen te gaan uitspreken.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><span style=\"color:teal\"><strong>LEVENSBOOM.</strong></span> Via de aanwezigheid van de rots, de boom en het kerkgebouw betrekt Andrei Roublev ook het levende beeld van de eigen tijd en die van het lijdende, Russische volk, in het beeld zelf. De boom staat in het midden, ter hoogte van de Jezusfiguur. Het personage van de boom verwijst naar <em>de levensboom</em> uit het Aards Paradijs, maar evengoed naar de ontelbare bomen die het Russische landschap vormen.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><span style=\"color:teal\"><strong>VISUELE ECHO IN KLEUR.</strong></span> In de epiloog laat Tarkovsky zien hoe allerlei details in de iconen van Roublev verwijzen naar de lotgevallen van het Russische, lijdende volk. Die vormt de visuele echo in kleur van het drama van het volk in zwart-wit. Hiermee laat hij tegelijkertijd ook zien hoe hij vanuit die iconische details concrete scènes heeft opgebouwd. De iconen lijken in de epiloog <em>de artistieke spons te zijn dat het drama van het Russische volk en bij uitbreiding van de mens in zich heeft opgenomen</em>.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><span style=\"color:teal\"><strong>RELIGIEUZE BEELDRUIMTE.</strong></span> Via de drieledige structuur met de drie grote iconen, <em>de Pantocrator, de Triniteit, de Verlosser</em>, kadert Roublev de fragmenten van de tragiek eigen aan het volk en de mensheid in de religieuze ruimte. In die structuur steekt ook een beweging die vertrekt bij de God als de Al-Beheerser (Pantocrator) om via de Triniteit dat beeld te corrigeren vanuit de Verlosser, de directe uitdrukking van de Menswording.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><span style=\"color:teal\"><strong>EEN ZONE VAN ZIN.</strong></span> Die structuur van de montage van de epiloog is bij nader toezien <em>een akte van geloof</em>. Die <em>filmische geloofsakte</em> wordt hier ervaarbaar als <em>een creatie van zingeving</em> en wel in <em>de trinaire modus van de creatie van een zowel kunstzinnige als religieuze zone van zin</em>.</p>\n</blockquote>\n</blockquote>\n<p><a name=\"CON\"></a></p>\n<h2><font color=\"#808000\"><strong>Context</strong></font></h2>\n<p>Met zijn film <span style=\"color:blue\"><strong>Andrei Roublev</strong></span> positioneert Tarkovsky _de historische Triniteitsicoon van _ als <em>een blijvend paradigma van het bestaan van een originele christelijke kunst</em>. Tegelijkertijd affirmeert hij <em>de blijvende actualiteit van het trinaire beeldende denken in het naoorlogse Europa van de toekomst</em>. Dat doet hij via een eigen en unieke cinematografische verdieping van Florensky’s theoretische visie op de eigen Russische traditie van iconen, met <em>Andrei Roublevs Triniteit</em> als referentiebron.</p>\n<blockquote>\n<p>In die trinaire spiegel bevindt zich die toekomst aan <em>de overzijde van de ideologische disputen en tegenstellingen</em>. Tarkovsky wordt vandaag gezien als <em>een profeet</em> die reeds in de jaren zestig van vorige eeuw voorbij de toen nog ondenkbare val van het Sovjetregime dacht en werkte. Hij bood op zijn eentje weerstand aan <em>de grote Ideologie</em> die niet alleen Rusland maar ook een groot deel van Europa in haar antidemocratische en antireligieuze greep hield.</p>\n</blockquote>\n<blockquote>\n<p>Het strijdterrein van Tarkovsky was <em>de kunst van de cinematografie</em>. Die had via de communistische Oktoberrevolutie van 1917 in de jonge USSR prestige gekregen als revolutionaire kunst. De pionier ervan was <em>Sergei Eisenstein</em> (1989-1948). Zijn voornaam verwijst nog naar de grote impact van de heilige Sergei van van Radonezh op de Russische cultuur. Maar de moderne dictatuur van Lenin-Stalin wilde daar definitief een einde aan stellen.</p>\n</blockquote>\n<blockquote>\n<p>Sergei Eisenstein werd de held van <em>de Sovjetfilm</em>. Hij interpreteerde en beoefende de cinematografie vanuit <em>de ideologische a priori’s van het Sovjetsysteem</em>. In de lijn van de voorschriften van de eerste partijleider, Lenin, ijkte Eisenstein de cinematografie als ‘<em>de intellectuele filmkunst</em>’. De hoeksteen ervan moest de (communistische, rationele) Idee zijn. In zijn filmtheorie en -praxis ontwikkelde Eisenstein die ‘intellectuele filmkunst’.</p>\n</blockquote>\n<blockquote>\n<p>Dat blijkt bijvoorbeeld uit zijn <strong>Alexander Nevski</strong> (1938). Daarin herinterpreteert hij de historische veldslag van 1242. Toen versloegen de Russen onder leiding van Alexander Nevski, de hertog van Novgorod, de oprukkende Duitse ridders. Eisenstein herinnert in <em>een nationalistische pose</em> aan die militaire zegen van het orthodoxe Rusland tegen de katholieke Duitsers. Onder impuls van Stalin moest het Russische verleden in dienst worden gesteld van het echte, nieuwe Rusland, dat van de communistische Idee. Stalin wilde met de film <em>de nationalistische gevoelens</em> van de bevolking oproepen om haar te kunnen mobiliseren voor een mogelijke oorlog tegen nazi-Duitsland, een oorlog die er uiteindelijk ook is gekomen.</p>\n</blockquote>\n<blockquote>\n<p>Met zijn films zoals <span style=\"color:blue\"><strong>Andrei Roublev</strong></span> weekte Tarkovsky daarentegen de kunst van de cinematografie los van <em>de dictatuur van de Idee (de Ideologie)</em>. In de eerste versie van het scenario dacht hij eraan <span style=\"color:blue\"><strong>Andrei Roublev</strong></span> te laten beginnen met de succesrijke historische veldslag van Koulikovo tegen de Mongoolse Gouden Horde van de Tartaren (1380). De veldslag betekende niet het einde van de Tartaarse terreur, wel het begin van het einde ervan.</p>\n</blockquote>\n<blockquote>\n<p>Uiteindelijk heeft Tarkovsky beslist het <em>oorlogstafereel</em> niet te verfilmen om aldus ieder mogelijk, nationalistisch en militaristisch gebruik en vooral misbruik van de film onmogelijk te maken. De verfilming van de verwoesting van Vladimir die tijdens het leven van Andrei Roublev effectief plaatsvond, is helemaal geen tafereel dat het <em>nationalistische</em> ego streelt. Tarkovsky’s verzet tegen de heersende <em>Idee</em> van de USSR blijkt uit zijn consequente keuze voor de historische monnik-schilder Roublev als hoofdpersonage. Hij legt ook de nadruk op de onderlinge verdeeldheid van de Russen zelf. Hij laat zien hoe de Russische machthebbers hun eigen mensen uitbuiten en vermoorden, een niet te missen verwijzing naar Stalins terreur tegen de eigen bevolking onder andere via de werkkampen van de Goulag Archipel. Met het dramatische tafereel van de plundering van de kerk te Vladimir zinspeelt Tarkovsky heel direct op de grootschalige destructie door het Sovjetregime, van orthodoxe kerken en kloosters met inbegrip van hun iconen.</p>\n</blockquote>\n<p><a name=\"LIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Links</strong></font></h2>\n<p>Voor een verdieping van de belangrijke noties <em>Toeschouwerschap, Beeldend denken, Tragiek, Zingeving &amp; Levensbeschouwing, Ideologie,</em> zie <a href=\"http://www.menstis.be/uitgeverij\">Levensbeschouwing democratisch belicht</a>.</p>\n<p>Sylvain De Bleeckere bestudeert sinds 1980 het oeuvre van Andrei Tarkovsky. Zie <a href=\"http://www.menstis.be/blog/\">bibliografie</a>.</p>\n<p><em>Mosfilm</em> stelt de film <span style=\"color:blue\"><strong>Andrei Roublev</strong></span> van Tarkovsky vrij ter beschikking voor streaming <a href=\"http://www.openculture.com/2010/07/tarkovksy.html\">online</a>.</p>\n<p><font size=\"-2\"> © Sylvain De Bleeckere, Men(S)tis, 2017.</font></p>\n"}

/***/ }),
/* 990 */
/***/ (function(module, exports) {

	module.exports = {"title":"BenX","body":"<center>\n<img src=\"bx.jpg\" >\n</center>\n<a name=\"KLA\"></a>\n<h2><font color=\"#808000\"><strong>Klapbord</strong></font></h2>\n<p>Met <span style=\"color:blue\"><strong>BenX</strong></span> bevestigt het Vlaamse productiehuis MMG dat het de kwaliteit van een art house film kan combineren met de toegankelijkheid van een productie voor een breed publiek van zowel opgroeiende jongeren als volwassenen. <span style=\"color:blue\"><strong>BenX</strong></span> is de debuutfilm van Nic Balthazar. Als regisseur is hij een autodidact. Hij schreef zelf het scenario op basis van zijn jeugdroman en theatervoorstelling <em>Niets was alles wat hij zei</em>. Op het <em>Festival des films du monde</em> (Montréal 2007) won de debuutfilm van Balthazar de prijs van de beste film, de publieksprijs en de oecumenische prijs.</p>\n<p><a name=\"SYN\"></a></p>\n<h2><font color=\"#808000\"><strong>Synopsis</strong></font></h2>\n<p><em>Ben Vertriest</em> volgt in de derde graad van het technisch onderwijs de afdeling metaal. Hij is erg goed in zijn vak en de leerkrachten zijn over hem tevreden, ook al weten ze dat hij wat raar doet. De meesten van zijn medeleerlingen kunnen aan Bens schoolresultaten trouwens nog een punt zuigen. De jongen woont samen met zijn <em>gescheiden en alleenstaande moeder</em>. Zijn jongere broertje heet <em>Jonas</em>. Ben wil graag de grote broer zijn voor Jonas en voor zijn moeder de voorbeeldige zoon. Maar dat lukt hem niet. Hij draagt de last van een loodzware onmacht mee. Hij kan het niet helpen dat hij al van kindsbeen af een probleemkind is geweest voor zijn ouders en de juffen. En toch heeft hij het, met de hulp van zijn moeder, al ver gebracht. Op het ogenblik dat de eindstreep van het secundair onderwijs in het vizier komt, voelt Ben zijn krachten wegvloeien. Hij speelt met de gedachte om het op te geven. De aanhoudende pesterijen door zijn klasgenoten, <em>Bogaert</em> en <em>Desmet</em>, versterken Bens voornemen een moord te begaan, de moord op zichzelf. Maar zo eenvoudig gaat dat niet. In de game <em>Archlord</em> treedt Ben op als zijn avatar, de succesrijke ridder <em>BenX</em>. Samen met de <em>human mage Scarlite</em> vormt hij een <em>guild</em>. Zij treedt op als de <em>healer</em> van <em>BenX</em>. Het spel kan beginnen, het plan wordt gesmeed en de strategie wordt uitgezet.</p>\n<p><a name=\"CIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Cinematografie</strong></font></h2>\n<p><span style=\"color:darkkhaki\"><strong>KLANKBAND.</strong></span> Een eerste, esthetische kwaliteit van de film is de verzorgde klankband. De regisseur heeft die in zekere zin als een zelfstandig deel van de film uitgewerkt. Dat gebeurt vanuit het perspectief van het hoofdpersonage, de autist Ben Vertriest.</p>\n<blockquote>\n<p>De film introduceert Ben als iemand die heel veel spreekt tot zichzelf en in zichzelf. De <em>voice-over</em> functioneert als de <em>innenstem</em> van Ben. Ook wanneer hij in beeld is, en hij spreekt, dan bewegen zijn lippen niet. Ben denkt enorm veel na. De hele film door krijgt de toeschouwer via de innenstem inzage in de eigen gedachtewereld van Ben, die hij ontwikkelt als een harnas tegen de al te pijnlijke buitenwereld.</p>\n</blockquote>\n<blockquote>\n<p>Een ander element van de klankband is de muziek. De regisseur wendt de muziek aan in de lijn van het voorgrond- en achtergrond effect. Ben heeft geleerd zich tegen die klankaanval van de buitenwereld te verdedigen. Zijn geliefd wapen is zijn walkman. Zijn klankharnas. Hij luistert er naar de muziek van <em>Praga Khan</em>. Nic Balthazar gebruikt die sferische, ambiente muziek van Kahn. Die sferische muziek werkt op Ben als zijn soort stilte: geen babbelende stemmen, maar een bijna stille stroom van zachte klanken.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>WOORD EN BEELD IN BEELD.</strong></span> De beeldende rijkdom van de film bestaat onder andere uit talrijke sequenties van ‘woord in beeld’. Het zijn <em>de chatsessies van Ben met Scarlite</em>, zijn bondgenoot in Archlord. Voor het hoofdpersonage zijn die gesprekken momenten van waarheid.</p>\n<blockquote>\n<p>Een ander belangrijk visueel element zijn <em>de getuigenissen</em>. Het eerste en het belangrijkste personage dat zo in beeld komt, is de moeder van Ben. Zij en nog andere personages spreken voor de camera in een interviewsituatie. De interviewsequenties geven aan de film <em>een niet-lineaire verhaalstructuur</em>.</p>\n</blockquote>\n<blockquote>\n<p>Voorts zijn er de talrijke gamebeelden. <em>De Archlord-beelden</em> tekenen zich zeer scherp af op het filmdoek en helpen hiermee de eigen belevingswereld van Ben levendig voor te stellen. De regisseur wendt die beelden op een zeer creatieve manier aan zodat de toeschouwer gaat begrijpen dat Ben de werkelijkheid waarneemt vanuit <em>het frame van de game</em>. Nooit eerder is in een film een game zo functioneel in een verhaal geïntegreerd. Ook dat maakt de film uniek.</p>\n</blockquote>\n<blockquote>\n<p>De regisseur wendt ook close-up, zelfs de extreme close-up aan om het portret van het hoofdpersonage beklijvend te schilderen.</p>\n</blockquote>\n<p><a name=\"BET\"></a></p>\n<h2><font color=\"#808000\"><strong>Betekenisruimte</strong></font></h2>\n<p>De rijke betekeniswereld van <span style=\"color:blue\"><strong>BenX</strong></span> ontstaat door de bijzondere vormgeving van de dramatische ontknoping. Daarbij hanteert de regisseur enkele bijzondere cinematografische middelen die bijzonder geschikt zijn voor de interpretatie van het genre van de <em>psychologische thriller</em> vanuit dat van de <em>spirituele film</em>.</p>\n<p>In <span style=\"color:blue\"><strong>BenX</strong></span> werkt Nic Balthazar, enkele <em>sterke beeldmotieven</em> uit. Ze werken als rode draden die het betekenisweefsel van de film vormen.</p>\n<p>Drie springen in het oog: <em>de oorlog, de spiegel en het kruisbeeld</em>. Dat laatste verschijnt wanneer Ben naar de bus stapt en even blijft stil staan bij het grote witte kruisbeeld aan het kerkgebouw dat hij passeert. Het is duidelijk één van zijn vaste rituelen. Op het houten kruis hangt een Jezusfiguur, volledig in het wit. Het kruisbeeld komt eveneens in beeld tijdens het uitgewerkte tafereel in <em>de godsdienstklas</em>. Het kruisbeeld speelt ook een hoofdrol in de grote finale van de film. Die is namelijk gesitueerd in <em>een kerkgebouw</em>. Hiermee neemt de regisseur de religieuze, erg christelijke dynamiek van dood en verrijzenis op in zijn verhaal.</p>\n<p>Het einde krijgt door al die religieuze referenties <em>het karakter van een verrijzenis</em>, waarvan de betekenis direct wordt ontleend aan het evangelicht narratief van <em>de Verrijzenis van de Gekruisigde Christus</em>. Hij doet dat op een originele en tevens eigentijdse, beeldende manier.</p>\n<p><a name=\"CON\"></a></p>\n<h2><font color=\"#808000\"><strong>Context</strong></font></h2>\n<p>De film <span style=\"color:blue\"><strong>BenX</strong></span> is een fictiefilm die op geen enkel moment vervalt in een documentaire uiteenzetting over cyberpesten, zelfdoding en autisme bij jongeren. Voor het schrijven van het scenario heeft Nic Balthazar wel grondig onderzoek verricht naar die fenomenen zodoende dat zijn verhaal over Ben Vertriest diepe wortels heeft in de realiteit. Trouwens tijdens de openingsgeneriek verschijnt de zin: “<em>Inspired by true events</em>”.</p>\n<p>Het filmverhaal <span style=\"color:blue\"><strong>BenX</strong></span> verschijnt vooral als een uitzonderlijke en waardevolle humane film. De hartslag ervan beweegt op het ritme van de heersende <em>nood aan een menswaardige zingeving</em> van wat er met en in het leven gebeurt. Hierdoor geeft <span style=\"color:blue\"><strong>BenX</strong></span>, de filmversie van het verhaal, een nog meer uitgesproken spirituele werking dan de roman en het theaterstuk. Dat spreekt zeer duidelijk uit het onderscheid tussen de drie.\nNic Balthazar situeert de grote ontknoping, de begrafenis, in de roman en het theaterstuk in de neutrale ruimte van een crematorium. Dat decor heeft hij helemaal veranderd in <span style=\"color:blue\"><strong>BenX</strong></span>. En hoe! Hij laat, zoals al vermeld, het hele gebeuren plaatsvinden in <em>een kerkgebouw</em>.</p>\n<p><a name=\"LIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Link</strong></font></h2>\n<p>Sylvain De Bleeckere schreef op vraag van de producent MMG, de distributeur KFD en het Vlaamse Ministerie van Onderwijs en Vorming een uitgebreid educatief dossier over de film. Het kan <a href=\"http://www.menstis.be/blog/\">hier</a> worden geraadpleegd op.</p>\n<p><font size=\"-2\"> © Sylvain De Bleeckere, Men(S)tis, 2011/2017.</font></p>\n"}

/***/ }),
/* 991 */
/***/ (function(module, exports) {

	module.exports = {"title":"The Birth of a Nation","body":"<center>\n<img src=\"bn.jpg\" >\n</center>\n<p><a name=\"KLA\"></a></p>\n<h2><font color=\"#808000\"><strong>Klapbord</strong></font></h2>\n<p>Het bewogen verkiezingsjaar 2016 in de Verenigde Staten van Amerika: Hilary Clinton voor de Democratische Partij en Donald Trump voor de Republikeinse Partij streden er voor het presidentschap. Hilary Clinton hoopte het beleid van de aftredende, eerste zwarte president Barack Obama te kunnen voortzetten. Na de eerste zwarte president in het Witte Huis, nu de eerste vrouw als president (‘breaking through the glass ceiling’). Het draaide anders uit. De overwinning van Trump met zijn uitgesproken anti-Obama-campagne sloeg de meeste Amerikanen en bijna alle Europeanen met verstomming. Dat in dat bewogen verkiezingsjaar 2016 de film <span style=\"color:blue\"><strong>The Birth of a Nation</strong></span> zijn wereldpremière kende, krijgt een bijzondere betekenis.\nDe film is namelijk een productie die onder het presidentschap van Obama mogelijk was geworden. Met de film debuteerde de Afro-Amerikaanse acteur Nate Parker als regisseur. Hij schreef zelf het scenario samen met Jean McGianni Celestin na zorgvuldig historisch onderzoek naar een vergeten periode in de geschiedenis van zwart Amerika. Die situeert zich in de eerste decennia van de negentiende eeuw met Nat Turner in de hoofdrol. Parker brengt die historische figuur voor het eerst filmisch tot leven. De film kende zijn wereldpremière tijdens het Sundance Film Festival en won er de Grand Jury Prize en de publieksprijs, de Sundance Audience Award.</p>\n<p><a name=\"SYN\"></a></p>\n<h2><font color=\"#808000\"><strong>Synopsis</strong></font></h2>\n<p>Nat Turner wordt geboren in 1800 op de katoenplantage in Southampton County, Virginia, van de familie Turner. Hij krijgt de Bijbelse voornaam Nathaniël, maar zijn familienaam, zijn identiteit, is Turner, de blanke houder van een eigen slavenkolonie. Nat groeit op als een slaaf. Na de vlucht van zijn vader voor de slavenjagers (‘slave catchers’), wordt Nat opgevoed door twee vrouwen, zijn moeder Nancy en zijn grootmoeder Bridget. Als kind gaat Nat steeds meer beseffen dat hij speciale talenten heeft. Hij leert zichzelf het alfabet en hij kan de letters herkennen in een tekst.</p>\n<img src=\"book.jpg\">\n<blockquote>\n<p>De weduwe Elizabeth Turner ontdekt dat en neemt de jongen onder haar hoede, niettegenstaande het voor de slaven in het Zuiden streng verboden is om te leren lezen en schrijven. Op advies van de lokale  predikant Walthall, beslist de zoon van de weduwe, Samuel Turner, de eigenaar van de katoenplantage, zijn geletterde slaaf Nat te verhuren. Hij wil hiermee een welgekomen extra bron van inkomsten aanboren. Samuel rijdt regelmatig zijn zwarte predikant Nat naar de naburige plantagebezitters. De welbespraakte zwarte preacher krijgt de taak om in zijn predicaties zijn lotgenoten tot meer onderdanigheid, gehoorzaamheid en werkijver aan te zetten. De plantagehouders hopen op die manier hun vrees voor het ontstaan van slavenopstanden te bedwingen.</p>\n</blockquote>\n<blockquote>\n<p>Door zijn predicatiewerk leert Nat echter de onmenselijke situatie van de slaven door en door kennen. Hij absorbeert wat hij ziet. Ondertussen trouwt hij met de slavin Cherry-Anne ― later blijkt dat ze van haar moeder de naam Madison Hayne heeft gekregen. Op zeker dag is Nat getuige van de seksuele vernedering van de slavin Esther, de echtgenote van de slaaf Hark, vriend en rechterhand van Nate. Esher werkt in het huishouden van de Turners en na het jaarlijkse feest ten huize van de Turners wordt ze seksueel opgeëist door de naburige plantageman Joseph Randall. Nadat Nat ervaart dat de blanke slave catchers ook zijn eigen vrouw Cherry-Anne seksueel hebben misbruikt, en nadat hij zelf naar aanleiding van een doopsel dat hij heeft toegediend aan een blanke bekeerling, door Samuel Turner met zweepslagen wordt gestraft, beslist Nat ― geïnspireerd door zijn Bijbellezing, visioenen en een zonsverduistering ― zijn broeders op te roepen om met geweld in opstand te komen.</p>\n</blockquote>\n<blockquote>\n<p>Nat en zijn volgelingen doden enkele plantagehouders. Nat zelf doodt Samuel Turner. Lang duurt hun opstand niet. Nat weet te ontsnappen aan de gewapende blanke eigenaars die zich hebben verenigd om de rebellie de kop in te drukken. Na enige tijd geeft Nat zichzelf aan. Na een kort verblijf in de gevangenis, wordt hij opgehangen. De herinnering aan hem en zijn verzet inspireert echter de volgende generatie slaven ― hier belichaamd door de jongen Jasper. Zijn aanwezigheid valt ook op tijdens de terechtstelling van Nat. Hij kijkt op naar hem. De camera zoomt in op zijn gelaat. Hij weent. Dat beeld gaat over naar de zwarte soldaten van het Lincoln-leger. Zij beantwoorden de oproep van president Lincoln om mee te strijden met de noordelijke staten voor de afschaffing van het systeem van de slavernij.</p>\n</blockquote>\n<p><a name=\"CIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Cinematografie</strong></font></h2>\n<p><span style=\"color:darkkhaki\"><strong>PROLOOG EN EPILOOG</strong></span>. De film <span style=\"color:blue\"><strong>The Birth of a Nation</strong></span> is narratief gezien, lineair opgebouwd. Het verhaal zelf opent met een betekenisvolle proloog die verleden en heden verbindt, en een even betekenisvolle epiloog die heden en toekomst aan elkaar haakt. Tussen beide ontspint zich het chronologisch verhaal van Nat Turner in twee delen. Een kort deel belicht enkele episodes uit de kindertijd, terwijl het grote deel de volwassenheid behandelt.</p>\n<blockquote>\n<p>De proloog verwijst direct naar ‘the birth’ uit de titel. De slaven van de plantage Turner komen in het geheim samen. Ze spreken een zegening uit over de kleine Nat tijdens een Afrikaans-Ghanees ritueel. De gemeenschap heeft opgemerkt dat de jongen bijzondere tekenen draagt op zijn lichaam en dat hij ongewone talenten heeft. Geplaatst in het midden van een cirkel van oudere vrouwen die ritmische gebaren maken, luistert Nat naar een ouderling die de ceremonie leidt. Hij wijst de jongen aan als ‘iemand die de voorvaderlijke heilige tekens draagt’. Hij stelt de jongen aan als ‘leider’ en ‘profeet’ naar wie moet worden geluisterd. Hiermee affirmeert de slavengemeenschap in de Verenigde Staten de blijvende verbondenheid met hun Afrikaanse bakermat en bevestigen ze de grote rol die de generaties daarin vervullen. De ceremoniemeester schrijft Nat als leider kwaliteiten toe die hem een heel leven lang zullen ondersteunen: wijsheid – moed - inzicht.</p>\n</blockquote>\n<blockquote>\n<p>Na die proloog verschijnt de titel van de film: de ‘geboorte’ van een natie, woorden die, zo zal blijken, slaan op de Afro-Amerikaanse natie binnen de Verenigde Staten én bij uitbreiding van de echte Verenigde Staten waarin de voormalige zwarte slavenbevolking ooit volwaardig deel van zal uitmaken; de weeën van de ‘geboorte van die natie’ blijven tot vandaag voortduren.</p>\n</blockquote>\n<blockquote>\n<p>De epiloog staat opnieuw in het teken van de generaties, maar nu kijkend richting toekomst. Dat gebeurt via het beeldmetaforisch personage van zwarte jongen Jasper. Hij is een slaaf van de plantage van Randall waar Nat gaat prediken. Daar stelt Randall zelf Jasper voor aan Samuel en Nat Turner. Het hele tafereel van het bezoek aan de Randall-plantage is opgebouwd als een inclusie tussen de twee shots van Jasper. Zowel in het begin als op het einde zegt hij niets, maar kijkt aandachtig. Hij lijkt vooral gefascineerd door de figuur van Nat. Jasper zelf komt dan ook terug in beeld tijdens de eerste bijeenkomst van de opstandelingen. De jongen wil deelnamen aan de bijeenkomst. De volwassen mannen willen hem echter wegsturen, maar Nat beslist dat hij mag blijven.</p>\n</blockquote>\n<blockquote>\n<p>Zo wordt Jasper de kroongetuige van de opstand. Via een overvloeier van de close-up van het gelaat met de traan verschijnt hij opnieuw. Dat gebeurt in het slotbeeld. Nu is hij jonge man. Hij doet dienst als soldaat in het leger van de Amerikaanse leger tijdens de Civil War, uitgeroepen door president Abraham Lincoln, ter afschaffing van de slavernij in het Zuiden.</p>\n</blockquote>\n<blockquote>\n<p>Met die slotbeelden van de epiloog verbindt Parker de opstand van Nat Turner met de Civil War. Hij portretteert de opstand van Nat Turner als de prelude van de grootse, militaire onderneming in de Verenigde Staten om de instelling van de slavernij voor altijd uit te roeien. In dat slotbeeld herdefinieert Parker meesterlijk de titel ‘the birth of a nation’, met de nadruk op ‘nation’. Een natie kan enkel een ware natie worden genoemd, als alle delen van de bevolking er volwaardig deel van kunnen uitmaken.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>FILMTITEL ALS CITAAT</strong></span>. Met de titelkeuze van <span style=\"color:blue\"><strong>The Birth of a Nation</strong></span> stelt Parker een sterk gebaar. Parkers titel is namelijk bewust niet origineel. Het is namelijk een citaat. Parker citeert een bestaande filmtitel: The Birth of a Nation. Dat is de stille, epische film van regisseur David W. Griffith. Diens film is gebaseerd op een roman en toneelstuk <em>The Clansman: An Historical Romance of the Ku Klux Klan</em> (1905) van Thomas Dixon, Jr. Die historische roman was het tweede deel van een trilogie over de Ku Klux Klan (KKK) waarvan het succes bij het blanke publiek, vooral in het Zuiden van de Verenigde Staten, leidde tot een revival van de racistische Ku Klux Klan-beweging in het begin van de twintigste eeuw. De impact van Griffiths epos versterkte niet alleen het succes van Dixons romans; de film leidde tevens in het Zuiden tot de succesrijke heroprichting van de KKK. Griffith mocht in 1915 zijn film voorstellen in het Witte Huis onder het presidentschap van Woodrow Wilson. Hij prees de film als ‘history written with lighting’. Hierdoor kreeg de film ook een presidentieel aura.</p>\n<blockquote>\n<p>De heropleving van de KKK, de witte suprematisme en het blanke racisme diende een politiek doel. Dat bestond erin de gevolgen van de afschaffing van de slavernij en de bevrijding van de slaven, ‘the negro’s’, politiek in te dammen door te pleiten voor een systematische segregatie, een juridische scheiding van zwarten en blanken waarbij de zwarten als ‘gevaarlijke’ en ‘te mijden’ tweederangsburgers werden afgeschilderd.</p>\n</blockquote>\n<blockquote>\n<p>De roman van Dixon en de film van Griffith scherpten het beeld aan van de vrije ‘negro’s’ als wellustige, wraakzuchtige en ongecultiveerde barbaren die erop uit zijn om blanke vrouwen te verkrachten en blanke burgers te beroven en zelfs te vermoorden. De film verwerkt in een aantal sequenties met revolterende zwarten quasi letterlijk de herinnering op aan de opstand van Nat Turner. Dat KKK-beeld sloot de gewezen zwarte slaaf op in een mensbeeld vol haat tegenover de blanke. De roman en de film verspreidden met opzet het valse beeld van de reële slavengeschiedenis. In die vertekende voorstelling verschenen én verschijnen de leden van de racistische KKK als de helden die het Zuiden hebben gered van een blinde terreur van de zwarte bevolking ten aanzien van hun voormalige blanke meesters. Tegelijkertijd impliceert die verwrongen voorstelling een collectieve vrijspraak voor de voormalige slavernij-periode. Dat alles leert dat aanzienlijk veel blanken in het Zuiden de nederlaag in de Civil War als een onrechtmatige vernedering beschouwen die ze (nog steeds) niet willen accepteren.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>STRIJD OM GESCHIEDENISBEELD</strong></span>. Evenals in de gewezen Sovjet-Unie, vormde in de vorige eeuw het medium film in de Verenigde Staten de machtigste wapen van de politieke beeldvorming. De Afro-Amerikaanse regisseur Parker is zich bewust van de unieke macht. Hij wendt het filmmedium aan om het blijvend racisme in de Amerikaanse samenleving te bestrijden. Zijn motivatie om enkele jaren van zijn leven volledig te wijden aan het project van zijn film over Nat Turner, vond hij in het historisch belang van Griffith’s film <em>The Birth of a Nation</em>.</p>\n<blockquote>\n<p>Tot voor de realisatie van Parkers gelijknamige film was er nog geen beeldende rechtzetting gekomen op die invloedrijke film van Griffith. Die film heeft nog steeds een groot gezag wegens de naam van Griffith zelf, één van de grote pioniers uit de Amerikaanse, ja zelfs de hele filmgeschiedenis. Nog steeds worden Griffiths films bestudeerd omwille van zijn grote vernieuwingen in het krachtige narratieve vermogen van film. Bovendien is de KKK nog steeds een actieve organisatie die de Griffiths film als hun beeldbijbel beschouwt. De eveneens historische Oscarfilm <em>BlacKKKlansman</em> (2018) van Spike Lee brengt dat sterk aan het licht. Hij kreeg ervoor de Grand Prix op het Filmfestival van Cannes en een Oscar voor het beste scenario.</p>\n</blockquote>\n<blockquote>\n<p>En dan is er nog de recente politieke realiteit. De eerste minister van Justitie, Jeff Sessions, onder de regering van de nieuwe president Trump, heeft in het verleden racistische uitspraken gedaan tegen de zwarte burgerrechten en voor de KKK. In zijn historisch statement van 27 februari 2019 voor de <em>United States House Commitee on Oversight and Reform</em>, onder het voorzitterschap van het Afro-Amerikaanse Congreslid Elijah Eugene Cummings stelde de gewezen persoonlijke juridische adviseur van president Trump onder ede zonder aarzelen dat Trump een racist is die zwarte mensen minderwaardig en dom vindt, gewezen president Obama incluis. Dat wijst erop dat het blanke suprematistische mensbeeld, zoals verheerlijkt in Griffiths <em>The Birth of a Nation</em>, in de Verenigde Staten niet alleen onder de oppervlakte, maar ook aan de publieke oppervlakte nog steeds actief doorwerkt.</p>\n</blockquote>\n<blockquote>\n<p>In die optiek ontmaskert Parker <em>The Birth of a Nation</em> van Griffith als een echte propagandafilm die de ideologie van het blanke suprematisme onderschrijft en verspreidt. Dat het blanke ras superieur en hoogwaardiger is dan het zwarte ras blijkt inderdaad uit iedere scène van Griffiths film. Parker verwijst ernaar in de eerste scènes van zijn Birth of a Nation. Het betreft de scène waarin Nats vader Isaac in het avonddonker op zoek gaat naar eten voor zijn gezin, en onderweg door lokale slave catchers wordt tegengehouden. De leider van de slavenjagers, Raymond Copp, vraagt aan een van zijn trawanten, Jesse:</p>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><em>Hoe noem wij een neger die zichzelf slimmer vindt dat een blanke?</em></p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p>Jesse: <em>Een dode neger</em>.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<p>De vader van Nat kan zich verdedigen en ontsnappen, wat hem echter verplicht zijn gezin te verlaten en blijvend te vluchten. Die vroege scène is reeds een voorafspiegeling van het verzet dat Nat Turner later zal organiseren tegen het ontmenselijkende systeem van de slavernij.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>HEMELSE KLANKEN EN MENSELIJKE WEEKLACHT</strong></span>. De muziek vormt een volwaardig deel van de film <span style=\"color:blue\"><strong>The Birth of a Nation</strong></span>. De eerste muziek is die van de natuur, het geluid van de stilte. De plantage bevindt zich midden in de natuur: de uitgestrekte bossen met veel moerassige delen, de katoenplantage. Die natuurmuziek brengt de stilte voort die prominent aanwezig is en die de toeschouwer helpt om zich in de sfeer te kunnen inleven.</p>\n<img src=\"kcrobs.jpg\">\n<p>De natuurlijke stilte sluit aan bij het opgelegde zwijgen van de slaven. Ze hebben niet het recht om vrijuit te spreken en alles wat ze zien en horen, moeten ze voor zich houden. Nat zelf ondervindt wat er gebeurt, als hij dat opgelegde zwijgen verbreekt.</p>\n<blockquote>\n<p>Vervolgens is er de originele muziekscore die componist Henry Jackson schreef in opdracht van de regisseur. Zelf beklemtoont Jackson vooral de spirituele dimensie van zijn compositie. Ze kleurt het dramatisch verhaal in met een religieus-spiritueel palet. Concreet gebeurt dat via een eerder ingetogen symfonische filmmuziek met violen en een kinder- en vrouwenkoor. Hierdoor ontstaat er een muziek die uit de hemel lijkt te weerklinken. Dat is zeker het geval in de sequenties waarin de met zweepslagen neergeslagen Nat terug opstaat, gesterkt door het zien van de vele kaarslichtjes die zijn medeslaven zwijgend voor hem hebben doen branden. De componist verwijst zelf expliciet naar diezelfde ‘hemelse’ spirituele muziek bij de gewelddadige confrontatie tussen de rebellerende opstandelingen en de goed bewapende blanken, bijeengebracht door de gealarmeerde plantagehouders. De muziek ‘ontwapent’ de gewelddadige actiescènes. De gebruikelijk heroïsche muziek dikt het visueel geweld niet aan. Het tegenovergesteld gebeurt. Voorts duidt de ‘hemelse’ muziek Nats twee engel-visioenen: op het einde van de geseling en op het einde van de terechtstelling aan de galg. Ieder keer verschijnt de witte engel vanuit een zeer helder wit, hemels licht. De engelfiguur brengt bij de geseling troost en verlichting, en bij de dood verwelkomt ze Nat in de ‘hemelse’ wereld na de dood.</p>\n</blockquote>\n<blockquote>\n<p>In enkele sequenties verwerkt Jackson de typische Afrikaanse houtblazers en percussie. Die weerklinken in de proloog en in de beginsequenties van de opstand.</p>\n</blockquote>\n<blockquote>\n<p>De soundtrack van de film nog een ander belangrijke component: de cello solo. Die is prominent aanwezig en vertolkt het ingehouden verdriet van de slaven, en in het bijzonder dat van de zwarte vrouwen. Hun verdriet verdicht zich in de personages van Nats grootmoeder Bridget en moeder Nancy, en in die van Nats vrouw Cherry en Harks vrouw Esther. Een ‘wenende’ mix van symfonische klanken en cello onderlijnen ook de typische overgangssequenties. Die verbinden soms twee verschillende taferelen, soms twee verschillende momenten in de tijd.</p>\n</blockquote>\n<blockquote>\n<p>Naast de eigen filmmuziek, geeft Parker aan enkele negro-spirituals een cruciale rol. Het unieke genre van de negro-spiritual vertolkt direct de unieke stem van de Afro-Amerikaanse slaven. Ze behoren nu tot de rijkdom van het muziekerfgoed van de Verenigde Staten van Amerika. In die slavenliederen spiegelen de slaven hun onmenselijke situatie in Bijbelse verzen en verhalen. Ze kennen een unieke mix van klaagzang en gebed.</p>\n</blockquote>\n<blockquote>\n<p>Enkele belangrijke filmtaferelen krijgen een unieke stem via die authentieke songs. Ze zijn onlosmakelijk verweven met die taferelen. Het betreft: <em>Sweet Low, Sweet Chariot</em> die de overgang duidt van de jonge Nat naar de volwassen Nat in het katoenveld; <em>Run, Mary, Run</em> dat de zwarte bewoners van de Parker-plantage zingen tijdens het trouwfeest van Hark en Ester;  <em>Couldn’t Hear Nobody Pray</em>, een unieke a capella interpretatie, gecomponeerd voor de film, door het Afro-Amerikaanse Wiley College Choir met de Afro-Amerikaanse solist Lewis Keys.</p>\n</blockquote>\n<blockquote>\n<p><em>Sweet Low, Sweet Chariot</em> verwijst bij het begin van het verhaal van de volwassen Nat al naar het einde ervan. De spiritual vertolkt de troost van de slaaf in de dood die wordt ervaren als een reis naar de thuis van de hemel. Het beeld van de kar is aan de Bijbel ontleent (2 Kon. 2:11) waar de profeet Elia met een ‘<em>wagen (chariot) van vuur</em>’ naar de hemel wordt gevoerd. Voor de Afro-Amerikaanse slaven is die wagen een houten kar waarmee de overleden slaaf naar het graf wordt gevoerd, een laatste reis die wordt ervaren als de laatste reis naar de hemelse thuis zonder pijn, lijden en verdriet. Sommige interpretaties zien in de song eerder een verdoken verwijzing naar de Underground Railroad, de ondergrondse vrijheidsbeweging die slaven hielp ongemerkt te vluchten naar de Noordelijke Staten en naar Canada. De ‘kar’ is dan de ‘trein’. Het feit is dat de song zeer populair werd in de jaren zestig van vorige eeuw door toedoen van de Civil Rights Movement. Ook de blanke folkrevival pikte de zwarte song op. Joan Baez bracht het lied zelfs op het historische Woodstock Festival voor een overwegend blank jongerenpubliek. Al die associaties spelen mee in het citaat ervan in Parkers film bij de introductie van de jonge en volwassen Nat in de katoenplantage.</p>\n</blockquote>\n<blockquote>\n<p>De minder populaire <em>Run, Mary, Run</em> weerklinkt bij het trouwfeest van Hark en Esther. Geplaatst in deze context werkt het als een verzetslied. Dat blijkt uit de herhaling van het refrein: <em>Run, Mary, Run, you got the right to the tree of life</em>. Het beeld van de levensboom is ontleend aan het <em>Genesisverhaal 2</em> over Adam en Eva in het aards paradijs waar de levensboom zich bevindt. In de filmcontext geven de slaven aan het gehuwde koppel het recht om te leven. In de praktijk van het systeem was dat helemaal niet de realiteit.</p>\n</blockquote>\n<blockquote>\n<img src=\"ch.jpg\">\n</blockquote>\n<blockquote>\n<p>Slavenhouders hielden ervan om gehuwde Afro-Amerikaanse koppels en gezinnen te breken door een van beiden en/of de kinderen door te verkopen. In de film wordt die praktijk gesuggereerd in het gegeven dat Nat en Cherry-Anne wel kunnen huwen maar niet samen kunnen leven, omdat ze ieder tot een aparte plantage behoren. Bovendien weerklinkt in de film de echo van de song na in de beklijvende scène waarin blijkt dat de pas gehuwde Esther seksueel is misbruikt door slaveneigenaar Joseph Randall na het feest ten huize van de Turners. <em>Run, Mary, Run</em> klinkt retrospectief als een waarschuwing voor het ondraaglijke leed dat Esther nog zal overkomen. Dit alles krijgt nog meer dramatisch gewicht, wanneer de toeschouwer weet dat de actrice Gabrielle Union die Esther vertolkt, zelf heeft getuigd hoe ze slachtoffer is geweest van seksueel geweld.</p>\n</blockquote>\n<blockquote>\n<p>De hele film sluit af met de generiek op een zwarte achtergrond terwijl de negro-spiritual <em>I Couldn’t Hear Nobody Pray</em>, Lord de toeschouwer en toehoorder uitgeleide doet. De aangrijpende vertolking synthetiseert de hele film retrospectief. De woorden van de spiritual spreken een ondubbelzinge taal. Het refrein is een gebeden weeklacht waarin de stem van Nat over zijn dood heen in de film en in de realiteit alsnog weerklinkt. Zijn stem wordt geleidelijk ook de stem van het hele slavenvolk. Ook hier is er de Bijbelse referentie: de scène uit het passieverhaal van Jezus in de Hof van Olijven. Jezus die zich door iedereen verlaten voelt. Zijn leerlingen slapen, niemand om samen met hem te bidden in het donkerste uur van zijn bestaan. Ziehier de tekst van de song:</p>\n</blockquote>\n<blockquote>\n<blockquote>\n<p>[Solo]\n<em>I couldn’t hear nobody pray.\nSee when I was way down yonder,\nBy myself.\nAnd I couldn’t hear nobody pray.\nSee, oh Lord.</em></p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p>[Koor]\n<em>I couldn’t hear nobody pray, Lord.\nI couldn’t hear nobody pray.\nSee when I was way down yonder,\nBy myself\nAnd I couldn’t hear nobody pray.</em></p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p>[Solo]\n<em>Dark was the night and cold the ground,\nOn which my Lord was laid.\nAnd great drops of blood like sweat roll down,\nIn agony he prayed.\nSee, oh Lord…\nFather remove this bitter cup\nIf such thy sacred will.\nBut if not content to drink it up,\nThy pleasure I’ll fulfill.\nSee,oh Lord oh.</em></p>\n</blockquote>\n</blockquote>\n<blockquote>\n<p>Behalve de genoemde drie negro-spirituals weerklinkt ook de jazzsong <em>Strange Fruit</em>. Dat gebeurt bij de slotsequenties waarin de opstandige slaven worden gevangen, berecht en worden opgehangen. Via <em>Strange Fruit</em> interpreteert Parker dat historisch tafereel voorwaarts. Hij verwijst ermee naar de beruchte lynchpartijen door KKK op het einde van de negentiende en eerste decennia van de  twintigste eeuw. De Joods-Amerikaase dichter Abel Meeropol, pseudoniem Lewis Allen, schreef de song in de jaren dertig van vorige eeuw nadat hij geschokt was door een foto in de krant die berichtte over een lynchpartij in het Zuiden van de Verenigde Staten van Amerika. Hij publiceerde het gedicht eerst in 1937 in het magazine <em>Teachers Union</em> en schreef daarna zelf de muziek bij zijn gedicht. Het groeide uit tot een protestsong avant la lettre. De Afro-Amerikaanse jazzzangeres Billie Holliday maakt de song onsterfelijk toen ze die voor het eerst song in 1939. Ook Afro-Amerikaanse pianiste en zanger Nina Simone bracht een indringende vertolking van de song. Het is haar versie die Parker gebruikt in de film.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>BIJBELBOEK ALS DRAGENDE BEELDMETAFOOR</strong></span>. Het belangrijkste beeldmotief van de film is het boek van de Bijbel, in het bijzonder het exemplaar van Nat Turner. Zijn persoonlijke ‘Bijbel’ bestaat nog steeds en wordt heden bewaard in het <em>African American Museum</em> in Washington, DC. Daar is te zien dat de historische Nat persoonlijk het Bijbelboek Apocalyps 6:2 met potlood heeft gemarkeerd:</p>\n<blockquote>\n<blockquote>\n<p><em>En ik zag dit:  een wit paard met een ruiter, die een boog droeg. Hij kreeg een zegekrans en trok op als een overwinnaar, de overwinning tegemoet.</em> (Nieuwe Bijbelvertaling)</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<p>Dit citaat komt niet in de film zelf voor, maar de geest ervan klinkt door in de vele Bijbelverwijzingen die de film typeren.</p>\n</blockquote>\n<blockquote>\n<img src=\"nch.jpg\">\n</blockquote>\n<blockquote>\n<p>Het inleidende deel van de kindertijd van Nat staat helemaal in het teken van het Bijbelboek. De avond dat zijn vader Isaac voor zijn leven moet vluchten en gedwongen afscheid moet nemen van zijn gezin zegent hij op zijn beurt Nat, zijn enig kind. Hij zegt letterlijk:</p>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><em>Je bent een kind van God. Je hebt een doel. Het zit in je. God heeft het jou gegeven en iemand kan het je afnemen.</em></p>\n</blockquote>\n</blockquote>\n<blockquote>\n<p>Kort daarna, ziet Nat voor het eerst een boek. Het ligt omgekeerd op de rug van de schommelstoel van Elisabeth Turner. Het is zij die daarna aan Nats moeder Nancy vertelt dat haar man heeft ontdekt dat Nat zichzelf heeft leren lezen. Ze wil zich over hem ontfermen.</p>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><em>Als de Heer de jongen de gave van het lezen gaf, zou het zonde zijn die verloren te laten gaan.</em></p>\n</blockquote>\n</blockquote>\n<blockquote>\n<p>Daarna krijgt Nat in de bibliotheek van het huis van mevrouw Turner ‘<em>het beste boek dat ooit geschreven werd</em>’, de Bijbel, zijn Bijbel. Ze verzekert hem tevens dat wanneer hij haar instructies volgt, zijn leven nooit meer hetzelfde zal zijn. Dan begint ze met de jongen de eerste regels van de Bijbel, de opening van <em>Genesis</em>, te leren lezen: ‘<em>In het begin…</em>’.</p>\n</blockquote>\n<blockquote>\n<p>Daarna volgt nog de sequentie in de blanke kerk, gebouwd op de plantage, waar het kind Nat voor het voltallige blanke kerkpubliek voorleest uit de Bijbel: <em>Jak. 4:8b-9</em>:</p>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><em>Reinig uw handen, zondaars, en zuiver uw hart, wankelmoedigen. Erken uw ellende, en treur, en ween. Laat uw lachten in rouw verkeren en uw vreugde in droefheid.</em></p>\n</blockquote>\n</blockquote>\n<blockquote>\n<p>Daarna neemt de blanke dominee het over en nodigt de blanke kerkgemeente uit om in het licht van <em>Jak. 1</em> vast te houden aan ‘<em>de goedheid van de Heer</em>’. Na de dood van zijn meester Benjamin Turner, moet de jongen op het katoenveld gaan werken. Via de klankband met <em>Sweet Low, Sweet Chariot</em> volgt de overgang naar de volwassenheid van Nat. Hij werkt nog steeds op het katoenveld, maar de song op de klankband eindigt met de sequentie van Nat die predikt in zijn eigen kerk die hij heeft ingericht in de schuur van het slavenkwartier. Daar resumeert hij de hoofdgedachte van het einde van <em>Psalm 27</em>:</p>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><em>Ik zou vergaan zijn zo ik niet had geloofd dat ik het goede van de Heer zou zien in het land van de levenden. Wacht op de Heer, wees sterk en Hij zal uw hart versterken. Wacht, zeg ik, op de Heer.</em></p>\n</blockquote>\n</blockquote>\n<blockquote>\n<p>In een tweede predicatie voor zijn eigen zwarte kerk, met de Bijbel in zijn handen, bespeelt Nat het agrarisch thema van het planten van de gewassen en het oogsten ervan, waarmee hij zinspeelt op het katoenplantage. Hij verplaatst het slavenwerk op de plantage naar het eigen leven van de slaven dat, mits vertrouwen in God, ooit anders zal worden. Daarom is het sleutelwoord van de predicatie: moed en vertrouwen in het werk van God, die hemelse Planter die anders werkt dan de ‘massa’, de meester van de katoenplantage.</p>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><em>Zoals het gewas dat geplant werd, op tijd wordt geoogst, zo heeft de Heer ons ook geplant. De goede God zal Zijn werk voltooien in ons. Tot slot vraag ik jullie allemaal moed te vatten, want God is aan het werk in je leven en Hij stopt niet eer Zijn werk gedaan is. Amen.</em></p>\n</blockquote>\n</blockquote>\n<blockquote>\n<p>Daarna begint de carrière van Nat als prediker die door zijn meester Samuel Turner wordt verhuurd aan diens buren. In de film blijft Parker stilstaan bij twee bijzondere plantages: de meer rijke plantage van de gecultiveerde Joseph Randall en de meer arme plantage van de ruwe Earl Fowler. Randall eist dat Nat zijn slaven aanspoort om zich volledig en zonder morren te onderwerpen aan hun ‘massa’. Nat leest zijn broeders en zusters slaven van Randall <em>1 Petr. 2:18</em> voor:</p>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><em>Slaven, onderwerpt u aan uw meesters met alle respect. Niet alleen als ze goed en vriendelijk zijn, maar ook als zij hardvochtig zijn.</em></p>\n</blockquote>\n</blockquote>\n<blockquote>\n<p>De Nederlandse vertalingen van dit vers verschillen. Sommige edities vertalen ‘vriendelijk’ en ‘hardvochtig’ met ‘rechtvaardig’ en ‘onrechtvaardig’. Tussen de bezoeken aan de twee plantages staat een montage die laat zien dat Samuel Turner zijn predikende slaaf overal naar plantages brengt waar hij tegen betaling de diensten van Nat verkoopt. Bij die beelden hoort Nats predicatie met het <em>vers 2 van Psalm 123</em> en de <em>verzen 24-26 van Gen. 9</em>. In de Nederlandse ondertiteling van de film luidt dat als volgt.</p>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><em>Zoals de ogen der knechten zijn gericht op de hand van hun meester, zoals de ogen der dienstmaagd zijn gericht op de hand der gebiedster… Toen Noah uit zijn roes ontwaakte en ontdekte wat zijn jongste zoon hem had aangedaan, zei hij: 'Vervloekt zij Kanaän. …de minste knecht zal hij zijn van zijn broers. En hij vervolgde: Gezegend zij de Heer, de God van Sem, en Kanaän…</em></p>\n</blockquote>\n</blockquote>\n<blockquote>\n<p>De tweede en laatste uitgewerkte predicatie van Nat situeert zich op de plantage van de wrede en onbarmhartige Earl Fowler. Die eist dat de zwarte prediker Nat zijn slaven tot blinde gehoorzaamheid aanzet wat de Bijbel kan, aldus Bradley, effectiever zijn dan zijn geweer. Nat die getuige is geweest van de wreedheden van de man, beslist om zijn predicatie te baseren op <em>Psalm 149</em>. Ziehier de vertaling zoals ze in de ondertiteling van de film voorkomt. Het is duidelijk dat Nat via de psalmtekst zijn medebroeders verdoken inspireert om zich in Gods Naam in opstand te komen tegen de slavenhouders.</p>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><em>Broeders, ik bid dat je tot de Heer zingt…met een nieuw lied. Zing Zijn lof in de gemeenschap der rechtschapenen. Opdat de getrouwen zich verheugen in de glorie. Laat hen zingen waar zij zijn gelegerd. Met Gods lof op de lippen der getrouwen en een tweesnijdend zwaard in hun hand tot voltrekking van wraak aan de heidenen, tot een strafgericht over die volken om hun koningen in ketenen te slaan en hun edelen in boeien van ijzer, te voltrekken aan hen dit geschreven recht. Glorie is dit voor al Zijn getrouwen! Loof de Heer! Zing tot Hem met een nieuw lied! Loof de Heer!</em></p>\n</blockquote>\n</blockquote>\n<blockquote>\n<p>Vervolgens komen er nog expliciete verwijzingen naar Bijbelpassages voor in dialogen tussen de personages. Tijdens het gesprek van Nat met zijn vrouw Cherry-Ann nadat ze zwaar toegetakeld is door de ‘slave catchers’, zegt Nat haar dat hij dit zal rechtzetten. Zij antwoordt hem echter dat zij van hem het volgende heeft geleerd. Ze citeert dan <em>Mat. 26, 52</em>:</p>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><em>Steek uw zwaard weer op zijn plaats. Want allen die naar het zwaard grijpen, zullen door het zwaard omkomen.</em></p>\n</blockquote>\n</blockquote>\n<blockquote>\n<p>Dan is er nog het grote feest op de Turner-plantage. Nat mag van Samuel het tafelgebed uitspreken. Hij begint met de aanhef van het Onzevader (<em>Mat. 6:913 en Luc. 11:2-4</em>). Zijn grootmoeder Bridget had dit eerder al gedaan bij de huwelijksinzegening van Nat en Cherry-Anne. Tijdens zijn tafelgebed zet Nat het <em>Onzevader</em> naar zijn hand. Hij bidt eigenlijk voor zichzelf om de moed om ‘<em>de vijand van onze vijanden</em>’ te bestrijden en te ‘<em>in onze beproeving te kunnen volharden</em>’. Het gegeven van ‘de vijand van onze vijanden’ is een typisch <em>Oudtestamentisch</em> thema dat in alle boeken van de <em>Thora</em> en in vele <em>Psalmen</em> weerklinkt. Het tafelgebed van Nat:</p>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><em>Onze Vader, Wij danken U voor Uw woord en Uw wil. Wij bidden voor en danken U voor Uw bescherming en Uw belofte. En in onze gehoorzaamheid zult Gij een vijand van onze vijanden zijn. Gij zult bestrijden wie ons bestrijdt. Blijf ons leiden, o Heer, en wij blijven U volgen. In onze beproeving zullen wij volharden en enkel U erkennen als onze bron en kracht. In Uw heilige naam bidden wij. Amen.</em></p>\n</blockquote>\n</blockquote>\n<blockquote>\n<p>Na het seksuele misbruik van Esther door plantagehouder Randall, vraagt Hark aan Nat: ‘<em>Waar is Hij? Waar is God nu?</em>’ Daarin weerklinkt het gebed van Jezus aan het kruis: <em>Mat. 27:46 en Mar. 15:34</em>, wat zelf een citaat is uit <em>Psalm 22,2-3</em>.</p>\n</blockquote>\n<blockquote>\n<p>Ook het doopsel dat Nat uitvoert bij een blanke zondaar verwijst visueel naar de scène van het doopsel van Jezus in de Jordaan door Johannes De Doper (<em>Mat 3,13-17</em>).</p>\n</blockquote>\n<blockquote>\n<img src=\"sw.jpg\">\n</blockquote>\n<blockquote>\n<p>Daarna volgt de grote confrontatie Nat versus Samuel Turner en dominee Walthall. Die eisen dat Nat zich verantwoordt over het volgens hen onverantwoorde doopsel. Dan ontspint er zich een Bijbelgevecht. Nat verdedigt zich met <em>Hand. 20:28</em>:</p>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><em>Pas goed op uzelf en op de kudde waarover de Heilige Geest u het toezicht heeft gegeven. Leef als herders voor de gemeente van God, die Hij door het bloed van zijn eigen Zoon heeft verkregen.</em></p>\n</blockquote>\n</blockquote>\n<blockquote>\n<p>De blanke dominee Walthall riposteert met:</p>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><em>Zeg tegen de slaven dat zij hun meesters moeten gehoorzamen, al hun eisen inwilligen, niet tegenspreken…</em> (Ef.6:5 en het al eerder geciteerde 1 Petr. 2:18).</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<p>Nat heeft vervolgens zijn antwoord klaar door <em>1 Kor. 7:23</em> aan te halen:</p>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><em>Gij zijt gekocht en betaald, word geen slaven van mensen.</em>, wat hij koppelt aan <em>Mat 12:32</em>: <em>Wie de Heilige Geest belastert, zal nooit vergeving krijgen, maar is bezwaard…</em></p>\n</blockquote>\n</blockquote>\n<blockquote>\n<p>De dominee kan daar niet mee lachten en roept <em>Mat. 7:15</em> in:</p>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><em>Wacht u voor de valse profeten in schapenvacht, vanbinnen zijn zij wolven!</em></p>\n</blockquote>\n</blockquote>\n<blockquote>\n<p>Nadat dat intens Bijbelgevecht wordt Nat aan de paal gebonden en slaat Jethro, de rechterhand van Samuel, met een harde zweep op de ontblote rug van Nat, met tal van open wonden als resultaat.</p>\n</blockquote>\n<blockquote>\n<p>Na het overlijden van zijn grootmoeder Bridget, beslist Nat een gewapende opstand te leiden. Hij citeert voor zichzelf <em>1 Sam. 15:3</em>:</p>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><em>Ga nu heen, versla Amalek, vernietig al wat hij bezit en spaar hem niet. Dood man en vrouw, kind en zuigeling, rund en schaap, kameel en ezel.</em></p>\n</blockquote>\n</blockquote>\n<blockquote>\n<p>Die tekst verschijnt als Bijbeltekst in close-up op het scherm.\nTijdens de geheime bijeenkomst waar Nat aan enkele vertrouwelingen in aanwezigheid van de jongen Jasper roept Nat het Bijbelse beeld van de strijd van David tegen Goliath (<em>1 Sam. 17:31-54</em>) en hij citeert ook <em>Mat. 20:16</em>:</p>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><em>De eersten zullen de laatsten zijn en de laatsten zullen de eersten zijn.</em></p>\n</blockquote>\n</blockquote>\n<blockquote>\n<p>En wanneer zijn leerlingen vragen wat ze dan concreet zullen gaan doen, antwoordt Nat weer in Bijbelse termen:</p>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><em>Hetzelfde als David en Gideon, en Jozua en Samson.</em></p>\n</blockquote>\n</blockquote>\n<blockquote>\n<p>Naar David had hij al eerder verwezen. Met Gideon roept hij de herinnering op aan de vijfde rechter die van God de opdracht kreeg Zijn vijanden te verslaan (<em>Recht. 6-8</em>). Jozua, de opvolger van Mozes, verovert en verdeelt het Beloofde Land Kanaän (het boek Jozua) en de rechter Samson (<em>Recht. 13-16</em>) bond de strijd aan tegen de vijanden van Gods volk, de Filistijnen.</p>\n</blockquote>\n<blockquote>\n<p>Die visie speelt ook door in de discussie tussen de rebellerende Nat en Isaiah. Deze wijst het gebruik van dodelijk geweld af. Hij wijst erop dat God een God van liefde is. De belangrijke scène tussen Nat en Isaiah evoceert de discussie over de Bijbelinterpretatie binnen de gemeenschap van de slaven en bij uitbreiding binnen de Afro-Amerikaanse gemeenschap in de 19de en 20ste eeuw: reageren met geweld versus reageren met geweldloos verzet, gevoed door een grote christelijke liefde voor de mens. Met die scène verwijst Parker voorwaarts in de geschiedenis, meer bepaald naar de figuur van de Afro-Amerikaanse dominee dr. Martin Luther King.</p>\n</blockquote>\n<blockquote>\n<p>Nat verdedigt zich tegenover Isaiah door zich te beroepen op zijn verantwoordelijkheid voor ‘<em>het verdrukte volk van God</em>’ en ‘<em>Gods Wil</em>’,termen die een grote rol spelen in de beide Bijbel-Testamenten. En in diezefde geest beëindigt Nat de discussie met Isaiah door erop te wijzen dat God ook een ‘<em>god van toorn</em>’(‘wrath’) is, waarna hij herhaalt dat de Heer hem roept om op te staan en te strijden. Die visie krijgt een bevestiging van Cherry-Anne die nog steeds herstelt van haar wonden. Nat neemt afscheid van haar en vertelt haar over zijn beslissing om de opstand te leiden. Haar reactie is:</p>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><em>Mijn hele leven lang heb ik gebeden dat de Heer ons zou helpen door iemand te sturen die dat kon. Wij allemaal hebben dat gebeden. Ik had alleen niet gedacht dat het mijn eigen man zou zijn. Als de Heer je geroepen heeft om te strijden, moet je dat doen. Strijd voor mij en Joanna. Strijd voor ons allemaal.</em></p>\n</blockquote>\n</blockquote>\n<blockquote>\n<p>De allerlaatste keer dat Nat naar de Bijbel verwijst, gebeurt in het aangezicht van de ‘vijand’. Daar spreekt hij zijn broeders toe, geïnspireerd door <em>Jesaja 12:2</em>:</p>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><em>De Heer is de kracht van ons leven. Wie zouden wij vrezen?</em>, gekoppeld aan <em>Psalm 27:2</em>: <em>Kwaadwilligen, ja zelfs onze vijanden kwamen op ons af om ons te verslinden, maar zij struikelden</em>.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<p>En met zijn laatste woorden van doorzetting alvorens de aanval in te zetten, roept hij: Al trekt een leger tegen ons op, ons hart versaagt niet, waarmee hij duidelijk verwijst naar het beeld van het leger van de Farao die de gevluchte slaven, het Volk van God, achterna zit (<em>Ex. 14</em>).</p>\n</blockquote>\n<blockquote>\n<p>In de gevangenis creëert Parker een beeld met het hemelse, invallende witte licht tegen de achtergrond van de donkere tralies van de cel. Dan in clair-obscure compositie vormt Parker een beeld met het personage van Nat dat direct verwijzing naar <em>de kruisiging van Jezus</em>. Daarna volgen de sequenties van de tocht naar de galg, waarbij de visuele nadruk valt op de bespotting onderweg. De omstaanders beschimpen en slaan Nat. De weg naar de plaats van zijn terechtstelling spiegelt zich in <em>de kruisweg van Jezus in Jeruzalem</em>. In de kleine Amerikaanse stad die ook Jeruzalem heet, voltrekt zich de opstand van Nat en zijn volgelingen worden er neergeslagen, helemaal in overstemming met de historische feiten. Ook Nat zelf wordt er terechtgesteld. De weg van Jezus en zijn leerlingen eindigde eveneens in de historische stad die Jeruzalem heet. Ook de negro-spiritual song, <em>I Couldn’t Hear Nobody Pray</em>, die de eindgeneriek en aldus de hele film retrospectief belicht, legt direct de link tussen het verhaal over Nat Turner en <em>het passieverhaal van Jezus</em>.</p>\n</blockquote>\n<blockquote>\n<p>Tot slot, is de Bijbel nog direct aanwezig via <em>de Bijbelse namen</em> van zowel blanke als zwarte personages: Nat is de Amerikaanse afkorting van <em>Nathaniël</em>, volgens het Johannes’ Evangelie een van de twaalf apostelen van Jezus. De Hebreeuwse naam betekent ‘gave van God’. Voorts zijn er de Bijbelse namen Samuel, Elizabeth, Isaiah, Esther, Joseph, Benjamin en Simon. De kleine stad Jeruzalem in Southampton County, Virginia, is genoemd naar de grote, historische en Bijbelse stad Jeruzalem.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>BEELDSPRAAK VAN VUUR</strong></span>. In de beeldsignatuur van de film speelt ook de aanwezigheid van vuur een hoofdrol. Dat gebeurt via het brandend haardvuur in de woningen, in het bijzonder in de woning van Bridget, Nancy en Nat. Er komen tal van binnensequenties voor waarin het schijnsel van het haardvuur zelf niet in beeld is, maar wel zichtbaar is op de personages.</p>\n<blockquote>\n<p>Het beeld van het vuur in huis heeft ook een Bijbelse inspiratie. Het verwijst naar de werking van de Heilige Geest bij Pinksteren (Hand.2). Door de komst van de Heilige Geest in de vorm van ‘iets wat op vuur geleek’ overwonnen de leerlingen die zich vol droefheid, verlatenheid en rouwgevoelens in een huis waarvan de ramen dicht waren, hadden opgesloten, hervonden ze hun moed, inzicht en bezieling.</p>\n</blockquote>\n<blockquote>\n<p>Nat Turner weet zich bezield door het vuur van de Geest. Hij ervaart zijn inzichten en visioenen als de bezielende werking van de Heilige Geest in hem.</p>\n</blockquote>\n<blockquote>\n<p>De huwelijksscène met Nat en Cherry-Anne is een sobere, maar zeer sterk opgebouwde binnenscène. Beiden zitten naakt tegenover elkaar in een relatief donkere ruimte die enkel wordt verlicht door een grote, brandende kaars. De camera zoomt langzaam in op die kaars. Dan komen ook de neervallende druppels van de zich opbrandende kaars in beeld. Het zijn de druppels van verdriet dat nog zullen volgen, maar ze roepen ook het beeld op van het offer.</p>\n</blockquote>\n<blockquote>\n<p>Dat verwijst vooruit naar de laatste scène met beiden, de scène die direct voorafgaat aan het begin van de gewapende opstand. Die staat, helemaal in de lijn van de overgeleverde documenten, niet zozeer in het teken van de rebellie zelf, maar in dat van het offer dat Nat, gesterkt door zijn vrouw Cherry-Ann, brengt. Dat sluit ook aan bij de sequentie waarin Nat zich vrijwillig en zonder geweld gaat aangeven aan de overheid.</p>\n</blockquote>\n<h2><font color=\"#808000\"><strong>Betekenisruimte</strong></font></h2>\n<p><span style=\"color:darkkhaki\"><strong>MODERNE DEMOCRATIE ALS HET ONTWAKEN VAN GODS RECHTVAARDIGHEID</strong></span>. Vooraleer de film <span style=\"color:blue\"><strong>The Birth of a Nation</strong></span> begint met de proloog, verschijnt er eerst een citaat van Thomas Jefferson, auteur van de Amerikaanse Declaration of Independence waarmee de Amerikaanse Revolutie op 4 juli 1776 begon. Uit het citaat blijkt dat Thomas Jefferson die zelf in zijn Monticello een slavenkwartier had, inzag dat het systeem van de slavernij op termijn niet te verzoenen was met de ideeën van de eerste, moderne democratie in de geschiedenis van de mensheid:</p>\n<blockquote>\n<blockquote>\n<p><em>Indeed I tremble for my country when I reflect that God is just: that his justice cannot sleep forever.</em></p>\n</blockquote>\n</blockquote>\n<blockquote>\n<p>Het citaat bevestigt dat het religieus-christelijke Godsgeloof aan de grondslag lag van de eerste stappen van de moderne democratie. Jefferson besefte dat er echter nog een lange weg te gaan was om die moderne democratie in de gestalte van de Verenigde Staten van Amerika daadwerkelijk de uitdrukking zou worden van Gods Rechtvaardigheid. Het ‘<em>Uw Rijk Kome</em>’ uit het <em>Onzevader</em> weerklonk luidt, zeker bij de miljoenen Afro-Amerikaanse slaven.</p>\n</blockquote>\n<blockquote>\n<p>Hun gebeden zouden samenkomen in de speech van de twintigste eeuw, de ‘<em>I Have A Dream</em>’, het ‘<em>Uw Rijk Kome</em>’ van de vorige eeuw, die dr. Martin Luther King sprak op 28 augustus 1963 op de trappen van het Lincoln Memorial te Washington D.C. Het monumentale beeld van president Lincoln die de Civil War ter afschaffing van de slavernij, luisterde aandachtig. The Birth of a Nation van Parker eindigt met het begin van de Civil War. Die wordt nu gezien als het grote vuur, waarvan de lont is aangestoken door Nat Turner.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>BEELDENDE OPSTAND</strong></span>. <span style=\"color:blue\"><strong>The Birth of a Nation</strong></span> van Nate Parker is een historische film met een biografische insteek. Verfilmde geschiedenis is altijd een vorm van re-enactment. Historische gebeurtenissen worden nagespeeld. Ze worden als het ware live gekopieerd. In een re-enactment reiken verleden en heden elkaar over de brug van de tijd de hand. Letterlijk de feiten herhalen is natuurlijk onmogelijk. De uitdaging van een historische en filmische re-enactment bestaat erin zo getrouw mogelijk personen en gebeurtenissen uit de collectieve herinnering halen en opnieuw aan de oppervlakte van het heden te brengen. Dat gegeven betekent vandaag dat dergelijke onderneming niet kan zonder wetenschappelijk onderzoek. Daarna moet de scenarist en regisseur ― in het geval van <span style=\"color:blue\"><strong>The Birth of a Nation</strong></span> is dat een en dezelfde persoon ― een keuze maken. Niemand, ook Nate Parker niet, kan immers het leven van iemand als Nat Turner (2 oktober 1800 – 11 november 1831) in een gefilmd document van twee uren samenbrengen. Scenarist en regisseur Parker moet zo trouw mogelijk blijven aan de geregistreerde gebeurtenissen in zijn eigen beredeneerde interpretatie, rekening houdend met de eigenheid van het filmmedium en met de verstaanbaarheid en de relevantie van de film voor een hedendaags publiek.</p>\n<blockquote>\n<p>Een goed voorbeeld hiervan is de focus die Parker verantwoord en geslaagd richt op de familie Turner. In de film verblijft Nat Turner op één plantage, die van de Turners. In het begin van het verhaal zien we de meester van de plantage, Benjamin Turner. Na diens dood in 1810 neemt Samuel Turner, de volwassen en ongehuwde zoon, de leiding van de plantage op zich. Nat en Samuel zijn in de film leeftijdsgenoten die als kinderen samen spelen. Het is historisch juist dat Nat Turner zijn familienaam heeft gekregen van zijn eerste meester, Benjamin Turner. Na diens dood werd de historische Nat de eigendom van de broer van Benjamin, Samuel Turner. Dat personage speelt in de film een belangrijke rol. Daarin verschijnt hij als de zoon van Benjamin. De historische Samuel stierf een natuurlijke dood, waarna Nat werd verkocht aan de familie van Thomas Moore.\nNat Turner is zijn rebellie dus niet zoals in de film begonnen met het ombrengen van Samuel Turner, maar van zijn toenmalige plantagehouder, Joseph Travis. Turner was namelijk op het ogenblik van de opstand de eigendom van een kind, de elfjarige Putnam Moore. Toen Thomas Moore stierf, erfde namelijk zijn nog jonge zoon diens slavenplantage. Zijn moeder hertrouwde met de karrenmaker Joseph Travis. Juridisch echter bleef Parker nog steeds de eigendom van Moore’s jonge zoon, terwijl in de praktijk Travis de plantage runde. Deze laatste vormde dan ook het eerste doelwit van Nats historische opstand tegen de plantagehouders.</p>\n</blockquote>\n<blockquote>\n<p>De film <span style=\"color:blue\"><strong>The Birth of a Nation</strong></span> van Parker resumeert eigenlijk de verschillende eigenaars van Nat Turner in de familie Turner onder wier dak Nat als slaaf werd geboren. De familie Turner, Benjamin en Samuel, vertegenwoordigen in de film het instituut van de slavernij in het Zuiden, in het bijzonder in de staat Virginia. Via de activiteiten van de volwassen Nat als zwarte prediker die onder begeleiding van Samuel Turner diverse naburige plantages bezoekt en met de behandeling van de slaven in contact komt, verduidelijkt de film het historisch gegeven dat Nat Turner een goed beeld had van de slavernij als instelling via zijn verblijf als slaaf op diverse plantages in Virginia. Dit historisch gegeven is van cruciaal belang, waar de film correct recht aan doet. De film herinnert er terecht aan dat de historische rebellie van Nat Turner is voortgekomen uit zijn groeiend inzicht in het sociaal-economische systeem van de slavernij, waarvan niet alleen hijzelf maar al zijn Afro-Amerikaanse broeders en zusters slachtoffer van waren.</p>\n</blockquote>\n<blockquote>\n<p>De keuze van Parker voor de historische figuur van Nat Turner is echter niet evident.</p>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><em>Ik wilde een verhaal waarin de held verzet duidelijk ziet als een optie om aan de systematische onderdrukking het hoofd te bieden.</em></p>\n</blockquote>\n</blockquote>\n<blockquote>\n<p>Dat lijkt niet zo vanzelfsprekend. De historische opstand van Nat Turner versterkt immers op het eerste zicht de visie van Griffith/Dixon: de zwarte slaven zijn minderwaardige wezens, wilde dieren die met harde hand en met de zweep moeten worden getemd zodat ze zich altijd onderdanig zouden gedragen.</p>\n</blockquote>\n<blockquote>\n<p>Dat zien we ook in de film van Parker. Er komt immers een dramatische scène in voor met Nat die op zo’n brutale manier zweepslagen krijgt tot hij aan de open wonden bijna bezwijkt. Dat dramatisch gegeven vat goed de logica samen van de blanke suprematie waarop de instelling van de slavernij in het Zuiden was gebaseerd. De slaaf die niet met de gewone middelen kan worden getemd, moet nog harder worden aangepakt met de zweep of andere harde middelen om die alsnog tot onderwerping te dwingen. De reden waarom de ‘temming’ niet mocht leiden tot de dood, was economisch. De slaaf was het fysieke bezit van de plantagehouder die ervoor een aanzienlijk bedrag had betaald. Door hem te doden, zou de eigenaar zichzelf immers economische schade toebrengen.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>HET LEERPROCES VAN NAT TURNER</strong></span>.</p>\n<blockquote>\n<blockquote>\n<p>Samuel Turner: <em>Je les geleerd, jongen (‘boy’)?</em></p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p>Nat Turner: <em>O ja, meneer, ik heb eruit geleerd.</em></p>\n</blockquote>\n</blockquote>\n<p>In het tafereel dat volgt na de zweepslagen, vraagt Samuel aan Nat wiens rug open ligt, of hij zijn les heeft geleerd. De gebroken Nat antwoordt met ja. Maar de betekenis van dat ja ligt anders bij Nat dan bij Samuel. Voor de eerste betekent het ja dat hij nu weet dat zijn eigenaar Samuel die tot dan toe vrij goed was voor hem, uiteindelijk een slavenbezitter is als alle anderen. Hij beseft nu dat Samuel uiteindelijk ook deel uitmaakt van de instelling van de slavernij. Samuel zelf interpreteert het ja van de murw geslagen Nat helemaal anders. Hij denkt dat het ja van Nat gehoorzaamheid en onderdanigheid, passend bij een slaaf, inhoudt.</p>\n<blockquote>\n<p>Voor Nat Turner vormt de geseling met de zweep de eindconclusie van het leerproces dat hem voert naar het inzicht in het noodzakelijk verzet tegen de instelling van de slavernij. Dat leerproces beslaat het grootste deel van de film en verloopt crescendo naar het dramatische orgelpunt van de bloedige rebellie. Die verschijnt als de cumulatie van vele, kleine maar toch duidelijke verzetsmomenten tegen de gesel van de slavernij.</p>\n</blockquote>\n<blockquote>\n<p>In de proloog is er al de verboden samenkomst met het Afrikaanse zegeningsritueel. Het kind Nat onderricht zichzelf door in een boek te leren lezen, iets wat absoluut verbonden is voor slaven. In het grote deel met de volwassen Nat, opent de geleidelijke kennismaking met verschillende plantages en het bijhorende slavenbeleid de open van Nat. Hij spiegelt die realiteit aan zijn groeiende kennis van de Bijbel.</p>\n</blockquote>\n<blockquote>\n<p>Een belangrijk rol in zijn leerproces richting opstand vormen de vrouwenfiguren. Het seksueel misbruik bij Esther en bij Cherry-Ann, waarvan Nat de gevolgen ziet, wakkeren zijn verantwoordelijkheidsgevoel als ‘de herder die voor zijn kudde’ wil zorgen. De ervaring met de bijna fatale zweepslagen versterkt zijn solidaire betrokkenheid met zijn vele zusters en broeders. Na de dood van zijn grootmoeder Bridget die de wonden van Nat verzorgt, terwijl ze vertelt over haar leven in Afrika samen met haar man die, zo stelt ze, gelukkig gestorven is voor de slavenhandelaren langs zijn gekomen, mediteert Nat bij zijn opgebaarde grootmoeder.</p>\n</blockquote>\n<blockquote>\n<p>Die meditatie is een prachtig uitgewerkt als moment van beeldend denken. Nat zegt niets. Hij combineert in zijn geest herinneringsbeelden ― de twee meisjes die hij heeft zien spelen toen hij moest gaan prediken op de plantage van Randall, het blanke meisje trekt het zwarte meisje mee met een koord die rond de hals van het zwarte meisje is vastgemaakt; het gezicht van de misbruikte Cherry-Ann; de gedwongen voeding bij de slaaf op de plantage van Fowler. Bij die herinneringsbeelden hoort de close-up de Bijbeltekst <em>1 Sam. 15:3</em>. Na die meditatie spreekt Nat bij het graf van zijn grootmoeder af met Hark. Hij vraagt hem enkele mannen bijeen te roepen op een geheime plaats. Daar kondigt Nat de rebellie aan.</p>\n</blockquote>\n<blockquote>\n<p>Het hele leerproces staat in het teken van Nats eigen autodidactisch leerproces met de bipolaire polen van de eigen ervaringen en de eigen lezing van de Bijbel. Het leerproces van Nat staat helemaal in het teken van de macht van het beeldend denken. Aan zijn broeders die hem in de rebellie volgen, licht hij dat zelf als volgt toe:</p>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><em>Ik volg de Heer al een hele tijd. Ik predik, citeer uit de Bijbel, verkondig het evangelie met de paar bladzijden en stukken die me zijn toegestaan. Maar ik heb het Woord doorgenomen, helemaal. Met nieuwe ogen zie ik nu dat tegenover elk vers waarmee ze onze slavernij handhaven een ander vers onze vrijheid eist. Tegenover elk vers waarmee ze onze kwelling rechtvaardigen veroordeelt een ander vers hen voor die daden tot de hel. De Heer heeft tot mij gesproken. Visioenen van wat komen gaat.</em></p>\n</blockquote>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>INTERPRETATIESTRIJD OM DE BIJBEL</strong></span>. Helemaal in overstemming met alle overgeleverde getuigen en documenten over de opstand van Nat Turner, onderlijnt Parker het belangrijke feit dat Nat Turner doordrongen was van zijn lectuur van de Bijbel. Zijn zelfbeeld werd er helemaal door gevormd. Hij ervoer dat de Heilige Geest hem bezielde en leidde. Dat leidde geleidelijk tot de kracht om eigen beslissingen te nemen.</p>\n<blockquote>\n<p>Dat blijkt uit de verandering in de toon en de inhoud van zijn predicatie op de plantage van Fowler, uit de kracht van zijn tafelgebed, uit zijn wil om een blanke zondaar te dopen met daarna de strijd om de interpretatie van de Bijbel tussen hem, de zwarte prediker, en Walthall, de blanke dominee, en tot slot, uit zijn besluit om de rebellie te beginnen na het definitieve hemelse teken van de zonsverduistering te hebben aanschouwd.</p>\n</blockquote>\n<blockquote>\n<p>Parker stelt in zijn Helemaal in overstemming met alle overgeleverde getuigen en documenten over de opstand van Nat Turner, onderlijnt Parker het belangrijke feit dat Nat Turner doordrongen was van zijn lectuur van de Bijbel. Zijn zelfbeeld werd er helemaal door gevormd. Hij ervoer dat de Heilige Geest hem bezielde en leidde. Dat leidde geleidelijk tot de kracht om eigen beslissingen te nemen. Dat blijkt uit de verandering in de toon en de inhoud van zijn predicatie op de plantage van Fowler, uit de kracht van zijn tafelgebed, uit zijn wil om een blanke zondaar te dopen met daarna de strijd om de interpretatie van de Bijbel tussen hem, de zwarte prediker, en Walthall, de blanke dominee, en tot slot, uit zijn besluit om de rebellie te beginnen na het definitieve hemelse teken van de zonsverduistering te hebben aanschouwd.</p>\n</blockquote>\n<blockquote>\n<p>Parker stelt in zijn The Birth of a Nation duidelijk de belangrijke rol van de Bijbel en de interpretatie ervan in het leerproces van de jonge democratische Staten van Amerika. Die zijn immers ontstaan uit de opstand uit de opstand van vooral radicaal protestantse groepen die wegens vervolging waren gevolgd uit christelijke Europese landen. In de katholieke of anglicaanse landen waren ze te Bijbels en in tal van protestantse landen waren ze te radicaal. Ze wilden leefden en denken volgens het algemeen protestantse principe van ‘de letter van de tekst’. Het Woord van God is de Bijbel en niets meer is er nodig. De letter van de Tekst en alleen de letter van de Tekst.</p>\n</blockquote>\n<blockquote>\n<p>Die weigering van iedere interpretatie bracht uiteindelijk de religieuze interpretatiestrijd om de Bijbel voort. Dat leidde uiteindelijk tot de confrontatie van de blanken uit het Zuiden met die van het Noorden, met de <em>Civil War</em> als resultaat, en in het Zuiden botsten de eensgezinde Bijbelvaste blanken met de eveneens Bijbel-geïnspireerde zwarte christenen, met de rebellie van Nat Turner en de <em>Civil War</em> als resultaat.</p>\n</blockquote>\n<p><a name=\"CON\"></a></p>\n<h2><font color=\"#808000\"><strong>Context</strong></font></h2>\n<p>De regisseur Nate Parker wil met zijn film <span style=\"color:blue\"><strong>The Birth of a Nation</strong></span> de figuur van Nat Turner opnemen in de geschiedenis van de Verenigde Staten en bij uitbreiding in die van de democratische strijd voor de burgerrechten in de wereld. In dat perspectief heeft de regisseur het boek <em>The Birth of a Nation. Nat Turner and the Making of a Movement</em> samengesteld en op de website van de film heeft hij een rubriek uitgewerkt met als titel <em>Nat Turner Lives</em>. Die webpagina omvat diverse deelpagina’s die gewijd zijn aan diverse voorvechters van de democratische mensenrechten.</p>\n<blockquote>\n<p>De film sluit naadloos aan op de Oscarfilm <em>Lincoln</em> (2012) van Steven Spielberg. De slotsequentie van Parkers <span style=\"color:blue\"><strong>The Birth of a Nation</strong></span> verwijzen direct naar de openingssequenties van Lincoln. Ook de Afro-Amerikaanse acteur, Colman Domingo die in <span style=\"color:blue\"><strong>The Birth of a Nation</strong></span> Nat Turners rechterhand, Hark, vertolkt, heeft een bijrol van Afro-Amerikaanse soldaat in <em>Lincoln</em>. Voorts vertolkt Colman de rol van Ralph Abernathy, de rechterhand van dr. Martin Luther King in de film <em>Selma</em> (2014) van Ava DuVernay.</p>\n</blockquote>\n<blockquote>\n<p>Via de acteur Colman ontstaat er aldus beeldend een sterke link tussen de historische rebellie van preacher Turner, de Civil War onder leiding van president Lincoln en de Civil Rights Movement onder leiding van dr. Martin Luther King, de voorzitter van de Southern Christian Leadership Conference.</p>\n</blockquote>\n<p><a name=\"LIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Links</strong></font></h2>\n<p><strong>GESCHREVEN BRONNEN</strong></p>\n<p>Breen, Patrick, <em>The Land Shall Be Deluged with Blood: A New History of the Nat Turner Revolt.</em> New York, Oxford University Press, 2015.</p>\n<p>Parker, Nate (ed.), <em>The Birth of a Nation. Nat Turner and the Making of a Movement. The Official Movie Tie-in</em>. New York, Atria Books, 2016.</p>\n<p><strong>ONLINE BRONNEN</strong></p>\n<p>Griffith, David W., <a href=\"https://www.youtube.com/watch?v=I3kmVgQHIEY\">The Birth of a Nation (1915)</a>. De historische film over de KKK.</p>\n<p>Fox Searchlight, <a href=\"http://www.foxsearchlight.com/thebirthofanation\">The Birth of a Nation</a>. De officiële (Engelse) site van de film.</p>\n<p><a href=\"https://www.youtube.com/watch?v=7IwXxBrA3wA\">I Couldn’t Hear Nobody Pray</a>. De opname in de studio in aanwezigheid van regisseur Parker.</p>\n<p><a href=\"https://open.spotify.com/album/2TYEOvQnoeNMmhKMl04XIs\">De soundtrack van de film</a>.</p>\n<p><font size=\"-2\">© Sylvain De Bleeckere, Men(S)tis, 2019</font>.</p>\n"}

/***/ }),
/* 992 */
/***/ (function(module, exports) {

	module.exports = {"title":"Come and See","body":"<center>\n<img src=\"cas.jpg\" >\n</center>\n<a name=\"KLA\"></a>\n<h2><font color=\"#808000\"><strong>Klapbord</strong></font></h2>\n<p>De kortfilm in zwart-wit met de internationale titel <span style=\"color:blue\"><strong>Come and See</strong></span> is geschreven en geregisseerd door Selina De Maeyer. Deze Belgische heeft zich reeds een naam verworven als kunstfotografe. Tevens heeft ze zich in de media expliciet over haar katholiek geloof uitgesproken. In 2017 debuteerde Selina De Mayer als filmregisseuse met haar kortfilm <span style=\"color:blue\"><strong>Come and See</strong></span>.</p>\n<p>De kortfilm verdient het label Europese auteursfilm. Selina De Maeyer schreef zelf het scenario, hanteerde zelf de camera en voerde ook de volledige regie. Ze kaapte ermee prijzen weg op internationale katholieke filmfestivals. Dat geldt vooral voor de achtste editie van het <em>Mirabile Dictu-Filmfestival</em> (2017) van het Vaticaan waar <span style=\"color:blue\"><strong>Come and See</strong></span> de prijs van beste kortfilm kreeg. En op het 32ste Internationale <em>Niepokalana Film en Multimediafestival</em> in Warschau won de kortfilm de derde prijs.</p>\n<p>De opnames vonden plaats in de stad <em>Antwerpen</em>: het rustieke historisch centrum met het bestaande huisje aan de Ossenmarkt, bewoond door een Spaanse vrouw die luistert naar de naam Maria-Jezus, het Begijnhof aan de Rodestraat, en de Vlaaikensgang die de Oude Koornmarkt, de Pelgrimstraat en de Hoogstraat verbindt; voorts zijn er sequenties in de winkelstraat de Meir, op de kaaien aan het Steen en in het Stadspark. De slotsequenties in het kerkgebouw zijn gefilmd in de kerk van het Heilig Hart van de gelijknamige parochie, gelegen aan de Lange Beeldekensstraat.</p>\n<p>Alles is op locatie gefilmd tijdens de winter van 2016-2017. Daarbij waren slechts vier personen betrokken: <em>Selina De Maeyer</em>, minderbroeder kapucijn <em>Marcin Derdziuk</em>, priester, die ook de rol van de dakloze bedelaar speelt, <em>Bartek</em>, de roepnaam van het hoofdpersonage, het kind, vertolkt door het zesjarig Poolse jongentje Bartlomiej Basiaga, en zijn moeder, <em>Dorota</em>. Luc De Maeyer tekende het storyboard. Selina De Maeyer verstrekte zelf de nodige gegevens over de opnames aan de auteur en heeft ook deze studie nagelezen. Zelf deelde ze de auteur nog het volgende mee over het verloop van het productieproces:</p>\n<blockquote>\n<blockquote>\n<p><span style=\"color:olive\"><em>Geen draaidag is gestart zonder gebed en geen draaidag is geëindigd zonder gebed. Daar ligt de sleutel. God is waarlijk de regisseur van deze film. Er zijn zo veel toevalligheden mee gemoeid geweest dat je die alleen maar kan toeschrijven aan de Goddelijke Voorzienigheid.</em></span></p>\n</blockquote>\n</blockquote>\n<p>De productie is van de Nederlandse, katholieke uitgeverij Betsaida en de Minderbroeders Kapucijnen Vlaanderen. Xander Nichting componeerde de originele filmmuziek, vooral voor piano en elektrische viool. De film duurt 11 minuten.</p>\n<p><a name=\"SYN\"></a></p>\n<h2><font color=\"#808000\"><strong>Synopsis</strong></font></h2>\n<p>Op de kast in de woonkamer staan behalve familiefoto’s van kinderen, ook verschillende beelden die getuigen van een katholiek huis. Er blijkt niemand thuis te zijn, behalve een kind, een jongentje dat de kamer binnenkomt. Hij kijkt door het raam naar de hemel. De kale boomkruinen zeggen dat het winter is. Het heldere hemellicht werkt als een magneet op het jongentje. Het inspireert hem. Hij neemt de kaarshouder van de kast, steekt de kaars aan en gaat de deur uit nadat hij in de gang de affiche ‘Kom en zie’ heeft gelezen.</p>\n<blockquote>\n<p>Met zijn brandende kaars begint hij aan een tocht vanuit het historisch centrum van de stad Antwerpen. Hij bereikt de grote winkelstraat, de Meir. Er is veel volk. Hij moet zijn kaars brandend zien te houden. Hij steekt het zebrapad over en gaat naar de tramhalte. Via tram 11 rijdt hij richting Stadspark. Daar stapt hij over de besneeuwde paden. Hij is er alleen, omringd door duiven.</p>\n</blockquote>\n<blockquote>\n<p>Uiteindelijk bereikt hij zijn doel, het kerkgebouw van de parochie Heilig Hart. Wanneer hij de kerk betreedt, begint hij enthousiast naar het hoogaltaar te lopen. Hierdoor dooft zijn kaars. Aan het altaar gekomen, ziet hij de uitgestalde monstrans met de heilige Hostie. Hij kijkt aandachtig en blij naar het heilig Sacrament, maar hij beseft tevens dat de vlam van zijn kaars is gedoofd. Hij kijkt naar de glasramen die zich vullen met licht, de zon licht op in de Hostie; het hemelse licht verlicht het gezicht van de jongen en doet zijn kaars opnieuw branden. Hij is diep gelukkig. Zijn blik zoomt in op de Hostie. Ze is een en al licht waarin de eucharistische woorden verschijnen: ‘<em>This is my Body. This is my Blood.</em>’, waarna het  ‘<em>I am the Light of the World</em>’ de film afsluit.</p>\n</blockquote>\n<p><a name=\"CIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Cinematografie</strong></font></h2>\n<p><span style=\"color:darkkhaki\"><strong>GESCHREVEN MET DE PEN VAN DE LICHTAARD IN ZWART-WIT.</strong></span> Door zijn zwart-wit look oogt de film heel esthetisch. De regisseuse slaagt erin de kunst van de cinematografie, waarvan de oorsprong teruggaat op de negentiende-eeuwse zwart-wit fotografie, optimaal in te zetten. Het zwart-wit accentueert immers de bron van alle beelden, het heldere zonlicht dat iedere dag opnieuw de duisternis overwint. Dit wonderlijk gebeuren waarin zich het leven van mensen, dieren en planten op aarde voltrekt, heeft een echo gevonden in de openingstekst van de joodse Thora en de christelijke Bijbel. In de spiegel van <em>Genesis 1-2.4a</em> én de kunst van de cinematografie diept <a href=\"http://www.menstis.be/uitgeverij/Levensbeschouwing\">Levensbeschouwing democratisch belicht</a> die religiositeit van het licht uitgebreid uit in het neologisme van <em>de Lichtaard</em>.</p>\n<blockquote>\n<p><span style=\"color:blue\"><strong>Come and See</strong></span> beweegt zich letterlijk als een blij kind in die Lichtaard. Dat krijgt zijn bezegeling met het citaat uit het <em>Johannesevangelie 8.12</em>: ‘<em>I am the Light of the World</em>’. Daarna volgt de eindgeneriek.</p>\n</blockquote>\n<blockquote>\n<p><span style=\"color:blue\"><strong>Come and See</strong></span> is inderdaad geschreven met de pen van de Lichtaard. Die pen is de filmcamera. Die is voortdurend in beweging. <em>Het openingsshot</em> bevestigt dat met de tracking shot (traveling shot) bij de kast in de woonkamer. De camera beweegt langs de kast met de voorwerpen. Ook <em>het slotbeeld</em> ontstaat uit een beweging. Het is even eenvoudig als complex opgebouwd. Nadat de gloed van het zowel goddelijke als aardse licht de kaars van het kind weer heeft doen branden, plaatst het kind de kaarshouder met de brandende kaars op het altaar naast de andere brandende kaarsen. Dan kijkt hij blij en gelukkig op naar de monstrans met de heilige Hostie. Daarop volgt de ‘goddelijke’ respons. De regisseuse bereikt dat effect door gebruik te maken van de <em>subjectieve camera</em>. Die bevindt zich achter de monstrans en zoomt geleidelijk in op de heilige Hostie. Er ontstaat een <em>grote close-up</em> waarbij de hostie zelf een bron van licht wordt, waarin vervolgens de eucharistische woorden verschijnen. Met andere woorden, de regisseuse gebruikt hier de subjectieve camera om de goddelijke aanwezigheid, fysisch present in het <em>heilig Sacrament</em>, te evoceren. Die goddelijke aanwezigheid waarmee de positie van de camera via de <em>inzoom</em> bijna letterlijk samenvalt, belichaamt het goddelijke welkom en ontvangst van het kind in het kerkgebouw, het eindpunt en de bekroning van zijn tocht doorheen de stad.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>MONTAGE EN INLAS.</strong></span> De bewegende camera past perfect in het beeld van de tocht van de jongen door de stad, richting het kerkgebouw met het heilig Sacrament. De camera stapt mee met de jongen. Dat kondigt zich aan via een creatief gebruik van de montage. De film is namelijk lineair opgebouwd. Het is <em>een kleine road movie</em>, een genre waarvan het kenmerk is dat het hoofdpersonage een concrete weg aflegt. Het verhaal is dan de weg zelf. In <span style=\"color:blue\"><strong>Come and See</strong></span> betreft het de weg van het hoofdpersonage van de kleine jongen doorheen de stad Antwerpen: van het historisch centrum via de winkelstraat naar de tramhalte en zo naar het park om aan te komen bij de kerk.</p>\n<blockquote>\n<p>Die narratieve ononderbroken lijn kent één korte, maar belangrijke uitzondering. Die situeert zich helemaal aan het begin van de film. De korte passage bestaat uit <em>een close-up van stappende voeten</em>. De camera focust op de schoenen op de weg. Dat tussenshot is erg betekenisvol. Het jongentje kijkt door het raam naar de hemel over de kale kruinen van de bomen. Dan volgt het <em>bedoelde tussenshot</em>, waarna het kind beslist om de kaarshouder te nemen, de kaars aan te steken en aan zijn tocht te beginnen. Met andere woorden, op het ogenblik dat het kind nog binnen in de woonkamer is, vormt het tussenshot van de stappende voeten een uitnodiging. Het kind ervaart een kracht vanuit het helderde hemellicht om op weg te gaan. Die beeldende compositie werkt narratief als de roep om de Bron van het licht op te gaan zoeken.</p>\n</blockquote>\n<blockquote>\n<p>Een dergelijke ‘roeping’ herinnert aan het evangelisch verhaal van <em>Mattheüs 2.1-23</em> met de drie koningen die de roep van de lichtende kerstster volgen en <em>Lucas 2, 8-12</em> met de herders die op weg gaan naar Bethlehem na de ontmoeting met een engel ‘<em>omgeven door het stralende licht van de Heer</em>’. Net voor het kind de huisdeur opent, leest hij nog de affiche in de gang: ‘<em>Kom en zie</em>’. Ook die versterkt de roep die hij kijkend naar het licht heeft vernomen. De regisseuse heeft zelf de originele affiche ontworpen. Aan de auteur liet ze weten dat ze de affiche heeft gemaakt als een uitnodiging voor de wekelijkse <a href=\"https://jezus-hart.be/activiteiten\">Kom en Zie-bijeenkomsten met Jezus (gebed, catechese, ontmoeting)</a> op donderdagavond in de H. Hartkerk. Daar zijn de eindsequenties opgenomen. Selina De Maeyer staat mede aan de wieg van dit initiatief. De affiche toont gevouwen, biddende handen waaruit een sterke lichtbron ontspringt. Die uitnodigende affiche is uitgegroeid tot de kortfilm <span style=\"color:blue\"><strong>Come and See</strong></span>.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>HET KIND ALS WANDELENDE BEELDMETAFOOR.</strong></span>  <span style=\"color:blue\"><strong>Come and See</strong></span> ontspringt aan het <em>beeldend denken</em>. Dat gebeurt zeer intens. De film maakt de kijker bewust van zijn <em>toeschouwerschap</em> (zie Deel 1 van <a href=\"http://www.menstis.be/uitgeverij/Levensbeschouwing\">Levensbeschouwing democratisch belicht</a>. Van de eerste sequentie af plaatst de film de kijker voor zijn eigen verantwoordelijkheid als toeschouwer. Beeldconsumptie is hier niet mogelijk. Op het eerste zicht wordt die toeschouwer immers aan zijn lot overgelaten. Die krijgt geen enkele introductie, geen mededeling over wat en waar. Het hoofdpersonage is niet gesitueerd. Het kind heeft wel een thuis, maar ouders of sporen ervan zijn niet te bespeuren. Het lijkt erop alsof hij alleen in het huis woont. En vooral: er wordt geen woord gesproken, zoals in een stille film uit de beginperiode van de filmkunst. Maar toen werden de stille beelden afgewisseld met tekstborden om de toeschouwers te informeren. Hier niet. Alleen verschijnen op het einde de eucharistische woorden.</p>\n<blockquote>\n<p>Het beeldend denken werkt met <em>beeldmetaforen</em>. De voornaamste is <em>het kind zelf</em>. Zijn anonimiteit, de afwezigheid van enige gezinssituatie, een portret zonder enige psychologische analyse, dat alles maakt van het hoofdpersonage een levend beeld van het kind-zijn. Hij belichaamt het menszijn in de gestalte van het kind. Dat het daarbij niet om een bepaalde levensfase met een bepaalde eigen psychologische setting gaat, blijkt uit de hele signatuur van de film. Het kind-zijn geldt voor alle mensen, klein en groot, jong en oud, man of vrouw, monnik of dakloze. De oudste man of vrouw op aarde blijft nog steeds het kind van zijn ouders. Maar er is nog meer.</p>\n</blockquote>\n<blockquote>\n<p>Niet de psychologie, maar de <em>spiritualiteit van het kind-zijn</em> primeert in <span style=\"color:blue\"><strong>Come and See</strong></span>. In de optiek van de eerste sequenties geldt het kind-zijn voor alle bewoners van de aarde. Alle mensen zijn kinderen van het licht, zonen en dochters van het mysterie van het leven op aarde. Het jongentje woont in een huis en vanaf zijn eerste verschijnen beweegt hij vanuit de verbondenheid met het licht aan de hemel dat boven de hoge kale bomen zichtbaar is. Zelfs in de winter waarborgt dat <em>lichtende licht</em> de belofte van leven, beweging, toekomst. Die primaire relatie van het mensenkind met de bron zelf van het leven, <em>de Lichtaard</em>, maakt de mens tot een religieus wezen. Het wezen dat alle religies delen met elkaar is die onderlinge verbondenheid met het enige en zelfde mysterie van het Leven, opgewekt door het lichtende Licht.</p>\n</blockquote>\n<blockquote>\n<p><em>Religiositeit</em> is eigen aan de mens op aarde die baat in het licht dat hem omhult. Dat licht roept het kind op weg te gaan naar zijn oorsprong, naar de Bron van zijn bestaan. Daarbij vertrekt hij niet vanuit het niets. Hij vertrekt vanuit zijn thuis. Hij is niet alleen het mensenkind van de Lichtaard, maar ook van de cultuur, het tweede licht waarin hij leeft en beweegt.</p>\n</blockquote>\n<blockquote>\n<p>De openingsshot van <span style=\"color:blue\"><strong>Come and See</strong></span> brengt dat <em>cultuurhuis</em> in beeld. Naast de baby- en kinderfoto’s, de blijvende herinnering aan het mysterie van de geboorte als kind, het waarmerk dat iedere mens tekent, zijn er duidelijke sporen van de <em>katholieke geloofscultuur</em>: het beeldje van de engel, de grote prent van het Heilig Hart van Jezus, het open bijbelboek in het Spaans met de bladwijzer van de zalig verklaarde priester Edward Poppe, een rode roos en een rozenkrans met grote bollen, zijnde het katholieke gebedssnoer, vervolgens het beeldje van de Heilige Familie bij de levensboom, het glazen kistje met erin een volksmissaal of persoonlijk misboek, het beeld van Onze-Lieve-Vrouw met een rozenkrans in haar handen. Die tekens van de katholieke geloofscultuur begeleiden de kleine jongen. Ze vormen de achtergrond evenals de rugdekking van zijn tocht door de stad. Daarbij maakt de kaarshouder met de brandende kaars deel uit van de bewegende beeldmetafoor van het jongentje.</p>\n</blockquote>\n<blockquote>\n<p>Dat beeld definieert <em>de eigen narratieve lijn</em> van <span style=\"color:blue\"><strong>Come and See</strong></span>. Die bevindt zich tussen het begin ― zelf aansteken van de kaars in de woonkamer ― en het einde ― het uitdoven van de kaars in de kerk én de terugkeer van de vlam via het inwerkende Licht. De beeldende verhaallijn van <span style=\"color:blue\"><strong>Come and See</strong></span> ontwikkelt zich in de tocht naar het kerkgebouw waarbij het jongentje vervuld is van de zorg om de kaars brandend te houden. Zijn doel is om op de enige plaats waar dat kan, hulde te brengen aan het heilige mysterie van het goddelijke Licht in het kerkgebouw.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>CHRISTELIJKE TEKENS ONDERWEG.</strong></span> De tocht van het kind met de brandende kaars verloopt niet blind. Allereerst verlaat het jongentje het huis met een duidelijke boodschap die hij op de affiche ‘<em>kom en zie</em>’ leest alvorens op weg te gaan. Iets roept hem, nodigt hem uit te komen en te zien. Ook de katholieke cultuurtekens, de devotiebeelden, in het huis vormen een kompas dat hij in zijn hart en geest meeneemt. Maar ook onderweg leiden religieuze tekens uit diezelfde katholieke geloofstraditie zijn pad. Die bestaan uit dingen, dieren en mensen.</p>\n<blockquote>\n<p>Er zijn de <em>gebouwen</em> die getuigen van het katholiek verleden van de stad: kerktorens, de grote Onze-Lieve-Vrouwkathedraal. Er zijn de <em>kruisbeelden en kruistekens</em>: een groot kruisbeeld in de publieke ruimte, de straatnaam ‘Jezusstraat’ met vlakbij een kruisteken in neonlicht. In het historisch centrum staan <em>Mariabeelden</em> in nissen boven deuren of in uitsnijdingen van huizen op straathoeken.</p>\n</blockquote>\n<blockquote>\n<p>Naast de tekens van gebouwen en beelden in de stad, begeleiden ook <em>duiven</em> het kind. Wanneer hij het zebrapad in de drukke winkelstraat oversteekt, houdt hij even halt, kijkt achterom en ziet op het zebrapad een witte duif. Niemand anders dan het jongentje ziet ze. Hij kijkt toe en ziet hoe ze opvliegt, hemelwaarts. Er volgt een subjectief camerastandpunt. Genomen vanuit een kikvorsperspectief, monteert de regisseuse een inlas die toont hoe de witte duif zich in de lucht bevindt samen met nog twee andere duiven. In de christelijke iconografie staat de witte duif voor de <em>Heilige Geest</em>. In de katholieke traditie is de voorstelling van de duif ook verbonden met het sacrament van het <em>vormsel</em>. Het beeld van de drie duiven vliegend in de lucht verwijst tegelijkertijd ook naar het <em>mysterie van de Triniteit of Drievuldigheid</em> waarnaar ieder christen verwijst telkens wanneer hij het kruisteken maakt. Na het shot met de drie duiven volgt een shot van het glimlachende jongentje. In het park verwelkomen hem de duiven. Hij loopt op het pad langs het water. Op de afsluiting zit een duif. Wanneer hij voorbij de duif loopt, slaat ze haar vleugels open. Die scène is in slow motion gefilmd. Het gebeuren krijgt een accent. De duif met gespreide vleugels vormt een kruisteken. Het laatste shot in het park is eveneens in slow motion. Op zeker ogenblik komt hij op een plek waar zich veel duiven hebben verzameld. Bij zijn komst vliegen ze een voor een op in slow motion. Na die scène komt het jongentje aan de grote deur van de kerk. In de wat donkere hal verwelkomt hem een groot kruisbeeld. Dan stapt hij binnen in het licht van het kerkgebouw.</p>\n</blockquote>\n<blockquote>\n<p>Niet alleen de gebouwen, de beelden, de duiven begeleiden hem op zijn tocht naar het kerkgebouw. Er zijn ook <em>mensen</em>. Eerst is er <em>de pater</em>, de minderbroeder kapucijn. Hij verschijnt in beeld vanuit het blikveld van het jongentje. Die ziet ― in close-up ― vooral het kruisbeeld van de grote rozenkrans die hangt aan de witte koord van het habijt van de pater. Die legt zijn handen op het hoofd van de jongen. De ontmoeting met de pater gebeurt aan het begin van de tocht, net voor hij de eerder gesloten omgeving waar zich het huis bevindt, verlaat en de stad intrekt. Onmiddellijk daarna volgt de ontmoeting met <em>de dakloze man</em>. Het jongentje wil hem geld geven maar stelt vast dat hij geen geld bij zich heeft. Het kind maakt een gebaar van ‘het spijt me, ik heb niets bij’, de man glimlacht. Direct na die ontmoeting last de regisseuse een korte sequentie in waarin twee vliegtuigstrepen in de lucht een kruisteken tekenen. Het komt voor op het ogenblik dat de echte tocht doorheen de stad begint. Het vormt een wegwijzer in de lucht. Een erg belangrijk moment dat filmisch amper enkele seconden duurt, speelt zich af bij het opstappen op tram 11. <em>De bestuurder</em> roept het jongentje terug; hij heeft immers niet betaald. Op dat ogenblik stapt <em>een onbekende man</em> op die de buschauffeur een eurobiljet geeft zonder te wachten op de teruggave van het teveel betaalde bedrag. Uit de eindgeneriek blijkt dat die persoon Jezus heet.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>CRESCENDO VAN LICHT EN STILTE .</strong></span> <span style=\"color:blue\"><strong>Come and See</strong></span> beweegt zich als <em>spirituele road movi</em> naar een crescendo van licht toe. Dat crescendo ontwikkelt zich in een afwisseling van sequenties die de aarde en de hemel samenbrengen. Er is het shot van de voetstappen, de kasseien, de verharde bestrating van de winkelstraat, het zebrapad, het besneeuwde park, de vloer van het kerkgebouw. Die beelden tekenen het <em>element van de aarde, de woon- en werkplaats van de mens</em>. Andere beelden tonen vanuit een kikvorsperspectief dat samenvalt met de blik van het kind, de <em>hoge lucht met zijn aura van helder licht</em>. De weg van het kind krijgt inhoud zowel via zijn voeten (de aarde) als via zijn mentale blik (de hemel). Beide polen zijn geen tegengestelden. Ze scheppen een leefwereld waarin het jongentje zich schouwend beweegt. Het kind spreekt niet, hij concentreert zich op zijn kaars, maar absorbeert tevens schouwend de vele tekens en de personen die hem geruisloos begeleiden. En dat wordt in zijn geheel geregisseerd door ‘het licht van de Schepping’, <em>de Lichtaard</em>.</p>\n<blockquote>\n<p>Er is één <em>fade out naar een zwart beeld</em>. Dat gebeurt na de sequentie in het park. Het kind stapt op het pad met de vele duiven. Ze vliegen op. Dan volgt de fade out. Het zwarte beeld markeert het <em>einde van de tocht</em>. Het volgende beeld toont immers de aankomst van het kind aan de grote dubbele deur van het kerkgebouw. Dan bereikt de regie van de <em>Lichtaard</em> haar hoogtepunt in de slotsequenties aan het hoogaltaar in de kerk.</p>\n</blockquote>\n<blockquote>\n<p>Het uitgestalde heilige Sacrament verschijnt als een bron van helder, hemels licht dat opnieuw wenkt en uitnodigt naderbij te komen. De regisseuse laat hierover geen twijfel bestaan. Zij monteert een <em>inlas van de zon</em> en koppelt die aan de close-up van de ronde heilige Hostie. <em>Het crescendo van licht</em> eindigt immers met een inzoom op de Hostie tot die verschijnt in een zeer grote close-up die vloeiend overgaat in zuiver licht waarop de eucharistische woorden verschijnen.</p>\n</blockquote>\n<blockquote>\n<p>Voorts krijgt het crescendo nog een auditieve ondersteuning door <em>de filmmuziek</em>. De film kent slechts enkele natuurlijke geluiden: de wind, het openen van de kerkdeur. De filmbeelden zijn als het ware stom, maar worden begeleid door de <em>muziekscore van Xander Nichting</em>. De openingssequentie met de kast introduceert de piano die vanaf de inlas met de voetstappen wordt versterkt met de elektrische viool. Samen begeleiden ze de tocht van het jongentje. De <em>piano</em> vertegenwoordigt de klanken van de aarde, terwijl de <em>viool</em> die van de hemel oproept. Wanneer het jongentje aan de tweedelige deur van de kerk komt, zwijgt de muziek even. De <em>stilte</em> neemt het over. De zachte wind en het geluid van de opengaande kerkdeur markeren de aanwezigheid van een gewijde stilte. Dan ontstaat er een beweging van relatieve donkerte naar intens hemels licht. Het kind komt eerst aan in het voorportaal dat vrij donker is. Hij ziet er een kruisbeeld aan de muur hangen. Dan merkt hij de open deur naar de verlichte ruimte van de kerk. Wanneer hij de kerkruimte zelf betreedt, registreert een subjectief camerastandpunt de grote verwondering van het kind. Een bijna verblindende lichtbundel, begeleid door zachte, sferische muziek, verwelkomt hem. Hij bewondert de hoge hemelkoepel waarin zich glasruimten bevinden.</p>\n</blockquote>\n<blockquote>\n<p>Dan merkt het kind de monstrans op en begint ernaar toe te lopen. Dan weerklinken opnieuw de piano en de viool, nu in een uptempo. Op het ogenblik dat het kind merkt dat zijn kaars niet langer meer brandt, is er opnieuw een moment van volledige stilte. Geleidelijk wellen uit die stilte de <em>etherische klanken</em> op van bij het binnenkomen van de kerk. Ze klinken nu duidelijker en ze lijken afkomstig te zijn van een koor. Die sferische muziek begeleidt de filmische introductie van het heilig Sacrament in de monstrans op het hoogaltaar. In combinatie met de eraan vooraf gaande opwaartse gerichte shots van de kerkkoepel met zijn glasramen en het shot van het hoog invallende zonlicht met het grote opgehangen kruisbeeld in tegenlicht, zou het onzichtbare koor een engelenkoor kunnen zijn. Bij het shot van het jongentje die in het donker wat verloren kijkt naar zijn gedoofde kaars, is er volledige stilte. Wanneer er plots een helder licht valt op het gelaat van het kind en de kaars terug begint te branden, weerklinkt weer de <em>muziek van de tocht</em>, de piano en de viool. De camera neemt de blik van het kind over en zoomt in op de monstrans. Opnieuw een moment van gewijde stilte. Met de close-up van de bijna opgebrande kaars begint de allerlaatste beweging van de tocht van het jongentje. De muziek zet in en het jongentje gaat naar het hoogaltaar toe waar hij de kaarshouder met de brandende kaars neerzet. Tijdens die laatste stappen weerklinkt opnieuw het engelenkoor. In de slotsequentie ― het jongentje en de Hostie kijken elkaar aan, staan oog in oog bij elkaar ― speelt alleen de piano de laatste klanken.</p>\n</blockquote>\n<blockquote>\n<p>In de openingssequentie was het ook de piano die de beelden op de kast introduceerde. Nu blijkt dat die kast waarvan alleen het bovenblad met de voorwerpen in beeld komt, <em>een soort huisaltaar</em> is dat nu gelinkt wordt aan <em>het hoogaltaar</em> van de kerk. Op dat hoogaltaar staat nu de monstrans met het heilig Sacrament en de brandende kaarsen, ook die van het kind. De film eindigt met de verschijning van de eucharistische woorden op een lichtende achtergrond. Dat gebeurt in stilte, net zoals ook tijdens de eucharistie zelf de eucharistische woorden en de bijhorende liturgische gebaren met de Hostie en de Kelk zich in de gewijde stilte van de kerk voltrekken.</p>\n</blockquote>\n<p><a name=\"BET\"></a></p>\n<h2><font color=\"#808000\"><strong>Betekenisruimte</strong></font></h2>\n<p><span style=\"color:darkkhaki\"><strong>SCHAKERING.</strong></span> Selina De Mayer bespeelt in <span style=\"color:blue\"><strong>Come and See</strong></span> de vele mogelijkheden van het cinematografische register. Ze stelt die in het teken van de schakering. Daarvan getuigt al haar eerste keuze om het verhaal in zwart-wit in beeld te brengen. Ze wisselt wazige beelden af met scherpe. Ook de muziekscore kent een tweeledigheid, die van de piano en de viool, een toetseninstrument in een lagere en een snaarinstrument in een hogere klankorde.</p>\n<blockquote>\n<p><span style=\"color:blue\"><strong>Come and See</strong></span> werkt met <em>schakeringen</em>, niet met contrasten. De film komt niet voort uit een visie getekend door harde tegenstellingen. Het zwart en het wit behoren in <span style=\"color:blue\"><strong>Come and See</strong></span> niet tot een set van scherpe tegengestelden. Ze verschijnen als schakeringen van witheid, eigen aan het heldere zonlicht én de heilige Hostie. <span style=\"color:blue\"><strong>Come and See</strong></span> beschrijft een weg van een eerdere donkere naar een heldere schakering. De wisseling van het ene naar het andere mondt uit in het crescendo van het hemels licht dat het alles in zich opneemt. In die zin treden het zwart en het wit in <span style=\"color:blue\"><strong>Come and See</strong></span> op als kleurschakeringen van de helderheid, eigen aan het Licht.</p>\n</blockquote>\n<blockquote>\n<p>In diezelfde geest schildert de regisseuse het <em>onderscheid</em> tussen het huis en de stad, tussen de winkelstraat en het park, en tussen het park en het kerkgebouw. Selina De Maeyer schept haar verhaal geenszins vanuit de dualistische instelling. Ze laat niet toe dat de tegengestelde categorieën van goed versus slecht, kwaad versus goed haar regie overnemen. Dat blijkt heel duidelijk uit de sequenties die zich in de stad, met name in de tram en de winkelstraat situeren. Het jongentje bevindt zich in de tram met de andere tramreizigers en hij beweegt zich in de winkelstraat tussen de shoppers. Hij zondert zich niet af, hij vermijdt ze niet als de pest of als de wereld van de onreinen.</p>\n</blockquote>\n<blockquote>\n<p>Hij onderscheidt zich enkel door <em>zijn zorg voor de brandende kaars</em>. Hij blijft gefocust op de weg die hij bewandelt. Die loopt niet langs het pad van de shoppers. Evenmin lijkt de weg van het jongentje op die van de automobilist die naast de tram even stilstaat. De arm van de chauffeur hangt uit het open raam omdat de man een <em>sigaret</em> aan het roken is. Het vuur van de sigaret lijkt niet op dat van de <em>brandende kaars</em> in de tram</p>\n</blockquote>\n<blockquote>\n<p>Het jongentje dat als toeschouwer zijn weg gaat, neemt alles waar, ook het seculiere leven, eigen aan de stad. Juist in die stad gaat hij zijn <em>eigen weg</em>. Enige behoefte om de anderen te veroordelen of zelfs te bekeren, blijft hem vreemd. Hij neemt alles in zich op terwijl hij zich blijft concentreren op zijn brandende kaars.</p>\n</blockquote>\n<blockquote>\n<p>Langs zijn <em>spirituele pad</em> laat het jongentje een en ander links liggen. Dat geldt voor <em>het geld</em> en <em>de sigaret</em>. Van zijn eerste schreden af blijkt dat hij op zijn tocht geen geld bij zich heeft. De dakloze herkent in het kind zijnsgelijke. Wanneer het jongentje de tram opstapt, betaalt hij niet. Hij heeft immers geen geld bij zich. Zonder geld vindt men in de stad zijn weg niet. Daarvan getuigt de winkelstraat. Wat loopt iemand zonder geld daar immers te doen? De regisseuse blijft dicht bij het kind zonder geld of smartphone met GPS. Wat geld in de stad doet, verdicht zich in het beeld van de rokende chauffeur. Hij blijft onzichtbaar, alleen zijn arm en hand met een brandende sigaret zijn te zien. Het vuur van de sigaret is dat van de consumptie. Het eigen verbruik, het eigen genot primeert. Het vuur van de consumptie brandt het leven op in functie van het eigen narcisme. Dat is een reële mogelijkheid, het is een reële weg die mensen in de stad kunnen en willen gaan. Het is een van de redenen waaraan de stad haar reden van bestaan ontleent. Eén, maar niet de enige reden van bestaan. Eén weg, maar niet de enig mogelijke.</p>\n</blockquote>\n<blockquote>\n<p>Het jongentje en zijn weg getuigen van een andere levenshouding. Die licht op in <em>de tram</em>. In tegenstelling met de <em>auto</em> en de sigaret, instrumenten van het ego, vertegenwoordigt de <em>tram</em> de gemeenschap. De anonieme man betaalt de rit van het jongentje. In tegenstelling met de autorijder, heeft de trambestuurder wel een gezicht. Hij glimlacht. Op de tram bevindt zich ergens anoniem <em>Jezus</em>. Het kind ziet op de tram de staatnaam ‘Jezusstraat’ verschijnen, hangend naast een kruisteken in neon. In de stad waar het jongentje leeft, is de heersende consumptieve levenshouding, gestoeld op de daadkracht van het geld, geen dwangbuis. Daarvan levert de levenshouding van het kind het menselijke bewijs. Hij volgt <em>een roeping</em>, hij handelt en wandelt vanuit een spirituele levenshouding die haar motivatie haalt uit een religieuze beleving. Daarin overstijgt hij zijn ego. Zijn doel is de kaars brandend te houden om ze als een offer op te dragen aan het heilig Sacrament. Dat belichaamt het fundament van het christelijke geloofsmysterie, fysiek verdicht in de gewijde Hostie in de monstrans op het hoogaltaar.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>DE TRADITIE ALS WEGWIJZER.</strong></span> In de optiek van <span style=\"color:blue\"><strong>Come and See</strong></span> hoort de christelijke, meer bepaald de <em>katholieke geloofstraditie</em> tot de levende stad. Het kind vertrekt vanuit een bestaand woning nabij de Ossenmarkt, bewoond door een diepgelovige Spaanse vrouw die luistert naar de naam <em>Maria-Jezus</em>. De setting op de kast is niet geënsceneerd. Dat heeft Selina De Maeyer aan de auteur laten weten. De kast met de devotiebeelden en open geslagen Bijbel staat zo in de woonkamer van Maria-Jezus. Na de sequenties in het huisje, komt het kind eerst door het <em>Begijnhof</em>, een typische architectuur, specifiek voor het katholieke verleden van Vlaanderen. Dan zijn er ook de talrijke aanwezige kerkgebouwen en diverse kruisbeelden op publieke plaatsen.</p>\n<blockquote>\n<p>Voorts zijn nog de duidelijk herkenbare vertegenwoordigers van de katholieke kerk zelf, met in de film de <em>minderbroeders kapucijnen</em>, vroeger gekend onder de katholieke bevolking als ‘de bruine paters’, officieel de <em>Ordo Fratrum Minorum</em> waarvan de oorsprong teruggaat op de middeleeuwse heilige <em>Fransciscus van Assisi</em>. Het gekende <em>Zonnelied</em> van Franciscus bezingt de lof van de schepping. Hij spreekt er de zon aan met ‘broeder’ en de maan met ‘zuster’. ‘Broeder’ zonlicht speelt een hoofdrol in <span style=\"color:blue\"><strong>Come and See</strong></span>. Interessant detail om te weten, met als bron de regisseuse zelf, speelt een kapucijn de figuur van de dakloze bedelaar. De minderbroeders kapucijnen horen bij de middeleeuwse bedelorden, zij die hun voedsel bedelden en dus leefden zonder geld dat ze zelf genereerden. Zij herinnerden aan Jezus zelf die in de overleving van de Evangelies vaste woning noch inkomen bezat.</p>\n</blockquote>\n<blockquote>\n<p>De katholieke traditie komt in <span style=\"color:blue\"><strong>Come and See</strong></span> al in de eerste sequentie, het tracking shot in de woonkamer, in beeld via de <em>devotiebeeldjes</em> zoals die in de vele Vlaamse huiskamers een plaats hebben gekregen. Dat geldt in het bijzonder voor afbeeldingen van de <em>Heilige Familie</em>, Maria, Jozef en de kleine Jezus. Ook de aanwezigheid van de sterk verspreide devotie van <em>het Heilig Hart van Jezus</em> komt duidelijk in beeld. Het kind bereikt het doel van zijn tocht doorheen de stad in de <em>Heilig-Hartkerk</em>. In de periode die men aanduidt als ‘het rijke Roomse leven’ in Vlaanderen ― tweede helft van de negentiende eeuw tot aan het Tweede Vaticaans Concilie in  het begin van de jaren zestig van vorige eeuw ― waren de devotieprentjes met het <a href=\"https://nl.wikipedia.org/wiki/Heilig_Hartverering\">H. Hart van Jezus</a> overal verspreid.</p>\n</blockquote>\n<blockquote>\n<p>In die devotie werd in de parochies de eerste vrijdag van de maand toegewijd aan het <em>Heilig Hart van Jezus</em>, wat gepaard ging met de uitstalling in de monstrans van <em>het heilig Sacrament</em>. Die uitstalling speelt een hoofdrol in de ontknoping van <span style=\"color:blue\"><strong>Come and See</strong></span>. Daarnaast krijgt de devotionele eerbied voor het heilig Sacrament nog extra aandacht tijdens het <em>katholiek hoogfeest van het Heilig Bloed en Lichaam van Christus</em>, kortweg <em>Sacramentsdag</em> genoemd. Op de tweede donderdag na Pinksteren wordt de geconsacreerde Hostie in een monstrans ter aanbidding opgesteld op het hoofdaltaar. Voorheen ging op die dag ook de Sacramentsprocessie uit waarbij de monstrans door de straten van de parochie werd rondgedragen. Tot op heden is Sacramentsdag in sommige Europese landen, alsook in Brazilië,  met een sterk katholiek verleden nog steeds een officiële feestdag. In Vlaanderen en Nederland werd het feest van het heilig Sacrament verplaatst naar de tweede zondag na Pinksteren.</p>\n</blockquote>\n<blockquote>\n<p>Die gegevens uit de traditie verduidelijken hoe sterk <span style=\"color:blue\"><strong>Come and See</strong></span> verankerd zit in <em>die katholieke geloofstraditie</em> in Vlaanderen en het Zuiden van Nederland. De religieuze objecten, de monnik in habijt, het kerkgebouw met de monstrans, al deze ‘kerkschatten’ zijn <em>sporen van een religieuze, christelijk-katholieke</em> cultuur die vandaag nog duidelijk zichtbaar zijn in het heden van de seculiere stad. Die sporen werken als gidsen. Ze ondersteunen de tocht van het hoofdpersonage dat zijn ‘roeping’ volgt.</p>\n</blockquote>\n<blockquote>\n<p>In <span style=\"color:blue\"><strong>Come and See</strong></span> beleren de cultuursporen niet, ze dwingen niet; er is zelfs geen catecheseonderricht noch wordt er een preek gehouden.</p>\n</blockquote>\n<blockquote>\n<p>In de optiek van<span style=\"color:blue\"><strong>Come and See</strong></span> werkt de genoemde traditie vooral als een inspiratiebron, als een <em>bron van creativiteit</em>. Dat houdt in dat die traditie niet verschijnt als een onbeweeglijk massief gegeven of als een oud relict uit het verre verleden, alleen nog aanwezig in een of ander museum. De jonge kunstenares Selina De Maeyer gaat <em>creatief</em> om met die geloofstraditie die ze benadert als grondstof voor haar eigen origineel verhaal.</p>\n</blockquote>\n<blockquote>\n<p><span style=\"color:blue\"><strong>Come and See</strong></span> is een cinematografisch geloofsverhaal, een <em>filmisch credo</em>, vertolkt in een zuiver beeldende stijl. De geloofstraditie toont hier vooral haar <em>beeldend wezen</em>, van architectuur tot devotiebeelden. Die christelijk-katholieke traditie was eeuwenlang bijzonder schatplichtig aan een canon van woorden en strakke formuleringen.</p>\n</blockquote>\n<blockquote>\n<p><span style=\"color:blue\"><strong>Come and See</strong></span> relativeert die en voert ze vanuit de eigen kracht van de cinematografie, terug naar haar ware bron, het <em>levende licht van ‘de Schepping’</em>, het zonlicht dat energie, warmte en leven geeft aan alles op aarde, aan plant, dier en mens. Selina De Maeyer onderhoudt als kunstfotografe een diepe, zeg maar mystieke band met het hemelse licht, de <em>Lichtaard</em>. Zij doordrenkt de oude geloofstraditie met dat Licht.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>BEZIELD DOOR DE HEILIGE GEEST.</strong></span> Er is een subtiel auditief detail dat de intro van de religieuze roep kracht bijzet. Het hoort bij de titel <span style=\"color:blue\"><strong>Come and See</strong></span>, witte letters op een zwarte achtergrond, zwart en wit, de twee componenten van de film. Bij die titel hoort namelijk nog het geluid van de wind.</p>\n<blockquote>\n<p>In de christelijke traditie staat de wind voor de <em>werking van de Heilige Geest</em>. Die bezielt, zet in beweging, motiveert. Daarover vertellen de huissequenties. In de loop van de tocht van het kind doorheen de stad begeleiden de duiven hem op zijn tocht. Dat gebeurt op het einde van de passage in de winkelstraat bij het oversteken van het zebrapad, waar de inlas van de witte duif én die van de drie duiven, hoog in de lucht vliegend: beeld van de Triniteit. En op het einde van zijn tocht, het deel in het park, verwelkomen de opvliegende duiven de jongen, waarna hij het kerkgebouw betreedt. Tijdens zijn intrede in de kerk, het binnenkomen, is het stil op het geluid van de opengaande deur én dat van de wind na; met dat laatst opent ook de film. Bij de eerste sequenties aan en in het kerkgebouw, duidt de aanwezigheid van de wind de herkomst van de wind bij het beeld van de titel: die wind vindt zijn oorsprong in de religieuze kracht en de beweging, waarvan het kerkgebouw de stenen getuige is. De zacht voorbij waaiende wind, een duif die opvliegt, tastbaar beeld van <em>de Heilige Geest</em> die motiveert om de eucharistische weg van en naar Jezus te gaan.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>FILMISCHE CHRISTOLOGIE IN HET TEKEN VAN DE EUCHARISTIE.</strong></span> De beeldende intro, het tracking shot, met de devotievoorwerpen op de kast in de woonkamer, bevat de eucharistische sleutel tot de eigen betekeniswereld van de film. Het betreft het beeld van het Heilig Hart van Jezus en een historisch portret van de Vlaamse priester <em>Edward Poppe</em>, te zien op de bladwijzer op de open gevouwen Bijbel.</p>\n<blockquote>\n<p>De twee beelden zijn met elkaar verbonden, zoals blijkt uit een korte biografische schets van de bakkerszoon van Temse die leefde van 1890-1924. Hij werd in Gent op 1 mei 1916 priester gewijd. Hij leed een consequent ascetisch leven niettegenstaande zijn zwakke gezondheid. Zijn pastoraal werk als priester stelde hij consequent in dienst van de verspreiding van de eucharistische spiritualiteit. Dit was in overeenstemming met wat de katholieke kerk <em>de communiedecreten</em> van paus Pius X van 1910 is gaan noemen. Centraal daarin stond de nieuwe pastoraal gericht op de kinderen en het ontvangen van de heilige communie door hen. Het motto van die pastorale beweging was Jezus’ gezegde: ‘<em>Laat de kinderen tot mij komen</em>.’ (Mc. 10.14). Hierdoor ontstond in de katholieke kerk de pastoraal en catechetische werking rond de eerste communie, een gebruik dat ook na het <em>Tweede Vaticaans Concilie</em> (1962-1965) is blijven bestaan tot op de dag van vandaag. Priester Poppe nam het pauselijk communiebeleid zeer ter harte. In zijn priesterlijk engagement speelde het sacrament van de eucharistie de hoofdrol. Hij stimuleerde de volwassen gelovigen om veelvuldig het sacrament van de eucharistie te ontvangen. Zijn aandacht ging echter vooral uit naar de kinderen en de jongeren. In Vlaanderen begon voor hen <em>de beweging van de Eucharistische Kruistocht</em> in 1920. Dat gebeurde onder impuls van de norbertijnen van Averbode. In priester Edward Poppe vond de beweging vanaf 1922 haar meest vurige bezieler. Ze had als doel de kinderen te stimuleren om vanaf hun eerste communie iedere week minstens eenmaal de heilige communie te ontvangen. De leden droegen een speldje in de vorm van een wit kruis met een beeld van een kelk met een hostie erin verwerkt. Die beweging die nog tot diep in de jaren vijftig van vorige eeuw erg verspreid was, kwam voor in alle Vlaamse parochies. Er is nog een biografisch gegeven dat niet onbelangrijk is voor de film. De overlevering over priester Poppe bewaart namelijk de herinnering aan zijn sterfbed. Hij stierf terwijl hij keek naar een devotiebeeldje van het H. Hart van Jezus. Op 3 oktober 1999 is hij zalig verklaard door paus Johannes-Paulus II.</p>\n</blockquote>\n<blockquote>\n<p>De kortfilm <span style=\"color:blue\"><strong>Come and See</strong></span> herbront <em>de eucharistische spiritualiteit van de zalige priester Poppe</em>. Selina De Maeyer toont er de blijvende actualiteit van door als hoofdfiguur een anoniem jongentje, een kind, te nemen. Wanneer de kortfilm in het tegenlicht van de figuur van Edward Poppe wordt gehouden, kan die zelfs worden gezien als een vrije bewerking van de roeping van de kleine Edward Poppe.</p>\n</blockquote>\n<blockquote>\n<p>Door echter het scenario in het heden te situeren, kan het jongentje voor ieder kind staan dat zich aangesproken weet door het <em>geloofsmysterie van de eucharistie</em>, al dan niet tijdens de voorbereiding op het ontvangen van de eerste communie. Het doel van de tocht van het kind doorheen de stad is de kerk van het H. Hart en de uitgestalde heilige Hostie in de monstrans op het hoogaltaar.</p>\n</blockquote>\n<blockquote>\n<p>In de traditie hoort het spreken over de eucharistie thuis in de <em>sacramentologie</em>, de leer over de zeven sacramenten (doopsel, eucharistie, vormsel, huwelijk, ziekenzalving, biecht en priesterwijding). Met zijn twee invloedrijke studies  ― <em>De sacramentele heilseconomie</em> (1952) en <em>Christus, sacrament van Godsontmoeting</em> (1959) ― effende de Vlaamse theoloog <a href=\"https://www.lucepedia.nl/dossieritem/schillebeeckx-edward/introductie-edward-schillebeeckx\">Edward Schillebeeckx</a> het pad voor de liturgievernieuwing die tijdens het reeds vermelde <em>Tweede Vaticaans Concilie</em> tot stand kwam. Zelf beschouwde Schillebeeckx zijn studies als een reactie tegen wat hij ‘<em>de verzakelijking van de sacramenten</em>’ noemde. Dat slaat op het gebruik van de sacramenten als een ritueel automatisme zonder enige spirituele beleving. In positieve zin voerde Schillebeeckx de visie en de praktijk van de sacramenten terug op de bron van alle sacramenten, de eucharistie en die vindt haar bron in het evangelische verhaal van Jezus zelf. De eucharistie ― het verhaal van het laatste avondmaal, de instelling van de eucharistie met het woorden ‘<em>Dit is mijn Lichaam, Dit is mijn Bloed</em> ― is het fundament van het christelijk leven en de bijhorende christologie.</p>\n</blockquote>\n<blockquote>\n<p><span style=\"color:blue\"><strong>Come and See</strong></span> voltrekt op een <em>eigen, originele manier die christologisch terugkeer naar de eucharistie</em>, niet zozeer als een sacrament op zich, maar als de grondslag van alle kerkelijke sacramenten.</p>\n</blockquote>\n<blockquote>\n<p>In <span style=\"color:blue\"><strong>Come and See</strong></span> komen er geen sacramentele handelingen voor. Het crescendo bestaat wel uit een verering, ja een aanbidding van het heilig Sacrament zelf, waaraan de eucharistische woorden zijn verbonden. En die worden bezegeld door het christologische ‘<em>Ik ben het licht van de wereld</em>’ (Johannes 8.12). In ‘dat Licht’ onthullen verschillende filmische elementen hun rijke betekenis. Die staat helemaal in het teken van Christus, fundament van het credo van alle christelijke kerken.</p>\n</blockquote>\n<blockquote>\n<p>De beeldende visie op Christus, de christologie, in <span style=\"color:blue\"><strong>Come and See</strong></span> staat helemaal in het teken van <em>Jezus’ leven en werk</em>. De keuze voor het kind verwijst naar het reeds aangehaalde Jezuswoord: ‘<em>Laat de kinderen tot mij komen</em>’ (Mc. 10.14). De openingssequentie herinnert aan de Heilige Familie en aan de moeder van Jezus, Maria, vereerd als Onze-Lieve-Vrouw en aan wie de grote kathedraal van Antwerpen is toegewijd. In de stad tonen verschillende kruisbeelden het kind de weg. Ze verwijzen naar de Passie van Jezus in Jeruzalem en het Romeinse kruis waaraan hij is gestorven. Ook het kerkgebouw zelf herbergt niet alleen twee grote kruisbeelden; het grondplan ervan zelf verwijst naar een uitvergroot Romeins kruis, liggend op de grond. Een ander Jezus-element betreft de devotieprent van het H. Hart van Jezus en het kerkgebouw van de Heilig-Hartparochie, ook al wordt de naam ervan in de film niet expliciet genoemd. In de hoge koepel van de kerk bevindt zich, zo blijkt uit de film, een grote muurschildering van het <em>Lam Gods</em>, centrale figuur op het meest gekende, gelijknamige schilderij van Jan van Eyck. Het gelijknamige, christelijke gebed ― het <em>Agnus Dei</em> (Lam Gods)― maakt deel uit van de eucharistieviering. De priester spreekt het gebed uit op het moment dat hij de heilige Hostie breekt en een stukje ervan in de kelk met het heilige Bloed legt.</p>\n</blockquote>\n<blockquote>\n<p>De <em>beeldende christologie</em> van <span style=\"color:blue\"><strong>Come and See</strong></span> bestaat ook uit het kruis getekend in de hoge lucht door twee vliegtuigen. Voorts is er de Jezusstraat, en bovenal er is de Jezusfiguur zelf die op de tram stapt en het kind zijn rit betaalt. Het personage verschijnt enkel op zijn rug, en dan nog maar gedeeltelijk. Het is geen toeval dat het om <em>tram 11</em> gaat. Een schijnbaar onbelangrijk detail. Maar het Jezuspersonage stapt wel op de tram samen met het jongentje. Van de twaalf apostelen die door Jezus waren geroepen om met hem mee te gaan om zijn goede boodschap uit te dragen, was er één afvallige bij, Judas. Eigenlijk waren ze maar elf ware apostelen. Vandaag, op de tram in de stad van nu, vertegenwoordigt het kind de twaalfde apostel, iedere mogelijke twaalfde apostel. De bijna onzichtbare aanwezigheid van Jezus bezegelt dat.</p>\n</blockquote>\n<blockquote>\n<p>Hier verschijnt de kern zelf van de cinematografische christologie. Het <em>Jezusverhaal</em>, voor altijd geconsacreerd in het uitgestalde heilige Sacrament, voltrekt zich nog steeds daar waar concrete mensen leven, en proberen, met vallen en opstaan, mens te worden. Dat dit geen evidentie is, bewijst de seculiere stad.</p>\n</blockquote>\n<blockquote>\n<p>Het jongentje met de brandende kaars in de stad herinnert trouwens aan de Griekse overlevering. Die bewaart de herinnering aan <em>Diogenes van Sinope</em>. Deze filosoof die eerder op een dakloze dan op een geleerde leek, wandelde op klaarlichte dag met een brandende lantaarn in de hand over de agora op zoek naar een echte mens. De agora liep vol mensen, maar Diogenes vond dat hij heel hard moest zoeken om onder al die passanten ‘een mens’ te vinden. In <span style=\"color:blue\"><strong>Come and See</strong></span> betekent de wandelende beeldmetafoor van het kind met zijn brandende kaars overdag in de stad niet zozeer dat hij op zoek is naar een echte mens an sich. Hij is veeleer onderweg naar de bron van menselijkheid, present in de heilige Hostie, mysterievolle beeldende belichaming van Jezus Christus zelf. Hij vormt het ware licht onder de mensen, hij brengt de menselijkheid van de mens aan het licht, gisteren, vandaag en morgen.</p>\n</blockquote>\n<blockquote>\n<p>Denkers zoals de theoloog <em>Schillebeeckx</em> en de christelijke filosoof <em>Paul Ricœur</em> hebben in de tweede helft van vorige eeuw onderlijnd dat het christelijk credo <em>narratief, verhalend</em>, is en blijft. Selina De Maeyer laat zien dat dit doorwerkend christologisch Jezusverhaal vandaag meer dan ooit het geval is geweest, in de volle zin een beeldverhaal is en als beeldverhaal een verhaal van Licht is.</p>\n</blockquote>\n<p><a name=\"CON\"></a></p>\n<h2><font color=\"#808000\"><strong>Context</strong></font></h2>\n<p>De kortfilm <span style=\"color:blue\"><strong>Come and See</strong></span> is dankzij zijn cinematografische kwaliteit zeer geschikt voor alle leerkrachten in het godsdienstonderwijs, die via het beeldend denken met kinderen van het basisonderwijs en van de eerste graad secundair onderwijs willen werken rond het katholiek credo en het basissacrament van de eucharistie. Het filmpje is een godsgeschenk voor de eerstecommuniecatechese. Tegelijkertijd kan de kortfilm een hedendaags gesprek tussen jongeren en volwassenen over de aanwezigheid van het katholieke geloof in onze cultuur vandaag introduceren en begeleiden.</p>\n<p><a name=\"LIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Links</strong></font></h2>\n<p><a href=\"http://www.selinademaeyer.com\">De website van Selina De Mayer</a>.</p>\n<p>Er staan diverse filmpjes met Selina De Mayer op youtube o.a. <a href=\"https://www.youtube.com/watch?v=t5UvjxdzCMc\">Interview met haar in Terzake</a>.</p>\n<p>De dvd van <span style=\"color:blue\"><strong>Come and See</strong></span> is te bestellen bij <a href=\"https://www.betsaida.org/?p=dvd&amp;id=320&amp;t=Come+and+See\">Uitgeverij Betsaida</a>.</p>\n<p><font size=\"-2\"> © Sylvain De Bleeckere, Men(S)tis, 2018.</font></p>\n"}

/***/ }),
/* 993 */
/***/ (function(module, exports) {

	module.exports = {"title":"Father Damien","body":"<center>\n<img src=\"priesterkleed.jpg\" >\n</center>\n<a name=\"KLA\"></a>\n<h2><font color=\"#808000\"><strong>Klapbord</strong></font></h2>\n<p><span style=\"color:blue\"><strong>Father Damien</strong></span>\nis de titel van _het historische filmeposis hoofdzakelijk <em>een Vlaamse productie</em>. In Vlaanderen is de film uitgebracht onder de titel <em>Damiaan</em>, terwijl de internationale titel <em>Molokai: The Story of Father Damien</em> is. Die wordt gewoonlijk verkort tot <em>Father Damien</em>.</p>\n<blockquote>\n<p>Na haar wereldpremière op woensdag 10 maart 1999 (Antwerpen) oogstte de film van regisseur <em>Paul Cox</em> bij de filmpers een onbarmhartige kritiek. De toeschouwers reageerden echter positief op de film. Die is en blijft <em>de belangrijkste film over de historische figuur van pater Damiaan</em>.</p>\n</blockquote>\n<blockquote>\n<p>De toeschouwer kijkt geboeid naar de film over de merkwaardige geschiedenis die zo onvoorstelbaar is dat geen menselijke verbeelding ze zou kunnen bedenken. De grote episode van <em>Damiaans leven en sterven op Molokai</em> komt helder in beeld, mede dank zij het scenario van Briley dat gebaseerd is op het historisch onderzoek dat de Vlaamse historica <em>Hilde Eynikel</em> heeft gepubliceerd onder de titel <em>Damiaan. De definitieve biografie</em> (1999).</p>\n</blockquote>\n<p><a name=\"SYN\"></a></p>\n<h2><font color=\"#808000\"><strong>Synopsis</strong></font></h2>\n<p>Na een korte introductie in Honolulu waar <em>de jonge Vlaamse pater Damiaan</em> zich als vrijwilliger opgeeft om als priester naar <em>het lepra-eiland Molokai</em> te vertrekken, evoceert de film het verblijf van Damiaan op Molokai. Het verhaal begint met zijn aankomst tot aan zijn dood als melaatse priester. De film schenkt vooral aandacht aan <em>het spiritueel portret van pater Damiaan</em>, zijn innerlijke strijd, en aan het menselijk portret dat het engagement van pater Damiaan toont voor de menswaardigheid van de leprazieken die op het eiland zijn gedumpt. Daarbij komen enkele belangrijke, historische nevenpersonages in beeld.</p>\n<blockquote>\n<p>Er is vooral <em>Rudolph Meyer</em>, de Duitse ingenieur die met zijn gezin aan de bovenkant van de pali woont, en het algemeen toezicht houdt op de leprozerie. Hij wordt een bondgenoot van Damiaan.</p>\n</blockquote>\n<blockquote>\n<p>Daarnaast is er <em>William Williamson</em>, verpleger, patiënt, Brit en protestant. De man is besmet geraakt tijdens zijn werk als verpleger in Honolulu en, ook verbannen naar Molokai, wacht hij nu op de spoedige komst van de dood.</p>\n</blockquote>\n<blockquote>\n<p>De jonge dokter <em>Nathaniel Emerson</em> komt Damiaan helpen, maar hij houdt de alomtegenwoordige ellende niet uit en vertrekt.</p>\n</blockquote>\n<blockquote>\n<p>Andere tijdelijke bezoekers geven de jonge priester moed, vooral omdat ze zijn werk bewonderen en het ook materieel en/of medisch ondersteunen. Een echte riem onder het hart is het bezoek van <em>princes Liliuokalani</em>.</p>\n</blockquote>\n<blockquote>\n<p>Wanneer hij al melaats is geworden, krijgt pater Damiaan assistentie van broeder <em>Joseph Ira Dutton</em> en blijvende hulp van de Belgische priester <em>Louis-Lambert Conrady</em>. In 1888 krijgt de melaatse Damiaan ook bezoek van <em>Edward Clifford</em>, Britse schilder en schrijver die een portret schildert van hem. Op het einde komen enkele zusters onder leiding van <em>Ann Cope</em>, zuster Marianne, de stervende zieke priester helpen en bijstaan.</p>\n</blockquote>\n<p><a name=\"CIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Cinematografie</strong></font></h2>\n<p><span style=\"color:darkkhaki\"><strong>CONFLICT TUSSEN LYRIEK EN EPIEK.</strong></span> De toeschouwer ervaart dat de film lijdt onder <em>het esthetische conflict</em> tussen de filmdichter Paul Cox die zijn trouw aan de historische waarheid op een <em>poëtische</em> wijze wil vertolken en de eisen van de productie die de opdracht gaf voor een <em>epische</em> film, bestemd voor een groot publiek.</p>\n<blockquote>\n<p>De eisen van de epiek vragen voortgang, strak ritme, spanning. Het is duidelijk dat Cox soms meer <em>filmische tijd</em> zou willen voor het beeld zelf. Dat is het geval bijvoorbeeld bij <em>de openingsscène</em> waarmee hij de personage van Damiaan en de lepra via het meisje Maulani introduceert. Oorspronkelijk opgenomen via een prachtig gecomponeerde pan, is het beeldend elan van die introductie op de montagetafel tot een minimum gereduceerd en is de epische kern – de achtervolging – maximaal op de voorgrond gebracht.</p>\n</blockquote>\n<blockquote>\n<p>In dezelfde geest worden enkele cruciale scènes te abrupt afgebroken. De toeschouwer leeft zich in de dramatische situaties in – vooral de scène van de overboord gegooide melaatsen, de biechtscéne – maar de montage dwingt hem direct over te schakelen naar een volgend tafereel.</p>\n</blockquote>\n<blockquote>\n<p>Het is duidelijk dat Cox tal van sequenties heeft willen laten uitmonden in <em>een lyrisch-poëtisch en bezinnend moment</em>. De eisen van de <em>epiek</em> halen het daarbij af en toe van de <em>lyriek</em>. Maar die plaatsen waar de strijd duidelijk zichtbaar is en waar het dictaat van de epiek bij de montage het verlangen van de lyriek, het beeld, afremt, zijn uitzonderingen, geen algemene regel. In de versie van  Cox zelf, de ‘director’s cut’ genoemd, is dat conflict tussen epiek en lyriek in het voordeel van de lyriek beslecht.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>KLANKBAND.</strong></span> Een van de sterkste en tevens unieke cinematografische kwaliteiten van <span style=\"color:blue\"><strong>Father Damien</strong></span> is de klankband. Die vormt een unieke compositie met de originele filmmuziek van de Belgische componist <em>Wim Mertens</em> en de natuurlijke geluiden van <em>de wind op het eiland Molokai</em> zelf.</p>\n<blockquote>\n<p>Het is de grote verdienste van de productie dat de opnames zijn kunnen gebeuren op Molokai zelf. <em>As Music in the Trees</em> is de titel van een nummer van Wim Mertens. De titel verwijst naar een scène van Damiaan met een blinde leprajongen. Wanneer de priester de jongen vraagt waarom hij niet slaapt, bekent de jongen bang te zijn van de wind. Damiaan stelt hem gerust:<em>‘Denk aan de wind als muziek in de bomen’</em>. De angst om de wind bij de jongen is geen inbeelding. In feite deelt Damiaan dezelfde angst. Alle leprabewoners kennen dat gevoel. Het hoort bij de plek. De wind regeert immers als heer en meester over Kalaupapa, het schiereiland van Molokai.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>PANORAMISCH BEELD.</strong></span> De cinematografie van <span style=\"color:blue\"><strong>Father Damien</strong></span> is gekenmerkt door <em>het poëtisch gebruik van het panoramische beeld</em>. Via de pano laat Cox de spirit van de plek, <em>de genius loci</em>, het beeld mee componeren.</p>\n<blockquote>\n<p>Die genius loci is hier audiovisueel: zichtbaar verschijnt de geest van de plek in het landschap van de oceaan, het schiereiland en het gebergte, de pali, en hoorbaar laat die geest zijn stem weerklinken met <em>de kracht van de wind</em>. Daar waar het kan en zinvol is, laat Cox op de klank- en beeldband ofwel via korte inlassen ofwel midden in de scène zelf, de wind mee het portret van Damiaan regisseren.</p>\n</blockquote>\n<blockquote>\n<p>Het gebruik van een super 35mm camera bevordert de filmpoëtische werking van de panoramische beelden. Cox ent het verhaal op de geografische realiteit van de wind en geeft daardoor aan het filmportret van Damiaan een poëtische dimensie. De wind groeit zo uit tot een <em>metaforisch</em> element dat geleidelijk de waarde krijgt van de hoeksteen van de betekenisruimte van de film.</p>\n</blockquote>\n<p><a name=\"BET\"></a></p>\n<h2><font color=\"#808000\"><strong>Betekenisruimte</strong></font></h2>\n<p><span style=\"color:darkkhaki\"><strong>IN HET TEKEN VAN HET KRUIS.</strong></span> Midden in de betekenisruimte van de film staat <em>het christelijke kruis</em>.</p>\n<blockquote>\n<p>Damiaan maakt verschillende keren <em>het kruisteken</em>: om te bidden nadat hij als eerste vrijwilliger aangeduid is om als priester van de melaatsen naar Molokai te gaan, om zijn eerste mis te beginnen op Molokai, voorts ook als opening van zijn preek over het gemis en het gevoel een outcast te zijn, of wanneer hij een biecht begint te horen; het gebeurt eveneens in zijn kerk wanneer hij er gaat bidden nadat Emerson hem duidelijk heeft gemaakt dat hij melaats geworden is.</p>\n</blockquote>\n<blockquote>\n<p>Naast het kruisteken, is er <em>het kruisbeeld</em>. Damiaan vindt een groot kruisbeeld in het vervallen kerkje van Molokai. Het beeld van <em>de Gekruisigde Jezus</em> lijkt voor Damiaan een trouwe gezel te zijn. Het beeld lijkt hem zelfs te verwachten en te verwelkomen. Wanneer hij bewust is dat hij melaats geworden is, gaat hij de Gekruisigde danken voor de verschillende jaren die hij gezond is gebleven en heeft kunnen werken. Maar het beeld van de Gekruisigde spreekt ook van lijden en dood. De lepra is het gezicht van het lijden en de dood op Molokai. Het gewicht van die destructieve werkelijkheid weegt zwaar op Damiaans schouders en ook dat maakt deel uit van zijn diep eenzaamheidsgevoel. Hij die iedereen helpt, is zelf verstoken van iedere geestelijke bijstand. Vandaar Damiaans voortdurende nood om te biechten.</p>\n</blockquote>\n<blockquote>\n<p>De opvallende aanwezigheid van het kruisbeeld in talrijke Molokai-sequenties geeft <em>een religieuze, christelijke duiding</em> aan het werk van Damiaan. Het kruisbeeld spiegelt er niet alleen het lijden van de zieken, het spreekt ook nog een andere taal. Damiaan is daar de tolk van.</p>\n</blockquote>\n<blockquote>\n<p>In zijn eerste preek op Molokai thematiseert hij niet alleen <em>het Kruis van Jezus</em>, hij verwijst er ook letterlijk naar. Na het maken van het kruisteken, introduceert hij de letterlijke verwijzing naar het kruisbeeld in zijn kerk als volgt:</p>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><em>‘I do not have the disease that has sent you tot Molokai, but I want you to remind that all men know loneliness, all men know isolation and despair. And all men are afflicted in their hearts or in their bodies by sores and wounds that make them outcasts. Outcasts to all but Him…’</em></p>\n</blockquote>\n</blockquote>\n<blockquote>\n<p>Bij het woord <em>‘Him’</em> draait Damiaan zich even om en wijst naar het beeld van de Gekruisigde. Welnu, in de scène die zich afspeelt in de werkkamer van de bisschop, blijkt er ook een kruisbeeld aan de muur te hangen. Cox filmt de scène zo dat de drie vertegenwoordigers van de macht met hun rug naar het kruisbeeld staan gekeerd. Zij keren zich niet om naar het kruisbeeld.</p>\n</blockquote>\n<blockquote>\n<p>Cox vervolgt <em>de beeldspraak van het kruis</em> tot in de sterfscène. Ook hier werkt hij beeldend, met name via het spel van  licht en donker in de vorm van licht en schaduw. In de scène vraagt zuster Marianne aan Damiaan om vergeving omdat zij, de zusters, zo lang hebben gewacht om naar Molokai zelf te komen. Ze vraagt hem zijn zegen. Een laatste keer maakt Damiaan het zegenende gebaar van het kruisteken. Cox filmt het gebeuren zo dat de schaduw van de zegende hand van Damiaan wordt geprojecteerd op de muur van de kamer. Die schaduw valt juist aan de voet van het kruisbeeld dat aan de muur hangt.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>IN HET TEKEN VAN DE WIND.</strong></span> Wanneer Damiaan Little Bishop troost door de boze wind van Kalaupapa voor te stellen als muziek, dan gebruikt hij <em>een beeldspraak waarin de wind een nieuwe en helende dimensie</em> krijgt.</p>\n<blockquote>\n<p>Tegenover de wind van Molokai plaatst Damiaan een andere wind, of beter: hij buigt die wind zoveel als hij kan om in een andere richting. Het windscherm dat hij bouwt, is daarvan een voorbeeld. In die scène stelt Cox Damiaan zelf voor als een krachtige wind. Dit raakt de kern van het beeldend denken dat Cox in <span style=\"color:blue\"><strong>Father Damien</strong></span> uitwerkt.</p>\n</blockquote>\n<blockquote>\n<p>De wind als beeldspraak die iets belangrijks onthult over de <em>betekenis van de figuur van Damiaan</em>. Geen oceaanwind, geen leprawind, maar <em>de wind als helende kracht</em>. De komst van Damiaan naar Molokai doet inderdaad in menig opzicht <em>een windscherm van helende humaniteit</em> ontstaan. Hij schudt het stof dat de oceaanwind in de hut van William heeft geblazen, letterlijk uit de hut. In die scène gaat Damiaan met zijn rug naar de wind zijn. Ook al lijkt het hopeloos, hij wil een windscherm zijn voor de oceaan-en leprawind.</p>\n</blockquote>\n<blockquote>\n<p>In Cox’ filmische tekening van Damiaan krijgt de wind de betekenis van <em>opbouwende levensadem</em>. Damiaans aanwezigheid geeft adem aan de in wanhoop levende lepraleiders. Hij kan de ziekte niet genezen, maar hij brengt terug humaniteit in de aardse hel van Molokai. Zijn aandacht voor de kinderen, zijn verzet tegen alcoholisme en gedwongen prostitutie, Maulani die zich aan hem spiegelt en de kracht vindt om in een mooie scène neen te zeggen tegen ‘het goede leven’ van alcohol en goedkope seks.</p>\n</blockquote>\n<blockquote>\n<p>Damiaans aanwezigheid, zijn werk, geeft aan de hel van ‘het goede leven’ een andere windrichting. Zijn waken bij de stervenden in de dodenhut, deze en andere handelingen laten een weldoende wind van humaniteit waaien in de harten van de verweesde zieken. Wanneer de melaatse missionaris sterft, moet hij inderdaad buigen voor de leprawind. Maar tegelijkertijd geeft hij op Molokai een hele, andere wind gebracht. <em>Een wind die muziek maakt in de bomen</em>. Letterlijk: William sterft terwijl hij hoort hoe het melaatsenkoor van Damiaan <em>het Miserere</em> instudeert.</p>\n</blockquote>\n<blockquote>\n<p>Muziek is wind, geluid, de adem van klanken. Muziek, dat zijn voor Little Bishop en al de andere melaatsen de woorden van Damiaan. Al die vormen van muziek krijgen een filmische ondersteuning door de eigenlijke filmmuziek, ingetogen, droevig, maar ook bezield.‘De muziek in de bomen’ is <em>de Heilige Geest, de helende geest, de goddelijke en bezielende Levensadem</em> die door de eenvoudige Damiaan over Molokai is komen waaien. Dat is niet ongezien gebleven.</p>\n</blockquote>\n<blockquote>\n<p>Zijn getuigenis is uitgegroeid tot een begenadigd moment in de humane en religieuze geschiedenis van de moderne mensheid, waarvan Cox’ film niet alleen vertellend en episch, maar ook beeldend en poëtisch de herinnering doorgeeft.</p>\n</blockquote>\n<p><a name=\"CON\"></a></p>\n<h2><font color=\"#808000\"><strong>Context</strong></font></h2>\n<p>De opdrachtfilm <span style=\"color:blue\"><strong>Father Damien</strong></span> van Cox is <em>een blijvend waardig en authentiek portret</em> dat aan deze Vlaamse zoon van christelijke goedheid alle recht doet. Door de film kan pater Damiaan <em>een blijvende inspiratiebron</em> zijn voor de  komende generaties. De film helpt begrijpen waarom pater Damiaan in 2005 tijdens een selectieprogramma van de VRT werd gekozen tot <em>‘de grootste Belg’</em>. Door de katholieke Kerk werd hij met name door paus Johannes-Paulus II op 4 juni 1995 <em>zalig</em> verklaard. Op 11 oktober 2009 verklaarde  paus Benedictus XVI te Rome pater Damiaan <em>heilig</em>.</p>\n<p><a name=\"LIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Links</strong></font></h2>\n<p>In 1999 schreef Sylvain De Bleeckere het filmdossier <em>Damiaan. Gevoelig episch en karaktervol filmportret.</em> In 2009 heeft hij dit herwerkt. Het uitgebreide dossier is <a href=\"http://www.menstis.be/blog/\">hier</a> te downloaden.</p>\n<p><font size=\"-2\">© Sylvain De Bleeckere, Men(S)tis, 2011/2017</font></p>\n"}

/***/ }),
/* 994 */
/***/ (function(module, exports) {

	module.exports = {"title":"Darkest Hour","body":"<center>\n<img src=\"Darkest.jpg\" >\n</center>\n<p><a name=\"Darkest Hour\"></a></p>\n<h2><font color=\"#808000\"><strong>Klapbord</strong></font></h2>\n<p>De historische, Britse Oscarfilm van Joe Wright zoomt in op een weinig gekend historisch moment in het verhaal van de Tweede Wereldoorlog. Nochtans blijven die gebeurtenissen tot op heden het landschap van de huidige Europese Unie uittekenen. De Britse politicus Winston Churchill met zijn uitzonderlijk belangrijk politiek inzicht, zijn buitengewone moed en zijn unieke verantwoordelijkheidszin vormt de spilfiguur van die historische korte periode. In de meimaand van 1940 bevond zich aan de donkere kant van het machtsspectrum Hitler en zijn oorlogsregime, met wie de leiding gevende Engelse politici een deal wilden sluiten, aan de lichtzijde ervan stond de pas benoemde premier Winston Churchill helemaal alleen. Het beklijvende en immer actuele filmportret is sterk gebaseerd op nauwkeurig historisch onderzoek van al het schriftelijke, auditieve en beeldende archiefmateriaal. Het scenario is het werk van talentrijke Anthony McCarten, Britse auteur en producer. Hij kreeg de directe medewerking van de Churchill-familie en van de Churchill Archives. Hij verwerkte zijn scenario nog in een historisch boek met de gelijknamige titel: <strong>Darkest Hour</strong> (2017). De Britse film zelf kreeg internationale weerklank: zes Oscarnominaties, waarvan drie gewonnen Oscars, waaronder die voor de beste acteur in ‘leading role’ (hoofdrol) voor Gary Oldman, en die voor de beste film van het jaar. Gary Oldman won nog de Golden Globe en de Bafta (Britse Oscars) voor beste acteur, één van de zeven Baftanominaties, waaronder ook die voor beste film. De film werd volledig opgenomen in Engeland, onder andere in Chartwell House in Kent, van 1924 tot 1964 het geliefde landhuis van inston Churchill en zijn vrouw Clementine. Het is nu een museum gewijd aan het leven en werk van Winston Churchill, beheerd door de National Trust. Er is eveneens gefilmd in en nabij Westminster, Londen. Het parlement, the House of Commons, dat werd gebruikt voor de film is een replica van het Britse parlement van de jaren veertig van vorige eeuw.</p>\n<p><a name=\"SYN\"></a></p>\n<h2><font color=\"#808000\"><strong>Synopsis</strong></font></h2>\n<p>Op 3 september 1939 verklaarden Engeland en Frankrijk de oorlog aan nazi-Duitsland nadat het met zijn infanterie, tanks en vliegtuigen op 1 september brutaal Polen was binnengevallen. In Downing Street 10 en in het Palace of Westminster, de zetel van de twee Britse parlementen (Houses of Parlement) heerste er paniek. De regering van de Britse premier Neville Chamberlain verkeerde in een permanente staat van crisis. Op 10 mei 1940 zette Duitsland zijn militaire agressie verder. Het lanceerde zijn Blitzkrieg in de neutrale landen België, Luxemburg, Nederland. Het doel: zo snel mogelijk de kusten bereiken, Frankrijk bezetten om dan snel Engeland aan te vallen. Op diezelfde 10de mei moest Chamberlain, tegen zijn zin, aftreden. Terwijl Hitlers Wehrmacht vanuit het epicentrum Berlijn over het Europese vasteland een nooit geziene politieke en militaire tsunami op gang bracht, bereikte in de meidagen van 1940 de politieke crisis in Londen haar absoluut dieptepunt. Wie moest de regering en het land met zijn bevolking doorheen die nooit geziene storm leiden? Wie kon en wilde een regering vormen die het land kon besturen nu een Duitse invasie van Engeland erg reëel begon te worden?  Het land moest op zoek gaan naar een politicus die Groot-Brittannië en ook de rest van Europa kon loodsen doorheen de grootste politieke, morele en militaire beproeving waarmee Engeland en Europa ooit werden geconfronteerd. De film Darkest Hour brengt de collectieve herinnering in beeld hoe Winston Churchill op 10 mei 1940 die gezochte politieke leider werd. Hij bleek de enig democratisch verkozen Britse en tevens Europese politicus te zijn die in staat bleek op te staan tegen de dictator Hitler en diens naziregime. Dat gebeurde in de beslissende weken van mei 1940, toen nog niemand wist wat er zou volgen, laat staan dat er toen al iemand kon voorzien dat het zo overmachtige nazi-Duitsland met zijn politieke en militaire leiders vijf jaar later dramatisch ten onder zou gaan.</p>\n<p><a name=\"CIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Cinematografie</strong></font></h2>\n<p><span class=\"menstis\">OP HET RITME VAN DE HISTORISCHE MEIDAGEN</span>. <strong>Darkest Hour</strong> is geen biografische film. Het is een historische film die inzoomt op een bepaalde sectie van de zeer bewogen eerste helft van de twintigste eeuw. De verhaalstructuur van Darkest Hour bestaat uit een kalender, gevormd door enkele dagen van de meimaand van 1940. Na de generiek volgen verschillende fasen van de historische gebeurtenissen die zich in het Londen van toen hebben afgespeeld. In de eerste helft van mei gaat het om de dagen van 9, 10 en 13 mei. Het dramatische zwaartepunt situeert zich eind mei met de dagen 25, 26, 27 en 28 mei. De kalenderstructuur onderlijnt het historische karakter van het verhaal. De film reconstrueert zo exact mogelijk de gebeurtenissen op het moment dat ze zich afspelen in de tijd. De toeschouwer aanschouwt het verloop ervan. De film is dus geen flashback waarbij achteraf op de gebeurtenissen wordt teruggeblikt. Het blikveld van de film is daarentegen helemaal dat van de historische personages die zich midden in de gebeurtenissen bevinden zonder te weten waarmee ze de volgende dagen, weken en maanden zullen worden geconfronteerd. Ze kunnen met andere woorden de implicaties van hun gemaakte keuzes niet overzien. Alleen de toeschouwer van de film is in staat om de personages te volgen tijdens het verloop van de gebeurtenissen vanuit hun actuele kennis over wat de historische gevolgen zijn geweest van de beslissingen die de historische figuren toen in die bewuste maand mei hebben genomen: de overwinning van de geallieerde troepen, de smadelijke nederlaag van Hitlers Duitsland. Een bijkomend effect van die kalender-verhaalstructuur is de verwondering over de korte periode waarop de bewuste personages zo’n grote en uiterst belangrijke beslissingen hebben moeten nemen.</p>\n<p><span class=\"menstis\">HET DRAMA VAN DE INTERNE OORLOG</span>. De eerste dag, 9 mei, staat helemaal in het teken van het ontslag van de Britse premier Neville Chamberlain en voorzitter van de Conservatieve Partij. De oppositieleider, de voorzitter van de Labour Partij, Clement Antlee schreeuwt het uit: ‘<em>Mr. Speaker, we zijn in oorlog en Mr. Chamberlain is onbekwaam om ons in oorlogstijd te leiden. We zullen nooit toetreden tot een grote coalitie met de regerende Conservatie Partij geleid door mijnheer Chamberlain.</em>’ Tegen zijn zin en die van de kopstokken van zijn partij, vooral zijn vriend en bondgenoot, de aristocraat Lord Edward Wood, de derde graaf van Halifax, sinds 1938 minister van Buitenlandse Zaken in de regering Chamberlain. Iedereen aan de top van de Conservatieve Partij wil Halifax als nieuwe eerste minister. Dat zou neerkomen op een kleine stoelendans met de voortzetting van de huidige bewind als gevolg. Op 10 mei moeten Chamberlain-Halifax erkennen dat alleen Winston Churchill aanvaardbaar is voor de oppositie. De koning George VI steunde Chamberlain en moest tegen zijn zin Churchill de opdracht geven een nieuwe regering te vormen.\nDe dramatische verhaallijn is niet die van de militaire oorlog tussen Duitsland en Engeland. Natuurlijk is die voortdurend aanwezig, weliswaar zelden op de voorgrond, wel steeds op de achtergrond. Er komen verschillende belangrijke sequenties voor die zich afspelen in de War Room van de Britse oorlogsregering onder leiding van Winston Churchill. De historische War Room, vandaag een Londense trekpleister, is getrouw nagebouwd in de studio. In de War Room-sequenties overlegt het War Room Cabinet met de militaire hoofdverantwoordelijken. Opmerkelijk daarbij ligt de focus van het filmverhaal op de interne, politieke oorlog die zich afspeelt tussen de nieuwe, kersverse premier Winston Churchill enerzijds en de vorige premier Nelville Chamberlain en de minister van buitenlandse zaken Halifax anderzijds. Churchill heeft namelijk zijn grote politieke opponenten  opgenomen in zijn oorlogskabinet. Hij wil immers tijdens die cruciale periode geen open oorlog binnen zijn eigen partij ontketenen. Zijn positie in zijn partij, de Conservatieve, is immers zwak juist omdat Chamberlain-Halifax tegen hun zin het premierschap van Winston hadden hebben moeten  accepteren. De dramatische klemtoon van Darkest Hour ligt op de onophoudelijke politieke poging van Chamberlain-Halifax om Winston als premier tegen te werken en hem te doen mislukken zodat zij het roer terug in handen kunnen nemen. Achter de rug van Winston spelen ze een weinig fraai politiek spel waarbij ze zelfs de koning betrekken. Wanneer Winston op 13 mei zijn eerste toespraak als premier houdt in het parlement dan verbiedt Chamberlain al de partijleden van de Conservatieve Partij, de partij van Winston, te applaudisseren. De dramatische lijn van de interne, politieke oorlog mondt uit in de slotsequenties. Daarin moet Halifax gelaten toezien dat Chamberlain aan de partijleden na de tweede toespraak van Winston in het parlement op 28 mei de toestemming geeft om samen met de Labour-partijleden te applaudisseren.</p>\n<p><span class=\"menstis\">DE GELUIDSCINEMATOGRAFIE VAN TWEE HISTORISCHE STEMMEN</span>. Een sterk cinematografisch punt van Darkest Hour, is de bijzondere zorg voor de klankband. De ondersteunende filmmuziek van Dario Marianelli domineert niet en is vooral functioneel aanwezig in overgangsscènes. Karakteristiek voor de film daarentegen zijn de klanken, in het bijzonder die van de menselijke stem die beweegt tussen de stilte en het gesproken woord. Dat geldt in de eerste plaats voor de vier speeches van Winston Churchill in de film: in het parlement (13 mei), diens eerste radiotoespraak (eveneens op 13 mei), één voor de voltallige ministers en belangstellenden in het vertrek van het Outer Cabinet (28 mei) en de tweede toespraak voor het volledige parlement (eveneens op 28 mei). Daarbij werkt de regisseur het contrast uit tussen de twee historische antagonisten: Winston Churchill en Hitler. Met de film corrigeert Joe Wright het collectieve beeldgeheugen. Door de niet meer te tellen documentaires over de Tweede Wereldoorlog en het naziregime van Hitler is de balans zeer sterk gaan doorslaan in de richting van de retor Hitler. Alle documentaires gebruiken de footage dat afkomstig is van het naziregime. Dat muntte uit in het gebruik van het nog jonge filmmedium in dienst van de ideologische propaganda en brainwashing van de bevolking. Dat verklaart waarom er zoveel beeldmateriaal van Hitlers toespraken bestaan. Dat geldt niet voor zijn tegenpool Winston Churchill. Tijdens een korte scène, gesitueerd in de smalle gangen van het ondergrondse oorlogsministerie in Londen, hoort Churchill Hitler speechen op de radio in een van de kamers. Hij blijft even staan om te luisteren en stelt dan een opvallend gebaar. Hij gooit ostentatief de deur van de kamer toe. Hij legt de orakelende Hitler het zwijgen op. Andere stijl – stilte bezielde woorden de muziek van de taal versus het bulderende geschreeuw en sloganeske geroep eigen aan Hitlers spreekstijl. De film laat het volledige andere auditief spectrum zien van Churchills spreken zowel in de private als in de publieke sfeer. Hij werkte intens aan zijn een unieke manier van publiek spreken. Daarvan was vooral de radio het dragende medium. De radio speelde een cruciale rol tijdens de Tweede Wereldoorlog, vooral in Engeland en in het verzetsgroepen in de Duitse bezette gebieden. Voor de mannen en vrouwen in het verzet was de BBC-radio van wezenlijk belang. In Churchills radiospeeches vonden niet alle de Engelse bevolking, maar ook de mensen in het verzet motivatie en bezieling. Churchill was geschoold inde retorische Grieks-Romeinse traditie. In de film zoekt Churchill op zeker ogenblik naar zijn boek van Cicereo, de grote Romeinse juridische retor. Tegelijkertijd was Churchill ook, zoals iedereen in Engeland, gevormd door de impressionante, Shakespeareaanse theatertradtie. Vooral door de opnames van Churchills speeches voor het Engelse volk via de BBC-radio kon de acteur Gary Oldman zich perfect voorbereiden om zo dicht mogelijk bij de klank en de toon van Churchills stem te komen. Door zijn vertolking slaagt Oldman erin om de unieke spreekstijl van Churchill bijzonder aanwezig te brengen. In fel contrast met Hitler beweegt Churchills spreekstijl vanuit de geladen stilte. Zij is de bron van de woorden die hij zoekt. De stilte tussen de zinnen en de woorden vertolkt zijn contemplatieve geest. Hij denkt voortdurend, ademt alle gebeurtenissen die tot hem komen in, beschouwt ze en probeert die dan te verwerken in klank en woord. Daarom legt de film ook de nadruk op het typische gemurmel van Churchill. Hij dacht intens na, zocht woorden, vond die niet altijd, maar hij zocht verder. Hij gaf niet op. De film capteert dit fenomeen treffend in de korte, maar sprekende scène met de laatste seconden voor de eerste radiotoespraak op 13 mei. De BBC-regisseur jaagt Churchill op die nog tot op de laatste seconde aan zijn tekst aan het werken is. De eerste seconden van de toespraak bestaan uit stilte. Vanuit die gewijde stilte vloeien dan de woorden die die stilte met zich meedragen. Ook in een ontroerende scène met Churchill en zijn onmisbare secretaresse, miss Layton, schenkt de regisseur aandacht aan het ontstaan van Churchills unieke spreekstijl. Hij vindt zijn woorden niet op 27 mei, de dag voor zijn grote speech in het parlement. Hij struikelt over hoe hij Hitler zal noemen, de man tegen wie hij het moet opnemen, zij het met ongelijke wapens. Hitler boekt immers met zijn Blitzkrieg de ene overwinning na de ander. Churchill krijgt voortdurende nieuws van het oorlogsfront dat altijd maar slechter en slechter wordt. Churchill is ook en vooral ontmoedigd door de interne tegenwerking. Miss Clayton verstaat hem niet. Ze zegt: ‘<em>You were mumbling</em>’ (mompelen). Hij reageert: ‘<em>The right words won’t come</em>.’ (‘<em>De juiste woorden komen niet.</em>’) Zij troost hem: ‘<em>They will come sir. No one can put words together like you.</em>’ (‘<em>Ze zullen komen, sir. Niemand anders dan gij kan woorden bij elkaar brengen.</em>’)</p>\n<p><span class=\"menstis\">AUTHENTIEK FILMPORTRET</span>. De film oogt als een levend portret van de zestiger Winston Churchill. Toen hij premier werd in mei 1940 was hij al goed 65 geworden. Dat Darkest Hour oogt als een authentiek historisch filmportret, daar tekent Joe Wright voor. Hij heeft echter zijn doel kunnen bereiken dankzij het bijzondere acteertalent van Gary Oldman. De Britse acteur mocht voor zijn prestatie in 2018 terecht verschillende hoogste prijzen in ontvangst nemen. De acteur lijkt nochtans helemaal niet op de echte Winston Churchill. Oldman heeft een grote transformatie moeten ondergaan en is in zijn rol als Churchill zelf niet meer herkenbaar. Zelf heeft Oldman zich een jaar lang toegelegd op de studie van de houding en de manier van spreken, eigen aan Winston Churchill. Daarvoor kon hij gebruik maken van het uitgebreid klank- en beeldarchief. Oldman is een telg uit de Britse theaterschool. Toch is een vertolking voor film iets helemaal anders dan spelen op een podium. Dit laatste is statisch, terwijl de filmcamera voortdurend zelf in beweging is. Bovendien beschikt de camera over verschillende lenzen die kunnen uit- en inzoomen. De camera blijft ook altijd gefocust. Hij verliest de personages nooit uit het oog en hij kan de kleinste details registreren. In het geval van Darkest Hour betekent dit alles dat de camera veel aandacht besteed aan de lichaamstaal van het hoofdpersonages zowel in de privésfeer als in het publieke domein. Oldman is er met zijn regisseur Wright in geslaagd om beeldend de historische Churchill terug tot leven te brengen, iets wat archieffoto’s en –beelden, hoe belangrijk ze ook zijn, zelf niet meer kunnen.</p>\n<p><span class=\"menstis\">COMPOSITIE MET DONKER EN LICHT</span>. De filmtitel <strong>Darkest Hour</strong> introduceert een belangrijk cinematografisch gegeven. Niettegenstaande de film in kleur is, componeert Wright zijn Churchill-film met het coloriet  ‘donker–licht’. Eerst en vooral zijn er twee bijzondere momenten waarop het beeld helemaal donker kleurt. Dat gebeurt bij het begin van de episode 10 mei en bij de opening van het slottafereel van de episode 27 mei. In beide voldonkere beelden bevindt zich Winston Churchill. In de scène van 10 mei gebeurt de introductie van het hoofdpersonage en een belangrijk nevenpersonage. We bevinden ons in de slaap- en werkkamer van Churchill. Van zodra hij ontwaakt – hij werkt tot laat in de nacht – neemt hij het ontbijt in bed en begint hij te schrijven door te dicteren. In de bewuste scène voltrekt zich de introductie van de werkende Churchill en zijn nieuwe typiste en secretaresse, miss Clayton. De twee worden onafscheidelijk. Churchill denkt zo snel dat de typiste hem soms amper kan volgen. Nadien neemt hij de getypte tekst nog door en corrigeert die met een pen. Daarom moeten alle teksten een dubbelle spatie hebben. Wanneer miss Clayton de kamer betreedt, stapt ze binnen in het donker. Op dat ogenblik gaat het eerste licht aan. Churchill ontsteekt een lucifer om zijn eerste sigaar van de dag aan te steken. Met andere woorden, hij zal de komende weken in mei degene zijn die het licht aansteekt in de alsmaar donkere tijden. Het tweede moment van volledige duisternis komt voor in het laatste tafereel van de episode van 27 mei, het slottafereel met de koning. Churchill bevindt zich dan politiek en emotioneel op het meest donkere punt van zijn prille premierschap. Hij ziet geen licht meer. Hij zit in een volledig donkere kamer. Plots gaat de deur op. Zijn vrouw Clementine kondigt de komst van een onverwachte gast aan op het late avondduur: de koning in eigen persoon. Nu brengt de koning het licht naar Churchill. Voorheen steunde hij Chamberlain en Halifax en stond hij onder hun anti-Churchill invloed. Maar hij is geleidelijk aan waardering gaan krijgen voor de nieuwe premier. Hij kom hem melden dat hij nu af aan aan zijn kant staat. Uit dat bijzonder gebaar put Churchill de moed om de volgende dag, 28 mei, definitief zijn eigen lichtspoor te volgen. Er komen nog enkele frappante taferelen voor waarin de regie met ‘donker – licht’ betekenisvolle accenten plaatst. Dat betreft de belangrijke taferelen in het parlement, het House of Commons. Op 9 mei, het eerste parlement-tafereel, staat de oppositie in het licht – de Labourleider Clement Attlee is aan het woord. De zijde van de regering onder leiding van Chamberlain zit in het indirecte licht. In de volgende taferelen met premier Churchill staat de regeringsleider in het licht, waarbij het opvalt dat nu het volle licht schijnt op de Speaker’s Table (de Sprekers Tabel), ook Clerk’s Table genoemd. Op de tafel liggen onder andere de boeken met de democratische basiswetten van het Britse volk samen met de Despatch Boxes. Dat zijn historische houten kisten waarop de regeringsleden, met als eerste de premier, en de oppositieleider hun teksten leggen van de redes die ze houden. Regisseur Wright  zorgt er tijdens de speeches van Churchill altijd het volle licht valt op de belangrijke tafel. Het personage van Churchill staat mede aan de tafel in het volle licht. Ook een betekenisvol lichtmoment doet zich voor wanneer Winston samen is met zijn vrouw Clementine. Dat is al het geval vanaf hun eerste verschijning samen in de episode van 10 mei. Ze zitten naast elkaar op de rand van Winstons bed. Ze zitten samen in het volle licht dat door het grote raam de kamer vult, die kamer die in het begin van de episode alleen maar donker kende. Clementine zegt daar tegen haar man die op het punt staat geroepen te worden om premier te worden: ‘<em>I want others to love and respect you, as I do.</em>’ (‘<em>Ik wil dat anderen van u houden en u respecteren zoals ik doe</em>’.)  Met die lichtscène van Winston en Clementine is de toon gezet: beiden vormen een en dezelfde lichtbron in het donkerste uur dat de Britse natie kent. Beiden vormen een geheel, een feminiene en een masculiene component die elkaar in balans houden. In de momenten die volgen, zal premier Churchill verschijnen als een lichtbron in de duisternis van de toenmalige politieke omstandigheden. Zo schijnt in de episode van 13 mei de lamp op zijn gelaat in de BBC-opnamekamer die voor het overige erg duister is. Na die opname loopt hij door de donkere gang van het ondergrondse complex waar de Britse regering tijdens de oorlog werkte. Na de opname stapt Churchill door de flauw verlichte gang naar de lift die hem naar de bovengronds woonvertrekken van de premier zal brengen. De regisseur filmt dan de liftscène. In het midden van een volledig donker beeld beweegt de verlichte lift met de premier naar boven. Diens eerste BBC-speech vormt een eerste, bescheiden stap opwaarts naar het nog zwakke licht in een overweldigende donkerte.</p>\n<p><span class=\"menstis\">OOG VOOR DETAILS</span>. Regisseur Wright zet alle cinematografische middelen in voor het filmportret. Dat impliceert een goed oog voor details. Close-ups maken hier wezenlijk deel uit van het levende portret. Ze helpen de uniekheid van de persoon in kwestie in de verf te zetten. Daartoe behoren de close-ups van de sigaar, de lucifer, de ring, de whisky, de blik, de mond, de typemachine, de letters op het blad. Die detailbeelden zijn met elkaar verweven. Ze typeren namelijk de wijze waarop Churchill leeft en werkt. Ze kenmerken de eigen lichaamstaal van Churchill; ze ogen als directe expressies van de denkende politicus Churchill. De sigaar en de ring zijn historisch, evenals de typemachine waarop letterlijk de teksten van Churchill zijn ontstaan via de snelle vingers van miss Layton. Die details die de gewone beelden versterken en naar hun eigenlijk betekenis verwijzen, schilderen de snel denkende geest van Churchill. Churchill ontwikkelde een persoonlijke stijl om een sigaar te roken en een glad whisky te drinken, als deel van zijn werkritueel. Zijn vijanden gebruikten dat om zijn naam te bekladden. Voor hem hoorden die zaken tot het ritueel om zich te concentreren en te focussen. Van zodra hij begon te werken, stak hij een sigaar aan. Dat verklaart de introscène in zijn slaapkamer die eveneens een werkkamer was. Ook bij de uitwerking van Churchills tegenpool, zijn voorganger Chamberlain, gebruikt de regisseur de close-up, met name van diens witte zakdoek. Met die close-up tegenpartij beschrijft Wright een narratieve inclusie. Ze opent op het einde van de eerste episode, die van 9 mei, en sluit in de close-up van de witte zakdoek bij de afsluiting van de laatste episode, die van 28 mei. Bij de eerste gaf Chamberlain aan de partijleden het teken om niet te applaudisseren voor Churchill door zijn witte zakdoek weg te steken. Op 28 mei veranderde hij van mening. Met het teken van de witte zakdoek gaf hij toe dat Churchill had gewonnen.</p>\n<p><span class=\"menstis\">SLOW-MOTION</span>. <strong>Darkest Hour</strong> kent ook twee taferelen in slow-motion. Telkens gaat het om het gebruik van de subjectieve camera, het blikveld van het hoofdpersonage. Het eerste tafereel situeert zich in de episode van 10 mei. Churchill rijdt naar Buckingham Palace voor zijn eerste audiëntie met de koning. In de taxi observeert de mensen die langs de weg voorbij lopen op weg naar hun werk of hun thuis. De slow-motion onderstreept het belang hiervan. Die beelden van gewone mensen in de stad horen bij de observatie, de scherpe en open blik van  de toekomstige premier. Die beelden tonen hoe hij zich verbonden weet met de stadsbewoners. Hij zorgt om hun lot vanuit zijn kennis over de concrete oorlogssituatie die zich dan aan het voltrekken is. Het tweede tafereel in slow-motion kent dezelfde dynamiek. In de laatste episode, die van 28 mei, is Churchill op weg naar de vergadering in de War Room. Opnieuw focust hij zich op de concrete mensen. Hierdoor beslist hij op zeker ogenblik uit de taxi te stappen en de metro te nemen. Het metro-tafereel vormt het dramatische hoogtepunt van de film. De ervaringen die Churchill daar opdoet, de concrete mannen, vrouwen en kinderen die hij daar leert kennen, leveren hem de mentale grondstof die hij nodig heeft om de moeilijke politieke beslissing als oorlogspremier te nemen. Die beslissing brengt hem naar zijn toespraak in het Outer Cabinet, gevolgd door zijn belangrijke speech in het parlement, het crescendo van de hele film <strong>Darkest Hour</strong>.</p>\n<p><a name=\"BET\"></a></p>\n<h2><font color=\"#808000\"><strong>Betekenisruimte</strong></font></h2>\n<p><span class=\"menstis\">DE OORSPRONG VAN HET DONKERE UUR.</span> Darkest Hour opent met een heel korte maar betekenisvolle korte proloog, een pregeneriek. Die bestaat een triptiek in zwart-wit beelden. Ze vormen een montage van archiefbeelden van nazi-Duitsland. Achtereenvolgens verschijnen gehelmde Duitse soldaten, opgesteld in een perfecte rij, gevolgd door eveneens perfect op één rij opgestelde kanonlopen van tanks, waarna een korte sequentie volgt met Hitler die zijn generaals instructies geeft op een militaire kaart. Die openingstriptiek roept de herinnering wakker aan de directe oorzaak van Europa’s ‘donkerste uur’. De term ‘darkest hour’ komt van Churchill zelf. Hij gebruikt het in zijn eerste toespraak als premier in het parlement. Churchill ontleent de term zelf aan de Bijbel, meer bepaald aan Jesaja 58: 8-10. Churchill gebruikt de benaming ‘darkest hour’ in een concrete, actuele zin. Hij beschrijft ermee de heersende toestand waarin Engeland en de ander Europese landen zich dan bevinden. Hitler ontketende met zijn militair naziregime een wereldbrand. Hij had in dat kader een nieuwe strategische stap genomen: de opening van het westelijke front met een Blitzkrieg in de neutrale Lage Landen, waaronder België, en Frankrijk met als doel: een mogelijke samenwerking tussen Frankrijk en Engeland verhinderen, en een aanval op Engeland voorbereiden. De eigenlijke betekenis van die eerste sequenties van Darkest Hour licht op door het contrast met de eerste sequenties na de filmtitel. Van dan af situeren de beelden zich in Engeland, vooral in London. De eerste sequenties, gesitueerd op 9 mei, plaatsen de toeschouwer midden een parlementair debat. De oppositieleider Clement Attlee eist dat de premier Chamberlain en zijn regering opstappen. Opmerkelijk valt dan het eerste gesproken woord in de film. De Speaker of the House roept driemaal: ‘Order!’.  De Londense parlementszitting is alles behalve een toonbeeld van orde. De parlementsleden luisteren, maar reageren spontaan en luid. De oppositieleden, de meerderheidsleden, allen zijn ze betrokken in een open forum van uitgesproken gedachten en voorstellen waarvoor ze hun goed- of afkeuring laten blijken. Dat vormt een enorm contrast met de Duitse openingssequenties. Het nazibeleid van Führer Hitler legt een perfecte orde op. De Engelse democratie ontstaat uit een chaos van botsende gedachten en voorstellen, uitgesproken door verkozen parlementsleden. De roep ‘order’ van de Speaker is geen dictatoriaal bevel dat met wapens en terreur wordt afgedwongen. Een van de eerste maatregelingen die de nieuwe kanselier Hitler na zijn aanstelling op 30 mei 1933 uitvaardigde, leidde tot het sluiten van het eerste Duitse, democratische parlement, dat van de Weimarrepubliek, ontstaan na de Duitse nederlaag in Wereldoorlog I. Van dan af kende Duitsland maar één stem, het bevel van de Führer. De aanwezigen, de nazi-partijleden, mochten enkele nog op maat applaudisseren. Met andere woorden, de film Darkest Hour, plaatst de werking van een democratische samenleving tegenover die van nazi-Duitsland, een samenleving gebouwd op de steen van terreur en blinde gehoorzaamheid. De tegenpool van Hitler is Winston Churchill. In de film wordt de historisch juiste uitspraak aangehaald dat Hitler maar van één man schrik had, en dat was Winston Churchill. Darkest Hour is opgebouwd naar het crescendo van de toespraak van Churchill op 29 mei in het parlement. Dan blijkt dat hij van onderuit de orde waarnaar de Speaker in het begin naar vroeg, heeft tot stand gebracht. Die democratisch verworven orde zal de dictatoriale orde van Hitler verslaan. Daartoe moest op 29 mei nog een hele weg worden afgelegd. De eerste stap was gezet.</p>\n<p><span class=\"menstis\">DE GROOTSTE BEPROEVING OOIT </span>. In zijn eerste toespraak op 13 mei voor het parlement spreekt Churchill over ‘<em>an ordeal of the most grievous kind</em>’. Die zin spreekt hij direct uit na de historische woorden ‘<em>I have nothing to offer but blood, toil, tears and sweat</em>’ uitspreekt. ‘<em>Ik heb niets te bieden behalve bloed, labeur, tranen en zweet</em>’. De reden van dat alles, zo verduidelijkt hij, is het feit dat het land zich bevindt voor ‘beproeving van de ergste soort’. De ‘<em>blood, toil, tears and sweat</em>’-zin is in het collectieve geheugen blijven hangen. De daarop volgende ‘<em>ordeal</em>’-zin daarentegen is in de vergetelheid geraakt. Niemand anders dan Churchill zelf begreep de volle betekenis van die zin. De film <strong>Darkest Hour</strong> laat nu zien wat die voor Churchill zelf inhield. De ‘<em>blood, toil, tears and sweat</em>’-zin slaat natuurlijk op het hele land dat officieel in staat van oorlog verkeert met uit zijn as herrezen Duitsland. In mei 1940 ondervoed de Engelse bevolking nog praktisch niets van die oorlog. Maar het ‘bruine’ gevaar kwam nader. Op 10 mei was het zover. Hitler startte zijn Blitzkrieg richting Engeland. In zijn toespraak doelde Churchill niet alleen op de naderende, militaire confrontatie met Hitlers troepen. Hij zelf begreep ook de echte beproeving waarmee hij werd geconfronteerd. Die bestond in de ontmoediging, de wanhoop die dreigde bezit te nemen van de natie. Iedereen was zonder uitzondering danig onder de indruk van de Duitse militaire overmacht. Iedereen, zonder uitzondering,stelde zich hardop de vraag die Britse historicus Tim Bouverie in zijn boek <em>Appeasing Hitler. Chamberlain, Churchill and the Road to War (2019)</em>:</p>\n<blockquote>\n<p><em>How was it that a country defeated in 1918, reduced in size, restricted in arms and surrounded by potential foes, was allowed to rise in twenty short years to a position where she was able to mount a challenge for global supremacy and almost achieve her objective?</em> (p. 414)</p>\n</blockquote>\n<p>Niemand zag een uitweg. De beproeving van de ontmoediging woog steeds zwaarder en de bekoring om eraan te bezwijken nam overmaats toe. Ook Churchill kon niet zomaar een oplossing uit zijn mauw schudden. De twee volkomen donkere beelden in de film, gesitueerd in de episodes van 10 mei en 27 mei, roepen die beproeving van ontmoediging, ook bij Churchill, op. Maar er is meer. De zwaarte van die beproeving kwam helemaal terecht op de persoonlijke, politieke schouders van Churchill. Alleen hij zelf voelde dat gewicht dat hij moest torsen. Dat gewicht kwam niet rechtstreeks van de oorlogszucht van Hitler, maar van de eigen partij, ondersteund door het Engelse koningshuis: Neville Chamberlain, premier en partijleider van de Conservatieve Partij, waarvan Churchill zelf ook lid was, en Edward Wood, Viscount Halifax genoemd? Beiden deden er alles aan om Churchill van het premierschap te houden en zelfs wanneer de kersverse premier Churchill hen beiden opnam in zijn War Room Cabinet als volwaardige ministers, hielden ze niet op met Churchill te dwarsbomen en zelfs achter zijn rug samen te zweren om hem ten val te brengen om daarna via het premierschap van Halifax het beleid van Chamberlain voort te kunnen zetten. Churchills beproeving bestond dus niet alleen uit de naderende oorlogsmachine van Hitler, maar ook uit de harde, interne tegenwerking in eigen politieke rangen bij monde van zijn oorlogsministers Chamberlain en Halifax. Hij had zelf zijn politieke vijanden in eigen partijrangen als ministers aangesteld bij wijze van politiek gebaar van verzoening. De beproeving van politieke zwaarte betekende voor Churchill persoonlijk een existentiële beproeving van een voor hem zelf nooit eerder geziene grootte.</p>\n<p><span class=\"menstis\">HET EIGEN EGO, DE GEVAARLIJKE BLINDHEID VAN POLITIEKE VERWAANDHEID</span>. In het derde seizoen van de veel geprezen en bekroonde televisieserie The Crown bezoekt koningin Elisabeth II Winston Churchill op zijn sterfbed. Daar zegt ze tegen hem: ‘<em>Where would Great Britain be without its greatest Briton?</em>’ Of dit bezoek er is geweest en wat de koningin heeft gezegd, is niet  geweten. Scenarist Peter Morgan heeft in die scène de sterke band tussen Winston Churchill en de koningin weten samen te vatten. En als koningin vertolkt ze de mening van alle Britten die in 2002 Winston Churchill als de grootste Brit aller tijden hebben gekozen. Die nationaal-Britse waardering mag vandaag vanuit een breder perspectief worden uitgebreid tot: ‘De grootste Europese politicus die tot nu toe heeft geleefd.’ Waarom? Hoever reikt zo’n uitspraak?</p>\n<p><strong>Darkest Hour</strong> helpt om een antwoord te vinden. Churchill wist de Britse natie de zwaarste beproeving ooit te overwinnen. Meteen gold die overwinning ook voor de grootste beproeving waarmee tegelijkertijd Europa werd geconfronteerd. De draagwijdte van die overwonnen beproeving, zo laat Darkest Hour op grond van degelijk archiefonderzoek zien, strekt zich uit tot wat we vandaag ‘politieke verantwoordelijkheid nemen’. Die woorden zijn niet onschuldig. Ze worden te pas en te onpas gebruikt. De enen vinden dat ze hun politieke verantwoordelijkheid nemen, terwijl de anderen het omgekeerde beweren. Tragisch genoeg, zijn het meestal de feiten achteraf die onthullen wie zijn politieke verantwoordelijkheid wel of niet heeft genomen. Darkest Hour toont duidelijk dat Churchill dat duidelijk wel heeft gedaan. De film realiseert dat door aandacht te besteden aan Churchills antipoden: Chamberlain en Halifax. Zij vormen dan ook de belangrijkste nevenpersonages. Het helpt veel wanneer de toeschouwer van Darkest Hour enige voorkennis bezit over beide historische, Britse politici. De zwaarste beproeving voor de Britse natie, de bezette Europese landen en Churchill persoonlijk ontsprong niet alleen aan Hitlers politieke waanzin, maar evenzeer uit het Engelse buitenlandse beleid dat Chamberlain samen met Halifax voerde. Vanaf 1933, het begin van Hitlers kanselierschap, was ‘<em>appeasement</em>’ het codewoord van dat beleid. Deze term is sinds die tijd niet alleen een historisch, maar tevens ook blijvend diplomatiek begrip geworden. Letterlijk betekent ‘<em>appeasement</em>’ ‘<em>verzoening, concessie, kalmering, toegeving</em>’. Concreet formuleerde Chamberlain zelf zijn beleid in een brief van januari 1938 aan een kennis als volgt:</p>\n<blockquote>\n<p><em>The didactors are too often regarded as though they were entirely inhuman. I believe this idea to be quite erroneous. It is needed the human side of the didactors which makes them dangerous, but on the other hand, it is the side on which they can be approached with the greatest hope of successful issue.</em> (Bouverie, o.c.,  p. 131)</p>\n</blockquote>\n<p>Met andere woorden, Chamberlain geloofde in zijn persoonlijk talent om het menselijke in heersende Europese dictators aan te kunnen spreken om zodoende erger te kunnen voorkomen. Concreet was hij er heilig van overtuigd om Hitler tot redelijkheid te kunnen brengen en zo een vredesverdrag tussen Duitsland en Engeland te kunnen realiseren. Daartoe was hij bereid Hitlers aanspraken op nieuw Duits grondgebied in Centraal-Europa (Oostenrijk, Sudetenland, dit is een stuk van Tsjecho-Slovakije, Polen in te willigen. Om hij beleid te realiseren, gingen Chamberlain en Halifax heel ver. Ook letterlijk. Op 17 november 1937 reisde Halifax persoonlijk naar Berlijn en nam daar de nachttrein naar Hitlers schuiloord Berghof in Brechtesgarten. Hij onderhandelde er persoonlijk met Hitler. Daarna reisde Chamberlain zelf nog drie keren kort na elkaar naar Duitsland om er persoonlijk met Hitler te spreken. De eerste keer, op 15 september 1938, nodigde Chamberlain zichzelf uit bij Hitler in Berghof. Daarna volgen er nog officiële besprekingen in Bad Godesberg nabij Bonn (22-24 augustus 1938) en in München (19-30 september). Dit laatste betrof de historische, zogeheten München Vredesconferentie onder leiding van Hitler zelf. Na die conferentie kwam premier Chamberlain terug naar Londen. Hij stapte uit het vliegtuig, zwaaide met het blad van de overeenkomst naar de aanwezige journalisten met hun camera’s in aanslag en noemde het papier: ‘<em>Peace for our time</em>’, de waarborg van de gemeenschappelijke wil van de twee volkeren om nooit meer tegen elkaar oorlog te voeren. (Bouverie, o.c.,  p. 286). In eigen land werd Chamberlain ontvangen met groot enthousiasme door de aristocratie en hogere burgerij. Ze zagen hem als een soort <em>Christus op aarde</em> (Idem, 299). De hogere kringen juichten omdat de kalender van de cricket wedstrijden niet meer door een mogelijke, nakende oorlog zou worden verstoord (Idem, p. 360). Daarentegen, zo laten de archieven van Münchenconferentie zien, noemde Hitler in eigen kringen achteraf de overeenkomst ‘een vodje papier’. Tegenover zijn intimi liet hij verstaan dat hij Chamberlain een belachelijk, zwak figuur vond van wie hij alles gedaan kreeg als hij nog maar het woord ‘oorlog’ uitsprak. Chamberlain hield aan zijn gesprekken met Hitler een andere indruk over. Chamberlain meende, zo blijkt uit diens eigen notities en verklaringen, dat hij een persoonlijke band met Hitler had weten tot stand te brengen, dat het hem was gelukt op die manier Hitler in te tomen en dat hij er niet aan twijfelde dat Hitler een ‘man van zijn woord’ was. Die voorstelling en dat geloof in zichzelf stortte op 9 mei toen Hitler het bevel tot de Blitzkrieg had gegeven, als een kaartenhuisje in elkaar.</p>\n<p><strong>Darkest Hour</strong> laat correct zien dat Chamberlain en Halifax zelfs in de weken na 10de mei, de Duitse aanval op onder andere België, bleven geloven in hun diplomatieke kunde om met Hitler een vredesakkoord te sluiten om diens mogelijke invasie van Engeland te voorkomen. Daarbij wilden ze alle bezette gebieden compromisloos aan Hitler toewijzen. Dat verklaart wat er in Darkest Hour gebeurt in de ‘donkerste’ episodes tussen 13 mei en 27 mei. Churchill wist zich geconfronteerd met zijn grootste beproeving. Tegelijkertijd moest hij direct een militair-strategische oplossing zien te vinden voor de redding van zo’n 300 000 Engelse soldaten die vast zitten aan de Franse kust nabij Duinkerken wegens de Duitse Blitzkrieg. Hij kon enkel op zichzelf rekenen. Niemand in War Room wilde hem helpen. Alleen van generaal Ismay kreeg hij de nodige en juiste militaire info over de toestand aan het front. Hij telefoneerde dan maar naar de Amerikaanse president Franklin Delano Roosevelt maar daar kreeg hij op een erg cynische manier een koude douche te trotseren. Hij overwon echter de beproeving van politieke verlatenheid en eenzaamheid door de Operatie Dynamo te lanceren. Hij schakelde burgers in om met hun boten de soldaten aan de Franse kust op te gaan halen om de beperkte Britse militaire vloot te ondersteunen. Met die historische, geslaagde operatie legde Churchill, ofschoon het op korte termijn gezien een militaire nederlaag betrof, op middellange termijn met de redding van het overgrote deel van het Engelse leger de grondvesten voor het nieuw op te bouwen Engelse leger. Hij slaagde ermee de Engelse bevolking samen met de militairen mentaal te mobiliseren om weerstand te bieden aan Hitler en diens troepen.  En dan nog bleven Chamberlain en Halifax hun premier dwarsbomen. Ze plaatsten hem met zijn rug tegen de muur door te eisen via de Italiaanse dictator Mussolini  opnieuw met Hitler te gaan onderhandelen. Churchill begon ernstig te twijfelen. Alle militaire feiten riepen duisternis op. Zijn externe en interne vijanden zetten hem klem. De beproeving toe te geven aan de agressor Hitler en zijn Britse onderhandelaars groeide uit tot een onoverkomelijk obstakel. Dat gebeurde op het einde van 27 mei. Waarom handelden Chamberlain en Halifax op die manier?</p>\n<p>Beide politici vormden een tweespan dat werd voortgestuwd door hun eigen groot ego, nog aangesterkt door hun aristocratisch meerderwaardigheidsgevoel. Dat uitvergroot ego maakte hen blind voor hun eigen realiteit en voor die van buiten hen. Ze waren niet in staat het ware wezen van Hitlers nazisme onder ogen te zien en dat niettegenstaande Churchill al vanaf 1930 systematisch in bijdragen in kranten en in speeches de demonische ziel van Hitlers ambitie had blootgelegd. Tevens waren ze op de hoogte van wat er echt aan de gang was in het Duitsland van Hitler via de nieuwsreportages van Engelse en Amerikaanse journalisten vanuit Berlijn. Vandaag zijn er voldoende data gekend om de impact van de nefaste gevolgen van het buitenlands beleid van Chamberlain en Halifax in te schatten. Duitse generaals hebben tijdens de processen van Neurenberg (1945-1946) duidelijk bevestigd dat wanneer de Fransen en de Engelsen in 1938 militair waren opgetreden tegen Hitler, er nooit een Blitzkrieg was gekomen, en dat door het noodlottige zogeheten Vredesverdrag van München de voorziene opstand van de Duitse generaals om Hitler af te zetten, werd gedwarsboomd, met de ontmoediging van de interne Duitse oppositie als gevolg. Het tragische van de situatie, de tragiek van de verblindheid door het eigen ego, het bezwijken aan de beproeving van de eigen machtuitoefening, worden nog dramatische wanneer men weet dat dat politieke ego bij Chamberlain werd gevoed door diens sterk geloof dat God zelf hem had uitgekozen als in instrument om de oorlogsdreiging af te wenden. (Bouverie, o.c.,  p. 338). Dat verklaart ook een van de karaktertrekken van Chamberlain. Hij haatte te worden tegengesproken (idem, p. 241).</p>\n<p><span class=\"menstis\">AAN DE TAFEL VAN DE EUROPESE DEMOCRATIE MET EEN CHRISTELIJKE ONDERSTROOM.</span> Dat Churchill die grootse beproeving heeft weten te doorstaan, heeft alles van doen met zijn diep geworteld geloof in de unieke humane waarden eigen aan de moderne, democratische samenleving. Chamberlain en Halifax waren ook democratisch verkozenen en toch bezweken ze aan hun fascinatie voor Hitler die brutaal de prille, Duitse democratie van na de Eerste Wereldoorlog tot in de kiem zelf vernietigde. De film Darkest Hour laat zien wat Churchills trouw aan en inzet voor de democratische, humane waarden inhield: zijn emotionele verbondenheid met het lot van de mensen in de straat, met het lot van de soldaten in hun hachelijke situatie aan het nieuwe front. Wat dat laatste betreft, organiseerde hij op zeer korte termijn de Operatie Dynamo. Wat het eerste betreft, zijn er de twee sequenties langs de straten van Londen in slow motion en het tafereel in de metro. Cinematografisch versterkt regisseur Wright die democratisch-humane bezieling van Churchill via de lichtinval op de tafel in het parlement, het House of Commons. Die tafel van de democratie verbindt. De opening van <strong>Darkest Hour</strong> laat de bitsige woordenstrijd zien aan die tafel, terwijl het einde ervan toont hoe Churchill alle strekkingen weet te verenigen rond de democratisch tafel. Wat daarbij opvalt, is het gebruik van de religieuze inval van het licht. Het schijnt van buiten door de hoge ramen naar beneden. Wright maakt beeldend gebruik van het feit dat het Britse parlement zetelt in de oorspronkelijke Sint-Stevens Kapel van het Paleis van Westminster, het centrum van de Britse democratie. Die bewuste verwijzing naar die religieus-christelijke origine van het parlementsgebouw is niet gratuit. Het onderlijnt de christelijke onderstroom van de Europese democratisch-humane waarden. Churchill begreep dat zeer goed en hij had van dag één al door dat Hitlers nazisme en nationalisme haaks stonden op christelijke waarden. In zijn toespraken gebruikte hij geregeld ‘<em>and I pray God that…</em>’. Zijn gebed was zijn democratisch engagement dat zich toonde én in zijn bezielde woorden én in zijn volgehouden werkijver. Zijn ‘gebedswerk’ onderscheidt zich wezenlijk van het christendom van, zoals <strong>Darkest Hour</strong>, terecht laat zien, zijn hevigste opponent, de bekende Britse politicus Lord Halifax, Edward Frederick Lindley Wood, een nakomeling van het adellijke geslacht Wood, graaf van Halifax. Hij had twee passies: christelijke religie en vossenjacht (o.c. p. 137). Hij zag er meer uit als iemand van de clerus als dan als een politicus. Churchill noemde hem daarom ‘<em>Holy Fox</em>’ en iemand anders typeerde hem als ‘<em>a sort of Jesus in long boots</em>’ (‘<em>een Jezus met lange botten</em>’) (o.c. p. 137). In contrast met Churchill betekende het christelijk geloofs- en gebedsleven een kleed dat hij uit gewoonte droeg. Het was een façade. Het christelijk bidden droeg niet verder dan uitgesproken woorden.</p>\n<p>Voor Churchill droeg de christelijke onderstroom zijn consequent engagement voor de bescherming van de humaan-christelijke waarden in het dagelijkse leven van alle mensen. Voor hem uitte zich in zijn grote waardering voor de huiselijke en parlementaire tafel. Als er iets christelijks is dat teruggaat naar de bron ervan, de figuur van Jezus van Nazareth, dan is het de tafel [zie S. De Bleeckere, <em>Beeldgebed</em> (2020)].</p>\n<p><strong>Darkest Hour</strong> besteedt terecht ook veel aandacht aan de huiselijke tafel van Churchills gezin, vooral aan de hechte huwelijksband van Winston en Clementine. Sonia Purnell heeft in haar boek <em>First Lady. The Life and Wars of Clementine Churchill</em> (2015) terecht laten zien welke hoofdrol Clementine heeft gespeeld in het leven van Winston als man en als politicus. <strong>Darkest Hour</strong> heeft dat ook ernstig genomen. In Winstons leven en werk vormde Clementine het actieve, vrouwelijke element. Dat werd nog aangevuld door de rol van miss Clayton en die van de kokkin van het huis, Georgina Landemare. In de episode van 10 mei, de introductie van het hoofdpersonage Winston Churchill, verschijnt ze even in beeld. Haar belangrijk, huiselijk werk komt in close-up eerst in beeld: het klaargemaakte ontbijt. Later in de film komt haar onmisbaar werk nog in beeld via de tafel waar Winston en koning George VI iedere maandagmiddag samen eten. Historisch kwam de koning heel graag naar wekelijkse tafel want het eten was er beter dan in het paleis. In zijn strijd midden in de grootste beproeving vond Winston er de onmisbare energie om niet te bezwijken in zijn huiselijke basis. Die huiselijke basis breidde hij uit naar alle mensen, mannen, vrouwen en kinderen. In de film belichaamt miss Clayton de gewone Brit. Heel wat sequenties tonen haar als bevoorrechte getuige en Churchill laat haar ook een actieve rol spelen in zijn werk. Die verbondenheid met de tafel van het volk, bereikt zijn hoogtepunt uit het tafereel in de metro. Een bijzonder detail daarbij is dat hij op dat moment een nieuwe sigaar wilt aansteken, maar geen licht, geen lucifers bij zich heeft. Die ene keer krijgt hij licht en vuur van iemand van het volk. Met dat licht stapt hij naar het parlement en vindt hij de kracht om aan de beproeving van het ‘donkerste uur’ weerstand te bieden aan de tafel van de democratie. Voor hem is dat democratisch licht evenzeer een christelijk licht.\nDat gegeven belicht ook het hemelsbrede onderscheid tussen Winston Churchill en Adolf  Hitler. De Führer trouwde met Eva Braun op de dag dat ze samen zelfmoord pleegden. Hij hield in het publiek Eva Braun verborgen. Zijn eigen monumentaal, mannelijk ego vulde de hele publieke ruimte. Niemand anders mocht het beeld vullen. Churchill daarentegen oversteeg die beproeving van het ego. Zijn vrouw Clementine ondersteunde hem daarin. Trouwens, echt last had hij niet van dergelijk ego, want hij had al heel wat mislukkingen en vernederingen achter de rug. Hij had samen met Clementine ook een intens rouwproces doorstaan na het overlijden van hun twee-en-een-halfjarig dochtertje Marigold. Winston kende en toonde twijfel, en hij relativeerde zichzelf via zijn humor. Dit laatste komt in <strong>Darkest Hour</strong> goed uit de verf. Na de oorlog aanvaardde hij tegen zijn zin de eretitel ‘Sir’. Hij vond ‘Winston’ prima. Hij gedroeg zich niet als een Führer. Hij schreef en sprak ook als historicus, iets wat werd opgemerkt toen hij de Nobelprijs voor literatuur mocht ontvangen in 1953. Hitler kende zijn geschiedenis niet; de frustratie over de Duitse nederlaag in de Eerste Wereldoorlog was zijn enig referentiepunt, versterkt door zijn valse lezing van het jodendom. Het christendom legde hij naast zich neer om via de Germaanse mythologie zichzelf en het Duitse volk te verheerlijken.</p>\n<p>Het grote onderscheid tussen Winston Churchill en Hitler komt vooral aan de oppervlakte in het gebruik van de taal. Hitler schreeuwde, riep en tierde. Humor was hem vreemd. Zijn spreken werd beheerst door het Ideologische Woord vol goddeloze haat, radicaal racisme en blind nationalisme. Hitlers spreken dulde geen tegenspraak; het verdroeg geen respons, het accepteerde geen feedback. Het eiste gedirigeerd applaus en absolute gehoorzaamheid. Het woord van Churchill daarentegen werd bezield door zijn democratische geest die hij entte op die van het Britse en Europese, vrije volk. Zijn woord maakte deel uit van een democratische tafel waar woord en wederwoord met elkaar blijven dialogeren. <strong>Darkest Hour</strong> eindigt met een historische uitspraak van Halifax die uiteindelijk tegen zijn zin het talent van Churchill erkent: ‘<em>He mobilised the English language and sent it into battle’</em>. Vanuit zijn democratisch-christelijke motivatie en inspiratie zette Winston de beeldende kracht van de taal in om weerstand te bieden aan het holle gebulder van Hitlers destructieve oorlogstaal. Na de oorlog ontving Sir Winston Spencer Churchill de Nobelprijs voor de Vrede in 1953. De verantwoording luidde:</p>\n<blockquote>\n<p><em>For his mastery of historical and biographical description as well as for brilliant oratory in defending exalted human values</em>’ (‘<em>voor zijn meesterschap in historische en biografische beschrijving alsook voor zijn briljante welsprekendheid voor de verdediging van uitgelezen humane waarden</em>’).</p>\n</blockquote>\n<p><a name=\"CON\"></a></p>\n<h2><font color=\"#808000\"><strong>Context</strong></font></h2>\n<p>De Operatie Dynamo was al tweemaal het voorwerp van een oorlogsfilm. De eerste, de Britse film <strong>Dunkirk</strong> in zwart-wit, dateert van 1958. De film beklemtoont de solidariteit tussen militairen en burgers. De naam Churchill wordt slechts eenmaal genoemd, en dan nog eerder terloops. De film legt geen direct verband tussen Operatie Dynamo en Churchill. In 1958 was men zich in Engeland daar niet bewust van. De meer recente 2017-film <strong>Dunkirk</strong> van Chistopher Nolan, een Amerikaans-Brits-Frans-Nederlandse productie, blijft vooral stilstaan bij het militaire dimensie van Operatie Dynamo op het land en het strand, in de lucht en op de zee. Ook in deze film is de directe link met het initiatief van Churchill zoek.\nDe film <strong>Darkest Hour</strong> wint nog meer aan belang in het licht van enkele, belangrijke recente historische gebeurtenissen. In 2019 vierden de westerse landen 75ste verjaardag van D-Day (Operatie Overlord). De presidenten Trump en Macron vergaten tijdens hun speeches Winston Churchill te vernoemen. Nochtans was zonder hem er geen sprake geweest van een D-Day. In 2020 werd Brexit een feit onder het premierschap van Boris Johnson die het eerder al vermelde, mooie boek schreef over Winston Churchill. Met de Brexit misbruikte Johnson echter de Europese erfenis van Churchill. Die erfenis is trouwens eveneens een veelal vergeten gegeven in het Europese collectieve geheugen. Het politieke concept van een Verenigd Europa komt nochtans van Churchill. Hij sprak er al over in de jaren dertig van vorige eeuw en zag toen al Groot-Brittannië als de grote sponsor van dat nieuw Europa. Het verzwijgen van Churchills werk en bijdrage tot het ontstaan van de naoorlogse Europese Unie, werd gedeeltelijk rechtgezet door Felix Klos in diens studie ‘<em>Churchill on Europe. The Untold Story of Churchill’s European Project</em>’ (London, I.B. Taurus, 2016).</p>\n<p>In zijn historische rede van 14 mei 1947 in de Royal Albert Hall in Londen, rechtstreeks te volgen op de BBC-radio, had als titel ‘On an United Europe’. Daar zei hij het volgende:</p>\n<blockquote>\n<p><em>The influence and the power of Europe and of Christendom have for centuries shaped and dominated the course of history. We hope to reach again a Europa purged of the slavery of ancient days in which men will be as proud to say ‘I’m a European’ as once they were to say ‘ Civis Romanus sum’.</em> <a href=\"https://archive.org/stream/W.S.ChurchillOnAUnitedEurope1947/W.S.%20Churchill%20-%20%27%27On%20a%20United%20Europe%27%27%20%5B1947%5D_djvu.txt\">Bron</a></p>\n</blockquote>\n<p>Churchill werd de naoorlogse gangmaker voor de Europese beweging. Dit leidde tot de oprichting van de allereerste Europese organisatie De Raad van Europa. Churchills Europees engagement werd ook de inspiratiebron voor het belangrijke Marshallplan van de Amerikaanse General Marshall. Die verwees expliciet naar Churchill als zijn inspiratie. Zonder dat plan had de naoorlogse wederopbouw voor de bevolking van de bevrijde Europese landen in het Noorden en het Westen, een erg moeizaam verloop gekend.</p>\n<p><a name=\"LIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Links</strong></font></h2>\n<p><a href=\"http://www.churchillarchive.com\">Churchill Archive</a></p>\n<p><a href=\"https://www.nationaltrust.org.uk/chartwell\">Chartwell House</a></p>\n<p>Anthony McCarten, <em>Darkest Hour. How Churchill brought us back from the brink</em>. Pinguin Books. London, Pinguin Random House, 2017.</p>\n<p>Tim Bouverie, <em>Appeasing Hitler. Chamberlain, Churchill and the Road to War</em>. London, The Bodley Head (Vintage), 2019.</p>\n<p><font size=\"-2\">© Sylvain De Bleeckere, Men(S)tis, 2020</font></p>\n"}

/***/ }),
/* 995 */
/***/ (function(module, exports) {

	module.exports = {"title":"En waar de sterre bleef stille staan","body":"<center> \n<img src=\"kruisboot 300.jpg\" >\n</center>\n<a name=\"KLA\"></a>\n<h2><font color=\"#808000\"><strong>Klapbord</strong></font></h2>\n<p>Helemaal in de traditie van de Europese auteursfilm zet <em>de jonge Vlaamse regisseur Gust Van den Berghe</em> film in als een volwaardig artistiek medium waarvan hij al de middelen en mogelijkheden verkent om zijn eigen visie op mens en wereld uit te bdrukken. Dat blijkt uit zijn debuutfilm <strong>En waar de sterre bleef stille staan</strong> (2010). Het is zijn <em>afstudeerfilm</em> aan de Brusselse filmschool, het RITS, waarmee hij meteen de selectie haalde van het prestigieuze <em>Quainzaine des Réalisateurs</em> van het filmfestival Cannes 2010. In 2011 ontving hij <em>de Vlaamse Cultuurprijs voor Film voor 2010-2011</em>. Gust Van den Berghe heeft zijn eigenzinnige debuutfilm kunnen realiseren dankzij de creativiteit en de durf van het <em>Vlaamse productiehuis Minds Meet</em>. De film van Gust Van de Berghe is <em>een originele, filmische gedachtenis aan het oerchristelijke geboorteverhaal</em>. Daarbij heeft hij zich direct laten inspireren door de Vlaamse auteur <em>Felix Timmermans</em> (1886-1947). Het werk van de Lierenaar maakt deel uit van het Rijke Roomse leven in Vlaanderen dat zijn bloei kende in het interbellum en uitliep tot in de jaren vijftig van de vorige eeuw.</p>\n<p><a name=\"SYN\"></a></p>\n<h2><font color=\"#808000\"><strong>Synopsis</strong></font></h2>\n<p><em>Suskewiet, Pitje Vogel en Schrobberbeeck</em> zijn drie vrienden in een Kempisch dorp. Het zijn marginale figuren die jaarlijks in de kersttijd Driekoningen gaan zingen. Hun bedeltocht krijgt een ongewone wending in het jaar dat ze verdwalen en getuigen worden van een wonderlijke geboorte in een woonwagen. Suskewiet gelooft achteraf dat ze de geboorte van het Kindje Jezus hebben aanschouwd, zijn kompanen twijfelen. Maar het gebeuren grijpt hen zo aan dat ze alles wat ze bijeen hebben gebedeld en gezongen aan het arme gezin schenken. Dat is het verhaal van de eerste Kerstmis. Er volgt nog een tweede en een derde. In de tweede valt Suskewiet af. Hij is ziek en sterft, begeleid door het Kindje Jezus dat hem verschijnt. In de derde valt Pitje Vogel af nadat hij zijn ziel aan de duivel heeft verkocht en sterft. Schrobberbeek is de enig overlevende die met de ster <em>Driekoningen</em> gaat zingen. Hij kan niet vermoeden welke wonderlijke gebeurtenis zijn pad nog zal kruisen.</p>\n<p><a name=\"CIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Cinematografie</strong></font></h2>\n<p><span class=\"menstis\">FILMISCHE BEWERKING</span>. De Vlaamse filmtitel is dezelfde als <em>het mirakelspel van Timmermans</em>: <strong>En waar de sterre bleef stille staan</strong>. Het scenario van de film is gebaseerd op <em>een eigen bewerking</em> van het gelijknamige theaterstuk van Felix Timmermans. De authenticiteit van Van den Berghes driekoningenfilm bestaat inderdaad uit de originele manier waarop hij trouw blijft aan de geest van Timmermans’ werk en uit de wijze waarop hij die trouw weet te verbinden met de eisen van de <em>auteursfilm</em>. Van den Berghe transponeert het theaterstuk naar het eigen medium van de cinematografie. Zijn film is namelijk alles behalve verfilmd theater. Hij is authentiek beeldend denken.</p>\n<p><span class=\"menstis\">FILMGEDICHT</span>. Van den Berghe wil niet alleen vertellen om te vertellen, niet enkel het verhaal uitbeelden, hij wil <em>helemaal in de lijn van iemand zoals Andrei Tarkovski</em> de spirituele betekenis aan de oppervlakte brengen. Dat blijkt uit de bijzonder subtiele en poëtische manier waarop hij voor de toeschouwer het gordijn opent bij het begin van de film. ‘Poëtisch’ mag hier letterlijk worden genomen. Hij opent de film met <em>‘Gedicht’</em>, een tekst die hij zelf heeft geschreven en waarin hij concept van de film vertolkt.</p>\n<p><span class=\"menstis\">ZWART-WIT</span>. Gust Van de Berghe kiest bewust voor <em>een introverte, poëtische meditatie in zwart-wit</em>. De picturale look leunt dicht aan bij de zwart-wit fotografie uit de eerste helft van de twintigste eeuw. Bij die fotografie, zeker bij buitenopnames, zoekt het licht als het ware nog zijn weg door het donker. Beschouwd vanuit een huidig perspectief ademt een dergelijke zwart-wit fotografie <em>een sfeer van rouw</em>, van een fragment van het leven dat voorbij is gegaan en alleen als <em>gedachtenis</em> nog blijft voortbestaan.</p>\n<p><span class=\"menstis\">ACTEURS MET SYNDROOM VAN DOWN</span>. Het gedoofde licht huwt de gedoofde stem en die gedoofde stem weerkaatst de gedoofde geest. De beelden waarvan het natuurlijke licht is getemperd, stemmen overeen met de moeilijke en tevens moedige keuze van de regisseur om de belangrijke personages te laten spelen door mensen die lijden aan het syndroom van Down, dus mensen met een verstandelijke beperking.</p>\n<p><a name=\"BET\"></a></p>\n<h2><font color=\"#808000\"><strong>Betekenisruimte</strong></font></h2>\n<p><span class=\"menstis\">EIGENTIJDS MYSTERIESPEL</span>. Zijn filmische interpretatie, materieel gelimiteerd door beperkte financiële middelen, haalt <em>de spirituele en religieuze diepgang van Timmermans’ toneelstuk</em> naar de oppervlakte. Bij Timmermans zit die diepgang verscholen onder de oppervlakte van de volkse theateruitvoering. In de filmische voorstelling blijft die theaterenscenering achterwege. De kostumering is beperkt tot een minimum, het winterlandschap vormt het voornaamste decor. De drie hoofdpersonages komen centraal te staan. De cineast brengt hen op het voorplan. Hij vertrekt daarbij van de basisgegevens die Timmermans zelf aanreikt en bouwt daarop voort. Gust Van den Berghe gebruikt creatief al de filmische middelen die hij heeft om de drie personages als <em>een eenheid in verscheidenheid</em> uit te werken. Die eenheid betreft het hoofdthema: <em>de betekenis van het religieuze geloven eigen aan de mens</em>. Dat religieuze geloven betreft het christelijke getuigenis van Gods Geboorte als mens onder de mensen, het mysterie dat de kern vormt van <em>de gedachtenis eigen aan het feest van Kerstmis</em>. Die betekenis is niet neutraal. Ze raakt de persoon van de mens. Zijn gedachten, zijn gevoelens, zijn plannen, zijn voornemens, zijn beslissingen, zijn handel en wandel.</p>\n<p>. De regisseur werkt enkele sterke beeldmetaforen die de unieke betekenisruimte van de film kenmerken. Er in onder andere <em>het beeld met de drie schommels tussen de twee hoge bomen</em>. Dat beeld includeert <em>het drieledige Driekoningenverhaal</em>. De beeldmetafoor met de schommels opent een rijke betekeniswereld met een sterk religieuze en spirituele inslag. De heel lange koorden roepen het beeld op van de aardse navelstreng waarmee de drie figuren met het leven zelf zijn verbonden. Dat aardse leven toont zich in de kracht van de eiken reuzenbomen, met diepe wortels in de grond en hoge takken in de lucht. De plankjes bevinden zich net boven de grond. De plaats van de mens. Hij kan bewegen, hij schommelt tussen hemel en aarde. Dat is zijn wezen, dat vormt ook zijn tragiek. Net zoals zijn plaats in de tijd. Op het einde zijn de plankjes weg of verlaten. Iedere levensweg is eindig voor de mens en alles wat bij hem hoort, zijn zoektocht naar de zin van zijn leven incluis. Zijn spirituele weg. De weg van de Driekoningen Suskewiet, Pitje Vogel, Schrobberbeeck. Een andere beeldmetafoor is <em>de ster</em>. Er is de eenvoudige maar toch erg persoonlijke ster van Suskewiet. Zijn ster heeft 5 punten en verwijst naar de menselijke figuur (hoofd, twee arme, twee benen). In het derde deel verandert die ster in die van Schrobberbeek. Hij krijgt zijn ster van de figuur van de Verrezen Christus; het is een hemelse ster. Dat verklaart waarom ze zes punten heeft, een echte <em>Davidsster</em>, zichtbaar teken van de ontmoeting van hemel (God) en aarde (mens), en van aarde (mens) en hemel (God).</p>\n<p><a name=\"CON\"></a></p>\n<h2><font color=\"#808000\"><strong>Context</strong></font></h2>\n<p>Met de filmische bewerking van Gust Van den Berghe krijgt het theaterstuk van Timmermans een nieuw leven. De jonge cineast vindt in Felix Timmermans zijn zielsverwant. Zijn film <strong>En waar de sterre bleef stille staan</strong> vormt een gedachtenis aan het werk van Timmermans en via Timmermans aan die ontelbare dorpsmensen in Vlaanderen die in de zaal en op de scène het kerstspel hebben beleefd. Samen met de Nederlandse toneel- en romanauteur Eduard Veterman bewerkte de Lierenaar namelijk zijn novelle Driekoningentryptiek tot het theaterstuk <strong>En waar de sterre bleef stille staan</strong>. Het kerstspel ging in première op 5 februari 1925 in het Nederlandse ’s-Gravenhage (Den Haag). Het stuk kreeg in Nederland een goede pers, maar vond vooral bij het publiek grote bijval. Dat was nog meer het geval in Vlaanderen waar het in de kleinste parochiezaal is vertoond en op het repertoire stond van  ieder <em>Vlaams volkstheatergezelschap</em>. In de postmoderne traditie van de religieuze en spirituele cinematografie van auteurs als Tarkovski en Pasolini, is  <strong>En waar de sterre bleef stille staan</strong> een bij momenten geniale en uiterst originele gedachtenis van én aan het religieuze geloven. De hele film beweegt op het ritme van hemel en aarde. Daarbij speelt <em>de gedachtenis van het christelijke geloven</em> een inspirerende rol. <em>Gedachtenis</em> is bij uitstek verbonden met verbeelding die zich ent op een oorspronkelijkheid in de tijd. Welnu, het christendom vertrekt van het oorspronkelijke geloven dat de hemel naar de aarde komt. Dat is <em>de kern van de Kerstmis</em> die <strong>En waar de sterre bleef stille staan</strong> structureert.</p>\n<p><a name=\"LIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Links</strong></font></h2>\n<p>Sylvain De Bleeckere schreef een uitgebreid essay over de achtergrond van de film in relatie tot het werk van Timmermans, een cinematografische analyse van beeld, klank en structuur en een thematische verdieping van de betekeniswereld. Het essay verscheen als het eerste, uitgebreide deel van <em>Men(S)tis’ Studies # 1</em>. Klik <a href=\"http://www.menstis.be/blog/\">hier</a> voor een presentatie ervan.</p>\n<p><font size=\"-2\">© Sylvain De Bleeckere, Men(S)tis, 2011/2017</font></p>\n"}

/***/ }),
/* 996 */
/***/ (function(module, exports) {

	module.exports = {"title":"Dolls","body":"<center>\n<img src=\"dolls.jpeg\" >\n</center>\n<p><a name=\"KLA\"></a></p>\n<h2><font color=\"#808000\"><strong>Klapbord</strong></font></h2>\n<p>Met zijn film <strong>Dolls</strong> bereikt de Japanse regisseur Kitano Takeshi een esthetisch hoogtepunt in zijn zeer persoonlijk werk. In de loop van de jaren negentig van vorige eeuw heeft hij <em>een eigen oeuvre</em> geschapen waarmee hij is uitgegroeid tot een nieuwe grootmeester van de naoorlogse, Japanse cinema. In <strong>Dolls</strong> verwerkt hij op een originele manier de oude Japanse en tevens unieke traditie van <em>het bunraku-marionnettentheater</em>.</p>\n<p><a name=\"SYN\"></a></p>\n<h2><font color=\"#808000\"><strong>Synopsis</strong></font></h2>\n<p>De film opent met beelden van een opvoering van het bunraku-stuk <em>Meido no Hikyaku</em> (Boodschapper voor de onderwereld). Van de opvoering door het <em>Tokio National Theater</em> krijgen we zowel de uitvoerders als de toeschouwers te zien. De twee marionetten, <em>Chunei en Umegawa</em>, beheersen de scène. Omdat hun liefde voor elkaar maatschappelijk niet wordt aanvaard, beslissen ze samen te vluchten. Uit dit tafereel ontstaat <em>het filmische hoofdverhaal</em> dat zich in het heden afspeelt. Om elkaar niet te verliezen zijn <em>Matsumoto en Sawaka</em> aan elkaar vastgebonden. Voorbijgangers herkennen hen als <em>de gebonden bedelaars</em>. De jongen en het meisje houden erg veel van elkaar. Onder druk van zijn ouders verlaat Matsumoto zijn geliefde Sawaka en huwt de dochter van zijn baas. Op zijn trouwdag verneemt hij dat de treurende Sawaka bij een mislukte zelfdoding haar herinneringsvermogen is verloren. Zonder aarzelen verlaat Matsumoto het trouwfeest en haalt Sawaka weg uit de psychiatrische instelling. Zij herkent hem niet. Aan elkaar vastgeknoopt met een rode, dikke koord <em>dwalen ze zwijgzaam langs de wegen</em> om in het decor van een winters en besneeuwd berglandschap, samen te sterven, boven de afgrond hangend aan de tak van een boom. Het verhaal van Matsumoto en Sawaka is verweven met <em>twee nevenverhalen</em>. Dat van <em>Hiro</em>, de oude yakuza, die na dertig jaar zijn jeugdliefde <em>Ryoko</em> opzoekt. Al die tijd heeft de jonge vrouw iedere zaterdag op een bank in het park tevergeefs gewacht op haar verloofde die zich niet aan zijn woord van terugkeer heeft gehouden. Het tweede liefdesverhaal is dat van de jonge popster <em>Haruna</em> en haar fan <em>Nukui</em>. Na een ongeval met de auto trekt de zangeres zich terug uit het openbaar leven. Ze wil niet dat iemand die haar als populaire zangeres heeft gekend, haar geschonden gelaat ziet. Om zijn idool toch te kunnen benaderen, verminkt Nukui zich aan de ogen. De blinde Nukui slaagt erin de gekwetste Haruna te ontmoeten.</p>\n<p><a name=\"CIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Cinematografie</strong></font></h2>\n<p><span class=\"menstis\">BUNRAKU</span>. Het bijzondere perspectief is een van de bijzondere aspecten van de rijke cinematografie dat <strong>Dolls</strong> kenmerkt. Twee stilistische beslissingen dragen <em>de visuele poëzie van de sublieme esthetische visie</em> van Kitano. Allebei komen ze voort uit <em>het bunrakutheater</em>. Er is vooreerst <em>de structurele inclusie</em>. De film opent en eindigt met fragmenten uit de bunraku-voorstelling. Vooral het tafereel met de vluchtende Chunei en Umegawa werkt door de montage als <em>een spiegel</em> voor het verhaal van Matsumoto en Sawaka. Naast de structurele inclusie is er <em>de meesterlijke inversie van het blikveld</em>. Die inversie voltrekt zich in <em>de tweeledige proloog</em>. Eerst is er de introductie van de theatervoorstelling zelf met beelden van de scène met de marionettenspelers, het decor, de poppen en met beelden van de toeschouwers in de zaal. Gescheiden van het eerste deel door een zwart beeld, volgt het tweede proloogstuk. Op een volledig zwarte achtergrond verschijnen nu de <em>twee marionetten Chunei en Umegawa als zelfstandige personages</em>. Ze kijken zwijgend naar de camera die inzoomt. Kitano maakt in die beweging de overgang naar het eerste beeld van de twee zwervende hoofdpersonages Matsumoto en Sawaka. Dat betekent dat hij het verhaal in scène zet <em>vanuit het perspectief van de marionetten</em>. Niet de marionetten treden op voor de toeschouwers, maar de menselijke personages komen voort uit <em>de schouwende blik van de marionetten</em>. Met andere woorden, Kitano keert het perspectief om. De film sluit af met het beeld van de twee schouwende marionetten.</p>\n<p><span class=\"menstis\">KOSTUMERING</span>. De uitgesproken esthetische visie eigen aan <strong>Dolls</strong> materialiseert zich in de geniale kostumering. Deze is het werk van de internationaal befaamde Japanse modeontwerper <em>Yohji Yamamoto</em>. Hij ontwierp de kostuums op uitnodiging van Kitano en na de lezing van het scenario. Bij het zien van de kostuums overviel Kitano niet alleen een gevoel van verbazing. Hij begreep dat hij de hele film zou moeten herzien in functie van de sublieme ontwerpen van Yohji Yamamoto. Zo geschiedde. De ontwerper wilde met de kostuums <em>een surreële sfeer</em> scheppen. Kitano heeft dat gegeven filmisch uitgediept. De twee bedelaars, Matsumoto en Sawaka, zijn gekleed als zeer voorname personen. Hun gewaden vertonen feestelijke kleurencombinaties van geel, wit, rood en blauw. De gewaden zijn ook wijd en lang. Visueel integreert deze kleding zich in het stilistische concept van de film: <em>het omgekeerde perspectief van de marionetten</em>. Deze traditionele poppen dragen immers uiterst mooie en gestileerde stoffen. Aldus verschijnen Matsumoto en Sawaka vanuit het oogpunt van hun poppentegenhangers, Chunei en Umegawa.</p>\n<p><span class=\"menstis\">NATUURBEELDEN</span>. Een ander esthetische basiseigenschap van <strong>Dolls</strong> ent zich op de onvergetelijke natuurbeelden. De regisseur kadert het verhaal van de verbonden bedelaars in het verloop van de vier seizoenen. Hij integreert de eigen ruimtelijke poëzie van het Japanse klimaat in het verhaal van <em>de weg</em> die Matsumoto en Sawaka in de tijd afleggen. Ook al spelen de drie verhalen zich af in de huidige tijd, toch is de heersende tijd niet die van de mens, maar die van de natuur. Het is <em>een eerder kosmische tijd</em> waarin niet de logica van de vooruitgang, maar eerder die van <em>de golfbeweging en de metamorfose</em> primeert. Het hoofdverhaal opent onder de bloesemhemel van de eerste lentedagen en eindigt onder de donkere koepel van de diepe winternacht.</p>\n<p><span class=\"menstis\">HET ZWIJGEN</span>. Op dramatisch vlak tast Kitano de grenzen af van de stilte en het zwijgen. Het ritme van de film is inderdaad oosters traag en mediterend diep. Voor de geconditioneerde vluchtige blik van de westerse toeschouwer oogt <strong>Dolls</strong> bijna ondraaglijk traag. En toch is dat een verkeerde indruk, want door de kleurrijke afwisseling in kostuums en seizoenen, door de montage van de drie verhalen, door de talrijke flashbacks, flitsen van herinneringsbeelden, kent de film op spiritueel vlak zo een intense diepgang dat iedere actiescène à la Hollywood erbij verbleekt. Het cinematografische wonder dat Kitano hier realiseert, bestaat erin dat hij op geen enkel ogenblik angst heeft voor <em>de stille, zwijgende blik van de personages</em>. Tijdens hun tocht spreken Matsumoto en Sawaka niet met elkaar en toch zijn ze onlosmakelijk met elkaar verbonden. De afwisseling van close-ups van hun blikken die boekdelen spreken en van panoramische beelden van hun tocht door het landschap, wekt een dramatische spankracht op in het gemoed van de onthaaste toeschouwer.<a name=\"BET\"></a></p>\n<h2><font color=\"#808000\"><strong>Betekenisruimte</strong></font></h2>\n<p><span class=\"menstis\">OFFERBEELD</span>. Een eerste gegeven van de eigen betekenisruimte van <strong>Dolls</strong> ligt in <em>de tragiek</em>. Kitano spreekt in naam van de Japanse cultuur wanneer hij in een interview (Positif nr. 506) naar aanleiding van zijn film opmerkt dat de gekende zin ‘<em>en ze leefden nog lang en gelukkig</em>’ niet in de Japanse woordenschat voorkomt. En hij verduidelijkt: ‘<em>Wanneer je over liefde spreekt in een Japanse context, dan is er een onvermijdelijk element van zelfoffering bij.</em>’ Matsumoto kiest consequent voor Sawaka, terwijl Sawaka zich in de zelfdoding offert in naam van de liefde die haar en Matsumoto bindt. Ook in de andere, twee verhalen verstrengelen liefde en offer zich. Dergelijk beeld overheerst in het traditionele Japanse theater. Via de populaire bunrakustukken is het gegeven van twee geliefden die hun unieke liefde bezegelen in <em>een gemeenschappelijke zelfdoding</em> een vertrouwde voorstelling geworden. In een meer consumptiegerichte visie is <em>een dergelijk, spiritueel offerbeeld van de liefde</em> zonder meer onvoorstelbaar geworden.</p>\n<p><span class=\"menstis\">VERGEVING</span>. De esthetische betekenisruimte heeft ook <em>een bijzondere ethische dimensie</em>. De esthetische schoonheid staat bij Kitano helemaal niet in het teken van een estheticisme, evenmin als de esthetische kracht van de bunrakuvoorstelling opgaat in het oogverblindende spel van marionetten, woord en muziek. In de lijn van zijn andere films verkent Kitano zeker ook in <strong>Dolls</strong> <em>de ethische betekenisruimte</em> tussen mensen, in het bijzonder tussen mannen en vrouwen. <em>Ethiek en tragiek, geweten en spiriualiteit</em> versterken hier elkaar. Een van de weinigen zinnen die Matsumoto spreekt, luidt: ‘Vergeef mij.’ Ook in de scène met de laatste flashback, net voor de laatste sequenties in de winternacht, weent hij vanuit zijn intens schuldbesef. Kitano onderbouwt het aspect van <em>schuld en boete</em>, verbonden met dat van de <em>vergeving</em>, met <em>het visuele element van het kerkgebouw</em>. Een voor Japan atypisch gegeven. Het dramatische moment van Matsumoto’s beslissing om in plaats van te trouwen zijn weg te delen met de mentaal gebroken Sawaka, gebeurt tegen de achtergrond van <em>een nieuw, christelijk kerkgebouw</em>. Later komt het gebouw, nu verlicht in het avonddonker, nog een keer terug. Het grondgegeven van vergeving en berouw heeft verder ook <em>een autobiografische achtergrond</em>. Kitano steekt het in zijn interviews naar aanleiding van de film niet onder stoelen of banken dat hij spijt heeft van zijn vroeger negatief en destructief gedrag tegenover zijn toenmalige vriendin. In zijn vroege jaren heeft hij haar afgewezen en diep gekwetst. Hij vraagt haar en nog andere vrouwen letterlijk in en door zijn film om vergeving en, in de ruime zin, vraagt hij om vergeving aan al die vrouwen die door zoveel mannen in <em>hun gevoelens van liefde en offerzin</em> onpeilbaar en soms ontroostbaar diep zijn verwond. In die optiek verschijnt in de Japanse context het christelijk kerkgebouw als de religieuze ruimte waar berouw en vergeving een plaats krijgen. Het vormt een tegengewicht voor het traditionele Japanse gebruik dat schuld en boete eerder verwerkt via zelfdoding. De film heeft in die optiek een cultuurkritische insteek ten aanzien van de Japanse cultuurtraditie van de zelfdoding.</p>\n<p><a name=\"CON\"></a></p>\n<h2><font color=\"#808000\"><strong>Context</strong></font></h2>\n<p>Met zijn film <strong>Dolls</strong> brengt Kitano de toeschouwer in contact met een belangrijke traditie uit het Japanse theater. Het stuk dat hij in de film citeert, is van Japans grootste toneelauteur ooit, <em>Chikamatsu Monzaemon</em> (1653-1724). Hij is de Shakespeare van de Japanse toneelliteratuur. Maar Kitano doet nog meer. Hij huldigt de hedendaagse vertolkers van deze moeilijke, maar uiterst verheven kunst van de bunraku. In de openingssequenties die de proloog vormen, brengt hij deze uitvoerders in beeld. Hiermee brengt hij ook een hulde aan zijn vader en grootmoeder. Beiden waren ze meesters in de Japanse toneel- en danswereld. Zijn vader was meester in de traditionele Japanse danskunst en zijn grootmoeder bespeelde de traditionele muziekinstrumenten die onder andere in de bunraku worden gebruikt. Met <strong>Dolls</strong> houdt Kitano bij zijn jongerenpubliek een pleidooi om de erfenis van deze traditionle kunst niet verloren te laten gaan, maar ze op te nemen en zelf weer door te geven. In het huidige consumptieparadijs Japan worstelen de veeleisende traditionele kunsten immers met een tekort aan jonge mensen die het geduld en de wil tonen om zich te laten inwijden in die eeuwenoude en betekenisrijke theaterkunst. Met zijn film laat Kitano zien dat deze kunst iets heeft te zeggen aan jonge mensen van nu. Kitano laat met <strong>Dolls</strong> zien hoe de jonge traditie van de filmkunst een <em>metafmorfose</em> is van de oude theaterkunst. Hij benadert <em>de eigenheid van de cinematografie</em> niet vanuit een breuk met de kunsttraditie, maar eerder als <em>een voortzetting en zelfs als het bewaren van die traditie met nieuwe middelen</em>. Hier betekent ‘het bewaren’ niet zozeer het conserveren, maar wel het dynamisch herinterpreteren. Dit laatste gebeurt tijdens een noodzakelijke reflectie over de relatie met het eigen cultuurverleden, maar ook tijdens een persoonlijk moment van zingeving aan de eigen biografie.</p>\n<p><a name=\"LIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Links</strong></font></h2>\n<p>De Bleeckere, S., Claessens, S., <em>Dolls</em>, in CineMagie nr. 245 (winter 2003), 31-38.</p>\n<p><font size=\"-2\">© Sylvain De Bleeckere, Men(S)tis, 2011/2017</font>.</p>\n"}

/***/ }),
/* 997 */
/***/ (function(module, exports) {

	module.exports = {"title":"El sol del membrillo","body":"<center>\n<img src=\"sol.jpg\" >\n</center>\n<a name=\"KLA\"></a>\n<h2><font color=\"#808000\"><strong>Klapbord</strong></font></h2>\n<p>In de tweede helft van vorige eeuw heeft de Europese film heel wat blijvende meesterwerken voortgebracht. Tussen die meesterwerken vormt de Spaanse film <span style=\"color:blue\"><strong>El sol del membrillo</strong></span> een meesterwerk buiten categorie.</p>\n<blockquote>\n<p>Van het volkomen unieke karakter van het kunstwerk getuigt reeds zijn ontstaansgeschiedenis. Daarbij zijn twee Spaanse kunstenaars betrokken: de cineast <em>Victor Erice</em> (°1940), en de Spaanse kunstschilder en beeldhouwer, <em>Antonio Lopez Garcia</em> (°1936). Beiden vonden elkaar in hun gemeenschappelijke waardering van het waardevolle beeld dat diep verankerde zit in het leven zelf.</p>\n</blockquote>\n<blockquote>\n<p>De eerste aanzet van hun gemeenschappelijk project dateert van de <em>zomer van 1990</em>. Antonio vertelde Victor dat hij op het punt stond om de kweeperenboom in zijn kleine stadstuin te schilderen. Hij had die eerder gepland als herinnering aan zijn ouderlijk huis waar in de tuin een kweeperenboom stond. Hij droomde soms van dat huis met de boom. Met die basisgegevens beslisten beide mannen samen aan het werk te gaan, de een met het penseel, de ander met de filmcamera in de hand.</p>\n</blockquote>\n<blockquote>\n<p>Zonder enige leidraad of geschreven scenario, begonnen ze op <em>29 september 1990</em> bij de boom hun gemeenschappelijk artistiek project. Van dan af leefden en werkten ze in de herfst tot aan het begin van de winter in de nabijheid van de boom. Hun laatste werkdag vond plaats op <em>11 december</em>.</p>\n</blockquote>\n<blockquote>\n<p>In de film speelt <em>Antonio Lopez Garcia</em> de hoofdrol. ‘Spelen’ is hier oneigenlijk gebruikt. De schilder acteert niet, hij schildert, hij is gewoon zichzelf. Zijn echtgenote, <em>Maria Moreno</em>, komt ook voor in de film en is tevens co-producente.</p>\n</blockquote>\n<blockquote>\n<p><span style=\"color:blue\"><strong>El sol del membrillo</strong></span> kende zijn wereldpremière tijdens het <em>Cannes Filmfestival 1992</em> waar Victor Erice de FIPRESCI Prijs en de Prijs van de Jury mocht ontvangen.</p>\n</blockquote>\n<p><a name=\"SYN\"></a></p>\n<h2><font color=\"#808000\"><strong>Synopsis</strong></font></h2>\n<p>[In voorbereiding]</p>\n<p><a name=\"CIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Cinematografie</strong></font></h2>\n<p><span style=\"color:darkkhaki\"></span></p>\n<p>[In voorbereiding]\n<a name=\"BET\"></a></p>\n<h2><font color=\"#808000\"><strong>Betekenisruimte</strong></font></h2>\n<p>[In voorbereiding]</p>\n<p><a name=\"CON\"></a></p>\n<h2><font color=\"#808000\"><strong>Context</strong></font></h2>\n<p>[In voorbereiding]</p>\n<p><a name=\"LIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Links</strong></font></h2>\n<p>[In voorbereiding]</p>\n<p><font size=\"-2\"> © Sylvain De Bleeckere, Men(S)tis, 2018.</font></p>\n"}

/***/ }),
/* 998 */
/***/ (function(module, exports) {

	module.exports = {"title":"Goddess of 1967","body":"<center>\n<img src=\"goddess67.jpg\" >\n</center>\n<p><a name=\"KLA\"></a></p>\n<h2><font color=\"#808000\"><strong>Klapbord</strong></font></h2>\n<p><strong>The Goddess of 1967</strong> van Clara Law ontving in 2000 tijdens <em>het Festival van Venetië</em> de prijs van de beste vrouwelijke vertolking voor Rose Byrne. Niettegenstaande die erkenning, is <strong>The Goddess of 1967</strong> in Vlaanderen en Nederland slechts door een kleine groep toeschouwers gezien. Onterecht, want met deze prent bewijst de jonge cineaste uit Macau (China) die in Australië woont, dat <em>het genre van de spirituele film</em> actuele en onmisbare beelden maakt. Een belangrijke inspiratiebron voor haar is het werk van <em>Andrei Tarkovski</em>.</p>\n<p><a name=\"SYN\"></a></p>\n<h2><font color=\"#808000\"><strong>Synopsis</strong></font></h2>\n<p>JM (Deirdre) en BG, dat zijn de namen van de twee protagonisten. Beide personages leven elk in een verschillende cultuur: de Aziaat JM leeft in de metropool Tokio, terwijl BG een blanke, Australische is die als kind is opgegroeid in het desolate, uitgestrekte Australische landschap van Lightning Ridge en White Cliff. De twee vinden elkaar in Australië door toedoen van een bijzondere auto, <em>de Citroen DS van 1967</em>. In deze auto bewegen JM en BG door het uitgestrekte Australische landschap. Ze zijn onderweg. De weg is hun thuis. JM wil de auto kopen en BG gidst de jongen naar de eigenaar, althans dit is wat BG de jongen wijsmaakt. Ze loodst zichzelf en haar Japanse chauffeur naar niemand minder dan <em>haar vader</em>. Het eindpunt wordt voor beide jonge mensen een nieuw vertrekpunt.</p>\n<p><a name=\"CIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Cinematografie</strong></font></h2>\n<p><span class=\"menstis\">TAOÏSTISCH SCENARIO</span>.Regisseur Clara Law schreef zelf het scenario van <strong>The Goddess of 1967</strong>samen met haar levensgezel Eddie L.C. Fong die tevens coproducent is van de film. Het filmverhaal heeft een origineel plot. Die originaliteit ent zich op de twee jeugdige hoofdpersonages die via <em>een rijke taoïstische (yin/yang) uitwerking</em> - oosters/westers, ziend/blind, man/vrouw, stad/platteland - reliëf krijgen. Clara Law ontleent de stof aan haar eigen ervaringen en haar kijk op de wereld van de jonge generaties die aan het begin van het nieuwe, derde millennium leven in een zich globaliserende, postmoderne wereld. <em>Het narratieve</em> staat in de film niet op de voorgrond. Law vertelt geen verhaal om de toeschouwer te onderhouden. Het verhaal zelf is eerder secundair; de nadruk ligt op de tekening van de twee bijzondere personages en op de cinematografische kwaliteit van de beelden.</p>\n<p><span class=\"menstis\">ROADMOVIE</span>. Na een kort inleidend deel in Tokio, krijgt <strong>The Goddess of 1967</strong>, eens in Australië, het karakter van <em>een roadmovie</em>. Dan wordt het meisje het hoofdpersonage. Dankzij een bijzonder gebruik van de camera verschijnt <em>het landschap</em> dat zich via de weg openbaart, eveneens als een apart hoofdpersonage. De rode kleur van de aarde reflecteert zich in het haar van BG. Law gebruikt de camera om de landschappelijke elementen van de horizon, de kleurrijke wolken, de sublieme sterrenhemel te profileren. Deze cinematografie van het landschap bereikt hier sublieme momenten. Ze huldigen de unieke Australische natuur, maar ze dienen vooral de inhoudelijke strekking van deze bijzondere roadmovie. Vooral door in sommige sequenties gebruik te maken van <em>de bleach-bypass techniek</em>, toegepast op het negatief van de film, vermijdt Law toeristisch ogende shots en vindt ze haar eigen cinematografische signatuur.</p>\n<p><span class=\"menstis\">FUGA IN TWEE TIJDEN.</span> Een ander opvallend cinematografisch kenmerk van <strong>The Goddess of 1967</strong> komt aan het licht via <em>de flashbacksequenties</em>. De montage steunt op de ritmische afwisseling tussen de scènes die zich in het heden afspelen en de andere die duidelijk in het recente verleden zijn gesitueerd. Hierdoor realiseert de film esthetisch een eigen tijdsbeleving. In het heden verloopt de tijdslijn chronologisch, terwijl juist door voorwaarts in de tijd en langs de weg te bewegen, de personages zelf steeds verder teruggaan in de tijd. De regisseur laat de film evolueren als <em>een fuga met twee bewegingen in de tijd</em>: ze drijven elkaar aan en houden tegelijk elkaar in evenwicht volgens <em>het yin-yang principe</em> met aandacht voor de zowel reële als spirituele wisseling van licht en donder in vele variaties, ook soms in één beeld of één sequentie.</p>\n<p><span class=\"menstis\">BEELDSPRAAK</span>. Law ‘schrijft’ in <strong>The Goddess of 1967</strong> een cinematografische poëzie met <em>een sterk uitgewerkte beeldspraak</em>: de dieren, de revolver, de DS, de satelliettelefoon, de oude boom, de mijnschacht, de kuisheidsgordel, de vervallen kerk, de dans, de wijn en het brood.</p>\n<p><a name=\"BET\"></a></p>\n<h2><font color=\"#808000\"><strong>Betekenisruimte</strong></font></h2>\n<p><span class=\"menstis\">POSTMODERNE CULTUUR.</span> Clara Law ontwikkelt in haar oeuvre en zeker in <strong>The Goddess of 1967</strong> een heel persoonlijke kijk op <em>de zich globaliserende mens en diens postmoderne cultuur</em>. Ze gebruikt diverse genres van muziek, ze mengt ernst met humor en een flinke knipoog naar de postmoderne semiotiek van Roland Barthes. Daarbij legt ze consequent de nadruk op <em>de spirituele grondtoon</em> van het menselijk bestaan, die zich toont in <em>het streven naar zingeving</em>.</p>\n<p><span class=\"menstis\">NOMADISCH LEVENSGEVOEL</span>. Eén van de sterke cinematografische elementen is de evocatie van <em>het postmoderne nomadische levensgevoel</em>. Dat gebeurt niet op een modieuze en dus oppervlakkige wijze. Via haar eigen cinematografie peilt ze in <strong>The Goddess of 1967</strong> naar de diepere achtergronden van dat existentiële  grondgevoel dat niet meer gebonden is aan een welbepaalde cultuur of een bepaalde plek. Daarbij blijft Law niet steken in een zuiver interculturele of multiculturele retoriek. Ze overstijgt de intellectuele multiculti-mode en exploreert het spirituele leven van vooral de millenniumgeneratie die is opgegroeid met de eerste huiscomputers. Clara Law evoceert de wereld op van de metropool en de hightech van de communicatiemachines, de ‘natuurlijke’ biotoop van ontelbare jonge mensen over heel de wereld. Die biotoop is ondertussen ook uitgegroeid tot die van de meeste volwassenen en ouderen.</p>\n<p><span class=\"menstis\">GODDELIJKE BEELDSPRAAK.</span> De beeldspraak van de auto in <strong>The Goddess of 1967</strong> past in de postmoderne setting. JM verstuurt in het begin van de film een e-mail met als inhoud: ‘<em>I want to buy God</em>’. De bewuste auto wordt namelijk '<em>la déese</em>&quot; (DS) genoemd. Door met dit gegeven te spelen, opent Law een betekeniswereld met <em>een religieus-spirituele strekking</em>. In de wereld van JM ‘is God dood’, dit wil zeggen: Hij is nu een auto, een designproduct, een consumptievehikel met een mythische status. Dat gaat gepaard met een spirituele leegte en een cultuur van verveling. Het wonderlijke van Laws film bestaat erin dat juist het blinde meisje BG de jongen de open ruimte van het landschap en de diepte van het menselijke hart leert kennen: de wolken, de sterren, de dorre woestijn, even zoveel beeldende expressies die elk een elk een beeldend verhaal vertellen.</p>\n<p><span class=\"menstis\">METAFOOR KERKGEBOUW.</span> Het lege houten kerkgebouw vormt in <strong>The Goddess of 1967</strong> een belangrijk onderdeel van de ‘goddelijke beeldspraak’. Deirdres moeder, Mary, zelf slachtoffer van kindermisbruik, komt er nog bidden wanneer de wanhoop haar overvalt. Wanneer ze ontdekt dat haar eigen vader die tevens haar man is, ook nog hun dochtertje misbruikt, neemt ze de kleine Deirdre mee naar de vervallen kerk. Ze dwingt het meisje te bidden om zich via God te reinigen. De moeder, zelf slachtoffer, predikt over de fundamentele schuld van Eva. Wanneer Mary vaststelt dat Deirdre niet in haar verwrongen logica stapt, pleegt ze zelfmoord door de kerk in brand te steken en zich bewust over te geven aan de vlammen. De terugkeer naar haar nog levende vader die in zijn eigen waanzin leeft en in zijn zelf uitgegraven mijnschacht woont, is voor Deirdre <em>het doel van haar spirituele reis</em>, de weg waarlangs ze zichzelf bevrijdt van de beschaving zonder religieuze ziel. Ook voor de Japanse hacker die JM uiteindelijk blijkt te zijn, vormt de reis <em>een spirituele bevrijding</em>. Hij slaagt erin afstand te doen van zijn materialistische waarbeeld waarin ‘de auto’ een hogere waarde vormt dan een levende mens. Door mee te reizen met de blinde Deirdre ontdekt hij voor het eerst <em>de onbetaalbare schoonheid van het landschap, de onvergankelijke betekenis van de sterrenhemel, de poëzie van de dans en de tederheid van de liefdevolle aanraking</em>. Tegelijkertijd geneest de liefde van de jongen voor haar Deirdre van haar dwang om zich te wreken op haar schuldige (groot)vader die ze wil vermoorden. In die overwinning op zichzelf maakt ze het mogelijk om samen met JM aan een nieuwe weg te beginnen. De auto is nu hun gemeenschappelijke thuis, hun verworven eigendom. De <em>goddelijkheid</em> steekt niet meer in de machine zelf, maar in hun onderlinge sterke band die hen allebei in beweging heeft gezet en in beweging houdt. Met <strong>The Goddess of 1967</strong> geeft Clara Law stem aan een belangrijk segment van <em>de jong volwassenen aan het begin van het derde millennium</em>. In een interview met CineMagie verduidelijkt Law haar visie als volgt: '<em>Eigenlijk moet je je afvragen of er nog wel plaats is in onze samenleving voor fundamentele vragen of je nu vrouw of man bent. Vragen zoals ‘Wie ben ik? Waar kom ik van? Waarom ben ik hier? Waar gaan we na onze dood naartoe?’ Zeer fundamentele kwesties omdat we allemaal ‘born to die’ zijn. Die vragen komen nog nauwelijks – ook niet in Australië waar ik nu leef – aan bod in films of boeken.’</em> <strong>The Goddess of 1967</strong> is alvast een mooie uitzondering.</p>\n<p><a name=\"CON\"></a></p>\n<h2><font color=\"#808000\"><strong>Context</strong></font></h2>\n<p>Clara Law formuleert vooral via de flashbacksequenties van <strong>The Goddess of 1967</strong> een scherpe tijds- en cultuurkritiek. Zij verdicht dat in <em>het portret van de grootvader van BG</em>, de man die tevens haar vader is. De beeldspraak van ‘God’ krijgt ook hier weer inhoud omdat de man in kwestie beweert dat hij als ‘een god’ kan heersen over wat hem toebehoort. Na de dood van zijn vrouw, pleegt hij incest met zijn eigen dochter en nadien met zijn kleindochter, Deirdre. Hij leeft als een onmens. Hij blijkt een gewezen hippie te zijn die de donkere terreur van de toenmalige slogan van ‘de vrije liefde’ aan het licht brengt. Law laat zien dat de generatie van de optimistische jaren zestig - zie het jaartal 1967 in de titel - vooral een consumptiewereld heeft voortgebracht waarin de mens zelf voor god speelt, met als resultaat: de dramatische verdwijning van iedere zin voor spiritualiteit en religiositeit.</p>\n<p><a name=\"LIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Links</strong></font></h2>\n<p>De Bleeckere, S., 2002. <em>The Goddess of 1967</em>, in: CineMagie nr. 239, 7-12. / Sartor, F., 2002. The <em>The Goddess of 1967.</em> Recensie en interview, in: CineMagie nr. 239, 13-16.</p>\n<p><font size=\"-2\">© Sylvain De Bleeckere, Men(S)tis, 2011/2017</font>.</p>\n"}

/***/ }),
/* 999 */
/***/ (function(module, exports) {

	module.exports = {"title":"Des hommes et des dieux","body":"<center>\n<img src=\"hommes.jpg\" >\n</center>\n<p><a name=\"KLA\"></a></p>\n<h2><font color=\"#808000\"><strong>Klapbord</strong></font></h2>\n<p>De film <strong>Des hommes en des dieux</strong> van Xavier Beauvois kende zijn wereldpremière in de officiële selectie van het prestigieuze Festival van Cannes 2010 en werd er bekroond met de <em>Grote Prijs van Cannes 2010</em> en <em>de Prijs van de Oecumenische jury</em>. En naast de ruime publieke belangstelling voor deze ingetogen film kwam daar in februari 2011 nog <em>de Prijs van Beste Europese Film 2010</em> bovenop, uitgereikt door Signis, de internationale katholieke organisatie voor radio, film en televisie. Afgevaardigden van 26 verschillende Europese landen brachten hun stem uit. Ook ontving de film in Frankrijk <em>de Prix de l’Education 2010</em>, uitgereikt door het Ministerie van Onderwijs. Maar ook de filmpers- en kritiek, los van de ideologische voorkeuren, konden de film naar waarde schatten.</p>\n<p><a name=\"SYN\"></a></p>\n<h2><font color=\"#808000\"><strong>Synopsis</strong></font></h2>\n<p>De plaats van het gebeuren is <em>het klooster van Onze-Lieve-Vrouw van de Atlas in Tibhirine (Algerije)</em> in de jaren negentig van vorige eeuw. Dit klooster van de Franse trappisten van de orde van de cisterciënzers van de strikte observantie (O.C.S.O.) wordt dan geleid door prior Christian de Chergé. Onder zijn leiding is er een hechte band gegroeid met de plaatselijke moslimbevolking. Dat komt mede door het werk van de monnik-geneesheer Luc Dochier. Hij runt in het klooster het enige medische kabinet dat Tibhirine rijk is. Alles verloopt vredig. Dat verandert tijdens de middernachtmis van Kerstmis 1993. Dan worden de monniken voor het eerste geviseerd en bedreigd door moslimterroristen (GIA). Van dan af leven de kloosterlingen in spanning over de prangende vraag of ze moeten blijven of moeten vertrekken. Ze doorlopen elk afzonderlijk een proces maar beslissen in groep te blijven tot ze door dezelfde terroristen in de nacht van 27 maart 1996 worden ontvoerd. Ze worden als gijzelaars meegenomen maar worden de volgende meimaand <strong>vermoord</strong> teruggevonden.</p>\n<p><a name=\"CIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Cinematografie</strong></font></h2>\n<p><span class=\"menstis\">DOCUDRAMA</span>. <strong>Des hommes et des dieux</strong>  is een in memoriam film. Een <em>gedachtenisfilm</em>. De regisseur Beauvois neemt de toeschouwers mee naar de dramatische gebeurtenissen waarbij zeven monniken van Tibhirine hun leven verloren. Het scenario is <em>een reconstructie van de historische gebeurtenissen</em>, een docudrama. Daarbij kon de regisseur steunen op talrijke bronnen en twee kroongetuigen. De twee monniken, Jean-Pierre Schumacher, de nachtportier en Amédée Noto, een medestichter van het klooster in 1939, die in de nacht van de ontvoering op 27 maart 1996, circa 01u15, niet werden meegenomen, zijn kroongetuigen geworden van het leven en het werk van de monniken in Tibhirine. Tot die groep behoren de zeven trappisten die op 21 mei 1996 omgekomen zijn:  prior Christian de Chergé (59 jaar), de monniken Luc Dochier (82 jaar), Christophe Lebreton (45 jaar), Michel Fleury (52 jaar), Bruno Lemarchand (66 jaar), Célestin Ringeard (62 jaar) en Paul Favre-Miville (57 jaar).</p>\n<p><span class=\"menstis\">MUZIEK</span>. Beeldend vertolkt <strong>Des hommes et des dieux</strong> de authenticiteit van de monniken in Tibherine via talrijke sequenties waarin de muziek centraal staat.  Er zijn <em>de religieuze gezangen</em> die de acteurs-monniken zelf vertolken. In chronologische volgorde betreft het de volgende religieuze gezangen: <em>Seigneur, Ouvre mes Lèvres; Puisqu’Il Est Avec Vous; Psaume 142; Dieu, Viens A Mon Aide; Nous Ne savons Pas Ton Msytère; En Toi Seigneur Nos Vies Reposent; Cantique De Siméon; Voici la Nuit; Salve Regina; O Père Des Lumières.</em> Die liturgische gezangen dienen niet alleen om <em>het geregelde contemplatieve leven</em> van de monniken te evoceren. Het gaat verder. Het zijn ook <em>gebeden</em> die de biddende ziel van de kloostergemeenschap die in bijzondere omstandigheden leeft, doen weerklinken. Voor hen zijn de gezongen en gesproken gebeden, geen rituelen die omwille van zichzelf worden herhaald. Die gebeden in groep vormen de gedachtenis zelf van de groep. De monniken dalen bij het zingen en spreken van de gebeden als het ware af in die diepte zelf van hun gedachtenis, de kern van hun leven, hun roeping: <em>de gedachtenis aan het mysterie van God, dat ze uitzingen</em>. Dat blijkt bijvoorbeeld wanneer ze bij het begin van de viering van de middernachtmis van 1993 in de kloosterkapel samen <em>Voici la nuit</em> zingen_._ In een cruciale scène weerklinkt er ook ‘<em>profane’ muziek</em>. Het betreft de geniale scène waarin de monniken, op initiatief van broeder Luc, hun beslissing te blijven, vieren in de refter. Ze drinken zwijgend een glas rode wijn terwijl ze luisteren naar het moderato van _het Opus 20 van Tsaikovsky, <em>Het Zwanenmeer</em>. De muziek verwijst naar het begin van de tweede act. Het hoofdpersonage prins Siegfried ontdekt het zwanenmeer en de betoverde zwaankoningin Odette. Het is een poëtische, muzikale dansmetafoor, hier opgenomen in een religieus drama. Het zwanenmeer is een metafoor van het menselijke verdriet. In dat meer zullen de prins en Odette bewust verdrinken omdat ze niet meer kunnen ontsnappen aan de magie van de duivelse tovenaar Von Rothbart en zijn instrument, de zwarte zwaan, behalve… door samen te sterven. Tegelijkertijd weerklinkt in het moderato ook de innerlijke vreugde om de ontmoeting met de witte zwaan; voor de monniken is dat hun diep Christusgeloof die hun motivatie voedt om te blijven.</p>\n<p><span class=\"menstis\">LANDSCHAP</span>. <strong>Des hommes et des dieux</strong> maakt gebruik van de natuurlijke soundscape van het Marokkaanse berglandschap waar de film is opgenomen. Het geluid van de natuur is die van de zwijgende of ‘sprekende’ wind. Dat stemt overeen met de levenswijze van de monniken die dicht bij de natuur leven: ze voorzien immers in hun eigen voedsel, ze kweken schapen en telen groenten. Prior Christian mediteert niet alleen in de kapel van het klooster, maar ook midden de grote kathedraal van het  Marokkaanse natuurlandschap. De cruciale scène met pater Christian en pater Christophe die vecht om zijn angst voor een gewelddadige dood te overstijgen, speelt zich af in dat landschap.</p>\n<p><a name=\"BET\"></a></p>\n<h2><font color=\"#808000\"><strong>Betekenisruimte</strong></font></h2>\n<p><span class=\"menstis\">EEN EIGENTIJFDE INTERPRETATIE VAN HET MONNIK-ZIJN.</span> De gedachtenis waarin de monniken van Tibhirine onder leiding van prior Christian de Chergé zich bewogen, zo blijkt uit <strong>Des hommes et des dieux</strong>, werd gevoed door de manier waarop zij de eigen waarheid van de christelijke religie wilden gedenken. Geworteld in de eeuwenoude contemplatieve monastieke traditie, peilden ze intellectueel en pastoraal naar de betekenis van een christelijk leven. Ze begrepen dat het rigoureus herhalen van strenge regels niet voldeed om ‘monnik’ te zijn. In feite beleefden ze <em>het monnik-zijn als een weg om de betekenis van het christen-zijn te exploreren en te beoefenen</em>. Dat vroeg van hen voortdurend <em>een wakker bewustzijn</em>. Ze accepteerden de bijzondere omstandigheden in tijd en ruimte waarin ze zich bevonden en waarvoor ze bewust hadden gekozen.</p>\n<p><span class=\"menstis\">DIOLOOG MET DE ISLAM</span>. Prior Christian heeft zich verdiept in de Koran, hij kon Arabisch lezen en spreken. Dat wordt in de film ook duidelijk getoond. Voor prior Christian verscheen <em>de ‘gans andere’ (Levinas) ook met het gelaat van de GIA, het gelaat gewapend met agressie en haat</em>. Pater Christophe heeft het meest geworsteld met dat gewelddadige gelaat van de ‘gans andere’. Dat blijkt uit zijn dagboeken die ook een belangrijke bron vormden voor zijn personage in <strong>Des hommes et des dieux</strong>.</p>\n<p><span class=\"menstis\">MARTELAARSCHAP</span>. Een belangrijk gegeven in <strong>Des hommes et des dieux</strong> is de overweging over het martelaarschap. Prior Christiaan geeft ieder van zijn medebroeders de tijd om vrij na te denken over de vraag om te blijven of te vertrekken. Daarbij wisten ze dat ‘blijven’ het risico van het martelaarschap inhield. Zij hebben in groep gekozen om te blijven maar niet omwille van het martelaarschap. De film laat helemaal trouw aan de geest van de vermoorde monniken zien hoe ze in hun overwegingen en hun besluit vertrekken van <em>de christelijke kerstgedachtenis</em>. Die staat helemaal in het teken van de radicale keuze van een geweldloze beleving van de christelijke religie en in se van iedere religie. Die <em>hedendaagse postmoderne taal en gedachte</em> liggen in de lijn van hedendaagse Franse filosofen, met name van Levinas wiens werk prior Christiaan grondig had bestudeerd, alsook van Jacques Derrida. <em>De pacifistische religieuze beleving</em> impliceert een deconstructie van de eeuwenoude koppeling van religie en agressie. Religieuze beleving, verkondiging, verdediging steunden bijna vanzelfsprekend op een constructie van geweld, intellectueel en verbaal geweld, militair en bloedig geweld. De monniken van Tibhirine hebben die deconstructie ervan intellectueel, spiritueel en religieus voltrokken.</p>\n<p><a name=\"CON\"></a></p>\n<h2><font color=\"#808000\"><strong>Context</strong></font></h2>\n<p><strong>Des hommes et des dieux</strong> werpt een bijzonder licht op een gebeuren dat misschien in 1996 als anekdotisch en plaatselijk werd gezien, maar dat vanuit een hedendaags wereldperspectief <em>profetisch</em> mag worden genoemd. Dat is het gepaste label voor het levenswerk, bezegeld met hun gewelddadige dood, van de Tibhirine-monniken. De gedachtenis die <strong>Des hommes et des dieux</strong> realiseert, vindt haar profetische dimensie met een anker in <em>de hedendaagse geschiedenis</em>. In 1996 kon nog niemand vermoeden wat er op <em>11 september 2001 zich in Manhattan en nadien</em> in Parijs, Brussel, Londen enzovoort zou voordoen. Toen de Twin Towers neerstortten, vond de geschiedenis even geen adem meer. Al Qaida, het brein achter het terroristische <em>moslimfundamentalisme</em>, triomfeerde. Een nieuwe periode van religieus fanatisme en martelaarschap was begonnen en groeide uit tot het kalifaat van IS. Nochtans vormt de geslaagde aanslag op de twee torens van Manhattan retrospectief gezien het dramatische hoogtepunt van een ontwikkeling die de monniken van Tibhirine vanaf de eerste rij hebben meegemaakt. Zij ervoeren als eerste westerlingen het proces van radicalisering dat zich binnen de moslimwereld aan het voltrekken was en dat tevens gepaard ging met een hevige antiwesterse haatcampagne. De ontwikkelingen in Algerije waren representatief voor een brede stroming binnen de moslimlanden. De monniken wilden met hun werk en hun leven getuigen dat wat zou komen <em>niet de enige en ook niet de juiste oplossing zou zijn voor het mondiaal samenleven van culturen en religies</em>.</p>\n<p><a name=\"LIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Links</strong></font></h2>\n<p>Sylvain De Bleeckere schreef een uitgebreid essay over de historische bronnen van het docudrama, de eigen verstilde cinematografie en de thematische verdieping van de betekeniswereld die zowel handelt over de postmoderne interpretatie van het monnikenwezen als over het pacifisme en de religies in gespannen relatie tussen het christendom en de islam. Het essay verscheen als het derde, uitgebreide deel van <em>Men(S)tis’ Studies # 1</em>. Klik <a href=\"http://www.menstis.be/blog/\">hier</a> voor een presentatie ervan.</p>\n<p><font size=\"-2\">© Sylvain De Bleeckere, Men(S)tis, 2011/2017</font></p>\n"}

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

	module.exports = {"title":"Ida","body":"<center>\n<img src=\"Ida.jpg\" >\n</center>\n<p><a name=\"Ida\"></a></p>\n<h2><font color=\"#808000\"><strong>Klapbord</strong></font></h2>\n<p>Met <strong>Ida</strong> bevestigt Pawel Pawlikowski zijn unieke plaatst in het landschap van de Europese film. In 2013 won hij ermee de Best Film Award van het London Film Festival en in 2015 mocht hij in Los Angeles de Academy Award (Oscar) for Foreign Language Film in ontvangst nemen. In 2014 kreeg hij al de LUX Film Prize van het Europese Parlement uitgereikt in het Europees Parlement te Straasburg. In <strong>Ida</strong>, waarvoor hij zelf samen met de Britse toneelauteur Rebecca Lenkiewicz het scenario schreef, verwerkt Pawlikowski zijn eigen Poolse en katholieke achtergrond. Hij werd in 1957 geboren in de Poolse hoofdstad Warschau, maar als tiener emigreerde hij samen met zijn moeder naar het vrije Europa, eerst in Engeland, dan in West-Duitsland en uiteindelijk definitief in Engeland. Ze verlieten het Polen van de Koude Oorlog, de toenmalige satellietstaat van de communistische Sovjet-Unie. Toch kreeg hij in dat communistische Polen een katholieke opvoeding. Hij beschouwt zichzelf nog steeds als een katholiek gelovige. In zijn late tienerjaren vernam hij dat zijn grootmoeder langs vaderszijde Joods was en in Auschwitz wad omgekomen. Deze elementen uit zijn biografie vormen de grondstof voor zijn persoonlijk verhaal dat <strong>Ida</strong> heet. Met de film keert Pawlikowski letterlijk terug naar het Polen van zijn kindertijd in het jaar 1962.</p>\n<p><a name=\"SYN\"></a></p>\n<h2><font color=\"#808000\"><strong>Synopsis</strong></font></h2>\n<p>Anna is een Poolse, jonge vrouw. In 1962  beëindigt ze haar opleiding als novice, aspirant-zuster, in een vrouwenklooster.\nDaar is ze als weesmeisje opgevangen en opgegroeid. Nu is ze op het punt gekomen om haar eeuwige geloften als kloosterzuster af te leggen.\nJuist dan verneemt ze via haar overste, een moederfiguur voor Anna, tot haar grote verwondering dat ze toch nog een familielid heeft, een tante.\nZe heet Wanda. Via de moeder overste verzoekt ze Anna om haar te komen opzoeken.\nDat bezoek aan haar tante in de naburige stad vormt voor Anna het begin van een even innerlijke als biografische reis naar zichzelf.\nDie innerlijke reis is tevens een gedachtenreis in het complexe oorlogsverleden van Polen.\nDoor toedoen van Wanda verneemt Anna dat haar echte naam Ida Lebenstein is en dat ze geboren is\nals Joodse dochter van Haïm Lebenstein en Róza Herc, de artistieke zus van Wanda. Met haar tante Wanda\nals gids bezoekt Ida de voormalige ouderlijke boerderij en leert ze de huidige, Poolse bewoners ervan, de Skiba’s, kennen.\nVia dat spoor ontdekken Wanda en Ida het verborgen graf van haar ouders én van het enige zoontje van Wanda zelf.\nZe leefden alle vier ondergedoken voor de ouders nabij hun huis dat ze aan Poolse mensen hebben moeten overlaten.\nWanda en Ida ontdekken dat de zoon die nu het huis bewoont, uit vrees voor de Duitsers de ouders van Ida\nen het zoontje van Wanda heeft gedood en begraven in het nabije bos. De kleine Ida heeft hij gespaard omdat\nze niet als Jodin herkenbaar was. Op aanwijzing van de huidige bewoner ontgraven Wanda en Ida de stoffelijke\nresten van hun omgebrachte familieleden en geven hen een waardige begrafenis op het kerkhof. Tijdens haar\ntocht leert Anna/Ida ook Wanda beter kennen. Haar oudere tante is een alleenstaande vrouw die in het heersende\ncommunistische regime werkt als een strenge rechter(‘Rode Wanda’). Tegelijkertijd leert de jong enovice de\ntegenpool van haar religieuze levenswijze kennen. De tante geeft haar bestaan zin door het verleden te verdringen\nvia alcohol en seksuele escapades. Wanda stelt bovendien Ida’s levenskeuze om als katholieke zuster door het leven te gaan,\nradicaal in vraag. Wanneer Anna/Ida terugkeert naar het klooster om haar eeuwig geloften af te leggen,\naarzelt ze. Ze is de schok van het bezoek aan haar tante Wanda nog aan het verwerken. Bedroefd vraagt ze uitstel.\nOndertussen pleegt haar tante zelfmoord en is Anna/Ida haar enige erfgename. Ze neemt deel aan de seculiere begrafenis.\nIn het appartement van Wanda kruipt ze in de kleren van haar tante en experimenteert ze voor even met de levenswijze van de tante.\nNa een seksuele flirt met de jonge saxofoonspeler Lis, besluit ze terug te keren naar haar klooster,\nhaar echte thuis dat in de letterlijke zin haar ‘moederhuis’ is geweest en blijft.</p>\n<p><a name=\"CIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Cinematografie</strong></font></h2>\n<p><span class=\"menstis\">ZWART-WIT IN GRIJSMODUS</span>. Pawlikowski kiest voor een cinematografie in zwart-wit.\nDie bewuste keuze komt voort vanuit zijn nostalgische terugkeer naar het Polen van zijn kindertijd,\nhet Polen van het begin van de jaren zestig van vorige eeuw. In een interview met Ferdinand Derus (DVD Ida,\nCinéart, 2014) vertelt de regisseur dat zijn oude indrukken van zijn vaderland geen kleur kennen.\nPolen was toen ook geen blij land. Zijn moeder koos ervoor om samen met haar kind in het vrije\nWesten een betere toekomst te zoeken. Dat negatief gegeven belet Pawlikowski niet om <em>vanuit\neen zekere nostalgie</em> naar het Polen van zijn kindertijd terug te kijken. Vandaar om het contrast\ntussen wit en zwart niet extreem uit te werken, maar eerder te milderen. Dat gebeurt bijvoorbeeld\ndoor te kiezen voor de novicen en niet voor de volwaardige kloosterzusters. De kleding van de\nechte zusters kent immers een sterk contrast tussen de zwart en de witte delen.\nDe kleding van de novicen daarentegen heeft <em>het grijs als dominante kleur</em>. In de\nbeginsequenties zet de regisseur het zwart-wit sterk in de verf door de taferelen\nte situeren in een winters sneeuwlandschap. De witte sneeuw accentueert de contrasten\nmet het kloostergebouw en de personages. Eens de reis van Anna/Ida naar haar tante begint,\nverdwijnt de sneeuw en gaat het scherpere zwart-wit contrast over in een algemeen grijs.\nBovendien past het grijs\nook bij <em>de sluier van verdriet</em> die over de reis van Anna naar Wanda gaat, een reis naar\nhet traumatische leven van het Polen in de Tweede Wereldoorlog én van het naoorlogse Polen.\nHet <em>grijze zwart-wit</em> is niet louter nostalgie, het is evenzeer <em>de kleur van de rouw</em> die Anna/Ida\nen Wanda samen dragen tijdens hun tocht naar de dood van hun familie. <strong>Ida</strong> is een filmische partituur geschreven in <em>de toonaard van Em</em>.</p>\n<p><span class=\"menstis\">UNIEKE BEELDCOMPOSITIES</span>. De film <strong>Ida</strong> heeft een bijzondere beeldende signatuur door de beslissing\nvan de regisseur Pawlikowski om niet alleen in zwart-wit te filmen, maar ook om te kiezen voor het beeldformaat 4:3.\nDit rechthoekig formaat (4 eenheden in de breedte, 3 eenheden in de hoogte) benadert het vierkant. Dit betekent\ndat er horizontaal weinig ruimte is, wat bijvoorbeeld wel het geval is voor panoramische formaten zoals 16:9 dat\nvoor de eerste generatie breedbeeldtelevisie is gebruikt en ook als panoramisch filmformaat veel is gebruikt.\nHet 4:3-formaat is erg geschikt voor het gebruik van close-ups. Het vreemde bij <strong>Ida</strong> is dat Pawlikowski weinig close-ups heeft voorzien.\nHij gebruikt het beeld in formaat 4:3 door in te gaan tegen de natuurlijke werking ervan.\nHij exploreert namelijk het formaat om toch ruimte te scheppen in het beeld. Dat gebeurt door\nin de meeste sequenties de acteurs onderaan in het beeld te plaatsen, waardoor er boven hen\nheel wat ruimte ontstaat. Zo zijn in tal van taferelen enkel de hoofden van de personages\nzichtbaar en ontstaat er boven hen in het beeld heel wat ruimte. Dat is bijvoorbeeld het geval\nin het openingsbeeld. We zien Anna links onderaan in beeld. Alleen haar hoofd is zichtbaar samen\nmet het hoofd van het Heilig Hart-beeld dat ze aan het restaureren is. In een heel wat sequenties\nbevinden de acteurs zich aan een van de twee zijkanten van het beeld, waardoor er naast hen dan\nweer een ruimtelijke werking ontstaat. De novicen dragen in de proloog het Heilig Hartbeeld\nnaar buiten en lopen daarbij helemaal rechts in beeld. Ze vallen hierdoor bijna niet op in\nhet grote ruimtebeeld van een van de binnenkoeren van het kloostergebouw. Een ander middel\nom ruimte te scheppen binnen het gebruikte beeldformaat, is het gebruik van het diagonaal\nvogelperspectief. De camera bevindt zich boven het gefilmde tafereel, maar niet in loodrechte zin.\nIn een veeleer diagonaal of schuin vogelperspectief ontstaat er groter ruimtebeeld. Dat gebeurt\nin het tafereel waarmee de proloog van de film afsluit. Nadat de vier novicen het\ngerestaureerde Heilig Hartbeeld naar buiten hebben gedragen en op  zijn sokkel hebben\ngetild (ook dat gebeurt helemaal onderaan in het beeld), componeert Pawlikowski een uniek\nbeeldsetting. In een schuin vogelperspectief bevinden de vier jonge vrouwen zich onderaan\nrechts in het beeldkader. Ze stellen zich in een halve cirkel voor het beeld op,\nze maken een kruisteken, vouwen hun handen en bidden elk in stilte. Daar het tafereel\nzich in de rechterhoek van het beeldkader situeert, ontstaat er een asymmetrische\ncompositie die zowel aandacht schenkt aan de intimiteit en de poëzie van het tafereel\nals aan de omgevende ruimte van de besneeuwde plein voor het kloostergebouw.\nDe sokkel met het religieuze beeld staat in het midden van de cirkel van een stenen muur.\nHet hele beeld verschijnt in een sneeuwlandschap met erin het pad met de voetsporen van de zusters.</p>\n<p><span class=\"menstis\">CONTEMPLATIEF BLIKVELD</span>. De authenticiteit van de film ontspringt niet alleen aan het originele gebruik van zwart-wit en het ongewone beeldformaat. Daarnaast is er ook de unieke acteursregie. Pawlikowski werkt met twee Poolse actrices. De in Polen zeer gewaarde actrice, Agata Kulesza, neemt de complexe rol van Wanda voor haar rekening, terwijl Agata Trzebuchowska die de rol van Anna/Ida speelt, nooit eerder acteerde. Pawlikowski heeft haar door toeval ontdekt. Hij heeft haar voor de rol gevraagd omwille van haar bijzondere verschijning die eenvoud, ingetogenheid en onschuld uitstraalt. De jonge vrouw had geen enkele theater- of filmervaring. Door de bijzondere acteursregie zet Agata Trzebuchowska een unieke vertolking neer. Haar verschijning als de jonge novice Anna/Ida heeft niets van enige theatrale opvoering. Ze vertolkt niet, ze is zichzelf. Dat haar verschijning de volle aandacht van de camera krijgt, blijkt ook uit de ontdramatisering van de al schaarse dialogen. Pawlikowski en Lenkiewicz herleiden de gesprekken tot een minimum. Zelfs in dramatische scènes blijft  het psychologisch realisme achterwege. Dat is niet evident daar de narratieve basislijn zich juist situeert in het domein van de identiteit van de personages Anna/Ida en Wanda. Pawlikowski focust vooral op de contemplatieve blik van Anna/Ida. Zij staat schouwend in het leven en de camera neemt haar attitude over. Die contemplatieve houding ent zich op het personage van de novice, de jonge kloosterzuster die zich op enkele weken van haar definitieve toetreding tot het kloosterleven bevindt. Maar ook het personage zelf komt vooral in beeld als een contemplatieve verschijning. Anna/Ida is geen praatster, zelfs niet in erg dramatische scènes, zoals wanneer ze op zeker moment in het bos oog in oog staat met Feliks Skiba. Die man bewoont nu met zijn gezin het ouderlijke huis van Ida’s ouders. Tijdens de oorlog heeft hij met zijn vader het huis overgenomen in ruil voor het helpen onderduiken van Ida’s ouders, Ida zelf en het zoontje van Wanda. Op zeker dag heeft de toen nog jonge zoon van de Skiba’s, Feliks, beslist om de ouders en het zoontje van Wanda eigenhandig om te brengen en hun lijken in het bos onder de grond te verstoppen. In de scène bevindt Feliks zich in de put waar hij de stoffelijke resten van zijn slachtoffers heeft opgegraven. Ida en Wanda hebben die stoffelijke resten elk in een doek gewikkeld. De man zit emotioneel geslagen in de aarden put. Ida kijkt naar hem aan de rand van de put die tot dan toe het onzichtbare graf van haar ouders en neefje is geweest. Zij stelt hem met een rustige stem de existentiële vraag: ‘En ik? Waarom ben ik er niet?’ Ida luistert aandachtig naar de bekentenis van de man. Om zijn eigen hachje te redden tegenover de nazi’s, de bezetters, heeft hij eigenhandig de Joodse mensen die hem waren toevertrouwd, vermoord en hun lijken in het bos ‘weggestopt’. Blijkbaar heeft hij dit uit zelfbehoud gedaan want hij wilde geen risico lopen om de boerderij van de Lebensteins te verliezen indien de Joodse familie zou worden ontdekt door de nazi’s. Zelfs in dergelijke dramatische scène blijft Ida trouw aan haar contemplatieve houding waarmee ze de dingen die gebeuren in zich opneemt. Schijnbaar emotieloos absorbeert ze de onthullende en verschrikkelijke bekentenis van Feliks Skiba. Omdat Ida nog erg klein was en niet als Joodse herkenbaar was, geeft hij haar als weeskind aan pastoor André gegeven die haar op zijn beurt heeft overgedragen aan de zusters. Die hebben het kind binnen de muren van hun klooster verborgen hebben gehouden en na de oorlog hebben ze het Joodse meisje opgevoed tot katholieke novice. Ook voor de oudere Wanda betekent de onverwachte komst van haar enig familielid, haar nichtje Ida, het begin van een contemplatieve reis doorheen het bewogen landschap van haar existentie, vol dramatische herinneringen. Een unieke scène waarin beide vrouwen hun schouwende houding voor een ogenblik verlaten en overgaan tot een gemeenschappelijke actie, is die van de begrafenis op het Joodse kerkhof van Lublin. In de scène bedekken ze met hun handen de aarde over de stoffelijke resten van Ida’s ouders en het zoontje van Wanda. Deze laatste heeft handschoenen aan, Ida daarentegen werkt we aarde weg met haar blote handen. Er zijn geen anderen bij betrokken, er zijn geen werkinstrumenten voor handen, er is geen muziek en er worden geen woorden gesproken. Er is geen ritueel. Het laatste shot van het tafereel is dat van de geknielde Ida die een kruisteken maakt. De vanzelfsprekendheid van Ida’s contemplatieve blik die ook door de regisseur wordt overgenomen vindt ook haar bevestiging in de even ongewone als spontane cinematografie. Om die te realiseren heeft Pawlikowski, daarbij uitgedaagd door bijzondere omstandigheden, beroep gedaan op een jonge en debuterende cameraman, Lukasz Zal, die nog nooit eerder aan een langspeelfilm had meegewerkt. Met een zelfde onbevangenheid als die van de hoofdactrice Agata Trzebuchowska voor de camera, handelde Zal op de set vanuit zijn natuurlijke, schouwende houding van achter de camera. Voor zijn uniek camerawerk kreeg Zal een Bafta- en Oscarnominatie. Al die gegevens die getuigen van een zeer bewuste contemplatieve instelling tegenover het verhaal, verdicht zich in de beslissing van Pawlikowski om ieder scène in één take vast te leggen. Alles moest goed zijn na één opname. In die werkwijze bundelden zich alle creatieve beslissingen die het authentieke, contemplatieve blikveld van de film <strong>Ida</strong> hebben voortgebracht.</p>\n<p><span class=\"menstis\">KLANKWERELD</span>. De soberheid van de klankwereld ent zich helemaal op de stilte die eigen is aan het contemplatieve blikveld van de film. Die soberheid drukt zich uit in de klanken die de even reële als spirituele reis van de jonge vrouw Anna/Ida en Wanda vergezellen. Dat blijkt al uit het openingstafereel. Anna beëindigt het gelaat van het Heilig Hartbeeld in een ruimte waar ook haar medezusters aan het werk zijn. Het eerste geluid waarmee de film opent op de achtergrond van een volledig zwart beeld, is dat van de ongure wind buiten waarvan blijkt dat het een sneeuwwind is. Ieder geluid dat de zusters maken in de ruimte weerklinkt zeer helder en met een zekere echo. Dat geldt voor de voetstappen van de vier jonge zusters die het religieuze beeld naar de sokkel brengen tegenover de frontmuur van het kloostergebouw. Ook het plaatsen van het beeld op de sokkel weerklinkt op die manier. Ofschoon de camera zelf op een afstand blijft staan, zijn de geluiden van heel kortbij opgenomen. Bij het inpakken van haar reiskoffer horen we het sluiten van de koffer als muzieknoten die voortkomen uit de compositie van het reële leven van Anna/Ida. Voor de hele film geldt dat de scenaristen Pawlikowski en Lenkiewicz bewust de dialogen tot een minimum beperken. Het contact van Anna/Ida met de wereld waarin ze zich beweegt, is hoofdzakelijk schouwend en de gesproken woorden vormen slechts een beperkt deel van die schouwende aanwezigheid van Anna/Ida. Een uitstekend voorbeeld hiervan is de mededeling van de moeder overste aan Anna om haar tante te gaan opzoeken. Het grote verhaal dat hieraan voorafgaat, is weggelaten. De toeschouwer krijgt direct een eigen plaats in het verhaal dat zich voor zijn ogen begint te ontwikkelen. Hij dient de schouwende blik van de camera over te nemen en zelf actief te gaan interpreteren. De zwijgzaamheid, eigen aan Anna/Ida en in zekere zin ook aan Wanda, verstrekt de klank van de stilte die bestaat uit de natuurlijke geluiden van de natuur en de menselijke omgeving. De filmmuziek is evenals de dialogen erg beperkt. Wel speelt de scenische muziek een belangrijke rol, dit is de muziek die live in het beeld aanwezig is via musicerende personages of een geluidsdrager zoals een radio of platenspeler. Het nevenpersonage van de jonge altsaxofoonspeler Lis die al liftend langs de weg het verhaal binnenkomt, brengt ook muziek in het beeld. Hij speelt mee in een band die met Amerikaanse geïnspireerde pop, rock en jazz op aanvraag feestjes opluisteren. Naast Poolse pop- en rocksongs die de tijdgeest van het begin van de sixties in Polen oproepen, zijn er enkele bijzondere muzikale fragmenten opgenomen in het filmverhaal. Dat is bijvoorbeeld het geval voor een van de composities waarbij Lis soleert. Het betreft de instrumentale, bluesy ballade Naima (1959) van de Amerikaanse jazzlegende John Coltrane. De naam van de compositie is ontleend aan de voornaam van de vrouw van Coltrane. De woordbetekenis van Naima met een Afro-Arabische origine is ‘gracieus’ en sluit qua betekenis nauw aan bij de Engelse meisjesnaam Grace, het woord voor ‘genade’. In de film komt de life uitvoering voor in het hotel waar Ida en haar tante verblijven en waar ook de band met Lis speelt. Na hun optreden jammen de musici nog voor zichzelf. Hun enige toehoorder is op dat moment Anna/Ida. Na hun jamsessie maken Anna/Ida en Lis kennis met elkaar. Ze vraagt Lis wat ze hebben gespeeld. Hij antwoordt: ‘Naima van Coltrane’. Hij vraagt: ‘Vond je het goed?’ Ze antwoordt: ‘Heel goed’. Een tweede belangrijk voorbeeld van scenische muziek, komt voor in een de meest dramatische scènes van de film. Het betreft de zelfmoordscène van Wanda. Eerst legt de vrouw een vinylplaat op de grammofoonspeler. Het allegro vivace van Mozarts laatste symfonie weerklinkt door de kamer. De symfonie, door Mozart enkele maanden voor zijn niet voorziene dood gecomponeerd, is de Symfonie nummer 41 in C groot (1788). Ze wordt ook de Jupiter Symfonie genoemd. De naam Jupiter verwijst naar de planeet van ons zonnestelsel waarvan de naam ontleend is aan de Romeinse mythologie waarin Jupiter de hoofdrol speelt van de oppergod, de Romeinse tegenhanger van de Griekse oppergod Zeus. Jupiter/Zeus beheerst het hemelgewelf en bepaalt aldus de gebeurtenissen op aarde via de gunstige of ongunstige weersomstandigheden. Wanda laat de plaat met de krachtige en in zeker zin triomfantelijke symfonische muziek draaien terwijl ze, na te hebben ontbeten, uit het open raam naar haar dood springt. Naast de scenische muziek, is er nog de filmmuziek die enkel via de klankband de beelden begeleidt. De eigen filmmuziek van <strong>Ida</strong>, een compositie van de Deen Kristian Eidnes Andersen, onderlijnt de ingetogen en nostalgische sfeer die het eigen verdriet van Ida en Wanda over hun verloren familie verklankt. De filmmuziek wordt voor het eerst hoorbaar op het ogenblik dat Wanda haar nichtje Ida terug komt ophalen. Ze had de jonge vrouw eerst weg gestuurd, maar ze bedenkt zich. Ze gaat Ida zoeken in de wachtzaal van het station en neemt haar terug mee naar haar appartement. Daar bekijken ze samen het familiealbum. Van dan af vormen de twee vrouwen, de twee generaties, voor het eerst een familie. De tante en het nichtje voelen zich van dan af verbonden, waarna ze onder leiding van Wanda een gemeenschappelijke zoektocht beginnen naar hun familie die ze in de oorlog hebben verloren. De filmmuziek onderlijnt hun familieband en hun beider wil om de resten van hun gemeenschappelijke oorsprong te gaan zoeken. Tot slot, is er naast de eigen filmmuziek, nog een belangrijk muzikaal citaat. Dat begeleidt de slotbeelden met Anna/Ida die als novice met haar reiskoffer te voet op weg is naar haar klooster nadat ze in de stad de begrafenis van haar tante heeft bijgewoond en het appartement van haar tante, waar ze de nacht heeft doorgebracht met Lis, achter zich heeft gelaten. De keuze van de muziek bij die slotbeelden is frappant. Het betreft namelijk de muziek van de religieuze cantate Ich ruf zu dir Herr Jesu Christ (1732) van Johann Sebastiaan Bach. De regisseur gebruikt niet de cantate zelf, maar de instrumentale versie die Bach als koraalprelude heeft opgenomen in zijn Orgelbüchlein. In <strong>Ida</strong> gebruikt de regisseur niet die orgeluitvoering, maar de meer ingetogen pianoversie ervan, een bewerking door Ferruccio Busoni in een vertolking door Alfred Brendel.</p>\n<p><a name=\"BET\"></a></p>\n<h2><font color=\"#808000\"><strong>Betekenisruimte</strong></font></h2>\n<p><span class=\"menstis\">EVA EN MARIA.</span> Pawlikowski heeft in zijn film <strong>Ida</strong> duidelijk het fenomeen religiositeit of religieus leven willen thematiseren via een welbewust uitgekend vrouwenportret. Anna/Ida staat centraal. We leren haar kennen als een jonge novice in een klooster in de weken voor ze de grote beslissing neemt om definitief tot te treden tot het klooster. De regisseur werkt het filmportret van Anna/Ida uit via een spiegelportret, namelijk dat van Wanda. De uitwerking van dat portret gebeurt psychologisch. Er vinden geen psychologisch getinte analyses, gesprekken, discussies of confrontaties plaats. De regisseur mijdt op dat vlak ieder dramatisch realisme. Dat komt omdat hij zijn film veeleer onder de oppervlakte van de gebeurtenissen en de eerste impressies wil laten bewegen. Dat verklaart de bewuste keuze voor de levensbeschouwelijke houding die consequent is uitgetekend in het dubbele vrouwenportret. Het is zeker geen toeval dat de familieband tussen beide vrouwen dan pas echt tot stand komt in de scène waarin ze samen voor het eerst kijken naar de familiefoto’s die Wanda heeft bewaard. Hun beider motivatie om samen op weg te gaan, komt voort uit hun gemeenschappelijke wil om samen hun leven via het prisma van de familiegeschiedenis te beschouwen. Via die weg willen ze samen én elk op hun manier hun leven onder ogen zien. Ze gaan letterlijk onderweg, wat de film het karakter geeft van een road movie. Uiteindelijk bewegen ze allebei langs de levensbeschouwelijke weg van de zingeving. Hier komt het tweeledige portret volledig tot zijn recht en krijgt het zijn rijke dieptewerking. Vanuit zijn eigen katholieke achtergrond en beleving, werkt Pawlikowski het portret van Anna/Ida en Wanda uit vanuit een eigen herinterpretatie van de twee belangrijkste Bijbelse vrouwenfiguren, Eva en Maria. Vanuit een christelijke perspectief belichaamt Eva het oudtestamentische beeld van de vrouw en Maria het nieuwtestamentische. Voor Pawlikowski vormen beide Bijbelse vrouwbeelden de grondstof voor zijn eigen creatieve en actualiserende hertekening. Daarbij pretendeert hij niet om de Bijbelwetenschap van de exegese te beoefenen. Via beide filmportretten actualiseert hij de levensbeschouwelijke reflectie over de betekenis en draagwijdte van een religieuze levenswijze. Anna/Ida en Wanda zijn binnen de verhaallijn verwanten. Dat geldt ook in het domein van de levensbeschouwelijke zingeving. Ze willen allebei een verbondenheid met de oorsprong van hun bestaan, belichaamd in de ouders van Anna/Ida en in de zus van Wanda. Hierdoor verloopt de weg van Anna/Ida naar haar religieuze leven als kloosterzuster niet meer in een rechte lijn. Ze miste iets. Ze kende zichzelf als weeskind. Ook de moeder overste en de andere zusters kenden Anna enkel als een weeskind. Anna/Ida groeide op als kind en nadien als novice met een witte vlek op de landkaart van haar bestaan. Via Wanda kan ze die witte plek inkleuren. Wanneer ze voor de eerste keer terugkeert naar het klooster voor het feest van haar intrede, beseft Anna/Ida dat ze er niet klaar voor is. Haar tante heeft haar geconfronteerd met de woorden: ‘Dat is het leven!’, daarbij verwijzend naar haar eigen vrije omgang met mannen en de drank. Anna/Ida heeft voor het eerst het leven buiten het klooster gezien en de existentiële vraag van haar tante in zich opgenomen: ‘Hoe kan je weten waar je afstand van doet, als je het niet hebt geprobeerd?’ Wanneer Anna/Ida na de zelfmoord van haar tante, terugkeert naar de stad en het appartement, kruipt ze letterlijk in de kleren van haar tante. Ze zoekt Lis op en brengt in het appartement van Wanda de nacht door met de jonge muzikant. ’s Morgens kleedt zich weer aan als novice en gaat stilzwijgend op weg naar het klooster, haar thuis. In de lijn van de evangelieverhalen is Maria een reëel Joods meisje wier bestaan verweven zit met de geschiedenis van haar familie, haar volk en land. Anna/Ida draagt die verbondenheid op het einde van de film in zich. Nu neemt ze bewust als zelfstandige vrouw zelf de beslissing om op weg te gaan naar het klooster, een weg die ze als weesmeisje ooit is gegaan door toedoen van anderen. Haar religieuze opvoeding en vorming was tot aan het begin van het verhaal een automatisme. Haar religieus leven baadde in de gewoonte van de vanzelfsprekendheid. Haar korte, maar intense levensbeschouwelijke weg heeft geholpen die evidentie te overstijgen. Wanda daarentegen weigert ieder religieus leven. Haar Joodse roots staan niet in het teken van enige religiositeit, maar in dat van het ras dat door de nazi’s gruwelijk als doelwit is genomen. Daar heeft ze tegen gestreden binnen het communistische verzet in Polen. Ze heeft het communistische atheïsme politiek en existentieel omhelsd. Als juriste en lid van de communistische partij heeft ze in de naoorlogse periode als rechter van de staat gewerkt in politieke processen, in feite schijnprocessen om ‘vijanden van het volk’ uit te schakelen. Niet voor niets wordt ze daarvoor geprezen tijdens haar begrafenis op het einde waarvan de Internationale speelt. Wanda stond bekend als ‘Rode Wanda’. Tegelijkertijd leert Ida haar tante kennen in de periode dat haar politieke faam aan het tanen is wegens haar overdadig drankgebruik. Ze is alcoholiste geworden en een nymfomane die voortdurend met andere mannen het bed deelt. Nadat ze samen met Ida de stoffelijke resten van haar zoontje, haar enig kind, en die van haar zus en schoonbroer heeft begraven, besluit ze uit het leven te stappen. Ze verschijnt hier als een Eva, de vrouw die haar mislukking in het gekregen leven inziet. In tegenstelling met de Bijbelse Eva, stelt Pawlikowski Wanda niet voor als iemand die een morele schuld draagt na de rebellie tegen God de Schepper. De regisseur en het hoofdpersonage Anna/Ida nemen een levensbeschouwelijk standpunt in. Ze respecteren wat zich voordoet en respecteren het leven dat verschijnt in zijn onvoorziene en vooral dramatische gedaanten. Noch de regisseur noch zijn hoofdpersonage willen die dramatiek wegredeneren vanuit een of ander moralistisch wereldbeeld dat als een sluier over het leven zelf heen wordt gelegd.</p>\n<p><span class=\"menstis\">VERTICALISERING VAN HET BEELD</span>. Pawlikowski bouwt de eigen religieuze betekeniswereld van de film ook uit via de verticalisering van het beeld. Eén aspect ervan is de verticalisering van het beeldkader zelf. Dat blijkt uit het gebruik van de bijzondere ruimtewerking die hij realiseert door bewust gebruik te maken van het oude en vandaag ongebruikelijke formaat 4:3. Daarmee slaagt hij erin om in de ruimtewerking niet zozeer de horizontale, maar vooral de verticale beweging op de voorgrond te plaatsen. Dat sluit zeer sterk aan bij het levensbeschouwelijke blikveld van de novice Anna/Ida. In de proloog plaatsen de vier novicen, onder wie Anna, het Heilig Hartbeeld op een sokkel, stellen zich op in een halve cirkel bij het beeld en kijken naar omhoog, richting beeld. De levensbeschouwelijke blik van Anna/Ida kent ruimte. Dat betekent ze weet zich opgenomen in een groter geheel dat zowel de aarde als de hemel omsluit. Het is niet zo dat ze met haar hoofd in de wolken loopt. Integendeel, ze houdt haar blik op het leven rondom zich open. In die open blik verschijnt voor Anna/Ida het aardse leven op een hemelse horizon. Die verticalisering van het beeldkader krijgt nog versterking via het beeldmotief van de trap. De weg die Anna/Ida volgt, verloopt niet louter horizontaal. De belangrijke momenten ervan kennen een verticale beweging. De regisseur besteedt daar expliciet aandacht aan. Er zijn drie belangrijke trapmomenten. Anna moet de trap opgaan om het appartement van haar tante te kunnen bereiken. Anna/Ida en Wanda moeten de trap oplopen om de kamer van vader Skiba te vinden. In beide scènes verloopt het betreden van de trap opwaarts. De derde trapscène situeert zich in het hotel. Anna/Ida bevindt zich boven bij de grote spiraaltrap. Ze hoort beneden de band van Lis jammen. Ze beslist uiteindelijk de trap af te lopen en te gaan kijken en luisteren. Daar vindt dan haar kennismaking met de jonge saxofonist plaats. De drie trapscènes vormen een betekenisvolle trapbeweging, eerst opwaarts dan neerwaarts. De opwaartse beweging betekent voor Anna/Ida dat ze moeite moet doen. Ze moet haar weg zoeken en vinden op plaatsen die haar vreemd zijn. En toch, zo ontdekt ze, hebben die plaatsen iets maar haar zelf, haar onbekende zelf, te maken. Haar tante bewaart een familiealbum. De neerwaartse beweging daarentegen heeft een andere uitstraling. Hier zien we eerst Ida vanuit een kikvorsperspectief helemaal boven de spiraaltrap in het licht staan. Ze lijkt wel op een engel die vanuit de hemel neerkijkt. Vervolgens bekijken we vanuit haar hemelperspectief de brede spiraaltrap die lijkt te eindigen in het donkere niets daar ergens beneden. Ida bevindt zich in een religieus cocon met een hemelse aura. Via de kennismaking met haar tante, komt ze in een heel andere wereld terecht, de wereld van heel concrete mensen die zonder beschutting en bescherming hun leven trachten te leven, met vallen en opstaan. Dat hebben ook haar ouders gedaan in moeilijke, historische omstandigheden, dat heeft ook het gezin Skiba gedaan in diezelfde dramatische omstandigheden, Wanda en Lis tekenen hun bestaan nu uit in het heden. Ida daalt voor het eerst de trap van de hogere sfeer af richting het heden zoals het nu is. Dat is ook de betekenis van haar reis. Die brengt haar in contact met de anderen. Die waren in het klooster helemaal afwezig, temeer dat ze ervan overtuigd was dat ze in de wereld buiten het klooster helemaal niemand had. Dan ontdekt ze het bestaan van haar tante Wanda die in een heel andere wereld dan een klooster leeft. Tevens komt ze in contact met Lis, het andere geslacht, een andere cultuur. Al die contacten absorbeert ze en vanuit die ervaring keert ze terug naar haar vertrekpunt, het klooster en haar geloften. De film toont niet meer de aankomst van Anna/Ida in het klooster. De weg die de jonge religieuze doorloopt, staat centraal. Dat dit een religieuze weg is, daarover laat de regisseur geen twijfel bestaan. Hij monteert bij de stappende Anna/Ida het koraalgebed van Bach in een rustige, meditatieve versie: Ich ruf zu dir Herr Jesu Christ. Met dit door en door menselijke gebed stapt Anna/Ida naar haar klooster. Ze geeft in haar religieus leven een tweede onschuld gevonden.</p>\n<p><span class=\"menstis\">MAGNIFICAT IN Em</span>. De film Ida oogt als een eigentijds Magnificat in Em. De term Magnificat duidt op een van de meest merkwaardige teksten uit de Evangelies (Lucas 1, 46-55). Dat fragment kenmerkt mede de eigenheid van het christendom. Het vertoont qua genre enige verwantschap met het oudtestamentische loflied van Hanna (1 Sam. 2:1-10). Inhoudelijk getuigt het echter van een heel eigen religieuze houding die sterk aanleunt bij de Bergrede in Matteüs 5-7, met name de Zaligsprekingen (Matteüs 5, 3-12). Het evangelische Magnificat is een blijvende artistieke inspiratiebron gebleken. We vinden het terug bij de Gregoriaanse Vespers, alsook bij Claudio Monteverdi, Giovanni Pergolesi, Johan Sebastiaan Bach, Antonio Vivaldi, Franz Schubert en Arvo Pärt. Het thema van het Magnificat vormt een tweeluik met dat van het Stabat Mater, verbonden met het beeld van de Mater Dolorosa, geïnspireerd door het evangelietafereel van Johannes 19, 25-27. Michelangelo heeft dat tafereel in Rome beeldend onsterfelijk gemaakt met zijn Pietà. Die herinnering aan zowel de Bijbelse bronnen als aan de artistieke expressies leert ons hoe het christelijke, religieuze geloof verankert zit in het fenomeen van de Menswording via de historische figuur van de jonge moeder van Jezus, Maria. Zij belichaamt letterlijk en daardoor ook beeldend de eigen tragiek van die Menswording. Ze omvat de fysieke geboorte, maar ook de dood. Niet de dood in het algemeen, maar de historische dood van haar kind Jezus, waarvan de herinnering is bewaard in de evangelische passieverhalen. In de herinnering weerklinken in één samenklank de doorleefde blijheid en vreugde van de geboorte én de dramatiek van de dood. Deze laatste werd zichtbaar in de historische terechtstelling, het onrechtmatige lijden dat Maria’s zoon overkwam in de noodlottige regie van de moeizame historische menswording van de mens tijdens de hoogdagen van het Romeinse Rijk. Maar ook in het Magnificat zelf is die éne samenklank al hoorbaar. De jonge vrouw zingt haar vreugde uit wegens haar zwangerschap die niet zozeer van de mensen, maar vooral van Godswege het fiat krijgt. In de ogen van de mensen, in het bijzonder van haar Joodse omgeving, beleeft Maria haar zwangerschap eerder als een schande. Ze is namelijk ongehuwd. Exegeten hebben de voorbije decennia het feit van de ongehuwde, zwangere Maria, de moeder van Jezus, steeds meer in de verf gezet. Daarbij relativeren ze de eeuwenoude dogmatische interpretaties die wegens hun abstractie zich te ver van de evangelische, verhalende en tevens historische oorsprong zelf van het christelijke geloof in de Menswording hebben verwijderd. Het is binnen die religieuze, christelijke sfeer dat de Pools-Britse regisseur Pawlikowski zich beweegt in zijn filmisch portret van de katholieke novice Ida. De jonge vrouw handelt niet vanuit een dogmatische reflex. Ze staat levensbeschouwelijk in het leven. Ze is een verwante van de evangelische Maria. Ze heet trouwens Anna, de naam van de moeder van Maria, in de volksdevotie gekend als de Heilige Anna of Sint Anna, beschreven in De geboorte van Maria, het Proto-Evangelie van Jacobus. De verwantschap tussen de filmische Anna en de evangelische Maria blijkt niet alleen uit hun leeftijd. Veel meer vinden we die in de opmerkelijk proloog van de film. De regisseur verwijst er namelijk naar de artistieke traditie van het katholieke, christelijke geloof eerder dan naar de dogmatische, kerkelijke. In de eerste scène zien we de novice Anna zeer geconcentreerd het gelaat schilderen van het Heilig Hartbeeld. Later blijkt dat Anna/Ida die artistieke genen van haar moeder heeft geërfd. Die maakte, zo vernemen we via Wanda, glasramen in lood in de koestal om de dieren blij te stemmen. In een tweede tafereel zien we in de proloog hoe Anna en haar drie, jonge medezusters het beeld in een stille processie naar buiten dragen. Ze brengen het in een winterse sneeuwwind naar de sokkel in de voortuin van het klooster. Tijdens die niet-officiële processie ontstaat er een bijzonder cinematografisch beeld. Het standbeeld oogt nu als een lijk en de vier zusters verschijnen als de dragers van het dode lichaam. Samen leggen ze echter het beeld niet in een graf, maar laten ze het herrijzen door het op een sokkel te plaatsen. Ze wekken het als het ware tot leven. Dat krijgt nog zijn bevestiging in de opstelling van de vier in stilte biddende zusters rond het beeld. De regisseur linkt het gekende Heilig Hartbeeld dat in de katholieke volksdevotie van eind negentiende en eerste helft twintigste eeuw een hoofdrol heeft gespeeld, met het personage van de novice Anna. Het standbeeld verbeeldt de warme hartelijkheid en volle menselijkheid, verbonden met het christelijke credo van de Menswording. Die hartverwarmende menselijkheid krijgt in het Magnificat een diep religieuze duiding. En zoals in de proloog van de film het Heilig Hartbeeld door de vier jonge zusters in de koude, winterse omgeving wordt geplaatst, zo ook klinkt in het Magnificat de onmenselijke hardheid van de historische omgeving door. In de film vormt het Heilig Hartbeeld de hartslag zelf van Anna haar geloof, ook al staat het in het teken van een groot verdriet dat ze als weeskind vanaf haar eerste levensjaren meedraagt. Dat verdriet neemt alleen maar toe op het ritme van haar tocht naar haar tante. Ze vindt dat grote verdriet ook terug bij haar tante zelf en via haar tante in de geschiedenis waar ze zelf, zo beseft ze, deel van uitmaakt. Zoals aangestipt, weerklinkt die historische dimensie, verdicht in het verdriet van een jonge vrouw, in het evangelische Magnificat. De jonge Maria draagt ook in zich het verdriet van haar volk dat onder het juk leeft van een heerszuchtige koning Herodes en van het grote Rijk van de Romeinse keizer. De echo van dat verdriet is hoorbaar in de jubel van de jonge, ongehuwde zwangere vrouw Maria, in haar Magnificat in Em.  <a name=\"CON\"></a></p>\n<h2><font color=\"#808000\"><strong>Context</strong></font></h2>\n<p>Pawlikowski situeert zijn filmverhaal in 1962. Dat jaartal verwijst naar zijn kindertijd in Polen. Maar het gekozen jaartal is meer dan dat. Het refereert ook naar een bijzondere historische context die een sterk licht werpt op het verhaal zelf. Allereerst verwijst 1962 naar het begin van een belangrijke dynamiek in de katholieke Kerk met de opening van het Tweede Vaticaans Concilie door paus Johannes XXIII. Hij kondigde een nieuwe wind, een nieuwe geest aan in de Kerk. De paus zelf die heel dicht stond bij het gelovige volk zelf, gaf het startsein van wat hij de aggiornamento-beweging noemde. Die moest de Kerk en het christelijke geloof in dialoog doen treden met de bestaande tijd. De wereldvreemdheid van de Kerk moest worden afgebouwd. Die wereldvreemdheid had zich geïnstalleerd met het Eerste Vaticaans Concilie (1869-1870). De Kerk van Rome koos toen voor een anti-modernistisch beleid en ging de strijd aan tegen de nieuwe ontwikkeling in de samenleving. Ze zette de intellectuele wapens van het klerikalisme en het moralisme in. Pawlikowski regisseert de proloog van de film duidelijk met een artistieke verwijzing naar de geest van het Tweede Vaticaans Concilie. Hij interpreteert die vanuit een eigen Poolse context met een zowel binnenkerkelijke als buitenkerkelijke inslag. Binnenkerkelijk:  Pawlikowski plaatst de jonge vrouw Anna op de voorgrond. De novice vormt samen met haar medezusters de jeugd van de Poolse Kerk. Zij halen het Heilig Hartbeeld van onder het stof, renoveren het en dragen het samen naar buiten waar ze het doen herrijzen. Voor deze jonge gelovigen staat in hun religieus leven het Heilig Hart centraal dat klopt voor de levende mensen in de concrete samenleving. Net zoals in het programma van het Concilie opent de film met de opdracht van moeder overste aan Anna om de wereld in te trekken en die te leren kennen alvorens haar kloostergelofte af te leggen. Het is ook betekenisvol dat Pawlikowski niet focust op de zusters zelf. Die zijn eerder figuranten. Zij dragen de sterk contrasterende kloosterkleding: zwart met verwijzing naar de dood, de dood voor de wereld, en zuiver wit, verwijzend naar de hemelse zuiverheid na de dood. Het concrete leven valt hierbij buiten het bereik van het kloosterleven. Anna en haar medezusters daarentegen dragen nog het grijs, een mix van het contrasterende zwart en wit. De film handelt ook niet over de strenge kloosterregels zelf. Het individu staat centraal. Anna/Ida absorbeert de religieuze levenswijze vanuit haar eigen wil en na haar persoonlijk contact met het leven buiten de kloostermuren. Pawlikowski brengt hiermee ook hulde aan de belangrijke bijdrage van heel wat katholieke instellingen in het redden van Joodse kinderen van de Holocaust door ze te verbergen in hun midden. Tegelijkertijd herinnert de regisseur ook aan de eigen weerbaarheid van de Poolse katholieke Kerk tegen de communistische Ideologie die na de Tweede Wereldoorlog onder dwang van de Sovjet-Unie werd geïnstalleerd. Die geestelijke en culturele weerbaarheid zou uitmonden in de beweging Solidarność, die de grondslag heeft gelegd voor de val van het communisme niet alleen in Polen (1989), maar ook in het hele Oostblok. De keuze voor de Poolse paus Johannes-Paulus II (1978-2005) hangt ook samen met die succesrijke bovengrondse en ondergrondse katholieke Poolse beweging. Hieruit blijkt al de buitenkerkelijke draagwijdte van wat volgens Pawlikowski het Tweede Vaticaans Concilie voor Polen betekende. Via het portret van Anna/Ida plaatst hij ook de eigen en unieke waarde van een spiritueel, religieus leven tegenover iedere vorm van een zuiver materialistisch levenswijze, die tot voor kort door het communistische bewind werd opgelegd en die vandaag richting westerse consumptiemaatschappij opschuift. Het personage van de tante Wanda incorporeert die materialistische levenswijze onder het communisme. Dat gebeurt in de film via een directe verwijzing naar de beruchte schijnprocessen tegen de zogenaamde ‘vijanden van het volk’. Wanda is duidelijk een van de strenge rechters die dergelijke schijnprocessen heeft voorgezeten. Ze staat bekend als ‘Rode Wanda’. De film toont echter hoe haar persoonlijk leven een puinhoop is. Pawlikowski stelt hiermee de achilleshiel van een moderne samenleving die, zoals Polen in de tijd van de Koude Oorlog, wordt verplicht te leven onder de regie van een zuivere materialistische Ideologie. Pawlikowski evoceert dat in het tafereel van de begrafenis van Wanda. De officiële schijn die de loftrompet steekt over ‘de Rode Wanda’, met de Internationale als orgelpunt, contrasteert met de novice Anna/Ida die in beeld komt terwijl ze van buiten af de politieke plechtigheid gadeslaat. In het kader van de context, speelt ook het kloostergebouw zelf een beeldende rol. Pawlikowski gebruikt voor de locatie van het klooster, het historische Zamoyski Paleis in Zamość nabij Lublin, gelegen in het Zuidoosten van Polen nabij de grens met Oekraïne. De adellijke Poolse familie Zamoyski heeft in de late 16de eeuw het paleis gebouwd én de stad Zamość gesticht. De geschiedenis van Polen weerspiegelt zich in de lotgevallen van het paleis dat anno 2016 nog op een nieuwe bestemming wachtte. In de 19de eeuw werd het historische paleis omgebouwd tot een militair hospitaal, terwijl  in het begin van 20ste eeuw het stedelijke gerechtshof huisvestte. Zowel de nazi’s als de communisten na hen vernederden de familie Zamoyski. Na de val het communisme werd de nazaat van de familie Zamoyski in ere hersteld, maar het gebouw blijft voorlopig leeg en onbestemd staan. Pawlikowski stelt met zijn film <strong>Ida</strong> een duidelijk gebaar. Hij herinterpreteert via het paleis Polen als een nog te renoveren historische monument voor. Hij bestemt concreet het lege paleis tot een zusterklooster waar een gerenoveerd Heilig Hartbeeld de bezoekers verwelkomt. Hiermee wijst de regisseur op de blijvende noodzaak om de Poolse samenleving na  het trauma van de Duitse bezetting met de Holocaust en dat van het communisme, op te bouwen op spirituele hoeksteen. Met deze artistieke en spirituele boodschap sluit Pawlikowski zich aan bij zijn Poolse voorganger, Krzysztof Kieslowski die met zijn Dekalog (1989) in diezelfde geest de Poolse postcommunistische samenleving had opgeroepen. Pawlikowski ziet die spirituele hoeksteen van de Poolse samenleving in opbouw in een christelijke religiositeit zoals hij die portretteert via het hoofdpersonage van de novice Anna/Ida. Een novice is iemand die zich nog in een leerproces bevindt. Daarbij legt de regisseur ook de nadruk op de fundamentele waarde van de vrijheid zonder dewelke in een postmoderne samenleving geen authentieke religiositeit mogelijk is. Dat laat hij zien door Ida in contact te laten komen met Lis, de jonge saxofonist. Die vindt van zichzelf dat hij iets van een zigeuner heeft. Hij trekt rond als muzikant van actuele westerse muziek: pop, rock en jazz. Pawlikowski bevestigt zelf dat in het begin van de jaren zestig in Polen een vrij grote marge van vrijheid heerste dan in andere communistische Oostbloklanden. Na de kritiek op het bewind van Stalin naar het einde van de jaren vijftig toe in de Sovjet-Unie, ontstond in Polen een zekere marge van vrijheid van expressie. De jeugd speelde daar op in. Ze importeerde en imiteerde de populaire muziek uit het vrije Westen. In de film laat Pawlikowski het hoofdpersonage Anna/Ida die culturele vrijheid kritisch absorberen en integreren in haar religieuze beleving waaraan ze trouw blijft, zoals blijkt uit de slotbeelden.</p>\n<p><a name=\"LIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Links</strong></font></h2>\n<p>Voor de eigenheid van de levensbeschouwelijke blik zoals die in de film <strong>Ida</strong> zowel door de regisseur als door zijn hoofdpersonage wordt beoefend, zie: het eerste deel van Levensbeschouwing democratisch belicht. En voor het gegeven van de Ideologie, zie het tweede deel van hetzelfde boek.\n<a href=\"https://www.facebook.com/idafilm\">De officiële site van de film</a>.</p>\n<p><font size=\"-2\">© Sylvain De Bleeckere, Men(S)tis, 2017</font></p>\n"}

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDocumentTitle = __webpack_require__(952);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _config = __webpack_require__(404);
	
	var _reactRouter = __webpack_require__(173);
	
	var _safeAccess = __webpack_require__(976);
	
	var _safeAccess2 = _interopRequireDefault(_safeAccess);
	
	var _include = __webpack_require__(420);
	
	var _include2 = _interopRequireDefault(_include);
	
	var _startsWith = __webpack_require__(573);
	
	var _startsWith2 = _interopRequireDefault(_startsWith);
	
	var _typography = __webpack_require__(427);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _gatsbyHelpers = __webpack_require__(403);
	
	var _Header = __webpack_require__(419);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _semanticUiReact = __webpack_require__(471);
	
	__webpack_require__(949);
	
	var _IndImage = __webpack_require__(1002);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rhythm = _typography2.default.rhythm;
	//import {IndexImage} from 'components/IndexImage'
	
	var FilmFocus = _react2.default.createClass({
	  displayName: 'FilmFocus',
	
	  statics: {
	    metadata: function metadata() {
	      return {
	        title: 'Men(S)tis'
	      };
	    }
	  },
	
	  onImageClick: function onImageClick(e, el) {
	    _reactRouter.browserHistory.push((0, _gatsbyHelpers.prefixLink)(el));
	  },
	  render: function render() {
	    var _this = this;
	
	    var movies = [];
	    var pages = this.props.route.pages;
	
	    pages.forEach(function (page) {
	      if ((0, _safeAccess2.default)(page, 'file.ext') === 'md' && !(0, _include2.default)(page.path, '/404') && (0, _startsWith2.default)(page.path, "/film-focus/")) {
	        movies.push(page);
	      }
	    });
	    var gridMovies = [];
	    while (movies.length > 0) {
	
	      var line = movies.splice(0, 1);
	      line.forEach(function (el, idx) {
	        gridMovies.push(_react2.default.createElement(
	          'div',
	          { className: 'column' },
	          _react2.default.createElement(
	            'div',
	            { className: 'image-fit', onClick: function onClick(e) {
	                return _this.onImageClick(e, el.path);
	              } },
	            _react2.default.createElement(_semanticUiReact.Image, { src: (0, _gatsbyHelpers.prefixLink)(el.path) + "front.jpg" }),
	            _react2.default.createElement(
	              'div',
	              { className: 'image-overlay' },
	              _react2.default.createElement(
	                'div',
	                { className: 'image-text' },
	                el.data.title
	              )
	            )
	          )
	        ));
	        //gridMovies.push(( <TestImage/> ));
	      });
	      //var line = movies.splice(0,3);
	
	      //var elLine = [] 
	      //line.forEach( (el, idx) => {
	      //    elLine.push(( <Grid.Column> <div className="image-fit"><Image  src={prefixLink(el)  + "front.jpg"} onClick={ (e) => this.onImageClick(e,el) } /></div></Grid.Column>))  
	      //});
	
	
	      //gridMovies.push((<Grid.Row columns={3}> {elLine}</Grid.Row>) )
	    }
	    return _react2.default.createElement(
	      _reactDocumentTitle2.default,
	      { title: FilmFocus.metadata().title + ' | ' + _config.config.siteTitle },
	      _react2.default.createElement(
	        'div',
	        { className: 'ui container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'three column stackable ui grid ' },
	          gridMovies
	        )
	      )
	    );
	  }
	});
	
	exports.default = FilmFocus;
	module.exports = exports['default'];

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _include = __webpack_require__(420);
	
	var _include2 = _interopRequireDefault(_include);
	
	var _colors = __webpack_require__(422);
	
	var _typography = __webpack_require__(427);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _reactRouter = __webpack_require__(173);
	
	var _gatsbyHelpers = __webpack_require__(403);
	
	var _config = __webpack_require__(404);
	
	var _semanticUiReact = __webpack_require__(471);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var rhythm = _typography2.default.rhythm,
	    adjustFontSizeTo = _typography2.default.adjustFontSizeTo;
	
	var TestImage = function (_Component) {
	    _inherits(TestImage, _Component);
	
	    function TestImage() {
	        _classCallCheck(this, TestImage);
	
	        return _possibleConstructorReturn(this, (TestImage.__proto__ || Object.getPrototypeOf(TestImage)).apply(this, arguments));
	    }
	
	    _createClass(TestImage, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                "A"
	            );
	        }
	    }]);
	
	    return TestImage;
	}(_react.Component);
	
	;
	
	TestImage.propTypes = {};
	
	exports.default = TestImage;
	module.exports = exports['default'];

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

	module.exports = {"title":"Les Innocentes","body":"<center>\n<img src=\"Inno.jpg\">\n</center>\n<p><a name=\"KLA\"></a></p>\n<h2><font color=\"#808000\"><strong>Klapbord</strong></font></h2>\n<p>De Frans-Luxemburgse actrice <strong>Anne Fontaine</strong> debuteerde als cineaste in 1993 met Les histoires d’amour finissent mal…en général. Geleidelijk heeft ze zich geprofileerd als een van de vrouwelijke, Europese cineasten die bewust <strong>cinematografische vrouwenportretten</strong> op het witte doek brengen. Dat was het geval met haar internationaal gewaardeerde <em>Coco avant Chanel</em> (2009). Met <strong>Les Innocentes</strong> bevestigt ze dit engagement. Daarbij kiest ze bewust voor onbekende vrouwen, kloosterzusters die slachtoffer werden in een historisch drama. De film zou oorspronkelijk <strong>Agnus Dei</strong> heten. Uiteindelijk werd voor <strong>Les Innocentes</strong> gekozen. De film brengt een vergeten gebeurtenis uit de naoorlogse Poolse geschiedenis aan het licht. De opnames vonden plaats in de Poolse, noordelijke regio Warmia in de winter van januari-februari 2015. Voor de opnames werd een gedesaffecteerd klooster terug tot leven gewekt. In begin 2016 ging de film in première tijdens het Amerikaanse <em>Sundance Film Festival</em>. Poolse actrices vertolken de rol van de kloosterzusters. Eén van hen is de bekende Agata Kulesza in de rol van moeder overste. In de Poolse film <strong>Ida</strong> nam ze de rol van de tante Wanda voor haar rekening. De film Les Innocentes is een Frans-Poolse coproductie.</p>\n<p><a name=\"SYN\"></a></p>\n<h2><font color=\"#808000\"><strong>Synopsis</strong></font></h2>\n<p>Twee jonge vrouwen leven in totaal verschillende werelden, maar een historisch drama doet hun wegen kruisen. Dat gebeurt in <strong>Polen in de winter van 1945-1946</strong>. Polen is dan bevrijd door het Sovjetleger. De Tweede Wereldoorlog is in Europa al op 8 mei 1945 beëindigd. Het Sovjetleger bezet Polen. De ene jonge vrouw heet <strong>Mathilde Beaulieu</strong>. Ze is een Franse dokter met van huis uit communistische sympathieën. De andere is de Benedictijnse <strong>zuster Maria</strong>, verantwoordelijk voor de novicen. De twee jonge vrouwen komen in contact met elkaar door toedoen van de novice Teresa. Die overtreedt de kloosterregels door op zoek te gaan naar hulp bij <strong>de medische post van het Franse Rode Kruis</strong> nabij Warschau. Ze zoekt een dokter die noch Russisch noch Pools is. Teresa vindt Mathilde aan wie ze in gebrekkig Frans medische bijstand vraagt voor een van haar medezusters die stervende is. Eerst verwijst Mathilde de non door naar het Poolse Rode Kruis. Wanneer ze echter Teresa ziet volharden terwijl ze biddend op haar blijft wachten, volgt Mathilde de jonge non naar <strong>de abij</strong>. Daar ontmoeten Mathilde en Maria elkaar voor het eerst. Mathilde ontdekt dat een van de zusters, <strong>de novice Zofia</strong>, in levensgevaar verkeert wegens een moeilijke, nakende geboorte van haar baby. Mathilde, geholpen door zuster Maria, voert met succes een keizersnede uit. Uiteindelijk ontdekt Mathilde <strong>de dramatische waarheid van de abdij</strong>. De voorbij trekkende Sovjettroepen hebben gedurende enkele dagen in de abdij de zusters tot driemaal toe verkracht. Collectief en individueel moeten de zusters met dat onvoorstelbare trauma hun kloosterleven verder zetten. Maria vertelt Mathilde dat zeven zusters zwanger zijn geraakt. Nadien blijkt dat er ook zusters hun zwangerschap hebben weten te verbergen voor zichzelf en de anderen. Door toedoen van zuster Maria, raakt Mathilde geleidelijk vertrouwd met de gang van zaken in de abdij, een wereld die haar als communiste volkomen vreemd is. Ze ziet hoe zuster Maria moet optornen tegen haar overste, <strong>de abdis Jadwiga Oledzka</strong>. Die doet er alles aan om haar zusters tegen de schande en de schaamte ten aanzien van de buitenwereld te beschermen. Zelf heeft moeder overste syfilis opgelopen tijdens de verkrachtingen. Ze weigert zich te laten behandelen door Mathilde. In een eerste fase aanvaarden de zusters met tegenzin de hulp van Mathilde, maar in een tweede fase leren ze haar waarderen en nemen ze haar in hun gemeenschap op alsof ze een medezuster is. <strong>Zuster Maria en dokter Mathilde</strong> wisselen ook gedachten uit over wat er gebeurt en over hoe de zusters het drama trachten te verwerken. Wanneer dokter Mathilde op zekere avond onderweg is van de abdij naar de Franse medische missie, haar werkplek, houden Sovjetsoldaten haar tegen. Ze willen haar verkrachten, wat slechts op het nippertje door hun militaire overste wordt verhinderd. Ze rijdt dan terug naar de abdij, waar ze veilig overnacht. In de medische missie waar ze werkt als assistente van haar Joodse collega en mentor, <strong>dokter Samuel Lehmann</strong>, botst dokter Mathilde steeds meer op kritiek over haar vreemd gedrag. Ze kan echter niet vrijuit spreken. Toch ontstaat er tussen haar en Samuel een goede band en zelfs een beginnende liefdesrelatie, de antipode van de agressieve omgang met seksualiteit door de Sovjets. Op zeker moment vraagt Mathilde Samuel om mee te komen helpen bij de gelijke bevalling van twee zusters. Als Jood heeft Samuel geen hoge pet op van Polen wegens de betrokkenheid, passief of actief, van vele Polen bij de Holocaust. En hij weet dat de katholieke Kerk, ook de Poolse, een antisemitisch verleden heeft. Toch helpt hij mee bij de bevalling van de zusters. Ondertussen spannen zuster Maria en dokter Mathilde samen om zonder weten van de abdis één van de pasgeboren baby’s bij zuster Zofia onder te brengen. Ze kan de baby voeden. Ze beschouwt de zuigeling als haar eigen kind dat ze door toedoen van de abdis  heeft moeten afstaan voor adoptie. Ze noemt de baby <strong>Helena</strong>. Toch ontdekt de abdus het bestaan van Helena en neemt ze het kind weg van zuster Zofia. Die ziet hoe de abdis de baby in een mand wegdraagt. Zofia volgt haar moeder overste in paniek in het omliggende bos, maar verliest haar spoor. Overvallen door verdriet en radeloosheid, pleegt zuster Zofia <strong>zelfmoord</strong>. De dokters Mathilde en Samuel zijn er getuige van. Kort daarna, ontdekt zuster Maria dat haar overste in plaats van de kinderen naar Poolse adoptieouders te brengen, hen heeft laten sterven. Na de ontdekking daarvan verlaten <strong>zuster Maria en zuster Anna</strong> met de twee nieuwe baby’s naar het Rode Kruis om bescherming te vragen. Mathilde weet de zusters te overtuigen om terug te keren naar de abdij om er <strong>een weeshuis</strong> in onder te brengen voor de verschillende weeskinderen die een voorlopig onderkomen hebben gevonden in het tijdelijke, medische kamp van het Franse Rode Kruis. Op die manier kunnen ze ook de kinderen van de zusters zonder schaamte als weeskinderen in de abdij blijven verzorgen. De zieke abdis trekt zich, overrompeld door een intens schuldgevoel, terug in haar cel. Zuster Anna verlaat de abdij. Bij de komst van de eerste lentedagen, poseren de zusters fier met hun weeskinderen op de feestelijke dag waarop de novicen hun kloostergeloften afleggen. Zuster Maria zendt <strong>de groepsfoto</strong> naar Mathilde om haar in naam van iedereen in de abdij te bedanken voor haar zorgend werk waardoor zij allen en hun abdij een nieuwe toekomst hebben.</p>\n<p><a name=\"CIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Cinematografie</strong></font></h2>\n<p><span class=\"menstis\"><strong>REGIE VAN HET LICHT</strong></span>. Cinematografisch gezien, is <strong>Les Innocentes</strong> van grote klasse. Dat komt door het werk van de cinematografe van dienst, <strong>Caroline Champetier</strong>. Zij geniet een groot prestige in de Franse cinema. Ze werkt immers al twee generaties lang nauw samen met een aantal eerste klasse regisseurs: Jean-Luc Godard (<em>Hélas pour moi</em>), Alain Cuny <em>(L’annonce faite à Marie</em>), Jacques Rivette (<em>La bande des quatres</em>), Xavier Beauvois (<em>Des Hommes et des Dieux</em>), Leos Carax (<em>Holy Motors</em>), Margarethe von Trotta (<em>Hannah Arendt</em>). Door de jaren en de films heen heeft Caroline Champetier zich ontpopt tot een grootmeester van het cinematografische lichtbeeld. In een interview met Claude Lefort en Didier Péron voor Libération (4 februari 2014) met haar, verduidelijkt Caroline Champetier haar werk in het domein van de cinematografie. Ze vertelt hoe ze zich vooral <strong>‘een vertolkster van het beeld’</strong> voelt (‘Je me sens très interprète de l’image’), zoals een muzikant die een parituur interpreteert en zichzelf ieder dag telkens opnieuw uitvindt op het ritme van de voortdurend veranderende realiteit tijdens de opnames. de wisselende weersomstandigheden, de acteurs die in goede of slechte stemming verkeren, allerlei kleine technische conflicten die een oplossing vragen, enzovoort. Ze noemt de filmset een strijdplaats waar de vrede moet worden behouden via technisch, artistieke en menselijk overleg. Zij ziet haar taak als cinematograaf in het voortdurend bevorderen van de vrede via een nauwe samenwerking tussen de regisseur en de cinematograaf. Die samenwerking op de filmset noemt ze ‘<strong>een utopische democratie</strong>’ (‘C’est pour ça que le cinéma est une utopie démocratique’). In haar meer recent werk, zoals voor <strong>Des Hommes et des Dieux</strong> en <strong>Les Innocentes</strong>, combineert ze wat ze noemt <strong>de twee grote stijlen om met het licht om te gaan in de filmkunst</strong>. Er is <em>de Duitse school</em> die vooral aandacht schenkt aan de ruimte, de omgeving, het decor en het spel van de lichtcontrasten, terwijl <em>de Amerikaanse school</em> zich meer focust op de acteurs. In de samenwerking met de regisseur gaat het voor de cinematograaf steeds om de juiste verhouding te vinden tussen de ruimtewerking en het fotogenieke. In <strong>Les Innocentes</strong> blijkt die verhouding uit een sterk doordacht afwisselend ritme tussen de landschapsbeelden en de fotogenieke close-ups met de vertolkers. Bij de eerste betreft dit vooral <strong>de sublieme beelden van de buitenomgeving van de abdij met het naburige bos</strong>. Het openingsbeeld met zuster Teresa die op zoek gaat naar medische hulp voor haar medezuster Zofia, zet hierbij de visuele toon van de film. Andere sterke ruimtebeelden komen voor in de tocht van moeder overste met baby Helena naar het kruisbeeld aan de rand van het bos, waarbij Zofia haar volgt maar zich verloren voelt in het bos daar waar twee wegen elkaar kruisen. Een derde belangrijke ruimtebeeld situeert zich in de naburige hoeve waar de tante van Zofia woont. Zuster Maria gaat haar opzoeken om haar het overlijden van Zofia te melden. Daar ontdekt zuster Maria dat moeder overste baby Helena nooit daar heeft naar toe gebracht. Die verschillende ruimtebeelden baden in <strong>een zacht maar helder winterlicht dat door de sneeuw wordt geabsorbeerd</strong>. Daarbij ontstaat er een ingetogen picturaal beeld met contrasten tussen wit en zwart dat ook de kleur van de habijten van de zusters kenmerkt. <strong>De lichtende interpretatie</strong> die Caroline Champetier eraan geeft, drukt <strong>de grondstemming van het verhaal</strong> passend uit. Daarbij beklemtoont ze niet zozeer het contrast tussen zwart en wit, maar <strong>de simultane aanwezigheid</strong> van de twee. Daarin wordt het drama dat zich afspeelt, heel zichtbaar. Het dramatische van het fysieke en mentale lijden van de zusters, die donkere zijde van het drama dat ze meemaken, geeft nu aan hun kleding een bijzondere betekenis. Het zwarte gaat nu samen met hun onschuld, uitgedrukt in het witte deel van hun habijt, vooral bij de jonge novicen die een volledig witte kap dragen. <strong>Het winterlandschap</strong> lijkt verlengde van het kloosterleven te zijn geworden met dezelfde samenhang tussen de diepste donkerte en een hemelse helderheid. In de talrijke opnames in het abdijgebouw ligt de nadruk op de personages, de zusters en dokter Mathilde. Hierbij werkt Caroline Champetier met <strong>het picturale licht</strong> in de lijn van de Nederlandse schilders Vermeer en Rembrandt. Daaruit spreekt <strong>een grote feminiene lichtpoëzie</strong> die erin slaagt zonder woorden de innerlijke gemoedsgesteldheid passend uit te drukken. De woorden voeren niet de regie over de scènes. Het zijn veeleer <strong>de stilte en de schouwende blik</strong> die de gevoelens evoceren van de zusters, in het bijzonder van zuster Maria die het dichtste bij het drama staat en dokter Mathilde die direct met de gevolgen van het drama oog in oog komt te staan. Via de komst van zuster Teresa in de medische zorgzaal van het Franse Rode Kruis ontstaat er ook cinematografisch een band tussen de abdij en de medische post. De medische post staaat aan deze zijde van het bos net terwijl de abdij zich aan de andere kant ervan bevindt. En via de medische witte kleding ontstaat er een gelijkaardig wit licht als in de kleding van de zusters. Dat <strong>lichte licht</strong> wenkt Mathilde wanneer ze vanuit een rraam in de medische post tijdens een korte pauze zuster Teresa ziet bidden op haar knieën in de sneeuw tussen de bomen. Dan beslist Mathilde dat <strong>lichtspoor</strong> te volgen en zo ontstaat er een verbindingslijn tussen de ene en de andere kant van het winterse bos, tussen de medische post en de abdij. Daarnaast komen er een aantal taferelen voor die in <strong>een andere lichttoonaard</strong> zijn opgenomen. Dat geldt voor <strong>de intieme sequenties met Mathilde en Samuel</strong> en het eenmalige tafereel met Mathilde en de Russische soldaten langs de weg in het bos. Bij dit laatste overheerst een donker en vuil groen-militair licht, <strong>de kleur van de hel</strong>. In de intieme scènes met Mathilde en Samuel herinnert een gedempt groen-militair en bakstenen-rood licht aan de hel van de Oorlog die nu wel voorbij is, maar waarvan de gevolgen nog overal zichtbaar zijn. Alleen de gezichten van de twee collega’s en geliefden, twee mensen van goede wil, lichten op in het grauwe donker. Die intieme scènes situeren zich in de ontspanningszaal van het medische team en in de logeerkamer van Mathilde in Poolse woning. Het gedempte groen-roodachtige licht in de ontspanningszaal evoceert <strong>een mix van romantiek en melancholie</strong>, terwijl het gedempte licht in de slaapkamer van Mathilde via het binnenvallend schemerlicht en de witheid van de lakens en nachtkleding, weer aansluit bij de lichtsfeer van de abdij. In dat positieve licht schijnt de kleine zon van de sympathie en liefde tussen Mathilde en Samuel. Ze waarderen en steunen elkaars medisch werk. Allebei zetten ze zich in voor een andere wereld, één waar tijd en ruimte is voor liefde en genegenheid. Dat drukken ze uit in het bewustzijn dat ze elkaar respecteren en van elkaar houden, maar ze wellicht na het beëindiging van hun medische missie elkaar nooit meer zullen zien. Bovendien dragen ze in hun gemoed ook hun eigen persoonlijk oorlogsverdriet mee. Mathilde moet haar geheim over de vrouwenabdij bewaren, Samuel is de enig overlevende van zijn Joodse familie. De <strong>unieke eigen lichtsfeer</strong> die <strong>Les Innocentes</strong> typeert, bestaat uit het afwisselend ritme van buitenbeelden en binnenbeelden met vooral de abdij als focuspunt. Dat gebeurt via het werk van Caroline Champetier in de regie van wat we in het derde deel van <em>Levensbeschouwing democratisch belicht</em> <strong>de Lichtaard</strong> noemen.</p>\n<p><span class=\"menstis\"><strong>DOCUDRAMA</strong></span>. ‘<em>Geïnspireerd door ware gebeurtenissen</em>’. Zo introduceert de film zichzelf bij het publiek. Het scenario van de film is geschreven door vier auteurs onder wie de cineaste zelf, Anne Fontaine. Het uitgangspunt van hun scenario waren de nota’s van de <strong>Franse dokter, Madeleine Pauliac</strong> (1912-1946). Over die nota’s en zijn tante, heeft haar neef, Philippe Maynial, onderzoek verricht. Hij heeft op basis hiervan het idee voor de film aangebracht. Voor de historische gegevens over zijn tante die hierna volgen, is hij de aangewezen bron. Arthur Herlin publiceerde op 20 februari 2016 een interview met hem op de site Aleteia, het wereldwijde katholieke netwerk (<em><a href=\"http://www.aleteia.org\">www.aleteia.org</a></em>). Zo leren we dat zijn tante Madeleine, een gespecialiseerde hospitaaldokter in Parijs, tijdens de bezetting van Frankrijk door de troepen van Hitler actief het verzet steunde. Ze liet zelfs bij haar ook Joodse slachtoffers onderduiken. Op vraag van generaal De Gaulle zelf, leidde ze reeds vanaf april 1945 als <strong>medische luitenant van het Franse leger</strong> de heropbouw van het hospitaal van Warschau en het Franse Rode Kruis in Polen, waarbij ze ook een tijd in bevrijd Rusland heeft gewerkt. Haar taak bestond in de organisatie van de medische hulp bij <strong>de repatriëring van de talrijke Franse overlevenden in de circa 200 Poolse concentratie- en vernietigingskampen</strong> die ze zelf ook heeft bezocht. Tijdens een van de autoritten naar de kampen, liep ze een zwaar hoofdletsel op, wat haar niet belette haar medische werk in Warschau voort te zetten. Daar stierf ze tijdens een auto-ongeval op weg naar het hospitaal. Philippe Maynial heeft de rechten van het historisch verhaal over zijn tante verkocht aan de makers van de film <strong>Les Innocentes</strong>. Zij hebben de historische gegevens uiteraard vrij aangepast met behoud van de geest zelf en de basislijn van het geschreven getuigenis van de Franse dokter. Van haar neef Maynial weten we dat Madeleine Pauliac op haar tocht door bevrijd Oost-Europa in Polen zelf vergezeld en geholpen werd door <strong>de Franse priester Belliard</strong>. Hij was zelf een bevrijde krijgsgevangene in Polen. Na zijn bevrijding, heeft hij het werk van Madeleine Pauliac onbaatzuchtig en vol toewijding ondersteund, zoals blijkt uit de nota’s van Madeleine Pauliac zelf. Het scenario heeft de historische priester vervangen door <strong>het fictieve personage van de jonge Joodse dokter Samuel Lehman</strong>, wiens familie is omgekomen in het nazikamp Bergen-Belsen. In de film wordt Madeleine zelf vervangen door <strong>het fictieve personage van Mathilde Beaulieu</strong>. Zij is een medische studente die haar stage doet in de Franse medische missie van het Rode Kruis in het pas bevrijde Polen. Zij werkt er onder leiding van de Joodse dokter Samuel. In de film blijkt dat Mathilde <strong>communiste en dus ook atheïste</strong> is. De historische Madeleine was katholiek. Het filmische motief om het personage van de dokter aan te passen betreft het scenario. Daarin ligt de focus niet op een reconstructie van de gebeurtenissen in de eerste weken en maanden na de bevrijding van de Russische bezette gebieden in Polen. In die zin heeft de film geen historische pretenties; de film biedt geen biopic over de historische Madeleine Pauliac. De focus ervan richt zich helemaal op <strong>het contrast tussen de medische nazorg van de Oorlog en de getraumatiseerde abdijgemeenschap</strong>, alsook op <strong>de vrouwelijke solidariteit</strong> die uit dat contrast voortkomt. De film werkt met de verwondering van de ongelovige jonge vrouwelijke dokter die uit eigen vrije wil en vanuit een medisch plichtsgevoel de zustergemeenschap bijstaat. Bovendien laat de rol van de Joodse dokter Samuel ook toe om,in het korte bestek van het verhaal dat zich in Polen situeert, verantwoord naar <strong>de Holocaust</strong> te verwijzen zonder dit op zich uit te werken. Enkele overlevende kinderen van de kampen komen voor als figuranten. Wat de filmische tijd betreft, concentreert Mathilde zich niet zozeer op de slachtoffers van de nazikampen, maar op <strong>de Poolse slachtoffers van de Russische bevrijders</strong>. In dat filmisch gegeven steekt ook een historische verwijzing naar de historische Madeleine. Als dokter heeft ze zelf de gevolgen gezien van de grote schanddaden, begaan door de Sovjettroepen op hun weg naar Hitler in Berlijn. Ondertussen heeft historisch onderzoek de omvang van dit taboe uit de bevrijdingsgeschiedenis van de Tweede Wereldoorlog in kaart gebracht. Selm Wenselaers vat in zijn bijdrage <strong>De Sovjetschande</strong> de cijfers van het opzienbarende onderzoek <em>Befreier und Befreite</em> (1992) als volgt samen:</p>\n<blockquote>\n<p>‘<em>De oprukkende Sovjettroepen in 1944 waren genadeloos voor de Duitse bevolking. De ‘Ivans’ werden gevreesd omdat ze zich plunderend en verkrachtend een weg naar Berlijn baanden. Vooral de vrouwen betaalden het gelag. Het maakte niet uit of ze jong of oud waren, nazi of Joods, of ze pas bevrijd waren uit een concentratiekamp of uit hun schuilplaats kwamen na jaren ondergedoken te hebben geleefd. Tussen de herfst van 1944 en de zomer van 1946 werden alleen al in Duitsland zo’n 2 miljoen vrouwen door Sovjetsoldaten verkracht. Naar schatting 240 000 vrouwen lieten hierbij het leven, omdat ze vermoord werden of omdat ze zichzelf om het leven beroofde, beschaamd voor wat hen was aangedaan.</em>’ (De Oorlogskranten 1940-1945, nr. 48).</p>\n</blockquote>\n<p>De film <strong>Les Innocentes</strong> herinnert niet alleen aan die dramatische oorlogsgeschiedenis. De film versterkt nog de draagwijdte ervan door te herinneren aan de Poolse vrouwen, met name dan nog de Poolse kloosterzusters die ook slachtoffer zijn geworden van <strong>de Sovjetsoldaten</strong>. Dat blijkt uit de nota’s van de historische <strong>Madeleine Pauliac</strong> zelf. Trouwens in de film komt een tafereel voor waarin haar filmpersonage Mathilde zelf ook slachtoffer dreigt te worden van die soldaten. Dat tafereel samen met het tafereel waarin Mathilde in de abdij de zusters behoedt voor de terugkerende Sovjetmannen, verdicht ook een historische gebeurtenis. Onderweg met de Franse Rode Kruis in het bevrijde deel van de Sovjet-Unie, werd Madeleine Pauliac en haar hele team gevangen genomen door het Sovjetleger. Ze werden opgesloten en bedreigd te worden terechtgesteld. <strong>Een moedige tussenkomst van dokter Madeleine</strong> bij de hogere miitaire overste heeft haar en haar team het leven gered. Ze vertelde de Sovjetofficier dat een familielid van haar deel uitmaakte van het vermaarde escadrille Normandie-Niemen dat tegen de Duitsers vocht in opdracht van generaal De Gaulle aan het Oostfront. Deze leugen om bestwil wist de officier te overtuigen om het team van het Franse Rode Kruis vrij te laten. Ook in de film <strong>Les Innocentes</strong> weet dokter Mathilde de Sovjetsoldaten om de tuin te leiden met een leugen om bestwil. Ten slotte, de hulp die Mathilde in de film verleent aan de Poolse zusters, weerspiegelt ook het werk van de historische dokter Madeleine. Ze maakte in haar werk <strong>geen onderscheid tussen de slachtoffers op basis van nationaliteit</strong>, wat werd bevestigd door de priester Belliard die in haar voetsporen stapte om geestelijke hulp aan de slachtoffers te bieden.</p>\n<p><span class=\"menstis\"><strong>KLANKWERELD</strong></span>. De film opent met een zwart beeld waarop de productiedata verschijnen. Bij het zwart beeld staat op de klankband het geluid van de abdijklok die de zusters oproept tot het koorgebed, gevolgd door de klank van de voetstappen van de zusters in de kloostergang. Dan zien we hen in rugzijde door de kloostergang uit het beeld verdwijnen, waarna de titel <strong>Les Innocentes</strong> tegen de wand van de kloostergang verschijnt. Deze<strong>audiovisuele intro</strong> zet meteen de toon voor de klankwereld van de film. Die bestaat in de eerste plaats uit <strong>de natuurlijke geluiden, verbonden met de wereld van de abdij</strong>: de klok, de voetstappen die sterk weergalmen in <strong>de contemplatieve ruimte van de stilte</strong>. Diezelfde stilte typeert ook het bos met de sneeuw waar zuster Teresa haar weg vervolgt. We horen haar kordate voetstappen in de sneeuw. Die contemplatieve stilte die de natuurlijke klanken in zich opneemt, maakt dat de menselijke stem geen hoofdrol krijgt. <strong>De dialogen</strong> zijn uiterst beperkt wat de zusters onderling betreft, en gedeeltelijk ook wat de die tussen dokter Mathilde en zuster Maria betreft, op enkele uitzondringen na. Alleen buiten de abdijmuren, namelijk in de medische missiepost, komen er enkele gesprekken voor tussen dokter Mathilde en dokter Samuel over hun respectieve familiegeschiedenis. Hun gesprekken hebben een intiem en daardoor ook een contemplatief karakter. Binnen de abdijmuren krijgt de menselijke stem via de stilte toch een bijzonder klankkleur. Daar zijn <strong>de religieuze, Gregoriaanse gezangen</strong>. Vooral in het openingstafereel zingen de zuster de Gregoriaanse getijdengebed <strong>Conditor Alme Siderum</strong>. Die wordt volledig in beeld gezongen. Het betreft een hymne uit de 7de eeuw die veelal in de Adventstijd tijdens de vespers wordt gezongen. Het is een smeekgebed tot <em>‘de Schepper van de sterren van de nacht, van het altijd durend licht van Zijn volk’</em> en tot '<em>Jezus, de Verlosser</em>’. Ze smeken om verlossing en om gehoord te worden. In de smeekbede die daarop volgt, vragen de gelovigen, in casu de zusters, om <em>een remedie</em> (‘remedium’) die verlossing kan brengen aan hen die moeten leven inleiding <em>een wereld in ruïne</em>. In een volgende strofe introduceert de religieuze hymne de beeldspraak van <em>de Bruidegom en de Bruid uit het Hooglied</em>. Die beeldspraak is van groot belang voor de zusters. In hun spirituele beleving zijn zij de maagdelijke bruiden en is de hemelse Jezus de Verlosser hun Bruidegom. Op het einde vragen ze bescherming zolang ze hier <em>‘beneden’</em> in de tijd verblijven, waarna ze afsluiten met lof aan de Heilige Drie-eenheid. De openingshymne doet filmisch drie dingen. Ze bevestigt <strong>het dagelijkse ritueel van het getijdengebed</strong> met psalmen en hymnen, wat het monastieke leven, zeker van de Benedictinessen, typeert. Tegelijkertijd drukt het in een religieuze taal <strong>de dramatische situatie</strong> uit waarin de zusters zich bevinden. Het smeekgebed verwijst metaforisch naar hun ‘wereld in ruïne’ en naar hun verlangen naar een verlossing, wat in deze context wel erg bijzonder klinkt. In de tekst komt ook het medisch klinkend woord van een remedie voor. Ten derde is er het dramatische effect waarmee het verhaal opstart. De <em>novice Teresa</em> heeft de hymne aandachtig meegezongen en geabsorbeerd, vooral wanneer ze door het gezang van de zusters heen de wanklank hoort van de pijnschreeuw van haar medezuster, novice Zofia. Die schreeuw zet haar na het gebed in beweging richting de Franse medische missie. Met die beslissing, tevens een overtreding van de geldende kloosterregels, opent de dramatische wending in het filmverhaal. Die schreeuw van in weeën verkerende Zofia vormt <strong>de hoofdklank van de film</strong>. In het tafereel met <strong>Conditor Alme Siderum</strong> integreert de klankmontage de schreeuw van de jonge moeder-zuster in het religieuze gezang, een wonderlijk en betekenisrijke compositie. Later volgt nog <strong>de hartverscheurende schreeuw in het bos</strong> van de wanhopige Zofia die op zoek is naar ‘haar’ baby Helena. En in de verkrachtingsscène met Mathilde weerklinkt ook haar schreeuw waarin die van de verkrachte zusters nazindert in de verbeelding van de aandachtige toeschouwer. In het tafereel van de dubbele geboorte waarbij dokter Mathilde hulp krijgt van dokter Samuel, komt er nog een sterke verwevenheid van het religieuze gebed van de zusters en de kreet van de twee moeders in weeën. Ze onderbreken hun diepe ademhaling bij de weeën driemaal op het ritme van het Angelus dat ze ’s middags gewoon zijn te bidden. Een tweede Gregoriaans gezang dat een zowel religieuze als dramatische betekenis krijgt, is <strong>Regem Venturum Dominum</strong>. Die wordt gezongen bij de dageraad, de <em>Lauden</em>. Het is een Kerstlied want het spreekt over de komst van de <em>‘Koning der koningen’ op aarde, als kind ‘onder ons’ geboren (‘nascetur nobis parvulus’)</em>. In hun morgengebed smeken de zusters de komst af van <em>‘de Koning der Koningen’, ‘onze Beschermer’</em>. Ze aanbidden Hem en vragen om weldra te komen in <em>‘een groot licht’ (‘lux magna’)</em>. Op de tonen van dit betekenisvol gezang laat zuster Maria dokter Mathilde binnen in de abdij, zonder medeweten van de abdis, om Zofia en haar baby medisch te kunnen opvolgen. Dokter Mathilde stelt dan vast dat de baby is verdwenen. Na het fragment met de consultatie van de zwangere zusters, waarin blijkt dat ze collectief weigeren zich te laten onderzoeken door dokter Mathilde, doet zuster Maria dokter Mathilde uitgeleide. Bij de scène waarin dokter Mathilde de abdij verlaat, weerklinkt in voice-over het <strong>Vox Clamantis in Deserto</strong>. Het korte gezang is ontleend aan de Bijbeltekst van <em>Marcus 1, 1-3</em> en <em>Johannes 1, 22-23</em>. Het spreekt over Johannes de Doper, de profeet die zich voelt als een roepende in de woestijn. Dergelijk gevoel overvalt zowel zuster Maria als dokter Mathilde. Hun woestijn is de abdij met zijn zwangere, getraumatiseerde zusters. Een ander belangrijk Gregoriaans gezang is het meer gekende <strong>Rorate Caeli</strong>. Dat komt voor op het ogenblik dat dokter Mathilde ontwaakt in de abdij nadat ze op het nippertje ontsnapt is aan een verkrachting. In de abdij wordt ze gewekt door het gezang van de zusters. Ze wandelt naar de kapel en luistert naar het <strong>Rorate Caeli</strong>. Dat kerkgelijke gezang is een Gregoriaanse introïtus, een inleiding op de misviering van de laatste, de vierde zondag van de Advent, dus de laatste zondagsmis voor het eigenlijke feest van Kerstmis. De tekst zelf is gebaseerd op de Bijbeltekst van <em>Jesaja 45,8</em>. In het refrein weerklinkt de bede aan <em>de Schepper om als regen uit de hemel gerechtigheid te laten neerdalen over de aarde</em>. In een apart beeld zien we Mathilde die aandachtig luistert en het gebed ook in zich opneemt. Dat is begrijpelijk want voor één nacht is ze ook kloosterzuster geweest nadat ze door de Sovjetsoldaten onderweg was overvallen en een groot verdriet haar overviel nadat zuster Maria haar een veilig onderkomen had gegeven in de abdij. De compositie van beeld- en klankband bij dit belangrijke gezang ligt in de lijn van de vorige, maar bereikt hier een hoogtepunt. De religieuze a capella muziek mengt zich met de dreigende geluiden buiten beeld van de binnendringende Sovjetsoldaten, geluiden die de zusters maar al te goed herkennen. Opmerkelijk is dat ze blijven doorzingen. Eerst zingen ze in aanwezigheid van Mathilde het refrein en de tweede strofe. Daarin zingen ze:</p>\n<blockquote>\n<p>‘<em>We hebben gezondigd en zijn onrein geworden waardoor we lijken op vallende bladeren want door onze zonden worden we met de wind meegenomen. Ge hebt U voor ons verborgen en ons neergeworpen wegens de zwaarte van onze zonden.</em>’</p>\n</blockquote>\n<p>Dan zingen de zusters de laatste strofe. Maar dat gebeurt cinematografisch opmerkelijk. De camera richt zich naar zuster Maria en zuqter Anna die samen de laatste strofe zingen. Het betreft de strofe waar God zelf antwoordt op de bede van de gelovigen. Het is het goddelijke antwoord van de troost:</p>\n<blockquote>\n<p><em>‘Consolamini, consolamini, popule meus’: ‘Troost u, troost u, mijn volk. Weldra komt uw heil. Waarom verliest u zich in uw verdriet daar het uw smart nog verzwaart. Vrees niet, ik zal u redden, want ik ben de Heer, uw God, de Heilige van Israël, uw Verlosser.</em>’</p>\n</blockquote>\n<p>Uitgerekend bij deze strofe zoomt de camera steeds meer in op het gelaat van de zingende Maria terwijl het dreigende geluid van de invallende Sovjetsoldaten luider begint te klinken om uiteindelijk het religieuze gezang te overstemmen. De troost en redding waarover de zusters zingen, komst op dat ogenblik van Mathilde die de soldaten met een medische leugen om best wil uit de buurt van de zusters kan houden. Na dat dreigend tafereel die bij alle zusters dramatische herinneringen wakker roept, volgt <em>het belangrijke gesprek tussen zuster Maria en dokter Mathilde</em>. De zuster weent en bekent dat ze bidt en bidt, maar geen troost vindt, die troost waarover ze even daarvoor zo intens had gezongen. Ze bekent dat ze iedere dag de verschrikking van de verkrachtingen terug beleeft. ‘Ze hadden ons moeten vermoorden. Het is een wonder dat ze dat niet hebben gedaan.’ In het daarop volgende beeldkader met de close-up met zuster Maria en dokter Mathilde vertelt Maria dat zij nog enigszins geluk heeft gehad omdat ze voor ze in de abdij is gekomen, had ze omgang gehad met een man, maar de meeste zusters waren nog maagd. Mathilde vraagt dan of niemand van hen het geloof heeft verloren. Dan vertelt zuster Maria over het geloof.</p>\n<blockquote>\n<p><em>‘Eerst is het als een kind dat zich veilig voelt aan de hand van zijn vader. Dan komt er altijd een moment dat je vader je hand loslaat. Je voelt je verloren, alleen in het donker. Je roept om hulp maar niemand antwoordt. Hoe goed je jezelf ook voorbereidt, je wordt toch verrast. Het raakt je recht in je hart.</em>’</p>\n</blockquote>\n<p>Op dat ogenblik gaat ze naar het raam toe met <strong>het invallende, zachte licht</strong>. Terwijl in beeld dat licht op haar gelaat valt, spreekt ze verder over het geloof: ‘Dat is het kruis dat we dragen. Achter de vreugde is er het kruis.’ Dokter Mathilde luistert aandachtig en neemt de woorden in zich op. Het is het einde van haar verblijf in de abdij, bezegeld door de warme begroeting van alle zusters die haar blij uitwuiven. Een ander Gregoriaanse hymne heet <strong>Nunc, Sancte, nobis Spiritus</strong>. De intro ervan begint met de klank van de abdijklok. Dat is de tweede keer in de film. Deze keer hoort de klank van de klok samen met een panoramisch shot van de abdij met de klokkentoren. De zusters komen weer samen voor het getijdengebed. Ze zingen <strong>Nunc, Sancte, nobis Spiritus</strong>. De hymne verwijst naar het verhaal van de nederdaling van de Geest over de bange apostelen in het nieuwtestamentische <em>Handelingen van de Apostelen 2, 1-4</em>. De zusters bidden tot de Heilige Geest om kracht en sterkte om hun religieus leven te kunnen voortzetten. We zien de zwangere zusters in close-up. Dan vloeit de Gregoriaanse muziek over in rustige, meditatieve filmmuziek <strong>Les tâches quotidiennes</strong>. Strijkinstrumenten met een contrapuntische piano begeleiden het dagelijkse leven van de zusters, het <em>ora et labora</em>. De gebruikelijke rust schijnt te zijn teruggekeerd tot de muziek stopt en een van de zwangere zusters haar water breekt. Een ander belangrijk muzikaal fragment is gelinkt aan het personage van zuster en novice Zofia, de eerste zuster die is bevallen. Na de onverwachte bevalling van de al wat oudere zuster Ludwika die haar baby niet aanvaardt, beslissen zuster Maria en dokter Mathilde zonder medeweten van de abdis de baby aan Zofia te geven. Die zorgt ervoor alsof het haar eigen baby is. Ze noemt de baby <strong>Helena</strong>. Op het ogenblik dat de abdis echter het bestaan van Helena ontdekt, eist ze de baby op. Zuster Zofia ziet de abdis met ‘haar’ baby in een mand de abdij verlaten. Ze volgt de abdis in het bos maar raakt haar spoor bijster. Verloren staat ze op een kruispunt in het bos. Ze weent van wanhoop en verlatenheid. Ze kijkt smekend naar de hemel. De klank van haar wenen gaat over in het mystieke gezang van Hildegard von Bingen, <strong>O Vis Aeternitatis</strong>, terwijl het beeld nu de abdis volgt die baby Helena wegdraagt en bij het maken van een kruisteken voor dood achterlaat bij het kruisbeeld aan de rand van het bos. De extatisch, religieuze muziek van Hildegard von Bingen werkt contrapuntisch. Ook zij was een abdis. Het beeld van haar, aanwezig in haar mystieke muziek, contrasteert met het beeld van de Poolse abdis Jadwiga Oledzka. Hildergard van Bingen bezingt <em>het religieuze wonder van de geboorte, ‘de Incarnatie’</em>. Ze looft inderdaad <em>‘de grote goedheid van de Redder die alle dingen heeft bevrijd door zijn goddelijke Incarnatie, onaangetast door enige zonde’</em>. Dat credo in de goddelijke goedheid contrasteert met het beeld van de moord op baby Helena door de Poolse abdis die meent te moeten handelen uit plichtbesef. Ze drijft hiermee niet alleen de baby de dood in, maar ook haar novice Zofia. De moord zelf, het achterlaten in de mand aan de voet van het kruisbeeld, gebeurt in stilte. Alleen de handelingen van de zuster en de baby zijn versterkt hoorbaar. Bij de sequenties van het afscheid van de zusters van de opgebaarde Zofia weerklinkt in voice-over een fragment uit het <strong>Veni Creator Spiritus</strong>. Het is een smeekbede om de vervulling van de eigen geest en gemoed met de genade van de Heilige Geest. Het is de hymne die tijdens de liturgie van het hoogfeest van Pinksteren wordt gezongen. Vreemd genoeg, monteert de regisseur bij deze rouwscènes geen requiem, bijvoorbeeld geen <em>Dies Irae</em>. Het requiem is echter wel aanwezig, niet in klank maar in de beelden van een donker licht. Voor de eerste keer is het schroomvolle, heilige licht dat de abdij en de zusters omhult, afwezig. De religieuze muziek van het <strong>Veni Creator Spiritus</strong> impliceert ook dat de zusters de zelfmoord van Zofia <em>niet</em> beschouwen als een doodzonde. Ze begeleiden haar met een gebed dat spreekt van een geloof in <em>een genadevolle kracht van de Schepper die hemel en aarde omvat</em>. Bij het beeld van het afscheid van zuster Maria van de opgebaarde Zofia, gaat het <strong>Veni Creator Spiritus</strong> over in de filmmuziek <strong>La Ferme</strong>. Het stuk voor piano en cello klinkt als een instrumentaal requiem. Dat blijkt weerklinken tijdens de scènes met zuster Maria die naar de hoeve van de tante van zuster Zofia stapt om daar tot haar groot verdriet te ontdekken dat haar abdis de baby’s van de zusters heeft gedood. De rouwmuziek vertolkt het intense verdriet van de zusters en in het bijzonder dat van zuster Maria over hun overleden pasgeborenen. De muziek verbindt de scènes van de overleden zuster Zofia met die van het besef van de overleden baby’s, een besef dat zuster Zofia als eerste had gekregen. Behalve de Gregoriaanse gezangen, is er ook <strong>instrumentale scenische muziek in de abdij</strong>. Tijdens een ontspanningsmoment waarbij ook Mathilde aanwezig is, speelt zuster Irena piano. Ze vertolkt <strong>Suite No. 2 in F Major, HWV 427- I. Adagio</strong> van Georg Friedrich Händel. Dit blij moment van ontspanning vindt zijn tegenhanger in de medische post van het Franse Rode Kruis waar er dansmuziek wordt gespeeld. Aan dat muzikaal ontspanningsmoment in de abdij komt een abrupt einde door de onvoorziene geboorte van de baby bij zuster Ludwika. Naast de scenische muziek, is er <strong>de filmmuziek</strong> van Grégoire Hetzel. Zijn compositie <strong>Les tâches quotidiennes</strong> werd al genoemd. In het belangrijke deel naar het einde toe van de film, het deel dat begint met de verhuisscène van het medische kamp met het afscheid van dokter Mathilde en dokter Samuel en eindigt met de dageraad bij het ontwaken van de zusters Maria en Anna in het medische kamp, weerklinkt <strong>Petite messe solennelle- XI. Preludio religioso</strong> van Gioachino Rossini in een pianoversie en zonder gezang. Hiermee duidt de cineaste het deel waarin door het samenspel tussen dokter Mathilde en zuster Maria een definitieve oplossing komt voor de abdijzusters en hun baby’s, als een religieus gebeuren. Door de mis louter instrumentaal en solo voor piano te citeren, vermijdt Anne Fontaine iedere vorm van heroïsme wat dokter Mathilde betreft of religieus triomfalisme wat zuster Maria betreft. Tot slot, is er de compositie <strong>On The Nature Of Daylight</strong> van Max Richter. De Britse componist schreef de compositie in 2003 als zijn pacifistische antwoord op de invasie van Irak door de Amerikaanse troepen. Het stuk verwerkt de aanwezigheid van geweld en oorlog. In die geest past het muzikaal citaat zeker in <strong>Les Innocentes</strong>. Maar de film interpreteert de muziek beeldend en vult ze in die zin ook aan. De muziek begeleidt namelijk de slotbeelden. Die omvatten de komst van de lente en de feestdag waarop de novicen hun kloostergeloften afleggen. Hun familieleden zijn er bij. Tijdens het feest wordt er <strong>een groepsfoto</strong> gemaakt van de zusters met hun kinderen en weeskinderen. Zuster Maria heeft de foto verzonden met een brief aan dokter Mathilde om haar te bedanken in naam van iedereen. Ze noemt Mathilde voor de abdij een Godsgeschenk. Dokter Mathilde is aan het werk in een kliniek terwijl ze in voice-over de brief van zuster Maria hoort voorlezen en ze de groepsfoto bekijkt. De camera zoomt in op haar in haar witte schort tegen een witte achtergrond. Ze lijkt wel een engel. Dit close-up beeld van haar vloeit over naar het moment waarop de fotograaf in de abdij de groepsfoto neemt. Hij gebruikt daarvoor een primitieve vorm van flits. Een kleine explosie van vuur verlicht de groep en maakt de foto. Hiermee gaat het beeld over naar een zwarte achtergrond voor de eindgeneriek. De muziek van Richter die in de titel naar <strong>het wonder van het daglicht</strong> verwijst, begeleidt ook nog de eindgeneriek.</p>\n<p><a name=\"BET\"></a></p>\n<h2><font color=\"#808000\"><strong>Betekenisruimte</strong></font></h2>\n<p><span class=\"menstis\"><strong>TRAGIEK EN ZINGEVING ALS ZORG</strong>.</span> De film <strong>Les Innocentes</strong> brengt een vergeten drama terug aan de oppervlakte en brengt daarbij postuum hulde aan zeer moedige vrouwen. In de meest dramatische omstandigheden wisten ze hun menselijke waardigheid te bewaren in de zorg voor anderen. Die zorg krijgt in de film twee concrete vrouwengezichten: die van <strong>dokter Mathilde</strong> en die van <strong>zuster Maria</strong>. Op het eerste gezicht zijn die <strong>twee antipoden</strong>. Ze leven namelijk in een totaal andere wereld. Die van de moderne geneeskunde wat dokter Mathilde betreft en die van de eeuwenoude katholieke kloostertraditie van contemplatieve zusters, in casu de Benedictinessen, wat zuster Maria betreft. Bovendien werkt en denkt dokter Mathilde vanuit een communistische achtergrond die radicaal tegenover het katholieke credo van de zusters staat. Hun onderlinge tegenstelling is slechts het vertrekpunt van het filmverhaal met zijn historische verankering. In de ontwikkeling ervan blijkt hoe beide jonge vrouwen, ieder vanuit hun verschillende achtergrond, ontdekken dat ze eigenlijk <strong>zielsverwanten</strong> zijn. Ze staan, zo blijkt, allebei <strong>zorgend midden in de menselijke tragedie</strong> die zich voor hun ogen afspeelt. Geen van beiden weigeren ze de dramatische gebeurtenissen en de gevolgen ervan te verdringen. Ze vinden hun motivatie in <strong>hun sterke wil om de werkelijkheid onder ogen te zien</strong>. Vanaf de eerste medische tussenkomst van dokter Mathilde, de keizersnede bij zuster Zofia, assisteert zuster Maria dokter Mathilde. Verderop in de film treedt <strong>zuster Maria zelfs op als vroedvrouw</strong> bij de bevalling van zuster Anna. Aan de andere kant van het spectrum beweegt dokter Mathilde <strong>in de richting van de religieuze wereld van de kloosterzusters</strong> door toedoen van zuster Maria. In eerste instantie stelt dokter Mathilde zich zuiver medisch op. Geconfronteerd met een noodgeval, treedt ze zeer professioneel op. Ze voelt zich daarna ook medisch verantwoordelijk voor zuster Zofia en haar baby, haar patiënten die ze medisch wil opvolgen. Via de hulp van zuster Maria krijgt ze daartoe ook blijvende toegang tot de abdij. Zuster Maria weet van de abdis de toestemming te krijgen voor dokter Mathilde om de andere zwangere zussen medisch op te volgen. Maar in een eerste moment weigeren de zusters zelf. Zuster Maria en dokter Mathilde voelen zich allebei ‘als roependen in de woestijn’ (<em>Vox Clamantis in Deserto</em>). Een belangrijk keerpunt vormt het moment dat zuster Maria dokter Mathilde opvangt na haar aanranding door de Sovjetsoldaten. Hierdoor overnacht ze in de abdij en ontwaakt ze op de tonen van het <em>Rorate Caeli</em>. Door die ervaring ziet dokter Mathilde voor het eerst de zusters <strong>niet als patiënten, maar als religieuze vrouwen</strong>. Hun wijze van staan in het leven en hun vaste wil om, niettegenstaande het trauma dat ze in zich meedragen, trouw te blijven aan hun religieuze levenskeuze, imponeert dokter Mathilde. In feite herkent ze daarin <strong>haar eigen sterke wil om trouw haar medisch beroep uit te oefenen in de zorg voor wie in nood verkeert</strong>. Nadat dokter Mathilde de zusters redt van de invallende Sovjetroepen die de abdij ervan verdenken ‘vijanden van het volk’ te verbergen, nemen alle zusters dokter Mathilde op in hun gemeenschap. Ze beschouwen hen nu als <strong>één van hen</strong>. Hierna hebben zij en zuster Maria een intens gesprek. Dokter Mathilde luistert naar het verdriet van zuster Maria die terug overrompeld is door de komst van de Sovjetsoldaten. Als verantwoordelijke voor de jonge novicen, handelt ze vanuit <strong>een moederlijke zorg</strong> tegenover hen, terwijl ze zelf ook slachtoffer is. Ze deelt haar eigen verdriet met dokter Mathilde. De jonge dokter neemt met eerbied en grote aandacht het getuigenis van zuster Maria in zich op. De jonge zuster vertelt over haar groot verdriet en over hoe ze haar geloof beleeft in die bijzondere omstandigheden ('<em>Het geloof is vierentwintig uren twijfel en één minuut hoop.</em>’). Beiden groeien mentaal steeds meer naar elkaar toe. Op zeker ogenblik geeft zuster Maria <strong>het kleed</strong> waarmee ze als burgervrouw naar de abdij is gekomen, aan dokter Mathilde die het aantrekt. Het zijn <strong>echte zussen</strong> geworden. Wat hen echt verbindt, is <strong>hun zorgende wil om ‘het leven te dienen’</strong>. Dat zien ze in elkaar en daarin steunen ze ook elkaar. Dat culmineert bij zuster Maria in de weerstand tegen het moordend gedrag van haar abdis aan wie ze gehoorzaamheid is verschuldigd, en bij dokter Mathilde in haar engagement voor de abdijzusters waardoor ze ingaat tegen haar militaire overste die haar huisarrest oplegt. Beiden komen ze tot een echte oplossing voor de abdij die een deel van de taken van de medische missie van het Franse Rode Kruis overneemt, met name de zorg voor de weeskinderen. In <strong>de onderlinge feminiene solidariteit</strong> waarin <strong>zorg, humaniteit en zingeving</strong> elkaar versterken, verschijnt <strong>de relativiteit van de Ideologieën</strong>. Die zijn aanwezig in de verwijzing naar <strong>het communisme</strong> dat dokter Mathilde van huis uit meekreeg, maar ook via de aanwezigheid van de Sovjetsoldaten die zich na de bevrijding van Polen focussen op het opsporen van ‘vijanden van het volk’. <strong>De Ideologie</strong> verschijnt ook in het kleed van de religie, belichaamd door <strong>de abdis</strong>. Ze handelt vanuit de absolute trouw aan het monastieke systeem ten koste van alles, ook van het leven van de ongewenste kinderen. Zuster Maria ontmaskert de wreedheid van dergelijke <strong>verharding van een religieuze beleving tot een ideologisch systeem</strong> dat zich volledig afkeert van het leven in zichzelf, de anderen en de wereld rondom hen. Wat een middel is,wordt een doel op zich. In de lijn van het portret van zuster Maria introduceert de cineaste in een van de cinematografische hoogtepunten van de film <strong>het contrast tussen de historische abdis Hildegard von Bingen via haar <em>O Vis Aeternitatis</em> op de klankband en het personage van abdis Jadwiga Oledzka op de beeldband</strong>. Ook religieuze tradities bezitten geen immuniteit tegenover de ideologische verharding. Daarin wenden ze zich af van <strong>het wonder van het leven zelf, het wonder van de Schepping</strong>, en in het kader van de film kunnen we zeggen ‘<strong>het Licht van de Schepping</strong>’. Ze gebruiken het als een instrument voor eigen machtsuitoefening. Dergelijke verworden religies voeren <strong>rituelen zonder ziel</strong> op, rituelen zonder contact met de werkelijkheid. Dat blijkt zeer scherp uit <strong>de dialoog tussen moeder overste en zuster Anna</strong>. Het is zuster Anna die op het einde samen met zuster Maria beslist om de laatst geborenen, onder andere haar eigen kind, te redden uit de handen van de abdis, door ze naar de missie van het Rode Kruis te brengen. Zuster Anna beslist ook op het einde om uit de abdij te treden op zoek naar haar ‘verloofde’ die ze niet kent. Het is een Sovjetsoldaat zonder naam. Hij heeft zuster Anna beschermd tegenover zijn medesoldaten, die zelfs met hen daarover heeft gevochten en die er ook voor heeft gezorgd dat zijn medesoldaten de zusters niet hebben vermoord, wat ze vanuit ideologische overwegingen wel geneigd waren te doen. In haar gesprek met de abdis, zegt zuster Anna dat ze haar geloof niet meer kan verzoenen met wat er is gebeurd. Ze ziet zichzelf nog steeds als een bruid van God, maar begrijpt niet waarom Hij dan heeft gewild wat er is gebeurd.</p>\n<blockquote>\n<p>Zij: ‘<em>Het is gebeurd. Dus wilde Hij het</em>.’ <br>\nDe abdis: ‘<em>We kunnen niet weten wat Gods wil is</em>.’<br>\nZuster Anna: ‘<em>De enige waarheid is zijn Liefde en dit leven dat ongewild in mij groeit en zich weldra openbaart, wat wil Hij dat ik daarmee doe?</em>’ Haar existentiële en religieuze vragen blijven onbeantwoord.<br>\nHet enige wat de abdis doet, is zeggen: ‘<em>Laat ons bidden. We zullen bidden. Dat is onze enige troost</em>.’</p>\n</blockquote>\n<p>Deze ideologische respons maakt het gebed als bron van troost tot een leeg ritueel. Het kijkt weg van <strong>de opdracht om wat er in en met het leven gebeurt, onder ogen te zien en zin te geven</strong>. De abdis houdt zich krampachtig vast aan de opgelegde regels en haar eigen autocratische machtspositie (‘<em>Ik ben je overste. Gehoorzaam mij!</em>’). Zo veroordeelt ze zichzelf om <strong>ziende blind</strong> te zijn voor de dramatische gevolgen van haar gedrag tegenover de pasgeborenen en haar eigen medezusters, de onschuldigen. Aan de andere zijde van de Ideologie staat het partijcommunisme van het Sovjetleger. Dat ontleent aan zijn eigen gelijk een vrijgeleide om te verkrachten en te vermoorden. Dit heet nu de historische <strong>Sovjetschande</strong> waarnaar de film duidelijk verwijst. Dokter Mathilde vertelt aan haar collega en vriend Samuel dat ze geen partijlid is maar van huis uit communistisch is opgevoed. Haar ouders hebben hun leven geriskeerd in het verzet tegen de Duitse bezetter. In Polen ervaart ze dat een Ideologie, ook de communistische, <strong>ethisch blind</strong> wordt wanneer ze handelt vanuit <strong>een intellectuele, politieke en militaire machtsdrang</strong>. Zuster Maria en dokter Mathilde overstijgen samen die Ideologieën die het leven niet alleen in de weg staan, maar ook nog vernederen en vernietigen. Ze vinden elkaar in <strong>de humaniserende wil om de tragiek in zich op te nemen en zo het leven te dienen en verzorgen</strong>. Dokter Mathilde vindt haar motivatie in haar wil om ‘<em>levens te redden</em>’ en zuster Maria luistert naar de nood van de haar toevertrouwde jonge zusters en hun baby’s. Zo blijkt hoe <strong>de humaniserende wil tot zingeving</strong> in al zijn modaliteiten van zorg voor de menswording verankert zit in de zorg voor <strong>die ene werkelijkheid van het leven, zijn inherente tragiek inbegrepen</strong>. De film <strong>Les Innocentes</strong> is een belangrijke oefening in levensbeschouwing.</p>\n<p><span class=\"menstis\"><strong>MAGNIFICAT IN Em</strong></span>.  <a name=\"CON\"></a> De cineaste Anne Fontaine die zelf mee het scenario heeft geschreven, heeft ervoor gekozen om twee belangrijke zusterpersonages <strong>Maria</strong> en <strong>Anna</strong> te noemen. Dat is zeker geen toeval. Beide voornamen zijn in de christelijke traditie erg belangrijk: Maria is de naam van de moeder van Jezus en Anna is de naam van de moeder van Maria. Ook de cineaste draagt die naam als voornaam. In <strong>Les Innocentes</strong> weerklinkt zowel visueel als auditief een echo naar <strong>het Magnificat</strong>, de evangelische ode aan het moederschap van de anonieme vrouw. In <strong>het Magnificat</strong> krijgt dat moederschap een hoogst religieuze betekenis. Het evangelische Magnificat is in die zin in de eerste plaats <strong>een uiting van zingeving aan het moederschap en via het prisma van de eenvoudige, Palestijnse Maria aan alle moeders</strong>. Concreet steekt die verwijzing naar dat evangelische Magnificat in de Gregoriaanse gezangen die door de zusters worden gezongen of door de cineast worden geciteerd. De meeste ervan komen ze uit de jaarkrans van <strong>de Advent</strong>, de vier wekentijd waarin de gelovigen <strong>het feest van Kerstmis</strong> voorbereiden in bezinning en gebed. In <strong>Les Innocentes</strong> wordt er niet direct verwezen naar Kerstmis ofschoon het verhaal begint in de decembermaand. De nadruk ligt duidelijk op <strong>de Adventstijd</strong>, wat zich weerspiegelt in de zwangerschappen van de verkrachte zusters. Het hele gebeuren staat in het teken van de te verwachte geboorten. Dat sluit ook aan bij de aandacht in <strong>de evangelische kindheidsverhalen over de zwangerschap van Maria</strong>. Bovendien blijkt uit de verhalen en het exegetische onderzoek ernaar dat de zwangerschap van Maria in de ogen van de mensen ongewenst was. Eén van de historische mogelijkheden is zelfs dat de jonge, Palestijnse Maria wellicht werd verkracht door Romeinse soldaten. De link met de film <strong>Les Innocentes</strong> wordt dan wel erg groot. Hoe dan ook, de Gregoriaanse gezangen herinneren zeer expliciet aan <strong>het christelijke credo van de Incarnatie</strong> en dus van <strong>het religieuze mysterie van de Menswording</strong>. De cineaste beklemtoont dit nog eens zeer uitdrukkelijk via de klankverwijzing naar het mystieke lied van Hildegard von Bingen. De hele film is <strong>een Magnificat, maar cinematografisch geschreven in Em</strong>, de toonaard van het verdriet. In het interview met Christie Huysmans, getuigt Anne Fontaine dat <strong>de christelijke iconen van de Madonna met Kind</strong> voor haar een belangrijke inspiratiebron zijn geweest. Ook de iconen van de Madonna met King kunnen gezien worden als <strong>een visueel Magnificat in Em</strong>. Voorts slaagt de cineaste er esthetisch in om de oude Gregoriaanse gezangen zo in het filmverhaal te integreren dat de toeschouwer voor het eerst <strong>het Gregoriaans als de blues van de christelijke middeleeuwen</strong> kan ervaren. De film opent hiermee via de beslissing van de novice Teresa bij het zingend bidden van <em>Conditor Alme Siderum</em> waarvan het gezang de schreeuw van de hoogzwangere Zofia in zich opneemt. De cineaste laat de Gregoriaanse gezangen ook overgaan in de eigen en ontleende filmmuziek. Het sterkst gebeurt dat in de wake bij het opgebaarde lichaam van zuster Zofia. Het <em>Veni Creator Spiritus</em> vloeit over in de filmmuziek <em>La Ferme</em> dat als een hedendaags muzikaal requiem klinkt. Het vertolkt het grote verdriet dat zuster Maria na de wake bij de overleden Zofia en na haar ontdekking van de moord op de pasgeborenen. Dat laatste gegeven herinnert aan <strong>de kindermoord door koning Herodos de Grote</strong> in <em>Mattheus 2, 16-18</em> over de kindertijd van Jesus. Aan die bron is het kerkelijk feest ontstaan dat bekend staat als <strong>het feest van de Onnozele of Onschuldige Kinderen</strong>. Bij uitbreiding verwijst het naar alle kleine kinderen die ooit zijn vermoord door allerlei machthebbers, een praktijk die nog niet uit de mensenwereld is gebannen. De titel van de film, <strong>Les Innocentes</strong>, zinspeelt ook op die traditie waarin de figuur van Maria en haar pasgeboren kind een hoofdrol spelen. <strong>Het Magnificat in Em</strong> spreekt niet alleen uit de klankwereld van de film. Het ‘weerklinkt’ nog meer door de eigen, unieke cinematografie van Caroline Champetier. <strong>Het ingetogen winterlicht</strong> bedekt niet alleen het landschap rondom de abdij en het omliggende bos met een kleed van zuiverheid. Het beeld ontstaat niet alleen van een zuiverheid op zich, maar van <strong>een verwerkt hemels verdriet</strong>. De sneeuw is wit bevroren regen die uit de hemel komt. In een religieuze beschouwing staat regen voor de hemel die weent. De sneeuw werkt in die zin als een hemelse troost op de aarde met haar wreedheid door de mens aangericht. <strong>Het sneeuwtapijt dat het hemelse licht absorbeert op aarde</strong>, herinnert de mens aan de onschuld. Het bekleedt de met bloed doordrenkte aarde zorgend met een kleed van onschuld. In dat landschap weerklinken de voetstappen van zuster Teresa en zuster Zofia als noten op de notenbalk van de menselijke geschiedenis. <strong>Dat hemels, troostende licht</strong> woont in de abdij en begeleidt ook dokter Mathilde. De zorg van haar en die van zuster Maria vormen <strong>het sneeuwlicht dat verlossing en troost</strong> brengt in een oord dat geroepen is om een teken van onschuld te zijn in de mensenwereld. Het filmcitaat van <strong>On the Nature of the Daylight</strong> bewaart muzikaal het ingetogen verdriet én troost van het sneeuwlicht en begeleidt de eindsequenties van de lente die een nieuwe toekomst aankondigt voor de abdij, de zusters en hun weeskinderen. Het teken van onschuld dat de abdij nastreeft te zijn, was geschonden en is hersteld. De komst van dokter Mathilde maakt daar deel van uit. Uit haar engelachtige, witte verschijning op het einde vloeit de groepsfoto van de zusters met ‘hun’ kinderen voort. Dat einde van de film is niet louter fictief. De overgeleverde nota’s van Madeleine Pauliac zijn strik medisch en zakelijk, aldus Anne Fontaine in het interview met Christie Huysmans. Ze stipt daarin aan dat uit die nota’s niets kan worden afgeleid over de relatie tussen de historische dokter Madeleine en de zusters die ze heeft behandeld. Wel, zo verklaart de cineaste verder, zijn er in Polen nog gelijkaardige gevallen aan het licht gekomen. Het positieve einde van de film is geïnspireerd door wat er in een ander klooster is gebeurd.</p>\n<h2><font color=\"#808000\"><strong>Context</strong></font></h2>\n<p>De film <strong>Les Innocentes</strong> kende zijn release in bewogen jaar <strong>2016</strong>, het jaar van de onverwachte <em>Brexit</em> en de nog meer onverwachte verkiezing van de Amerikaanse <em>president Donald Trump</em>. Deze laatste won het presidentschap van Hilary Clinton. Ze zou de eerste vrouwelijke president zijn geworden. Wat haar van de democratische overwinning heeft gehaald is <strong>de algemene opkomst van nationalistische reflexen</strong>. Zo in Engeland, zo ook in <em>het America First</em> van president Trump. De film van Anne Fontaine biedt een ingetogen maar betekenisvol antwoord op deze nationalistische opwelling in de democratische wereld, ook in Europa. Met haar film brengt Anne Fontaine <strong>de noodzakelijke herinnering aan de Tweede Wereldoorlog</strong> in beeld. Die oorlog vormde het failliet van <strong>de Europese nationalismen</strong> en het begin van de ideologische Koude Oorlog die vandaag opnieuw onder het Rusland van Poetin de kop opsteek. De film is <strong>een Europese film</strong>, het resultaat van zowel de financiële als artistieke samenwerking tussen Frankrijk en Polen, twee landen met een katholieke achtergrond en elk uit een deel van het tot voor kort ideologisch verdeelde Europa. Dergelijke culturele producties die nationalistische en ideologische grenzen overstijgen, tonen de weg naar <strong>een echte toekomst van het verenigde Europa</strong>. Ongewild verscheen deze Frans-Poolse film in de periode dat de Eureopese Unie <strong>de Pool Donald Tusk als president</strong> heeft. Naast de Europese context, heeft de film ook <strong>een kerk-katholieke context</strong>. Het brengt de vergeten groep van kloosterzusters en hun stille, zorgende bijdrage tot de christelijke, Europese cultuur naar de oppervlakte en uit de zone van de vergetelheid. Uit het eerder genoemde interview van Christie Huysmans met de cineaste weten we dat de Franciscaanse aartsbisschop José Rodriguez Carballo, werkzaam in de Romeinse Curie, <strong>Les Innocentes</strong> na de visie van de film in het Vaticaan <strong>‘un film thérapeutique pour l’Eglise’</strong> heeft genoemd. Waarin die therapie dan bestaat, blijft een open vraag. In het licht van de film zelf, blijkt de inspirerende draagwijdte van <strong>een feminiene benadering van de eeuwenoude katholieke en bij uitbreiding christelijke tradities</strong>. In het oude Europa van de naties zijn die tradities dominant mannelijk en nationaal geweest. <strong>Het klerikalisme</strong> dat de man religieus boven de vrouw stelt, geldt nog steeds. <strong>Les Innocentes</strong> laat vanuit een feminiene herinterpretatie van de die eeuwenoude tradities zien <strong>welke waardevolle betekenis het religieuze en in het bijzonder het christelijke credo</strong> heeft in <strong>het licht van de tragiek in de menselijke geschiedenis die blijkt duren</strong>.</p>\n<p><a name=\"LIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Links</strong></font></h2>\n<p>Voor de achtergrond over de draagwijdte van de Ideologie en het fenomeen van de Lichtaard (het Licht van de Schepping), zie delen 2 en 3 van <strong>Levensbeschouwing democratisch belicht</strong>. <br>\nKlik hier voor het vermelde interview van Christie Huysmans met de cineaste Anne Fontaine. <a href=\"http://www.cinefemme.be/spip.php?article64\">Klik hier voor het vermelde interview van Christie Huysmans met de cineaste Anne Fontaine.</a>.</p>\n<p><font size=\"-2\">© Sylvain De Bleeckere, Men(S)tis, 2017</font></p>\n"}

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

	module.exports = {"title":"Into the Wild","body":"<center>\n<img src=\"intothewild.jpg\" >\n</center>\n<p><a name=\"KLA\"></a></p>\n<h2><font color=\"#808000\"><strong>Klapbord</strong></font></h2>\n<p><strong>Into the Wils</strong> is <em>een onafhankelijke Amerikaanse</em> River Road productie. De regie is van de acteur en regisseur <em>Sean Penn</em>. Het is de vierde speelfilm van de eigenzinnige Sean Penn waarin hij telkens reflecteert over vervreemding en verlies: <em>The Indian Runner, The Crossing Guard, The Pledge</em>.  Met <strong>Into the Wild</strong> verdiept hij zich in het ware verhaal van de 22-jarige drop-out Chris McCandless. De film is gebaseerd op het gelijknamige non-fictie boek (1996) van Jon Krakauer over de lotgevallen van Chris McCandless (1968-1992).</p>\n<p><a name=\"SYN\"></a></p>\n<h2><font color=\"#808000\"><strong>Synopsis</strong></font></h2>\n<p>Chris McCandless wordt in 1968 geboren bij zijn ouders Walt McCandless en Wilhelmina ‘Billie” Johnson. Het gezin zit er warmpjes in. De ouders leiden in Annandale, Virginia een bloeiend consulting bedrijf. Tussen beide partners heersen er echter voortdurende emotionele spanningen die leiden tot openlijke conflicten. Het huwelijk balanceert voortdurend op de slappe koord van de echtscheiding. Chris is een idealist die ook intens fysiek traint. Hij beleeft bijvoorbeeld lopen als een spirituele oefening en zoekt leden voor een cross-country team. Lopen op uithouding is voor hem '<em>running against the forces of darkness … all the evil in the world, all the hatred</em>.'Hij studeert succesvol af aan de W.T.Woodson High School in 1986 en aan de Emory University van Atlanta, Georgia in 1990 met als majors geschiedenis en antropologie. Na die alweer succesrijke studieperiode beslist hij als 20-er zijn gegoede familie, zijn diploma en toekomstige carrière in Virginia achter te laten en westwaarts te trekken. Chris verbrandt zijn spaarcenten, rijdt zijn wagen vast en trekt liftend door het land. Hij ontmoet een hippiepaar, een boer, toeristen, een jong meisje en een weduwnaar maar bewaart afstand. Hij verandert zijn naam in ‘Alexander Supertramp’ en is cultureel en spiritueel goed voorbereid, maar tegenover bepaalde uitdagingen van de natuur blijkt dat hij toch niet goed te zijn uitgerust, wat hij ervaart tijdens een kanotocht of een verblijf tussen daklozen in LA. Zijn ervaringen onderweg sturen hem richting Alaska. Ongerepte natuur en zowat het laatste nog resterende gebied voor wie ‘weg’ wil uit de beschaving. Maar Chris is opnieuw onvoorbereid. Slechts giften (laarzen, warme kleren, mes) en een beschavingsrestant (een verlaten ‘magische bus’) leveren bescherming in wat snel een ongelijke overlevingsstrijd wordt. In 1992 sterft Chris door totale verzwakking en voedselvergiftiging.</p>\n<p><a name=\"CIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Cinematografie</strong></font></h2>\n<p>AUTOBIOGRAFISCHE WOORDEN. Bij het openingsbeeld van <strong>Into the Wild</strong> geeft Penn aan dat woorden tellen. Ze zijn van belang. Hij opent met een zwart beeld met daarop de verzen van Lord Byron, die ook voor Chris een inspiratiebron waren:</p>\n<blockquote>\n<p>There is a pleasure in the pathless woods;<br>\nThere is a rapture on the lonely shore;<br>\nThere is society, where none intrudes,<br>\nBy the deep sea, and music in its roar:<br>\nI love not man the less, but Nature more.<br></p>\n</blockquote>\n<p>De woorden zijn belangrijk in de film, maar niet zoals bij een documentaire waar in voice-over wordt verteld wat er te zien is. Sean Penn maakt van de biografie over Chris ook gedeeltelijk een <em>autobiografie</em>. Hij laat Chris zelf aan het woord. Dat gebeurt concreet door woorden die al schrijvend in gele letters verschijnen op het beeld. Dat is bijvoorbeeld het geval met de titel <strong>Into the Wild</strong> Het is het tweede deel van de zin die Chris zelf op het scherm schrijft: ‘<em>I now walk into the wild</em>.’ Zijn woorden zijn gebaseerd op het schrift dat bij zijn dode lichaam is gevonden. De jonge man noteerde zijn gedachten. Sean Penn introduceert de toeschouwer met de woorden van Chris op het ogenblik dat hij in 1992 aankomt aan het eindpunt van zijn tocht: de Stampede Road, ergens in Alaska waar geen mens met een auto of ander vervoermiddel nog voorbij kan. De woorden in de vorm van <em>schriftbeelden</em> geven aan de film zijn <em>meditatieve</em> dimensie en doen recht aan de <em>beschouwelijke</em> geest de Chris zelf is geweest. In een houten plank kerft hij zijn ‘onafhankelijkheidsverklaring’.</p>\n<p>ROAD MOVIE. De film is een road movie genoemd. Dat is slechts gedeeltelijk waar. De film heeft namelijk geen lineaire structuur in de zin dat het personage van een punt vertrekt en op een bepaald punt aankomt. Zo eenvoudig liggen de zaken niet bij <strong>Into the Wild</strong>. Na de openingstekst van de dichter Lord Byron, volgt er eerst een korte sequentie met de ouders. De moeder schrikt wakker. Ze heeft een vreemde droom gehad en zegt tegen haar man: ‘<em>Ik hoorde hem.</em>’ De stem van de ongeruste ouders is eerst hoorbaar. De toeschouwer ontdekt pas op het einde van de film dat dit het ogenblik was waarop Chris is gestorven. Na die korte openingsequentie met de ouders, volgen de sequenties van de aankomst van Chris op het eindpunt van zijn tocht nabij de berg McKinley in Alaska op 27 april 1992. Met andere woorden, niet eerst de reis, maar de aankomst.</p>\n<p>FLASHBACK. De film is gestructureerd als een veelzijdige flashback. Die komt voort uit de beschouwende geest van het hoofdpersonage Chris. <em>De eerste tijdslaag</em> van de flashbacks is die van de voorbije reis die Chris heeft afgelegd. En dan reist hij verder in de tijd: zijn leven thuis bij zijn welstellende, maar ruziënde ouders. Binnen <em>die tweede tijdslaag</em> treedt er nog een flashback op, die van zijn zus Carine. Zij reflecteert ook over Chris, hoe hij vroeger was. Zij zoekt erin de reden van zijn vrijwillige verdwijning.</p>\n<p><a name=\"BET\"></a></p>\n<h2><font color=\"#808000\"><strong>Betekenisruimte</strong></font></h2>\n<p>EEN JEZUSFIGUUR. <strong>Into the Wild</strong> handelt over <em>een reis naar spirituele volwassenheid</em>. Dat blijk uit de titels van de hoofdstukken die Penn aanbrengt in de film: ze heten ‘geboorte, ‘adolescentie’ en ‘het bereiken van wijsheid’. Vanuit die spirituele basis van het portret tekent Penn de jonge volwassen Chris als iemand die zich tijdens zijn tocht tussen de mensen beweegt als een Jezusfiguur. Dat gebeurt subtiel maar daarom niet minder diepgaand. Helemaal in de biografische lijn van de echte Chris — toevallig verwijst zijn voornaam naar Christus — laat Penn, in de flashbacks van de tocht, zien hoe Chris bij de mensen die hij ontmoet goedheid en menslievendheid oproept. Hij heeft in zich een bewuste ethische zuiverheid ontwikkeld, mede geïnspireerd door een christelijke auteur als <em>Leon Tolstoi</em>.</p>\n<p>IN DE GEEST VAN DE BERGREDE.<strong>Into the Wild</strong> brengt met sympathie en maar ook met een groot mededogen een hedendaagse mens in beeld die in de geest van de evangelische Bergrede een bron van goedheid en liefde voor de mens wil zijn. Die wil komt niet uit de opvoeding die hij thuis heeft gekregen. Hij keert zich af van het gezinsleven dat kent en gebouwd is op leugen, geruzie en rijkdom. Hij gaat zelf op zoek naar meesters in de spiritualiteit en vindt die in christelijk geïnspireerde auteurs als Tolstoi. Interessant is te zien hoe een jonge en talentrijke jonge man, een zoon van het in welvaart badende Amerika, zich een eigen weg baant naar zijn diepste wezen als mens. Hij vindt <em>die religieuze kern</em> niet in een of andere gevestigde religie, maar in de dagelijkse omgang met concrete mensen die zijn pad kruisen en uiteindelijk in de ongerepte natuur. Eerst is die natuur een bron van religieuze ervaring. Geleidelijk ontdekt hij echter de vijandige zijde van die natuur. Die houdt hem een spiegel voor waarin hij beseft dat hij het contact met andere mensen nodig heeft om <em>de religieuze ervaring van innerlijke zuiverheid</em> te kunnen delen en beleven. Op het ogenblik dat hij naar de mensenwereld wil terugkeren, ontdekt hij echter dat hij zonder enig voedsel gevangen zit op een tijdelijk eiland vanwaar hij niemand kan bereiken. In dat inzicht aanvaardt hij zijn onvermijdelijke dood.</p>\n<p><a name=\"CON\"></a></p>\n<h2><font color=\"#808000\"><strong>Context</strong></font></h2>\n<p>Sean Penn wil meer dan enkel de biografie van een zonderling geval, Chris McCandless, in beeld brengen. In zijn optiek is dit ook de biografie van een jonge generatie. Penn wil het portret filmen van een opgroeiende generatie in de jaren negentig van vorige eeuw en van het eerste decennium van de twintigste eeuw. Een generatie die ontevreden is met de vooral morele gang van zaken in de westerse wereld in het algemeen en de Verenigde Staten in het bijzonder. In zijn ‘onafhankelijkheidsverklaring’ spreekt Chris over ‘<em>een spirituele revolutie</em>’. Sean Penn idealiseert het hoofdpersonage niet; hij oordeelt of veroordeelt niet. Hij laat de jonge man zoveel mogelijk zelf aan het woord, maar laat ook zijn ouders en zijn zus zien die hem missen. Penn laat ook zien dat Chris de natuur zelf overschat. Hij kent er te weinig van en dat gebrek aan kennis wordt zijn dood. Penn toont vooral respect voor het avontuur van Chris en het meest van al voor zijn spirituele motieven. Hiermee wil hij aantonen dat niet alle westerse jongeren zich laten meesleuren door de materiële golfstroom van rijkdom en consumptie. Die golfstroom is verbonden met de politiek van het neoliberalisme, vooral het waarmerk van de drie presidentschappen van de Bush-familie. Via een foto van het eerste presidentschap, dat van George H.W. Bush (1989-1993), verwijst Penn daar expliciet naar zonder ook maar op één moment een politiek statement te willen maken.</p>\n<p><a name=\"LIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Links</strong></font></h2>\n<p>In <em>Leren Leven Met Beelden</em> nr. 15 (2009) verscheen er een voorstelling van de film. Er is een website gewijd aan <a href=\"http://www.christophermccandless.info/\">Chris McCandless</a>.</p>\n<p><font size=\"-2\">© Sylvain De Bleeckere, Men(S)tis, 2011/2017</font></p>\n"}

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

	module.exports = {"title":"Iris","body":"<center>\n<img src=\"iris.jpg\" >\n</center>\n<p><a name=\"KLA\"></a></p>\n<h2><font color=\"#808000\"><strong>Klapbord</strong></font></h2>\n<p>John Bailey schreef twee autobiografische boeken over zijn leven met Iris Murdoch: <em>Iris. A Memoir</em> en <em>Elegy for Iris</em>. In het eerste boek getuigt Bailey over zijn 42 huwelijksjaren met Iris en de eerste jaren van haar ziekte. In het tweede boek beschrijft hij Iris’ laatste levensjaar en haar overlijden in 1999. Richard Eyre en Charles Wood schreven het scenario van de film <strong>Iris</strong> naar de twee boeken van Bailey. Tijdens de opnames was Bailey een onmisbare raadsman. De Britse acteur Jim Broadbent kroop in de huid van het personage van de oudere Bailey. Zijn uitzonderlijke vertolking leverde hem de Oscar op voor de beste, mannelijke bijrol. De jonge Iris kreeg het gezicht van Kate Winslet, terwijl de vooraanstaande Judi Dench de oudere Iris op het witte doek terug tot leven bracht.</p>\n<p><a name=\"SYN\"></a></p>\n<h2><font color=\"#808000\"><strong>Synopsis</strong></font></h2>\n<p>Oxford, de Britse universiteitsstad. Engeland geneest van zijn open oorlogswonde. Het is immers al 1952. Een nieuwe generatie intellectuelen meldt zich. Onder hen bevinden zich twee bijzondere jongvolwassenen. John Bayley is een verlegen, maar bekwame literatuurprofessor; zij heet Iris Murdoch, een intelligente, dynamische studente die vanuit een eigen verworven vrijheid twee passies koestert: die van de liefde en die van de taal. Wanneer ze haar eerste teksten toespeelt aan John, ontstaat er een levenslange relatie, ze huwen, vormen een hecht team tot de ziekte van Alzheimer Iris’ geest aantast. Dame Iris Murdoch is dan al uitgegroeid tot een gewaardeerde Britse filosofe en tot de grootste Engelse schrijfster van de tweede helft van de 20ste eeuw. Ze leefde van 1919 tot 1999.</p>\n<p><a name=\"CIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Cinematografie</strong></font></h2>\n<p><span class=\"menstis\">BIOPIC</span>.De waarde van <strong>Iris</strong> steekt niet in het genre van de biopic. De film schrijft geen biografie. Alleen de tijd waarin Iris en John elkaar leren kennen én de jaren van de fatale doorbraak van Iris’ ziekte, komen in beeld. Maar ook in die twee belangrijke segmenten van de gemeenschappelijke biografie van Iris en John, primeert geenszins de wil om te documenteren. Niettegenstaande de grote zorg voor de authenticiteit van de in scène gezette taferelen, transcendeert de film de registratie van feiten. Terecht, want Dame Iris Murdoch vertolkte in haar leven, haar visie en romans <em>de wondere wereld van de menselijke geest</em>. In de eerste grote scène met de oudere Iris - ze geeft een lezing in het Sommerville College te Oxford - spreekt ze over de waarde van de opvoeding (‘<em>education</em>’). Letterlijk zegt ze:</p>\n<blockquote>\n<p><em>Education doensn’t make you happy. Nor does freedom. We don’t become happy just because we’re free - if we are - or because we’ve been educated - if we have - or but because education may be the means by which we realise we are happy; it opens our eyes, our ears, tells us where delights are lurking, convinces us that there is only one freedom of any importance whatsoever, that of the mind, and give us the assurance…the confidence to walk the path our mind, our educated mind offers.</em></p>\n</blockquote>\n<p>De cinematografische verdienste van de film bestaat erin de biopic terug te voeren naar de bron zelf van de biografie: het spirituele of ‘mentale leven’ van, in dit geval, Dame Iris Murdoch. Op deze wijze schildert <strong>Iris</strong> geen kroniek van Iris’ verschillende werken, maar zoomt hij in op haar eigen, grote geest, die ze zelf beschouwde als de bron van al haar werken, die bron die door de ziekte van Alzheimer in het duister werd gehuld.</p>\n<p><span class=\"menstis\">SPIEGELMONTAGE</span>. De structurele kracht van <strong>Iris</strong> ligt in de voortdurende spiegeling van de jeugd en de ouderdom van de huwelijksliefde van Iris en John. De geboorte van hun hechte liefde en de destructie ervan door ziekte en dood spiegelen zich in elkaar als alfa en omega. Reeds in de eerste minuten van de schildering van de ontluikende levenslust bij het verliefde koppel, is via de spiegelmontage de schaduw van het verlies al aanwezig. Dat gebeurt niet in een levenspessimistisch gebaar. Door spiegeling van ‘<em>leven en dood in liefde</em>’ licht er op het filmdoek een portret op dat een eerbetoon is aan <em>het wonder van de huwelijksliefde</em>. Het huwelijk van Iris en John was kinderloos, maar juist daardoor evoceert <strong>Iris</strong> hoe de vruchtbaarheid van zo’n liefde niet zozeer ligt in de biologische productiviteit, maar allereerst in <em>de spirituele rijkdom</em> van het innig en intens samenleven, ook dan wanneer de dood in de ogen verschijnt.</p>\n<p><span class=\"menstis\">HUISMETAFOOR</span>. Een dramatisch aspect van de cinematografie verschijnt in het beeld van <em>het huis</em>. De ingrijpende dramatiek van de ziekte van Alzheimer komt niet zozeer in woorden aan het licht; dat gebeurt veeleer in de sprakeloze neergang van de huiselijkheid in de woning van Iris en John. Iris bestuurde het huis, zij leidde John en hij volgde haar. Hij wist zich van het begin af geborgen in de wijze waarop zij orde schiep in hun leven, in hun huis. Wanneer de ziekte van Alzheimer het licht van haar geest doofde, trad geruisloos de chaos het huis binnen. De tragiek, hier zuiver beeldend van aard, is schrijnend en laat de toeschouwer aanvoelen voor welke wanhoop en onmacht John komt te staan wanneer hij ervaart hoe de ziekte Iris zich ongewild en onhoudbaar van hem verwijdert.</p>\n<p><a name=\"BET\"></a></p>\n<h2><font color=\"#808000\"><strong>Betekenisruimte</strong></font></h2>\n<p><span class=\"menstis\">MIND</span>. Na de diagnosesequenties, zegt Iris: ‘<em>I feel as if I’m sailing into darkness</em>.’ De film evoceert het sterven van Iris niet in een scéne met een ziekenhuisbed en een medisch apparaat dat de intrede van de dood signaleert. In plaats daarvan staat een sequentie met de demente Iris die in een gang op haar eigen manier naar het steeds helder wordende licht toe danst. De film evoceert de eigen aardse ruimte van het menselijke bestaan, waarvan de muren gebouwd zijn met zowel duisternis als licht; die muren bevinden zich in <em>de geest van ieder mens</em>. In het begin van de film komt er een sequentie voor waarin Iris als filosofieprofessor een lezing geeft. Die scène bevat in een notedop het filosofische credo van de denker Iris Murdoch. Ze zegt letterlijk:</p>\n<blockquote>\n<p><em>Education doensn’t make you happy. Nor does freedom. We don’t become happy just because we’re free - if we are - or because we’ve been educated - if we have - or but because education may be the means by which we realise we are happy; it opens our eyes, our ears, tells us where delights are lurking, convinces us that there is only one freedom of any importance whatsoever, that of the mind, and give us the assurance…the confidence to walk the path our mind, our educated mind offers.</em></p>\n</blockquote>\n<p>De film schildert Iris Murdoch als een grote dame die zich ophoudt in de kamer van de menselijke geest, die zich daar installeert in het licht van de liefde en de taal; daardoor verandert het menszijn in <em>een bijzonder en uniek zinnebeeld</em>. De film volgt in het biografische spoor van Iris <em>de aardse ruimte van een intense zinbeleving</em>. Het personage van Iris verschijnt daarbij eerder als de betrouwbare gids dan als een object om te beschouwen. De geestelijke ruimte waarin de film zijn eigen waarheid vindt, krijgt zijn juiste benaming in de woorden die Iris spreekt tijdens een lezing, kort voor de intrede van de ziekte: ‘<em>We need to believe in something divine without the need for God, something we might call Love or Goodness.</em>’ Daarna citeert vers 8 van Psalm 139:</p>\n<blockquote>\n<p><em>Al verhief ik mij op de vleugels van de dageraad, al ging ik wonen voorbij de verste zee, ook daar zou Uw hand mij leiden, zou Uw rechterhand mij vasthouden.</em></p>\n</blockquote>\n<p>Voor Iris Murdoch zelf en de film <strong>Iris</strong> onthult het goddelijke zich tastbaar in de <em>zorg voor het leven</em>. In die optiek mag <em>zorg</em> wel met een hoofdletter worden geschreven. Die <em>Zorg</em> komt in beeld in <strong>Iris</strong>. Voortgestuwd door het getuigenis van de echte John Bailey, worden de filmbeelden een plaats waar twee concrete, sterfelijke mensen elkaar omarmen in <em>de goddelijke ruimte van hun bestaan</em>, tragisch begrensd door de ziekte die uitgerekend de geest (‘<em>mind</em>’) aantast.</p>\n<p><span class=\"menstis\">WATER</span>. Een krachtig, poëtisch element van de eigen cinematografie is dat van het water. In dat element verdichten zich de twee zinscheppende krachten van de liefde en de taal. Het levensbeeld ervan bestrijkt zowel de rivier waarin beide geliefden zwemmen, als de grote zee die hun thuisland als een eiland definiëert. Het element van de zee vormt in het oeuvre van Dame Iris Murdoch een voorname, zinbeeldige wereld. Een van haar romans heet trouwens: <em>The Sea, The Sea</em>. In Eyre’s <strong>Iris</strong>, in zekere zin ook de film van Dame Iris Murdoch zelf, vindt dit literair gegeven zijn eigen cinmatografische waarheid. De zee, het stromend water, was voor de auteur Iris Murdoch immers een concrete metafoor van het goddelijke wonder van het leven zelf. De film opent én eindigt met beelden onder water.</p>\n<p><a name=\"CON\"></a></p>\n<h2><font color=\"#808000\"><strong>Context</strong></font></h2>\n<p>Zowel in zijn oorsprong als in zijn uitwerking documenteert <strong>Iris</strong> een belangrijk moment uit het intellectuele milieu van het naoorlogse Engeland. De film sluit aan bij een specifieke traditie van de naoorlogse Britse cinema die teruggaat op Sir Richard Attenboroughs. In diens film <strong>Shadowlands</strong> brengt hij een belangrijk hoofdstuk uit het leven van <em>C.S.Lewis</em> (1898-1963) op het scherm. Deze film vormt een referentiepunt voor de film <strong>Iris</strong>. Beide werken huldigen twee grote persoonlijkheden van de Engelse, naoorlogse intellectuele traditie met aandacht voor literatuur en filosofisch onderbouwde spiritualiteit. Beide films herinneren beide invloedrijke figuren als concrete mensen. De grote humaniteit waarvan hun werken getuigen, staat niet los van hun biografie. Beide films leggen dan ook op die nauwe relatie tussen leven en werk de volle nadruk. Beschouwd vanuit de historische situatie zelf, evoceert <strong>Shadowlands</strong> het perspectief van de man en van de generatie die in haar jeugd de Eerste Wereldoorlog en in haar volwassenheid de Tweede Wereldoorlog heeft meegemaakt. De periode die <strong>Shadowlands</strong> behandelt, situeert zich in de jaren vijftig. In dat decennium brak de emancipatie van de vrouw door in de gesloten mannelijke, academische wereld in Engeland. <strong>Iris</strong> schetst via het portret van de jonge Iris Murdoch hoe zich in de jaren vijftig de jonge generatie van vrouwelijke studenten manifesteert. De persoonlijkheid van Iris Murdoch kleurt het beeld van die ontwikkeling op een zeer levendige en waardevolle wijze in. Evenals <strong>Shadowlands</strong> ent <strong>Iris</strong> het gegeven van de existentiële zingeving op het genre van de biografie. Beide films vermijden een louter narratieve en chronologische vertelling. Ze laten zien wat het betekent voor de denkende mens - de intellectueel - vanaf de tweede helft van de twintigste eeuw zonder dogma’s en illusies de waarde van het bestaan te ervaren en te doorleven, ook dan wanneer zich in dat bestaan tekorkomingen en fatale sterfelijkheid melden. In beide films vormen de biografie, het bewustzijn van de tragiek en de zingeving een hecht en intens samenspelend trio.</p>\n<p><a name=\"LIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Links</strong></font></h2>\n<p>Voor de betekenis van het fenomeen ‘mind’ (geest) en het menszijn, zie <a href=\"http://www.menstis.be/uitgeverij/Levensbeschouwing/\">Levensbeschouwing democratisch belicht, deel 1</a>.      Dat deel zoomt in op wat Iris Murdoch in haar werk en in de film ‘<em>the power of our imagination</em>’ noemt.</p>\n<p>Voor meer over <a href=\"http://fass.kingston.ac.uk/research/iris-murdoch/\">Iris Murdoch zelf</a>.</p>\n<p>De film brengt de worsteling in beeld met de impact van de ziekte van Alzheimer. Dit sluit erg goed aan bij de Oscarfilm <strong>Still Alice</strong>. Zie <a href=\"http://sonyclassics.com/stillalice\">hier</a> de officiële website van de film. Ook <strong>Still Alice</strong> brengt een vrouwelijke professor in beeld en ook hier is zij, als linguïste,  werkzaam in het domein van de taal. In de spiegel van beide films dringt de toeschouwer door tot <em>het menselijke wonder en het goddelijke mysterie van de geest (‘mind’)</em>.</p>\n<p><font size=\"-2\">© Sylvain De Bleeckere, Men(S)tis, 2011/2017</font></p>\n"}

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

	module.exports = {"title":"Italiensk for Begyndere","body":"<center>\n<img src=\"italianforbeginners.jpg\" >\n</center>\n<p><a name=\"KLA\"></a></p>\n<h2><font color=\"#808000\"><strong>Klapbord</strong></font></h2>\n<p>Op 8 december 2000 kende de film <strong>Italiensk for Begyndere - Italiaans voor beginners</strong> zijn wereldpremière in Denemarken, het land waar hij werd geproduceerd en gedraaid. Oorspronkelijk alleen maar bedoeld voor de Deense markt, vond de film echter internationale weerklank en waardering toen hij tijdens het Festival van Berlijn, begin 2001, met de Zilveren Beer werd bekroond. Daarna ontving de film nog enkele prijzen onder andere die voor het beste scenario op het kleinere, 2001 Robert Festival. Zelfs Miramax Films besloot om deze eigenzinnige film ook vanaf januari 2002 uit te brengen in de USA. In België kreeg de film in januari 2002 zijn première. Hij haalde echter de grote zalen niet. Ten onrechte, zo blijkt.</p>\n<p><a name=\"SYN\"></a></p>\n<h2><font color=\"#808000\"><strong>Synopsis</strong></font></h2>\n<p>In de buitenwijk waar het Kopenhaagse voetbalstadion ligt, vind je ook nog een modern kerkgebouw,een hotel, een klein kapsalon, een pasteibakkerij, een aula. Er wonen en werken verschillende alleenstaanden van middelbare leeftijd: de nog jonge dominee Andreas, de kapster Karen, de verkoopster Olympia,de hotelbediende Jorgen Mortensen, de kokkin Guilia en Hal-Finn, de vaste kelner van de voetbalkantine. Behalve het feit dat ze zich eenzaam voelen, hebben ze nog iets gemeenschappelijks. Langs diverse wegen vinden ze elkaar op de banken van de Italiaanse les voor beginners. De groep beslist op zekere dag om samen hun Italiaans te gaan testen in Venetië. Daar raken ze hun eenzaamheid kwijt.</p>\n<p><a name=\"CIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Cinematografie</strong></font></h2>\n<p><span class=\"menstis\">EIGEN SCENARIO</span>. Regisseur Scherfig schreef zelf het scenario. Ze ontwierp zelf de personages en bracht ze ook tot leven. Met de hulp van bevriende acteurs en actrices is haar dat wonderwel gelukt. Scenario en vertolking ondersteunen elkaar en dragen samen de film. Scherfig schreef het scenario vanuit haar wil om levensechte personages te schilderen. Haar verdienste daarbij is dat ze kiest voor zes personages - drie mannen en drie vrouwen - en dat die elkaar niet verdringen. Elk personage krijgt voldoende tijd en ruimte om zich te ontwikkelen. Scherfig slaagt in deze moeilijke opdracht omdat ze consequent kiest om de personges als reële menselijke personen te behandelen. Ze toont de personages zowel in hun werkmilieu als in hun thuissituatie. Hierdoor vermijdt de regisseur dat de nadruk ontstaat alsof de personages alleen maar marionetten in haar handen zouden zijn.Scherfig slaagt erin mensen te tekenen die voor de toeschouwer zeer herkenbaar blijven, gewone mensen die men op straat kan tegenkomen. Scherfig laat via alledaagse situaties zien hoe bij de personages het persoonlijke leven en het beroepsleven in elkaar verweven zijn.</p>\n<p><span class=\"menstis\">BEWUST ONHANDIGE CAMERA</span> Camera en montage dienen perfect de verbeelding van het alledaagse leven van gewone mensen, een verbeelding die de regisseur nastreeft. De camera krijgt namelijk een schijnbaar amateuristische behandeling. Het lijkt erop alsof de persoon die filmt, erg onhandig met de camera omspringt. Soms zet hij de lens scherp terwijl hij al aan het filmen is. Er komen schokken voor in de beweging van het beeld en ook de monatage binnen één scène verloopt niet altijd vloeiend. Met andere woorden, vooral het cameragebruik en in mindere mate de monatage onderlijnen wat de regisseur op het oog heeft: geen perfecte wereld, geen perfecte mensen en dus ook met opzet geen perfecte beelden.</p>\n<p><span class=\"menstis\">ARCHITECTUURMETAFOOR</span>. Een ander belangrijke cinematografische dimensie die bij <strong>Italiensk for Begyndere</strong> in het oog springt, is de wijze waarop de film omgaat met de architecturale ruimtes. Deze spelen een belangrijke rol en verschijnen als even belangrijk voor de uitwerking van de personages als hun kleding. Volgens de lijn beroepsleven - thuissituatie evoceert de film een zekere overeenstemming tussen de zakelijke en wat desolate architectuur van de gebouwen enerzijds en het diep, maar ingehouden verlangen van de personages naar huiselijke warmte en geborgenheid anderzijds. Dat beeld mondt uit in het architecturaal contrast van de slotsequenties in Venetië. In het kleurrijke en romantische Venetië dat oogt als een groot, gezellig huis waarin iedereen zijn plaats vindt, vergeten de personges de noorderlijke, afstandelijke gebouwen van hun Kopenhaagse wijk. <strong>Italiensk for Begyndere</strong> eindigt in een Venetiaans restaurant waar alle personages aan een grote tafel aanzitten: het beeld van een warme huiskamer waar de aanwezigen leden van een grote familie zijn geworden.</p>\n<p><a name=\"BET\"></a></p>\n<h2><font color=\"#808000\"><strong>Betekenisruimte</strong></font></h2>\n<p><span class=\"menstis\">GENERATIES</span>. Lone Scherfig opent met haar scenario en regie voor de toeschouwer een zeer boeiende betekenisruimte. Daarin versterken twee krachtige, beeldlijnen elkaar. Een eerste is zeker die van de <a href=\"http://generaties.De\">generaties.De</a> zes personages vertegenwoordigen de generatie van de volwassenen, de dertigers en veertigers. De regisseur spreekt hiermee over haar eigen generatie, ze is geboren in 1959. Kinderen komen in de film niet voor. Daarentegen tekent de film wel het portret van twee bejaarden: een man en een vrouw. Allebei staan ze als gebroken mensen in het leven. Ze zijn verslaafd, de man aan het televisietoestel, de vrouw aan de alcohol. In de loop van het verhaal blijkt dat ze ooit een koppel zijn geweest. Elk hebben ze een dochter die voor hen zorgt: Karen voor haar vader, Olympia voor haar moeder. De twee vrouwen weten echter niet van elkaar dat ze zusters zijn. Dat ontdekken ze in de kerk op het ogenblik dat zowel de vader als de moeder bijna gelijktijdig overlijden en worden begraven. Met dit beeld van de generatie spreekt Scherfig over de onmacht van de oudere generatie - de naoorlogse generatie van de ouders - om samen te leven en elkaar lief te hebben. Het is de generatie van de televisie, maar ook van de echtscheiding en de gebroken dromen. De generatie van hun kinderen, aldus het standpunt van <strong>Italiensk for Begyndere</strong>, weigert dergelijke levenswijze. Ze willen geen bestaan zonder stevig fundament. Maar zoals blijkt bij de personges van Karen en Olympia lijden ze nog onder de mislukking van hun ouders. De wijze waarop Scherfig in het eerste deel van de fim in beeld brengt hoe de twee dochters, onafhankelijk van elkaar, met veel geduld en mededogen voor hun ondankbare en zeurende ouder zorgen, is erg indrukwekkend en treffend. De toeschouwer kijkt in een spiegel en ziet een generatie die opgegroeid is met de eerste golf van de consumptiemaatschappij en die daarin is weggezonken. De kinderen ervan willen dergelijke levenswijze niet, maar lijden onder het gebrek aan ouderlijk voorbeeld. Ze hunkeren naar een authentieke, menselijke relatie, maar weten niet hoe ze die kunnen opbouwen. De film beweegt zich in het centrum van die reële dramatiek.</p>\n<p><span class=\"menstis\">LEVENSNABIJE RELIGIE</span>. Een tweede betekenislijn die de ruimte definieert, is de religieuze.Het eerste personage dat in de beeld komt, is dat van Andreas, de jonge dominee die interims doet. Het eerste gebouw dat we zien, is dat van de kerk. De reden waarom Andreas op vraag van die kerkgemeenschap zich aanmeldt, is voor de film niet zonder belang. Het betreft een conflict tussen de plaatselijke, protestantse kerkraad en dominee Wredmann. Het conflict, zo blijkt, heeft een duidelijke theologische achtergrond. Die komt reeds vroeg in de film aan de oppervlakte. Tijdens de eerste kerkdienst die Andreas leidt voor een zo goed als lege kerk, zit ook Wredmann te luisteren. De eerste zinnen van Andreas onthullen de religieuze betekenisruimte van <strong>Italiensk for Begyndere</strong>. Hij spreekt over de aanwezigheid van God in de dagelijkse, kleine dingen van het leven. Gods aanwezigheid kunnen mensen ervaren en beleven in alles wat ze in het leven zelf kennen en waardevol achten. Dergelijke theologie van Godsnabijheid maakt de geschorste dominee woest. Hij onderbreekt de dienst. Andreas ondergaat gelaten de oppositie. Later in de film zwijgt de jonge dominee niet langer. Op kerstavond zoekt Andreas, na zijn gewaardeerde dienst voor een volle kerk, Wredmann op. Dan breekt het theologische conflict helemaal open en houdt Andreas zich niet meer in. Hij wijst de ontgoochelde oudere collega zeer scherp terecht. Ook hier speelt het thema van de jonere en oudere generatie mee. De inhoud van het theologische conflict zelf handelt over Wredmanns veranderde visie op God. Na de dood van zijn vrouw, hebben het verdriet en de eenzaamheid hem overvallen. Met zijn vrouw heeft de godsman ook zijn geloof verloren. Sinsdien preekt hij vanuit een intellectuele hoogte over God als de abstractie die een illusie is die we als mensen dienen te verwijderen. Hij wil, in een protestantse geest, een emancipatie prediken, maar doet dit vanuit een intellectuele, hautaine en kille instelling. Andreas repliceert zonder aarzelen dat Wredmann zich heeft opgesloten in een koud en koel egoïsme. Via het personage van Andreas schept Scherfig een eigentijdse wijze van de benadering en de waardering van het religieuze, christelijke leven. Andreas spreekt niet vanuit de hoogte en evenmin vanuit een negatieve levenshouding: ook hij is weduwnaar, want zijn psychisch zieke vrouw heeft onlangs zelfmoord gepleegd. Hij kent ook het gemis. We zien hem in de hotelkamer zijn gevoel van eenzaamheid ‘uitbidden’. Hij weet echter zijn waardigheid te bewaren. Zijn woord en gedrag ontspringen aan een authentiek christelijk geloof, een incarnatiegeloof: God staat niet boven de mensen, maar tussen en in de mensen. Daarover spreekt hij, dat beleeft hij. Hij helpt mensen niet alleen in de kerk door de diensten waardig te verzorgen, maar ook in het zwembad van het hotel waar de impotente Jorgen Mortensen hem raad komt vragen. Vanuit de incarnatorische gedachte is het zeer betekenisvol dat het grote deel dat zich in Kopenhagen situeert, een hoogtepunt kent tijdens het kerstfeest: <em>het feest van de Incarnatie, van de heiliging van de Menswording</em>.</p>\n<p><a name=\"CON\"></a></p>\n<h2><font color=\"#808000\"><strong>Context</strong></font></h2>\n<p>De twee krachtige betekenislijnen scheppen een betekenisruimte waarin de tafel een sacraal midden vormt. Het hele filmverhaal mondt uit in de slotscène in Venetië; het is een tafelscène. Hier schrijft de film zich in in wat we in het kader van het grote project van Men(S)tis in 2000-2001 hebben uitgewerkt: <em>het project Tabula Sacra</em>. De begeleidende visie met zijn antropologische, antropologische en ook religieuze dimensies heeft De Bleeckere uitgeschreven in zijn essay <em>Het tafelschap</em> Daarin vestigt hij de aandacht op onder andere de Skandinavische filmtraditie waarin de tafel een belangrijk en betekenisrijk beeldmotief vormt: van <strong>Fanny och Alexander</strong> (1982) van Ingmar Bergman over <strong>Babettes Gaestebud</strong> (1987) van Gabriël Axel naar <strong>Festen</strong> (1998) van Thomas Vinterberg. De film <strong>Italiensk for Begyndere</strong> plaatst zich op een eigen en oorspronkelijke wijze in die betekenistraditie. De film van Scherfig behoort niet alleen tot <em>de Skandinavische filmtraditie</em>. Zijn hele verschijning wijst op een zeer duidelijke context, namelijk die van de Skandinavische vernieuwende filmbeweging, <em>Dogma 95</em> genoemd. Scherfigs film is de twaalfde film die het Dogma-certificaat draagt. De film opent ook met het beeld van dat certificaat. Bezield door de avant-gardistische wil van de Deense cineast <em>Lars Von Trier</em> heeft de Dogma 95-beweging al tal van meesterwerken geproduceerd. Met de film van Scherfig heeft de beweging er een nieuw meesterwerk bij.</p>\n<p><a name=\"LIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Links</strong></font></h2>\n<p>De Bleeckere, S., 2001. <em>Het tafelschap, in:</em> CineMagie nr.234, lente, 34-53.</p>\n<p><font size=\"-2\">© Sylvain De Bleeckere, Men(S)tis, 2011/2017</font></p>\n"}

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

	module.exports = {"title":"Kaïn","body":"<center>\n<img src=\"KAIN.jpg\" >\n</center>\n<a name=\"KLA\"></a>\n<h2><font color=\"#808000\"><strong>Klapbord</strong></font></h2>\n<p>De kortfilm <strong>Kaïn</strong> (16 min.) is de debuutfilm van de jonge, Oostendse cineast Kristof Hoornaert. Hij is een autodidacticus die zijn eigen scenario met steun van het Vlaams Audiovisueel Fonds (VAF) heeft kunnen verfilmen voor de Vlaamse productiemaatschappij <em>Minds Meet</em>. De film kreeg een selectie voor de Berlinale <em>Shorts Competition</em> van het filmfestival van Berlijn 2009, waar hij werd genomineerd voor de Gouden Beer. Selecties waren er ook voor het <em>Manlleu Short Film Festival, Tofifest International Film Festival - Oostende Film Festival, Bursa International Silk Road Film Festival, Madrid Experimental Cinema Week</em> en <em>India International Film Festival</em>.</p>\n<p><a name=\"SYN\"></a></p>\n<h2><font color=\"#808000\"><strong>Synopsis</strong></font></h2>\n<p>Op een open plek in een bos op een niet gepreciseerde plaats kan een jonge man nog net op tijd de stok afweren waarmee iemand van achter hem wil neerslaan. Hij verdedigt zich tijdens het gevecht op de grond met zijn aanvaller, eveneens een jonge man. Net zoals hij goed gebouwd. Het zouden, zo te zien, kunnen broers zijn. De aanvaller laat niet los en spant zich tot het uiterste in om de grote steen die hij ziet liggen, met beide handen te grijpen. Het lukt hem en hij slaat ermee zijn slachtoffer het hoofd in. De moordenaar rust even uit en torst dan het dode lichaam op zijn schouder. Hij draagt het lichaam een eind het bos in tot waar de grond vochtig wordt wegens de nabijheid van een uitgestrekte vijver. Daar dumpt hij het lijk onder een hoge struik. Daarna stapt hij naar de vijver. Wast het bloed van zijn handen en zijn shirt, om dan helemaal naakt onder te duiken in het water. Wanneer hij boven water komt, hoort hij in de verte geluiden en vlucht haastig weg over het veld. Hij stopt met vluchten in het hoge gras ergens op een weide, gelegen op een heuvel. Met gebogen hoofd rust hij uit. Dan richt hij zijn hoofd op en kijkt met tranen in de ogen over het glooiende landschap naar de horizon met de eerste tekenen van menselijke beschaving: het vervallen huisje.</p>\n<p><a name=\"CIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Cinematografie</strong></font></h2>\n<p><span class=\"menstis\">FILMGEDICHT.</span> <strong>Kaïn</strong> situeert zich zelfbewust in de traditie van <em>de Europese auteursfilm</em>. Dat blijkt uit het feit dat Kristof Hoornaert tekent voor het concept, het script en de regie. Maar er is meer. De jonge regisseur stelt zich bewust op in de traditie van de cineasten Andrei Tarkovski  met films en Bruno Dumont. Met deze laatste deelt hij trouwens dezelfde betrokkenheid op het heuvelland van West- en Frans-Vlaanderen. Voor Kristof Hoornaert is <strong>Kaïn</strong> een studie in de cinematografie die vanuit zijn eigen unieke en beeldende kracht <em>het mysterie van het leven zelf</em> aan het woord laat, of beter: <em>zijn eigen beeld laat regisseren</em>. De filmische middelen komen consequent in dienst te staan van de eigen kracht van de levende werkelijkheid. Concreet is dat hier de werkelijkheid van de natuur (het bos, het meer, de weide, het landschap) en de werkelijkheid van de mens. Zo ontstaat het filmgedicht dat <strong>Kaïn</strong> is. Alleen de beelden en de klanken vormen het corpus van het gedicht. Het enige woord dat erbij hoort, is de titel. De montage van beelden en klanken zijn de verzen van het gedicht dat zijn eigen betekenis voordraagt. De toeschouwer krijgt de tijd om vanuit <em>een contemplative houding</em>, eigen aan het beeldend denken, het audiovisuele gedicht te schouwen.</p>\n<p><span class=\"menstis\">HET GELUID VAN DE STILTE</span>. <strong>Kaïn</strong> kent geen gecomponeerde muziek. De klankwereld is die van de plaats van de handeling. De stem van het bos met alles wat er leeft, en de woordeloze klanken van de twee mensen, vooral dan van de moordenaar: zijn zuchten, zijn ademhaling, zijn stappen, zijn vluchten. Zelfs tijdens de vechtpartij worden er geen woorden naar elkaar toe geschreeuwd. De stem van de mens, zelfs niet van de vechtende mens, verstoort hier geenszins de stilte van de natuur. Die blijft rustig en quasi geruisloos ademen. Het is windstil, de bebladerde bomen rusten. De natuur krijgt haar eigen stem. Die wordt niet naar de achtergrond geduwd door opdringerige muziek die hier bijna als heiligschennis zou overkomen.</p>\n<p><span class=\"menstis\">PANORAMISCHE KADRERING</span>. De film kent een panoramische breedte, die via de statische camera nog meer de nadruk krijgt. Dat impliceert dat de keuze voor de panoramische beeldwerking ook het ritme bepaalt. De camera beweegt slechts enkele keren snel. Dat gebeurt om het personage van de moordenaar op zijn vlucht te volgen. Maar de momenten waarop hij tijdens zijn vlucht stilstaat, zijn talrijker dan de momenten waarop hij daadwerkelijk versneld beweegt. De panoramische kadrering geeft aan de cineast ook de mogelijkheid om zijn doel te bereiken en dat is <em>de natuur zelf als hoofdpersonage</em> te laten optreden. De panoramische shots van het bos volgens de horizontale en de verticale as, van het landschap met de horizon, van het wateroppervlak van het meer openen een wijde ruimte die recht doet aan de werkelijkheid van de omringende natuur en het groeiende leven waaruit ze concreet bestaat. Kristof Hoornaert schrijft zich met zijn cinematografie van het panoramische landschap in in de traditie van <em>de spirituele landschapschilderkunst die teruggaat op Caspar David Friedrich</em> en die in Vlaanderen in het oeuvre van <em>Valerius De Saedeleer</em> zijn weerga vond.</p>\n<p><span class=\"menstis\">RUGSHOTS</span>. Bij de opnames van de twee menselijke figuren, valt het consequente gebruik op van het rugshot. Dat stemt overeen met het picturale universum waarvan de meester van het spirituele landschap, het genie van de Duitse romantische schilderkunst, de zopas genoemde <em>Caspar David Friedrich</em>, de auteur is. In tegenstelling tot het modernistische dogma van het portret waarin het ego van het individu het daglicht opeist, schildert Friedrich voor het eerst de mens op de rug. Zijn <em>Der Wanderer über dem Nebelmeer</em> van circa 1818 is daarvan het meest sprekende voorbeeld. Ook het panoramische schilderij <em>Der Monch am Meer</em> van circa 1808-10 kent diezelfde uitstraling. In dat beelduniversum draait de (moderne) mens niet meer rond zijn eigen middelpunt. Het beeld haalt hem uit zijn centrum en plaatst hem in zijn originele thuis: de weidse, aardse natuur die hem tot zijn ware proporties herleidt. Vanuit zijn eigen wezen heeft dergelijk beeldwereld <em>een gewilde religieuze werking</em> omdat ze de (moderne) mens herdefinieert vanuit zijn wezenlijke verbondenheid met de bron van zijn eigen bestaan: <em>het heilige leven op aarde</em>. In <strong>Kaïn</strong> is het hoofdpersonage van de natuur de bevoorrechte getuige van wat er met de mens gebeurt. Vanuit dat perspectief valt er een bijzonder licht op het belangrijke filmische feit dat de regisseur bewust met twee <em>niet-professionele acteurs</em> heeft willen werken. In zijn cinematografie van het rugshot is er geen plaats voor psychologie, wat ook blijkt uit de afwezigheid van het menselijke woord. Het menselijk lichaam komt op de voorgrond. In de orde van de mensenwereld is dat het hoofdpersonage. Hier treedt Kristof Hoornaert in de voetsporen van Bruno Dumont die met zijn werk een hedendaagse, nieuw hoofdstuk heeft geschreven in ‘<em>de film van het lichaam</em>’. In de plot van <strong>Kaïn</strong> komt die film helemaal tot zijn recht. Het laatste shot van de moordenaar is dat van zijn beweend gelaat. Dat slotbeeld werkt als de monding voor de voorgaande rugbeelden van het personage. Voor zijn cinematografie van het lichaam vond Kristof Hoornaert naar eigen zeggen ook inspiratie in de Vlaamse schilderkunst van <em>Gustave van de Woestyne</em> met zijn unieke beelden van kwetsbare lichamen. Eenzelfde inspiratiebron vormde het werk <em>Zittende jongeling</em> van de Duitse beeldhouwer Wilhelm Lehmbruck. Net zoals in <strong>Kaïn</strong> is bij de beelden van van de Woestyne en Lehmbruck het menselijk lichaam bron van een <em>spirituele intensiteit</em>.</p>\n<p><a name=\"BET\"></a></p>\n<h2><font color=\"#808000\"><strong>Betekenisruimte</strong></font></h2>\n<p><span class=\"menstis\">BIJBELBEELD</span>. Het vierde hoofdstuk van het eerste bijbelboek, <em>Genesis</em>, handelt over Adams zonen. De eerste twee heten Kaïn en Abel. De twee broers komen tegenover elkaar te staan door de schuld van de jaloerse Kaïn. Op de titel na refereert de film zelf niet direct aan <em>Genesis 4</em>. Het is er geen letterlijke verfilming. Het gaat om de betekenis ervan. De cineast getuigt daarover zelf:</p>\n<blockquote>\n<p><em>De wreedheid van de mens kent zijn oorsprong in het verhaal van Kaïn en Abel uit het Oude Testament: de eerste moord. De ene broer die uit jaloezie de andere vermoordt. De mens die zijn medemens van het leven berooft. Dit tragische beeld was voor mij de motivatie om dit kortverhaal te schrijven. Uiteindelijk weent de moordenaar om zijn gruwelijke daad. Met dit kortverhaal wil ik reflecteren over onze menselijke conditie. De broedermoord van Kaïn en Abel is meer dan ooit enorm actueel.</em> (K. Hoornaert. <em>Kaïn. Nota van de regisseur</em>. 2009)</p>\n</blockquote>\n<p><strong>Kaïn</strong> toont goed aan hoe beeldende kunstenaars de Bijbel lezen. Als een beeldrijke tekst. Zij zien de beeldende kracht in de teksten en wenden de hedendaagse instrumenten aan om die beeldende kracht opnieuw te herontdekken. De cinematografie van het beeldende denken evoceert zo de blijvende actualiteit van tal van bijbelverhalen. Dat geldt zeker voor het verhaal over de eerste broedermoord. Het filmgedicht bevrijdt in zeker opzicht de werkelijkheid van het Bijbelverhaal van zijn tekstuele inkleding. Niet dat het de tekst zelf wil vervangen, laat staan weggooien. In het filmgedicht krijgt <em>de werkelijkheid van de broedermoord</em> zijn blijvende <em>religieuze resonantie</em> omdat het medium film een mystieke band onderhoudt met het mysterie van de werkelijkheid zelf.</p>\n<p><span class=\"menstis\">GEBOORTE VAN HET GEWETEN</span>. De openingsbeelden introduceren het bos, de plaats van de handeling. Dat betekent geenszins dat het bos louter als decor optreedt. De beelden en de natuurlijke geluiden nemen de tijd om het bos als een reëel personage voor te stellen. In de schildering ervan verschijnt het bos als een natuurlijke, gotische kathedraal. De regisseur schenkt immers aandacht aan de open ruimte in het bos en aan het samenspel tussen de vruchtbare aarde, de moederschoot van het leven, en de lichtende hemel. Tijdens het drama van de broedermoord blijft het bos en de omgeving altijd aanwezig. Het geheel heeft een minimale verhaallijn. Iedere psychologische verklaring wordt bewust weggelaten, een aanpak die door de Franse cineast <em>Robert Bresson</em> werd geïntroduceerd. Kristof Hoornaert gaat consequent ver in die cinematografie. Door het gebruik van het rugshot ontbreken de close-ups van de gezichten. De lichamen beheersen de scène. Er is geen enkel motief noch achtergrond voor de moord. Over de verwevenheid van het bos en de menselijke lichamen noteert de regisseur zelf het volgende:</p>\n<blockquote>\n<p><em>De rust van het bos contrasteert met de wreedheid van de moord. Rupsen, insekten en vogels in het bos. De natuur is onverschillig voor  de menselijke wreedheid. De natuur die de oorsprong van het leven is. Het is een plaats van water, licht, wind, stilte, bomen, wolken, aarde. Het is de natuurlijke leefomgeving van de mens.</em>(K. Hoornaert, <em>Kaïn. Nota van de regisseur</em>. 2009)_</p>\n</blockquote>\n<p>Het filmgedicht van de broedermoord verschijnt zonder woorden. De vele woorden die dagelijks in de kranten en in de media over die wreedheid worden geproduceerd, lijken hier eerder op een enorm gedruis met als effect het doen verstommen van die werkelijkheid. Daartegenover staat <em>de stille kracht van de audiovisuele beelding</em>. Die evoceert de geboorte van het menselijke geweten. De cineast koppelt immers het Kaïngebeuren met het vijfde van de Tien Geboden: ‘<em>Pleeg geen moord</em>.’ (Ex. 20:13). Hij probeert helemaal niet om het bijbeltafereel na te spelen. Hij gaat immers anders te werk dan de auteur van <em>Genesis</em> die de klemtoon legt op het psychologische motief van de jaloezie, op het brengen van offers en op het nageslacht. Hoornaert distilleert uit het verhaal de kern die onvergankelijk actueel blijft in de mensenwereld: de broedermoord waarvan de zwaartekracht echoot in Gen. 4:10:</p>\n<blockquote>\n<p>‘<em>Wat heb je gedaan?’ zei de HEER.</em><br>\n‘<em>Hoor toch hoe het bloed van je broer uit de aarde naar mij schreeuwt</em>.’<br></p>\n</blockquote>\n<p>In het filmgedicht weerklinkt die schreeuw in de <em>kathedraal van het bos</em> en <em>het West-Vlaamse heuvelland</em>. Het is geen letterlijke schreeuw, maar een proces van verwerking en meditatie dat zich in het innerlijk van de moordenaar afspeelt en zich voltrekt binnen de sprekende stilte van de heilige ruimte van de natuur. Hij gebruikt  het bos om zijn daad uit te voeren, te verbergen, te vluchten, het bloed weg te wassen van zijn handen en zijn hele lijf te reinigen. Maar de sprekende stilte van de natuurlijke omgeving weerkaatst zich in zijn gemoed. In het slotbeeld richt hij zijn gebogen hoofd op en kijkt met betraand gelaat recht in de ogen van de verre horizon, waar hemel en aarde elkaar ontmoeten en waar zich de eerste tekenen van beschaving in de aanwezigheid van een vervallen huisje zich aftekenen. Door de beeldsetting die vooraf gaat aan <em>de onthullende close-up van het wenende gelaat</em> oogt het filmgedicht als een eigentijdse meditatie over <em>de religieuze geboorte van het geweten</em>. In die geboorte voltrekt zich de transcendentie van de broedermoord, een beweging die wordt beschreven in de gang van de open ruimte in het bos naar de plek op de heuvelrug waar zich de horizon ontvouwt.</p>\n<p><span class=\"menstis\">LEVENSBESCHOUWING</span>. Het filmgedicht handelt niet over levensbeschouwing, het <em>is</em> levensbeschouwing, in de rijke zin van het woord. De bijzondere kracht ervan vloeit voort door micro en camera zo aan te wenden dat het leven zelf in de actieve zin schouwend wordt. Het bos neemt het drama op in zijn blikveld. In het filmgedicht bekleedt de levende aarde de plaats die het personage van God heeft in <em>Genesis 4</em>. Het landschap met zijn horizon, levend beeld van het goddelijke mysterie van het bestaan, worden oog en oor voor <em>het proces van menswording</em> dat zich aan het voltrekken is van in de Bijbelse tijden tot op vandaag, een ononderbroken drama met ontelbare taferelen waarvan de zwaartekracht zich verdicht in de kortfilm <strong>Kaïn</strong>.</p>\n<p><a name=\"CON\"></a></p>\n<h2><font color=\"#808000\"><strong>Context</strong></font></h2>\n<p>De kortfilm is een atypische Vlaamse productie en creatie in het Vlaamse filmlandschap dat zich in het eerste decennium van deze eeuw heeft gevormd. De jonge regisseur Hoornaert schrijft zich in de internationale, vooral Europese traditie van de religieus geïnspireerde film. Sommigen gebruiken liever de term ‘spirituele film’. De Vlaamse filmproductie blijft in die traditie afwezig. Het genre van de misdaadthriller en de komedie domineren het filmdoek in Vlaanderen. Het relatiedrama vindt ook zijn publiek. Hoornaert bewandelt eigenzinnig de weg van de cinematografie die zich zonder omwegen naar de werkelijkheid van het leven zelf richt. Met <strong>Kaïn</strong> treedt hij in dialoog met de schrijver van het oude Genesisverhaal over de mens die in staat is zijn medemens, zijn broer, te doden, ononderbroken, van generatie op generatie. Wonderlijk genoeg gaat die keuze voor <em>de werkelijkheid van het leven zelf</em> gepaard met een radicale keuze voor het filmbeeld zelf. Hoornaert toont zijn geloof in de eigen unieke denkkracht van de cinematografie.</p>\n<p><a name=\"LIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Links</strong></font></h2>\n<p>K. Hoornaert, <em>Kaïn. Nota van de regisseur</em>. 2009 (niet-gepubliceerde nota, ter beschikking gesteld door de regisseur) <a href=\"http://www.kristofhoornaert.com/\">De website van Kristof Hoornaert</a></p>\n<p><font size=\"-2\">© Sylvain De Bleeckere, Men(S)tis, 2011/2017</font></p>\n"}

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

	module.exports = {"title":"Marie Heurtin","body":"<center>\n<img src=\"mh.jpg\" >\n</center>\n<p><a name=\"KLA\"></a></p>\n<h2><font color=\"#808000\"><strong>Klapbord</strong></font></h2>\n<p>De historisch-biografische film <strong>Marie Heurtin</strong> ging in de zomer van 2014  in première tijdens het internationaal filmfestival van Locarno. Hij won er de <em>Variety Piazza Grande Award</em>. De internationale titel is <strong>Marie’s Story</strong>. De Franse regisseur <em>Jean-Pierre Améris</em> baseerde zich op het goed gedocumenteerde verhaal van <em>Marie Heurtin</em>. Ze kwam doofblind ter wereld in 1885 en overleed op 36jarige leeftijd op 22 juli 1921. Het meisje had de eerste dertien jaren van haar leven geen enkel contact met zichzelf en haar omgeving. Ze had geen enkel besef wie ze was en waar ze was. Ze bleef  onhandelbaar. Dat veranderde op haar veertiende. Ze kwam dan terecht bij de kloosterzusters <em>Filles de la Sagesse</em>. Die bestuurden het <em>Institut Notre-Dame de Larnay</em> bij Poitiers, Frankrijk. Het instituut bestaat nog steeds. Sinds 2006 hebben de zusters het bestuur overgedragen aan de vereniging Larnay Sagesse. Priester <em>Chaubier de Larnay</em> stichtte het instituut in 1847 met als doel sensorieel gehandicapte personen, blinden en doven, op te vangen en te begeleiden. Doofblinden zijn heel uitzonderlijk. Eén van de uitzonderingen was Marie Heurtin. In het Institut Larnay ontfermde de kloosterzuster <em>Sainte-Marguerite</em> ontfermt zich over de veertienjarige doofblinde Marie Heurtin. De zuster ontwikkelde een pedagogie waarmee ze erin slaagde om contact te krijgen met het doofblinde meisje. Door de jaren heen kon Marie Heurtin aldus <em>een eigen menselijke persoonlijkheid</em> opbouwen. Aan het werk van zuster Marguerite dankt het instituut zijn bekendheid. De film is gebaseerd op <em>de wetenschappelijke documentatie</em> over het pedagogische werk van zuster Marguerite met Marie Heurtin. De Franse professor Louis Arnould, verbonden aan de universiteit van Poitiers, wijdde reeds in 1900 in zijn wetenschappelijk werk <em>Une âme en prison</em> een uitgebreide studie aan Marie Heurtin. Zijn studie werd in 1907 nog uitgebreid met een beschrijving van de behandeling van een tweede doofblinde vrouw, Anne-Marie Poyet en met een uitbreiding van het geval Marie Heurtin door haar zuster Marthe Heurtin. De nieuwe titel van het werk dat verwijst naar de eerste studie luidt: <em>Âmes en prison, l’École française des sourdes-muettes-aveugles</em> (1910). De regisseur Jean-Pierre Améris schreef zelf het scenario samen met Philippe Blasband op basis van de historische bonnen. Daarbij legden ze de nadruk op de relatie tussen de twee betrokken vrouwen, zuster Marguerite en Marie Heurtin. De actrice <em>Isabelle Carre</em> nam de rol van de zuster op zich en bereidde zich een half jaar voor met het leren van de Franse gebarentaal. De dove <em>Arianan Rovoire</em> werkte nooit eerder als actrice. De regisseur koos haar voor de rol van Marie Heurtin. De vertolking van beide vrouwen is indrukwekkend.</p>\n<p><a name=\"SYN\"></a></p>\n<h2><font color=\"#808000\"><strong>Synopsis</strong></font></h2>\n<p>De ouders van Marie Heurtin hebben hun doofblinde dochter met liefde opgevoed. Ze staan echter machteloos tegenover de ingrijpende handicap van hun meisje. Ze zijn er bijvoorbeeld al die jaren niet in geslaagd het meisje schoenen aan te doen en behoorlijk te kleden. Het kind heeft immers geen enkel contact met zichzelf noch met haar omgeving. De ouders kunnen niet communiceren met hun opgroeiende dochter. Ze herkent haar ouders enkel via de geur en door met haar handen de gezichten te betasten, maar wie eigenlijk wie ze zijn. Met haar zorgende vader heeft ze een goede band. Ze vertrouwt hem. Ze willen de opgroeiende Marie niet laten opsluiten in een asiel voor krankzinnigen. Ze vragen aan het nabijgelegen Larnay Instituut haar te willen opnemen. De moeder-overste weigert, terwijl zuster Marguerite zich geroepen voelt om het meisje te helpen. Ze weet de moeder-overste te overtuigen. Ze krijgt de toestemming van haar overste om het meisje te gaan halen en mee te brengen. Eens aangekomen in het klooster en het internaat, begint het opvoedingswerk van zuster Marguerite. Ze moet improviseren. Ze laat zich niet ontmoedigen door tegenslagen. Ook de scepsis van haar overste  kan haar motivatie en inzet niet temperen. Ondersteund door vooral haar dove medezuster Raphaëlle, gaat zuster Marguerite met een eindeloos geduld te werk. Ze experimenteert. Haar medezusters Véronique, Joseph, Elisabeth, Marthe, Anne, Clothilde en Marie-Ange volgen het verloop van de opvoeding van Marie met verwondering, soms met ongeloof en zelfs met scepsis. Uiteindelijk slaagt Marie een eerste contact te krijgen met de geest van Marie. Het meisje ontwaakt en begint aan een ongekend leerproces. Tussen Marie en zuster Marguerite ontstaat er een heel sterke band. Die wordt op de proef gesteld door de zwakke gezondheid van zuster Marguerite. Uiteindelijk kunnen ze allebei afscheid nemen op het sterfbed van zuster Marguerite. Marie bezoekt het graf van zuster Marguerite,en spreekt tot haar, over de dood heen, in de gebarentaal die ze van haar heeft geleerd.</p>\n<p><a name=\"CIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Cinematografie</strong></font></h2>\n<p><span class=\"menstis\">WARME KLEUREN.</span> De film kent een zonnige uitstraling. Dat komt door de aandacht voor de <em>volle kleuren</em>, zelfs in de sequenties die zich in de winter situeren. Het eerste deel van de film speelt zich trouwens af in de lente. Het is in de meimaand, de Mariamaand, dat zuster Marguerite, met toestemming van moeder-overste, Marie gaat halen bij haar thuis om ze mee te nemen. De <em>zonovergoten</em> beelden vertolken de blijheid van zuster Marguerite. De blijde lentebeelden krijgen nog versterking van de begeleidende <em>zonnige muziek</em> waarin de speelse, maar warme fagot een hoofdrol speelt. Het betreft <em>Jeux d’enfants, After Janacek’s Moravian Folksongs V</em> van Franck Krawcyck. Voorts straalt de <em>licht blauwe kleding</em> van de zusters een blijde eenvoud uit.</p>\n<p><span class=\"menstis\">CYCLISCHE TIJD.</span> De film is lineair opgebouwd, maar toch staat de duur van het verhaal in het teken van de cyclische tijd. De openingssequenties brengen zuster Marguerite en Marie samen. Eens Marie in het instituut is waar zuster Marguerite zich over het meisje ontfermt, begint de zuster <em>een dagboek</em>. Regelmatig volgen er korte sequenties met zuster Marguerite schrijvend in haar dagboek. Daarna gaat haar stem die uitspreekt wat ze schrijft, verder in voice-over bij de beelden van het leerproces van Marie. Dat dagboekdeel dat tevens het grootste deel van de film omvat, is gestructureerd via <em>de kalenderdagen</em> die de zuster in haar dagboek noteert. Het begint op 10 mei. Daarna volgen nog 27 mei, 26 juli, 20 september, 27 oktober, 15 november, 15 juni, 20 april. Het valt op dat bij de data <em>geen jaartallen</em> staan. Hiermee lost Améris het probleem op van de duur van het leerproces. Het is onmogelijk om dat leerproces dat jaren bestrijkt, binnen de tijdsduur van een film weer te geven. Alleen via suggestie is het mogelijk om het wezenlijke van dat reële proces te evoceren. Via de data beschrijft de regisseur <em>een cyclus van lente (mei) tot lente (eind april)</em>. Het is de <em>natuurcyclus van de wedergeboorte</em>. In dat teken plaatst de regisseur het hele leerproces dat zuster Marguerite en Marie Heurtin samen doormaken.</p>\n<p><span class=\"menstis\">PANO EN CLOSE-UPS.</span> Het beeldformaat varieert van panorama tot close-up. In <em>de buitenbeelden</em> plaatst de regisseur de personages in de omgeving, de natuur. Dat gebeurt in het eerste deel van de film vooral in de sequenties van de weg die zuster Marguerite samen met Marie te voet aflegt van Marie’s thuis tot aan het instituut. In de buitensequenties die zich situeren in het instituut gebruikt de cineast het kleinere panoramaformaat om de personages te situeren in de groetentuin, de grote tuin met vooral gras en enkele bomen en het kleine kerkhof. Het formaat in <em>de binnensequenties</em> is vooral dat van de close-up. De talrijke close-ups brengen de pedagogische werk van zuster Marguerite in beeld. De close-ups van <em>de gezichten van zuster Marguerite en Marie</em> zetten het wonder van het contact tussen beiden in reliëf. Dat contact verloopt immers zonder woorden. Dat verklaart waarom de close-ups van <em>de handen van beide vrouwen</em> het visuele leidmotief van de film vormen.</p>\n<p><span class=\"menstis\">BEELDMETAFOREN.</span> De film kent geen visuele bravoure. Hij oogt eenvoudig. Dat sluit aan bij <em>de spiritualiteit van de eenvoud</em> die het werk van de zusters typeert. Ze leiden een bestaan in eenvoud en ze stellen zich in dienst van de opvoeding van de meisjes met een zintuiglijke beperking. Die cinematografische eenvoud krijgt een grote diepgang via <em>enkele beeldmetaforen</em> die op het dagelijkse leven zijn geënt. Juist in een omgeving waar woorden amper een rol spelen, ontwikkelt zich <em>het beeldend denken</em> via visuele metaforen op een manier die alleen de kunst van de cinematografie kan realiseren. De belangrijkste beeldmetafoor is die van <em>het zakmes</em>. Zuster Marguerite ontdekt in het huis van de ouders van Marie dat het meisje zeer gehecht is aan het zakmes. Ze neemt het in haar handen en ruikt er het intens aan. Zuster Marguerite gebruikt dat zakmes om een eerste vorm van communicatie te realiseren met Marie. Daarnaast groeien via talrijke close-ups <em>de handen</em> uit tot sterke lichaamsmetaforen. In tal van sequenties vormt het spel van de handen een eigen visuele partituur. Een andere belangrijke beeldmetafoor is die van <em>de boom</em>. De regisseur brengt ermee <em>een inclusie</em> aan in de film. Bij de eerste aankomst van Marie op het Institut Notre-Dame de Larnay vlucht Marie in de boom. Zuster Marguerite probeert haar te overtuigen om terug naar beneden te komen. Op het ogenblik dat dit bijna lukt, komt moeder-overste tussen waardoor zuster Marguerite uit de boom valt. Naar het einde toe, met name in de sequenties die in het teken staan van de stervende zuster Marguerite, komt er opnieuw een boomscène voor. Opnieuw is Marie in de boom geklommen. Ze is gefrustreerd omdat de zieke zuster Marguerite haar niet meer in haar kamer wil toelaten. De zuster heeft immers grote moeite om afscheid van Marie te nemen. Opnieuw komt de moeder-overste tussen, maar nu in de positieve zin. Ze weet zuster Marguerite te overtuigen om Marie toe te laten bij haar ziekbed. Daarna is het de moeder-overste die zelf in de boom klimt om Marie te overtuigen om naar beneden te komen en opnieuw voor de zieker zuster Marguerite te gaan zorgen. De boom krijgt in die dramatische context en door de inclusie de betekenis van <em>de levensboom</em>. Hij brengt zuster Marguerite en Marie samen bij het begin en op het einde.</p>\n<p><span class=\"menstis\">DE KLANK VAN CELLO EN VOGELS.</span> Naast de reeds vermelde zonnige muziek in het eerste deel van <strong>Marie Heurtin</strong>, is het vooral <em>de cellomuziek</em> de filmbeelden begeleidt. Voor de instrumentale filmmuziek tekende de Franse celliste <em>Sonia Wieder-Atherton</em>. Ze vertolkt samen met Matthieu Lejeune en Sarah Lancu fragmenten van Claude Monteverdi’s <em>Madrigali Guerrieri et Amorosi, Libro VIII : Altri Canti d’Amor</em>. Voorts speelt ze een eigen bewerking van <em>Jeux d’enfants, After Janacek’s Moravian Folksongs I-VII</em> van Franck Krawcyck, <em>de Vespers</em> van Rachmaninov, <em>Variaties on a Slovak Folksong 1-5</em> van Bohuslav Martinu, <em>het Rückert-Lied Ich bin der Welt abhanden gekommen</em> van Gustav Mahler, <em>La chanson de Marie</em>, Sonia Wieder-Athertons bewerking van een Joodse tradional voor cello. Via de keuze voor de cello als leidend instrument krijgt de filmmuziek een homogeen karakter. De hoofdtoon is <em>ingetogen, met een ondertoon van beheerste droefheid</em>. Die begeleidt <em>de innerlijke strijd</em> van zowel zuster Marguerite als van de doofblinde Marie. De muzikale uitzonderingen zijn het reeds vermelde zonnige <em>Jeux d’enfants, After Janacek’s Moravian Folksongs V</em> van Franck Krawcyck, alsook Bachs <em>Sicilienne</em>. Dit laatste stuk wordt in de film zelf op piano gespeeld door een medezuster van zuster Marguerite. De piano staat in de eetzaal van de zusters. In de scène met de piano leert Marie voor het eerst de wereld van de muziek en de muziekinstrumenten verkennen. Naast de muziek, monteert  Améris ook <em>natuurgeluiden</em>, in het bijzonder <em>het gefluit van vogel</em>. Het instituut die het internaat voor de meisjes en het klooster van de zusters omvat, ligt immers midden in de natuur. De stemmen van de vogels die zich ophouden in de grote tuin met bomen van het instituut, begeleiden vooral de buitenbeelden met zuster Marguerite en Marie. Vooral in de momenten van harmonie en verstandhouding tussen beiden situeren zich buiten, begeleid door de vogels. De slotsequentie met Marie bij het graf van zuster Marguerite situeert zich ook in de grote tuin waar zich het kerkhof van de zusters bevindt. De binnenbeelden onderlijnen vooral de strijd die zuster Marguerite moet voeren om Marie uit haar duisternis te halen, een strijd die grenzeloos geduld vereist. Die binnenbeelden krijgen vooral een cellobegeleiding.</p>\n<p><a name=\"BET\"></a></p>\n<h2><font color=\"#808000\"><strong>Betekenisruimte</strong></font></h2>\n<p><span class=\"menstis\">DE GEBOORTE VAN DE GEEST</span>. De kracht van de film <strong>Marie Heurtin</strong> reikt verder dan de re-enactment van de historische case van de doofblind geboren Marie Heurtin en haar opvoedster zuster Marguerite. Via die filmische reconstructie, herinnert de regisseur de toeschouwer aan <em>een zeer fundamenteel menselijk fenomeen</em>, namelijk dat van <em>de geboorte en de wording van de geest</em>. Met die geest is niet alleen de identiteit van de mens als mens en individu gegeven, maar eveneens het onlosmakelijk fenomeen van de opvoeding en de menswording. Geen mens die wordt geboren, is in staat zichzelf op te voeden. En dat geldt bij uitstek voor wie doofblind ter wereld komt. Doofblindheid van bij de geboorte, officieel <em>aangeboren of congenitale doofblindheid</em> genoemd, is eerder zeldzaam. Tot in de tweede helft van de negentiende eeuw, de tijd van Marie Heurtin, werd een opgroeiende doofblinde als ‘abnormaal, wild, gek, idioot’ beschouwd, waarvoor er geen remedie of therapie bestond. Overleden hij of zij niet op jonge leeftijd en werd hij of zij volwassenen, dan kwamen die terecht in een gesloten instelling voor psychiatrische patiënten, toen in de volksmond ‘een gekkenhuis of zothuis’ genoemd. Kortom, opsluiting! Dat laatste wilden de ouders van Marie Heurtin vermijden. Ze konden echter geen kant uit daar ze zelf hun opgroeiende dochter niet meer in bedwang konden houden. Daarom zochten ze hun toevlucht tot het nabijgelegen Institut Notre-Dame de Larnay, gespecialiseerd in de opvoeding van dove meisjes. Zuster Marguerite beschouwde het als haar roeping om alles te proberen om de doofblinde Marie te helpen. De film brengt <em>het opvoedingsproces</em> in beeld, dat zich tussen beiden heeft afgespeeld. Hierdoor krijgt de toeschouwer de gelegenheid om met zuster Marguerite mee <em>het wonder van de geboorte van de menselijke geest</em> te zien voltrekken. Alles staat daarbij in het teken van het contact krijgen met zichzelf en de eigen omgeving. In <a href=\"http://www.menstis.be/uitgeverij/Levensbeschouwing\">Levensbeschouwing democratisch belicht</a> wordt die open relatie tussen de mens en de wereld rondom als ‘<em>het contactum</em>’ belicht.</p>\n<p>In <strong>Marie Heurtin</strong> staat alles in het teken van het ontstaan van dat contactum. Dat gebeurt via de beeldmetafoor van <em>het zakmes</em>. Voor Marie is het een bijzonder voorwerp. Ze voelt en ruikt het. Tegelijkertijd belichaamt het zakmes ook de onmogelijkheid om in contact te komen met de dingen. Ze weet niet wat het zakmes precies is, wat het betekent en hoe ze het kan gebruiken. Dat verandert wanneer ze onder leiding van zuster Marguerite leert eten met mes en vork. Van zodra dat lukt, neemt zuster Marguerite dit succes als opstap om de link te leggen met het zakmes. Ze brengt Marie het eerste teken van de gebarentaal bij: <em>twee vingers die over elkaar bewegen</em>. ‘Couteau’! Dat herhaalt ze honderden keren na elkaar, uren lang. Ze houdt Marie aan de tafel, ook al is het tijd om te gaan slapen. Ze houdt vol. Plots breekt het inzicht door bij Marie. Ze legt voor het eerst een verband tussen het zakmes en het teken van de gebarentaal. Zuster Marguerite omhelst Marie, beiden lachen. De geest, de ‘<em>mind</em>’, van Marie is ontwaakt, acht maanden na haar aankomst in het instituut. Van dat moment af, leert ze heel erg snel. Dat komt omdat ze de moeilijke grens naar het contactum heeft overgestoken. Ze begint te begrijpen dat ze in contact staat met dingen die een naam en een betekenis hebben. Ze leert wat leren is. Voorheen kende ze aangename momenten van verwondering: de ontdekking van het stromende water van de rivier, de zachte, warme huid van de koe. Op die momenten kon het contact echter niet doordringen tot haar omdat haar geest <em>volkomen afgesloten</em> was, ook en vooral voor het contact met zichzelf.</p>\n<p>Met het eerste gebaarteken ‘mes’ verwerft ze een sleutel waarmee ze <em>toegang</em> krijgt tot haar eigen geest en via haar geest opent zich <em>het contact met de werkelijkheid</em> rondom haar. De film belicht dat wonderlijk gebeuren door de mentale ontwikkeling van Marie helemaal in het teken van <em>de levensboom</em> te plaatsen. In de boom zoekt ze veiligheid bij haar aankomst in het instituut en daar vindt ze op het einde opnieuw een houvast. Zo blijkt dat <em>de geboorte van de geest voor Marie en bij uitbreiding voor iedere mens</em> de deur opent van <em>de werkelijkheid van het leven</em>. Aan die werkelijkheid krijgt ieder mens als pasgeborene deel zonder het te beseffen. In de slotsequentie, bij het graf van zuster Marguerite, spreekt Marie in gebarentaal tot de zuster in de hemel. Ze eert haar als haar <em>tweede moeder</em>, zij die haar het leven als unieke mens heeft geschonken. Via het mentale leven leert ze zichzelf zien in relatie tot alles wat tot het leven behoort, ook het sterven. Ze zegt: ‘<em>Ik denk de hele dag aan jou, ’s morgens als ik wakker word, ’s avonds als ik slapen ga. Wanneer ik nieuwe dingen leer, denk ik aan jou.</em>’</p>\n<p>Er komt een zeer krachtig tafereel voor in de film. Die staat helemaal in het teken van <em>de ontmoeting van Marie met haar ouders</em> in het instituut. Daar blijkt hoe dochter en ouders nu voor de allereerste keer contact met elkaar hebben. Marie heeft door het werk van zuster Marguerite contact met zichzelf gekregen, waardoor ze nu ook in contact kan treden met haar ouders, met wie ze altijd heeft geleefd, maar die nooit heeft kunnen kennen. Dan blijkt hoe de menselijke geest tijdens dat contact, die herkenning, vervuld wordt van <em>dankbaarheid</em>. Die heeft betrekking op het besef van aanwezig te mogen zijn in het leven, een gave die een mens bij de geboorte krijgt. Aan haar ouders kan ze nu zeggen: ‘<em>Ik hou van jullie</em>’.</p>\n<p>Het wonder van de geboorte van de menselijke geest voltrekt zich in <em>het intens contact met de eigen oorsprong</em>, die via de ouders uiteindelijk leidt naar <em>het heilig mysterie van het leven zelf</em>. Juist iemand als Marie Heurtin die in zeer extreme omstandigheden moet leven, komt tot een sterker inzicht in <em>het wezen van die dankbaarheid, eigen aan het contactum</em>, dan ontelbare mensen die het leven ervaren als niets meer dan een dagelijkse gewoonte. Hun sterkste gevoel is dat van de verveling.</p>\n<p>Het gevoel van verveling is volkomen vreemd aan Marie en zuster Marguerite. Via de grote inspanningen die de zuster levert om toegang te krijgen tot Marie, krijgt ze ook meer toegang tot <em>het mysterie</em> van haar eigen menselijk wezen. Als kroongetuige van het wonder van de geboorte van de geest bij Marie, treedt zuster Marguerite zelf ook opnieuw binnen in het mysterie van de menselijke geest en zo in het mysterie van het leven zelf. Ze zegt: ‘<em>Marie heeft mij zoveel gegeven. Ze heeft me een wereld leren ontdekken waarvan ik niets wist. Een wereld die je aanraakt, een wereld waarin alles wat leeft, onder de vingers vibreert.</em>’</p>\n<p>De film <strong>Marie Heurtin</strong> is voor de toeschouwer een sterk antidotum tegen de existentiële verveling, of positief geformuleerd: de film helpt de toeschouwer het wonder van de eigen menselijke geest en het contactum te herontdekken, vervuld van een gevoel van dankbaarheid.</p>\n<p><span class=\"menstis\">CHRISTELIJK LEVENSWERK.</span> Beschouwd vanuit het perspectief van het personage van zuster Marguerite, valt er een bijzonder licht op de eigen betekeniswereld van de film. Dat zij een kloosterzuster is die zich in dienst stelt van zintuiglijk gehandicapte meisjes, is niet zonder betekenis. De zorg om de nieuwe, onhandelbare Marie beschouwt ze als haar <em>roeping</em>. Die heeft een door en door <em>christelijke</em> motivatie. Tegenover haar sceptische moeder-overste spreekt zuster Marguerite zelfs over ‘<em>een openbaring</em>’ (‘<em>une révélation</em>’) die ze heeft gehad. Ze interpreteert die vervolgens als ‘een idee’, een ingeving. Dat daarin haar <em>evangelische</em> bezieling om in de voetsporen van Jezus zelf te treden, een hoofdrol speelt, staat buiten kijf. De moeder-overste wijst zuster Marguerite erop dat ze zelf een veel te zwakke gezondheid heeft: ‘Dat u nog leeft, is een wonder.’ Ze mag geen zware inspanningen doen. Dat kan haar fataal zijn. Toch zet zuster Marguerite door, ze trekt haar moeder-overste over de streep en brengt persoonlijk Marie naar het instituut. Van dan af volgt er de grote inspanning van het opvoedingswerk die haar uiteindelijk toch fataal wordt. Ze spaart haar schaarse krachten niet en die raken op. In de concrete context gezien, <em>geeft ze haar leven</em> voor de mentale geboorte van Marie.</p>\n<p>De film blijft sober over wat <em>de expliciet christelijke bezieling</em> van zuster Marguerite, op de aanwezigheid van de kloosterkleding na. Het kloosterleven zelf komt niet in beeld omdat de focus ligt op de pedagogische relatie tussen Marie en zuster Marguerite. Toch zijn er twee scènes waarin op de achtergrond iets van <em>de christelijke bezieling</em> van de zuster zichtbaar wordt. Het betreft twee momenten in scènes die zich situeren in de eetzaal. De zusters en de meisjes eten samen in stilte, terwijl tijdens het eten, zoals gebruikelijk is een klooster, iemand voorleest uit de rijke christelijke literatuur. Concreet betreft het een fragment uit de <em>Fioretti</em>, een anoniem geschrift uit de 14de eeuw, met verhalen over het leven van de heilige <em>Franciscus</em>. Het verhaal handelt over de heilige Franciscus en zijn broeder Leo, Franciscus’ grootste vertrouweling, tevens zijn secretaris en biechtvader. Ze zijn samen onderweg naar een klooster. Ze zien er uit als bedelaars en schooiers. Broeder Leo vreest dat de portier van het klooster hen omwille van hun verschijning niet zal binnenlaten. Franciscus stelt broeder Leo gerust. Hij vraagt de broeder zich niet boos te maken maar te reageren met ‘humilité’ en ‘charité’, nederigheid en naastenliefde. Terwijl de lectrice de tekst aan het lezen is, zoomt de camera in op zuster Marguerite die <em>een fysiek gevecht</em> levert met Marie aan de tafel. Ze probeert het meisje aan de tafel te houden. In de film zien we hoe de zuster zich nooit boos maakt, nooit haar geduld verliest. Ze volhardt vanuit haar nederigheid en grote naastenliefde. Hierbij verschijnen <em>die christelijke, Franciscaanse deugden</em> niet als een teken van zwakheid, maar, zo blijkt, van <em>grote kracht en inzet</em> die het onmogelijke mogelijk maken.</p>\n<p>In een ander tafereel dat zich ook in de eetzaal situeert, leest een zuster het verhaal uit de <em>Handelingen van de Apostelen, hoofdstuk 9</em>. De nadruk in de film ligt op het gegeven dat Saulus die door een verblindend licht waarin de verrezen Jezus hem verscheen, van zijn paard viel en ‘drie dagen niets zag’ (Hand. 9:9). Het fragment komt voor in de episode dat zuster Marguerite door de moeder-overste op rust is gestuurd in een sanatorium in de bergen. Marie begrijpt niet  waarom ze zuster Marguerite nergens meer vindt. Geconfronteerd met die afwezigheid en leegte, sluit Marie zich in zichzelf op. Ze weigert te eten en deel te nemen aan het dagelijkse ritme in het instituut. Gealarmeerd door een brief van zuster Raphaëlle, keert zuster Marguerite terug naar het instituut, tegen het advies van haar dokter in. Wanneer beiden elkaar terug ontmoeten, schrijft zuster Marguerite in haar dagboek: ‘‘<em>Ze is mijn vreugde. De dochter van mijn ziel. Het licht van mijn leven.</em>’ In de geest van de evangelische <a href=\"http://www.menstis.be/blog\">Bergrede</a> wijdt zuster Marguerite zich aan de geboorte van de geest van Marie. Haar christelijk werk oogt als dat van een vroedvrouw die helpt om nieuw leven te laten geboren worden. Het betreft hier een spirituele geboorte. Het christelijkelevenswerk verschijnt hier als een <em>dienstwerk</em> waarbij een mens toegang krijgt tot zijn eigen geest en daardoor tot het heilig wonder zelf van het leven.</p>\n<p><a name=\"CON\"></a></p>\n<h2><font color=\"#808000\"><strong>Context</strong></font></h2>\n<p>De film <strong>Marie Heurtin</strong> brengt ook ongewild een hulde aan <em>het stille, maar baanbrekende werk van de ontelbare kloosterzusters</em> in de katholieke landen van Europa in de negentiende en de eerste helft van de twintigste eeuw. Hun werk, zoals dat van de <em>Filles de la Sagesse</em>, situeede  zich in de zorgsector, de medische inbegrepen, en het onderwijs. Daarbij hebben ze, los van theologische en ideologische discussies en debatten, gekozen voor de concrete, kwetsbare mensen, de kinderen en de jeugd, in het bijzonder de meisjes. In de tweede helft van de negentiende eeuw was <em>vrouwenemancipatie</em> geen punt op de agenda van zowel de klerikale Kerk als op die van de burgerlijke maatschappij. Die burgerlijke maatschappij was zich op dat ogenblik aan het verliezen in het cultiveren van nationalistische gevoelens, de noodlottige kiemen voor de komende Wereldoorlogen.</p>\n<p><a name=\"LIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Links</strong></font></h2>\n<p><a href=\"https://www.facebook.com/MarieHeurtin.lefilm\">Hier</a> vind je de Franse Faceboek pagina van <strong>Marie Heurtin</strong> met onder andere enkele videogesprekken met de regisseur en de actrices.</p>\n<p><a href=\"http://www.fdlsagesse.org/cms/article-161-FR-a-l-institution-de-larnay-un-grand-anniversaire.html\">Hier</a> vind je internationale site van de <em>Filles de la Sagesse</em>.</p>\n<p><font size=\"-2\">© Sylvain De Bleeckere, Men(S)tis, 2017</font></p>\n"}

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

	module.exports = {"title":"The Mill & the Cross","body":"<center>\n<img src=\"mc.jpg\" >\n</center>\n<p><a name=\"The Mill & the Cross\"></a></p>\n<h2><font color=\"#808000\"><strong>Klapbord</strong></font></h2>\n<p>De Pools-Zweedse film <strong>The Mill &amp; the Cross</strong> (Młyn i krzyż ) van Lech Majewski brengt één schilderij van de schilder Pieter Bruegel de Oude (1525/1530-1569) tot leven op het beeldscherm. Het gaat om De Calvarietocht van Christus, soms kortweg De kruisdraging genoemd, in het Engels <a href=\"https://commons.wikimedia.org/wiki/File:Pieter_Bruegel_d._%C3%84._007.jpg\">The Procession to Calvery</a> genoemd. Bruegel schilderde het doek in 1564. Het wordt nu dagelijks bewonderd door de bezoekers in het Weense Kunsthistorische Museum. Majewski zelf was ooit een van die vele bezoekers. Hij werd voorafgegaan door de Amerikaanse kunstcriticus en historicus Michael Francis Gibson. Hij schreef over dat ene schilderij in het Frans het boek <em>Le Portement de croix de Pierre Bruegel l’Aîné</em>, en hij vertaalde het zelf in het Engels onder de titel <em>The Mill &amp; the Cross</em> (2001). Die titel werd ook de titel van Majewski’s film. Gibson heeft Majewski zelf gevraagd om een film te maken op basis van zijn boek. De Amerikaanse auteur was immers sterk onder de indruk gekomen van Majewski’s Poolse film <em>Angelus</em> (2001), een loflied op de spirituele ervaring van het Mysterie en de poëtisch-visuele kracht van de verbeelding als antwoord op materialisme en totalitarisme. Gibson was onder de indruk van de picturale stijl van de film die hem deed denken aan de kunst van Bruegel. Majewski las het boek van Gibson over Bruegels merkwaardig schilderij <em>De Calvarietocht van Christus</em> en besloot naar het schilderij een film te maken. Hij schreef samen Gibson het scenario voor <strong>The Mill &amp; the Cross</strong>. Beide scenaristen besloten dat er maar één verhaallijn zou zijn, die van het schilderij van Bruegel. Voor de opnames kon de Poolse regisseur beroep doen op een internationale cast met de Nederlandse acteur Rutger Hauer in de rol van de schilder, de Franse actrice Charlotte Rampling in de rol van Maria, de moeder van Jezus , en de Engelse acteur Michael York. Hij vertolkt de rol van Bruegels Antwerpse bankier en mecenas van Bruegel, Nicolaas Jonghelinck, de koninklijke belastingontvanger van het toenmalige hertogdom Brabant en marktgraafschap Antwerpen, die samen één van de Zeventien Provinciën van de (Habsburgse) Nederlanden vormden. Deze Europese film kreeg zijn wereldpremière tijdens het Amerikaanse Sundance Film Festival in 2011. Over hun samenwerking schreven Gibson en Majewski een boek: <em>Bruegel. The Mill and the Cross</em>. Olszanica, BOSZ &amp; Angelus Silesius, 2010. Daarin synthetiseert en verscherpt Gibson zijn eerder verschenen analyse van Bruegels schilderij in functie van de film (p. 7-117). In het tweede deel ervan publiceert Dagmara Drzazga haar verslag van het opnameproces van de film onder de titel <em>Lech Majewski: The World According to Bruegel</em> (p. 119-197). Het boek besluit met fragmenten van het storyboard, getekend door Jerzy Orga (p. 199-218).</p>\n<p><a name=\"SYN\"></a></p>\n<h2><font color=\"#808000\"><strong>Synopsis</strong></font></h2>\n<p>Met zijn zware tekenmap onder de arm, bezoekt <em>Pieter Breugel</em> samen met zijn mecenas, de bankier <em>Nicolaas Jonghelinck</em>, een setting van een groep treurende vrouwen ergens buiten de muren van een zestiende-eeuwse, Brabantse stad. Breugel informeert Jonghelinck wat hij van plan is te schilderen. De Brabantse kunstenaar denkt aan het Bijbelse thema van de kruisweg van Jezus naar de Calvarieberg. De schilder licht verschillende taferelen toe die hij wenst in beeld te brengen. Dat geldt eerst en vooral <em>de groep van de drie wenende, heilige vrouwen</em>: Maria, moeder van Jezus, Maria-Magdalena en een derde vrouw. Vervolgens spreekt Breugel, tot verwondering van Nicolaas, over de figuur van de molenaar en diens vrouw die hoog boven op een steile ros wonen, van waarop ze de molen beheren. Dan komen ook <em>de rode, gewapende ruiters</em> in beeld. Zij vertegenwoordigen het politieke gezag van de Spaanse koning. Ze nemen eerst een jonge man, <em>Jan</em>, gevangen. Hij is samen met zijn vrouw <em>Netje</em> onderweg naar de markt om hun kalf te verkopen. De ruiters slaan en schoppen de jonge man, binden hem vast aan een karrenwiel dat ze vervolgens op een hoge, smalle paal plaatsen. Die trekken ze met koorden recht. Ze leveren de bebloede jonge man over aan de kraaien, de lijkenpikkers. Netje blijft verweesd achter, in haar machteloosheid wenend onderaan de paal. De tweede gevangene is <em>Jezus</em>. Hij moet, in tegenstelling met Jan, een zwaar kruis dragen, van de stad naar de nabijgelegen heuvel. Na te zijn geslagen en met een doornen kroon te zijn gemarteld, bezwijkt hij onderweg onder het kruishout. De gewapende ruiters verplichten een voorbijganger, <em>Simon</em>, om de veroordeelde te komen helpen diens kruis te dragen. Zijn vrouw <em>Esther</em> protesteert hevig tegen de opeising van haar echtgenoot. Ze gingen immers de tegengestelde richting van de stoet uit. Ze waren op weg naar de markt in de stad. Ondertussen bekijkt <em>de molenaar</em> van hoog boven zijn rots het gebeuren. Hij ziet hoe een grote menigte een stoet vormt richting de heuvel waar de kruisiging plaats zal vinden. Ondertussen bestudeert Breugel hoe hij het tafereel met al zijn protagonisten en figuranten in één beeld kan samenbrengen. Hij vindt inspiratie in <em>een spinnenweb</em>. Hij maakt tal van schetsen en verklaart aan zijn mecenas <em>Nicolaas</em> hoe hij de compositie opvat. Nicolaas zelf volgt ook de stoet naar de heuvel van de terechtstelling terwijl hij zich erg kritisch uitspreekt tegenover zijn vrouw <em>Saskia</em> over de toenemende terreur van de gewapende ruiters. Breugel zelf observeert en maakt voortdurend schetsen, steeds buiten in het landschap. Zijn jonge vrouw <em>Marijken</em> zorgt voor de kinderen en het huis. Ze brengt voedsel aan haar man terwijl hij buiten aan het werk is. Ondertussen observeert ook <em>Maria</em>, de moeder van Jezus, de voorbijtrekkende stoet. Ze spreekt haar verdriet en onbegrip uit over het gebeuren. Na de terechtstelling gaat ze naar het kruis toe. Daar waakt ze onder samen met Maria-Magdalena en een vriendin. De schilder merkt op dat tijdens de stoet van de dood de tijd even stilstaat. Na de terechtstelling verzamelt het volk op een plek waar geen soldaten meer zijn noch de molen te bespeuren valt. Ze vormen een kring rond een anoniem koppel dat Breugel overal heeft opgemerkt. Alle aanwezigen nemen deel aan de rondedans.</p>\n<p><a name=\"CIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Cinematografie</strong></font></h2>\n<p><span class=\"menstis\">FILMEN ALS SCHILDEREN EN VICE VERSA</span>. <strong>The Mill &amp; the Cross</strong> is het werk van een cineast die schildert. Majewski identificeert zich met de schilder, wat impliceert dat hij Bruegel als zijnsgelijke beschouwt. Cinematograaf Majewski schildert en kunstschilder Bruegel regisseert. Dat blijkt uit de openingssequentie. Het personage van de schilder stapt samen met dat van Nicolaas Jonghelinck het beeld in. Met zijn schetsboek in de hand, stapt hij naar de filmset waar <em>de groep van de heilige vrouwen</em> hun plaats hebben ingenomen, terwijl de overige personages en figuranten zich stil houden tot het woord van de regisseur ‘action’ weerklinkt. Bruegel wil eerst de groep van de heilige vrouwen controleren, hij herschikt even de plooien van hun gewaden. Nicolaas zegt wat hij meent te zien: ‘<em>Zo. Dit kan een groep van heiligen zijn die uit het verleden terugkeren om te wenen over het huidige lot van Vlaanderen</em>.’ Bruegel bevestigt en voegt eraan toe: ‘<em>Als het schilderij klaar is, mag jij het hebben als je wilt</em>.’ De proloog van de groep met de heilige, wenende vrouwen en de intro van Bruegel en Jonghelinck bevinden zich tussen het eerste en tweede deel van <em>de generiek</em>. Hiermee introduceert Majewski bij de toeschouwer wat er zal gebeuren. De film wil het ene schilderij van Bruegel, <em>De Calvarietocht van Christus</em>, voorstellen als een geschilderde film. Bruegel verschijnt als de zestiende-eeuwse cineast die hele setting heeft klaar gezet voor de opname, terwijl Jonghelinck optreedt als de producent die over de schouder van de cineast-schilder meekijkt. Bruegel gebruikt zijn schetsmap zoals een regisseur de cameralens aanwendt om definitief het kader van het beeld vast te leggen, waarna hij ‘action’ roept. Majewski wil laten zien hoe Bruegel te werk is gegaan. Hij wil het schilderij cinematografisch tot leven brengen met het hoofdpersonage Bruegel als gids. Dat alles mondt uit in de epiloog. Daarin toont Majewski het originele schilderij zelf. Het hangt nu in een van de zalen van het Weense Kunsthistorisch Museum. Via een uitzoombeweging toont Majewski waar het schilderij zich precies in het gebouw bevindt. Hiermee neemt hij op het einde de positie in van de museumbezoeker. Na meer dan 92 minuten mentaal het schilderij zelf schouwend te zijn binnengestapt, verlaat de cineast het schilderij om zijn weg in het museum te vervolgen. Om die intense beschouwing te kunnen realiseren, heeft Majewski drie jaar nodig gehad. Hij heeft immers_een heel eigen cinematografische beeldruimte_ ontwikkeld. Daarbij heeft hij gebruik gemaakt van alle beeldende middelen zoals ook Bruegel alle beschikbare middelen van zijn tijd heeft gebruikt. Majewksi is er inderdaad in geslaagd om de hedendaagse toeschouwer mee te nemen in de eigen beeldruimte van het schilderij. Aldus betreedt de toeschouwer het schilderij op een manier waarop hij het in het museum nooit kan zien en beleven. In het museum wordt de bezoeker-toeschouwer overigens op een veilige afstand gehouden. Bruegels schilderij in kwestie bevat honderden details. Het is onmogelijk om in het museum zo dicht bij het schilderij te komen om die details te kunnen waarnemen en exploreren. Daarom reconstrueerde Majewski Bruegels doek in de tijdelijke filmstudio gebouwd in het <em>Katowice International Trade Fair Center</em> en de postproductiekamer van de <em>Odeon Film Studio</em> in Warschau (Drzazga, o.c., 147, 176). Majewski’s grote uitdaging bestond erin het tweedimensionale schilderij van Bruegel te transponeren naar het eveneens tweedimensionale beeldscherm waarop het doek driedimensionaal tot leven komt. Daartoe maakte hij op drie verschillende wijzen digitale opnames met een Amerikaanse <em>RED digital camera met een 4K resolutie</em> (idem, 150). De opnames van de acteurs gebeurden voor een blauw scherm in de filmstudio. Daarnaast werden er opnames gemaakt van de acteurs op buitenlocaties in de pittoreske rotsformaties van de Kraków-Częstochowa Juraketen met zijn ruïnes van middeleeuwse kastelen, onder andere de kasteelruïne van Olsztyn (idem, 126-129), in Tsjechië en in Wenen. In Nieuw-Zeeland filmde Majewski samen met John Crisstoffels een reeks van unieke licht- en wolkencomposities (Idem, 173). Voor de opnames met de acteurs werkte Majewski samen met zijn vaste cameraman Norbert Rudzik die ook instond voor de speciale effecten. De derde soort opnames bestonden uit beelden van een grote tweedimensionale achtergrond (‘backdrop’). Die bestond uit het schilderij van Bruegel dat Majewski zelf op een zeer groot doek heeft nageschilderd. Al die digitale opnames moesten tijdens de postproductie laag per laag op elkaar worden gelegd en tot één beeld worden samengevoegd. Majewski noemt het een ‘<em>elektronische alchemie</em>’ (Idem, 150). Hij moest daartoe creatief gebruik maken van de nieuwe ontwikkelingen in de technologie van de computer graphics (CG), ook soms computer-generated imagery (CGI) genoemd. Op die manier kon Majewski op het beeldscherm het schilderij van Bruegel met een 3D-effect laten verschijnen.</p>\n<p><span class=\"menstis\">SOUNDSCAPE</span>. Een schilderij als <em>De Calvarietocht van Christus</em> is pure stilte. Het geeft geen klank, het is louter visueel. Dat is niet de bedoeling. Bruegel zou maar al te graag hebben kunnen beschikken over middelen om zijn beeld te doen spreken. De huidige cinematograaf zoals Majewski beschikt over de mogelijkheden om het schilderij een eigen soundscape te geven. Majewski transponeert Bruegels doek in de cinematografische modus van bewegend beeld en klank. In zijn filmische transcriptie gaat Majewski niet zijn eigen weg. Hij blijft trouw aan de geest van Bruegels meesterwerk. Dat uit zich in de vele stille taferelen. Dat geldt bij uitstek voor <em>de stilte-sequentie</em>. Wanneer Jezus bezwijkt onder het kruis, legt Majewski alles het zwijgen op. Een korte klaagzang van de vrouwen geeft nog diepgang aan die stilte. De klanksfeer van de film is in hoofdzaak een compositie van natuurlijke geluiden: vogels hoorbaar in het bos, krijsende kraaien, de wind. Daarnaast contrasteert Majewksi die muziek van de landschappelijke omgeving met de geluiden die hun oorsprong vinden in de stad van de mens. De cineast versterkt die klanken zodat ze aan het schilderij een heel eigen stem geven. Dat gebeurt al in het begin van de film, met name in de sequenties waarmee de cineast de rode ruiters introduceert. <em>Het aankomende paardengetrappel</em> rolt als een donder vanuit de mist het beeld in. Het kondigt de harde terreur aan waarmee de huurlingen van de Spaanse koning het volk onderwerpen. Behalve het klankmotief van het paardengetrappel, componeert Majewski en zijn geluidsteam ook dat van <em>draaiende raderen en wieken van de molen</em>. De monumentale molenraderen kraken wanneer de wind ze via de wieken in beweging zet. Het paardengetrappel en de molenraderen vormen de eigen partituur van de film. Ook de klank die de menselijke beweging voortbrengt, krijgt een versterkt accent. De klompen van de molenaar, zijn vrouw en hun knecht op de plankenvloer van hun verblijf in de molen, het kappen van de boom in het bos, het spelen van de kinderen.</p>\n<p>Majewski verrijkt de partituur van de film met <em>twee korte, maar betekenisvolle muziekcomposities</em> van hemzelf en de veelzijdige Poolse muzikant Jozef Skrzek. De eerste compositie vertolkt <em>een zachte, eerder kinderlijk blijde stemming op de tonen van een elektronische piano</em>, bespeeld door Skrzek. Majewski koppelt die muziek aan de eerste verschijning van Bruegel op de set in het middenstuk van de proloog. En bij de eindgeneriek met de namen van wie betrokken zijn geweest bij het productieproces, weerklinkt dezelfde muziek. Het doet de toeschouwer van de film uitgeleide. De tweede korte compositie van Majewski en Skrzek hoort als <em>een erg korte, maar pregnante klaagzang van vrouwenstemmen</em>. Die weerklinkt enkel op de klankband en duurt maar enkele seconden. Dat muzikaal leidmotief komt <em>drie keren</em> voor, verspreid over de hele film. De regisseur introduceert het in de proloog bij het tweede deel van de generiek met de namen van de acteurs, de regisseur en de filmtitel. De tweede keer verschijnt de treurzang bij het tafereel met het lijk van de gemartelde Jan, liggend op de grond aan de voet van de boom met het karrenwiel waarop de rode ruiters Jan hadden vastgebonden, terwijl zijn jonge vrouw Netje hem beweent. Op het ogenblik dat de grafdelver het lijk komt weghalen, zet de muziek in. De derde keer monteert Majewski de muziek bij de eerder genoemde stilte-sequentie. Wanneer de camera die van rechts naar links beweegt, ter hoogte van de neergevallen Jezus onder het kruis komt, weerklinkt opnieuw het vrouwelijke lamento. Majewski vult dit muzikale leidmotief op het einde van de film nog aan met twee zeer korte muzikale citaten. Bedoeld zijn, <em>het Miserere, Opus 44</em> ― het fragment <em>XI Miserere Nobis</em> ―van de hedendaagse Poolse componist Henryk Górecki (1933-2010) en het <em>Miserere Mei</em> van de Venetiaanse barokcomponist Antonio Lotti (1667-1740). Het eerste weerklinkt heel even bij het tafereel met de grot waarin de voeten van de overleden Jezus nog zichtbaar zijn. In de buurt staat een oudere burger van de stad mediterend voor zich uit te staren. Het <em>Miserere Nobis</em> begeleidt die beelden tot aan het beeld met Judas die zichzelf aan de galg ombrengt. Helemaal op het einde, met name bij de overgang van het gefilmde schilderij naar het echte doek in het museum, de epiloog van de film, vertrekt Majewski van de groep van de bedroefde, heilige vrouwen en zoomt dan uit. Bij het beginbeeld, de close-up van de groep, weerklinkt het <em>Miserere Mei</em> van Lotti. Hij mixt het heel even met de volksmuziek uit het laatste gefilmde tafereel, om dan de klankband te laten overgaan in stilte.</p>\n<p><em>De volksmuziek</em> in de film komt ook letterlijk in beeld en refereert naar de oude volksmuziek in het toenmalige Brabant en Vlaanderen. <em>De dansmuziek met fluiten, doedelzak en trom</em> staat centraal in het slottafereel van de film. Een groep van koppels uit alle standen van de samenleving dansen vrij en blij in het rond op een groen begroeide heuvel. De spelende muziekkanten dansen mee. In het begin vormt de groep een cirkel rond het koppel dat zich in de loop van de film heeft gevormd. De fluitspeler is de muzikale getuige van de vorming van het koppel langs de weg naar de markt. In de scène die voorafgaat aan de eindsequentie met de rondedans komt eerst een kort tafereel voor. Het toont voor de laatste keer Bruegel die thuis leunend tegen de houten binnenwand van het huis, met zijn vinger tekent in de lucht. Achter hem zien we door het open raam een trio dat danst: de fluitspeler, een burger en een boer. Hun kleine rondedans introduceert de grote rondedans waarmee de film eindigt en waarna de proloog in het museum volgt. Opmerkelijk is dat de grote rondedans geleidelijk overgaat in een dans van koppels die zich vrij naast elkaar bewegen en die dus de initiële cirkel hebben verbroken.</p>\n<p>Tot de eigen soundscape van <strong>The Mill &amp; the Cross</strong> hoort ook <em>de menselijke stem</em>. Er komen tien momenten voor waarin personages spreken. Dat gebeurt meestal in voice-over. Bruegel, Nicolaas Jonghelinck en de oudere Maria spreken hun gedachten uit voor zichzelf (Maria, Bruegel) of voor anderen (Bruegel, Nicolaas Jonghelinck). Reeds in de proloog licht Bruegel aan zijn mecenas zijn schetsen toe die hij maakt ter voorbereiding van het schilderij over de kruisweg van Jezus naar Golgotha. In de loop van de film zetten zich die gesprekken voort. Bruegel verduidelijkt aan Nicolaas zijn werkwijze en de opbouw van het tafereel dat hij wil schilderen. Daarnaast vertolkt Maria haar gedachten bij het zien van de kruisgang van haar zoon. Nicolaas Jonghelinck is ook een kroongetuige van het gebeuren. In zijn burgerwoning in de stad laat hij zich, binnenskamers tegenover zijn gemalin, erg kritisch uit over <em>de Spaanse terreur tegenover de lokale bevolking</em>. Maria krijgt het laatste woord. Haar derde beschouwing handelt over de kruisiging van haar zoon. Na haar woorden volgt het tafereel van de kruisafname – de kruisiging zelf wordt niet in beeld gebracht. Van dan af zwijgt de menselijke stem.</p>\n<p><span class=\"menstis\">CINEMATOGRAFISCHE CIRKELBEWEGINGEN.</span>. Wat de opbouw van <strong>The Mill &amp; the Cross</strong> betreft, springen <em>de cirkelbewegingen</em> in het oog. In de literaire en beeldende tweedimensionale kunsten is het moeilijk om een cirkelbeweging in de opbouw uit te drukken. Toch hebben door de eeuwen heen schrijvers en schilders een creatieve oplossing gevonden via de narratieve techniek van <em>de inclusie</em>. Die verdicht zich in het schema A B A’. In de literatuur noemt men die inclusie ook wel sandwich-structuur. De anonieme auteur van het Evangelie van Marcus heeft daar handig gebruik van gemaakt. In de schilderkunst vertaalt zich dat in de vorm van de triptiek, intens gebruikt door de grote Vlaamse Primitieven.</p>\n<p>Majewski bespeelt in <strong>The Mill &amp; the Cross</strong> op zijn persoonlijke manier <em>de techniek van inclusie</em> om de cirkelbeweging te accentueren. Dat doet hij voor de hele structuur van de film en voor afzonderlijke onderdelen in de film. Vooreerst <em>de hele structuur</em> van de film. Majewski bouwt de grote structuur op <em>het tafereel met de groep van de heilige vrouwen</em>. Hij introduceert dit in de proloog en hij brengt het beeld van die groep, via een close-up van het echte schilderij, terug in beeld als begin van de epiloog in het Weense museum. Met het tafereel met de heilige vrouwen beschrijft de regisseur een inclusie, het fundament van de grote structuur. De inclusie omsluit de hele film die het verhaal vertelt van het ontstaan van het doek De Calvarietocht van Christus. Met de proloog introduceert de cineast al de cinematografische cirkelbeweging. Dat gebeurt via de beeldende inclusie van de generiek.  Die kent twee delen met daartussen het beeldend deel met de groep van de heilige vrouwen. In dat tussendeel van de triptiek ontstaat er een nieuwe, kleine cinematografische cirkelbeweging. De camera toont eerst de heilige vrouwen die op de voorgrond van de set plaatsnemen, terwijl de overige personages en figuranten al klaar staan en wachten op het fiat van de regisseur om te gaan bewegen. Dan tekent de regisseur met de camera een inclusie met de personages van de schilder en zijn mecenas als ankerpunten. Wanneer de camera voor de eerste keer aan de rechterzijde van het tafereel komt, stappen de personages van Bruegel en Jonghelinck in het kader van het beeld. Ze bewegen van rechts naar links, de camera volgt hen. Bruegel maakt vlug een schets en stapt dan in het midden op de lage rots naar de groep van de heilige vrouwen toe. De schilder legt zijn map even neer en schikt de plooien van de gewaden. Dan keert hij terug naar Jonghelinck die Bruegel zijn schetsmap aanreikt. Ze stappen dan samen terug naar de rechterzijde van het beeld. Wanneer ze uit de beeldkader verdwijnen, eindigt het middenluik van de proloog. Op diezelfde manier componeert de regisseur ook binnen het grote middenluik ― het ontstaan van de schilderij vanuit de observaties en schetsen van Bruegel ― nog verschillende cinematografische cirkels. Dat is bijvoorbeeld het geval met de sequentiereeks die zich situeert in het huis van Bruegel. De jonge moeder, de vrouw van Bruegel, en de kinderen komen in beeld. De sequentiereeks opent met de jonge moeder die het huis binnenkomt. Dat gebeurt via een deurschot. De camera staat binnen, gericht naar de open deur. De moeder komt binnen. Door de open deur ziet de camera in de verte de draaiende molen. De sequentiereeks eindigt opnieuw met een shot van de open deur waardoor nu de kinderen, op vraag van de moeder, naar buiten lopen. Ook de belangrijke stilte-sequentie, opgebouwd rond Jezus’ val onder het kruis, vormt een cirkelbeweging via de inclusie met de molen. Ze opent immers met het beeld van de molenwieken die plots ophouden te draaien en ze eindigt wanneer diezelfde molenwieken opnieuw beginnen te bewegen. Naar het einde toe van de film volgt nog een cinematografische cirkelbeweging met de danssequentie. Aan het begin staat de sequentie met Bruegel in zijn huis, leunend tegen de houten muur, tekenend met zijn vinger in de lucht. Door het raam naast Bruegel filmt de camera een rondedans van de fluitspeler, de burger en de boer. Dit beeld introduceert het einde van film. Die staat in het teken van de grote rondedans.</p>\n<p>Behalve de cinematografische cirkelbeweging via de beeldinclusie, bouwt Majewski het eigen filmverhaal ook op via <em>beelden van heel concrete cirkelbewegingen</em> van personen en dingen. De grote molen op de rots bestaat uit een samenspel van cirkelbewegingen. De molen kan draaien rond zijn as, er zijn de wieken en de raderen. Daarnaast krijgt het ronde karrenwiel als marteltuig veel beeldruimte. Voorts zijn er de dansbewegingen: personages draaien rond zowel individueel als in groep. Het slottafereel met de volksdans van de grote groep accentueert voor de laatste keer die cirkelbeweging.</p>\n<p>Majewski ontleent via de analyse van Gibson het belang van de cirkelbeweging aan <em>het schilderij van Bruegel zelf</em> (Gibson, 2000, 43-50; 2010, 23-25). Gibson ziet <em>drie cirkels</em> als basis van Bruegels compositie. Gezien vanuit de toeschouwer, bevindt zich in de linkerbovenhoek de stad met haar omwalling in cirkelvorm. In de rechterbovenhoek ziet de toeschouwer de cirkel van de kijklustigen op de heuvel waar zich de terechtstelling situeert. De volkstoeloop die zich vormt rond de drie mannen die op weg zijn naar hun kruisiging, verbindt de twee cirkels. Op dit punt forceert Gibson zijn interpretatie. De langgerekte optocht vormt geen mooi afgelijnde cirkelbeweging. Geometrisch lijkt de lijn ervan meer op een gedeeltelijke ovaal. Majewski zelf stelt Gibsons visie over de drie cirkels bij. Hij relativeert die visie door in de film via het personage van Bruegel <em>het totaalbeeld van het spinnenweb</em> te introduceren. In die optiek verschijnen de vele schetsen van Bruegel als de bestanddelen van het grafische spinrag waaruit hij gestaag de compositie van zijn schilderij laat groeien. In tegenstelling tot Gibsons geometrische analyse, oogt het schilderij veeleer als een bewuste disruptie van de cirkelfiguur. Het beeld bestaat uit een myriade van circa 500 verschillende menselijke figuren plus nog de talrijke dieren, planten en dingen (rotsen, water, bomen, vogels, paarden, een kalf en een lam, een paardenschedel, karren, galgen, distels, enzovoort). Bruegel wil met opzet de blik van de toeschouwer desoriënteren. Dat heeft alles te maken met de creatie van de eigen en unieke betekeniswereld van het doek, waarin zich ook Majewski beweegt. In de creatie van die eigen betekeniswereld, blijft Majewski, wat de drie cirkels van Gibson betreft, dichter bij Bruegels doek. Hij concentreert namelijk <em>de cirkelbeweging in het beeld van de molen</em>. In Bruegels schilderij trekt de molen op de rots de aandacht. Niet het beeld van de veroordeelde Jezus onder het kruis, het eigenlijke hoofdpersonage, maar het beeld van de molen domineert het blikveld van de toeschouwer. Majewski werkt de draaiende molen uit als een hoofdpersonage, helemaal in de letter en de geest van Bruegels schilderij. Tegelijkertijd laat hij de molen zien in tal van taferelen. Hierdoor verschijnt de molen in werking als een kroongetuige van het hele gebeuren.</p>\n<p><a name=\"BET\"></a></p>\n<h2><font color=\"#808000\"><strong>Betekenisruimte</strong></font></h2>\n<p><span class=\"menstis\">HET ZELFPORTRET VAN BRUEGEL.</span> Het feit dat <strong>The Mill &amp; the Cross</strong> geen Vlaamse, maar Poolse productie is, onthult dat het werk van Breugel meer dan ooit een internationale vermaardheid kent en een dito uitstraling heeft. Geen enkele productiehuis en regisseur in het Vlaanderen van vandaag blijken in staat te zijn zo een werk als <strong>The Mill &amp; the Cross</strong> te realiseren. Dat heeft veel van doen met het dominante beeld van Bruegel in het Vlaanderen van vandaag. In haar recente biografie over Pieter Bruegel legt de Vlaamse kunsthistorica Leen Huet de vinger op de wonde (Leen Huet, <em>Pieter Bruegel. De biografie</em>. Kalmthout, Polis, 2016). Ze beschouwt alle gekende prenten en de doeken van de schilder als de belangrijkste historische bron om iets over hem te weten te komen. De overgeleverde historische data zijn immers erg schaars. Bruegel liet, zover bekend, geen geschreven bronnen na, alleen zijn artistiek werk vormt zijn testament. Maar <em>het publieke beeld van Bruegel dat in Vlaanderen</em> dominant geworden is, staat de kennismaking met de schilder en zijn werk pas echt in de weg. Dat publieke beeld is dat van ‘<em>de boeren Bruegel</em>’, ook ‘<em>Pier den Drol</em>’ genoemd. Dat beeld is relatief recent en is het resultaat van de herontdekking van Bruegel in de twintigste eeuw. In zijn eigen tijd waren Bruegel en zijn werk internationaal gekend en gewaardeerd: van Antwerpen en Brussel tot in Keulen en Rome. Vanaf de zeventiende eeuw werd hij vergeten om eind negentiende―begin twintigste eeuw te worden herontdekt in het Vlaanderen van het nieuwe België (Huet, o.c., 9-10, 18-22). Die herontdekking situeerde zich binnen <em>de succesrijke beweging van het nationalisme</em> in Europa, dus ook in Vlaanderen. In die optiek werd Bruegels werk in Vlaanderen voorgesteld als <em>de expressie van een eenvoudige, ietwat boerse volksaard</em>. De bewaarde schilderijen <em>Luilekkerland</em>, <em>Het bruiloftsmaal</em> en <em>De boerendans</em>, alle drie daterend van ca. 1567, dienden als bewijsvoeringen van die eenvoudige Vlaamse volksaard. Die toont zich in <em>een simpele, ietwat domme levenswijze</em> waarin men met zijn allen gezellig vet geroosterd varkensvlees en gebraden kip eet, bier drinkt, taarten en rijstpap naar binnen speelt. Traiteurs bieden tot op vandaag aan hun Vlaamse klanten een ‘breugeliaans buffet’ aan. Niemand minder dan de katholieke schrijver <em>Felix Timmermans</em> verspreidde, geïnspireerd door Breugels schilderijen vooral via zijn succesrijke volksroman <em>Pallieter</em> (1916), het beeld van de Vlaamse, breugeliaanse volksaard. Ook in zijn vele lezingen in Vlaanderen, Nederland en Duitsland verspreidde Timmermans die volkse voorstelling van Bruegel (idem, 345-346). Geïnspireerd door de grote Bruegelviering van 1924 in Brussel, publiceerde Timmermans zelfs in 1928 zijn roman <em>Pieter Bruegel zo heb ik u uit uwe werken geroken</em>. In die geest kon men in alle Vlaamse huiskamers afdrukken tegenkomen van Bruegels boerentaferelen op koekjesdozen of in kaders aan de muur. In die beeldvorming à la Timmermans ging het Vlaamse publiek ‘hun schilder’ zelf ook zien als een schilderende boer. Huet rekent anno 2016 af met die vertekende beeldvorming. Ze schrijft:</p>\n<blockquote>\n<p><em>‘Toch is het verbazingwekkend dat Timmermans zich Pieter Bruegel alleen kan voorstellen als een neurotische angsthaas. Timmermans’ Bruegel durft om zo te zeggen niets,heeft amper ideeën over kunst en sukkelt kwansuis op een volkse stijl af. Die interpretatie is moeilijk te verteren voor wie Bruegels meesterlijke schilderijen, zijn doeltreffende composities bekijkt. Zo schilderen angsthazen en mannen zonder ideeën niet.’</em> (idem, 345-346).</p>\n</blockquote>\n<p>Het grootste argument tegen dergelijk vertekende beeld van Bruegel en zijn werk, zijn de circa veertig schilderijen die van Bruegel zijn bewaard. Die vormen één groot oeuvre. Het vormt een groot en complex dubbel zelfportret: dat van de mens en intellectueel Bruegel en dat zijn eigen tijd. Bruegel behoorde tot de belangrijke groep van intellectuelen in het Antwerpen en Brussel van het toenmalige Brabant. Die intellectuelen bevorderden alles wat met de nieuwe drukpersen kon worden gemaakt: boeken en prenten. Die intellectuelen ademden <em>de toenmalige tijdgeest van het jonge humanisme</em> waarin bewondering voor de Grieks-Romeinse Oudheid gepaard ging met een verbondenheid met de christelijke religie. Tegelijkertijd waren Bruegel en zijn vrienden getuigen op de eerste rij van een tijd waarin zich in het christelijke Europa <em>de grootste geestelijke en politieke crisis</em> ooit voltrok, een crisis waarvan de gevolgen vandaag nog overal duidelijk zichtbaar zijn gebleven. Majewski heeft genoeg aan één schilderij van Bruegel om dat beeld van Bruegel en zijn tijd te begrijpen. Alleen via de methode van het beeldend denken kan iemand tot dergelijk inzicht komen, uitgedrukt in <strong>The Mill &amp; the Cross</strong>.</p>\n<p><span class=\"menstis\">HET BEELDEND DENKEN EIGEN AAN HET TOESCHOUWERSCHAP</span>. Bij de presentatie van de film aan de pers in 2011 schreef Majewski in de persmap: <em>‘Bruegel was, and still is, the wisest philosopher among te painters.</em> Gibson noemt Bruegel <em>‘a true philosopher-painter’</em> (2000, 90) en Huet geeft hem de titel van <em>‘wijsgerige waarnemer’</em> (o.c., 252). Dat inzicht is niet nieuw. In zijn boek herinnert Gibson bijvoorbeeld aan de eulogie die Breugels beste vriend en officiële kosmograaf van koning Filips II, Abraham Ortelius uit Antwerpen, in het Latijn uitsprak vier jaar na Bruegels overlijden (Gibson, 2010, 13). Letterlijk zei hij: ‘<em>In omnibus eius operibus intelligitur plus semper quam pingitur</em>’. Het Latijnse ‘<em>pingo</em>’ betekent letterlijk ‘<em>een kleur of een tint aanbrengen, decoreren of opfleuren</em>’. Ortel bedoelt hier dus het letterlijke schilderwerk, dat wat op het doek is aangebracht in tinten en kleuren. Eenvoudig uitgedrukt: bij Bruegel is een schilderij meer dan een geschilderd paneel dat als decoratief meubilair in een salon aan de muur wordt gehangen. Bruegels werk reikt altijd verder dan wat letterlijk is geschilderd. Het opent een gedachtewereld (‘<em>intelligitur</em>’). Kortom: Bruegel is een beeldende denker pur sang.</p>\n<p>Majewski voert in <strong>The Mill &amp; the Cross</strong> Bruegel op als personage. Dat verantwoordt hij vanuit het schilderij zelf. Hij vertrekt van de figuur die helemaal beneden in de rechterhoek aan de boom aandachtig staat toe te kijken. In de proloog duidt Majewksi die figuur als een zelfportret van Bruegel (Gibson, 2010, 101-102). Hij wekt die in de film tot leven via de acteur Rutger Hauer. Uit de sequenties met het hoofdpersonage zien we Bruegel als een zeer aandachtige en geconcentreerde getuige van wat er zich rondom hem afspeelt. Hij staat niet zomaar aan de kant toe te kijken. Hij observeert alles erg nauwkeurig. Hij schrijft zijn observaties niet op in een tekst. Historisch weten we dat Bruegel geen tekstschrijver was, ofschoon hij <em>als humanist van de zestiende eeuw</em> een zeer belezen iemand was. Hij schrijft niet, hij tekent en schildert. Hij draagt altijd een grote, lederen map bij zich. Die gebruikt hij als onderlegger voor de schetsen die hij in situ maakt. We zien hem nooit aan het werk in een kunstenaarsatelier met een schildersezel. De natuur en de buitenwereld vormen de contouren van zijn atelier. We zien hem terwijl hij nauwgezet een spin aan het werk observeert en op een dag schets hij vanop een heuvel het landschap, terwijl zijn jonge vrouw met de baby zijn eten brengt. Op het einde van de film zien we hem voor één keer bij hem thuis. Hij zit neer en hij tekent met zijn vinger in de lucht. Als personage in de film licht Bruegel mondeling zijn schetsen toe. Majewski laat hiermee zien hoe Bruegel zelf zeer intens nadacht over wat hij wilde schilderen en hoe hij het in beeld wilde brengen. Hij schilderde niet zomaar om te schilderen of louter om de brode. Zijn_ observerende levenshouding_ kende geen passiviteit. Zijn zien met de ogen en de hand was een <em>‘wijze’ wijze van zien</em>. Huet drukt het zo uit: Het is ‘<em>een oefening in aandacht en verwondering</em>’ (o.c., 351). In diezelfde lijn noteer ze naar aanleiding van Bruegels schilderijen <em>Dulle Griet, De val van de opstandige engelen, De triomf van de dood</em> en de prent <em>De afdaling van Christus in het voorgeborchte</em> hoe Bruegel omging met <em>de in zijn tijd erg gangbare christelijke verzoeningsleer</em>. Die verkondigde triomfantelijk de overwinning op de dood door Christus. Bruegel hoorde die ontelbare keren verkondigen, niet alleen door theologen en clerici, maar ook door populaire dichters die in zijn tijd actief waren in <em>de rederijkerskamers</em>. Huet, doelend op Bruegel, stelt vast:</p>\n<blockquote>\n<p>‘<em>Een schilder in het publiek begon blijkbaar na te denken over die afgesloten clichés en besloot al schilderend een onderzoek in te stellen.</em>’ (p. 219)</p>\n</blockquote>\n<p>In <strong>The Mill &amp; the Cross</strong> zien we Bruegel nadenkend observeren, via schetsen noteren en op het schildersdoek componeren. <em>Zijn intens beeldend denken</em> blijkt inderdaad uit zijn grote zorg voor de compositie die echter niet op zich staat, maar die hij in één beweging verbindt met <em>de creatie van beeld- en klankmetaforen</em>. Die componeert hij met elementen uit de werkelijkheid die hij heeft geregistreerd. Dat geldt voor de hemel met het heldere licht aan de linkerzijde en de dreigende donkerte aan de rechterzijde. Andere bepalende beeldmetaforen zijn: <em>de rots met de molen, en de boom van het leven en die van de dood</em>. Ze vormen beide het linker- en rechterkader van het schilderij. Maar ook met de personages schept hij krachtige metaforen. Dat geldt voor <em>de groep van de heilige vrouwen</em> op de voorgrond, <em>de ruiters in het rood</em> en, niet in het minst, <em>de Figuur onder het kruis</em>. Door zijn unieke wijze van werken als beeldend denker realiseert hij in alle opzichten een beeld waarin hij de toeschouwer ervan zelf mee betrekt. Met andere woorden, niet alleen Bruegel zelf gaat te werk als beeldend denker, ook brengt hij bewust de toeschouwer ook in de positie van beeldend denker.</p>\n<p>Een essentieel aspect van Bruegels beeldend denken is de grote waarde van <a href=\"http://www.menstis.be/uitgeverij/Levensbeschouwing/\">het toeschouwerschap</a>. Majewski laat zeer goed zien hoe Bruegel zelf dat toeschouwerschap actief beoefent. Van alle personages stelt Bruegel zich bewust op in de positie van <em>de aandachtige getuige die schouwend het gebeuren en alle betrokkenen in zich opneemt</em>. Hij maakt geen deel uit van het drama dat de machthebbers in gang hebben gezet. Evenmin stelt hij zich op bij <em>de kijklustigen</em> voor wie het gebeuren van de drievoudige kruisgang niets meer is dan een sensationeel intermezzo in hun dagelijks bestaan. Hij voegt zich ook niet <em>bij hen die zich afwenden</em> van de opvoering van geweld en lijden om hun weg naar de markt in de stad te vervolgen. Toeschouwer Bruegel wil <em>het geheel</em> overzien. Bovendien wil hij <em>alle details</em> die dat geheel voortbrengen in kaart brengen. <em>Zijn intense schouwende betrokkenheid</em> is uniek. Niemand is op die manier betrokken bij wat er zich afspeelt. Bruegel is de enige die als doel heeft de betekenis van de dramatische kruisgang te registreren. En dat is geen passieve, afstandelijke activiteit. Bruegel gaat op zoek naar wat <em>de draagwijdte</em> is van wat zich aan het afspelen is. Schouwen, dé activiteit bij uitstek van het toeschouwerschap, wordt bij Bruegel <em>een bron van creatief denken in beeld</em>. Die unieke praxis ligt aan de grondslag van Bruegels beeldend werk. Het oogt als het werk van <em>een panoramische miniaturist</em>. Dat geldt bij uitstek voor <em>De Calvarietocht van Christus</em>.\nBruegels toeschouwerschap bepaalt ook de verschijning van het werk naar de beschouwer ervan. Die beschouwer is vandaag de museumbezoeker in Wenen. Majewski is ooit die beschouwer geweest. Hij is figuurlijk drie jaar blijven staan voor het schilderij met <strong>The Mill &amp; the Cross</strong> als resultaat. Dat leert dat Bruegel niet bezig was met het werken <em>binnen een bepaalde stijl of schoonheidscanon</em>. Wat primeert, is niet de verschijning, het uitzicht, maar <em>de expressie van de betekenis van wat zich in de werkelijkheid voordoet</em>. Daarom hield hij eerst en vooral rekening met de overdracht van die betekenis naar de toeschouwer ervan. In het schilderij zelf werkt Bruegel met <em>de verdubbeling van de toeschouwer</em> die hij zelf is via het personage van de marktventer, vooraan zittend op de lage rots. Diens positie is een verdubbeling van de positie van de schilder, de eerste toeschouwer. Terecht besteedt ook Majewski in de loop van de film aandacht aan het personage van de marktventer. Voorts zijn nog andere personages in wiens positie zich de toeschouwer van het schilderij kan herkennen. Dat geldt voor de twee mannen in de rechterbenedenhoek van het schilderij. Majewski vergroot die uit in de filmpersonages van Bruegel en Jonghelinck. Vreemd genoeg definieert Bruegel nog <em>de actieve positie van de toeschouwer</em> van het schilderij via de belangrijke groep van de heilige vrouwen. Zij keren hun rug naar het drama en keren zich naar de toeschouwer die zich voor het doek bevindt. Zij openen voor de toeschouwer de deur van zijn blikveld. Ze leiden hem binnen in <em>de betekenisruimte van het tafereel</em>. Dat heeft Majewski goed begrepen want hij leidt op zijn beurt de filmtoeschouwer binnen in de betekenisruimte van de film <em>via de proloog</em> met de groep van de heilige vrouwen. En ook de uitgeleide van de film gebeurt via datzelfde tafereel. Een laatste aspect van Bruegels kunst van het toeschouwerschap betreft <em>het zoekperspectief</em>. Dat impliceert dat de toeschouwer het geheel met al zijn visuele data nooit in één oogopslag kan waarnemen. Er bevindt zich in het schilderij geen visueel brandpunt waarrond zich alles ordent. Dat gegeven krijgt nog versterking via <em>het gebruik van de narratieve schaduw</em>. Het eigenlijke hoofdpersonage Jezus Christus bezet niet de narratieve scène. Dat komt omdat Bruegel ervoor opteert om de figuur van Jezus te schilderen liggend op de grond onder het kruis. Lager kan Jezus niet liggen. Bovendien ligt Jezus onder het kruis als verloren tussen de menigte. De toeschouwer moet bewust naar Hem op zoek gaan. Voor Bruegel is dat een visueel teken van het inzicht dat <em>de zoektocht naar de betekenis van het gebeuren</em> zich moet begeven voorbij de veel verspreide voorstellingen van het gebeuren in prenten, schilderijen en taferelen van het Bijbelse passieverhaal in kerken (brandglasramen, basreliëfs, muurschilderingen of beschilderde planken of doeken). Bruegel haalt de christelijke toeschouwer uit zijn <em>vertrouwde voorstelling van Jezus’ Passie</em>. Vanuit die gekende voorstelling zoekt de toeschouwer naar Jezus aan het kruis. Hij kan die echter niet vinden. Ook in <strong>The Mill &amp; the Cross</strong> komt geen scène met de eigenlijke kruisiging voor. In de lijn van Bruegel legt Majewski het narratieve accent op Jezus die neerligt onder het kruishout. <em>De stiltesequentie</em> vormt daarvan het filmische hoofdaccent. Het is de filmische vertaling van <em>de narratieve schaduw</em> waarin Bruegel zelf het hoofdpersonage heeft geplaatst. Hiermee vraagt Bruegel zijn toeschouwer het vertrouwde vanuit een nieuw blikveld te bekijken. Kortom, bij Bruegel is de toeschouwer aan zet. Majewski heeft dat goed begrepen.</p>\n<p><span class=\"menstis\">BEELD IN DE REGIE VAN HET LEVEN</span>. Het toeschouwerschap bestaat enkel bij de gratie van het beeld. Als volwaardige beeldend denker had Bruegel een uitgesproken visie op de waarde van het beeld als <em>het vormend medium bij uitstek voor het toeschouwerschap van de mens</em>. Met <em>De Calvarietocht van Christus</em> geeft Bruegel een krachtige vertolking van zijn constructieve visie op het beeld. Die zit diep verworteld in zijn verwerking van wat zich afspeelde in de bewogen tijd waarin hij leefde en werkte. Bruegels visie plaatst de waarde van het beeld tussen <em>het stilisme</em> en <em>het negativisme</em>.</p>\n<p>Aan de ene kant van het beeld staat <em>het stilisme</em>. Dat betekent dat het beeld wordt opgesloten in een stijlcanon, meestal aangeduid via een –isme, zoals bijvoorbeeld het classicisme. In <strong>The Mill &amp; the Cross</strong> introduceert Majewski via het tafereel van heilige vrouwen het fenomeen van het stilisme. In Bruegels doek staat het tafereel op de voorgrond. Hij schildert het als <em>een visueel citaat</em>. Bruegel toont de groep met de treurende vrouwen helemaal in de gekende en geprezen stijl van <em>de Vlaamse Primitieven</em>, in het bijzonder van Jan van Eyck en Rogier van der Weyden. Zij ontpopten zich in de vijftiende eeuw als de ware grootmeesters in <em>de techniek van geplooide gewaden</em>. Die vaardigheid maakte deel uit van <em>hun geniaal vakmanschap in de haarfijne detaillering</em>, een vaardigheid die ze erfden van de middeleeuwse miniaturisten. Majewski laat in de proloog van <strong>The Mill &amp; the Cross</strong> zien hoe het personage van Bruegel de plooien van het gewaad van de vrouwen inspecteert en nog wat aanpast. Ook in de epiloog vertrekt Majewski van datzelfde detail uit het schilderij van Bruegel. Met dat visuele citaat van zijn voorgangers, de Vlaamse Primitieven, laat Bruegel duidelijk zien dat hij zelf met een zeker gemak de stijl ervan meesterlijk beheerst en imiteert. Hij citeert hen als <em>blijk van waardering</em>, maar ook als een niet mis te verstaan teken dat hij <em>zijn eigen beeldsignatuur</em> ontwikkelt. Hij wil de kunst van het beeld niet in het keurslijf van <em>een stijlcanon</em> duwen. Het beeld is voor hem het medium van de vrijheid van denken. En die vrijheid bevindt zijn <em>aan de overzijde van het stijlgebod</em>. Stijl idealiseert het beeld. Dat heeft de achtentwintig jarige Bruegel met eigen ogen kunnen zien tijdens zijn verblijf (1552-1555) in <em>het Italië van de renaissanceschilders</em> (Huet, o.c., 105-146). Bruegels Italiaanse collega’s ontwierpen via <em>de herontdekking van het Grieks-Romeinse classicisme</em> een nieuw schoonheidsideaal. Daarbij inspireerden ze zich op <em>de Schoonheid als hogere Idee</em> die ze leerden door het lezen van de werken van de Atheense filosoof <em>Plato</em>, wiens <em>Dialogen</em> ze voor het eerst in boekvorm konden lezen in een Latijnse vertaling. Via de introductie van <em>het klassieke perspectief</em> beoefenden de renaissancekunstenaars <em>de cultus van de Schoonheid</em>. Hun idealisme steunde op de stilistische hoeksteen van <em>de Oud-Griekse geometrie van de harmonie en de symmetrie</em>, iets wat de Romeinen hadden overgenomen. De muurschildering <em>De school van Athene</em> van Rafaël in de <em>Stanza della Segnatura</em> van het Vaticaan is van dat uitgesproken <em>schoonheidsidealisme</em> het blijvende stijlcredo. Bruegel nam kennis van die nieuwe, modieuze ‘renaissance’ van de klassieke kunst en architectuur. Hij bewonderde hun grote beheersing van de nieuwe technieken. Maar hij imiteerde die stilistische kunst niet. Het stijlidealisme sprak hem niet aan. Uit de bewaarde prenten, gemaakt tijdens zijn reis naar Italië, blijkt dat hij geen tekeningen heeft gemaakt van de klassieke ruïnes in en rond Rome. Wat hem imponeerde, waren <em>de berglandschappen</em> die hij tijdens zijn reis had ontdekt. Als toeschouwer vol van een kinderlijke verwondering absorbeerde hij <em>de vele vergezichten</em>. De <em>immense uitgestrektheid van de landschappen met hun rotsige verscheidenheid</em> liet hem niet meer los. Vandaar <em>het heuvelstandpunt</em> dat hij als schilder inneemt in de meeste van zijn werken. Dat is ook het geval in <em>De Calvarietocht van Christus</em>. Het schilderij kent een wijds panorama waarin rotsen een visuele hoofdrol spelen. In tegenstelling met het Idealisme van de renaissance, betrekt Bruegel de toeschouwer bij het schilderij. Bruegel beoefent niet <em>de kunst van de afstand tussen toeschouwer en beeld</em>. Hij gaat dus niet tewerk zoals zijn Italiaanse collega’s. Met hun renaissanceperspectief scheppen ze een afstand tussen de toeschouwer en het schilderij door <em>het geometrische middelpunt</em> in het beeld zelf te leggen. Bruegel slaagt erin om de toeschouwer als het ware in het schilderij zelf mee te nemen. Vanuit dat gegeven heeft Majewski zijn film <strong>The Mill &amp; the Cross</strong> gemaakt. Hij is op de uitnodiging van de schilderij zelf ingegaan en als toeschouwer gaan wandelen in het schilderij.</p>\n<p>Aan de andere kant van het beeld stelt zich <em>het negativisme</em> op. Die radicaal negatieve houding tegenover het beeld toont zich in de cultuur van <em>het iconoclasme</em>. Die komt voort uit de monotheïstische religies en de traditie heeft als <em>Bijbelse bron het boek Exodus 20, 2</em>. Daar klinkt het goddelijke beeldverbod erg duidelijk: Gods aanwezigheid is geen zichtbaar gegeven en kan dus niet worden afgebeeld op eender welke wijze. <em>Het jodendom en de islam</em> nemen dat goddelijke beeldverbod bijzonder ernstig. Mede onder druk van de oprukkende islam, en relatief vroeg in de bewogen geschiedenis van het christendom (730-834), heeft zich vooral in het oosterse deel van de Kerk <em>de eerste strijd over de religieuze beeldvorming</em> afgespeeld. Die ging gepaard met bloedig geweld. Tegelijkertijd werd de strijd ook gevoerd op de intellectuele, vooral theologische scène. De strijdende partijen waren aan de ene kant <em>de initiatief nemende iconoclasten</em>, geleid door de Byzantijnse keizer in Constantinopel, en aan de andere kant <em>de iconofielen</em>, ook <em>iconodulen</em> genaamd, aangevoerd door de vele christelijke kloosters (Alain Besançon, <em>L’image interdite. Une histoire intellecutuelle de l’iconoclasme</em>. Paris, Fayard, 1994, 151-200). Die eerste grote iconoclastenstrijd werd uiteindelijk gewonnen door de iconofielen. Zij legden de grondslag voor de traditie van de (orthodoxe) iconen en de talrijke vormen van religieuze beelden in christelijke kloosters en kerken. De christelijke, religieuze kunst herwon <em>een tweede onschuld</em>. Die verdween opnieuw in de tijd van Bruegel. Hij werd een historische getuige van <em>de tweede iconoclastische golf</em> in het christendom. Bruegel schilderde <em>De Calvarietocht van Christus</em> in 1564, het sterfjaar van <em>Johannes Calvijn</em>, de belangrijke en invloedrijke Frans-Zwitserse reformator en auteur van het zeer invloedrijke <em>Institutio Religionis Christianae</em> (1536), de hoeksteen van wat tot op heden in het protestantisme <em>de gereformeerde kerk</em> wordt genoemd. Calvijns werk in zijn geheel maar vooral de hoofdstukken 11 en 12 legden de basis van <em>het zeer strenge, calvinistische beeldenverbod</em>. Dat vormde de voedingsbodem voor de cultuurschok van de zomer van 1566, die zich vooral in het westelijke en noordelijke deel van de christenheid liet gevoelen, dus ook in de toenmalige Provincies Vlaanderen en Brabant. Die cultuurschok staat historisch opgetekend als <em>de Beeldenstrijd</em> of <em>de Beeldenstorm</em>. Huet spreekt in haar Bruegel-biografie over de ‘<em>grootscheepse imagocide</em>’ (o.c., 67). Die raasde toen als een opstekende cultuurstorm vanuit het toenmalige West-Vlaamse Steenvoorde eerst over de Nederlandse Provincies Vlaanderen en Brabant. Bruegel maakte die gewelddadige revolutie mee. In <em>De Calvarietocht van Christus</em> van 1564 voorvoelt Bruegel als een profeet die vooruitkijkt, de komst van beeldenstormers. Dat hij vanuit dat aanvoelen, toch uit eigen vrije wil, dus niet op bestelling, opteert voor een religieus schilderij van de Passie is profetisch en tegelijk een statement. Zoals Majewski duidelijk onderlijnt in <strong>The Mill &amp; the Cross</strong>, stelt Bruegel zich op als een geëngageerde toeschouwer. Hij kiest geen partij voor een van beide kampen. Als aandachtige toeschouwer kiest hij voor het beeld, het medium dat hem toelaat de betekenis te bevroeden van wat er aan de gang is. Hij handelt als kunstenaar <em>in de geest van het christelijk humanisme</em> waarvan <em>Erasmus</em> een generatie voor Bruegel de grondslag had gelegd. Als beeldend denker par excellence interpreteerde Bruegel die jonge traditie van christelijk denken op een heel eigen wijze. Dat toont zich in <em>de weigering van het triomfgevoel</em>. Hij cultiveert noch zichzelf als schilder noch zijn personages. Hij deelt niet <em>de cultus van het ego</em> die zijn renaissancecollega’s introduceerden. Die cultus van het ego brak inderdaad door met <em>het humanisme eigen aan de renaissance</em>. Ontelbare rijke burgers en mecenassen lieten zich in volle glorie portretteren. Hun portretten waren een streling voor het oog en van hun eigen ego. En het leverde de kunstenaars een goed inkomen op. Niets daarvan is bij Bruegel terug te vinden. Gibson heeft gelijk wanneer hij vaststelt dat Bruegels personages niet op zichzelf geconcentreerd zijn (Gibson, 2010, 66). Dat geldt ook voor de centrale figuur van <em>De Calvarietocht van Christus</em>. Het statement dat Bruegel hiermee maakt, handelt over <em>de moeilijke relatie tussen woord en beeld</em>. Alles stond in Bruegels eigen tijd in het teken van <em>het gedrukte w/Woord</em>. De boekdrukkunst floreerde en zorgde voor een nieuwe culturele omwenteling. Die had ook theologische implicaties. De Bijbel kon nu als <em>hét Boek</em> overal gemakkelijk en snel worden verspreid. Hiermee barstte de intellectuele strijd los over wie met macht en gezag <em>het Woord van God</em> kon en mocht interpreteren. Katholieken kwamen tegenover protestanten te staan, en protestanten tegenover weer andere, meer radicale protestanten. Dat alles deed zich voor als een gigantische theologische polemiek. Wat was de betekenis van de Passie van Jezus, die van het Kruisbeeld en de Verrijzenis? Bruegel begreep dat <em>deze strijd om het Woord</em> in de eerste plaats <em>een woordenstrijd</em> was, weliswaar een met concrete, dramatische implicaties. De tegengestelde partijen voedden elkaars radicaliteit. De woorden gingen aan beide kanten steeds zwaarder wegen. In naam van het Bijbelse Woord bekleedden vooral de iconoclasten zich met het gezag om alle beelden niet alleen te verbieden, maar ook radicaal te vernietigen. Wat doet een beeldend, christelijk bewogen kunstenaar in een tijd dat alle beelden, en in het bijzonder de beelden met religieus-christelijke taferelen bovenaan op de agenda staan van extreme beeldenstormers? Die vraag stelde Bruegel zich voortdurend en hij beantwoordde ze met <em>zijn humaan-religieuze beelden</em>. Hij opende een nieuwe weg die tussen de tegengestelde posities liep. Hij vond <em>de weg van de tolerantie</em> door <em>het toeschouwerschap van de mens</em> ernstig te nemen. Dat beweegt zich voorbij de grenzen van de harde strijd om het woord/Woord. <em>Niet het w/Woord heeft het laatste woord, wel het beeld</em>. Weliswaar niet het beeld om het beeld zelf, niet het beeld als promotie van Stijl, maar <em>het beeld als getuige van het unieke contact tussen de mens en de realiteit van het leven</em>. Uitgerekend in de heilige waarde van dat unieke contact, vindt het christendom zijn blijvende bron. <em>Voor Bruegel draagt het menselijke toeschouwerschap en de beoefening ervan een door en door christelijk-religieus zegel</em>. Van dat zegel getuigt <em>De Calvarietocht van Christus</em>.</p>\n<p><span class=\"menstis\">DE PASSIE GESPIEGELD IN HET BEELDEND ONDERZOEK</span>. Met <em>De Calvarietocht van Christus</em> zet Bruegel de toekomstige beeldenstormers op het verkeerde been. In hun fanatisme zouden ze het schilderij niet als een christelijke uitbeelding van de Passie van Jezus herkennen. Bruegel verbergt Jezus. Door de wirwar van bewegingen en figuren decentreert hij de aandacht voor het hoofdpersonage. Het dramatische hoogtepunt van het schilderij is tevens het dieptepunt ervan. Maar Bruegel doet meer. Hij neemt beeldend een positie in in <em>de intellectuele strijd over de culturele erfenis van het christendom en zijn Kerken</em>. Om te beginnen, distantieert hij zich van <em>het kerkelijk triomfalisme</em> dat gepaard gaat met de uitoefening van geweld. Dat laatste zag hij overal om zich heen. In <strong>The Mill &amp; the Cross</strong> duikt het geweld al in de eerste sequenties op. Dat gebeurt met de introductie van de <em>Roode Rocx’s</em>, de ruiters die in naam van de Spaanse koning de bevolking van Vlaanderen en Brabant terroriseren. Zij zijn de instrumenten waarmee koning Filips II de buitenzinnige taksen heft om zo het eigen bankroet van het Spaanse wereldrijk te voorkomen. Met de Roode Rocx’s kwam Filips II ‘<em>de substantie van het land uitzuigen</em>’ (Gibson, 2010, 20). Dat alles zag Bruegel zelf gebeuren. Die officiële terreur ten aanzien van de bevolking was slechts de voorbode van de komst van de in het zwart geklede <em>Hertog van Alva</em>. In 1567 bracht hij 60 000 militairen mee naar Brabant en Vlaanderen. De goed uitgeruste Italiaanse huurlingen moesten worden gehuisvest en gevoed door de lokale bevolking. Daarbij gingen de huurlingen wreed tekeer. Dat laat Majewski zien bij het begin van <strong>The Mill &amp; the Cross</strong>. Hij introduceert het jonge koppel, Jan en Netje, die met hun kalf naar de markt trekken. Onderweg komen ze de Roode Rocx’s tegen. Ze nemen Jan mee, binnen hem vast op een karrenwiel en brengen hem naar het galgenveld waar hij wordt overgeleverd aan de zwarte kraaien. Dat tafereel vormt in <strong>The Mill &amp; the Cross</strong> voor Bruegel de spiegel voor zijn tafereel van de kruisiging van Christus. Hierbij doet zich iets vreemds voor. De Christusfiguur draagt zijn kruis in een Europees landschap met een stad en een dorp met een kerk. In de film weerklinkt klokkengelui. In de kruisweg nemen, naast de Roode Rocx’s, ook monniken het voortouw. Eerder hebben ze een jonge vrouw, wellicht een heks, levend begraven volgens het gebruik in die tijd. In <strong>The Mill &amp; the Cross</strong> speelt de witte monnik een belangrijke rol. Op het einde, na de kruisiging, leest hij de Bijbel. Met andere woorden, Bruegel vertrekt van <em>de culturele evidentie van het christendom</em>. Het is overal aanwezig door het samenspel van de Kerk (de monniken, de kerkgebouwen) en de Staat (de koning, de notabelen, de Roode Rocx’s). Bruegel is in zijn tijd ook getuige geweest van <em>de succesrijke rederijkerskamers</em>. Wanneer die samenkwamen in een stad voor een grote bijeenkomst en wedstrijd in welsprekendheid, het Landjuweel, was dit een hoogmis voor intellectuelen. Ze discussieerden er over <em>allerlei christelijk-theologische onderwerpen</em> als zonde, dood, hel, hemel, vagevuur, verlossing, verzoening. Die christelijk-kerkelijk thema’s die op de agenda stonden, waren uitgegroeid tot <em>evidenties</em>, gecementeerd in vaste woordformules. Bruegel hoorde dit alles vanop de eerste rij, maar hij vroeg zich af wat die ‘<em>afgesleten clichés</em>’ konden betekenen in het licht van het reële leven van iedere dag en hij ‘<em>besloot al schilderend een onderzoek in te stellen</em>’ (Huet, o.c., 219). Hij ging er van uit dat het christelijk credo een diepe betekenis heeft die niet meer herkenbaar was onder het stof van evidenties en clichés die met dezelfde verwoordingen eindeloos worden opgevoerd. De groeiende twist tussen katholicisme en protestantisme versterkte nog de nadruk op de exacte formuleringen. Via <em>zijn keuze voor het beeld</em> keert Bruegel terug naar <em>de realiteit van het dagelijkse leven</em>. Zonder <em>de toetssteen van het contact met dat leven</em> dat door concrete mensen wordt geleefd, blijft de betekenis van Christus opgesloten in de verbale clichés. Bruegel haalt de Christusfiguur weg uit dat <em>verbaal Idealisme</em> dat hij ook in de christelijke kunst terugvindt. Kruisigings- en verrijzenistaferelen ogen triomfantelijk. In veel christelijke kunst, ook van de Vlaamse Primitieven, kijkt God zelf of de Verrezen Christus vanuit de Hemel naar de mensen op de aarde. De hemelse Figuur verschijnt als een triomferende Koning die neerkijkt op de volk van wie hij onderwerping en onderdanigheid verlangt. Dergelijke iconografie kent geen <em>tragiek</em>, eigen aan de menselijke geschiedenis. Tot die tragiek behoort wel <em>de Passie en de Kruisdood van Jezus zelf</em>. De evangelisten hebben die vastgehouden. Bruegel herinnert zich dat en neemt daarvan midden in een tijdsgewricht waarin theologische en kerkelijke partijen elkaar met hun triomfalisme probeerden de loef af te steken.</p>\n<p>Bruegel keert terug naar <em>het narratief van het evangelische Passieverhaal</em>. In die zin situeerde hij zich in <em>de jonge humanistische traditie van de terugkeer naar de bronnen, ook de Bijbelse</em>. Daarvoor had Erasmus met zijn eerste kritische editie van <em>de Oudgriekse nieuwtestamentische manuscripten</em> het pad geëffend. Hij toonde hiermee fouten aan in de vertaling in <em>de Latijnse Vulgaatvertaling</em> die overal door de Kerk werd gebruikt. Voor Erasmus en Bruegel betrof de renaissance niet in de eerste plaats de herontdekking van de cultuur van het Oude Griekenland en het Oude Rome, maar die van <em>de oorspronkelijke christelijk geschriften, het Nieuwe Testament</em>. Die christelijke renaissance gebeurde bij Bruegel op een beeldende manier. Hiermee nam hij afstand van de protestantse terugkeer naar de letter van de Bijbeltekst. Voor Bruegel was de kruisgang van Christus geen tekst gevat in woorden en zinnen, maar <em>een gebeuren in de tijd</em>. Van die tijd geeft hij een metaforisch beeld met <em>de molen op de rots</em>. Majewski werkt het beeld van de molen sterk uit. De cirkelende molenwieken, de ronddraaiende reuzeraderen, het witte meel, het gebakken brood, al die bewegingen roepen <em>het beeld op van het dagelijkse leven van mensen</em>. De beelden ontspringen aan <em>de waardering van de dagelijkse rituelen</em> die het leven van mensen ritmeren. Die waardering weerklinkt in het christelijk oergebed bij uitstek, <em>Het Onze Vader</em>, in woorden: ‘<em>Geef ons heden ons dagelijks brood</em>’. Majewski filmt enkele scènes waarin dat dagelijks brood centraal staat. Bruegel plaatst de molen die ieder dag opnieuw door de wind op gang wordt getrokken, hoog op een rots. Zo krijgt die molen de betekenis van <em>het wereldwiel van de tijd</em>. De mensenwereld beweegt op dat onveranderlijk ritme, van dag en nacht, van uur tot uur, van geboorte tot dood, van generatie tot generatie. Telkens weer opnieuw. Bruegels werk toont <em>een grote waardering voor dat dagelijkse levensritme</em>. Zonder enige vorm van verheerlijking maakt de Brabantse schilder van dat dagelijks leven zijn muze. Huet noemt Bruegels drieluik <em>De spreekwoorden</em>, <em>De strijd tussen Carnaval en Vasten</em> en <em>De kinderspelen</em> ‘<em>een antropologisch drieluik, drie ontdekkingsreizen naar het dagelijkse leven</em>.’ (Huet, o.c., 208). Bruegel beoefent de kunst als een act waarin hij de humane waardigheid van het dagelijkse leven in kaart brengt zonder enige idealiserende verheerlijking, eigen aan de Italiaanse renaissance. En dan is er <em>het christelijk narratief van de Gekruisigde</em>. Voor Bruegel bevat het christelijk narratief van de evangelies <em>het mysterie van de Incarnatie</em>. God zelf eert en waardeert het menszijn in de figuur van Jezus. Met de geboorte, het leven en de kruisdood van Jezus staan de molenwieken van de tijd even stil. Dat moment houdt Majewski even vast. Dat moment geldt eigenlijk voor het gehele schilderij van Bruegel, wat in zeker zin een artistiek gebaar is waarmee het wereldwiel even stil wordt gelegd. In de proloog met de heilige vrouwen treedt Bruegel op als de cineast die alles en iedereen opstelt in stilte, om dan ‘action’ te roepen. Maar in de film zelf markeert Majewski het hoogtepunt van de film, tevens het dramatische dieptepunt, de val van Jezus onder de zwaarte van het kruishout, door even alle beweging, ook die van de molen, stil te leggen. In die verstilde aandacht toont zich <em>het christelijk blikveld</em>. Vanuit het Romeinse machtsperspectief was de calvarietocht van Jezus van Nazareth niets meer dan een fait divers. Terechtstellingen waren een dagelijkse gewoonte, een politiek ritueel. Maar enkelen, de moeder van Jezus en zijn naasten, wisten dat het gebeuren meer was dan een ordinaire terechtstelling. Zij ontwikkelden <em>het christelijk narratief dat God zelf, de Schepper, met Jezus’ geboorte en dood het menselijk leven heeft geheiligd</em>. Voor Bruegel geeft dat narratief blijvende waarde, ook en vooral in een tijd waar het christelijk credo een machtsinstrument was geworden waarmee de heilige waarde van het dagelijks leven fundamenteel werd geschonden; een tijd ook waarin het beeldende, het incarnatorische van dat narratief verdwijnt onder het dikke stof van een bloedige woordenstrijd tussen christenen onderling. In de epiloog van <strong>The Mill &amp; the Cross</strong> laat Majewski, in de geest van Bruegel, de dansende mensen, jong en oud, man en vrouw, boer en burger, zien in een beeld waarin geen Roode Rocx’s en geen draaiende molen meer zijn te bespeuren.</p>\n<p><a name=\"CON\"></a></p>\n<h2><font color=\"#808000\"><strong>Context</strong></font></h2>\n<p>‘<em>De meeste werken zijn herontdekt in de twintigste eeuw. Niet alleen in die zin is het oeuvre van Bruegel jong en actueel</em>.’ (Huet, o.c., 9) De film <strong>The Mill &amp; the Cross</strong> maakt deel uit van het breder cultuurfenomeen van <em>de herontdekking en herwaardering</em> van Pieter Bruegel de Oude, de belangrijkste schilder uit de Lage Landen van de zestiende eeuw, en tevens een van de grootmeesters van de Europese schilderkunst ooit. De basis van die herontdekking en herwaardering is gelegd in het Antwerpen van einde van de negentiende-begin twintigste eeuw door de verzamelaar Fritz Mayer van den Bergh. Door zijn inspanningen kan Huet anno 2016 schrijven: ‘<em>Van alle oude schilders van de Lage Landen is Pieter Bruegel het laatst herontdekt en bestudeerd, eigenlijk pas in de loop van de twintigste eeuw.</em>’ (Huet, o.c., 18). Dat die beweging van herontdekking en herwaardering <em>internationaal</em> uitdijt, daarvan getuigt het vermelde boek van Gibson en de film van Lew Majewski. Maar ook <em>de stad Brussel</em> waar Bruegel heeft geleefd en gewerkt sinds zijn huwelijk met Mayken Coecke in de Brusselse Kapellekekerk, waar hij ook ligt begraven, sluit zich aan bij die beweging. Dat blijkt uit het project Bruegel/Unseen masterpieces’ van de <a href=\"https://www.brusselsmuseums.be/nl/tentoonstellingen/bruegel-unseen-masterpieces\">Koninklijke Musea voor Schone Kunsten</a> in Brussel. Dat is een voorloper van de oprichting van <em>het Bruegel Huis</em> in de Brusselse Hoogstraat 132 ― het huis waar Bruegel met zijn gezin woonde ― dat, wanneer alles volgens plan verloopt, in 2019 (de 450ste verjaardag van Bruegels overlijden) zijn deuren zal openen in het centrum van Brussel</p>\n<p><a name=\"LIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Links</strong></font></h2>\n<p>De website van de film <a href=\"http://www.themillandthecross.com/\">The Mill &amp; the Cross</a>.</p>\n<p>De persoonlijke site van <a href=\"http://www.lechmajewski.com/index.htm\">Lech Majewksi</a>.</p>\n<p><font size=\"-2\">© Sylvain De Bleeckere, Men(S)tis, 2017</font></p>\n"}

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

	module.exports = {"title":"Mr. Turner","body":"<center>\n<img src=\"mt.jpg\" >\n</center>\n<p><a name=\"KLA\"></a></p>\n<h2><font color=\"#808000\"><strong>Klapbord</strong></font></h2>\n<p>De kunstenaarsfilm <strong>Mr. Turner</strong> is een werk van de Britse cineast Mike Leigh. Vooral samen met Ken Loach heeft Mike Leigh de Britse film op de wereldkaart gezet sinds de tweede helft van vorige eeuw. Tot zijn beste langspeelfilms behoren de films <em>Naked</em> (1993), <em>Secret and Lies</em> (1996), <em>All or Nothing</em> (2002) en <em>Another Year</em> (2010). Met <strong>Mr. Turner</strong> bereikt de filmkunst van Leigh een nieuw hoogtepunt. Dat blijkt in de eerste plaats uit de positieve respons op de film die zijn wereldpremière kende tijdens het 67ste Festival van Cannes (2014). Daar kreeg de hoofdrolspeler Timothy Spall de Prijs voor beste acteur, terwijl de film zelf een nominatie voor de Gouden Palm ontving. Daarnaast won Mike Leigh met <strong>Mr. Turner</strong> ook de BAFTA/ BRITANNIA Award voor Excellence in Directing. Voorts verwierf de film vier nominaties voor zowel de 87ste Academy Awards als de 68ste British Academy Film Awards. De film zelf hoort bij het genre van de historische, en in het bijzonder de biografische film. Toch is <strong>Mr. Turner</strong> niet in de volle zin van het woord een biopic. De film beperkt zich namelijk tot de laatste vijfentwintig levensjaren van de Britse schilder <em>Joseph Mallord William Turner</em> (1775-1851), begraven in de Sint Pauls Cathedral. Veel meer dan een biopic oogt <strong>Mr. Turner</strong> vooral als een volwaardige Europese auteursfilm met een sterk historische dimensie. Mike Leigh nam niet alleen de regie voor zijn rekening, hij schreef ook zelf het scenario op basis van een accurate historische studie van de beschikbare bronnen. Leigh liet zich bijstaan door dr. Jacqueline Riding, kunsthistorica, historica, adviseur en auteur, gespecialiseerd in de epoche van koning George III (1760-1820).</p>\n<p><a name=\"SYN\"></a></p>\n<h2><font color=\"#808000\"><strong>Synopsis</strong></font></h2>\n<p>In september 1826 komt J.M.W. Turner terug thuis in Harley Street 64, Londen, na een bezoek aan de Lage Landen. Zijn huisgenoten, zijn vader, <em>Mr. William</em>, en de inwonende huishoudster, <em>Hannah Danby</em>, zijn erg blij hem terug te zien. Ze vreesden dat Billy, zo noemen ze hem, misschien was omgekomen bij de grote explosie in het kruitmagazijn te Oostende van waar hij geacht werd de boot te nemen. Vader William heeft een hartelijke relatie met zijn beroemde zoon-schilder. Ze hebben een sterke band. Ze werken ook intens samen. Vader William ondersteunt zijn zoon als een volleerde assistent kunstschilder. Hij zorgt voor de aankoop van de juiste pigmenten, maakt de verschillende kleuren klaar en spant de blanco schilderdoeken op. Op haar beurt zorgt Hannah voor het huishouden en ze ontvangt de gasten. Turner geniet als kunstschilder immers koninklijke waardering. Mecenassen uit de adellijke kringen en het milieu van de Londense hoge burgerij komen werk van hem kopen. Hannah is heimelijk verliefd op Turner en zoekt ook seksueel contact met hem. Af en toe gaat Turner op dat verzoek in, zij het onhandig. Hannah lijdt aan de huidziekte psoriasis. Turner concentreert zich <em>helemaal en zeer intens</em> op zijn werk in zijn atelier te London. Hij schildert op basis van de schetsen die hij bij voorkeur maakt aan <em>de kustlijn van Margate, Kent</em>. Hij huurt daar een kamer met zicht op zee in het huis van <em>Sophia Caroline Booth</em>. Wanneer zij voor de tweede keer weduwe wordt, krijgen zij en Turner een vaste relatie. Om elkaar meer te kunnen zien, koopt Turner voor hen een huis in <em>Cheyne Walk, Chelsea,  West-Londen</em> vlakbij de Thames. Niettegenstaande hij ouder wordt, blijft Turner zich <em>een hoog werkschema</em> opleggen, dat ook fysiek veel van hem vergt. Hij maakt immers erg lange wandelingen langs de kustlijn om te schetsen. Hoge of lage temperaturen deren hem niet. Hij laat zich vastbinden aan de mast van een schip om het licht en de wolkenbewegingen te kunnen bestuderen tijdens een winterstorm. De ervaring gebruikt hij voor het doek <em>Snow Storm – Steam Boat off a Harbour’s Mouth</em>. Tijdens die ervaring in extreme weersomstandigheden, loopt Turner echter een zware bronchitis op. Geleidelijk verzwakt zijn hart. Dat komt niet alleen door de grote fysieke inspanningen. Bijna dagelijks maakt hij wandelingen in weer en wind van veertig kilometer. Ook <em>het verdriet</em> weegt zwaar op zijn gemoed. Hij vertrouwt Sophia Booth toe dat hij zijn zusje heeft verloren toen hij acht was. Hij heeft bovendien twee van zijn klasvrienden in de lagere school aan de dood moeten afstaan. Zijn vader en hij hebben Turners moeder moeten laten opnemen in een psychiatrische instelling waar ze is overleden. Dat gebeuren heeft in het gemoed van Turner en zijn vader blijvende sporen getrokken. Tegelijkertijd wordt Turner regelmatig geconfronteerd met de tante van Hannah, <em>Sarah Danby</em>, met wie Turner ooit een korte seksuele relatie heeft gehad. Als ongehuwde moeder voort ze haar twee meisjes, Evalina en Georgiana, op in het huis van Turner met de bewering dat zij zijn dochters zijn. Ze speelt de meisjes uit om van Turner financiële steun te bekomen. Ze gaat daarbij agressief te keer. Dat neemt nog toe wanneer Georgiana in het kraambed overlijdt. Turner ontkent de vader te zijn van beide meisjes, maar hij wijst ze niet af. Die situatie bezwaart zijn gemoed. Wanneer Turners vader overlijdt, voelt Turner zich gedesoriënteerd. Hij vecht tegen zwaarmoedige gevoelens. Hij bezoekt de prostituee Eliza. Hij wil haar schetsen in een pose van een wanhopig jong meisje. Al schetsend overvalt hem in haar kamer een immens verdriet. Geleidelijk vindt hij toch terug een warme thuis bij mrs Booth. Ondertussen zet hij zijn sociaal leven verder. Een van zijn adellijke bewonderaars, <em>George O’Brien Wyndham, de 3de Graaf van Egremont</em>, nodigt hem graag uit om in zijn ruim Petworth House te verblijven en daar voor hem doeken van zijn domein te schilderen. Turner is al van 1789, op zijn veertiende, erkend lid van de prestigieuze Londense <em>Royal Academy of Arts</em>. Sinds 1796, het jaar waarin hij in de Royal Academy of Arts zijn eerste olieverf schilderij (<em>Fishermen at Sea</em>) tentoonstelde, werd hij geprezen als getalenteerde tekenaar en geniale schilder van <em>marines</em> (zeezichten).  Op zijn vierentwintigste wordt hij al gekozen als associate van de Academy. Hij geniet er een groot prestige. Later beginnen sommigen zich te ergeren aan Turners toenemend hoekig gedrag en gaan sommigen hem zien als een oude meester uit een voorbije tijd. De nog jonge <em>Koningin Victoria</em> laat openlijk haar afkeur voor Turners gedurfd later werk zien. De oude Turner ziet hoe in het theater met hem, zijn werk en zijn bewonderaars de spot wordt gedreven. Zelf blijft hij intellectueel zeer alert. Hij houdt lezingen voor zijn collega’s van de Academy over licht en kleur. Sinds 1840 is <em>John Ruskin</em> die zich een naam verwerft als kunstcriticus, een grote fan van Turner. De schilder is trouwens een graag geziene gast bij de Ruskins. Turner is eveneens bevriend met <em>Mary Somerville</em>. Tegen de tijdgeest in, geniet deze geëmancipeerde vrouw die Turners werk bewondert, faam als natuurkundige vorser. Ze voert in Turners atelier wetenschappelijke experimenten uit met licht en kleur. Turner volgt trouwens de moderne ontwikkelingen in wetenschap en techniek op de voet. Hij heeft oog voor de komst van <em>het ijzeren stoomschip</em> dat het houten zeilschip zal gaan vervangen. De stoomtrein doet zijn intrede, evenals <em>de fotografie</em> waarmee Turner als een van de eerste kennis wil maken in de Londense studio van de Amerikaan John E. Mayall uit het Amerikaanse Philadelphia. Op zekere dag krijgt de oude Turner in zijn atelier bezoek van de rijke kunstmecenas <em>Joseph Gillot</em>, fabrikant van stalen pennen die in heel de wereld worden gebruikt. Hij wil Turner de ronde som van honderd duizend pond betalen voor alle werken ― schilderijen, aquarellen, tekeningen en schetsboeken. Turner weigert. Hij heeft testamentair vastgelegd dat zijn werken in eigen bezit ― 300 olieschilderijen op doek, circa 30 000 schetsen en aquarellen, waaronder 300 schetsboeken ― aan de Britse natie gratis toekomt, met als enige voorwaarde dat het voor alle burgers vrij toegankelijk wordt tentoongesteld. In 1851, op de drempel van de eerste naar de tweede helft van de 19de eeuw, de periode van de doorbraak van de Industriële Revolutie, overlijdt William Turner in het huis dat hij bewoont met zijn partner, Sophia Booth. Hij sterft er aan een hartfalen. In zijn laatste ogenblikken zegt hij: ‘<em>De zon is God.</em>’</p>\n<p><a name=\"CIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Cinematografie</strong></font></h2>\n<p><span class=\"menstis\">AUTHENTICITEIT.</span> Wie het leven en werk van een schilder als William Turner wil verfilmen, staat voor een grote uitdaging. Mike Leigh heeft die uitdaging aangenomen. Hij werkte zeven jaar aan de voorbereiding van het project, dat is veel meer dan een masterstudent nodig heeft om een doctoraatsstudie te schrijven. Geconfronteerd met de uitzonderlijke hoeveelheid plastisch werk van Turner en met het feit dat diens privéleven niet zo goed is gedocumenteerd, heeft Leigh geopteerd om <em>een zo groot mogelijke authenticiteit</em> te bereiken. Daarvoor alleen al engageerde hij <em>76 acteurs en actrices</em> voor de evenveel rollen van historische personages te vertolken. Toch moest Leigh ook keuzes maken. Leigh koos ervoor om zich te beperken tot <em>de laatste vijfentwintig levensjaren</em> van Turner. Vreemd genoeg is dat de periode waarin de faam van Turner begon te tanen en waarin Turner zelf zich meer en meer sociaal isoleerde. Vervolgens heeft Leigh beslist om <em>zowel de mens als het werk</em> centraal te stellen. Na de studie van de beschikbare biografische data en vooral de studie van Turners schilderijen en schetsboeken, vroeg Leigh aan de Engelse acteur <em>Timothy Spall</em> met wie Leigh al eerder werkte, gedurende twee jaar zich voor te bereiden op de opnames. Onder leiding van de leraar-schilder van portretten, Tim Wright, leerde Spall de techniek van het schilderen naar de werken van Turner. Strik biografisch beschouwd, zijn de data die direct betrekking hebben op de creatie van Turners werk, <em>zeer accuraat</em>: zijn omgang met andere schilders van de Royal Academy en mecenassen, zijn sterke band met criticus John Ruskin, de eerste en meest trouwe promotor van Turners werk, Turners experimenten met kleur en licht, diens interesse in natuurkundige experimenten met licht, zijn vele wandelingen en schetsen. Wat <em>het privéleven van Turner</em> betreft, houdt Leigh zich aan de gekende feiten: Turner bleef ongehuwd, zijn moeder werd psychiatrisch opgenomen, zijn vader werd zijn voornaamste assistent en woonde bij hem in, zijn verborgen relatie met weduwe Booth op oudere leeftijd. In de film werkt Leigh vooral <em>de sterke band tussen Turner en zijn vader</em> uit, en focust hij op <em>de sterke relatie tussen de schilder en weduwe Booth</em>. De scènes met de vader en met weduwe Booth behoren tot de sterke, dramatische momenten van scènes uit het privéleven van Turner. Voor <em>de scènes met Sarah Danby</em> met haar twee dochters kon Leigh niet beschikken over harde feiten. Het verhaal over <em>het vermeende vaderschap</em> van Turner kan niet meer worden geverifieerd. Turner zelf heeft dat vermeende vaderschap nooit bevestigd. Ten aanzien van <em>Hannah Danby</em>, die trouwe huishoudster die aan psoriasis lijdt, bewandelt Leigh een heel eigen pad waarvoor er geen biografische ondersteuning voorhanden is. Dat Hannah Danby veertig jaar de trouwe huishoudster van Turner was, valt buiten iedere twijfel. Leigh heeft zelf verklaard dat er voor zijn interpretatie van mogelijke seksuele relatie tussen Turner en Hannah geen enkele historische evidentie bestaat. De reden waarom Leigh toch voor die optie heeft gekozen, kan voortkomen uit <em>zijn historisch correcte visie op de tijdsgeest</em> waarin Turner als kind en jongen is opgegroeid. Hij is namelijk geboren tijdens het bewind van koning George III (1760-1820) en hij is overleden tijdens het bewind van de nog jonge koningin Victoria (1837-1901). De eerste koning staat bekend als een vrij liberale koning en als ‘de gekke koning’ omdat hij leed aan hevige stemmingswisselingen. Dat blijkt ook uit het filmportret <em>The Madness of King George</em> (1994) van Nicolas Hytner. Het Victoriaanse tijdperk daarentegen is alom gekend omwille van zijn strenge zeden en doorgedreven burgerlijke moraal. Wellicht speelde dit cultuurverschil mee in de weigering van koningin Victoria om Turner de eer van het ridderschap te verlenen, een weigering waaronder Turner leed. Leigh verwerkt beeldend die historische afstand tussen de koningin en de oudere Turner in de sequenties waarin de koningin de tentoonstelling van de Academy bezoekt. William Turner was inderdaad duidelijk <em>een kind van de Georgiaanse epoche</em>. Hij werd immers geboren en getogen in Maiden Lane, vlakbij de Londense wijk <em>Covent Garden</em>. Toen Turner opgroeide bij zijn vader, kapper en pruikenmaker, en bij zijn geesteszieke moeder, was Covent Garden <em>de libertijnse bohemienbuurt van Londen</em> waar losse zeden de sfeer bepaalden. De Britse historicus Vic Gatrell wijdde er zijn onderzoek aan dat hij publiceerde in <em>The First Bohemians: Life and Art in London’s Golden Age</em> (2013). Mike Leigh laat zien dat de oudere Turner terecht was gekomen in een heel ander Engeland, dat van het Victoriaanse met zijn strenge zeden. De sequenties met Hannah en Sarah Danby, en die met de jonge prostituee krijgen hun historische authenticiteit vanuit die cultuurwissel. De historische authenticiteit van <strong>Mr. Turner</strong> speelt ook mee in <em>de reconstructie van het kunstenaarsmilieu</em> waartoe Turner behoorde. Zo is voor de film een historische trouwe reconstructie gemaakt van Turners <em>Queen Anne Street galerij</em>, de eigen galerij die Turner in zijn ruime woning had ingericht, alsook van <em>de historische zomertentoonstelling van de Royal Academy in 1832</em>. Daarnaast kent de film vooral <em>een esthetische authenticiteit</em>. Dat geldt namelijk voor de panoramische buitenopnames. De cinematograaf <em>Dick Pope</em> brengt de unieke wijze waarop Turner in zijn werk het licht evoceert, over op de filmbeelden van de landschappen. Hierdoor kijkt de toeschouwer naar de lichtcomposities van het landschap op dezelfde wijze waarop Turner dit deed toen hij tijdens zijn wandelingen schetsen maakte. Pope kreeg van de jury van het Festival van Cannes terecht een speciale prijs voor de bijzondere cinematografie. Het werk van Pope voor <strong>Mr. Turner</strong> is hierdoor een sterk voorbeeld geworden van hoe <em>de Europese cinematografie zichzelf begrijpt als de voortzetting van de Europese schilderkunst met nieuwe middelen</em>, en omgekeerd toont <strong>Mr. Turner</strong> aan dat Europese schilders als Turner eigenlijk op dezelfde wijze naar de werkelijkheid keken als de kunst van de cinematografie, eigen aan de twintigste eeuw. Het waren cinematografen avant la lettre. Een ander aspect van de esthetische authenticiteit betreft <em>de vele scènes met doeken van Turner</em>. Bepaalde scènes bestaan uit een inzoom op een schilderij. Dat gebeurt bijvoorbeeld bij het doek <em>Snow Storm: Hannibal and his Army Crossing the Alps</em> (1812), vandaag te zien in de Tate Galery. Een ander doek waarop de film inzoomt, is <em>Slave Ship (Slavers Throwing Overboard the Dead and the Dying. Typhoon Coming On</em>) (1840). Dit doek  krijgt veel aandacht, in het bijzonder wat het ontstaan ervan betreft. Dat blijkt uit de sequentie met mijnheer Booth, de tweede man van mevrouw Booth. Turner, de huurder van de kamer, maakt kennis met mijnheer Booth. Wanneer deze vertelt dat hij heeft gewerkt als scheepstimmerman, wekt dit Turners aandacht. Het eigenlijke onderwerp van het gesprek handelt over <em>de slavenhandel</em> die de scheepstimmerman met eigen ogen heeft aanschouwd. Turner krijgt informatie uit eerste hand. Zijn doek <em>Slave Ship</em> komt verder tweemaal ter sprake tijdens het gesprek met de Ruskins. De eerste keer in de eigen galerij van Turner terwijl de Ruskins het doek zelf ontdekken en de tweede keer handelt het gesprek in het huis van de Ruskins over het schilderij. De jonge John Ruskin zelf noemt het schilderij in aanwezigheid van Turner een meesterwerk en citeert respectvol de lange naam van het werk. Kort daarna werkt Turner in zijn atelier aan een nieuw werk, <em>Rain, Stea and Speed – The Great Western Railway</em>. Het tafereel van dit nieuwe meesterwerk dat de opkomst van de Industriële Revolutie uitdrukt, wordt nadien filmisch in het echt gereconstrueerd. Voor de schilderijen die in beeld komen, deed Leigh beroep op de Britse schilder <em>Charlie Cobb</em>. Hij kopieerde die schilderijen die in close-up in beeld komen. Voor die schilderijen die alleen op de achtergrond te zien zijn, gebruikte Leah gedrukte reproducties, bewerkt met een laag vernis.</p>\n<p><span class=\"menstis\">BIPOLAIR RITME.</span> Turner is de onovertroffen grootmeester in het genre van de marines. Eigen aan zijn zeezichten is de beweging. Hij begreep door zijn jarenlange volgehouden observaties dat de zee nooit een stilstaande massa water is. De zee beweegt op het ritme van eb en vloed. Perioden van rust wisselen af met perioden van storm. Dat inzicht heeft Mike Leigh ook in zijn scenario verwerkt. <em>De film beweegt namelijk op het bipolaire ritme van enerzijds de menselijke schaal en anderzijds op de panoramische schaal</em>. Op de eerste staat de mens Turner centraal. Op die schaal situeren zich vooral <em>de binnenopnames</em>. Op de panoramische schaal staat de kunstenaar Turner centraal. Hij komt in beeld als de man die horizonten opzoekt zowel in het landschap als langs de kustlijn. <em>Dat bipolaire ritme ‘Turner de mens – Turner de schilder’</em> geeft de film zijn eigenheid en eenheid. Leigh werkt niet met twee gescheiden werelden. Turner is <em>een buitenmens en een binnenmens</em>. Hij gaat naar buiten om al schetsend horizonten op te zoeken. Hij absorbeert impressies en brengt die mee naar binnen, in zijn atelier. Daar gebruikt hij zijn schetsen als grondstof voor zijn doeken. Helemaal in overeenstemming met de overgeleverde gegevens, regisseert Leigh het filmische leven van Turner volgens het bipolaire ritme ‘<em>naar buiten – naar binnen</em>’.  De film opent buiten. Turner schetst in Holland het landschap met molen. De film eindigt binnen. Turner ligt op zijn sterfbed. Zijn laatste gedachten gaan naar buiten, naar de zon.</p>\n<p>De filmrecensies van de film, verschenen na de première, focusten <em>eenzijdig op ‘de man’</em>. Ze hadden geen oog voor het bipolaire ritme van de film. Dat komt mede door <em>de bijzondere en sterk gewaardeerde vertolking door Timothy Spall</em>. De scènes waarin de acteur de hoekige, grommende en morrende Turner neerzet, kregen veel aandacht en werden overbelicht. Die scènes werden geïsoleerd en kwamen op zich te staan. Hierdoor verloren de recensies <em>het gehele portret uit het oog</em>.</p>\n<p>Leigh werkt helemaal <em>niet</em> met de tegenstelling tussen de man en het werk. Om het hele plaatje te zien, is het noodzakelijk om oog te hebben voor het zachte hout achter de ruwe schors. Dat is wat Leigh zelf doet. De regisseur toont, helemaal in overeenstemming met de biografische gegevens, hoe de man die van geboorte tot de lagere klasse behoorde, <em>bijzonder intelligent</em> was. Met <em>een open geest</em> verkende Turner zijn omgang met de wereld van mensen en dingen, en verwerkte dit alles in zijn artistiek werk. De film toont niet de kindertijd, de jeugd en jong-volwassenheid van Turner. In die tijd schoolde Turner zichzelf voortdurend bij, onophoudelijk zelf. In de film brengt Turner hulde aan zijn vader als ‘<em>a man of high intellect</em>’ en hij voegt eraan toe dat zijn vader hem ‘<em>leerde lezen en schrijven</em>’. In de film beklemtoont Turners vader zelf het belang van de opvoeding: ‘<em>Education is an important thing.</em>’ De film toont het resultaat van dat proces. De aandachtige toeschouwer ontdekt hoe Turner tot aan zijn laatste dagen van het tekenen en het schetsen <em>zijn eigen leerschool</em> maakte. Via de kracht van zijn intelligentie, gekoppeld aan zijn artistiek talent, klom Turner omhoog op de maatschappelijke ladder en maakte hij vrienden in de hoogste kunstkringen. Dat gebeurde niet via een netwerk van relaties, maar uitsluitend via zijn talent dat steunde op <em>onophoudelijk werken</em> en <em>een grote nieuwsgierigheid</em> om bij te leren.</p>\n<p>Leigh legt terecht de nadruk op <em>Turners kennis van de taal</em>. Bij het zien van de film, is het voor niet-Engelstaligen van belang om niet alleen de onderschriften te lezen, maar ook en vooral te luisteren naar de bijzondere taal die Turner spreekt. Hij spreekt in <em>een beknopte, maar beeldrijke taal met regelmatige verwijzingen naar de Grieks-Romeinse mythologie</em>. Tijdens het lichtexperiment van mevrouw Somerville noemt Turner de beweging van het zonlicht ‘<em>het machtige hemelse gebied van Apollo</em>’ (‘<em>As mighty Apollo moves across his heavenly tract</em>’). Nadien beschrijft hij het gelaat van mevrouw Booth  met de trekken van een Grieks beeld van Aphrodite. Hij bevestigt tegenover mevrouw Booth dat hij ‘<em>vertrouwd is met het Griekse beeld</em>’. Voorts omschrijft hij de slaap met de uitdrukking ‘<em>zich werpen in de armen van Morpheus</em>’ ('<em>I’m gonna throw myself into the arms of Morpheus</em>’), verwijzend naar de Griekse god van de dromen. In een andere scène noemt hij de slaap ‘<em>the Kingdom of Hypnos</em>’. In de Griekse mythologie is Hypnos de god van de slaap en de vader van Morpheus. In een andere scène noemt hij de zon <em>Helios</em>, de zonnegod uit de Griekse mythologie. Tegenover de voorzitter van de Royal Academy of Arts, mr. Shee, noemt hij de tentoonstelling ‘<em>a splendid cornucopia</em>’ (Hoorn des overvloeds), opnieuw een verwijzing naar een gegeven uit de Griekse mythologie.</p>\n<p>Zo blijkt dat Turner <em>de toenmalige neoklassieke tijdgeest</em> persoonlijk had geabsorbeerd. Hij deelde met andere intellectuelen van zijn tijd <em>de bewondering voor de oud-Griekse cultuur</em>. Het vroege negentiende-eeuwse <em>neoclassicisme</em> kende in de westerse wereld een grote bloei. Dat blijkt uit de neoklassieke architectuur voor grote, officiële gebouwen in Frankrijk, Engeland en in de jonge Verenigde Staten van Amerika. Ook in de wereld van de schilderkunst bekleedden ‘de academici’, invloedrijke posities, ook in de Royal Academy of Arts. De groep van ‘de academici’ vertegenwoordigden <em>de standaard van klassieke schoonheid</em>, te vinden in de oud-Grieks-Romeinse beeldkunst. Mede door de invloed van de Duitse kunsthistoricus en archeoloog, <em>Johann Winckelman</em> (1717-1768) gold in intellectueel Europa op het einde van de achttiende en begin negentiende eeuw de statische en symmetrische Grieks-Romeinse kunst en architectuur als de blijvende standaard van hoogste schoonheid. Dat speelde ook mee in vorming en onderwijs waar de studie van de klassieke filologie in de negentiende eeuw het hoogste aanzien genoot. De film laat zien hoe de zowel gerenommeerde als controversiële kunstenaar Turner zich die neoklassieke cultuur had toegeëigend. Reeds vroeg in zijn carrière had de jonge Turner trouwens tekenles gegeven aan de Royal Academy aan de hand van plasteren kopieën van antieke beelden. Die waren in het kader van <em>de neoclassicistische mode</em> zeer verspreid.</p>\n<p>Turner maakte zich tegelijkertijd ook <em>de groeiende romantische beweging</em> eigen. Die beweging corrigeerde als tegenbeweging de meer rationele neoklassieke stroming. De film <strong>Mr. Turner</strong> besteed terecht aandacht aan de historische figuur en tijdgenoot van Turner,<em>John Constable</em> (1776-1837). In de Engelse schilderkunst wordt hij beschouwd als de voorloper van de romantische schilderkunst in Engeland en Frankrijk. Zijn doel was om <em>de levende natuur en het concrete landschap als de enige leermeester van zijn werk</em> te zien. Ook Turner maakte van het landschap zijn werkterrein. Constable en Turner hadden een gemeenschappelijke referentie, <em>het werk van de Franse schilder Claude Lorrain</em> (1602-1862). Die plaatste als eerste zijn personages, die hij ontleende aan de oud-Grieks-Romeinse cultuur, in een realistisch landschap.</p>\n<p>Mike Leigh reconstrueert in <strong>Mr. Turner</strong> het historische <em>‘rode boei-incident’</em> waarbij Turner en Constable betrokken waren. Het vond plaats tijdens de voorbereiding van de tentoonstelling in de gebouwen van de Royal Academy of Arts. Het schilderij <em>Helvoetsluys – The City of Utrecht, 64, Going to Sea</em> van Turner en het doek <em>The Opening of Waterloo Bridge</em> van Constable gingen er in de grote zaal naast elkaar. In de filmscène loopt Turner naar zijn schilderij, waarna hij zich naar Constable wendt die druk doende is met het aanbrengen van nog enkele details aan zijn schilderij waarin de kleur rood erg domineert. De mannen begroeten elkaar formeel. Beiden zijn immers niet de beste vrienden, ze zien zichzelf als concurrenten. Turner loopt door de verschillende zalen van de tentoonstellingen en begroet zijn collega’s en bestuursleden van de Academie. In korte, gebalde zinnen drukt hij zijn waardering en collegialiteit uit. Hij participeert gezwind aan het gebeuren, maar relativeert het ook. Uit het tafereel blijkt ook hoe verschillende aanwezigen Turner waarderen en achten. De pointe van het tafereel is de scène waarin Turner weer naar zijn grijs getinte <em>Helvoetsluys</em> toestapt, nu met een schilderskwast, terwijl Constable nog steeds aan het worstelen is met het rood op zijn <em>The Opening of Waterloo Bridge</em>. Met een krachtig, precies gebaar werpt Turner een klad rode verf op het doek, waarna hij zonder iets te zeggen de grote zaal verlaat. De academici onder leiding van de toenmalige voorzitter van de Academie, <em>Sir Martin Archer Shee</em>, kijken met grote ogen naar het Turners schilderij. Ook Constable. Er ontstaan verschillende meningen. Shee vindt dat Turner een meesterwerk heeft verbrod, anderen vinden dat Turner goed weet wat hij doet. In de algemene verbijstering, trekt de verbolgen Constable zijn jas aan en terwijl hij aanstalten maakt om weg te gaan, zegt hij, geërgerd, over Turner: ‘<em>Hij is hier geweest en hij vuurde een schot af.</em>’  De controverse over Turners ‘rode’ tussenkomst loopt op en Shee noemt Turners actie ‘<em>pure madness</em>’. Kort daarna, komt Turner opnieuw de grote zaal in. Hij gaat direct naar zijn schilderij en hervat zijn actie. Met zijn duim en een lap stof verandert hij de klont rode verf op het doek in <em>een dobberende boei in het water</em>. Wanneer iedereen beseft wat er is gebeurd, roept Shee: ‘<em>Bravo, bravo.</em>’ Turner demonstreerde voor zijn collega’s en het bestuur van de Academie zijn geniaal talent en zijn doorleefde visie over hoe de schilder het licht en de bewegende dingen in het golvende water kan evoceren.\nTurner ging dan ook zijn eigen unieke weg, tegen de stroom in van de heersende academische stijl in de kunst en kunstopleidingen. Hierdoor was hij in Europa <em>een echte pionier in de vrije kunststijlen</em> die pas eind negentiende en begin twintigste eeuw zouden doorbreken.</p>\n<p>Turners intellectuele standing blijkt uit zijn vriendenkring waartoe de historische leden van de <em>Londonse Royal Academy of Arts</em> behoorden. Hij frequenteerde mensen als de jonge <em>John Ruskin</em> en diens ouders, de Londense architect <em>Sir John Soane</em> en schilders als <em>Benjamin Haydon</em>. Ofschoon hij van lagere komaf was, liet Turner zich niet intimideren door de leden van de hogere kringen. Hij bleef zichzelf en drukte zich uit in zeer gevatte, korte zinnen die ook getuigden van een persoonlijk gevoel voor humor. Zo reageert hij bijvoorbeeld op de kritiek van de heer Lenox dat Turners werk ‘<em>onduidelijk, vaag</em>’ is, gevat met: ‘<em>You should tell Mr Lenox that indistinctness is my forte</em>’. Wat in de ogen van anderen een gemis lijkt, daarvan maakt Turner zijn handelsmerk.</p>\n<p>Wat de beheersing van de taal betreft, uitte Turner zich ook in <em>gedichten</em>. Naar het einde toe van de film, schildert hij in het atelier in het Chelsea huis dat hij samen met mevrouw Booth bewoont. Terwijl hij het doek <em>Norham Castle, Sunrise</em> aan het schilderen is waarbij mevrouw Booth hem assisteert, draagt hij voor haar zijn liefdesgedicht <em>Be still, my dear Molly, be still</em> voor. De regisseur heeft het gedicht gevonden in Turners vele notitieboekjes die vandaag worden bewaard in de Londense Tate Gallery. In de film krijgt het doek <em>The Slave Ship</em> ― de oorspronkelijke titel luidde <em>Slavers Throwing overboard the Dead and Dying-Typhoon coming on</em> ― heel wat aandacht. Terecht toont de film dat het doek zich nog in Turners atelier bevindt waar hij het in 1840 schilderde. Vader en zoon Ruskin bezoeken het atelier en zijn erg onder de indruk. John Ruskin werd de eerste eigenaar. Turner, een pleitbezorger van het Britse abolitionisme dat zich keerde tegen de slavenhandel, stelde het doek voor het eerst tentoon tijdens de grote Londense <em>World Anti-Slavery Convention</em>. Die vond er plaats in 1840 onder voorzitterschap van de jonge prins Albert, de echtgenoot van koningin Victoria. Naast het schilderij plaatste Turner toen enkele regels van een gedicht dat hij reeds in 1812 had geschreven. Opnieuw blijkt dat de intellectueel Turner een erg taalvaardig was.</p>\n<p>Hoezeer Turner zich ook vrij en vlot bewoog in het intellectuele landschap van de taal, toch relativeerde hij het medium in relatie tot <em>het vermogen ervan om het echte mysterie van het bestaan te vertolken</em>. Dat toont Mike Leigh gevat in de sequentie ten huize van de Ruskins. Turner luistert er aandachtig naar een intellectueel hoogstaande conversatie over de schilderkunst van maritiemes. John Ruskin zwaait de lof over Turners kunst en zijn schilderij <em>Slave Ship</em>, nu in het bezit van Ruskin. De jonge, ambitieuze kunstcriticus stelt dat de kunst van Claude Lorrain, geplaatst tegenover die van Turner, schraal overkomt. Turner luistert aandachtig en komt slechts tussen om Lorrain een genie te noemen en om de conversatie af te breken door John Ruskin en het gezelschap terug met beide voeten op de grond te zetten. Hij vraagt droogjes of hij mijnheer Ruskin een ‘<em>enigszins moeilijk</em>’ probleem mag voorleggen. Hij vraagt hem namelijk of hij eerder een pastei van biefstuk en nier dan wel een pastei van kalfsvlees en hesp prefereert. Hiermee relativeert hij <em>de waarde van het zuiver verbaal en intellectueel spreken over het artistieke beeld</em>. Dit laatste, het beeld zelf, blijft in de optiek van de intellectueel en kunstenaar Turner <em>de alfa en omega</em>. Het intellectuele spreken, de taal van de geleerden, heeft een relatieve waarde op voorwaarde dat ze geen doel op zich wordt en zich steeds beweegt in verbondenheid met het beeld zelf, haar oorsprong en blijvende inspiratie. Tegelijkertijd herinnert Turner er het gezelschap aan dat het misschien tijd is om iets te eten. Voor hem staat <em>het eten</em> hier als de blijvende verbondenheid van de mens met zijn lichaam en met het leven zelf. Ieder spreken, hoe geleerd ook, ontleent daaraan zijn betekenis. <em>De taal ontspringt aan de bron van het leven en keert er altijd naar terug</em>.</p>\n<p>Mike Leigh vervolledig het portret van de intellectueel Turner nog via <em>de muziek</em>. Hij toont hoe Turner zich ook in dat domein op eigen wijze beweegt. Er komt een sterke muzieksequentie voor tijdens het bezoek aan Turner aan zijn belangrijke mecenas, Lord Egremont. In de scène luistert Turner aandachtig naar <em>miss Coggins</em> aan de piano. Na het stuk feliciteert Turner haar in zijn gebruikelijke, gebalde stijl, maar vol attentie: ‘<em>Exceedingly beautiful</em>’. Hij herkent de melodie maar kan ze niet noemen. Miss Coggins vertelt hem dat ze de <em>Pathétique</em> heeft gespeeld, de pianosonate nr. 8, opus 13, van Beethoven. Turner vertrouwt miss Coggins toe dat hij bijzonder veel van de muziek van <em>Henry Purcell</em> houdt. De vrouw bevestigt dat ook zij die liefde deelt en ze zet <em>Dido’s Lament</em> in. Turner herkent direct de muziek en begint onhandig maar zeer doorleefd de tekst te zingen, daarbij geholpen door miss Coggins. Tekst en muziek drukken een diep verdriet uit (‘<em>a song of lost love</em>’), een blues waarin Miss Coggins en Turner elk hun eigen persoonlijk verdriet leggen. Opmerkelijk daarbij is dat Leigh de scène met de piano plaatst vlakbij de wand waar enkele doeken met landschappen van Turner hangen. De expressie van het verdriet via de muziek krijgt haar visuele echo in de schilderijen. De scène vertolkt hoe de menselijke communicatie tussen mensen over wat hen in hun diepste wezen heeft geraakt, <em>eerder</em> via muziek en beelden dan via verbale mededelingen geschiedt.</p>\n<p>Leigh verrijkt het intellectueel portret van de historische Turner nog met enkele krachtige scènes waaruit blijkt hoe Turner zich ook <em>de christelijke cultuur</em> heeft eigen gemaakt. Vooral in de scènes met de historische collega-schilder <em>Benjamin Haydon</em> zet Leigh die christelijke dimensie in de verf. Dat gebeurt hier via de opstap van een schilderij, namelijk het doek <em>Heilige Sebastiaan getroost door een engel</em> van de Vlaming Gerard Seghers. Het is Turner die zijn twee collega’s, de schilder Haydon en de beeldhouwer Carew de legende van de martelaar Sebastiaan uitlegt en daarbij verwijst naar de nieuwtestamentische parabel van <em>de Barmhartige Samaritaan</em>. Het Sebastiaan-schilderij is de intro tot de bijzondere relatie tussen Haydon en Turner als een van de leidmotieven van het filmverhaal. Uit dat verhaal blijkt hoe Turner optreedt als een barmhartige Samaritaan tegenover zijn collega Haydon die zich miskend voelt door de kunstscene, zich in financiële nesten werkt, wegens schulden gevangenisstraf oploopt en uiteindelijk zelfmoord pleegt.</p>\n<p>Leighs rijk geschakeerd filmportret van de schilder Turner als intellectueel doet niet alleen recht aan de historische figuur zelf,maar nog meer aan diens werk. Via <em>het filmische ritme ‘buiten-binnen’</em> laat Leigh de toeschouwer toe een vermoeden te krijgen van de diepe inwendige bron van Turners inzichten en emoties, bron van zijn unieke kunst.</p>\n<p><a name=\"BET\"></a></p>\n<h2><font color=\"#808000\"><strong>Betekenisruimte</strong></font></h2>\n<p><span class=\"menstis\">LEVENSBESCHOUWING IN HET TEKEN VAN HET LICHT</span>. De Londense National Gallery noemt William Turner <a href=\"http://www.nationalgallery.org.uk/artists/joseph-mallord-william-turner\">'the painter of light’</a>. Dat is helemaal terecht. In geen enkel oeuvre uit de rijke westerse schilderkunst onderhoudt zo een intense relatie met de bron ervan, <em>het mysterie van het licht</em>. Dat mysterie krijgt in het derde deel van <a href=\"http://www.menstis.be/uitgeverij/Levensbeschouwing\">Levensbeschouwing democratisch belicht</a> de naam <em>Lichtaard</em>. Mike Leigh doet de historische Turner als <em>de grootmeester van de Lichtaard</em> alle eer aan. Dat komt in de eerste plaats door beroep te doen op zijn vaste Britse cameraman <em>Dick Pope</em> die voor zijn werk een Oscarnominatie voor beste cinematografie ontving. Opgenomen met een digitale camera, slaagt Pope van de eerste panoramische beelden erin de toeschouwer naar het landschap en de horizon te laten kijken met de ogen van Turner. Vooral de panoramische beelden hebben de signatuur van de schilderijen van Turner. De situatie waarin bepaalde schilderijen, zoals <em>Rain, Steam, and Speed – The Great Western Railway</em>, zijn ontstaan, zijn in situ gereconstrueerd. Daarbij heeft Pope vooral heel veel zorg besteed aan <em>de registratie van licht</em> zoals Turner het heeft overgebracht op zijn doeken. Pope en Leigh maken van <strong>Mr. Turner</strong> <em>een studie in de kunst van de cinematografie</em>. Ze laten zien hoe <em>de cinematografie de ultieme lichtkunst</em> is die voortbouwt op die van de grootmeesters van de Europese schilderkunst. Ze verbinden namelijk het werk van Turner aan dat van <em>Johannes Vermeer</em> (1632-1675) en <em>Caspar David Friedrich</em> (1774-1840). De eerste is de grootmeester van <em>het invallende interieurlicht</em>. Leigh-Pope herinneren eraan in het portret van mrs Booth bij het raam in de scène met de laatste dialoog tussen haar en Turner. Het onderwerp is dat van de echte menselijke schoonheid die voortkomt uit de kracht van het innerlijk. <em>Friedrich</em>, die slechts een jaar ouder was dan Turner, is <em>de Europese grootmeester van de spirituele landschappen</em>, de bezielde panorama’s met bijna onzichtbare menselijke figuren of met menselijke personages die hij schildert op de rugzijde kijkend naar de horizon. <strong>Mr. Turner</strong> brengt beide grootmeesters van het licht, Vermeer en Friedrich, samen in het portret van <em>het negentiende-eeuwse genie van het licht</em>. Tegelijkertijd legt de film ook zelf direct een verband tussen de schilderkunst van Turner en de kunst van de cinematografie. Dat gebeurt concreet in het tafereel dat zich situeert in de galerij die Turner in zijn eigen huis had ingericht. In die galerij ontving hij kunstminnende bezoekers, zoals de Ruskins. Turner organiseerde hun bezoek als <em>een bioscoopbezoek avant la lettre</em>. Eerst liet hij de bezoekers even wachten in een donkere antichambre. Na enkele minuten werd de deur naar de galerij geopend. Die baadde in het volle licht dat rijkelijk viel op de schilderijen die zelf een ode aan het licht zijn. Dit historisch correct tafereel toont heel goed aan hoe Turner in de eerste helft van de negentiende eeuw reeds cinematografisch dacht.</p>\n<p>Turners <em>licht-oeuvre</em> speelt niet alleen mee in de talrijke buitenopnames van <strong>Mr. Turner</strong>, maar ook in de vele binnenopnames ervan. Dat gebeurt in talrijke taferelen waarin Leigh toont hoe de denker Turner voortdurend bezig is met <em>zijn eigen onderzoek naar het licht</em>. Dat geldt bijvoorbeeld voor het tafereel waarin via toedoen van mrs Somerville het atelier van Turner verandert in <em>een labo voor een natuurkundig onderzoek naar de gedraging van het licht via het spectrum</em>. Tijdens dat experiment noemt mrs Somerville het licht ‘<em>God’s good sunlight</em>’. Die gedachte resoneert in de laatste woorden, volgens de overlevering, van Turner op zijn sterfbed: ‘<em>The sun is God</em>’. Daaruit blijkt Turners religieuze beleving van het zonlicht dat het leven op aarde voortbrengt. Die beleving echoot in het gesprek tussen Turner en mrs Somerville over het universum als ‘<em>a wondrous thing</em>’. Turner bevestigt mrs Sommerville haar sterk geloof ‘<em>that all things on this earth are connected. Nothing exists in isolation.</em>’ Eén van de basisbetekenissen van het woord religie is verbondenheid, aanwezig in het Latijnse <em>religare</em> dat staat voor <em>binden, verbinden</em>. Iemand als kerkvader Augustinus werkte reeds met die verbindende basisbetekenis van het woord religie. In <strong>Mr. Turner</strong> is het duidelijk dat Turner die zich daarbij helemaal op dezelfde lijn als mrs Somerville bevindt, die verbindende basisbetekenis opzoekt in <em>het mysterie van het zonlicht</em> in al zijn schakeringen zoals die zich in beweging voordoen aan de aardse beschouwer. Bij het zien van het effect van het lichtexperiment van mrs Somerville zegt Turner: ‘<em>The majesty of mystery</em>’. Het licht en de werking ervan vormen inderdaad voor Turner <em>de grootsheid van het mysterie van de Lichtaard</em>. Tegenover mrs Sommerville verduidelijkt hij nog dat de zuiverheid van haar natuurkundige prisma en wat hij ‘<em>the contamination</em>’ (besmetting, onzuiverheid) van zijn palet noemt, elkaar aanvullen. Er is het natuurlijke heldere licht en er is het zwart. ‘<em>Wit is de macht van het goede, zwart de duivel.</em>’ Met die religieuze taal bevindt Turner zich heel dicht bij de anonieme auteur van het <em>Bijbels Scheppingsverhaal van Genesis 1-2,4a</em>, in <em>Levensbeschouwing democratisch belicht</em> uitvoerig in relatie gebracht met de notie van <a href=\"http://www.menstis.be/uitgeverij/Levensbeschouwing\">de Lichtaard</a>. Turners hele leven en werk beweegt zich binnen de levensruimte van de Lichtaard. Wat dat voor hem inhoudt, vertelt Turner in de film zelf tijdens een schildersessie in het grote Petworth House van zijn mecenas Lord Egrement. Lady Stuckley is samen met twee opgroeiende meisjes getuige van de sessie. Terwijl hij aan het schilderen is, ontspint er zich een conversatie met de dames. Die handelt over het onderscheid tussen het schilderen van een zonsopgang en een zonsondergang. Turner verduidelijkt dat heel wat natuurelementen de lichtinval van het zonlicht mee bepalen. Het zonlicht is met andere woorden altijd betrokken op het aardse leven in al zijn componenten zoals de weersomstandigheden, de vochtigheid, de wind, de breekbaarheid, enzovoort. Dat inzicht motiveert Turner om onvermoeid op onderzoek uit te gaan. Al schetsend wandelt hij bijna iedere dag opnieuw in het landschap of langs de kustlijn, terwijl hij de aanwezigheid van het licht aan de hemel (‘<em>mighty Apollo’s heavenly tract</em>’), in het wolkendek, op de opspattende golven of de glooiende heuvelruggen intens beschouwt. Turner vertelt de jonge dames dat terwijl zij nog ’s morgens in bed liggen, hij al buiten is om nog voor de leeuwerik bevoorrechte getuige te zijn van de ongeschonden zonsopgang. Daarnaast is er nog het tafereel van de lezing. Het situeert zich in <em>de aula van de Royal Academy of Arts</em>. Turner is er de spreker. Voor een volle zaal geeft Turner een lezing over <em>de lichtbreking op transparante lichamen zoals bijvoorbeeld water, gekleurd glas of spiegelglas</em>. Hij legt daarbij de nadruk op het vermogen van water om de werking van het natuurlijk licht te versterken. Hieruit blijkt hoe Turners <em>onderzoekende houding</em> in <em>het grootse labo van de aarde zelf</em> de bron is van zijn inzichten in het mysterie van de Lichtaard.</p>\n<p>Turner verschijnt in <strong>Mr. Turner</strong> als het model van <em>de beschouwende mens</em>. De schilder van het licht onthult iets van het grote gave van de mens. Die bereikt immers zijn diepste wezen in <em>de praxis van de levensbeschouwing</em>. De schilder Turner beoefent die praxis op een geniale wijze. Hij vertaalt die in zijn schilderen. Hierdoor kan iedere aandachtige toeschouwer van Turners doeken nog steeds deel hebben aan die unieke praxis van levensbeschouwing. In het tafereel met het lichtexperiment van mrs Somerville ontstaat er een dialoog tussen wetenschap (fysica) en kunst. Opmerkelijk is dat de natuurkundige met lof spreekt over de visie die spreekt uit de schilderijen van Turner. De aanleiding is een gesprek over licht en kleur. Voor de natuurkundige is kleur absoluut, terwijl voor Turner kleur contradictorisch is. Hij verduidelijkt zijn inzicht in kleur gebald met de woorden ‘<em>subliem maar contradictorisch, en toch harmonisch</em>’. Daarop reageert mrs Somerville dat Turner ‘<em>a man of great vision</em>’ is. Ze licht haar punt toe: ‘<em>The universe is chaotic and you make us see it.</em>’ In de spiegel van het werk van Turner en van de film <strong>Mr. Turner</strong> kunnen we vandaag zeggen dat Turner de kunst van de levensbeschouwing als geen andere in de eerste helft van de negentiende eeuw heeft beoefend. Vanuit een intens, volgehouden contact met het mysterie van het licht dat alles wat tot het leven op aarde behoort, letterlijk aan het licht brengt, creëerde Turner zijn unieke schilderijen. In zijn levensbeschouwelijke praxis bracht hij het onophoudelijk variërend samenspel van de zeegolven en het hemellicht op de voorgrond. Zo werkte Turner die nooit aflatende dynamiek uit tot <em>een complexe levensmetafoor</em>. Hierdoor worden zijn schilderijen ramen waardoor de mens schouwend in contact komt met de grote werkelijkheid waarvan hij zelf een deel vormt. In die zin is Turner een voorloper van de <em>(postmoderne) filosofie van het leven</em> zoals die in het werk van <em>Friedrich Nietzsche</em>, een generatie na Turner, voor het eerst werd verwoord. Tegelijkertijd kondigt het werk van Turner aan dat die levensbeschouwelijke kunst en <em>de nog te ontwikkelen nieuwe of moderne fysica</em> elkaar zouden vinden in een zelfde mentale ruimte. Dat is effectief gebeurd in het begin van de twintigste eeuw via <em>Einsteins relativiteitstheorie en de kwantummechanica van Niels Bohr en Werner Heisenberg</em>. Die gedeelde levens- en lichtruimte staat in het teken van <em>de relativiteit</em>, het kosmische fenomeen dat op aarde openheid en verbondenheid waarborgt, ook in de mensenwereld.</p>\n<p><span class=\"menstis\">KUNST ALS ZOWEL SPIRITUEEL ALS DEMOCRATISCH STATEMENT.</span> De titel van de film is <strong>Mr. Turner</strong>. De ‘Mr.’ heeft een betekenis. Mike Leigh legt er vanaf het begin de nadruk op dat Turner nooit door het Britse koningshuis geëerd is met een adellijke titel. Het is dus niet Sir Turner. Leigh maakt van Mijnheer (Mr.) een eretitel. Dat is <em>een democratisch statement</em>. Het verduidelijkt hoe vanuit de zowel spirituele als intellectuele kracht van het gewone volk genieën kunnen voorkomen. Dat geldt zeker voor Turner. Daarbij legt Leigh terecht de grote nadruk op de sterke band tussen vader en zoon Turner. De zoon, William, brengt in de film hulde aan zijn vader. Die heeft in zeer moeilijke levensomstandigheden zijn zoon opgevoed. Hij heeft hem leren lezen en schrijven, en hij heeft het kind de ruimte gegeven om zijn natuurlijk tekentalent in vrijheid te ontplooien. Een ander aspect van dat democratisch statement van Mr. Turner is <em>Turners doorleefde aandacht voor het menselijke lijden</em> dat hij uitdrukt in zijn werk. Het schilderij <em>The Slave Ship</em> komt in de film herhaaldelijk ter sprake. Voorts is er het schrijnende tafereel waarin Turner de jonge prostituee schetst. De visuele echo ervan werkt nog door naar het einde van de film, waarin de doodzieke Turner toch nog zijn huis uitkomt om het aangespoelde lijk van een jonge vrouw te schetsen. In beide gevallen toont Turner via zijn schetsen <em>zijn doorleefde blijk van medeleven</em>. Turner wil als mens en als kunstenaar participeren in het menselijke lijden waarmee hij zelf vertrouwd is. Hij wil als het licht zijn dat alles, ook het pijnlijke of het donkere, in zich opneemt. <em>Die lijfelijke verbondenheid met het lijden</em> werkt door in het deelverhaal van Turners collega Haydon, evenals in het tafereel Turner en miss Coggins aan de piano met <em>Dido’s Lament</em> van Purcell. Bij dit alles is het opmerkelijk dat Turner de tragiek van het menselijk leven opneemt in <em>de levensmetafoor van de zee</em>, eigen aan het genre van de maritime. Turner schildert de zee niet als een waterlandschap. Hij is niet uit op een zuiver esthetische evocatie van het aardse fenomeen van de grote zeeën. Via zijn volgehouden schetsend onderzoek ontwikkelt hij <em>de spirituele betekenis en de levensbeschouwelijke draagwijdte</em> van de zee. Hij werkt dat beeld uit tot <em>een levensmetafoor</em>. De zee is niet enkel de watermassa, het is evenzeer de horizon met het spel van de wolken in de lucht, de rust van de stilte en het gebulder van de storm; het is ook het spel van het licht op de golven, in de regie van de getijden, zelf het werk van de planetaire krachten die voortkomen uit de bewegingen van zon en maan. In die complexe levensmetafoor van de zee, in dat visuele narratief van de zee, komt ook de aanwezigheid van de mens voor, de moderne mens die geschiedenis schrijft op het golvende blad van het leven zelf. Hij schrijft die geschiedenis met het schip dat hij over de zeeën stuurt. Met het slavenschip maakt de moderne mens van de oceaan een zee van lijden. In de film is er ook sprake van Turners <em>The Battle of Trafalgar, 21 October 1822</em>,  met Lord Nelson’s <em>Flagship, The Victory</em>. Turner schilderde het in opdracht van koning George IV. In de film vertelt het personage van Turner dat hij er twee jaar heeft aan gewerkt maar de koning het schilderij niet waardeerde. De reden daarvoor ligt voor de hand. Turner leverde geen heroïsch tafereel af. Hij maakte er een studie van over de donkere wil van de moderne mens die een geschiedenis van oorlog en geweld schrijft op de bladzijden van het fluïde levensboek.</p>\n<p>Een belangrijk aspect van Turners democratische levenshouding als kunstenaar blijkt uit het historisch getrouwe tafereel van <strong>Mr. Turner</strong>. Het situeert zich in Turners eigen galerij waar mecenas Gillott de schilder voorstelt om al zijn nog aanwezig werk op te kopen. Tijdens zijn leven kocht Turner ook schilderijen die hij eerder had verkocht, terug en bewaarde ze in zijn eigen galerij. Turner weigerde Gillotts gul aanbod. Zoals blijkt uit het tafereel in de film, besliste de kunstenaar om de grote hoeveelheid schilderijen en schetsen in zijn bezit <em>testamentair</em> over te dragen aan het Engelse volk met als enige voorwaarde dat het samen zou blijven en voor het publiek vrij toegankelijk zou worden tentoongesteld in de National Gallery. Die nalatenschap, de grootste kunstdonatie ooit, heet officieel <em><a href=\"https://www.nationalgallery.org.uk/paintings/history/the-turner-bequest\">The Turner Bequest</a></em>. Het grootste deel van de nalatenschap bevindt zich heden in de Clore Gallery in Tate Britain. Een aantal werken bevindt zich in de National Gallery.</p>\n<p><a name=\"CON\"></a></p>\n<h2><font color=\"#808000\"><strong>Context</strong></font></h2>\n<p>De film <strong>Mr. Turner</strong> ging in première in 2014. In 2016 koos de Britse bevolking met een kleine meerderheid voor de <em>Brexit</em>. Die twee gebeurtenissen hebben op zich niets met elkaar te maken. Anderzijds werpt <strong>Mr. Turner</strong> wel een bijzonder licht op <em>het fenomeen Europa</em>. De film brengt een belangrijk gegeven uit de collectieve herinnering onder de aandacht. <strong>Mr. Turner</strong> demonstreert <em>de relativiteit van de nationale grenzen</em>. Nog voor het ondenkbare werkelijkheid zou worden in de twintigste eeuw, de twee Wereldoorlogen, liet Turner zien dat de kunst zelf alle nationale grenzen overstijgt. De film opent in <em>Nederland</em>. Het incident met de rode boei handelt over het schilderij <em>Helvoetsluys – The City of Utrecht, 64, Going to Sea</em>, opnieuw een verwijzing naar Nederland. Als autodidact reisde Turner Europa rond. Tijdens zijn verblijven in Italië werkte hij in een atelier in <em>Rome</em> en zocht hij de landschappen in en rond Rome op die Claude Lorrain hadden geïnspireerd. In de periode dat <strong>Mr. Turner</strong> zich situeert, het laatste deel van Turners leven, reisde de schilder  herhaaldelijk naar <em>Venetië</em> waar hij de combinatie van architectuur, water en licht intens bestudeerde. In zijn carrière maakte hij, behalve in Nederland, ook nog schetsen en aquarellen in <em>Frankrijk, Griekenland, België en Zwitserland</em>. In zijn testament noteerde Turner dat zijn schilderijen <em>Dido building Carthago</em> en <em>Sun Rising through Vapour</em> zouden worden gehangen naast <em>Landscape with the Marriage of Isaac en Rebecca</em> van Claude Lorrain, de Franse schilder die het grootste deel van zijn leven in Italië verbleef, vooral in Rome waar hij werkte en ook is gestorven. Turner beschouwde hem over de generaties heen als zijn echte leermeester. Voor kunstenaars als Lorrain en Turner is <em>de aarde de bakermat van het leven, en is het licht een sacrale werkelijkheid</em>. Voor beiden zijn de landen met hun grenzen erg relatief, gezien vanuit de levensbeschouwelijke Lichtaard. Tijdens het leven van Turner, in de eerste helft van de negentiende eeuw, werden in Europa de kiemen gelegd voor <em>de ideologie van het nationalisme</em>. Die ideologie zou in de tweede helft van de negentiende en de eerste helft van de twintigste eeuw uitgroeien tot een monster dat de Europese volkeren tegen elkaar zou opzetten. Turner oversteeg die ideologie nog voor ze helemaal tot wasdom kwam. Hij plaatste er <em>de praxis van de levensbeschouwing</em> tegenover. Die praxis is niet onder de noemer van enige ideologie te vangen. Ze beoefent een universele, religieuze zienswijze met als focus de Lichtaard, het verbindende hemelse licht dat geen landgrenzen kent en de mens vormt tot de beschouwer van <em>de grote, religieuze Gave</em> die hem is gegeven. De Brexit zet een grote stap terug. Het komt voort uit een kortzichtigheid die helemaal vreemd is aan de Londense Europeaan Turner. Misschien is het een troost te weten dat de stad London tegen de Brexit heeft gestemd.</p>\n<p><strong>Mr. Turner</strong> evoceert een belangrijk hoofdstuk van de Europese cultuur, namelijk dat van <em>de romantische stroming</em> van eind achttiende en begin negentiende eeuw. Die stroming is erg relevant voor een goed begrip van de hedendaagse cultuur. De romantische stroming vormt immers de bakermat van wat we sinds de jaren zestig van vorige eeuw <em>de postmoderne cultuur</em> noemen. In de ontwikkeling van de romantisch stroming hebben de literaire kunst van de poëzie en de schilderkunst een hoofdrol gespeeld. William Turner heeft in die optiek een werk van eerste categorie gerealiseerd. Kenneth McConkey noteert in zijn studie over <em>het impressionisme</em> in Groot-Brittannië, verschenen in <em>Landschaft im Licht</em> (1990, 123), dat het pas in het begin van de twintigste eeuw begon door te dringen in Europese kunstkringen dat het Franse impressionisme was ontstaan op de hoeksteen van Turners werk. Maar Turners kunst overstijgt de kunsttheorie en haar soms ijdele discussies over stijlen. Turner is nooit bezig geweest met stijlconcepten. Hij onderzocht <em>de indrukwekkende lichtruimte</em> waarin al wie en wat leeft, eenmalig beweegt. De film van Mike Leigh herinnert aan de unieke persoonlijkheid van Turner en de geniale expressie van zijn werk. Zijn onderzoek naar het licht is pas in de twintigste eeuw opgenomen in de natuurwetenschappen, met name door <em>Albert Einstein</em>. Hij heeft <em>zijn bijzondere en vooral algemene relativiteitstheorie</em> immers ontwikkeld vanuit zijn doorgedreven fascinatie voor <em>het kosmische oerfenomeen van het licht</em>. Turner werkte als eerste vanuit dergelijke fascinatie en het leverde hem zijn unieke kunst op. Die ontsprong uit <em>het inzicht in het fenomeen van het licht als grondslag van het als sacraal en religieus ervaren fenomeen van het leven</em>. In het werk van Turner neemt de dynamische werking van het licht al wat leeft in zich op. De ruimte kan geen vaste grenzen meer. Er ontstaat een <em>fluïde levensruimte</em> die zich voortdurend beweegt tussen de uitersten van licht en donker, dag en nacht. Nadien zal Einstein ook de kosmische ruimte doen vloeien en Newtons visie op de absoluutheid van tijd en ruimte overstijgen. Vanuit zijn unieke sacrale beleving en praxis is Turner ooggetuige geweest van het ontstaan van <em>de Industriële Revolutie</em> met de komst van de stoommachine. In de film wordt daar in verschillende taferelen naar verwezen. Turner sloot zich niet af voor die komende revolutie. Hij registreerde het. Hij doet dat in het besef dat hij wellicht de laatste van de schilders was die nog <em>het ongerepte licht</em> in al zijn schakeringen en gedaanten op aarde kon onderzoeken en weergeven. Hij besefte dat de industriële mens met zijn machines en hun zwarte dampen de natuurlijke verschijning van het licht over het landschap en de zeeën zou wegnemen. In het tafereel in Turners eigen galerij spreekt hij over zijn schilderij <em>Hannibal and his Army Crossing the Alps</em>. Hij verduidelijkt dat hij ermee <em>de menselijke hybris</em> heeft uitgedrukt. De basisgedachte van het Griekse woord hybris is dat de mens die handelt alsof God is, zichzelf verliest in de waanzin. Turner schildert in Hannibal het beeld van de militaire heerser die meent de krachten van de natuur te kunnen bedwingen net zoals hij zijn medemens meent te kunnen onderwerpen met zijn militair geweld. Voor Turner was het Carthago van Hannibal een historische metafoor van die hybris waarvan hij de betekenis ook overdroeg naar het Britse Rijk in zijn tijd. Turner behoorde immers tot de generatie die ervan getuige was dat het Britse rijk een belangrijk deel van zijn koloniale macht in 1776 had verloren aan de nieuwe Verenigde Staten van Amerika. Het Hannibal-schilderij wordt in die zin een metafoor voor de hybris van de Industriële en Koloniale, Westerse Mens. Turner verwijst <em>profetisch</em> in een ander schilderij, <em>Sun Rising through Vapour</em>, dat ook in de film <strong>Mr. Turner</strong> een rol speelt, naar het stoomschip de <em>Titanic</em>, toonbeeld van moderne hybris, dat in 1912 naar de bodem van de oceaan zonk. Moest Turner het lot van de Titanic hebben gekend, dan zou hij van zijn <em>Sun Rising through Vapour</em> zeker een tweeluik hebben gemaakt. In de spiegel van Turners lichtwerken verschijnt de hedendaagse luchtvervuiling, direct gevolg van de Industriële Revolutie, in de eerste plaats een <em>lichtvervuiling</em>. Ze brengt levensbeschouwelijke schade toe.</p>\n<p><a name=\"LIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Links</strong></font></h2>\n<p>Voor een verdieping van de belangrijke notie Lichtaard, zie <a href=\"http://www.menstis.be/uitgeverij\">Levensbeschouwing democratisch belicht</a>. Betrouwbare data voor verdere verdieping in de persoon en vooral het werk van Turner, zie de website van de <a href=\"http://www.turnersociety.com/turner\">Turner Society</a>.</p>\n<p><font size=\"-2\">© Sylvain De Bleeckere, Men(S)tis, 2017</font></p>\n"}

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

	module.exports = {"title":"The Nativity Story","body":"<center>\n<img src=\"Nativity.1.jpg\" >\n</center>\n<p><a name=\"KLA\"></a></p>\n<h2><font color=\"#808000\"><strong>Klapbord</strong></font></h2>\n<p><strong>The Nativity Story</strong> is de derde film van Catherine Hardwicke. Zij is een architecte, maar vooral werkzaam  als Amerikaanse regisseuse en producente. Zij regisseerde tot nu vier films waaruit een bijzondere aandacht blijkt voor de leefwereld van tieners en adolescenten. Er steekt in haar films een genderaspect want op <strong>Lords of Dogtown</strong> na, is de hoofdrol altijd een meisje. In <strong>The Nativity Stor</strong> is dat het meisje Maria, vertolkt door Keisha Castle-Hughes. De opnames gebeurden in Italië en Marokko (het Atlasgebergte). De muziek is erg belangrijk in de film en is een realisatie van Mychael Danna.</p>\n<p><a name=\"SYN\"></a></p>\n<h2><font color=\"#808000\"><strong>Synopsis</strong></font></h2>\n<p>Het is de tijd dat koning Herodes met harde hand regeert over het Joodse volk van Judea met goedkeuring van de Romeinse keizer Augustus. Herodes heeft al 35 jaar lang alles onder controle maar is waanzinnig angstig dat iemand uit eigen midden hem van zijn troon zou stoten. Vooral de oude profetie over iemand uit de stam van David die in opdracht van God vrede en gerechtigheid voor het volk zou brengen, achtervolgt hem. Wanneer drie wijzen, Gaspar, Melchior en Balthazar uit het Oosten hem in Jeruzalem komen vertellen van de nakende geboorte van de Koning van de Joden te Bethlehem, beslist hij alle mannelijke kinderen van twee jaar en jonger te doden. Hij weet echter niet dat de hoogzwangere Maria te Bethlehem bevallen is van Jezus, het kind dat haar via de boodschap van de engel Gabriël is voorzegd. De drie wijzen brengen eer aan het kind. Jozef van Judea, de man van Maria wordt in een droom gewaarschuwd. Hij vertrekt op tijd met Maria en hun kind uit Bethlehem. Ze ontkomen en bereiken veilig Egypte.</p>\n<p><a name=\"CIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Cinematografie</strong></font></h2>\n<p><span class=\"menstis\">INCLUSIE</span>. De introductie met beelden van de nachtelijke sterrenhemel boven de wolken en de daaropvolgende neerwaartse beweging — van de hemel door het wolkendek heen naar de aarde — eindigt in Jeruzalem. Dan volgt de eerste reeks van sequenties in het paleis van Herodes. Daar beveelt de wrede koning de kindermoord te Bethlehem. Na de beelden van de soldaten die in de avond de huizen binnenvallen en de kleine jongentjes ombrengen, maakt het verhaal een terugkeer in de tijd. Het lange middenluik met Maria, Jozef en de drie wijzen tot en met de geboorte van het kind Jezus te Bethlehem mondt uit in de kindermoordsequenties. Die worden nu anders dan in het begin opgebouwd. Dat leert dat Hardwicke het kerstverhaal heeft willen vertellen via de verhaalstructuur van <em>de inclusie</em> die door toedoen van het <em>Marcusevangelie</em> een gebruikelijke verteltechniek is van de synoptische evangelies. De inclusie met de infanticide te Bethlehem komt zelf niet voor in de nieuwtestamentische geboorteverhalen. De regisseuse geeft met die inclusie een eigen en contrastrijke dimensie aan de geboorte van Jezus te Bethlehem. Een betekenisvolle, filmische lezing van het gekende Bijbelverhaal.</p>\n<p><span class=\"menstis\">KOORMZUIEK</span>. De muziek speelt een belangrijke rol in de sferische werking van <strong>The Nativity Story</strong>. Van de 101’ speelduur zijn er ongeveer 85’ minuten met muziek. Componist Mychael Danna koos voor een orkestscore met een groot koor. Hij beschikte over een symfonisch orkest van 70 leden. In nauw overleg met Catherine Hardwicke heeft hij er niet voor gekozen om muziek te zoeken die de historische tijd, het jaar nul van onze tijdrekening, wil suggereren. De beelden zelf volstaan om de toeschouwer het gevoel te geven dat hij getuige is van de gebeurtenissen op het ogenblik dat ze zich voordeden. Met de muziek daarentegen wil de componist een muzikale brug bouwen van de toenmalige gebeurtenissen (de beelden) naar de huidige wereld (de klanken). In de score gebruikt hij namelijk gegevens uit de oude muziekcultuur die het oorspronkelijke verhaal over de generaties zingend en spelend heeft doorgegeven. Daarom gebruikt hij bijvoorbeeld instrumenten en koortechnieken uit <em>de middeleeuwen en de renaissance</em>. De gezongen muziek, te beginnen met de openingsbeelden waar het kerstlied <em>‘Veni, Veni Emmanuel’</em> weerklinkt, zijn in het Latijn. Hij gebruikt voor de vele koorliederen gregoriaanse melodieën en melodieën van oude kerstliederen. Zo integreert hij in de compositie voor de aankondiging van de kindermoord door Herodes het Engelse <em>‘Coventry Carol’</em>, afkomstig uit een Engels kerstspel van de 15de eeuw. <em>‘Corde natus ex parentis’</em> weerklinkt bij de geboorte van Johannes, de zoon van het oudere koppel Elizabeth en Zachariah. <em>‘Rosa Aeterna Floret’</em> begeleidt de eindgeneriek. Daarvoor komt het herkenbare <em>Silent Nox</em>, het in het Latijn gezongen <em>‘Stille Nacht, Heilige Nacht’</em> bij de beelden van de vlucht naar Egypte. Voor de meer emotionele scènes gebruikt Danna de gebruikelijke moderne orkestscore met strijkers.</p>\n<p><span class=\"menstis\">PARALLELMONTAGE</span>. Binnen het grote middenluik van de inclusie realiseert Hardwicke een lang uitgewerkte parallelmontage. Concreet lopen twee verhaallijnen naast elkaar en tevens onafhankelijk van elkaar. De gebeurtenissen verlopen in de ruimte en de tijd zonder op elkaar in te spelen. Er is namelijk <em>het verhaal in Nazareth en dat in Perzië</em>. In het eerste spelen Maria en Jozef de hoofdrol, terwijl in het tweede de drie wijzen op het voorplan staan. In Bethlehem vloeien de twee verhaallijnen in elkaar over.</p>\n<p><span class=\"menstis\">KLEUR EN LICHT</span>. De sequenties met Herodes en de kindermoord zijn vooral in het donker gefilmd. Ze verbinden Herodes met duistere krachten. De talrijke taferelen met Maria en Jozef in hun natuurlijke omgeving en met de ezel waarmee ze reizen naar Bethlehem en nadien naar Egypte, zijn niet in volle kleuren gefilmd. Dat zou immers erg sentimenteel en romantiserend overkomen. Hardwicke heeft ervoor gekozen om de gebeurtenissen zo in beeld te brengen alsof ze zich voor het eerst voltrekken. Ze vermijdt hiermee iedere verwijzing naar het theatergenre van het kerstspel. Vandaar de keuze om alles te situeren in een natuurlijke omgeving die gemakkelijk de sfeer evoceert van het Judea van het begin van de christelijke tijdrekening. De regisseuse versterkt dat effect nog door de kleuren te filteren zodat zelfs <em>een zwart-wit effect ontstaat</em>. Zelfs het woestijnzand kleurt niet geel. Sommige sequenties ogen daardoor alsof ze <em>in sepia</em> zijn gefilmd. De kleding van de personages is daaraan aangepast: soorten van witte en soorten van donkere tinten overheersen. Maria is daarbij altijd in een gebroken wit gekleed. De engel Gabriël verschijnt in een helder wit gewaad in een donkere omgeving. Dat hemelse helder wit sluit aan bij de <em>talrijke beelden in vogelperspectief van de hemelse lichtstroken</em> die hoog vanuit de hemel naar de aarde stralen. De regisseuse evoceert hiermee de vaderlijke betrokkenheid van God zelf op het gebeuren dat zich in Judea afspeelt. Het grote panoramische slotbeeld met in de verte de Egyptische piramiden is gecomponeerd met een opgaande camerabeweging die vanuit de aarde vertrekt en stilstaat bij een volledig verticaal shot van de hemel van waaruit lichtbundels naar beneden schijnen. Een lichtend orgelpunt op de tonen van ‘<em>Stille Nacht, Heilige Nacht</em>’. Een gedurfde, maar veelzeggende compositie. In de beeldvorming van de hemelse lichtbundels heeft Hardwiche zich duidelijk laten inspireren door de gekende bijbelillustraties van <em>Gustave Doré</em>. Picturaal brengt de film een mooie hulde aan deze grote illustrator.</p>\n<p><a name=\"BET\"></a></p>\n<h2><font color=\"#808000\"><strong>Betekenisruimte</strong></font></h2>\n<p><span class=\"menstis\">INCARNATIEMOTIEF</span>. <strong>The Nativity Story</strong> heeft zijn eigen plaats veroverd in het subgenre ‘Jezusfilm’ van het rijke genre ‘Bijbelfilm’. De film blijft trouw aan de gegevens van de Bijbel. De synoptische evangelies vormen de concrete beeldbron. Het gegeven van de engel Gabriël werd bijvoorbeeld niet uit het scenario weggeschreven. In de openingsbeelden wordt <em>Jer. 23, 5-6</em> geciteerd en in de slotsequenties spreekt Maria in voice-over het <em>Magnificat (Lc 1, 47-54)</em> uit. Dit laatste hoort thuis in het tafereel van het bezoek van Maria aan Elisabeth, terwijl Hardwicke het laat horen in de slotbeelden van de vlucht naar Egypte. Als een soort synthese van de betekenis van alles wat zich heeft afgespeeld. Juist door de inclusievertelling met de kindermoord onderlijnt Hardwicke dat het mysterie van Gods aanwezigheid niet in de dood maar de geboorte van het kind te vinden is. Dat is wat de herders en de wijzen ontdekken, en wat Maria en Jozef van zeer nabij beleven. Daarom verwoordt Maria na de geboorte aan de herders <em>het credo voor een hedendaags publiek</em>: ‘<em>Hij is geboren voor de hele mensheid. Ons allemaal is een geschenk gegeven.</em>’ De drie wijzen belijden bij een inzoom op de pasgeboren baby: '<em>God is vlees geworden/ God made into flesh</em>. Het christelijke narratief van de <em>Incarnatie</em> vormt de theologisch leiddraad van de film. In de geboortescène is er een zeer nauwe band tussen de blik van Maria en de hemelse lichtbundel van de Ster van Bethlehem.</p>\n<p><span class=\"menstis\">BLIJVEND BIJBELBEELD</span>. In het blikveld van <strong>The Nativity Story</strong> verschijnt het kerstverhaal als <em>een onsterfelijk verhaal dat blijvend inspireert</em>. Het bevat talrijke taferelen die bijzonder beeldend zijn en in het verleden ontelbare generaties heeft geïnspireerd om ze zelf in scène te zetten. Zonder ze te imiteren, sluit Hardwicke aan bij die eeuwenoude <em>volkscultuur</em>. Door creatief gebruik te maken van de hedendaagse filmmiddelen vertelt ze het verhaal alsof het nu aan het gebeuren is. Dat is de magie van het cinematografische beeld. En via <em>de originele klankband</em> verbindt ze toch het verhaal met zijn werkingsgeschiedenis die zich heeft gematerialiseerd in een schat aan populaire liederen, woorden en melodieën.</p>\n<p><span class=\"menstis\">FEMINIENE TOUCH</span>. Wellicht kan vandaag enkel een vrouwelijke cineast zo consequent kiezen voor het personage van <em>het jonge meisje Maria</em> en juist daardoor ook voor <em>het vergeten personage van Jozef</em> die hier helemaal tot zijn recht komt. Hardwicke plaatst namelijk het jonge meisje in de Joodse context van toen waar uithuwelijking op jonge leeftijd de algemene regel was (wat vandaag als in strijd met de wet zou worden gezien). In <strong>The Nativity Story</strong> schildert de regisseuse Maria en Jozef in een eenvoudig maar zeer gelovig Joods milieu en reflecteert over de moeilijkheid die de ‘vreemde’ zwangerschap van de nog ongehuwde Maria concreet moeten hebben teweeg gebracht. Vandaar het belang van en <em>de waardering voor de figuur van Jozef</em>. Niet toevallig zegt Maria na de geboorte van Jezus dat ze daartoe in staat is geweest <em>‘dankzij de kracht van God’</em> en, zo voegt ze eraan toe kijkend naar Jozef, ‘<em>en dankzij u</em>’.  In de patriarchale samenleving van toen was de attente aanwezigheid van Jozef onontbeerlijk. De eigen <em>feminiene benadering</em> leidt er ook toe dat de episode van de drie wijzen veel aandacht krijgt. Het is een verhaal in een verhaal geworden waarbij Hardwicke niet nalaat op <em>de universele betekenis van de geboorte van Jezus voor alle culturen</em> te wijzen. Het is trouwens de zwarte Melchior die zijn collega’s vraagt om hun ervaring van Bethlehem voor zichzelf te houden en niet bekend te maken aan Herodes. <em>Het beeld van de drie wijzen</em> krijgt hier in een mondiale samenleving een actuele belichting. De grote oude namen voor koning (‘<em>goud</em>’) en priester (‘<em>wierook</em>’), functies verbonden met grote macht in het verleden, worden door de wijzen aan een pasgeboren baby toegezegd onder hemelse belichting. Het derde geschenk (‘<em>mire</em>’) opent echter de betekenis van ‘<em>de goddelijke macht van de kwetsbaarheid</em>’ en verwijst in plaats van naar macht naar <em>het offer</em>. De machtfiguren van de koning en de priester krijgen hun actuele blijvende betekenis in de figuur van ‘<em>de dienaar</em>’. De figuren van Maria en Jozef zijn van dit laatste de concrete voorafbeeldingen.</p>\n<p><a name=\"CON\"></a></p>\n<h2><font color=\"#808000\"><strong>Context</strong></font></h2>\n<p><strong>The Nativity Story</strong> kan ook worden gezien als een antwoord op de zeer bloedige en wrede verfilming van het passieverhaal door <em>Mel Gibson</em> in diens <strong>The Passion of the Christ</strong> (2004). In die film verschijnt vooral God zelf als een op bloed beluste vaderfiguur en treedt Jezus op als een sadomasochistische superheld. Bij <strong>The Nativity Story</strong> blijft <em>het mysterie van Gods bestaan veel dichter bij de concrete, menselijke ervaring</em>. De wreedheid is hier het werk van koningen die gewone mensen uitbuiten en er niet voor terug schrikken kinderen om te brengen.</p>\n<p><a name=\"LIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Link</strong></font></h2>\n<p><em>Leren Leven Met Beelden</em>, nr. 16 (2010),19-22.</p>\n<p><font size=\"-2\">© Sylvain De Bleeckere, Men(S)tis, 2011/2017</font>.</p>\n"}

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

	module.exports = {"title":"The New World","body":"<center>\n<img src=\"newworldkl.jpg\" >\n</center>\n<p><a name=\"KLA\"></a></p>\n<h2><font color=\"#808000\"><strong>Klapbord</strong></font></h2>\n<p><strong>The New World</strong> is de vierde langspeelfilm van Terrence Malick. Voor de <em>Academy Awards</em> editie 2006 kreeg hij een Oscarnominatie in de categorie van de cinematografie (Emmanuel Lubezki). Maar die bescheiden erkenning weerspiegelt niet de eigenlijke en unieke waarde de film. In het voorjaar van 2006 vroeg Jeffrey M. Anderson in San Francisco aan de Duitse regisseur Wim Wenders, een autoriteit in de Europese filmwereld, of er hem recente films of regisseurs waren opgevallen. Hij antwoordde: <em>“I saw one of the greatest films of my life not so long ago, and I’ve now seen it four times. For me it’s one of those movies above everything in the Oscars, and there were some great movies, but it was in a class by itself, way above all of it, and that was The New World, Terrence Malick’s movie.”</em> De wondermooie film van Malick past in het kader van de grote viering in 2007 van <em>de 400ste verjaardag</em> van het begin van de huidige Verenigde Staten bij de stichting van de eerste blanke kolonie Jamestown.</p>\n<p><a name=\"SYN\"></a></p>\n<h2><font color=\"#808000\"><strong>Synopsis</strong></font></h2>\n<p>Midden mei 1607 zien de Powhatans iets wat meer dan hun gewone aandacht trekt. Langs de oever van de James River meren drie boten met 104 vreemdelingen aan boord aan. De indianen zijn zeer nieuwsgierig en angstig tegelijk. De vreemde bezoekers zijn blank, ze dragen kleren over het hele lichaam en brengen onverstaanbare klanken voort. De jonge indiaanse prinses voelt zich sterk aangetrokken door het hele gebeuren, vooral wanneer haar oog valt op kapitein John Smith. Geleidelijk ontstaat er een sterke band tussen beiden. Hetzelfde kan niet gezegd worden van de twee gemeenschappen: de Engelse kolonisten en de inheemse indianen. Het eerste wederzijdse wantrouwen groeit uit tot een gewelddadige krachtmeting die de indianen door hun gebrek aan vuurwapens niet kunnen winnen. Ondertussen doorkruist de wederzijdse affectie tussen de inheemse prinses en Smith de lotgevallen van het koloniale James Fort. De prinses redt de blanke fortbewoners in de koude wintermaanden van de hongerdood. Smith beseft dat hij in de gegeven omstandigheden zijn relatie met de prinses moeilijk kan volhouden. Hij vertrekt terug naar Engeland om een nieuwe expeditie te leiden en laat de prinses in de waan dat hij op zee is omgekomen. Zij rouwt. Op haar beurt ondervindt ze de negatieve gevolgen van haar band met Smith en de kolonisten. Haar vader Powhatan verbant haar. Ze komt uiteindelijk als gijzelaar terecht in het fort van Jamestown waar ze de jonge weduwnaar en planter John Rolfe leert kennen. Hij vraagt haar ten huwelijk. Ze krijgt de christelijke doopnaam Rebecca. Ze helpt haar man met de succesrijke uitbouw van zijn tabaksplantage. Ze wordt moeder van Thomas. Op een dag vaart het gezin Rolfe naar Engeland. Prinses Rebecca wordt door niemand minder dan de Engelse koning en koningin met grote eer ontvangen. Juist voor haar terugkeer naar haar moederland wordt ze ziek en sterft ze.</p>\n<p><a name=\"CIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Cinematografie</strong></font></h2>\n<p><span class=\"menstis\">WATERSPIEGEL</span>. Wat Malicks <strong>The New World</strong> tot een unieke cinematografische ervaring maakt, zijn de cinematografische methode en de filosofische visie ervan. Het openingsbeeld is meteen het logo van de film: de waterspiegel. Er ontstaat een vloeibaar beeld dat contrasteert met een stabiel en statisch beeld. Er beweegt altijd wel iets, volkomen stilstand komt niet voor. Vanuit dat beeld vertrekt er een hele fluïde klankwereld. De natuurlijke muziek van vogels en kikkers, de cultuurmuziek van <em>Vorspiel</em> tot <em>Das Rheingold</em>, het eerste deel van de monumentale opera <em>Der Ring des Nibelungen</em> van Richard Wagner. Daarbij voegt zich de menselijke stem.</p>\n<p><span class=\"menstis\">VOICE-OVER</span>. Malick is zonder enige twijfel de meester van de voice-over. De woorden verklanken het innerlijk dat zich beweegt in de denkruimte van het gebed en de meditatie. De naakte registratie van gesprekken in functie van de voortgang van de dramatische vertelling, hoort niet thuis in Malicks methode. De vertelwijze voltrekt zich via beeldenreeksen die hij in de montagekamer componeert. Tijdens het lange montageproces neemt hij de voice-over stemmen op. Ze worden daar een deel van <em>een vloeiend klank- en beelduniversum</em>.</p>\n<p><a name=\"BET\"></a></p>\n<h2><font color=\"#808000\"><strong>Betekenisruimte</strong></font></h2>\n<p><span class=\"menstis\">DENKMEDIUM</span>. De fluïde cinematografie van Malick krijgt haar volle betekenis vanuit de filosofische visie ervan. Malick benadert film niet alleen als een volwaardig kunstmedium, maar evenzeer en tegelijk als een volwaardig denkmedium. Hij is in alle opzichten <em>een filmische denker</em>. Zijn personages zijn geen zuivere dramatische karakters. Ze participeren aan de actie, ze staan er zelfs midden in, maar tegelijkertijd bewegen zich op de zijlijn van die actie. Ze <em>beschouwen wat er gebeurt en hen overkomt</em>. De drie sleutelpersonages van <strong>The New World</strong>  bewegen ze zich in dezelfde cirkel. Ze hebben een innerlijk leven. Ze kennen een spiritueel bewustzijn.</p>\n<p><span class=\"menstis\">ELEGIE</span>. De film is filosofisch geschreven in de toon van <em>de elegie</em>. Malick legt over de historische vertelling het rouwkleed van de herinnering aan de verloren droom van een nieuw begin, van een nieuwe wereld. Het muzikaal openingscitaat van <em>Das Reingold</em> bevat al de rouwklanken waarop de hele cyclus van <em>Der Ring des Nibelungen</em> op uitloopt, het apocalyptische slotdeel van <em>Götterdämmerung</em>, de ineenstorting van een hele beschaving. Filosofisch thematiseert Malick eveneens die <em>ondergang van de droom van de Nieuwe Wereld</em>. Die sterft bij de dood van de prinses. Wanneer zij sterft, verdwijnen de goede krachten die Smith het leven hebben gered waarna er een echte ontmoeting en een wederzijdse verrijking konden ontstaan. Op dit punt spreekt Malick duidelijke taal. De Europese cultuur was niet in staat om het nieuwe te zien en te begrijpen wat er gebeurde. De kolonisten beroepen zich op hun christelijk geloof om de anderen, de vreemden, als gevaarlijke en onbeschaafde duivels te bestempelen die verdienen van naar de diepten van de hel te worden gezonden. Maar wat <em>de christelijke goedheid</em> zou moeten zijn, treffen we aan bij de prinses. Zij brengt in het midden van de harde winter voedsel naar het fort zodat de overlevende vreemdelingen de winter kunnen doorkomen. Maar uit die goedheid trekken ze geen lessen.</p>\n<p><a name=\"CON\"></a></p>\n<h2><font color=\"#808000\"><strong>Context</strong></font></h2>\n<p>De filosofische kritiek die vanuit <strong>The New World</strong> uitgaat, naar de hedendaagse Amerikaanse beschaving is niet te onderschatten. Malick laat zien dat het fundament van de Verenigde Staten niet in de eerste plaats de <em>democratie</em> is, zoals geproclameerd in <em>The Declaration of Independence</em>. De onmogelijkheid van de blanke, Europese kolonisten om andere culturen te ontmoeten in een wederzijds respect en verrijking ― relatie prinses-Smit, relatie Rebecca-Rolfe ― vormt het fundament van een beschaving die nog steeds getuigt van dezelfde onmogelijkheid. <strong>The New World</strong> ontstaat vanuit een filosofische visie die de andere cultuur, de indiaanse, tot <em>lerares</em> promoveert. Die lerares krijgt gestalte in de natuurfiguren van de zon en moeder aarde, metaforisch verdicht in het stromende water en de hoge bomen wier kruin naar de hemel reikt en wier wortels in de diepte van de aarde zijn verankerd. De indiaanse lerares zegt: <em>Mens, luistert naar jouw Moeder</em>. Die stem weerklinkt in een politiek landschap dat, op het ogenblik dat de film verscheen, nog werd bepaald door een regering die zich niets gelegen lliet aat aan de internationale milieuakkoorden en die ervoor pleitte om in beschermde natuurgebieden economische boringen toe te laten. De blindmakende goudkoorts woekert nog altijd voort in de ziel van heel wat erfgenamen van de koloniale Europeanen die 400 jaar geleden in Jamestown aan land zijn gegaan. Daardoor lijden ze nog steeds aan een erge vorm van <em>spirituele blindheid</em>, niettegenstaande hun luide belijdenis van het christelijk geloof. Het <em>zelfkritische rouwproces</em> waarvan <strong>The New World</strong> getuigt, richt zich op het blijvende filosofische onvermogen om als Amerikaanse blanke collectiviteit het goede en waardevolle te kunnen denken, evenals op het onvermogen om dankbaar te kunnen zijn tegenover de echte en historische ‘lerares’. De droom van een Nieuwe Wereld ligt in de visie van Malick veel meer in de toekomst dan in het verleden en heden.</p>\n<p><a name=\"LIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Link</strong></font></h2>\n<p>Sylvain De Bleeckere schreef een uitgebreide studie in <em>Men(S)tis’ Studies # 2:Het aards paradijs als zinnebeeld</em>. Klik <a href=\"http://www.menstis.be/blog/\">hier</a> voor een kennismaking.</p>\n<p><font size=\"-2\">© Sylvain De Bleeckere, Men(S)tis, 2011/2017</font>.</p>\n"}

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

	module.exports = {"title":"PilgrImage","body":"<center>\n<img src=\"pilgrim.jpg\" >\n</center>\n<p><a name=\"KLA\"></a></p>\n<h2><font color=\"#808000\"><strong>Klapbord</strong></font></h2>\n<p>De kortfilm <span style=\"color:blue\"><strong>PilgrImage</strong></span> - bekijk <a href=\"http://www.menstis.be/producties/Agora/AgoraMovies/\">hier</a> de film - is een kleine, onafhankelijke productie van Men(S)tis (Hasselt), in samenwerking met Yot (Brugge). Het concept is van Sylvain De Bleeckere. De regie is een gemeenschappelijk werk van Sylvain De Bleeckere en Kristof Hoornaert.</p>\n<blockquote>\n<p>Met minimale middelen en veel creativiteit maakten ze de opnames in de <em>Heilige-Magdalenakerk</em> (Brugge) op 25 juni 2018, met in de hoofdrol het kerkgebouw en tal van vaste en tijdelijke beelden. Het filmpje ging in première op <em>de website van Men(S)tis</em> op 3 juli 2018. De opnames kaderden in het <a href=\"http://www.menstis.be/producties/Agora/\">Project Agora</a> (Brugge, mei-september 2018).</p>\n</blockquote>\n<blockquote>\n<p>Enkele kunstwerken die in het kader ervan werden gerealiseerd en getoond, spelen een hoofdrol in <span style=\"color:blue\"><strong>PilgrImage</strong></span>. De regisseurs gebruikten de tentoonstelling als een filmset. Het toont de volgende beelden uit de Agora-expositie: <em>Humana</em> van Marleen Mertens en in volgorde van verschijning de volgende werken van Jan De Wachter: de tekening <em>Madonna en de slapende geliefde</em>, het doek <em>Verlatenheid</em>, de beelden <em>Solus</em> en <em>De traan</em>, het tapijt <em>Liefdeslabyrint - Allegorie van het leven</em>, de bewerkte botscan <em>Ecce Homo</em> en het schilderij <em>De Madonna van de Tederheid</em>.</p>\n</blockquote>\n<blockquote>\n<p>Kristof Hoornaert bediende de <em>camera</em> van een eenvoudig Panasonic fototoestel, en verzorgde, in overleg met Sylvain De Bleeckere, de montage.</p>\n</blockquote>\n<blockquote>\n<p>De <em>sounddesign</em> is een gemeenschappelijk concept van  Sylvain De Bleeckere en Jan De Wachter, technisch gerealiseerd door Mark Vercnocke, en met de stem van de Russische componist Alexander Knaifel.</p>\n</blockquote>\n<blockquote>\n<p>Geert Delbeke van Yot assisteerde tijdens de opnames.</p>\n</blockquote>\n<blockquote>\n<p>Het filmpje is opgedragen aan ― de kort voor de opnames ― overleden <em>Patrick Perquy</em>, priester-leraar, romanist, bijbelkenner, cinefiel, mentor en medewerker van Yot.</p>\n</blockquote>\n<p><a name=\"SYN\"></a></p>\n<h2><font color=\"#808000\"><strong>Synopsis</strong></font></h2>\n<p>Een pelgrim (m/v) komt aan in een katholieke kerk. De pelgrim neemt verwonderd het kerkgebouw in zich op en merkt onmiddellijk dat zijn vertrouwde beeld van een kerkgebouw niet helemaal klopt. De kaarsen aan de zuilen branden, maar er is geen kerkdienst aan de gang. Er bevindt zich een watervlak in het religieuze gebouw. Daarop staat een vrouwelijke figuur in het wit met een donkerblauwe kroon. Ze lijkt op een verschijning. De pelgrim neemt het beeld van de witte vrouw in zich op en vervolgt daarna een eigen pad doorheen de kerk. Enkele beelden gidsen de pelgrim. Net voor het betreden van het koor stapt hij op een tapijt met een labyrint. De verwondering neemt toe. Het priesterkoor waar het grote altaar zou moeten staan, is helemaal leeg. De pelgrim kijkt even rond, zoekt, ziet aan de oostelijke muur van het koor een beeld van een skelet. Plots ziet de pelgrim links een open deur met een kleine zwarte gang. Hij stapt er naar toe. Dan ontdekt de pelgrim de verborgen kamer waar twee kaarsen branden bij het grote hedendaagse schilderij met een honinggele kleur en het silhouet van de Madonna met Kind.</p>\n<p><a name=\"CIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Cinematografie</strong></font></h2>\n<p><span style=\"color:darkkhaki\"><strong>VOETSTAPPENMOVIE IN TRIPTIEKVORM</strong></span>. De <em>proloog</em> van <span style=\"color:blue\"><strong>PilgrImage</strong></span> opent met een triptiek. Centraal verschijnt het beeld <em>Humana</em>, symmetrisch gekadreerd in de neogotische binnenzijde van de deuropening van de kerk. Links en rechts zijn bewegende beelden van het water waarop <em>Humana</em> zicht bevindt. Links weerspiegelt een brandglasraam het zonlicht dat speelt op het rimpelende wateroppervlak. Rechts kleurt het water blauwig door de weerkaatsing van het kleed van <em>Humana</em> op de waterspiegel. Dat blauw ontstaat door de werking van de spots die mede <em>Humana</em> belichten. De pelgrim (m/v) hoort het ruizen van de wind en het stromen van het water.</p>\n<blockquote>\n<p>Dan volgt er een <em>fade out</em> naar een zwart totaalbeeld waarop de titel verschijnt. In het midden van het Engelse woord <em>pilgrimage</em> staat de hoofdletter <em>I</em> waardoor er een woordbeeld ontstaat waarvan het tweede deel bestaat uit het woord <em>Image</em> (het Engelse woord voor <em>beeld</em>).</p>\n</blockquote>\n<blockquote>\n<p>Uit het donker van de <em>nieuwe fade out</em> na de titel verschijnt de triptiek terug. Van dan af begint het pad van de pelgrim. Zijn stem weerklinkt op de geluidsband. Hij bidt het Mariagebed in het Russisch. Bij de eerste woorden van het gebed - de aanspreking <em>Maria</em> - komen links en rechts details van de tekening <em>Madonna en de slapende geliefde</em> in beeld. Zo wordt het beeld <em>Humana</em>, nu gefilmd op de rug tegen de achtergrond van het priesterkoor met de grote glasramen, gekoppeld aan dat van de <em>Madonna</em>. De triptiek brengt beide beelden samen. <em>Humana</em> wijst de pelgrim naar de richting van het priesterkoor waar zich in een zijkapel de <em>Madonna van de Tederheid</em> bevindt.</p>\n</blockquote>\n<blockquote>\n<p>De pelgrim legt nu de weg af van <em>de zuidelijke ingang van de kerk naar het noordelijke eindpunt</em>, het priesterkoor. Hij volgt de rechtergang. Het midden van de filmtriptiek toont zijn pad. Links en rechts begeleiden hem enkele beelden die in het teken staan van verdriet en lijden: <em>Verlatenheid</em>, <em>Solus</em> en <em>De traan</em>. De pelgrim beschouwt de sculptuur van de wenende man bij de boom (<em>De traan</em>) en eindigt zijn gebed met ‘<em>Amen</em>’.  Van dan af keren het geluid van de wind in de bomen en dat van de golven van de zee terug tot aan het slotbeeld.</p>\n</blockquote>\n<blockquote>\n<p>Ondertussen eindigt de beschouwing van het beeld <em>De traan</em> met <em>een nieuwe fade out</em> naar een volledig donker beeld. Dan licht de triptiek terug op met in het midden het tapijt <em>Liefdeslabyrint - Allegorie van het leven</em>, de zijkanten blijven donker. De pelgrim verkent het labyrint en zoekt zijn weg. Dan lichten links en rechts de wegwijzers op: links het glasraam met de heilige Maria Magdalena en rechts het houten beeld van dezelfde heilige maar in een andere positie. Telkens voltrekt er zich een <em>verticale</em> beweging richting naar boven, terwijl de blik van de pelgrim nog neerwaarts richting tapijt op de grond is gericht. De opwaartse beweging van de zijpanelen begeleidt in het middelpaneel de blik van de pelgrim richting het priesterkoor waar het licht door de glasramen schijnt.</p>\n</blockquote>\n<blockquote>\n<p>Nu bevindt de pelgrim zich in een nieuwe ruimte die hij verwonderd verkent. Hij ziet echter enkel de leegte van het priesterkoor en het beeld <em>Ecce Homo</em> dat getuigt van ziekte en lijden. De beelden van de zijpanelen zijn nu helemaal donker geworden.</p>\n</blockquote>\n<blockquote>\n<p>Na enige aarzeling merkt de pelgrim een <em>open gang</em> die helemaal donker is. Hij stapt de donkerte in. <em>Fade out</em>. Ook het beeld ‘kleurt’ (opnieuw) donker.</p>\n</blockquote>\n<blockquote>\n<p>Dan licht uit die duisternis de <em>epiloog</em> van <span style=\"color:blue\"><strong>PilgrImage</strong></span>. Het is een totaalbeeld op met de <em>Madonna van de Tederheid</em> die zich in de kamer bevindt die de pelgrim heeft betreden via de donkere gang. De triptiek is weg, er is nu enkel het statische totaalbeeld met de <em>Madonna van de Tederheid</em> en de twee brandende kaarsen. De camera neemt de positie in van de beschouwende pelgrim die aan het einde van zijn weg is gekomen.</p>\n</blockquote>\n<blockquote>\n<p>Laatste <em>fade out</em>. Dan volgt nog het beeld met eindgeneriek.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>SOUNDDESIGN</strong></span>. <span style=\"color:blue\"><strong>PilgrImage</strong></span> heeft een autonome klankband die zelf als een triptiek is opgebouwd. Er komen geen geluiden voor van de stappende pelgrim (m/v). Wel begeleidt een eigen soundtrack zijn weg in de kerk.</p>\n<blockquote>\n<p>Die bestaat in hoofdzaak uit het in <em>het Russisch gebeden Mariagebed</em>. Dat vormt het middendeel van de klankband. De keuze van het gebed is van kunstenaar Jan De Wachter die het als kind van zijn vader heeft geleerd. De Nederlandse tekst is de volgende:</p>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><span style=\"color:olive\"><em>Heilige Maria, vol van tedere toewijding. Gedenk dat nooit iemand tevergeefs tot u zijn toevlucht nam, uw hulp inriep, om uw bijstand verzocht. Vervuld van dat vertrouwen in u, kom ik tot u, nader ik, sta ik smekend voor uw voeten. O, Moeder van het vleesgeworden Woord, versmaad mijn gebeden niet, aanhoor mijn smeken en wees mij genadig. Amen</em></span></p>\n</blockquote>\n</blockquote>\n<blockquote>\n<p>Dat middendeel van de klankband wordt geflankeerd door een klankmontage van het <em>geluid van de wind die waait in hoge bomen en dat van de golven van de zee</em>. Die montage begeleidt de proloog van het filmpje, alsook de sequenties die volgen na de beschouwing van <em>De traan</em> en leiden naar de kamer met <em>De Madonna van de Tederheid</em>.</p>\n</blockquote>\n<h2><font color=\"#808000\"><strong>Betekenisruimte</strong></font></h2>\n<p><span style=\"color:darkkhaki\"><strong>HET KERKGEBOUW ALS FEMINIENE ZONE VAN ZIN</strong></span>. In <span style=\"color:blue\"><strong>PilgrImage</strong></span> komen er geen mensen in beeld. Er is enkel de aanwezigheid van de pelgrim (m/v) via de subjectieve camera. Alle beelden vloeien voort uit zijn beschouwende blik. Het kerkgebouw verschijnt als het hoofdpersonage met een eigen identiteit. Met haar ruimtelijk, beeldend wezen toont de kerk zich als <em>een unieke zone van zin</em>. Het gebouw is veel meer dan een verzameling stenen, geordend volgend een bepaalde hoogte, lente en breedte. ‘<em>Is</em>’ is te weinig gezegd. De kerk is niet, ze <em>doet</em>, ze <em>handelt</em>, ze <em>ontplooit</em> een eigen werking. Dat ervaart de pelgrim vanaf het eerste moment van zijn aanwezigheid in het gebouw.</p>\n<blockquote>\n<p>De kerk ontvangt de pelgrim die aan het einde van zijn tocht is aangekomen in de kerk. Van die gastvrijheid getuigt de <em>openheid van het gebouw</em>, en <em>de brandende kaarsen</em>. Die wijzen erop alsof de kerk de komst van de pelgrim heeft verwacht. Ze nodigt hem uit om nog een laatste weg af te leggen, fysiek met de voeten en mentaal met zijn geest en hart. Hij neemt het pad waar dat zich opent van het westen naar het oosten, van achteraan naar vooraan.  <span style=\"color:blue\"><strong>PilgrImage</strong></span> beschrijft die pelgrimsgang in de kerk.</p>\n</blockquote>\n<blockquote>\n<p>Het gebaar van openheid en gastvrijheid komt voort uit het <em>feminiene wezen</em> van de kerk. Het hele gebouw stelt een <em>moederlijke</em> geste: ze ontvangt en geeft leven. Ze geeft een <em>thuis</em> aan de lokale, omwonende gemeenschap, maar ook aan de verre vreemdeling die passeert. Ze ontvangt hen allen als de pelgrims die mensen zijn, onderweg in het leven, van hun geboorte tot hun overlijden, generatie na generatie.</p>\n</blockquote>\n<blockquote>\n<p>De <em>feminiene</em> werking van de kerk spreekt ook uit het resultaat ervan. De thuis die ze aan het individu en de gemeenschap biedt, vormt een <em>zone van zin</em>. De pelgrims, de mensen, krijgen er een ruimte om zich te bezinnen, om aan de grondstof van hun bestaan, hun ervaringen van vreugde en lijden, een betekenis te geven.  <span style=\"color:blue\"><strong>PilgrImage</strong></span> toont hoe de pelgrim thuiskomt in die zone van zin, daar waar hij toegang krijgt tot zijn diepste wezen als mens onderweg, zoals een kind thuiskomt bij zijn moeder.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>IN DE SCHADUW VAN HET FLUÏDE LEVENSLICHT</strong></span>. Het openingsbeeld - zie het beeld hierboven - in triptiek zet de visuele toon. Het statige beeld <em>Humana</em> staat op het bewegende en spiegelende water. Dat reflecteert het inwerkende licht.</p>\n<blockquote>\n<p>De twee spiegelbeelden onthullen de fluïde kracht van het inwerkende licht. Dat fluïde licht verschijnt ook in het witte kleed van <em>Humana</em>. De blik van de pelgrim (m/v) richt zich met de intensiteit van de verwondering op haar etherische verschijning. Het van het Grieks komende ‘etherisch’ (ether) duidt letterlijk op de verschijning van ‘<em>de heldere lucht van de hemel</em>’. Hier kunnen we dat vrij interpreteren als ‘<em>zo licht als het licht van de hemel</em>’. <em>Humana</em> oogt alsof ze grotendeels uit licht bestaat. Dat geldt in zekere zin ook van de kerkruimte zelf. De glasramen vertellen dat aan de pelgrim, evenals de vele brandende kaarsen aan de zuilen.</p>\n</blockquote>\n<blockquote>\n<p>De krachtige, <em>feminiene</em> werking van de kerk komt voort uit de wijze waarop ze het hemelse licht in zich opneemt. Dat licht is hier niet het louter functionele licht, maar dat van <em>het wonder van het aardse licht van de schepping</em>, in het derde deel van <a href=\"http://www.menstis.be/uitgeverij/Levensbeschouwing/\">Levensbeschouwing democratisch belicht</a> ‘<em>de Lichtaard</em>’ genoemd. In het openingsbeeld van <span style=\"color:blue\"><strong>PilgrImage</strong></span> verschijnt het als het fluïde levenslicht. De pelgrim beleeft dat licht langs zijn kerkpad op een bijna mystieke wijze. Hij beseft dat het dat scheppende levenslicht is die de regie voert van het pad dat hij volgt, van <em>Humana</em> naar <em>De Madonna van de Tederheid</em>. Hij volgt het spoor van het licht dat hem vanuit de oostelijke koorruimte wenkt. Daarbij gaat hij tweemaal door een donkere ruimte. Dat gebeurt de eerste maal wanneer hij bij het beeld <em>De traan</em> aankomt en van daar naar het labyrint <em>Liefdeslabyrint - Allegorie van het leven</em> stapt. Daar aangekomen, wijst het licht in de koorruimte hem opnieuw de weg. Daar ontdekt hij dat niet het priesterkoor het einddoel van zijn pad is. Hij moet nog eerst door een donkere gang. Voor de tweede keer stapt hij de duisternis in, alvorens zijn echte einddoel, de kamer van de <em>Madonna van de Tederheid</em>, te bereiken.</p>\n</blockquote>\n<blockquote>\n<p>Langs het pad van het fluïde levenslicht gaat de pelgrim inderdaad door <em>donkere plekken</em>. Die verschijnen reeds in het eerste lichtbeeld van de openingstriptiek. Er zijn de schaal van de <em>Humana</em> en de blauwige reflectie van haar gewaad in het rechterluik van het filmbeeld, een effect van een mix van invallend zonlicht en kunstlicht. De <em>donkerblauwe kleur van de hoofdschaal</em> contrasteert met het <em>witte</em> gewaad. Dat contrast is echter niet absoluut.</p>\n</blockquote>\n<blockquote>\n<p>De pelgrim ziet hoe vanuit de schaal van <em>Humana</em> blauwe draden door het witte kleed zijn geweven waarin zich in datzelfde blauw druppels hebben gevormd. Ze vertegenwoordigen de fijne stralen en druppels van het verdriet, die in de schaal zijn opgevangen. Ze vloeien door het kleed heen naar het zacht bewegende wateroppervlak. Hierdoor krijgt in het rechterbeeld het watervlak de <em>ingetogen kleur van de blues</em>, de naam van het diepe verdriet dat de mens in zich opslaat langs zijn levensweg.</p>\n</blockquote>\n<blockquote>\n<p>De pelgrim spiegelt erin zijn <em>eigen</em> verdriet, evenals het <em>collectieve</em> verdriet wat hij deelt met de mensheid waarvan hij deel uitmaakt. Langs zijn pad in de kerk begeleidt het fluïde levenslicht de pelgrim langs momenten waar dat <em>eigen en gedeelde</em> verdriet verder doordringt in zijn gemoed. Hij herkent zich in het beeld van de man met de traan, buigend bij een afgeknotte boom. Die leidt hem naar het labyrint met een kaart van de verschillende regionen die de mens voortdurend doorloopt in zijn mentaal landschap. De botscan in het priesterkoor confronteert hem met de broosheid van zijn lichaam.</p>\n</blockquote>\n<blockquote>\n<p>Het fluïde levenslicht tovert dat alles niet weg. Het neemt die blauwe stemmingen en beelden van verdriet in zich op, belicht ze zelfs, en neemt ze mee in een verticale, hemelwaartse beweging, die spreekt van de <em>feminiene</em> kracht van de dragende zuil en het brandglasraam. Met die kracht stapt de pelgrim doorheen de donkere gang om er in de kamer van <em>De Madonna van de Tederheid</em> aan te komen. In de beeldende beschouwing van de pelgrim echoot het Mariagebed dat hij tijdens zijn weg tot Haar heeft gebeden.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>MENTALE BEE(LD)WEG</strong></span>. Het woord <em>beeweg</em> is in Vlaanderen het dialectwoord voor bedevaart, en is een samendrukking van <em>bedeweg</em>. Zo zegt men bijvoorbeeld dat iemand <em>op bedeweg is geweest</em> naar Lourdes. Langs een bedevaart komt een pelgrim veel andere pelgrims tegen. In <span style=\"color:blue\"><strong>PilgrImage</strong></span> zijn de tochtgenoten van de pelgrim (m/v) beelden; daarnaar verwijst het woord <em>Image</em> in de titel <span style=\"color:blue\"><strong>PilgrImage</strong></span>. De beelden hebben ieder hun eigen narratief. Samen versterken ze elkaar om één groot beeldend gebed zwijgend ‘uit te spreken’. De pelgrim volgt hun spoor, ze vormen zijn bee(ld)weg.</p>\n<blockquote>\n<p><strong><span style=\"color:teal\"> Het neogotische kerkgebouw</span></strong> is het eerste beeldwerk. Dat neemt als moederbeeld alle andere beelden in zich opneemt. De kerk geeft ze ruimte en laat ze tot leven komen. Dat ontdekt de pelgrim tijdens zijn bee(ld)weg. De diverse beelden gidsen hem langs zijn pad in het kerkgebouw. Het zijn tekeningen, schilderijen, een scanfoto, driedimensionale beelden in linnen, gips en hout, alsook nog een tapijt en een brandglasraam.</p>\n</blockquote>\n<blockquote>\n<p><strong><span style=\"color:teal\">Humana</span></strong> op het water is een installatie met centraal een vrouwenfiguur met een handgeweven gewaad van linnen (vlas). De installatie met de ruimte, de figuur, de kleding, het water en het licht creëert een uniek weefsel.</p>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><em>Humana</em> belichaamt eerst en vooral het feminiene wezen van het neogotische kerkgebouw. De naam roept tevens de vrouwelijke dimensie van het wezen mens op. Het woord <em>humana</em> is het vrouwelijke van het Latijnse bijvoeglijk naamwoord <em>humanus</em>, waarvan in de Europese talen, ook in het Nederlands, het woord <em>humaan</em>, menselijk, van is afgeleid. Het beeld vertegenwoordigt niet alleen alle vrouwen die ooit hebben geleefd, nu leven en nog zullen leven.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><em>Humana</em> vertolkt ook de ingetogen waardigheid van de mens als vrouw, zij wier menselijke verschijning in de voorbije eeuwen van wat men de ‘beschaafde’ mensheid is gaan noemen, altijd in de schaduw heeft gestaan. Vandaar ook de blauwe schaal op haar hoofd. Het blauw is de kleur van haar lijden en verdriet dat ze al eeuwen met zich meedraagt. Door haar gestalte verwijst ze naar haar zes zusters, de <a href=\"http://my-favourite-planet.de/english/europe/greece/attica/athens/acropolis/acropolis-photos-01-018.html\">Kariatiden</a> van het Erechtheion op de Atheense Acropolis. <em>Humana</em> synthetiseert de twee, tegenstrijdige betekenissen van het overgeleverde beeldfenomeen kariatide.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p>De Oud-Romeinse lezing ziet in de figuren de tot slaven gemaakte vrouwen van het Spartaanse stadje Karyae die voor eeuwig en altijd lasten op hun hoofd moeten dragen. De meer archeologische visie ziet ze als priesteressen van Karyae die tijdens het tempelfeest voor de godinnen Artemis en Athena de heilige voorwerpen op hun hoofd in manden of schotels naar de tempel brengen. <em>Humana</em> absorbeert beide, tegenstrijdige zienswijzen. In het kader van de installatie in het kerkgebouw krijgt <em>Humana</em> een priesterlijke verschijning, terwijl ze in haar schaal het verdriet van de vrouwelijke mensheid meedraagt.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<p><strong><span style=\"color:teal\">Madonna en de slapende geliefde</span></strong> begeleidt het begin van de tocht van de pelgrim. Vanaf de verschijning van deze tekening begint hij zijn Mariagebed te bidden. Die tekening verbindt de Madonna of Heilige Maria - de meest gekende en vereerde vrouw van de zowel orthodoxe als katholieke christenheid - met iedere vrouw die als geliefde echtgenote door het leven is gegaan, gaat en nog zal gaan. Hiermee roepen het feminiene trio – Humana, de Madonna, de slapende geliefde - bij de pelgrim de herinnering op aan het begin van alle menselijk leven op aarde, de oorsprong ervan: de geboorte van ieder mensenkind, eerst tot leven gekomen in de moederschoot. De heilige Maria, vereerd als Moeder Gods, belichaamt in die zin niet enkel alle moeders, maar ook en tegelijkertijd de heilige gave van het menselijk leven, m.a.w. de heiligheid van het moederschap op zich.</p>\n</blockquote>\n<blockquote>\n<p><strong><span style=\"color:teal\">Verlatenheid, Solus, De traan en Ecce Homo</span></strong> versterken langs het pad van de pelgrim elkaar binnen hetzelfde betekenisveld. Ze roepen ervaringen op die zich situeren in het existentiële register van eenzaamheid, psychisch en fysiek lijden.</p>\n</blockquote>\n<blockquote>\n<blockquote>\n<p>De mannelijke figuur van <em>Verlatenheid, Solus, De traan</em> evoceren het psychisch of mentaal lijden, <em>Ecce Homo</em> confronteert de pelgrim met het lijden van het lichaam door ziekte. Die beelden spiegelen langs het feminiene pad van de pelgrim de kwetsbare kant van de man en in ruime zin van iedere mens, man of vrouw.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p>Dat beeld van de kwetsbare man contrasteert met dat van de eeuwenoude, historische realiteit. Die bewaart de zichtbare tekenen van de masculiene uitoefening van culturele, godsdienstige, economische, politieke en militaire machtsuitoefening die een niet meer te vatten wreedheid en lijden heeft voortgebracht.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p>Tot het beeld van de kwetsbare man hoort ook dat van de afgeknotte boom. De boom is in het collectieve bewustzijn van de mens steeds als levensboom gezien en gewaardeerd. Ook <em>Genesis</em> 3:22 en <em>Spreuken</em> 3:18, 30 kennen die zienswijze. En de middeleeuwse bouwers van de gotische kerken gebruikten de hoge bomen als model voor hun hoge zuilen, een verwijzing naar de Bijbelse levensboom. Vele gotische kerkgewelven ogen als een bladerendek ontsprongen aan de kruinen van de hoge zuilen.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p>In de feminiene beelden van de kwetsbare man die de pelgrim langs zijn pad in zich opneemt, staat de afgeknotte levensboom op de voorgrond. Dat leert dat zijn verdriet niet alleen op hem, maar ook op het lot van de levensboom betrekking heeft. De slachtoffers van de eeuwenlange, masculiene wreedheid – het werk van heel wat farao’s, keizers, tsaren, koningen, duces, pauzen, grootayatollahs, partijleiders, Führers, generaals - waren niet alleen de gewone stervelingen in het algemeen, maar vooral de vrouwen in het bijzonder, evenals moeder aarde met haar mensen, dieren, bomen en zeeën. De tekenen van die niet meer te overziene aanhoudende destructie komen, op het ritme van de jaren, steeds duidelijker aan de oppervlakte.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<p><strong><span style=\"color:teal\">Liefdeslabyrint - Allegorie van het leven</span></strong> is het kunstzinnige tapijt waarop de pelgrim de overgang maakt van de kerkruimte naar het priesterkoor. Deze installatie met het beschilderde tapijt en twee paar schoenen, één voor een man, één voor een vrouw, is verdeeld in vier kwartieren. Ze dragen de namen: sanguinisch, cholerisch, melancholisch, flegmatisch.</p>\n</blockquote>\n<blockquote>\n<blockquote>\n<p>Ze verwijzen naar de vier <em>humores</em> of lichaamsappen die de basis hebben gevormd van de westerse geneeskunde, van de Oud-Griekse tijd tot in de 19de eeuw. Het concept ervan bestaat erin dat iedere mens voortdurend een fluïde balans moet zien te vinden om niet in een of andere extreme stemming te vervallen met tal van schadelijke gevolgen vandien.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p>De installatie gebruikt die eeuwenoude voorstelling als een <em>allegorie van het fluïde leven zelf</em> dat de mens eigen is. Het labyrint vormt een halte op de weg van de pelgrim, een moment van intense inkeer, vervuld van het zoeken naar een licht in de donkerte.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p>Met zijn twee voeten op de grond verblijft de pelgrim even ‘in het midden’ van zijn levensweg. Op het tapijt staat de zin: <em>Nel mezzo del cammin di nostra vita</em> (<em>In het midden van de weg van ons leven</em>). Met dit vers opent Dantes <em>Divina Commedia</em>. Het roept de levensbeschouwelijke kracht van de mens op die hij ervaart telkens wanneer hij, vrijwillig of daartoe door de omstandigheden gedwongen, even halt houdt langs zijn levensweg en daar dan een korte of lange mentale pelgrimage maakt.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<p><strong><span style=\"color:teal\">De twee Maria Magdalena’s in het lege priesterkoor</span></strong>. Na zijn verkenning van het tapijt met labyrint betreedt de pelgrim het lege priesterkoor. Links en rechts begeleiden hem twee verticale beeldbewegingen. Daarin figureert de nieuwtestamentische heilige <em>Maria Magdalena</em> tweemaal.</p>\n</blockquote>\n<blockquote>\n<blockquote>\n<p>Rechts in beeld vormt het houten heiligenbeeld aan de zuil de aanzet van een opwaartse beweging die boven eindigt bij het houten beeld van Adam, waar de vertakking van de zuil begint in de gebogen lijnen van het gewelf. Links van het centrale beeld met het lege priesterkoor is er de eveneens opwaartse beweging van het glasraam dat zich boven de ingang van de kamer met <em>De Madonna van de Tederheid</em> bevindt. De pelgrim merkt dat hier de heilige Maria Magdalena anders wordt voorgesteld.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p>De eerste, die van het houten beeld, toont haar als de Maria uit Magdala - Maria Magdalena - het stadje op de westelijke oever van het meer van Tiberias, een volgelinge van Jezus. Ze is aanwezig bij de kruisiging van Jezus. Op de dag na Jezus’ dood en begrafenis gaat ze heel vroeg in de morgen naar het graf met welriekende olie. Daar is ze als eerste getuige van het lege graf van Jezus. Ze bericht over dat lege graf aan de apostelen (<em>Johannes</em> 20: 1-3).</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p>De tweede figuratie, die van de Maria Magdalena van het brandglasraam, verschilt van de evangelische. Hier toont de voorstelling haar als de berouwvolle zondares die een doodshoofd vasthoudt. Dit is de ‘kerkelijke’ Maria Magdalena, enkel gekend in de katholieke kerktraditie. Die traditie verdicht zich beeldend in de sculptuur in de Brugse Heilige-Magdalenakerk. De sculptuur hangt in de hoogte en verbindt de bovenste uiteinden van de twee zuilen die de theologische en ruimtelijke grens markeren tussen het publieke deel van de kerk en het priesterkoor. In <span style=\"color:blue\"><strong>PilgrImage</strong></span> vertegenwoordigt de figuur van <em>Adam</em> boven de zuil, de hoge sculptuur die in zijn geheel zelf niet in beeld komt. Gezien vanuit het priesterkoor bevinden zich aan de buitenzijden van het in hout uitgewerkte tafereel rechts Adam en links Eva, op het ogenblik dat beiden uit het aards paradijs worden verdreven door de straffende Rechter-God (<em>Genesis</em> 3:23-24). Niemand minder dan kerkvader en paus Gregorius I de Grote (6de eeuw) besliste om catechetische en pastorale redenen alle figuren van christelijke zondaressen te bundelen in de anonieme figuur van de zondares uit <em>Lucas</em> 7: 44-50. De paus identificeerde de anonieme zondares uit het Lucas’ evangelie als de evangelische Maria Magdalena. Ze werd hierdoor het model van alle berouwvolle zondaressen.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p>Die kerkelijke herinterpretatie legde zo impliciet een link tussen de nieuwtestamentische Maria Magdalena en de oudtestamentische figuur van <em>Eva</em>, de Bijbelse oermoeder van de zondige mensheid tout court, en heel in het bijzonder de ‘oorzaak’ van de natuurlijke zondigheid van alle vrouwen. De moeder van alle mensen krijgt in de kerkelijke leer van de <em>erfzonde</em> inderdaad de schuld van het harde levenslot van de mensheid. Een grotere, theoretische minachting voor de vrouw bestaat niet. Zie in die optiek ook de film <a href=\"http://www.menstis.be/film-focus/agora/\">Agora</a>.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p>In dit licht gezien komt de pelgrim van <span style=\"color:blue\"><strong>PilgrImage</strong></span>, tijdens zijn verwondering in het lege priesterkoor, tot het inzicht dat er een eind is gekomen aan <em>het eeuwenoude mannelijke klerikalisme</em> dat steeds het monopolie over het priesterkoor heeft opgeëist. Alleen in de optiek van de officiële leer van de katholieke Kerk is dat monopolie echter vandaag nog steeds van kracht.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p>Langs zijn <em>feminiene</em> kerkpad beseft de pelgrim dat het beeld van de ‘kerkelijke’ Maria Magdalena onrecht aandoet aan de religieuze, feminiene kracht van de mens in het algemeen en die van de vrouw in het bijzonder. Geleid door de ‘evangelische’ Maria Magdalena die getuigt van de geloofskracht van opstanding, ontdekt de pelgrim dat vandaag het heilig levensmysterie in de zijkamer van het lege priesterkoor is te vinden. In die kamer ontdekt hij de warme gloed van <em>De Madonna van de Tederheid</em>, nadat hij eerst het beeld <em>Ecce Homo</em> tot zich heeft laten doordringen.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<p><strong><span style=\"color:teal\">Ecce Homo</span></strong> staat geschreven op de uitvergrote botscan in het lege priesterkoor. Die geijkte woorden komen uit het nieuwtestamentische <em>Passievehaal</em> (<em>Johannes</em> 19:5). In iedere katholieke kerk wordt ernaar verwezen in het eerste tafereel van de kruisweg, opgehangen aan de muren van de kerk. Ecce Homo is hier de botscan van een man. Het beeld bevindt zich in het meest oostelijke punt van het kerkgebouw, daar waar voorheen het hoofdaltaar stond en waar nu meestal een groot kruisbeeld hangt. De scan is gemaakt in het kader van een medisch onderzoek dat leidde tot de vaststelling van een levensbedreigende ziekte. Via dat beeld staat de pelgrim oog in oog met zijn eigen sterfelijkheid, met die van iedere mens en, gezien het kader van het priesterkoor, ook met die van het historisch klerikalisme.</p>\n</blockquote>\n<blockquote>\n<p><strong><span style=\"color:teal\">De Madonna van de Tederheid</span></strong> vormt in <span style=\"color:blue\"><strong>PilgrImage</strong></span> het eindpunt van het kerkpad van de pelgrim. Onderweg heeft hij zijn Mariagebed gebeden in het Russisch. Dat heeft een reden. Nog meer dan in de katholieke verering van Maria als de Moeder Gods, heeft de orthodoxe iconenkunst aan het beeld van Maria een hemels karakter gegeven. <a href=\"https://nl.wikipedia.org/wiki/Moeder_Gods_van_Vladimir\">Vladimirskaja</a> of de Moeder Gods van Vladimir, wordt vereerd als de beschermster van Rusland.</p>\n</blockquote>\n<blockquote>\n<blockquote>\n<p><em>De Madonna van de Tederheid</em> verwijst naar die beroemde icoon uit de Russisch-orthodoxe christenheid, met name in de zwarte contourlijnen van de Madonna met kind. De pelgrim merkt op dat beiden één en dezelfde contourlijn hebben. Ze vallen samen, ze zijn niet te scheiden. Het kind, meer dan in de historische icoon, maakt hier deel uit van de moeder zelf. De pelgrim schouwt in het beeld de heiligheid van het moederschap. Het grote schilderij is zelf geen icoon.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p>De pelgrim merkt op dat het driedimensionale beeld kleurrijk is en refereert naar de gouden glans in de <em>Vladimirskaja</em>. Dat goud heeft hier een honiggele kleur gekregen. De bijen doen alles voor hun moeder-koningin. Ze produceren de gele honing als heilzaam voedsel voor mens en dier.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p>Het doek oogt niet gepolijst of afgewerkt, en dit in tegenstelling met de iconen die altijd hemelse perfectie uitstralen. <em>De Madonna van de Tederheid</em> is aards, onaf; ze spreekt van de unieke, eigen-<em>aard</em>-ige schoonheid van de materie in al haar verscheidenheid en moederlijke levenskracht. De <em>Madonna</em> krijgt een <em>sokkel van jute</em>, de natuurlijke stof die verweven is met het dagelijkse leven van vele voorbije generaties. De sporen van het ontstaan van het beeld, van het werken aan het beeld blijven goed zichtbaar en maken deel uit van de verschijning ervan. Het veelvuldig overschilderen en het herhaaldelijk bewerken blijken uit de strepen van de schilderborstels, de krassen van het schildersmes, en de in de verf gedrukte handpalmen. Al die elementen ondersteunen de tederheid waarvan de Moeder-Madonna de visuele gestalte is.</p>\n</blockquote>\n</blockquote>\n<blockquote>\n<blockquote>\n<p>Links, van onder naar boven, is het woord <em>immaterie</em> in de verf gekrast. Het herinnert de pelgrim eraan dat het beeld in en uit de materie, als uit een moeder (het Latijnse <em>mater</em>), voort is gekomen, ‘geboren’ is. Die moederlijke materie is ook die van moeder aarde, aanwezig in de klankband met de wind en de golvende zee. Niettegenstaande zijn eigen moederlijke materialiteit, heeft het beeld, zoals bij de orthodoxe iconen, ook een immateriële uitstaling. Het brengt uit de materie net als de moeder de tederheid van de menswording voort. In die optiek merkt de pelgrim dat rond de heilige moederfiguur zich een sterrenhemel van handen in wit verzamelt. Deze open handen willen geven, niet nemen. Als naalden van een kompas oriënteren ze zich naar de magnetische, tedere hand van de heilige Moeder.</p>\n</blockquote>\n</blockquote>\n<p><a name=\"CON\"></a></p>\n<h2><font color=\"#808000\"><strong>Context</strong></font></h2>\n<p>Het filmpje <span style=\"color:blue\"><strong>PilgrImage</strong></span> staat op zichzelf als een kunstzinnige kortfilm. De toeschouwer kan die beleven als een beeldende meditatie en/of gebed.</p>\n<blockquote>\n<p>Tegelijkertijd maakt <span style=\"color:blue\"><strong>PilgrImage</strong></span> ook deel uit van een breed maatschappelijk en cultureel kader. Het betreft namelijk de zoektocht naar de <em>herstemming</em> van de katholieke parochiekerk, in de eerste plaats in Vlaanderen, maar ook elders in de katholieke landen of regio’s in Europa. Het onderzoekswerk van Sylvain De Bleeckere en Roel De Ridder, gepubliceerd in <em>Het open kerkgebouw. Verleden, heden en toekomst van het kerkgebouw in Vlaanderen</em> (Pelckmans, 2014), heeft voor het eerst die thematiek duidelijk geformuleerd en een concrete weg naar de hernieuwde toekomst van de parochiekerk uitgestippeld.</p>\n</blockquote>\n<blockquote>\n<p>Het <em>Project Agora</em> van Men(S)tis, voor het eerst in de Brugse <em>Heilige Magdalenakerk</em> gerealiseerd in een nauwe samenwerking met Yot, zet via een creatieve benadering een stap verder richting toekomst. <span style=\"color:blue\"><strong>PilgrImage</strong></span> evoceert een mogelijke richting van ‘herstemming’ van de parochiekerk niet enkel als collectief erfgoed, maar vooral als <em>een hedendaagse zone van zin</em>, die terug aansluiting vindt bij de <em>creativiteit</em> eigen aan de generaties die in het verre en nabije verleden het kerkgebouw hebben voortgebracht en in stand gehouden.</p>\n</blockquote>\n<p><a name=\"LIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Links</strong></font></h2>\n<p>Zie de sites van <a href=\"https://www.kristofhoornaert.com/\">Kristof Hoornaert</a> en <a href=\"http://www.marleen-mertens.be/metafora.php\">Marleen Mertens</a>.</p>\n<p>Zie ook de site van <a href=\"http://www.jandewachter.be/Intro\">Jan De Wachter</a>. De kunstenaar stelde zelf een verklarende nota op naar aanleiding van de installatie <a href=\"https://cdn.webdoos.io/yot/54cd231592e2692c342fdc3c3bc67872.pdf\">Alles goed? Jan De Wachter!</a>, een belangrijk onderdeel van het Project Agora.  Enkele van de werken uit die meerdelige installatie komen voor in <span style=\"color:blue\"><strong>PilgrImage</strong></span>. Daaruit blijkt dat de kunstwerken die hierboven zijn vermeld en toegelicht - <em>Verlatenheid, Solus, De traan, Ecce Homo</em> – het karakter van een zelfportret hebben. Ook voor <em>De Madonna van de Tederheid</em> putte Jan De Wachter, zo vertrouwde de kunstenaar de auteur toe, inspiratie uit zijn eigen leven. De overleden moeder van de kunstenaar was namelijk vroedvrouw. Ze bezat bijzonder korte, krachtige handen waarmee ze veel kinderen hielp geboren worden. De moeder van de schilder had een grote verering voor de Heilige Maria. Via de nagedachtenis van zijn moeder brengt hij met De Madonna van de Tederheid hulde aan alle vrouwen die als echte moeders in het leven staan en met het leven omgaan. Het vertolkt de bewondering van de kunstenaar voor de verbondenheid van moeder en kind, een verbondenheid die hij als een echt geloofsgebeuren ervaart.</p>\n<p>De auteur dankt Geert Delbeke van Yot en tevens vaste gids in de kerk, want die wees hem op de waarde en het belang van de twee beelden van de Heilige Maria Magdalena in de kerk, die nu ook deel uitmaken van <span style=\"color:blue\"><strong>PilgrImage</strong></span>.</p>\n<p><font size=\"-2\">© Sylvain De Bleeckere, Men(S)tis, 2018</font>.</p>\n"}

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

	module.exports = {"title":"La prière","body":"<center>\n<img src=\"priere.jpg\" >\n</center>\n<a name=\"KLA\"></a>\n<h2><strong>Klapbord</strong></h2>\n<p>De Franse regisseur Cédric Kahn ligt aan de basis van het filmscenario <span style=\"color:blue\"><strong>La prière</strong></span>. Geïnspireerd door een idee van de Franse romanschrijfster Aude Walker, begon Kahn te werken aan een concept voor een concrete film over jongeren die hun drugsverslaving willen overwinnen door te gaan leven in een rooms-katholieke gemeenschap. In de periode dat hij het script schreef, ging Cédric zelf tien dagen meeleven in een dergelijke, bestaande gemeenschap. Onder leiding van katholieke opvoeders leven de jongeren er volgens een monastiek ritme. Fysieke arbeid wisselt af met reguliere gebedsmomenten. Alle hedendaagse afleidingen worden geweerd. Cédric sprak er met een tiental jongeren wier levensverhaal het vertrekpunt vormde voor het scenario. In de film zelf vertolken acteurs en actrices die neergeschreven getuigenissen. Om uiteindelijk te vermijden dat een mogelijke film tussen de twee stoelen van een documentaire en een speelfilm zou terecht komen, ging de regisseur samenwerken met collega’s scenaristen Fanny Burdino en Samuel Doux. Deze laatste bereidde zich eveneens voor door in een religieuze gemeenschap te gaan meeleven. De eerste fase van de opnames vonden plaats van 15 februari tot 23 maart 2017 (winter), waarna de tweede fase volgde van 30 mei tot 8 juni (zomer) van datzelfde jaar. De filmploeg vond de geschikte locaties in de Franse Alpen, de regio Auvergne-Rhône-Alpes, vooral in het departement Isère, de vallei van Trièves, ten zuiden van Grenoble, omringd door 2000 meter hoge bergen. De 23jarige, beloftevolle Franse acteur, Anthony Bajon, ontving op het Filmfestival Berlijn (2018) de prijs voor de beste mannelijke hoofdrol.</p>\n<p><a name=\"SYN\"></a></p>\n<h2><strong>Synopsis</strong></h2>\n<p>De 22jarige drugsverslaafde Thomas zoekt een uitweg uit zijn jarenlange heroïneverslaving. Hij is onderweg naar een katholieke gebedsgemeenschap in het hooggebergte, geleid en bevolkt door gewezen verslaafden. Hij wordt opgenomen in hun kleine gemeenschap, geleid door Marco. Thomas krijgt een persoonlijke begeleider toegewezen, Pierre. De gemeenschap leeft vrij geïsoleerd van de buitenwereld volgens een zeer strenge discipline, zonder medicijnen, sigaretten, alcohol, televisie. Er is geen contact met de meisjes die verderop een gelijkaardige  gemeenschap vormen.</p>\n<blockquote>\n<p>De jonge mannen verrichten zware fysieke arbeid, die ze afwisselen met een intens gebedsleven. Hun dagelijks leven staat in het teken van vriendschap en wederzijdse ondersteuning bij ‘de gratie Gods’. Thomas kampt met ontwenningsverschijnselen en hij botst tegen de harde discipline. Het religieuze leven spreekt hem niet aan. Voor haar voorzieningen onderhoudt de gemeenschap contacten met het nabijgelegen dorp, vooral met de boerderij van Olivier en Agnès. Daar leert Thomas hun dochter, de archeologiestudente Sybille, kennen. Ze verblijft even bij haar ouders in afwachting van een teken om haar archeologische stage in Spanje te mogen beginnen. Zij voorkomt dat Thomas de gemeenschap vroegtijdig verlaat.</p>\n</blockquote>\n<blockquote>\n<p>Na die herstart vindt hij geleidelijk zijn eigen plaats in de gemeenschap. Tijdens het jaarlijkse gemengde feest van de twee gemeenschappen bereikt Thomas opnieuw de grens van zijn innerlijke zelf. Op het einde van het feestelijke dag wordt hij ’s avonds voor het eerst geconfronteerd met de dood van een van de jongens. Xavier is bezweken aan een overdosis. Thomas is overstuur, loopt naar het dorp en klopt aan bij Sibylle. Zij biedt hem troost. In haar kamer beleven ze een intens liefdesmoment. In de dagen na die gebeurtenissen neemt Thomas deel aan een inspannende trektocht naar berghut in het hooggebergte. Bij de terugkeer is een lichte sneeuwstorm. Thomas raakt afgezonderd van de groep en verliest zijn weg. Bij een zware val op de berghelling, bezaaid met stenen, verwondt hij zich aan de linkerknie. Hij moet de nacht in het gebergte alleen doorbrengen. Hij bidt: ‘Heer, verlaat me niet. Laat me hier niet sterven’.</p>\n</blockquote>\n<blockquote>\n<p>Wanneer hij ontwaakt, is zijn knie ontzwollen en kan hij zijn afdaling naar de vallei voortzetten. Na zijn intense bergervaring beslist hij seminarist te worden.  Na zeven maanden neemt hij afscheid van de gemeenschap. Onderweg naar het grootseminarie, twijfelt hij en beslist hij na te hebben gebeden, een andere weg te nemen, richting Spanje, naar de plaats waar Sibylle stage loopt.</p>\n</blockquote>\n<p><a name=\"CIN\"></a></p>\n<h2><strong>Cinematografie</strong></h2>\n<p><span style=\"color:darkkhaki\"><strong>DE INCLUSIE MET DE WEG</strong></span>. De verhaalstructuur van <span style=\"color:blue\"><strong>La prière</strong></span> kent een inclusie. De beelding ervan bestaat uit het op weg gaan. De introductiesequenties van het hoofdpersonage tonen Thomas zittend in een rijdende bus. De hobbelige weg schudt de ingedommelde jongen wakker. Hij staart naar de weg met op de horizon het hooggebergte. Hij draagt littekens van een verwonding boven en onder zijn linkeroog, die hij tijdens zijn voorbije weg van de verslaving heeft opgelopen. De bus stopt. Het eindstation voor Thomas. De volgende sequentie toont zijn intakegesprek in de afgelegen religieuze gemeenschap. De eindsequenties staan opnieuw in het teken van de weg. Marco, de hoofdverantwoordelijke van de gemeenschap, brengt Thomas met de auto naar een tankstation waar de jongen de bus kan nemen naar Grenoble. Terwijl hij even moet wachten, denkt hij na, hij bidt en kijkt in het toilet in de spiegel zichzelf in de ogen. Dan beslist hij naar de overkant van de autoweg te lopen. Daar vindt hij iemand met wie kan meerijden richting Spanje. In de auto kijkt Thomas opnieuw naar de weg. In de slotsequentie is hij aangekomen bij de archeologische site waar Sybille haar stage verricht.</p>\n<p><span Style=\"color:darkkhaki\"><strong>HET GESPROKEN WOORD</strong></span>. <span style=\"color:blue\"><strong>La prière</strong></span> opent en eindigt met het geluid van de natuurlijke stilte. In de grote tussenruimte bevinden zich enkele opvallende auditieve sculpturen. Het gesproken, levende woord kleurt enkele, belangrijke sequenties. Als eerste is er het intakegesprek waarin de verantwoordelijke Marco Thomas introduceert in de huisregels van de gemeenschap. Dat gesprek heeft het karakter van een monoloog. De jonge man krijgt ook een engelbewaarder, de ex-verslaafde Pierre.</p>\n<blockquote>\n<p>In de loop van de film komen er enkele sequenties voor die tonen hoe Pierre en Thomas elkaar vertrouwen en ondersteunen. Dat is het geval na de terugkeer van Thomas in de gemeenschap waaruit hij was gestapt als gevolg van ontwenningsverschijnselen die hij niet onder controle kreeg. Door toedoen van Sybille keert Thomas terug naar de gemeenschap. Zoals de regel voorschrijft, moet hij in therapeutische afzondering gaan. Pierre begeleidt hem daarbij. Pierre vertelt er over zijn verleden. Hij heeft een vrouw en een kind die hem af en toe komen bezoeken. Zijn jongen is nu vier jaar, en hij heeft die enkele keren gezien.</p>\n</blockquote>\n<blockquote>\n<p>Naar het einde toe van de film werken Pierre en Thomas in het houtatelier. Ze timmeren er samen een groot, houten kruisbeeld. Ze bevinden zich samen op het eindpunt vat hun gemeenschappelijke kruisdraging. Pierre is in dit licht beschouwd, Simon van Cyrene die Thomas heeft geholpen zijn kruis te dragen gedurende zijn verblijf in de gemeenschap. Op dat gemeenschappelijk eindpunt aangekomen, spreekt Thomas zijn innerlijke twijfel uit over zijn keuze om naar het priesterseminarie te gaan. Daaraan vooraf gaat de sequentie van het gesprek tussen Thomas en de priester Luc. Samen hebben ze het over de goddelijke roepstem die Thomas na zijn bergervaring heeft gehoord. Priester Luc probeert Thomas’ enthousiasme te temperen. Hij wijst er de jonge man onder andere op dat priesterleven een pad is met struikelstenen. Hij beklemtoont vooral dat een priester afstand doet van relaties met vrouwen. Dat laatste punt zal Thomas doen twijfelen. Die twijfel vertrouwt hij toe aan Pierre terwijl ze samen het grote houten kruis dat ze hebben getimmerd, voltooien. Tot slot is er nog het spirituele gesprek tussen zuster Myriam en Thomas op het einde van het gemengde feest. Dat gesprek vormt een van de belangrijke dramatische wendingen. Zuster Myriam dwingt Thomas eerlijk te zijn tegenover zichzelf.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>OPVOERING VAN LAZARUS</strong></span>. Er komt ook een tweeledige theaterdialoog voor. Die staat in het teken van de opvoering van de evangeliepassage over de opwekking van de overleden Lazarus, zoals opgetekend in het <em>Evangelie van Johannes</em>. De opvoering komt twee keren voor: in de sequentie van de repetitie en in de sequentie van de eigenlijke opvoering tijdens het gemengde feest. De mannen hebben zelf een primitieve scène met decor gebouwd en enkele van hen hebben zich verkleed als leerlingen van Jezus. Het opwekken uit de doden van Lazarus vormt het hoogtepunt van de opvoering. Helemaal in de geest van het <em>Johannesevangelie</em> staat het tafereel in het teken van de oproep tot het geloof in de macht van Jezus om de dood te overwinnen en wat dood is, nieuw leven te schenken.</p>\n<p><span style=\"color:darkkhaki\"><strong>GETUIGENISSEN</strong></span>. Opvallende woordelementen zijn de getuigenissen in monoloog. Sommigen gebeuren in de eigen kring van de gemeenschap, soms zoals in het geval van Pierre in een vertrouwelijk gesprek van man tot man. Daarnaast is er een grote sequentie die zich situeert tijdens het jaarlijkse, gemengde feest waarop ook gasten vanbuiten af worden uitgenodigd. Een van de activiteiten van dat feest bestaat erin dat wie wil, een getuigenis aflegt voor de groep van de twee gemeenschappen en hun genodigden. De getuige kan iemand zijn die de gemeenschap al enige tijd heeft verlaten en nu komt getuigen over haar of zijn ervaringen in de buitenwereld.</p>\n<blockquote>\n<p>Zo volgen drie getuigenissen na elkaar. Ze spreken recht in de camera en spreken eigenlijk tot de toeschouwers van de film. Die reële getuigenissen, vertolkt door acteurs, vormen de oorsprong van de film La prière. Eerst vertelt een jonge anonieme vrouw hoe ze als kind door haar vader werd misbruikt en hoe ze acht jaar verslaafd was aan drugs. Het was haar bijgebleven dat haar moeder een gelovige vrouw was. Na het verblijf in de gemeenschap leeft ze nu al twee jaar zelfstandig. Dan volgt Ben. Hij is de verwende zoon van rijke ouders die telkens opnieuw zijn misstappen met geld wegwisten. Dat werd hem fataal. Verslaafd aan drugs was hij nog geen zeventien toen hij op een dag zijn moeder sloeg voor geld. Nu verblijft hij al een jaar in de gemeenschap en heeft hij opnieuw contact met zijn ouders. De derde getuige verliet vier jaar geleden de gemeenschap na een verblijf van drie jaar. Na een half jaar buiten verviel hij opnieuw in zijn alcoholverslaving. Daarom is hij teruggekeerd naar de gemeenschap. De drie getuigenissen demonstreren hoe hardnekkig het probleem van de verslaving is en welke moeilijke weg ze moeten doorlopen om tot een zekere genezing te komen. Ook Thomas botst op die moeilijkheid.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>NOTRE DIEU S’EST FAIT HOMME</strong></span>. Vervolgens zijn er de sequenties die in het teken staan van het bidden. Sommige zijn gezongen, andere gesproken. Dat laatste is het geval in het begin van de film. De jongens bevinden zich buiten in de groentetuin nabij de serres. Wanneer tegen de middag de klok van het gebedshuis weerklinkt, verzamelen ze zich. Ze maken samen het kruisteken en beginnen dan in een lange rij te stappen terwijl ze de tekst van het katholieke credo opzeggen. Het eerste gezonden lied situeert zich in de sequentie tijdens de gezamenlijke morgeneucharistieviering. De sequentie toont niet de eucharistie zelf, maar focust op de groep van de jonge mannen die, begeleid door twee gitaristen, samen zingen:</p>\n<blockquote>\n<p><em>Notre Dieu s’est fait homme pour que l’homme soit Dieu.\nMystère inépuissable, fontaine du Salut.\nQuand Dieu dresse la table, il convie ses amies,\nPour que sa vie divine soit aussi notre vie!</em></p>\n</blockquote>\n<blockquote>\n<p><em>Le Seigneur nous convoque par le feu de l’Esprit\nAu banquet de ses noces célébrées dans la joie.\nNous sommes son Eglise, l’Epouse qu’il choisit,\nPour vivre son alliance et partager sa vie</em>.</p>\n</blockquote>\n<p>Dit lied is in katholiek Frankijk erg ingeburgerd vooral in de liturgie van de Advent en Kerstmis. Het vertolkt het geloofsmysterie van de goddelijke Menswording, ook al wordt de geboorte van Jezus zelf niet met name genoemd. Voor de jonge mannen vormt de eucharistie die ze ’s morgens vieren de goddelijke tafel waaraan ze als gasten van God zelf zijn uitgenodigd. De eucharistietafel belichaamt de gastvrijheid van de katholieke gemeenschap waar ze, niettegenstaande hun gevecht met verslaving, zich toch ‘vrienden en gasten’ van God voelen. In de tweede strofe zingen ze hun vreugde uit die gepaard gaat met het aanzitten aan het goddelijke huwelijksbanket. Die vreugde vormt ook een opdracht: hun gemeenschap is de bruid van de Heer, die opgeroepen wordt als zodanig ook te leve, gesterkt door het vuur van de Geest.</p>\n<p><span style=\"color:darkkhaki\"><strong>BIJBELBIDDEN</strong></span>. In de loop van de film volgen er nog verschillende sequenties waarin het gebedsleven van de gemeenschap en in het bijzonder van Thomas centraal staat. Dat is bijvoorbeeld het geval na de beëindiging van de therapeutische afzondering van Thomas, daarin bijgestaan door Pierre.</p>\n<blockquote>\n<p>Ze kunnen nu terug deelnemen aan de morgeneucharistie. Iemand van de jongens leest tijdens de woorddienst voor uit <em>Genesis 12:3</em>: ‘<em>Ik zal zegenen wie u zegenen, en wie u vervloekt, zal ik vervloeken; in u zullen alle geslachten  worden gezegend.</em>’ Het betreft de belofte die Jahwe uitspreekt bij de sluiting van het verbond met Abraham, de stamvader van het Joodse volk.</p>\n</blockquote>\n<blockquote>\n<p>Die Bijbeltekst bezegelt in zekere zin het verbond dat Thomas van nu af bewust en gewild kan sluiten met de gemeenschap en daardoor ook met God zelf, de hoeksteen van het verbond tussen God en de gemeenschap. Als bevestiging van dat verbond van Thomas met de katholieke gemeenschap waarvan hij nu volwaardig lid is geworden, staat Thomas op om <em>Psalm 27</em> als de tweede lezing te brengen. Het betreft een belijdenis van de gelovige die wil wonen in het huis van de Heer én een smeekgebed dat de hulp van de Heer inroept langs de weg naar dat huis van de Heer: ‘<em>Het enige wat ik verlang: wonen in het huis van de Heer</em>.’ (vers 4). ‘<em>Wijs mij uw weg, Heer, leid mij op een effen pad, bescherm mij tegen mijn vijanden, lever mij niet uit aan mijn belagers</em>.” (vers 11). Het Psalmgebed lijkt Thomas op het lijf geschreven.</p>\n</blockquote>\n<blockquote>\n<p>Verderop in de film zit Thomas alleen in de gebedsruimte. Die sequentie toont hoe de jonge man probeert het boek van Psalmen uit het hoofd te leren. Hij oefent de lofpsalm 145. Nadien, met name tijdens het beklimmen van de berg, vraagt priester Luc aan Thomas hoe ver hij is gevorderd met de <em>Psalmen</em>. Hij nodigt Thomas uit om tijdens het stappen bij wijze van oefening de korte <em>Psalm 3</em> vanbuiten op te zeggen. Dat lukt hem ook. De Psalm is zeker van toepassing op het gebeuren. Dat blijkt uit de verzen  4 en 5: “<em>U, Heer, bent een schild om mij heen, u bent mijn eer, u houdt mij staande. Roep ik tot de Heer om hulp, hij antwoordt mij vanaf zijn heilige berg</em>”. En het vers 6 wijst vooruit op wat Thomas zal meemaken tijdens de afdaling wanneer hij de groep kwijtraakt en de nacht alleen op de bergvlak moet doorbrengen: “<em>Ik ga slapen, val in slaap en word wakker – de Heer beschermt mij</em>.”</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>THIS LITTLE LIGHT OF MINE</strong></span>. Een gezongen scène situeert zich in de eetzaal tijdens een recreatiemoment.  Samen zingen ze de gospel <em>This Little Light of Mine</em>. Die lofzang op Jezus Christus als het ‘Licht van de wereld’ werd in de jaren twintig van vorige eeuw geschreven door de blanke componist Harry Dixon Loes. Hij componeerde Bijbelse liederen in de geest van de negro-spirituals. Loes schreef het lied oorspronkelijk voor kinderen. De tekst is geïnspireerd door Mattheüs 5:14-16/Lucas 11:33.</p>\n<blockquote>\n<p>Ook de gekende katholieke gebeden – <em>het Onzevader en het Weesgegroet</em> – komen voor in de film. Tijdens het moment van verlatenheid in de bergen bidt Thomas <em>het Onzevader</em>. <em>Het Weesgegroet</em> komt verschillende keren voor. Tijdens de repetitie, voorafgaand aan de Lazarusopvoering door de mannen, oefenen de vrouwen het gezongen <em>Weesgegroet</em>: ‘<em>Je vous salue Marie</em>’. Dat wordt ook gezongen als gemeenschappelijke afsluiting van het gemengde feest. Thomas en zuster Myiam bidden ook samen <em>het Weesgegroet</em> en het komt naar het einde toe opnieuw voor in de sequentie die het afscheid van Thomas inluidt. Hij bevindt zich alleen in de gebedsruimte en bidt er het Weesgegroet. Tot slot komt er, eveneens naar het slot toe van de film, een sequentie voor met Thomas als misdienaar. De groep zingt dan het <em>Hosanna</em>.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>BIST DU BEI MIR</strong></span>. Naast de gesproken en gezongen gebeden monteert de regisseur op drie belangrijke momenten een gezongen lied dat niet door de personages zelf wordt gezongen. Het betreft het lied <em>Bist Du Bei Mir</em>, een compositie van de Duitse musicus Gottfried Heinrich Stölzel (1690-1749). Het lied werd lange tijd ten onrechte toegeschreven aan Bach omdat die het had opgenomen in zijn <em>Klavierbüchlein für Anna Magdalena Bach</em> (BWV 508). De auteur van de tekst is anoniem gebleven. Het religieus klinkende lied weerklinkt in Duitsland vaak op huwelijksvieringen. Het is inderdaad een liefdeslied dat de wederzijdse trouwe verbondenheid tot aan de poort van de dood  verklankt.</p>\n<blockquote>\n<p><em>Bist du bei mir, geh ich mit Freuden\nzum Sterben und zu meiner Ruh.\nAch, wie vergnügt wär so mein Ende,\nes drückten deine schönen Hände\nmir die getreuen Augen zu!</em></p>\n</blockquote>\n<blockquote>\n<p><em>Als jij bij mij bent, dan ga ik met vreugde\nmijn sterven en mijn rust tegemoet.\nAch, hoe aangenaam zou mijn einde zijn\nwanneer dan jouw lieve handen\nmijn trouwe ogen zouden sluiten.</em></p>\n</blockquote>\n<p>De regisseur monteer het lied bij drie sequenties. De eerste keer duidt het lied de sequenties van Thomas in de auto van Sybille. Ze voert hem terug naar de gemeenschap nadat ze hem heeft kunnen overtuigen om zijn inspanning om af te kicken, niet te stoppen. Tijdens de rit terug weerklinkt dan <em>Bist du bei mir</em>. Bij het woord ‘<em>Ende</em>’ stopt de auto. De tweede maal dat het lied weerklinkt, gebeurt in de sequenties met Thomas’ afdaling van de berg. Gekwetst heeft hij de nacht doorgebracht op de bergflank. Genezen daalt hij in het zonlicht de berg af richting zijn thuis, de religieuze gemeenschap. De derde maal dat Bist du bei mir de beelden duidt, situeert zich opnieuw in de auto. Thomas kan meerijden richting Spanje. De jonge chauffeur zet de autoradio aan. De regisseur monteert hier een intro van het technonummer <em>Philtrum (original mix)</em> van Disco Fries. Die repetitieve drum contrasteert sterk met al de religieuze gezangen van de gemeenschap. Thomas rijdt duidelijk opnieuw ‘de wereld’ in. Maar hij is veranderd. De regisseur laat de technodrum overgaan in het liefdeslied Bist du bei mir met zijn religieuze uitstraling. Het begeleidt Thomas naar op zijn weg naar Sybille in Spanje.</p>\n<p><a name=\"BET\"></a></p>\n<h2><strong>Betekenisruimte</strong></h2>\n<p><span style=\"color:darkkhaki\"><strong>OP WEG NAAR ZIJN VERLOREN ZELF</strong></span>. <span style=\"color:blue\"><strong>La prière</strong></span> kent een cinematografie van de weg. Het verhaal van Thomas ontrolt zich tussen de inclusie van de weg. En in het lange tussenverhaal in de gemeenschap blijft de weg aanwezig: de weg naar het dorp, het weglopen, de terugweg, de weg naar het gemengde feest, het bergpad. Het beeld van de fysieke weg groeit uit tot een beeldmetafoor van de spirituele weg die Thomas aflegt op zoek naar zijn eigen zelf. Wanneer in de openingssequentie Thomas in de bus zit, rijdt hij weg van de plaats en de tijd waarin hij zichzelf is kwijtgeraakt. Over die weg vernemen we niets. Alleen noemt de jonge man tijdens zijn afscheid van de gemeenschap Pierre ‘mijn eerste vader’. De film doet niet aan psychologische duiding. Het verhaal van Pierre, Thomas’ beschermengel, over zijn alcoholverslaving, de drie getuigenissen tijdens het gemengde feest die over hun verleden vertellen, volstaan.</p>\n<blockquote>\n<p>Bij Thomas ligt de nadruk op de weg terug naar zichzelf. Hij draagt de tekenen van verwonding aan zijn linkeroog. Hij wil niet meer wegkijken van zichzelf. Hij zoekt de heling van zijn zelfbeeld. Op het einde neemt hij de belangrijke beslissing onderweg door zichzelf met een genezen blik in de spiegel te bekijken. Dit was tijdens zijn verslaving onmogelijk. Vanuit die heldere blik op zijn zelfbeeld neemt hij voor het eerst sinds lang een eigen beslissing over de toekomst van zijn levensweg.</p>\n</blockquote>\n<blockquote>\n<p>Na het intakegesprek komt er een betekenisvolle sequentie die de existentiële draagwijdte van Thomas’ tocht naar zichzelf in de verf zet. Thomas moet alles wat hij meebrengt van zijn afgelegde levenspad, afleggen. Ook zijn ondergoed. Zijn haren worden kort geknipt. Zijn naakte zelf is zijn enig vertrekpunt. Hij moet in de gemeenschap opnieuw worden geboren door de poort naar zijn eigen zelf terug te vinden en te openen. Dat verloopt niet van een leien dakje. In de eerste nacht wordt hij met afkickverschijnselen geconfronteerd. De gemeenschap gebruikt geen medicatie. Pierre en de anderen ondersteunen hem om door de pijn heen te gaan.</p>\n</blockquote>\n<blockquote>\n<p>De existentiële weg naar zichzelf, zijn tweede geboorte, kent twee grote fasen. De eerste begint met de nachtelijke afkickverschijnselen en eindigt met een gevecht in de eetzaal. Thomas kan niet overweg met de discipline en de huisregels. Het bidden zegt hem niets. Hij moet zich ook voor de groep verontschuldigen omdat hij een sigaret heeft gerookt, waarna hij in therapeutische afzondering moet gaan. Hij weigert alles. De anderen proberen hem te overtuigen, maar Thomas maakt zich boos. Na het gevecht beslist hij de gemeenschap te verlaten. Zo komt hij terecht bij Sybille. Zij overtuigt Thomas om door te zetten.</p>\n</blockquote>\n<blockquote>\n<p>Dan begint de tweede fase. Daarin staat de opwaartse, spirituele weg centraal. In de therapeutische afzondering, samen met Pierre, komt hij tot rust, waarna hij in staat is te participeren aan het gemeenschappelijke gebedsleven. Daar vindt hij steun in tot aan het moment dat hij de dode Xavier ontdekt. Dat brengt Thomas opnieuw van zijn opwaartse weg af. Hij loopt naar het dorp in de vallei waar hij troost vindt in de armen van Sybille. Daarna gaat het weer bergop. Letterlijk dan. Hij leert de Psalmen vanbuiten en trekt mee de bergen in. Tijdens het moment van afdaling beleeft hij, alleen aan zichzelf overgelaten midden in de Gods weidse natuur, zijn moment van terugkeer tot zichzelf. Dat interpreteert hij als een roeping en besluit voor de priesteropleiding te gaan. Uiteindelijk, mede door het gesprek met priester Luc, na een het spiegelmoment en een gebed in stilte, kiest hij voor de weg naar Sybille.</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>THOMAS’ LAZARUS-DOORTOCHT IN DE RELIGIEUZE GEMEENSCHAP</strong></span>. Voor Thomas en ook voor de anderen, met uitzondering van Xavier, is de rooms-katholieke gemeenschap de plaats van hun tweede geboorte. In de spiegel van Thomas’ verhaal valt het bijzonder karakter van die katholieke omgeving op. Thomas heeft geen existentiële connectie met de religieuze levenswijze die sterk verwant is aan dat van een abdij of klooster.</p>\n<blockquote>\n<p>Het kloosterleven staat haaks op dat een heroïneverslaafde zoals Thomas. Zo iemand leeft geïsoleerd en schuwt anderen. Thomas moet in de gemeenschap een existentiële bocht van 180 graden maken. Dat lukt zomaar niet. De gebeden zeggen hem niets. Hij participeert wel aan de gemeenschappelijke gebedsmomenten, maar hij zwijgt. Pas na zijn herstart, dankzij toedoen van Sybille, participeert hij aan het gebedsleven. Dat gebeurt na de therapeutische isolatie. Daar vertelt zijn engelbewaarder Pierre Thomas over zijn ervaring met het bidden. Die getuigt: ‘Ik heb God nooit gezien. Soms denk ik: ‘<em>Geef mij een teken dat U bestaat. Dan gebeurt er iets waar ik weer vertrouwen krijg</em>’. Pierre verbindt zijn getuigenis over zijn gebedsleven met zijn levensverhaal. Hij vertrouwt Thomas toe hoe zwaar zijn alcoholverslaving is geweest, hoe zijn vrouw zes maanden zwanger was en hij dan door toedoen van zijn ouders in de gemeenschap is terecht is gekomen. Zijn kind is nu al vier jaar. Hij heeft het al drie keren gezien. Zijn vrouw en zijn kind komen een keer per jaar op bezoek. Zelf durft hij nog niet terug te keren. De religieuze gemeenschap is zijn ruggensteun en hij beseft dat die zal wegvallen, wanneer hij naar zijn vrouw en kind terugkeert.</p>\n</blockquote>\n<blockquote>\n<p>Het getuigenis van Pierre zet Thomas aan het denken. Het leert hem de relatie te zien van de genezing van de verslaving met de vergeving en het krijgen van een herstart in het leven via de religieuze gemeenschap. Het dringt tot hem door dat het gemeenschappelijk gebedsleven de hoeksteen vormt van de hechte vriendschap, de wederzijdse ondersteuning en de onderlinge solidariteit. Thomas ontdekt dat het reguliere gebedsleven de voedingsbodem legt voor de doorgedreven eerlijkheid tegenover zichzelf en de anderen in de strijd tegen de leugen en voor de waarheid over zichzelf en het eigen gedrag. Met andere woorden, Thomas ontdekt dat het gezamenlijke gebedsleven geen doel op zich is, maar eerder de stam is waaraan belangrijke takken groeien die goede vruchten voortbrengen.</p>\n</blockquote>\n<blockquote>\n<p>Na zijn herstart in de katholieke gemeenschap doorloopt Thomas een eigen levensfase. Zijn genezing spiegelt zich in het evangelieverhaal van Lazarus die uit de doden herrijst. Het is een religieuze, christelijke beeldspraak die van betekenis is voor alle leden van de twee gemeenschappen, mannen en vrouwen. Ook voor Thomas. Alleen verloopt dit ‘opstaan uit de doden’ in de gemeenschap voor Thomas niet vanzelf. Nog op avond van het gemengde feest met de Lazarusopvoering komt Thomas oog in oog te staan met Xavier, overleden door een overdosis. Eerder, namelijk tijdens de repetitie, liep het al mis met Xavier. Hij hield de lange stok met de volle zon boven  het Lazarus-decor. De jongen kon dat niet volhouden en moest de stok loslaten. Het decor viel uiteen en ‘de opstanding’ werd afgebroken.</p>\n</blockquote>\n<blockquote>\n<p>Dat Thomas’ verblijf in de katholieke gemeenschap niet zonder crisissen verloopt, blijkt eveneens uit de belangrijke sequentie met hem en zuster Myriam. Dat gesprek situeert zich na de gebeurtenissen met de getuigen. Ook Thomas wil getuigen, maar het lukt hem niet. Hij vindt de woorden niet. Dat is zuster Myriam niet ontgaan. Wanneer de avond is gevallen, nodigt ze de jonge man uit voor een persoonlijk gesprek. Eerst bidden ze samen het Weesgegroet. Dan vraagt ze Thomas of hij gelukkig is. Ze confronteert hem met zijn zelfbeeld en met zijn wil om oprecht te zijn tegenover zichzelf. Ze vraagt hem ook of als hij bidt, wel echt bidt. Thomas antwoordt enthousiast: ‘<em>Ik ken alle gebeden en ga vaak naar de mis</em>.’ Zuster Myriam gaat verder: ‘<em>Lukt het jou om echt te geloven?</em>’ Thomas antwoordt steeds met ‘ja’. Tot zijn grote verbazing slaat de zuster de jongen op de wang. Ze wil hem letterlijk wakker schudden. ‘<em>Echt gelukkig?</em>’ ‘<em>Ja</em>.’ Opnieuw slaat ze op zijn wang. '<em>Als je hier knielt en bidt, voor wie kniel je dan? Je leeft in een leugen.</em>’ Dan breekt Thomas. Zijn masker van stoere overwinnaar valt af en hij weent. Zuster Myriam: ‘<em>Huil maar. Ik hoor het kind in jou wenen.</em>’ Ze legt haar hand op zijn hoofd.</p>\n</blockquote>\n<blockquote>\n<p>In het beslissende gesprek van Thomas met zuster Myriam speelt de gevoelens van Thomas voor Sybille mee. Thomas verzwijgt dit. Nochtans had hij de jonge vrouw persoonlijk uitgenodigd naar het gemengde feest. Vol verlangen stond hij langs de weg te wachten op haar, maar ze kwam niet. Het gesprek met de zuster stimuleert Thomas om eerlijk tegenover zichzelf te staan. Wanneer hij kort erna, op het einde van de avond, zijn hart breekt wanneer hij de dode, jonge Xavier vindt, loopt hij regelrecht naar Sybille. Hij vindt troost in haar armen. Daarna maakt hij de tocht mee in het hooggebergte. Ook die confronteert hem met zichzelf en met het grote wonder van de natuur, het hooggebergte met zijn sublieme zichten en tegelijk met zijn vele gevaren. Tijdens de beproeving van zijn nachtelijk verblijf in het gebergte bidt hij het Onzevader en smeekt hij de Vader: ‘<em>Heer, verlaat me niet. Maar me nier niet sterven</em>.’ Hij doorstaat de beproeving en hij geraakt veilig terug in de gemeenschap. Door de overweldiging van de bergervaring wil hij priester worden, maar priester Luc brengt Thomas terug naar de concrete realiteit van zichzelf. Kort nadien, erkent hij tegenover Pierre dat hij zich verbonden voelt met Sybille. Pierre vraagt Thomas of hij een antwoord over zijn twijfel heeft gezocht in het gebed. Hij antwoordt: ‘<em>Ja, maar ik krijg geen antwoord.</em>’ Hij blijft bij zijn voornemen naar het bisschoppelijke seminarie te gaan, hij neemt afscheid van de gemeenschap in dankbaarheid en vertrekt. Op het kruispunt van de definitieve keuze van de richting die hij uiteindelijk wil gaan, kiest hij na een persoonlijk gebed voor richting Spanje, richting Sybille.</p>\n</blockquote>\n<blockquote>\n<p>Regisseur Kahn speelt het religieuze gebedsleven niet uit tegenover de buitenwereld. Zelf heeft hij het als volgt geformuleerd: ‘<em>Mijn film is tijdloos. De verslaving, die is even oud als de wereld. Dat geldt ook voor het gebed</em>.’ Hij behandelt het gebedsleven van de groep met respect. Hij toont hoe de leden van de gemeenschap door de ruggengraat van hun gebedsleven heil en genezing hebben gevonden. Ze hebben er terug kunnen aanknopen bij hun menselijke waardigheid en zelfrespect. De gebedsgemeenschap is voor hen allen een Lazarus-gebeuren. Ook voor Thomas zijn persoonlijk Lazarus-proces betekent de gebedscultuur een belangrijke fase die zeker verder deel zal uitmaken van zijn verder leven. In die richting spreekt Thomas over de betekenis van het bidden voor hem tegenover Sybille. Hij bezoekt haar wanneer hij mee met de camionette proviand gaat afhalen op de boerderij van haar ouders. Het meisje vraagt hem waarom hij zo lang heeft gewacht haar te bezoeken sinds ze hem terugbracht naar de gemeenschap. Ze polst naar zijn welbevinden in de gebedsgemeenschap. Thomas vertelt haar dat hij van het bidden rustig wordt en hij besluit: ‘<em>Je hebt mijn leven gered</em>.’</p>\n</blockquote>\n<p><span style=\"color:darkkhaki\"><strong>DE ARCHEOLOGIE VAN HET RELIGIEUZE LEVEN</strong></span>. De originele insteek van <span style=\"color:blue\"><strong>La prière</strong></span> bestaat erin het Bijbelse Lazarusverhaal te koppelen aan de archeologie als beeldmetafoor. De slotsequentie staat inderdaad helemaal in het teken van de archeologische site in Spanje, waar Sybille haar stage doet. Het gegeven van de archeologie is inderdaad helemaal geënt op het personage van Sybille. De jonge vrouw vertelt Thomas wat archeologie betekent: ‘<em>In de bodem zoeken naar sporen van oude beschavingen</em>.’ Die korte uitleg van Sybille voor de jonge man die zijn middelbare studies na het vierde jaar heeft onderbroken, is correct.</p>\n<blockquote>\n<p>Het woord voor de veldwetenschap, eigen aan de studie van de geschiedenis, is een leenwoord van het Grieks, ‘<em>arkhaiologia</em>’. De oud-Griekse cultuur was zich immers al bewust van het bestaan van verloren gegane beschavingen. In de ruimere zin ging de oud-Griekse cultuur als eerste in de beschaafde mensheid op zoek naar de ‘archè’ van alles wat bestaat: de culturen van volkeren met hun eigen goden, riten en verhalen, de wereld van alle dingen, de planten en de stenen, de aarde en de zeeën, de dieren, de wolken, de sterren en planeten, enzovoort.</p>\n</blockquote>\n<blockquote>\n<p>Regisseur Kahn introduceert de archeologie in de film via Sybille als de metafoor waarin hij de verbondenheid van de mens met de oorsprong van zijn bestaan oproept. In die film krijgt het beeld van die oorsprong een religieuze uitstraling. Die oorsprong betekent immers verbondenheid, de grondbetekenis van het Latijnse woord ‘<em>religare</em>’ (verbinden, een band smeden), waaraan het woord religie wordt gelinkt. De verslaafde Thomas staat voor de mens die de band met zijn oorsprong is kwijtgespeeld. Dat geldt evenzeer voor alle bewoners van de gemeenschap waar hij wordt opgenomen. In de schoot van die gemeenschap volgt Thomas een pad dat hem terug verbindt met zijn menselijke archeologie. Hij ontdekt die in <strong>de heiligheid van het leven</strong> waarvan hij deel uitmaakt, een inzicht en een gevoel dat hij is kwijtgespeeld. Hij vindt de band met de heiligheid van het leven terug via de vriendschap, de gebedscultuur, de aanwezigheid van de wonderlijke natuur in de gestalte van het hooggebergte, alsook via het gevecht met zichzelf. Onderweg naar die religieuze verbinding met het leven dat hij terugvindt, blijkt de figuur van Sybille onmisbaar te zijn: ‘<em>Je hebt mijn leven gered</em>’.</p>\n</blockquote>\n<blockquote>\n<p>Kahn laat er geen twijfel over bestaan. Sybille is de dochter, geboren uit de humane liefde van Olivier en Agnès. Zij leven en werken in een boerderij, dicht bij de natuur. Ze werken samen met de afgelegen religieuze gemeenschap. Ze voorzien hen van de nodige natuurproducten, een bron van eerlijk gewonnen inkomsten. Tegelijkertijd stellen ze zich op als de barmhartige Samaritaan. Ze vangen de jonge mannen zoals Thomas op die in moeilijkheden geraken. Ze laten de vertwijfelde jonge man aanzitten aan hun tafel en geven hem een bed. Ook Sybille maakt deel uit van die <em>Samaritaanse</em> gezin. ’s Anderendaags weet Sybille Thomas te overtuigen terug te keren naar de gemeenschap en daar verder te werken aan de archeologische weg naar zijn verloren zelf.</p>\n</blockquote>\n<blockquote>\n<p>Het archeologische spoor van het Samaritaanse gezin, de geboorteplaats van de humane liefde tussen man en vrouw, is in de film nooit ver weg. Behalve Olivier en Agnès, zijn er ook sequenties die zich binnen de gemeenschap afspelen, die naar die liefde verwijzen. Tijdens het gemengde feest is er de aankondiging van de relatie tussen twee leden van de twee gemeenschappen: Dzianis en Agathe. Zij hebben elkaar gevonden na hun wedergeboorte als mens. Ook is er een korte sequentie in de gemeenschap van de mannen waarin even Pierre samen met zijn vrouw en hun kind is te zien. Die laatsten staan op het punt te vertrekken na hun bezoek. Eerder, tijdens de therapeutische afzondering, had Pierre Thomas al over zijn verleden en zijn gezin verteld. En dan is er de liefdessequentie met Thomas zelf en Sybille. Die is gelinkt aan de tragische dood van de jonge Xavier. Het antwoord op de confrontatie hiermee bestaat niet meer uit troostende woorden die hoe dan ook enkel woorden blijven. Het antwoord op de absurde dood is de beaming van het leven zelf in zijn meest menselijke, archeologische verschijning. Voor de tweede keer redt Sybille Thomas’ leven. Ze neemt zijn snijdend verdriet letterlijk op in haar armen, tastbaar teken van de wederzijdse liefde die ze voor elkaar voelen. Daarna moet Thomas echter nog zijn eigen weg verder zetten. Die loopt verder langs het religieuze bergpad. Uiteindelijk leidt hem dat terug naar Sybille. Dat vergt inspanning en inzet… Hij moet weer onderweg, naar de archeologische bakermat van het leven, daar waar Sybille werkt.</p>\n</blockquote>\n<blockquote>\n<p>In het archeologische perspectief van het leven waarmee de verslaafde Thomas geleidelijk terug aanknoping vindt, legt de regisseur de klemtoon op <strong>het religieuze leven als verweven met de lotgevallen van het menselijke bestaan op aarde</strong>. Dat blijkt uit het feit dat de religieuze gemeenschap erg lijkt op een klooster of een abdij, maar dat toch niet is. De jonge mannen moeten geen belofte van celibatair leven afleggen. Dat hoort niet bij de huisregels. Ook het gemengde feest bevestigt dit. Het celibaat is ook het onderwerp van het gesprek van Thomas met priester Luc. Op het einde ervan brengt de priester de verplichting van het celibaat ter sprake. Hij zegt expliciet dat kiezen voor het religieuze leven de eis van het celibaat inhoudt: ‘<em>afstand doen van vrouwen</em>’.</p>\n</blockquote>\n<blockquote>\n<p>Via deze sequentie neemt Kahn geen standpunt in over het al dan niet verantwoord zijn van de opgelegde kerkelijke wet van het celibatair leven voor priesters. Kahn oordeelt niet, hij constateert dat de wet er na eeuwen en eeuwen ook vandaag nog steeds van kracht is. Kahns focus richt zich naar de verbreding van de heilige waarde van het religieuze leven. Die overstijgt de suggestie die de Kerk verspreidt via het priestercelibaat, namelijk dat de weg naar het ware en hoogste religieuze leven celibatair verloopt.</p>\n</blockquote>\n<blockquote>\n<p>Kahn exploreert in <span style=\"color:blue\"><strong>La prière</strong></span> een andere betekenis van het religieuze leven. Die ent hij op de <em>archeologie van het leven zelf</em>. Vooral in de bergsequentie met Thomas evoceert hij <strong>het religieuze mysterie van het leven op aarde</strong>, waar de mens deel van uitmaakt. Via het genezingsproces van Thomas en het archeologische spoor van Sybille slaagt Kahn erin <strong>de grondwaarde van het religieuze leven te verweven met het grondgegeven van de humane man-vrouw liefde</strong>. En dat krijgt filmisch ondersteuning via de drieledige montage van het lied ‘<em>Bist du bei mir</em>’. Het is een liefdeslied dat het grote wonder van de humane man-vrouw liefde vertolkt waarin leven en dood zich innig verweven. Door Bachs optekening van het lied ‘Bist du bei mir’ klinkt het als een volwaardig intens religieus lied. Hierdoor krijgt het dezelfde religieuze uitstraling als Bachs gekende religieuze muziek, van zijn <em>Hoge Messe</em> (Missa in h - BWV 232) tot zijn <em>Matthäus-Passion</em> (BWV 244). Via dit cinematografisch weefsel van beeld en muziek waarmee Kahn het verhaal van Thomas vertelt, weet hij de betekenis van het religieuze leven uit te breiden naar het levensverhaal dat Thomas en Sybille samen kunnen beginnen op het ogenblik dat de film eindigt. Hierdoor is <span style=\"color:blue\"><strong>La prière</strong></span> een origineel, hedendaags ‘beelgebed’.</p>\n</blockquote>\n<p><a name=\"CON\"></a></p>\n<h2><strong>Context</strong></h2>\n<p>De actualiteit van de drugsverslaving is in de heersende consumptiemaatschappij nooit veraf. Telkens weer speelt zich een groot menselijk drama af, in de wereldsteden, in de landelijke dorpen. <span style=\"color:blue\"><strong>La prière</strong></span> handelt niet over die verslaving op zich. De film opent op het moment dat Thomas genezing zoekt. De film is gebaseerd op een realiteit. Dat verklaart de aanwezigheid van het personage van zuster Myriam. Hiermee brengt Kahn hulde aan het werk van de katholieke kloosterzuster Rita Agnese Petrozzi ― bekend als Moeder Elvira. De door velen ‘de zuster van de drugsverslaafden’ genoemd stichtte in 1983 in Italië (Saluzzo) de eerste <em>Gemeenschap Cenacolo</em> voor drugsverslaafde jongeren. Die is nu uitgegroeid tot een internationale katholieke gemeenschap met afdelingen in verschillende Europese landen, onder andere in Frankrijk, waar de film <span style=\"color:blue\"><strong>La prière</strong></span> is gesitueerd en opgenomen. In België heeft de Gemeenschap Cenacolo enkel een contactadres.</p>\n<blockquote>\n<p>Onafhankelijk van elkaar ontstond eveneens in 1983 onder impuls van de Duitse, franciscaanse missionaris de katholieke organisatie <em>Fazenda da Espereanza</em> (Boerderij van de hoop). De werking lijkt sterk op die in de film La prière. De organisatie kent ondertussen in heel wat landen stichtingen, waaronder Duitsland. Ondertussen is op 13 oktober 2018 in België (Noord-Limburg) de eerste stichting van Fazenda da Esperança in de abdij van Achel nabij de gekende Achelse Kluis opgestart.</p>\n</blockquote>\n<p><a name=\"FIL\"></a></p>\n<h2><font color=\"#808000\"><strong>Links</strong></font></h2>\n<p><a href=\"http://www.menstis.be/webshop/Beeldgebed/\">Beeldgebed</a>. De film werd vertoond tijdens de 29ste editie van De Dag van de Religieuze Film, naar aanleiding waarvan ook het boekje  Beeldgebed verscheen. Het fenomeen van het bidden als onderscheiden van ‘gebeden’, aanwezig in de film, vormt de rode draad van het beeldrijke boekje, beeldrijk zowel in de woorden als in de kunstwerken.</p>\n<p><a href=\"https://www.youtube.com/watch?v=ABWNXrUdYIE\">Bist Du Bei Mir</a>. De versie in de film wordt gezongen door de soprano Ingrid Kertesi, begeleid door Camerata Budapest onder leiding van Laszlo Kovacs.</p>\n<p><a href=\"https://www.comunitacenacolo.it/nl/index.php\">Gemeenschap Cenacolo</a>.</p>\n<p><a href=\"www.fazenda.de\">Fazenda da Esperanze</a>.</p>\n<p>Regisseur Kahn licht enkele aspecten van zijn film toe tijdens een gesprek met <a href=\"https://www.youtube.com/watch?v=w841guZCh_w\">Arte</a>.</p>\n<p><font size=\"-2\">© Sylvain De Bleeckere, Men(S)tis, 2020</font></p>\n"}

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

	module.exports = {"title":"Resurrection","body":"<center>\n<img src=\"re.jpg\" >\n</center>\n<p><a name=\"KLA\"></a></p>\n<h2><font color=\"#808000\"><strong>Klapbord</strong></font></h2>\n<p>Tijdens het Gentse Filmfestival, op zondagavond 15 oktober 2017, kende het langspeelfilmdebuut van Kristof Hoornaert, <strong>Resurrection</strong>, zijn wereldpremière. Voor de jonge Vlaamse regisseur uit Oostende, was dat gebeuren in meer dan één opzicht een verrijzenis. Zijn eerste kortfilm, <a href=\"http://www.menstis.be/film-focus/kain/\">Kaïn</a> dateert al van 2009. Hij kreeg ervoor op het filmfestival van Berlijn een nominatie voor de Gouden Beer. Zijn tweede kortfilm, <strong>The Fall</strong> (2013), moest hij draaien zonder budget en de opnames moesten op één dag worden gerealiseerd. Toch won de film verschillende prijzen en was hij te zien op meer dan 40 filmfestivals. Ook zijn derde kortfilm, <strong>Empire</strong>, kende een internationale carrière. Die drie kortfilms waren stapstenen naar zijn eerste langspeelfilm. Hoornaert schreef net zoals voor zijn triptiek van kortfilms, ook voor zijn langspeelfilmdebuut zelf het scenario. De release van de film in de Belgische bioscopen vanaf 10 januari 2018 is een unieke gebeurtenis in het landschap van de Belgische en vooral Vlaamse film.</p>\n<p><a name=\"SYN\"></a></p>\n<h2><font color=\"#808000\"><strong>Synopsis</strong></font></h2>\n<p>Vandaag, ergens in een stad. Torengebouwen tekenen zich af hoog in de lucht. Plots verschijnt er zwarte rook. Een bomaanslag op een bus. Slachtoffers liggen op straat, sommigen bewegen. Anderen helpen elkaar de gehavende bus uit. Vijfentwintig jaar later. Twee jonge mannen vechten in een bos op leven en dood. Een van hen vermoordt de ander en dumpt diens lijk in het bos. De dader vlucht in paniek weg, halfnaakt komt hij uit een vijver. Ontredderd legt hij zich buiten het bos neer in het hoge gras. Daar vindt een oude man met zijn hond hem. Hij geeft de ontredderde jongeling onderdak in zijn afgelegen boerderij. Na de aanslag op de stadsbus leeft de oude man als enig overlevende van zijn gezin teruggetrokken in de boerderij midden in de natuur. Hij zorgt er trouw voor zijn dieren en planten. Hij leidt een zeer sober bestaan en put energie uit de stille nabijheid van de weilanden en het nabijgelegen bos. De afwezigheid van mensen maakt hem rustig. De oude man probeert contact met de anonieme jonge man te krijgen, maar dat lukt niet. De jonge moordenaar dwaalt rond in zijn gedachten en gevoelens. De gastvrijheid van de oudere man overmant hem. Beiden communiceren via de stilte en hun dagelijkse handelingen. Alleen de oude man blijft proberen om tot een gesprek te komen. Tevergeefs. Langs de radio hoort de oude man een live verslag over een terroristische aanslag. Dat bericht katapulteert hem terug naar het drama dat zijn leven omgooide. Hij trekt zich terug in zijn slaapkamer waar hij knielt bij het kruisbeeld en het Onze Vader bidt: ‘Verlos ons van het kwade’. Na een bezoek van de politie, beseft hij dat hij het kwade in de persoon van de jonge man in zijn huis heeft binnen gehaald. De oude man besluit om de plek van de misdaad in het bos op te zoeken. Wanneer hij terug thuis is, vertelt hij aan de jonge moordenaar dat lang geleden zijn vrouw en zoon omgekomen zijn tijdens een bomaanslag in de stad. Daarna heeft hij zich van de wreedheid, eigen aan de mensenwereld, verwijderd om een teruggetrokken bestaan te leiden, ver weg van de mensenwereld. De jonge moordenaar aanhoort het verhaal, zegt niets, maar schreeuwt met zijn hele wezen zijn verwarde gevoelens uit. De oude man omarmt de ontredderde jonge man. ’s Anderendaags stelt de oude man vast dat zijn gast is weggegaan. Kort daarna krijgt hij een telefoon van de gevangenis om te melden dat de jonge moordenaar zichzelf heeft aangegeven. De oude man verlaat zijn boerderij, vergezeld van zijn hond. Hij meldt zich op zijn beurt aan in de gevangenis. Daar neemt hij zijn intrek in een cel. Hij neemt de plaats in van de jonge man. Daar zien ze elkaar terug en omarmen elkaar. Ze hebben geen woorden nodig.</p>\n<p><a name=\"CIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Cinematografie</strong></font></h2>\n<p><span class=\"menstis\">LINEAIRE NARRATIVITEIT.</span> <strong>Resurrection</strong> kent een narratieve opbouw met een lineair verloop. De film opent met een korte proloog die zich situeert ergens in een hedendaagse stad met woonblokken. Daarna volgt de generiek op een zwarte achtergrond. De generiek sluit af met de filmtitel. Daarna bouwt de regisseur-scenarist een spanningsboog op via vijf bewegingen die elk uit verschillende taferelen bestaan. De vijf bewegingen zijn enkel gemarkeerd door een fade out naar een zwart beeld. Behalve dat zwart beeld, zijn er geen aanduidingen.</p>\n<p>De <em>eerste</em> beweging opent in een groot bos waar zich het drama van de broedermoord afspeelt. De beweging eindigt met de jonge moordenaar in de eetkamer van de boerderij van de oude man. Hij zit er alleen aan tafel, nadat de oude man hem een goede nacht heeft gewenst. Het slotbeeld bestaat uit een inzoom op de rug van de jonge man aan de tafel.</p>\n<p>De <em>tweede</em> beweging opent met het panoramische beeld van de eerste ochtendschemering na de donkere onweersnacht. De eerste dag van de verblijf van de jonge man in de boerderij begint. De beweging mondt uit in een inzoom door het keukenraam met zicht op twee bomen waartussen de oude man over de horizon schouwt. Net daarvoor heeft hij op de radio het live verslag beluisterd over een dodelijke schietpartij die zich in een of andere stad aan het voltrekken is.</p>\n<p>Ook de <em>derde</em> beweging zet in met een panoramisch beeld. Het toont het omringde grasland waarin zich de enige toegangsweg naar de boerderij aftekent. De beweging sluit af met een panoramisch beeld met de oude man die stapt richting boerderij. Tussen beide panoramische beelden in gaat oude man in het bos de plaats opzoeken waar de politie het lijk van het slachtoffer heeft gevonden. Ondertussen zit de jonge man aan de tafel met zijn handen aan zijn hoofd. Hij schreeuwt zijn verscheurde ziel uit.</p>\n<p>De <em>vierde</em> beweging opent met een medium shot van de boerderij. De oude man komt uit de werkplaats, hij stapt richting het huis en treft er opnieuw de politie aan. De beweging gaat over naar een zwart beeld na de scène waarin de oude en de jonge man elkaar omarmen. Daarvoor heeft de oude man aan de jonge man zijn verleden verteld, waarna hij nogmaals vraagt aan de jonge man wie hij eigenlijk is. De jonge man begint te wenen. De oude man troost hem.</p>\n<p>De <em>vijfde</em> beweging opent met de jonge man. Hij begint een nieuwe dag en gaat voor het eerst sinds zijn verblijf op de boerderij, naar buiten. Wanneer de oude man opstaat, is de jonge man verdwenen. Later krijgt de oude man tweemaal een telefoon. De tweede maal neemt hij op en verneemt hij waar de jonge man zich bevindt: in de gevangenis. De oude man komt aan in de gevangenis. Hij krijgt er een eigen cel waar de jonge man hem komt opzoeken. Beiden spreken geen woord. Ze omarmen elkaar. Dat beeld gaat via een fade out over naar een zwart beeld met de eindgeneriek. Het korte tafereel in de gevangenis verschijnt als het narratieve orgelpunt van de hele film.</p>\n<p><span class=\"menstis\">CINEMATOGRAFISCHE LIJNEN IN HET TEKEN VAN HET KRUIS.</span>. Niettegenstaande de talrijke panoramische shots die in principe een horizontaal blikveld scheppen, kent de film ook een <em>verticale beeldlijn</em>. Kristof Hoornaert schept inderdaad een eigen cinematografische sfeer via een verticale camerabeweging of een verticaal hemelbeeld. De verticale beeldlijn beweegt zich tussen de punten ‘hemel’ en ‘aarde’. Dat geldt al voor het openingsshot van de proloog met de appartementsblokken. Ook de eerste beweging opent met een shot van de hoge boomkruinen reikend naar de hemel. De twee zopas genoemde openingsshots beschrijven die beeldlijn van boven (hemel) naar beneden (aarde). In proloog gebeurt dat in één ononderbroken beweging, in de eerste beweging, na de filmtitel, gebeurt die neerwaartse beweging trapsgewijs. In diezelfde eerste beweging komt het eerste hemelbeeld voor. Dat bevindt zich aan het hoogste punt van de verticale beeldlijn. De moordenaar met naakt bovenlijf heeft het bos verlaten en legt zich neer in het hoge gras. Dan komt er een beeld van de hemel. De wolken versluieren de zon die onzichtbaar blijft. Ze kondigen een nakend onweer aan. In de derde beweging ligt de oude man op de plaats waar het lijk is gevonden. Hij draait zich op zijn rug en kijkt naar de hemel. Dan volgt de inlas met het verticale beeld van het hoge bladerdek waar doorheen de zon schijnt. In de vierde beweging, met name na het tweede bezoek van de politie, zoekt de oude man steun tegen de stenen muur. Dan last de cineast een beeld in van de hemel. Doorheen het hoge wolkendek blijft de zon zichtbaar tot er een donkere wolk haar helemaal verbergt. Ze kondigt een onweer aan. Kort daarna volgt de belangrijke monoloog van de oude man die zijn geschiedenis deelt met de jonge moordenaar. In de vijfde en laatste beweging monteert de regisseur opnieuw een inlas van een hemelbeeld. Na het vertrek van de jonge man gaat de oude man naar de groentetuin. Hij aarzelt even en gaat naar de witte rozenstruik in bloei vlakbij de groentetuin. Hij neemt de bloemen in zijn handpalm, schouwt over de horizon met het bos. Dan komt het beeld van de hemel met het wolkendek waarin toch de heldere lichtbol van de zon aanwezig is.</p>\n<p>Daarnaast werkt de regisseur nog de verticale beeldlijn uit in de cinematografische schildering van <em>de relatie tussen de twee personages</em>. Die beeldlijn ontstaat door het blikveld van beiden. Ze bevinden zich namelijk niet steeds op dezelfde hoogte. Dat blijkt al uit hun eerste ontmoeting. De jongen die in het hoge gras ligt, schrikt op van de blaffende hond. Hij kijkt neergezeten op naar de oude man die de hond tot bedaren brengt. Omgekeerd ziet de oude man de jonge, halfnaakte man met zwijgende wanhoop in zijn ogen. De oude man staat recht en bevindt hij zich cameramatig aan de bovenkant, de hemelkant, van de verticale beeldlijn, terwijl de jongen zich aan de benedenkant ervan, de aardekant, bevindt. In de tweede beweging, meer bepaald in het tafereel met het Onze Vader, werkt de cineast opnieuw een verticale beeldlijn uit. De oude man bidt neergeknield het grote, christelijke gebed. Daarbij kijkt hij opwaarts naar het kleine kruisbeeld aan de muur van de kamer. Dat gebeurt bij het begin van het gebed. Bij de laatste zin, ‘Verlos ons van het kwade’, kijkt hij naar beneden, waarna hij die zin een tweede keer bidt, nu met zijn blik terug opwaarts naar het kruisbeeld gekeerd. Een vergelijkbare verticale beeldlijn ontstaat ook op het einde van de vierde beweging. Net voor de eerste omarming zit de jonge moordenaar wenend aan de tafel met zijn hand aan zijn hoofd. De oude man komt naar hem toe en neemt de hand van de jongen weg. Die kijkt met een betraand gelaat op naar de rechtstaande, oude man. Vervolgens volgt er een shot van de oude man die kijkt naar de neergezeten en terneergedrukte jonge man. Hun blikken kruisen elkaar. Ze omarmen elkaar. Met dat shot eindigt de vierde beweging.</p>\n<p>In de optiek van de verticale beeldlijn krijgt de keuze voor <em>de panoramische beeldwerking</em> een bijzondere betekenis. De sleutel ervan bevindt zich in <em>het teken van het kruis</em>. Dat geldt voor het belangrijke visuele leidmotief van de film, dat van de panoramische beelden met de weilanden, de bomenrijen en de lichtende hemel in de verte. Dat beeldmotief ontstaat uit <em>de kruising van de horizontale dwarslijn met de verticale hoogtelijn</em>. De aarde-hemellijn kruist met de horizontale aardelijn van het landschap. Die lijn heeft een menselijke pendant. Leonardo da Vinci begreep dit toen hij zijn beroemde <a href=\"https://commons.wikimedia.org/wiki/File:Da_Vinci_Vitruve_Luc_Viatour.jpg\">Homo Vitrivius</a> heeft getekend. Dit is op zich geen ontdekking van da Vinci. De Romeinen gebruikten die kennis om minder esthetische redenen. Ze ontwikkelden de kruismethode als marteltuig voor het menselijk lichaam. Via het christelijke verhaal van de kruisweg van Jezus is de Romeinse kruismethode bezit van de collectieve verbeelding geworden. Het kruisteken is zelfs uitgegroeid tot het gebedsteken bij uitstek waarmee de christenen hun religieuze rituelen beginnen en afsluiten. Ze tekenen dan het kruis op hun eigen lichaam. Dat doet ook de oude man. Hij maakt in de tweede beweging, na het nieuwsbericht van de aanslag te hebben beluisterd, een kruisteken alvorens het Onze Vader te bidden in zijn slaapkamer. In Resurrection wordt dit gegeven van het lichamelijk kruisteken nog op een impliciete manier aangebracht op het einde van de film. Wanneer de oude man de gevangenis binnenkomt, moet hij de metaaldetector passeren. Daartoe moet hij gestrekt blijven staan met zijn armen wijd open. Hij oogt als een levend kruisbeeld, gevormd door de verticale en horizontale lichaamslijn. In de Europese schilderkunst heeft de meester van het spirituele landschap, <a href=\"https://www.caspardavidfriedrich.org/links.html\">Caspar David Friedrich</a>, voor het eerst die religieus geïnspireerde kijk op het fenomeen van de horizon in zijn landschapsschilderijen uitgewerkt. De Russische filmregisseur <a href=\"http://www.menstis.be/film-focus/andreiroublev/\">Andrei Tarkovski</a> is hem daarin gevolgd. Ook de Franse cineast <em>Bruno Dumont</em> is in diezelfde voetsporen gestapt. Kristof Hoornaert is met <strong>Resurrection</strong> langs die esthetische weg zijn eigen persoonlijke weg gegaan.</p>\n<p><span class=\"menstis\">SOUNDSCAPE.</span> <strong>Resurrection</strong> kent een zeer eenvoudige en tegelijkertijd complexe soundscape. Een <em>eerste</em> klanklaag ervan bestaat uit de klank van de dingen, waarvan de natuur het grootste aandeel heeft. In de tweede en de vierde beweging weerklinkt het onweer met de regen. Telkens begeleidt die muziek van de hemelwolken de scène met de twee mannen aan de tafel. De <em>natuurlijke partituur van de dingen</em> kent ook de geluiden van het bos. De wind, het gekraak van het gevallen hout, het blaffen en gejank van de hond en vooral het gefluit van de vogels.</p>\n<p>Een <em>tweede</em> klanklaag ontspringt aan de handelingen van de personages. De voetstappen in het hoge gras, in het bos, in het huis. De talrijke binnengeluiden aan de tafel en in de keuken zoals het wassen van de handen en de borden, het plaatsen van de borden op de tafel, de klank van het bestek tijdens het eten, het gekraak van de oude deuren. Alle kleine, dagelijkse handelingen hebben hun eigen muziek. Die geluiden klinken als noten van de partituur, gecomponeerd door het levensritme zelf. Cinematografie klinkt hier als kamermuziek geschreven voor een oude man met hond, een jonge man met een bezwaard gemoed en een boerderij in een groen landschap met bossen en weilanden.</p>\n<p>Een <em>derde</em> klanklaag is die van de menselijke cultuur. Die weerklinkt in de eerste plaats via de radio die live een verslag over een moordende aanslag uitzendt, beluisterd door de oude en de jonge man. Daarnaast is er ook nog de muziek. Ook via de radio luistert de jonge man naar de Introïtus van Mozarts Requiemmis. Datzelfde muzikaal citaat begeleidt nadien ook de eindgeneriek. De Latijnse tekst luidt:</p>\n<blockquote>\n<p><em>Requiem aeternam dona eis, Domine,\nEt lux perpetua luceat eis.\nTe decet hymnus, Deus, in Sion,\nEt tibi reddetur votum in Jeruzalem.\nExaudi orationem meam\nAd te omnis caro veniet.</em></p>\n</blockquote>\n<p>Vrij vertaald zegt dit openingsgebed van de Latijnse uitvaartdienst het volgende:</p>\n<blockquote>\n<p><em>Heer, geef hen de eeuwige rust.\nLaat het eeuwig licht op hen schijnen.\nU komt de lofzang toe, God, in Sion,\nIn Jeruzalem zal ik U de beloofde offers brengen.\nVerhoor mijn gebed.\nTot U komen alle stervelingen.\nHeer, geef hen de eeuwige rust.\nLaat het eeuwig licht op hen schijnen.</em></p>\n</blockquote>\n<p>In een andere scène gaat de oude man zelf aan het harmonium zitten. Dat gebeurt in de laatste beweging. Op het ogenblik dat hij beseft dat de jonge man weg is gegaan, speelt hij een rustig, eenvoudige muziek. Het betreft een heel eenvoudige gelegenheidscompositie van Steve Willaert. Tot de klanklaag van de cultuurgeluiden horen ook <em>de woorden</em> die de personages spreken. Dat geldt alleen voor de oude man. Hij spreekt zeer weinig. In de tweede beweging bidt hij het Onze Vader. In de vierde beweging vertelt hij het verhaal van zijn leven aan de vreemde jonge man. Daarnaast zijn er de twee scènes met een dialoog tussen de oude man en de twee politiemensen. Het is eerder een monoloog waarin de oude man luistert naar de talrijke vragen van de politie. Die wil hij echter niet beantwoorden. Hiermee beschermt hij de jonge man die hij als gast in zijn huis heeft opgenomen.</p>\n<p>De <em>diepste</em> klanklaag van de soundscape van de film is echter <em>de muziek van de stilte</em>. Die weerklinkt eerst en vooral in de panoramische beelden. De stilte bestaat uit de klank van het landschap met boerderij. Daarnaast bestaat de stilte vooral uit het zwijgen van de twee personages. Dat geldt in de eerste plaats voor de jonge moordenaar. Hij zegt geen woord in de hele film. Hij huilt luid en op het einde weent hij in het bijzijn van de oude man. Spreken doet hij niet. En ook de oude man zwijgt meer dan dat hij woorden gebruikt. Hier wordt zeer duidelijk hoe Kristof Hoornaert consequent <em>de eigen kracht, de beeldende kracht</em>, van de cinematografie cultiveert. In de meeste films spreken acteurs. Ze declameren teksten in voorgeschreven dialogen en monologen. De unieke cinematografische kracht van de filmkunst bevindt zich daar waar ze ophoudt gefilmd theater te zijn. De acteurs krijgen dan de ruimte om te spreken via hun lichaam. Dat geldt voor Resurrection. De film verschijnt in die optiek als <em>cinematografische kamermuziek voor twee gezichten</em>. Dat resulteert in <em>het eigen ritme van de menselijke stilte</em>. Dat ritme is bijzonder subtiel en meesterlijk uitgewerkt. De regisseur evoceert ermee de unieke, rijke klank van de stilte aanwezig in de schouwende blik van beide personages. In de scène van de eerste ondervraging door de politie, blijft de camera helemaal gericht op de gelaat van de oude man. Hij antwoordt en reageert zwijgend op de talrijke vragen die de politiemannen hem voorleggen. Hetzelfde beeldritme typeert de scènes met de zwijgende jonge man. Via dat beeldritme schildert de regisseur een cinematografisch landschap van gezichten. Voor heel wat toeschouwers die gevormd zijn door de dagelijkse stroom van banale consumptiebeelden, allemaal voortgestuwd door een hectisch ritme, oogt <strong>Resurrection</strong> als een erg trage film. De toeschouwer daarentegen die ruimte geeft aan de kracht van het beeld zelf, ontdekt de eigen intensiteit aanwezig in het landschap van de gezichten. In dit opzicht verdient de cineast grote waardering voor <em>zijn uitgekiende acteursregie</em>. Hij is erin geslaagd het acteertalent van de internationaal erkende acteur <em>Johan Leysen</em> met zijn gegroefd gelaat optimaal te integreren in zijn filmisch verhaal. Datzelfde geldt voor de manier waarop hij het talent van de jonge <em>Gilles De Schryver</em> laat schitteren. Bij het grote Vlaamse publiek geniet de acteur bekendheid als komische acteur, terwijl Hoornaert recht doet aan het groot dramatisch talent van de jonge Belgische film-, televisie- en theateracteur en dito schrijver en producent. Hoornaert toont hoe alleen film in staat is een dergelijke metamorfose van een acteur te realiseren, een acteur die schittert door consequent te zwijgen.</p>\n<p><span class=\"menstis\">HET DERDE PERSONAGE.</span> Naast de twee mannelijke hoofdpersonages kent <strong>Resurrection</strong> nog een derde, een niet-menselijk hoofdpersonage, met name <em>het landschap met boerderij</em>. Voorbij het bos waar zich het drama van de twee broers afspeelt, bevinden er zich weilanden met een glooilijn naar de horizon. Er loopt slechts één aarden weg die leidt naar de boerderij. Daar heeft de oude man zich met zijn hond teruggetrokken en voorziet hij er in zijn eigen onderhoud. Hij houdt er enkele melkkoeien, kweekt er wat kleinvee en hij tuiniert er. In zijn woning houdt hij enkele kamerplanten. De unieke locatie die wonderwel past in het scenario, heeft een onzichtbare link met het thema van het kwade. Alleen de geïnformeerde toeschouwer beseft dat. In een persoonlijk gesprek met de auteur vertelde Kristof Hoornaert over zijn erg lange en geduldige zoektocht naar de geschikte locatie. Hij wilde immers niet in een studio filmen. De opnames in het bos gebeurden in het Zoniënwoud ten zuiden van Brussel. Het landschap met boerderij vond de regisseur over de Belgische grens, in het Franse <em>Romagne-sous-Montfoucan</em> in het noordoostelijk gelegen Lorraine. Het betreft de <em>Ferme La Robinette</em>. Een echte vondst. In de film spreekt een politieman de naam Robinette uit. Hij verwijst er naar het afgelegen bos waar het lijk van het slachtoffer is gevonden. De oude man zegt dat hij daar niet komt. In werkelijkheid is La Robinette de officiële naam van de boerderij in kwestie. Door de boerderij een hoofdrol te geven in de film doet de regisseur <em>de historische boerderij</em> alle eer aan. Hij brengt ze helemaal terug tot leven. Een echte ‘<em>resurrection</em>’. Bronnen bevestigen dat de boerderij in gebruik is geweest tot in de jaren zestig van vorige eeuw. Nadien bleef ze onbewoond tot op vandaag. Volgens het scenario zijn het hoofdpersonage en de boerderij na vijfentwintig jaren vergroeid met elkaar. Dit gegeven kan enkel filmisch werken in een boerderij die de littekens van de tijd vertoont, net zoals het gerimpelde gezicht van de oude man zijn leeftijd laat zien. De tijd heeft in <em>Romagne-sous-Montfoucan</em> diepe en blijvende sporen nagelaten. Het gebouw vertoont diepe architecturale rimpels. Dat geldt ook voor het meubilair. De historische littekens komen niet direct in beeld, maar via het thema van het kwaad belichten ze wel op een unieke wijze het verhaal dat Resurrection vertelt. De naam <em>Romagne-sous-Montfoucan</em> is namelijk sterk verbonden met het kwade dat verbonden is met de gruwel van <em>de Eerste Wereldoorlog</em>. In en rond de boerderij heeft de Duitse agressor in april 1916 <em>het Waltlager La Robinette</em> uitgebouwd, een afgelegen verblijfplaats waar de soldaten even konden uitrusten. De plaats ligt op circa 40 kilometer van het meer gekende Verdun. Het grootste Amerikaanse militair kerkhof in Europa, <em>het Meuse-Argonne American Cemetery</em> ― 14 246 graven over 52 hectaren ―  is gelegen in het landschap van Romagne-sous-Montfoucan. Er bevindt zich eveneens een kleiner Duitse militair kerkhof op het grondgebied van de gemeente, alsook een particulier uitgebreid museum <em>Romagne 14-18</em>. Vooral de soldatengraven zijn blijvende stille getuigen van de oorlog die het Amerikaanse en Duitse leger uitvochten gedurende <em>het Meuse-Argonne-offensief</em> tijdens de laatste maanden van de Eerste Wereldoorlog.</p>\n<p>In vorige eeuw heeft het kwade in de vorm van de oorlog zich gehuisvest in de boerderij. Dat gebeurt ook in de film, maar op een niet-historische manier. De oude man trok zich na de bomaanslag waarbij hij zijn vrouw en zoon heeft verloren, terug in de boerderij. Hij nam afstand van de bewoonde wereld. Sindsdien wantrouwt hij mensen. Nu blijkt dat hij, zonder het te beseffen, het kwade zelf herbergt wanneer hij de jonge man aan de rand van het bos aantreft en onderdak geeft. Via het hoofdpersonage van de boerderij La Robinette verbindt de regisseur het fenomeen van het historische kwade in de mensenwereld via de twee Wereldoorlogen met het hedendaagse kwaad van de terroristische aanslagen in het Westen, het Oosten, het Midden-Oosten en Africa. En die actuele verschijning van het kwade verbindt hij met het universele gegeven van het kwaad dat schuilt in het hart en de geest van iedere mens, belichaamd door de anonieme jonge man die zijn broer vermoordt. De reden waarom hij het deed, blijft onbesproken. Wellicht weet hij het zelf niet en is hij in zekere zin via de moord <em>het kwade in zichzelf</em> tegengekomen. In haar recent album <em>If All I Was Was Black</em> (2017) zingt de zwarte, Amerikaanse zangeres <a href=\"https://www.mavisstaples.com/\">Mavis Staples</a> de nieuwe song <em>Try Harder</em>. Die opent met de verzen: ‘<em>There’s evil in the world, and there’s evil in me.</em>’ Dit ongewild parallelisme tussen <strong>Resurrection</strong> en Mavis’ nieuwe song toont hoe de film zich beweegt op de golflengte van de worsteling van onze tijd met het fenomeen van het kwade. Het lijkt wel <em>een oerfenomeen</em> te zijn in de wereld bevolkt door mensen. Maakt religie daar deel van uit of is ze een humane respons op dat oerfenomeen? Die vragen openen de eigen betekenisruimte van <strong>Resurrection</strong>.</p>\n<p><a name=\"BET\"></a></p>\n<h2><font color=\"#808000\"><strong>Betekenisruimte</strong></font></h2>\n<p><span class=\"menstis\">HET CINEMASCOPISCHE TOESCHOUWERSCHAP AAN ZET</span>. Kristof Hoornaert stelt in een interview, gepubliceerd in de <em>Perskit</em> van de film, dat <strong>Resurrection</strong> ‘<em>een mentale film</em>’ is. Door de eigen kracht van de beelden is de toeschouwer aan zet. Hij maakt al schouwend de film in de mentale ruimte van zijn drie ogen: de twee ogen en het derde oog, het mentale oog (‘the mind’). Dat samenspel heet in <a href=\"http://www.menstis.be/uitgeverij/Levensbeschouwing\">Levensbeschouwing democratisch belicht</a>, <em>het contemplatievermogen</em> van de mens. Het maakt de mens tot het schouwend wezen dat hij kan worden. Die toeschouwer krijgt een actieve rol in de film. Tijdens de opnames zijn niet alleen de acteurs en de dingen aanwezig, maar ook de toeschouwer speelt mee. Dat uit zich in het gebruik van het cinemascoopformaat. Hierdoor komt de film het best tot zijn recht in een bioscoop. Regisseur Hoornaert licht in de <em>Perskit</em> van <strong>Resurrection</strong> zijn bewust gebruik van het cinemascoopformaat toe:</p>\n<blockquote>\n<p><em>Omdat dit formaat je toelaat om beelden te maken. Dat klinkt misschien vreemd, want is cinema niet altijd beeldend? Maar het brede cinemascoop-formaat zorgt ervoor dat je minder op de huid zit van je personages. Cinemascoop creëert een afstand tussen de kijken en het onderwerp dat je aan het filmen bent. Het is minder psychologisch. Je ziet een personage in zijn omgeving, dat maakt het beeld contemplatiever. Het ‘nadenken over’ is mijn doel met deze film. Cinemascoop geeft mij de mogelijkheid om de wereld te observeren in beelden. De camera als een telescoop of microscoop die de mens observeert in de wereld waarin hij leeft.</em></p>\n</blockquote>\n<p>De camera toont de personages op het ogenblik dat ze zich als mens in de situatie bevinden dat ze schouwend in het leven willen staan. Bij de oudere man is dat een zeer bewuste keuze. Na het dramatisch gebeuren van het kwade in de wereld die zijn hele wezen overhoop heeft gehaald, trekt hij zich terug in de boerderij La Robinette. Telkens wanneer hij met het kwade in aanraking komt, zoekt hij schouwend te horizon op. Dat gebeurt wanneer hij op de radio het live verslag hoort van een alweer nieuwe terroristische aanslag. Eerst gaat hij naar zijn slaapkamer waar hij het Onze Vader bidt, waarna hij buiten tussen de twee bomen over de horizon schouwt. Die zoekt hij opnieuw op wanneer het na het bezoek van de politie het bij hem begint door te dringen dat hij een jonge moordenaar onderdak heeft verleend. Op de dag dat hij ontdekt dat de jonge man weg is gegaan zonder iets te zeggen, verbindt de oude man zich opnieuw schouwend met de horizon waaraan hij zo gehecht is. Het is zijn tweede thuis. De oude man staat schouwend in het leven. Dat betekent dat hij het leven met al zijn dingen die hem omringen, inademt tot in het diepste vezels van zijn bestaan. Zijn schouwen is voor hem een act van intense verbondenheid met alles wat deel uitmaakt van zijn bestaan in de boerderij en het omringende landschap. Die intensiteit wordt zichtbaar in zijn gelaat en zijn gebaren. Dat laatste blijkt uit de wijze waarop hij de wit-roze bloem van de kamerplant felicia streelt op de vensterbank en de roos op de struik nabij de groentetuin. Hij gaat zorgzaam om met zijn dieren. En in de derde beweging stapt hij naar de plaats delict. Op de plaats waar het lijk is gevonden, raakt hij de aarde aan en legt hij er zich neer. Op het einde van de derde beweging, met name na het tafereel met de bloedneus van de jonge man, gaat de oude man opnieuw naar buiten, schouwt over de horizon, stapt toe naar een oude boom, raakt die wenend aan. <em>Toeschouwen</em> is geen passieve bezigheid, het is een act van intense verwevenheid met de levensader en met de tragiek die eigen is aan het menszijn.</p>\n<p><span class=\"menstis\">HET MENSELIJKE GELAAT VAN HET KWADE.</span> <strong>Resurrection</strong> opent met een dubbel beeld van het fenomeen van het kwade. De proloog evoceert in een ononderbroken sequentie het drama van een terroristische aanslag. Het tafereel synthetiseert de niet aflatende beelden van de bloedige aanslagen die de voorbije jaren de nieuwsbeelden de revue zijn gepasseerd. Daarna opent de eerste beweging met de broedermoord. Twee jonge mannen vechten midden in het bos op leven en dood. Een van de twee wordt de moordenaar, de ander het slachtoffer. Het gebeuren voltrekt zich. Er is geen context behalve het bos. De beelden ontdoen het fenomeen van het kwade van al zijn historische verschijningen en tonen er de concrete harde kern van. Het betreft het beroven van het leven van een mens door een medemens. Twee mensen, twee broers, delen hetzelfde leven, hebben dezelfde moeder, maar de een gunt de andere niet de gave van het leven, die hij nochtans zelf ook als een kostbaar geschenk heeft ontvangen. De registratie van dàt oerfenomeen gebeurt door een derde, de regisseur, de beschouwer. Hij neemt afstand van dat kwade, maakt er zich los van en wordt beschouwer. Die beschouwer is altijd <em>een levensbeschouwer</em>. Hij stelt vragen waarvan de klank een echo vormt die weerklinkt tot in het heelal. De oude man luistert naar de vragen van de politie die op zoek zijn naar de dader. Hij luistert terwijl hij de mannen aankijkt. Zijn blik en gelaat spreken boekdelen. Zijn woorden zijn gemeten: ‘<em>Dat zo iets kan gebeuren!</em>’ Niet alleen die spaarzame woorden, niet alleen zijn blik, maar ook zijn hele lichaam, zijn wenen, vertolkt zijn verwondering over de niet te stoppen gang van het kwade. Die verwondering vormt de bron van de schouwende blik van de oude man in <strong>Resurrection</strong>. Hij is de dubbelganger van de regisseur zelf.</p>\n<p>Kristof Hoornaert maakte zijn debuut als cineast met de kortfilm <strong>Kaïn</strong>. Dat was zijn zeer geslaagde vingeroefening, de opstap naar <strong>Resurrection</strong>, met een tussentijd van acht jaar. De proloog van de film is een bewerking van <strong>Kaïn</strong>, nu gecomponeerd als de ouverture op de eerste langspeelfilm van Hoornaert. De titel <strong>Kaïn</strong> verwijst naar het Bijbelverhaal Kaïn en Abel in <em><a href=\"https://www.kuleuven.be/thomas/page/bijbelfiche-kain-en-abel/\">Genesis 4, 1-16</a></em>. Hier is de anonieme schrijver de tolk van de menselijke verwondering over het oerfenomeen van het kwade dat de ene mens de andere aandoet. <strong>Kaïn</strong> en de proloog van <strong>Resurrection</strong> illustreren het Bijbelverhaal niet. Ze dringen door tot <em>de levensbeschouwende kern</em> ervan, verborgen in de taal. Die Bijbeltaal zoekt de verbeelding op via het beeld van de twee broers Kaïn en Abel. Het giet de verbeelding in de mal van de taal. Dat impliceert dat het verhaal gevangen zit in een bepaald denkpatroon dat in dit geval bestaat uit een genealogische gedachtegang, gecombineerd met een bepaalde religieuze voorstelling, eigen aan een etnische bevolkingsgroep op zoek naar haar eigen identiteit. De cinematografie van <strong>Kaïn</strong> en <strong>Resurrection</strong> weekt het oerfenomeen van het kwade los van die literaire en culturele inbedding. Ze onthult er <em>de blijvende, levensbeschouwelijke kern</em> van, het open zicht op de overrompelende aanwezigheid van de tragiek van het kwade dat menselijke wezens elkaar blijven aandoen, ook en vooral zij die broeders zijn en dus van nature geroepen zijn om elkaar te helpen en te steunen. Diezelfde verwondering komt ook in een ander, overgeleverd genealogisch verhaal terug. Vergilius’ <em>Aeneas</em> vertelt in de eerste eeuw v. Chr. het mythisch verhaal van de oorsprong van de stad Rome door de tweelingbroers <em>Romulus</em> en <em>Remus</em>. Romulus vermoordde zijn tweelingbroer na een ruzie over de vraag wie van beiden de eerste koning over de stad zou worden en naar wiens naam de stad genoemd mocht worden. Ook hier drong het besef van de broedermoord door tot in de diepste lagen van de Romeinse collectieve herinnering. In <strong>Kaïn</strong> en de proloog van <strong>Resurrection</strong> ontdoet Hoornaert die herinneringen aan het fenomeen van de broedermoord van hun genealogische context. Hij smeedt het tot <em>het oerbeeld van het kwaad</em>, gesitueerd in de context van het bos, tastbaar teken van de planetaire thuis van de mensheid. Dat beeld onthult het grote contrast tussen de grootsheid en schoonheid van het leven op aarde en het moordend geweld van de mensen. Zij verschijnen als een klein deel van de grote, groene levenszone. Zij hebben geen enkel oog voor datgene waaruit ze zijn voortgekomen en wat ze delen, het levende leven. Ze slaan op elkaar in en gunnen elkaar geen levensruimte. De een slaat de ander dood. De beschouwer bij uitstek, de oude man in de boerderij, registreert dat destructief gegeven, eigen aan de mensenwereld, <em>met</em> en <em>in</em> heel zijn wezen. In de vierde beweging spreekt de oude man de jonge moordenaar aan. Op het einde van het korte getuigenis over zijn eigen levensgeschiedenis verwijst hij ook naar de broedermoord. Hij zegt letterlijk: ‘<em>Hoe kan zo iets gebeuren? Hoe kan je zo iets doen? Waarom in Gods Naam?</em>’ Hij vertolkt zijn levenslange verwondering over de terugkeer van het kwade in de aardse mensenwereld. Hij stelt vragen in het besef dat er geen antwoord voorhanden is. De jonge moordenaar kan zelf geen woord uitbrengen. De politie vertegenwoordigt het antwoord van de maatschappij. De twee mannen moeten het probleem van de moord oplossen door de dader te vinden. Dan is, zoals dat heet, ‘de moord opgelost’. De oude man weet beter. Als de beschouwer ziet hij in de lokale moord de heerschappij van het oerfenomeen van het kwade. In zijn levensbeschouwelijke aanwezigheid bij de dingen en de gebeurtenissen ontdoet hij het kwade van zijn maatschappelijk en psychologisch omhulsel. Hij beslist om de jonge moordenaar die in zijn huis schuilt, niet aan de politie uit te leveren.</p>\n<p><span class=\"menstis\">DE BARMHARTIGE SAMARITAAN.</span> Wanneer de hond van de oude man de jonge moordenaar in het hoge gras aan de rand van het bos heeft gevonden, neemt de oude man de jonge man in bescherming. Hij roept de hond bij zich, stelt de jongen gerust en nodigt hem uit te komen schuilen bij hem thuis voor het nakende onweer. De oude man doet zijn jas uit om die over de schouders te leggen van de halfnaakte, verwarde jonge man. Die schrikt even en gaat een stap achteruit. Daarop overhandigt de oude man zijn jas aan de jonge man. Die trekt de jas van de man aan en volgt hem richting boerderij. Dit kennismakingstafereel contrasteert helemaal met die van de broedermoord. De oude man behoort tot een andere wereld en leidt de jonge binnen in een ongekende zone van leven. Het openingstafereel van de eerste beweging introduceert de oude man als een <em>Barmhartige Samaritaan</em>, een personage geïntroduceerd in <a href=\"https://www.kuleuven.be/thomas/page/bijbelfiche-de-barmhartige-samaritaan/\">Lucas 10, 25-37</a>. Op de theoretische en theologische vraag wie is mijn naaste, antwoordt Jezus <em>beeldend</em>. Hij laat zich niet verleiden tot allerlei spitsvondige discussies met hun pirouettes van begrippen. Via het beeldend verhaal plaatst Jezus de vraag op de aarden vloer van het leven zelf. Alleen de kracht van het beeld kan dat en alleen de schouwende toehoorder verstaat dat. De hele eerste beweging staat vanaf de introductie van de oude man helemaal in het teken van het gebaar van de Barmhartige Samaritaan. Hij is de anonieme man die reageert op de gevolgen van het kwade in de mensenwereld. In <strong>Resurrection</strong> krijgt dit gegeven een bijzondere uitvergroting omdat hier de Barmhartige Samaritaan zich niet over het slachtoffer, maar over de dader ontfermt. Hij ziet een jonge man in nood en herbergt hem. Hij geeft hem een onderdak, eten en drinken, en kleding. Hij schenkt de jonge man een T-shirt van zijn omgekomen zoon die ongeveer dezelfde leeftijd had van de jonge, anonieme man. Maar de houding van de Barmhartige Samaritaan reikt verder dan die in het Bijbelverhaal. De oude man biedt de jonge man in nood niet enkel materiële, lichamelijke bescherming. Hij doet veel meer. Hij neemt een belangrijke beslissing na de eerste bevraging van de politie waardoor hij beseft dat hij de dader van de broedermoord onderdak verleent. Dat brengt een nieuwe dynamiek op gang, een dynamiek die zich bevindt aan de overzijde van de zuiver maatschappelijke of politionele omgang met het kwade. Vanaf de derde beweging ontwikkelt zich de levensbeschouwelijke confrontatie met het kwade in de dubbele regie van de oude man en Kristof Hoornaert.</p>\n<p><span class=\"menstis\">ROUW EN BEROUW.</span>De jonge moordenaar komt in de boerderij in contact met een hem volkomen vreemde wereld. Die staat haaks op de wereld waarvan hij de vertegenwoordiger is, die van het kwade in zijn ergste vorm: doodslag. Eerst is de jonge man verwonderd over de gastvrijheid van de oude man. Zonder enige vraag of uiterlijke dwang krijgt de jonge man kleding, eten en drinken, en een plaats om te slapen. Van de derde beweging af weet de oude man dat hij een moordenaar in huis heeft gehaald. Hij accepteert hem door te weigeren hem uit te leveren aan de politie. Wat hij vijfentwintig jaar heeft vermeden, de confrontatie met het kwade in de mensenwereld, staat en zit nu voor hem in de figuur van de jonge man. Uit zijn houding blijkt hoe de oude man daarover een zekere angst vertoont. Zal de jonge man zich ook tegen hem keren? Zal hij, net zoals zijn vrouw en zoon, uiteindelijk ook het slachtoffer worden van dat onbegrijpelijke kwade? Hij overwint zijn terechte angst en eerste verbijstering over wat hij nu meemaakt. Hij beslist om het kwade dat zo dichtbij is gekomen, helemaal onder ogen te zien. Daarbij blijft hij trouw aan zijn levensbeschouwelijke houding. Hij blijft zorgen voor de jonge man die hij mentaal ziet lijden: de onmacht om te spreken, de vertwijfeling in zijn blik, de handen aan zijn hoofd alsof er een storm in woedt, de schreeuw van een verscheurde ziel, het bloeden uit de neus, het overweldigende verdriet.</p>\n<p>De oude man geeft de jonge moordenaar de ruimte en de tijd om het kwade in zichzelf onder ogen te zien. Concreet gebeurt dit door de jonge dader op te nemen in <em>de dagelijkse rituelen van het wonen</em>: de tafel dekken, de handen wassen, brood eten, melk drinken, slapen, ontwaken. Die rituelen scheppen ruimte en tijd voor het verdriet eigen aan de rouw (de oude man) en het berouw (de jonge moordenaar). Dat menselijk verdriet verweeft zich met wat we hier in de sfeer van de film, de <em>weeklank</em> ― nee, niet de weerklank, maar inderdaad de <em>weeklank</em> ― van de dingen noemen. In de eerste en de vierde beweging weent de hemel regen. Die begeleidt en bezegelt de mensentranen. De oude man voert de rituelen van het wonen uit met een priesterlijke waardigheid. De jonge man merkt dat en na zijn eerste verwondering daarover, neemt hij geleidelijk aan die rituelen over. Het betreft geen de rituelen van een of ander religieuze cultus. Neen, de rituelen maken deel uit van <em>de levenskunst</em> die haar wortels vindt in <em>de levensbeschouwelijke attitude</em> van de oude man. Ze vormen het dagelijkse leven. Ze openen voor de jonge moordenaar de poort naar <em>het basale leven</em>. Het kwade waarin hij heeft verbleven heeft hem afgesneden van de oergrond van zijn eigen bestaan. De oude man is na de confrontatie met het kwade in de grootstad, teruggekeerd naar dat basale leven, ver van de stedelijke samenleving die zich steeds verder daarvan verwijdert. In het landschap met de boerderij heeft hij de wijding van het basale leven teruggevonden. Daar heeft hij <em>zijn eigen zone van zin</em> ontwikkeld in de rituelen die een even eenvoudige als complexe uiting zijn van de zorg voor het dagelijkse wonen in verbondenheid met het omringde aardse leven.</p>\n<p>Het is in die zone van het basale leven dat de jonge moordenaar terug contact krijgt met <em>zijn eigen menselijke grondlaag</em>. Zo ontdekt hij dat de hond van de oude man over hem komt waken. De hond beschermt hem en blaft naar de politie als die begint vragen te stellen over de mogelijke aanwezigheid van de jonge moordenaar. Geleidelijk adopteert de jonge man de rituelen van de oude man over. Dat blijkt uit het gebaar van het strelen van de bloem van de kamerplant. De jonge man legt zich op het bed van de oude man en ziet hoe het kruisbeeld aan de muur in het blikveld van de oude man hangt. Hij interesseert zich in zijn beschermer die hij geleidelijk als zijn leidsman accepteert. Hij opent de schuif in het nachtkastje van de oude man en vindt er een oud exemplaar van het boek <em>Ornaments de la mémoire</em>, met erin een foto van diens echtgenote en zoon. Hij schenkt op zeker ogenblik zelf water in in het glas van de oude man. Hij helpt mee opruimen en afwassen. Hij luistert mee met de oude man naar het radiobericht over de terroristische aanslag, zoals hij ook aandachtig luistert naar het levensverhaal van de oude man en diens indringende levensvragen aan hem. Hij neemt zelf het initiatief om de radio aan te zetten en het begin van het Latijnse <em>Requiem</em> in zich op te nemen. Hij stelt zich steeds kwetsbaarder op om op zeker ogenblik te beginnen bloeden uit zijn neus waarop ook een fysiek litteken van de moord zichtbaar is gebleven. Daarna blijft hij het T-shirt met de vlek van zijn eigen bloed dragen als zijn tweede litteken. Was er vanaf de eerste kennismaking, de eerste beweging, een afstand tussen beide mensen, dan verkleint die afstand geleidelijk op <em>het levensritme van de basale rituelen</em>. Die beweging van toenadering mondt uit in <em>het beeldende crescendo</em> van de wederzijdse omarming. Daarmee besluit én de vierde én de laatste beweging.</p>\n<p><span class=\"menstis\">DE TROOST VAN HET HEMELS-AARDSE LICHT.</span> Het krachtigste ritueel van de levenskunst, beoefend door de levensbeschouwelijke oude man, is <em>het schouwen over de horizon</em>. Daarin beleeft hij zijn de betrokkenheid met de bron van alle leven op aarde, het hemelse zonlicht, dat in het derde deel van <a href=\"http://www.menstis.be/uitgeverij/Levensbeschouwing\">Levensbeschouwing democratisch belicht</a> met het neologisme <em>de Lichtaard</em> wordt genoemd. Het visuele leidmotief van de hemelbeelden met de wolken en de zon, van de lichtbeelden aan het raam, van het bladerdek met de zon, van de panoramische beelden met de lichtende horizon, onthult hier zijn eigen unieke betekenis. Vooral in de lichtbeelden aan het raam weerkaatst de kracht van de Lichtaard zich op het gezicht van de personages. De oude man zoekt voortdurend dat licht op bij het raam met de kamerplanten, vooral dan wanneer hij voelt dat zijn verdriet over het kwade weer dreigt de bovenhand te halen. Het licht door het raam nodigt hem uit naar buiten te gaan waar hij over de lichtende horizon schouwt. In die schouwende verbondenheid met dat licht vindt hij niet alleen troost, maar bovenal energie en kracht om menselijk weerstand te bieden aan de impact van het kwade. Dat is de rijkste beleving die hij via de basale rituelen van de levenskunst zonder woorden overbrengt naar de jonge moordenaar. Ook die begint de richting van het licht op te zoeken. Hij gaat ook naar het raam toe om in dat licht zijn schouwend vermogen te ontdekken.</p>\n<p>Het slottafereel van de tweede beweging staat helemaal in het teken van die ommekeer van de moordenaar. Hij bevindt zich alleen in de kamer met de radio waarmee hij zopas het dramatische bericht over de terroristische aanslag mee heeft beluisterd. Hij heeft de oude man, overmand door een groot verdriet, de kamer zien verlaten. Hij draait opnieuw aan de radioknop en beluistert er Mozart’s <em>Requiem</em>. Hij laat er zich door raken. De muziek spreekt over de doden in relatie tot het hemelse licht, <em>Lux Aeterna</em>. De camera volgt de blik van de jonge man. Die gaat richting het raam met het volle licht die de drie kamerplanten doet groeien en bloeien.</p>\n<p><span class=\"menstis\">VERLOS ONS VAN HET KWADE.</span>De tweede beweging is cruciaal in de eigen narratieve ontwikkeling van <strong>Resurrection</strong>. In de dramatische ontwikkeling ervan omvat ze het tafereel met het Onze Vader. En de beweging eindigt met het <em>Requiem Aeternam</em> van Mozart. Beide momenten zijn gebedsmomenten. Het Onze Vader wordt luidop gebeden door de oude man nadat hij het live bericht over de terroristische aanslag heeft gehoord. Hij doet het helemaal alleen in zijn slaapkamer, geknield voor het kleine kruisbeeld aan de muur. Opmerkelijk daarbij is dat hij de slotzin ‘<em>En verlos ons van het kwade</em>’ herhaalt. Daarbij beschrijft hij met zijn blik een verticale beeldlijn. De eerste maal buigt hij zijn hoofd naar de vloer, de tweede maal richt hij zijn blik opwaarts naar het kruisbeeld. Ook het <em>Requiem Aeternam</em> is een gebed. Het wordt gezongen door een koor. De jonge moordenaar laat het weerklinken in de kamer waar hij met de oude man eet. Daarbij absorbeert hij de requiemmuziek terwijl hij zijn blik richt naar het lichtende raam. Later verkent de jonge man de slaapkamer van de oude man en ziet er het kruisbeeld hangen. Via zijn gastheer en zwijgzame mentor verlaat hij langzaam de mentale kamer van het kwade waarin hij zat opgesloten en treedt hij binnen in de lichtende kamer van de levenskunst. Hij ontdekt dat de sleutel tot die mentale kamer <em>een christelijke signatuur</em> heeft. Via de beluistering van het <em>Requiem</em>, het gezongen Latijnse openingsgebed van de katholieke begrafenisdienst, én via de ontdekking van het kruisbeeld in de slaapkamer, komt de jonge man op het spoor van de christelijke motivatie van zijn beschermheer, zijn Barmhartige Samaritaan. Hierdoor krijgt de betekenisruimte van <strong>Resurrection</strong> een <em>expliciete, christelijke</em> dimensie. Kristof Hoornaert spreekt in de <em>Perskit</em> daar ook zelf over. Hij belicht daarbij de titel en de anonieme figuur van de oude man. Hij verduidelijkt:</p>\n<blockquote>\n<p><em>’Resurrection’ is een zwaar geladen titel. Daarom wordt die ook gepresenteerd in kleine letters in de film en op de poster. Het is een kleine symbolische verrijzenis van het hoofdpersonage. Natuurlijk wilde ik met deze titel ook verwijzen naar de verrijzenis van Christus. Ik wou altijd al een film maken over een Christusfiguur in onze moderne wereld. Een interessant idee om deze twee gegevens te contrasteren met elkaar.</em></p>\n</blockquote>\n<p>In die optiek verschijnt de oude man als <em>een Christusfiguur</em> in onze supermoderne wereld, getypeerd door zijn overbevolkte grootsteden met hun anonieme, agressieve beton- en glasarchitectuur, hun onophoudelijke strijd tegen alle vormen van agressie, hun hectische beeldschermcultus, hun verstikkende lucht en  ongebreidelde consumptiecultuur, gedirigeerd door een ontembare geldhonger. Die christelijke, of misschien beter gezegd, die <em>christische</em> dimensie van <strong>Resurrection</strong> blijkt uit de eigen, unieke strijd van de oude man tegen de terreur van het kwade. Die uit zich in zijn werk als Barmhartige Samaritaan tegenover de jonge moordenaar, zijn Onze Vader-gebed, zijn religieuze verbondenheid met de lichtende schepping van het leven op aarde. Zijn <em>christische levenskunst</em> kristalliseert zich in zijn wil om het kwade op te heffen door het te <em>absorberen</em>. Hij trekt naar de plaats delict en legt zich op de plaats van het lijk, eerst met zijn gezicht gekeerd naar de aarde zelf, daarna op zijn rug met zijn blik gericht naar de zon die door het bladerdek op een klaarlichte dag wenkt als een Ster van Bethlehem. Tegelijkertijd oogt de locatie in het bos als een neergevallen kruis door de wijze waarop de omgevallen boom in het bos ligt over de plaats waar de moordenaar het lijk heeft gedumpt. De oude man identificeert zich met het slachtoffer dat onder het gewicht van het kwade werd ‘gekruisigd’. De oude man vervolgt zijn absorptie van het kwade door zich ook te identificeren met de dader. Hij biedt hem een fysieke en mentale thuis waarin die zich kan verlossen van het kwade dat zijn hele menselijke wezen in zijn greep heeft. Die identificatie mondt uit in de dubbele omarming, eenmaal in het huis van de verrijzenis, en eenmaal in de gevangenis waar de oude man de plaats inneemt van de dader. Dat laatste gebeurt concreet met het gebaar van de Barmhartige Vader uit de parabel van de verloren zoon (Lc.15,11-32) in de beeldende versie van <a href=\"https://nl.wikipedia.org/wiki/Terugkeer_van_de_Verloren_Zoon\">Rembrandt van Rijn</a>. De oude man, de vader, neemt het initiatief van de omarming. Zoals de verloren zoon bij Rembrandt, is ook de jonge man in <strong>Resurrection</strong> helemaal kaal. Ze kunnen broers van elkaar zijn. De mentale verrijzenis bij de jonge man voltrekt zich via <em>de christische kracht van de barmhartigheid</em>. Dat gebeuren voltrekt zich in de intieme ruimte van de gevangeniscel, buiten alle aandacht van de media. Dat betekent dat het christische gebeuren voortkomt uit de levensbeschouwelijke regie van de toeschouwer bij uitstek, de cineast. Hij stelt zich op als <em>de eerste en bevoorrechte toeschouwer van de menswording</em> die zich voltrekt in de confrontatie met het kwade. <strong>Resurrection</strong> verschijnt hierdoor als <em>een filmische of levensbeschouwelijke parabel</em> over de confrontatie met het kwade op de scène waar de levenswegen van personen elkaar kruisen.</p>\n<p>In die zin brengt de film  een ode aan het eigen mentale, levensbeschouwelijke werk <em>van, door en voor</em> de toeschouwer. De film handelt aldus niet alleen over het kwade, het is ook <em>een mentale remedie</em> tegen dat kwade.</p>\n<p><a name=\"CON\"></a></p>\n<h2><font color=\"#808000\"><strong>Context</strong></font></h2>\n<p><strong>Resurrection</strong> is een unieke, gedurfde en moedige Vlaamse film die zich bewust inschrijft in de rijke traditie van vooral de Europese cinematografie, ook nog de auteurscinema genoemd. Samen met de jonge <a href=\"http://www.menstis.be/film-focus/desterre/\">Gust Van de Berghe</a> vormt Kristof Hoornaert een jongste generatie die, tegen de geldende stroom van de Vlaamse Hollywoodfilm van de Jan Verheyens en de Erik Van Looy’s in, trouw blijven aan de exploratie van de unieke zeggingskracht van de kunst van de cinematografie.</p>\n<p><a name=\"LIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Links</strong></font></h2>\n<p>De website van <a href=\"http://www.kristofhoornaert.com/\">Kristof Hoornaert</a>.</p>\n<p><font size=\"-2\">© Sylvain De Bleeckere, Men(S)tis, 2018</font></p>\n"}

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

	module.exports = {"title":"Samsara","body":"<center>\n<img src=\"samsara.gif\" >\n</center>\n<p><a name=\"KLA\"></a></p>\n<h2><font color=\"#808000\"><strong>Klapbord</strong></font></h2>\n<p>Slechts enkele kleine en alternatieve bioscopen durfden het in Vlaanderen aan om de film <strong>Samsara</strong> van de Indische regisseur Pan Nalin te programmeren. De film kreeg aldus een kleine kans om een publiek te vinden. Een van die bioscopen prees de film aan met het volgende statement: ‘<em>Een jonge boeddhistische monnik raakt volledig in de ban van een beeldschone vrouw. Hun stomende vrijscènes zorgen er uiteindelijk voor dat zijn nirvana eerder overhoop wordt gehaald</em>.’ Deze beschamende nonsense doet de film onrecht aan. De presentatie haalt niet eens het niveau van de reclame voor een zuiver commerciële Hollywoodfilm. Het onderkoelde cynisme bewijst volkomen blind te zijn: blind voor de beelden en blind voor hun grote spirituele rijkdom. <strong>Samsara</strong> is namelijk in tal van opzichten een meesterwerk. De film en zijn auteur verwerven zich een vaste plaats in de schatkamer van <em>de religieuze cinematografie</em>.</p>\n<p><a name=\"SYN\"></a></p>\n<h2><font color=\"#808000\"><strong>Synopsis</strong></font></h2>\n<p>Tashi groeit op als een boeddhistische lama in het schilderachtige berglandschap van het Indische Ladakh. Hij gaat helemaal op in zijn opleiding. Via een strenge discipline en volgehouden studie wil hij de spirituele verlichting bereiken. De oudere Apo en de jongere Sonam omringen en steunen hem. Op zeker ogenblik beslist Tashi drie jaar, drie maanden en drie dagen in afzondering te gaan leven. Heel zijn bestaan staat nu in het teken van meditatie en yoga. Hij bereikt het punt van het nirvana. Met dat punt begint de film. Apo en Sonam brengen Tashi uit zijn nirvanabeleving terug naar het klooster. In boeddhistische termen betekent die terugkeer het opnieuw intreden in het samsara: de kringloop van dood en wedergeboorte. Tashi herstelt fysisch en neemt terug deel aan het kloosterleven. Toch ervaart hij bij zichzelf enige veranderingen. Het beeld van een jonge moeder die haar baby voedt, dringt diep in zijn geest binnen. Hij krijgt seksuele dromen en wordt onrustig. Tijdens een oogstfeest ontmoet hij Pema, de huwbare dochter van een plaatselijke graanboer. Na zijn inwijding in het tantrisme door een asceet, beslist Tashi het klooster te verlaten. Hij treedt binnen in de wereld van het samsara. Hij huwt Pema, ze krijgen een jongen Karma. Tashi maakt zijn schoonvader economisch onafhankelijk van de lokale graanhandelaar, Dawa. Voorts komt hij in conflict met Jamayang, de jonge man uit het dorp aan wie Pema eerder was toegewezen. Tashi ondergaat ook de verleidende kracht van de jonge seizoenarbeidster Sujata. Maar nog meer ontdekt Tashi de eigen wijsheid van Pema zelf. Op zekere dag beslist hij uit de wereld van samsara te stappen en terug te keren naar het klooster. Op zijn weg komt hij echter Pema tegen die hem confronteert met zijn verantwoordelijkheid tegenover haar en hun kind. Die confrontatie werpt Tashi letterlijk op de aarde: hij huilt en kijkt naar de hemel boven hem.</p>\n<p><a name=\"CIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Cinematografie</strong></font></h2>\n<p><span class=\"menstis\">AUTODIDACT</span>. Regisseur Pan Nalin  schreef samen met Tim Baker het scenario naar een eigen verhaal van Nalin. Met <strong>Samsara</strong> levert Nalin zijn eerste langspeelfilm af. Gezien het resultaat is dat een enorme verdienste. Als cineast is hij een autodidact die in 1992 een eerste kortfilm draaide, <strong>Khajuraho</strong>. Zijn spirituele Ayurveda-opvoeding thuis, zijn talrijke trektochten doorheen India en Europa, zijn werkervaring in Bollywood te Bombay, zijn filmclub waar hij retrospectieves organiseerde van het werk van Tarkovski, Goddard, Kurosawa, Eisenstein en Bunuel, zijn spirituele leerschool in de Himalayastreek, dat alles mondde in 2001 uit in twee belangrijke internationale films: de fictiefilm <strong>Samsara</strong> en de lange documentaire film <strong>Ayurveda: Art of Being</strong>.</p>\n<p><span class=\"menstis\">ZENEMATOGRAFIE</span>. Het heeft Nalin zeven jaar gekost om de hele productie van <strong>Samsara</strong> rond te krijgen. In <strong>Samsara</strong> ontwikkelt hij een cinematografie die hijzelf doopt met de nieuwe naam <em>zenematografie</em>. Het begrip vertrekt van het boeddhistische begrip zen. De cineast gebruikt het niet in de strikte zin van het Japanse zenboeddhisme. Zen verschijnt hier in een algemene zin, en duidt op de oosterse cultuur waarin meditatie en yoga binnen een vooral boeddhistische omgeving centraal staan. In <strong>Samsara</strong> gaat het om een Tibetaans boeddhisme met veel lokale, Noord-Indische accenten en met een expliciete inbreng van het tantrisme, een in wezen hindoeïtische religie. Deze zenematografische werkwijze impliceert dat de filmploeg, technici en acteurs, tijdens het draaien spirituele werksessies houden. Ze mediteren en beoefenen yoga. Uiteraard uit zich deze cinematografie in de kunst van de beelden en de klanken zelf. Een belangrijk zenematografisch aspect betreft <em>de wereld van het licht en de daarmee verbonden kleuren</em>. De proloog van de film die tevens als generiek dient, introduceert de toeschouwer in <em>de adembenemende, picturale schoonheid van het Indische hooggebebergte in Ladakh</em>. Het licht regisseert. Het onthult een landschap met wijdte en een diepte die de mens sprakeloos maakt en hem tot inkeer brengt. Uit datzelfde magische licht ontstaat ook de diverse kleuren. De filmcrew heeft de grootste zorg besteed aan de kleding van de personages. Vooral aan de kleuren ervan besteedde men heel veel aandacht. Via hun kleding integreren de personages zich in de omgeving of vormen ze ermee een contrast. Dat gegeven speelt ook dramatisch mee op het niveau van het scenario en wel op twee cruciale vlakken. Ten eerste, voltrekt het personage Tashi een belangrijke beweging die begint in de duisternis van zijn nirvanaverblijf: Apo en Sonam brengen hem terug in de werkelijkheid van het licht en dekken Tashi’s ogen af om te voorkomen dat hij tijdens de overgang van duisternis naar licht zijn ogen niet schaadt. Ten tweede, het personge Tashi draagt verschillende kleren in de loop van de film. De spirituele fasen die hij doormaakt, verbeelden zich in zijn kleding.</p>\n<p><span class=\"menstis\">SOUNDSCAPE</span>. Van de talrijke cinematografische kwaliteiten valt ook de verzorgde klankband op.  <strong>Samsara</strong> kent weinig gesproken passages. Dat betekent niet dat de meeste sequenties stil zijn. Veeleer vormen de reële dingen en gebeurtenissen het klankmilieu van <strong>Samsara</strong>. In de eerste plaats geldt dat voor de bergwind. De talrijke beelden van typische Tibetaanse wimpels maken de alom aanwezige en sterke onzichtbare wind tastbaar. De natuurlijke muziek van de bergstroom begeleidt als een vast personage de mentale reis van Tashi. Voorts weerklinkt op een indringende wijze de cultische muziek van de monniken, alsook de etnische muziek van de feestende boerengemeenschap.</p>\n<p><span class=\"menstis\">CIRKEL</span>. De film bevat een rijkdom aan beeldcomposities waarvan de eigen picturale waarde de uitwerking van de betekeniswereld ondersteunt. Er zijn de panoramische beelden die de goed gekozen close-ups omkaderen. Het ritme van de seizoenen krijgt veel aandacht; vooral de sequenties in de winter en die in de oogsttijd dragen hun betekenis over op wat er met de personages gebeurt. Een belangrijk cinematografisch element ent zich op de spirituele titel: <strong>Samsara</strong>. Daarin staat de figuur van de cirkel - de kringloop - centraal. In de geest van de zenemotagrafie gaat het om een dynamische cirkel. De cirkel van de kringloop omschrijft bijvoorbeeld <em>het zeer indrukwekkende openingstafereel met de arend</em> die ook terugkeert in het slotbeeld. Voorts componeert de zenemotografische cirkel <em>de bijzonder originele montage en poëzie van de eerste liefdescène tussen Tashi en Pema</em>. In andere sequenties blijft de camera onbeweeglijk, maar komt de cirkelbeweging in het beeld voor vanuit de beweging van de personages zelf: de opvallend opgebouwde verleidingsscène met Sujata en Tashi, en de dramatische confrontatiescène met Pema en Tashi.</p>\n<p><a name=\"BET\"></a></p>\n<h2><font color=\"#808000\"><strong>Betekenisruimte</strong></font></h2>\n<p>De zenematografie van <strong>Samsara</strong> schildert via het portret van het hoofdpersonage lama Tashi een boeiende en inspirerende betekeniswereld. De film blijft niet steken in een documentair exotisme. De personages krijgen een eigenheid die past binnen de ontwikkeling van een beeldend uitgewerkt, spiritueel drama. In de kern van dat drama ontwikkelt Nalin Pan een eigen origineel denken dat zijn diepe wortels heeft in <em>de religieuze en spirituele tradities van het Oosten</em>, zowel van de Indische als de Chinese culturen, alsook in <em>de religieuze en spirituele traditie van de Europese auteurscinema van auteurs als Tarkovski, Bunuel en Godard</em>. Wat deze Europese cineasten doen met de Europese, christelijke tradities, realiseert Nalin Pan ten aanzien van de overgeleverde oosterse tradities van vooral het Mahayana boeddhisme en het hindoeïstische tantrisme. Hieruit blijkt dat in het spirituele midden van het cinematografische beeld de westerse en oosterse culturen een gemeenschappelijke ontmoetingsruimte vinden. Nalins beeldende interpretatie van ‘samsara’, bevindt zich zeer dicht bij Tarkovski’s verbeelding van de heilige waarde van ‘het leven’. Nalin evoceert dat er in wezen geen scheiding dient te bestaan tussen spirituele waarden en het concrete leven van de mens. In bepaalde boeddhistische interpretaties begint spiritualiteit wanneer iemand <em>de kringloop van dood en wedergeboorte</em> verlaat. Nalin brengt het drama in beeld waarbij de boeddhistische monnik Tashi <em>de omgekeerde weg</em> aflegt: van het bijna-nirvana punt, eigen aan het streven van de monnik, naar het samsara punt, eigen aan het leven dat mensen iedere dag ervaren en waaraan ze een zin geven…met vallen en opstaan.</p>\n<p><a name=\"CON\"></a></p>\n<h2><font color=\"#808000\"><strong>Context</strong></font></h2>\n<p>Pan Nalins <strong>Samsara</strong> is de eerste langspeelfilm die volledig is opgenomen in <em>Ladakh</em>. Het gebied bevindt zich in Noord-Indië. Het wordt omzoomd door <em>de bergketens van de Grote Himalaya en de Karakoram</em>. Een deel behoort tot de Indische provincie Jamnu, een ander deel tot de Indische provincie Kasmir. Het bevindt zich dus in het gebied waar Indië en Pakistan elkaar diplomatiek en militair bestrijden. Het gebied is zowel historisch als geografisch erg ongewoon voor Indië. Het wordt trouwens ook ‘Klein Tibet’ genoemd. Gezien de grote onderdrukking van de Chinese Tibetaanse cultuur wint <em>het ongeschonden Tibetaanse Ladakh</em> aan belang. Alleen het gevaarlijke westerse, cultuur- en sporttoerisme kan op termijn een bedreiging vormen. Ook dat aspect haalt Nalin aan in <strong>Samsara</strong>. De film betreft een productie van de Duitse maatschappij <em>Pandora Film</em>, gesticht in 1981 en ondertussen uitgegroeid tot het grootste Europese productiehuis voor internationale kunstfilms. Dezelfde productiemaatschappij realiseerde onder andere de erg antropologische en documentair ogende langspeelfilm <strong>Himalaya</strong> van Eric Valli, alsook de tantristische Indische film <strong>Kama Sutra</strong> van Mira Nair. Het productiehuis engageerde zich ook voor films als <strong>Nostalghia</strong> van Tarkovski en <strong>Farewell, My Concubine</strong> van Chen Kaige.</p>\n<p><a name=\"LIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Links</strong></font></h2>\n<p>Het religieuze levensfenomeen van het licht speelt een hoofdrol in het derde deel van <a href=\"http://www.menstis.be/uitgeverij/Levensbeschouwing/\">Levensbeschouwing democratisch belicht</a>, waar het fenomeen <em>De Lichtaard</em> heet.</p>\n<p>Over <a href=\"https://en.wikipedia.org/wiki/Pan_Nalin\">Nalin</a>.</p>\n<p><font size=\"-2\">© Sylvain De Bleeckere, Men(S)tis, 2011/2017.</font></p>\n"}

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

	module.exports = {"title":"Into Great Silence","body":"<center>\n<img src=\"intogreatsilenece.jpg\" >\n</center>\n<p><a name=\"KLA\"></a></p>\n<h2><font color=\"#808000\"><strong>Klapbord</strong></font></h2>\n<p>Met de documentaire <strong>Die grosse Stille/ Le grand silence/ Into Great Silence</strong> schrijft de Duitse regisseur Gröning zonder meer en in absolute zin geschiedenis: filmgeschiedenis én kerkgeschiedenis. Het is de allereerste keer in de geschiedenis dat er filmopnames zijn gemaakt binnen de muren van de historische <em>Grande Chartreuse</em>, het moederklooster van de kartuizermonniken. In 2006 ging de film in première op het filmfestival van Venetië. Eind december 2006 won hij <em>de European Film Award voor de beste documentaire</em> van het jaar.</p>\n<p><a name=\"SYN\"></a></p>\n<h2><font color=\"#808000\"><strong>Synopsis</strong></font></h2>\n<p><strong>Into Great Silence</strong> is een documentaire film. Het is dus geen verfilming van een vooraf uitgeschreven scenario. In zekere zin is het de werkelijkheid zelf die de film regisseert. Die werkelijkheid bestaat concreet uit de gebouwen van de Grande Chartreuse, afgelegen in het berglandschap van de Franse Alpen, waar een belangrijk deel van het jaar sneeuw ligt. Een ander aspect van de regisserende werkelijkheid is de kloostergemeenschap zelf. Het leven van de monniken brengt niet alleen de beelden voor, maar ook het ritme van de beelden. Dat blijkt al in het begin van de film. De camera staat in de cel van één van de monniken. Hij blijft er tot de klokken luiden en hem een teken geven om de cel te verlaten. Eerst de kleine klok, nadien de grote kerkklok. Er zijn dus heel wat lange sequenties van de monniken in hun cel. Dat is de ruimte waar ze het grootste deel van hun leven als monnik doorbrengen. Het is daar waar ze slapen, bidden, mediteren, studeren en eten. Ze verlaten hun cel alleen op het ritme van de klokken die hen oproepen naar de kerk te gaan voor het gemeenschappelijk gebedsleven. Dat begint om middernacht. Dan begint de monnik zijn nieuwe dag. Samen met de andere monniken blijft hij drie uren in de donkere kerk, enkel verlicht door de kleine godslamp en de leeslampen van de koorbanken. Het hele scenario beweegt tussen de passages van de monnik in zijn cel en die van de schaarse momenten van het gemeenschapsleven. Dat voltrekt zich in volkomen stilte, waaraan de titel van de film is ontleend. Stilte betekent hier dat de monniken niet met elkaar spreken. Buiten het grootste deel van de sequenties in de cel en in de kerk, komen er in de film enkele uitzonderingen voor. Er is de sequentie in de refter, de gemeenschappelijke eetzaal waar de monniken op zondag samen in stilte eten terwijl ze naar een lezing van een tekst luisteren. In de film komt er ook een tafereel voor met de monniken die zich op zondag even ontspannen. Dat gebeurt tijdens een wandeling. Dan spreken ze met elkaar. Uit de beschrijving van de documentaire film blijkt dat het een cyclische film is. Er is geen lineaire ontwikkeling van dramatische elementen. Er is alleen de zuivere werkelijkheid van de cyclus van dag en nacht en van die van de seizoenen. Dat alles belet de regisseur niet om via de montage toch een licht narratief accent in te brengen. Dat gebeurt al in het begin van de film. Dan is de camera getuige van de officiële intrede van twee nieuwe, jonge monniken. Die intrede gebeurt volgens een strikt beregelde plechtigheid. In de loop van de film volgt de camera één van de nieuwe monniken. Een andere, relatieve narratieve lijn is die van de blinde monnik. Hij  komt even in beeld in het eerste kwart van de film en keert dan in een crescendobeweging naar het einde frontaal in beeld. Dat gebeurt in de lang uitgewerkte sequenties met zijn getuigenis. Hij verbreekt de stilte en spreekt recht in de camera, als het ware tot de toeschouwer, over zijn visie op het leven van zichzelf en dat van wat hij de moderne mens noemt. Nadat de toeschouwer op een zuivere cinematografische wijze een beeld heeft gekregen van het monastieke leven van de kartuizers, krijgt hij even ook verbaal van binnenuit een beeld van het leven en denken van de monnik. Maar het eerste en het laatste woord van de film is de grote stilte, de eigenlijke werkelijkheid die in beeld komt.</p>\n<p><a name=\"CIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Cinematografie</strong></font></h2>\n<p><span class=\"menstis\">UNIEKE OPNAME</span>. De eigen cinematografie van <strong>Into Great Silence</strong> komt in de eerste plaats voort uit de bijzondere omstandigheden waarin de opnames gebeurden. De regisseur verbleef alles bij elkaar ongeveer zes maanden in het klooster. Hij filmde in de lente en de zomer van 2002, drie weken in de winter van begin 2003 plus nog drie dagen in december 2003. Hij deelde het leven van de monniken en was voor zijn filmwerk helemaal op zichzelf aangewezen. Niemand anders dan hijzelf mocht filmen. Hij leefde dus helemaal alleen met de monniken in de <em>Grande Chartreuse</em>. Wegens de verschillende kloostertaken die hij moest vervullen, gecombineerd met de zeer strikte timing van het kloosterleven, kon Gröning ongeveer 2 à 3 uur per dag filmen. Hij filmde een cassette per dag, dat is 49 minuten. Hij deed zelf de opnames met een HD Cam, een digitale videocamera. Die opnames werden aangevuld met enkele 35mm opnames, vooral de buitenopnames van de kloostergebouwen vanuit een panoramisch perspectief, plus ook enkele Super 8mm opnamen. Uit ongeveer 120 uur gefilmd materiaal heeft Gröning zijn 160 minuten durende film gemonteerd. De monniken van de Grande Chartreuse legden de regisseur contractueel het verbod van kunstlicht op. Bij de opnames mocht Gröning bij geen enkele opname kunstlicht gebruiken. Zonder kunstlicht filmen in een kloostergebouw als dat van de Grande Chartreuse is natuurlijk geen sinecure. Gröning moest heel wat creativiteit aan de dag leggen om het schaarse licht te benutten van het zonlicht, brandende kaarsen, brandende houtblokken, en de schaarse elektrische lampen. Hij heeft ook in enkele cellen gefilmd waar behoorlijk weinig natuurlijk licht in schijnt en waar slechts één elektrische lamp hangt. Heel wat van die opnames heeft hij in Super8 mm gefilmd, wat een grove beeldkorrel, een visuele ruis, oplevert.</p>\n<p><span class=\"menstis\">NATUURLIJK GELUID</span>. Een tweede cinematografische regel waaraan Gröning zich contractueel diende te houden, was geen gebruik maken van toegevoegde muziek of gesproken commentaar. Die methodische regel is in de eerste plaats een spirituele regel. Die determineert echter de cinematografie en is in overeenstemming met de spiritualiteit van de stilte, eigen aan de kartuizers. Eén van de grote, stevige pijlers van spiritualiteit van de kartuizers is namelijk de stilte. De film verklankt de eigen, unieke stilte van de <em>Grande Chartreuse</em> en haar bewoners. De methodische regel van het natuurlijke geluid heeft ook een schaduwzijde. Geen commentaar. Gröning komt nergens tussen om bepaalde beelden toe te lichten. Geen enkele commentaarstem begeleidt de toeschouwer. Die wordt aan zijn lot over gelaten. Anders geformuleerd: hij wordt de woestijn van de beelden ingestuurd. Alleen de beelden spreken. Soms worden er teksten gezongen en voorgelezen. Maar ook die behoren tot de stem van de stilte, waarnaar de monniken luisteren.</p>\n<p><span class=\"menstis\">BEELDRIJM</span>. Een ander cinematografisch element is <em>het zwarte beeld</em>. Tevens het openingsbeeld van de film. Het vertegenwoordigt ook de wereld van de gesloten ogen van de monniken. Trouwens, uit het zwarte beeld verschijnt het donkere beeld van de biddende kartuizer in zijn cel. De toeschouwer kan in de grote close-up het beeld herkennen van het gebogen hoofd van de biddende monnik die zijn hoofd laat rusten op zijn gevouwen handen. Zijn oor staat centraal in die grootopname. De wereld van de kartuizer speelt zich niet af in die van het licht, bron van beelden. De kartuizer is geen toeschouwer, hij is een contemplatief die zijn ogen sluit voor wat het zonnelicht van de dag onthult. Hij houdt eerder van het donker dan van het licht, ook al draagt hij een witte pij. Dank zij die witheid kan Gröning de aanwezigheid van de monnik vanuit het eerste donkere beeld laten oplichten. De monnik zelf bevindt zich in de onzichtbare wereld van de ‘gesloten of donkere’ contemplatie. <em>Het zwarte beeld</em> vertegenwoordigt die onzichtbaarheid. In het grote close-upbeeld van de biddende monnik met gesloten ogen last Gröning een overvloeier naar een ander abstract beeld in.</p>\n<p><span class=\"menstis\">TEKSTBEELD</span>. Er is ook een cinematografisch element, het tekstbeeld, dat herinnert aan de periode van de stille film. Zowel helemaal in het begin van de film, in de loop van de film en in het eindbeeld laat de regisseur <em>teksten</em> verschijnen op het filmdoek. De openingstekst is een Bijbelperikoop <em>1 Kon. 19:11-12</em>. De tekst in de Willebrordvertaling luidt:</p>\n<blockquote>\n<p><em>‘11 Maar Jahwe zei: “Ga naar buiten en treed voor Jahwe op de berg.” Toen trok Jahwe voorbij. Voor Jahwe uit ging een zeer zware storm, die bergen deed splijten en rotsen verbrijzelde. Maar Jahwe was niet in de storm. Op de storm volgde een aardbeving. Maar ook in de aardbeving was Jahwe niet.12 Op de aardbeving volgde vuur. Maar ook in het vuur was Jahwe niet. Op het vuur volgde het suizen van een zachte bries’.</em><br></p>\n</blockquote>\n<p>Een andere Bijbeltekst is <em>Lucas 14: 33</em>:</p>\n<blockquote>\n<p><em>‘Wie geen afstand doet van al zijn bezittingen en mijn voorbeeld niet volgt, kan mijn leerling niet zijn’.</em> <br></p>\n</blockquote>\n<p>De regisseur monteert dat tekstbeeld enkele keren. Zonder zelf commentaar te geven, last hij toch op die manier teksten in die deel uitmaken van het leven en de studie van de kartuizers.</p>\n<p><a name=\"BET\"></a></p>\n<h2><font color=\"#808000\"><strong>Betekenisruimte</strong></font></h2>\n<p><span class=\"menstis\">BLINDHEID</span>. Een wezenlijk aspect van de monastieke betekeniswereld van <strong>Into Great Silence</strong> ent zich op <em>de figuur van de oude blinde monnik</em>. Het is het dramatische hoogtepunt van de film want de kartuizer neemt zelf het woord en spreekt tot de camera. Het is het enige interview in de film, ofschoon er geen vragen worden gesteld. De cineast en de toeschouwer luisteren naar de woorden van de blinde religieus. Het getuigenis opent met een zwart beeld en de eerste zin handelt over <em>de dood</em>.</p>\n<blockquote>\n<p><em>'Angst voor de dood heeft geen zin, want het is het lot van alle mensen. Zwart beeld. Sterven is het geluk verwerven, dat bestaat in het nabijkomen van God. In feite is de dood de grote vreugde van de mens.</em>\nZwart beeld.</p>\n</blockquote>\n<blockquote>\n<p><em>'In God bestaat geen verleden en toekomst. God is enkel heden. Hij overziet ons leven in één ogenblik. Omdat hij bron is van alle goedheid, hoeven we als mensen niet bang te zijn voor wat ons overkomt. Het is het beste wat God met ons voorheeft.</em>’</p>\n</blockquote>\n<blockquote>\n<p>Zwart beeld.</p>\n</blockquote>\n<blockquote>\n<p>‘<em>Ik dank God dat hij me blind heeft laten worden voor het welzijn van mijn ziel. Zwart beeld. Het is jammer dat de wereld de zin voor God heeft verloren. Ze hebben geen reden meer om te leven. Als je de gedachte aan God afschaft, waarom leef je dan nog. Zwart beeld. Een christen mag nooit verdrietig zijn, maar altijd gelukkig want God doet alles voor ons voor ons welzijn. Alles wat gebeurt is Gods wil en geschiedt voor het welzijn van de ziel. God is oppermachtig, goed en Hij helpt ons.</em>’</p>\n</blockquote>\n<blockquote>\n<p>Zwart beeld.</p>\n</blockquote>\n<blockquote>\n<p>‘<em>En dat is alles wat men moet doen,en men wordt gelukkig.</em>’</p>\n</blockquote>\n<blockquote>\n<p>Zwart beeld.</p>\n</blockquote>\n<p>Aldus het getuigenis van de blinde kartuizermonnik.</p>\n<p><span class=\"menstis\">ICONOCLASME</span>. Een ander inhoudelijk wezenlijk aspect is het iconoclasme van het zwarte beeld. De regisseur is hiermee trouw aan de spiritualiteit van <em>het afwezige beeld in de leef- en denkwereld van de kartuizers</em>. Hun spirituele leven steunt immers op het fundament van het iconoclasme met zijn diepe wortels in de klassieke traditie van het metafysisch Idealisme. Dat voert een grote hiërarchische scheiding in tussen de concrete lichtwereld waar de ogen toegang toe hebben en de bovennatuurlijke wereld van het goddelijke licht waar alleen de mediterende geest toegang toe heeft. Dergelijke, eeuwenoude religieuze cultuur die teruggaat tot de eerste eeuwen van het institutionele christendom is door de kartuizers tot op vandaag zuiver en authentiek bewaard. Niets beter dan deze film maakt het vandaag mogelijk om een zeker inzicht te krijgen in de oudste fundamenten van het contemplatieve, monastieke leven dat zo sterk de Europese, christelijke cultuur doorheen de middeleeuwen en nog nadien heeft getekend. Die traditie wordt hier een levend en toegankelijk beeld.<a name=\"CON\"></a></p>\n<h2><font color=\"#808000\"><strong>Context</strong></font></h2>\n<p><span class=\"menstis\">OEFENING IN STILTE</span>. De film confronteert de hedendaagse toeschouwer met de werkelijkheid van de contemplatieve stilte die uit zijn leefwereld zo goed als verdwenen is. Het was puur toeval dat toen de film in België in de bioscoop te zien was, in het nieuws van december 2006 de mededeling kwam van een wetenschappelijk onderzoek van de Rijksuniversiteit Gent. Daaruit blijkt dat één op zes adolescenten een ernstig gehoorprobleem heeft. In de leeftijdsgroep van 18 tot 22 jaar vinden wij bijna niemand meer met een perfect gehoor. Als dat zo doorgaat heeft de jeugd tegen haar dertigste verjaardag het gehoor van een oudere man. Aldus het onderzoek. De film <strong>Into Great Silence</strong> biedt in de context van onze hedendaagse lawaaicultuur een zeer nuttige, meditatieve oefening in stilte. De kartuizers praktiseren die oefening tot in het extreme. Juist daardoor krijgt hun <em>geluidsascese</em> een hedendaagse betekenis die ze nooit eerder heeft gehad.</p>\n<p><span class=\"menstis\">HET FENOMEEN MONACHISME</span>. Een tweede contextueel element betreft de waarde van het beeld van de extreme religiositeit dat uit de film spreekt en duidelijk wordt verwoord door de blinde monnik. Die betreurt dat de mensen van nu de zin voor God hebben verloren waardoor het bestaan geen echte zin meer heeft. Dit punt vormt de grens van de film zelf. Gröning leent zijn camera aan de monastieke gemeenschap van de <em>Grande Chartreuse</em>. Hij geeft hen het volle beeld en de volle klank. De film is in dat opzicht zeker een geslaagd kunstwerk. Als portret van het religieuze leven voor onze tijd is het echter eenzijdig. Zo eenvoudig zit de hedendaagse beschaving namelijk niet in elkaar dat ze in een zwart-wit tekening kan worden weergegeven. De kartuizerwereld als de laatste zone van het zuiver geloof versus de buitenwereld als de negatieve zone waar het geloof is verdwenen. Eeuwen beschaving van christelijke en monastieke cultuur hebben niet kunnen verhinderen dat de concrete beleving van het religieuze, christelijke leven is geëvolueerd. En het is zeker niet zo dat die evolutie een louter negatieve balans oplevert. <em>Het eeuwenoude monachisme*</em> eiste het monopolie van het zuivere geloof op. Het onderbouwde zijn eis met een zware metafysische constructie die ook in <strong>Into Great Silence</strong> voor de aandachtige toeschouwer zichtbaar aan de oppervlakte komt: de radicale afwijzing van de eigen waarde van de tijd, het wegredeneren van het probleem van de dood als een schijnprobleem, het fenomeen van het persoonlijk lijden minimaliseren vanuit een absolute apologie van de algoede God die ook in het lijden nog het beste met de mens voorgeeft. Dergelijke visie heeft diepe wortels in de Griekse metafysica van het eeuwige zijn. In de context van de film verschijnt die visie als <em>het iconoclasme van het bestaan</em>. Het reële bestaan van de mens in tijd en ruimte wordt weggezuiverd en opgelost in het zwarte beeld, het visuele leidmotief van de hele film.</p>\n<p><a name=\"LIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Links</strong></font></h2>\n<p>De Bleeckere, S., <em>Het tijdperk van het monachisme</em>, in: Vanclooster, D., (red.), <em>De Duinenabdij van Koksijde. Cisterciënzers in de Lage Landen</em>. Tielt; Lannoo, pp. 12-23.</p>\n<p>De auteur situeert het fenomeen van het monachisme in het westerse fenomeen van het wereldbeeld in <a href=\"http://www.menstis.be/uitgeverij/Levensbeschouwing/\">Levensbeschouwing democratisch belicht</a>.</p>\n<p><font size=\"-2\">© Sylvain De Bleeckere, Men(S)tis, 2011/2017</font>.</p>\n"}

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

	module.exports = {"title":"Son of Saul","body":"<center>\n<img src=\"sos.jpg\" >\n</center>\n<p><a name=\"KLA\"></a></p>\n<h2><font color=\"#808000\"><strong>Klapbord</strong></font></h2>\n<p><strong>Son of Saul</strong> is een Hongaarse film van de debuterende László Nemes. De film liet vanaf zijn wereldpremière tijdens <em>het Filmfestival van Cannes</em> in 2015 een grote indruk na. De jury gaf aan de film haar Grote Prijs. Dit is na de Gouden Palm, de meest prestigieuze prijs van het festival. Bovendien kreeg de film tijdens <em>de 88ste Academy Awards (de Oscars)</em> de award voor <em>beste niet-Engelstalige film</em>. De regisseur Nemes schreef zelf het scenario, daarbij geholpen door Clara Royer. De casting is ook bijzonder. De regisseur koos acteurs en actrices die hun eigen moedertaal moesten spreken. Er wordt in de film onder andere Duits, Hongaars, Pools en Yiddisch gesproken. Voor het hoofdpersonage koos hij <em>Géza Röhrig</em>. Hij is een orthodoxe, Hongaarse jood, tevens dichter die sinds 2000 in New York woont. Hij werkt er als leraar Joodse studies. Zijn eerste dichtbundel had Auschwitz als onderwerp en was de vertolking van <em>zijn vele bezoeken aan de site van Auschwitz-Birkenau</em> vanuit Krakau waar hij als student een tijdlang verbleef in de jaren tachtig van vorige eeuw. Toen was de site, gelegen achter het toenmalige IJzeren Gordijn, nog geen ‘toeristische’ halte. Röhrig is geen echte acteur; in de jaren tachtig van vorige eeuw speelde hij even mee in een televisieserie. Als goede kennis van de regisseur, kreeg Röhrig de vraag van de regisseur de hoofdrol in diens debuutfilm over de Holocaust voor zijn rekening te nemen. De film werd opgenomen in <em>Budafok, een wijk van Budapest</em>. De Hongaarse architect László Rajk zorgde voor <em>de reconstructie van de crematoria van Auschwitz-Birkenau</em>. Hij werkte namelijk aan de permanente Hongaarse tentoonstelling van het Auschwitz-Birkenau Staatsmuseum in Polen. Het verhaal zelf is <em>fictief</em>, maar het is ontleend aan bijzonder historische feiten. Nemes heeft zich namelijk gebaseerd op <em>de opgetekende getuigenissen van enkele overlevende Sonderkommando’s</em>. Hun nota’s staan gekend onder de internationale naam <em>The Scrolls of Auschwitz</em>. De schrijvers hebben toen hun nota’s verborgen in de grond van het terrein rond het Crematorium III van Birkenau in de hoop dat ze later zouden worden gevonden. Die zijn tussen 1945 en 1980 inderdaad door toeval ontdekt. Nicholas Chare en Dominic Williams publiceerden in 2015 hun onderzoek naar de Scrolls in hun boek <a href=\"https://www.google.be/search?q=the+scrolls+of+auschwitz&amp;oq=The+Scrolls+o&amp;aqs=chrome.2.69i59j69i57j0l4.8191j0j8&amp;sourceid=chrome&amp;ie=UTF-8#q=the+scrolls+of+auschwitz+pdf\">Matters of Testimony: Interpreting the Scrolls of Auschwitz</a>. Er waren circa 950 Sonderkommando’s in Auschwitz-Birkenau. Negentig van hen overleefden de oorlog en het kamp. Son of Saul is het eerste filmdocument dat op de studie ervan is gebaseerd. Aan het historische fenomeen van de Sonderkommando’s werd nooit eerder een film gewijd. In Son of Saul heet het hoofdpersonage Saul. Hij wordt in het grootste vernietigingskamp als Sonderkommando tewerkgesteld. De nazi’s selecteerden namelijk een aantal sterke Joodse mannen die voor hen het monsterlijke werk dienden uit te voeren bij de vergassing en verbranding van de joodse slachtoffers in Auschwitz-Birkenau. Om te voorkomen dat die Joodse Sonderkommando’s zouden gaan samenspannen en rebelleren, werden ze na enige tijd, maximum drie maanden, vervangen en geëxecuteerd.</p>\n<p><a name=\"SYN\"></a></p>\n<h2><font color=\"#808000\"><strong>Synopsis</strong></font></h2>\n<p><em>Saul Ausländer</em> hoort bij <em>de Hongaarse Joden</em> die in 1944 massaal naar Auschwitz-Birkenau zijn gebracht. Het Duitse leger is stilaan de oorlog aan het verliezen, en de nazi’s willen in verhoogd tempo nog zoveel mogelijk hun <em>Endlösung</em> doorvoeren. De Duitse term Endlösung staat voor de genocide van alle Joden in Europa. Het bewind in Berlijn eiste dat de vernietigingsmachine van Auschwitz-Birkenau op volle toeren draaide. Wanneer Saul Ausländer <em>in oktober 1944</em> in het kamp aankomt, wordt hij geselecteerd voor <em>de Sonderkommando’s</em>. Saul is ingedeeld bij de sectie die instaat voor het collecteren van kostbaarheden in de kleding van hen die zijn vergast, het verwijderen van de lijken uit de gaskamers en het direct daarna schrobben van de vloeren om de volgende groep slachtoffers te kunnen ‘verwerken’. Saul voert de bevelen schijnbaar apathisch en automatisch uit. Hij doet perfect wat van hem wordt verwacht. Dat verandert op de dag dat hij in de gaskamers <em>het lijk vindt van een jongen</em>. Onmiddellijk <em>ontfermt hij zich over het lichaam alsof het dat van zijn zoon betreft</em>. Hij stelt vast dat de jongen nog ademt niettegenstaande de vergassing. Hij moet toezien dat een nazi-dokter de jongen vermoordt. De dokter beveelt het lijk naar de autopsie-afdeling te brengen. Op dat ogenblik stapt Saul naar voren en biedt zich aan om het bevel uit te voeren. Zo maakt hij in de autopsie-afdeling kennis met dokter Miklós. Die blijkt ook een Hongaarse Jood te zijn die gedwongen wordt om de nazi-bevelen uit te voeren. Saul weet Miklós te overtuigen dat niet te doen in het geval van het lijk van de jongen. <em>Hij wil immers diens lijk meenemen om het een gepaste Joodse begrafenis te kunnen geven.</em> Miklós wijst de vraag van Saul niet af. Hij laat voorlopig het lijk ongeschonden en negeert ermee het bevel van de nazi-dokter. Saul zelf begint <em>zijn speurtocht naar een rabbijn</em> die het ritueel van <em>de kaddisj</em> kan uitvoeren. Hij vindt <em>rabbijn Frankel</em>. Die weigert mee te werken en stelt voor dat Saul zelf het ritueel voltrekt. Ondertussen ontstaan er binnen de groep van de Sonderkommando’s twee strekkingen. De eerste, onder leiding van de opstandige Abraham, wil met Oberkapo Biedermann, de Joodse leider van de sectie waartoe Saul en Abraham behoort, een opstand voorbereiden tegen de SS-bewakers. Van de tweede strekking is die van Bierdemann zelf de woordvoerder. Hij stelt voor om de wreedheden in het geheim te fotograferen en het fotomateriaal naar buiten te smokkelen en ermee mogelijke hulp uit te lokken. Om zijn eigen plan te kunnen uitvoeren, werkt Saul mee aan beide plannen. Via de medewerking komt hij in situaties terecht waarop hij inspeelt om een rabbijn te vinden. Zo komt hij via Abraham te weten dat er in een van de secties van de Sonderkommando’s een man is  die <em>‘de Renegaat’</em> wordt genoemd. Hij is van Griekse origine en was voorheen wellicht een rabbijn. Saul zegt in ruil aan Abraham toe om mee te werken met het fotografieplan. Saul vindt de Renegaat bij de leden van de sectie die de assen uit de gasovens in de nabijgelegen rivier moeten scheppen. Wanneer de Renegaat echter weigert in te gaan op Sauls vraag, veroorzaakt Saul bewust een incident om de man toch te dwingen om mee te werken. Het incident leidt tot een ondervraging door de SS-commandant die de Renegaat executeert en Saul terugstuurt naar zijn sectie. Daar slaagt Saul erin het lijk van de jongen dat Miklós heeft verborgen in de autopsiekamer, mee te nemen naar de barak van de Sonderkommando’s in afwachting dat hij een rabbijn vindt. Saul wordt opgeroepen om de tafel op te ruimte van SS-commandant Voss, de nazi-baas van de gaskamers en verbrandingsovens. Saul hoort Voss Biedermann bevelen hem een lijst van zeventig namen te bezorgen. Hieruit leidt Biedermann af dat de mannen van zijn sectie waartoe ook Saul behoort, kortelings zullen worden omgebracht. In overleg met Abraham, besluit Biedermann een opstand voor te bereiden. Saul moet in het kamp van de vrouwen via Ella een pakje met dynamiet zien weg te smokkelen. De vrouw herkent hem, noemt zijn naam en zoekt toenadering, maar Saul blijft gefocust en houdt afstand. Onderweg naar zijn barak, komt Saul terecht in een groep van Hongaarse Joden die pas in het kamp zijn gearriveerd. Ze worden direct naar het bos gebracht om te worden geëxecuteerd. Onmiddellijk gaat Saul op zoek naar een mogelijke rabbijn onder de nieuwelingen. De Fransman <em>Braun</em> maakt zich bekend bij Saul en zegt dat hij een rabbijn is. Daarop vermomt Saul Braun als een Sonderkommando en neemt hem mee naar de barak. Daar stelt Saul vast dat hij tijdens het tumult in het bos zijn pakje dynamiet is kwijtgespeeld. Ondertussen heeft Abraham het lijk van de jongen ontdekt in de barak. Daarover ondervraagd door Abraham, onthult Saul dat de jongen zijn zoon is. Abraham weigert dat te geloven. Tijdens het morgenappel zien Miklós en Saul elkaar. Miklós eist van Saul een ander lijk ter vervanging van dat van de jongen. Wanneer de sectie terug aan het werk moet, ontdekken de mannen dat hun leider Biedermann door de SS is geëxecuteerd. Daarop start Abraham <em>de rebellie</em>. Van dat tumult maakt Saul gebruik om het lijk van de jongen mee te nemen naar de bossen. Hij neemt ook Braun mee. Bij de rivier wil Saul het lijk begraven. Hij vraagt Braun het gebed uit te spreken, maar de man blijkt vals te hebben gespeeld. <em>Hij kent het gebed niet, hij blijkt geen rabbijn te zijn</em>. Daarop steekt Saul met het lijk de rivier over, maar door het gewicht en de stroming kan hij het lijk niet meer houden en moet hij het laten wegdrijven. Een van de medevluchters, de echte rabbijn Frankel, helpt Saul uit de rivier. De ontsnapten verzamelen in een schuur en plannen om aan te sluiten bij het Poolse verzet. Plots ontdekt Saul een Poolse jongen in de nabijheid van de schuur. Saul en de jongen glimlachen naar elkaar. Dan loopt de jongen plots weg, SS-wachten naderen de schuur. De jongen verdwijnt in het bos.</p>\n<p><a name=\"CIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Cinematografie</strong></font></h2>\n<p><span class=\"menstis\">CINEMATOGRAFIE VAN DE RADICALE SOLIDARITEIT.</span> De meest opvallende cinematografische keuze die de regisseur heeft gemaakt, is die van -het besloten cameraperspectief-. De panoramische zichten ontbreken met uitzondering van het slotbeeld met het bos. Er is evenmin een alwetende verteller aanwezig om de beelden toe te lichten. In die zin kent de film <em>een claustrofobische look</em>. De openingssequentie is onscherp gefilmd. De toeschouwer kijkt naar een flou beeld waarin hij figuren ziet bewegen zonder ze duidelijk te kunnen onderscheiden. Een van de figuren loopt richting camera. Van het ogenblik af dat de figuur bij de camera is gekomen, ontstaat er een scherp beeld. Hiermee geeft de regisseur een duidelijk teken aan de toeschouwer. <em>Ook de regisseur beschikt niet over aan alziend en alwetend perspectief</em>. Nemes zelf probeert midden in het gebeuren scherp te zien vanuit zijn eigen, beperkte positie. De regisseur beslist dan om zijn camera te binden aan de positie van de man die naar hem toestapt: <em>Saul</em>. Van dan af zit de camera op de hielen van het hoofdpersonage Saul. Hij kleeft er als het ware aan. Die keuze stelt de cameraman voor een grote uitdaging. De acteur en de cameraman moeten voortdurend een soort dansbeweging uitvoeren. De cameraman moet de loodzware filmcamera minutenlang bedienen door achter het hoofdpersonage afwisselend voorwaarts en achterwaarts te lopen. In vergelijking met een doorsnee film zijn er langere sequenties. In totaal bestaat <strong>Son of Saul</strong> uit tachtig cuts (onderbrekingen aangebracht tijdens de montage), terwijl een doorsnee film 200 à 300 cuts telt. Dergelijk gefocust cameragebruik is geïntroduceerd door <em>de gebroeders Dardenne</em> in hun eerste films, vooral in hun <em>Rosetta</em> (1999). Nemes radicaliseert die cinematografische benadering in zijn <strong>Son of Saul</strong> tot in het extreme. Terecht. Op die manier identificeert de cineast zich voor honderd procent met zijn hoofdpersonage. Aldus realiseert Nemes met de film een bijna één op één identificatie met het slachtoffer en bij uitbreiding alle slachtoffers, belichaamd door het personage Saul. Hier wordt <em>de camera het instrument van engagement</em>. De camera handelt als enige <em>in volle solidariteit</em> met de Holocaustslachtoffers. Dat engagement zit echter ook verankerd in <em>een narratieve logica die de historische situatie correct weerspiegelt</em>. De Scrolls of Auschwitz bevestigen samen met de studie van het grondplan van Auschwitz-Birkenau dat de Sonderkommando’s geïsoleerd leefden van de rest van het kamp. Hun barakken bevonden zich direct in de buurt van de gaskamers en verbrandingsovens. Enerzijds beseften de Sonderkommando’s dat ze bij de uitzonderingen, ja in zeker opzicht zelfs bij de geprivilegieerden, hoorden. De gemiddelde levensduur in het kamp was tien dagen na de aankomst. De Sonderkommando’s wisten dat zij dankzij hun gedwongen job langer dan wie ook van alle Joodse slachtoffers, langer in leven konden blijven. Anderzijds leefden en werkten ze volledig afgezonderd. Ze hadden geen enkel overzicht over het kamp. Ze waren volledig onwetend over de beslissingen van de SS van wie ze wisten dat die altijd het bevel konden geven om ook hen, de Sonderkommando’s, op zekere dag om te brengen. Hierdoor konden de Sonderkommando’s met geen derden communiceren over hun bijzondere ervaringen over wat ze zelf in de Scrolls ‘<em>het hart van de hel</em>’ noemen. Verschillenden voelden een sterke nood om te getuigen van hun bevoorrechte ervaringen. Van alle Joden stonden zij letterlijk aan <em>de frontlijn van de Holocaust</em>. Ook in <strong>Son of Saul</strong> blijkt die nood aan communicatie met de buitenwereld in het gegeven van het fotografieplan. De leden van de Sonderkommando’s ervoeren op de meest extreme wijze een eigenschap van ieder menselijke conditie, met name begrensd te zijn in tijd en ruimte. Zij zaten letterlijk en mentaal opgesloten in de tijd en de ruimte van de historische Holocaust. Geen enkele oog- en oorgetuige van de slachtoffers kreeg de tijd om daarvan op zo’n intense manier getuigen. <strong>Son of Saul</strong> blijft trouw aan die unieke getuigenis. Op deze wijze wordt ook de toeschouwer van de film via de camera en de microfoon deelgenoot van dit uniek, historisch getuigenis. Sinds het einde van de Tweede Wereldoorlog kan alleen de kunst van de cinematografie blijvend zo dicht bij de doorleefde horror van de historische Holocaust komen.</p>\n<p><span class=\"menstis\">DE ARCHITECTUURMETAFOOR VAN HET LABYRINT.</span> Als er één metafoor is die de spirit van <em>onze postmoderne tijden</em> vertolkt, is het wel die van <em>het labyrint</em>. En die metafoor werd nergens zo reëel doorleefd als door de slachtoffers van de historische Holocaust. De cinematografie van <strong>Son of Saul</strong> realiseert die metafoor van het labyrint op een meesterlijke manier. Dat gebeurt tegelijk visueel en auditief. Saul krijgt nergens een overzicht van de situatie. Hij beweegt midden in <em>een enge en besloten ruimte</em>. Iedere vluchtpoging is vooraf gedoemd om te mislukken.</p>\n<p><em>De architectuurmetafoor van het labyrint</em> is voor het eerst in de westerse cultuurgeschiedenis geïntroduceerd via <em>het oud-Griekse verhaal</em> van koning Minos van Kreta, beschreven door Herodotos in zijn <em>Historiën</em> uit de 5de eeuw v.C. en vooral bekend gebleven door de literaire evocatie ervan door de Romeinse schrijver Ovidius in zijn <em>Metamorfosen</em>, voltooid in de 1ste eeuw n.C. In de oud-Griekse overlevering staat de Griekse held Theseus centraal. Hij slaagde erin het monster, de Minotaurus, opgesloten in het labyrint, aan wie de Atheners jaarlijks mensenoffers moesten brengen, te overwinnen met de hulp van <em>de draad van Ariadne</em>. De dochter van koning Minos had Theseus een bol van wollen draad meegegeven waardoor hij de weg terug kon vinden. In het oermodel van het Kretenzische labyrint is er één uitgang en is er zelfs via de list van de draad van Ariadne de mogelijkheid om er, eens binnen,gemakkelijk terug uit te geraken.</p>\n<p>De draad van Ariadne <em>onbreekt</em> in het geval van Auschwitz-Birkenau in het algemeen en in de werkplaats en het terrein van de Sonderkommando’s in het bijzonder. Saul en zijn lotgenoten bewegen zich van <em>het ene ruimtelijke cataclysme in het andere</em>. Ze hebben op geen enkele manier enig meesterschap op de labyrintische ruimte en de gebeurtenissen die er zich in voltrekken. Saul probeert in zekere zin een draad van Ariadne te vinden via het lijk van ‘zijn zoon’, maar tijdens de hopeloze ontsnapping verliest hij ook die broze draad. <strong>Son of Saul</strong> Saul werkt met de metafoor van het labyrint en breidt de betekenis ervan uit in alle richtingen. Saul bevindt zich eerst en vooral letterlijk in de labyrintische dodengang zonder uitweg. Het besef van Saul constant in een labyrint rond te lopen is niet alleen visueel uitgewerkt. Het is ook <em>auditief</em> aanwezig. Er is geen filmische muziek die van buitenaf over de beelden wordt gelegd. Saul beweegt zich namelijk in een labyrint van stemmen en geluiden waarvan hij de herkomst amper kan overzien. Támas Zányi, de verantwoordelijke voor de klankband, heeft vijf maanden gewerkt aan de sound design van <strong>Son of Saul</strong>.</p>\n<p><a name=\"BET\"></a></p>\n<h2><font color=\"#808000\"><strong>Betekenisruimte</strong></font></h2>\n<p><span class=\"menstis\">KADDISJ</span>. Nemes bouwt de betekeniswereld van <strong>Son of Saul</strong> op via <em>het narratief van de kaddisj</em>. Saul verzet zich, niettegenstaande de overrompelende impact van wat er gebeurt, tegen de industriële en mechanische vergassing van mensen en de dito verbranding van de lijken. Zijn verzet bestaat erin dat hij één lijk weghoudt van de verbrandingsovens met als doel het ritueel te begraven. Daartoe zoekt hij een rabbijn. Die moet namelijk bij de begrafenis het ritueel gebed van <em>de kaddisj</em> uitspreken. Met dit narratief element bouwt de regisseur de betekeniswereld van de film op de hoeksteen van <em>het joodse gebedsleven</em>. Het gebed <a href=\"https://www.jewishvirtuallibrary.org/the-mourners-kaddish\">kaddisj</a> staat centraal tijdens de joodse liturgie in de synagoge. Het gebed scheidt de diverse delen van de eredienst. In de joodse religie speelt de <em>kaddisj</em> ook nog een grote rol tijdens het begrafenisritueel. In dat geval spreekt men van <em>de kaddisj van de rouwenden</em>. Tijdens een begrafenis wordt de kaddisj gebeden en jaarlijks wordt op de verjaardag van het overlijden in familiekring de kaddisj gebeden ter nagedachtenis van de overledene. Ook wordt de kaddisj ‘gezegd’ tijdens de elf maanden durende rouwperiode bij een overlijden. De uitdrukking ‘<em>kaddisj zeggen</em>’ verwijst altijd naar het rouwritueel. In <strong>Son of Saul</strong> gebruikt Saul de woorden _‘<em>kaddisj zeggen</em>’ wanneer hij aan de drie mannen waarvan hij denkt dat ze rabbijn zijn of zijn geweest, vraagt hem te helpen bij de begrafenis van ‘zijn zoon’.</p>\n<p>Via <em>het narratief kaddisj</em> plaatst Nemes het gebeuren van de Holocaust in de bewogen geschiedenis van het Joodse volk. Het vertrouwde Joodse gebed van de kaddisj is in <em>het Aramees</em>, op de laatste zin na die in het Hebreeuws is. Het Aramees was namelijk de taal die de Joden spraken <em>tijdens de Babylonische ballingschap</em> die volgde op de historische verwoesting van Jeruzalem, en dus ook van het hart van het jodendom, de tempel van Jeruzalem, in 583 v.C. Het zeggen van de Kaddish verbindt de generaties met elkaar, en in het bijzonder met <em>het gedeelde rouwproces</em> over het verlies van de eigen thuis en van hen die worden gemist. <em>De kaddisj</em> bewaart in zich het rouwverdriet van het hele volk, dat van generatie tot generatie wordt overgeleverd.</p>\n<p>Het opmerkelijke van de <em>kaddisj</em> als een gebed voor de dode is dat <em>diens naam niet wordt genoemd</em>. Er komt zelfs <em>geen enkele verwijzing naar de dood</em> in voor. Het gebed is namelijk <em>een uitgesproken lofprijzing van God en een heiliging van de naam van God</em>. In die zin is de <em>kaddisj</em> een <em>hymne</em>. Het is opgebouwd uit tien werkwoorden. Het getal tien verwijst naar <em>de Tien Geboden</em>, maar ook naar de tien keren dat God sprak tijdens de schepping van de wereld volgens het boek <em>Genesis</em>. In de eerste regels van de hymne wordt immers direct verwezen naar ‘<em>de wereld die Hij geschapen heeft</em>’. Voorts spreekt de hymne de hoop uit op de spoedige komst van ‘<em>de vrede uit de hemel</em>’. De laatste zin luidt: ‘<em>Hij die vrede maakt in zijn hoge sferen zal ook vrede maken voor ons en voor geheel Israël.</em>’ Het gebed sluit af met de uitnodiging aan de gelovigen het gebed te beamen: ‘<em>Zeg nu: Amen</em>’.</p>\n<p>In <strong>Son of Saul</strong> roept het narratief ‘<em>kaddisj zeggen</em>’ zowel de band met de generaties op als het rouwproces zelf. De overleden ‘zoon’ van Saul, het lijk dat Saul in zijn armen en op zijn schouder meedraagt, belichaamt letterlijk <em>alle slachtoffers van de Holocaust</em> die aan de lopende band worden vergast <em>zonder enig begrafenisritueel</em>. Hij die uitgerekend wordt gedwongen een rol te spelen in die mechanisering van het lijden en de dood van zijn volk, organiseert zijn eigen verzet door zich vast te klampen aan de kaddisj. <strong>Son of Saul</strong> is de kaddisj voor alle Joodse slachtoffers van de Holocaust. De film is een gebed.</p>\n<p><span class=\"menstis\">JOODSE RELIGIE IN RELATIE TOT DE HOLOCAUST.</span> Nemes benadert de Holocaust consequent <em>vanuit de optiek van de slachtoffers</em>, niet vanuit die van de daders. Dat verklaart waarom hij in de opbouw van de betekeniswereld expliciet verwijst naar <em>de joodse religie via de kaddisj en de figuur van de joodse geestelijke, de rabbijn</em>. Saul heeft een strak afgelijnd doel. Hij wil onder de Sonderkommando’s en de nieuw aangevoerde slachtoffers, kost wat kost een echte rabbijn zoeken en vinden. In volgorde komt hij in contact met rabbijn Frankel, die deel uitmaakt van de sectie van Saul, de Renegaat en Braun. In de drie gevallen mislukt Saul zijn poging om de rabbijn te engageren voor het ‘<em>kaddisj zeggen</em>’. De echte rabbijn Frankel weigert, gezien de omstandigheden, de vraag van Saul ernstig te nemen. Frankels weigering houdt Saul niet tegen. Hij wil immers een ritueel correcte begrafenis, met anderen woorden een begrafenis in aanwezigheid van een rabbijn. De tweede poging van Saul betreft de Renegaat. Aan de oever van de rivier Soła waarin de assen worden gedumpt, verplicht Saul de Renegaat mee te werken aan de uitvoering van zijn plan. Ook die poging mislukt. De derde poging vindt plaats tijdens de ontsnapping. Ook die faalt. Saul heeft er alles aan gedaan om Braun te redden vanuit de overtuiging dat de man een rabbijn is. Tijdens de aanzet tot de echte begrafenis in het bos, opnieuw aan de oever van de rivier, blijkt dat Braun helemaal geen rabbijn is. Achterna gezeten door de SS-bewakers, moet Saul de begrafenis onderbreken. Hij neemt het lijkt mee en zwemt ermee de rivier over. De stroming dwingt hem echter het lijk los te laten. <em>Het stromende water</em> neemt letterlijk de last weg van zijn schouders. Dankzij de inspanningen van Saul ontkomt het lijk aan het vuur van de verbrandingsovens en gaat het op in de natuurkracht die weerstand biedt aan dat vuur, <em>het stromende water van de rivier Soła</em>. Het is de rabbijn Frankel die Saul, vechtend tegen de sterke stroming, uit de rivier helpt en hem meeneemt in het bos. Uit deze narratieve elementen blijkt dat Son of Saul de confrontatie tussen de Holocaust en de joodse religie thematiseert. Dat gebeurt uiteraard niet via een theoretische, laat staan theologische beschouwing.</p>\n<p>Behalve via het personage van de rabbijn, werkt Nemes nog via <em>drie andere belangrijke beeldmetaforen</em> een betekeniswereld uit waarin in eerste instantie <em>de Joodse cultuur</em> centraal staat. Het zijn de naam van het hoofdpersonage, het narratief vader-zoon en de metafoor van het lijk.</p>\n<p>Nemes laat de bijzondere groep van de Sonderkommando’s vertegenwoordigen door het hoofdpersonage dat <em>de Joodse naam Saul</em>,in het Latijn Saulus, draagt. De beschikbare online bronnen bevestigen allemaal dat de Hebreeuwse naam <em>Sha’ul</em> de volgende betekeniskern heeft: ‘<em>gevraagd worden voor, gesmeekt of gebeden worden om</em>’. De naam krijgt in de context van <em>de geschiedenis van het Joodse volk</em>, zoals bewaard in de Bijbel, een religieuze betekenis. Hij verwijst naar een antwoord op de religieuze bede van het volk naar hun god, Jahwe, om iemand te zenden die hen uit de nood kan helpen. Saul is het goddelijke antwoord op die smeekbede van het volk. Dat verklaart waarom de betekenis van <em>de naam Saul</em> sterk historisch is <em>verankerd in de Bijbelse geschiedenis van het Joodse volk</em>. <em>De eerste koning van Israël</em> heet inderdaad <em>Saul</em>. Hij werd als eerste man door de profeet Samuel tot koning van Israël gezalfd. Saul is de eerste Messias, de eerste gestalte van het goddelijk Antwoord op de roep om hulp van Zijn volk. Saul leidde als eerste inderdaad het volk van Jahwe in diverse oorlogen tegen de vijanden van Israël, in het bijzonder de Filistijnen. In de context van het Holocaustverhaal krijgt de naam Saul via de centrale figuur van de Sonderkommando een bijzondere wending. De Hongaar Saul ervaart hoe het Joodse volk ook en vooral in de twintigste eeuw nog steeds op vijanden botst. De Holocaust lijkt nu wel <em>het summum van alle vijandige acties</em> ooit ondernomen tegen het Joodse volk te vertegenwoordigen. Dat beleeft Saul aan de lijve. Als Sonderkommando, werkzaam bij de gaskamers en de verbrandingsovens, is hij tevens een kroongetuige van <em>dat onvoorstelbaar summum aan vijandigheid en destructie ten aanzien van het Joodse volk</em>. Maar er is nog meer. De historische koning Saul slaagde er niet in zijn goddelijke opdracht om de diverse stammen van Israël samen te brengen en te verenigen in vrede en voorspoed. In die zin leeft hij ook verder als een mislukte koning die zelfs probeerde zijn opvolger, David, te vermoorden. Dat laatste mislukte echter en Saul stierf zelf, samen met zijn zoon Jonathan, tijdens een veldslag tegen de Filistijnen. Ook de Sonderkammando Saul mislukt in zijn religieuze opdracht. Hij vindt geen rabbijn om ‘zijn zoon’ ritueel te kunnen begraven. Saul wil nog ten koste van alles een messias zijn, een gezalfde, een redder, niet van de levenden, maar van de doden. Hij luistert in zekere zin naar de verstomde smeekbede van de vergaste slachtoffers. Hij neemt die roep op en gaat over tot de actie, ook al is die gedoemd om te mislukken.</p>\n<p>De beeldmetafoor Saul werkt verder door in_ het narratief vader-zoon_. Er is geen ander volk dan het Joodse gekend, waarin <em>het fenomeen van de generaties</em> zo sterk doorweegt in religie en cultuur. De joodse Bijbel besteedt veel aandacht aan stambomen, een traditie die nog doorspeelt in de christelijke evangelies. Dat laatste geldt voor het Evangelie volgens Mattheus, het meeste Joodse van de vier. In Son of Saul beheerst het vader-zoon narratief de loop van de gebeurtenissen. Saul ontfermt zich bij de ontruiming van de gastkamer over een van de slachtoffers, een jongen die nog tekenen van leven geeft. Onmiddellijk adopteert hij de jongeling als zijn zoon. De regisseur laat in het midden of Saul überhaupt kinderen heeft en dan nog eventueel een zoon. De regisseur toont ook nergens een beeld van het gezicht van de jongen en er komt geen herkenningsscène voor, een moment waarin Saul de jongen effectief als zijn echte zoon herkent. Door de gebeurtenissen in het kamp van de Sonderkommando’s te bespelen vanuit de optiek van zijn dode zoon, gewikkeld in een witte lijkwade, plaatst Saul in het kamp <em>de hoeksteen van het Joodse volk</em>. De <em>identiteit</em> van het Joodse volk bestaat immers niet in de eerste plaats uit <em>de religieuze credo’s</em> zoals de onuitspreekbare naam van de ene God, het statuut van het uitverkoren volk van God, de Tien Geboden van Mozes, de voorschriften inzake hygiëne en voedsel, enzovoort. Die religieuze bijzonderheden krijgen hun ware betekenis vanuit de eerste, de <em>genetische identiteit</em>. Al wie <em>kind is van een Joodse moeder</em>, is een Jood. Wie zich als niet-Jood de Joodse godsdienst aanneemt en beoefent, is een proseliet. Hij wordt nooit een echte Jood. Dat werpt een bijzonder licht op <strong>Son of Saul</strong>. Saul komt als Sonderkommando oog in oog te staan met de uiterste consequentie van de Jodenhaat van het Duitse naziregime. De <em>nazi-ideologie</em> richtte zich niet in de eerste plaats tegen in de religie van het Jodendom. Het doelwit ervan waren niet in de eerste plaats de Joodse gelovigen en hun religieus gedrag. De nazi’s concentreerden zich op <em>de genetische hoeksteen van het Jodendom</em>. Al wie als Jood geboren is, is Jood en, in de optiek van <em>Endlösung</em>, een Jood te veel, gelovig of niet. Op basis van hun ideologie gebaseerd op <em>de biologie van het zuivere ras</em>, viseerden de nazi’s het Joodse volk als het onzuivere ras bij uitstek. In hun zoekacties naar Joden, concentreerden ze zich dan ook niet op het gegeven van de religie, maar op dat van de biologische identiteit. Dat gegeven speelt mee in <em>het narratief vader-zoon</em>, eigen aan <strong>Son of Saul</strong>. De Sonderkommando Saul adopteert de slachtoffers vanuit zijn bijzondere positie in het ene personage van ‘zijn’ zoon. In dat gebaar benut hij de laatste, kleine ruimte die hem is gegeven, om niet in de eerste plaats aan zijn eigen zelfbehoud te denken, maar om zich radicaal in te zetten voor het volk dat als een kwalijk insect wordt vertrapt en vernietigd. Saul wil zijn eigen waardigheid kost wat kost behouden door in zijn denken en handelen de Joodse identiteit te bewaren. Hij wil blijven denken en handelen vanuit het vader-zoon narratief.</p>\n<p>Nemes verdiept de beeldmetafoor vader-zoon via <em>die van het lijk</em>. Het anonieme personage van de zoon verschijnt in beeld als bijna-dood. Onmiddellijk daarna vermoordt een nazi-dokter de jongen in de autopsiekamer en daarna komt hij enkel nog in beeld gewikkeld in de lijkwade. Via dit filmische leidmotief slaagt de regisseur erin om de slachtoffers nog <em>een minimum aan waardigheid</em> te verlenen. De filmbeelden richten zich niet op de onvoorstelbare vernedering en ontwaarding van ieder humaniteit. Het blijft bij suggesties. De nadruk ligt van het begin af op <em>het stil verzet van Saul</em>. Zijn engagement bestaat erin dat hij het lijk van de jongen niet wil laten verbranden. Hij wil het een decente begrafenis geven,begeleid door een religieus ritueel. Zijn ondernemen lukt niet wat het religieuze aspect betreft, maar hij slaagt er wel in het lijk ver van de gasovens te houden. Uiteindelijk is het <em>de rivier</em> die het lijk overneemt van Saul en het meevoert in de stroming, weg van het vuur van Auschwitz-Birkenau. <em>Het stromende water waarin het hemelse licht</em> zich weerspiegelt, getuigt in alle opzichten van <em>leven</em>. Het omarmt het lijk en voert het met zijn levenskracht mee. Nemes geeft aan alle slachtoffers van Auschwitz-Birkenau en bij uitbreiding alle slachtoffers van de Holocaust, toch een waardige, humane plaats via het beeld van Sauls zorg om het lijk. Via die beeldmetafoor krijgt de Joodse betekeniswereld van de film ook <em>een algemeen humane resonantie</em>.</p>\n<p><span class=\"menstis\">TRAGIEK EN ZINGEVING.</span> De betekenis die voortkomt uit de Joodse beeldelementen ― <em>kaddisj, de rabbijn, Saul, vader-zoon, het lijk</em> ― reikt inderdaad over de grenzen van de Joodse cultuur. Via de <em>universele beeldtaal van de cinematografie</em> strekt hun betekeniswereld zich ook uit naar <em>de hele huidige mensheid</em>. Dat gebeurt concreet via <em>het element van de taal</em>. De Joodse cultuur onderhoudt een structurele band met de taal. Ze waardeert <em>de joodse Bijbel als het Woord van God zelf</em>. De Boekrol,het Boek, het Woord, ze krijgen een goddelijk statuut. Voortdurend weerklinkt er ‘<em>En God sprak</em>’ als een mantra. Het wezen van God blijkt fundamenteel verbonden te zijn met de Taal. Het goddelijke Woord bepaalt de loop der dingen. Dit Joodse cultuurgegeven werkt door in <em>de monotheïstische religies van het Boek</em>: de christelijke kerken (‘In het begin was er het Woord/Logos’) en de islam (de Koran). Maar ook in <em>het tijdperk van de moderne staten</em> verwierf de Taal/het Woord een eersterangs statuut. De geschreven wetten regelen het openbaar leven. Ook in <em>de wetenschappen</em> (de logoi) domineert de Taal in haar verschillende academische gedaanten. Zelfs de moderne nazi-ideologie beriep zich op de wetenschappelijke Logos van de moderne biologie. In de moderne staten is via de grote impact van de communicatiemiddelen de geschreven en gesproken taal overal aanwezig. Maar in <em>het postmoderne cultuurklimaat</em> is de Taal <em>haar monopolie</em> verloren. <em>Het historische fenomeen Holocaust</em> en de verwerking ervan vanaf de tweede helft van de vorige eeuw, liggen aan de oorsprong van <em>het postmoderne cultuurbewustzijn</em>. <strong>Son of Saul</strong> laat zien wat dit inhoudt. In de betekeniswereld van de film is <em>de taal een onderdeel geworden van een stroom van geluiden en klanken</em> waarin de mens, in casu het hoofdpersonage Saul, zich beweegt. De taal is haar goddelijk statuut, haar hoofdletter, kwijtgespeeld. Er is geen enkel woord of zin die in staat is die klankenstroom stil te leggen. Niemand heeft nog een sleutel, zelfs de nazi’s bezitten die niet. Hun dominante <em>Leer (Logos) van het Ras</em> die Wet geworden is, brengt uiteindelijk een tsunami van de inwerkende werkelijkheid voor, die de meesters van de Wet, de nazi’s, zelf niet meer kunnen bedwingen. Dat blijkt uit hun falen om zelf hun monsterlijke moordmachine te bedienen. Ze zijn verplicht om een deel van hun slachtoffers in te zetten om hun even onwezenlijk als reëel dodenplan uit te voeren. Dat ervaart Saul aan de lijve. Bovendien brengt <em>de moderne ideo-Logos</em> van de nazi’s een Gruwel voort die zich tegen hen keert. Van alle slachtoffers zijn immers de Sonderkommando’s door hun positie de bevoorrechte getuigen. Ze zien en horen alles, terwijl de eigenlijke slachtoffers direct worden geneutraliseerd en vernietigd. De Sonderkommando’s zijn de enige slachtoffers met een herinnering aan de monsterlijke impact van de werkelijkheid, van <em>het vreselijke wrede contactum waarvan de regie in handen is van een elite van mensen die menen met hun Logos de macht over de werkelijkheid in handen te hebben</em>. Omwille van hun eigen rol, vormen de leden van de Sonderkommando’s een groot gevaar voor de nazi’s. Daarom worden ze zelf ook na korte tijd neergeschoten. Dat weten ze en daarom komen ze in opstand. Dat laat <strong>Son of Saul</strong> zien. Die beperkte opstand mislukt, maar is wel de voorbode van de historische militaire en morele nederlaag van de nazi’s. In die nederlaag zindert ook <em>het failliet van iedere beschaving na, die zich wil realiseren op basis van het monopolie van het Woord, de Logos</em>. Wie dat beseft, weet samen met Saul dat de postmoderne mens zich bevindt in <em>het grote labyrint van de werkelijkheid</em>. De eeuwenoude draad van Ariadne ― <em>het Woord waarvan de mens meende dat die hem doorheen het labyrint van de werkelijkheid kon leiden</em> ― is niet langer beschikbaar.</p>\n<p><strong>Son of Saul</strong> evoceert zeer pregnant hoe de mens sinds de Holocaust zijn vertrouwde draad van Ariadne voor altijd heeft verloren. De Holocaust is <em>geen fait divers</em>. Het is geen geschiedenis die voorbij is. <em>Het gebeuren herdefinieert het menselijke vermogen van de collectieve herinnering tot een onbegrensd labyrint</em>. De mens heeft <em>zijn vermogen tot herinnering</em> altijd al ervaren als de mentale plaats bij uitstek is waar hij <em>de impact van de inwerkende werkelijkheid</em> registreert. Daar ervaart de mens het sterkst <em>zijn structurele kwetsbaarheid</em>. Daar leert hij dat hij in situaties kan terecht komen waarin de impact van de werkelijkheid voor hem te immens kan zijn. Bob Dylan dicht dit sterk in de het vers van <em>Not Dark Yet</em>: ‘<em>Sometimes my burden seems more than I can bear.</em>’ Dat geldt heel in het bijzonder voor Saul. Geworpen midden het tumult van de extreme historische omstandigheden, vertoeft hij bijzonder dicht bij de immense impact van de inslaande werkelijkheid. Hij put uit de bron van zijn laatste menselijke kracht om in zijn herinnering die impact vast te houden. Die inslag is zo hevig dat ze alle goede herinneringen verdringt die Saul als mens meedroeg tot op de dag dat hij aankwam in het vernietigingskamp. Die goede herinneringen houden geen stand meer tegenover de actuele herinneringen die hij als Sonderkommando opbouwt. Die nieuwe overrompelende herinneringen <em>ontregelen</em> zijn menszijn. Hij beschikt niet meer over de menselijke middelen ― woorden, gedachten, gebeden, emoties ― om dit te plaatsen en te dragen. De laatste kiem van menselijkheid waaraan hij zich vastklampt, is die van de dode jongen, die hij adopteert als de zoon die hij wellicht nooit heeft gehad, maar die hij wel heeft gewenst, een wens die hij nu nooit meer zal kunnen in vervulling zien gaan. Hij verbergt het lijk vanuit de laatste rest van zijn sterke wil om het dode lichaam een rituele begrafenis te geven, uitgevoerd door een rabbijn. Dit blijkt een illusie te zijn.</p>\n<p>In het filmverhaal van Saul verdicht Nemes <em>het fenomeen van de geschiedenis</em>, dit is de menselijke en de door de mens gevormde tijd. De cineast laat zien hoe die geschiedenis via de herinnering <em>een onbegrensd labyrint</em> is geworden, waarvan niemand nog de ultieme betekenissleutel bezit, ook de regisseur niet. In tegenstelling met andere Holocaustfilms zoals <em>Schindler’s List</em> (1993) van Steven Spielberg, die hun eigen waarde bezitten, toont László Nemes <em>geen panoramisch overzicht</em> van de gebeurtenissen. Samen met Saul, krijgt de toeschouwer geen overkoepelend beeld van de ruimte en het gebeuren. De regisseur identificeert zich helemaal met het perspectief van zijn hoofdpersonage. Hiermee vertegenwoordigt de regisseur <em>het postmoderne blikveld</em>. De werkelijkheid die altijd is geschreven in de modus van <em>het post-Holocaust tijdperk</em>, een onbegrensd labyrint. Wie zoals de regisseur Nemes leeft en werkt in dergelijke epoche, doet dat vanuit de wil tot het scheppen van humaniteit <em>vanuit de sterke beaming van de tragiek</em>. De <em>hardnekkige wil tot zingeving</em> en de tragiek brengen elkaar voor. Zij vormen samen <em>een nieuwe humaniteit</em> midden in het labyrint van de gebeurtenissen. Interessant is, dat de film ook laat zien dat de religies en de traditionele godsdiensten <em>niet buiten die tragiek</em> staan: Sauls zoektocht naar een rabbijn mislukt. In de dramatische situatie is de rabbijn niet meer herkenbaar als rabbijn, en indien die er is, staat hij net zo min als alle andere mensen boven de stroom van de gebeurtenissen. Hij kan zich niet langer beroepen op het onaantastbare Woord van God. De rabbijn, de priester, de imam, ze maken zelf deel uit van de gebeurtenissen. De gebeurtennissen hebben hen <em>hun vertrouwde, godsdienstige draad van Ariadne</em> afgenomen. In <strong>Son of Saul</strong> vindt de rabbijn geen woorden meer om uit te brengen. Die uitvergroting van de extreme gebeurtenis, de Holocaust, het werk overigens van de moderne, verlichte mens, is één van de collectieve herinneringen die de huidige mens helpen te leven vanuit <em>de beaming van het open labyrint</em>. De wil om niet te vergeten als fundament om <em>vanuit de wil tot zingeving in de tragiek te gaan zijn</em>, is het enige anker van humaniteit dat overblijft. In de postmoderne epoche is de kunst van de cinematografie daartoe <em>onmisbaar</em> geworden. Een film als <strong>Son of Saul</strong> is absoluut noodzakelijk. Hij wijst op <em>de enige draad van Ariadne</em> die de postmoderne mens overblijft, de dunne maar onmisbare draad van <em>het werk aan de zingeving midden in de tragiek</em> met haar vermogen tot herinnering.</p>\n<p>Midden in de tragiek, is <strong>Son of Saul</strong> een <em>credo</em>. Dat blijkt uit de slotsequentie. Gefilmd met een subjectieve camera, toont de slotsequentie de laatste blik van Saul. Vanuit de close-up van zijn gelaat ontstaat dan de <em>enige sequentie met een panoramische dimensie</em>. Saul glimlacht voor de eerste keer op het ogenblik dat hij de jongen, nog een kind, ziet die uit het bos naar de schuilplaats van de Sonderkommando’s toekomt. Wanneer de SS-wachters aankomen, ziet Saul nog hoe de jongen door de SS-wachters wordt tegengehouden, waarna ze hem direct weer vrijlaten. Hij ziet nog hoe de jongen terug in het bos verdwijnt. Hoe vreemd het ook lijkt, <em>het credo</em> van die slotsequentie spreekt van <em>het ultieme geloof in de werkelijkheid van het leven, bron van zingeving midden in de menselijke tragiek</em>. Dat <em>credo</em> verschijnt in het korte, maar intense contact tussen de glimlach van Saul, de jongen en de natuur. Die verschijnt in <em>de beeldcompositie van het heldere daglicht en de bomen van het bos, geworteld in de aarde maar reikend naar de hemel</em>. Saul laatste blik is gericht op de jongen, die in metaforische zin zijn andere zoon zou kunnen zijn, die ontsnapt aan de SS en deel blijft uitmaken van <em>het grote leven op aarde</em>. Dat omvat <em>het wonderlijke weefsel van tijd en ruimte</em>, van licht, groen en aarde met in de nabijheid het stromende water van de rivier. In het postmoderne perspectief van de film suggereert Nemes dat <em>dit weefsel</em> geen nieuwe draad van Ariadne is. Het is eerder <em>een credo</em> dat toegang verleent tot het onbegrensde labyrint van tijd en ruimte, van indrukken, ervaringen, gebeurtenissen, gevoelens en gedachten, van de taal met haar eindeloze betekenisweefsels, het onbegrensde labyrint van beelden en klanken, waarin <em>tragiek en zingeving</em> elkaar versterken.</p>\n<p><a name=\"CON\"></a></p>\n<h2><font color=\"#808000\"><strong>Context</strong></font></h2>\n<p><strong>Son of Saul</strong> maakt deel uit van <em>het genre van de Holocaustfilm</em>. De film heeft er zijn eigen, unieke plaats ingenomen. Niettegenstaande het een fictiefilm betreft, slaagt hij erin de toeschouwer bijzonder dicht bij de historische realiteit te brengen via het personage van de Sonderkommando Saul. Nemes kreeg dan ook alle waardering van Claude Lanzmann, de regisseur van <em>Shoah</em>, de belangrijkste documentaire over Auschwitz tot nu toe. Lanzmann prees <strong>Son of Saul</strong> als volgt: ‘<em>It’s a very new film, very original, very unusual. It’s a film that gives a very real sense of what it was like to be in the Sonderkommando. It’s not at all melodramatic. It’s done with a very great modesty.</em>’ Bron: <a href=\"https://www.nytimes.com/2015/12/15/movies/in-son-of-saul-laszlo-nemes-expands-the-language-of-holocaust-films.html?_r=0\">The New York Times</a>.</p>\n<p><strong>Son of Saul</strong> is bijzonder geschikt om in groep, volwassenen en jongeren vanaf zestien, te bekijken op 27 januari. Ieder jaar wordt op die dag de <a href=\"http://hmd.org.uk\">Holocaust Memorial Day</a> georganiseerd. Groot-Brittannië neemt daarbij het voortouw. Dat wereldwijd initiatief is ontstaan uit de <em>Stockholm Declaration</em> van 2000. Toen gingen 46 regeringen akkoord om jaarlijks een dag in het teken te stellen van de Holocaust in <em>opvoeding, publieke herdenking en onderzoek</em>.</p>\n<p>De acteur Rohrig zelf getuigt in de Israëlische krant <em>Haaretz</em> van 17 april 2016 het volgende over het fenomeen en de blijvende betekenis van de <em>Sonderkommando’s</em> als volgt:<em>'Even though the Sonderkommando were fed better than the other prisoners, it was only to assist in the machinery of extermination. They were under a thick and protective armor of numbness, mechanically doing their duty. In such misery, the only way to function is not to think, not to feel. The will to live becomes independent of the person. In some cases, members of the Sondercommando, in extreme despair, snuck into the gas chamber with the other prisoners. Those were saints.</em>’.</p>\n<p><a name=\"LIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Links</strong></font></h2>\n<p><a href=\"http://www.comingsoon.net/movies/features/641059-interview-son-of-saul-director-laszlo-nemes-and-geza-rohrig-on-the-unique-vision-of-auschwitz\">Interview met Nemes en Rohrig</a></p>\n<p>De verwerking van de historische fenomeen van de Holocaust als collectieve zingeving in het kader van het ontstaan van de staat Israël, komt ook aan de orde in het derde deel van het boek <a href=\"http://www.menstis.be/uitgeverij/Land/\">Het Beloofde Land</a>.</p>\n<p>Voor een verdieping van het gegeven ‘tragiek en zingeving’, zie <a href=\"http://www.menstis.be/uitgeverij/Levensbeschouwing/\">Levensbeschouwing democratisch belicht</a>.</p>\n<p><font size=\"-2\">© Sylvain De Bleeckere, Men(S)tis, 2017</font></p>\n"}

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

	module.exports = {"title":"Spirited Away","body":"<center>\n<img src=\"spiritedaway.jpg\" >\n</center>\n<p><a name=\"KLA\"></a></p>\n<h2><font color=\"#808000\"><strong>Klapbord</strong></font></h2>\n<p>In 2003 won Hayao Miyazaki met zijn <strong>Spirited Away [Sen To Chihiro No Kamikakushi]</strong> niet alleen de Gouden Beer van het Berlijnse filmfestival, maar ook de Oscar voor de beste animatiefilm. De film is dan ook de kroon op het werk van de Japanse ‘keizer’ van de animatiefilm. Reeds meer dan negenerdertig jaar werkt hij consequent aan zijn oeuvre waarrond hij in Mitaka, een buitenwijk van Tokio, een eigen productiehuis, <em>de Ghibi Studio’s</em>, en een eigen museum heeft uitgebouwd. Met zijn eerdere productie <strong>Prinses Mononoke</strong> (1997) oogstte hij al internationale erkenning. Hij schrijft zelf de verhalen die voor alle generaties boeiend en verrijkend zijn.</p>\n<p><a name=\"SYN\"></a></p>\n<h2><font color=\"#808000\"><strong>Synopsis</strong></font></h2>\n<p>Het tienjarig meisje Chihiro moet tegen haar zin verhuizen. Haar ouders, Akio en Yugo, brengen haar naar het nieuwe huis. Onderweg rijdt haar vader verloren. De ingeslagen weg loopt dood in een bos waar de drie plots voor een verlaten poortgebouw staan. De ouders lopen, alweer tegen de zin van Chihiro, door de lange tunnel onder het poortgebouw. Die geeft toegang tot wat de vader interpreteert als een verlaten pretpark. In één van de gebouwen vinden ze een gedekte tafel. Zonder aarzelen beginnen de ouders van Chihiro gulzig het uitgestalde voedsel te verorberen. Vol ergernis laat Chihiro haar ouders achter en wandelt ze het park verder in. Dat lijkt helemaal niet zo verlaten te zijn als het wel lijkt. Een jongen, Haku, waarschuwt haar dat ze zich op verboden terrein bevindt en dat dit voor haar als mens levensgevaarlijk is. Wanneer ze snel haar ouders gaat opzoeken, ontdekt ze verbaasd dat die in vetgemeste varkens zijn veranderd. Een grote angst overvalt haar. Ze kan alleen rekenen op de hulp van Haku om in leven te blijven in het pretpark dat bij het vallen van de duisternis verandert in een recreatieoord voor geesten. Het wordt bestuurd door de harpijachtige Yubaba met haar verwende baby Bo. Chihiro krijgt van Yubaba een arbeidscontract op voorwaarde dat ze zichzelf voortaan Sen noemt. Dan mag ze werken in het grote badhuis. Ze wint de sympathie van Yubaba en voelt een hechte liefde voor Haku die over haar waakt. Chihiro houdt één doel voor ogen: haar ouders redden uit de varkensstallen van Yubaba. Met haar ijver, moed en liefde lukt haar dat, maar haar teruggekeerde ouders merken daar niets van. Ze denken dat hun koppige Chihiro verloren is gelopen en dat ze haar nu eindelijk hebben teruggevonden. De Japanse titel luidt trouwens: <strong>Sen en de mysterieuze verdwijning van Chihiro</strong>.</p>\n<p><a name=\"CIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Cinematografie</strong></font></h2>\n<p><span class=\"menstis\">JAPANSE BEELDTAAL</span>. Regisseur en scenarist Hayao Miyazaki blijft trouw aan de Japanse tekentraditie. Die heeft haar oude wortels in de calligrafie en in de zeer alomverspreide, Japanse stripcultuur (manga) en tekenfilms (anime). Miyazaki loopt niet mee met de heersende trend in de digitale animatiefilm. Die keuze heeft geen reactionaire achtegrond. Ze komt voort uit een esthetische visie. Daarin vormt de lijn de basis van de tekening, terwijl de digitale animatie vertrekt van het vlak. Het gevolg van Miyazaki’s esthetische optie is <em>de rijkdom aan details</em>. Deze typische Japanse gevoeligheid uit zich ook in de tuinarchitectuur en in de kunst van de bonsai en het bloemschikken. Bij Miyazaki leidt die gevoeligheid tot een weelde aan detailering. De digitale animatie die liever imponeert met kwantiteit, kan dergelijke visuele rijkdom niet evenaren. Daaruit volgt dat de narrativiteit niet domineert, maar voortkomt uit een fundamenteel beeldend concept. <em>Het beeldend denken</em> primeert.</p>\n<p><span class=\"menstis\">ARCHITECTUURBEELDEN</span>. Een bijzonder cinematografisch aspect betreft de architecturale uitbeelding. De ruimte in het bijzonder en de gebouwen in het algemeen zijn volwaardige personages. Het is op het niveau van de plot geen toeval dat de eerste sequenties in het teken staan van het verhuizen. En wanneer Chihiro het verlaten pretpark binnenstapt, kijkt ze even achterom naar het poortgebouw en zegt ze: ‘<em>Het huis zucht</em>’. De verantwoordelijke voor de artistieke look van de film, Yoji Takeshige, baseerde zich, op advies van de regisseur, op foto’s en films van oude Japanse gebouwen zoals die uit de oude Gionbuurt van Kyoto en in het Koganei Park. Voor het centrale badhuis (yuga) stonden de badhuizen van Dogo Onsen model. En voor het huis van Zeniba nam Takeshige de oude Engelse cottage als vertrekpunt. Die vertoont immers enige gelijkenis met oude Japanse boerderijen.</p>\n<p><span class=\"menstis\">METAMORFOSE</span>. De cinematografie van deze Miyazakifilm steunt op de metamorfose. Tot de esthetische wereld waaroe het esthetische principe van de metamorfose toegang verleent, is in de eerste plaats het cinematografisch beginsel van de beweging. In de openingsbeelden zijn de personages onderweg. Chihiro zit in de auto. Bewegen impliceert onderweg zijn, van plaats veranderen. Die eerste algemene component van de metamorfose verdiept zich in de tweede, die van de gedaanteverandering. Die structureert de dramatische opbouw van de plot en inspireert de verbluffende tekenkunst van Miyazaki.</p>\n<p><a name=\"BET\"></a></p>\n<h2><font color=\"#808000\"><strong>Betekenisruimte</strong></font></h2>\n<p><span class=\"menstis\">PEDAGOGISCHE RELATIE</span>. De film beweegt zich op verschillende betekenisniveaus tegelijk. Een eerste niveau is van pedagogische aard en ent zich op de inclusiestructuur. Door het narratief gegeven van Chihiro en haar ouders, is het pedagogische gegeven altijd aanwezig. Het vreemde daarbij is dat het meisje haar ouders moet beschermen. Er ontstaat met andere woorden een omgekeerde pedagogische relatie: Chihiro redt haar ouders, terwijl zijzelf het slechte voorbeeld geven. Het rijgedrag van haar vader in de openeningsequenties getuigt daarvan. Die pedagogische relatie spiegelt zich nog in de relatie tussen Chihiro, Yubaba en baby Bo.</p>\n<p><span class=\"menstis\">BEELDMOTIEF VAN HET WATER</span>. Een andere betekenislaag betreft de beeldspraak van het water. Het element van het water is <em>alomtegenwoordig</em>. Zelfs de trein rijdt over het water. Het centrale gebouw is het badhuis. De riviergod krijgt een visuele en dramatische hoofdrol. Het gegeven van het zich zuiveren door en in het water evolueert naar <em>het beeld van het water dat zichzelf zuivert in de gedaante van de riviergod</em>. Door de aanwezigheid van de geesten thematiseert de kunstenaar het element van de spiritualiteit. Interessant is te zien hoe de wereld van de geesten verborgen blijft voor de mensen. Alleen enkele mensen hebben toegang tot die geestelijke wereld en dat is onder andere Chihiro. In de geestenwereld functioneren de mensen als hard werkende dienaars. In die rol bereikt Chihiro een vooraanstaande status dankzij haar hechte band van solidariteit en liefde met enkele bijzondere personages.<a name=\"CON\"></a></p>\n<h2><font color=\"#808000\"><strong>Context</strong></font></h2>\n<p><span class=\"menstis\">CONSUMPTIEBESCHAVING</span>. Met <strong>Spitited Away</strong> thematiseert Miyazaki op een kritische wijze de consumptiehonger waaraan veel kinderen, jongeren en volwassenen vandaag lijden. De verandering van Chihiro’s gulzige ouders in vetgemeste varkens, Yubaba’s verwende en veel te dikke baby Bo, het zwarte fantoom Zondergezicht verwijzen naar de consumptieziekte. In een inhoudelijk interview bevestig Miyazaki zelf de betekenis van de varkens: ‘<em>Zij verslinden alles. Ze vertegenwoordigen **het hedendaagse Japan.</em>’</p>\n<p><span class=\"menstis\">SJINTOÏSME</span>. Langs het kritische spoor ontwikkelt Miyazaki de waarde van de spirituele band met de traditie. Hij ziet in die band de juiste, pedagogische ruimte. De uitdrukking van die band is aanwezig in het geven van ‘goden’ (kami) en ‘geesten’ (rei). In de lijn van het oude sjintoïsme actualiseert de kunstenaar de rijkdom van de spirituele beleving van de werkelijkheid. Kinderen als Chihiro hebben daar nog een natuurlijke toegang toe, maar het zijn de consumerende ouders die die toegang voor de kinderen verzegelen.</p>\n<p><span class=\"menstis\">TRADITIE EN MODERNITEIT.</span> De actuele cultuurwaarde van de verwevenheid van traditie en moderniteit is in een Japanse context zeer actueel. Er is naast de groeiende tegenstelling tussen Tokio en Kyoto, ook nog de groeiende culturele tegenstelling tussen de agrarische en de stedelijke zones. Het cultuurdomein waarop die tegenstelling zich profileert, is dat van de architectuur. Vandaar dat Miyazaki in zijn film de gebouwen een hoofdrol toebedeelt. De sublieme tekeningen die getuigen van een intense, architecturale verbeelding impliceren een duidelijke kritiek op de strakke en zielloze betonarchitectuur die een stad als Tokio ontsiert. Een architectuur die zich uit schaamte verbergt achter een wand van digitale beeldschermen. Miyazaki huldigt geen conservatieve terugkeer naar het verre verleden. Hij verdedigt geen archaïsme. Alleen al de keuze voor het filmmedium bewijst dat. Hij denkt na in het moderne medium van het bewegende beeld. Een andere element in deze context is zijn creatieve integratie in <strong>Spitited Away</strong> van twee moderne, westerse kunstwerken: <strong>Alice in Wonderland</strong> van Lewis Caroll en de film <strong>Metropolis</strong> van Fritz Lang.</p>\n<p><a name=\"LIN\"></a></p>\n<h2><font color=\"#808000\"><strong>Link</strong></font></h2>\n<p><a href=\"http://www.studioghibli.nl/\">De Nederlandse site van Studio Ghibli</a></p>\n<p><font size=\"-2\">© Sylvain De Bleeckere, Men(S)tis, 2011/2017.</font></p>\n"}

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDocumentTitle = __webpack_require__(952);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _config = __webpack_require__(404);
	
	var _safeAccess = __webpack_require__(976);
	
	var _safeAccess2 = _interopRequireDefault(_safeAccess);
	
	var _include = __webpack_require__(420);
	
	var _include2 = _interopRequireDefault(_include);
	
	var _startsWith = __webpack_require__(573);
	
	var _startsWith2 = _interopRequireDefault(_startsWith);
	
	var _typography = __webpack_require__(427);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _reactRouter = __webpack_require__(173);
	
	var _gatsbyHelpers = __webpack_require__(403);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rhythm = _typography2.default.rhythm;
	
	
	var SomeReactCode = _react2.default.createClass({
	  displayName: 'SomeReactCode',
	
	  statics: {
	    metadata: function metadata() {
	      return {
	        title: 'Men(s)tis website'
	      };
	    }
	  },
	
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement('div', { style: { height: '50px' } }),
	      _react2.default.createElement(
	        'div',
	        { className: 'parent landing-image', style: { cursor: "pointer" }, onClick: function onClick(e) {
	            return _reactRouter.browserHistory.push((0, _gatsbyHelpers.prefixLink)("/missie/"));
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'child' },
	          _react2.default.createElement(
	            'span',
	            { style: { fontWeight: 'bold' } },
	            'men(',
	            _react2.default.createElement(
	              'span',
	              { style: { color: '#f26d80' } },
	              's'
	            ),
	            ')tis'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'landing-menu' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ui fluid container ' },
	          _react2.default.createElement(
	            'div',
	            { className: 'ui secondary stackable five item menu' },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                className: 'item landing-item',
	                to: (0, _gatsbyHelpers.prefixLink)('/dedag/')
	              },
	              _react2.default.createElement(
	                'span',
	                { className: 'main-menu-item' },
	                ' De Dag'
	              )
	            ),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                className: 'item landing-item',
	                to: (0, _gatsbyHelpers.prefixLink)('/blog/')
	              },
	              _react2.default.createElement(
	                'span',
	                { className: 'main-menu-item' },
	                ' Blog'
	              )
	            ),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                className: 'item landing-item',
	                to: (0, _gatsbyHelpers.prefixLink)('/film-focus/')
	              },
	              _react2.default.createElement(
	                'span',
	                { className: 'main-menu-item' },
	                ' FilmFocus'
	              )
	            ),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                className: 'item landing-item',
	                to: (0, _gatsbyHelpers.prefixLink)('/producties/')
	              },
	              _react2.default.createElement(
	                'span',
	                { className: 'main-menu-item' },
	                ' Producties'
	              )
	            ),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                className: 'item landing-item',
	                to: (0, _gatsbyHelpers.prefixLink)('/webshop/')
	              },
	              _react2.default.createElement(
	                'span',
	                { className: 'main-menu-item' },
	                ' Webshop'
	              )
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	exports.default = SomeReactCode;
	module.exports = exports['default'];

/***/ }),
/* 1021 */
987,
/* 1022 */
/***/ (function(module, exports) {

	module.exports = {"body":"<h1>Missie</h1>\n<p>De missie van de vereniging zonder winstgevend doel, <strong>Men(S)tis,</strong> rust op <strong>de waarden ‘mens, geest en leven’</strong>.\n<strong>Het eerste element,</strong> <strong>de mens,</strong> is aanwezig in de naam die leest als ‘mens, menstis’.\n<strong>Men(S)tis vzw</strong> <strong>wil het mysterie van de menswording</strong> blijven huldigen en exploreren in <strong>al</strong> zijn dimensies.</p>\n<p><strong>Het tweede element</strong> van ‘mens, menstis’, is <strong>het Latijnse woord mens voor geest</strong>.\nDie betekenis blijft immers goed leesbaar in de woorden ‘mentaal, mentaliteit’ en het Engelse ‘mind’.\n<strong>Men(S)tis</strong> <strong>werkt vanuit de mentale rijkdom van de mens.</strong> In en door de mens stroomt\ner een innerlijk kapitaal aan gedachten, gevoelens en beelden. Het hoort bij de <em>Homo sapiens</em>\nals de bladeren aan de boom, maar… ze zijn diens <strong>geleende</strong> eigendom.\nDe Latijnse genitief — <em>menstis</em> — signaleert dat de mens verbonden is\nmet <strong>de wonderlijke en complexe wereld van de geest</strong>. In die  wonderlijke wereld heeft de mens zijn wotels, een wereld waarin hij thuis is en woont,\nmaar die hij <em>niet</em> als zijn volle eigendom bezit of beheerst, maar eerder <em>verzorgend beheert en dient</em>.</p>\n<center><img src=\"logom.jpg\"></center>\n<p><strong>Het derde element</strong> van de missie, is <strong>het fenomeen van het leven</strong></span>.\nDaarvan is het beeldlogo het zichtbare teken. De naam <em>Men(S)tis</em> waarbij de <strong>S</strong> de symmetrie vormt\ntussen de twee woorddelen, bevindt zich op de foto van het Japanse <strong>Hakonegras</strong> waarvan de herfstkleur\nin de kleur van de letter S herkenbaar is. Het Hakonegras wuift mee met de wind. In de Bijbelse, christelijke\nspiritualiteit staat de wind ook voor <strong>de Geest die leven geeft</strong>. Op een gelijkaardige wijze kennen de Oosterse\nculturen het fenomeen wind als de <strong>Levenskracht</strong> die energie en beweging met zich meebrengt in de mens en in de natuur.</p>\n<p><strong>Men(S)tis vzw</strong> schept met ieder initiatief een reële en mentale ruimte\ndie verschijnt als een <strong>bescheiden, tijdelijke en vruchtbare zone van zin</strong>,\neen oord van levensbeschouwing. <strong>Men(S)tis vzw</strong>\nwil hiermee bijdragen tot de ontwikkeling\nvan <strong>het beeldend denken</strong> en tot <strong>het onderzoek naar de religiositeit</strong>,\neigen aan <em>de zich ontwikkelende audiovisuele cultuur</em> in een wereld die voortbeweegt in de richting van <strong>een zowel democratische als globaliserende mensheid</strong>.</p>\n<p><a name=\"STI\"></a>De <span class=\"opvallend\"><strong>stichtende leden</strong></span> zijn:\nSylvain De Bleeckere (1950), Felix Rijcken (1929), Nicole De Bleeckere-Van de Kerckhove (1951-1996),\nGie Dandois (1955-1997). De <strong>huidige</strong> bestuursleden zijn: Sylvain De Bleeckere (voorzitter),\nFelix Rijcken (ondervoorzitter), Samuel De Bleeckere (secretaris). De webmaster is\nSiegfried De Bleeckere.</p>\n"}

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

	module.exports = {"body":"<!DOCTYPE HTML PUBLIC \"-//W3C//DTD HTML 4.0 Transitional//EN\">\r\n<html><!-- InstanceBegin template=\"/Templates/missie.dwt\" codeOutsideHTMLIsLocked=\"false\" -->\r\n<head>\r\n<meta http-equiv=\"Content-Type\" content=\"text/html; charset=iso-8859-1\">\r\n<meta http-equiv=\"imagetoolbar\" content=\"no\">\r\n<!-- InstanceBeginEditable name=\"titel\" -->\r\n<title>Missie statement Men(s)tis vzw</title>\r\n<!-- InstanceEndEditable -->\r\n<link href=\"/style/basic.css\" rel=\"stylesheet\" type=\"text/css\" media=\"all\">\r\n<link rel=\"icon\" type=\"image/gif\" href=\"/favicon.gif\">\r\n</head>\r\n<body bgcolor=\"#FFFFF4\" text=\"#7F7D82\" link=\"#7366EE\" vlink=\"#8388FF\" alink=\"#F78A6A\">\r\n<div align=\"center\">\r\n<center>\r\n\r\n<table border=\"0\" cellpadding=\"10\" cellspacing=\"0\" width=\"80%\">\r\n<tr>\r\n\t<td><a href=\"index.html\"><img border=\"0\" src=\"../statement.jpg\" width=\"60\" height=\"30\" alt=\"Missie\"></a></td>\r\n\t<td><a href=\"../blog/index.html\"><img border=\"0\" src=\"../etalage.jpg\" width=\"60\" height=\"30\" alt=\"Blog\"></a></td>\r\n\t<td><a href=\"../dedag/index.html\"><img border=\"0\" src=\"../De%20Dag.jpg\" width=\"30\" height=\"45\" alt=\"De Dag van de Religieuze Film\"></a></td>\r\n\t<td><a href=\"../film/index.html\"><img border=\"0\" src=\"../FilmFocus.jpg\" width=\"30\" height=\"45\" alt=\"FilmFocus\"></a></td>\r\n\t<td><a href=\"../producties/index.html\"><img border=\"0\" src=\"../producties.jpg\" width=\"60\" height=\"30\" alt=\"Producties\"></a></td>\r\n    <td><a href=\"../uitgeverij/index.html\"><img border=\"0\" src=\"../uitgeverij.jpg\" width=\"60\" height=\"30\" alt=\"Uitgeverij\"></a></td>\r\n</tr>\r\n\r\n</table>\r\n<table border=\"0\" cellpadding=\"4\" cellspacing=\"0\" width=\"90%\">\r\n    <tr>\r\n        <td width=\"160\" valign=\"top\" rowspan=\"2\" bgcolor=\"#FCF9FF\">\r\n\t\t\t\t       \r\n\t\t<!-- InstanceBeginEditable name=\"menueinde\" -->\r\n\t\t\t<h2>Men(S)tis vzw</h2>\r\n\t        <p><a href=\"#HOM\"><b>Mens</b></a><br></p>\r\n\t        <p><a href=\"#GEE\"><b>Geest</b></a><br></p>\r\n\t        <p><a href=\"#HET\"><b>Leven</b></a><br></p>\r\n\t        \r\n\t        <p><a href=\"#STI\"><b>Stichtende leden</b></a><br></p><!-- InstanceEndEditable -->\r\n\t\t</td>\r\n        <td rowspan=\"2\">&nbsp;</td>\r\n        <td valign=\"bottom\" nowrap bgcolor=\"#400030\"><font color=\"#FFFFF4\"><h2>\r\n\t\t<!-- InstanceBeginEditable name=\"subtitel\" -->Missie\r\n\t\t<!-- InstanceEndEditable -->\r\n\t\t</h2>\r\n\t\t<h2>\r\n\t\t  <!-- InstanceBeginEditable name=\"subtitel2\" --><!-- InstanceEndEditable -->\r\n\t\t</h2></font>\r\n        </td>\r\n    </tr>\r\n \t<tr>\r\n\t\t<td valign=\"top\" bgcolor=\"#FCF9FF\">\r\n             <!-- InstanceBeginEditable name=\"Inhoud\" -->\r\n\t\t\t<p>De missie van de vereniging zonder winstgevend doel, <strong class=\"menstis\">Men(S)tis, </strong>rust op </strong><span class=\"opvallend\"><strong>de waarden 'mens, geest en leven'</strong></span>. </p>\r\n\t\t\t<p><strong>Het eerste element, </strong><span class=\"opvallend\"><strong>de mens, </strong></span>is aanwezig in de naam die leest als 'mens, menstis'.<strong class=\"menstis\">  Men(S)tis vzw</strong> <strong>wil het mysterie van de menswording</strong> blijven huldigen en  exploreren.</p>\r\n\t\t\t<p><strong>Het tweede element </strong> van  'mens, menstis', is  <strong>het Latijnse woord mens voor </strong><span class=\"opvallend\"><strong>geest</strong></span>.  Die betekenis blijft immers goed leesbaar in de woorden 'mentaal, mentaliteit'   en het Engelse 'mind'.   <strong class=\"menstis\">Men(S)tis   </strong><strong>werkt vanuit  de mentale rijkdom van de mens.</strong> In en door de mens stroomt er  een innerlijk kapitaal aan gedachten, gevoelens en beelden. Het hoort bij de Homo  sapiens als de bladeren aan de boom, maar... ze zijn diens eigendom niet. De  Latijnse genitief &mdash; <em>menstis</em> &mdash; signaleert dat de mens verbonden  is met <strong>de wonderlijke en complexe wereld van de geest</strong>, een wereld waarin  het fenomeen mens zijn nest heeft, een wereld waarin hij thuis is en woont,  maar die hij niet als zijn volle eigendom bezit of beheerst.             </p><p><center><a name=\"GIB\"></a><img src=\"GIB.jpg\" width=200 height=200> </center></p>\r\n<p><strong>Het derde element</strong> van de missie, is <strong>het fenomeen van </strong><span class=\"opvallend\"><strong>het leven</strong></span>.</strong> Daarvan is het beeldlogo het zichtbare teken. Het beeld, een creatie van Nelly Claeys in opdracht van de vereniging, toont in close-up een ginkgoblad op een alizarine rode achtergrond. Het blad vertegenwoordigt  de oudste  boom, de <strong>ginkgo biloba</strong>. Hij is de  echte levensboom van de planeet aarde. <strong class=\"menstis\">Men(S)tis  vzw</strong> participeert hiermee aan een kunsttraditie die het ginkgoblad als  <strong>het levende beeld ziet van de heilige waarde van het leven</strong>. De Duitse dichter Goethe bezong het ginkgoblad;  het hedendaagse Britse kunstenaarsduo Gilbert &amp; George nam het blad als leidmotief voor een reeks van werken.</p>\r\n<p><strong class=\"menstis\">Men(S)tis  vzw</strong> schept met ieder initiatief  een re&euml;le en mentale ruimte die verschijnt als een <strong>bescheiden, tijdelijke en  vruchtbare zone van zin</strong>, een oord van levensbeschouwing. <strong class=\"menstis\">Men(S)tis vzw</strong> wil hiermee bijdragen tot de ontwikkeling van  <strong>het  beeldend denken</strong> en tot <strong>het onderzoek naar de  religiositeit, eigen aan de zich ontwikkelende audiovisuele cultuur</strong>. </p>\r\n<p>De vereniging heeft ook een <strong>eigen website </strong>en<strong> een Facebook-profiel</strong>.</p>\r\n<p><a name=\"STI\"></a>De</strong><span class=\"opvallend\"> <strong>stichtende leden</strong></span> </strong>zijn: Sylvain De Bleeckere  (1950), Felix Rijcken (1929), Nicole De Bleeckere-Van de Kerckhove (1951-1996),  Gie Dandois (1955-1997). De <strong>huidige </strong>bestuursleden  zijn: Sylvain De Bleeckere (voorzitter), Felix Rijcken (ondervoorzitter), Samuel   De Bleeckere (secretaris-boekhouder).</p>\r\n             <!-- InstanceEndEditable -->\r\n\t\t</td>\r\n     </tr>\r\n</table>\r\n</center>\r\n</div>\r\n</body>\r\n<!-- InstanceEnd --></html>\r\n"}

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDocumentTitle = __webpack_require__(952);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _config = __webpack_require__(404);
	
	var _reactRouter = __webpack_require__(173);
	
	var _safeAccess = __webpack_require__(976);
	
	var _safeAccess2 = _interopRequireDefault(_safeAccess);
	
	var _include = __webpack_require__(420);
	
	var _include2 = _interopRequireDefault(_include);
	
	var _startsWith = __webpack_require__(573);
	
	var _startsWith2 = _interopRequireDefault(_startsWith);
	
	var _typography = __webpack_require__(427);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _gatsbyHelpers = __webpack_require__(403);
	
	var _Header = __webpack_require__(419);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _semanticUiReact = __webpack_require__(471);
	
	__webpack_require__(949);
	
	var _IndImage = __webpack_require__(1002);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rhythm = _typography2.default.rhythm;
	//import {IndexImage} from 'components/IndexImage'
	
	var FilmFocus = _react2.default.createClass({
	  displayName: 'FilmFocus',
	
	  statics: {
	    metadata: function metadata() {
	      return {
	        title: 'Men(S)tis'
	      };
	    }
	  },
	
	  onImageClick: function onImageClick(e, el) {
	    console.log(el);
	
	    _reactRouter.browserHistory.push(el);
	  },
	  render: function render() {
	    var movies = [];
	    var movieLinks = [];
	    var movieTitles = [];
	    var movieImageFile = [];
	
	    movieLinks.push("https://www.youtube.com/embed/zG_OGGv9NZ0?rel=0;&autoplay=1");
	    movieTitles.push("PilgrImage");
	    movieImageFile.push("../PilgrImage.jpg");
	
	    var that = this;
	    var gridMovies = [];
	    if (movieLinks.length == 0) {
	      gridMovies = _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('h1', null),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Van zodra het eerste filmpje beschikbaar is, zal het hier verschijnen'
	        )
	      );
	    } else {
	      var i = 0;
	      while (movieLinks.length > 0) {
	
	        var line = movieLinks.splice(0, 1);
	        line.forEach(function (el, idx) {
	          gridMovies.push(_react2.default.createElement(
	            'div',
	            { className: 'column' },
	            _react2.default.createElement(
	              'div',
	              { className: 'image-fit' },
	              _react2.default.createElement(
	                'a',
	                { href: el, id: "extimg" + i },
	                _react2.default.createElement(_semanticUiReact.Image, { src: (0, _gatsbyHelpers.prefixLink)(movieImageFile[i]) }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'image-overlay' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'image-text' },
	                    movieTitles[i]
	                  )
	                )
	              )
	            )
	          ));
	        });
	        i += 1;
	      }
	    }
	    return _react2.default.createElement(
	      _reactDocumentTitle2.default,
	      { title: FilmFocus.metadata().title + ' | ' + _config.config.siteTitle },
	      _react2.default.createElement(
	        'div',
	        { className: 'ui container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'two column stackable ui grid ' },
	          gridMovies
	        )
	      )
	    );
	  }
	});
	
	exports.default = FilmFocus;
	module.exports = exports['default'];

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

	module.exports = {"title":"AGORA: KERKGEBOUW - WEEFSEL VAN ZINGEVING","order":1,"body":"<p><img src=\"./Agora.jpg\" alt=\"Agora\"></p>\n<p><span style=\"color:fuchsia\"><strong>P I L O O T P R O J E C T</strong></span></p>\n<p>Men(S)tis ontwikkelde vanaf 2018 het <strong>Project AGORA</strong> in Vlaamse parochiekerken in nauwe samenwerking met de plaatselijke verantwoordelijkheden. De eerste editie vond plaats in de Heilige-Magdalenekerk te Brugge (mei-oktober 2018). Daarvoor werktte Men(S)tis samen met de lokale vzw <a href=\"https://www.yot.be/nl/home/5\">YOT</a>.</p>\n<p>Kerkraden die interesse hebben, kunnen contact opnemen met Men(S)tis via: <a href=\"mailto:info@mentis.be\">info@mentis.be</a>.</p>\n<p>Tijdens het <strong>Project AGORA</strong> rolde de Heilige-Magdalenakerk de rode loper uit voor iedereen, klein en groot, buurtbewoner, Bruggeling en toerist. Er ontstond <em>een experimentele ontmoetingsplaats</em>. Het <strong>Project AGORA</strong> deed binnen het inspirerende, historische en neogotische gebouw <em>een zichtbaar en onzichtbaar weefsel van zingeving</em> ontstaan. Dat gebeurde via:</p>\n<blockquote>\n<ol>\n<li>De <em>tentoonstelling</em> van hedendaagse kunst met werk van <a href=\"http://www.marleen-mertens.be/humana.html\">Marleen Mertens</a> (<em>Humana</em>) en <a href=\"http://www.jandewachter.be/Intro\">Jan De Wachter</a> (De meerdelige installatie, uitgewerkt als beeldweg met als titel <em>Alles goed? Jan De Wachter!</em>, alsook het schilderij <em>De Madonna van de Tederheid</em> in een aparte ruimte met soundscape)</li>\n<li>De <em>Verhalenkamer</em> waar iedere woensdagnamiddag en zaterdagnamiddag (15u00 - 17u00) iemand een verhaal vertelde, en naar aanleiding waarvan telkens de koffiebar open was.</li>\n<li>De <em>Filmstudio Lichtaard</em>. In juni 2018 realiseerden Sylvain De Bleeckere en Kristof Hoornaert de kortfilm <strong>PilgrImage</strong>. Het filmpje is <a href=\"./AgoraMovies/\">hier</a> te bekijken. Over <strong>PilgrImage</strong> kan je een uitgebreide voorstelling vinden in <a href=\"http://www.menstis.be/film-focus/pilgrimage/\">FilmFocus</a>.</li>\n</ol>\n</blockquote>\n<p>Triënnale Brugge 2018 kende aan het <strong>Project AGORA</strong> haar logo ‘<em>Inspired by Triennale Brugge 2018</em>’ toe.</p>\n<p>Als verwerking van het pilootproject AGORA verscheen in 2019 het boek <a href=\"http://www.menstis.be/webshop/Kerkgebouw/\">Meerstemmig Kerkgebouw</a>.</p>\n<p>© Men(S)tis, 2020.</p>\n"}

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

	module.exports = {"title":"Clair - Obscur","order":3,"body":"<p><img src=\"./Cello.JPG\" alt=\"Cello\"></p>\n<h2>Wat</h2>\n<p>Clair-Obscur is een kunstvoorstelling, opgebouwd rond de uitvoering van <strong>Methode</strong>, een kamermuziekspel voor stem, viool en cello. De uitvoering wordt omkaderd door een <strong>performance met drie schilderijen</strong>. De conceptuele achtergrond van <strong>Clair-Obscur</strong> is het boek <a href=\"http://www.menstis.be/uitgeverij/Levensbeschouwing/\">Levensbeschouwing democratisch belicht</a>. Het geheel realiseert <strong>een levensbeschouwelijke performance</strong>.</p>\n<h2>Programma</h2>\n<p>Welkom en inleiding in het teken van levensbeschouwing<br>\nOpeningsperformance met drie schilderijen<br>\nMethode – deel 1: muzikale uitvoering met viool en cello<br>\nMethode – deel 2: muzikale uitvoering met viool, cello en stem<br>\nSlotperformance met drie schilderijen</p>\n<h2>Wie</h2>\n<p><strong>Sylvain De Bleeckere.</strong> Hij concipieerde Clair-Obscur in de geest van zijn boek  <em>Levensbeschouwing democratisch belicht</em> (Pelckmans, 2015). Hij verzorgt het welkom en de inleiding. Hij schreef eveneens het filosofische poëem <em>Methode. Een denkbeeld</em> (2001), een bibliofiele editie met CD van <a href=\"/uitgeverij/\">uitgeverij Men(S)tis</a>. Hij draagt ook zelf de tekst voor tijdens de uitvoering. Woorden die tot leven komen tijdens de uitvoering: leven, geboorte, zingeving, tragiek, toeschouwerschap, onderweg, cultuurstuur.</p>\n<p><img src=\"./Sylvain.JPG\" alt=\"Sylvain De Bleeckere\"></p>\n<p><strong>Jan De Wachter.</strong> Hedendaags, plastisch kunstenaar opent en sluit de voorstelling af met een korte performance met drie van zijn grote schilderijen die het clair-obscur op een eigen, plastische wijze vertolken. <a href=\"http://www.jandewachter.be/Jan_De_Wachter\">www.jandewachter.be/Jan_De_Wachter</a></p>\n<p><img src=\"./Jan.JPG\" alt=\"Jan De Wachter\"></p>\n<p><strong>Wouter Vandenabeele</strong> componeerde de muziek voor viool en cello bij Methode, dirigeert en speelt zelf de vioolpartij. Hij is de inspirator, componist en dirigent van Olla Vogola en lid van de groep Ambrozijn. Hij is als muzikant een echte multiculturalist, een van Vlaanderens beste violisten in de traditie van de folk, de jazz en de wereldmuziek. <a href=\"http://www.woutervandenabeele.be\">www.woutervandenabeele.be</a></p>\n<p><img src=\"./Wouter.JPG\" alt=\"Wouter Vandenabeele\"></p>\n<p><strong>Lode Vercampt</strong> bespeelt de cello. Hij is een ware meester en voelt zich thuis op de scène van de klassieke muziek, de Vlaamse folk en rock, de jazz, de experimentele muziek en het muziektheater. Hij neemt tijdens de uitvoering de cellopartij voor zijn rekening.</p>\n<p><img src=\"./Muzikanten.JPG\" alt=\"Lode Vercampt\"></p>\n<h2>‘Zones van zin’</h2>\n<p>De voorstelling komt het best tot zijn recht in oude of nieuwe ruimtes met een architecturale kwaliteit. Tijdens de uitvoering krijgen ze de uitstraling van een tijdelijke ‘zone van zin’. Het publiek bestaat uit toeschouwers die voor de duur van de voorstelling zinzoekers worden. De voorstelling duurt 60 minuten.</p>\n<h2>Uitvoeringen</h2>\n<p>De première van Methode vond plaats in De Markten te Brussel op 3 en 4 februari 2007. Op 25 februari 2015 vond de eerste uitvoering van Clair-Obscur plaats in het Theater Tinnenpot te Gent naar aanleiding van de presentatie van het boek Levensbeschouwing democratisch belicht.</p>\n<p>Beluister hieronder de aanzet van het stuk Methode:</p>\n<audio controls>\n <source src=\"./Prelude.mp3\"\n         type='audio/mp3'>\n</audio>\n<p><img src=\"./Partituur.JPG\" alt=\"\"></p>\n"}

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

	module.exports = {"title":"De Madonna van de Tederheid","order":4,"body":"<p><img src=\"./degelemadonna.jpg\" alt=\"De Gele Madonna\"></p>\n<p>Kunstenaar Jan De Wachter schonk het werk aan Men(S)tis vzw. Het doek is voor het eerst in het publiek getoond tijdens de begrafenis van <strong>Nicole De Bleeckere-Van de Kerckhove</strong> (17 januari 1996) in de parochiekerk te Kermt (Hasselt).</p>\n<p>Het was eveneens te zien in de tentoonstelling van actuele religieuze kunst, <strong>De Adem van Adam</strong>, in het Provinciaal Centrum voor Beeldend Kunsten te Hasselt van 3 augustus - 1 september 1996.</p>\n<p>Heden is het doek uitgeleend aan <strong>Yot vzw</strong> te Brugge. Het schilderij hangt in de voormalige doopkapel van de <strong>Heilige-Magdalenakerk</strong> te Brugge, beheerd door Yot vzw.</p>\n<p>Het schilderij maakte van mei tot september 2018 deel uit van het <strong>Project Agora</strong>. Zie daarover de productie <strong>Project Agora</strong> op deze pagina.</p>\n<p>Eveneens in 2018 verscheen het beeld van de <em>Madonna van de Tederheid</em> als front van <em>de eigentijdse gebedskaart</em> met een <em>gebedstekst</em>, geschreven door Sylvain De Bleeckere. De gebedskaart is te verkrijgen via <a href=\"mailto:info@mentis.be\">info@mentis.be</a>. De gebedskaart maakt ook deel uit van de inschrijving voor de 28ste editie (2019) van <a href=\"http://www.menstis.be/dedag/inschrijving/\">De Dag van de Religieuze Film</a>.</p>\n<p>Het schilderij speelt ook een hoofdrol in het filmpje <a href=\"http://www.menstis.be/film-focus/pilgrimage/\">PilgrImage</a>.</p>\n"}

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

	module.exports = {"title":"Jute","order":2,"body":"<p><img src=\"./Jute.jpg\" alt=\"Jute\"></p>\n<h2>Wat</h2>\n<p>Een <em>levensbeschouwelijke en narratieve performance</em> bestaat uit de vertelling van <strong>Het Verhaal van Jute</strong> over de wijsheid en de dwaasheid van de mensheid.</p>\n<h2>Programma</h2>\n<p>Het verhaal bestaat uit drie delen: <strong>Corchorus - Lilli Jahn - Jute Art</strong>. Het verhaal wordt ononderbroken vertelt en duurt circa 75 minuten. Het verhaal is omkaderd met enkele aangepaste rekwisieten en beelden.</p>\n<h2>Wie</h2>\n<p>Sylvain De Bleeckere creëerde het verhaal en vertelt het tijdens de narratieve performance met een levensbeschouwelijk karakter.</p>\n<h2>Thema’s</h2>\n<p>De naam van het hoofdpersonage verwijst naar <strong>de vezelplant corchorus</strong>, grondstof voor de stof jute. Ze is ontdekt en gecultiveerd in Zuid-Oost Azië en heeft <em>unieke en waardevolle biologische</em> eigenschappen. De waarde van de plant is in het Westen ontdekt tijdens de Industriële Revolutie van de negentiende eeuw en ze speelt nu opnieuw een hoofdrol in de strijd tegen <em>ecologische vervuiling van onze planeet Aarde en voor fairtrade</em>. Het verhaal van Jute onthult een deel van de wijsheid van de mens. Die wijsheid kan ieder ogenblik verloren gaan. Dat leert Jute die het verhaal vertelt van <strong>Lilli Jahn</strong>, de Duits-Joodse moeder en arts die de <em>Holocaust</em> niet heeft overleefd. Ook in haar verhaal speelt jute een hoofdrol. Over de afgrond van de dwaasheid van de mensheid legt Jute in haar verhaal een fragiele brug naar de herontdekking van de wijsheid van de mens. Het is een brug van jute, ontworpen door <strong>de hedendaagse levensbeschouwelijke jutekunst</strong> van <em>Paul Gaugain, Ibrahim Mahama, Jan De Wachter</em>.</p>\n<h2>Uitvoeringen</h2>\n<p><strong>28 augustus 2018</strong>: De try-out vond plaats op zaterdag 25 augustus 2018 in de Heilig-Magdalenakerk (Brugge) tijdens het <a href=\"http://www.menstis.be/producties/Agora/\">Project Agora</a>.</p>\n<h2>Programmeren</h2>\n<p>De voorstelling kan worden geprogrammeerd in locaties die een zekere huiselijke en bezinnende sfeer uitstralen voor een publiek vanaf tien jaar. De grootte van de groep is maximum 50 personen. Indien interesse, neem vrijblijvend contact via: <strong><a href=\"mailto:info@menstis.be\">info@menstis.be</a></strong>.</p>\n"}

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(173);
	
	var _breakpoint = __webpack_require__(947);
	
	var _breakpoint2 = _interopRequireDefault(_breakpoint);
	
	var _find = __webpack_require__(601);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _lodash = __webpack_require__(975);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _gatsbyHelpers = __webpack_require__(403);
	
	var _config = __webpack_require__(404);
	
	var _safeAccess = __webpack_require__(976);
	
	var _safeAccess2 = _interopRequireDefault(_safeAccess);
	
	var _typography = __webpack_require__(427);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _include = __webpack_require__(420);
	
	var _include2 = _interopRequireDefault(_include);
	
	var _startsWith = __webpack_require__(573);
	
	var _startsWith2 = _interopRequireDefault(_startsWith);
	
	var _Header = __webpack_require__(419);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _semanticUiReact = __webpack_require__(471);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rhythm = _typography2.default.rhythm;
	
	
	module.exports = _react2.default.createClass({
	  displayName: 'exports',
	  propTypes: function propTypes() {
	    return {
	      route: _react2.default.PropTypes.object
	    };
	  },
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	  handleTopicChange: function handleTopicChange(e) {
	    return this.context.router.push(e.target.value);
	  },
	  handleDropDown: function handleDropDown(e, data) {
	    return this.context.router.push(data.value);
	  },
	  render: function render() {
	    var _this = this;
	
	    var pageLinks = [];
	    var dropDown = [];
	    var pageOrder = [];
	    // Sort pages.
	    var pages = this.props.route.pages;
	    var activeCombo = "";
	    pages.forEach(function (page) {
	      if ((0, _safeAccess2.default)(page, 'file.ext') === 'md' && !(0, _include2.default)(page.path, '/404') && (0, _startsWith2.default)(page.path, "/producties/") && page.path != "/producties/") {
	        var title = (0, _safeAccess2.default)(page, 'data.title') || page.path;
	        var order = (0, _safeAccess2.default)(page, 'data.order');
	        var isActive = page.path === _this.props.location.pathname;
	        if (isActive) {
	          activeCombo = title;
	        }
	        pageOrder.push(parseInt(order));
	        pageLinks.push(_react2.default.createElement(
	          'li',
	          {
	            key: page.path,
	            style: {
	              marginBottom: rhythm(1 / 4)
	            }
	          },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { style: { boxShadow: 'none' }, to: (0, _gatsbyHelpers.prefixLink)(page.path) },
	            isActive ? _react2.default.createElement(
	              'strong',
	              null,
	              title
	            ) : title
	          )
	        ));
	        dropDown.push({ key: page.path, value: page.path, text: title });
	      }
	    });
	    var zippedPages = _lodash2.default.zip(pageOrder, pageLinks);
	    var sortedPages = _lodash2.default.sortBy(zippedPages, function (o) {
	      return o[0];
	    });
	    var unzippedPages = _lodash2.default.map(sortedPages, function (o) {
	      return o[1];
	    });
	    var zippedCombo = _lodash2.default.zip(pageOrder, dropDown);
	    var sortedCombo = _lodash2.default.sortBy(zippedCombo, function (o) {
	      return o[0];
	    });
	    var unzippedCombo = _lodash2.default.map(sortedCombo, function (o) {
	      return o[1];
	    });
	    console.log(unzippedPages.length);
	    return _react2.default.createElement(
	      'div',
	      { className: 'ui container' },
	      _react2.default.createElement(
	        _breakpoint2.default,
	        {
	          mobile: true
	        },
	        _react2.default.createElement(
	          'div',
	          {
	            style: {
	              overflowY: 'auto',
	              paddingRight: 'calc(' + rhythm(1 / 2) + ' - 2px)',
	              position: 'absolute',
	              width: 'calc(' + rhythm(8) + ' - 2px)',
	              borderRight: '1px solid lightgrey'
	            }
	          },
	          _react2.default.createElement(
	            'ul',
	            {
	              style: {
	                listStyle: 'none',
	                marginLeft: 0,
	                marginTop: rhythm(1 / 2)
	              }
	            },
	            unzippedPages
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            style: {
	              padding: '0 ' + rhythm(1),
	              paddingLeft: 'calc(' + rhythm(8) + ' + ' + rhythm(1) + ')'
	            }
	          },
	          this.props.children
	        )
	      ),
	      _react2.default.createElement(
	        _breakpoint2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { paddingLeft: '15px' } },
	          _react2.default.createElement(_semanticUiReact.Dropdown, { defaultValue: activeCombo, fluid: true, search: true, selection: true,
	            options: unzippedCombo, onChange: this.handleDropDown
	
	          })
	        ),
	        _react2.default.createElement('br', null),
	        this.props.children
	      )
	    );
	  }
	});

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

	module.exports = {"title":"Producties","body":"<h2>Agora</h2>\n<p><a href=\"./Agora/\"><img src=\"./Agora/Agora.jpg\" ></a></p>\n<h2>Jute</h2>\n<p><a href=\"./Jute/\"><img src=\"./Jute/Jute.jpg\" ></a></p>\n<h2>Clair-Obscur</h2>\n<p><a href=\"./ClairObscur/\"><img src=\"./ClairObscur/Muzikanten.JPG\" ></a></p>\n<h2>De Madonna van de Tederheid</h2>\n<p><a href=\"./DeGeleMadonna/\"><img src=\"./DeGeleMadonna/gmk.jpg\" ></a></p>\n"}

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

	module.exports = {"title":"Aan de tafel van het verborgen atelier","body":"<p><img src=\"./tafel.jpg\" alt=\"\"></p>\n<p><strong>Auteurs</strong></p>\n<p>Sylvain De Bleeckere en Jan De Wachter</p>\n<p><strong>Beschrijving</strong></p>\n<p>Het kunstboek bestaat uit een dialoog tussen <strong>het essay van Sylvain De Bleeckere</strong>: <em>Aan de tafel van het verborgen atelier. Een bericht aan Jan De Wachter</em>, en <strong>de tekeningen van Jan De Wachter</strong> met als motief <strong>de oude en lange tafel</strong> die van zijn atelier een huiskamer maakt. Het werk heeft als opdracht: <em>Aan al die vrienden die nu, in de Herinnering, ooit aan deze tafel aanzaten.</em><br>\nHet boek toont eerst een tekening, daarna opent het essay met het deel dat als titel heeft: HET. Het middenluik van het boek bestaat uit een reeks tekeningen in kleur. Vervolgens gaat het essay verder met het deel: ZIJ. Het boek eindigt met een tekening in zwart-wit en het colofon.</p>\n<p><strong>Doelgroepen</strong></p>\n<blockquote>\n<p>Al wie begaan is met actuele kunst.</p>\n</blockquote>\n<blockquote>\n<p>Al wie wil verder kijken dan kunst om de kunst.</p>\n</blockquote>\n<blockquote>\n<p>Al wie bibliofiele edities verzamelt.</p>\n</blockquote>\n<p><strong>Technische gegevens</strong></p>\n<p>Het betreft <strong>een bibliofiel kunstboek</strong>, een verzamelitem.</p>\n<p>Prijs: 250,00 EUR.</p>\n<p>Het boek bevat <strong>26 bladzijden en 21 beelden</strong>.<br>\nDe <strong>afmetingen</strong> van het boek zijn L:30 cm, B: 1 cm, H:42 cm.<br>\nHet boek verscheen in <strong>1997</strong> in een oplage van 200 exemplaren. De <strong>eerste 30 exemplaren</strong> zijn romeins genummerd en gesigneerd van I tot XXX en voorzien van een originele tekening. De <strong>overige 170 exemplaren</strong> zijn genummerd en gesigneerd van 1 tot 170.<br>\nVoor <strong>de vormgeving, de maquette, het bindwerk en het ontwerp van de omslag met zeefdruk</strong> zorgden Jan en Ann De Wachter.<br>\nHet papier is rivoli wit, 160 gram. Het boek is gezet uit Esprit Book 13 punt.<br>\n<strong>Het drukwerk</strong> gebeurde bij Salto n.v. (Rekem-Lanaken).</p>\n<p>Deze unieke publicatie is enkel verkrijgbaar via: <a href=\"mailto:info@menstis.be\">info@menstis.be</a>.</p>\n<p>© Men(S)tis, 2020.</p>\n"}

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

	module.exports = {"title":"Het aards paradijs als zinnebeeld","body":"<p><img src=\"./AP%20titepaginal.jpg\" alt=\"AP titelpaginal\"></p>\n<p><strong>Auteur</strong></p>\n<p>Sylvain De Bleeckere</p>\n<p><strong>Beschrijving</strong></p>\n<p>De publicatie belicht het Bijbelse thema ‘Het aards paradijs’ vanuit een beeldend en levensbeschouwelijk perspectief. Concreet bestaat  het boek uit de filmdiptiek <em>The New World</em> en <em>The Tree of Life</em> van Terrence Malick. Voor een uitgebreide kennismaking met het boek via de pagina Blog van deze site, <a href=\"http://www.menstis.be/blog/\">klik hier</a>.</p>\n<p><strong>Doelgroepen</strong></p>\n<blockquote>\n<p>Al wie interesse heeft voor Bijvelse thema’s.</p>\n</blockquote>\n<blockquote>\n<p>Al wie oog heeft voor de beeldende inspiratie van Bijbelse thema’s.</p>\n</blockquote>\n<blockquote>\n<p>Al wie het filmoeuvre van Terrence Malick waardeert.</p>\n</blockquote>\n<blockquote>\n<p>Al wie zich wil verdiepen in de levensbeschouwelijke dimensie van de actuele kunst van de cinematografie.</p>\n</blockquote>\n<p><strong>Technische gegevens</strong></p>\n<p>Het boek telt 124 bladzijden.<br>\nDe kaft is in kleur en is een digitale bewerking van een originele schildering van een ginkgoblad.<br>\nDe tekst is verlucht met talrijke zwart-wit filmfoto’s.<br>\nDe afmetingen zijn: 20 cm op 20 cm.<br>\nISBN 978 90 8051 653 3<br>\n2012</p>\n<p>U kunt het boek bestellen via: <a href=\"mailto:info@menstis.be\">info@menstis.be</a>.</p>\n<p>© Men(S)tis, 2020.</p>\n"}

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

	module.exports = {"title":"Beeldgebed","body":"<p><img src=\"./bg.jpg\" alt=\"\"></p>\n<p><strong>Auteur</strong></p>\n<p>Sylvain De Bleeckere</p>\n<p><strong>Beschrijving</strong></p>\n<p>BEELDGEBED is een even kunstzinnig als zinscheppende boekje. Het bestaat uit een origineel weefsel van beelden en woorden die samen peilen naar het <strong>beeldende hart van het christendom</strong>.\nMet het meest kenmerkende, christelijke gebed, <em>het Onzevader</em>, als opstap, diept het boekje in het eerste deel, <em><strong>Woordbeeld</strong></em>, het onderscheid uit tussen bidden als werkwoord en gebeden als woorden. In die optiek bijft het boekje stilstaan bij de <strong>tragiek</strong> eigen aan de taal en de talen, namelijk die van de interpretatie. Dat inzicht - denk aan het verhaal over de Toren van Babel - belicht kritisch de eeuwenlange kerkelijke traditie dat bidden gelijk is aan het opzeggen van voorgeschreven woorden, gebeden genoemd. Vandaag ervaren we meer dan ooit dat woorden, ook religieuze woorden zoals gebeden, terecht zijn gekomen in een verstikkend en onvruchtbaar moeras van woorden.</p>\n<p><strong>BEELDGEBED</strong> neemt in het tweede deel, <em><strong>Beeldwoord</strong></em>, stapt uit dat moeras van het eeuwenoude geloof in woorden, door mensen bekleed met het zegel van eeuwigheid. De eerst stap daartoe bestaat in de kritische afstand tegenover  de visie en aanpak van de apostel Paulus en de inzoom op de <strong>beeldrijke evangelies en de lichticoon Jezus</strong>. Via een inzicht in <strong>de interpretatie van de tragiek</strong>, waaruit de christelijke grondteksten zijn voortgekomen, valt er een ander dan tradioneel licht op bidden. Hier verschijnt bidden als werkwoord, als levensbeschouwelijke praxis. Dat gebeurt via de spiegel van het <strong>feminien-beeldende</strong> karakter van Jezus’ handelen en spreken. Daarin verschijint de blijvende relevantie van het oermenselijke fenomeen ‘<strong>tafelgemeenschap</strong>’ - grondslag van Jezus’ handelen - voor een <strong>actuele, groeiende democratische samenleving</strong>. Inspirerende herinneringsbeelden aan Jezus kunnen vandaag nog onze gemeenschap voeden. BEELDGEBED opent een nieuwe visie op de beproeving waarmee de wereldwijde samenleving met haar consumptiezucht progressief te kampen heeft: de mentale gezondheid van iedere persoon.</p>\n<p><strong>Doelgroepen</strong></p>\n<blockquote>\n<p>Al wie levensbeschouwelijk actief is.</p>\n</blockquote>\n<blockquote>\n<p>Al wie een kunstminnend oog en geest heeft.</p>\n</blockquote>\n<blockquote>\n<p>Al wie zich wil verwonderen over het unieke universeel-menselijk oerfenomeen dat ‘bidden’ heet.</p>\n</blockquote>\n<blockquote>\n<p>Al wie moedig durft nadenken over het lot van de christelijke kerken (orthodox, katholiek, protestant).</p>\n</blockquote>\n<blockquote>\n<p>Al wie beseft dat de humane rijkdom van het christendom verder reikt dan het domein van de traditionele kerken die zich in een morele crisis bevinden.</p>\n</blockquote>\n<blockquote>\n<p>Al wie leeft en werkt vanuit een democratische gezindheid die niet kan worden gerecupereerd of gemanipuleerd door welke politieke partij dan ook.</p>\n</blockquote>\n<blockquote>\n<p>Creatieve scholen en hun hun alerte onderwijsmensen.</p>\n</blockquote>\n<blockquote>\n<p>Actieve, religieuze leesgroepen en/of gebedsgroepen.</p>\n</blockquote>\n<p><strong>Technische gegevens</strong></p>\n<p>Het boekje ligt in de hand door zijn vierkant formaat van 14cm. De stoffen kaft met zilveren boord en letters straalt ingetogenheid en een bijna liturgische waardigheid uit.<br></p>\n<p>Het boekje telt <strong>120 bladzijden</strong> en <strong>17 beelden</strong>. Kunstenaars <a href=\"http://www.marleen-mertens.be/\">Marleen Mertens</a>, <a href=\"http://www.jandewachter.be/Intro\">Jan De Wachter</a>, <a href=\"https://www.vincentspaas.com/\">Vincent Spaas</a>, <a href=\"http://www.jefvaneynde.be/\">Jef Van Eynde</a> en <a href=\"https://www.kristofhoornaert.com/\">Kristof Hoornaert</a> leverden op vraag van de auteur nieuwe beelden aan die zich integreren in het boekje. Het boekje werkt ook met een uitsnede van een beeld van Leonardo da Vinci. Het bijzondere boekdesign is een ontwerp van de auteur in samenwerking met Jan De Meester van de drukkerij <a href=\"http://www.cultura.be/\">Cultura</a>, Wetteren.<br></p>\n<p>Door zijn mooi uitzicht, zijn handig formaat, zijn visueel boekdesign, zijn bijzondere inhoud, is het een <strong>ideaal geschenk</strong> om aan een bijzonder iemand te geven.</p>\n<p>De uitgever is <strong>Men(S)tis</strong>, Hasselt, 2020.<br>\nISBN: 978 90 805 1655 7.<br>\nKostrpijs: 20,00 EUR<br></p>\n<p>BEELDGEBED is niet in de boekhandel. Het is verkrijgbaar bij Men(S)tis via <a href=\"mailto:info@menstis.be\">info@menstis.be</a>.<br></p>\n<p>© Men(S)tis, 2020.</p>\n"}

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

	module.exports = {"title":"Meerstemmig kerkgebouw","body":"<h3>Meerstemmig kerkgebouw</h3>\n<p><img src=\"./msk.jpg\" alt=\"msk\"></p>\n<p><strong>Auteurs</strong></p>\n<p>Sylvain De Bleeckere, Koen Dekorte, Geert Delbeke, Jef Van Eynde</p>\n<p><strong>Beschrijving</strong></p>\n<p>Het boek is verschenen begin maart 2019 als een gemeenschappelijke reflectie over het <a href=\"http://www.menstis.be/producties/Agora/\">Project Agora</a> in de Heilige-\nMagdalenakerk te Brugge. Het is een gemeenschappelijke uitgave van Men(S)tis en <a href=\"https://www.yot.be/nl/home/5\">Yot</a>.\nHet boek telt vier inhoudelijke hoofdstukken plus een hoofdstuk met bronnen. De Maria-Magdalenakerk is onder leiding van de vzw YOT in Vlaanderen uitgegroeid tot een modelproject van een constructieve benadering van de parochiekerken die leeg komen te staan. Het pilootproject <em>Agora</em> onderbouwt het werk van YOT en schept een werk- en reflectieruimte over het lot\nvan de vele parochiekerken in Vlaanderen. Met de titel ‘<em>Meerstemmig kerkgebouw</em>’ nemen de auteurs afstand van het heersende discours over ‘<em>herbestemming van kerken</em>’ en tonen ze vanuit de praktijk aan hoe het anders kan.\nHet boek is rijk geïllustreerd met het werk van fotograaf Jef Van Eynde.</p>\n<p><strong>Doelgroepen</strong></p>\n<blockquote>\n<p>Al wie zich privé en/of professioneel betrokken voelt bij de heersende problematiek van de toekomst van de parochiekerken.</p>\n</blockquote>\n<blockquote>\n<p>Al wie met het kerkelijke erfgoed van Vlaanderen is begaan.</p>\n</blockquote>\n<blockquote>\n<p>Al wie oogt heeft voor de eigen beeldende en feminiene waarden van de neogitische kerkgebouw.</p>\n</blockquote>\n<blockquote>\n<p>Al wie belangstelling heeft voor de integratie van actuele kunst in de publieke ruimte.</p>\n</blockquote>\n<blockquote>\n<p>Al wie de kunst van Jan De Wachter, Marleen Mertens en Jef Van Eynde volgt.</p>\n</blockquote>\n<p><strong>Technische gegevens</strong></p>\n<p>Het boek telt 108 bladzijden.<br>\nHet heeft een harde kaft.<br>\nDe afmetingen zijn: 160 mm op 235 mm.<br>\nISBN 978-90-8051-654-0<br>\n2019</p>\n<p>Bestel <strong>Meerstemmig kerkgebouw</strong> - de winkelprijs bedraagt 20,00 EUR -, verzending niet inbegrepen,\nvia: <a href=\"mailto:info@menstis.be\">info@menstis.be</a>.</p>\n<p>© Men(S)tis, 2020.</p>\n"}

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

	module.exports = {"title":"Het Beloofde Land","body":"<p><img src=\"./bl.jpg\" alt=\"\"></p>\n<p><strong>Auteurs</strong></p>\n<p>Sylvain De Bleeckere, Dennis Baert, David Dessin</p>\n<p><strong>Beschrijving</strong></p>\n<p>Het boek handelt over het Bijbelse gegeven van het Beloofde Land. Het eerste deel,\n<strong>Het Beloofd Land in Woord</strong>, behandelt\nhet Bijbelse narratief van het Beloofde Land <strong>exegetisch</strong> (Dennis Baert). Daarna volgt het onderzoek hoe het narratief\nvan het Beloofde Land als <strong>Joods vraagstuk in de diaspora</strong> doorwerkt (David Dessin). Het tweede deel, Het Beloofde Land\nin Beeld (Sylvan De Bleeckere), behandelt <strong>het Beloofde Land en de staat Israël</strong>. Dit hedendaags perspectief krijgt inhoud\nvia drie langspeelfilms <em>Hannah Arendt</em> (Margarethe von Trotta), <em>Inch’Allah</em>\n(Anais Berbeau-Lavalette) en <em>The Attack</em> (Zias Doueiri).</p>\n<p><strong>Doelgroepen</strong></p>\n<blockquote>\n<p>Al wie wil reflecteren over het Bijbelse gegeven van ‘het beloofde land’, rekening houdend met de studie van de Bijbelse teksten en het hedendaagse joodse denken daarover.</p>\n</blockquote>\n<blockquote>\n<p>Al wie de actualiteit van Israël en het Midden Oosten niet onberoerd laat.</p>\n</blockquote>\n<blockquote>\n<p>Al wie oogt heeft voor de doorwerking van de actuele toestand in het Bijbelse ‘beloofde land’ in enkele, relevante hedendaagse films.</p>\n</blockquote>\n<p><strong>Technische gegevens</strong></p>\n<p>Het betreft <strong>een studieboek</strong>, academisch onderbouwd en gericht\nnaar een publiek dat tijd wil nemen om lezend en schouwend na te denken vanuit een open geest.<br>\nHet boek telt <strong>118 bladzijden en 10 beelden</strong>.<br>\nDe <strong>afmetingen</strong> van het boek zijn: D: 1 cm, B: 14 cm, H: 21 cm.<br><br>\nHet boek verscheen in <strong>2014</strong> naar aanleiding\nvan <em>De Dag van de Religieuze Film</em>\nrond het gelijknamige thema en met de drie films die in het boek worden belicht.\n<br><br>\nDe uitgever is <strong>Altiora Averbode</strong>, Averbode.<br>\nISBN: 978 90 317 3792 5<br></p>\n<p>Het boek is verkrijgbaar aan 10,00 EUR - portkosten niet meegerekend - via: <a href=\"mailto:info@menstis.be\">info@menstis.be</a>.</p>\n<p>© Men(S)tis, 2020.</p>\n"}

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

	module.exports = {"title":"Leren Leven Met Beelden","body":"<p><img src=\"./llb.jpg\" alt=\"\"></p>\n<p><strong>Auteur</strong></p>\n<p>Sylvain De Bleeckere</p>\n<p><strong>Beschrijving</strong></p>\n<p>Leren Leven Met Beelden is <strong>een beeldpedagogische uitgave</strong>, geschreven vanuit een eigen ontworpen concept en met als doelgroep: leerkrachten uit het basisonderwijs,het secundair en het hoger onderwijs. De ondertitel luidt: <em>Gids voor een filmprogrammatie in onderwijs en vorming.</em> De auteur stelt een tiental <strong>recente films</strong> voor die zowel esthetisch als inhoudelijk <strong>een beeldvormende en algemeen vormende waarde</strong> bezitten. Met deze presentatie in de hand, kunnen leerkrachten beslissen of een bepaalde film pedagogisch nuttig en ondersteunend kan zijn voor de uitwerking van een beeldpedagogisch en/of thematisch project.</p>\n<p><strong>Doelgroepen</strong></p>\n<blockquote>\n<p>Al wie in onderwijs en vorming begaan is met beeldopvoeding aan de hand van kwalitieve beelden.</p>\n</blockquote>\n<blockquote>\n<p>Al wie lid is van een werkfroep film- en beeldopvoeding op school.</p>\n</blockquote>\n<p><strong>Technische gegevens</strong></p>\n<p>De uitgave heeft een A4-formaat en telt 48 bladzijden.<br>\n<strong>In 2012</strong> verscheen <strong>de 17de en laatste editie</strong>.</p>\n<p>U kan de laatste exemplaren van <strong>Leren Leven Met Beelden</strong> bestellen via: <a href=\"mailto:info@menstis.be\">info@menstis.be</a>.</p>\n<p>Kostprijs: 2,00 EUR per exemplaar - portkosten niet inbegrepen.</p>\n<p>© Men(S)tis, 2020.</p>\n"}

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

	module.exports = {"title":"Levensbeschouwing democratisch belicht","body":"<p><img src=\"./LBS.jpg\" alt=\"\"></p>\n<p><strong>Auteur</strong></p>\n<p>Sylvain De Bleeckere</p>\n<p><strong>Beschrijving</strong></p>\n<p>Het boek vormt <strong>de syntese en de verdieping</strong> van het jarenlange onderzoek van de auteur naar de relatie\ntussen de filosofie van het leven tot de cultuurfenomenen kunst en religie en het antoropologisch fenomeen\nvan <strong>de zingeving</strong> in het perspectief van <strong>de postmoderne, naoorlogse en democratische samenleving</strong>.\nHet bestaat uit drie delen: <strong>Praxis van het contemplatievermogen, Het grote vergeten, De Lichtaard</strong>.\nHet boek zondert het fenomeen levensbeschouwing af tegenover dat van <strong>het wereldbeeld</strong> en <strong>de Ideologie</strong>.\nHet boek vertelt het verhaal van de <strong>Europese, westerse cultuur</strong> vanuit <strong>het Atheeense experiment</strong> van de democratie met het ontstaan van het theater\nen de kunst van de tragedie. Het belicht in die optiek ook <strong>het toeschouwerschap</strong> van de mens.</p>\n<p><strong>Doelgroepen</strong></p>\n<blockquote>\n<p>Al wie ernstig wil nadenken over onze westerse cultuur en beschaving.</p>\n</blockquote>\n<blockquote>\n<p>Al wie de impact inziet van het moderne fenomeen ‘ideologie’.</p>\n</blockquote>\n<blockquote>\n<p>Al wie zich buigt over het fenomeen ‘levensbeschouweing’ in een democratisch, actueel perspectief.</p>\n</blockquote>\n<blockquote>\n<p>Al wie belangstelling toont voor de kunst van de tragedie en haar doorwerking in de kunst van de cinematografie.</p>\n</blockquote>\n<blockquote>\n<p>Al wie meedenkt over een herijking van de betekenis van ‘religie’.</p>\n</blockquote>\n<blockquote>\n<p>Al wie actief is in de studie van de filosofie en de godsdienstwetenschappen en theologie, alsook in het onderwijs, vooral in de lessen algemene vakken.</p>\n</blockquote>\n<blockquote>\n<p>Al wie politiek geëngageerd is.</p>\n</blockquote>\n<p><strong>Technische gegevens</strong></p>\n<p>Het betreft <strong>een studieboek</strong>, academisch onderbouwd.<br>\nHet boek telt <strong>304 bladzijden en 5 beelden</strong>.<br>\nDe <strong>afmetingen</strong> van het boek zijn: D: 2,5 cm, B: 15 cm, H: 23,5cm.<br><br>\nHet boek verscheen in <strong>2015</strong> naar aanleidng van het jubeleum van De Dag van de Religieuze Film en het emeritaat van de auteur.<br><br>\nDe uitgever is <strong>Pelckmans</strong>, Kalmthout.<br>\nISBN: 978 90 289 7914 7<br></p>\n<p>Het boek is nog verkrijgbaar via: <a href=\"mailto:info@menstis.be\">info@menstis.be</a>.</p>\n<p>Het boek kost 20,00 Eur, portkosten niet inbegrepen.</p>\n<p>© Men(S)tis, 2020.</p>\n"}

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

	module.exports = {"title":"Methode Boek","body":"<p><img src=\"./methode.jpg\" alt=\"Methode boek\"></p>\n<p><strong>Auteur</strong></p>\n<p>Sylvain De Bleeckere</p>\n<p><strong>Beschrijving</strong></p>\n<p>Het boek <strong>Methode</strong>\nheeft een dubbele ondertitel waarvan de eerste is: <em>Een denkbeeld</em>, gevolgd door de tweede: <em>Fragmenten van een reflexie na een wandeling met een onbekende vriend.</em> Het betreft een filosofisch-religieus poëem. De auteur bewandelt hier onbegane paden om <strong>een oorspronkelijke verwoording</strong> te zoeken van wat sommigen vandaag onder <strong>een religieuze beleving van het bestaan op aarde</strong> kunnen verstaan. De tekst vertolkt en verklankt een dergelijke beleving waarbij <strong>het indivuele beleven</strong> zich mengt met <strong>het collectieve lot van de mensheid</strong> onderweg. De tekst heeft <strong>in een bepaald opzicht een liturgisch karakter</strong> en is geschreven om te worden voorgelezen. In het colofon preciseert de auteur dat het poëem is geschreven <em>om te worden voorgedragen daar waar enkele mensen zich rond een tafel verzamelen om bezinnend het heilig mysterie van het leven te delen.</em></p>\n<p><strong>Doelgroepen</strong></p>\n<blockquote>\n<p>Al wie levensbeschouwelijk actief is.</p>\n</blockquote>\n<blockquote>\n<p>Al wie gevoelig is voor poëtische beeldtaal.</p>\n</blockquote>\n<blockquote>\n<p>Al wie aan het leven een religieuze waarde toekent.</p>\n</blockquote>\n<p><strong>Technische gegevens</strong></p>\n<p>Het boekje verscheen in <strong>2001</strong> en heeft een <strong>broze</strong>\nverschijning.\nDe afmetingen zijn: L:22 cm, D: 0,5 cm, H:22 cm.<br>\nHet telt <strong>24</strong> bladzijden.<br>\nDe tekst is evenals de kaft in <strong>een aarden kleur</strong> gezet.\nDe uitgever: Men(S)tis vzw, Hasselt.\nISBN: 90-805165-2-X</p>\n<p>U kunt <strong>Methode</strong> bestellen via: <a href=\"mailto:info@menstis.be\">info@menstis.be</a>. Zie ook nog op deze site, bij Producties:\n<a href=\"http://www.menstis.be/producties/ClairObscur/\">Clair-Obscur</a>.</p>\n<p>© Men(S)tis, 2020.</p>\n"}

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

	module.exports = {"title":"Methode CD","body":"<p><img src=\"./cdfront.jpg\" alt=\"cdfront\"></p>\n<p><strong>Auteur</strong></p>\n<p>Sylvain De Bleeckere</p>\n<p><strong>Beschrijving</strong></p>\n<p>De <strong>CD Methode</strong> is een <strong>klankopname</strong> van <strong>het filosofisch poëem Methode</strong> van Sylvain De Bleeckere.\nMusicus <strong>Wouter Vandenabeele</strong> (Olla Vogala, Ambrozijn) heeft naar aanleiding\nvan dat poëtisch werk <strong>een nieuwe partituur</strong> voor viool, altviool, cello en zang geschreven. De CD heeft een drieledige structuur.\nEr is een korte <strong>prelude</strong> die zowel muzikaal als tekstueel\nde sfeer oproept van het geheel. Daarna volgt <strong>instrumentale uitvoering</strong> van de compositie.\nDat stuk werkt zelf als een lange prelude op <strong>de volledige uitvoering met de voorgedragen tekst</strong>.\nDe CD is niet in de handel verkrijgbaar. Het werk is enkel als <strong>een geschenk</strong> verkrijgbaar bij\nde aankoop van het boek Methode, alsook bij een betalende deelname aan\nde productie <strong>Clair-Obscur</strong> van Men(S)tis vzw.</p>\n<p><strong>Doelgroepen</strong></p>\n<blockquote>\n<p>Al wie levensbeschouwelijk actief is.</p>\n</blockquote>\n<blockquote>\n<p>Al wie gevoelig is voor poëtische beeldtaal.</p>\n</blockquote>\n<blockquote>\n<p>Al wie aan het leven een religieuze waarde toekent.</p>\n</blockquote>\n<p><strong>Technische gegevens</strong></p>\n<p><em>Uitvoerders</em><br>\nWouter Vandenabeele (compositie, viool, altviool)<br>\nLode Vercampt (cello)<br>\nSoetkin Baptist (zang)<br>\nSylvain De Bleeckere (tekst, voordracht)</p>\n<p><em>Techniek</em><br>\nOpname en masering: Home Records (Luik) / 2007.<br>\nMixage: Michel Van Achter, Wouter Vandenabeele, Sylvain De Bleeckere.<br>\nFoto’s: Michel Van Achter.<br>\nStemmentor: Veerle Verheyen.<br>\nTekening; Jan De Wachter.</p>\n<p><em>Duur</em><br>\n1 Prelude 1’13”<br>\n2 Methode 1 (instrumentaal) 24’56”<br>\n3 Methode 2 28’53”</p>\n<p>De CD is verkrijgbaar via: <a href=\"mailto:info@menstis.be\">info@menstis.be</a>.\nKostprijs: 5,00 EUR, portkosten niet inbegerpen.</p>\n<p>De CD wordt als een geschenk gegeven aan al wie  betalend de productie <a href=\"http://www.menstis.be/producties/ClairObscur/\">Clair-Obscur</a> bijwoont.</p>\n<p>© Men(S)tis, 2020.</p>\n"}

/***/ }),
/* 1040 */
987,
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDocumentTitle = __webpack_require__(952);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _config = __webpack_require__(404);
	
	var _reactRouter = __webpack_require__(173);
	
	var _safeAccess = __webpack_require__(976);
	
	var _safeAccess2 = _interopRequireDefault(_safeAccess);
	
	var _include = __webpack_require__(420);
	
	var _include2 = _interopRequireDefault(_include);
	
	var _startsWith = __webpack_require__(573);
	
	var _startsWith2 = _interopRequireDefault(_startsWith);
	
	var _typography = __webpack_require__(427);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _gatsbyHelpers = __webpack_require__(403);
	
	var _Header = __webpack_require__(419);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _semanticUiReact = __webpack_require__(471);
	
	__webpack_require__(949);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rhythm = _typography2.default.rhythm;
	
	
	var SomeReactCode = _react2.default.createClass({
	  displayName: 'SomeReactCode',
	
	  statics: {
	    metadata: function metadata() {
	      return {
	        title: 'Men(s)tis - Webshop'
	      };
	    }
	  },
	
	  onImageClick: function onImageClick(e, el) {
	    _reactRouter.browserHistory.push((0, _gatsbyHelpers.prefixLink)(el));
	  },
	  render: function render() {
	    var _this = this;
	
	    var movies = [];
	    var pages = this.props.route.pages;
	
	    pages.forEach(function (page) {
	      if ((0, _safeAccess2.default)(page, 'file.ext') === 'md' && !(0, _include2.default)(page.path, '/404') && (0, _startsWith2.default)(page.path, "/webshop/")) {
	        movies.push(page.path);
	      }
	    });
	    var gridMovies = [];
	    while (movies.length > 0) {
	      var line = movies.splice(0, 1);
	      line.forEach(function (el, idx) {
	        gridMovies.push(_react2.default.createElement(
	          'div',
	          { className: 'column' },
	          ' ',
	          _react2.default.createElement(
	            'div',
	            { className: 'image-fit-webshop' },
	            _react2.default.createElement(_semanticUiReact.Image, { src: (0, _gatsbyHelpers.prefixLink)(el) + "front.jpg", onClick: function onClick(e) {
	                return _this.onImageClick(e, el);
	              } })
	          )
	        ));
	      });
	    }
	
	    return _react2.default.createElement(
	      _reactDocumentTitle2.default,
	      { title: SomeReactCode.metadata().title + ' | ' + _config.config.siteTitle },
	      _react2.default.createElement(
	        'div',
	        { className: 'ui container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'three column stackable ui grid ' },
	          gridMovies
	        )
	      )
	    );
	  }
	});
	
	exports.default = SomeReactCode;
	module.exports = exports['default'];

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ })
/******/ ])));


// WEBPACK FOOTER //
// bundle.js